/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 415);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapState", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapMutations", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapGetters", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapActions", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNamespacedHelpers", function() { return createNamespacedHelpers; });
/**
 * vuex v3.1.1
 * (c) 2019 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if (false) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return result.then(function (res) {
    try {
      this$1._actionSubscribers
        .filter(function (sub) { return sub.after; })
        .forEach(function (sub) { return sub.after(action, this$1.state); });
    } catch (e) {
      if (false) {
        console.warn("[vuex] error in after action subscribers: ");
        console.error(e);
      }
    }
    return res
  })
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure enviroment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.1.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};

/* harmony default export */ __webpack_exports__["default"] = (index_esm);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51), __webpack_require__(416).setImmediate))

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(471)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(470)(module)))

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Auth module
 */
var AUTH_LOGIN_PENDING = exports.AUTH_LOGIN_PENDING = 'AUTH_LOGIN_PENDING';
var AUTH_LOGIN_SUCCESS = exports.AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
var AUTH_LOGIN_FAILURE = exports.AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';

var AUTH_ACTIVATION_PENDING = exports.AUTH_ACTIVATION_PENDING = 'AUTH_ACTIVATION_PENDING';
var AUTH_ACTIVATION_SUCCESS = exports.AUTH_ACTIVATION_SUCCESS = 'AUTH_ACTIVATION_SUCCESS';
var AUTH_ACTIVATION_FAILURE = exports.AUTH_ACTIVATION_FAILURE = 'AUTH_ACTIVATION_FAILURE';

var AUTH_RESET_PENDING = exports.AUTH_RESET_PENDING = 'AUTH_RESET_PENDING';
var AUTH_RESET_SUCCESS = exports.AUTH_RESET_SUCCESS = 'AUTH_RESET_SUCCESS';
var AUTH_RESET_FAILURE = exports.AUTH_RESET_FAILURE = 'AUTH_RESET_FAILURE';

var AUTH_FORGOT_PENDING = exports.AUTH_FORGOT_PENDING = 'AUTH_FORGOT_PENDING';
var AUTH_FORGOT_SUCCESS = exports.AUTH_FORGOT_SUCCESS = 'AUTH_FORGOT_SUCCESS';
var AUTH_FORGOT_FAILURE = exports.AUTH_FORGOT_FAILURE = 'AUTH_FORGOT_FAILURE';

var AUTH_USER_SET = exports.AUTH_USER_SET = 'AUTH_USER_SET';
var AUTH_USER_UNSET = exports.AUTH_USER_UNSET = 'AUTH_USER_UNSET';
var AUTH_SUPPLIERS_SET = exports.AUTH_SUPPLIERS_SET = 'AUTH_SUPPLIERS_SET';
var AUTH_PRODUCT_TYPES_SET = exports.AUTH_PRODUCT_TYPES_SET = 'AUTH_PRODUCT_TYPES_SET';

var AUTH_MESSAGE_SET = exports.AUTH_MESSAGE_SET = 'AUTH_MESSAGE_SET';
var AUTH_REFERRER_SET = exports.AUTH_REFERRER_SET = 'AUTH_REFERRER_SET';
var AUTH_REFERRER_UNSET = exports.AUTH_REFERRER_UNSET = 'AUTH_REFERRER_UNSET';

var AUTH_PRODUCT_TYPES_PENDING = exports.AUTH_PRODUCT_TYPES_PENDING = 'AUTH_PRODUCT_TYPES_PENDING';
var AUTH_PRODUCT_TYPES_SUCCESS = exports.AUTH_PRODUCT_TYPES_SUCCESS = 'AUTH_PRODUCT_TYPES_SUCCESS';
var AUTH_PRODUCT_TYPES_FAILURE = exports.AUTH_PRODUCT_TYPES_FAILURE = 'AUTH_PRODUCT_TYPES_FAILURE';

var AUTH_SUPPLIERS_LIST_PENDING = exports.AUTH_SUPPLIERS_LIST_PENDING = 'AUTH_SUPPLIERS_LIST_PENDING';
var AUTH_SUPPLIERS_LIST_SUCCESS = exports.AUTH_SUPPLIERS_LIST_SUCCESS = 'AUTH_SUPPLIERS_LIST_SUCCESS';
var AUTH_SUPPLIERS_LIST_FAILURE = exports.AUTH_SUPPLIERS_LIST_FAILURE = 'AUTH_SUPPLIERS_LIST_FAILURE';

var AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING = exports.AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING = 'AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING';
var AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS = exports.AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS = 'AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS';
var AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE = exports.AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE = 'AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE';

var AUTH_SUPPLIER_SET = exports.AUTH_SUPPLIER_SET = 'AUTH_SUPPLIER_SET';
var AUTH_SUPPLIER_UNSET = exports.AUTH_SUPPLIER_UNSET = 'AUTH_SUPPLIER_UNSET';
var AUTH_PRODUCT_TYPE_SET = exports.AUTH_PRODUCT_TYPE_SET = 'AUTH_PRODUCT_TYPE_SET';

/*
 * Nav module
 */
var NAV_MINIMIZE_TOGGLE = exports.NAV_MINIMIZE_TOGGLE = 'NAV_MINIMIZE_TOGGLE';
var NAV_MINIMIZE_SET = exports.NAV_MINIMIZE_SET = 'NAV_MINIMIZE_SET';
var NAV_MENU_TOGGLE = exports.NAV_MENU_TOGGLE = 'NAV_MENU_TOGGLE';

/*
 * Booking module
 */
var BOOKING_RESET_STATE = exports.BOOKING_RESET_STATE = 'BOOKING_RESET_STATE';

var BOOKING_FETCH_PENDING = exports.BOOKING_FETCH_PENDING = 'BOOKING_FETCH_PENDING';
var BOOKING_FETCH_SUCCESS = exports.BOOKING_FETCH_SUCCESS = 'BOOKING_FETCH_SUCCESS';
var BOOKING_FETCH_FAILURE = exports.BOOKING_FETCH_FAILURE = 'BOOKING_FETCH_FAILURE';
var BOOKING_FETCH_NO_CONTENT = exports.BOOKING_FETCH_NO_CONTENT = 'BOOKING_FETCH_NO_CONTENT';

var BOOKING_PAGE_INCREMENT = exports.BOOKING_PAGE_INCREMENT = 'BOOKING_PAGE_INCREMENT';
var BOOKING_PAGE_DECREMENT = exports.BOOKING_PAGE_DECREMENT = 'BOOKING_PAGE_DECREMENT';
var BOOKING_PAGE_SET = exports.BOOKING_PAGE_SET = 'BOOKING_PAGE_SET';

var BOOKING_PREDICATE_SET = exports.BOOKING_PREDICATE_SET = 'BOOKING_PREDICATE_SET';
var BOOKING_MULTI_PREDICATE_SET = exports.BOOKING_MULTI_PREDICATE_SET = 'BOOKING_MULTI_PREDICATE_SET';
var BOOKING_MULTI_PREDICATE_UNSET = exports.BOOKING_MULTI_PREDICATE_UNSET = 'BOOKING_MULTI_PREDICATE_UNSET';
var BOOKING_MULTI_PREDICATE_RESET = exports.BOOKING_MULTI_PREDICATE_RESET = 'BOOKING_MULTI_PREDICATE_RESET';
var BOOKING_MULTI_PREDICATE_SELECT = exports.BOOKING_MULTI_PREDICATE_SELECT = 'BOOKING_MULTI_PREDICATE_SELECT';
var BOOKING_LIMIT_SET = exports.BOOKING_LIMIT_SET = 'BOOKING_LIMIT_SET';
var BOOKING_ORDER_SET = exports.BOOKING_ORDER_SET = 'BOOKING_ORDER_SET';

var BOOKING_FILTER_PENDING = exports.BOOKING_FILTER_PENDING = 'BOOKING_FILTER_PENDING';
var BOOKING_FILTER_FAILURE = exports.BOOKING_FILTER_FAILURE = 'BOOKING_FILTER_FAILURE';
var BOOKING_FILTER_SUCCESS = exports.BOOKING_FILTER_SUCCESS = 'BOOKING_FILTER_SUCCESS';
var BOOKING_FILTER_SEARCH = exports.BOOKING_FILTER_SEARCH = 'BOOKING_FILTER_SEARCH';

var BOOKING_SET_SELECTED_FILTERS = exports.BOOKING_SET_SELECTED_FILTERS = 'BOOKING_SET_SELECTED_FILTERS';
var BOOKING_SET_BOOKING_PERIOD = exports.BOOKING_SET_BOOKING_PERIOD = 'BOOKING_SET_BOOKING_PERIOD';
var BOOKING_SET_ARRIVAL_PERIOD = exports.BOOKING_SET_ARRIVAL_PERIOD = 'BOOKING_SET_ARRIVAL_PERIOD';

/*
 * Stat module
 */
var STAT_RESET_STATE = exports.STAT_RESET_STATE = 'STAT_RESET_STATE';

var STAT_REVENUE_TOTAL_PENDING = exports.STAT_REVENUE_TOTAL_PENDING = 'STAT_REVENUE_TOTAL_PENDING';
var STAT_REVENUE_TOTAL_SUCCESS = exports.STAT_REVENUE_TOTAL_SUCCESS = 'STAT_REVENUE_TOTAL_SUCCESS';
var STAT_REVENUE_TOTAL_FAILURE = exports.STAT_REVENUE_TOTAL_FAILURE = 'STAT_REVENUE_TOTAL_FAILURE';
var STAT_REVENUE_TOTAL_NO_CONTENT = exports.STAT_REVENUE_TOTAL_NO_CONTENT = 'STAT_REVENUE_TOTAL_NO_CONTENT';

var STAT_REVENUE_PERIOD_PENDING = exports.STAT_REVENUE_PERIOD_PENDING = 'STAT_REVENUE_PERIOD_PENDING';
var STAT_REVENUE_PERIOD_SUCCESS = exports.STAT_REVENUE_PERIOD_SUCCESS = 'STAT_REVENUE_PERIOD_SUCCESS';
var STAT_REVENUE_PERIOD_FAILURE = exports.STAT_REVENUE_PERIOD_FAILURE = 'STAT_REVENUE_PERIOD_FAILURE';
var STAT_REVENUE_PERIOD_NO_CONTENT = exports.STAT_REVENUE_PERIOD_NO_CONTENT = 'STAT_REVENUE_PERIOD_NO_CONTENT';

var STAT_UPDATE_BOOKING_PERIOD = exports.STAT_UPDATE_BOOKING_PERIOD = 'STAT_UPDATE_BOOKING_PERIOD';
var STAT_UPDATE_ARRIVAL_PERIOD = exports.STAT_UPDATE_ARRIVAL_PERIOD = 'STAT_UPDATE_ARRIVAL_PERIOD';
var STAT_UPDATE_SELECTED_SITE = exports.STAT_UPDATE_SELECTED_SITE = 'STAT_UPDATE_SELECTED_SITE';

var STAT_UPDATE_SELECTED_STAT_LIST_ITEM = exports.STAT_UPDATE_SELECTED_STAT_LIST_ITEM = 'STAT_UPDATE_SELECTED_STAT_LIST_ITEM';

var STAT_UPDATE_DROPDOWN_SITES = exports.STAT_UPDATE_DROPDOWN_SITES = "STAT_UPDATE_DROPDOWN_SITES";
var STAT_UPDATE_DROPDOWN_ACCOMMODATION = exports.STAT_UPDATE_DROPDOWN_ACCOMMODATION = "STAT_UPDATE_DROPDOWN_ACCOMMODATION";
var STAT_UPDATE_DROPDOWN_LIST = exports.STAT_UPDATE_DROPDOWN_LIST = "STAT_UPDATE_DROPDOWN_LIST";

/*
 * Allocation module
 */
var ALLOCATION_RESET_STATE = exports.ALLOCATION_RESET_STATE = 'ALLOCATION_RESET_STATE';

var ALLOCATION_DATA_FETCH_PENDING = exports.ALLOCATION_DATA_FETCH_PENDING = 'ALLOCATION_DATA_FETCH_PENDING';
var ALLOCATION_DATA_FETCH_SUCCESS = exports.ALLOCATION_DATA_FETCH_SUCCESS = 'ALLOCATION_DATA_FETCH_SUCCESS';
var ALLOCATION_DATA_FETCH_FAILURE = exports.ALLOCATION_DATA_FETCH_FAILURE = 'ALLOCATION_DATA_FETCH_FAILURE';

var ALLOCATION_LIST_FETCH_PENDING = exports.ALLOCATION_LIST_FETCH_PENDING = 'ALLOCATION_LIST_FETCH_PENDING';
var ALLOCATION_LIST_FETCH_SUCCESS = exports.ALLOCATION_LIST_FETCH_SUCCESS = 'ALLOCATION_LIST_FETCH_SUCCESS';
var ALLOCATION_LIST_FETCH_FAILURE = exports.ALLOCATION_LIST_FETCH_FAILURE = 'ALLOCATION_LIST_FETCH_FAILURE';
var ALLOCATION_LIST_FETCH_NO_CONTENT = exports.ALLOCATION_LIST_FETCH_NO_CONTENT = 'ALLOCATION_LIST_FETCH_NO_CONTENT';

var ALLOCATION_LIST_FILTERS_PENDING = exports.ALLOCATION_LIST_FILTERS_PENDING = 'ALLOCATION_LIST_FILTERS_PENDING';
var ALLOCATION_LIST_FILTERS_SUCCESS = exports.ALLOCATION_LIST_FILTERS_SUCCESS = 'ALLOCATION_LIST_FILTERS_SUCCESS';
var ALLOCATION_LIST_FILTERS_FAILURE = exports.ALLOCATION_LIST_FILTERS_FAILURE = 'ALLOCATION_LIST_FILTERS_FAILURE';

var ALLOCATION_LIST_PAGE_SET = exports.ALLOCATION_LIST_PAGE_SET = 'ALLOCATION_LIST_PAGE_SET';
var ALLOCATION_LIST_PAGE_INCREMENT = exports.ALLOCATION_LIST_PAGE_INCREMENT = 'ALLOCATION_LIST_PAGE_INCREMENT';
var ALLOCATION_LIST_PAGE_DECREMENT = exports.ALLOCATION_LIST_PAGE_DECREMENT = 'ALLOCATION_LIST_PAGE_DECREMENT';

var ALLOCATION_LIST_SELECTED_SET = exports.ALLOCATION_LIST_SELECTED_SET = 'ALLOCATION_LIST_SELECTED_SET';
var ALLOCATION_LIST_SELECTED_RESET = exports.ALLOCATION_LIST_SELECTED_RESET = 'ALLOCATION_LIST_SELECTED_RESET';
var ALLOCATION_LIST_PREDICATE_SET = exports.ALLOCATION_LIST_PREDICATE_SET = 'ALLOCATION_LIST_PREDICATE_SET';
var ALLOCATION_LIST_LIMIT_SET = exports.ALLOCATION_LIST_LIMIT_SET = 'ALLOCATION_LIST_LIMIT_SET';
var ALLOCATION_LIST_ORDER_SET = exports.ALLOCATION_LIST_ORDER_SET = 'ALLOCATION_LIST_ORDER_SET';

var ALLOCATION_LIST_DISPLAY_SELECT = exports.ALLOCATION_LIST_DISPLAY_SELECT = 'ALLOCATION_LIST_DISPLAY_SELECT';
var ALLOCATION_LIST_DISPLAY_RESET = exports.ALLOCATION_LIST_DISPLAY_RESET = 'ALLOCATION_LIST_DISPLAY_RESET';

var ALLOCATION_FORM_ROW_ADD = exports.ALLOCATION_FORM_ROW_ADD = 'ALLOCATION_FORM_ROW_ADD';
var ALLOCATION_FORM_ROW_REMOVE = exports.ALLOCATION_FORM_ROW_REMOVE = 'ALLOCATION_FORM_ROW_REMOVE';
var ALLOCATION_FORM_ROW_CLEAR = exports.ALLOCATION_FORM_ROW_CLEAR = 'ALLOCATION_FORM_ROW_CLEAR';
var ALLOCATION_FORM_ROW_SET = exports.ALLOCATION_FORM_ROW_SET = 'ALLOCATION_FORM_ROW_SET';
var ALLOCATION_FORM_ROW_DUPLICATE = exports.ALLOCATION_FORM_ROW_DUPLICATE = 'ALLOCATION_FORM_ROW_DUPLICATE';
var ALLOCATION_FORM_ROW_RESET = exports.ALLOCATION_FORM_ROW_RESET = 'ALLOCATION_FORM_ROW_RESET';

var ALLOCATION_FORM_SUBMIT = exports.ALLOCATION_FORM_SUBMIT = 'ALLOCATION_FORM_ROW_SUBMIT';
var ALLOCATION_FORM_ACCEPT = exports.ALLOCATION_FORM_ACCEPT = 'ALLOCATION_FORM_ROW_ACCEPT';
var ALLOCATION_FORM_CANCEL = exports.ALLOCATION_FORM_CANCEL = 'ALLOCATION_FORM_ROW_CANCEL';
var ALLOCATION_FORM_TOGGLE = exports.ALLOCATION_FORM_TOGGLE = 'ALLOCATION_FORM_TOGGLE';

var ALLOCATION_ROUTE_FILTERS_PENDING = exports.ALLOCATION_ROUTE_FILTERS_PENDING = 'ALLOCATION_ROUTE_FILTERS_PENDING';
var ALLOCATION_ROUTE_FILTERS_SUCCESS = exports.ALLOCATION_ROUTE_FILTERS_SUCCESS = 'ALLOCATION_ROUTE_FILTERS_SUCCESS';
var ALLOCATION_ROUTE_FILTERS_FAILURE = exports.ALLOCATION_ROUTE_FILTERS_FAILURE = 'ALLOCATION_ROUTE_FILTERS_FAILURE';
var ALLOCATION_ROUTE_FILTERS_SELECTED_SET = exports.ALLOCATION_ROUTE_FILTERS_SELECTED_SET = 'ALLOCATION_ROUTE_FILTERS_SELECTED_SET';

var ALLOCATION_SELECT = exports.ALLOCATION_SELECT = 'ALLOCATION_SELECT';

var ALLOCATION_ALLOCATIONS_ADD_PENDING = exports.ALLOCATION_ALLOCATIONS_ADD_PENDING = 'ALLOCATION_ALLOCATIONS_ADD_PENDING';
var ALLOCATION_ALLOCATIONS_ADD_SUCCESS = exports.ALLOCATION_ALLOCATIONS_ADD_SUCCESS = 'ALLOCATION_ALLOCATIONS_ADD_SUCCESS';
var ALLOCATION_ALLOCATIONS_ADD_FAILURE = exports.ALLOCATION_ALLOCATIONS_ADD_FAILURE = 'ALLOCATION_ALLOCATIONS_ADD_FAILURE';

var ALLOCATION_ALLOCATIONS_FETCH_PENDING = exports.ALLOCATION_ALLOCATIONS_FETCH_PENDING = 'ALLOCATION_ALLOCATIONS_FETCH_PENDING';
var ALLOCATION_ALLOCATIONS_FETCH_SUCCESS = exports.ALLOCATION_ALLOCATIONS_FETCH_SUCCESS = 'ALLOCATION_ALLOCATIONS_FETCH_SUCCESS';
var ALLOCATION_ALLOCATIONS_FETCH_FAILURE = exports.ALLOCATION_ALLOCATIONS_FETCH_FAILURE = 'ALLOCATION_ALLOCATIONS_FETCH_FAILURE';
var ALLOCATION_ALLOCATIONS_FETCH_NO_CONTENT = exports.ALLOCATION_ALLOCATIONS_FETCH_NO_CONTENT = 'ALLOCATION_ALLOCATIONS_FETCH_NO_CONTENT';

var ALLOCATION_ALLOCATIONS_MERGED_FETCH_PENDING = exports.ALLOCATION_ALLOCATIONS_MERGED_FETCH_PENDING = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_PENDING';
var ALLOCATION_ALLOCATIONS_MERGED_FETCH_SUCCESS = exports.ALLOCATION_ALLOCATIONS_MERGED_FETCH_SUCCESS = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_SUCCESS';
var ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE = exports.ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE';
var ALLOCATION_ALLOCATIONS_MERGED_FETCH_NO_CONTENT = exports.ALLOCATION_ALLOCATIONS_MERGED_FETCH_NO_CONTENT = 'ALLOCATION_ALLOCATIONS_MERGED_FETCH_NO_CONTENT';

var ALLOCATION_ALLOCATIONS_PAGE_DECREMENT = exports.ALLOCATION_ALLOCATIONS_PAGE_DECREMENT = 'ALLOCATION_ALLOCATIONS_PAGE_DECREMENT';
var ALLOCATION_ALLOCATIONS_PAGE_INCREMENT = exports.ALLOCATION_ALLOCATIONS_PAGE_INCREMENT = 'ALLOCATION_ALLOCATIONS_PAGE_INCREMENT';
var ALLOCATION_ALLOCATIONS_PAGE_SET = exports.ALLOCATION_ALLOCATIONS_PAGE_SET = 'ALLOCATION_ALLOCATIONS_PAGE_SET';
var ALLOCATION_ALLOCATIONS_LIMIT_SET = exports.ALLOCATION_ALLOCATIONS_LIMIT_SET = 'ALLOCATION_ALLOCATIONS_LIMIT_SET';

var ALLOCATION_CALENDAR_FETCH_PENDING = exports.ALLOCATION_CALENDAR_FETCH_PENDING = 'ALLOCATION_CALENDAR_FETCH_PENDING';
var ALLOCATION_CALENDAR_FETCH_SUCCESS = exports.ALLOCATION_CALENDAR_FETCH_SUCCESS = 'ALLOCATION_CALENDAR_FETCH_SUCCESS';
var ALLOCATION_CALENDAR_FETCH_FAILURE = exports.ALLOCATION_CALENDAR_FETCH_FAILURE = 'ALLOCATION_CALENDAR_FETCH_FAILURE';
var ALLOCATION_CALENDAR_DATE_SET = exports.ALLOCATION_CALENDAR_DATE_SET = 'ALLOCATION_CALENDAR_DATE_SET';
var ALLOCATION_CALENDAR_PAGE_INCREMENT = exports.ALLOCATION_CALENDAR_PAGE_INCREMENT = 'ALLOCATION_CALENDAR_PAGE_INCREMENT';
var ALLOCATION_CALENDAR_PAGE_DECREMENT = exports.ALLOCATION_CALENDAR_PAGE_DECREMENT = 'ALLOCATION_CALENDAR_PAGE_DECREMENT';
var ALLOCATION_CALENDAR_DISPLAY_SET = exports.ALLOCATION_CALENDAR_DISPLAY_SET = 'ALLOCATION_CALENDAR_DISPLAY_SET';
var ALLOCATION_CALENDAR_INFO_TOGGLE = exports.ALLOCATION_CALENDAR_INFO_TOGGLE = 'ALLOCATION_CALENDAR_INFO_TOGGLE';
var ALLOCATION_CALENDAR_INFO_PAGE_SET = exports.ALLOCATION_CALENDAR_INFO_PAGE_SET = 'ALLOCATION_CALENDAR_INFO_PAGE_SET';

var ALLOCATION_YEAR_SET = exports.ALLOCATION_YEAR_SET = 'ALLOCATION_YEAR_SET';

var ALLOCATION_MODAL_FORM_SET = exports.ALLOCATION_MODAL_FORM_SET = 'ALLOCATION_MODAL_FORM_SET';
var ALLOCATION_MODAL_FORM_RESET = exports.ALLOCATION_MODAL_FORM_RESET = 'ALLOCATION_MODAL_FORM_RESET';
var ALLOCATION_FORM_VALIDATOR_FAILURE = exports.ALLOCATION_FORM_VALIDATOR_FAILURE = 'ALLOCATION_FORM_VALIDATOR_FAILURE';
var ALLOCATION_FORM_VALIDATOR_SUCCESS = exports.ALLOCATION_FORM_VALIDATOR_SUCCESS = 'ALLOCATION_FORM_VALIDATOR_SUCCESS';
var ALLOCATION_FORM_VALIDATOR_RESET = exports.ALLOCATION_FORM_VALIDATOR_RESET = 'ALLOCATION_FORM_VALIDATOR_RESET';

var ALLOCATION_MODAL_TOGGLE = exports.ALLOCATION_MODAL_TOGGLE = 'ALLOCATION_MODAL_TOGGLE';
var ALLOCATION_MODAL_ADD_TOGGLE = exports.ALLOCATION_MODAL_ADD_TOGGLE = 'ALLOCATION_MODAL_ADD_TOGGLE';
var ALLOCATION_MODAL_PAGE_INCREMENT = exports.ALLOCATION_MODAL_PAGE_INCREMENT = 'ALLOCATION_MODAL_PAGE_INCREMENT';
var ALLOCATION_MODAL_PAGE_DECREMENT = exports.ALLOCATION_MODAL_PAGE_DECREMENT = 'ALLOCATION_MODAL_PAGE_DECREMENT';
var ALLOCATION_MODAL_PAGE_SET = exports.ALLOCATION_MODAL_PAGE_SET = 'ALLOCATION_MODAL_PAGE_SET';
var ALLOCATION_MODAL_ALLOCATION_SET = exports.ALLOCATION_MODAL_ALLOCATION_SET = 'ALLOCATION_MODAL_ALLOCATION_SET';

var ALLOCATION_MODAL_OVERLAY_TOGGLE = exports.ALLOCATION_MODAL_OVERLAY_TOGGLE = 'ALLOCATION_MODAL_OVERLAY_TOGGLE';
var ALLOCATION_MODAL_OVERLAY_FORM_SET = exports.ALLOCATION_MODAL_OVERLAY_FORM_SET = 'ALLOCATION_MODAL_OVERLAY_FORM_SET';
var ALLOCATION_MODAL_OVERLAY_FORM_RESET = exports.ALLOCATION_MODAL_OVERLAY_FORM_RESET = 'ALLOCATION_MODAL_OVERLAY_FORM_RESET';

var ALLOCATION_MODAL_OVERLAY_VALIDATOR_FAILURE = exports.ALLOCATION_MODAL_OVERLAY_VALIDATOR_FAILURE = 'ALLOCATION_MODAL_OVERLAY_VALIDATOR_FAILURE';
var ALLOCATION_MODAL_OVERLAY_VALIDATOR_SUCCESS = exports.ALLOCATION_MODAL_OVERLAY_VALIDATOR_SUCCESS = 'ALLOCATION_MODAL_OVERLAY_VALIDATOR_SUCCESS';
var ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING = exports.ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING = 'ALLOCATION_ALLOCATIONS_UPDATE_PENDING';
var ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS = exports.ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS = 'ALLOCATION_ALLOCATIONS_UPDATE_SUCCESS';
var ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE = exports.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE = 'ALLOCATION_ALLOCATIONS_UPDATE_FAILURE';
var ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_INCREMENT = exports.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_INCREMENT = 'ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_INCREMENT';
var ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_DECREMENT = exports.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_DECREMENT = 'ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_DECREMENT';
var ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET = exports.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET = 'ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET';
var ALLOCATION_MODAL_OVERLAY_ERROR_MESSAGE_RESET = exports.ALLOCATION_MODAL_OVERLAY_ERROR_MESSAGE_RESET = 'ALLOCATION_MODAL_OVERLAY_ERROR_MESSAGE_RESET';

var ALLOCATION_REQUEST_UPDATE_PENDING = exports.ALLOCATION_REQUEST_UPDATE_PENDING = 'ALLOCATION_REQUEST_UPDATE_PENDING';
var ALLOCATION_REQUEST_UPDATE_SUCCESS = exports.ALLOCATION_REQUEST_UPDATE_SUCCESS = 'ALLOCATION_REQUEST_UPDATE_SUCCESS';
var ALLOCATION_REQUEST_UPDATE_FAILURE = exports.ALLOCATION_REQUEST_UPDATE_FAILURE = 'ALLOCATION_REQUEST_UPDATE_FAILURE';

var ALLOCATION_REQUEST_CHANGE = exports.ALLOCATION_REQUEST_CHANGE = 'ALLOCATION_REQUEST_CHANGE';
var ALLOCATION_REQUEST_LIST_PENDING = exports.ALLOCATION_REQUEST_LIST_PENDING = 'ALLOCATION_REQUEST_LIST_PENDING';
var ALLOCATION_REQUEST_LIST_SUCCESS = exports.ALLOCATION_REQUEST_LIST_SUCCESS = 'ALLOCATION_REQUEST_LIST_SUCCESS';
var ALLOCATION_REQUEST_LIST_FAILURE = exports.ALLOCATION_REQUEST_LIST_FAILURE = 'ALLOCATION_REQUEST_LIST_FAILURE';
var ALLOCATION_REQUEST_LIST_NO_CONTENT = exports.ALLOCATION_REQUEST_LIST_NO_CONTENT = 'ALLOCATION_REQUEST_LIST_NO_CONTENT';

var ALLOCATION_REQUEST_PREDICATE_SET = exports.ALLOCATION_REQUEST_PREDICATE_SET = 'ALLOCATION_REQUEST_PREDICATE_SET';
var ALLOCATION_REQUEST_PAGE_INCREMENT = exports.ALLOCATION_REQUEST_PAGE_INCREMENT = 'ALLOCATION_REQUEST_PAGE_INCREMENT';
var ALLOCATION_REQUEST_PAGE_DECREMENT = exports.ALLOCATION_REQUEST_PAGE_DECREMENT = 'ALLOCATION_REQUEST_PAGE_DECREMENT';
var ALLOCATION_REQUEST_PAGE_RESET = exports.ALLOCATION_REQUEST_PAGE_RESET = 'ALLOCATION_REQUEST_PAGE_RESET';

var ALLOCATION_REQUEST_EDIT_TOGGLE = exports.ALLOCATION_REQUEST_EDIT_TOGGLE = 'ALLOCATION_REQUEST_EDIT_TOGGLE';
var ALLOCATION_REQUEST_ITEM_SELECT = exports.ALLOCATION_REQUEST_ITEM_SELECT = 'ALLOCATION_REQUEST_ITEM_SELECT';
var ALLOCATION_REQUEST_ITEM_DESELECT = exports.ALLOCATION_REQUEST_ITEM_DESELECT = 'ALLOCATION_REQUEST_ITEM_DESELECT';
var ALLOCATION_REQUEST_ITEM_SET = exports.ALLOCATION_REQUEST_ITEM_SET = 'ALLOCATION_REQUEST_ITEM_SET';

var ALLOCATION_COUNTDOWN_RESET = exports.ALLOCATION_COUNTDOWN_RESET = 'ALLOCATION_COUNTDOWN_RESET';
var ALLOCATION_COUNTDOWN_DECREMENT = exports.ALLOCATION_COUNTDOWN_DECREMENT = 'ALLOCATION_COUNTDOWN_DECREMENT';

var ALLOCATION_CALENDAR_DATES_SET = exports.ALLOCATION_CALENDAR_DATES_SET = 'ALLOCATION_CALENDAR_DATES_SET';

var ALLOCATION_ARRIVAL_LIST_PENDING = exports.ALLOCATION_ARRIVAL_LIST_PENDING = 'ALLOCATION_ARRIVAL_LIST_PENDING';
var ALLOCATION_ARRIVAL_LIST_SUCCESS = exports.ALLOCATION_ARRIVAL_LIST_SUCCESS = 'ALLOCATION_ARRIVAL_LIST_SUCCESS';
var ALLOCATION_ARRIVAL_LIST_FAILURE = exports.ALLOCATION_ARRIVAL_LIST_FAILURE = 'ALLOCATION_ARRIVAL_LIST_FAILURE';
var ALLOCATION_ARRIVAL_LIST_NO_CONTENT = exports.ALLOCATION_ARRIVAL_LIST_NO_CONTENT = 'ALLOCATION_ARRIVAL_LIST_NO_CONTENT';

var ALLOCATION_COMMENT_SET = exports.ALLOCATION_COMMENT_SET = 'ALLOCATION_COMMENT_SET';
var ALLOCATION_COMMENT_RESET = exports.ALLOCATION_COMMENT_RESET = 'ALLOCATION_COMMENT_RESET';

// Admin constants
var ADMIN_USERS_GET_PENDING = exports.ADMIN_USERS_GET_PENDING = 'ADMIN_USERS_GET_PENDING';
var ADMIN_USERS_GET_SUCCESS = exports.ADMIN_USERS_GET_SUCCESS = 'ADMIN_USERS_GET_SUCCESS';
var ADMIN_USERS_GET_NOCONTENT = exports.ADMIN_USERS_GET_NOCONTENT = 'ADMIN_USERS_GET_NOCONTENT';
var ADMIN_USERS_GET_FAILURE = exports.ADMIN_USERS_GET_FAILURE = 'ADMIN_USERS_GET_FAILURE';

var ADMIN_USER_GET_PENDING = exports.ADMIN_USER_GET_PENDING = 'ADMIN_USER_GET_PENDING';
var ADMIN_USER_GET_SUCCESS = exports.ADMIN_USER_GET_SUCCESS = 'ADMIN_USER_GET_SUCCESS';
var ADMIN_USER_GET_NOCONTENT = exports.ADMIN_USER_GET_NOCONTENT = 'ADMIN_USER_GET_NOCONTENT';
var ADMIN_USER_GET_FAILURE = exports.ADMIN_USER_GET_FAILURE = 'ADMIN_USER_GET_FAILURE';

var ADMIN_USER_SET = exports.ADMIN_USER_SET = 'ADMIN_USER_SET';
var ADMIN_USER_UNSET = exports.ADMIN_USER_UNSET = 'ADMIN_USER_UNSET';
var ADMIN_USER_EDIT_VALUES = exports.ADMIN_USER_EDIT_VALUES = 'ADMIN_USER_EDIT_VALUES';
var ADMIN_USER_CREATE_VALUES = exports.ADMIN_USER_CREATE_VALUES = 'ADMIN_USER_CREATE_VALUES';

var ADMIN_USER_CREATE_PENDING = exports.ADMIN_USER_CREATE_PENDING = 'ADMIN_USER_CREATE_PENDING';
var ADMIN_USER_CREATE_SUCCESS = exports.ADMIN_USER_CREATE_SUCCESS = 'ADMIN_USER_CREATE_SUCCESS';
var ADMIN_USER_CREATE_FAILURE = exports.ADMIN_USER_CREATE_FAILURE = 'ADMIN_USER_CREATE_FAILURE';

var ADMIN_USER_EDIT_PENDING = exports.ADMIN_USER_EDIT_PENDING = 'ADMIN_USER_EDIT_PENDING';
var ADMIN_USER_EDIT_SUCCESS = exports.ADMIN_USER_EDIT_SUCCESS = 'ADMIN_USER_EDIT_SUCCESS';
var ADMIN_USER_EDIT_FAILURE = exports.ADMIN_USER_EDIT_FAILURE = 'ADMIN_USER_EDIT_FAILURE';

var ADMIN_USER_EDIT_MODAL_TOGGLE = exports.ADMIN_USER_EDIT_MODAL_TOGGLE = 'ADMIN_USER_EDIT_MODAL_TOGGLE';
var ADMIN_USER_CREATE_MODAL_TOGGLE = exports.ADMIN_USER_CREATE_MODAL_TOGGLE = 'ADMIN_USER_CREATE_MODAL_TOGGLE';

var ADMIN_ROLES_GET_PENDING = exports.ADMIN_ROLES_GET_PENDING = 'ADMIN_ROLES_GET_PENDING';
var ADMIN_ROLES_GET_SUCCESS = exports.ADMIN_ROLES_GET_SUCCESS = 'ADMIN_ROLES_GET_SUCCESS';
var ADMIN_ROLES_GET_FAILURE = exports.ADMIN_ROLES_GET_FAILURE = 'ADMIN_ROLES_GET_FAILURE';
var ADMIN_ROLES_GET_NO_CONTENT = exports.ADMIN_ROLES_GET_NO_CONTENT = 'ADMIN_ROLES_GET_NO_CONTENT';

var ADMIN_LANGUAGES_GET_PENDING = exports.ADMIN_LANGUAGES_GET_PENDING = 'ADMIN_LANGUAGES_GET_PENDING';
var ADMIN_LANGUAGES_GET_SUCCESS = exports.ADMIN_LANGUAGES_GET_SUCCESS = 'ADMIN_LANGUAGES_GET_SUCCESS';
var ADMIN_LANGUAGES_GET_FAILURE = exports.ADMIN_LANGUAGES_GET_FAILURE = 'ADMIN_LANGUAGES_GET_FAILURE';
var ADMIN_LANGUAGES_GET_NO_CONTENT = exports.ADMIN_LANGUAGES_GET_NO_CONTENT = 'ADMIN_LANGUAGES_GET_NO_CONTENT';

var ADMIN_FORM_EDIT_SUBMIT = exports.ADMIN_FORM_EDIT_SUBMIT = 'ADMIN_FORM_EDIT_SUBMIT';
var ADMIN_FORM_EDIT_CANCEL = exports.ADMIN_FORM_EDIT_CANCEL = 'ADMIN_FORM_EDIT_CANCEL';
var ADMIN_FORM_EDIT_ACCEPT = exports.ADMIN_FORM_EDIT_ACCEPT = 'ADMIN_FORM_EDIT_ACCEPT';

var ADMIN_FORM_CREATE_SUBMIT = exports.ADMIN_FORM_CREATE_SUBMIT = 'ADMIN_FORM_CREATE_SUBMIT';
var ADMIN_FORM_CREATE_CANCEL = exports.ADMIN_FORM_CREATE_CANCEL = 'ADMIN_FORM_CREATE_CANCEL';
var ADMIN_FORM_CREATE_ACCEPT = exports.ADMIN_FORM_CREATE_ACCEPT = 'ADMIN_FORM_CREATE_ACCEPT';
var LANGUAGE_SELECT = exports.LANGUAGE_SELECT = 'LANGUAGE_SELECT';
var LANGUAGE_SET = exports.LANGUAGE_SET = 'LANGUAGE_SET';

var ADMIN_COUNTDOWN_DECREMENT = exports.ADMIN_COUNTDOWN_DECREMENT = 'ADMIN_COUNTDOWN_DECREMENT';
var ADMIN_COUNTDOWN_CREATE_RESET = exports.ADMIN_COUNTDOWN_CREATE_RESET = 'ADMIN_COUNTDOWN_CREATE_RESET';
var ADMIN_COUNTDOWN_EDIT_RESET = exports.ADMIN_COUNTDOWN_EDIT_RESET = 'ADMIN_COUNTDOWN_EDIT_RESET';

var CSV = exports.CSV = 'CSV';

// Info widget constants
var INFO_WIDGET_TOGGLE = exports.INFO_WIDGET_TOGGLE = 'INFO_WIDGET_TOGGLE';
var INFO_WIDGET_PAGE_SELECT = exports.INFO_WIDGET_PAGE_SELECT = 'INFO_WIDGET_PAGE_SELECT';
var INFO_WIDGET_PAGE_RESET = exports.INFO_WIDGET_PAGE_RESET = 'INFO_WIDGET_PAGE_RESET';
var INFO_WIDGET_PAGE_INCREMENT = exports.INFO_WIDGET_PAGE_INCREMENT = 'INFO_WIDGET_PAGE_INCREMENT';

// Alert constants
var ALERT_COUNTDOWN_RESET = exports.ALERT_COUNTDOWN_RESET = 'ALERT_COUNTDOWN_RESET';
var ALERT_COUNTDOWN_DECREMENT = exports.ALERT_COUNTDOWN_DECREMENT = 'ALERT_COUNTDOWN_DECREMENT';

// Dashboard constants
var DASHBOARD_RESET_STATE = exports.DASHBOARD_RESET_STATE = 'DASHBOARD_RESET_STATE';

var DASHBOARD_AVAILABILITY_PENDING = exports.DASHBOARD_AVAILABILITY_PENDING = 'DASHBOARD_AVAILABILITY_PENDING';
var DASHBOARD_AVAILABILITY_SUCCESS = exports.DASHBOARD_AVAILABILITY_SUCCESS = 'DASHBOARD_AVAILABILITY_SUCCESS';
var DASHBOARD_AVAILABILITY_FAILURE = exports.DASHBOARD_AVAILABILITY_FAILURE = 'DASHBOARD_AVAILABILITY_FAILURE';
var DASHBOARD_AVAILABILITY_NO_CONTENT = exports.DASHBOARD_AVAILABILITY_NO_CONTENT = 'DASHBOARD_AVAILABILITY_NO_CONTENT';

var DASHBOARD_AVAILABILITY_ACCOMMODATION_SET = exports.DASHBOARD_AVAILABILITY_ACCOMMODATION_SET = 'DASHBOARD_AVAILABILITY_ACCOMMODATION_SET';

var DASHBOARD_NOTIFICATIONS_PENDING = exports.DASHBOARD_NOTIFICATIONS_PENDING = 'DASHBOARD_NOTIFICATIONS_PENDING';
var DASHBOARD_NOTIFICATIONS_SUCCESS = exports.DASHBOARD_NOTIFICATIONS_SUCCESS = 'DASHBOARD_NOTIFICATIONS_SUCCESS';
var DASHBOARD_NOTIFICATIONS_FAILURE = exports.DASHBOARD_NOTIFICATIONS_FAILURE = 'DASHBOARD_NOTIFICATIONS_FAILURE';
var DASHBOARD_NOTIFICATIONS_NO_CONTENT = exports.DASHBOARD_NOTIFICATIONS_NO_CONTENT = 'DASHBOARD_NOTIFICATIONS_NO_CONTENT';

var DASHBOARD_NOTIFICATIONS_FILTERS_SET = exports.DASHBOARD_NOTIFICATIONS_FILTERS_SET = 'DASHBOARD_NOTIFICATIONS_FILTERS_SET';
var DASHBOARD_NOTIFICATIONS_PAGE_RESET = exports.DASHBOARD_NOTIFICATIONS_PAGE_RESET = 'DASHBOARD_NOTIFICATIONS_PAGE_RESET';
var DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT = exports.DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT = 'DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT';
var DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT = exports.DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT = 'DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT';
var DASHBOARD_NOTIFICATIONS_LIMIT_SET = exports.DASHBOARD_NOTIFICATIONS_LIMIT_SET = 'DASHBOARD_NOTIFICATIONS_LIMIT_SET';

var DASHBOARD_NOTIFICATIONS_DISMISS_PENDING = exports.DASHBOARD_NOTIFICATIONS_DISMISS_PENDING = 'DASHBOARD_NOTIFICATIONS_DISMISS_PENDING';
var DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS = exports.DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS = 'DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS';
var DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE = exports.DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE = 'DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE';
var DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT = exports.DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT = 'DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT';

var DASHBOARD_SUPPLIERS_PENDING = exports.DASHBOARD_SUPPLIERS_PENDING = 'DASHBOARD_SUPPLIERS_PENDING';
var DASHBOARD_SUPPLIERS_SUCCESS = exports.DASHBOARD_SUPPLIERS_SUCCESS = 'DASHBOARD_SUPPLIERS_SUCCESS';
var DASHBOARD_SUPPLIERS_FAILURE = exports.DASHBOARD_SUPPLIERS_FAILURE = 'DASHBOARD_SUPPLIERS_FAILURE';
var DASHBOARD_SUPPLIERS_NO_CONTENT = exports.DASHBOARD_SUPPLIERS_NO_CONTENT = 'DASHBOARD_SUPPLIERS_NO_CONTENT';

var DASHBOARD_SUPPLIER_SET = exports.DASHBOARD_SUPPLIER_SET = 'DASHBOARD_SUPPLIER_SET';

// Account constants
var ACCOUNT_ACTIVITY_PENDING = exports.ACCOUNT_ACTIVITY_PENDING = 'ACCOUNT_ACTIVITY_PENDING';
var ACCOUNT_ACTIVITY_SUCCESS = exports.ACCOUNT_ACTIVITY_SUCCESS = 'ACCOUNT_ACTIVITY_SUCCESS';
var ACCOUNT_ACTIVITY_FAILURE = exports.ACCOUNT_ACTIVITY_FAILURE = 'ACCOUNT_ACTIVITY_FAILURE';
var ACCOUNT_ACTIVITY_NO_CONTENT = exports.ACCOUNT_ACTIVITY_NO_CONTENT = 'ACCOUNT_ACTIVITY_NO_CONTENT';

var ACCOUNT_NOTIFICATIONS_PENDING = exports.ACCOUNT_NOTIFICATIONS_PENDING = 'ACCOUNT_NOTIFICATIONS_PENDING';
var ACCOUNT_NOTIFICATIONS_SUCCESS = exports.ACCOUNT_NOTIFICATIONS_SUCCESS = 'ACCOUNT_NOTIFICATIONS_SUCCESS';
var ACCOUNT_NOTIFICATIONS_FAILURE = exports.ACCOUNT_NOTIFICATIONS_FAILURE = 'ACCOUNT_NOTIFICATIONS_FAILURE';
var ACCOUNT_NOTIFICATIONS_NO_CONTENT = exports.ACCOUNT_NOTIFICATIONS_NO_CONTENT = 'ACCOUNT_NOTIFICATIONS_NO_CONTENT';

var ACCOUNT_ACTIVITY_ROWS_SET = exports.ACCOUNT_ACTIVITY_ROWS_SET = 'ACCOUNT_ACTIVITY_ROWS_SET';

var ACCOUNT_ACTIVITY_PAGE_INCREMENT = exports.ACCOUNT_ACTIVITY_PAGE_INCREMENT = 'ACCOUNT_ACTIVITY_PAGE_INCREMENT';
var ACCOUNT_ACTIVITY_PAGE_DECREMENT = exports.ACCOUNT_ACTIVITY_PAGE_DECREMENT = 'ACCOUNT_ACTIVITY_PAGE_DECREMENT';
var ACCOUNT_ACTIVITY_PAGE_RESET = exports.ACCOUNT_ACTIVITY_PAGE_RESET = 'ACCOUNT_ACTIVITY_PAGE_RESET';

var ACCOUNT_NOTIFICATION_TOGGLE_PENDING = exports.ACCOUNT_NOTIFICATION_TOGGLE_PENDING = 'ACCOUNT_NOTIFICATION_TOGGLE_PENDING';
var ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS = exports.ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS = 'ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS';
var ACCOUNT_NOTIFICATION_TOGGLE_FAILURE = exports.ACCOUNT_NOTIFICATION_TOGGLE_FAILURE = 'ACCOUNT_NOTIFICATION_TOGGLE_FAILURE';

var ACCOUNT_NOTIFICATION_UPDATE_PENDING = exports.ACCOUNT_NOTIFICATION_UPDATE_PENDING = 'ACCOUNT_NOTIFICATION_UPDATE_PENDING';
var ACCOUNT_NOTIFICATION_UPDATE_SUCCESS = exports.ACCOUNT_NOTIFICATION_UPDATE_SUCCESS = 'ACCOUNT_NOTIFICATION_UPDATE_SUCCESS';
var ACCOUNT_NOTIFICATION_UPDATE_FAILURE = exports.ACCOUNT_NOTIFICATION_UPDATE_FAILURE = 'ACCOUNT_NOTIFICATION_UPDATE_FAILURE';
var ACCOUNT_NOTIFICATION_UPDATE_NO_CONTENT = exports.ACCOUNT_NOTIFICATION_UPDATE_NO_CONTENT = 'ACCOUNT_NOTIFICATION_UPDATE_NO_CONTENT';

var ACCOUNT_NOTIFICATION_EDIT = exports.ACCOUNT_NOTIFICATION_EDIT = 'ACCOUNT_NOTIFICATION_EDIT';
var ACCOUNT_NOTIFICATION_EDIT_TOGGLE = exports.ACCOUNT_NOTIFICATION_EDIT_TOGGLE = 'ACCOUNT_NOTIFICATION_EDIT_TOGGLE';

var ACCOUNT_USER_EDIT = exports.ACCOUNT_USER_EDIT = 'ACCOUNT_USER_EDIT';
var ACCOUNT_USER_RESET = exports.ACCOUNT_USER_RESET = 'ACCOUNT_USER_RESET';

var ACCOUNT_PASSWORD_EDIT = exports.ACCOUNT_PASSWORD_EDIT = 'ACCOUNT_PASSWORD_EDIT';
var ACCOUNT_PASSWORD_RESET = exports.ACCOUNT_PASSWORD_RESET = 'ACCOUNT_PASSWORD_RESET';

var ACCOUNT_USER_PENDING = exports.ACCOUNT_USER_PENDING = 'ACCOUNT_USER_PENDING';
var ACCOUNT_USER_SUCCESS = exports.ACCOUNT_USER_SUCCESS = 'ACCOUNT_USER_SUCCESS';
var ACCOUNT_USER_FAILURE = exports.ACCOUNT_USER_FAILURE = 'ACCOUNT_USER_FAILURE';
var ACCOUNT_USER_NO_CONTENT = exports.ACCOUNT_USER_NO_CONTENT = 'ACCOUNT_USER_NO_CONTENT';

var ACCOUNT_USER_UPDATE_PENDING = exports.ACCOUNT_USER_UPDATE_PENDING = 'ACCOUNT_USER_UPDATE_PENDING';
var ACCOUNT_USER_UPDATE_SUCCESS = exports.ACCOUNT_USER_UPDATE_SUCCESS = 'ACCOUNT_USER_UPDATE_SUCCESS';
var ACCOUNT_USER_UPDATE_FAILURE = exports.ACCOUNT_USER_UPDATE_FAILURE = 'ACCOUNT_USER_UPDATE_FAILURE';
var ACCOUNT_USER_UPDATE_NO_CONTENT = exports.ACCOUNT_USER_UPDATE_NO_CONTENT = 'ACCOUNT_USER_UPDATE_NO_CONTENT';

var ACCOUNT_PASSWORD_UPDATE_PENDING = exports.ACCOUNT_PASSWORD_UPDATE_PENDING = 'ACCOUNT_PASSWORD_UPDATE_PENDING';
var ACCOUNT_PASSWORD_UPDATE_SUCCESS = exports.ACCOUNT_PASSWORD_UPDATE_SUCCESS = 'ACCOUNT_PASSWORD_UPDATE_SUCCESS';
var ACCOUNT_PASSWORD_UPDATE_FAILURE = exports.ACCOUNT_PASSWORD_UPDATE_FAILURE = 'ACCOUNT_PASSWORD_UPDATE_FAILURE';
var ACCOUNT_PASSWORD_UPDATE_NO_CONTENT = exports.ACCOUNT_PASSWORD_UPDATE_NO_CONTENT = 'ACCOUNT_PASSWORD_UPDATE_NO_CONTENT';

// Introduction constants
var INTRODUCTION_CONFIRM_SEND_PENDING = exports.INTRODUCTION_CONFIRM_SEND_PENDING = 'INTRODUCTION_CONFIRM_SEND_PENDING';
var INTRODUCTION_CONFIRM_SEND_SUCCESS = exports.INTRODUCTION_CONFIRM_SEND_SUCCESS = 'INTRODUCTION_CONFIRM_SEND_SUCCESS';
var INTRODUCTION_CONFIRM_SEND_FAILURE = exports.INTRODUCTION_CONFIRM_SEND_FAILURE = 'INTRODUCTION_CONFIRM_SEND_FAILURE';
var INTRODUCTION_CONFIRM_SEND_WARNING = exports.INTRODUCTION_CONFIRM_SEND_WARNING = 'INTRODUCTION_CONFIRM_SEND_WARNING';
var INTRODUCTION_CONFIRM_SEND_NO_CONTENT = exports.INTRODUCTION_CONFIRM_SEND_NO_CONTENT = 'INTRODUCTION_CONFIRM_SEND_NO_CONTENT';

// Contract management constants
var CONTRACT_MANAGEMENT_RESET_STATE = exports.CONTRACT_MANAGEMENT_RESET_STATE = 'CONTRACT_MANAGEMENT_RESET_STATE';

var CONTRACT_MANAGEMENT_OVERVIEW_PENDING = exports.CONTRACT_MANAGEMENT_OVERVIEW_PENDING = 'CONTRACT_MANAGEMENT_OVERVIEW_PENDING';
var CONTRACT_MANAGEMENT_YEARS_SUCCESS = exports.CONTRACT_MANAGEMENT_YEARS_SUCCESS = 'CONTRACT_MANAGEMENT_YEARS_SUCCESS';
var CONTRACT_MANAGEMENT_YEARS_NO_CONTENT = exports.CONTRACT_MANAGEMENT_YEARS_NO_CONTENT = 'CONTRACT_MANAGEMENT_YEARS_NO_CONTENT';
var CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS = exports.CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS = 'CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS';
var CONTRACT_MANAGEMENT_OVERVIEW_FAILURE = exports.CONTRACT_MANAGEMENT_OVERVIEW_FAILURE = 'CONTRACT_MANAGEMENT_OVERVIEW_FAILURE';
var CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT = exports.CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT = 'CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT';

var CONTRACT_MANAGEMENT_FILTER_SET = exports.CONTRACT_MANAGEMENT_FILTER_SET = 'CONTRACT_MANAGEMENT_FILTER_SET';
var CONTRACT_MANAGEMENT_LIST_LIMIT_SET = exports.CONTRACT_MANAGEMENT_LIST_LIMIT_SET = 'CONTRACT_MANAGEMENT_LIST_LIMIT_SET';
var CONTRACT_MANAGEMENT_LIST_YEAR_SET = exports.CONTRACT_MANAGEMENT_LIST_YEAR_SET = 'CONTRACT_MANAGEMENT_LIST_YEAR_SET';
var CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT = exports.CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT = 'CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT';
var CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT = exports.CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT = 'CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT';
var CONTRACT_MANAGEMENT_LIST_PAGE_RESET = exports.CONTRACT_MANAGEMENT_LIST_PAGE_RESET = 'CONTRACT_MANAGEMENT_LIST_PAGE_RESET';
var CONTRACT_MANAGEMENT_LIST_SHOW_SET = exports.CONTRACT_MANAGEMENT_LIST_SHOW_SET = 'CONTRACT_MANAGEMENT_LIST_SHOW_SET';
var CONTRACT_MANAGEMENT_LIST_SEARCH_SET = exports.CONTRACT_MANAGEMENT_LIST_SEARCH_SET = 'CONTRACT_MANAGEMENT_LIST_SEARCH_SET';

var CONTRACT_MANAGEMENT_DATA_PENDING = exports.CONTRACT_MANAGEMENT_DATA_PENDING = 'CONTRACT_MANAGEMENT_DATA_PENDING';
var CONTRACT_MANAGEMENT_DATA_SUCCESS = exports.CONTRACT_MANAGEMENT_DATA_SUCCESS = 'CONTRACT_MANAGEMENT_DATA_SUCCESS';
var CONTRACT_MANAGEMENT_DATA_FAILURE = exports.CONTRACT_MANAGEMENT_DATA_FAILURE = 'CONTRACT_MANAGEMENT_DATA_FAILURE';
var CONTRACT_MANAGEMENT_DATA_NO_CONTENT = exports.CONTRACT_MANAGEMENT_DATA_NO_CONTENT = 'CONTRACT_MANAGEMENT_DATA_NO_CONTENT';

var CONTRACT_MANAGEMENT_FORM_SET = exports.CONTRACT_MANAGEMENT_FORM_SET = 'CONTRACT_MANAGEMENT_FORM_SET';
var CONTRACT_MANAGEMENT_FORM_UNSET = exports.CONTRACT_MANAGEMENT_FORM_UNSET = 'CONTRACT_MANAGEMENT_FORM_UNSET';
var CONTRACT_MANAGEMENT_PART_SET = exports.CONTRACT_MANAGEMENT_PART_SET = 'CONTRACT_MANAGEMENT_PART_SET';
var CONTRACT_MANAGEMENT_FORM_FILE_REMOVE = exports.CONTRACT_MANAGEMENT_FORM_FILE_REMOVE = 'CONTRACT_MANAGEMENT_FORM_FILE_REMOVE';

var CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING = exports.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING';
var CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS = exports.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS';
var CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE = exports.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE';
var CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT = exports.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT';

var CONTRACT_MANAGEMENT_FORM_PAGE_SET = exports.CONTRACT_MANAGEMENT_FORM_PAGE_SET = 'CONTRACT_MANAGEMENT_FORM_PAGE_SET';

var CONTRACT_MANAGEMENT_FORM_SAVE_PENDING = exports.CONTRACT_MANAGEMENT_FORM_SAVE_PENDING = 'CONTRACT_MANAGEMENT_FORM_SAVE_PENDING';
var CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS = exports.CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS';
var CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE = exports.CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE = 'CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE';
var CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT = exports.CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT';

var CONTRACT_MANAGEMENT_PROGRESS_SET = exports.CONTRACT_MANAGEMENT_PROGRESS_SET = 'CONTRACT_MANAGEMENT_PROGRESS_SET';

var CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING = exports.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING';
var CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS = exports.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS';
var CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE = exports.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE';
var CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT = exports.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT';

var CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING = exports.CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING = 'CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING';
var CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS = exports.CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS = 'CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS';
var CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE = exports.CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE = 'CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE';
var CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT = exports.CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT = 'CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT';

var CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD = exports.CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD = 'CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD';
var CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE = exports.CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE = 'CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE';

var CONTRACT_MANAGEMENT_FORM_INDEX_SET = exports.CONTRACT_MANAGEMENT_FORM_INDEX_SET = 'CONTRACT_MANAGEMENT_FORM_INDEX_SET';
var CONTRACT_MANAGEMENT_FORM_INDEX_RESET = exports.CONTRACT_MANAGEMENT_FORM_INDEX_RESET = 'CONTRACT_MANAGEMENT_FORM_INDEX_RESET';

var CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING = exports.CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING';
var CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS = exports.CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS';
var CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE = exports.CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE';
var CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT = exports.CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT = 'CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT';

var CONTRACT_MANAGEMENT_READY_FOR_REVIEW_PENDING = exports.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_PENDING = 'CONTRACT_MANAGEMENT_READY_FOR_REVIEW_PENDING';
var CONTRACT_MANAGEMENT_READY_FOR_REVIEW_SUCCESS = exports.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_SUCCESS = 'CONTRACT_MANAGEMENT_READY_FOR_REVIEW_SUCCESS';
var CONTRACT_MANAGEMENT_READY_FOR_REVIEW_FAILURE = exports.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_FAILURE = 'CONTRACT_MANAGEMENT_READY_FOR_REVIEW_FAILURE';

var CONTRACT_MANAGEMENT_NO_CHANGES_SET = exports.CONTRACT_MANAGEMENT_NO_CHANGES_SET = 'CONTRACT_MANAGEMENT_NO_CHANGES_SET';

var CONTRACT_MANAGEMENT_GET_BRANDS_PENDING = exports.CONTRACT_MANAGEMENT_GET_BRANDS_PENDING = 'CONTRACT_MANAGEMENT_GET_BRANDS_PENDING';
var CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS = exports.CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS = 'CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS';
var CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT = exports.CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT = 'CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT';
var CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE = exports.CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE = 'CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE';

var CONTRACT_MANAGEMENT_ADD_BRAND = exports.CONTRACT_MANAGEMENT_ADD_BRAND = 'CONTRACT_MANAGEMENT_ADD_BRAND';
var CONTRACT_MANAGEMENT_REMOVE_BRAND = exports.CONTRACT_MANAGEMENT_REMOVE_BRAND = 'CONTRACT_MANAGEMENT_REMOVE_BRAND';

var CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING = exports.CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING = 'CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING';
var CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS = exports.CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS = 'CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS';
var CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS = exports.CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS = 'CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS';
var CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT = exports.CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT = 'CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT';
var CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE = exports.CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE = 'CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE';

// Contract constants
var CONTRACT_DATA_PENDING = exports.CONTRACT_DATA_PENDING = 'CONTRACT_DATA_PENDING';
var CONTRACT_DATA_SUCCESS = exports.CONTRACT_DATA_SUCCESS = 'CONTRACT_DATA_SUCCESS';
var CONTRACT_DATA_FAILURE = exports.CONTRACT_DATA_FAILURE = 'CONTRACT_DATA_FAILURE';
var CONTRACT_DATA_NO_CONTENT = exports.CONTRACT_DATA_NO_CONTENT = 'CONTRACT_DATA_NO_CONTENT';
var CONTRACT_DATA_PRODUCT_ERROR = exports.CONTRACT_DATA_PRODUCT_ERROR = 'CONTRACT_DATA_PRODUCT_ERROR';

var CONTRACT_NOTES_PENDING = exports.CONTRACT_NOTES_PENDING = 'CONTRACT_NOTES_PENDING';
var CONTRACT_NOTES_SUCCESS = exports.CONTRACT_NOTES_SUCCESS = 'CONTRACT_NOTES_SUCCESS';
var CONTRACT_NOTES_FAILURE = exports.CONTRACT_NOTES_FAILURE = 'CONTRACT_NOTES_FAILURE';
var CONTRACT_NOTES_NO_CONTENT = exports.CONTRACT_NOTES_NO_CONTENT = 'CONTRACT_NOTES_NO_CONTENT';

var CONTRACT_HISTORY_PENDING = exports.CONTRACT_HISTORY_PENDING = 'CONTRACT_HISTORY_PENDING';
var CONTRACT_HISTORY_SUCCESS = exports.CONTRACT_HISTORY_SUCCESS = 'CONTRACT_HISTORY_SUCCESS';
var CONTRACT_HISTORY_FAILURE = exports.CONTRACT_HISTORY_FAILURE = 'CONTRACT_HISTORY_FAILURE';
var CONTRACT_HISTORY_NO_CONTENT = exports.CONTRACT_HISTORY_NO_CONTENT = 'CONTRACT_HISTORY_NO_CONTENT';

var CONTRACT_FORM_PART_SET = exports.CONTRACT_FORM_PART_SET = 'CONTRACT_FORM_PART_SET';

var CONTRACT_FORM_PART_ACCEPT_PENDING = exports.CONTRACT_FORM_PART_ACCEPT_PENDING = 'CONTRACT_FORM_PART_ACCEPT_PENDING';
var CONTRACT_FORM_PART_ACCEPT_SUCCESS = exports.CONTRACT_FORM_PART_ACCEPT_SUCCESS = 'CONTRACT_FORM_PART_ACCEPT_SUCCESS';
var CONTRACT_FORM_PART_ACCEPT_FAILURE = exports.CONTRACT_FORM_PART_ACCEPT_FAILURE = 'CONTRACT_FORM_PART_ACCEPT_FAILURE';

var CONTRACT_FORM_NOTES_SET = exports.CONTRACT_FORM_NOTES_SET = 'CONTRACT_FORM_NOTES_SET';

var CONTRACT_FORM_SAVE_PENDING = exports.CONTRACT_FORM_SAVE_PENDING = 'CONTRACT_FORM_SAVE_PENDING';
var CONTRACT_FORM_SAVE_SUCCESS = exports.CONTRACT_FORM_SAVE_SUCCESS = 'CONTRACT_FORM_SAVE_SUCCESS';
var CONTRACT_FORM_SAVE_FAILURE = exports.CONTRACT_FORM_SAVE_FAILURE = 'CONTRACT_FORM_SAVE_FAILURE';

var CONTRACT_FINISH_PENDING = exports.CONTRACT_FINISH_PENDING = 'CONTRACT_FINISH_PENDING';
var CONTRACT_FINISH_SUCCESS = exports.CONTRACT_FINISH_SUCCESS = 'CONTRACT_FINISH_SUCCESS';
var CONTRACT_FINISH_FAILURE = exports.CONTRACT_FINISH_FAILURE = 'CONTRACT_FINISH_FAILURE';
var CONTRACT_FINISH_NO_CONTENT = exports.CONTRACT_FINISH_NO_CONTENT = 'CONTRACT_FINISH_NO_CONTENT';

var CONTRACT_DOWNLOAD_PENDING = exports.CONTRACT_DOWNLOAD_PENDING = 'CONTRACT_DOWNLOAD_PENDING';
var CONTRACT_DOWNLOAD_SUCCESS = exports.CONTRACT_DOWNLOAD_SUCCESS = 'CONTRACT_DOWNLOAD_SUCCESS';
var CONTRACT_DOWNLOAD_FAILURE = exports.CONTRACT_DOWNLOAD_FAILURE = 'CONTRACT_DOWNLOAD_FAILURE';

var CONTRACT_NOTE_SET = exports.CONTRACT_NOTE_SET = 'CONTRACT_NOTE_SET';

var CONTRACT_NOTE_CREATE_PENDING = exports.CONTRACT_NOTE_CREATE_PENDING = 'CONTRACT_NOTE_CREATE_PENDING';
var CONTRACT_NOTE_CREATE_SUCCESS = exports.CONTRACT_NOTE_CREATE_SUCCESS = 'CONTRACT_NOTE_CREATE_SUCCESS';
var CONTRACT_NOTE_CREATE_FAILURE = exports.CONTRACT_NOTE_CREATE_FAILURE = 'CONTRACT_NOTE_CREATE_FAILURE';

var CONTRACT_ACCEPT_LIST_PENDING = exports.CONTRACT_ACCEPT_LIST_PENDING = 'CONTRACT_ACCEPT_LIST_PENDING';
var CONTRACT_ACCEPT_LIST_SUCCESS = exports.CONTRACT_ACCEPT_LIST_SUCCESS = 'CONTRACT_ACCEPT_LIST_SUCCESS';
var CONTRACT_ACCEPT_LIST_FAILURE = exports.CONTRACT_ACCEPT_LIST_FAILURE = 'CONTRACT_ACCEPT_LIST_FAILURE';

var CONTRACT_NOTE_EMAIL_PENDING = exports.CONTRACT_NOTE_EMAIL_PENDING = 'CONTRACT_NOTE_EMAIL_PENDING';
var CONTRACT_NOTE_EMAIL_SUCCESS = exports.CONTRACT_NOTE_EMAIL_SUCCESS = 'CONTRACT_NOTE_EMAIL_SUCCESS';
var CONTRACT_NOTE_EMAIL_FAILURE = exports.CONTRACT_NOTE_EMAIL_FAILURE = 'CONTRACT_NOTE_EMAIL_FAILURE';

var CONTRACT_RESET_STATE = exports.CONTRACT_RESET_STATE = 'CONTRACT_RESET_STATE';

var CONTRACT_DRAFT_PENDING = exports.CONTRACT_DRAFT_PENDING = 'CONTRACT_DRAFT_PENDING';
var CONTRACT_DRAFT_SUCCESS = exports.CONTRACT_DRAFT_SUCCESS = 'CONTRACT_DRAFT_SUCCESS';
var CONTRACT_DRAFT_FAILURE = exports.CONTRACT_DRAFT_FAILURE = 'CONTRACT_DRAFT_FAILURE';

// Instruction constants
var INSTRUCTION_DISMISS = exports.INSTRUCTION_DISMISS = 'INSTRUCTION_DISMISS';

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash-es/_root.js
var _root = __webpack_require__(17);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root["a" /* default */].Symbol;

/* harmony default export */ var _Symbol = (Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == symbolTag);
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToNumber.js


/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (lodash_es_isSymbol(value)) {
    return NAN;
  }
  return +value;
}

/* harmony default export */ var _baseToNumber = (baseToNumber);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createMathOperation.js



/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = _baseToString(value);
        other = _baseToString(other);
      } else {
        value = _baseToNumber(value);
        other = _baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

/* harmony default export */ var _createMathOperation = (createMathOperation);

// CONCATENATED MODULE: ./node_modules/lodash-es/add.js


/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = _createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

/* harmony default export */ var lodash_es_add = (add);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/toNumber.js



/** Used as references for various `Number` constants. */
var toNumber_NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (lodash_es_isSymbol(value)) {
    return toNumber_NAN;
  }
  if (lodash_es_isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = lodash_es_isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? toNumber_NAN : +value);
}

/* harmony default export */ var lodash_es_toNumber = (toNumber);

// CONCATENATED MODULE: ./node_modules/lodash-es/toFinite.js


/** Used as references for various `Number` constants. */
var toFinite_INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = lodash_es_toNumber(value);
  if (value === toFinite_INFINITY || value === -toFinite_INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ var lodash_es_toFinite = (toFinite);

// CONCATENATED MODULE: ./node_modules/lodash-es/toInteger.js


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = lodash_es_toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ var lodash_es_toInteger = (toInteger);

// CONCATENATED MODULE: ./node_modules/lodash-es/after.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The opposite of `_.before`; this method creates a function that invokes
 * `func` once it's called `n` or more times.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {number} n The number of calls before `func` is invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var saves = ['profile', 'settings'];
 *
 * var done = _.after(saves.length, function() {
 *   console.log('done saving!');
 * });
 *
 * _.forEach(saves, function(type) {
 *   asyncSave({ 'type': type, 'complete': done });
 * });
 * // => Logs 'done saving!' after the two async saves have completed.
 */
function after(n, func) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = lodash_es_toInteger(n);
  return function() {
    if (--n < 1) {
      return func.apply(this, arguments);
    }
  };
}

/* harmony default export */ var lodash_es_after = (after);

// CONCATENATED MODULE: ./node_modules/lodash-es/identity.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var lodash_es_identity = (identity);

// CONCATENATED MODULE: ./node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ var lodash_es_isFunction = (isFunction);

// CONCATENATED MODULE: ./node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["a" /* default */]['__core-js_shared__'];

/* harmony default export */ var _coreJsData = (coreJsData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

// CONCATENATED MODULE: ./node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ var _toSource = (toSource);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root["a" /* default */], 'WeakMap');

/* harmony default export */ var _WeakMap = (WeakMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_metaMap.js


/** Used to store function metadata. */
var metaMap = _WeakMap && new _WeakMap;

/* harmony default export */ var _metaMap = (metaMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetData.js



/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !_metaMap ? lodash_es_identity : function(func, data) {
  _metaMap.set(func, data);
  return func;
};

/* harmony default export */ var _baseSetData = (baseSetData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCtor.js



/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = _baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return lodash_es_isObject(result) ? result : thisBinding;
  };
}

/* harmony default export */ var _createCtor = (createCtor);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createBind.js



/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = _createCtor(func);

  function wrapper() {
    var fn = (this && this !== _root["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/* harmony default export */ var _createBind = (createBind);

// CONCATENATED MODULE: ./node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ var _apply = (apply);

// CONCATENATED MODULE: ./node_modules/lodash-es/_composeArgs.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/* harmony default export */ var _composeArgs = (composeArgs);

// CONCATENATED MODULE: ./node_modules/lodash-es/_composeArgsRight.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _composeArgsRight_nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = _composeArgsRight_nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/* harmony default export */ var _composeArgsRight = (composeArgsRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_countHolders.js
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

/* harmony default export */ var _countHolders = (countHolders);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseLodash.js
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

/* harmony default export */ var _baseLodash = (baseLodash);

// CONCATENATED MODULE: ./node_modules/lodash-es/_LazyWrapper.js



/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = _baseCreate(_baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

/* harmony default export */ var _LazyWrapper = (LazyWrapper);

// CONCATENATED MODULE: ./node_modules/lodash-es/noop.js
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/* harmony default export */ var lodash_es_noop = (noop);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getData.js



/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !_metaMap ? lodash_es_noop : function(func) {
  return _metaMap.get(func);
};

/* harmony default export */ var _getData = (getData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_realNames.js
/** Used to lookup unminified function names. */
var realNames = {};

/* harmony default export */ var _realNames = (realNames);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getFuncName.js


/** Used for built-in method references. */
var _getFuncName_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getFuncName_hasOwnProperty = _getFuncName_objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = _realNames[result],
      length = _getFuncName_hasOwnProperty.call(_realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

/* harmony default export */ var _getFuncName = (getFuncName);

// CONCATENATED MODULE: ./node_modules/lodash-es/_LodashWrapper.js



/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = _baseCreate(_baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

/* harmony default export */ var _LodashWrapper = (LodashWrapper);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_wrapperClone.js




/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof _LazyWrapper) {
    return wrapper.clone();
  }
  var result = new _LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = _copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

/* harmony default export */ var _wrapperClone = (wrapperClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperLodash.js







/** Used for built-in method references. */
var wrapperLodash_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var wrapperLodash_hasOwnProperty = wrapperLodash_objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (lodash_es_isObjectLike(value) && !lodash_es_isArray(value) && !(value instanceof _LazyWrapper)) {
    if (value instanceof _LodashWrapper) {
      return value;
    }
    if (wrapperLodash_hasOwnProperty.call(value, '__wrapped__')) {
      return _wrapperClone(value);
    }
  }
  return new _LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = _baseLodash.prototype;
lodash.prototype.constructor = lodash;

/* harmony default export */ var wrapperLodash = (lodash);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isLaziable.js





/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = _getFuncName(func),
      other = wrapperLodash[funcName];

  if (typeof other != 'function' || !(funcName in _LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = _getData(other);
  return !!data && func === data[0];
}

/* harmony default export */ var _isLaziable = (isLaziable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ var _shortOut = (shortOut);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setData.js



/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = _shortOut(_baseSetData);

/* harmony default export */ var _setData = (setData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getWrapDetails.js
/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/* harmony default export */ var _getWrapDetails = (getWrapDetails);

// CONCATENATED MODULE: ./node_modules/lodash-es/_insertWrapDetails.js
/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/* harmony default export */ var _insertWrapDetails = (insertWrapDetails);

// CONCATENATED MODULE: ./node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);

// CONCATENATED MODULE: ./node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var _defineProperty = (defineProperty);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty ? lodash_es_identity : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* harmony default export */ var _setToString = (setToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFindIndex.js
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _baseFindIndex = (baseFindIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNaN.js
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ var _baseIsNaN = (baseIsNaN);

// CONCATENATED MODULE: ./node_modules/lodash-es/_strictIndexOf.js
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _strictIndexOf = (strictIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIndexOf.js




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

/* harmony default export */ var _baseIndexOf = (baseIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayIncludes.js


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && _baseIndexOf(array, value, 0) > -1;
}

/* harmony default export */ var _arrayIncludes = (arrayIncludes);

// CONCATENATED MODULE: ./node_modules/lodash-es/_updateWrapDetails.js



/** Used to compose bitmasks for function metadata. */
var _updateWrapDetails_WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', _updateWrapDetails_WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  _arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !_arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/* harmony default export */ var _updateWrapDetails = (updateWrapDetails);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setWrapToString.js





/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return _setToString(wrapper, _insertWrapDetails(source, _updateWrapDetails(_getWrapDetails(source), bitmask)));
}

/* harmony default export */ var _setWrapToString = (setWrapToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createRecurry.js




/** Used to compose bitmasks for function metadata. */
var _createRecurry_WRAP_BIND_FLAG = 1,
    _createRecurry_WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    _createRecurry_WRAP_CURRY_FLAG = 8,
    _createRecurry_WRAP_PARTIAL_FLAG = 32,
    _createRecurry_WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & _createRecurry_WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? _createRecurry_WRAP_PARTIAL_FLAG : _createRecurry_WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? _createRecurry_WRAP_PARTIAL_RIGHT_FLAG : _createRecurry_WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(_createRecurry_WRAP_BIND_FLAG | _createRecurry_WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (_isLaziable(func)) {
    _setData(result, newData);
  }
  result.placeholder = placeholder;
  return _setWrapToString(result, func, bitmask);
}

/* harmony default export */ var _createRecurry = (createRecurry);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getHolder.js
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/* harmony default export */ var _getHolder = (getHolder);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ var _isIndex = (isIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/_reorder.js



/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = _copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = _isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/* harmony default export */ var _reorder = (reorder);

// CONCATENATED MODULE: ./node_modules/lodash-es/_replaceHolders.js
/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/* harmony default export */ var _replaceHolders = (replaceHolders);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createHybrid.js










/** Used to compose bitmasks for function metadata. */
var _createHybrid_WRAP_BIND_FLAG = 1,
    _createHybrid_WRAP_BIND_KEY_FLAG = 2,
    _createHybrid_WRAP_CURRY_FLAG = 8,
    _createHybrid_WRAP_CURRY_RIGHT_FLAG = 16,
    _createHybrid_WRAP_ARY_FLAG = 128,
    _createHybrid_WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & _createHybrid_WRAP_ARY_FLAG,
      isBind = bitmask & _createHybrid_WRAP_BIND_FLAG,
      isBindKey = bitmask & _createHybrid_WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (_createHybrid_WRAP_CURRY_FLAG | _createHybrid_WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & _createHybrid_WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : _createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = _getHolder(wrapper),
          holdersCount = _countHolders(args, placeholder);
    }
    if (partials) {
      args = _composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = _composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = _replaceHolders(args, placeholder);
      return _createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = _reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== _root["a" /* default */] && this instanceof wrapper) {
      fn = Ctor || _createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/* harmony default export */ var _createHybrid = (createHybrid);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCurry.js








/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = _createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = _getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : _replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return _createRecurry(
        func, bitmask, _createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== _root["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return _apply(fn, this, args);
  }
  return wrapper;
}

/* harmony default export */ var _createCurry = (createCurry);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createPartial.js




/** Used to compose bitmasks for function metadata. */
var _createPartial_WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & _createPartial_WRAP_BIND_FLAG,
      Ctor = _createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== _root["a" /* default */] && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return _apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/* harmony default export */ var _createPartial = (createPartial);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mergeData.js




/** Used as the internal argument placeholder. */
var _mergeData_PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var _mergeData_WRAP_BIND_FLAG = 1,
    _mergeData_WRAP_BIND_KEY_FLAG = 2,
    _mergeData_WRAP_CURRY_BOUND_FLAG = 4,
    _mergeData_WRAP_CURRY_FLAG = 8,
    _mergeData_WRAP_ARY_FLAG = 128,
    _mergeData_WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _mergeData_nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (_mergeData_WRAP_BIND_FLAG | _mergeData_WRAP_BIND_KEY_FLAG | _mergeData_WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == _mergeData_WRAP_ARY_FLAG) && (bitmask == _mergeData_WRAP_CURRY_FLAG)) ||
    ((srcBitmask == _mergeData_WRAP_ARY_FLAG) && (bitmask == _mergeData_WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (_mergeData_WRAP_ARY_FLAG | _mergeData_WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == _mergeData_WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & _mergeData_WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & _mergeData_WRAP_BIND_FLAG ? 0 : _mergeData_WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? _composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? _replaceHolders(data[3], _mergeData_PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? _composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? _replaceHolders(data[5], _mergeData_PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & _mergeData_WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : _mergeData_nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

/* harmony default export */ var _mergeData = (mergeData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createWrap.js











/** Error message constants. */
var _createWrap_FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var _createWrap_WRAP_BIND_FLAG = 1,
    _createWrap_WRAP_BIND_KEY_FLAG = 2,
    _createWrap_WRAP_CURRY_FLAG = 8,
    _createWrap_WRAP_CURRY_RIGHT_FLAG = 16,
    _createWrap_WRAP_PARTIAL_FLAG = 32,
    _createWrap_WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _createWrap_nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & _createWrap_WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(_createWrap_FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(_createWrap_WRAP_PARTIAL_FLAG | _createWrap_WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : _createWrap_nativeMax(lodash_es_toInteger(ary), 0);
  arity = arity === undefined ? arity : lodash_es_toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & _createWrap_WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : _getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    _mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : _createWrap_nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (_createWrap_WRAP_CURRY_FLAG | _createWrap_WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(_createWrap_WRAP_CURRY_FLAG | _createWrap_WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == _createWrap_WRAP_BIND_FLAG) {
    var result = _createBind(func, bitmask, thisArg);
  } else if (bitmask == _createWrap_WRAP_CURRY_FLAG || bitmask == _createWrap_WRAP_CURRY_RIGHT_FLAG) {
    result = _createCurry(func, bitmask, arity);
  } else if ((bitmask == _createWrap_WRAP_PARTIAL_FLAG || bitmask == (_createWrap_WRAP_BIND_FLAG | _createWrap_WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = _createPartial(func, bitmask, thisArg, partials);
  } else {
    result = _createHybrid.apply(undefined, newData);
  }
  var setter = data ? _baseSetData : _setData;
  return _setWrapToString(setter(result, newData), func, bitmask);
}

/* harmony default export */ var _createWrap = (createWrap);

// CONCATENATED MODULE: ./node_modules/lodash-es/ary.js


/** Used to compose bitmasks for function metadata. */
var ary_WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary_ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return _createWrap(func, ary_WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

/* harmony default export */ var lodash_es_ary = (ary_ary);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

// CONCATENATED MODULE: ./node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var _overRest_nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = _overRest_nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = _overRest_nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* harmony default export */ var _overRest = (overRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRest.js




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, lodash_es_identity), func + '');
}

/* harmony default export */ var _baseRest = (baseRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var isLength_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= isLength_MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isIterateeCall.js





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!lodash_es_isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (lodash_es_isArrayLike(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return lodash_es_eq(object[index], value);
  }
  return false;
}

/* harmony default export */ var _isIterateeCall = (isIterateeCall);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createAssigner.js



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ var _createAssigner = (createAssigner);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);

// EXTERNAL MODULE: ./node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(47);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);

// EXTERNAL MODULE: ./node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__(73);

// CONCATENATED MODULE: ./node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && Object(isBuffer["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = (arrayLikeKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* harmony default export */ var lodash_es_keys = (keys);

// CONCATENATED MODULE: ./node_modules/lodash-es/assign.js







/** Used for built-in method references. */
var assign_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var assign_hasOwnProperty = assign_objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign_assign = _createAssigner(function(object, source) {
  if (_isPrototype(source) || lodash_es_isArrayLike(source)) {
    _copyObject(source, lodash_es_keys(source), object);
    return;
  }
  for (var key in source) {
    if (assign_hasOwnProperty.call(source, key)) {
      _assignValue(object, key, source[key]);
    }
  }
});

/* harmony default export */ var lodash_es_assign = (assign_assign);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var _baseKeysIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = _baseKeysIn_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!lodash_es_isObject(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn_keysIn(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = (keysIn_keysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/assignIn.js




/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = _createAssigner(function(object, source) {
  _copyObject(source, lodash_es_keysIn(source), object);
});

/* harmony default export */ var lodash_es_assignIn = (assignIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/assignInWith.js




/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = _createAssigner(function(object, source, srcIndex, customizer) {
  _copyObject(source, lodash_es_keysIn(source), object, customizer);
});

/* harmony default export */ var lodash_es_assignInWith = (assignInWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/assignWith.js




/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = _createAssigner(function(object, source, srcIndex, customizer) {
  _copyObject(source, lodash_es_keys(source), object, customizer);
});

/* harmony default export */ var lodash_es_assignWith = (assignWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isKey.js



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (lodash_es_isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || lodash_es_isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ var _isKey = (isKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root["a" /* default */], 'Map');

/* harmony default export */ var _Map = (Map);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

// CONCATENATED MODULE: ./node_modules/lodash-es/memoize.js


/** Error message constants. */
var memoize_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(memoize_FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (lodash_es_isArray(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(lodash_es_toString(value));
}

/* harmony default export */ var _castPath = (castPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var _toKey_INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_toKey_INFINITY) ? '-0' : result;
}

/* harmony default export */ var _toKey = (toKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGet.js



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ var _baseGet = (baseGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/get.js


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ var lodash_es_get = (get);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAt.js


/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
      length = paths.length,
      result = Array(length),
      skip = object == null;

  while (++index < length) {
    result[index] = skip ? undefined : lodash_es_get(object, paths[index]);
  }
  return result;
}

/* harmony default export */ var _baseAt = (baseAt);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ var _arrayPush = (arrayPush);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isFlattenable.js




/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return lodash_es_isArray(value) || lodash_es_isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* harmony default export */ var _isFlattenable = (isFlattenable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFlatten.js



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* harmony default export */ var _baseFlatten = (baseFlatten);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatten.js


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

/* harmony default export */ var lodash_es_flatten = (flatten);

// CONCATENATED MODULE: ./node_modules/lodash-es/_flatRest.js




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return _setToString(_overRest(func, undefined, lodash_es_flatten), func + '');
}

/* harmony default export */ var _flatRest = (flatRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/at.js



/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = _flatRest(_baseAt);

/* harmony default export */ var lodash_es_at = (at);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var isPlainObject_objectTag = '[object Object]';

/** Used for built-in method references. */
var isPlainObject_funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var isPlainObject_funcToString = isPlainObject_funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = isPlainObject_funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != isPlainObject_objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    isPlainObject_funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/isError.js




/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    isError_errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!lodash_es_isObjectLike(value)) {
    return false;
  }
  var tag = _baseGetTag(value);
  return tag == isError_errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !lodash_es_isPlainObject(value));
}

/* harmony default export */ var lodash_es_isError = (isError);

// CONCATENATED MODULE: ./node_modules/lodash-es/attempt.js




/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = _baseRest(function(func, args) {
  try {
    return _apply(func, undefined, args);
  } catch (e) {
    return lodash_es_isError(e) ? e : new Error(e);
  }
});

/* harmony default export */ var lodash_es_attempt = (attempt);

// CONCATENATED MODULE: ./node_modules/lodash-es/before.js


/** Error message constants. */
var before_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(before_FUNC_ERROR_TEXT);
  }
  n = lodash_es_toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/* harmony default export */ var lodash_es_before = (before);

// CONCATENATED MODULE: ./node_modules/lodash-es/bind.js





/** Used to compose bitmasks for function metadata. */
var bind_WRAP_BIND_FLAG = 1,
    bind_WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = _baseRest(function(func, thisArg, partials) {
  var bitmask = bind_WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = _replaceHolders(partials, _getHolder(bind));
    bitmask |= bind_WRAP_PARTIAL_FLAG;
  }
  return _createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

/* harmony default export */ var lodash_es_bind = (bind);

// CONCATENATED MODULE: ./node_modules/lodash-es/bindAll.js






/**
 * Binds methods of an object to the object itself, overwriting the existing
 * method.
 *
 * **Note:** This method doesn't set the "length" property of bound functions.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Object} object The object to bind and assign the bound methods to.
 * @param {...(string|string[])} methodNames The object method names to bind.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var view = {
 *   'label': 'docs',
 *   'click': function() {
 *     console.log('clicked ' + this.label);
 *   }
 * };
 *
 * _.bindAll(view, ['click']);
 * jQuery(element).on('click', view.click);
 * // => Logs 'clicked docs' when clicked.
 */
var bindAll = _flatRest(function(object, methodNames) {
  _arrayEach(methodNames, function(key) {
    key = _toKey(key);
    _baseAssignValue(object, key, lodash_es_bind(object[key], object));
  });
  return object;
});

/* harmony default export */ var lodash_es_bindAll = (bindAll);

// CONCATENATED MODULE: ./node_modules/lodash-es/bindKey.js





/** Used to compose bitmasks for function metadata. */
var bindKey_WRAP_BIND_FLAG = 1,
    bindKey_WRAP_BIND_KEY_FLAG = 2,
    bindKey_WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes the method at `object[key]` with `partials`
 * prepended to the arguments it receives.
 *
 * This method differs from `_.bind` by allowing bound functions to reference
 * methods that may be redefined or don't yet exist. See
 * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
 * for more details.
 *
 * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Function
 * @param {Object} object The object to invoke the method on.
 * @param {string} key The key of the method.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var object = {
 *   'user': 'fred',
 *   'greet': function(greeting, punctuation) {
 *     return greeting + ' ' + this.user + punctuation;
 *   }
 * };
 *
 * var bound = _.bindKey(object, 'greet', 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * object.greet = function(greeting, punctuation) {
 *   return greeting + 'ya ' + this.user + punctuation;
 * };
 *
 * bound('!');
 * // => 'hiya fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bindKey(object, 'greet', _, '!');
 * bound('hi');
 * // => 'hiya fred!'
 */
var bindKey = _baseRest(function(object, key, partials) {
  var bitmask = bindKey_WRAP_BIND_FLAG | bindKey_WRAP_BIND_KEY_FLAG;
  if (partials.length) {
    var holders = _replaceHolders(partials, _getHolder(bindKey));
    bitmask |= bindKey_WRAP_PARTIAL_FLAG;
  }
  return _createWrap(key, bitmask, object, partials, holders);
});

// Assign default placeholders.
bindKey.placeholder = {};

/* harmony default export */ var lodash_es_bindKey = (bindKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSlice.js
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/* harmony default export */ var _baseSlice = (baseSlice);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castSlice.js


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

/* harmony default export */ var _castSlice = (castSlice);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hasUnicode.js
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/* harmony default export */ var _hasUnicode = (hasUnicode);

// CONCATENATED MODULE: ./node_modules/lodash-es/_asciiToArray.js
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/* harmony default export */ var _asciiToArray = (asciiToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unicodeToArray.js
/** Used to compose unicode character classes. */
var _unicodeToArray_rsAstralRange = '\\ud800-\\udfff',
    _unicodeToArray_rsComboMarksRange = '\\u0300-\\u036f',
    _unicodeToArray_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    _unicodeToArray_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    _unicodeToArray_rsComboRange = _unicodeToArray_rsComboMarksRange + _unicodeToArray_reComboHalfMarksRange + _unicodeToArray_rsComboSymbolsRange,
    _unicodeToArray_rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + _unicodeToArray_rsAstralRange + ']',
    rsCombo = '[' + _unicodeToArray_rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + _unicodeToArray_rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    _unicodeToArray_rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + _unicodeToArray_rsVarRange + ']?',
    rsOptJoin = '(?:' + _unicodeToArray_rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/* harmony default export */ var _unicodeToArray = (unicodeToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToArray.js




/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

/* harmony default export */ var _stringToArray = (stringToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCaseFirst.js





/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = lodash_es_toString(string);

    var strSymbols = _hasUnicode(string)
      ? _stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? _castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/* harmony default export */ var _createCaseFirst = (createCaseFirst);

// CONCATENATED MODULE: ./node_modules/lodash-es/upperFirst.js


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = _createCaseFirst('toUpperCase');

/* harmony default export */ var lodash_es_upperFirst = (upperFirst);

// CONCATENATED MODULE: ./node_modules/lodash-es/capitalize.js



/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return lodash_es_upperFirst(lodash_es_toString(string).toLowerCase());
}

/* harmony default export */ var lodash_es_capitalize = (capitalize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayReduce.js
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayReduce = (arrayReduce);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePropertyOf.js
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _basePropertyOf = (basePropertyOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_deburrLetter.js


/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

/* harmony default export */ var _deburrLetter = (deburrLetter);

// CONCATENATED MODULE: ./node_modules/lodash-es/deburr.js



/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var deburr_rsComboMarksRange = '\\u0300-\\u036f',
    deburr_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    deburr_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    deburr_rsComboRange = deburr_rsComboMarksRange + deburr_reComboHalfMarksRange + deburr_rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var deburr_rsCombo = '[' + deburr_rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(deburr_rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = lodash_es_toString(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

/* harmony default export */ var lodash_es_deburr = (deburr);

// CONCATENATED MODULE: ./node_modules/lodash-es/_asciiWords.js
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/* harmony default export */ var _asciiWords = (asciiWords);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hasUnicodeWord.js
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/* harmony default export */ var _hasUnicodeWord = (hasUnicodeWord);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unicodeWords.js
/** Used to compose unicode character classes. */
var _unicodeWords_rsAstralRange = '\\ud800-\\udfff',
    _unicodeWords_rsComboMarksRange = '\\u0300-\\u036f',
    _unicodeWords_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    _unicodeWords_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    _unicodeWords_rsComboRange = _unicodeWords_rsComboMarksRange + _unicodeWords_reComboHalfMarksRange + _unicodeWords_rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    _unicodeWords_rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    _unicodeWords_rsCombo = '[' + _unicodeWords_rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + _unicodeWords_rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    _unicodeWords_rsFitz = '\\ud83c[\\udffb-\\udfff]',
    _unicodeWords_rsModifier = '(?:' + _unicodeWords_rsCombo + '|' + _unicodeWords_rsFitz + ')',
    _unicodeWords_rsNonAstral = '[^' + _unicodeWords_rsAstralRange + ']',
    _unicodeWords_rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    _unicodeWords_rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    _unicodeWords_rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    _unicodeWords_reOptMod = _unicodeWords_rsModifier + '?',
    _unicodeWords_rsOptVar = '[' + _unicodeWords_rsVarRange + ']?',
    _unicodeWords_rsOptJoin = '(?:' + _unicodeWords_rsZWJ + '(?:' + [_unicodeWords_rsNonAstral, _unicodeWords_rsRegional, _unicodeWords_rsSurrPair].join('|') + ')' + _unicodeWords_rsOptVar + _unicodeWords_reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    _unicodeWords_rsSeq = _unicodeWords_rsOptVar + _unicodeWords_reOptMod + _unicodeWords_rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, _unicodeWords_rsRegional, _unicodeWords_rsSurrPair].join('|') + ')' + _unicodeWords_rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/* harmony default export */ var _unicodeWords = (unicodeWords);

// CONCATENATED MODULE: ./node_modules/lodash-es/words.js





/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = lodash_es_toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return _hasUnicodeWord(string) ? _unicodeWords(string) : _asciiWords(string);
  }
  return string.match(pattern) || [];
}

/* harmony default export */ var lodash_es_words = (words);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCompounder.js




/** Used to compose unicode capture groups. */
var _createCompounder_rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(_createCompounder_rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return _arrayReduce(lodash_es_words(lodash_es_deburr(string).replace(reApos, '')), callback, '');
  };
}

/* harmony default export */ var _createCompounder = (createCompounder);

// CONCATENATED MODULE: ./node_modules/lodash-es/camelCase.js



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = _createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? lodash_es_capitalize(word) : word);
});

/* harmony default export */ var lodash_es_camelCase = (camelCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/castArray.js


/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return lodash_es_isArray(value) ? value : [value];
}

/* harmony default export */ var lodash_es_castArray = (castArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createRound.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = _root["a" /* default */].isFinite,
    _createRound_nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = lodash_es_toNumber(number);
    precision = precision == null ? 0 : _createRound_nativeMin(lodash_es_toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (lodash_es_toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (lodash_es_toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

/* harmony default export */ var _createRound = (createRound);

// CONCATENATED MODULE: ./node_modules/lodash-es/ceil.js


/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = _createRound('ceil');

/* harmony default export */ var lodash_es_ceil = (ceil);

// CONCATENATED MODULE: ./node_modules/lodash-es/chain.js


/**
 * Creates a `lodash` wrapper instance that wraps `value` with explicit method
 * chain sequences enabled. The result of such sequences must be unwrapped
 * with `_#value`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Seq
 * @param {*} value The value to wrap.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36 },
 *   { 'user': 'fred',    'age': 40 },
 *   { 'user': 'pebbles', 'age': 1 }
 * ];
 *
 * var youngest = _
 *   .chain(users)
 *   .sortBy('age')
 *   .map(function(o) {
 *     return o.user + ' is ' + o.age;
 *   })
 *   .head()
 *   .value();
 * // => 'pebbles is 1'
 */
function chain_chain(value) {
  var result = wrapperLodash(value);
  result.__chain__ = true;
  return result;
}

/* harmony default export */ var lodash_es_chain = (chain_chain);

// CONCATENATED MODULE: ./node_modules/lodash-es/chunk.js




/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    chunk_nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? _isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = chunk_nativeMax(lodash_es_toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = _baseSlice(array, index, (index += size));
  }
  return result;
}

/* harmony default export */ var lodash_es_chunk = (chunk);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseClamp.js
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ var _baseClamp = (baseClamp);

// CONCATENATED MODULE: ./node_modules/lodash-es/clamp.js



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = lodash_es_toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = lodash_es_toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return _baseClamp(lodash_es_toNumber(number), lower, upper);
}

/* harmony default export */ var lodash_es_clamp = (clamp);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, lodash_es_keys(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, lodash_es_keysIn(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

// EXTERNAL MODULE: ./node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__(184);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var lodash_es_stubArray = (stubArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var _getSymbols_propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return _getSymbols_propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = (getSymbols);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbolsIn.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var _getSymbolsIn_nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !_getSymbolsIn_nativeGetSymbols ? lodash_es_stubArray : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

/* harmony default export */ var _getSymbolsIn = (getSymbolsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* harmony default export */ var _baseGetAllKeys = (baseGetAllKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* harmony default export */ var _getAllKeys = (getAllKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeysIn.js




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, lodash_es_keysIn, _getSymbolsIn);
}

/* harmony default export */ var _getAllKeysIn = (getAllKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root["a" /* default */], 'DataView');

/* harmony default export */ var _DataView = (DataView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root["a" /* default */], 'Promise');

/* harmony default export */ var _Promise = (Promise);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var Set = _getNative(_root["a" /* default */], 'Set');

/* harmony default export */ var _Set = (Set);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map && getTag(new _Map) != _getTag_mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap && getTag(new _WeakMap) != _getTag_weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return _getTag_dataViewTag;
        case mapCtorString: return _getTag_mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return _getTag_setTag;
        case weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var _initCloneArray_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = _initCloneArray_objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var Uint8Array = _root["a" /* default */].Uint8Array;

/* harmony default export */ var _Uint8Array = (Uint8Array);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneArrayBuffer.js


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

/* harmony default export */ var _cloneArrayBuffer = (cloneArrayBuffer);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneDataView.js


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ var _cloneDataView = (cloneDataView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneRegExp.js
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ var _cloneRegExp = (cloneRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneSymbol.js


/** Used to convert symbols to primitives and strings. */
var _cloneSymbol_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = _cloneSymbol_symbolProto ? _cloneSymbol_symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ var _cloneSymbol = (cloneSymbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneTypedArray.js


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ var _cloneTypedArray = (cloneTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneByTag.js






/** `Object#toString` result references. */
var _initCloneByTag_boolTag = '[object Boolean]',
    _initCloneByTag_dateTag = '[object Date]',
    _initCloneByTag_mapTag = '[object Map]',
    _initCloneByTag_numberTag = '[object Number]',
    _initCloneByTag_regexpTag = '[object RegExp]',
    _initCloneByTag_setTag = '[object Set]',
    _initCloneByTag_stringTag = '[object String]',
    _initCloneByTag_symbolTag = '[object Symbol]';

var _initCloneByTag_arrayBufferTag = '[object ArrayBuffer]',
    _initCloneByTag_dataViewTag = '[object DataView]',
    _initCloneByTag_float32Tag = '[object Float32Array]',
    _initCloneByTag_float64Tag = '[object Float64Array]',
    _initCloneByTag_int8Tag = '[object Int8Array]',
    _initCloneByTag_int16Tag = '[object Int16Array]',
    _initCloneByTag_int32Tag = '[object Int32Array]',
    _initCloneByTag_uint8Tag = '[object Uint8Array]',
    _initCloneByTag_uint8ClampedTag = '[object Uint8ClampedArray]',
    _initCloneByTag_uint16Tag = '[object Uint16Array]',
    _initCloneByTag_uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case _initCloneByTag_arrayBufferTag:
      return _cloneArrayBuffer(object);

    case _initCloneByTag_boolTag:
    case _initCloneByTag_dateTag:
      return new Ctor(+object);

    case _initCloneByTag_dataViewTag:
      return _cloneDataView(object, isDeep);

    case _initCloneByTag_float32Tag: case _initCloneByTag_float64Tag:
    case _initCloneByTag_int8Tag: case _initCloneByTag_int16Tag: case _initCloneByTag_int32Tag:
    case _initCloneByTag_uint8Tag: case _initCloneByTag_uint8ClampedTag: case _initCloneByTag_uint16Tag: case _initCloneByTag_uint32Tag:
      return _cloneTypedArray(object, isDeep);

    case _initCloneByTag_mapTag:
      return new Ctor;

    case _initCloneByTag_numberTag:
    case _initCloneByTag_stringTag:
      return new Ctor(object);

    case _initCloneByTag_regexpTag:
      return _cloneRegExp(object);

    case _initCloneByTag_setTag:
      return new Ctor;

    case _initCloneByTag_symbolTag:
      return _cloneSymbol(object);
  }
}

/* harmony default export */ var _initCloneByTag = (initCloneByTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsMap.js



/** `Object#toString` result references. */
var _baseIsMap_mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return lodash_es_isObjectLike(value) && _getTag(value) == _baseIsMap_mapTag;
}

/* harmony default export */ var _baseIsMap = (baseIsMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isMap.js




/* Node.js helper references. */
var nodeIsMap = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

/* harmony default export */ var lodash_es_isMap = (isMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsSet.js



/** `Object#toString` result references. */
var _baseIsSet_setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return lodash_es_isObjectLike(value) && _getTag(value) == _baseIsSet_setTag;
}

/* harmony default export */ var _baseIsSet = (baseIsSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSet.js




/* Node.js helper references. */
var nodeIsSet = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

/* harmony default export */ var lodash_es_isSet = (isSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseClone.js






















/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var _baseClone_argsTag = '[object Arguments]',
    _baseClone_arrayTag = '[object Array]',
    _baseClone_boolTag = '[object Boolean]',
    _baseClone_dateTag = '[object Date]',
    _baseClone_errorTag = '[object Error]',
    _baseClone_funcTag = '[object Function]',
    _baseClone_genTag = '[object GeneratorFunction]',
    _baseClone_mapTag = '[object Map]',
    _baseClone_numberTag = '[object Number]',
    _baseClone_objectTag = '[object Object]',
    _baseClone_regexpTag = '[object RegExp]',
    _baseClone_setTag = '[object Set]',
    _baseClone_stringTag = '[object String]',
    _baseClone_symbolTag = '[object Symbol]',
    _baseClone_weakMapTag = '[object WeakMap]';

var _baseClone_arrayBufferTag = '[object ArrayBuffer]',
    _baseClone_dataViewTag = '[object DataView]',
    _baseClone_float32Tag = '[object Float32Array]',
    _baseClone_float64Tag = '[object Float64Array]',
    _baseClone_int8Tag = '[object Int8Array]',
    _baseClone_int16Tag = '[object Int16Array]',
    _baseClone_int32Tag = '[object Int32Array]',
    _baseClone_uint8Tag = '[object Uint8Array]',
    _baseClone_uint8ClampedTag = '[object Uint8ClampedArray]',
    _baseClone_uint16Tag = '[object Uint16Array]',
    _baseClone_uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[_baseClone_argsTag] = cloneableTags[_baseClone_arrayTag] =
cloneableTags[_baseClone_arrayBufferTag] = cloneableTags[_baseClone_dataViewTag] =
cloneableTags[_baseClone_boolTag] = cloneableTags[_baseClone_dateTag] =
cloneableTags[_baseClone_float32Tag] = cloneableTags[_baseClone_float64Tag] =
cloneableTags[_baseClone_int8Tag] = cloneableTags[_baseClone_int16Tag] =
cloneableTags[_baseClone_int32Tag] = cloneableTags[_baseClone_mapTag] =
cloneableTags[_baseClone_numberTag] = cloneableTags[_baseClone_objectTag] =
cloneableTags[_baseClone_regexpTag] = cloneableTags[_baseClone_setTag] =
cloneableTags[_baseClone_stringTag] = cloneableTags[_baseClone_symbolTag] =
cloneableTags[_baseClone_uint8Tag] = cloneableTags[_baseClone_uint8ClampedTag] =
cloneableTags[_baseClone_uint16Tag] = cloneableTags[_baseClone_uint32Tag] = true;
cloneableTags[_baseClone_errorTag] = cloneableTags[_baseClone_funcTag] =
cloneableTags[_baseClone_weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!lodash_es_isObject(value)) {
    return value;
  }
  var isArr = lodash_es_isArray(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == _baseClone_funcTag || tag == _baseClone_genTag;

    if (Object(isBuffer["a" /* default */])(value)) {
      return Object(_cloneBuffer["a" /* default */])(value, isDeep);
    }
    if (tag == _baseClone_objectTag || tag == _baseClone_argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (lodash_es_isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (lodash_es_isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn : lodash_es_keys);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = (baseClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/clone.js


/** Used to compose bitmasks for cloning. */
var clone_CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone_clone(value) {
  return _baseClone(value, clone_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_clone = (clone_clone);

// CONCATENATED MODULE: ./node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var cloneDeep_CLONE_DEEP_FLAG = 1,
    cloneDeep_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, cloneDeep_CLONE_DEEP_FLAG | cloneDeep_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/cloneDeepWith.js


/** Used to compose bitmasks for cloning. */
var cloneDeepWith_CLONE_DEEP_FLAG = 1,
    cloneDeepWith_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseClone(value, cloneDeepWith_CLONE_DEEP_FLAG | cloneDeepWith_CLONE_SYMBOLS_FLAG, customizer);
}

/* harmony default export */ var lodash_es_cloneDeepWith = (cloneDeepWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/cloneWith.js


/** Used to compose bitmasks for cloning. */
var cloneWith_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseClone(value, cloneWith_CLONE_SYMBOLS_FLAG, customizer);
}

/* harmony default export */ var lodash_es_cloneWith = (cloneWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/commit.js


/**
 * Executes the chain sequence and returns the wrapped result.
 *
 * @name commit
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2];
 * var wrapped = _(array).push(3);
 *
 * console.log(array);
 * // => [1, 2]
 *
 * wrapped = wrapped.commit();
 * console.log(array);
 * // => [1, 2, 3]
 *
 * wrapped.last();
 * // => 3
 *
 * console.log(array);
 * // => [1, 2, 3]
 */
function wrapperCommit() {
  return new _LodashWrapper(this.value(), this.__chain__);
}

/* harmony default export */ var commit = (wrapperCommit);

// CONCATENATED MODULE: ./node_modules/lodash-es/compact.js
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var lodash_es_compact = (compact);

// CONCATENATED MODULE: ./node_modules/lodash-es/concat.js





/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return _arrayPush(lodash_es_isArray(array) ? _copyArray(array) : [array], _baseFlatten(args, 1));
}

/* harmony default export */ var lodash_es_concat = (concat);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var _setCacheAdd_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, _setCacheAdd_HASH_UNDEFINED);
  return this;
}

/* harmony default export */ var _setCacheAdd = (setCacheAdd);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ var _setCacheHas = (setCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

/* harmony default export */ var _SetCache = (SetCache);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arraySome = (arraySome);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cacheHas.js
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ var _cacheHas = (cacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalArrays = (equalArrays);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ var _mapToArray = (mapToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setToArray.js
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ var _setToArray = (setToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var _equalByTag_boolTag = '[object Boolean]',
    _equalByTag_dateTag = '[object Date]',
    _equalByTag_errorTag = '[object Error]',
    _equalByTag_mapTag = '[object Map]',
    _equalByTag_numberTag = '[object Number]',
    _equalByTag_regexpTag = '[object RegExp]',
    _equalByTag_setTag = '[object Set]',
    _equalByTag_stringTag = '[object String]',
    _equalByTag_symbolTag = '[object Symbol]';

var _equalByTag_arrayBufferTag = '[object ArrayBuffer]',
    _equalByTag_dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var _equalByTag_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    _equalByTag_symbolValueOf = _equalByTag_symbolProto ? _equalByTag_symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case _equalByTag_dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case _equalByTag_arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case _equalByTag_boolTag:
    case _equalByTag_dateTag:
    case _equalByTag_numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return lodash_es_eq(+object, +other);

    case _equalByTag_errorTag:
      return object.name == other.name && object.message == other.message;

    case _equalByTag_regexpTag:
    case _equalByTag_stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case _equalByTag_mapTag:
      var convert = _mapToArray;

    case _equalByTag_setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case _equalByTag_symbolTag:
      if (_equalByTag_symbolValueOf) {
        return _equalByTag_symbolValueOf.call(object) == _equalByTag_symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ var _equalByTag = (equalByTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var _equalObjects_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = _equalObjects_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalObjects = (equalObjects);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var _baseIsEqualDeep_argsTag = '[object Arguments]',
    _baseIsEqualDeep_arrayTag = '[object Array]',
    _baseIsEqualDeep_objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = lodash_es_isArray(object),
      othIsArr = lodash_es_isArray(other),
      objTag = objIsArr ? _baseIsEqualDeep_arrayTag : _getTag(object),
      othTag = othIsArr ? _baseIsEqualDeep_arrayTag : _getTag(other);

  objTag = objTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : objTag;
  othTag = othTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : othTag;

  var objIsObj = objTag == _baseIsEqualDeep_objectTag,
      othIsObj = othTag == _baseIsEqualDeep_objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(isBuffer["a" /* default */])(object)) {
    if (!Object(isBuffer["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || lodash_es_isTypedArray(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ var _baseIsEqualDeep = (baseIsEqualDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!lodash_es_isObjectLike(value) && !lodash_es_isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ var _baseIsEqual = (baseIsEqual);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsMatch.js



/** Used to compose bitmasks for value comparisons. */
var _baseIsMatch_COMPARE_PARTIAL_FLAG = 1,
    _baseIsMatch_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, _baseIsMatch_COMPARE_PARTIAL_FLAG | _baseIsMatch_COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ var _baseIsMatch = (baseIsMatch);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isStrictComparable.js


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !lodash_es_isObject(value);
}

/* harmony default export */ var _isStrictComparable = (isStrictComparable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getMatchData.js



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = lodash_es_keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

/* harmony default export */ var _getMatchData = (getMatchData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_matchesStrictComparable.js
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ var _matchesStrictComparable = (matchesStrictComparable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMatches.js




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

/* harmony default export */ var _baseMatches = (baseMatches);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ var _baseHasIn = (baseHasIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && lodash_es_isLength(length) && _isIndex(key, length) &&
    (lodash_es_isArray(object) || lodash_es_isArguments(object));
}

/* harmony default export */ var _hasPath = (hasPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* harmony default export */ var lodash_es_hasIn = (hasIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMatchesProperty.js








/** Used to compose bitmasks for value comparisons. */
var _baseMatchesProperty_COMPARE_PARTIAL_FLAG = 1,
    _baseMatchesProperty_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = lodash_es_get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? lodash_es_hasIn(object, path)
      : _baseIsEqual(srcValue, objValue, _baseMatchesProperty_COMPARE_PARTIAL_FLAG | _baseMatchesProperty_COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ var _baseMatchesProperty = (baseMatchesProperty);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseProperty.js
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _baseProperty = (baseProperty);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePropertyDeep.js


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

/* harmony default export */ var _basePropertyDeep = (basePropertyDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/property.js





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

/* harmony default export */ var lodash_es_property = (property);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIteratee.js






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return lodash_es_identity;
  }
  if (typeof value == 'object') {
    return lodash_es_isArray(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return lodash_es_property(value);
}

/* harmony default export */ var _baseIteratee = (baseIteratee);

// CONCATENATED MODULE: ./node_modules/lodash-es/cond.js





/** Error message constants. */
var cond_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */
function cond(pairs) {
  var length = pairs == null ? 0 : pairs.length,
      toIteratee = _baseIteratee;

  pairs = !length ? [] : _arrayMap(pairs, function(pair) {
    if (typeof pair[1] != 'function') {
      throw new TypeError(cond_FUNC_ERROR_TEXT);
    }
    return [toIteratee(pair[0]), pair[1]];
  });

  return _baseRest(function(args) {
    var index = -1;
    while (++index < length) {
      var pair = pairs[index];
      if (_apply(pair[0], this, args)) {
        return _apply(pair[1], this, args);
      }
    }
  });
}

/* harmony default export */ var lodash_es_cond = (cond);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseConformsTo.js
/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
        predicate = source[key],
        value = object[key];

    if ((value === undefined && !(key in object)) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var _baseConformsTo = (baseConformsTo);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseConforms.js



/**
 * The base implementation of `_.conforms` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 */
function baseConforms(source) {
  var props = lodash_es_keys(source);
  return function(object) {
    return _baseConformsTo(object, source, props);
  };
}

/* harmony default export */ var _baseConforms = (baseConforms);

// CONCATENATED MODULE: ./node_modules/lodash-es/conforms.js



/** Used to compose bitmasks for cloning. */
var conforms_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes the predicate properties of `source` with
 * the corresponding property values of a given object, returning `true` if
 * all predicates return truthy, else `false`.
 *
 * **Note:** The created function is equivalent to `_.conformsTo` with
 * `source` partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 2, 'b': 1 },
 *   { 'a': 1, 'b': 2 }
 * ];
 *
 * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
 * // => [{ 'a': 1, 'b': 2 }]
 */
function conforms(source) {
  return _baseConforms(_baseClone(source, conforms_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_conforms = (conforms);

// CONCATENATED MODULE: ./node_modules/lodash-es/conformsTo.js



/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || _baseConformsTo(object, source, lodash_es_keys(source));
}

/* harmony default export */ var lodash_es_conformsTo = (conformsTo);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayAggregator.js
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayAggregator = (arrayAggregator);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createBaseFor.js
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ var _createBaseFor = (createBaseFor);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFor.js


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

/* harmony default export */ var _baseFor = (baseFor);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseForOwn.js



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, lodash_es_keys);
}

/* harmony default export */ var _baseForOwn = (baseForOwn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createBaseEach.js


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!lodash_es_isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ var _createBaseEach = (createBaseEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseEach.js



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

/* harmony default export */ var _baseEach = (baseEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAggregator.js


/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  _baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/* harmony default export */ var _baseAggregator = (baseAggregator);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createAggregator.js





/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = lodash_es_isArray(collection) ? _arrayAggregator : _baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, _baseIteratee(iteratee, 2), accumulator);
  };
}

/* harmony default export */ var _createAggregator = (createAggregator);

// CONCATENATED MODULE: ./node_modules/lodash-es/countBy.js



/** Used for built-in method references. */
var countBy_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var countBy_hasOwnProperty = countBy_objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = _createAggregator(function(result, value, key) {
  if (countBy_hasOwnProperty.call(result, key)) {
    ++result[key];
  } else {
    _baseAssignValue(result, key, 1);
  }
});

/* harmony default export */ var lodash_es_countBy = (countBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/create.js



/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = _baseCreate(prototype);
  return properties == null ? result : _baseAssign(result, properties);
}

/* harmony default export */ var lodash_es_create = (create);

// CONCATENATED MODULE: ./node_modules/lodash-es/curry.js


/** Used to compose bitmasks for function metadata. */
var curry_WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = _createWrap(func, curry_WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

/* harmony default export */ var lodash_es_curry = (curry);

// CONCATENATED MODULE: ./node_modules/lodash-es/curryRight.js


/** Used to compose bitmasks for function metadata. */
var curryRight_WRAP_CURRY_RIGHT_FLAG = 16;

/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */
function curryRight(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = _createWrap(func, curryRight_WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curryRight.placeholder;
  return result;
}

// Assign default placeholders.
curryRight.placeholder = {};

/* harmony default export */ var lodash_es_curryRight = (curryRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/now.js


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root["a" /* default */].Date.now();
};

/* harmony default export */ var lodash_es_now = (now);

// CONCATENATED MODULE: ./node_modules/lodash-es/debounce.js




/** Error message constants. */
var debounce_FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var debounce_nativeMax = Math.max,
    debounce_nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(debounce_FUNC_ERROR_TEXT);
  }
  wait = lodash_es_toNumber(wait) || 0;
  if (lodash_es_isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? debounce_nativeMax(lodash_es_toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? debounce_nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = lodash_es_now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ var lodash_es_debounce = (debounce);

// CONCATENATED MODULE: ./node_modules/lodash-es/defaultTo.js
/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value;
}

/* harmony default export */ var lodash_es_defaultTo = (defaultTo);

// CONCATENATED MODULE: ./node_modules/lodash-es/defaults.js





/** Used for built-in method references. */
var defaults_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var defaults_hasOwnProperty = defaults_objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = _baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = lodash_es_keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (lodash_es_eq(value, defaults_objectProto[key]) && !defaults_hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

/* harmony default export */ var lodash_es_defaults = (defaults);

// CONCATENATED MODULE: ./node_modules/lodash-es/_assignMergeValue.js



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !lodash_es_eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignMergeValue = (assignMergeValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLikeObject.js



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return lodash_es_isObjectLike(value) && lodash_es_isArrayLike(value);
}

/* harmony default export */ var lodash_es_isArrayLikeObject = (isArrayLikeObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_safeGet.js
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ var _safeGet = (safeGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/toPlainObject.js



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, lodash_es_keysIn(value));
}

/* harmony default export */ var lodash_es_toPlainObject = (toPlainObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMergeDeep.js
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = lodash_es_isArray(srcValue),
        isBuff = !isArr && Object(isBuffer["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && lodash_es_isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (lodash_es_isArray(objValue)) {
        newValue = objValue;
      }
      else if (lodash_es_isArrayLikeObject(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(_cloneBuffer["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (lodash_es_isPlainObject(srcValue) || lodash_es_isArguments(srcValue)) {
      newValue = objValue;
      if (lodash_es_isArguments(objValue)) {
        newValue = lodash_es_toPlainObject(objValue);
      }
      else if (!lodash_es_isObject(objValue) || lodash_es_isFunction(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

/* harmony default export */ var _baseMergeDeep = (baseMergeDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMerge.js








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (lodash_es_isObject(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, lodash_es_keysIn);
}

/* harmony default export */ var _baseMerge = (baseMerge);

// CONCATENATED MODULE: ./node_modules/lodash-es/_customDefaultsMerge.js



/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (lodash_es_isObject(objValue) && lodash_es_isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    _baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/* harmony default export */ var _customDefaultsMerge = (customDefaultsMerge);

// CONCATENATED MODULE: ./node_modules/lodash-es/mergeWith.js



/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = _createAssigner(function(object, source, srcIndex, customizer) {
  _baseMerge(object, source, srcIndex, customizer);
});

/* harmony default export */ var lodash_es_mergeWith = (mergeWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/defaultsDeep.js





/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = _baseRest(function(args) {
  args.push(undefined, _customDefaultsMerge);
  return _apply(lodash_es_mergeWith, undefined, args);
});

/* harmony default export */ var lodash_es_defaultsDeep = (defaultsDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseDelay.js
/** Error message constants. */
var _baseDelay_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(_baseDelay_FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

/* harmony default export */ var _baseDelay = (baseDelay);

// CONCATENATED MODULE: ./node_modules/lodash-es/defer.js



/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = _baseRest(function(func, args) {
  return _baseDelay(func, 1, args);
});

/* harmony default export */ var lodash_es_defer = (defer);

// CONCATENATED MODULE: ./node_modules/lodash-es/delay.js




/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = _baseRest(function(func, wait, args) {
  return _baseDelay(func, lodash_es_toNumber(wait) || 0, args);
});

/* harmony default export */ var lodash_es_delay = (delay);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayIncludesWith.js
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arrayIncludesWith = (arrayIncludesWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseDifference.js







/** Used as the size to enable large array optimizations. */
var _baseDifference_LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = _arrayMap(values, _baseUnary(iteratee));
  }
  if (comparator) {
    includes = _arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= _baseDifference_LARGE_ARRAY_SIZE) {
    includes = _cacheHas;
    isCommon = false;
    values = new _SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ var _baseDifference = (baseDifference);

// CONCATENATED MODULE: ./node_modules/lodash-es/difference.js





/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = _baseRest(function(array, values) {
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, _baseFlatten(values, 1, lodash_es_isArrayLikeObject, true))
    : [];
});

/* harmony default export */ var lodash_es_difference = (difference);

// CONCATENATED MODULE: ./node_modules/lodash-es/last.js
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ var lodash_es_last = (last);

// CONCATENATED MODULE: ./node_modules/lodash-es/differenceBy.js







/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = _baseRest(function(array, values) {
  var iteratee = lodash_es_last(values);
  if (lodash_es_isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, _baseFlatten(values, 1, lodash_es_isArrayLikeObject, true), _baseIteratee(iteratee, 2))
    : [];
});

/* harmony default export */ var lodash_es_differenceBy = (differenceBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/differenceWith.js






/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = _baseRest(function(array, values) {
  var comparator = lodash_es_last(values);
  if (lodash_es_isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, _baseFlatten(values, 1, lodash_es_isArrayLikeObject, true), undefined, comparator)
    : [];
});

/* harmony default export */ var lodash_es_differenceWith = (differenceWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/divide.js


/**
 * Divide two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} dividend The first number in a division.
 * @param {number} divisor The second number in a division.
 * @returns {number} Returns the quotient.
 * @example
 *
 * _.divide(6, 4);
 * // => 1.5
 */
var divide = _createMathOperation(function(dividend, divisor) {
  return dividend / divisor;
}, 1);

/* harmony default export */ var lodash_es_divide = (divide);

// CONCATENATED MODULE: ./node_modules/lodash-es/drop.js



/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : lodash_es_toInteger(n);
  return _baseSlice(array, n < 0 ? 0 : n, length);
}

/* harmony default export */ var lodash_es_drop = (drop);

// CONCATENATED MODULE: ./node_modules/lodash-es/dropRight.js



/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : lodash_es_toInteger(n);
  n = length - n;
  return _baseSlice(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ var lodash_es_dropRight = (dropRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseWhile.js


/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) &&
    predicate(array[index], index, array)) {}

  return isDrop
    ? _baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
    : _baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}

/* harmony default export */ var _baseWhile = (baseWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/dropRightWhile.js



/**
 * Creates a slice of `array` excluding elements dropped from the end.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.dropRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropRightWhile(users, ['active', false]);
 * // => objects for ['barney']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropRightWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropRightWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3), true, true)
    : [];
}

/* harmony default export */ var lodash_es_dropRightWhile = (dropRightWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/dropWhile.js



/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3), true)
    : [];
}

/* harmony default export */ var lodash_es_dropWhile = (dropWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castFunction.js


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : lodash_es_identity;
}

/* harmony default export */ var _castFunction = (castFunction);

// CONCATENATED MODULE: ./node_modules/lodash-es/forEach.js





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = lodash_es_isArray(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forEach = (forEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/each.js


// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayEachRight.js
/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;

  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEachRight = (arrayEachRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseForRight.js


/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = _createBaseFor(true);

/* harmony default export */ var _baseForRight = (baseForRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseForOwnRight.js



/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && _baseForRight(object, iteratee, lodash_es_keys);
}

/* harmony default export */ var _baseForOwnRight = (baseForOwnRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseEachRight.js



/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = _createBaseEach(_baseForOwnRight, true);

/* harmony default export */ var _baseEachRight = (baseEachRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/forEachRight.js





/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = lodash_es_isArray(collection) ? _arrayEachRight : _baseEachRight;
  return func(collection, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forEachRight = (forEachRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/eachRight.js


// CONCATENATED MODULE: ./node_modules/lodash-es/endsWith.js





/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = lodash_es_toString(string);
  target = _baseToString(target);

  var length = string.length;
  position = position === undefined
    ? length
    : _baseClamp(lodash_es_toInteger(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

/* harmony default export */ var lodash_es_endsWith = (endsWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToPairs.js


/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return _arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

/* harmony default export */ var _baseToPairs = (baseToPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setToPairs.js
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

/* harmony default export */ var _setToPairs = (setToPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createToPairs.js





/** `Object#toString` result references. */
var _createToPairs_mapTag = '[object Map]',
    _createToPairs_setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = _getTag(object);
    if (tag == _createToPairs_mapTag) {
      return _mapToArray(object);
    }
    if (tag == _createToPairs_setTag) {
      return _setToPairs(object);
    }
    return _baseToPairs(object, keysFunc(object));
  };
}

/* harmony default export */ var _createToPairs = (createToPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/toPairs.js



/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = _createToPairs(lodash_es_keys);

/* harmony default export */ var lodash_es_toPairs = (toPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/entries.js


// CONCATENATED MODULE: ./node_modules/lodash-es/toPairsIn.js



/**
 * Creates an array of own and inherited enumerable string keyed-value pairs
 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
 * or set, its entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entriesIn
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairsIn(new Foo);
 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
 */
var toPairsIn = _createToPairs(lodash_es_keysIn);

/* harmony default export */ var lodash_es_toPairsIn = (toPairsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/entriesIn.js


// CONCATENATED MODULE: ./node_modules/lodash-es/_escapeHtmlChar.js


/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = _basePropertyOf(htmlEscapes);

/* harmony default export */ var _escapeHtmlChar = (escapeHtmlChar);

// CONCATENATED MODULE: ./node_modules/lodash-es/escape.js



/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape_escape(string) {
  string = lodash_es_toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, _escapeHtmlChar)
    : string;
}

/* harmony default export */ var lodash_es_escape = (escape_escape);

// CONCATENATED MODULE: ./node_modules/lodash-es/escapeRegExp.js


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var escapeRegExp_reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(escapeRegExp_reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = lodash_es_toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(escapeRegExp_reRegExpChar, '\\$&')
    : string;
}

/* harmony default export */ var lodash_es_escapeRegExp = (escapeRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayEvery.js
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var _arrayEvery = (arrayEvery);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseEvery.js


/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  _baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

/* harmony default export */ var _baseEvery = (baseEvery);

// CONCATENATED MODULE: ./node_modules/lodash-es/every.js






/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = lodash_es_isArray(collection) ? _arrayEvery : _baseEvery;
  if (guard && _isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, _baseIteratee(predicate, 3));
}

/* harmony default export */ var lodash_es_every = (every);

// CONCATENATED MODULE: ./node_modules/lodash-es/extend.js


// CONCATENATED MODULE: ./node_modules/lodash-es/extendWith.js


// CONCATENATED MODULE: ./node_modules/lodash-es/toLength.js



/** Used as references for the maximum length and index of an array. */
var toLength_MAX_ARRAY_LENGTH = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? _baseClamp(lodash_es_toInteger(value), 0, toLength_MAX_ARRAY_LENGTH) : 0;
}

/* harmony default export */ var lodash_es_toLength = (toLength);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFill.js



/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */
function baseFill(array, value, start, end) {
  var length = array.length;

  start = lodash_es_toInteger(start);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : lodash_es_toInteger(end);
  if (end < 0) {
    end += length;
  }
  end = start > end ? 0 : lodash_es_toLength(end);
  while (start < end) {
    array[start++] = value;
  }
  return array;
}

/* harmony default export */ var _baseFill = (baseFill);

// CONCATENATED MODULE: ./node_modules/lodash-es/fill.js



/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */
function fill(array, value, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (start && typeof start != 'number' && _isIterateeCall(array, value, start)) {
    start = 0;
    end = length;
  }
  return _baseFill(array, value, start, end);
}

/* harmony default export */ var lodash_es_fill = (fill);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFilter.js


/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  _baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/* harmony default export */ var _baseFilter = (baseFilter);

// CONCATENATED MODULE: ./node_modules/lodash-es/filter.js





/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = lodash_es_isArray(collection) ? _arrayFilter : _baseFilter;
  return func(collection, _baseIteratee(predicate, 3));
}

/* harmony default export */ var lodash_es_filter = (filter);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createFind.js




/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!lodash_es_isArrayLike(collection)) {
      var iteratee = _baseIteratee(predicate, 3);
      collection = lodash_es_keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/* harmony default export */ var _createFind = (createFind);

// CONCATENATED MODULE: ./node_modules/lodash-es/findIndex.js




/* Built-in method references for those with the same name as other `lodash` methods. */
var findIndex_nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : lodash_es_toInteger(fromIndex);
  if (index < 0) {
    index = findIndex_nativeMax(length + index, 0);
  }
  return _baseFindIndex(array, _baseIteratee(predicate, 3), index);
}

/* harmony default export */ var lodash_es_findIndex = (findIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/find.js



/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = _createFind(lodash_es_findIndex);

/* harmony default export */ var lodash_es_find = (find);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFindKey.js
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/* harmony default export */ var _baseFindKey = (baseFindKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/findKey.js




/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return _baseFindKey(object, _baseIteratee(predicate, 3), _baseForOwn);
}

/* harmony default export */ var lodash_es_findKey = (findKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/findLastIndex.js




/* Built-in method references for those with the same name as other `lodash` methods. */
var findLastIndex_nativeMax = Math.max,
    findLastIndex_nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = lodash_es_toInteger(fromIndex);
    index = fromIndex < 0
      ? findLastIndex_nativeMax(length + index, 0)
      : findLastIndex_nativeMin(index, length - 1);
  }
  return _baseFindIndex(array, _baseIteratee(predicate, 3), index, true);
}

/* harmony default export */ var lodash_es_findLastIndex = (findLastIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/findLast.js



/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = _createFind(lodash_es_findLastIndex);

/* harmony default export */ var lodash_es_findLast = (findLast);

// CONCATENATED MODULE: ./node_modules/lodash-es/findLastKey.js




/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return _baseFindKey(object, _baseIteratee(predicate, 3), _baseForOwnRight);
}

/* harmony default export */ var lodash_es_findLastKey = (findLastKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/head.js
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

/* harmony default export */ var lodash_es_head = (head);

// CONCATENATED MODULE: ./node_modules/lodash-es/first.js


// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMap.js



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = lodash_es_isArrayLike(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ var _baseMap = (baseMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/map.js





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map_map(collection, iteratee) {
  var func = lodash_es_isArray(collection) ? _arrayMap : _baseMap;
  return func(collection, _baseIteratee(iteratee, 3));
}

/* harmony default export */ var lodash_es_map = (map_map);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatMap.js



/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return _baseFlatten(lodash_es_map(collection, iteratee), 1);
}

/* harmony default export */ var lodash_es_flatMap = (flatMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatMapDeep.js



/** Used as references for various `Number` constants. */
var flatMapDeep_INFINITY = 1 / 0;

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMapDeep(collection, iteratee) {
  return _baseFlatten(lodash_es_map(collection, iteratee), flatMapDeep_INFINITY);
}

/* harmony default export */ var lodash_es_flatMapDeep = (flatMapDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatMapDepth.js




/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDepth([1, 2], duplicate, 2);
 * // => [[1, 1], [2, 2]]
 */
function flatMapDepth(collection, iteratee, depth) {
  depth = depth === undefined ? 1 : lodash_es_toInteger(depth);
  return _baseFlatten(lodash_es_map(collection, iteratee), depth);
}

/* harmony default export */ var lodash_es_flatMapDepth = (flatMapDepth);

// CONCATENATED MODULE: ./node_modules/lodash-es/flattenDeep.js


/** Used as references for various `Number` constants. */
var flattenDeep_INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, flattenDeep_INFINITY) : [];
}

/* harmony default export */ var lodash_es_flattenDeep = (flattenDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/flattenDepth.js



/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */
function flattenDepth(array, depth) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  depth = depth === undefined ? 1 : lodash_es_toInteger(depth);
  return _baseFlatten(array, depth);
}

/* harmony default export */ var lodash_es_flattenDepth = (flattenDepth);

// CONCATENATED MODULE: ./node_modules/lodash-es/flip.js


/** Used to compose bitmasks for function metadata. */
var flip_WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that invokes `func` with arguments reversed.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to flip arguments for.
 * @returns {Function} Returns the new flipped function.
 * @example
 *
 * var flipped = _.flip(function() {
 *   return _.toArray(arguments);
 * });
 *
 * flipped('a', 'b', 'c', 'd');
 * // => ['d', 'c', 'b', 'a']
 */
function flip(func) {
  return _createWrap(func, flip_WRAP_FLIP_FLAG);
}

/* harmony default export */ var lodash_es_flip = (flip);

// CONCATENATED MODULE: ./node_modules/lodash-es/floor.js


/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */
var floor = _createRound('floor');

/* harmony default export */ var lodash_es_floor = (floor);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createFlow.js







/** Error message constants. */
var _createFlow_FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var _createFlow_WRAP_CURRY_FLAG = 8,
    _createFlow_WRAP_PARTIAL_FLAG = 32,
    _createFlow_WRAP_ARY_FLAG = 128,
    _createFlow_WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return _flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = _LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(_createFlow_FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && _getFuncName(func) == 'wrapper') {
        var wrapper = new _LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = _getFuncName(func),
          data = funcName == 'wrapper' ? _getData(func) : undefined;

      if (data && _isLaziable(data[0]) &&
            data[1] == (_createFlow_WRAP_ARY_FLAG | _createFlow_WRAP_CURRY_FLAG | _createFlow_WRAP_PARTIAL_FLAG | _createFlow_WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[_getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && _isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && lodash_es_isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/* harmony default export */ var _createFlow = (createFlow);

// CONCATENATED MODULE: ./node_modules/lodash-es/flow.js


/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = _createFlow();

/* harmony default export */ var lodash_es_flow = (flow);

// CONCATENATED MODULE: ./node_modules/lodash-es/flowRight.js


/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = _createFlow(true);

/* harmony default export */ var lodash_es_flowRight = (flowRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/forIn.js




/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : _baseFor(object, _castFunction(iteratee), lodash_es_keysIn);
}

/* harmony default export */ var lodash_es_forIn = (forIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/forInRight.js




/**
 * This method is like `_.forIn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forInRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
 */
function forInRight(object, iteratee) {
  return object == null
    ? object
    : _baseForRight(object, _castFunction(iteratee), lodash_es_keysIn);
}

/* harmony default export */ var lodash_es_forInRight = (forInRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/forOwn.js



/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && _baseForOwn(object, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forOwn = (forOwn);

// CONCATENATED MODULE: ./node_modules/lodash-es/forOwnRight.js



/**
 * This method is like `_.forOwn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwnRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
 */
function forOwnRight(object, iteratee) {
  return object && _baseForOwnRight(object, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forOwnRight = (forOwnRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/fromPairs.js
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

/* harmony default export */ var lodash_es_fromPairs = (fromPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFunctions.js



/**
 * The base implementation of `_.functions` which creates an array of
 * `object` function property names filtered from `props`.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} props The property names to filter.
 * @returns {Array} Returns the function names.
 */
function baseFunctions(object, props) {
  return _arrayFilter(props, function(key) {
    return lodash_es_isFunction(object[key]);
  });
}

/* harmony default export */ var _baseFunctions = (baseFunctions);

// CONCATENATED MODULE: ./node_modules/lodash-es/functions.js



/**
 * Creates an array of function property names from own enumerable properties
 * of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functionsIn
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functions(new Foo);
 * // => ['a', 'b']
 */
function functions(object) {
  return object == null ? [] : _baseFunctions(object, lodash_es_keys(object));
}

/* harmony default export */ var lodash_es_functions = (functions);

// CONCATENATED MODULE: ./node_modules/lodash-es/functionsIn.js



/**
 * Creates an array of function property names from own and inherited
 * enumerable properties of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functions
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functionsIn(new Foo);
 * // => ['a', 'b', 'c']
 */
function functionsIn(object) {
  return object == null ? [] : _baseFunctions(object, lodash_es_keysIn(object));
}

/* harmony default export */ var lodash_es_functionsIn = (functionsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/groupBy.js



/** Used for built-in method references. */
var groupBy_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var groupBy_hasOwnProperty = groupBy_objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = _createAggregator(function(result, value, key) {
  if (groupBy_hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    _baseAssignValue(result, key, [value]);
  }
});

/* harmony default export */ var lodash_es_groupBy = (groupBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGt.js
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

/* harmony default export */ var _baseGt = (baseGt);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createRelationalOperation.js


/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = lodash_es_toNumber(value);
      other = lodash_es_toNumber(other);
    }
    return operator(value, other);
  };
}

/* harmony default export */ var _createRelationalOperation = (createRelationalOperation);

// CONCATENATED MODULE: ./node_modules/lodash-es/gt.js



/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = _createRelationalOperation(_baseGt);

/* harmony default export */ var lodash_es_gt = (gt);

// CONCATENATED MODULE: ./node_modules/lodash-es/gte.js


/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = _createRelationalOperation(function(value, other) {
  return value >= other;
});

/* harmony default export */ var lodash_es_gte = (gte);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHas.js
/** Used for built-in method references. */
var _baseHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseHas_hasOwnProperty = _baseHas_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && _baseHas_hasOwnProperty.call(object, key);
}

/* harmony default export */ var _baseHas = (baseHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/has.js



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && _hasPath(object, path, _baseHas);
}

/* harmony default export */ var lodash_es_has = (has);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseInRange.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseInRange_nativeMax = Math.max,
    _baseInRange_nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= _baseInRange_nativeMin(start, end) && number < _baseInRange_nativeMax(start, end);
}

/* harmony default export */ var _baseInRange = (baseInRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/inRange.js




/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = lodash_es_toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = lodash_es_toFinite(end);
  }
  number = lodash_es_toNumber(number);
  return _baseInRange(number, start, end);
}

/* harmony default export */ var lodash_es_inRange = (inRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/isString.js




/** `Object#toString` result references. */
var isString_stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!lodash_es_isArray(value) && lodash_es_isObjectLike(value) && _baseGetTag(value) == isString_stringTag);
}

/* harmony default export */ var lodash_es_isString = (isString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseValues.js


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return _arrayMap(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ var _baseValues = (baseValues);

// CONCATENATED MODULE: ./node_modules/lodash-es/values.js



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values_values(object) {
  return object == null ? [] : _baseValues(object, lodash_es_keys(object));
}

/* harmony default export */ var lodash_es_values = (values_values);

// CONCATENATED MODULE: ./node_modules/lodash-es/includes.js






/* Built-in method references for those with the same name as other `lodash` methods. */
var includes_nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes_includes(collection, value, fromIndex, guard) {
  collection = lodash_es_isArrayLike(collection) ? collection : lodash_es_values(collection);
  fromIndex = (fromIndex && !guard) ? lodash_es_toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = includes_nativeMax(length + fromIndex, 0);
  }
  return lodash_es_isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && _baseIndexOf(collection, value, fromIndex) > -1);
}

/* harmony default export */ var lodash_es_includes = (includes_includes);

// CONCATENATED MODULE: ./node_modules/lodash-es/indexOf.js



/* Built-in method references for those with the same name as other `lodash` methods. */
var indexOf_nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf_indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : lodash_es_toInteger(fromIndex);
  if (index < 0) {
    index = indexOf_nativeMax(length + index, 0);
  }
  return _baseIndexOf(array, value, index);
}

/* harmony default export */ var lodash_es_indexOf = (indexOf_indexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/initial.js


/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseSlice(array, 0, -1) : [];
}

/* harmony default export */ var lodash_es_initial = (initial);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIntersection.js







/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseIntersection_nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? _arrayIncludesWith : _arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = _arrayMap(array, _baseUnary(iteratee));
    }
    maxLength = _baseIntersection_nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new _SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? _cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? _cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ var _baseIntersection = (baseIntersection);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castArrayLikeObject.js


/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return lodash_es_isArrayLikeObject(value) ? value : [];
}

/* harmony default export */ var _castArrayLikeObject = (castArrayLikeObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/intersection.js





/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = _baseRest(function(arrays) {
  var mapped = _arrayMap(arrays, _castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? _baseIntersection(mapped)
    : [];
});

/* harmony default export */ var lodash_es_intersection = (intersection);

// CONCATENATED MODULE: ./node_modules/lodash-es/intersectionBy.js







/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = _baseRest(function(arrays) {
  var iteratee = lodash_es_last(arrays),
      mapped = _arrayMap(arrays, _castArrayLikeObject);

  if (iteratee === lodash_es_last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? _baseIntersection(mapped, _baseIteratee(iteratee, 2))
    : [];
});

/* harmony default export */ var lodash_es_intersectionBy = (intersectionBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/intersectionWith.js






/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = _baseRest(function(arrays) {
  var comparator = lodash_es_last(arrays),
      mapped = _arrayMap(arrays, _castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? _baseIntersection(mapped, undefined, comparator)
    : [];
});

/* harmony default export */ var lodash_es_intersectionWith = (intersectionWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseInverter.js


/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  _baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/* harmony default export */ var _baseInverter = (baseInverter);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createInverter.js


/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return _baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/* harmony default export */ var _createInverter = (createInverter);

// CONCATENATED MODULE: ./node_modules/lodash-es/invert.js




/** Used for built-in method references. */
var invert_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var invert_nativeObjectToString = invert_objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = _createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = invert_nativeObjectToString.call(value);
  }

  result[value] = key;
}, lodash_es_constant(lodash_es_identity));

/* harmony default export */ var lodash_es_invert = (invert);

// CONCATENATED MODULE: ./node_modules/lodash-es/invertBy.js



/** Used for built-in method references. */
var invertBy_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var invertBy_hasOwnProperty = invertBy_objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var invertBy_nativeObjectToString = invertBy_objectProto.toString;

/**
 * This method is like `_.invert` except that the inverted object is generated
 * from the results of running each element of `object` thru `iteratee`. The
 * corresponding inverted value of each inverted key is an array of keys
 * responsible for generating the inverted value. The iteratee is invoked
 * with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Object
 * @param {Object} object The object to invert.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invertBy(object);
 * // => { '1': ['a', 'c'], '2': ['b'] }
 *
 * _.invertBy(object, function(value) {
 *   return 'group' + value;
 * });
 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
 */
var invertBy = _createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = invertBy_nativeObjectToString.call(value);
  }

  if (invertBy_hasOwnProperty.call(result, value)) {
    result[value].push(key);
  } else {
    result[value] = [key];
  }
}, _baseIteratee);

/* harmony default export */ var lodash_es_invertBy = (invertBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_parent.js



/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function _parent_parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

/* harmony default export */ var _parent = (_parent_parent);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseInvoke.js






/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = _castPath(path, object);
  object = _parent(object, path);
  var func = object == null ? object : object[_toKey(lodash_es_last(path))];
  return func == null ? undefined : _apply(func, object, args);
}

/* harmony default export */ var _baseInvoke = (baseInvoke);

// CONCATENATED MODULE: ./node_modules/lodash-es/invoke.js



/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = _baseRest(_baseInvoke);

/* harmony default export */ var lodash_es_invoke = (invoke);

// CONCATENATED MODULE: ./node_modules/lodash-es/invokeMap.js






/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = _baseRest(function(collection, path, args) {
  var index = -1,
      isFunc = typeof path == 'function',
      result = lodash_es_isArrayLike(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value) {
    result[++index] = isFunc ? _apply(path, value, args) : _baseInvoke(value, path, args);
  });
  return result;
});

/* harmony default export */ var lodash_es_invokeMap = (invokeMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArrayBuffer.js



var _baseIsArrayBuffer_arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == _baseIsArrayBuffer_arrayBufferTag;
}

/* harmony default export */ var _baseIsArrayBuffer = (baseIsArrayBuffer);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayBuffer.js




/* Node.js helper references. */
var nodeIsArrayBuffer = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? _baseUnary(nodeIsArrayBuffer) : _baseIsArrayBuffer;

/* harmony default export */ var lodash_es_isArrayBuffer = (isArrayBuffer);

// CONCATENATED MODULE: ./node_modules/lodash-es/isBoolean.js



/** `Object#toString` result references. */
var isBoolean_boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == isBoolean_boolTag);
}

/* harmony default export */ var lodash_es_isBoolean = (isBoolean);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsDate.js



/** `Object#toString` result references. */
var _baseIsDate_dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == _baseIsDate_dateTag;
}

/* harmony default export */ var _baseIsDate = (baseIsDate);

// CONCATENATED MODULE: ./node_modules/lodash-es/isDate.js




/* Node.js helper references. */
var nodeIsDate = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? _baseUnary(nodeIsDate) : _baseIsDate;

/* harmony default export */ var lodash_es_isDate = (isDate);

// CONCATENATED MODULE: ./node_modules/lodash-es/isElement.js



/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return lodash_es_isObjectLike(value) && value.nodeType === 1 && !lodash_es_isPlainObject(value);
}

/* harmony default export */ var lodash_es_isElement = (isElement);

// CONCATENATED MODULE: ./node_modules/lodash-es/isEmpty.js









/** `Object#toString` result references. */
var isEmpty_mapTag = '[object Map]',
    isEmpty_setTag = '[object Set]';

/** Used for built-in method references. */
var isEmpty_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isEmpty_hasOwnProperty = isEmpty_objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (lodash_es_isArrayLike(value) &&
      (lodash_es_isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(isBuffer["a" /* default */])(value) || lodash_es_isTypedArray(value) || lodash_es_isArguments(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == isEmpty_mapTag || tag == isEmpty_setTag) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (isEmpty_hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var lodash_es_isEmpty = (isEmpty);

// CONCATENATED MODULE: ./node_modules/lodash-es/isEqual.js


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return _baseIsEqual(value, other);
}

/* harmony default export */ var lodash_es_isEqual = (isEqual);

// CONCATENATED MODULE: ./node_modules/lodash-es/isEqualWith.js


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? _baseIsEqual(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ var lodash_es_isEqualWith = (isEqualWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/isFinite.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var isFinite_nativeIsFinite = _root["a" /* default */].isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite_isFinite(value) {
  return typeof value == 'number' && isFinite_nativeIsFinite(value);
}

/* harmony default export */ var lodash_es_isFinite = (isFinite_isFinite);

// CONCATENATED MODULE: ./node_modules/lodash-es/isInteger.js


/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == lodash_es_toInteger(value);
}

/* harmony default export */ var lodash_es_isInteger = (isInteger);

// CONCATENATED MODULE: ./node_modules/lodash-es/isMatch.js



/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || _baseIsMatch(object, source, _getMatchData(source));
}

/* harmony default export */ var lodash_es_isMatch = (isMatch);

// CONCATENATED MODULE: ./node_modules/lodash-es/isMatchWith.js



/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseIsMatch(object, source, _getMatchData(source), customizer);
}

/* harmony default export */ var lodash_es_isMatchWith = (isMatchWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNumber.js



/** `Object#toString` result references. */
var isNumber_numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == isNumber_numberTag);
}

/* harmony default export */ var lodash_es_isNumber = (isNumber);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNaN.js


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN_isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return lodash_es_isNumber(value) && value != +value;
}

/* harmony default export */ var lodash_es_isNaN = (isNaN_isNaN);

// EXTERNAL MODULE: ./node_modules/lodash-es/stubFalse.js
var stubFalse = __webpack_require__(84);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isMaskable.js




/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = _coreJsData ? lodash_es_isFunction : stubFalse["a" /* default */];

/* harmony default export */ var _isMaskable = (isMaskable);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNative.js



/** Error message constants. */
var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';

/**
 * Checks if `value` is a pristine native function.
 *
 * **Note:** This method can't reliably detect native functions in the presence
 * of the core-js package because core-js circumvents this kind of detection.
 * Despite multiple requests, the core-js maintainer has made it clear: any
 * attempt to fix the detection will be obstructed. As a result, we're left
 * with little choice but to throw an error. Unfortunately, this also affects
 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
 * which rely on core-js.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (_isMaskable(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return _baseIsNative(value);
}

/* harmony default export */ var lodash_es_isNative = (isNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNil.js
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ var lodash_es_isNil = (isNil);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNull.js
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/* harmony default export */ var lodash_es_isNull = (isNull);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsRegExp.js



/** `Object#toString` result references. */
var _baseIsRegExp_regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == _baseIsRegExp_regexpTag;
}

/* harmony default export */ var _baseIsRegExp = (baseIsRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/isRegExp.js




/* Node.js helper references. */
var nodeIsRegExp = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? _baseUnary(nodeIsRegExp) : _baseIsRegExp;

/* harmony default export */ var lodash_es_isRegExp = (isRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSafeInteger.js


/** Used as references for various `Number` constants. */
var isSafeInteger_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return lodash_es_isInteger(value) && value >= -isSafeInteger_MAX_SAFE_INTEGER && value <= isSafeInteger_MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isSafeInteger = (isSafeInteger);

// CONCATENATED MODULE: ./node_modules/lodash-es/isUndefined.js
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ var lodash_es_isUndefined = (isUndefined);

// CONCATENATED MODULE: ./node_modules/lodash-es/isWeakMap.js



/** `Object#toString` result references. */
var isWeakMap_weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return lodash_es_isObjectLike(value) && _getTag(value) == isWeakMap_weakMapTag;
}

/* harmony default export */ var lodash_es_isWeakMap = (isWeakMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isWeakSet.js



/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == weakSetTag;
}

/* harmony default export */ var lodash_es_isWeakSet = (isWeakSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/iteratee.js



/** Used to compose bitmasks for cloning. */
var iteratee_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee_iteratee(func) {
  return _baseIteratee(typeof func == 'function' ? func : _baseClone(func, iteratee_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_iteratee = (iteratee_iteratee);

// CONCATENATED MODULE: ./node_modules/lodash-es/join.js
/** Used for built-in method references. */
var join_arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = join_arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

/* harmony default export */ var lodash_es_join = (join);

// CONCATENATED MODULE: ./node_modules/lodash-es/kebabCase.js


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = _createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/* harmony default export */ var lodash_es_kebabCase = (kebabCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/keyBy.js



/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = _createAggregator(function(result, value, key) {
  _baseAssignValue(result, key, value);
});

/* harmony default export */ var lodash_es_keyBy = (keyBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_strictLastIndexOf.js
/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictLastIndexOf(array, value, fromIndex) {
  var index = fromIndex + 1;
  while (index--) {
    if (array[index] === value) {
      return index;
    }
  }
  return index;
}

/* harmony default export */ var _strictLastIndexOf = (strictLastIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/lastIndexOf.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var lastIndexOf_nativeMax = Math.max,
    lastIndexOf_nativeMin = Math.min;

/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */
function lastIndexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length;
  if (fromIndex !== undefined) {
    index = lodash_es_toInteger(fromIndex);
    index = index < 0 ? lastIndexOf_nativeMax(length + index, 0) : lastIndexOf_nativeMin(index, length - 1);
  }
  return value === value
    ? _strictLastIndexOf(array, value, index)
    : _baseFindIndex(array, _baseIsNaN, index, true);
}

/* harmony default export */ var lodash_es_lastIndexOf = (lastIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/lowerCase.js


/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = _createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

/* harmony default export */ var lodash_es_lowerCase = (lowerCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/lowerFirst.js


/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = _createCaseFirst('toLowerCase');

/* harmony default export */ var lodash_es_lowerFirst = (lowerFirst);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseLt.js
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

/* harmony default export */ var _baseLt = (baseLt);

// CONCATENATED MODULE: ./node_modules/lodash-es/lt.js



/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = _createRelationalOperation(_baseLt);

/* harmony default export */ var lodash_es_lt = (lt);

// CONCATENATED MODULE: ./node_modules/lodash-es/lte.js


/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = _createRelationalOperation(function(value, other) {
  return value <= other;
});

/* harmony default export */ var lodash_es_lte = (lte);

// CONCATENATED MODULE: ./node_modules/lodash-es/mapKeys.js




/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

/* harmony default export */ var lodash_es_mapKeys = (mapKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/mapValues.js




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ var lodash_es_mapValues = (mapValues);

// CONCATENATED MODULE: ./node_modules/lodash-es/matches.js



/** Used to compose bitmasks for cloning. */
var matches_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between a given
 * object and `source`, returning `true` if the given object has equivalent
 * property values, else `false`.
 *
 * **Note:** The created function is equivalent to `_.isMatch` with `source`
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
 * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
 */
function matches(source) {
  return _baseMatches(_baseClone(source, matches_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_matches = (matches);

// CONCATENATED MODULE: ./node_modules/lodash-es/matchesProperty.js



/** Used to compose bitmasks for cloning. */
var matchesProperty_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between the
 * value at `path` of a given object to `srcValue`, returning `true` if the
 * object value is equivalent, else `false`.
 *
 * **Note:** Partial comparisons will match empty array and empty object
 * `srcValue` values against any array or object value, respectively. See
 * `_.isEqual` for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.find(objects, _.matchesProperty('a', 4));
 * // => { 'a': 4, 'b': 5, 'c': 6 }
 */
function matchesProperty(path, srcValue) {
  return _baseMatchesProperty(path, _baseClone(srcValue, matchesProperty_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_matchesProperty = (matchesProperty);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseExtremum.js


/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !lodash_es_isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

/* harmony default export */ var _baseExtremum = (baseExtremum);

// CONCATENATED MODULE: ./node_modules/lodash-es/max.js




/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? _baseExtremum(array, lodash_es_identity, _baseGt)
    : undefined;
}

/* harmony default export */ var lodash_es_max = (max);

// CONCATENATED MODULE: ./node_modules/lodash-es/maxBy.js




/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? _baseExtremum(array, _baseIteratee(iteratee, 2), _baseGt)
    : undefined;
}

/* harmony default export */ var lodash_es_maxBy = (maxBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSum.js
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

/* harmony default export */ var _baseSum = (baseSum);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMean.js


/** Used as references for various `Number` constants. */
var _baseMean_NAN = 0 / 0;

/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */
function baseMean(array, iteratee) {
  var length = array == null ? 0 : array.length;
  return length ? (_baseSum(array, iteratee) / length) : _baseMean_NAN;
}

/* harmony default export */ var _baseMean = (baseMean);

// CONCATENATED MODULE: ./node_modules/lodash-es/mean.js



/**
 * Computes the mean of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the mean.
 * @example
 *
 * _.mean([4, 2, 8, 6]);
 * // => 5
 */
function mean(array) {
  return _baseMean(array, lodash_es_identity);
}

/* harmony default export */ var lodash_es_mean = (mean);

// CONCATENATED MODULE: ./node_modules/lodash-es/meanBy.js



/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */
function meanBy(array, iteratee) {
  return _baseMean(array, _baseIteratee(iteratee, 2));
}

/* harmony default export */ var lodash_es_meanBy = (meanBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/merge.js



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

/* harmony default export */ var lodash_es_merge = (merge);

// CONCATENATED MODULE: ./node_modules/lodash-es/method.js



/**
 * Creates a function that invokes the method at `path` of a given object.
 * Any additional arguments are provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': _.constant(2) } },
 *   { 'a': { 'b': _.constant(1) } }
 * ];
 *
 * _.map(objects, _.method('a.b'));
 * // => [2, 1]
 *
 * _.map(objects, _.method(['a', 'b']));
 * // => [2, 1]
 */
var method = _baseRest(function(path, args) {
  return function(object) {
    return _baseInvoke(object, path, args);
  };
});

/* harmony default export */ var lodash_es_method = (method);

// CONCATENATED MODULE: ./node_modules/lodash-es/methodOf.js



/**
 * The opposite of `_.method`; this method creates a function that invokes
 * the method at a given path of `object`. Any additional arguments are
 * provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Object} object The object to query.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var array = _.times(3, _.constant),
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.methodOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
 * // => [2, 0]
 */
var methodOf = _baseRest(function(object, args) {
  return function(path) {
    return _baseInvoke(object, path, args);
  };
});

/* harmony default export */ var lodash_es_methodOf = (methodOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/min.js




/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? _baseExtremum(array, lodash_es_identity, _baseLt)
    : undefined;
}

/* harmony default export */ var lodash_es_min = (min);

// CONCATENATED MODULE: ./node_modules/lodash-es/minBy.js




/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? _baseExtremum(array, _baseIteratee(iteratee, 2), _baseLt)
    : undefined;
}

/* harmony default export */ var lodash_es_minBy = (minBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/mixin.js








/**
 * Adds all own enumerable string keyed function properties of a source
 * object to the destination object. If `object` is a function, then methods
 * are added to its prototype as well.
 *
 * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
 * avoid conflicts caused by modifying the original.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Function|Object} [object=lodash] The destination object.
 * @param {Object} source The object of functions to add.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
 * @returns {Function|Object} Returns `object`.
 * @example
 *
 * function vowels(string) {
 *   return _.filter(string, function(v) {
 *     return /[aeiou]/i.test(v);
 *   });
 * }
 *
 * _.mixin({ 'vowels': vowels });
 * _.vowels('fred');
 * // => ['e']
 *
 * _('fred').vowels().value();
 * // => ['e']
 *
 * _.mixin({ 'vowels': vowels }, { 'chain': false });
 * _('fred').vowels();
 * // => ['e']
 */
function mixin(object, source, options) {
  var props = lodash_es_keys(source),
      methodNames = _baseFunctions(source, props);

  var chain = !(lodash_es_isObject(options) && 'chain' in options) || !!options.chain,
      isFunc = lodash_es_isFunction(object);

  _arrayEach(methodNames, function(methodName) {
    var func = source[methodName];
    object[methodName] = func;
    if (isFunc) {
      object.prototype[methodName] = function() {
        var chainAll = this.__chain__;
        if (chain || chainAll) {
          var result = object(this.__wrapped__),
              actions = result.__actions__ = _copyArray(this.__actions__);

          actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
          result.__chain__ = chainAll;
          return result;
        }
        return func.apply(object, _arrayPush([this.value()], arguments));
      };
    }
  });

  return object;
}

/* harmony default export */ var lodash_es_mixin = (mixin);

// CONCATENATED MODULE: ./node_modules/lodash-es/multiply.js


/**
 * Multiply two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} multiplier The first number in a multiplication.
 * @param {number} multiplicand The second number in a multiplication.
 * @returns {number} Returns the product.
 * @example
 *
 * _.multiply(6, 4);
 * // => 24
 */
var multiply = _createMathOperation(function(multiplier, multiplicand) {
  return multiplier * multiplicand;
}, 1);

/* harmony default export */ var lodash_es_multiply = (multiply);

// CONCATENATED MODULE: ./node_modules/lodash-es/negate.js
/** Error message constants. */
var negate_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(negate_FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/* harmony default export */ var lodash_es_negate = (negate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_iteratorToArray.js
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/* harmony default export */ var _iteratorToArray = (iteratorToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/toArray.js











/** `Object#toString` result references. */
var toArray_mapTag = '[object Map]',
    toArray_setTag = '[object Set]';

/** Built-in value references. */
var symIterator = _Symbol ? _Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (lodash_es_isArrayLike(value)) {
    return lodash_es_isString(value) ? _stringToArray(value) : _copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return _iteratorToArray(value[symIterator]());
  }
  var tag = _getTag(value),
      func = tag == toArray_mapTag ? _mapToArray : (tag == toArray_setTag ? _setToArray : lodash_es_values);

  return func(value);
}

/* harmony default export */ var lodash_es_toArray = (toArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/next.js


/**
 * Gets the next value on a wrapped object following the
 * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
 *
 * @name next
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the next iterator value.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 1 }
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 2 }
 *
 * wrapped.next();
 * // => { 'done': true, 'value': undefined }
 */
function wrapperNext() {
  if (this.__values__ === undefined) {
    this.__values__ = lodash_es_toArray(this.value());
  }
  var done = this.__index__ >= this.__values__.length,
      value = done ? undefined : this.__values__[this.__index__++];

  return { 'done': done, 'value': value };
}

/* harmony default export */ var next = (wrapperNext);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseNth.js


/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return _isIndex(n, length) ? array[n] : undefined;
}

/* harmony default export */ var _baseNth = (baseNth);

// CONCATENATED MODULE: ./node_modules/lodash-es/nth.js



/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? _baseNth(array, lodash_es_toInteger(n)) : undefined;
}

/* harmony default export */ var lodash_es_nth = (nth);

// CONCATENATED MODULE: ./node_modules/lodash-es/nthArg.js




/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */
function nthArg(n) {
  n = lodash_es_toInteger(n);
  return _baseRest(function(args) {
    return _baseNth(args, n);
  });
}

/* harmony default export */ var lodash_es_nthArg = (nthArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnset.js





/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = _castPath(path, object);
  object = _parent(object, path);
  return object == null || delete object[_toKey(lodash_es_last(path))];
}

/* harmony default export */ var _baseUnset = (baseUnset);

// CONCATENATED MODULE: ./node_modules/lodash-es/_customOmitClone.js


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return lodash_es_isPlainObject(value) ? undefined : value;
}

/* harmony default export */ var _customOmitClone = (customOmitClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/omit.js









/** Used to compose bitmasks for cloning. */
var omit_CLONE_DEEP_FLAG = 1,
    omit_CLONE_FLAT_FLAG = 2,
    omit_CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = _flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = _arrayMap(paths, function(path) {
    path = _castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  _copyObject(object, _getAllKeysIn(object), result);
  if (isDeep) {
    result = _baseClone(result, omit_CLONE_DEEP_FLAG | omit_CLONE_FLAT_FLAG | omit_CLONE_SYMBOLS_FLAG, _customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    _baseUnset(result, paths[length]);
  }
  return result;
});

/* harmony default export */ var lodash_es_omit = (omit);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSet.js






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!lodash_es_isObject(object)) {
    return object;
  }
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = _toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = lodash_es_isObject(objValue)
          ? objValue
          : (_isIndex(path[index + 1]) ? [] : {});
      }
    }
    _assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* harmony default export */ var _baseSet = (baseSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePickBy.js




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = _baseGet(object, path);

    if (predicate(value, path)) {
      _baseSet(result, _castPath(path, object), value);
    }
  }
  return result;
}

/* harmony default export */ var _basePickBy = (basePickBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/pickBy.js





/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = _arrayMap(_getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = _baseIteratee(predicate);
  return _basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

/* harmony default export */ var lodash_es_pickBy = (pickBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/omitBy.js




/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return lodash_es_pickBy(object, lodash_es_negate(_baseIteratee(predicate)));
}

/* harmony default export */ var lodash_es_omitBy = (omitBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/once.js


/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return lodash_es_before(2, func);
}

/* harmony default export */ var lodash_es_once = (once);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortBy.js
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/* harmony default export */ var _baseSortBy = (baseSortBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_compareAscending.js


/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = lodash_es_isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = lodash_es_isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/* harmony default export */ var _compareAscending = (compareAscending);

// CONCATENATED MODULE: ./node_modules/lodash-es/_compareMultiple.js


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = _compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/* harmony default export */ var _compareMultiple = (compareMultiple);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseOrderBy.js








/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = _arrayMap(iteratees.length ? iteratees : [lodash_es_identity], _baseUnary(_baseIteratee));

  var result = _baseMap(collection, function(value, key, collection) {
    var criteria = _arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return _baseSortBy(result, function(object, other) {
    return _compareMultiple(object, other, orders);
  });
}

/* harmony default export */ var _baseOrderBy = (baseOrderBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/orderBy.js



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!lodash_es_isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!lodash_es_isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return _baseOrderBy(collection, iteratees, orders);
}

/* harmony default export */ var lodash_es_orderBy = (orderBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createOver.js







/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return _flatRest(function(iteratees) {
    iteratees = _arrayMap(iteratees, _baseUnary(_baseIteratee));
    return _baseRest(function(args) {
      var thisArg = this;
      return arrayFunc(iteratees, function(iteratee) {
        return _apply(iteratee, thisArg, args);
      });
    });
  });
}

/* harmony default export */ var _createOver = (createOver);

// CONCATENATED MODULE: ./node_modules/lodash-es/over.js



/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */
var over = _createOver(_arrayMap);

/* harmony default export */ var lodash_es_over = (over);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castRest.js


/**
 * A `baseRest` alias which can be replaced with `identity` by module
 * replacement plugins.
 *
 * @private
 * @type {Function}
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
var castRest = _baseRest;

/* harmony default export */ var _castRest = (castRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/overArgs.js









/* Built-in method references for those with the same name as other `lodash` methods. */
var overArgs_nativeMin = Math.min;

/**
 * Creates a function that invokes `func` with its arguments transformed.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Function
 * @param {Function} func The function to wrap.
 * @param {...(Function|Function[])} [transforms=[_.identity]]
 *  The argument transforms.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function doubled(n) {
 *   return n * 2;
 * }
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var func = _.overArgs(function(x, y) {
 *   return [x, y];
 * }, [square, doubled]);
 *
 * func(9, 3);
 * // => [81, 6]
 *
 * func(10, 5);
 * // => [100, 10]
 */
var overArgs = _castRest(function(func, transforms) {
  transforms = (transforms.length == 1 && lodash_es_isArray(transforms[0]))
    ? _arrayMap(transforms[0], _baseUnary(_baseIteratee))
    : _arrayMap(_baseFlatten(transforms, 1), _baseUnary(_baseIteratee));

  var funcsLength = transforms.length;
  return _baseRest(function(args) {
    var index = -1,
        length = overArgs_nativeMin(args.length, funcsLength);

    while (++index < length) {
      args[index] = transforms[index].call(this, args[index]);
    }
    return _apply(func, this, args);
  });
});

/* harmony default export */ var lodash_es_overArgs = (overArgs);

// CONCATENATED MODULE: ./node_modules/lodash-es/overEvery.js



/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overEvery([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => false
 *
 * func(NaN);
 * // => false
 */
var overEvery = _createOver(_arrayEvery);

/* harmony default export */ var lodash_es_overEvery = (overEvery);

// CONCATENATED MODULE: ./node_modules/lodash-es/overSome.js



/**
 * Creates a function that checks if **any** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overSome([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => true
 *
 * func(NaN);
 * // => false
 */
var overSome = _createOver(_arraySome);

/* harmony default export */ var lodash_es_overSome = (overSome);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRepeat.js
/** Used as references for various `Number` constants. */
var _baseRepeat_MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > _baseRepeat_MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

/* harmony default export */ var _baseRepeat = (baseRepeat);

// CONCATENATED MODULE: ./node_modules/lodash-es/_asciiSize.js


/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = _baseProperty('length');

/* harmony default export */ var _asciiSize = (asciiSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unicodeSize.js
/** Used to compose unicode character classes. */
var _unicodeSize_rsAstralRange = '\\ud800-\\udfff',
    _unicodeSize_rsComboMarksRange = '\\u0300-\\u036f',
    _unicodeSize_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    _unicodeSize_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    _unicodeSize_rsComboRange = _unicodeSize_rsComboMarksRange + _unicodeSize_reComboHalfMarksRange + _unicodeSize_rsComboSymbolsRange,
    _unicodeSize_rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var _unicodeSize_rsAstral = '[' + _unicodeSize_rsAstralRange + ']',
    _unicodeSize_rsCombo = '[' + _unicodeSize_rsComboRange + ']',
    _unicodeSize_rsFitz = '\\ud83c[\\udffb-\\udfff]',
    _unicodeSize_rsModifier = '(?:' + _unicodeSize_rsCombo + '|' + _unicodeSize_rsFitz + ')',
    _unicodeSize_rsNonAstral = '[^' + _unicodeSize_rsAstralRange + ']',
    _unicodeSize_rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    _unicodeSize_rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    _unicodeSize_rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var _unicodeSize_reOptMod = _unicodeSize_rsModifier + '?',
    _unicodeSize_rsOptVar = '[' + _unicodeSize_rsVarRange + ']?',
    _unicodeSize_rsOptJoin = '(?:' + _unicodeSize_rsZWJ + '(?:' + [_unicodeSize_rsNonAstral, _unicodeSize_rsRegional, _unicodeSize_rsSurrPair].join('|') + ')' + _unicodeSize_rsOptVar + _unicodeSize_reOptMod + ')*',
    _unicodeSize_rsSeq = _unicodeSize_rsOptVar + _unicodeSize_reOptMod + _unicodeSize_rsOptJoin,
    _unicodeSize_rsSymbol = '(?:' + [_unicodeSize_rsNonAstral + _unicodeSize_rsCombo + '?', _unicodeSize_rsCombo, _unicodeSize_rsRegional, _unicodeSize_rsSurrPair, _unicodeSize_rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var _unicodeSize_reUnicode = RegExp(_unicodeSize_rsFitz + '(?=' + _unicodeSize_rsFitz + ')|' + _unicodeSize_rsSymbol + _unicodeSize_rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = _unicodeSize_reUnicode.lastIndex = 0;
  while (_unicodeSize_reUnicode.test(string)) {
    ++result;
  }
  return result;
}

/* harmony default export */ var _unicodeSize = (unicodeSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stringSize.js




/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return _hasUnicode(string)
    ? _unicodeSize(string)
    : _asciiSize(string);
}

/* harmony default export */ var _stringSize = (stringSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createPadding.js







/* Built-in method references for those with the same name as other `lodash` methods. */
var _createPadding_nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : _baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? _baseRepeat(chars, length) : chars;
  }
  var result = _baseRepeat(chars, _createPadding_nativeCeil(length / _stringSize(chars)));
  return _hasUnicode(chars)
    ? _castSlice(_stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

/* harmony default export */ var _createPadding = (createPadding);

// CONCATENATED MODULE: ./node_modules/lodash-es/pad.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var pad_nativeCeil = Math.ceil,
    pad_nativeFloor = Math.floor;

/**
 * Pads `string` on the left and right sides if it's shorter than `length`.
 * Padding characters are truncated if they can't be evenly divided by `length`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.pad('abc', 8);
 * // => '  abc   '
 *
 * _.pad('abc', 8, '_-');
 * // => '_-abc_-_'
 *
 * _.pad('abc', 3);
 * // => 'abc'
 */
function pad(string, length, chars) {
  string = lodash_es_toString(string);
  length = lodash_es_toInteger(length);

  var strLength = length ? _stringSize(string) : 0;
  if (!length || strLength >= length) {
    return string;
  }
  var mid = (length - strLength) / 2;
  return (
    _createPadding(pad_nativeFloor(mid), chars) +
    string +
    _createPadding(pad_nativeCeil(mid), chars)
  );
}

/* harmony default export */ var lodash_es_pad = (pad);

// CONCATENATED MODULE: ./node_modules/lodash-es/padEnd.js





/**
 * Pads `string` on the right side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padEnd('abc', 6);
 * // => 'abc   '
 *
 * _.padEnd('abc', 6, '_-');
 * // => 'abc_-_'
 *
 * _.padEnd('abc', 3);
 * // => 'abc'
 */
function padEnd(string, length, chars) {
  string = lodash_es_toString(string);
  length = lodash_es_toInteger(length);

  var strLength = length ? _stringSize(string) : 0;
  return (length && strLength < length)
    ? (string + _createPadding(length - strLength, chars))
    : string;
}

/* harmony default export */ var lodash_es_padEnd = (padEnd);

// CONCATENATED MODULE: ./node_modules/lodash-es/padStart.js





/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = lodash_es_toString(string);
  length = lodash_es_toInteger(length);

  var strLength = length ? _stringSize(string) : 0;
  return (length && strLength < length)
    ? (_createPadding(length - strLength, chars) + string)
    : string;
}

/* harmony default export */ var lodash_es_padStart = (padStart);

// CONCATENATED MODULE: ./node_modules/lodash-es/parseInt.js



/** Used to match leading and trailing whitespace. */
var reTrimStart = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = _root["a" /* default */].parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt_parseInt(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(lodash_es_toString(string).replace(reTrimStart, ''), radix || 0);
}

/* harmony default export */ var lodash_es_parseInt = (parseInt_parseInt);

// CONCATENATED MODULE: ./node_modules/lodash-es/partial.js





/** Used to compose bitmasks for function metadata. */
var partial_WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = _baseRest(function(func, partials) {
  var holders = _replaceHolders(partials, _getHolder(partial));
  return _createWrap(func, partial_WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

/* harmony default export */ var lodash_es_partial = (partial);

// CONCATENATED MODULE: ./node_modules/lodash-es/partialRight.js





/** Used to compose bitmasks for function metadata. */
var partialRight_WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = _baseRest(function(func, partials) {
  var holders = _replaceHolders(partials, _getHolder(partialRight));
  return _createWrap(func, partialRight_WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

/* harmony default export */ var lodash_es_partialRight = (partialRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/partition.js


/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = _createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

/* harmony default export */ var lodash_es_partition = (partition);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePick.js



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return lodash_es_hasIn(object, path);
  });
}

/* harmony default export */ var _basePick = (basePick);

// CONCATENATED MODULE: ./node_modules/lodash-es/pick.js



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = _flatRest(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

/* harmony default export */ var lodash_es_pick = (pick);

// CONCATENATED MODULE: ./node_modules/lodash-es/plant.js



/**
 * Creates a clone of the chain sequence planting `value` as the wrapped value.
 *
 * @name plant
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @param {*} value The value to plant.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2]).map(square);
 * var other = wrapped.plant([3, 4]);
 *
 * other.value();
 * // => [9, 16]
 *
 * wrapped.value();
 * // => [1, 4]
 */
function wrapperPlant(value) {
  var result,
      parent = this;

  while (parent instanceof _baseLodash) {
    var clone = _wrapperClone(parent);
    clone.__index__ = 0;
    clone.__values__ = undefined;
    if (result) {
      previous.__wrapped__ = clone;
    } else {
      result = clone;
    }
    var previous = clone;
    parent = parent.__wrapped__;
  }
  previous.__wrapped__ = value;
  return result;
}

/* harmony default export */ var plant = (wrapperPlant);

// CONCATENATED MODULE: ./node_modules/lodash-es/propertyOf.js


/**
 * The opposite of `_.property`; this method creates a function that returns
 * the value at a given path of `object`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var array = [0, 1, 2],
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
 * // => [2, 0]
 */
function propertyOf(object) {
  return function(path) {
    return object == null ? undefined : _baseGet(object, path);
  };
}

/* harmony default export */ var lodash_es_propertyOf = (propertyOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIndexOfWith.js
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _baseIndexOfWith = (baseIndexOfWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePullAll.js






/** Used for built-in method references. */
var _basePullAll_arrayProto = Array.prototype;

/** Built-in value references. */
var _basePullAll_splice = _basePullAll_arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? _baseIndexOfWith : _baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = _copyArray(values);
  }
  if (iteratee) {
    seen = _arrayMap(array, _baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        _basePullAll_splice.call(seen, fromIndex, 1);
      }
      _basePullAll_splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

/* harmony default export */ var _basePullAll = (basePullAll);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAll.js


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values)
    : array;
}

/* harmony default export */ var lodash_es_pullAll = (pullAll);

// CONCATENATED MODULE: ./node_modules/lodash-es/pull.js



/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = _baseRest(lodash_es_pullAll);

/* harmony default export */ var lodash_es_pull = (pull);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAllBy.js



/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(array);
 * // => [{ 'x': 2 }]
 */
function pullAllBy(array, values, iteratee) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values, _baseIteratee(iteratee, 2))
    : array;
}

/* harmony default export */ var lodash_es_pullAllBy = (pullAllBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAllWith.js


/**
 * This method is like `_.pullAll` except that it accepts `comparator` which
 * is invoked to compare elements of `array` to `values`. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
 *
 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
 * console.log(array);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
 */
function pullAllWith(array, values, comparator) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values, undefined, comparator)
    : array;
}

/* harmony default export */ var lodash_es_pullAllWith = (pullAllWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePullAt.js



/** Used for built-in method references. */
var _basePullAt_arrayProto = Array.prototype;

/** Built-in value references. */
var _basePullAt_splice = _basePullAt_arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (_isIndex(index)) {
        _basePullAt_splice.call(array, index, 1);
      } else {
        _baseUnset(array, index);
      }
    }
  }
  return array;
}

/* harmony default export */ var _basePullAt = (basePullAt);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAt.js







/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */
var pullAt = _flatRest(function(array, indexes) {
  var length = array == null ? 0 : array.length,
      result = _baseAt(array, indexes);

  _basePullAt(array, _arrayMap(indexes, function(index) {
    return _isIndex(index, length) ? +index : index;
  }).sort(_compareAscending));

  return result;
});

/* harmony default export */ var lodash_es_pullAt = (pullAt);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRandom.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseRandom_nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + _baseRandom_nativeFloor(nativeRandom() * (upper - lower + 1));
}

/* harmony default export */ var _baseRandom = (baseRandom);

// CONCATENATED MODULE: ./node_modules/lodash-es/random.js




/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var random_nativeMin = Math.min,
    random_nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && _isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = lodash_es_toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = lodash_es_toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = random_nativeRandom();
    return random_nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return _baseRandom(lower, upper);
}

/* harmony default export */ var lodash_es_random = (random);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRange.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseRange_nativeCeil = Math.ceil,
    _baseRange_nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = _baseRange_nativeMax(_baseRange_nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/* harmony default export */ var _baseRange = (baseRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createRange.js




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && _isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = lodash_es_toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = lodash_es_toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : lodash_es_toFinite(step);
    return _baseRange(start, end, step, fromRight);
  };
}

/* harmony default export */ var _createRange = (createRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/range.js


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = _createRange();

/* harmony default export */ var lodash_es_range = (range);

// CONCATENATED MODULE: ./node_modules/lodash-es/rangeRight.js


/**
 * This method is like `_.range` except that it populates values in
 * descending order.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.range
 * @example
 *
 * _.rangeRight(4);
 * // => [3, 2, 1, 0]
 *
 * _.rangeRight(-4);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 5);
 * // => [4, 3, 2, 1]
 *
 * _.rangeRight(0, 20, 5);
 * // => [15, 10, 5, 0]
 *
 * _.rangeRight(0, -4, -1);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.rangeRight(0);
 * // => []
 */
var rangeRight = _createRange(true);

/* harmony default export */ var lodash_es_rangeRight = (rangeRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/rearg.js



/** Used to compose bitmasks for function metadata. */
var rearg_WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = _flatRest(function(func, indexes) {
  return _createWrap(func, rearg_WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

/* harmony default export */ var lodash_es_rearg = (rearg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseReduce.js
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/* harmony default export */ var _baseReduce = (baseReduce);

// CONCATENATED MODULE: ./node_modules/lodash-es/reduce.js






/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = lodash_es_isArray(collection) ? _arrayReduce : _baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, _baseIteratee(iteratee, 4), accumulator, initAccum, _baseEach);
}

/* harmony default export */ var lodash_es_reduce = (reduce);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayReduceRight.js
/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayReduceRight = (arrayReduceRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/reduceRight.js






/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = lodash_es_isArray(collection) ? _arrayReduceRight : _baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, _baseIteratee(iteratee, 4), accumulator, initAccum, _baseEachRight);
}

/* harmony default export */ var lodash_es_reduceRight = (reduceRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/reject.js






/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = lodash_es_isArray(collection) ? _arrayFilter : _baseFilter;
  return func(collection, lodash_es_negate(_baseIteratee(predicate, 3)));
}

/* harmony default export */ var lodash_es_reject = (reject);

// CONCATENATED MODULE: ./node_modules/lodash-es/remove.js



/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = _baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  _basePullAt(array, indexes);
  return result;
}

/* harmony default export */ var lodash_es_remove = (remove);

// CONCATENATED MODULE: ./node_modules/lodash-es/repeat.js





/**
 * Repeats the given string `n` times.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to repeat.
 * @param {number} [n=1] The number of times to repeat the string.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the repeated string.
 * @example
 *
 * _.repeat('*', 3);
 * // => '***'
 *
 * _.repeat('abc', 2);
 * // => 'abcabc'
 *
 * _.repeat('abc', 0);
 * // => ''
 */
function repeat(string, n, guard) {
  if ((guard ? _isIterateeCall(string, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = lodash_es_toInteger(n);
  }
  return _baseRepeat(lodash_es_toString(string), n);
}

/* harmony default export */ var lodash_es_repeat = (repeat);

// CONCATENATED MODULE: ./node_modules/lodash-es/replace.js


/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = lodash_es_toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

/* harmony default export */ var lodash_es_replace = (replace);

// CONCATENATED MODULE: ./node_modules/lodash-es/rest.js



/** Error message constants. */
var rest_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as
 * an array.
 *
 * **Note:** This method is based on the
 * [rest parameter](https://mdn.io/rest_parameters).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.rest(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function rest(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(rest_FUNC_ERROR_TEXT);
  }
  start = start === undefined ? start : lodash_es_toInteger(start);
  return _baseRest(func, start);
}

/* harmony default export */ var lodash_es_rest = (rest);

// CONCATENATED MODULE: ./node_modules/lodash-es/result.js




/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result_result(object, path, defaultValue) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[_toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = lodash_es_isFunction(value) ? value.call(object) : value;
  }
  return object;
}

/* harmony default export */ var lodash_es_result = (result_result);

// CONCATENATED MODULE: ./node_modules/lodash-es/reverse.js
/** Used for built-in method references. */
var reverse_arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = reverse_arrayProto.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

/* harmony default export */ var lodash_es_reverse = (reverse);

// CONCATENATED MODULE: ./node_modules/lodash-es/round.js


/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = _createRound('round');

/* harmony default export */ var lodash_es_round = (round);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySample.js


/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[_baseRandom(0, length - 1)] : undefined;
}

/* harmony default export */ var _arraySample = (arraySample);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSample.js



/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return _arraySample(lodash_es_values(collection));
}

/* harmony default export */ var _baseSample = (baseSample);

// CONCATENATED MODULE: ./node_modules/lodash-es/sample.js




/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = lodash_es_isArray(collection) ? _arraySample : _baseSample;
  return func(collection);
}

/* harmony default export */ var lodash_es_sample = (sample);

// CONCATENATED MODULE: ./node_modules/lodash-es/_shuffleSelf.js


/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = _baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

/* harmony default export */ var _shuffleSelf = (shuffleSelf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySampleSize.js




/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return _shuffleSelf(_copyArray(array), _baseClamp(n, 0, array.length));
}

/* harmony default export */ var _arraySampleSize = (arraySampleSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSampleSize.js




/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = lodash_es_values(collection);
  return _shuffleSelf(array, _baseClamp(n, 0, array.length));
}

/* harmony default export */ var _baseSampleSize = (baseSampleSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/sampleSize.js






/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? _isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = lodash_es_toInteger(n);
  }
  var func = lodash_es_isArray(collection) ? _arraySampleSize : _baseSampleSize;
  return func(collection, n);
}

/* harmony default export */ var lodash_es_sampleSize = (sampleSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/set.js


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set_set(object, path, value) {
  return object == null ? object : _baseSet(object, path, value);
}

/* harmony default export */ var lodash_es_set = (set_set);

// CONCATENATED MODULE: ./node_modules/lodash-es/setWith.js


/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : _baseSet(object, path, value, customizer);
}

/* harmony default export */ var lodash_es_setWith = (setWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayShuffle.js



/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return _shuffleSelf(_copyArray(array));
}

/* harmony default export */ var _arrayShuffle = (arrayShuffle);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseShuffle.js



/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return _shuffleSelf(lodash_es_values(collection));
}

/* harmony default export */ var _baseShuffle = (baseShuffle);

// CONCATENATED MODULE: ./node_modules/lodash-es/shuffle.js




/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = lodash_es_isArray(collection) ? _arrayShuffle : _baseShuffle;
  return func(collection);
}

/* harmony default export */ var lodash_es_shuffle = (shuffle);

// CONCATENATED MODULE: ./node_modules/lodash-es/size.js






/** `Object#toString` result references. */
var size_mapTag = '[object Map]',
    size_setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size_size(collection) {
  if (collection == null) {
    return 0;
  }
  if (lodash_es_isArrayLike(collection)) {
    return lodash_es_isString(collection) ? _stringSize(collection) : collection.length;
  }
  var tag = _getTag(collection);
  if (tag == size_mapTag || tag == size_setTag) {
    return collection.size;
  }
  return _baseKeys(collection).length;
}

/* harmony default export */ var lodash_es_size = (size_size);

// CONCATENATED MODULE: ./node_modules/lodash-es/slice.js




/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && _isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : lodash_es_toInteger(start);
    end = end === undefined ? length : lodash_es_toInteger(end);
  }
  return _baseSlice(array, start, end);
}

/* harmony default export */ var lodash_es_slice = (slice);

// CONCATENATED MODULE: ./node_modules/lodash-es/snakeCase.js


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = _createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/* harmony default export */ var lodash_es_snakeCase = (snakeCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSome.js


/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  _baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

/* harmony default export */ var _baseSome = (baseSome);

// CONCATENATED MODULE: ./node_modules/lodash-es/some.js






/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = lodash_es_isArray(collection) ? _arraySome : _baseSome;
  if (guard && _isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, _baseIteratee(predicate, 3));
}

/* harmony default export */ var lodash_es_some = (some);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortBy.js





/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = _baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && _isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && _isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return _baseOrderBy(collection, _baseFlatten(iteratees, 1), []);
});

/* harmony default export */ var lodash_es_sortBy = (sortBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortedIndexBy.js


/** Used as references for the maximum length and index of an array. */
var _baseSortedIndexBy_MAX_ARRAY_LENGTH = 4294967295,
    MAX_ARRAY_INDEX = _baseSortedIndexBy_MAX_ARRAY_LENGTH - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseSortedIndexBy_nativeFloor = Math.floor,
    _baseSortedIndexBy_nativeMin = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  value = iteratee(value);

  var low = 0,
      high = array == null ? 0 : array.length,
      valIsNaN = value !== value,
      valIsNull = value === null,
      valIsSymbol = lodash_es_isSymbol(value),
      valIsUndefined = value === undefined;

  while (low < high) {
    var mid = _baseSortedIndexBy_nativeFloor((low + high) / 2),
        computed = iteratee(array[mid]),
        othIsDefined = computed !== undefined,
        othIsNull = computed === null,
        othIsReflexive = computed === computed,
        othIsSymbol = lodash_es_isSymbol(computed);

    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? (computed <= value) : (computed < value);
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return _baseSortedIndexBy_nativeMin(high, MAX_ARRAY_INDEX);
}

/* harmony default export */ var _baseSortedIndexBy = (baseSortedIndexBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortedIndex.js




/** Used as references for the maximum length and index of an array. */
var _baseSortedIndex_MAX_ARRAY_LENGTH = 4294967295,
    HALF_MAX_ARRAY_LENGTH = _baseSortedIndex_MAX_ARRAY_LENGTH >>> 1;

/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndex(array, value, retHighest) {
  var low = 0,
      high = array == null ? low : array.length;

  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
    while (low < high) {
      var mid = (low + high) >>> 1,
          computed = array[mid];

      if (computed !== null && !lodash_es_isSymbol(computed) &&
          (retHighest ? (computed <= value) : (computed < value))) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return high;
  }
  return _baseSortedIndexBy(array, value, lodash_es_identity, retHighest);
}

/* harmony default export */ var _baseSortedIndex = (baseSortedIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedIndex.js


/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */
function sortedIndex(array, value) {
  return _baseSortedIndex(array, value);
}

/* harmony default export */ var lodash_es_sortedIndex = (sortedIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedIndexBy.js



/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return _baseSortedIndexBy(array, value, _baseIteratee(iteratee, 2));
}

/* harmony default export */ var lodash_es_sortedIndexBy = (sortedIndexBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedIndexOf.js



/**
 * This method is like `_.indexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
 * // => 1
 */
function sortedIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = _baseSortedIndex(array, value);
    if (index < length && lodash_es_eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var lodash_es_sortedIndexOf = (sortedIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedLastIndex.js


/**
 * This method is like `_.sortedIndex` except that it returns the highest
 * index at which `value` should be inserted into `array` in order to
 * maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
 * // => 4
 */
function sortedLastIndex(array, value) {
  return _baseSortedIndex(array, value, true);
}

/* harmony default export */ var lodash_es_sortedLastIndex = (sortedLastIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedLastIndexBy.js



/**
 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 1
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
 * // => 1
 */
function sortedLastIndexBy(array, value, iteratee) {
  return _baseSortedIndexBy(array, value, _baseIteratee(iteratee, 2), true);
}

/* harmony default export */ var lodash_es_sortedLastIndexBy = (sortedLastIndexBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedLastIndexOf.js



/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = _baseSortedIndex(array, value, true) - 1;
    if (lodash_es_eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var lodash_es_sortedLastIndexOf = (sortedLastIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortedUniq.js


/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !lodash_es_eq(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

/* harmony default export */ var _baseSortedUniq = (baseSortedUniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedUniq.js


/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return (array && array.length)
    ? _baseSortedUniq(array)
    : [];
}

/* harmony default export */ var lodash_es_sortedUniq = (sortedUniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedUniqBy.js



/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return (array && array.length)
    ? _baseSortedUniq(array, _baseIteratee(iteratee, 2))
    : [];
}

/* harmony default export */ var lodash_es_sortedUniqBy = (sortedUniqBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/split.js








/** Used as references for the maximum length and index of an array. */
var split_MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && _isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? split_MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = lodash_es_toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !lodash_es_isRegExp(separator))
      )) {
    separator = _baseToString(separator);
    if (!separator && _hasUnicode(string)) {
      return _castSlice(_stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

/* harmony default export */ var lodash_es_split = (split);

// CONCATENATED MODULE: ./node_modules/lodash-es/spread.js






/** Error message constants. */
var spread_FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var spread_nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * create function and an array of arguments much like
 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
 *
 * **Note:** This method is based on the
 * [spread operator](https://mdn.io/spread_operator).
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Function
 * @param {Function} func The function to spread arguments over.
 * @param {number} [start=0] The start position of the spread.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.spread(function(who, what) {
 *   return who + ' says ' + what;
 * });
 *
 * say(['fred', 'hello']);
 * // => 'fred says hello'
 *
 * var numbers = Promise.all([
 *   Promise.resolve(40),
 *   Promise.resolve(36)
 * ]);
 *
 * numbers.then(_.spread(function(x, y) {
 *   return x + y;
 * }));
 * // => a Promise of 76
 */
function spread(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(spread_FUNC_ERROR_TEXT);
  }
  start = start == null ? 0 : spread_nativeMax(lodash_es_toInteger(start), 0);
  return _baseRest(function(args) {
    var array = args[start],
        otherArgs = _castSlice(args, 0, start);

    if (array) {
      _arrayPush(otherArgs, array);
    }
    return _apply(func, this, otherArgs);
  });
}

/* harmony default export */ var lodash_es_spread = (spread);

// CONCATENATED MODULE: ./node_modules/lodash-es/startCase.js



/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = _createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + lodash_es_upperFirst(word);
});

/* harmony default export */ var lodash_es_startCase = (startCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/startsWith.js





/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = lodash_es_toString(string);
  position = position == null
    ? 0
    : _baseClamp(lodash_es_toInteger(position), 0, string.length);

  target = _baseToString(target);
  return string.slice(position, position + target.length) == target;
}

/* harmony default export */ var lodash_es_startsWith = (startsWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubObject.js
/**
 * This method returns a new empty object.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Object} Returns the new empty object.
 * @example
 *
 * var objects = _.times(2, _.stubObject);
 *
 * console.log(objects);
 * // => [{}, {}]
 *
 * console.log(objects[0] === objects[1]);
 * // => false
 */
function stubObject() {
  return {};
}

/* harmony default export */ var lodash_es_stubObject = (stubObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubString.js
/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

/* harmony default export */ var lodash_es_stubString = (stubString);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubTrue.js
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

/* harmony default export */ var lodash_es_stubTrue = (stubTrue);

// CONCATENATED MODULE: ./node_modules/lodash-es/subtract.js


/**
 * Subtract two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {number} minuend The first number in a subtraction.
 * @param {number} subtrahend The second number in a subtraction.
 * @returns {number} Returns the difference.
 * @example
 *
 * _.subtract(6, 4);
 * // => 2
 */
var subtract = _createMathOperation(function(minuend, subtrahend) {
  return minuend - subtrahend;
}, 0);

/* harmony default export */ var lodash_es_subtract = (subtract);

// CONCATENATED MODULE: ./node_modules/lodash-es/sum.js



/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? _baseSum(array, lodash_es_identity)
    : 0;
}

/* harmony default export */ var lodash_es_sum = (sum);

// CONCATENATED MODULE: ./node_modules/lodash-es/sumBy.js



/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? _baseSum(array, _baseIteratee(iteratee, 2))
    : 0;
}

/* harmony default export */ var lodash_es_sumBy = (sumBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/tail.js


/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseSlice(array, 1, length) : [];
}

/* harmony default export */ var lodash_es_tail = (tail);

// CONCATENATED MODULE: ./node_modules/lodash-es/take.js



/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : lodash_es_toInteger(n);
  return _baseSlice(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ var lodash_es_take = (take);

// CONCATENATED MODULE: ./node_modules/lodash-es/takeRight.js



/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : lodash_es_toInteger(n);
  n = length - n;
  return _baseSlice(array, n < 0 ? 0 : n, length);
}

/* harmony default export */ var lodash_es_takeRight = (takeRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/takeRightWhile.js



/**
 * Creates a slice of `array` with elements taken from the end. Elements are
 * taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.takeRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeRightWhile(users, ['active', false]);
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeRightWhile(users, 'active');
 * // => []
 */
function takeRightWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3), false, true)
    : [];
}

/* harmony default export */ var lodash_es_takeRightWhile = (takeRightWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/takeWhile.js



/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3))
    : [];
}

/* harmony default export */ var lodash_es_takeWhile = (takeWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/tap.js
/**
 * This method invokes `interceptor` and returns `value`. The interceptor
 * is invoked with one argument; (value). The purpose of this method is to
 * "tap into" a method chain sequence in order to modify intermediate results.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns `value`.
 * @example
 *
 * _([1, 2, 3])
 *  .tap(function(array) {
 *    // Mutate input array.
 *    array.pop();
 *  })
 *  .reverse()
 *  .value();
 * // => [2, 1]
 */
function tap(value, interceptor) {
  interceptor(value);
  return value;
}

/* harmony default export */ var lodash_es_tap = (tap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_customDefaultsAssignIn.js


/** Used for built-in method references. */
var _customDefaultsAssignIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _customDefaultsAssignIn_hasOwnProperty = _customDefaultsAssignIn_objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (lodash_es_eq(objValue, _customDefaultsAssignIn_objectProto[key]) && !_customDefaultsAssignIn_hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

/* harmony default export */ var _customDefaultsAssignIn = (customDefaultsAssignIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_escapeStringChar.js
/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/* harmony default export */ var _escapeStringChar = (escapeStringChar);

// CONCATENATED MODULE: ./node_modules/lodash-es/_reInterpolate.js
/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/* harmony default export */ var _reInterpolate = (reInterpolate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_reEscape.js
/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/* harmony default export */ var _reEscape = (reEscape);

// CONCATENATED MODULE: ./node_modules/lodash-es/_reEvaluate.js
/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/* harmony default export */ var _reEvaluate = (reEvaluate);

// CONCATENATED MODULE: ./node_modules/lodash-es/templateSettings.js





/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': _reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': _reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': _reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': lodash_es_escape }
  }
};

/* harmony default export */ var lodash_es_templateSettings = (templateSettings);

// CONCATENATED MODULE: ./node_modules/lodash-es/template.js












/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used for built-in method references. */
var template_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var template_hasOwnProperty = template_objectProto.hasOwnProperty;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = lodash_es_templateSettings.imports._.templateSettings || lodash_es_templateSettings;

  if (guard && _isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = lodash_es_toString(string);
  options = lodash_es_assignInWith({}, options, settings, _customDefaultsAssignIn);

  var imports = lodash_es_assignInWith({}, options.imports, settings.imports, _customDefaultsAssignIn),
      importsKeys = lodash_es_keys(imports),
      importsValues = _baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === _reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  // The sourceURL gets injected into the source that's eval-ed, so be careful
  // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
  // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
  var sourceURL = template_hasOwnProperty.call(options, 'sourceURL')
    ? ('//# sourceURL=' +
       (options.sourceURL + '').replace(/[\r\n]/g, ' ') +
       '\n')
    : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, _escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  // Like with sourceURL, we take care to not check the option's prototype,
  // as this configuration is a code injection vector.
  var variable = template_hasOwnProperty.call(options, 'variable') && options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = lodash_es_attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (lodash_es_isError(result)) {
    throw result;
  }
  return result;
}

/* harmony default export */ var lodash_es_template = (template);

// CONCATENATED MODULE: ./node_modules/lodash-es/throttle.js



/** Error message constants. */
var throttle_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(throttle_FUNC_ERROR_TEXT);
  }
  if (lodash_es_isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return lodash_es_debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ var lodash_es_throttle = (throttle);

// CONCATENATED MODULE: ./node_modules/lodash-es/thru.js
/**
 * This method is like `_.tap` except that it returns the result of `interceptor`.
 * The purpose of this method is to "pass thru" values replacing intermediate
 * results in a method chain sequence.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns the result of `interceptor`.
 * @example
 *
 * _('  abc  ')
 *  .chain()
 *  .trim()
 *  .thru(function(value) {
 *    return [value];
 *  })
 *  .value();
 * // => ['abc']
 */
function thru(value, interceptor) {
  return interceptor(value);
}

/* harmony default export */ var lodash_es_thru = (thru);

// CONCATENATED MODULE: ./node_modules/lodash-es/times.js




/** Used as references for various `Number` constants. */
var times_MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var times_MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var times_nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = lodash_es_toInteger(n);
  if (n < 1 || n > times_MAX_SAFE_INTEGER) {
    return [];
  }
  var index = times_MAX_ARRAY_LENGTH,
      length = times_nativeMin(n, times_MAX_ARRAY_LENGTH);

  iteratee = _castFunction(iteratee);
  n -= times_MAX_ARRAY_LENGTH;

  var result = _baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

/* harmony default export */ var lodash_es_times = (times);

// CONCATENATED MODULE: ./node_modules/lodash-es/toIterator.js
/**
 * Enables the wrapper to be iterable.
 *
 * @name Symbol.iterator
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the wrapper object.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped[Symbol.iterator]() === wrapped;
 * // => true
 *
 * Array.from(wrapped);
 * // => [1, 2]
 */
function wrapperToIterator() {
  return this;
}

/* harmony default export */ var toIterator = (wrapperToIterator);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseWrapperValue.js




/**
 * The base implementation of `wrapperValue` which returns the result of
 * performing a sequence of actions on the unwrapped `value`, where each
 * successive action is supplied the return value of the previous.
 *
 * @private
 * @param {*} value The unwrapped value.
 * @param {Array} actions Actions to perform to resolve the unwrapped value.
 * @returns {*} Returns the resolved value.
 */
function baseWrapperValue(value, actions) {
  var result = value;
  if (result instanceof _LazyWrapper) {
    result = result.value();
  }
  return _arrayReduce(actions, function(result, action) {
    return action.func.apply(action.thisArg, _arrayPush([result], action.args));
  }, result);
}

/* harmony default export */ var _baseWrapperValue = (baseWrapperValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperValue.js


/**
 * Executes the chain sequence to resolve the unwrapped value.
 *
 * @name value
 * @memberOf _
 * @since 0.1.0
 * @alias toJSON, valueOf
 * @category Seq
 * @returns {*} Returns the resolved unwrapped value.
 * @example
 *
 * _([1, 2, 3]).value();
 * // => [1, 2, 3]
 */
function wrapperValue() {
  return _baseWrapperValue(this.__wrapped__, this.__actions__);
}

/* harmony default export */ var lodash_es_wrapperValue = (wrapperValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/toJSON.js


// CONCATENATED MODULE: ./node_modules/lodash-es/toLower.js


/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return lodash_es_toString(value).toLowerCase();
}

/* harmony default export */ var lodash_es_toLower = (toLower);

// CONCATENATED MODULE: ./node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (lodash_es_isArray(value)) {
    return _arrayMap(value, _toKey);
  }
  return lodash_es_isSymbol(value) ? [value] : _copyArray(_stringToPath(lodash_es_toString(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/toSafeInteger.js



/** Used as references for various `Number` constants. */
var toSafeInteger_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value
    ? _baseClamp(lodash_es_toInteger(value), -toSafeInteger_MAX_SAFE_INTEGER, toSafeInteger_MAX_SAFE_INTEGER)
    : (value === 0 ? value : 0);
}

/* harmony default export */ var lodash_es_toSafeInteger = (toSafeInteger);

// CONCATENATED MODULE: ./node_modules/lodash-es/toUpper.js


/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return lodash_es_toString(value).toUpperCase();
}

/* harmony default export */ var lodash_es_toUpper = (toUpper);

// CONCATENATED MODULE: ./node_modules/lodash-es/transform.js











/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform_transform(object, iteratee, accumulator) {
  var isArr = lodash_es_isArray(object),
      isArrLike = isArr || Object(isBuffer["a" /* default */])(object) || lodash_es_isTypedArray(object);

  iteratee = _baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (lodash_es_isObject(object)) {
      accumulator = lodash_es_isFunction(Ctor) ? _baseCreate(_getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? _arrayEach : _baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/* harmony default export */ var lodash_es_transform = (transform_transform);

// CONCATENATED MODULE: ./node_modules/lodash-es/_charsEndIndex.js


/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && _baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ var _charsEndIndex = (charsEndIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/_charsStartIndex.js


/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && _baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ var _charsStartIndex = (charsStartIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/trim.js







/** Used to match leading and trailing whitespace. */
var trim_reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = lodash_es_toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(trim_reTrim, '');
  }
  if (!string || !(chars = _baseToString(chars))) {
    return string;
  }
  var strSymbols = _stringToArray(string),
      chrSymbols = _stringToArray(chars),
      start = _charsStartIndex(strSymbols, chrSymbols),
      end = _charsEndIndex(strSymbols, chrSymbols) + 1;

  return _castSlice(strSymbols, start, end).join('');
}

/* harmony default export */ var lodash_es_trim = (trim);

// CONCATENATED MODULE: ./node_modules/lodash-es/trimEnd.js






/** Used to match leading and trailing whitespace. */
var reTrimEnd = /\s+$/;

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = lodash_es_toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimEnd, '');
  }
  if (!string || !(chars = _baseToString(chars))) {
    return string;
  }
  var strSymbols = _stringToArray(string),
      end = _charsEndIndex(strSymbols, _stringToArray(chars)) + 1;

  return _castSlice(strSymbols, 0, end).join('');
}

/* harmony default export */ var lodash_es_trimEnd = (trimEnd);

// CONCATENATED MODULE: ./node_modules/lodash-es/trimStart.js






/** Used to match leading and trailing whitespace. */
var trimStart_reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = lodash_es_toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(trimStart_reTrimStart, '');
  }
  if (!string || !(chars = _baseToString(chars))) {
    return string;
  }
  var strSymbols = _stringToArray(string),
      start = _charsStartIndex(strSymbols, _stringToArray(chars));

  return _castSlice(strSymbols, start).join('');
}

/* harmony default export */ var lodash_es_trimStart = (trimStart);

// CONCATENATED MODULE: ./node_modules/lodash-es/truncate.js










/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var truncate_reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (lodash_es_isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? lodash_es_toInteger(options.length) : length;
    omission = 'omission' in options ? _baseToString(options.omission) : omission;
  }
  string = lodash_es_toString(string);

  var strLength = string.length;
  if (_hasUnicode(string)) {
    var strSymbols = _stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - _stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? _castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (lodash_es_isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, lodash_es_toString(truncate_reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(_baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

/* harmony default export */ var lodash_es_truncate = (truncate);

// CONCATENATED MODULE: ./node_modules/lodash-es/unary.js


/**
 * Creates a function that accepts up to one argument, ignoring any
 * additional arguments.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.unary(parseInt));
 * // => [6, 8, 10]
 */
function unary(func) {
  return lodash_es_ary(func, 1);
}

/* harmony default export */ var lodash_es_unary = (unary);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unescapeHtmlChar.js


/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = _basePropertyOf(htmlUnescapes);

/* harmony default export */ var _unescapeHtmlChar = (unescapeHtmlChar);

// CONCATENATED MODULE: ./node_modules/lodash-es/unescape.js



/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape_unescape(string) {
  string = lodash_es_toString(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, _unescapeHtmlChar)
    : string;
}

/* harmony default export */ var lodash_es_unescape = (unescape_unescape);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createSet.js




/** Used as references for various `Number` constants. */
var _createSet_INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(_Set && (1 / _setToArray(new _Set([,-0]))[1]) == _createSet_INFINITY) ? lodash_es_noop : function(values) {
  return new _Set(values);
};

/* harmony default export */ var _createSet = (createSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUniq.js







/** Used as the size to enable large array optimizations. */
var _baseUniq_LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = _arrayIncludesWith;
  }
  else if (length >= _baseUniq_LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : _createSet(array);
    if (set) {
      return _setToArray(set);
    }
    isCommon = false;
    includes = _cacheHas;
    seen = new _SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ var _baseUniq = (baseUniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/union.js





/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = _baseRest(function(arrays) {
  return _baseUniq(_baseFlatten(arrays, 1, lodash_es_isArrayLikeObject, true));
});

/* harmony default export */ var lodash_es_union = (union);

// CONCATENATED MODULE: ./node_modules/lodash-es/unionBy.js







/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = _baseRest(function(arrays) {
  var iteratee = lodash_es_last(arrays);
  if (lodash_es_isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return _baseUniq(_baseFlatten(arrays, 1, lodash_es_isArrayLikeObject, true), _baseIteratee(iteratee, 2));
});

/* harmony default export */ var lodash_es_unionBy = (unionBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/unionWith.js






/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = _baseRest(function(arrays) {
  var comparator = lodash_es_last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return _baseUniq(_baseFlatten(arrays, 1, lodash_es_isArrayLikeObject, true), undefined, comparator);
});

/* harmony default export */ var lodash_es_unionWith = (unionWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniq.js


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? _baseUniq(array) : [];
}

/* harmony default export */ var lodash_es_uniq = (uniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniqBy.js



/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? _baseUniq(array, _baseIteratee(iteratee, 2)) : [];
}

/* harmony default export */ var lodash_es_uniqBy = (uniqBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniqWith.js


/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? _baseUniq(array, undefined, comparator) : [];
}

/* harmony default export */ var lodash_es_uniqWith = (uniqWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniqueId.js


/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return lodash_es_toString(prefix) + id;
}

/* harmony default export */ var lodash_es_uniqueId = (uniqueId);

// CONCATENATED MODULE: ./node_modules/lodash-es/unset.js


/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : _baseUnset(object, path);
}

/* harmony default export */ var lodash_es_unset = (unset);

// CONCATENATED MODULE: ./node_modules/lodash-es/unzip.js






/* Built-in method references for those with the same name as other `lodash` methods. */
var unzip_nativeMax = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = _arrayFilter(array, function(group) {
    if (lodash_es_isArrayLikeObject(group)) {
      length = unzip_nativeMax(group.length, length);
      return true;
    }
  });
  return _baseTimes(length, function(index) {
    return _arrayMap(array, _baseProperty(index));
  });
}

/* harmony default export */ var lodash_es_unzip = (unzip);

// CONCATENATED MODULE: ./node_modules/lodash-es/unzipWith.js




/**
 * This method is like `_.unzip` except that it accepts `iteratee` to specify
 * how regrouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  regrouped values.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
 * // => [[1, 10, 100], [2, 20, 200]]
 *
 * _.unzipWith(zipped, _.add);
 * // => [3, 30, 300]
 */
function unzipWith(array, iteratee) {
  if (!(array && array.length)) {
    return [];
  }
  var result = lodash_es_unzip(array);
  if (iteratee == null) {
    return result;
  }
  return _arrayMap(result, function(group) {
    return _apply(iteratee, undefined, group);
  });
}

/* harmony default export */ var lodash_es_unzipWith = (unzipWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUpdate.js



/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseUpdate(object, path, updater, customizer) {
  return _baseSet(object, path, updater(_baseGet(object, path)), customizer);
}

/* harmony default export */ var _baseUpdate = (baseUpdate);

// CONCATENATED MODULE: ./node_modules/lodash-es/update.js



/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */
function update(object, path, updater) {
  return object == null ? object : _baseUpdate(object, path, _castFunction(updater));
}

/* harmony default export */ var lodash_es_update = (update);

// CONCATENATED MODULE: ./node_modules/lodash-es/updateWith.js



/**
 * This method is like `_.update` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
 * // => { '0': { '1': 'a' } }
 */
function updateWith(object, path, updater, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : _baseUpdate(object, path, _castFunction(updater), customizer);
}

/* harmony default export */ var lodash_es_updateWith = (updateWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/upperCase.js


/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = _createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

/* harmony default export */ var lodash_es_upperCase = (upperCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/value.js


// CONCATENATED MODULE: ./node_modules/lodash-es/valueOf.js


// CONCATENATED MODULE: ./node_modules/lodash-es/valuesIn.js



/**
 * Creates an array of the own and inherited enumerable string keyed property
 * values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.valuesIn(new Foo);
 * // => [1, 2, 3] (iteration order is not guaranteed)
 */
function valuesIn(object) {
  return object == null ? [] : _baseValues(object, lodash_es_keysIn(object));
}

/* harmony default export */ var lodash_es_valuesIn = (valuesIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/without.js




/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = _baseRest(function(array, values) {
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, values)
    : [];
});

/* harmony default export */ var lodash_es_without = (without);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrap.js



/**
 * Creates a function that provides `value` to `wrapper` as its first
 * argument. Any additional arguments provided to the function are appended
 * to those provided to the `wrapper`. The wrapper is invoked with the `this`
 * binding of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {*} value The value to wrap.
 * @param {Function} [wrapper=identity] The wrapper function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var p = _.wrap(_.escape, function(func, text) {
 *   return '<p>' + func(text) + '</p>';
 * });
 *
 * p('fred, barney, & pebbles');
 * // => '<p>fred, barney, &amp; pebbles</p>'
 */
function wrap(value, wrapper) {
  return lodash_es_partial(_castFunction(wrapper), value);
}

/* harmony default export */ var lodash_es_wrap = (wrap);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperAt.js







/**
 * This method is the wrapper version of `_.at`.
 *
 * @name at
 * @memberOf _
 * @since 1.0.0
 * @category Seq
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _(object).at(['a[0].b.c', 'a[1]']).value();
 * // => [3, 4]
 */
var wrapperAt = _flatRest(function(paths) {
  var length = paths.length,
      start = length ? paths[0] : 0,
      value = this.__wrapped__,
      interceptor = function(object) { return _baseAt(object, paths); };

  if (length > 1 || this.__actions__.length ||
      !(value instanceof _LazyWrapper) || !_isIndex(start)) {
    return this.thru(interceptor);
  }
  value = value.slice(start, +start + (length ? 1 : 0));
  value.__actions__.push({
    'func': lodash_es_thru,
    'args': [interceptor],
    'thisArg': undefined
  });
  return new _LodashWrapper(value, this.__chain__).thru(function(array) {
    if (length && !array.length) {
      array.push(undefined);
    }
    return array;
  });
});

/* harmony default export */ var lodash_es_wrapperAt = (wrapperAt);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperChain.js


/**
 * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
 *
 * @name chain
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 }
 * ];
 *
 * // A sequence without explicit chaining.
 * _(users).head();
 * // => { 'user': 'barney', 'age': 36 }
 *
 * // A sequence with explicit chaining.
 * _(users)
 *   .chain()
 *   .head()
 *   .pick('user')
 *   .value();
 * // => { 'user': 'barney' }
 */
function wrapperChain() {
  return lodash_es_chain(this);
}

/* harmony default export */ var lodash_es_wrapperChain = (wrapperChain);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperReverse.js





/**
 * This method is the wrapper version of `_.reverse`.
 *
 * **Note:** This method mutates the wrapped array.
 *
 * @name reverse
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _(array).reverse().value()
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function wrapperReverse() {
  var value = this.__wrapped__;
  if (value instanceof _LazyWrapper) {
    var wrapped = value;
    if (this.__actions__.length) {
      wrapped = new _LazyWrapper(this);
    }
    wrapped = wrapped.reverse();
    wrapped.__actions__.push({
      'func': lodash_es_thru,
      'args': [lodash_es_reverse],
      'thisArg': undefined
    });
    return new _LodashWrapper(wrapped, this.__chain__);
  }
  return this.thru(lodash_es_reverse);
}

/* harmony default export */ var lodash_es_wrapperReverse = (wrapperReverse);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseXor.js




/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? _baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = _baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return _baseUniq(_baseFlatten(result, 1), iteratee, comparator);
}

/* harmony default export */ var _baseXor = (baseXor);

// CONCATENATED MODULE: ./node_modules/lodash-es/xor.js





/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = _baseRest(function(arrays) {
  return _baseXor(_arrayFilter(arrays, lodash_es_isArrayLikeObject));
});

/* harmony default export */ var lodash_es_xor = (xor);

// CONCATENATED MODULE: ./node_modules/lodash-es/xorBy.js







/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = _baseRest(function(arrays) {
  var iteratee = lodash_es_last(arrays);
  if (lodash_es_isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return _baseXor(_arrayFilter(arrays, lodash_es_isArrayLikeObject), _baseIteratee(iteratee, 2));
});

/* harmony default export */ var lodash_es_xorBy = (xorBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/xorWith.js






/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var xorWith = _baseRest(function(arrays) {
  var comparator = lodash_es_last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return _baseXor(_arrayFilter(arrays, lodash_es_isArrayLikeObject), undefined, comparator);
});

/* harmony default export */ var lodash_es_xorWith = (xorWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/zip.js



/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = _baseRest(lodash_es_unzip);

/* harmony default export */ var lodash_es_zip = (zip);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseZipObject.js
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

/* harmony default export */ var _baseZipObject = (baseZipObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/zipObject.js



/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return _baseZipObject(props || [], values || [], _assignValue);
}

/* harmony default export */ var lodash_es_zipObject = (zipObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/zipObjectDeep.js



/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return _baseZipObject(props || [], values || [], _baseSet);
}

/* harmony default export */ var lodash_es_zipObjectDeep = (zipObjectDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/zipWith.js



/**
 * This method is like `_.zip` except that it accepts `iteratee` to specify
 * how grouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  grouped values.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
 *   return a + b + c;
 * });
 * // => [111, 222]
 */
var zipWith = _baseRest(function(arrays) {
  var length = arrays.length,
      iteratee = length > 1 ? arrays[length - 1] : undefined;

  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
  return lodash_es_unzipWith(arrays, iteratee);
});

/* harmony default export */ var lodash_es_zipWith = (zipWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/array.default.js


































































/* harmony default export */ var array_default = ({
  chunk: lodash_es_chunk, compact: lodash_es_compact, concat: lodash_es_concat, difference: lodash_es_difference, differenceBy: lodash_es_differenceBy,
  differenceWith: lodash_es_differenceWith, drop: lodash_es_drop, dropRight: lodash_es_dropRight, dropRightWhile: lodash_es_dropRightWhile, dropWhile: lodash_es_dropWhile,
  fill: lodash_es_fill, findIndex: lodash_es_findIndex, findLastIndex: lodash_es_findLastIndex, first: lodash_es_head, flatten: lodash_es_flatten,
  flattenDeep: lodash_es_flattenDeep, flattenDepth: lodash_es_flattenDepth, fromPairs: lodash_es_fromPairs, head: lodash_es_head, indexOf: lodash_es_indexOf,
  initial: lodash_es_initial, intersection: lodash_es_intersection, intersectionBy: lodash_es_intersectionBy, intersectionWith: lodash_es_intersectionWith, join: lodash_es_join,
  last: lodash_es_last, lastIndexOf: lodash_es_lastIndexOf, nth: lodash_es_nth, pull: lodash_es_pull, pullAll: lodash_es_pullAll,
  pullAllBy: lodash_es_pullAllBy, pullAllWith: lodash_es_pullAllWith, pullAt: lodash_es_pullAt, remove: lodash_es_remove, reverse: lodash_es_reverse,
  slice: lodash_es_slice, sortedIndex: lodash_es_sortedIndex, sortedIndexBy: lodash_es_sortedIndexBy, sortedIndexOf: lodash_es_sortedIndexOf, sortedLastIndex: lodash_es_sortedLastIndex,
  sortedLastIndexBy: lodash_es_sortedLastIndexBy, sortedLastIndexOf: lodash_es_sortedLastIndexOf, sortedUniq: lodash_es_sortedUniq, sortedUniqBy: lodash_es_sortedUniqBy, tail: lodash_es_tail,
  take: lodash_es_take, takeRight: lodash_es_takeRight, takeRightWhile: lodash_es_takeRightWhile, takeWhile: lodash_es_takeWhile, union: lodash_es_union,
  unionBy: lodash_es_unionBy, unionWith: lodash_es_unionWith, uniq: lodash_es_uniq, uniqBy: lodash_es_uniqBy, uniqWith: lodash_es_uniqWith,
  unzip: lodash_es_unzip, unzipWith: lodash_es_unzipWith, without: lodash_es_without, xor: lodash_es_xor, xorBy: lodash_es_xorBy,
  xorWith: lodash_es_xorWith, zip: lodash_es_zip, zipObject: lodash_es_zipObject, zipObjectDeep: lodash_es_zipObjectDeep, zipWith: lodash_es_zipWith
});

// CONCATENATED MODULE: ./node_modules/lodash-es/array.js



































































// CONCATENATED MODULE: ./node_modules/lodash-es/collection.default.js





























/* harmony default export */ var collection_default = ({
  countBy: lodash_es_countBy, each: lodash_es_forEach, eachRight: lodash_es_forEachRight, every: lodash_es_every, filter: lodash_es_filter,
  find: lodash_es_find, findLast: lodash_es_findLast, flatMap: lodash_es_flatMap, flatMapDeep: lodash_es_flatMapDeep, flatMapDepth: lodash_es_flatMapDepth,
  forEach: lodash_es_forEach, forEachRight: lodash_es_forEachRight, groupBy: lodash_es_groupBy, includes: lodash_es_includes, invokeMap: lodash_es_invokeMap,
  keyBy: lodash_es_keyBy, map: lodash_es_map, orderBy: lodash_es_orderBy, partition: lodash_es_partition, reduce: lodash_es_reduce,
  reduceRight: lodash_es_reduceRight, reject: lodash_es_reject, sample: lodash_es_sample, sampleSize: lodash_es_sampleSize, shuffle: lodash_es_shuffle,
  size: lodash_es_size, some: lodash_es_some, sortBy: lodash_es_sortBy
});

// CONCATENATED MODULE: ./node_modules/lodash-es/collection.js






























// CONCATENATED MODULE: ./node_modules/lodash-es/date.default.js


/* harmony default export */ var date_default = ({
  now: lodash_es_now
});

// CONCATENATED MODULE: ./node_modules/lodash-es/date.js



// CONCATENATED MODULE: ./node_modules/lodash-es/function.default.js
























/* harmony default export */ var function_default = ({
  after: lodash_es_after, ary: lodash_es_ary, before: lodash_es_before, bind: lodash_es_bind, bindKey: lodash_es_bindKey,
  curry: lodash_es_curry, curryRight: lodash_es_curryRight, debounce: lodash_es_debounce, defer: lodash_es_defer, delay: lodash_es_delay,
  flip: lodash_es_flip, memoize: lodash_es_memoize, negate: lodash_es_negate, once: lodash_es_once, overArgs: lodash_es_overArgs,
  partial: lodash_es_partial, partialRight: lodash_es_partialRight, rearg: lodash_es_rearg, rest: lodash_es_rest, spread: lodash_es_spread,
  throttle: lodash_es_throttle, unary: lodash_es_unary, wrap: lodash_es_wrap
});

// CONCATENATED MODULE: ./node_modules/lodash-es/function.js

























// CONCATENATED MODULE: ./node_modules/lodash-es/lang.default.js

























































/* harmony default export */ var lang_default = ({
  castArray: lodash_es_castArray, clone: lodash_es_clone, cloneDeep: lodash_es_cloneDeep, cloneDeepWith: lodash_es_cloneDeepWith, cloneWith: lodash_es_cloneWith,
  conformsTo: lodash_es_conformsTo, eq: lodash_es_eq, gt: lodash_es_gt, gte: lodash_es_gte, isArguments: lodash_es_isArguments,
  isArray: lodash_es_isArray, isArrayBuffer: lodash_es_isArrayBuffer, isArrayLike: lodash_es_isArrayLike, isArrayLikeObject: lodash_es_isArrayLikeObject, isBoolean: lodash_es_isBoolean,
  isBuffer: isBuffer["a" /* default */], isDate: lodash_es_isDate, isElement: lodash_es_isElement, isEmpty: lodash_es_isEmpty, isEqual: lodash_es_isEqual,
  isEqualWith: lodash_es_isEqualWith, isError: lodash_es_isError, isFinite: lodash_es_isFinite, isFunction: lodash_es_isFunction, isInteger: lodash_es_isInteger,
  isLength: lodash_es_isLength, isMap: lodash_es_isMap, isMatch: lodash_es_isMatch, isMatchWith: lodash_es_isMatchWith, isNaN: lodash_es_isNaN,
  isNative: lodash_es_isNative, isNil: lodash_es_isNil, isNull: lodash_es_isNull, isNumber: lodash_es_isNumber, isObject: lodash_es_isObject,
  isObjectLike: lodash_es_isObjectLike, isPlainObject: lodash_es_isPlainObject, isRegExp: lodash_es_isRegExp, isSafeInteger: lodash_es_isSafeInteger, isSet: lodash_es_isSet,
  isString: lodash_es_isString, isSymbol: lodash_es_isSymbol, isTypedArray: lodash_es_isTypedArray, isUndefined: lodash_es_isUndefined, isWeakMap: lodash_es_isWeakMap,
  isWeakSet: lodash_es_isWeakSet, lt: lodash_es_lt, lte: lodash_es_lte, toArray: lodash_es_toArray, toFinite: lodash_es_toFinite,
  toInteger: lodash_es_toInteger, toLength: lodash_es_toLength, toNumber: lodash_es_toNumber, toPlainObject: lodash_es_toPlainObject, toSafeInteger: lodash_es_toSafeInteger,
  toString: lodash_es_toString
});

// CONCATENATED MODULE: ./node_modules/lodash-es/lang.js


























































// CONCATENATED MODULE: ./node_modules/lodash-es/math.default.js
















/* harmony default export */ var math_default = ({
  add: lodash_es_add, ceil: lodash_es_ceil, divide: lodash_es_divide, floor: lodash_es_floor, max: lodash_es_max,
  maxBy: lodash_es_maxBy, mean: lodash_es_mean, meanBy: lodash_es_meanBy, min: lodash_es_min, minBy: lodash_es_minBy,
  multiply: lodash_es_multiply, round: lodash_es_round, subtract: lodash_es_subtract, sum: lodash_es_sum, sumBy: lodash_es_sumBy
});

// CONCATENATED MODULE: ./node_modules/lodash-es/math.js

















// CONCATENATED MODULE: ./node_modules/lodash-es/number.default.js




/* harmony default export */ var number_default = ({
  clamp: lodash_es_clamp, inRange: lodash_es_inRange, random: lodash_es_random
});

// CONCATENATED MODULE: ./node_modules/lodash-es/number.js





// CONCATENATED MODULE: ./node_modules/lodash-es/object.default.js
















































/* harmony default export */ var object_default = ({
  assign: lodash_es_assign, assignIn: lodash_es_assignIn, assignInWith: lodash_es_assignInWith, assignWith: lodash_es_assignWith, at: lodash_es_at,
  create: lodash_es_create, defaults: lodash_es_defaults, defaultsDeep: lodash_es_defaultsDeep, entries: lodash_es_toPairs, entriesIn: lodash_es_toPairsIn,
  extend: lodash_es_assignIn, extendWith: lodash_es_assignInWith, findKey: lodash_es_findKey, findLastKey: lodash_es_findLastKey, forIn: lodash_es_forIn,
  forInRight: lodash_es_forInRight, forOwn: lodash_es_forOwn, forOwnRight: lodash_es_forOwnRight, functions: lodash_es_functions, functionsIn: lodash_es_functionsIn,
  get: lodash_es_get, has: lodash_es_has, hasIn: lodash_es_hasIn, invert: lodash_es_invert, invertBy: lodash_es_invertBy,
  invoke: lodash_es_invoke, keys: lodash_es_keys, keysIn: lodash_es_keysIn, mapKeys: lodash_es_mapKeys, mapValues: lodash_es_mapValues,
  merge: lodash_es_merge, mergeWith: lodash_es_mergeWith, omit: lodash_es_omit, omitBy: lodash_es_omitBy, pick: lodash_es_pick,
  pickBy: lodash_es_pickBy, result: lodash_es_result, set: lodash_es_set, setWith: lodash_es_setWith, toPairs: lodash_es_toPairs,
  toPairsIn: lodash_es_toPairsIn, transform: lodash_es_transform, unset: lodash_es_unset, update: lodash_es_update, updateWith: lodash_es_updateWith,
  values: lodash_es_values, valuesIn: lodash_es_valuesIn
});

// CONCATENATED MODULE: ./node_modules/lodash-es/object.js

















































// CONCATENATED MODULE: ./node_modules/lodash-es/seq.default.js















/* harmony default export */ var seq_default = ({
  at: lodash_es_wrapperAt, chain: lodash_es_chain, commit: commit, lodash: wrapperLodash, next: next,
  plant: plant, reverse: lodash_es_wrapperReverse, tap: lodash_es_tap, thru: lodash_es_thru, toIterator: toIterator,
  toJSON: lodash_es_wrapperValue, value: lodash_es_wrapperValue, valueOf: lodash_es_wrapperValue, wrapperChain: lodash_es_wrapperChain
});

// CONCATENATED MODULE: ./node_modules/lodash-es/seq.js
















// CONCATENATED MODULE: ./node_modules/lodash-es/string.default.js
































/* harmony default export */ var string_default = ({
  camelCase: lodash_es_camelCase, capitalize: lodash_es_capitalize, deburr: lodash_es_deburr, endsWith: lodash_es_endsWith, escape: lodash_es_escape,
  escapeRegExp: lodash_es_escapeRegExp, kebabCase: lodash_es_kebabCase, lowerCase: lodash_es_lowerCase, lowerFirst: lodash_es_lowerFirst, pad: lodash_es_pad,
  padEnd: lodash_es_padEnd, padStart: lodash_es_padStart, parseInt: lodash_es_parseInt, repeat: lodash_es_repeat, replace: lodash_es_replace,
  snakeCase: lodash_es_snakeCase, split: lodash_es_split, startCase: lodash_es_startCase, startsWith: lodash_es_startsWith, template: lodash_es_template,
  templateSettings: lodash_es_templateSettings, toLower: lodash_es_toLower, toUpper: lodash_es_toUpper, trim: lodash_es_trim, trimEnd: lodash_es_trimEnd,
  trimStart: lodash_es_trimStart, truncate: lodash_es_truncate, unescape: lodash_es_unescape, upperCase: lodash_es_upperCase, upperFirst: lodash_es_upperFirst,
  words: lodash_es_words
});

// CONCATENATED MODULE: ./node_modules/lodash-es/string.js

































// CONCATENATED MODULE: ./node_modules/lodash-es/util.default.js

































/* harmony default export */ var util_default = ({
  attempt: lodash_es_attempt, bindAll: lodash_es_bindAll, cond: lodash_es_cond, conforms: lodash_es_conforms, constant: lodash_es_constant,
  defaultTo: lodash_es_defaultTo, flow: lodash_es_flow, flowRight: lodash_es_flowRight, identity: lodash_es_identity, iteratee: lodash_es_iteratee,
  matches: lodash_es_matches, matchesProperty: lodash_es_matchesProperty, method: lodash_es_method, methodOf: lodash_es_methodOf, mixin: lodash_es_mixin,
  noop: lodash_es_noop, nthArg: lodash_es_nthArg, over: lodash_es_over, overEvery: lodash_es_overEvery, overSome: lodash_es_overSome,
  property: lodash_es_property, propertyOf: lodash_es_propertyOf, range: lodash_es_range, rangeRight: lodash_es_rangeRight, stubArray: lodash_es_stubArray,
  stubFalse: stubFalse["a" /* default */], stubObject: lodash_es_stubObject, stubString: lodash_es_stubString, stubTrue: lodash_es_stubTrue, times: lodash_es_times,
  toPath: lodash_es_toPath, uniqueId: lodash_es_uniqueId
});

// CONCATENATED MODULE: ./node_modules/lodash-es/util.js


































// CONCATENATED MODULE: ./node_modules/lodash-es/_lazyClone.js



/**
 * Creates a clone of the lazy wrapper object.
 *
 * @private
 * @name clone
 * @memberOf LazyWrapper
 * @returns {Object} Returns the cloned `LazyWrapper` object.
 */
function lazyClone() {
  var result = new _LazyWrapper(this.__wrapped__);
  result.__actions__ = _copyArray(this.__actions__);
  result.__dir__ = this.__dir__;
  result.__filtered__ = this.__filtered__;
  result.__iteratees__ = _copyArray(this.__iteratees__);
  result.__takeCount__ = this.__takeCount__;
  result.__views__ = _copyArray(this.__views__);
  return result;
}

/* harmony default export */ var _lazyClone = (lazyClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/_lazyReverse.js


/**
 * Reverses the direction of lazy iteration.
 *
 * @private
 * @name reverse
 * @memberOf LazyWrapper
 * @returns {Object} Returns the new reversed `LazyWrapper` object.
 */
function lazyReverse() {
  if (this.__filtered__) {
    var result = new _LazyWrapper(this);
    result.__dir__ = -1;
    result.__filtered__ = true;
  } else {
    result = this.clone();
    result.__dir__ *= -1;
  }
  return result;
}

/* harmony default export */ var _lazyReverse = (lazyReverse);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getView.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _getView_nativeMax = Math.max,
    _getView_nativeMin = Math.min;

/**
 * Gets the view, applying any `transforms` to the `start` and `end` positions.
 *
 * @private
 * @param {number} start The start of the view.
 * @param {number} end The end of the view.
 * @param {Array} transforms The transformations to apply to the view.
 * @returns {Object} Returns an object containing the `start` and `end`
 *  positions of the view.
 */
function getView(start, end, transforms) {
  var index = -1,
      length = transforms.length;

  while (++index < length) {
    var data = transforms[index],
        size = data.size;

    switch (data.type) {
      case 'drop':      start += size; break;
      case 'dropRight': end -= size; break;
      case 'take':      end = _getView_nativeMin(end, start + size); break;
      case 'takeRight': start = _getView_nativeMax(start, end - size); break;
    }
  }
  return { 'start': start, 'end': end };
}

/* harmony default export */ var _getView = (getView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_lazyValue.js




/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG = 1,
    LAZY_MAP_FLAG = 2;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _lazyValue_nativeMin = Math.min;

/**
 * Extracts the unwrapped value from its lazy wrapper.
 *
 * @private
 * @name value
 * @memberOf LazyWrapper
 * @returns {*} Returns the unwrapped value.
 */
function lazyValue() {
  var array = this.__wrapped__.value(),
      dir = this.__dir__,
      isArr = lodash_es_isArray(array),
      isRight = dir < 0,
      arrLength = isArr ? array.length : 0,
      view = _getView(0, arrLength, this.__views__),
      start = view.start,
      end = view.end,
      length = end - start,
      index = isRight ? end : (start - 1),
      iteratees = this.__iteratees__,
      iterLength = iteratees.length,
      resIndex = 0,
      takeCount = _lazyValue_nativeMin(length, this.__takeCount__);

  if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
    return _baseWrapperValue(array, this.__actions__);
  }
  var result = [];

  outer:
  while (length-- && resIndex < takeCount) {
    index += dir;

    var iterIndex = -1,
        value = array[index];

    while (++iterIndex < iterLength) {
      var data = iteratees[iterIndex],
          iteratee = data.iteratee,
          type = data.type,
          computed = iteratee(value);

      if (type == LAZY_MAP_FLAG) {
        value = computed;
      } else if (!computed) {
        if (type == LAZY_FILTER_FLAG) {
          continue outer;
        } else {
          break outer;
        }
      }
    }
    result[resIndex++] = value;
  }
  return result;
}

/* harmony default export */ var _lazyValue = (lazyValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/lodash.default.js
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */





































/** Used as the semantic version number. */
var VERSION = '4.17.15';

/** Used to compose bitmasks for function metadata. */
var lodash_default_WRAP_BIND_KEY_FLAG = 2;

/** Used to indicate the type of lazy iteratees. */
var lodash_default_LAZY_FILTER_FLAG = 1,
    LAZY_WHILE_FLAG = 3;

/** Used as references for the maximum length and index of an array. */
var lodash_default_MAX_ARRAY_LENGTH = 4294967295;

/** Used for built-in method references. */
var lodash_default_arrayProto = Array.prototype,
    lodash_default_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var lodash_default_hasOwnProperty = lodash_default_objectProto.hasOwnProperty;

/** Built-in value references. */
var lodash_default_symIterator = _Symbol ? _Symbol.iterator : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var lodash_default_nativeMax = Math.max,
    lodash_default_nativeMin = Math.min;

// wrap `_.mixin` so it works when provided only one argument
var lodash_default_mixin = (function(func) {
  return function(object, source, options) {
    if (options == null) {
      var isObj = lodash_es_isObject(source),
          props = isObj && lodash_es_keys(source),
          methodNames = props && props.length && _baseFunctions(source, props);

      if (!(methodNames ? methodNames.length : isObj)) {
        options = source;
        source = object;
        object = this;
      }
    }
    return func(object, source, options);
  };
}(lodash_es_mixin));

// Add methods that return wrapped values in chain sequences.
wrapperLodash.after = function_default.after;
wrapperLodash.ary = function_default.ary;
wrapperLodash.assign = object_default.assign;
wrapperLodash.assignIn = object_default.assignIn;
wrapperLodash.assignInWith = object_default.assignInWith;
wrapperLodash.assignWith = object_default.assignWith;
wrapperLodash.at = object_default.at;
wrapperLodash.before = function_default.before;
wrapperLodash.bind = function_default.bind;
wrapperLodash.bindAll = util_default.bindAll;
wrapperLodash.bindKey = function_default.bindKey;
wrapperLodash.castArray = lang_default.castArray;
wrapperLodash.chain = seq_default.chain;
wrapperLodash.chunk = array_default.chunk;
wrapperLodash.compact = array_default.compact;
wrapperLodash.concat = array_default.concat;
wrapperLodash.cond = util_default.cond;
wrapperLodash.conforms = util_default.conforms;
wrapperLodash.constant = util_default.constant;
wrapperLodash.countBy = collection_default.countBy;
wrapperLodash.create = object_default.create;
wrapperLodash.curry = function_default.curry;
wrapperLodash.curryRight = function_default.curryRight;
wrapperLodash.debounce = function_default.debounce;
wrapperLodash.defaults = object_default.defaults;
wrapperLodash.defaultsDeep = object_default.defaultsDeep;
wrapperLodash.defer = function_default.defer;
wrapperLodash.delay = function_default.delay;
wrapperLodash.difference = array_default.difference;
wrapperLodash.differenceBy = array_default.differenceBy;
wrapperLodash.differenceWith = array_default.differenceWith;
wrapperLodash.drop = array_default.drop;
wrapperLodash.dropRight = array_default.dropRight;
wrapperLodash.dropRightWhile = array_default.dropRightWhile;
wrapperLodash.dropWhile = array_default.dropWhile;
wrapperLodash.fill = array_default.fill;
wrapperLodash.filter = collection_default.filter;
wrapperLodash.flatMap = collection_default.flatMap;
wrapperLodash.flatMapDeep = collection_default.flatMapDeep;
wrapperLodash.flatMapDepth = collection_default.flatMapDepth;
wrapperLodash.flatten = array_default.flatten;
wrapperLodash.flattenDeep = array_default.flattenDeep;
wrapperLodash.flattenDepth = array_default.flattenDepth;
wrapperLodash.flip = function_default.flip;
wrapperLodash.flow = util_default.flow;
wrapperLodash.flowRight = util_default.flowRight;
wrapperLodash.fromPairs = array_default.fromPairs;
wrapperLodash.functions = object_default.functions;
wrapperLodash.functionsIn = object_default.functionsIn;
wrapperLodash.groupBy = collection_default.groupBy;
wrapperLodash.initial = array_default.initial;
wrapperLodash.intersection = array_default.intersection;
wrapperLodash.intersectionBy = array_default.intersectionBy;
wrapperLodash.intersectionWith = array_default.intersectionWith;
wrapperLodash.invert = object_default.invert;
wrapperLodash.invertBy = object_default.invertBy;
wrapperLodash.invokeMap = collection_default.invokeMap;
wrapperLodash.iteratee = util_default.iteratee;
wrapperLodash.keyBy = collection_default.keyBy;
wrapperLodash.keys = lodash_es_keys;
wrapperLodash.keysIn = object_default.keysIn;
wrapperLodash.map = collection_default.map;
wrapperLodash.mapKeys = object_default.mapKeys;
wrapperLodash.mapValues = object_default.mapValues;
wrapperLodash.matches = util_default.matches;
wrapperLodash.matchesProperty = util_default.matchesProperty;
wrapperLodash.memoize = function_default.memoize;
wrapperLodash.merge = object_default.merge;
wrapperLodash.mergeWith = object_default.mergeWith;
wrapperLodash.method = util_default.method;
wrapperLodash.methodOf = util_default.methodOf;
wrapperLodash.mixin = lodash_default_mixin;
wrapperLodash.negate = lodash_es_negate;
wrapperLodash.nthArg = util_default.nthArg;
wrapperLodash.omit = object_default.omit;
wrapperLodash.omitBy = object_default.omitBy;
wrapperLodash.once = function_default.once;
wrapperLodash.orderBy = collection_default.orderBy;
wrapperLodash.over = util_default.over;
wrapperLodash.overArgs = function_default.overArgs;
wrapperLodash.overEvery = util_default.overEvery;
wrapperLodash.overSome = util_default.overSome;
wrapperLodash.partial = function_default.partial;
wrapperLodash.partialRight = function_default.partialRight;
wrapperLodash.partition = collection_default.partition;
wrapperLodash.pick = object_default.pick;
wrapperLodash.pickBy = object_default.pickBy;
wrapperLodash.property = util_default.property;
wrapperLodash.propertyOf = util_default.propertyOf;
wrapperLodash.pull = array_default.pull;
wrapperLodash.pullAll = array_default.pullAll;
wrapperLodash.pullAllBy = array_default.pullAllBy;
wrapperLodash.pullAllWith = array_default.pullAllWith;
wrapperLodash.pullAt = array_default.pullAt;
wrapperLodash.range = util_default.range;
wrapperLodash.rangeRight = util_default.rangeRight;
wrapperLodash.rearg = function_default.rearg;
wrapperLodash.reject = collection_default.reject;
wrapperLodash.remove = array_default.remove;
wrapperLodash.rest = function_default.rest;
wrapperLodash.reverse = array_default.reverse;
wrapperLodash.sampleSize = collection_default.sampleSize;
wrapperLodash.set = object_default.set;
wrapperLodash.setWith = object_default.setWith;
wrapperLodash.shuffle = collection_default.shuffle;
wrapperLodash.slice = array_default.slice;
wrapperLodash.sortBy = collection_default.sortBy;
wrapperLodash.sortedUniq = array_default.sortedUniq;
wrapperLodash.sortedUniqBy = array_default.sortedUniqBy;
wrapperLodash.split = string_default.split;
wrapperLodash.spread = function_default.spread;
wrapperLodash.tail = array_default.tail;
wrapperLodash.take = array_default.take;
wrapperLodash.takeRight = array_default.takeRight;
wrapperLodash.takeRightWhile = array_default.takeRightWhile;
wrapperLodash.takeWhile = array_default.takeWhile;
wrapperLodash.tap = seq_default.tap;
wrapperLodash.throttle = function_default.throttle;
wrapperLodash.thru = lodash_es_thru;
wrapperLodash.toArray = lang_default.toArray;
wrapperLodash.toPairs = object_default.toPairs;
wrapperLodash.toPairsIn = object_default.toPairsIn;
wrapperLodash.toPath = util_default.toPath;
wrapperLodash.toPlainObject = lang_default.toPlainObject;
wrapperLodash.transform = object_default.transform;
wrapperLodash.unary = function_default.unary;
wrapperLodash.union = array_default.union;
wrapperLodash.unionBy = array_default.unionBy;
wrapperLodash.unionWith = array_default.unionWith;
wrapperLodash.uniq = array_default.uniq;
wrapperLodash.uniqBy = array_default.uniqBy;
wrapperLodash.uniqWith = array_default.uniqWith;
wrapperLodash.unset = object_default.unset;
wrapperLodash.unzip = array_default.unzip;
wrapperLodash.unzipWith = array_default.unzipWith;
wrapperLodash.update = object_default.update;
wrapperLodash.updateWith = object_default.updateWith;
wrapperLodash.values = object_default.values;
wrapperLodash.valuesIn = object_default.valuesIn;
wrapperLodash.without = array_default.without;
wrapperLodash.words = string_default.words;
wrapperLodash.wrap = function_default.wrap;
wrapperLodash.xor = array_default.xor;
wrapperLodash.xorBy = array_default.xorBy;
wrapperLodash.xorWith = array_default.xorWith;
wrapperLodash.zip = array_default.zip;
wrapperLodash.zipObject = array_default.zipObject;
wrapperLodash.zipObjectDeep = array_default.zipObjectDeep;
wrapperLodash.zipWith = array_default.zipWith;

// Add aliases.
wrapperLodash.entries = object_default.toPairs;
wrapperLodash.entriesIn = object_default.toPairsIn;
wrapperLodash.extend = object_default.assignIn;
wrapperLodash.extendWith = object_default.assignInWith;

// Add methods to `lodash.prototype`.
lodash_default_mixin(wrapperLodash, wrapperLodash);

// Add methods that return unwrapped values in chain sequences.
wrapperLodash.add = math_default.add;
wrapperLodash.attempt = util_default.attempt;
wrapperLodash.camelCase = string_default.camelCase;
wrapperLodash.capitalize = string_default.capitalize;
wrapperLodash.ceil = math_default.ceil;
wrapperLodash.clamp = number_default.clamp;
wrapperLodash.clone = lang_default.clone;
wrapperLodash.cloneDeep = lang_default.cloneDeep;
wrapperLodash.cloneDeepWith = lang_default.cloneDeepWith;
wrapperLodash.cloneWith = lang_default.cloneWith;
wrapperLodash.conformsTo = lang_default.conformsTo;
wrapperLodash.deburr = string_default.deburr;
wrapperLodash.defaultTo = util_default.defaultTo;
wrapperLodash.divide = math_default.divide;
wrapperLodash.endsWith = string_default.endsWith;
wrapperLodash.eq = lang_default.eq;
wrapperLodash.escape = string_default.escape;
wrapperLodash.escapeRegExp = string_default.escapeRegExp;
wrapperLodash.every = collection_default.every;
wrapperLodash.find = collection_default.find;
wrapperLodash.findIndex = array_default.findIndex;
wrapperLodash.findKey = object_default.findKey;
wrapperLodash.findLast = collection_default.findLast;
wrapperLodash.findLastIndex = array_default.findLastIndex;
wrapperLodash.findLastKey = object_default.findLastKey;
wrapperLodash.floor = math_default.floor;
wrapperLodash.forEach = collection_default.forEach;
wrapperLodash.forEachRight = collection_default.forEachRight;
wrapperLodash.forIn = object_default.forIn;
wrapperLodash.forInRight = object_default.forInRight;
wrapperLodash.forOwn = object_default.forOwn;
wrapperLodash.forOwnRight = object_default.forOwnRight;
wrapperLodash.get = object_default.get;
wrapperLodash.gt = lang_default.gt;
wrapperLodash.gte = lang_default.gte;
wrapperLodash.has = object_default.has;
wrapperLodash.hasIn = object_default.hasIn;
wrapperLodash.head = array_default.head;
wrapperLodash.identity = lodash_es_identity;
wrapperLodash.includes = collection_default.includes;
wrapperLodash.indexOf = array_default.indexOf;
wrapperLodash.inRange = number_default.inRange;
wrapperLodash.invoke = object_default.invoke;
wrapperLodash.isArguments = lang_default.isArguments;
wrapperLodash.isArray = lodash_es_isArray;
wrapperLodash.isArrayBuffer = lang_default.isArrayBuffer;
wrapperLodash.isArrayLike = lang_default.isArrayLike;
wrapperLodash.isArrayLikeObject = lang_default.isArrayLikeObject;
wrapperLodash.isBoolean = lang_default.isBoolean;
wrapperLodash.isBuffer = lang_default.isBuffer;
wrapperLodash.isDate = lang_default.isDate;
wrapperLodash.isElement = lang_default.isElement;
wrapperLodash.isEmpty = lang_default.isEmpty;
wrapperLodash.isEqual = lang_default.isEqual;
wrapperLodash.isEqualWith = lang_default.isEqualWith;
wrapperLodash.isError = lang_default.isError;
wrapperLodash.isFinite = lang_default.isFinite;
wrapperLodash.isFunction = lang_default.isFunction;
wrapperLodash.isInteger = lang_default.isInteger;
wrapperLodash.isLength = lang_default.isLength;
wrapperLodash.isMap = lang_default.isMap;
wrapperLodash.isMatch = lang_default.isMatch;
wrapperLodash.isMatchWith = lang_default.isMatchWith;
wrapperLodash.isNaN = lang_default.isNaN;
wrapperLodash.isNative = lang_default.isNative;
wrapperLodash.isNil = lang_default.isNil;
wrapperLodash.isNull = lang_default.isNull;
wrapperLodash.isNumber = lang_default.isNumber;
wrapperLodash.isObject = lodash_es_isObject;
wrapperLodash.isObjectLike = lang_default.isObjectLike;
wrapperLodash.isPlainObject = lang_default.isPlainObject;
wrapperLodash.isRegExp = lang_default.isRegExp;
wrapperLodash.isSafeInteger = lang_default.isSafeInteger;
wrapperLodash.isSet = lang_default.isSet;
wrapperLodash.isString = lang_default.isString;
wrapperLodash.isSymbol = lang_default.isSymbol;
wrapperLodash.isTypedArray = lang_default.isTypedArray;
wrapperLodash.isUndefined = lang_default.isUndefined;
wrapperLodash.isWeakMap = lang_default.isWeakMap;
wrapperLodash.isWeakSet = lang_default.isWeakSet;
wrapperLodash.join = array_default.join;
wrapperLodash.kebabCase = string_default.kebabCase;
wrapperLodash.last = lodash_es_last;
wrapperLodash.lastIndexOf = array_default.lastIndexOf;
wrapperLodash.lowerCase = string_default.lowerCase;
wrapperLodash.lowerFirst = string_default.lowerFirst;
wrapperLodash.lt = lang_default.lt;
wrapperLodash.lte = lang_default.lte;
wrapperLodash.max = math_default.max;
wrapperLodash.maxBy = math_default.maxBy;
wrapperLodash.mean = math_default.mean;
wrapperLodash.meanBy = math_default.meanBy;
wrapperLodash.min = math_default.min;
wrapperLodash.minBy = math_default.minBy;
wrapperLodash.stubArray = util_default.stubArray;
wrapperLodash.stubFalse = util_default.stubFalse;
wrapperLodash.stubObject = util_default.stubObject;
wrapperLodash.stubString = util_default.stubString;
wrapperLodash.stubTrue = util_default.stubTrue;
wrapperLodash.multiply = math_default.multiply;
wrapperLodash.nth = array_default.nth;
wrapperLodash.noop = util_default.noop;
wrapperLodash.now = date_default.now;
wrapperLodash.pad = string_default.pad;
wrapperLodash.padEnd = string_default.padEnd;
wrapperLodash.padStart = string_default.padStart;
wrapperLodash.parseInt = string_default.parseInt;
wrapperLodash.random = number_default.random;
wrapperLodash.reduce = collection_default.reduce;
wrapperLodash.reduceRight = collection_default.reduceRight;
wrapperLodash.repeat = string_default.repeat;
wrapperLodash.replace = string_default.replace;
wrapperLodash.result = object_default.result;
wrapperLodash.round = math_default.round;
wrapperLodash.sample = collection_default.sample;
wrapperLodash.size = collection_default.size;
wrapperLodash.snakeCase = string_default.snakeCase;
wrapperLodash.some = collection_default.some;
wrapperLodash.sortedIndex = array_default.sortedIndex;
wrapperLodash.sortedIndexBy = array_default.sortedIndexBy;
wrapperLodash.sortedIndexOf = array_default.sortedIndexOf;
wrapperLodash.sortedLastIndex = array_default.sortedLastIndex;
wrapperLodash.sortedLastIndexBy = array_default.sortedLastIndexBy;
wrapperLodash.sortedLastIndexOf = array_default.sortedLastIndexOf;
wrapperLodash.startCase = string_default.startCase;
wrapperLodash.startsWith = string_default.startsWith;
wrapperLodash.subtract = math_default.subtract;
wrapperLodash.sum = math_default.sum;
wrapperLodash.sumBy = math_default.sumBy;
wrapperLodash.template = string_default.template;
wrapperLodash.times = util_default.times;
wrapperLodash.toFinite = lang_default.toFinite;
wrapperLodash.toInteger = lodash_es_toInteger;
wrapperLodash.toLength = lang_default.toLength;
wrapperLodash.toLower = string_default.toLower;
wrapperLodash.toNumber = lang_default.toNumber;
wrapperLodash.toSafeInteger = lang_default.toSafeInteger;
wrapperLodash.toString = lang_default.toString;
wrapperLodash.toUpper = string_default.toUpper;
wrapperLodash.trim = string_default.trim;
wrapperLodash.trimEnd = string_default.trimEnd;
wrapperLodash.trimStart = string_default.trimStart;
wrapperLodash.truncate = string_default.truncate;
wrapperLodash.unescape = string_default.unescape;
wrapperLodash.uniqueId = util_default.uniqueId;
wrapperLodash.upperCase = string_default.upperCase;
wrapperLodash.upperFirst = string_default.upperFirst;

// Add aliases.
wrapperLodash.each = collection_default.forEach;
wrapperLodash.eachRight = collection_default.forEachRight;
wrapperLodash.first = array_default.head;

lodash_default_mixin(wrapperLodash, (function() {
  var source = {};
  _baseForOwn(wrapperLodash, function(func, methodName) {
    if (!lodash_default_hasOwnProperty.call(wrapperLodash.prototype, methodName)) {
      source[methodName] = func;
    }
  });
  return source;
}()), { 'chain': false });

/**
 * The semantic version number.
 *
 * @static
 * @memberOf _
 * @type {string}
 */
wrapperLodash.VERSION = VERSION;
(wrapperLodash.templateSettings = string_default.templateSettings).imports._ = wrapperLodash;

// Assign default placeholders.
_arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
  wrapperLodash[methodName].placeholder = wrapperLodash;
});

// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
_arrayEach(['drop', 'take'], function(methodName, index) {
  _LazyWrapper.prototype[methodName] = function(n) {
    n = n === undefined ? 1 : lodash_default_nativeMax(lodash_es_toInteger(n), 0);

    var result = (this.__filtered__ && !index)
      ? new _LazyWrapper(this)
      : this.clone();

    if (result.__filtered__) {
      result.__takeCount__ = lodash_default_nativeMin(n, result.__takeCount__);
    } else {
      result.__views__.push({
        'size': lodash_default_nativeMin(n, lodash_default_MAX_ARRAY_LENGTH),
        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
      });
    }
    return result;
  };

  _LazyWrapper.prototype[methodName + 'Right'] = function(n) {
    return this.reverse()[methodName](n).reverse();
  };
});

// Add `LazyWrapper` methods that accept an `iteratee` value.
_arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
  var type = index + 1,
      isFilter = type == lodash_default_LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

  _LazyWrapper.prototype[methodName] = function(iteratee) {
    var result = this.clone();
    result.__iteratees__.push({
      'iteratee': _baseIteratee(iteratee, 3),
      'type': type
    });
    result.__filtered__ = result.__filtered__ || isFilter;
    return result;
  };
});

// Add `LazyWrapper` methods for `_.head` and `_.last`.
_arrayEach(['head', 'last'], function(methodName, index) {
  var takeName = 'take' + (index ? 'Right' : '');

  _LazyWrapper.prototype[methodName] = function() {
    return this[takeName](1).value()[0];
  };
});

// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
_arrayEach(['initial', 'tail'], function(methodName, index) {
  var dropName = 'drop' + (index ? '' : 'Right');

  _LazyWrapper.prototype[methodName] = function() {
    return this.__filtered__ ? new _LazyWrapper(this) : this[dropName](1);
  };
});

_LazyWrapper.prototype.compact = function() {
  return this.filter(lodash_es_identity);
};

_LazyWrapper.prototype.find = function(predicate) {
  return this.filter(predicate).head();
};

_LazyWrapper.prototype.findLast = function(predicate) {
  return this.reverse().find(predicate);
};

_LazyWrapper.prototype.invokeMap = _baseRest(function(path, args) {
  if (typeof path == 'function') {
    return new _LazyWrapper(this);
  }
  return this.map(function(value) {
    return _baseInvoke(value, path, args);
  });
});

_LazyWrapper.prototype.reject = function(predicate) {
  return this.filter(lodash_es_negate(_baseIteratee(predicate)));
};

_LazyWrapper.prototype.slice = function(start, end) {
  start = lodash_es_toInteger(start);

  var result = this;
  if (result.__filtered__ && (start > 0 || end < 0)) {
    return new _LazyWrapper(result);
  }
  if (start < 0) {
    result = result.takeRight(-start);
  } else if (start) {
    result = result.drop(start);
  }
  if (end !== undefined) {
    end = lodash_es_toInteger(end);
    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
  }
  return result;
};

_LazyWrapper.prototype.takeRightWhile = function(predicate) {
  return this.reverse().takeWhile(predicate).reverse();
};

_LazyWrapper.prototype.toArray = function() {
  return this.take(lodash_default_MAX_ARRAY_LENGTH);
};

// Add `LazyWrapper` methods to `lodash.prototype`.
_baseForOwn(_LazyWrapper.prototype, function(func, methodName) {
  var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
      isTaker = /^(?:head|last)$/.test(methodName),
      lodashFunc = wrapperLodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
      retUnwrapped = isTaker || /^find/.test(methodName);

  if (!lodashFunc) {
    return;
  }
  wrapperLodash.prototype[methodName] = function() {
    var value = this.__wrapped__,
        args = isTaker ? [1] : arguments,
        isLazy = value instanceof _LazyWrapper,
        iteratee = args[0],
        useLazy = isLazy || lodash_es_isArray(value);

    var interceptor = function(value) {
      var result = lodashFunc.apply(wrapperLodash, _arrayPush([value], args));
      return (isTaker && chainAll) ? result[0] : result;
    };

    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
      // Avoid lazy use if the iteratee has a "length" value other than `1`.
      isLazy = useLazy = false;
    }
    var chainAll = this.__chain__,
        isHybrid = !!this.__actions__.length,
        isUnwrapped = retUnwrapped && !chainAll,
        onlyLazy = isLazy && !isHybrid;

    if (!retUnwrapped && useLazy) {
      value = onlyLazy ? value : new _LazyWrapper(this);
      var result = func.apply(value, args);
      result.__actions__.push({ 'func': lodash_es_thru, 'args': [interceptor], 'thisArg': undefined });
      return new _LodashWrapper(result, chainAll);
    }
    if (isUnwrapped && onlyLazy) {
      return func.apply(this, args);
    }
    result = this.thru(interceptor);
    return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
  };
});

// Add `Array` methods to `lodash.prototype`.
_arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
  var func = lodash_default_arrayProto[methodName],
      chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
      retUnwrapped = /^(?:pop|shift)$/.test(methodName);

  wrapperLodash.prototype[methodName] = function() {
    var args = arguments;
    if (retUnwrapped && !this.__chain__) {
      var value = this.value();
      return func.apply(lodash_es_isArray(value) ? value : [], args);
    }
    return this[chainName](function(value) {
      return func.apply(lodash_es_isArray(value) ? value : [], args);
    });
  };
});

// Map minified method names to their real names.
_baseForOwn(_LazyWrapper.prototype, function(func, methodName) {
  var lodashFunc = wrapperLodash[methodName];
  if (lodashFunc) {
    var key = lodashFunc.name + '';
    if (!lodash_default_hasOwnProperty.call(_realNames, key)) {
      _realNames[key] = [];
    }
    _realNames[key].push({ 'name': methodName, 'func': lodashFunc });
  }
});

_realNames[_createHybrid(undefined, lodash_default_WRAP_BIND_KEY_FLAG).name] = [{
  'name': 'wrapper',
  'func': undefined
}];

// Add methods to `LazyWrapper`.
_LazyWrapper.prototype.clone = _lazyClone;
_LazyWrapper.prototype.reverse = _lazyReverse;
_LazyWrapper.prototype.value = _lazyValue;

// Add chain sequence methods to the `lodash` wrapper.
wrapperLodash.prototype.at = seq_default.at;
wrapperLodash.prototype.chain = seq_default.wrapperChain;
wrapperLodash.prototype.commit = seq_default.commit;
wrapperLodash.prototype.next = seq_default.next;
wrapperLodash.prototype.plant = seq_default.plant;
wrapperLodash.prototype.reverse = seq_default.reverse;
wrapperLodash.prototype.toJSON = wrapperLodash.prototype.valueOf = wrapperLodash.prototype.value = seq_default.value;

// Add lazy aliases.
wrapperLodash.prototype.first = wrapperLodash.prototype.head;

if (lodash_default_symIterator) {
  wrapperLodash.prototype[lodash_default_symIterator] = seq_default.toIterator;
}

/* harmony default export */ var lodash_default = (wrapperLodash);

// CONCATENATED MODULE: ./node_modules/lodash-es/lodash.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "add", function() { return lodash_es_add; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "after", function() { return lodash_es_after; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ary", function() { return lodash_es_ary; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "assign", function() { return lodash_es_assign; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "assignIn", function() { return lodash_es_assignIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "assignInWith", function() { return lodash_es_assignInWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "assignWith", function() { return lodash_es_assignWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "at", function() { return lodash_es_at; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "attempt", function() { return lodash_es_attempt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "before", function() { return lodash_es_before; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bind", function() { return lodash_es_bind; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindAll", function() { return lodash_es_bindAll; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindKey", function() { return lodash_es_bindKey; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "camelCase", function() { return lodash_es_camelCase; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "capitalize", function() { return lodash_es_capitalize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "castArray", function() { return lodash_es_castArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ceil", function() { return lodash_es_ceil; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "chain", function() { return lodash_es_chain; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "chunk", function() { return lodash_es_chunk; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "clamp", function() { return lodash_es_clamp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "clone", function() { return lodash_es_clone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "cloneDeep", function() { return lodash_es_cloneDeep; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "cloneDeepWith", function() { return lodash_es_cloneDeepWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "cloneWith", function() { return lodash_es_cloneWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "commit", function() { return commit; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compact", function() { return lodash_es_compact; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "concat", function() { return lodash_es_concat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "cond", function() { return lodash_es_cond; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "conforms", function() { return lodash_es_conforms; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "conformsTo", function() { return lodash_es_conformsTo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "constant", function() { return lodash_es_constant; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "countBy", function() { return lodash_es_countBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "create", function() { return lodash_es_create; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "curry", function() { return lodash_es_curry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "curryRight", function() { return lodash_es_curryRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "debounce", function() { return lodash_es_debounce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "deburr", function() { return lodash_es_deburr; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defaultTo", function() { return lodash_es_defaultTo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defaults", function() { return lodash_es_defaults; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defaultsDeep", function() { return lodash_es_defaultsDeep; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defer", function() { return lodash_es_defer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "delay", function() { return lodash_es_delay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "difference", function() { return lodash_es_difference; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "differenceBy", function() { return lodash_es_differenceBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "differenceWith", function() { return lodash_es_differenceWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "divide", function() { return lodash_es_divide; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "drop", function() { return lodash_es_drop; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "dropRight", function() { return lodash_es_dropRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "dropRightWhile", function() { return lodash_es_dropRightWhile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "dropWhile", function() { return lodash_es_dropWhile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "each", function() { return lodash_es_forEach; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "eachRight", function() { return lodash_es_forEachRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "endsWith", function() { return lodash_es_endsWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "entries", function() { return lodash_es_toPairs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "entriesIn", function() { return lodash_es_toPairsIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "eq", function() { return lodash_es_eq; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "escape", function() { return lodash_es_escape; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "escapeRegExp", function() { return lodash_es_escapeRegExp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "every", function() { return lodash_es_every; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "extend", function() { return lodash_es_assignIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "extendWith", function() { return lodash_es_assignInWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "fill", function() { return lodash_es_fill; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "filter", function() { return lodash_es_filter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "find", function() { return lodash_es_find; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findIndex", function() { return lodash_es_findIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findKey", function() { return lodash_es_findKey; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findLast", function() { return lodash_es_findLast; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return lodash_es_findLastIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findLastKey", function() { return lodash_es_findLastKey; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "first", function() { return lodash_es_head; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flatMap", function() { return lodash_es_flatMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flatMapDeep", function() { return lodash_es_flatMapDeep; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flatMapDepth", function() { return lodash_es_flatMapDepth; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flatten", function() { return lodash_es_flatten; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flattenDeep", function() { return lodash_es_flattenDeep; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flattenDepth", function() { return lodash_es_flattenDepth; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flip", function() { return lodash_es_flip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "floor", function() { return lodash_es_floor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flow", function() { return lodash_es_flow; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flowRight", function() { return lodash_es_flowRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forEach", function() { return lodash_es_forEach; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forEachRight", function() { return lodash_es_forEachRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forIn", function() { return lodash_es_forIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forInRight", function() { return lodash_es_forInRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forOwn", function() { return lodash_es_forOwn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forOwnRight", function() { return lodash_es_forOwnRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "fromPairs", function() { return lodash_es_fromPairs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "functions", function() { return lodash_es_functions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "functionsIn", function() { return lodash_es_functionsIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "get", function() { return lodash_es_get; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "groupBy", function() { return lodash_es_groupBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "gt", function() { return lodash_es_gt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "gte", function() { return lodash_es_gte; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "has", function() { return lodash_es_has; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "hasIn", function() { return lodash_es_hasIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "head", function() { return lodash_es_head; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "identity", function() { return lodash_es_identity; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "inRange", function() { return lodash_es_inRange; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "includes", function() { return lodash_es_includes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "indexOf", function() { return lodash_es_indexOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "initial", function() { return lodash_es_initial; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "intersection", function() { return lodash_es_intersection; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "intersectionBy", function() { return lodash_es_intersectionBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "intersectionWith", function() { return lodash_es_intersectionWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "invert", function() { return lodash_es_invert; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "invertBy", function() { return lodash_es_invertBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "invoke", function() { return lodash_es_invoke; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "invokeMap", function() { return lodash_es_invokeMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArguments", function() { return lodash_es_isArguments; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArray", function() { return lodash_es_isArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return lodash_es_isArrayBuffer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return lodash_es_isArrayLike; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArrayLikeObject", function() { return lodash_es_isArrayLikeObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isBoolean", function() { return lodash_es_isBoolean; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isBuffer", function() { return isBuffer["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isDate", function() { return lodash_es_isDate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isElement", function() { return lodash_es_isElement; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isEmpty", function() { return lodash_es_isEmpty; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isEqual", function() { return lodash_es_isEqual; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isEqualWith", function() { return lodash_es_isEqualWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isError", function() { return lodash_es_isError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isFinite", function() { return lodash_es_isFinite; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isFunction", function() { return lodash_es_isFunction; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isInteger", function() { return lodash_es_isInteger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isLength", function() { return lodash_es_isLength; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMap", function() { return lodash_es_isMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMatch", function() { return lodash_es_isMatch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMatchWith", function() { return lodash_es_isMatchWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNaN", function() { return lodash_es_isNaN; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNative", function() { return lodash_es_isNative; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNil", function() { return lodash_es_isNil; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNull", function() { return lodash_es_isNull; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNumber", function() { return lodash_es_isNumber; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isObject", function() { return lodash_es_isObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isObjectLike", function() { return lodash_es_isObjectLike; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isPlainObject", function() { return lodash_es_isPlainObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isRegExp", function() { return lodash_es_isRegExp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isSafeInteger", function() { return lodash_es_isSafeInteger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isSet", function() { return lodash_es_isSet; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isString", function() { return lodash_es_isString; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isSymbol", function() { return lodash_es_isSymbol; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return lodash_es_isTypedArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isUndefined", function() { return lodash_es_isUndefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return lodash_es_isWeakMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return lodash_es_isWeakSet; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "iteratee", function() { return lodash_es_iteratee; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "join", function() { return lodash_es_join; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "kebabCase", function() { return lodash_es_kebabCase; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "keyBy", function() { return lodash_es_keyBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "keys", function() { return lodash_es_keys; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "keysIn", function() { return lodash_es_keysIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "last", function() { return lodash_es_last; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return lodash_es_lastIndexOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lodash", function() { return wrapperLodash; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lowerCase", function() { return lodash_es_lowerCase; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lowerFirst", function() { return lodash_es_lowerFirst; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lt", function() { return lodash_es_lt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lte", function() { return lodash_es_lte; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "map", function() { return lodash_es_map; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mapKeys", function() { return lodash_es_mapKeys; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mapValues", function() { return lodash_es_mapValues; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "matches", function() { return lodash_es_matches; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "matchesProperty", function() { return lodash_es_matchesProperty; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "max", function() { return lodash_es_max; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "maxBy", function() { return lodash_es_maxBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mean", function() { return lodash_es_mean; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "meanBy", function() { return lodash_es_meanBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "memoize", function() { return lodash_es_memoize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "merge", function() { return lodash_es_merge; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mergeWith", function() { return lodash_es_mergeWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "method", function() { return lodash_es_method; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "methodOf", function() { return lodash_es_methodOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "min", function() { return lodash_es_min; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "minBy", function() { return lodash_es_minBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mixin", function() { return lodash_es_mixin; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "multiply", function() { return lodash_es_multiply; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "negate", function() { return lodash_es_negate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "next", function() { return next; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "noop", function() { return lodash_es_noop; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "now", function() { return lodash_es_now; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "nth", function() { return lodash_es_nth; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "nthArg", function() { return lodash_es_nthArg; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "omit", function() { return lodash_es_omit; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "omitBy", function() { return lodash_es_omitBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "once", function() { return lodash_es_once; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "orderBy", function() { return lodash_es_orderBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "over", function() { return lodash_es_over; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "overArgs", function() { return lodash_es_overArgs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "overEvery", function() { return lodash_es_overEvery; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "overSome", function() { return lodash_es_overSome; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pad", function() { return lodash_es_pad; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "padEnd", function() { return lodash_es_padEnd; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "padStart", function() { return lodash_es_padStart; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "parseInt", function() { return lodash_es_parseInt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "partial", function() { return lodash_es_partial; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "partialRight", function() { return lodash_es_partialRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "partition", function() { return lodash_es_partition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pick", function() { return lodash_es_pick; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pickBy", function() { return lodash_es_pickBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "plant", function() { return plant; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "property", function() { return lodash_es_property; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "propertyOf", function() { return lodash_es_propertyOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pull", function() { return lodash_es_pull; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pullAll", function() { return lodash_es_pullAll; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pullAllBy", function() { return lodash_es_pullAllBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pullAllWith", function() { return lodash_es_pullAllWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pullAt", function() { return lodash_es_pullAt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "random", function() { return lodash_es_random; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "range", function() { return lodash_es_range; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "rangeRight", function() { return lodash_es_rangeRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "rearg", function() { return lodash_es_rearg; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reduce", function() { return lodash_es_reduce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reduceRight", function() { return lodash_es_reduceRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reject", function() { return lodash_es_reject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "remove", function() { return lodash_es_remove; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "repeat", function() { return lodash_es_repeat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "replace", function() { return lodash_es_replace; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "rest", function() { return lodash_es_rest; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "result", function() { return lodash_es_result; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reverse", function() { return lodash_es_reverse; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "round", function() { return lodash_es_round; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sample", function() { return lodash_es_sample; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sampleSize", function() { return lodash_es_sampleSize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "set", function() { return lodash_es_set; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setWith", function() { return lodash_es_setWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "shuffle", function() { return lodash_es_shuffle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "size", function() { return lodash_es_size; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "slice", function() { return lodash_es_slice; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "snakeCase", function() { return lodash_es_snakeCase; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "some", function() { return lodash_es_some; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortBy", function() { return lodash_es_sortBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return lodash_es_sortedIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedIndexBy", function() { return lodash_es_sortedIndexBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedIndexOf", function() { return lodash_es_sortedIndexOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedLastIndex", function() { return lodash_es_sortedLastIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedLastIndexBy", function() { return lodash_es_sortedLastIndexBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedLastIndexOf", function() { return lodash_es_sortedLastIndexOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedUniq", function() { return lodash_es_sortedUniq; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedUniqBy", function() { return lodash_es_sortedUniqBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "split", function() { return lodash_es_split; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "spread", function() { return lodash_es_spread; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "startCase", function() { return lodash_es_startCase; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "startsWith", function() { return lodash_es_startsWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "stubArray", function() { return lodash_es_stubArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "stubFalse", function() { return stubFalse["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "stubObject", function() { return lodash_es_stubObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "stubString", function() { return lodash_es_stubString; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "stubTrue", function() { return lodash_es_stubTrue; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "subtract", function() { return lodash_es_subtract; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sum", function() { return lodash_es_sum; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sumBy", function() { return lodash_es_sumBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "tail", function() { return lodash_es_tail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "take", function() { return lodash_es_take; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "takeRight", function() { return lodash_es_takeRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "takeRightWhile", function() { return lodash_es_takeRightWhile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "takeWhile", function() { return lodash_es_takeWhile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "tap", function() { return lodash_es_tap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "template", function() { return lodash_es_template; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "templateSettings", function() { return lodash_es_templateSettings; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "throttle", function() { return lodash_es_throttle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "thru", function() { return lodash_es_thru; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "times", function() { return lodash_es_times; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toArray", function() { return lodash_es_toArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toFinite", function() { return lodash_es_toFinite; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toInteger", function() { return lodash_es_toInteger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toIterator", function() { return toIterator; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toJSON", function() { return lodash_es_wrapperValue; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toLength", function() { return lodash_es_toLength; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toLower", function() { return lodash_es_toLower; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toNumber", function() { return lodash_es_toNumber; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toPairs", function() { return lodash_es_toPairs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toPairsIn", function() { return lodash_es_toPairsIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toPath", function() { return lodash_es_toPath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toPlainObject", function() { return lodash_es_toPlainObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toSafeInteger", function() { return lodash_es_toSafeInteger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toString", function() { return lodash_es_toString; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toUpper", function() { return lodash_es_toUpper; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "transform", function() { return lodash_es_transform; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "trim", function() { return lodash_es_trim; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "trimEnd", function() { return lodash_es_trimEnd; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "trimStart", function() { return lodash_es_trimStart; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "truncate", function() { return lodash_es_truncate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unary", function() { return lodash_es_unary; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unescape", function() { return lodash_es_unescape; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "union", function() { return lodash_es_union; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unionBy", function() { return lodash_es_unionBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unionWith", function() { return lodash_es_unionWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "uniq", function() { return lodash_es_uniq; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "uniqBy", function() { return lodash_es_uniqBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "uniqWith", function() { return lodash_es_uniqWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "uniqueId", function() { return lodash_es_uniqueId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unset", function() { return lodash_es_unset; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unzip", function() { return lodash_es_unzip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unzipWith", function() { return lodash_es_unzipWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "update", function() { return lodash_es_update; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "updateWith", function() { return lodash_es_updateWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "upperCase", function() { return lodash_es_upperCase; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "upperFirst", function() { return lodash_es_upperFirst; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "value", function() { return lodash_es_wrapperValue; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "valueOf", function() { return lodash_es_wrapperValue; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "values", function() { return lodash_es_values; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "valuesIn", function() { return lodash_es_valuesIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "without", function() { return lodash_es_without; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "words", function() { return lodash_es_words; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrap", function() { return lodash_es_wrap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperAt", function() { return lodash_es_wrapperAt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperChain", function() { return lodash_es_wrapperChain; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperCommit", function() { return commit; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperLodash", function() { return wrapperLodash; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperNext", function() { return next; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperPlant", function() { return plant; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperReverse", function() { return lodash_es_wrapperReverse; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperToIterator", function() { return toIterator; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrapperValue", function() { return lodash_es_wrapperValue; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "xor", function() { return lodash_es_xor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "xorBy", function() { return lodash_es_xorBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "xorWith", function() { return lodash_es_xorWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "zip", function() { return lodash_es_zip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "zipObject", function() { return lodash_es_zipObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "zipObjectDeep", function() { return lodash_es_zipObjectDeep; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "zipWith", function() { return lodash_es_zipWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return lodash_default; });
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */




































































































































































































































































































































/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regex = exports.ref = exports.len = exports.req = exports.withParams = undefined;

var _withParams = __webpack_require__(451);

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.withParams = _withParams2.default;

// "required" core, used in almost every validator to allow empty values

var req = exports.req = function req(value) {
  if (Array.isArray(value)) return !!value.length;
  if (value === undefined || value === null || value === false) {
    return false;
  }

  if (value instanceof Date) {
    // invalid date won't pass
    return !isNaN(value.getTime());
  }

  if (typeof value === 'object') {
    for (var _ in value) {
      return true;
    }return false;
  }

  return !!String(value).length;
};

// get length in type-agnostic way
var len = exports.len = function len(value) {
  if (Array.isArray(value)) return value.length;
  if (typeof value === 'object') {
    return Object.keys(value).length;
  }
  return String(value).length;
};

// resolve referenced value
var ref = exports.ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

// regex based validator template
var regex = exports.regex = function regex(type, expr) {
  return (0, _withParams2.default)({ type: type }, function (value) {
    return !req(value) || expr.test(value);
  });
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(183);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(2);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueAnalytics = __webpack_require__(172);

var _auth = __webpack_require__(421);

var _auth2 = _interopRequireDefault(_auth);

var _nav = __webpack_require__(506);

var _nav2 = _interopRequireDefault(_nav);

var _booking = __webpack_require__(510);

var _booking2 = _interopRequireDefault(_booking);

var _stats = __webpack_require__(515);

var _stats2 = _interopRequireDefault(_stats);

var _allocation = __webpack_require__(519);

var _allocation2 = _interopRequireDefault(_allocation);

var _admin = __webpack_require__(524);

var _admin2 = _interopRequireDefault(_admin);

var _info = __webpack_require__(529);

var _info2 = _interopRequireDefault(_info);

var _alert = __webpack_require__(533);

var _alert2 = _interopRequireDefault(_alert);

var _dashboard = __webpack_require__(537);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _account = __webpack_require__(542);

var _account2 = _interopRequireDefault(_account);

var _introduction = __webpack_require__(547);

var _introduction2 = _interopRequireDefault(_introduction);

var _contract = __webpack_require__(551);

var _contract2 = _interopRequireDefault(_contract);

var _instruction = __webpack_require__(559);

var _instruction2 = _interopRequireDefault(_instruction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;
_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    strict: true,
    modules: {
        auth: _auth2.default,
        nav: _nav2.default,
        booking: _booking2.default,
        stats: _stats2.default,
        allocation: _allocation2.default,
        admin: _admin2.default,
        info: _info2.default,
        alert: _alert2.default,
        dashboard: _dashboard2.default,
        account: _account2.default,
        introduction: _introduction2.default,
        contract: _contract2.default,
        instruction: _instruction2.default
    },
    plugins: [_vueAnalytics.analyticsMiddleware]
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/lodash.js + 631 modules
var lodash = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DropdownMenu/DropdownMenu.vue



/* harmony default export */ var DropdownMenu = ({
    props: {
        searchable: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: [Number, String],
            default: undefined
        },
        items: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledValue: {
            type: String,
            default: 'N/A'
        },
        undefinedValue: {
            type: String,
            default: 'All items'
        },
        enableDeselect: {
            type: Boolean,
            default: false
        },
        translationPrefix: {
            type: String,
            default: undefined
        },
        itemsCounts: {
            type: Array,
            default: undefined
        }
    },
    data: function data() {
        return {
            toggled: false,
            event: undefined,
            search: '',
            filteredItems: undefined
        };
    },
    created: function created() {
        this.filteredItems = this.items;
    },

    methods: {
        toggle: function toggle() {
            if (!this.disabled) {
                if (!this.toggled) {
                    this.addListeners();
                } else {
                    this.resetSearch();
                    this.removeListeners();
                }
                this.toggled = !this.toggled;
            }
        },
        keypress: function keypress(key) {
            this.search += key;
        },
        backSpace: function backSpace() {
            this.search = this.search.substring(0, this.search.length - 1);
        },
        escape: function escape() {
            this.toggled = false;
            this.resetSearch();
            this.removeListeners();
        },
        select: function select(val) {
            this.resetSearch();
            this.$emit('input', val);
        },
        deselect: function deselect() {
            this.resetSearch();
            this.$emit('input', undefined);
        },
        filterSearch: function filterSearch() {
            var _this = this;

            this.filteredItems = Object(lodash["filter"])(this.items, function (item) {
                return item.toLowerCase().indexOf(_this.search.toLowerCase()) !== -1;
            });
        },
        clickEvent: function clickEvent(event) {
            if (!event.target.classList.contains('dropdown-menu__button')) {
                this.toggle();
            }
        },
        addListeners: function addListeners() {
            document.addEventListener('click', this.clickEvent);
            if (this.searchable) {
                document.addEventListener('keydown', this.keypressEvent);
            }
        },
        removeListeners: function removeListeners() {
            document.removeEventListener('click', this.clickEvent);
            if (this.searchable) {
                document.removeEventListener('keydown', this.keypressEvent);
            }
        },
        resetSearch: function resetSearch() {
            this.search = '';
            this.filteredItems = this.items;
        },
        keypressEvent: function keypressEvent(event) {
            var key = event.key;
            switch (key) {
                case 'Backspace':
                    this.backSpace();
                    break;
                case 'Escape':
                    this.escape();
                    break;
                case 'ArrowUp':
                    break;
                case 'ArrowDown':
                    break;
                case 'ArrowLeft':
                    break;
                case 'ArrowRight':
                    break;
                default:
                    this.keypress(key);
            }
            this.filterSearch();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da01af8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropdownMenu/DropdownMenu.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu",class:{'dropdown-menu--disabled': _vm.disabled},on:{"click":_vm.toggle}},[_c('div',{staticClass:"dropdown-menu__button",attrs:{"title":_vm.value}},[_c('div',{staticClass:"dropdown-menu__label"},[_vm._v("\n            "+_vm._s(_vm.label)+":\n        ")]),_vm._v(" "),(_vm.search === '')?_c('div',{staticClass:"dropdown-menu__value"},[(_vm.value)?_c('span',[_vm._v("\n                "+_vm._s(_vm.translationPrefix ? _vm.$t(_vm.translationPrefix + '.' + _vm.value) : _vm.value)+"\n            ")]):_vm._e(),_vm._v(" "),(!_vm.value)?_c('span',[_vm._v("\n                "+_vm._s(_vm.disabled ? _vm.disabledValue : _vm.undefinedValue)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.search !== '')?_c('div',{staticClass:"dropdown-menu__search"},[_vm._v("\n            "+_vm._s(_vm.search)+"\n        ")]):_vm._e()]),_vm._v(" "),(_vm.toggled)?_c('div',{staticClass:"dropdown-menu__dropdown",attrs:{"id":"dropdown-menu__dropdown"}},[(_vm.enableDeselect)?_c('div',{staticClass:"dropdown-menu__choice",class:{'dropdown-menu__choice--selected': !_vm.value},on:{"click":_vm.deselect}},[_vm._v("\n            "+_vm._s(_vm.undefinedValue)+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredItems),function(item,index){return _c('div',{key:'dropdown-item__' + index,staticClass:"dropdown-menu__choice",class:{'dropdown-menu__choice--selected': _vm.value === item},attrs:{"title":_vm.translationPrefix ? _vm.$t(_vm.translationPrefix + '.' + item) : item},on:{"click":function($event){return _vm.select(item)}}},[_vm._v("\n            "+_vm._s(_vm.translationPrefix ? _vm.$t(_vm.translationPrefix + '.' + item) : item)+"\n            "),(_vm.itemsCounts !== undefined)?_c('span',[_vm._v("\n                ("+_vm._s(_vm.itemsCounts[index])+")\n            ")]):_vm._e()])})],2):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/DropdownMenu/DropdownMenu.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  DropdownMenu,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var DropdownMenu_DropdownMenu = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = __webpack_require__(441);

var _auth2 = _interopRequireDefault(_auth);

var _http = __webpack_require__(442);

var _http2 = _interopRequireDefault(_http);

var _business = __webpack_require__(443);

var _business2 = _interopRequireDefault(_business);

var _lang = __webpack_require__(444);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    auth: _auth2.default,
    http: _http2.default,
    business: _business2.default,
    lang: _lang2.default
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Fake/Fake.vue


/* harmony default export */ var Fake = ({
    props: {
        headerRows: {
            type: Number,
            default: 0
        },
        headerCells: {
            type: Number,
            default: 1
        },
        bodyRows: {
            type: Number,
            default: 1
        },
        bodyCells: {
            type: Number,
            default: 1
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57362af4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fake/Fake.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fake"},[_c('div',{staticClass:"fake__content"},[_vm._l((_vm.headerRows),function(index){return _c('div',{key:'fake-header-row__' + index,staticClass:"fake__header-row"},_vm._l((_vm.headerCells),function(index){return _c('div',{key:'fake-header-cell__' + index,staticClass:"fake__header-cell",style:({width: (100 / _vm.headerCells) + '%'})})}),0)}),_vm._v(" "),_vm._l((_vm.bodyRows),function(index){return _c('div',{key:'fake-body-row__' + index,staticClass:"fake__body-row"},_vm._l((_vm.bodyCells),function(index){return _c('div',{key:'fake-body-cells__' + index,staticClass:"fake__body-cell",style:({width: (100 / _vm.bodyCells) + '%'})})}),0)})],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/Fake/Fake.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  Fake,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var Fake_Fake = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(173);
var isBuffer = __webpack_require__(425);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateStringMatch = exports.validatePassword = exports.validEmail = exports.required = exports.validateUpdateReleaseDate = exports.validateUpdateReleaseDays = exports.validateUpdateUnits = exports.validateMinNumber = exports.validateDateAfter = exports.validateWithinYear = exports.beforeOrEqualTo = exports.beforeOrEqualFrom = exports.validateValidDate = exports.isDeductionOrWorseRelease = exports.allocationWorseTypeChanged = exports.validateUpdateAllocationPossible = exports.validateAddAllocationInputs = exports.validateAddAllocationPeriod = undefined;

var _lodashEs = __webpack_require__(14);

var _moment = __webpack_require__(5);

var _moment2 = _interopRequireDefault(_moment);

var _DateToolService = __webpack_require__(48);

var DateTool = _interopRequireWildcard(_DateToolService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Validate the new allocations to see if any of them overlaps already existing allocation. In the case of overlaps
 * then return a list of periods that is being overlapped.
 *
 * @param newPeriods
 * @param oldPeriods
 * @returns {*}
 */
var validateAddAllocationPeriod = exports.validateAddAllocationPeriod = function validateAddAllocationPeriod(newPeriods, oldPeriods) {
    var newDates = [];
    var oldDates = [];

    // Generate calendars for the old and the new periods.
    (0, _lodashEs.filter)(newPeriods, function (period) {
        newDates = [].concat(_toConsumableArray(newDates), _toConsumableArray(DateTool.generateValidatorCalendar(period.from, period.to)));
    });
    (0, _lodashEs.filter)(oldPeriods, function (period) {
        // Ensure that the calendar is not validated by checking for the form and to period.
        if (period.from && period.to) {
            oldDates = [].concat(_toConsumableArray(oldDates), _toConsumableArray(DateTool.generateValidatorCalendar(period.from, period.to)));
        }
    });
    // Remove duplicates, which is only needed on the new periods as the old periods are already unique
    newDates = (0, _lodashEs.uniqBy)(newDates);
    return DateTool.checkForOverlap(newDates, oldDates);
};

/**
 * Validates the add allocation inputs.
 *
 * @param allocations
 */
var validateAddAllocationInputs = exports.validateAddAllocationInputs = function validateAddAllocationInputs(allocations) {
    var validator = {
        valid: true,
        messages: []
    };
    allocations.forEach(function (allocation) {
        if (!validateDates(allocation, validator) || !validateAllocationType(allocation, validator) || !validateReleaseDate(allocation, validator)) {
            validator.valid = false;
            validator.message = "Something went wrong";
        }
    });

    return validator;
};

/**
 * Validate if the update has deduction of units or a worse release rule.
 *
 * @param original
 * @param allocation
 * @param trusted
 * @returns {boolean|*}
 */
var validateUpdateAllocationPossible = exports.validateUpdateAllocationPossible = function validateUpdateAllocationPossible(original, allocation, trusted) {
    return trusted || !isDeductionOrWorseRelease(original, allocation) && !allocationWorseTypeChanged(original, allocation);
};

/**
 * Check if the allocation type has changed.
 *
 * @param original
 * @param allocation
 * @returns {boolean}
 */
var allocationWorseTypeChanged = exports.allocationWorseTypeChanged = function allocationWorseTypeChanged(original, allocation) {
    // Everyone can change type to allotment or free sale as its better than request or blocked
    if (allocation.type === 'FREESALE' || allocation.type === 'ALLOTMENT') {
        return false;
    }
    return original.type !== allocation.type;
};

/**
 * Check if is a deduction of units or worsening release date/days.
 *
 * @param original
 * @param allocation
 * @returns {boolean|*}
 */
var isDeductionOrWorseRelease = exports.isDeductionOrWorseRelease = function isDeductionOrWorseRelease(original, allocation) {
    // If free sale then dont evaluate unit difference
    var deducting = allocation.type === 'FREESALE' ? false : allocation.units < original.units;
    var worseRelease = void 0;
    if (original.releaseMethod === 'days') {
        worseRelease = allocation.releaseDays > original.releaseDays;
    } else {
        worseRelease = (0, _DateToolService.convertStringDateToDate)(original.releaseDate).diff((0, _DateToolService.convertStringDateToDate)(allocation.releaseDate)) > 0;
    }
    return deducting || worseRelease;
};

/*
 * ============================
 * VUELIDATOR CUSTOM VALIDATORS
 * ============================
 */

/**
 * Validate that the date is correct type
 *
 * @returns {boolean}
 * @param date
 */
var validateValidDate = exports.validateValidDate = function validateValidDate(date) {
    // Only validate if the whole date is stated
    if (date && date.length === 10) {
        return (0, _moment2.default)(date, 'DD/MM/YYYY')._isValid;
    }
    return false;
};

/**
 * Validate that the release date is before or equal the from date for period.
 *
 * @param date
 * @param allocation
 * @returns {boolean}
 */
var beforeOrEqualFrom = exports.beforeOrEqualFrom = function beforeOrEqualFrom(date, allocation) {
    var fromDate = (0, _moment2.default)(allocation.from, 'DD/MM/YYYY');
    var dateDate = (0, _moment2.default)(date, 'DD/MM/YYYY');
    return fromDate.diff(dateDate) >= 0;
};

/**
 * Validate that the release date is before or equal the from date for period.
 *
 * @param date
 * @param allocation
 * @returns {boolean}
 */
var beforeOrEqualTo = exports.beforeOrEqualTo = function beforeOrEqualTo(date, allocation) {
    var toDate = (0, _moment2.default)(allocation.to, 'DD/MM/YYYY');
    var dateDate = (0, _moment2.default)(date, 'DD/MM/YYYY');
    return toDate.diff(dateDate) > 0;
};

/**
 * Validates that the date is within the year chosen.
 *
 * @param date
 * @param chosenYear
 */
var validateWithinYear = exports.validateWithinYear = function validateWithinYear(date, chosenYear) {
    // Only validate if the whole date is stated
    if (date && date.length === 10) {
        var startOfYear = (0, _moment2.default)('01/01/' + chosenYear, 'DD/MM/YYYY');
        var endOfYear = (0, _moment2.default)('31/12/' + chosenYear, 'DD/MM/YYYY');
        var momentDate = (0, _moment2.default)(date, 'DD/MM/YYYY');
        return momentDate.diff(startOfYear) >= 0 && momentDate.diff(endOfYear) <= 0;
    }
    return false;
};

/**
 * Validate that the to date is after or equal the from date.
 *
 * @param date
 * @param row
 * @returns {boolean}
 */
var validateDateAfter = exports.validateDateAfter = function validateDateAfter(date, row) {
    // Only validate if the whole date is stated
    if (date && row && date.length === 10) {
        var from = (0, _moment2.default)(row.from, 'DD/MM/YYYY');
        return (0, _moment2.default)(date, 'DD/MM/YYYY').diff(from) >= 0;
    }
    return false;
};

/**
 * Validates if the to and from dates are set on add allocation.
 *
 * @param allocation
 * @param validator
 * @returns mixed
 */
var validateDates = function validateDates(allocation, validator) {
    if (!allocation.from || !allocation.to) {
        validator.valid = false;
        validator.messages.push("To and from date has to be set");
    } else if (!(0, _moment2.default)(allocation.from, 'DD/MM/YYYY')._isValid || !(0, _moment2.default)(allocation.to, 'DD/MM/YYYY')._isValid) {
        validator.valid = false;
        validator.messages.push("To or from date is invalid, should be formatted DD/MM/YYYY");
    } else if (allocation.from.length !== 10 || allocation.to.length !== 10) {
        validator.valid = false;
        validator.messages.push("To and from date has to be formatted DD/MM/YYYY");
    } else if ((0, _moment2.default)(allocation.from).diff((0, _moment2.default)(allocation.to)) > 0) {
        validator.valid = false;
        validator.messages.push("To date has to be after the from date");
    }
    return validator;
};

/**
 * Validate release date.
 *
 * @param allocation
 * @param validator
 * @returns {*}
 */
var validateReleaseDate = function validateReleaseDate(allocation, validator) {
    if (!allocation.releaseDays && allocation.releaseDate) {
        if (allocation.releaseDate.length !== 10) {
            validator.valid = false;
            validator.messages.push('Release date has to be valid in the format DD/MM/YYYY');
        }
        if ((0, _moment2.default)(allocation.releaseDate).diff((0, _moment2.default)(allocation.to)) >= 0) {
            validator.valid = false;
            validator.messages.push('Release date has to be before or equal to the from date');
        }
    } else if (allocation.releaseDays && !allocation.releaseDate) {
        if (allocation.releaseDays <= 0) {
            validator.valid = false;
            validator.messages.push('Release days has to be 1 or more days');
        }
    }
    return validator;
};

/**
 * Validates allotment type rules.
 *
 * @param allocation
 * @param validator
 * @returns mixed
 */
var validateAllocationType = function validateAllocationType(allocation, validator) {
    if (!allocation.type || allocation.type.length === 0) {
        validator.valid = false;
        validator.messages.push("Allocation type has to be set");
    } else if (allocation.type === 'ALLOTMENT') {
        if (!allocation.units || parseInt(allocation.units) <= 0 || parseInt(allocation.units) > 10) {
            validator.valid = false;
            validator.messages.push("Units has to be set to a value between 1 and 10");
        }
        if (allocation.releaseType.length === 0 || !allocation.releaseDate && !allocation.releaseDays) {
            validator.valid = false;
            validator.messages.push("Release days/date has to be set");
        }
    } else if (allocation.type === 'BLOCKED') {
        if (allocation.releaseDate || allocation.releaseType || allocation.releaseDays) {
            validator.valid = false;
            validator.messages.push("Release type, release date/days has not to be set");
        }
    }
    return validator;
};

/**
 * Validate number input to be positive number above 0.
 *
 * @param stringNumber
 * @returns {boolean}
 */
var validateMinNumber = exports.validateMinNumber = function validateMinNumber(stringNumber) {
    return parseInt(stringNumber) > 0;
};

/**
 * Units can only be increased in edit
 * TODO implement edit function as a request, so further editing is allowed.
 *
 * @param units
 * @param allocation
 * @returns {{valid: boolean, message: string}}
 */
var validateUpdateUnits = exports.validateUpdateUnits = function validateUpdateUnits(units, allocation) {
    if (allocation.type === 'ALLOTMENT') {
        var message = "";
        var valid = units > 0 && units <= 10;

        if (!valid) {
            message = "units.set";
        }

        return { valid: valid, message: message };
    }
    return { valid: true, message: '' };
};

/**
 * Validate the update release days rules.
 *
 * @param days
 * @returns {{valid: boolean, message: string}}
 */
var validateUpdateReleaseDays = exports.validateUpdateReleaseDays = function validateUpdateReleaseDays(days) {
    var message = "";
    var set = parseInt(days) > 0;

    if (!set) {
        message = "days.set";
    }
    return { valid: set, message: message };
};

/**
 * Validate the update release date rules.
 *
 * @param date
 * @param original
 * @returns {{valid: boolean, message: string}}
 */
var validateUpdateReleaseDate = exports.validateUpdateReleaseDate = function validateUpdateReleaseDate(date, original) {
    var message = "";
    var valid = date !== '';
    var toDate = (0, _DateToolService.convertStringDateToDate)(original.from);
    var newDate = (0, _DateToolService.convertStringDateToDate)(date);
    var before = toDate.diff(newDate) > 0;
    if (!valid) {
        message = "date.set";
    } else if (!before) {
        message = "date.before";
    }
    return { valid: valid && before, message: message };
};

/**
 * Validates if the value is present and not undefined.
 *
 * @param value
 * @param field
 * @returns {{valid: boolean, message: string}}
 */
var required = exports.required = function required(value, field) {
    var message = "";
    var valid = value !== undefined && value !== "";
    if (!valid) {
        message = field + ' is required';
    }
    return { valid: valid, message: message };
};

/**
 * Checks if the email is correctly formatted.
 *
 * @param value
 * @returns {{valid: boolean, message: string}}
 */
var validEmail = exports.validEmail = function validEmail(value) {
    var message = "";

    var valid = value !== undefined && value.indexOf('@') !== -1 && value.split('@')[1].indexOf('.') !== -1 && value.split('@')[1].split('.')[1].length >= 2;

    if (!valid) {
        message = 'Not valid email';
    }
    return { valid: valid, message: message };
};

/**
 * Validates that the password matches the password rules and that the retypedPassword equals it.
 *
 * @returns {{valid: boolean, message: string}}
 * @param password
 */
var validatePassword = exports.validatePassword = function validatePassword(password) {
    var message = "";
    var _regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

    var valid = _regexp.test(password);

    if (!valid) {
        message = 'password';
    }
    return { valid: valid, message: message };
};

/**
 * Validate if to strings match.
 *
 * @param stringA
 * @param stringB
 * @returns {{valid: boolean, message: string}}
 */
var validateStringMatch = exports.validateStringMatch = function validateStringMatch(stringA, stringB) {
    var message = "";

    var valid = stringA === stringB;

    if (!valid) {
        message = "mismatch";
    }
    return { valid: valid, message: message };
};

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InfoWidget/InfoWidget.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var InfoWidget = ({
    props: {
        tips: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            paused: false,
            overflowed: false,
            expanded: false,
            interval: undefined,
            wait: 15000
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        },
        open: function open(state) {
            return state.info.open;
        },
        page: function page(state) {
            return state.info.page;
        }
    })),
    created: function created() {
        this.pageReset();
        if (this.open) {
            this.interval = setInterval(this.incrementPage, this.wait);
        }
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        toggleInfoWidget: 'info/toggleInfoWidget',
        pageIncrement: 'info/pageIncrement',
        pageSelect: 'info/pageSelect',
        pageReset: 'info/pageReset'
    }), {
        toggle: function toggle() {
            if (!this.interval) {
                this.interval = setInterval(this.incrementPage, this.wait);
            }
            if (this.open) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
            this.toggleInfoWidget();
            this.checkForOverflow();
        },
        setPage: function setPage(index) {
            this.pageSelect(index);
            this.checkForOverflow();
        },
        checkForOverflow: function checkForOverflow() {
            var _this = this;

            this.expanded = false;
            setTimeout(function () {
                var element = document.getElementById('info-widget__info-body');
                _this.overflowed = element.scrollHeight > element.clientHeight;
            }, 1);
        },
        incrementPage: function incrementPage() {
            var _this2 = this;

            if (this.open && !this.paused && this.tips.length > 1) {
                this.pageIncrement(this.tips.length).then(function () {
                    _this2.checkForOverflow();
                });
            }
        },
        clean: function clean() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18aeb82e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoWidget/InfoWidget.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-widget"},[_c('div',{staticClass:"info-widget__toggle",on:{"click":_vm.toggle}},[_c('i',{staticClass:"fa fa-question-circle"})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","type":"in-out"}},[(_vm.open)?_c('div',{staticClass:"info-widget__container",on:{"mouseenter":function($event){_vm.paused = true},"mouseleave":function($event){_vm.paused = false}}},[_c('div',{staticClass:"info-widget__content"},[_c('div',{staticClass:"info-widget__welcome"},[_vm._v("\n                    "+_vm._s(_vm.$t('tips.hi'))+" "+_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName)+"\n                ")]),_vm._v(" "),_c('div',{class:['info-widget__tips', (_vm.expanded) ? 'info-widget__tips--expanded' : null]},[(_vm.tips.length > 0)?_c('div',{staticClass:"info-widget__info"},[_c('div',{staticClass:"info-widget__info-title"},[_vm._v("\n                            "+_vm._s(_vm.$t( _vm.tips[_vm.page].title ))+"\n                        ")]),_vm._v(" "),_c('div',{class:['info-widget__info-body', (_vm.expanded) ? 'info-widget__info-body--expanded' : null],attrs:{"id":"info-widget__info-body"}},[_vm._v("\n                            "+_vm._s(_vm.$t( _vm.tips[_vm.page].body ))+"\n                        ")]),_vm._v(" "),(_vm.overflowed && !_vm.expanded)?_c('div',{staticClass:"info-widget__info-more",on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._v("\n                            ... "+_vm._s(_vm.$t('tips.more'))+"\n                        ")]):_vm._e(),_vm._v(" "),(_vm.overflowed && _vm.expanded)?_c('div',{staticClass:"info-widget__info-less",on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._v("\n                            ... "+_vm._s(_vm.$t('tips.less'))+"\n                        ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","type":"in-out"}},[(!_vm.expanded)?_c('div',{staticClass:"info-widget__tips-controls"},_vm._l((_vm.tips),function(tip,index){return _c('span',{key:index,class:['info-widget__tips-page', index === _vm.page ? 'info-widget__tips-page--selected' : null],attrs:{"value":index},on:{"click":function($event){return _vm.setPage(index)}}})}),0):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","type":"in-out"}},[(!_vm.expanded)?_c('div',{staticClass:"info-widget__contact"},[_c('div',{staticClass:"info-widget__contact-header"},[_vm._v("\n                            "+_vm._s(_vm.$t('tips.help'))+"\n                        ")]),_vm._v(" "),(!_vm.user.contractManager)?_c('div',{staticClass:"info-widget__contact-person"},[_c('div',{staticClass:"info-widget__contact-name"},[_vm._v(_vm._s(_vm.supplier.contactName))]),_vm._v(" "),_c('a',{staticClass:"info-widget__contact-email",attrs:{"href":'mailto:' + _vm.supplier.contactEmail}},[_vm._v(_vm._s(_vm.supplier.contactEmail))])]):_vm._e(),_vm._v(" "),(_vm.user.contractManager)?_c('div',{staticClass:"info-widget__contact-person"},[_c('div',{staticClass:"info-widget__contact-name"},[_vm._v(_vm._s(_vm.$t('tips.camping')))])]):_vm._e()]):_vm._e()])],1)]):_vm._e()])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/InfoWidget/InfoWidget.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  InfoWidget,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var InfoWidget_InfoWidget = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f2db2ac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading/Loading.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre-loader"},[_c('div',{staticClass:"pre-loader__loader"})])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/Loading/Loading.vue
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var Loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _storage = localStorage;
var _identifier = _config2.default.auth.AUTH_TOKEN_STORAGE_IDENTIFIER;

/**
 * Class TokenStorageService
 */
exports.default = {

  /**
   * Stores the authorization token
   *
   * @param {string} token
   * @returns { void }
   */
  set: function set(token) {
    _storage.setItem(_identifier, token);
  },


  /**
   * Retrieves the authorization token from storage
   *
   * @returns {string | null}
   */
  get: function get() {
    return _storage.getItem(_identifier);
  },


  /**
   * Removes the authorization token from storage
   *
   * @returns { void }
   */
  del: function del() {
    return _storage.removeItem(_identifier);
  }
};

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HttpLibrary = __webpack_require__(423);

var _HttpLibrary2 = _interopRequireDefault(_HttpLibrary);

var _SecureHttpLibrary = __webpack_require__(445);

var _SecureHttpLibrary2 = _interopRequireDefault(_SecureHttpLibrary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service for making requests to the Gateway API
 */
exports.default = {

    /**
     * Download generated file.
     *
     * @param file
     * @returns {AxiosPromise<any>}
     */
    downloadFile: function downloadFile(file) {
        return new _HttpLibrary2.default().get(file);
    },


    /**
     * Attempts to authenticate
     *
     * @param email
     * @param password
     * @returns {AxiosPromise<any>|*}
     */
    authenticate: function authenticate(email, password) {
        return new _HttpLibrary2.default().post('/auth/login', { email: email, password: password });
    },


    /**
     * Request a password reset.
     *
     * @param email
     * @returns {AxiosPromise|*}
     */
    forgotPassword: function forgotPassword(email) {
        return new _HttpLibrary2.default().post('/user/password/reset', { email: email });
    },


    /**
     * Reset password from request.
     *
     * @param password
     * @param token
     * @returns {AxiosPromise|*}
     */
    resetPassword: function resetPassword(password, token) {
        return new _HttpLibrary2.default().post('/user/password/reset/' + token, { password: password });
    },


    /**
     * Attempts to activate user
     *
     * @param password
     * @param token
     * @returns {AxiosPromise|*}
     */
    activate: function activate(password, token) {
        return new _HttpLibrary2.default().post('/user/activate', { password: password, token: token });
    },


    /**
     * Get the suppliers bookings for a given period by either arrival or booking date.
     *
     * @param bookingFrom
     * @param bookingTo
     * @param arrivalFrom
     * @param arrivalTo
     * @param supplierId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getBookings: function getBookings(bookingFrom, bookingTo, arrivalFrom, arrivalTo, supplierId, token) {
        return new _SecureHttpLibrary2.default().get('/booking', token, {
            'booking-from': bookingFrom,
            'booking-to': bookingTo,
            'arrival-from': arrivalFrom,
            'arrival-to': arrivalTo,
            'supplierId': supplierId
        });
    },


    /**
     * Retrieves revenue data for a given period
     *
     * @param bookingFrom
     * @param bookingTo
     * @param arrivalFrom
     * @param arrivalTo
     * @param supplierId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getRevenue: function getRevenue(bookingFrom, bookingTo, arrivalFrom, arrivalTo, supplierId, token) {
        return new _SecureHttpLibrary2.default().get('/statistics/revenue', token, {
            'booking-from': bookingFrom,
            'booking-to': bookingTo,
            'arrival-from': arrivalFrom,
            'arrival-to': arrivalTo,
            'supplier-id': supplierId
        });
    },


    /**
     * Retrieves revenue data for a given period
     *
     * @param from
     * @param to
     * @param dateType
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getInventory: function getInventory(from, to, dateType, token) {
        return new _SecureHttpLibrary2.default().get('/statistics/inventory', token, {
            from: from,
            to: to,
            'date-type': dateType
        });
    },


    /**
     * Retrieves a list of accommodations for a supplier
     *
     * @param supplierId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getAccommodationList: function getAccommodationList(supplierId, token) {
        return new _SecureHttpLibrary2.default().get('/accommodation/accommodation-sites/' + supplierId, token);
    },


    /**
     * Retrieve allocation filter data consisting of array of sites with array of accommodations.
     *
     * @param accommodationSiteId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getAllocationFilterData: function getAllocationFilterData(accommodationSiteId, token) {
        return new _SecureHttpLibrary2.default().get('accommodation/sites/' + accommodationSiteId, token);
    },


    /**
     * Retrieves supplier sites.
     *
     * @param supplierId
     * @param token
     * @returns {AxiosPromise.<any>}
     */
    getAllocationSupplierSites: function getAllocationSupplierSites(supplierId, token) {
        return new _SecureHttpLibrary2.default().get('accommodation/get-supplier-sites/' + supplierId, token);
    },


    /**
     * Retrieves the list of allocations for a list of accommodations belonging to a specific site
     *
     * @param accommodationSiteIds
     * @param from
     * @param to
     * @param token
     * @returns {AxiosPromise|*}
     */
    getAllocationList: function getAllocationList(accommodationSiteIds, from, to, token) {
        return new _SecureHttpLibrary2.default().post('allocation', {
            accommodationSiteIds: accommodationSiteIds,
            from: from,
            to: to
        }, token);
    },


    /**
     * Retrieves the list of allocations for a list of accommodations belonging to a specific site merged and excluding
     * last updated by.
     *
     * @param accommodationSiteIds
     * @param from
     * @param to
     * @param token
     * @returns {AxiosPromise|*}
     */
    getAllocationListMerged: function getAllocationListMerged(accommodationSiteIds, from, to, token) {
        return new _SecureHttpLibrary2.default().post('allocation/merged', {
            accommodationSiteIds: accommodationSiteIds,
            from: from,
            to: to
        }, token);
    },


    /**
     * Retrieves a list of sites with their accommdoations for the allocation filters
     *
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getAllocationFilters: function getAllocationFilters(token) {
        return new _SecureHttpLibrary2.default().get('allocation/filter', token);
    },


    /**
     * Add the allocations for the accommodations selected for a specific site.
     *
     * @param accommodationSiteId
     * @param allocation
     * @param token
     * @returns {AxiosPromise|*}
     */
    addAllocations: function addAllocations(accommodationSiteId, allocation, token) {
        return new _SecureHttpLibrary2.default().post('allocation/add/' + accommodationSiteId, allocation, token);
    },


    /**
     * Update allocation.
     *
     * @param accommodationSiteId
     * @param allocation
     * @param token
     * @returns {AxiosPromise|*}
     */
    updateAllocation: function updateAllocation(accommodationSiteId, allocation, token) {
        return new _SecureHttpLibrary2.default().post('allocation/edit/' + accommodationSiteId, { allocation: allocation }, token);
    },


    /**
     * Request update allocation.
     *
     * @param accommodationSiteId
     * @param allocation
     * @param token
     * @returns {AxiosPromise|*}
     */
    requestUpdateAllocation: function requestUpdateAllocation(accommodationSiteId, allocation, token) {
        return new _SecureHttpLibrary2.default().post('allocation/edit/request/' + accommodationSiteId, { allocation: allocation }, token);
    },


    /**
     * Block allocation.
     *
     * @param accommodationSiteId
     * @param period
     * @param token
     * @returns {AxiosPromise|*}
     */
    blockAllocation: function blockAllocation(accommodationSiteId, period, token) {
        return new _SecureHttpLibrary2.default().post('allocation/block/' + accommodationSiteId, period, token);
    },


    /**
     * Request block allocation.
     *
     * @param accommodationSiteId
     * @param period
     * @param token
     * @returns {AxiosPromise|*}
     */
    requestBlockAllocation: function requestBlockAllocation(accommodationSiteId, period, token) {
        return new _SecureHttpLibrary2.default().post('allocation/block/request/' + accommodationSiteId, period, token);
    },


    /**
     * Get allocation calendar.
     *
     * @param accommodationSiteId
     * @param from
     * @param to
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getAllocationCalendar: function getAllocationCalendar(accommodationSiteId, from, to, token) {
        return new _SecureHttpLibrary2.default().get('allocation/calendar/' + accommodationSiteId + '/' + from + '/' + to, token);
    },


    /**
     * Get sub users for a supplier.
     *
     * @param supplierId
     * @param token
     * @returns {AxiosPromise.<any>}
     */
    getUsers: function getUsers(supplierId, token) {
        return new _SecureHttpLibrary2.default().get('admin/users/all/' + supplierId, token);
    },


    /**
     * Get a User by id.
     *
     * @param supplierId
     * @param userId
     * @param token
     * @returns {AxiosPromise.<any>}
     */
    getUser: function getUser(supplierId, userId, token) {
        return new _SecureHttpLibrary2.default().get('admin/users/' + userId + '/' + supplierId, token);
    },


    /**
     * Create a new User.
     *
     * @param supplierId
     * @param token
     * @param payload
     * @returns {AxiosPromise|*}
     */
    createUser: function createUser(supplierId, payload, token) {
        return new _SecureHttpLibrary2.default().post('admin/users/create/' + supplierId, payload, token);
    },


    /**
     * Edit information about a User.
     *
     * @param supplierId
     * @param user
     * @param token
     * @returns {AxiosPromise.<any>}
     */
    editUser: function editUser(supplierId, user, token) {
        return new _SecureHttpLibrary2.default().put('admin/users/update/' + user.id + '/' + supplierId, user, token);
    },


    /**
     * Delete a User.
     *
     * @param userId
     * @param token
     * @returns {AxiosPromise|*}
     */
    deleteUser: function deleteUser(userId, token) {
        return new _SecureHttpLibrary2.default().del('admin/users/delete/' + userId, token);
    },


    /**
     * Block a User.
     *
     * @param userId
     * @param token
     * @returns {AxiosPromise.<any>}
     */
    blockUser: function blockUser(userId, token) {
        return new _SecureHttpLibrary2.default().get('admin/users/block/' + userId, token);
    },


    /**
     * unblock a User.
     *
     * @param userId
     * @param token
     * @returns {AxiosPromise.<any>}
     */
    unblockUser: function unblockUser(userId, token) {
        return new _SecureHttpLibrary2.default().get('admin/users/unblock/' + userId, token);
    },


    /**
     * Get list of roles for the supplier.
     *
     * @param supplierId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getRoles: function getRoles(supplierId, token) {
        return new _SecureHttpLibrary2.default().get('admin/roles/' + supplierId, token);
    },


    /**
     * Get list of supported languages.
     *
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getLanguages: function getLanguages(token) {
        return new _SecureHttpLibrary2.default().get('languages', token);
    },


    /**
     * Get list of requested changes.
     *
     * @param token
     * @param accommodationSiteId
     * @param from
     * @param to
     * @returns {AxiosPromise<any>}
     */
    getRequestList: function getRequestList(token, accommodationSiteId, from, to) {
        return new _SecureHttpLibrary2.default().get('allocation/requested/' + accommodationSiteId + '/' + from + '/' + to, token);
    },


    /**
     * Request accept.
     *
     * @param token
     * @param payload
     * @returns {AxiosPromise<any>}
     */
    requestAccept: function requestAccept(token, payload) {
        return new _SecureHttpLibrary2.default().post('allocation/request/approve/' + payload, {}, token);
    },


    /**
     * Accept the request edit allocation with modifications.
     *
     * @param token
     * @param payload
     * @returns {*}
     */
    requestAcceptModfied: function requestAcceptModfied(token, payload) {
        return new _SecureHttpLibrary2.default().post('allocation/request/modify/' + payload.id, {
            allocation: payload.allocationObject
        }, token);
    },


    /**
     * Request accept.
     *
     * @param token
     * @param payload
     * @returns {AxiosPromise<any>}
     */
    requestDeny: function requestDeny(token, payload) {
        return new _SecureHttpLibrary2.default().post('allocation/request/decline/' + payload, {}, token);
    },


    /**
     * Cancel a request.
     *
     * @param token
     * @param payload
     * @returns {AxiosPromise<any>}
     */
    requestCancel: function requestCancel(token, payload) {
        return new _SecureHttpLibrary2.default().get('allocation/request/cancel/' + payload, token);
    },


    /**
     * Get the notification levels on user id.
     *
     * @param token
     * @param userId
     * @param supplierId
     * @returns {AxiosPromise<any>}
     */
    getNotificationsLevel: function getNotificationsLevel(token, userId, supplierId) {
        return new _SecureHttpLibrary2.default().get('admin/notifications/' + userId + '/' + supplierId, token);
    },


    /**
     * Update the notification level for a user.
     *
     * @param supplierId
     * @param token
     * @param payload
     * @returns {AxiosPromise|*}
     */
    updateNotificationsLevel: function updateNotificationsLevel(supplierId, token, payload) {
        if (payload.id !== undefined) {
            return new _SecureHttpLibrary2.default().post('admin/notifications/edit/' + payload.id + '/' + supplierId, payload.notificationObject, token);
        } else {
            return new _SecureHttpLibrary2.default().post('admin/notifications/edit/' + supplierId, payload.notificationObject, token);
        }
    },


    /**
     * Toggle the users notification status.
     *
     * @param token
     * @param userId
     * @param supplierId
     * @returns {AxiosPromise<any>}
     */
    toggleNotifications: function toggleNotifications(token, userId, supplierId) {
        return new _SecureHttpLibrary2.default().get('admin/notifications/toggle/' + userId + '/' + supplierId, token);
    },


    /**
     * Dismiss the specific notification.
     *
     * @param token
     * @param notificationId
     * @returns {AxiosPromise<any>}
     */
    dismissNotification: function dismissNotification(token, notificationId) {
        return new _SecureHttpLibrary2.default().get('dashboard/allotment/dismiss/' + notificationId, token);
    },


    /**
     * Retrieve account activity for last 6 months.
     *
     * @param supplierId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getAccountActivity: function getAccountActivity(supplierId, token) {
        return new _SecureHttpLibrary2.default().get('account/activity/' + supplierId, token);
    },


    /**
     * Retrieve account notifications settings.
     *
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getAccountNotifications: function getAccountNotifications(token) {
        return new _SecureHttpLibrary2.default().get('account/notifications', token);
    },


    /**
     * Get user account.
     *
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getAccount: function getAccount(token) {
        return new _SecureHttpLibrary2.default().get('account/get', token);
    },


    /**
     * Update user.
     *
     * @param user
     * @param token
     * @returns {AxiosPromise|*}
     */
    updateUser: function updateUser(user, token) {
        return new _SecureHttpLibrary2.default().post('account/update/account', user, token);
    },


    /**
     * Update account password.
     *
     * @param oldPassword
     * @param newPassword
     * @param token
     * @returns {AxiosPromise|*}
     */
    updatePassword: function updatePassword(oldPassword, newPassword, token) {
        return new _SecureHttpLibrary2.default().post('account/update/password', {
            password: newPassword,
            oldPassword: oldPassword
        }, token);
    },


    /**
     * Get availability for a specific supplier.
     *
     * @param token
     * @param supplierId
     * @returns {AxiosPromise<any>}
     */
    getAvailabilityBySupplierId: function getAvailabilityBySupplierId(token, supplierId) {
        return new _SecureHttpLibrary2.default().get('dashboard/allocation/' + supplierId, token);
    },


    /**
     * Get notifications for a specific supplier.
     *
     * @param token
     * @param supplierId
     * @returns {AxiosPromise<any>}
     */
    getAccommodationNotificationsBySupplierId: function getAccommodationNotificationsBySupplierId(token, supplierId) {
        return new _SecureHttpLibrary2.default().get('dashboard/allotment/' + supplierId, token);
    },


    /**
     * Send introduction sales confirmation.
     *
     * @param confirmationToken
     * @param ipAddress
     * @param browser
     * @returns {AxiosPromise<any>}
     */
    sendConfirmation: function sendConfirmation(confirmationToken, ipAddress, browser) {
        return new _SecureHttpLibrary2.default().post('introduction', {
            confirmationToken: confirmationToken,
            ipAddress: ipAddress,
            browser: browser
        });
    },


    /**
     * Get all years where contracts exists.
     *
     * @returns {AxiosPromise.<any>}
     */
    getContractYears: function getContractYears(token) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/years', token);
    },


    /**
     * Get contract overview.
     *
     * @param token
     * @param year
     * @returns {Promise<any>}
     */
    getContractManagementssOverview: function getContractManagementssOverview(token, year) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/all/' + year, token);
    },


    /**
     * Get contract by contract id.
     *
     * @param token
     * @param contractId
     */
    getContractManagementByContractId: function getContractManagementByContractId(token, contractId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/' + contractId, token);
    },


    /**
     * Save the contract.
     *
     * @param token
     * @param form
     * @param contractId
     * @returns {AxiosPromise|*}
     */
    saveContractManagementByContractId: function saveContractManagementByContractId(token, form, contractId) {
        return new _SecureHttpLibrary2.default().postCustomHeaders('contractmanagement/update/' + contractId, form, token, {
            ContentType: 'multipart/form-data'
        });
    },


    /**
     * Download file from s3.
     *
     * @param token
     * @param file
     * @returns {AxiosPromise<any>}
     */
    contractManagementFormFileDownload: function contractManagementFormFileDownload(token, file) {
        return new _SecureHttpLibrary2.default().download('get-file/contract/' + file, token);
    },


    /**
     * Remove file from s3.
     *
     * @param token
     * @param file
     * @param extension
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    removeFileFromS3: function removeFileFromS3(token, file, extension, contractId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/delete/' + contractId + '/file/' + file + '/' + extension, token);
    },


    /**
     * Send contract completion email.
     *
     * @param token
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    contractManagementSendEmailBackOffice: function contractManagementSendEmailBackOffice(token, contractId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/complete/' + contractId, token);
    },


    /**
     * Send contract readu for contract management review.
     *
     * @param token
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    contractManagementSendEmailReview: function contractManagementSendEmailReview(token, contractId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/readyForReview/' + contractId, token);
    },


    /**
     * Send contract readu for contract management review.
     *
     * @param token
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    contractManagementSendEmailSupplier: function contractManagementSendEmailSupplier(token, contractId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/readyForSupplier/' + contractId, token);
    },


    /**
     * Get the supplier data for the contract view.
     *
     * @param token
     * @param supplierId
     * @returns {Promise<any>}
     */
    getContractManagementSupplierData: function getContractManagementSupplierData(token, supplierId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/accommodations/sites/' + supplierId, token);
    },


    /**
     * Get contract data by supplier id.
     *
     * @param token
     * @param supplierId
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    getContractBySupplierId: function getContractBySupplierId(token, supplierId, contractId) {
        return new _SecureHttpLibrary2.default().get('contract/full/' + supplierId + '/' + contractId, token);
    },


    /**
     * Get contract accepted parts.
     *
     * @param token
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    getContractAcceptedParts: function getContractAcceptedParts(token, contractId) {
        return new _SecureHttpLibrary2.default().get('contract/accepted/' + contractId, token);
    },


    /**
     * Accept contract part.
     *
     * @param token
     * @param contractId
     * @param payload
     * @returns {AxiosPromise|*}
     */
    acceptContractPart: function acceptContractPart(token, contractId, payload) {
        return new _SecureHttpLibrary2.default().post('contract/accepted/' + contractId, payload, token);
    },


    /**
     * Get contract notes.
     *
     * @param token
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    getContractNotes: function getContractNotes(token, contractId) {
        return new _SecureHttpLibrary2.default().get('contract/notes/all/' + contractId, token);
    },


    /**
     * Create contract note.
     *
     * @param token
     * @param contractId
     * @param note
     * @returns {AxiosPromise|*}
     */
    createContractNote: function createContractNote(token, contractId, note) {
        return new _SecureHttpLibrary2.default().post('contract/notes/create/' + contractId, note, token);
    },


    /**
     * Get contract history by supplier id.
     *
     * @param token
     * @param supplierId
     * @returns {AxiosPromise<any>}
     */
    getContractHistoryBySupplierId: function getContractHistoryBySupplierId(token, supplierId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/history/' + supplierId, token);
    },


    /**
     * Save the contract form data.
     *
     * @param token
     * @param data
     * @param supplierId
     * @param contractId
     * @returns {AxiosPromise<any>}
     */
    saveContractForm: function saveContractForm(token, data, contractId) {
        return new _SecureHttpLibrary2.default().post('contract/notes/create/' + contractId, {
            notes: data
        }, token);
    },


    /**
     * Finish the contract.
     *
     * @param token
     * @param supplierId
     * @param contractId
     * @param ipAddress
     * @param browser
     * @returns {AxiosPromise|*}
     */
    acceptContract: function acceptContract(token, supplierId, contractId, ipAddress, browser) {
        return new _SecureHttpLibrary2.default().post('contract/finish/' + supplierId + '/' + contractId, {
            ipAddress: ipAddress,
            browser: browser
        }, token);
    },


    /**
     * Download the contract pdf.
     *
     * @param token
     * @param fileName
     * @returns {AxiosPromise|*}
     */
    downloadContract: function downloadContract(token, fileName) {
        return new _SecureHttpLibrary2.default().download('get-file/signed/' + fileName, token);
    },


    /**
     * Get bramds.
     *
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getBrands: function getBrands(token) {
        return new _SecureHttpLibrary2.default().get('brands', token);
    },


    /**
     * Get a suppliers existing sites.
     *
     * @param token
     * @param supplierId
     * @returns {AxiosPromise.<any>}
     */
    getContractManagementCopiedSites: function getContractManagementCopiedSites(token, supplierId) {
        return new _SecureHttpLibrary2.default().get('contractmanagement/existing-sites/' + supplierId, token);
    },


    /**
     * Get a supplier existing accommodations based on an array of site ids.
     *
     * @param token
     * @param supplierId
     * @param siteIds
     * @returns {AxiosPromise|*}
     */
    getContractManagementCopiedAccommodations: function getContractManagementCopiedAccommodations(token, supplierId, siteIds) {
        return new _SecureHttpLibrary2.default().post('contractmanagement/existing-accommodations/' + supplierId, {
            siteIds: siteIds
        }, token);
    },


    /**
     * Send notification email.
     *
     * @param token
     * @param supplierId
     * @param contractId
     */
    sendContractEmailNotification: function sendContractEmailNotification(token, supplierId, contractId) {
        return new _SecureHttpLibrary2.default().get('contract/notes/alert/' + supplierId + '/' + contractId, token);
    },


    /**
     * Get arrival rules for accommodation site id in period.
     *
     * @param token
     * @param accommodationSiteId
     * @param from
     * @param to
     * @returns {AxiosPromise<any>}
     */
    getArrivalRules: function getArrivalRules(token, accommodationSiteId, from, to) {
        return new _SecureHttpLibrary2.default().get('accommodation/arrival/' + accommodationSiteId + '/' + from + '/' + to, token);
    },


    /**
     * Get suppliers and products.
     *
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getSuppliersAndProducts: function getSuppliersAndProducts(token) {
        return new _SecureHttpLibrary2.default().get('suppliers-products', token);
    },


    /**
     * Get supplier booking filter data.
     *
     * @param supplierId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    getSupplierFilterData: function getSupplierFilterData(supplierId, token) {
        return new _SecureHttpLibrary2.default().get('filter/' + supplierId, token);
    },


    /**
     * Preview supplier contract draft.
     *
     * @param supplierId
     * @param contractId
     * @param token
     * @returns {AxiosPromise<any>}
     */
    previewContractDraft: function previewContractDraft(supplierId, contractId, token) {
        return new _SecureHttpLibrary2.default().download('contract/preview/' + supplierId + '/' + contractId, token);
    }
};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(84);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(130)(module)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSeasonPeriod = exports.calculateCalendarDates = exports.getCalendarHighlightIndices = exports.isSoldOut = exports.bookingForFullPeriod = exports.changeRequestForAllocation = exports.addDay = exports.calculateNewPeriodFromTo = exports.calculatePeriodFromTo = exports.convertDateToString = exports.convertStringDateToDate = exports.calculateToDate = exports.hasRequest = exports.isReleased = exports.listOfAllocationsWithinPeriod = exports.generateCalendar = exports.generateValidatorCalendarAddOneDay = exports.generateValidatorCalendar = exports.generatePeriod = exports.checkForOverlap = undefined;

var _lodashEs = __webpack_require__(14);

var _moment = __webpack_require__(5);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Method to checks for overlaps on dates and returns an array of the dates that are present in
 * both the new allocation dates array and the old allocations dates array.
 *
 * @param newDates
 * @param oldDates
 */
var checkForOverlap = exports.checkForOverlap = function checkForOverlap(newDates, oldDates) {
    var overlapDates = [];
    // Distinct the old dates to ensure that dates are not appearing twice
    newDates.forEach(function (date) {
        if (oldDates.indexOf(date) !== -1) {
            overlapDates.push(date);
        }
    });
    return generatePeriod(overlapDates);
};

/**
 * Returns an array of periods based on the overlaps dates.
 *
 * @param overlapDates
 */
var generatePeriod = exports.generatePeriod = function generatePeriod(overlapDates) {
    var periods = [];
    var from = null;
    var to = null;
    var current = null;

    if (overlapDates.length > 0) {
        overlapDates.forEach(function (date) {
            if (from === null) {
                current = (0, _moment2.default)(date).startOf('day');
                from = date;
            } else {
                var currentTomorrowStr = current.add(1, 'days').format('Y-MM-DD');
                if (currentTomorrowStr !== date) {
                    to = current.format('DD/MM/Y');
                    periods.push({ from: (0, _moment2.default)(from, 'YYYY-MM-DD').format('DD/MM/Y'), to: to });
                    current = (0, _moment2.default)(date).startOf('day');
                    from = date;
                }
            }
        });
        // Add the last period
        to = overlapDates[overlapDates.length - 1];
        to = (0, _moment2.default)(to, 'YYYY-MM-DD');
        to.add(1, 'days');
        periods.push({ from: (0, _moment2.default)(from, 'YYYY-MM-DD').format('DD/MM/Y'), to: to.format('DD/MM/Y') });
    }
    return periods;
};

/**
 * Returns a calendar of dates based on a from and a to date. All dates a string formatted YYYY-MM-DD
 *
 * @param from
 * @param to
 * @returns {Array}
 */
var generateValidatorCalendar = exports.generateValidatorCalendar = function generateValidatorCalendar(from, to) {
    var dates = [];
    // Convert dates to moment dates
    from = convertStringDateToDate(from);
    to = convertStringDateToDate(to);
    // Create dates in period from - to
    do {
        dates.push(from.format('Y-MM-DD'));
    } while (from.add(1, 'days').diff(to) < 0);
    return dates;
};

/**
 * Returns a calendar of dates based on a from and a to date with one added day. All dates a string formatted YYYY-MM-DD
 *
 * @param from
 * @param to
 * @returns {Array}
 */
var generateValidatorCalendarAddOneDay = exports.generateValidatorCalendarAddOneDay = function generateValidatorCalendarAddOneDay(from, to) {
    var dates = [];
    // Convert dates to moment dates
    from = convertStringDateToDate(from);
    to = convertStringDateToDate(to);
    // Create dates in period from - to
    do {
        dates.push(from.format('Y-MM-DD'));
    } while (from.add(1, 'days').diff(to) <= 0);
    return dates;
};

/**
 * Returns a calendar of dates based on a from and a to date. All dates a string formatted YYYY-MM-DD
 *
 * @param from
 * @param to
 * @returns {Array}
 */
var generateCalendar = exports.generateCalendar = function generateCalendar(from, to) {
    var dates = [];
    // Convert dates to moment dates
    from = convertStringDateToDate(from);
    to = convertStringDateToDate(to);
    // Create dates in period from - to
    do {
        dates.push(from.format('Y-MM-DD'));
    } while (from.add(1, 'days').diff(to) <= 0);
    return dates;
};

/**
 * List allocations within period based on from and to date.
 *
 * @param from
 * @param to
 * @param allocations
 * @param changeRequests
 * @returns {Array}
 */
var listOfAllocationsWithinPeriod = exports.listOfAllocationsWithinPeriod = function listOfAllocationsWithinPeriod(from, to, allocations, changeRequests) {
    var allocationsWithinPeriod = [];
    // Subtract 1 day from the to date
    var periodToExcludeLastDay = convertStringDateToDate(to).subtract(1, 'days');
    var newDates = from && to ? generateCalendar(from, periodToExcludeLastDay) : [];
    (0, _lodashEs.filter)(allocations, function (accommodation) {
        (0, _lodashEs.filter)(accommodation, function (allocation) {
            // Subtract 1 day from the to date
            var allocationToExcludeLastDay = convertStringDateToDate(allocation.to).subtract(1, 'days');
            var oldDates = generateCalendar(allocation.from, allocationToExcludeLastDay);
            if (checkForOverlap(newDates, oldDates).length > 0) {
                //Calculate from to dates to check for requests
                var period = calculateNewPeriodFromTo(from, to, allocation);
                // Add release status for allocation in period
                allocationsWithinPeriod.push({
                    allocation: allocation,
                    isReleased: isReleased(to, allocation) || isSoldOut(from, to, allocation),
                    hasRequest: hasRequest(period.from, period.to, changeRequests)
                });
            }
        });
    });
    return allocationsWithinPeriod;
};

/**
 * Check if the allocation is released in the period
 *
 * @param to
 * @param allocation
 */
var isReleased = exports.isReleased = function isReleased(to, allocation) {
    var today = (0, _moment2.default)().startOf('day');
    // Convert dates to moment dates
    to = convertStringDateToDate(to);
    var releaseDate = allocation.releaseDate !== null ? convertStringDateToDate(allocation.releaseDate) : calculateLatestReleaseDate(allocation, to);
    return today.diff(releaseDate) >= 0;
};

/**
 * Check if the allocation has any changes requested.
 *
 * @param from
 * @param to
 * @param changeRequests
 */
var hasRequest = exports.hasRequest = function hasRequest(from, to, changeRequests) {
    var fromToCalendar = generateValidatorCalendar(from, to);
    return (0, _lodashEs.filter)(changeRequests, function (request) {
        var requestCalendar = generateValidatorCalendar(request.from, request.to);
        return checkForOverlap(requestCalendar, fromToCalendar).length > 0;
    }).length > 0;
};

/**
 * Calculate the to date to use for the modals new allocations, which is used
 * when adding new allocation to released stock.
 *
 * @param calendarTo
 * @param allocationTo
 * @returns {*}
 */
var calculateToDate = exports.calculateToDate = function calculateToDate(calendarTo, allocationTo) {
    var calendarToDate = convertStringDateToDate(calendarTo);
    var allocationToDate = convertStringDateToDate(allocationTo);
    return allocationToDate.diff(calendarToDate) < 0 ? allocationToDate.format('DD/MM/YYYY') : calendarTo;
};

/**
 * Convert a string date to a moment date.
 *
 * @param date
 * @returns {*}
 */
var convertStringDateToDate = exports.convertStringDateToDate = function convertStringDateToDate(date) {
    if (typeof date === "string") {
        if (date.indexOf('-') !== -1) {
            return (0, _moment2.default)(date, 'YYYY-MM-DD').startOf('day');
        } else if (date.indexOf('/') !== -1) {
            return (0, _moment2.default)(date, 'DD/MM/YYYY').startOf('day');
        } else {
            return null;
        }
    }
    return (0, _moment2.default)(date);
};

/**
 * Converts a date to string.
 *
 * @param date
 */
var convertDateToString = exports.convertDateToString = function convertDateToString(date) {
    return convertStringDateToDate(date).format('YYYY-MM-DD');
};

/**
 * Calculate the latest release date in the period chosen for a specific allocation.
 *
 * @param allocation
 * @param to
 */
var calculateLatestReleaseDate = function calculateLatestReleaseDate(allocation, to) {
    var allocationEndDate = (0, _moment2.default)(allocation.to).startOf('day');
    var finalDate = to.diff(allocationEndDate) < 0 ? to : allocationEndDate;
    return finalDate.subtract(allocation.releaseDays + 1, 'days');
};

/**
 * Calculates which from and to date to use for the allocation, if the from date is before the
 * calendar from date, the calendar from date will be used, and same goes with the to date to
 * ensure that the allocation is only edited within the chosen period.
 *
 * @param calendarFrom
 * @param calendarTo
 * @param allocation
 * @returns {{from: string, to: string}}
 */
var calculatePeriodFromTo = exports.calculatePeriodFromTo = function calculatePeriodFromTo(calendarFrom, calendarTo, allocation) {
    var calendarFromMoment = convertStringDateToDate(calendarFrom);
    var calendarToMoment = convertStringDateToDate(calendarTo);
    var allocationFromMoment = convertStringDateToDate(allocation.from);
    var allocationToMoment = convertStringDateToDate(allocation.to);

    var from = calendarFromMoment.diff(allocationFromMoment) > 0 ? calendarFromMoment : allocationFromMoment;
    var to = calendarToMoment.diff(allocationToMoment) < 0 ? calendarToMoment : allocationToMoment;

    return { from: from, to: to };
};

/**
 * Calculates the from and to date when trying to add new allocations to a released period.
 *
 * @param calendarFrom
 * @param calendarTo
 * @param allocation
 * @returns {{from: *|moment.Moment, to: *|moment.Moment}}
 */
var calculateNewPeriodFromTo = exports.calculateNewPeriodFromTo = function calculateNewPeriodFromTo(calendarFrom, calendarTo, allocation) {
    var calendarFromMoment = convertStringDateToDate(calendarFrom);
    var calendarToMoment = convertStringDateToDate(calendarTo);
    var allocationFromMoment = convertStringDateToDate(allocation.from);
    var allocationToMoment = convertStringDateToDate(allocation.to);

    var from = calendarFromMoment.diff(allocationFromMoment) > 0 ? calendarFromMoment : allocationFromMoment;
    var to = calendarToMoment.diff(allocationToMoment) < 0 ? calendarToMoment : allocationToMoment;

    return { from: from.format('DD/MM/YYYY'), to: to.format('DD/MM/YYYY') };
};

/**
 * Takes a date and adds a day to it and returns as string in format DD/MM7YYYY
 *
 * @param dateString
 */
var addDay = exports.addDay = function addDay(dateString) {
    var date = convertStringDateToDate(dateString);
    return date.add(1, 'days').format('DD/MM/YYYY');
};

/**
 * Check the selected allocation for pending requests.
 *
 * @param allocation
 * @param changeRequests
 * @returns {Array}
 */
var changeRequestForAllocation = exports.changeRequestForAllocation = function changeRequestForAllocation(allocation, changeRequests) {
    // Create cloned dates to ensure that the state is not altered
    var allocationFrom = convertStringDateToDate(allocation.from);
    var allocationTo = convertStringDateToDate(allocation.to);
    var allocationCalendar = generateValidatorCalendar(allocationFrom, allocationTo);
    return (0, _lodashEs.filter)(changeRequests, function (request) {
        var requestCalendar = generateValidatorCalendar(request.from, request.to);
        return checkForOverlap(requestCalendar, allocationCalendar).length > 0;
    });
};

/**
 * Check that the bookings is for the full chosen period.
 *
 * @param allocationPeriod
 * @param bookingPeriod
 * @returns {boolean}
 */
var bookingForFullPeriod = exports.bookingForFullPeriod = function bookingForFullPeriod(allocationPeriod, bookingPeriod) {
    return (0, _lodashEs.filter)(allocationPeriod, function (date) {
        return bookingPeriod.indexOf(date) === -1;
    }).length === 0;
};

/**
 * Check the bookings in the chosen period and calculate if the number of bookings equals the number of units.
 *
 * @param calendarFrom
 * @param calendarTo
 * @param allocation
 * @returns {boolean}
 */
var isSoldOut = exports.isSoldOut = function isSoldOut(calendarFrom, calendarTo, allocation) {
    var period = calculateNewPeriodFromTo(calendarFrom, calendarTo, allocation);
    var allocationPeriod = generateValidatorCalendar(period.from, period.to);
    var bookingsInPeriod = (0, _lodashEs.filter)(allocation.bookings, function (booking) {
        var bookingPeriod = generateValidatorCalendarAddOneDay(booking.from, booking.to);
        return bookingForFullPeriod(allocationPeriod, bookingPeriod);
    });
    return allocation.units === bookingsInPeriod.length;
};

/**
 * Get the indices of the request chosen to highlight in the calendar.
 *
 * @param request
 * @returns {Array}
 */
var getCalendarHighlightIndices = exports.getCalendarHighlightIndices = function getCalendarHighlightIndices(request) {
    var indices = [];
    var fromIndex = parseInt(convertStringDateToDate(request.from).format('DDD')) - 1;
    var toIndex = parseInt(convertStringDateToDate(request.to).format('DDD')) - 1;
    for (fromIndex; fromIndex < toIndex; fromIndex++) {
        indices.push(fromIndex);
    }
    return indices;
};

/**
 * Calculate the calendar dates, if 1st of november then year will be next year.
 *
 * @returns {{}}
 */
var calculateCalendarDates = exports.calculateCalendarDates = function calculateCalendarDates() {
    var today = (0, _moment2.default)();
    var startOfNovember = (0, _moment2.default)(today.year() + '-10-01 00:00:000');
    var currentMonthNumber = today.format('M');

    var year = today.year() + 1; // If not after 1st november set year to current
    var startMonth = 0;
    var endMonth = 6;

    if (today.diff(startOfNovember) < 0) {
        year = today.year();
        startMonth = currentMonthNumber < 4 ? 0 : currentMonthNumber < 7 ? 3 : 6;
        endMonth = startMonth + 6;
    }
    return { year: year, startMonth: startMonth, endMonth: endMonth };
};

/**
 * Get the season period to and from dates.
 *
 * @param year
 * @returns {{from: string, to: string}}
 */
var getSeasonPeriod = exports.getSeasonPeriod = function getSeasonPeriod(year) {
    return {
        from: year + '-01-01',
        to: parseInt(year) + 1 + '-01-01'
    };
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PaginationControl/PaginationControl.vue

/* harmony default export */ var PaginationControl = ({
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        maxPages: {
            type: Number,
            required: true
        }
    },
    computed: {
        hasPrev: function hasPrev() {
            return this.currentPage > 1;
        },
        hasNext: function hasNext() {
            return this.currentPage < this.maxPages;
        }
    },
    methods: {
        goPrev: function goPrev() {
            if (this.hasPrev) {
                this.$emit('prev');
            }
        },
        goNext: function goNext() {
            if (this.hasNext) {
                this.$emit('next');
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f34984","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginationControl/PaginationControl.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-control"},[_c('div',{staticClass:"pagination-control__controls"},[_c('div',{staticClass:"pagination-control__button pagination-control__button--prev",class:{'pagination-control__button--disabled': !_vm.hasPrev},on:{"click":_vm.goPrev}}),_vm._v(" "),_c('div',{class:['pagination-control__info', (_vm.maxPages > 99) ? 'pagination-control__info--small' : null]},[_vm._v("\n            "+_vm._s(_vm.currentPage)+" / "+_vm._s(_vm.maxPages)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"pagination-control__button pagination-control__button--next",class:{'pagination-control__button--disabled': !_vm.hasNext},on:{"click":_vm.goNext}})])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/PaginationControl/PaginationControl.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  PaginationControl,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var PaginationControl_PaginationControl = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProductTypesAndSuppliersFromSuppliersProductsObject = exports.progressPartList = exports.mapContractAcceptedProgressParts = exports.getCurrentContractYear = exports.extractPathAndName = exports.getContractFormData = exports.getContractManagementPartLink = exports.generateS3ImageDownloadPath = exports.mergeFileLists = exports.getExtensionFromMIMEType = exports.extractFileAndExtension = exports.extractFileName = exports.generateDownloadPath = exports.getFormSaveDataExtended = exports.getFormSaveDataBasic = exports.getFormSaveData = exports.mergeDeep = exports.getContractManagementProgress = exports.convertContractManagementData = exports.getContractManagementData = exports.getRouteFilterData = exports.convertDaysObject = exports.mapBookings = exports.convertStringToNumber = exports.JSONClone = exports.clone = exports.createUserData = exports.editUserData = exports.modifyAllocationData = exports.requestAllocationData = exports.blockAllocationData = exports.updateAllocationData = exports.addAllocationData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = __webpack_require__(5);

var _moment2 = _interopRequireDefault(_moment);

var _DateToolService = __webpack_require__(48);

var _lodashEs = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Format the add allocation data.
 *
 * @returns {{}}}
 * @param accommodationSiteId
 * @param row
 */
var addAllocationData = exports.addAllocationData = function addAllocationData(accommodationSiteId, row) {
    return {
        allocation: {
            from: (0, _DateToolService.convertStringDateToDate)(row.from).format('Y-MM-DD'),
            to: (0, _DateToolService.convertStringDateToDate)(row.to).format('Y-MM-DD'),
            type: row.type,
            units: parseInt(row.units) || null,
            releaseType: row.releaseType,
            releaseDays: parseInt(row.releaseDays) || null,
            releaseDate: row.releaseDate ? (0, _moment2.default)(row.releaseDate, 'DD/MM/YYYY').format('Y-MM-DD') : null
        }
    };
};

/**
 * Format the update allocation data.
 *
 * @returns {{} | null}
 * @param item
 * @param original
 */
var updateAllocationData = exports.updateAllocationData = function updateAllocationData(item, original) {
    if (item) {
        return _extends({}, item, {
            from: (0, _DateToolService.convertStringDateToDate)(item.from).format('Y-MM-DD'),
            to: (0, _DateToolService.convertStringDateToDate)(item.to).format('Y-MM-DD'),
            type: item.type,
            releaseType: item.releaseType,
            units: calculateUnits(item, original),
            releaseDays: item.releaseDays || null,
            releaseDate: item.releaseDate ? (0, _DateToolService.convertStringDateToDate)(item.releaseDate).format('Y-MM-DD') : null
        });
    }
    return null;
};

/**
 * Calculate the units count.
 *
 * @param item
 * @param original
 * @returns {null|number}
 */
var calculateUnits = function calculateUnits(item, original) {
    if (item.type !== 'ALLOTMENT') {
        return null;
    } else {
        if (original.type !== 'ALLOTMENT') {
            return parseInt(item.units);
        } else {
            return parseInt(item.units) - parseInt(original.units);
        }
    }
};

/**
 * Format the block allocation data.
 *
 * @returns {{}}
 * @param item
 * @param comment
 */
var blockAllocationData = exports.blockAllocationData = function blockAllocationData(item, comment) {
    var blockAllocation = {};
    if (item) {
        blockAllocation.from = (0, _DateToolService.convertStringDateToDate)(item.from).format('Y-MM-DD');
        blockAllocation.to = (0, _DateToolService.convertStringDateToDate)(item.to).format('Y-MM-DD');
        blockAllocation.comment = comment;
    }
    return blockAllocation;
};

/**
 * Format the request allocation data object.
 *
 * @returns {{}}
 * @param item
 * @param original
 */
var requestAllocationData = exports.requestAllocationData = function requestAllocationData(item, original) {
    var requestAllocation = {};
    if (item && original) {
        requestAllocation = _extends({}, item, {
            from: (0, _DateToolService.convertStringDateToDate)(item.from).format('Y-MM-DD'),
            to: (0, _DateToolService.convertStringDateToDate)(item.to).format('Y-MM-DD'),
            units: parseInt(item.units) - parseInt(original.units) || null,
            releaseDate: item.releaseDate ? (0, _DateToolService.convertStringDateToDate)(item.releaseDate).format('Y-MM-DD') : item.releaseDate,
            originalType: original.type,
            originalReleaseDays: original.releaseDays,
            originalReleaseDate: original.releaseDate ? (0, _DateToolService.convertStringDateToDate)(original.releaseDate).format('Y-MM-DD') : original.releaseDate
        });
    }
    return requestAllocation;
};

/**
 * Modify allocation data.
 *
 * @param item
 * @param original
 * @returns {{units: *, releaseDate: null, releaseDays: null}}
 */
var modifyAllocationData = exports.modifyAllocationData = function modifyAllocationData(item, original) {
    return {
        units: item.changes.deduction.units,
        releaseDate: original.changes.release.releaseDate ? (0, _DateToolService.convertStringDateToDate)(item.changes.release.releaseDate).format('YYYY-MM-DD') : null,
        releaseDays: original.changes.release.releaseDays ? item.changes.release.releaseDays : null
    };
};

/**
 * Return a editUserData object consisting of the necessary information for the update user.
 *
 * @param user
 * @returns {{}}
 */
var editUserData = exports.editUserData = function editUserData(user) {
    return _extends({}, { id: user.id, firstname: user.firstName, lastname: user.lastName, language: user.language, roleIds: (0, _lodashEs.map)(user.roles, 'id') });
};

/**
 * Return a createUserData object consisting of the necessary information for the create user.
 *
 * @param user
 * @returns {{}}
 */
var createUserData = exports.createUserData = function createUserData(user) {
    return _extends({}, { firstname: user.firstName, lastname: user.lastName, email: user.email, language: user.language, roleIds: (0, _lodashEs.map)(user.roles, 'id') });
};

/**
 * Clones an object.
 *
 * @returns {{}}
 * @param object
 */
var clone = exports.clone = function clone(object) {
    return _extends({}, object);
};

/**
 * Clone a JSON object.
 *
 * @param json
 * @returns {any}
 * @constructor
 */
var JSONClone = exports.JSONClone = function JSONClone(json) {
    return JSON.parse(JSON.stringify(json));
};

/**
 * Converts the string to a number if possible, else returns string.
 *
 * @param string
 * @returns {number | *}
 */
var convertStringToNumber = exports.convertStringToNumber = function convertStringToNumber(string) {
    return parseInt(string) || string;
};

/**
 * Maps the bookings object to ensure that booking ref or supplier ref that is a number is converted
 * to be able to sort it correctly.
 *
 * @param bookings
 * @returns {Array}
 */
var mapBookings = exports.mapBookings = function mapBookings(bookings) {
    var mappedBookings = [];
    (0, _lodashEs.forEach)(bookings, function (booking) {
        var mappedBooking = {};
        (0, _lodashEs.forEach)(booking, function (value, key) {
            if (key === 'bookingRef' || key === 'supplierRef') {
                mappedBooking[key] = parseInt(value) || value;
            } else {
                mappedBooking[key] = value;
            }
        });
        mappedBookings.push(mappedBooking);
    });
    return mappedBookings;
};

/**
 * Creates a days object which resets all the days not selected in the radio group.
 *
 * @param item
 * @returns {{}}}
 */
var convertDaysObject = exports.convertDaysObject = function convertDaysObject(item) {
    var clone = _extends({}, item);
    var reset = {
        days: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
        }
    };
    return { days: _extends({}, reset.days, clone.days) };
};

/**
 * Extract the route filter data from the sites object.
 *
 * @param sites
 * @param siteId
 * @param accommodationSiteId
 * @returns {{site: Array|undefined, accommodation: *}}
 */
var getRouteFilterData = exports.getRouteFilterData = function getRouteFilterData(sites, siteId, accommodationSiteId) {
    var site = sites ? (0, _lodashEs.filter)(sites, ['id', parseInt(siteId)])[0] : [];
    var accommodation = site ? (0, _lodashEs.filter)(site.accommodations, ['accommodationSiteId', parseInt(accommodationSiteId)])[0] : null;
    return { site: site, accommodation: accommodation };
};

/**
 * Return the contract data for the specific contract id.
 *
 * @param items
 * @param contractId
 * @returns {*}
 */
var getContractManagementData = exports.getContractManagementData = function getContractManagementData(items, contractId) {
    var contractData = (0, _lodashEs.filter)(items, ['contractId', contractId])[0];
    return convertContractManagementData(contractData, contractId);
};

/**
 * Convert the contract data to map to view.
 *
 * @param data
 * @param contractId
 * @returns {{}}
 */
var convertContractManagementData = exports.convertContractManagementData = function convertContractManagementData(data, contractId) {
    var basic = mapBasicContractData(data);
    var extended = mapExtendedContractData(data);
    return {
        basic: basic,
        extended: extended,
        contractId: contractId,
        readyForBackOffice: data.readyForBackOffice,
        readyForReview: data.readyForReview,
        supplierId: data.supplierId,
        supplierName: data.supplierName
    };
};

/**
 * Convert the basic contract data.
 *
 * @param data
 * @returns {*}
 */
var mapBasicContractData = function mapBasicContractData(data) {
    return data ? {
        priceExtra: data.priceExtra,
        allotmentRules: data.allotmentRules,
        arrivalRules: data.arrivalRules,
        commission: data.commission,
        discounts: data.discounts,
        notes: data.notes
    } : null;
};

/**
 * Map the extended contract data.
 *
 * @param data
 * @returns {*}
 */
var mapExtendedContractData = function mapExtendedContractData(data) {
    return data ? {
        accInfo: data.accommodations.length > 0 ? data.accommodations : [{
            entityId: undefined,
            name: undefined,
            accommodationId: undefined,
            text: undefined,
            files: [],
            images: [],
            s3: [],
            imagesS3: [],
            sites: []
        }],
        siteInfo: data.sites.length > 0 ? data.sites : [{
            showInContract: true,
            entityId: undefined,
            name: undefined,
            siteId: undefined,
            text: undefined,
            files: [],
            images: [],
            s3: [],
            imagesS3: []
        }],
        arrivalDeparture: data.arrivalDeparture,
        brands: data.brands
    } : null;
};

/**
 * Return progress object.
 *
 * @param data
 * @returns {{}}
 */
var getContractManagementProgress = exports.getContractManagementProgress = function getContractManagementProgress(data) {
    return {
        basic: getBasicProgress(data.basic),
        extended: getExtendedProgress(data.extended)
    };
};

/**
 * Get the progress of the basic part.
 *
 * @param basicData
 * @returns {{priceExtra: boolean, allotmentRules: boolean, arrivalRules: boolean, commission: boolean, discounts: boolean, notes}}
 */
var getBasicProgress = function getBasicProgress(basicData) {
    return {
        priceExtra: getDefaultProgress(basicData.priceExtra),
        allotmentRules: getDefaultProgress(basicData.allotmentRules),
        arrivalRules: getDefaultProgress(basicData.arrivalRules),
        commission: getDefaultProgress(basicData.commission),
        discounts: getDefaultProgress(basicData.discounts),
        notes: basicData.notes.text
    };
};

/**
 * Get the progress of the extended contract part.
 *
 * @param extendedData
 * @returns {{}}
 */
var getExtendedProgress = function getExtendedProgress(extendedData) {
    return {
        siteInfo: getComplexProgress(extendedData.siteInfo),
        accInfo: getComplexProgress(extendedData.accInfo),
        arrivalDeparture: getDefaultProgress(extendedData.arrivalDeparture),
        brands: extendedData.brands.length > 0
    };
};

/**
 * Check if either text is filled in or their is a file attached.
 *
 * @param data
 * @returns {*|boolean}
 */
var getDefaultProgress = function getDefaultProgress(data) {
    return data.text || data.s3.length > 0;
};

/**
 * Check if name is present along with either text or a file.
 *
 * @param items
 */
var getComplexProgress = function getComplexProgress(items) {
    var valid = true;
    (0, _lodashEs.each)(items, function (item) {
        if (!(item.name && (item.text || item.s3.length > 0))) valid = false;
    });
    return valid;
};

/**
 * Merge two items deep.
 *
 * @param itemA
 * @param itemB
 */
var mergeDeep = exports.mergeDeep = function mergeDeep(itemA, itemB) {
    return (0, _lodashEs.merge)(itemA, itemB);
};

/**
 * Generate form data object.
 *
 * @param form
 */
var getFormSaveData = exports.getFormSaveData = function getFormSaveData(form) {
    var formData = new FormData();
    formData = getFormSaveDataBasic(form, formData);
    formData = getFormSaveDataExtended(form, formData);
    formData.append('brands', JSON.stringify(form.extended.brands));
    return formData;
};

/**
 * Get basic form data.
 *
 * @param form
 * @param formData
 */
var getFormSaveDataBasic = exports.getFormSaveDataBasic = function getFormSaveDataBasic(form, formData) {
    formData = mapDefault(form.basic.allotmentRules, formData, 'allotmentRules');
    formData = mapDefault(form.basic.arrivalRules, formData, 'arrivalRules');
    formData = mapDefault(form.basic.commission, formData, 'commission');
    formData = mapDefault(form.basic.discounts, formData, 'discounts');
    formData = mapDefault(form.basic.notes, formData, 'notes');
    formData = mapDefault(form.basic.priceExtra, formData, 'priceExtra');
    return formData;
};

/**
 * Map default values to form data.
 *
 * @param data
 * @param formData
 * @param part
 */
var mapDefault = function mapDefault(data, formData, part) {
    formData.append(part + 'Text', data.text || '');
    if (data.files) {
        (0, _lodashEs.each)(data.files, function (file, index) {
            formData.append(part + 'S3_' + (index + 1), file);
        });
    }
    return formData;
};

/**
 * Get extended form data.
 *
 * @param form
 * @param formData
 * @returns {FormData}
 */
var getFormSaveDataExtended = exports.getFormSaveDataExtended = function getFormSaveDataExtended(form, formData) {
    formData = mapAccommodations(form.extended.accInfo, formData);
    formData = mapSites(form.extended.siteInfo, formData);
    formData = mapFiles(form.extended.siteInfo, formData, 'siteInfo');
    formData = mapFiles(form.extended.accInfo, formData, 'accInfo');
    formData = mapDefault(form.extended.arrivalDeparture, formData, 'arrivalDeparture');

    return formData;
};

/**
 * Map sites info and append to form.
 *
 * @param siteInfo
 * @param formData
 */
var mapSites = function mapSites(siteInfo, formData) {
    var fileIndex = 1;
    var imageIndex = 1;
    var sites = (0, _lodashEs.map)(siteInfo, function (site) {
        var filesData = generateFileReferences(site.files, 'siteInfoS3', fileIndex);
        var imagesData = generateFileReferences(site.images, 'siteInfoImage', imageIndex);
        fileIndex = filesData.index;
        imageIndex = imagesData.index;
        return {
            showInContract: site.showInContract,
            entityId: site.entityId || null,
            name: site.name || null,
            id: site.id || null,
            text: site.text || null,
            files: filesData.files,
            images: imagesData.files
        };
    });
    formData.append('siteInfo', JSON.stringify({ sites: validateDataArray(sites) }));
    return formData;
};

/**
 * Filter the data to ensure that only non default items a send.
 *
 * @returns {Array}
 * @param items
 */
var validateDataArray = function validateDataArray(items) {
    return (0, _lodashEs.filter)(items, function (item) {
        var files = item.files.length > 0 ? item.files : null;
        var images = item.images.length > 0 ? item.images : null;
        return item.name || item.text || item.s3 || files || item.imagesS3 || images;
    });
};

/**
 * Map accommodations info and append to form.
 *
 * @param accInfo
 * @param formData
 */
var mapAccommodations = function mapAccommodations(accInfo, formData) {
    var fileIndex = 1;
    var imageIndex = 1;
    var accommodations = (0, _lodashEs.map)(accInfo, function (accommodation) {
        var filesData = generateFileReferences(accommodation.files, 'accInfoS3', fileIndex);
        var imagesData = generateFileReferences(accommodation.images, 'accInfoImage', imageIndex);
        fileIndex = filesData.index;
        imageIndex = imagesData.index;
        return {
            entityId: accommodation.entityId || null,
            name: accommodation.name || null,
            id: accommodation.id || null,
            text: accommodation.text || null,
            files: filesData.files,
            images: imagesData.files,
            sites: accommodation.sites
        };
    });
    formData.append('accInfo', JSON.stringify({ accommodations: validateDataArray(accommodations) }));
    return formData;
};

/**
 * Map files and append to form.
 *
 * @param items
 * @param formData
 * @param part
 * @returns {*}
 */
var mapFiles = function mapFiles(items, formData, part) {
    var s3index = 1;
    var imageIndex = 1;
    (0, _lodashEs.each)(items, function (item) {
        for (var i = 0; i < item.files.length; i++) {
            formData.append(part + 'S3_' + s3index++, item.files[i]);
        }
        for (var _i = 0; _i < item.images.length; _i++) {
            formData.append(part + 'Image_' + imageIndex++, item.images[_i]);
        }
    });
    return formData;
};

/**
 * Extract file names.
 *
 * @param files
 * @param prefix
 * @param index
 * @returns {{files: Array, index: *}}
 */
var generateFileReferences = function generateFileReferences(files, prefix, index) {
    var mappedFiles = (0, _lodashEs.map)(files, function () {
        var mappedFile = prefix + '_' + index;
        index++;
        return mappedFile;
    });
    return { files: mappedFiles, index: index };
};

/**
 * Generate the download path.
 *
 * @param file
 * @param subPath
 * @returns {string}
 */
var generateDownloadPath = exports.generateDownloadPath = function generateDownloadPath(file) {
    var baseUrl = "https://backend.twentybook.com/gateway/marketplace/v1";
    return baseUrl + '/file/basiccontract' + file.substring(file.lastIndexOf('/'), file.length);
};

/**
 * Extract the file name.
 *
 * @param file
 */
var extractFileName = exports.extractFileName = function extractFileName(file) {
    return typeof file === 'string' ? file.substring(file.lastIndexOf('/') + 1, file.length) : file.name;
};

/**
 * Extract file name and file extension.
 *
 * @param file
 * @returns {{name: string, extension: string}}
 */
var extractFileAndExtension = exports.extractFileAndExtension = function extractFileAndExtension(file) {
    var fileName = extractFileName(file);
    var name = fileName.substring(0, fileName.lastIndexOf('.'));
    var extension = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
    return { name: name, extension: extension };
};

/**
 * Get the extension from MIMEType.
 *
 * @param MIMEType
 * @returns {string}
 */
var getExtensionFromMIMEType = exports.getExtensionFromMIMEType = function getExtensionFromMIMEType(MIMEType) {
    switch (MIMEType) {
        case 'application/pdf':
            return 'pdf';
        case 'application/vnd.ms-excel':
            return 'xls';
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'xlsx';
        case 'application/msword':
            return 'doc';
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'docx';
        case 'application/vnd.ms-powerpoint':
            return 'ppt';
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'pptx';
        default:
            return 'txt';
    }
};

/**
 * Merge array with fileList.
 *
 * @param files
 * @param fileList
 */
var mergeFileLists = exports.mergeFileLists = function mergeFileLists(files, fileList) {
    var fileArray = Array.prototype.slice.call(fileList);
    return files.concat(fileArray);
};

/**
 * Generate image url.
 *
 * @param file
 * @returns {*}
 */
var generateS3ImageDownloadPath = exports.generateS3ImageDownloadPath = function generateS3ImageDownloadPath(file) {
    return "https://s3.eu-central-1.amazonaws.com/twenty-marketplace-uploads" + file;
};

/**
 * Get the Twenty link for each sub part of the contract management.
 *
 * @returns {*}
 * @param subPart
 */
var getContractManagementPartLink = exports.getContractManagementPartLink = function getContractManagementPartLink(subPart) {
    var baseUrl = "https://backend.twentybook.com";
    if (subPart) {
        switch (subPart) {
            case 'priceExtra':
                return [baseUrl + '/support-system/allocation', baseUrl + '/support-system/extra'];
            case 'allotmentRules':
                return baseUrl + '/support-system/allocation';
            case 'arrivalRules':
                return baseUrl + '/support-system/arrival-rules';
            case 'commission':
                return baseUrl + '/support-system/allocation';
            case 'discounts':
                return baseUrl + '/support-system/discount';
            case 'siteInfo':
                return baseUrl + '/production/products/sites';
            case 'accInfo':
                return baseUrl + '/production/products/accommodations';
            case 'arrivalDeparture':
                return baseUrl + '/support-system/arrival-rules';
        }
    }
    return null;
};

/**
 * Convert the contract form data to an array.
 *
 * @param form
 * @returns {Array}
 */
var getContractFormData = exports.getContractFormData = function getContractFormData(form) {
    var data = [];
    var id = 1;
    for (var attribute in form) {
        data.push(_extends({}, form[attribute], { field: id++ }));
    }
    return data;
};

/**
 * Extract path and filename from file.
 *
 * @param file
 * @returns {{path: string, name: string}}
 */
var extractPathAndName = exports.extractPathAndName = function extractPathAndName(file) {
    return {
        path: file.substring(0, file.lastIndexOf('/')),
        name: file.substring(file.lastIndexOf('/') + 1, file.lastIndexOf('.')),
        type: file.substring(file.lastIndexOf('.') + 1, file.length)
    };
};

/**
 * Get the current contract year.
 *
 * @returns {*}
 */
var getCurrentContractYear = exports.getCurrentContractYear = function getCurrentContractYear() {
    var date = (0, _moment2.default)();
    if (date.month() >= 7) {
        return date.year() + 1 + '';
    }
    return date.year() + '';
};

/**
 * Map the contract accepted parts
 * @param payload
 */
var mapContractAcceptedProgressParts = exports.mapContractAcceptedProgressParts = function mapContractAcceptedProgressParts(payload, progressObj) {
    var acceptedObj = clone(progressObj);

    (0, _lodashEs.each)(payload, function (item) {
        acceptedObj[progressPartList[item.field - 1]] = true;
    });
    return acceptedObj;
};

/**
 * List of contract part types.
 *
 * @type {string[]}
 */
var progressPartList = exports.progressPartList = ['supplierInfo', 'sites', 'accommodations', 'prices', 'extras', 'arrivalRules', 'cancellationRules', 'discounts', 'allocations', 'terms'];

/**
 * Get the first product type from suppliersProductsObject.
 *
 * @param suppliersProductsObject
 * @returns {{supplier: *, productType: string}}
 */
var getProductTypesAndSuppliersFromSuppliersProductsObject = exports.getProductTypesAndSuppliersFromSuppliersProductsObject = function getProductTypesAndSuppliersFromSuppliersProductsObject(suppliersProductsObject) {
    var productTypes = Object.keys(suppliersProductsObject).sort();
    var productType = checkIfCampingIsAmongTheProductTypes(productTypes) ? 'Camping' : productTypes[0];
    var supplier = suppliersProductsObject[productType][0];
    return {
        productTypes: productTypes,
        productType: productType,
        supplier: supplier
    };
};

/**
 * Check if camping is one of the product types.
 *
 * @param productTypes
 * @returns {boolean}
 */
var checkIfCampingIsAmongTheProductTypes = function checkIfCampingIsAmongTheProductTypes(productTypes) {
    return (0, _lodashEs.some)(productTypes, function (productType) {
        return productType === 'Camping';
    });
};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Alert/Alert.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var Alert = ({
    props: {
        translationPrefix: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            interval: undefined
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        timer: function timer(state) {
            return state.alert.timer;
        },
        message: function message(state) {
            return state.alert.message;
        }
    })),
    created: function created() {
        var _this = this;

        this.interval = setInterval(function () {
            if (_this.timer > 0) {
                _this.countdown();
            }
        }, 1000);
    },
    destroyed: function destroyed() {
        clearInterval(this.interval);
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        countdown: 'alert/countdown'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-177767cb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert/Alert.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.timer > 0)?_c('div',{staticClass:"message",class:'message--' + _vm.message.level},[_c('div',{staticClass:"message__content"},[(_vm.translationPrefix)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.translationPrefix + '.' + _vm.message.message)))]):_vm._e(),_vm._v(" "),(!_vm.translationPrefix)?_c('span',[_vm._v(_vm._s(_vm.message.message))]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/Alert/Alert.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  Alert,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var Alert_Alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxValue = exports.minValue = exports.and = exports.or = exports.url = exports.sameAs = exports.requiredUnless = exports.requiredIf = exports.required = exports.minLength = exports.maxLength = exports.macAddress = exports.ipAddress = exports.email = exports.between = exports.numeric = exports.alphaNum = exports.alpha = undefined;

var _alpha = __webpack_require__(450);

var _alpha2 = _interopRequireDefault(_alpha);

var _alphaNum = __webpack_require__(452);

var _alphaNum2 = _interopRequireDefault(_alphaNum);

var _numeric = __webpack_require__(453);

var _numeric2 = _interopRequireDefault(_numeric);

var _between = __webpack_require__(454);

var _between2 = _interopRequireDefault(_between);

var _email = __webpack_require__(455);

var _email2 = _interopRequireDefault(_email);

var _ipAddress = __webpack_require__(456);

var _ipAddress2 = _interopRequireDefault(_ipAddress);

var _macAddress = __webpack_require__(457);

var _macAddress2 = _interopRequireDefault(_macAddress);

var _maxLength = __webpack_require__(458);

var _maxLength2 = _interopRequireDefault(_maxLength);

var _minLength = __webpack_require__(459);

var _minLength2 = _interopRequireDefault(_minLength);

var _required = __webpack_require__(460);

var _required2 = _interopRequireDefault(_required);

var _requiredIf = __webpack_require__(461);

var _requiredIf2 = _interopRequireDefault(_requiredIf);

var _requiredUnless = __webpack_require__(462);

var _requiredUnless2 = _interopRequireDefault(_requiredUnless);

var _sameAs = __webpack_require__(463);

var _sameAs2 = _interopRequireDefault(_sameAs);

var _url = __webpack_require__(464);

var _url2 = _interopRequireDefault(_url);

var _or = __webpack_require__(465);

var _or2 = _interopRequireDefault(_or);

var _and = __webpack_require__(466);

var _and2 = _interopRequireDefault(_and);

var _minValue = __webpack_require__(467);

var _minValue2 = _interopRequireDefault(_minValue);

var _maxValue = __webpack_require__(468);

var _maxValue2 = _interopRequireDefault(_maxValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.alpha = _alpha2.default;
exports.alphaNum = _alphaNum2.default;
exports.numeric = _numeric2.default;
exports.between = _between2.default;
exports.email = _email2.default;
exports.ipAddress = _ipAddress2.default;
exports.macAddress = _macAddress2.default;
exports.maxLength = _maxLength2.default;
exports.minLength = _minLength2.default;
exports.required = _required2.default;
exports.requiredIf = _requiredIf2.default;
exports.requiredUnless = _requiredUnless2.default;
exports.sameAs = _sameAs2.default;
exports.url = _url2.default;
exports.or = _or2.default;
exports.and = _and2.default;
exports.minValue = _minValue2.default;
exports.maxValue = _maxValue2.default;

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SelectLanguage/SelectLanguage.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var SelectLanguage = ({
    computed: _extends({}, Object(vuex_esm["mapState"])({
        languages: function languages(state) {
            return state.nav.languages;
        },
        selectedLanguage: function selectedLanguage(state) {
            return state.nav.language;
        }
    })),
    created: function created() {
        this.setLanguages(this.$locale.getValidLanguages());
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        updateLanguage: 'nav/updateLanguage',
        setLanguages: 'nav/setLanguages'
    }), {
        updateLanguageValue: function updateLanguageValue(element) {
            this.$locale.change(element.value);
            this.updateLanguage(element);
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3d2232","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectLanguage/SelectLanguage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-language"},[_c('div',{staticClass:"select-language__content"},[(_vm.languages.length > 1)?_c('div',{staticClass:"select-language__elements"},_vm._l((_vm.languages),function(language){return _c('div',{key:language.value,staticClass:"select-language__element"},[_c('img',{class:['select-language__image', language.name === _vm.selectedLanguage.name ? 'select-language__image-selected' : null],attrs:{"src":'https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/flags/' + language.value + '.png'},on:{"click":function($event){return _vm.updateLanguageValue(language)}}})])}),0):_vm._e()])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/SelectLanguage/SelectLanguage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  SelectLanguage,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var SelectLanguage_SelectLanguage = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(183);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(130)(module)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Generates the Google Analytics meta object.
 *
 * @param category
 * @param action
 * @param label
 * @param value
 * @returns {{analytics: *[]}}
 */
var eventTracker = exports.eventTracker = function eventTracker(category, action, label, value) {
    return {
        analytics: [['event', {
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value
        }]]
    };
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "checkbox.png?8bdd8c25ad5a17221e23e5b08f737a35";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "checkbox--checked.png?84664068d4a280f56d0d26c1c13f2035";

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueRouter = __webpack_require__(171);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routesAuth = __webpack_require__(447);

var _routesAuth2 = _interopRequireDefault(_routesAuth);

var _routesPage = __webpack_require__(474);

var _routesPage2 = _interopRequireDefault(_routesPage);

var _routesDashboard = __webpack_require__(476);

var _routesDashboard2 = _interopRequireDefault(_routesDashboard);

var _routesIntroduction = __webpack_require__(497);

var _routesIntroduction2 = _interopRequireDefault(_routesIntroduction);

var _NotFoundContainer = __webpack_require__(500);

var _NotFoundContainer2 = _interopRequireDefault(_NotFoundContainer);

var _vueRouterMultiguard = __webpack_require__(501);

var _vueRouterMultiguard2 = _interopRequireDefault(_vueRouterMultiguard);

var _AuthGuards = __webpack_require__(502);

var _AuthGuards2 = _interopRequireDefault(_AuthGuards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var router = new _vueRouter2.default({
    mode: 'history',
    routes: [_routesAuth2.default, _routesPage2.default, _routesDashboard2.default, _routesIntroduction2.default, { path: '**/*', component: _NotFoundContainer2.default }]
});

router.beforeEach((0, _vueRouterMultiguard2.default)([_AuthGuards2.default.synchronizeUser, _AuthGuards2.default.isAuthenticated, _AuthGuards2.default.isUnauthenticated, _AuthGuards2.default.restrictXMLSupplier, _AuthGuards2.default.restrictContractManager, _AuthGuards2.default.restrictSupplier, _AuthGuards2.default.admin]));

exports.default = router;

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb3c802","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreloaderItem/PreloaderItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader-item"},[_c('div',{staticClass:"preloader-item__loader"},[_c('svg',{staticClass:"preloader-item__circle",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"preloader-item__path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"4","stroke-miterlimit":"10"}})])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/PreloaderItem/PreloaderItem.vue
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var PreloaderItem = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/lodash.js + 631 modules
var lodash = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KeyValueMenu/KeyValueMenu.vue



/* harmony default export */ var KeyValueMenu = ({
    props: {
        searchable: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: [Object],
            default: undefined
        },
        items: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledName: {
            type: String,
            default: 'N/A'
        },
        undefinedName: {
            type: String,
            default: 'All items'
        },
        enableDeselect: {
            type: Boolean,
            default: false
        },
        translationPrefix: {
            type: String,
            default: undefined
        }
    },
    data: function data() {
        return {
            toggled: false,
            event: undefined,
            search: '',
            filteredItems: undefined
        };
    },
    created: function created() {
        this.filteredItems = this.items;
    },

    methods: {
        toggle: function toggle() {
            if (!this.disabled) {
                if (!this.toggled) {
                    this.addListeners();
                } else {
                    this.resetSearch();
                    this.removeListeners();
                }
                this.toggled = !this.toggled;
            }
        },
        keypress: function keypress(key) {
            this.search += key;
        },
        backSpace: function backSpace() {
            this.search = this.search.substring(0, this.search.length - 1);
        },
        escape: function escape() {
            this.toggled = false;
            this.resetSearch();
            this.removeListeners();
        },
        select: function select(val) {
            this.resetSearch();
            this.$emit('input', val);
        },
        deselect: function deselect() {
            this.resetSearch();
            this.$emit('input', undefined);
        },
        filterSearch: function filterSearch() {
            var _this = this;

            this.filteredItems = Object(lodash["filter"])(this.items, function (item) {
                return item.name.toLowerCase().indexOf(_this.search.toLowerCase()) !== -1;
            });
        },
        clickEvent: function clickEvent(event) {
            if (!event.target.classList.contains('key-value-menu__button')) {
                this.toggle();
            }
        },
        addListeners: function addListeners() {
            document.addEventListener('click', this.clickEvent);
            if (this.searchable) {
                document.addEventListener('keydown', this.keypressEvent);
            }
        },
        removeListeners: function removeListeners() {
            document.removeEventListener('click', this.clickEvent);
            if (this.searchable) {
                document.removeEventListener('keydown', this.keypressEvent);
            }
        },
        resetSearch: function resetSearch() {
            this.search = '';
            this.filteredItems = this.items;
        },
        keypressEvent: function keypressEvent(event) {
            var key = event.key;
            switch (key) {
                case 'Backspace':
                    this.backSpace();
                    break;
                case 'Escape':
                    this.escape();
                    break;
                case 'ArrowUp':
                    break;
                case 'ArrowDown':
                    break;
                case 'ArrowLeft':
                    break;
                case 'ArrowRight':
                    break;
                default:
                    this.keypress(key);
            }
            this.filterSearch();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1707ab8e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeyValueMenu/KeyValueMenu.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"key-value-menu",class:{'key-value-menu--disabled': _vm.disabled},on:{"click":_vm.toggle}},[_c('div',{staticClass:"key-value-menu__button"},[_c('div',{staticClass:"key-value-menu__label"},[_vm._v("\n            "+_vm._s(_vm.label)+":\n        ")]),_vm._v(" "),(_vm.search === '')?_c('div',{staticClass:"key-value-menu__value"},[(_vm.value)?_c('span',[_vm._v("\n                "+_vm._s(_vm.value.name)+"\n            ")]):_vm._e(),_vm._v(" "),(!_vm.value)?_c('span',[_vm._v("\n                "+_vm._s(_vm.disabled ? _vm.disabledName : _vm.undefinedName)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.search !== '')?_c('div',{staticClass:"dropdown-menu__search"},[_vm._v("\n            "+_vm._s(_vm.search)+"\n        ")]):_vm._e()]),_vm._v(" "),(_vm.toggled)?_c('div',{staticClass:"key-value-menu__dropdown"},[(_vm.enableDeselect)?_c('div',{staticClass:"key-value-menu__choice",class:{'key-value-menu__choice--selected': !_vm.value},on:{"click":_vm.deselect}},[_vm._v("\n            "+_vm._s(_vm.undefinedName)+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredItems),function(item,index){return _c('div',{key:'key-value-item__' + index,staticClass:"key-value-menu__choice",class:{'key-value-menu__choice--selected': _vm.value === item},on:{"click":function($event){return _vm.select(item)}}},[_vm._v("\n            "+_vm._s(item.name)+"\n        ")])})],2):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/KeyValueMenu/KeyValueMenu.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  KeyValueMenu,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var KeyValueMenu_KeyValueMenu = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = exports.remove = exports.get = exports.save = exports.store = undefined;

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _storage = localStorage;
var _session = sessionStorage;

/**
 * Store a value in storage.
 *
 * @param key
 * @param value
 */
var store = exports.store = function store(key, value) {
  _storage.setItem(key, JSON.stringify(value));
};

/**
 * Save a value in session. NOTE! Will be deleted when window session ends.
 *
 * @param key
 * @param value
 */
var save = exports.save = function save(key, value) {
  _session.setItem(key, JSON.stringify(value));
};

/**
 * Get value from key in storage.
 */
var get = exports.get = function get(key) {
  return JSON.parse(_storage.getItem(key) || _session.getItem(key));
};

/**
 * Remove the key from storage.
 *
 * @param key
 */
var remove = exports.remove = function remove(key) {
  _storage.removeItem(key) || _session.removeItem(key);
};

/**
 * Clear the storage for this domain.
 */
var clear = exports.clear = function clear() {
  // Save the language selection
  var language = _storage.getItem(_config2.default.lang.LANGUAGE_IDENTIFIER);
  _storage.clear();
  _session.clear();
  _storage.setItem(_config2.default.lang.LANGUAGE_IDENTIFIER, language);
};

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(424);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(30);
var normalizeHeaderName = __webpack_require__(427);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(174);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(174);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)))

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-chartjs/es/mixins/index.js
function dataHandler(newData, oldData) {
  if (oldData) {
    var chart = this.$data._chart;
    var newDatasetLabels = newData.datasets.map(function (dataset) {
      return dataset.label;
    });
    var oldDatasetLabels = oldData.datasets.map(function (dataset) {
      return dataset.label;
    });
    var oldLabels = JSON.stringify(oldDatasetLabels);
    var newLabels = JSON.stringify(newDatasetLabels);

    if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
      newData.datasets.forEach(function (dataset, i) {
        var oldDatasetKeys = Object.keys(oldData.datasets[i]);
        var newDatasetKeys = Object.keys(dataset);
        var deletionKeys = oldDatasetKeys.filter(function (key) {
          return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
        });
        deletionKeys.forEach(function (deletionKey) {
          delete chart.data.datasets[i][deletionKey];
        });

        for (var attribute in dataset) {
          if (dataset.hasOwnProperty(attribute)) {
            chart.data.datasets[i][attribute] = dataset[attribute];
          }
        }
      });

      if (newData.hasOwnProperty('labels')) {
        chart.data.labels = newData.labels;
        this.$emit('labels:update');
      }

      if (newData.hasOwnProperty('xLabels')) {
        chart.data.xLabels = newData.xLabels;
        this.$emit('xlabels:update');
      }

      if (newData.hasOwnProperty('yLabels')) {
        chart.data.yLabels = newData.yLabels;
        this.$emit('ylabels:update');
      }

      chart.update();
      this.$emit('chart:update');
    } else {
      if (chart) {
        chart.destroy();
        this.$emit('chart:destroy');
      }

      this.renderChart(this.chartData, this.options);
      this.$emit('chart:render');
    }
  } else {
    if (this.$data._chart) {
      this.$data._chart.destroy();

      this.$emit('chart:destroy');
    }

    this.renderChart(this.chartData, this.options);
    this.$emit('chart:render');
  }
}

var reactiveData = {
  data: function data() {
    return {
      chartData: null
    };
  },
  watch: {
    'chartData': dataHandler
  }
};
var reactiveProp = {
  props: {
    chartData: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  watch: {
    'chartData': dataHandler
  }
};
/* harmony default export */ var mixins = ({
  reactiveData: reactiveData,
  reactiveProp: reactiveProp
});
// EXTERNAL MODULE: ./node_modules/chart.js/dist/Chart.js
var Chart = __webpack_require__(479);
var Chart_default = /*#__PURE__*/__webpack_require__.n(Chart);

// CONCATENATED MODULE: ./node_modules/vue-chartjs/es/BaseCharts.js

function generateChart(chartId, chartType) {
  return {
    render: function render(createElement) {
      return createElement('div', {
        style: this.styles,
        class: this.cssClasses
      }, [createElement('canvas', {
        attrs: {
          id: this.chartId,
          width: this.width,
          height: this.height
        },
        ref: 'canvas'
      })]);
    },
    props: {
      chartId: {
        default: chartId,
        type: String
      },
      width: {
        default: 400,
        type: Number
      },
      height: {
        default: 400,
        type: Number
      },
      cssClasses: {
        type: String,
        default: ''
      },
      styles: {
        type: Object
      },
      plugins: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    },
    data: function data() {
      return {
        _chart: null,
        _plugins: this.plugins
      };
    },
    methods: {
      addPlugin: function addPlugin(plugin) {
        this.$data._plugins.push(plugin);
      },
      generateLegend: function generateLegend() {
        if (this.$data._chart) {
          return this.$data._chart.generateLegend();
        }
      },
      renderChart: function renderChart(data, options) {
        if (this.$data._chart) this.$data._chart.destroy();
        this.$data._chart = new Chart_default.a(this.$refs.canvas.getContext('2d'), {
          type: chartType,
          data: data,
          options: options,
          plugins: this.$data._plugins
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.$data._chart) {
        this.$data._chart.destroy();
      }
    }
  };
}
var Bar = generateChart('bar-chart', 'bar');
var HorizontalBar = generateChart('horizontalbar-chart', 'horizontalBar');
var Doughnut = generateChart('doughnut-chart', 'doughnut');
var Line = generateChart('line-chart', 'line');
var Pie = generateChart('pie-chart', 'pie');
var PolarArea = generateChart('polar-chart', 'polarArea');
var Radar = generateChart('radar-chart', 'radar');
var Bubble = generateChart('bubble-chart', 'bubble');
var Scatter = generateChart('scatter-chart', 'scatter');
/* harmony default export */ var BaseCharts = ({
  Bar: Bar,
  HorizontalBar: HorizontalBar,
  Doughnut: Doughnut,
  Line: Line,
  Pie: Pie,
  PolarArea: PolarArea,
  Radar: Radar,
  Bubble: Bubble,
  Scatter: Scatter
});
// CONCATENATED MODULE: ./node_modules/vue-chartjs/es/index.js
/* unused harmony export VueCharts */
/* unused concated harmony import Bar */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Bar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return HorizontalBar; });
/* unused concated harmony import Doughnut */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Doughnut; });
/* unused concated harmony import Line */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Line; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return Pie; });
/* unused concated harmony import PolarArea */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return PolarArea; });
/* unused concated harmony import Radar */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Radar; });
/* unused concated harmony import Bubble */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Bubble; });
/* unused concated harmony import Scatter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Scatter; });
/* unused concated harmony import mixins */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return mixins; });
/* unused concated harmony import generateChart */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return generateChart; });


var VueCharts = {
  Bar: Bar,
  HorizontalBar: HorizontalBar,
  Doughnut: Doughnut,
  Line: Line,
  Pie: Pie,
  PolarArea: PolarArea,
  Radar: Radar,
  Bubble: Bubble,
  Scatter: Scatter,
  mixins: mixins,
  generateChart: generateChart,
  render: function render() {
    return console.error('[vue-chartjs]: This is not a vue component. It is the whole object containing all vue components. Please import the named export or access the components over the dot notation. For more info visit https://vue-chartjs.org/#/home?id=quick-start');
  }
};
/* harmony default export */ var es = (VueCharts);


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */

// Opera 8.0+
var isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
var isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
}(!window['safari'] || safari.pushNotification);

// Internet Explorer 6-11
var isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
var isEdge = !isIE && !!window.StyleMedia;

// Chrome 1+
var isChrome = !!window.chrome && !!window.chrome.webstore;

// Blink engine detection
var isBlink = (isChrome || isOpera) && !!window.CSS;

var getBrowserName = exports.getBrowserName = function getBrowserName() {
    if (isOpera) {
        return 'Opera';
    } else if (isFirefox) {
        return 'Firefox';
    } else if (isSafari) {
        return 'Safari';
    } else if (isIE) {
        return 'Internet Explorer';
    } else if (isEdge) {
        return 'Edge';
    } else if (isChrome) {
        return 'Chrome';
    } else if (isBlink) {
        return 'Blink';
    } else {
        return 'Unknown';
    }
};

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;

var stack = [];

// exported for tests
var target = exports.target = null;
var _setTarget = exports._setTarget = function _setTarget(x) {
  exports.target = target = x;
};

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }
  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;
  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }
    newTarget.$sub.push(lastTarget);
  }
  return lastTarget;
}

function addParams(params) {
  if (typeof params === 'object' && !Array.isArray(params)) {
    exports.target = target = _extends({}, target, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();
    try {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (typeof paramsOrClosure === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }
  return withParamsClosure(paramsOrClosure);
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
  * vue-router v3.0.7
  * (c) 2019 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode && parent.$vnode.data;
      if (vnodeData) {
        if (vnodeData.routerView) {
          depth++;
        }
        if (vnodeData.keepAlive && parent._inactive) {
          inactive = true;
        }
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
      ? 'router-link-active'
      : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
      ? 'router-link-exact-active'
      : globalExactActiveClass;
    var activeClass = this.activeClass == null
      ? activeClassFallback
      : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
      ? exactActiveClassFallback
      : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
}

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    if (params.pathMatch) { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    return extend({}, raw)
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  window.history.replaceState({ key: getStateKey() }, '', absolutePath);
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(router, to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) { href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex); }
    else { href = decodeURI(href); }
  } else {
    if (searchIndex > -1) { href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex); }
  }

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(
    to,
    current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.7';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["default"] = (VueRouter);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var r=n();for(var t in r)("object"==typeof exports?exports:e)[t]=r[t]}}(this,function(){return function(e){function n(t){if(r[t])return r[t].exports;var o=r[t]={i:t,l:!1,exports:{}};return e[t].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=e,n.c=r,n.d=function(e,r,t){n.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:t})},n.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(r,"a",r),r},n.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},n.p="",n(n.s=0)}([function(e,n,r){"use strict";function t(e){u(F,e)}function o(){return F.id?[].concat(F.id):[]}function i(){}function a(e){return new Promise(function(n,r){var t=document.head||document.getElementsByTagName("head")[0],o=document.createElement("script");o.async=!0,o.src=e,o.charset="utf-8",t.appendChild(o),o.onload=n,o.onerror=r})}function c(e,n){var r=n.split("/"),t=e.split("/");return""===r[0]&&"/"===e[e.length-1]&&r.shift(),t.join("/")+r.join("/")}function u(e,n){return Object.keys(n).forEach(function(r){var t=e[r]&&Object.prototype.toString.call(e[r]);if("[object Object]"===t||"[object Array]"===t)return void u(e[r],n[r]);e[r]=n[r]}),e}function f(){return Array.prototype.slice.call(document.getElementsByTagName("script")).filter(function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")}).length>0}function s(){return!(_.checkDuplicatedScript&&f())}function l(e){return e.name||e.replace(/-/gi,"")}function d(){return new Promise(function(e,n){var r=setInterval(function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(r))},10)})}function p(e,n){if(o().length>1){return l(n)+"."+e}return e}function v(e){var n=Object.keys(e).reduce(function(n,r,t,o){var i=t===o.length-1;return n+=r+"="+e[r]+(i?"":"&")},"");return""!==n?"?"+n:""}function y(e){return[e.name,e.path].filter(Boolean).find(function(e){return-1!==_.ignoreRoutes.indexOf(e)})}function h(e){return e.query&&e.params}function g(e){return e.currentRoute}function m(e){if(Array.isArray(e)){for(var n=0,r=Array(e.length);n<e.length;n++)r[n]=e[n];return r}return Array.from(e)}function w(e){for(var n=arguments.length,r=Array(n>1?n-1:0),t=1;t<n;t++)r[t-1]=arguments[t];"undefined"!=typeof window&&o().forEach(function(n){var t={m:p(e,n),a:r};if(!window.ga)return void _.untracked.push(t);if(_.batch.enabled)$.push(t),U||(U=setInterval(function(){$.length?$.splice(0,_.batch.amount).forEach(function(e){var n;(n=window).ga.apply(n,[e.m].concat(m(e.a)))}):(clearInterval(U),U=null)},_.batch.delay));else{var o;(o=window).ga.apply(o,[p(e,n)].concat(r))}})}function b(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];if("object"==typeof n[0]&&n[0].constructor===Object)return void w("set",n[0]);w("set",n[0],n[1])}function k(){var e=o();_.debug.enabled&&(window.ga_debug={trace:_.debug.trace}),e.forEach(function(n){var r=l(n),t=_.customIdFields[n]||{},o=e.length>1?D({},_.fields,t,{name:r}):_.fields;window.ga("create",n.id||n,"auto",o)}),_.beforeFirstHit();var n=_.ecommerce;if(n.enabled){var r=n.enhanced?"ec":"ecommerce";n.options?w("require",r,n.options):w("require",r)}_.linkers.length>0&&(w("require","linker"),w("linker:autoLink",_.linkers)),_.debug.sendHitTask||b("sendHitTask",null)}function x(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];var t=n[0];if(1===n.length&&"string"==typeof t)return w("send","screenview",{screenName:t});w.apply(void 0,["send","screenview"].concat(n))}function A(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];if(!n.length||n[0]){var t=void 0;if(n.length&&g(n[0])&&(t=n[0].currentRoute),n.length&&h(n[0])&&(t=n[0]),t)O(t);else{b("page","object"==typeof n[0]?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))}}}function O(e){if(!y(e)){var n=_.autoTracking,r=e.meta.analytics,t=void 0===r?{}:r,o=t.pageviewTemplate||n.pageviewTemplate;if(n.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(n.screenview)return void x(e.name);if(o)A(o(e));else{var i=_.router,a=_.autoTracking,u=a.transformQueryString,f=a.prependBase,s=v(e.query),l=i&&i.options.base,d=f&&l,p=e.path+(u?s:"");p=d?c(l,p):p,A(p)}}}function j(){var e=_.router,n=_.autoTracking;n.page&&e&&(n.pageviewOnLoad&&e.history.ready&&O(e.currentRoute),_.router.afterEach(function(r,t){var o=n.skipSamePath,i=n.shouldRouterUpdate;o&&r.path===t.path||("function"!=typeof i||i(r,t))&&_.$vue.nextTick().then(function(){O(e.currentRoute)})}))}function E(e){if(Array.isArray(e)){for(var n=0,r=Array(e.length);n<e.length;n++)r[n]=e[n];return r}return Array.from(e)}function T(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];w.apply(void 0,["send","event"].concat(n))}function q(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];w.apply(void 0,["send","social"].concat(n))}function P(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];w.apply(void 0,["send","timing"].concat(n))}function R(e,n,r){return n in e?Object.defineProperty(e,n,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[n]=r,e}function L(e){if(Array.isArray(e)){for(var n=0,r=Array(e.length);n<e.length;n++)r[n]=e[n];return r}return Array.from(e)}function S(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};t(ae({},n,{$vue:e})),e.directive("ga",te),e.prototype.$ga=e.$ga=re,V(e),z()}Object.defineProperty(n,"__esModule",{value:!0});var I=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var r=arguments[n];for(var t in r)Object.prototype.hasOwnProperty.call(r,t)&&(e[t]=r[t])}return e},H={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:i,ready:i,untracked:[]},F=I({},H),_=F,B=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)},U=void 0,$=[],D=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var r=arguments[n];for(var t in r)Object.prototype.hasOwnProperty.call(r,t)&&(e[t]=r[t])}return e},M=function(){if(2==arguments.length)return void w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1]);w("require",arguments.length<=0?void 0:arguments[0])},N=function(){_.set.forEach(function(e){var n=e.field,r=e.value;if(void 0===n||void 0===r)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');b(n,r)})},C=function(){var e=["ec","ecommerce"];_.require.forEach(function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!=typeof n)throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var r=n.name||n;if(n.options)return void M(r,n.options);M(r)})},Q=function(){N(),C()},W=function(){_.untracked.forEach(function(e){w.apply(void 0,[e.m].concat(E(e.a)))})},G=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&o().forEach(function(n){window["ga-disable-"+n]=e})},z=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){var e=_.disableScriptLoader,n=_.ready,r=_.debug.enabled?"analytics_debug":"analytics",o=_.customResourceURL||"https://www.google-analytics.com/"+r+".js";if(!_.id)throw new Error('[vue-analytics] Missing the "id" parameter. Add at least one tracking domain ID');var i=[B(_.id),B(_.disabled)];return!s()||window.ga&&e||i.push(a(o).catch(function(){throw new Error("[vue-analytics] An error occured! Please check your connection, if you have any Google Analytics blocker installed in your browser or check your custom resource URL if you have added any.")})),Promise.all(i).then(function(e){t({id:e[0],disabled:e[1]}),G(_.disabled),k(),Q(),W(),j(),n()}).catch(function(e){console.error(e.message)})}},J=this,K=function(e){w("send","exception",{exDescription:e,exFatal:arguments.length>1&&void 0!==arguments[1]&&arguments[1]})},V=function(e){if(_.autoTracking.exception){window.addEventListener("error",function(e){K(e.message)});var n=e.config.errorHandler;e.config.errorHandler=function(e,r,t){K(e.message),_.autoTracking.exceptionLogs&&(console.error("[vue-analytics] Error in "+t+": "+e.message),console.error(e)),"function"==typeof n&&n.call(J,e,r,t)}}},X=K,Y=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var r=arguments[n];for(var t in r)Object.prototype.hasOwnProperty.call(r,t)&&(e[t]=r[t])}return e},Z=function(e){return(_.ecommerce.enhanced?"ec":"ecommerce")+":"+e},ee=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"],ne=ee.reduce(function(e,n){return Y({},e,R({},n,function(){for(var e=arguments.length,r=Array(e),t=0;t<e;t++)r[t]=arguments[t];w.apply(void 0,[Z(n)].concat(r))}))},{}),re={event:T,exception:X,page:A,query:w,require:M,set:b,social:q,time:P,screenview:x,ecommerce:ne,disable:function(){return G(!0)},enable:function(){return G(!1)},commands:_.commands},te={inserted:function(e,n,r){var t=Object.keys(n.modifiers);0===t.length&&t.push("click"),t.forEach(function(t){e.addEventListener(t,function(){var e="string"==typeof n.value?_.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(r.context)})})}},oe=function(){function e(e,n){var r=[],t=!0,o=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(t=(a=c.next()).done)&&(r.push(a.value),!n||r.length!==n);t=!0);}catch(e){o=!0,i=e}finally{try{!t&&c.return&&c.return()}finally{if(o)throw i}}return r}return function(n,r){if(Array.isArray(n))return n;if(Symbol.iterator in Object(n))return e(n,r);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),ie=function(e){e.subscribe(function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var r=n.meta.analytics;if(!Array.isArray(r))throw new Error('The "analytics" property needs to be an array');r.forEach(function(e){var n=void 0,r=e.shift(),t=e;if(r.includes(":")){var o=r.split(":"),i=oe(o,2);r=i[0],n=i[1]}if(!(r in re))throw new Error('[vue-analytics:vuex] The type "'+r+"\" doesn't exist.");if(n&&!(n in re[r]))throw new Error('[vue-analytics:vuex] The type "'+r+'" has not method "'+n+'".');if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'+r+'" needs to call a method. Check documentation.');if(n){var a;(a=re[r])[n].apply(a,L(t))}else re[r].apply(re,L(t))})}})};n.default=S,r.d(n,"analyticsMiddleware",function(){return ce}),r.d(n,"onAnalyticsReady",function(){return ue}),r.d(n,"event",function(){return fe}),r.d(n,"ecommerce",function(){return se}),r.d(n,"set",function(){return le}),r.d(n,"page",function(){return de}),r.d(n,"query",function(){return pe}),r.d(n,"screenview",function(){return ve}),r.d(n,"time",function(){return ye}),r.d(n,"require",function(){return he}),r.d(n,"exception",function(){return ge}),r.d(n,"social",function(){return me});var ae=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var r=arguments[n];for(var t in r)Object.prototype.hasOwnProperty.call(r,t)&&(e[t]=r[t])}return e},ce=ie,ue=d,fe=re.event,se=re.ecommerce,le=re.set,de=re.page,pe=re.query,ve=re.screenview,ye=re.time,he=re.require,ge=re.exception,me=re.social}])});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);
var settle = __webpack_require__(428);
var buildURL = __webpack_require__(430);
var parseHeaders = __webpack_require__(431);
var isURLSameOrigin = __webpack_require__(432);
var createError = __webpack_require__(175);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(433);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(429);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _storage = localStorage;

exports.default = {

    /**
     * Get booking period start date for the booking page from storage.
     */
    getBookingBookingStartDateFromStorage: function getBookingBookingStartDateFromStorage() {
        return _storage.getItem('bookingBookingStartDate');
    },


    /**
     * Get booking period end date for the booking page from storage.
     */
    getBookingBookingEndDateFromStorage: function getBookingBookingEndDateFromStorage() {
        return _storage.getItem('bookingBookingEndDate');
    },


    /**
     * Set booking period for the booking page in storage
     *
     * @param bookingPeriod
     */
    setBookingBookingPeriodInStorage: function setBookingBookingPeriodInStorage(bookingPeriod) {
        _storage.setItem('bookingBookingStartDate', bookingPeriod.from);
        _storage.setItem('bookingBookingEndDate', bookingPeriod.to);
    },


    /**
     * Get arrival period start date for the booking page from storage.
     */
    getBookingArrivalStartDateFromStorage: function getBookingArrivalStartDateFromStorage() {
        return _storage.getItem('bookingArrivalStartDate');
    },


    /**
     * Get arrival period end date for the booking page from storage
     */
    getBookingArrivalEndDateFromStorage: function getBookingArrivalEndDateFromStorage() {
        return _storage.getItem('bookingArrivalEndDate');
    },


    /**
     * Set arrival period for the booking page in storage
     *
     * @param arrivalPeriod
     */
    setBookingArrivalPeriodInStorage: function setBookingArrivalPeriodInStorage(arrivalPeriod) {
        _storage.setItem('bookingArrivalStartDate', arrivalPeriod.from);
        _storage.setItem('bookingArrivalEndDate', arrivalPeriod.to);
    }
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class BaseInterceptors
 */
var BaseInterceptors = function () {
    function BaseInterceptors() {
        _classCallCheck(this, BaseInterceptors);
    }

    _createClass(BaseInterceptors, null, [{
        key: "addBaseInterceptors",


        /**
         * Adds base interceptors to an AxiosInstance
         *
         * @param instance
         */
        value: function addBaseInterceptors(instance) {
            this._extractResponseFromError(instance);
        }

        /**
         * Extracts the response from an error, when a promise is rejected
         *
         * @param {AxiosInstance} instance
         * @private
         */

    }, {
        key: "_extractResponseFromError",
        value: function _extractResponseFromError(instance) {
            instance.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                return Promise.reject(error.response);
            });
        }
    }]);

    return BaseInterceptors;
}();

exports.default = BaseInterceptors;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * TokenService
 *
 * Service for extracting data from tokens
 */
exports.default = {

  /**
   * Returns the user object
   *
   * @returns {object}
   */
  user: function user(token) {
    var data = JSON.parse(atob(token.split('.')[1]));
    return data.user;
  },


  /**
   * Returns the supplier object
   *
   * @param token
   * @returns {supplier}
   */
  suppliers: function suppliers(token) {
    var data = JSON.parse(atob(token.split('.')[1]));
    return data.suppliers;
  },


  /**
   * Returns the issuer value
   *
   * @returns {string}
   */
  iss: function iss(token) {
    var data = JSON.parse(atob(token.split('.')[1]));
    return data.iss;
  },


  /**
   * Returns the issued at value
   *
   * @returns {string}
   */
  iat: function iat(token) {
    var data = JSON.parse(atob(token.split('.')[1]));
    return data.iat;
  },


  /**
   * Returns the expiration value
   *
   * @returns {string}
   */
  exp: function exp(token) {
    var data = JSON.parse(atob(token.split('.')[1]));
    return data.exp;
  }
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _storage = localStorage;
var _identifier = _config2.default.lang.LANGUAGE_IDENTIFIER;

exports.default = {

    /**
     * Get the chosen language value from storage. If none selected then return default value.
     *
     * @returns {string | null}
     */
    getLanguageFromStorage: function getLanguageFromStorage() {
        return _storage.getItem(_identifier);
    },


    /**
     * Save the chosen language in storage.
     *
     * @param language
     */
    setLanguageInStorage: function setLanguageInStorage(language) {
        _storage.setItem(_identifier, language);
    }
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Small language pack. Add more if needed.
exports.default = {
    en: 'English',
    de: 'German',
    it: 'italien',
    es: 'Spanish',
    nl: 'Dutch',
    hr: 'Croatian',
    fr: 'French'
};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51)))

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(17);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(130)(module)))

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enSG = moment.defineLocale('en-SG', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSG;

})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var itCh = moment.defineLocale('it-ch', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;

})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SearchService class
 */
var WindowService = exports.WindowService = function () {
    function WindowService() {
        _classCallCheck(this, WindowService);
    }

    _createClass(WindowService, null, [{
        key: "width",


        /**
         * Returns the width of the client's viewport
         *
         * @returns {number}
         */
        value: function width() {
            return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }

        /**
         * Returns the height of the client's viewport
         *
         * @returns {number}
         */

    }, {
        key: "height",
        value: function height() {
            return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        }

        /**
         * Returns breakpoint sizes
         *
         * @returns {{xs: number, sm: number, md: number}}
         */

    }, {
        key: "breakpoints",
        get: function get() {
            return {
                xs: 768,
                sm: 991,
                md: 1024,
                lg: 1200
            };
        }
    }]);

    return WindowService;
}();

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(5);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/lodash-es/lodash.js + 631 modules
var lodash = __webpack_require__(14);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DatePicker/DatePicker.vue






/* harmony default export */ var DatePicker = ({
    props: {
        startDate: {
            type: String,
            default: moment_default()().format('YYYY-MM-DD')
        },
        value: {
            type: Object,
            required: true
        },
        heading: {
            type: String,
            default: 'Select a date'
        },
        label: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            open: false,
            internalValue: vue_esm["default"].util.extend({}, this.value),
            currentMonth: moment_default()(this.startDate, 'YYYY-MM-DD').month(),
            currentYear: moment_default()(this.startDate, 'YYYY-MM-DD').year(),
            nextMonth: moment_default()(this.startDate, 'YYYY-MM-DD').month() !== 11 ? moment_default()(this.startDate, 'YYYY-MM-DD').month() + 1 : 0,
            nextYear: moment_default()(this.startDate, 'YYYY-MM-DD').month() !== 11 ? moment_default()(this.startDate, 'YYYY-MM-DD').year() : moment_default()(this.startDate, 'YYYY-MM-DD').year() + 1
        };
    },

    computed: {
        weekdayNames: function weekdayNames() {
            var days = [];
            var date = moment_default()(this.currentMonth + 1, 'M').startOf('isoWeek');

            Object(lodash["times"])(7, function () {
                days.push(date.format('dd').substr(0, 1));
                date.add(1, 'day');
            });

            return days;
        },
        currentMonthDays: function currentMonthDays() {
            var _this = this;

            var days = [];
            var date = moment_default()(this.currentYear + '-' + (this.currentMonth + 1), 'YYYY-M').startOf('isoWeek');

            Object(lodash["times"])(42, function () {
                days.push({
                    timestamp: date.format('YYYY-MM-DD'),
                    day: date.format('D'),
                    month: date.month(),
                    date: date,
                    inMonth: date.month() === _this.currentMonth
                });
                date.add(1, 'day');
            });

            return days;
        },
        nextMonthDays: function nextMonthDays() {
            var _this2 = this;

            var days = [];
            var date = moment_default()(this.nextYear + '-' + (this.nextMonth + 1), 'YYYY-M').startOf('isoWeek');

            Object(lodash["times"])(42, function () {
                days.push({
                    timestamp: date.format('YYYY-MM-DD'),
                    day: date.format('D'),
                    month: date.month(),
                    date: date,
                    inMonth: date.month() === _this2.nextMonth
                });
                date.add(1, 'day');
            });

            return days;
        },
        currentMonthName: function currentMonthName() {
            return moment_default()(this.currentMonth + 1, 'M').format('MMMM');
        },
        nextMonthName: function nextMonthName() {
            return moment_default()(this.nextMonth + 1, 'M').format('MMMM');
        }
    },
    watch: {
        value: function value() {
            this.internalValue.from = this.value.from;
            this.internalValue.to = this.value.to;
        }
    },
    methods: {
        selectDate: function selectDate(date) {
            if (this.internalValue.from && this.internalValue.to) {
                this.internalValue.to = undefined;
                this.internalValue.from = date.timestamp;
            } else if (!this.internalValue.from) {
                this.internalValue.from = date.timestamp;
            } else {
                if (this.internalValue.from > date.timestamp) {
                    this.internalValue.to = this.internalValue.from;
                    this.internalValue.from = date.timestamp;
                } else {
                    this.internalValue.to = date.timestamp;
                }
                this.syncMonth();
                this.update();
            }
        },
        update: function update() {
            this.syncMonth();
            this.$emit('input', {
                from: this.internalValue.from,
                to: this.internalValue.to
            });
            this.open = false;
        },
        prev: function prev() {
            if (this.currentMonth === 0) {
                this.currentMonth = 11;
                this.currentYear -= 1;
            } else {
                this.currentMonth -= 1;
            }

            if (this.nextMonth === 0) {
                this.nextMonth = 11;
                this.nextYear -= 1;
            } else {
                this.nextMonth -= 1;
            }
        },
        next: function next() {
            if (this.currentMonth === 11) {
                this.currentMonth = 0;
                this.currentYear += 1;
            } else {
                this.currentMonth += 1;
            }
            if (this.nextMonth === 11) {
                this.nextMonth = 0;
                this.nextYear += 1;
            } else {
                this.nextMonth += 1;
            }
        },
        syncMonth: function syncMonth() {
            // If from and to dates are within the same month the current month should be the selected month
            this.currentMonth = moment_default()(this.internalValue.from).month();
            this.currentYear = moment_default()(this.internalValue.from).year();

            if (this.currentMonth + 1 === 12) {
                this.nextMonth = 0;
                this.nextYear = this.currentYear + 1;
            } else {
                this.nextMonth = this.currentMonth + 1;
                this.nextYear = this.currentYear;
            }
        },
        hide: function hide($event) {
            if ($event.target.id === 'date-picker-container') {
                if (!this.internalValue.to) {
                    this.internalValue.to = this.internalValue.from;
                    this.update();
                }
                this.open = false;
            }
        },
        setThisDay: function setThisDay() {
            this.internalValue.from = moment_default()().format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().format('YYYY-MM-DD');
            this.update();
        },
        setThisWeek: function setThisWeek() {
            this.internalValue.from = moment_default()().startOf('isoWeek').format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().endOf('isoWeek').format('YYYY-MM-DD');
            this.update();
        },
        setThisMonth: function setThisMonth() {
            this.internalValue.from = moment_default()().startOf('month').format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().endOf('month').format('YYYY-MM-DD');
            this.update();
        },
        setThisYear: function setThisYear() {
            this.internalValue.from = moment_default()().startOf('year').format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().endOf('year').format('YYYY-MM-DD');
            this.update();
        },
        setLastDay: function setLastDay() {
            this.internalValue.from = moment_default()().subtract(1, 'days').format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().subtract(1, 'days').format('YYYY-MM-DD');
            this.update();
        },
        setLastWeek: function setLastWeek() {
            this.internalValue.from = moment_default()().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
            this.update();
        },
        setLastMonth: function setLastMonth() {
            this.internalValue.from = moment_default()().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            this.update();
        },
        setLastYear: function setLastYear() {
            this.internalValue.from = moment_default()().subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
            this.internalValue.to = moment_default()().subtract(1, 'years').endOf('year').format('YYYY-MM-DD');
            this.update();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60258140","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DatePicker/DatePicker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-picker"},[_c('div',{staticClass:"date-picker__option",on:{"click":function($event){_vm.open = true}}},[_c('div',{staticClass:"date-picker__option-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"date-picker__option-value"},[(_vm.internalValue.from)?_c('span',[_vm._v(_vm._s(_vm._f("moment")([_vm.internalValue.from, "YYYY-MM-DD"],"DD/MM/YYYY")))]):_vm._e(),_vm._v(" "),(_vm.internalValue.to)?_c('span',[_vm._v("- "+_vm._s(_vm._f("moment")([_vm.internalValue.to, "YYYY-MM-DD"],"DD/MM/YYYY")))]):_vm._e()])]),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"date-picker__container",attrs:{"id":"date-picker-container"},on:{"click":function($event){return _vm.hide($event)}}},[_c('div',{staticClass:"date-picker__body"},[_c('div',{staticClass:"date-picker__header"},[_vm._v("\n                "+_vm._s(_vm.heading)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"date-picker__calendars"},[_c('div',{staticClass:"date-picker__calendar"},[_c('div',{staticClass:"date-picker__controls"},[_c('div',{staticClass:"date-picker__button date-picker__button--prev",on:{"click":_vm.prev}},[_c('i',{staticClass:"fa fa-fw fa-angle-left"})]),_vm._v(" "),_c('div',{staticClass:"date-picker__description"},[_vm._v("\n                            "+_vm._s(_vm.currentMonthName)+", "+_vm._s(_vm.currentYear)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"date-picker__button date-picker__button--next",on:{"click":_vm.next}},[_c('i',{staticClass:"fa fa-fw fa-angle-right"})])]),_vm._v(" "),_c('div',{staticClass:"date-picker__weekdays"},_vm._l((_vm.weekdayNames),function(weekday,index){return _c('div',{key:index,staticClass:"date-picker__weekday"},[_vm._v(_vm._s(weekday))])}),0),_vm._v(" "),_c('div',{staticClass:"date-picker__month"},_vm._l((_vm.currentMonthDays),function(date){return _c('div',{key:date.timestamp,staticClass:"date-picker__date",class:{
                                 'date-picker__date--selected': date.timestamp >= _vm.internalValue.from && date.timestamp <= _vm.internalValue.to || date.timestamp === _vm.internalValue.from && !_vm.internalValue.to,
                                 'date-picker__date--out': !date.inMonth && !(date.timestamp >= _vm.internalValue.from && date.timestamp <= _vm.internalValue.to || date.timestamp === _vm.internalValue.from && !_vm.internalValue.to),
                                 'date-picker__date--outselect': !date.inMonth && (date.timestamp >= _vm.internalValue.from && date.timestamp <= _vm.internalValue.to || date.timestamp === _vm.internalValue.from && !_vm.internalValue.to)},on:{"click":function($event){return _vm.selectDate(date)}}},[_vm._v("\n                            "+_vm._s(date.day)+"\n                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"date-picker__calendar"},[_c('div',{staticClass:"date-picker__controls"},[_c('div',{staticClass:"date-picker__button date-picker__button--prev",on:{"click":_vm.prev}},[_c('i',{staticClass:"fa fa-fw fa-angle-left"})]),_vm._v(" "),_c('div',{staticClass:"date-picker__description"},[_vm._v("\n                            "+_vm._s(_vm.nextMonthName)+", "+_vm._s(_vm.nextYear)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"date-picker__button date-picker__button--next",on:{"click":_vm.next}},[_c('i',{staticClass:"fa fa-fw fa-angle-right"})])]),_vm._v(" "),_c('div',{staticClass:"date-picker__weekdays"},_vm._l((_vm.weekdayNames),function(weekday,index){return _c('div',{key:index,staticClass:"date-picker__weekday"},[_vm._v(_vm._s(weekday))])}),0),_vm._v(" "),_c('div',{staticClass:"date-picker__month"},_vm._l((_vm.nextMonthDays),function(date){return _c('div',{key:date.timestamp,staticClass:"date-picker__date",class:{
                                 'date-picker__date--selected': date.timestamp >= _vm.internalValue.from && date.timestamp <= _vm.internalValue.to || date.timestamp === _vm.internalValue.from && !_vm.internalValue.to,
                                 'date-picker__date--out': !date.inMonth && !(date.timestamp >= _vm.internalValue.from && date.timestamp <= _vm.internalValue.to || date.timestamp === _vm.internalValue.from && !_vm.internalValue.to),
                                 'date-picker__date--outselect': !date.inMonth && (date.timestamp >= _vm.internalValue.from && date.timestamp <= _vm.internalValue.to || date.timestamp === _vm.internalValue.from && !_vm.internalValue.to)},on:{"click":function($event){return _vm.selectDate(date)}}},[_vm._v("\n                            "+_vm._s(date.day)+"\n                        ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"date-picker__predefined"},[_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setLastDay}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.yesterday')))]),_vm._v(" "),_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setLastWeek}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.lastWeek')))]),_vm._v(" "),_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setLastMonth}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.lastMonth')))]),_vm._v(" "),_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setLastYear}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.lastYear')))]),_vm._v(" "),_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setThisDay}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.today')))]),_vm._v(" "),_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setThisWeek}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.thisWeek')))]),_vm._v(" "),_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setThisMonth}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.thisMonth')))]),_vm._v(" "),_c('a',{staticClass:"date-picker__predefined-link",on:{"click":_vm.setThisYear}},[_vm._v(_vm._s(_vm.$t('datePicker.predefinedLinks.thisYear')))])])])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/DatePicker/DatePicker.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  DatePicker,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var DatePicker_DatePicker = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Instruction/Instruction.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var Instruction = (vue_esm["default"].extend({
    props: {
        page: {
            type: String,
            required: true
        }
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        instruction: function instruction(state) {
            return state.instruction;
        }
    })),
    created: function created() {
        store_default.a.dispatch('instruction/getDismissStatus', this.page);
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        dismissInstruction: 'instruction/dismissInstruction'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-504d899f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Instruction/Instruction.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.instruction[_vm.page].dismiss)?_c('div',{staticClass:"instruction"},[_c('div',{staticClass:"instruction__content"},[_c('div',{staticClass:"instruction__heading"},[_c('div',{staticClass:"instruction__header"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t( _vm.instruction[_vm.page].header )))])])]),_vm._v(" "),_c('div',{staticClass:"instruction__body",domProps:{"innerHTML":_vm._s(_vm.$t( _vm.instruction[_vm.page].body ))}}),_vm._v(" "),_c('div',{staticClass:"instruction__dismiss"},[_c('button',{staticClass:"instruction__dismiss-btn",on:{"click":function($event){return _vm.dismissInstruction(_vm.page)}}},[_vm._v("\n                "+_vm._s(_vm.$t( 'instruction.dismiss' ))+"\n            ")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"instruction__header-icon"},[_c('i',{staticClass:"fa fa-book-open"})])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/Instruction/Instruction.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  Instruction,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var Instruction_Instruction = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractBreadcrumb/ContractBreadcrumb.vue

/* harmony default export */ var ContractBreadcrumb = ({
    props: {
        contract: {
            type: Object,
            default: null
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c1458a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractBreadcrumb/ContractBreadcrumb.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-breadcrumb"},[_c('div',{staticClass:"contract-breadcrumb__content"},[_c('router-link',{attrs:{"to":{name: 'contractManagementOverview'}}},[_vm._v("\n            "+_vm._s(_vm.$t('contract.breadcrumb.label'))+"\n        ")]),_vm._v(" "),(_vm.contract)?_c('span',[_c('i',{staticClass:"fa fa-angle-right"})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contract.supplierName))])],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ContractBreadcrumb/ContractBreadcrumb.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ContractBreadcrumb,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ContractBreadcrumb_ContractBreadcrumb = __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// EXTERNAL MODULE: ./src/components/PaginationControl/PaginationControl.vue + 2 modules
var PaginationControl = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementItem/ContractManagementItem.vue

/* harmony default export */ var ContractManagementItem = ({
    props: {
        supplier: {
            type: String,
            required: true
        },
        contractId: {
            type: Number,
            required: true
        },
        supplierId: {
            type: Number,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        lastUpdated: {
            type: String,
            default: ''
        },
        updatedBy: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            toggled: false
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0375b66","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementItem/ContractManagementItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-item"},[_c('div',{staticClass:"contract-management-item__header"},[_c('div',{staticClass:"contract-management-item__label"},[_vm._v("\n            "+_vm._s(_vm.supplier)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"contract-management-item__control",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('i',{staticClass:"fa fa-fw fa-info"})])]),_vm._v(" "),(_vm.toggled)?_c('div',{staticClass:"contract-management-item__content"},[_c('div',{staticClass:"contract-management-item__props"},[_c('div',{staticClass:"contract-management-item__prop"},[_c('div',{staticClass:"contract-management-item__prop-key"},[_vm._v("\n                    "+_vm._s(_vm.$t('contractManagement.list.status.label'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"contract-management-item__prop-value"},[_vm._v("\n                    "+_vm._s(_vm.$t('contractManagement.list.status.' + _vm.status))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"contract-management-item__prop"},[_c('div',{staticClass:"contract-management-item__prop-key"},[_vm._v("\n                    "+_vm._s(_vm.$t('contractManagement.list.lastUpdated'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"contract-management-item__prop-value"},[_vm._v("\n                    "+_vm._s(_vm._f("moment")(_vm.lastUpdated,"DD/MM/YYYY"))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"contract-management-item__prop"},[_c('div',{staticClass:"contract-management-item__prop-key"},[_vm._v("\n                    "+_vm._s(_vm.$t('contractManagement.list.updatedBy'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"contract-management-item__prop-value"},[_vm._v("\n                    "+_vm._s(_vm.updatedBy)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"contract-management-item__prop"},[_c('router-link',{staticClass:"contract-management-item__prop-button",attrs:{"to":{name: 'contractManagement', params: {contractId: _vm.contractId}}}},[(!_vm.url)?_c('span',[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "+_vm._s(_vm.$t('contractManagement.list.edit')))]):_vm._e(),_vm._v(" "),(_vm.url)?_c('span',[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "+_vm._s(_vm.$t('contractManagement.list.download')))]):_vm._e()])],1),_vm._v(" "),(_vm.status === 'readyForContractManager' || _vm.status === 'readyForSupplier')?_c('div',{staticClass:"contract-management-item__prop"},[_c('router-link',{staticClass:"contract-management-item__prop-button",attrs:{"to":{name: 'contract', params: {contractId: _vm.contractId, supplierId: _vm.supplierId}}}},[(!_vm.url)?_c('span',[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" "+_vm._s(_vm.$t('contractManagement.list.view')))]):_vm._e()])],1):_vm._e()])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ContractManagementItem/ContractManagementItem.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ContractManagementItem,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ContractManagementItem_ContractManagementItem = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementListFilters/ContractManagementListFilters.vue




/* harmony default export */ var ContractManagementListFilters = ({
    components: {
        DropdownMenu: DropdownMenu["a" /* default */],
        PaginationControl: PaginationControl["a" /* default */]
    },
    props: {
        contractListMaxPages: {
            type: Number,
            default: null
        },
        contractListPage: {
            type: Number,
            default: 1
        },
        show: {
            type: Boolean,
            default: false
        },
        showList: {
            type: Array,
            default: null
        },
        years: {
            type: Array,
            default: null
        },
        year: {
            type: String,
            default: null
        },
        limits: {
            type: Array,
            default: null
        },
        limit: {
            type: String,
            default: null
        },
        filters: {
            type: Array,
            default: null
        },
        filter: {
            type: String,
            default: null
        },
        search: {
            type: String,
            default: null
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7abe3ef0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementListFilters/ContractManagementListFilters.vue
var ContractManagementListFilters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-list-filters"},[_c('div',{staticClass:"contract-management-list-filters__option"},[_c('div',{staticClass:"contract-management-list-filters__pagination"},[_c('pagination-control',{attrs:{"current-page":_vm.page,"max-pages":_vm.contractListMaxPages},on:{"prev":function($event){return _vm.$emit('pageDecrement')},"next":function($event){return _vm.$emit('pageIncrement')}}})],1)]),_vm._v(" "),_c('div',{staticClass:"contract-management-list-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('contractManagement.list.show.label'),"value":_vm.show,"items":_vm.showList,"searchable":false,"translation-prefix":'contractManagement.list.show'},on:{"input":function($event){return _vm.$emit('setShow', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"contract-management-list-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('contractManagement.list.year'),"value":_vm.year,"items":_vm.years,"searchable":false},on:{"input":function($event){return _vm.$emit('setYear', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"contract-management-list-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('contractManagement.list.perPage'),"value":_vm.limit,"items":_vm.limits,"searchable":false},on:{"input":function($event){return _vm.$emit('setLimit', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"contract-management-list-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('contractManagement.list.display.label'),"value":_vm.filter,"items":_vm.filters,"enable-deselect":true,"undefined-value":_vm.$t('contractManagement.list.display.all'),"translation-prefix":'contractManagement.list.status'},on:{"input":function($event){return _vm.$emit('setFilter', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"contract-management-list-filters__option"},[_c('input',{staticClass:"contract-management-list-filters__search-input",attrs:{"placeholder":_vm.$t('booking.filterText'),"type":"text"},domProps:{"value":_vm.search},on:{"input":function($event){return _vm.$emit('search', $event.target.value)}}})])])}
var ContractManagementListFilters_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementListFilters/ContractManagementListFilters.vue
/* script */


/* template */

/* template functional */
var ContractManagementListFilters___vue_template_functional__ = false
/* styles */
var ContractManagementListFilters___vue_styles__ = null
/* scopeId */
var ContractManagementListFilters___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementListFilters___vue_module_identifier__ = null

var ContractManagementListFilters_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementListFilters,
  ContractManagementListFilters_render,
  ContractManagementListFilters_staticRenderFns,
  ContractManagementListFilters___vue_template_functional__,
  ContractManagementListFilters___vue_styles__,
  ContractManagementListFilters___vue_scopeId__,
  ContractManagementListFilters___vue_module_identifier__
)

/* harmony default export */ var ContractManagementListFilters_ContractManagementListFilters = (ContractManagementListFilters_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementList/ContractManagementList.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var ContractManagementList = (vue_esm["default"].extend({
    components: {
        DropdownMenu: DropdownMenu["a" /* default */],
        PaginationControl: PaginationControl["a" /* default */],
        ContractManagementItem: ContractManagementItem_ContractManagementItem,
        ContractManagementListFilters: ContractManagementListFilters_ContractManagementListFilters
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        items: function items(state) {
            return state.contract.overview.items;
        },
        limits: function limits(state) {
            return state.contract.overview.limits;
        },
        limit: function limit(state) {
            return state.contract.overview.limit;
        },
        filter: function filter(state) {
            return state.contract.overview.filter;
        },
        filters: function filters(state) {
            return state.contract.overview.filters;
        },
        page: function page(state) {
            return state.contract.overview.page;
        },
        year: function year(state) {
            return state.contract.overview.year;
        },
        years: function years(state) {
            return state.contract.overview.years;
        },
        show: function show(state) {
            return state.contract.overview.show;
        },
        showList: function showList(state) {
            return state.contract.overview.showList;
        },
        search: function search(state) {
            return state.contract.overview.search;
        }
    }), Object(vuex_esm["mapGetters"])({
        contractListFilteredPaginated: 'contract/contractListFilteredPaginated',
        contractListMaxPages: 'contract/contractListMaxPages'
    })),
    mounted: function mounted() {
        this.contractManagementListSearchSet('');
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        contractManagementListShowSet: 'contract/contractManagementListShowSet',
        contractManagementListLimitSet: 'contract/contractManagementListLimitSet',
        contractManagementListYearSet: 'contract/contractManagementListYearSet',
        contractManagementListSearchSet: 'contract/contractManagementListSearchSet',
        contractManagementListFilterSelect: 'contract/contractManagementListFilterSelect',
        contractManagementListPageIncrement: 'contract/contractManagementListPageIncrement',
        contractManagementListPageDecrement: 'contract/contractManagementListPageDecrement',
        contractManagementListContractSelect: 'contract/contractManagementListContractSelect',
        downloadContract: 'contract/downloadContract'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec2880f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementList/ContractManagementList.vue
var ContractManagementList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-list"},[_c('div',{key:'body',staticClass:"contract-management-list__body"},[_c('div',{staticClass:"contract-management-list__header"},[_c('div',{staticClass:"contract-management-list__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contractManagement.list.heading.header'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"contract-management-list__filters"},[_c('contract-management-list-filters',{attrs:{"contract-list-max-pages":_vm.contractListMaxPages,"contract-list-page":_vm.page,"show":_vm.show,"show-list":_vm.showList,"years":_vm.years,"year":_vm.year,"limits":_vm.limits,"limit":_vm.limit,"filters":_vm.filters,"filter":_vm.filter,"search":_vm.search},on:{"pageDecrement":_vm.contractManagementListPageDecrement,"pageIncrement":_vm.contractManagementListPageIncrement,"setShow":_vm.contractManagementListShowSet,"setYear":_vm.contractManagementListYearSet,"setFilter":_vm.contractManagementListFilterSelect,"setLimit":_vm.contractManagementListLimitSet,"search":_vm.contractManagementListSearchSet}})],1)]),_vm._v(" "),_c('table',{staticClass:"contract-management-list__table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('contractManagement.list.supplier')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('contractManagement.list.status.label')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('contractManagement.list.lastUpdated')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('contractManagement.list.updatedBy')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.contractListFilteredPaginated),function(contract,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(contract.supplierName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('contractManagement.list.status.' + contract.status)))]),_vm._v(" "),_c('td',[(contract.lastModifiedAt)?_c('span',[_vm._v(_vm._s(_vm._f("moment")(contract.lastModifiedAt,"DD/MM/Y\, HH:mm")))]):_vm._e()]),_vm._v(" "),_c('td',[(contract.lastModifiedBy)?_c('span',[_vm._v(_vm._s(contract.lastModifiedBy))]):_vm._e()]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"contract-management-list__btn contract-management-list__btn-edit",attrs:{"to":{name: 'contractManagement', params: {contractId: contract.contractId, supplierId: contract.supplierId}}}},[_c('span',[_vm._v(_vm._s(_vm.$t('contractManagement.list.edit')))])]),_vm._v(" "),(!contract.contractS3 && contract.readyForReview)?_c('router-link',{staticClass:"contract-management-list__btn contract-management-list__btn-edit",attrs:{"to":{name: 'contract', params: {contractId: contract.contractId, supplierId: contract.supplierId}}}},[(!contract.readyForSupplier)?_c('span',[_vm._v(_vm._s(_vm.$t('contractManagement.list.view')))]):_vm._e(),_vm._v(" "),(contract.readyForSupplier)?_c('span',[_vm._v(_vm._s(_vm.$t('contractManagement.list.viewSupplier')))]):_vm._e()]):_vm._e(),_vm._v(" "),(contract.contractS3)?_c('div',{staticClass:"contract-management-list__btn contract-management-list__btn-download",on:{"click":function($event){return _vm.downloadContract(contract.contractS3)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('contractManagement.list.download'))+"\n                        ")]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('div',{staticClass:"contract-management-list__items"},[_c('div',{staticClass:"contract-management-list__items-list"},_vm._l((_vm.contractListFilteredPaginated),function(contract){return _c('contract-management-item',{key:contract.contractId,attrs:{"supplier":contract.supplierName,"contract-id":contract.contractId,"supplier-id":contract.supplierId,"status":contract.status,"last-updated":contract.lastModifiedAt,"updated-by":contract.lastModifiedBy,"url":contract.contractS3}})}),1)]),_vm._v(" "),(!_vm.contractListFilteredPaginated.length)?_c('div',{key:'no-content',staticClass:"contract-management-list__error"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"contract-management-list__error-message"},[_vm._v(_vm._s(_vm.$t('contractManagement.list.noContracts')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-management-list__footer"},[_c('div',{staticClass:"contract-management-list__pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.contractListMaxPages,"current-page":_vm.page},on:{"prev":_vm.contractManagementListPageDecrement,"next":_vm.contractManagementListPageIncrement}})],1)])])])}
var ContractManagementList_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementList/ContractManagementList.vue
/* script */


/* template */

/* template functional */
var ContractManagementList___vue_template_functional__ = false
/* styles */
var ContractManagementList___vue_styles__ = null
/* scopeId */
var ContractManagementList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementList___vue_module_identifier__ = null

var ContractManagementList_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementList,
  ContractManagementList_render,
  ContractManagementList_staticRenderFns,
  ContractManagementList___vue_template_functional__,
  ContractManagementList___vue_styles__,
  ContractManagementList___vue_scopeId__,
  ContractManagementList___vue_module_identifier__
)

/* harmony default export */ var ContractManagementList_ContractManagementList = __webpack_exports__["a"] = (ContractManagementList_Component.exports);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Handle the login navigation which should redirect to the referrer page if requesting
 * Marketplace page without being logged in, an to redirect when logged out. Else direct
 * to base page for either supplier or contract managers.
 *
 * @param router
 * @param user
 * @param referrer
 */
var handleLoginNavigation = exports.handleLoginNavigation = function handleLoginNavigation(router, user, referrer) {
    if (referrer !== undefined && referrer !== '/') {
        router.push(referrer);
    } else {
        if (user.contractManager) {
            router.push('dashboard/allocation');
        } else {
            router.push('dashboard');
        }
    }
};

/**
 * Get the path to site or accommodation in Twenty.
 *
 * @param subPart
 * @param id
 * @returns {string}
 */
var getContractItemTwentyPath = exports.getContractItemTwentyPath = function getContractItemTwentyPath(subPart, id) {
    var type = subPart === 'siteInfo' ? 'sites' : 'accommodations';
    return "https://backend.twentybook.com" + '/production/products/' + type + '/' + id + '/edit';
};

/**
 *
 * Get the path to create a new site or accommodation in Twenty.
 *
 * @param subPath
 * @returns {string}
 */
var getContractItemCreatePath = exports.getContractItemCreatePath = function getContractItemCreatePath(subPath) {
    var type = subPath === 'siteInfo' ? 'sites' : 'accommodations';
    return "https://backend.twentybook.com" + '/production/products/' + type + '/products';
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(128);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    /**
     * Get ip info.
     *
     * @returns {AxiosPromise<any>}
     */
    getIpInfo: function getIpInfo() {
        return _axios2.default.get(_config2.default.auth.AUTH_TOKEN_IP_INFO_URL, {
            headers: {
                Authorization: 'Bearer ' + _config2.default.auth.AUTH_TOKEN_IP_INFO
            }
        });
    }
};

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vuelidate = __webpack_require__(418);

var _vuelidate2 = _interopRequireDefault(_vuelidate);

var _App = __webpack_require__(420);

var _App2 = _interopRequireDefault(_App);

var _vueRouter = __webpack_require__(171);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

var _routes = __webpack_require__(82);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(563);

var _vuexRouterSync = __webpack_require__(569);

var _vueI18n = __webpack_require__(570);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _messages = __webpack_require__(571);

var _messages2 = _interopRequireDefault(_messages);

var _filters = __webpack_require__(579);

var _filters2 = _interopRequireDefault(_filters);

var _directives = __webpack_require__(581);

var _directives2 = _interopRequireDefault(_directives);

var _vueMoment = __webpack_require__(583);

var _vueMoment2 = _interopRequireDefault(_vueMoment);

var _shortNumber = __webpack_require__(584);

var _shortNumber2 = _interopRequireDefault(_shortNumber);

var _vMask = __webpack_require__(586);

var _vMask2 = _interopRequireDefault(_vMask);

var _vueProgressbar = __webpack_require__(587);

var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);

var _languages = __webpack_require__(182);

var _languages2 = _interopRequireDefault(_languages);

var _LanguageService = __webpack_require__(181);

var _LanguageService2 = _interopRequireDefault(_LanguageService);

var _vueRollbar = __webpack_require__(588);

var _vueRollbar2 = _interopRequireDefault(_vueRollbar);

var _rollbar = __webpack_require__(590);

var _rollbar2 = _interopRequireDefault(_rollbar);

var _vueAnalytics = __webpack_require__(172);

var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Register vue handlers
_vue2.default.config.errorHandler = function (err, vm, info) {
    if (_vue2.default.rollbar !== 'undefined') {
        _vue2.default.rollbar.error(err + '\n\n' + info + '\n\n');
    }
    console.error(err + '\n\n' + info + '\n\n');
}; /* eslint-disable */

_vue2.default.config.warnHandler = function (msg, vm, trace) {
    if (_vue2.default.rollbar !== 'undefined') {
        _vue2.default.rollbar.warning(msg + '\n\n' + trace + '\n\n');
    }
    console.warn(msg + '\n\n' + trace + '\n\n');
};

_vue2.default.use(_vueRollbar2.default, _rollbar2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuelidate2.default);
_vue2.default.use(_vueI18n2.default);
_vue2.default.use(_filters2.default);
_vue2.default.use(_directives2.default);
_vue2.default.use(_vueMoment2.default);
_vue2.default.use(_shortNumber2.default);
_vue2.default.use(_vMask2.default);
_vue2.default.use(_vueProgressbar2.default, {
    color: '#ffffff',
    failedColor: '#D95A4B'
});

// Google Analytics
_vue2.default.use(_vueAnalytics2.default, {
    id: 'UA-123342655-1',
    debug: {
        enabled: "production" !== 'production',
        sendHitTask: "production" === 'production'
    },
    router: _routes2.default
});

var i18n = new _vueI18n2.default({
    locale: _LanguageService2.default.getLanguageFromStorage() || 'en',
    fallbackLocale: 'en',
    silentTranslationWarn: "production" === 'production',
    messages: _messages2.default
});

_vue2.default.prototype.$locale = {
    change: function change(language) {
        var msg = { success: true, text: 'Language changed' };
        if (i18n.messages[language].valid) {
            i18n.locale = language;
            _LanguageService2.default.setLanguageInStorage(language);
        } else {
            msg = { success: false, text: 'Translations missing, displaying default language' };
            _LanguageService2.default.setLanguageInStorage(i18n.fallbackLocale);
        }
        return msg;
    },
    current: function current() {
        return i18n.locale;
    },
    getValidLanguages: function getValidLanguages() {
        var languages = [];
        // Only return valid languages
        for (var language in i18n.messages) {
            if (i18n.messages[language].valid) {
                languages.push({ value: language, name: _languages2.default[language] });
            }
        }
        return languages;
    }
};

(0, _vuexRouterSync.sync)(_store2.default, _routes2.default);

var app = new _vue2.default({
    el: '#app',
    router: _routes2.default,
    store: _store2.default,
    i18n: i18n,
    render: function render(h) {
        return h(_App2.default);
    }
});

exports.default = app;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(417);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(169)))

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = exports.validationMixin = exports.Vuelidate = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vval = __webpack_require__(419);

var _params = __webpack_require__(170);

var NUL = function NUL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (typeof val === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');
  for (var i = 0; i < path.length; i++) {
    if (obj && typeof obj === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';
function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true, // pending
      v: false // value
    }
  });

  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });

  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }
    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $pending: function $pending() {
    var _this3 = this;

    return this.ruleKeys.some(function (key) {
      return _this3.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this4 = this;

    var vals = this.validations;
    return _extends({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), buildFromKeys(this.ruleKeys, function (key) {
      return _this4.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];
    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();
        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }
        params = params.concat(childParams);
      } else {
        params.push({ path: [], name: key, params: this.$params[key] });
      }
    }
    return params;
  }
};

var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);

var _cachedComponent = null;
var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
      }
    },

    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();
        if (model) {
          return model[key];
        }
      }
    },
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};
        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });
        return refs;
      }
    }
  });

  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },

    methods: {
      runRule: function runRule(parent) {
        // Avoid using this.lazyParentModel to not get dependent on it.
        // Passed as an argument for workaround
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;

        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;

        return { output: output, params: params };
      }
    },
    computed: {
      run: function run() {
        return this.runRule(this.lazyParentModel());
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;
        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }
        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;
        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }
        return false;
      }
    }
  });

  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },

    methods: _extends({}, validationMethods, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _extends({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this5 = this;

        return this.keys.filter(function (k) {
          return !_this5.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this6 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true, // allow mocking lib calls
            get: function get() {
              return _this6.refProxy(key);
            }
          };
        });

        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this6[key];
            }
          };
        });

        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this6[key];
            }
          };
        });

        return Object.defineProperties({}, _extends({}, keyDefs, getterDefs, methodDefs));
      },
      children: function children() {
        var _this7 = this;

        return [].concat(this.nestedKeys.map(function (key) {
          return renderNested(_this7, key);
        }), this.ruleKeys.map(function (key) {
          return renderRule(_this7, key);
        })).filter(Boolean);
      }
    })
  });

  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            // default to invalid
            return vm.validations[key]() || false;
          }
        };
      }
    }
  });

  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();
        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this8 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return '' + getPath(_this8.rootModel, _this8.getModelKey(key), trackBy);
        } : function (x) {
          return '' + x;
        };
      },
      eagerParentModel: function eagerParentModel() {
        var parent = this.lazyParentModel();
        return function () {
          return parent;
        };
      },
      children: function children() {
        var _this9 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _extends({}, def);
        delete validations['$trackBy'];

        var usedTracks = {};

        return this.keys.map(function (key) {
          var track = _this9.tracker(key);
          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }
          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this9.eagerParentModel,
            model: model[key],
            rootModel: _this9.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }
    var validations = vm.validations[key];
    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NUL,
        prop: key,
        lazyModel: NUL,
        rootModel: root
      });
    }
    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = { VBase: VBase, Validation: Validation };
  return _cachedComponent;
};

var _cachedVue = null;
function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;
  /* istanbul ignore next */
  while (Vue.super) {
    Vue = Vue.super;
  }_cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;

        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NUL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;
    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }
    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;
    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();
      this._vuelidate = null;
    }
  }
};

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

exports.Vuelidate = Vuelidate;
exports.validationMixin = validationMixin;
exports.withParams = _params.withParams;
exports.default = Vuelidate;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;
// a minimial single-layer implementation
// of virtual-validation patching,
// based on Vue's snabbdom clone

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({ data: vval.args });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);
  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i = void 0,
      key = void 0;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }
  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx = void 0,
      idxInOld = void 0,
      elmToMove = void 0;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx]; // Vval has been moved left
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      // Vval moved right
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      // Vval moved left
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;
      if (isUndef(idxInOld)) {
        // New element
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];
        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          // same key but different element. treat as new element
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }
  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];
    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }
  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return { tag: tag, key: key, args: args };
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
    mounted: function mounted() {
        //  [App.vue specific] When App.vue is finish loading finish the progress bar
        this.$Progress.finish();
    },
    created: function created() {
        var _this = this;

        //  [App.vue specific] When App.vue is first loaded start the progress bar
        this.$Progress.start();
        //  hook the progress bar to start before we move router-view
        this.$router.beforeEach(function (to, from, next) {
            //  does the page we want to go to have a meta.progress object
            if (to.meta.progress !== undefined) {
                var meta = to.meta.progress;
                // parse meta tags
                _this.$Progress.parseMeta(meta);
            }
            //  start the progress bar
            _this.$Progress.start();
            //  continue to next page
            next();
        });
        //  hook the progress bar to finish after we've finished moving router-view
        this.$router.afterEach(function () {
            //  finish the progress bar
            _this.$Progress.finish();
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cce3c60","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('vue-progress-bar')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/App/App.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  App,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var App_App = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(422);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(503);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(504);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(505);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    getters: getters,
    actions: actions
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkIfOnlySupplierInProductType = exports.setProductTypes = exports.setProductType = exports.setSupplier = exports.getSuppliersAndProducts = exports.unsetReferrer = exports.setReferrer = exports.setSignInMessage = exports.setUser = exports.unauthenticate = exports.activate = exports.resetPassword = exports.forgotPassword = exports.authenticate = undefined;

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _TokenExtractionService = __webpack_require__(180);

var _TokenExtractionService2 = _interopRequireDefault(_TokenExtractionService);

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _LanguageService = __webpack_require__(181);

var _LanguageService2 = _interopRequireDefault(_LanguageService);

var _languages = __webpack_require__(182);

var _languages2 = _interopRequireDefault(_languages);

var _routes = __webpack_require__(82);

var _routes2 = _interopRequireDefault(_routes);

var _NavigationService = __webpack_require__(211);

var _StorageService = __webpack_require__(100);

var storageService = _interopRequireWildcard(_StorageService);

var _ConverterService = __webpack_require__(50);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Authenticates a user
 *
 * @param context
 * @param email
 * @param pass
 */
var authenticate = exports.authenticate = function authenticate(_ref, _ref2) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;
    var email = _ref2.email,
        pass = _ref2.pass;

    commit(CONSTANTS.AUTH_LOGIN_PENDING);

    // Clear the state and token to ensure no deprecated data is present
    storageService.clear();
    _TokenStorageService2.default.del();

    return _GatewayService2.default.authenticate(email, pass).then(function (res) {
        var token = res.data.data;
        _TokenStorageService2.default.set(token);
        var data = {
            user: _TokenExtractionService2.default.user(token),
            suppliers: _TokenExtractionService2.default.suppliers(token)
        };
        commit(CONSTANTS.AUTH_LOGIN_SUCCESS, data);
        // If the user hasn't specified a language then set language to default fro user
        var userLanguage = _LanguageService2.default.getLanguageFromStorage() || _TokenExtractionService2.default.user(token).language;
        var language = {
            value: userLanguage,
            name: _languages2.default[userLanguage]
        };
        commit('nav/NAV_MENU_TOGGLE', false, { root: true });
        commit('nav/' + CONSTANTS.LANGUAGE_SELECT, language, { root: true });

        dispatch('getSuppliersAndProducts').then(function () {
            // Handle navigation
            var referrer = state.referrer;
            (0, _NavigationService.handleLoginNavigation)(_routes2.default, data.user, referrer);
        });
    }).catch(function (err) {
        if (err.status === 401) {
            commit(CONSTANTS.AUTH_LOGIN_FAILURE, {
                level: 'warning',
                text: 'signIn.messages.mismatch'
            });
        } else {
            commit(CONSTANTS.AUTH_LOGIN_FAILURE, {
                level: 'error',
                text: 'signIn.messages.unexpected'
            });
        }
    });
};

/**
 * Sends a forgot password request
 *
 * @param context
 * @param email
 * @returns {*|PromiseLike<T>|Promise<T>}
 */
var forgotPassword = exports.forgotPassword = function forgotPassword(_ref3, _ref4) {
    var commit = _ref3.commit;
    var email = _ref4.email;

    commit(CONSTANTS.AUTH_FORGOT_PENDING);
    return _GatewayService2.default.forgotPassword(email).then(function () {
        commit(CONSTANTS.AUTH_FORGOT_SUCCESS, {
            level: 'success',
            text: 'forgotPassword.messages.success'
        });
    }).catch(function (err) {
        if (err.status === 401) {
            commit(CONSTANTS.AUTH_FORGOT_FAILURE, {
                level: 'warning',
                text: 'forgotPassword.messages.noexist'
            });
        } else {
            commit(CONSTANTS.AUTH_FORGOT_FAILURE, {
                level: 'error',
                text: 'forgotPassword.messages.unexpected'
            });
        }
    });
};

/**
 * Sends a reset password request
 *
 * @param context
 * @param pass
 * @param token
 * @returns {*|PromiseLike<T>|Promise<T>}
 */
var resetPassword = exports.resetPassword = function resetPassword(_ref5, _ref6) {
    var commit = _ref5.commit;
    var pass = _ref6.pass,
        token = _ref6.token;

    commit(CONSTANTS.AUTH_RESET_PENDING);
    return _GatewayService2.default.resetPassword(pass, token).then(function () {
        commit(CONSTANTS.AUTH_RESET_SUCCESS, {
            level: 'success',
            text: 'resetPassword.messages.success'
        });
    }).catch(function (err) {
        if (err.status === 400) {
            commit(CONSTANTS.AUTH_RESET_FAILURE, {
                level: 'warning',
                text: 'resetPassword.messages.mismatch'
            });
        } else if (err.status === 409) {
            commit(CONSTANTS.AUTH_RESET_FAILURE, {
                level: 'warning',
                text: 'resetPassword.messages.token'
            });
        } else {
            commit(CONSTANTS.AUTH_RESET_FAILURE, {
                level: 'error',
                text: 'resetPassword.messages.unexpected'
            });
        }
        return Promise.reject();
    });
};

/**
 * Sends an activate user request
 *
 * @param context
 * @param pass
 * @param token
 * @returns {*}
 */
var activate = exports.activate = function activate(_ref7, _ref8) {
    var commit = _ref7.commit;
    var pass = _ref8.pass,
        token = _ref8.token;

    commit(CONSTANTS.AUTH_ACTIVATION_PENDING);
    return _GatewayService2.default.activate(pass, token).then(function () {
        commit(CONSTANTS.AUTH_ACTIVATION_SUCCESS, {
            level: 'success',
            text: 'activateUser.messages.success'
        });
    }).catch(function (err) {
        if (err.status === 400) {
            commit(CONSTANTS.AUTH_ACTIVATION_FAILURE, {
                level: 'warning',
                text: 'activateUser.messages.mismatch'
            });
        } else if (err.status === 409) {
            commit(CONSTANTS.AUTH_ACTIVATION_FAILURE, {
                level: 'warning',
                text: 'activateUser.messages.token'
            });
        } else {
            commit(CONSTANTS.AUTH_ACTIVATION_FAILURE, {
                level: 'error',
                text: 'activateUser.messages.unexpected'
            });
        }
    });
};

/**
 * Unauthenticates the user
 *
 * @param context
 * @param payload
 */
var unauthenticate = exports.unauthenticate = function unauthenticate(_ref9, payload) {
    var commit = _ref9.commit;

    if (typeof payload !== 'undefined') {
        commit(CONSTANTS.AUTH_MESSAGE_SET, payload);
        if (payload.text === 'signIn.logoutNotice') {
            commit(CONSTANTS.AUTH_REFERRER_UNSET);
        }
    }
    storageService.clear();
    _TokenStorageService2.default.del();
    _routes2.default.push('/');
    commit(CONSTANTS.AUTH_USER_UNSET);
    commit(CONSTANTS.AUTH_SUPPLIER_UNSET);
};

/**
 * Updates the user in state
 *
 * @param context
 * @param user
 */
var setUser = exports.setUser = function setUser(_ref10, _ref11) {
    var commit = _ref10.commit;
    var user = _ref11.user;

    // If the user hasn't specified a language then set language to default fro user
    var userLanguage = _LanguageService2.default.getLanguageFromStorage() || user.language;
    var language = {
        value: userLanguage,
        name: _languages2.default[userLanguage]
    };
    commit('nav/' + CONSTANTS.LANGUAGE_SELECT, language, { root: true });
    commit(CONSTANTS.AUTH_USER_SET, user);
};

/**
 * Sets a login notice notice
 */
var setSignInMessage = exports.setSignInMessage = function setSignInMessage(_ref12, payload) {
    var commit = _ref12.commit;

    commit(CONSTANTS.AUTH_MESSAGE_SET, payload);
};

/**
 * Sets the referrer path of the client to use for navigation back to requested page.
 *
 * @param commit
 * @param payload
 */
var setReferrer = exports.setReferrer = function setReferrer(_ref13, payload) {
    var commit = _ref13.commit;

    commit(CONSTANTS.AUTH_REFERRER_SET, payload);
};

/**
 * Unset the referrer path-
 *
 * @param commit
 */
var unsetReferrer = exports.unsetReferrer = function unsetReferrer(_ref14) {
    var commit = _ref14.commit;

    commit(CONSTANTS.AUTH_REFERRER_UNSET);
};

/**
 * Get suppliers and products object for the nav menu.
 *
 * @param commit
 * @param dispatch
 * @returns {Promise<T | never>}
 */
var getSuppliersAndProducts = exports.getSuppliersAndProducts = function getSuppliersAndProducts(_ref15) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    commit(CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING);
    var token = _TokenStorageService2.default.get();
    var suppliersAndProducts = storageService.get('suppliersAndProducts');

    if (suppliersAndProducts) {
        commit(CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS, suppliersAndProducts);
        var productTypeAndSupplier = (0, _ConverterService.getProductTypesAndSuppliersFromSuppliersProductsObject)(suppliersAndProducts);
        dispatch('setSupplier', { supplier: productTypeAndSupplier.supplier, overwrite: false });
        dispatch('setProductType', { productType: productTypeAndSupplier.productType, overwrite: false });
        dispatch('setProductTypes', productTypeAndSupplier.productTypes);
    } else {
        return _GatewayService2.default.getSuppliersAndProducts(token).then(function (res) {
            var data = res.data.data;
            commit(CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS, data);
            var productTypeAndSupplier = (0, _ConverterService.getProductTypesAndSuppliersFromSuppliersProductsObject)(data);
            dispatch('setSupplier', { supplier: productTypeAndSupplier.supplier, overwrite: true });
            dispatch('setProductType', { productType: productTypeAndSupplier.productType, overwrite: true });
            dispatch('setProductTypes', productTypeAndSupplier.productTypes);
            storageService.save('suppliersAndProducts', data);
        }).catch(function () {
            commit(CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE);
        });
    }
};

/**
 * Set the supplier.
 * Save for the session to ensure easy navigation.
 *
 * @param commit
 * @param payload
 */
var setSupplier = exports.setSupplier = function setSupplier(_ref16, payload) {
    var commit = _ref16.commit;

    var supplier = payload.overwrite ? payload.supplier : storageService.get('supplier') || payload.supplier;
    commit(CONSTANTS.AUTH_SUPPLIER_SET, supplier);
    storageService.save('supplier', supplier);
};

/**
 * Set the product type.
 *
 * @param commit
 * @param dispatch
 * @param payload
 */
var setProductType = exports.setProductType = function setProductType(_ref17, payload) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;

    var productType = payload.overwrite ? payload.productType : storageService.get('productType') || payload.productType;
    commit(CONSTANTS.AUTH_PRODUCT_TYPE_SET, productType);
    storageService.save('productType', productType);

    // Check if there is only one supplier in a product type - if so then set to that supplier
    dispatch('checkIfOnlySupplierInProductType', productType);
};

/**
 * Set the products types.
 *
 * @param commit
 * @param payload
 */
var setProductTypes = exports.setProductTypes = function setProductTypes(_ref18, payload) {
    var commit = _ref18.commit;

    commit(CONSTANTS.AUTH_PRODUCT_TYPES_SET, payload);
};

/**
 * Check if there is only one supplier in the given product type, if so then set supplier to said one.
 *
 * @param state
 * @param dispatch
 * @param payload
 */
var checkIfOnlySupplierInProductType = exports.checkIfOnlySupplierInProductType = function checkIfOnlySupplierInProductType(_ref19, payload) {
    var state = _ref19.state,
        dispatch = _ref19.dispatch;

    var suppliersAndProducts = state.suppliersProducts.items;
    if (suppliersAndProducts[payload].length === 1) {
        var supplier = suppliersAndProducts[payload][0];
        dispatch('setSupplier', { supplier: supplier, overwrite: true });
    }
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(128);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

var _BaseInterceptors = __webpack_require__(179);

var _BaseInterceptors2 = _interopRequireDefault(_BaseInterceptors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Library for making non-secure HTTP Requests
 */
var HttpLibrary = function () {

    /**
     * HttpLibrary constructor
     *
     * @param {string} baseURL
     * @param {object} headers
     */
    function HttpLibrary() {
        var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config2.default.http.GATEWAY_API_URL;
        var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.http.GATEWAY_API_HEADERS;

        _classCallCheck(this, HttpLibrary);

        this._instance = _axios2.default.create({
            baseURL: baseURL,
            headers: headers,
            timeout: 30000
        });
        _BaseInterceptors2.default.addBaseInterceptors(this._instance);
    }

    /**
     * Sends a GET request
     *
     * @param {string} url
     * @param {object} params
     * @returns {AxiosPromise<any>}
     */


    _createClass(HttpLibrary, [{
        key: "get",
        value: function get(url) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this._instance.get(url, { params: _extends({}, params) });
        }

        /**
         * Sens a PUT request
         *
         * @param {string} url
         * @param {object} params
         * @returns {AxiosPromise<any>}
         */

    }, {
        key: "put",
        value: function put(url) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this._instance.put(url, { params: _extends({}, params) });
        }

        /**
         * Sends a POST request
         * @param {string} url
         * @param {object} data
         * @param {object} params
         * @returns {AxiosPromise | *}
         */

    }, {
        key: "post",
        value: function post(url, data) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return this._instance.post(url, data, params);
        }

        /**
         * Sends a DELETE request
         *
         * @param {string} url
         * @param {object} params
         * @returns {AxiosPromise | *}
         */

    }, {
        key: "delete",
        value: function _delete(url) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this._instance.delete(url, params);
        }
    }]);

    return HttpLibrary;
}();

exports.default = HttpLibrary;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);
var bind = __webpack_require__(173);
var Axios = __webpack_require__(426);
var defaults = __webpack_require__(129);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(177);
axios.CancelToken = __webpack_require__(439);
axios.isCancel = __webpack_require__(176);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(440);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(129);
var utils = __webpack_require__(30);
var InterceptorManager = __webpack_require__(434);
var dispatchRequest = __webpack_require__(435);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(175);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);
var transformData = __webpack_require__(436);
var isCancel = __webpack_require__(176);
var defaults = __webpack_require__(129);
var isAbsoluteURL = __webpack_require__(437);
var combineURLs = __webpack_require__(438);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(30);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(177);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    AUTH_TOKEN_STORAGE_IDENTIFIER: "uf2dLbU89F",
    AUTH_TOKEN_IP_INFO: "e93b5603c55a11",
    AUTH_TOKEN_IP_INFO_URL: "https://ipinfo.io"
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    GATEWAY_API_URL: "https://backend.twentybook.com/gateway/marketplace/v1",
    GATEWAY_API_HEADERS: {},
    GATEWAY_TOKEN_AUTH_HEADER: "X-MARKETPLACE-AUTH",
    GATEWAY_TOKEN_REFRESH_HEADER: "X-MARKETPLACE-TOKEN-REFRESH"
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DateStorageService = __webpack_require__(178);

var _DateStorageService2 = _interopRequireDefault(_DateStorageService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    SEASON_DATE_START: "2021-01-01",
    SEASON_DATE_END: "2022-01-01",

    BOOKING_BOOKING_DATE_START: _DateStorageService2.default.getBookingBookingStartDateFromStorage() || "2021-01-01",
    BOOKING_BOOKING_DATE_END: _DateStorageService2.default.getBookingBookingEndDateFromStorage() || "2022-01-01",

    BOOKING_ARRIVAL_DATE_START: _DateStorageService2.default.getBookingArrivalStartDateFromStorage() || "2021-01-01",
    BOOKING_ARRIVAL_DATE_END: _DateStorageService2.default.getBookingArrivalEndDateFromStorage() || "2022-01-01"
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    LANGUAGE_IDENTIFIER: "hjd89L7Shj"
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(128);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

var _BaseInterceptors = __webpack_require__(179);

var _BaseInterceptors2 = _interopRequireDefault(_BaseInterceptors);

var _AuthInterceptors = __webpack_require__(446);

var _AuthInterceptors2 = _interopRequireDefault(_AuthInterceptors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Library for making secure HTTP Requests
 */
var SecureHttpLibrary = function () {

    /**
     * SecureHttpLibrary constructor
     *
     * @param {string} baseURL
     * @param {object} headers
     */
    function SecureHttpLibrary() {
        var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config2.default.http.GATEWAY_API_URL;
        var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.http.GATEWAY_API_HEADERS;

        _classCallCheck(this, SecureHttpLibrary);

        this._instance = _axios2.default.create({
            baseURL: baseURL,
            headers: headers,
            timeout: 30000
        });
        _BaseInterceptors2.default.addBaseInterceptors(this._instance);
        _AuthInterceptors2.default.addAuthInterceptors(this._instance);
    }

    /**
     * Sends a GET request
     *
     * @param {string} url
     * @param token
     * @param {object} params
     * @returns {AxiosPromise<any>}
     */


    _createClass(SecureHttpLibrary, [{
        key: 'get',
        value: function get(url, token) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return this._instance.get(url, {
                params: _extends({}, params),
                headers: _defineProperty({}, _config2.default.http.GATEWAY_TOKEN_AUTH_HEADER, 'Bearer ' + token)
            });
        }

        /**
         * Sens a PUT request
         *
         * @param {string} url
         * @param data
         * @param {string} token
         * @param {object} params
         * @returns {AxiosPromise<any>}
         */

    }, {
        key: 'put',
        value: function put(url, data, token) {
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            return this._instance.put(url, data, {
                params: _extends({}, params),
                headers: _defineProperty({}, _config2.default.http.GATEWAY_TOKEN_AUTH_HEADER, 'Bearer ' + token)
            });
        }

        /**
         * Sends a POST request
         * @param {string} url
         * @param {object} data
         * @param {string} token
         * @param {object} params
         * @returns {AxiosPromise | *}
         */

    }, {
        key: 'post',
        value: function post(url, data, token) {
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            return this._instance.post(url, data, {
                params: _extends({}, params),
                headers: _defineProperty({}, _config2.default.http.GATEWAY_TOKEN_AUTH_HEADER, 'Bearer ' + token)
            });
        }

        /**
         * Sends a POST request with custom headers
         * @param url
         * @param data
         * @param token
         * @param headers
         * @param params
         * @returns {AxiosPromise<any>}
         */

    }, {
        key: 'postCustomHeaders',
        value: function postCustomHeaders(url, data, token, headers) {
            var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

            return this._instance.post(url, data, {
                params: _extends({}, params),
                headers: _extends(_defineProperty({}, _config2.default.http.GATEWAY_TOKEN_AUTH_HEADER, 'Bearer ' + token), headers)
            });
        }
    }, {
        key: 'download',
        value: function download(url, token) {
            return this._instance.get(url, {
                responseType: 'arraybuffer',
                headers: _defineProperty({}, _config2.default.http.GATEWAY_TOKEN_AUTH_HEADER, 'Bearer ' + token)
            });
        }

        /**
         * Sends a DELETE request
         *
         * @param {string} url
         * @param {string} token
         * @param {object} params
         * @returns {AxiosPromise | *}
         */

    }, {
        key: 'del',
        value: function del(url, token) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return this._instance.delete(url, {
                params: _extends({}, params),
                headers: _defineProperty({}, _config2.default.http.GATEWAY_TOKEN_AUTH_HEADER, 'Bearer ' + token)
            });
        }
    }]);

    return SecureHttpLibrary;
}();

exports.default = SecureHttpLibrary;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class AuthInterceptors
 */
var AuthInterceptors = function () {
    function AuthInterceptors() {
        _classCallCheck(this, AuthInterceptors);
    }

    _createClass(AuthInterceptors, null, [{
        key: 'addAuthInterceptors',


        /**
         * Adds base interceptors to an AxiosInstance
         *
         * @param instance
         */
        value: function addAuthInterceptors(instance) {
            this._redirectToLoginOnUnauthenticated(instance);
            this._refreshAuthorizationToken(instance);
        }

        /**
         * Redirects the user to the login page, and removes the token if a
         * response code is 401
         *
         * @param {AxiosInstance} instance
         * @private
         */

    }, {
        key: '_redirectToLoginOnUnauthenticated',
        value: function _redirectToLoginOnUnauthenticated(instance) {
            instance.interceptors.response.use(function (response) {
                return response;
            }, function (response) {
                if (response.status === 419) {
                    _store2.default.dispatch('auth/setReferrer', window.location.pathname);
                    _store2.default.dispatch('auth/unauthenticate', { level: 'info', text: 'signIn.inactivityNotice' });
                }
                if (response.status === 401) {
                    _store2.default.dispatch('auth/unauthenticate', { level: 'warning', text: 'signIn.invalidNotice' });
                }
                return Promise.reject(response);
            });
        }

        /**
         * Refreshes the authorization token if a token is intercepted
         *
         * @param instance
         * @private
         */

    }, {
        key: '_refreshAuthorizationToken',
        value: function _refreshAuthorizationToken(instance) {
            instance.interceptors.response.use(function (response) {

                var refreshHeader = response.headers[_config2.default.http.GATEWAY_TOKEN_REFRESH_HEADER.toLowerCase()];

                if (refreshHeader) {
                    _TokenStorageService2.default.set(refreshHeader);
                }

                return response;
            });
        }
    }]);

    return AuthInterceptors;
}();

exports.default = AuthInterceptors;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AuthContainer = __webpack_require__(448);

var _AuthContainer2 = _interopRequireDefault(_AuthContainer);

var _ForgotPasswordPage = __webpack_require__(449);

var _ForgotPasswordPage2 = _interopRequireDefault(_ForgotPasswordPage);

var _ResetPasswordPage = __webpack_require__(469);

var _ResetPasswordPage2 = _interopRequireDefault(_ResetPasswordPage);

var _SignInPage = __webpack_require__(472);

var _SignInPage2 = _interopRequireDefault(_SignInPage);

var _ActivateUserPage = __webpack_require__(473);

var _ActivateUserPage2 = _interopRequireDefault(_ActivateUserPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/',
    component: _AuthContainer2.default,
    meta: {
        unauthenticated: true
    },
    children: [{
        path: '/',
        component: _SignInPage2.default
    }, {
        path: '/forgot-password',
        component: _ForgotPasswordPage2.default
    }, {
        path: '/reset-password/:token',
        component: _ResetPasswordPage2.default
    }, {
        path: '/activate-user/:token',
        component: _ActivateUserPage2.default
    }]
};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19226c3e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuthContainer/AuthContainer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-container",attrs:{"id":"page"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('img',{staticClass:"auth-container__logo",attrs:{"src":"https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/logo.svg"}}),_vm._v(" "),_c('router-view')],1)])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/AuthContainer/AuthContainer.vue
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var AuthContainer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__(71);
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/PreloaderItem/PreloaderItem.vue + 1 modules
var PreloaderItem = __webpack_require__(83);

// EXTERNAL MODULE: ./src/components/SelectLanguage/SelectLanguage.vue + 2 modules
var SelectLanguage = __webpack_require__(72);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ForgotPasswordPage/ForgotPasswordPage.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var ForgotPasswordPage = (vue_esm["default"].extend({
    components: {
        PreloaderItem: PreloaderItem["a" /* default */],
        SelectLanguage: SelectLanguage["a" /* default */]
    },
    data: function data() {
        return {
            email: undefined
        };
    },

    validations: {
        email: {
            required: validators["required"],
            email: validators["email"]
        }
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.auth.forgot.loading;
        },
        message: function message(state) {
            return state.auth.forgot.message;
        }
    }), {
        emailClasses: function emailClasses() {
            return {
                'forgot-password-page__input--error': this.$v.email.$dirty && this.$v.email.$error,
                'forgot-password-page__input--success': this.$v.email.$dirty && !this.$v.email.$error
            };
        }
    }),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        forgotPassword: 'auth/forgotPassword'
    }), {
        submit: function submit() {
            this.$v.$touch();

            if (!this.$v.email.$error) {
                this.forgotPassword({
                    email: this.email
                });
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f9052ff","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPasswordPage/ForgotPasswordPage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot-password-page"},[_c('div',{staticClass:"forgot-password-page__heading"},[_vm._v(_vm._s(_vm.$t('forgotPassword.heading')))]),_vm._v(" "),_c('div',{staticClass:"forgot-password-page__paragraph"},[_vm._v(_vm._s(_vm.$t('forgotPassword.description')))]),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"forgot-password-page__alert",class:("forgot-password-page__alert--" + (_vm.message.level))},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.message.text))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"forgot-password-page__form"},[_c('div',{staticClass:"forgot-password-page__input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"forgot-password-page__input",class:_vm.emailClasses,attrs:{"placeholder":_vm.$t('forgotPassword.email.placeholder'),"type":"email"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},function($event){return _vm.$v.email.$touch()}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}}),_vm._v(" "),(_vm.$v.email.$dirty && !_vm.$v.email.required)?_c('span',{staticClass:"forgot-password-page__input-help"},[_vm._v(_vm._s(_vm.$t('forgotPassword.email.errors.required')))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$dirty && !_vm.$v.email.email)?_c('span',{staticClass:"forgot-password-page__input-help"},[_vm._v(_vm._s(_vm.$t('forgotPassword.email.errors.email')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"forgot-password-page__input-group"},[_c('button',{staticClass:"forgot-password-page__submit",attrs:{"disabled":_vm.loading},on:{"click":_vm.submit,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.$t('forgotPassword.button')))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('preloader-item'):_vm._e()],1)])]),_vm._v(" "),_c('router-link',{staticClass:"forgot-password-page__sign-in-link",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('forgotPassword.signInLink')))]),_vm._v(" "),_c('select-language')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ForgotPasswordPage/ForgotPasswordPage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ForgotPasswordPage,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ForgotPasswordPage_ForgotPasswordPage = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
var withParams =  false ? require('./withParamsBrowser').withParams : __webpack_require__(170).withParams;

exports.default = withParams;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = (0, _common.regex)('numeric', /^[0-9]*$/);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (min, max) {
  return (0, _common.withParams)({ type: 'between', min: min, max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

exports.default = (0, _common.regex)('email', emailRegex);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = (0, _common.withParams)({ type: 'ipAddress' }, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});


var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function () {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({ type: 'macAddress' }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;

    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'maxLength', max: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'minLength', min: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredIf', prop: prop }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredUnless', prop: prop }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (equalTo) {
  return (0, _common.withParams)({ type: 'sameAs', eq: equalTo }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

exports.default = (0, _common.regex)('url', urlRegex);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'or' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'and' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (min) {
  return (0, _common.withParams)({ type: 'minValue', min: min }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(16);

exports.default = function (max) {
  return (0, _common.withParams)({ type: 'maxValue', max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__(71);
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/services/ValidatorService.js
var ValidatorService = __webpack_require__(31);
var ValidatorService_default = /*#__PURE__*/__webpack_require__.n(ValidatorService);

// EXTERNAL MODULE: ./src/components/PreloaderItem/PreloaderItem.vue + 1 modules
var PreloaderItem = __webpack_require__(83);

// EXTERNAL MODULE: ./src/components/SelectLanguage/SelectLanguage.vue + 2 modules
var SelectLanguage = __webpack_require__(72);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ResetPasswordPage/ResetPasswordPage.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var ResetPasswordPage = (vue_esm["default"].extend({
    components: {
        PreloaderItem: PreloaderItem["a" /* default */],
        SelectLanguage: SelectLanguage["a" /* default */]
    },
    data: function data() {
        return {
            pass: undefined,
            passCheck: undefined,
            timer: 5,
            interval: undefined,
            submitted: false
        };
    },
    validations: function validations() {
        return {
            pass: {
                required: validators["required"],
                validatePassword: function validatePassword(password) {
                    return Object(ValidatorService["validatePassword"])(password).valid;
                }
            },
            passCheck: {
                required: validators["required"],
                validatePassword: function validatePassword(password) {
                    return Object(ValidatorService["validatePassword"])(password).valid;
                },
                sameAsPassword: Object(validators["sameAs"])('pass')
            }
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.auth.reset.loading;
        },
        message: function message(state) {
            return state.auth.reset.message;
        }
    }), {
        passClasses: function passClasses() {
            return {
                'reset-password-page__input--error': this.$v.pass.$dirty && this.$v.pass.$error,
                'reset-password-page__input--success': this.$v.pass.$dirty && !this.$v.pass.$error
            };
        },
        passCheckClasses: function passCheckClasses() {
            return {
                'reset-password-page__input--error': this.$v.passCheck.$dirty && this.$v.passCheck.$error,
                'reset-password-page__input--success': this.$v.passCheck.$dirty && !this.$v.passCheck.$error
            };
        }
    }),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        resetPassword: 'auth/resetPassword'
    }), {
        submit: function submit() {
            var _this = this;

            this.$v.$touch();

            if (!this.$v.pass.$error && !this.$v.passCheck.$error) {
                this.resetPassword({
                    pass: this.pass,
                    token: this.$route.params.token
                }).then(function () {
                    _this.submitted = true;
                    _this.interval = setInterval(function () {
                        _this.timer = _this.timer - 1;
                        if (_this.timer === 0) {
                            clearInterval(_this.interval);
                            _this.$router.push('/');
                        }
                    }, 1000);
                });
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f611c38","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPasswordPage/ResetPasswordPage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password-page"},[_c('div',{staticClass:"reset-password-page__heading"},[_vm._v(_vm._s(_vm.$t('resetPassword.heading')))]),_vm._v(" "),_c('div',{staticClass:"reset-password-page__paragraph"},[_vm._v(_vm._s(_vm.$t('resetPassword.description')))]),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"reset-password-page__alert",class:("reset-password-page__alert--" + (_vm.message.level))},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.message.text))+"\n        "),(_vm.message.level === 'success')?_c('span',[_vm._v(_vm._s(_vm.timer))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"reset-password-page__form"},[_c('div',{staticClass:"reset-password-page__input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],staticClass:"reset-password-page__input",class:_vm.passClasses,attrs:{"placeholder":_vm.$t('resetPassword.pass.placeholder'),"type":"password","autocomplete":"off"},domProps:{"value":(_vm.pass)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value},function($event){return _vm.$v.pass.$touch()}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}}),_vm._v(" "),(_vm.$v.pass.$dirty && !_vm.$v.pass.required)?_c('span',{staticClass:"reset-password-page__input-help"},[_vm._v("\n                "+_vm._s(_vm.$t('resetPassword.pass.errors.required'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.$v.pass.$dirty && !_vm.$v.pass.validatePassword)?_c('span',{staticClass:"reset-password-page__input-help"},[_vm._v("\n                "+_vm._s(_vm.$t('account.password.validator.password'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"reset-password-page__input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passCheck),expression:"passCheck"}],staticClass:"reset-password-page__input",class:_vm.passCheckClasses,attrs:{"placeholder":_vm.$t('resetPassword.passCheck.placeholder'),"type":"password","autocomplete":"off"},domProps:{"value":(_vm.passCheck)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.passCheck=$event.target.value},function($event){return _vm.$v.passCheck.$touch()}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}}),_vm._v(" "),(_vm.$v.passCheck.$dirty && !_vm.$v.passCheck.sameAsPassword)?_c('span',{staticClass:"reset-password-page__input-help"},[_vm._v("\n                "+_vm._s(_vm.$t('resetPassword.passCheck.errors.mismatch'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.$v.passCheck.$dirty && !_vm.$v.passCheck.required)?_c('span',{staticClass:"reset-password-page__input-help"},[_vm._v("\n                "+_vm._s(_vm.$t('resetPassword.passCheck.errors.required'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"reset-password-page__input-group"},[_c('button',{staticClass:"reset-password-page__submit",attrs:{"disabled":_vm.loading || _vm.submitted},on:{"click":_vm.submit}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.$t('resetPassword.button')))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('preloader-item'):_vm._e()],1)]),_vm._v(" "),_c('select-language')],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ResetPasswordPage/ResetPasswordPage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ResetPasswordPage,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ResetPasswordPage_ResetPasswordPage = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": 185,
	"./de-at": 186,
	"./de-at.js": 186,
	"./de-ch": 187,
	"./de-ch.js": 187,
	"./de.js": 185,
	"./en-SG": 188,
	"./en-SG.js": 188,
	"./en-au": 189,
	"./en-au.js": 189,
	"./en-ca": 190,
	"./en-ca.js": 190,
	"./en-gb": 191,
	"./en-gb.js": 191,
	"./en-ie": 192,
	"./en-ie.js": 192,
	"./en-il": 193,
	"./en-il.js": 193,
	"./en-nz": 194,
	"./en-nz.js": 194,
	"./es": 195,
	"./es-do": 196,
	"./es-do.js": 196,
	"./es-us": 197,
	"./es-us.js": 197,
	"./es.js": 195,
	"./fr": 198,
	"./fr-ca": 199,
	"./fr-ca.js": 199,
	"./fr-ch": 200,
	"./fr-ch.js": 200,
	"./fr.js": 198,
	"./hr": 201,
	"./hr.js": 201,
	"./it": 202,
	"./it-ch": 203,
	"./it-ch.js": 203,
	"./it.js": 202,
	"./nl": 204,
	"./nl-be": 205,
	"./nl-be.js": 205,
	"./nl.js": 204
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__(71);
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/PreloaderItem/PreloaderItem.vue + 1 modules
var PreloaderItem = __webpack_require__(83);

// EXTERNAL MODULE: ./src/components/SelectLanguage/SelectLanguage.vue + 2 modules
var SelectLanguage = __webpack_require__(72);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SignInPage/SignInPage.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var SignInPage = (vue_esm["default"].extend({
    components: {
        PreloaderItem: PreloaderItem["a" /* default */],
        SelectLanguage: SelectLanguage["a" /* default */]
    },
    data: function data() {
        return {
            email: undefined,
            pass: undefined
        };
    },

    validations: {
        email: {
            required: validators["required"],
            email: validators["email"]
        },
        pass: {
            required: validators["required"]
        }
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.auth.login.loading;
        },
        message: function message(state) {
            return state.auth.login.message;
        }
    }), {
        emailClasses: function emailClasses() {
            return {
                'sign-in-page__input--error': this.$v.email.$dirty && this.$v.email.$error,
                'sign-in-page__input--success': this.$v.email.$dirty && !this.$v.email.$error
            };
        },
        passClasses: function passClasses() {
            return {
                'sign-in-page__input--error': this.$v.pass.$dirty && this.$v.pass.$error,
                'sign-in-page__input--success': this.$v.pass.$dirty && !this.$v.pass.$error
            };
        }
    }),
    destroyed: function destroyed() {
        this.setMessage(undefined);
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        authenticate: 'auth/authenticate',
        setMessage: 'auth/setSignInMessage'
    }), {
        submit: function submit() {
            this.$v.$touch();

            if (!this.$v.pass.$error && !this.$v.email.$error) {
                this.authenticate({
                    email: this.email,
                    pass: this.pass
                });
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef54df18","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignInPage/SignInPage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in-page"},[_c('div',{staticClass:"sign-in-page__heading"},[_vm._v(_vm._s(_vm.$t('signIn.heading')))]),_vm._v(" "),_c('div',{staticClass:"sign-in-page__paragraph"},[_vm._v(_vm._s(_vm.$t('signIn.description')))]),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"sign-in-page__alert",class:("sign-in-page__alert--" + (_vm.message.level))},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.message.text))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sign-in-page__form"},[_c('div',{staticClass:"sign-in-page__input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"sign-in-page__input",class:_vm.emailClasses,attrs:{"placeholder":_vm.$t('signIn.email.placeholder'),"type":"email"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},function($event){return _vm.$v.email.$touch()}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}}),_vm._v(" "),(_vm.$v.email.$dirty && !_vm.$v.email.required)?_c('span',{staticClass:"sign-in-page__input-help"},[_vm._v(_vm._s(_vm.$t('signIn.email.errors.required')))]):_vm._e(),_vm._v(" "),(_vm.$v.email.$dirty && !_vm.$v.email.email)?_c('span',{staticClass:"sign-in-page__input-help"},[_vm._v(_vm._s(_vm.$t('signIn.email.errors.email')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sign-in-page__input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],staticClass:"sign-in-page__input",class:_vm.passClasses,attrs:{"placeholder":_vm.$t('signIn.pass.placeholder'),"type":"password"},domProps:{"value":(_vm.pass)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value},function($event){return _vm.$v.pass.$touch()}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}}),_vm._v(" "),(_vm.$v.pass.$dirty && !_vm.$v.pass.required)?_c('span',{staticClass:"sign-in-page__input-help"},[_vm._v(_vm._s(_vm.$t('signIn.pass.errors.required')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sign-in-page__input-group"},[_c('button',{staticClass:"sign-in-page__submit",attrs:{"disabled":_vm.loading},on:{"click":_vm.submit}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.$t('signIn.button')))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('preloader-item'):_vm._e()],1)])]),_vm._v(" "),_c('router-link',{staticClass:"sign-in-page__forgot-password-link",attrs:{"to":"/forgot-password"}},[_vm._v(_vm._s(_vm.$t('signIn.forgotPasswordLink')))]),_vm._v(" "),_c('select-language')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/SignInPage/SignInPage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  SignInPage,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var SignInPage_SignInPage = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__(71);
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// EXTERNAL MODULE: ./src/services/ValidatorService.js
var ValidatorService = __webpack_require__(31);
var ValidatorService_default = /*#__PURE__*/__webpack_require__.n(ValidatorService);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/PreloaderItem/PreloaderItem.vue + 1 modules
var PreloaderItem = __webpack_require__(83);

// EXTERNAL MODULE: ./src/components/SelectLanguage/SelectLanguage.vue + 2 modules
var SelectLanguage = __webpack_require__(72);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ActivateUserPage/ActivateUserPage.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var ActivateUserPage = (vue_esm["default"].extend({
    components: {
        PreloaderItem: PreloaderItem["a" /* default */],
        SelectLanguage: SelectLanguage["a" /* default */]
    },
    data: function data() {
        return {
            pass: undefined,
            passCheck: undefined,
            timer: 5,
            interval: undefined,
            submitted: false
        };
    },
    validations: function validations() {
        return {
            pass: {
                required: validators["required"],
                validatePassword: function validatePassword(password) {
                    return Object(ValidatorService["validatePassword"])(password).valid;
                }
            },
            passCheck: {
                required: validators["required"],
                validatePassword: function validatePassword(password) {
                    return Object(ValidatorService["validatePassword"])(password).valid;
                },
                sameAsPassword: Object(validators["sameAs"])('pass')
            }
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.auth.activation.loading;
        },
        message: function message(state) {
            return state.auth.activation.message;
        }
    }), {
        passClasses: function passClasses() {
            return {
                'activate-user-page__input--error': this.$v.pass.$dirty && this.$v.pass.$error,
                'activate-user-page__input--success': this.$v.pass.$dirty && !this.$v.pass.$error
            };
        },
        passCheckClasses: function passCheckClasses() {
            return {
                'activate-user-page__input--error': this.$v.passCheck.$dirty && this.$v.passCheck.$error,
                'activate-user-page__input--success': this.$v.passCheck.$dirty && !this.$v.passCheck.$error
            };
        }
    }),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        activate: 'auth/activate'
    }), {
        submit: function submit() {
            var _this = this;

            this.$v.$touch();
            // If input validation passes then submit request
            if (!this.$v.pass.$error && !this.$v.passCheck.$error) {
                this.activate({
                    pass: this.pass,
                    token: this.$route.params.token
                }).then(function () {
                    // If activation was successful then redirect to login page
                    if (_this.message.level === 'success') {
                        _this.submitted = true;
                        _this.interval = setInterval(function () {
                            _this.timer = _this.timer - 1;
                            if (_this.timer === 0) {
                                clearInterval(_this.interval);
                                _this.$router.push('/');
                            }
                        }, 1000);
                    }
                });
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d153439","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivateUserPage/ActivateUserPage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activate-user-page"},[_c('div',{staticClass:"activate-user-page__heading"},[_vm._v(_vm._s(_vm.$t('activateUser.heading')))]),_vm._v(" "),_c('div',{staticClass:"activate-user-page__paragraph"},[_vm._v(_vm._s(_vm.$t('activateUser.description')))]),_vm._v(" "),(_vm.message)?_c('div',{class:("activate-user-page__alert--" + (_vm.message.level))},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.message.text))+"\n        "),(_vm.message.level === 'success')?_c('span',[_vm._v(_vm._s(_vm.timer))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"activate-user-page__form"},[_c('div',{staticClass:"activate-user-page__input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],staticClass:"activate-user-page__input",class:_vm.passClasses,attrs:{"placeholder":_vm.$t('activateUser.pass.placeholder'),"type":"password"},domProps:{"value":(_vm.pass)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value},function($event){return _vm.$v.pass.$touch()}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}}),_vm._v(" "),(_vm.$v.pass.$dirty && !_vm.$v.pass.required)?_c('div',{staticClass:"activate-user-page__input-help"},[_vm._v(_vm._s(_vm.$t('activateUser.pass.errors.required')))]):_vm._e(),_vm._v(" "),(_vm.$v.pass.$dirty && !_vm.$v.pass.validatePassword)?_c('div',{staticClass:"activate-user-page__input-help"},[_vm._v(_vm._s(_vm.$t('account.password.validator.password')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"activate-user-page__input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passCheck),expression:"passCheck"}],staticClass:"activate-user-page__input",class:_vm.passCheckClasses,attrs:{"placeholder":_vm.$t('activateUser.passCheck.placeholder'),"type":"password"},domProps:{"value":(_vm.passCheck)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.passCheck=$event.target.value},function($event){return _vm.$v.passCheck.$touch()}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}}}),_vm._v(" "),(_vm.$v.passCheck.$dirty && !_vm.$v.passCheck.sameAsPassword)?_c('span',{staticClass:"activate-user-page__input-help"},[_vm._v(_vm._s(_vm.$t('activateUser.passCheck.errors.mismatch')))]):_vm._e(),_vm._v(" "),(_vm.$v.passCheck.$dirty && !_vm.$v.passCheck.required)?_c('span',{staticClass:"activate-user-page__input-help"},[_vm._v(_vm._s(_vm.$t('activateUser.passCheck.errors.required')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"activate-user-page__input-group"},[_c('button',{staticClass:"activate-user-page__submit",attrs:{"disabled":_vm.loading || _vm.submitted},on:{"click":_vm.submit}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.$t('activateUser.button')))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('preloader-item'):_vm._e()],1)]),_vm._v(" "),_c('select-language')],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ActivateUserPage/ActivateUserPage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ActivateUserPage,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ActivateUserPage_ActivateUserPage = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _StyleGuideContainer = __webpack_require__(475);

var _StyleGuideContainer2 = _interopRequireDefault(_StyleGuideContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/styleguide',
    component: _StyleGuideContainer2.default
};

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StyleGuideContainer/StyleGuideContainer.vue



/* harmony default export */ var StyleGuideContainer = (vue_esm["default"].extend({}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d1017f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StyleGuideContainer/StyleGuideContainer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"style-guide-container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Headings")]),_vm._v(" "),_c('h1',[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('h2',[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('h3',[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('h4',[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('h5',[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('h6',[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("Typography")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius error ex laboriosam minus modi nobis, reiciendis rem unde! Ad esse iure minima ratione repellat voluptates. Eveniet facilis modi numquam soluta!")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias commodi facere facilis impedit magnam perspiciatis placeat recusandae, ut veritatis vitae voluptatem voluptates. Ab ad amet animi aperiam asperiores atque aut, cupiditate debitis dolorum ducimus eligendi ex exercitationem harum itaque labore magni maiores, modi molestiae nulla "),_c('a',{attrs:{"href":"#"}},[_vm._v("read more")]),_vm._v(" provident qui quibusdam quos repellat repellendus sequi suscipit ut. Animi eius et reiciendis sequi ut. Amet architecto cupiditate dicta dignissimos ducimus omnis quidem quo repellat sed, voluptas. Et laborum nesciunt perferendis.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid, aut doloribus! A ab aperiam architecto assumenda atque beatae blanditiis consectetur cumque deserunt doloribus et inventore iure labore laborum magnam magni, maiores molestiae molestias mollitia necessitatibus nesciunt nobis nostrum odio, odit omnis possimus praesentium quae qui, quidem quod similique sunt suscipit tempora. Accusantium blanditiis consectetur culpa fuga quod reiciendis, sequi sint.")]),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("Forms")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',[_c('input',{staticClass:"input",attrs:{"type":"text","value":"Lorem ipsum"}})]),_vm._v(" "),_c('p',[_c('input',{staticClass:"input",attrs:{"type":"number","value":"300"}})]),_vm._v(" "),_c('p',[_c('select',{staticClass:"input"},[_c('option',{attrs:{"value":"3"}},[_vm._v("Lorem ipsum 1")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Lorem ipsum 2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Lorem ipsum 3")])])])])]),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("Buttons")]),_vm._v(" "),_c('button',{staticClass:"button__primary button__primary--lg"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__info button__info--lg"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__warning button__warning--lg"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__danger button__danger--lg"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__success button__success--lg"},[_vm._v("Read more")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button__primary"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__info"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__warning"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__danger"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__success"},[_vm._v("Read more")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button__primary button__primary--sm"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__info button__info--sm"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__warning button__warning--sm"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__danger button__danger--sm"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__success button__success--sm"},[_vm._v("Read more")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button__primary button__primary--xs"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__info button__info--xs"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__warning button__warning--xs"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__danger button__danger--xs"},[_vm._v("Read more")]),_vm._v(" "),_c('button',{staticClass:"button__success button__success--xs"},[_vm._v("Read more")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"alert alert--danger"},[_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.\n                ")]),_vm._v(" "),_c('div',{staticClass:"alert alert--warning"},[_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.\n                ")]),_vm._v(" "),_c('div',{staticClass:"alert alert--success"},[_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.\n                ")]),_vm._v(" "),_c('div',{staticClass:"alert alert--info"},[_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.\n                ")]),_vm._v(" "),_c('div',{staticClass:"alert alert--primary"},[_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/StyleGuideContainer/StyleGuideContainer.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  StyleGuideContainer,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var StyleGuideContainer_StyleGuideContainer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DashboardContainer = __webpack_require__(477);

var _DashboardContainer2 = _interopRequireDefault(_DashboardContainer);

var _StatPage = __webpack_require__(478);

var _StatPage2 = _interopRequireDefault(_StatPage);

var _AdminPage = __webpack_require__(480);

var _AdminPage2 = _interopRequireDefault(_AdminPage);

var _BookingPage = __webpack_require__(481);

var _BookingPage2 = _interopRequireDefault(_BookingPage);

var _AccountPage = __webpack_require__(482);

var _AccountPage2 = _interopRequireDefault(_AccountPage);

var _ContractPage = __webpack_require__(483);

var _ContractPage2 = _interopRequireDefault(_ContractPage);

var _DashboardPage = __webpack_require__(484);

var _DashboardPage2 = _interopRequireDefault(_DashboardPage);

var _AllocationPage = __webpack_require__(485);

var _AllocationPage2 = _interopRequireDefault(_AllocationPage);

var _ContractListPage = __webpack_require__(486);

var _ContractListPage2 = _interopRequireDefault(_ContractListPage);

var _ManageAllocationPage = __webpack_require__(487);

var _ManageAllocationPage2 = _interopRequireDefault(_ManageAllocationPage);

var _ContractManagementPage = __webpack_require__(494);

var _ContractManagementPage2 = _interopRequireDefault(_ContractManagementPage);

var _ContractManagementEditPage = __webpack_require__(495);

var _ContractManagementEditPage2 = _interopRequireDefault(_ContractManagementEditPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/dashboard',
    component: _DashboardContainer2.default,
    meta: {
        authenticated: true
    },
    children: [{
        path: '/dashboard',
        component: _DashboardPage2.default
    }, {
        path: '/dashboard/stats',
        component: _StatPage2.default
    }, {
        path: '/dashboard/admin',
        component: _AdminPage2.default,
        meta: {
            restrictContractManager: true,
            admin: true
        }
    }, {
        path: '/dashboard/contract-management',
        component: _ContractManagementPage2.default,
        name: 'contractManagementOverview',
        meta: {
            restrictSupplier: true
        }
    }, {
        path: '/dashboard/contract-management/:contractId/:supplierId',
        component: _ContractManagementEditPage2.default,
        name: 'contractManagement',
        meta: {
            restrictSupplier: true
        }
    }, {
        path: '/dashboard/contract/:supplierId',
        component: _ContractListPage2.default,
        name: 'contractList'
    }, {
        path: '/dashboard/contract/:supplierId/:contractId',
        component: _ContractPage2.default,
        name: 'contract'
    }, {
        path: '/dashboard/account',
        component: _AccountPage2.default
    }, {
        path: '/dashboard/booking',
        component: _BookingPage2.default
    }, {
        path: '/dashboard/allocation',
        component: _AllocationPage2.default,
        name: 'allocation',
        meta: {
            restrictXMLSuppliers: true
        }
    }, {
        path: '/dashboard/allocation-management/:siteId',
        component: _ManageAllocationPage2.default,
        name: 'manageSiteAllocation',
        meta: {
            restrictXMLSuppliers: true
        }
    }, {
        path: '/dashboard/allocation-management/:siteId/:accommodationSiteId',
        component: _ManageAllocationPage2.default,
        name: 'manageAccommodationAllocation',
        meta: {
            restrictXMLSuppliers: true
        }
    }]
};

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/services/WindowService.js
var WindowService = __webpack_require__(206);
var WindowService_default = /*#__PURE__*/__webpack_require__.n(WindowService);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// EXTERNAL MODULE: ./src/components/KeyValueMenu/KeyValueMenu.vue + 2 modules
var KeyValueMenu = __webpack_require__(99);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationMenuFilter/NavigationMenuFilter.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var NavigationMenuFilter = ({
    components: {
        DropdownMenu: DropdownMenu["a" /* default */],
        KeyValueMenu: KeyValueMenu["a" /* default */]
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        productTypes: function productTypes(state) {
            return state.auth.productTypes;
        },
        productType: function productType(state) {
            return state.auth.productType;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        },
        user: function user(state) {
            return state.auth.user;
        }
    }), Object(vuex_esm["mapGetters"])({
        getSuppliersInProductType: 'auth/getSuppliersInProductType'
    })),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        setProductType: 'auth/setProductType',
        setSupplier: 'auth/setSupplier'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed9aae26","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationMenuFilter/NavigationMenuFilter.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-menu-filter"},[_c('div',{staticClass:"navigation-menu-filter__content"},[(_vm.productTypes.length > 1)?_c('dropdown-menu',{attrs:{"label":_vm.$t('navigation-menu.items.productType'),"value":_vm.productType,"items":_vm.productTypes,"translation-prefix":'navigation-menu.items.products'},on:{"input":function($event){return _vm.setProductType({productType: $event, overwrite: true})}}}):_vm._e(),_vm._v(" "),(_vm.getSuppliersInProductType.length > 1)?_c('key-value-menu',{key:'navigation-filter-' + _vm.productType,attrs:{"label":_vm.$t('navigation-menu.items.supplier'),"value":_vm.supplier,"items":_vm.getSuppliersInProductType},on:{"input":function($event){return _vm.setSupplier({supplier: $event, overwrite: true})}}}):_vm._e()],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/NavigationMenuFilter/NavigationMenuFilter.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  NavigationMenuFilter,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var NavigationMenuFilter_NavigationMenuFilter = (Component.exports);

// EXTERNAL MODULE: ./src/components/SelectLanguage/SelectLanguage.vue + 2 modules
var SelectLanguage = __webpack_require__(72);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationMenu/NavigationMenu.vue
var NavigationMenu__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var NavigationMenu = ({
    components: {
        NavigationMenuFilter: NavigationMenuFilter_NavigationMenuFilter,
        SelectLanguage: SelectLanguage["a" /* default */],
        KeyValueMenu: KeyValueMenu["a" /* default */],
        DropdownMenu: DropdownMenu["a" /* default */]
    },
    data: function data() {
        return {
            languages: this.$locale.getValidLanguages()
        };
    },

    computed: NavigationMenu__extends({}, Object(vuex_esm["mapState"])({
        minimized: function minimized(state) {
            return state.nav.minimized;
        },
        language: function language(state) {
            return state.nav.language.value;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        },
        user: function user(state) {
            return state.auth.user;
        }
    })),
    created: function created() {
        this.$locale.change(this.language);
    },

    methods: NavigationMenu__extends({}, Object(vuex_esm["mapActions"])({
        setMinimizedNav: 'nav/setMinimizedNav'
    }), {
        showHideNav: function showHideNav($event) {
            if ($event.target.id === 'navigation-menu' && WindowService["WindowService"].width() < WindowService["WindowService"].breakpoints.lg) {
                this.setMinimizedNav(true);
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d187896c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationMenu/NavigationMenu.vue
var NavigationMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-menu",class:{'navigation-menu--minimized': _vm.minimized},attrs:{"id":"navigation-menu"},on:{"click":function($event){return _vm.showHideNav($event)}}},[_c('div',{staticClass:"navigation-menu__inner"},[_c('div',{staticClass:"navigation-menu__body"},[_c('ul',{staticClass:"navigation-menu__list"},[_c('li',{staticClass:"navigation-menu__item"},[_c('router-link',{staticClass:"navigation-menu__link navigation-menu__link--home",attrs:{"to":"/dashboard","active-class":"navigation-menu__link--active","exact":""}},[_c('span',{staticClass:"navigation-menu__link-text"},[_vm._v(_vm._s(_vm.$t('navigation-menu.items.dashboard')))])])],1),_vm._v(" "),_c('li',{staticClass:"navigation-menu__item"},[_c('router-link',{staticClass:"navigation-menu__link navigation-menu__link--statistics",attrs:{"to":"/dashboard/stats","active-class":"navigation-menu__link--active"}},[_c('span',{staticClass:"navigation-menu__link-text"},[_vm._v(_vm._s(_vm.$t('navigation-menu.items.stats')))])])],1),_vm._v(" "),_c('li',{staticClass:"navigation-menu__item"},[_c('router-link',{staticClass:"navigation-menu__link navigation-menu__link--booking",attrs:{"to":"/dashboard/booking","active-class":"navigation-menu__link--active"}},[_c('span',{staticClass:"navigation-menu__link-text"},[_vm._v(_vm._s(_vm.$t('navigation-menu.items.booking')))])])],1),_vm._v(" "),(_vm.user.contractManager || (_vm.supplier && !_vm.supplier.xmlSupplier))?_c('li',{staticClass:"navigation-menu__item"},[_c('router-link',{staticClass:"navigation-menu__link navigation-menu__link--allocation",attrs:{"to":"/dashboard/allocation","active-class":"navigation-menu__link--active"}},[_c('span',{staticClass:"navigation-menu__link-text"},[_vm._v(_vm._s(_vm.$t('navigation-menu.items.allocation')))])])],1):_vm._e(),_vm._v(" "),(_vm.user.contractManager)?_c('li',{staticClass:"navigation-menu__item"},[_c('router-link',{staticClass:"navigation-menu__link navigation-menu__link--contractManagement",attrs:{"to":"/dashboard/contract-management","active-class":"navigation-menu__link--active"}},[_c('span',{staticClass:"navigation-menu__link-text"},[_vm._v(_vm._s(_vm.$t('navigation-menu.items.contract')))])])],1):_vm._e(),_vm._v(" "),(!_vm.user.contractManager)?_c('li',{staticClass:"navigation-menu__item"},[_c('router-link',{staticClass:"navigation-menu__link navigation-menu__link--contract",attrs:{"to":{name: 'contractList', params: {supplierId: _vm.supplier.id}},"active-class":"navigation-menu__link--active"}},[_c('span',{staticClass:"navigation-menu__link-text"},[_vm._v(_vm._s(_vm.$t('navigation-menu.items.contract')))])])],1):_vm._e(),_vm._v(" "),(!_vm.minimized)?_c('li',{staticClass:"navigation-menu__select-supplier"},[_c('navigation-menu-filter')],1):_vm._e(),_vm._v(" "),(_vm.languages.length > 1)?_c('li',{staticClass:"navigation-menu__select-language"},[_vm._v("\n                    "+_vm._s(_vm.$t('navigation-menu.language'))+"\n                    "),_c('select-language')],1):_vm._e()])])])])}
var NavigationMenu_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/NavigationMenu/NavigationMenu.vue
/* script */


/* template */

/* template functional */
var NavigationMenu___vue_template_functional__ = false
/* styles */
var NavigationMenu___vue_styles__ = null
/* scopeId */
var NavigationMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationMenu___vue_module_identifier__ = null

var NavigationMenu_Component = Object(component_normalizer["a" /* default */])(
  NavigationMenu,
  NavigationMenu_render,
  NavigationMenu_staticRenderFns,
  NavigationMenu___vue_template_functional__,
  NavigationMenu___vue_styles__,
  NavigationMenu___vue_scopeId__,
  NavigationMenu___vue_module_identifier__
)

/* harmony default export */ var NavigationMenu_NavigationMenu = (NavigationMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TopMenu/TopMenu.vue
var TopMenu__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var TopMenu = ({
    components: {
        SelectLanguage: SelectLanguage["a" /* default */]
    },
    filters: {
        capitalized: function capitalized(supplierName) {
            var supplierNameCap = '';
            var words = supplierName.split(' ');
            words.forEach(function (word) {
                supplierNameCap += word.substring(0, 1).toUpperCase() + word.substring(1, word.length) + ' ';
            });
            return supplierNameCap.substring(0, supplierNameCap.length - 1);
        }
    },
    data: function data() {
        return {
            userDropdownToggled: false
        };
    },

    computed: TopMenu__extends({}, Object(vuex_esm["mapState"])({
        minimized: function minimized(state) {
            return state.nav.minimized;
        },
        user: function user(state) {
            return state.auth.user;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        },
        open: function open(state) {
            return state.nav.menu.open;
        }
    })),
    methods: TopMenu__extends({}, Object(vuex_esm["mapActions"])({
        unauthenticate: 'auth/unauthenticate',
        toggleMinimizeNav: 'nav/toggleMinimizeNav',
        toggleNavMenu: 'nav/toggleNavMenu'
    }), {
        admin: function admin() {
            this.$router.push('dashboard/admin');
        },
        signOut: function signOut() {
            this.unauthenticate({
                level: 'info',
                text: 'signIn.logoutNotice'
            });
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0192bba3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopMenu/TopMenu.vue
var TopMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu",class:{'top-menu--minimized': _vm.minimized}},[_c('div',{staticClass:"top-menu__left"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-menu__nav-toggle",on:{"click":_vm.toggleMinimizeNav}},[_c('i',{staticClass:"fa fa-fw fa-bars"})]),_vm._v(" "),(!_vm.user.contractManager)?_c('div',{staticClass:"top-menu__welcome-note"},[_vm._v("\n            "+_vm._s(_vm.$t('topMenu.left.welcome'))+" "+_vm._s(_vm._f("capitalized")(_vm.supplier.name))+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"top-menu__right"},[_c('div',{staticClass:"top-menu__user-controls",on:{"click":function($event){return _vm.toggleNavMenu()}}},[_c('i',{staticClass:"fa fa-fw fa-user"}),_vm._v("\n            "+_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName)+"\n        ")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-top"}},[(_vm.open)?_c('ul',{staticClass:"top-menu__user-dropdown"},[_c('li',{staticClass:"top-menu__user-dropdown-item"},[(_vm.user.admin)?_c('router-link',{staticClass:"top-menu__user-dropdown-link",attrs:{"tag":"a","to":"/dashboard/admin"}},[_c('i',{staticClass:"fa fa-key"}),_vm._v("\n                        "+_vm._s(_vm.$t('topMenu.right.admin'))+"\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.user.contractManager)?_c('router-link',{staticClass:"top-menu__user-dropdown-link",attrs:{"tag":"a","to":"/dashboard/account"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v("\n                        "+_vm._s(_vm.$t('topMenu.right.account'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"top-menu__user-dropdown-link",on:{"click":_vm.signOut}},[_c('i',{staticClass:"fa fa-sign-out-alt"}),_vm._v("\n                        "+_vm._s(_vm.$t('topMenu.right.logout'))+"\n                    ")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"top-menu__select-language"},[_c('select-language')],1)],1)])}
var TopMenu_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu__brand"},[_c('img',{staticClass:"top-menu__logo",attrs:{"src":"https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/logo-greybackground.svg"}}),_vm._v(" "),_c('img',{staticClass:"top-menu__icon",attrs:{"src":"https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/icon-greybackground.png"}})])}]

// CONCATENATED MODULE: ./src/components/TopMenu/TopMenu.vue
/* script */


/* template */

/* template functional */
var TopMenu___vue_template_functional__ = false
/* styles */
var TopMenu___vue_styles__ = null
/* scopeId */
var TopMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TopMenu___vue_module_identifier__ = null

var TopMenu_Component = Object(component_normalizer["a" /* default */])(
  TopMenu,
  TopMenu_render,
  TopMenu_staticRenderFns,
  TopMenu___vue_template_functional__,
  TopMenu___vue_styles__,
  TopMenu___vue_scopeId__,
  TopMenu___vue_module_identifier__
)

/* harmony default export */ var TopMenu_TopMenu = (TopMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardContainer/DashboardContainer.vue
var DashboardContainer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var DashboardContainer = (vue_esm["default"].extend({
    components: {
        NavigationMenu: NavigationMenu_NavigationMenu,
        TopMenu: TopMenu_TopMenu
    },
    computed: DashboardContainer__extends({}, Object(vuex_esm["mapState"])({
        navMinimized: function navMinimized(state) {
            return state.nav.minimized;
        }
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398dd258","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardContainer/DashboardContainer.vue
var DashboardContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container",class:{'dashboard-container--nav-minimized': _vm.navMinimized},attrs:{"id":"dashboard-container"}},[_c('div',{staticClass:"dashboard-container__topbar"},[_c('top-menu')],1),_vm._v(" "),_c('div',{staticClass:"dashboard-container__menu"},[_c('navigation-menu')],1),_vm._v(" "),_c('div',{staticClass:"dashboard-container__page"},[_c('router-view')],1)])}
var DashboardContainer_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DashboardContainer/DashboardContainer.vue
/* script */


/* template */

/* template functional */
var DashboardContainer___vue_template_functional__ = false
/* styles */
var DashboardContainer___vue_styles__ = null
/* scopeId */
var DashboardContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DashboardContainer___vue_module_identifier__ = null

var DashboardContainer_Component = Object(component_normalizer["a" /* default */])(
  DashboardContainer,
  DashboardContainer_render,
  DashboardContainer_staticRenderFns,
  DashboardContainer___vue_template_functional__,
  DashboardContainer___vue_styles__,
  DashboardContainer___vue_scopeId__,
  DashboardContainer___vue_module_identifier__
)

/* harmony default export */ var DashboardContainer_DashboardContainer = __webpack_exports__["default"] = (DashboardContainer_Component.exports);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue-chartjs/es/index.js + 2 modules
var es = __webpack_require__(131);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatSitesGraph/StatSitesGraph.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var StatSitesGraph = ({
    extends: es["a" /* HorizontalBar */],
    props: {
        chartData: {
            type: Array,
            required: true
        },
        labels: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        filteredSites: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            baseColor: '#64C1C7',
            activeColor: '#F4A830',
            selectedIndex: 0
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.stats.sites.value;
        },
        loading: function loading(state) {
            return state.stats.sites.loading;
        },
        error: function error(state) {
            return state.stats.sites.error;
        },
        noContent: function noContent(state) {
            return state.stats.sites.noContent;
        },
        selectedSite: function selectedSite(state) {
            return state.stats.selectedSite;
        }
    }), {
        backgroundColors: function backgroundColors() {
            var colors = [];
            for (var i = 0; i < this.filteredSites.length; i++) {
                if (this.selectedSite.id === this.filteredSites[i].id) {
                    colors.push(this.activeColor);
                } else {
                    colors.push(this.baseColor);
                }
            }
            return colors;
        },
        coloredDatasets: function coloredDatasets() {
            var datasets = this.chartData.slice();
            datasets[0].backgroundColor = this.backgroundColors;
            return datasets;
        }
    }),
    watch: {
        chartData: {
            deep: true,
            handler: function handler() {
                this.$data._chart.destroy();
                this.rerenderChart();
            }
        }
    },
    mounted: function mounted() {
        this.rerenderChart();
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        updateSelectedSite: 'stats/updateSelectedSite'
    }), {
        rerenderChart: function rerenderChart() {
            var _this = this;

            this.updateSelectedSite(this.filteredSites[0]).then(function () {
                _this.renderChart({
                    labels: _this.labels,
                    datasets: _this.coloredDatasets
                }, _extends({}, _this.options, {
                    onClick: _this.setActiveBar,
                    onHover: _this.showCursor
                }));
            });
        },
        setActiveBar: function setActiveBar(event, elements) {
            var _this2 = this;

            var dataset = void 0;

            if (elements.length) {
                var index = elements[0]._index;
                this.updateSelectedSite(this.filteredSites[index]).then(function () {
                    _this2.selectedIndex = index;
                    dataset = _this2.$data._chart.data.datasets[0];
                    dataset.backgroundColor = _this2.backgroundColors.slice();
                    _this2.$data._chart.update();
                });
            }
        },
        showCursor: function showCursor(event, elements) {
            if (elements.length) {
                event.target.style.cursor = 'pointer';
            } else {
                event.target.style.cursor = 'default';
            }
        }
    })
});
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/StatSitesGraph/StatSitesGraph.vue
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  StatSitesGraph,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var StatSitesGraph_StatSitesGraph = (Component.exports);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/lodash-es/lodash.js + 631 modules
var lodash = __webpack_require__(14);

// EXTERNAL MODULE: ./src/components/Fake/Fake.vue + 2 modules
var Fake = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatSites/StatSites.vue
var StatSites__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







/* harmony default export */ var StatSites = ({
    components: {
        StatSitesGraph: StatSitesGraph_StatSitesGraph,
        DropdownMenu: DropdownMenu["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    data: function data() {
        return {
            chartHeight: 400
        };
    },

    computed: StatSites__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.stats.sites;
        },
        loading: function loading(state) {
            return state.stats.statSites.loading;
        },
        error: function error(state) {
            return state.stats.statSites.error;
        },
        noContent: function noContent(state) {
            return state.stats.statSites.noContent;
        },
        period: function period(state) {
            return state.stats.period;
        },
        predicate: function predicate(state) {
            return state.stats.statSites.predicate;
        },
        predicates: function predicates(state) {
            return state.stats.statSites.predicates;
        }
    }), {
        chartData: function chartData() {
            var _this = this;

            var _chartData = {
                label: 'Sales'
            };

            _chartData.data = Object(lodash["map"])(this.filteredSites, function (site) {
                return site[_this.predicate];
            });

            return [_chartData];
        },
        labels: function labels() {
            return Object(lodash["map"])(this.filteredSites, function (site) {
                return site.name;
            });
        },
        filteredSites: function filteredSites() {
            var _this2 = this;

            var _sites = [].concat(_toConsumableArray(this.sites));

            _sites.sort(function (a, b) {
                return b[_this2.predicate] - a[_this2.predicate];
            });

            return _sites.slice(0, 10);
        },
        options: function options() {
            var _this3 = this;

            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function callback(value) {
                                if (value % 1 === 0) {
                                    return _this3.predicate === 'revenue' ? '\u20AC ' + _this3.$shortNumber(value) : value;
                                }
                            }
                        }
                    }]
                },
                tooltips: {
                    enabled: true
                }
            };
        }
    }),
    methods: StatSites__extends({}, Object(vuex_esm["mapActions"])({
        setFilter: 'stats/setFilter'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3691397e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatSites/StatSites.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-sites"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.noContent || _vm.error)?_c('div',{staticClass:"stat-sites__no-content"},[_c('div',{staticClass:"stat-sites__no-content-icon"},[_c('i',{staticClass:"fa fa-fw fa-exclamation-triangle"})]),_vm._v(" "),_c('div',{staticClass:"stat-sites__no-content-message"},[(_vm.noContent)?_c('span',[_vm._v(_vm._s(_vm.$t("statSites.noContent.missing")))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('span',[_vm._v(_vm._s(_vm.$t("statSites.noContent.error")))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.sites && !_vm.loading)?_c('div',{key:'content',staticClass:"stat-sites__content"},[_c('div',{staticClass:"stat-sites__header"},[(_vm.sites.length > 10)?_c('div',{staticClass:"stat-sites__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t(("statSites.predicate." + _vm.predicate)))+": "+_vm._s(_vm.$t("statSites.alternativeHeading"))+"\n                ")]):_c('div',{staticClass:"stat-sites__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t(("statSites.predicate." + _vm.predicate)))+": "+_vm._s(_vm.$t("statSites.heading"))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"stat-sites__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('statSites.dropdown.label'),"value":_vm.predicate,"items":_vm.predicates,"translation-prefix":'statSites.predicate'},on:{"input":function($event){return _vm.setFilter({sites: $event})}}})],1)]),_vm._v(" "),_c('div',{staticClass:"stat-sites__body"},[_c('stat-sites-graph',{attrs:{"chart-data":_vm.chartData,"labels":_vm.labels,"height":_vm.chartHeight,"options":_vm.options,"filtered-sites":_vm.filteredSites}})],1)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":10,"body-cells":4}}):_vm._e()],1)],1)}
var staticRenderFns = []

// CONCATENATED MODULE: ./src/components/StatSites/StatSites.vue
/* script */


/* template */

/* template functional */
var StatSites___vue_template_functional__ = false
/* styles */
var StatSites___vue_styles__ = null
/* scopeId */
var StatSites___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StatSites___vue_module_identifier__ = null

var StatSites_Component = Object(component_normalizer["a" /* default */])(
  StatSites,
  render,
  staticRenderFns,
  StatSites___vue_template_functional__,
  StatSites___vue_styles__,
  StatSites___vue_scopeId__,
  StatSites___vue_module_identifier__
)

/* harmony default export */ var StatSites_StatSites = (StatSites_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatNumber/StatNumber.vue


/* harmony default export */ var StatNumber = ({
    props: {
        label: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            default: 0
        },
        alternative: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            required: true
        },
        error: {
            type: Boolean,
            required: true
        },
        noContent: {
            type: Boolean,
            required: true
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28cb88a9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatNumber/StatNumber.vue
var StatNumber_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-number",class:{'stat-number--alternative': _vm.alternative}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.loading && !_vm.error && !_vm.noContent)?_c('div',{key:'success',staticClass:"stat-number__body"},[_c('div',{staticClass:"stat-number__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"stat-number__value"},[_vm._v(_vm._s(_vm.$shortNumber(_vm.value)))]),_vm._v(" "),_c('div',{staticClass:"stat-number__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{key:'loading',staticClass:"stat-number__body"},[_c('div',{staticClass:"stat-number__fake-label"}),_vm._v(" "),_c('div',{staticClass:"stat-number__fake-value"}),_vm._v(" "),_c('div',{staticClass:"stat-number__fake-subtitle"})]):_vm._e(),_vm._v(" "),(_vm.error && !_vm.loading)?_c('div',{key:'failed',staticClass:"stat-number__body"},[_c('div',{staticClass:"stat-number__error-label"},[_vm._v("\n                "+_vm._s(_vm.label)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"stat-number__error-icon"},[_c('i',{staticClass:"fa fa-fw fa-exclamation-triangle"})]),_vm._v(" "),_c('div',{staticClass:"stat-number__error-message"},[_vm._v("\n                "+_vm._s(_vm.$t('statNumber.body.failedToFetchData'))+"\n            ")])]):_vm._e(),_vm._v(" "),(_vm.noContent && !_vm.loading)?_c('div',{key:'noContent',staticClass:"stat-number__body"},[_c('div',{staticClass:"stat-number__error-label"},[_vm._v("\n                "+_vm._s(_vm.label)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"stat-number__error-icon"},[_c('i',{staticClass:"fa fa-fw fa-exclamation-triangle"})]),_vm._v(" "),_c('div',{staticClass:"stat-number__error-message"},[_vm._v("\n                "+_vm._s(_vm.$t('statNumber.body.noDataFound'))+"\n            ")])]):_vm._e()])],1)}
var StatNumber_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/StatNumber/StatNumber.vue
/* script */


/* template */

/* template functional */
var StatNumber___vue_template_functional__ = false
/* styles */
var StatNumber___vue_styles__ = null
/* scopeId */
var StatNumber___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StatNumber___vue_module_identifier__ = null

var StatNumber_Component = Object(component_normalizer["a" /* default */])(
  StatNumber,
  StatNumber_render,
  StatNumber_staticRenderFns,
  StatNumber___vue_template_functional__,
  StatNumber___vue_styles__,
  StatNumber___vue_scopeId__,
  StatNumber___vue_module_identifier__
)

/* harmony default export */ var StatNumber_StatNumber = (StatNumber_Component.exports);

// EXTERNAL MODULE: ./src/components/DatePicker/DatePicker.vue + 2 modules
var DatePicker = __webpack_require__(207);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatFilters/StatFilters.vue
var StatFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var StatFilters = ({
    components: {
        DatePicker: DatePicker["a" /* default */]
    },
    computed: StatFilters__extends({}, Object(vuex_esm["mapState"])({
        season: function season(state) {
            return state.stats.season;
        },
        bookingPeriod: function bookingPeriod(state) {
            return state.stats.bookingPeriod;
        },
        arrivalPeriod: function arrivalPeriod(state) {
            return state.stats.arrivalPeriod;
        }
    })),
    watch: {
        bookingPeriod: function bookingPeriod() {
            var supplierId = store_default.a.state.auth.supplier.id;
            store_default.a.dispatch('stats/getPeriodRevenue', supplierId);
        },
        arrivalPeriod: function arrivalPeriod() {
            var supplierId = store_default.a.state.auth.supplier.id;
            store_default.a.dispatch('stats/getPeriodRevenue', supplierId);
        }
    },
    methods: StatFilters__extends({}, Object(vuex_esm["mapActions"])({
        updateBookingPeriod: 'stats/updateBookingPeriod',
        updateArrivalPeriod: 'stats/updateArrivalPeriod',
        getPeriodRevenue: 'stats/getPeriodRevenue'

    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0b2574","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatFilters/StatFilters.vue
var StatFilters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-filters"},[_c('div',{staticClass:"stat-filters__option"},[_c('date-picker',{attrs:{"value":_vm.bookingPeriod,"label":_vm.$t('statFilters.datepickers.booking.label'),"heading":_vm.$t('statFilters.datepickers.booking.heading')},on:{"input":function($event){return _vm.updateBookingPeriod($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"stat-filters__option"},[_c('date-picker',{attrs:{"value":_vm.arrivalPeriod,"label":_vm.$t('statFilters.datepickers.arrival.label'),"heading":_vm.$t('statFilters.datepickers.arrival.heading')},on:{"input":function($event){return _vm.updateArrivalPeriod($event)}}})],1)])}
var StatFilters_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/StatFilters/StatFilters.vue
/* script */


/* template */

/* template functional */
var StatFilters___vue_template_functional__ = false
/* styles */
var StatFilters___vue_styles__ = null
/* scopeId */
var StatFilters___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StatFilters___vue_module_identifier__ = null

var StatFilters_Component = Object(component_normalizer["a" /* default */])(
  StatFilters,
  StatFilters_render,
  StatFilters_staticRenderFns,
  StatFilters___vue_template_functional__,
  StatFilters___vue_styles__,
  StatFilters___vue_scopeId__,
  StatFilters___vue_module_identifier__
)

/* harmony default export */ var StatFilters_StatFilters = (StatFilters_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatInventoryChart/StatInventoryChart.vue
var StatInventoryChart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var StatInventoryChart = ({
    extends: es["a" /* HorizontalBar */],
    props: {
        chartData: {
            type: Array,
            required: true
        },
        labels: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        filteredAccommodations: {
            type: Array,
            required: true
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler: function handler() {
                this.$data._chart.destroy();
                this.renderChart({ labels: this.labels, datasets: this.chartData }, StatInventoryChart__extends({}, this.options, { onHover: this.showCursor }));
            }
        }
    },
    mounted: function mounted() {
        this.renderChart({ labels: this.labels, datasets: this.chartData }, StatInventoryChart__extends({}, this.options));
    }
});
// CONCATENATED MODULE: ./src/components/StatInventoryChart/StatInventoryChart.vue
/* script */


/* template */
var StatInventoryChart___vue_render__, StatInventoryChart___vue_static_render_fns__
/* template functional */
var StatInventoryChart___vue_template_functional__ = false
/* styles */
var StatInventoryChart___vue_styles__ = null
/* scopeId */
var StatInventoryChart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StatInventoryChart___vue_module_identifier__ = null

var StatInventoryChart_Component = Object(component_normalizer["a" /* default */])(
  StatInventoryChart,
  StatInventoryChart___vue_render__,
  StatInventoryChart___vue_static_render_fns__,
  StatInventoryChart___vue_template_functional__,
  StatInventoryChart___vue_styles__,
  StatInventoryChart___vue_scopeId__,
  StatInventoryChart___vue_module_identifier__
)

/* harmony default export */ var StatInventoryChart_StatInventoryChart = (StatInventoryChart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatInventory/StatInventory.vue
var StatInventory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function StatInventory__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







/* harmony default export */ var StatInventory = ({
    components: {
        StatInventoryChart: StatInventoryChart_StatInventoryChart,
        DropdownMenu: DropdownMenu["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    data: function data() {
        return {
            chartHeight: 400
        };
    },

    computed: StatInventory__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.stats.statSites.loading;
        },
        error: function error(state) {
            return state.stats.statSites.error;
        },
        noContent: function noContent(state) {
            return state.stats.statSites.noContent;
        },
        period: function period(state) {
            return state.stats.period;
        },
        selectedSite: function selectedSite(state) {
            return state.stats.selectedSite;
        },
        predicate: function predicate(state) {
            return state.stats.statInventory.predicate;
        },
        predicates: function predicates(state) {
            return state.stats.statInventory.predicates;
        }
    }), {
        chartData: function chartData() {
            var _this = this;

            var _chartData = {
                label: 'Sales',
                backgroundColor: '#64C1C7'
            };

            _chartData.data = Object(lodash["map"])(this.filteredAccommodations, function (accommodation) {
                return accommodation[_this.predicate];
            });

            return [_chartData];
        },
        labels: function labels() {
            return Object(lodash["map"])(this.filteredAccommodations, function (accommodation) {
                return accommodation.name;
            });
        },
        filteredAccommodations: function filteredAccommodations() {
            var _this2 = this;

            if (!Object(lodash["get"])(this.selectedSite, 'accommodations', undefined)) {
                return undefined;
            }

            var _accommodations = [].concat(StatInventory__toConsumableArray(this.selectedSite.accommodations));

            _accommodations.sort(function (a, b) {
                return b[_this2.predicate] - a[_this2.predicate];
            });

            return _accommodations.slice(0, 10);
        },
        options: function options() {
            var _this3 = this;

            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function callback(value) {
                                // Removed all decimal point numbers from the axis.
                                if (value % 1 === 0) {
                                    return _this3.predicate === 'revenue' ? '\u20AC ' + _this3.$shortNumber(value) : value;
                                }
                            }
                        }
                    }]
                },
                tooltips: {
                    enabled: true
                }
            };
        }
    }),
    methods: StatInventory__extends({}, Object(vuex_esm["mapActions"])({
        setFilter: 'stats/setFilter'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebefc96e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatInventory/StatInventory.vue
var StatInventory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-inventory"},[((_vm.noContent || _vm.error) && !_vm.loading)?_c('div',{key:'no-content',staticClass:"stat-inventory__no-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"stat-inventory__no-content-message"},[(_vm.noContent)?_c('span',[_vm._v(_vm._s(_vm.$t("statInventory.noContent.missing")))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('span',[_vm._v(_vm._s(_vm.$t("statInventory.noContent.error")))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedSite && _vm.selectedSite.accommodations && !_vm.loading)?_c('div',{key:'content',staticClass:"stat-inventory__content"},[_c('div',{staticClass:"stat-inventory__header"},[(_vm.selectedSite && _vm.selectedSite.accommodations.length > 10)?_c('div',{staticClass:"stat-inventory__heading"},[_vm._v("\n                "+_vm._s(_vm.$t(("statInventory.predicate." + _vm.predicate)))+": "+_vm._s(_vm.$t("statInventory.alternativeHeading"))+"\n            ")]):_c('div',{staticClass:"stat-inventory__heading"},[_vm._v("\n                "+_vm._s(_vm.$t(("statInventory.predicate." + _vm.predicate)))+": "+_vm._s(_vm.$t("statInventory.heading"))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"stat-inventory__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('statInventory.dropdown.label'),"value":_vm.predicate,"items":_vm.predicates,"translation-prefix":'statInventory.predicate'},on:{"input":function($event){return _vm.setFilter({accommodation: $event})}}})],1)]),_vm._v(" "),_c('div',{staticClass:"stat-inventory__body"},[_c('stat-inventory-chart',{attrs:{"chart-data":_vm.chartData,"labels":_vm.labels,"height":_vm.chartHeight,"options":_vm.options,"filtered-accommodations":_vm.filteredAccommodations}})],1)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":10,"body-cells":4}}):_vm._e()],1)}
var StatInventory_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-inventory__no-content-icon"},[_c('i',{staticClass:"fa fa-fw fa-exclamation-triangle"})])}]

// CONCATENATED MODULE: ./src/components/StatInventory/StatInventory.vue
/* script */


/* template */

/* template functional */
var StatInventory___vue_template_functional__ = false
/* styles */
var StatInventory___vue_styles__ = null
/* scopeId */
var StatInventory___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StatInventory___vue_module_identifier__ = null

var StatInventory_Component = Object(component_normalizer["a" /* default */])(
  StatInventory,
  StatInventory_render,
  StatInventory_staticRenderFns,
  StatInventory___vue_template_functional__,
  StatInventory___vue_styles__,
  StatInventory___vue_scopeId__,
  StatInventory___vue_module_identifier__
)

/* harmony default export */ var StatInventory_StatInventory = (StatInventory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatList/StatList.vue
var StatList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function StatList__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




/* harmony default export */ var StatList = ({
    components: {
        DropdownMenu: DropdownMenu["a" /* default */]
    },
    computed: StatList__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.stats.sites;
        },
        selectedItem: function selectedItem(state) {
            return state.stats.statList.selectedItem;
        },
        predicate: function predicate(state) {
            return state.stats.statList.predicate;
        },
        predicates: function predicates(state) {
            return state.stats.statList.predicates;
        }
    }), {
        filteredSites: function filteredSites() {
            var _this = this;

            var _sites = [].concat(StatList__toConsumableArray(this.sites));
            _sites.sort(function (a, b) {
                return b[_this.predicate] - a[_this.predicate];
            });
            return _sites.slice(0, 10);
        },
        filteredItems: function filteredItems() {
            var _this2 = this;

            if (!this.selectedItem || !this.selectedItem.accommodations) {
                return undefined;
            }
            var _items = [].concat(StatList__toConsumableArray(this.selectedItem.accommodations));
            _items.sort(function (a, b) {
                return b[_this2.predicate] - a[_this2.predicate];
            });
            return _items.slice(0, 10);
        }
    }),
    methods: StatList__extends({}, Object(vuex_esm["mapActions"])({
        updateSelectedStatListItem: 'stats/updateSelectedStatListItem',
        setFilter: 'stats/setFilter'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab8fb6d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatList/StatList.vue
var StatList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-list"},[(_vm.sites)?_c('div',{staticClass:"stat-list__content"},[_c('div',{staticClass:"stat-list__header"},[_vm._v("\n            "+_vm._s(_vm.$t('statList.heading'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stat-list__body"},[_c('div',{staticClass:"stat-list__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('statSites.dropdown.label'),"value":_vm.predicate,"items":_vm.predicates,"translation-prefix":'statSites.predicate'},on:{"input":function($event){return _vm.setFilter({list: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"stat-list__items"},[_vm._l((_vm.filteredSites),function(site){return _c('div',{key:site.id,staticClass:"stat-list__item",on:{"click":function($event){return _vm.updateSelectedStatListItem(site)}}},[_c('div',{staticClass:"stat-list__label"},[_vm._v("\n                        "+_vm._s(site.name)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"stat-list__value"},[_vm._v("\n                        "+_vm._s(_vm.predicate === 'revenue' ? '€' : '')+"\n                        "+_vm._s(_vm.$shortNumber(site[_vm.predicate]))+"\n                    ")])])}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-in"}},[(_vm.selectedItem)?_c('div',{staticClass:"stat-list__inventory"},[_c('div',{staticClass:"stat-list__inventory-back",on:{"click":function($event){return _vm.updateSelectedStatListItem(undefined)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('statList.backButton'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"stat-list__inventory-list"},_vm._l((_vm.filteredItems),function(item){return _c('div',{key:item.id,staticClass:"stat-list__inventory-item"},[_c('div',{staticClass:"stat-list__inventory-label"},[_vm._v("\n                                    "+_vm._s(item.name)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"stat-list__inventory-value"},[_vm._v("\n                                    "+_vm._s(_vm.predicate === 'revenue' ? '€' : '')+"\n                                    "+_vm._s(_vm.$shortNumber(item[_vm.predicate]))+"\n                                ")])])}),0)]):_vm._e()])],2)])]):_vm._e()])}
var StatList_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/StatList/StatList.vue
/* script */


/* template */

/* template functional */
var StatList___vue_template_functional__ = false
/* styles */
var StatList___vue_styles__ = null
/* scopeId */
var StatList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StatList___vue_module_identifier__ = null

var StatList_Component = Object(component_normalizer["a" /* default */])(
  StatList,
  StatList_render,
  StatList_staticRenderFns,
  StatList___vue_template_functional__,
  StatList___vue_styles__,
  StatList___vue_scopeId__,
  StatList___vue_module_identifier__
)

/* harmony default export */ var StatList_StatList = (StatList_Component.exports);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatPage/StatPage.vue
var StatPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











/* harmony default export */ var StatPage = ({
    components: {
        StatSites: StatSites_StatSites,
        StatNumber: StatNumber_StatNumber,
        StatFilters: StatFilters_StatFilters,
        StatList: StatList_StatList,
        StatInventory: StatInventory_StatInventory,
        InfoWidget: InfoWidget["a" /* default */]
    },
    computed: StatPage__extends({}, Object(vuex_esm["mapState"])({
        totalRevenue: function totalRevenue(state) {
            return state.stats.totalRevenue;
        },
        totalBookings: function totalBookings(state) {
            return state.stats.totalBookings;
        },
        periodRevenue: function periodRevenue(state) {
            return state.stats.periodRevenue;
        },
        periodBookings: function periodBookings(state) {
            return state.stats.periodBookings;
        },
        bookingPeriod: function bookingPeriod(state) {
            return state.stats.bookingPeriod;
        },
        arrivalPeriod: function arrivalPeriod(state) {
            return state.stats.arrivalPeriod;
        },
        tips: function tips(state) {
            return state.stats.tips;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    watch: {
        supplier: function supplier(_supplier) {
            store_default.a.dispatch('stats/getPeriodRevenue', _supplier.id);
            store_default.a.dispatch('stats/getTotalRevenue', _supplier.id);
        }
    },
    created: function created() {
        this.toggleNavMenu(false);
        this.getPeriodRevenue(this.supplier.id);
        this.getTotalRevenue(this.supplier.id);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        Promise.all([this.$refs.infoWidget.clean()]).then(function () {
            next();
        });
    },
    destroyed: function destroyed() {
        this.resetState();
    },

    methods: StatPage__extends({}, Object(vuex_esm["mapActions"])({
        getPeriodRevenue: 'stats/getPeriodRevenue',
        getTotalRevenue: 'stats/getTotalRevenue',
        resetState: 'stats/resetState',
        toggleNavMenu: 'nav/toggleNavMenu'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc89495c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatPage/StatPage.vue
var StatPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 col-xs-6"},[_c('stat-number',{attrs:{"value":_vm.periodRevenue.value,"loading":_vm.periodRevenue.loading,"error":_vm.periodRevenue.error,"no-content":_vm.periodRevenue.noContent,"label":_vm.$t('subPages.home.labelPeriodRevenue'),"subtitle":_vm.$t('subPages.home.subTitleRevenue'),"alternative":false}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-xs-6"},[_c('stat-number',{attrs:{"value":_vm.periodBookings.value,"loading":_vm.periodBookings.loading,"error":_vm.periodBookings.error,"no-content":_vm.periodBookings.noContent,"label":_vm.$t('subPages.home.labelPeriodBookings'),"subtitle":_vm.$t('subPages.home.subTitleBookings'),"alternative":false}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-xs-6"},[_c('stat-number',{attrs:{"value":_vm.totalRevenue.value,"loading":_vm.totalRevenue.loading,"error":_vm.totalRevenue.error,"no-content":_vm.totalRevenue.noContent,"label":_vm.$t('subPages.home.labelTotalRevenue'),"subtitle":_vm.$t('subPages.home.subTitleRevenue'),"alternative":true}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-xs-6"},[_c('stat-number',{attrs:{"value":_vm.totalBookings.value,"loading":_vm.totalBookings.loading,"error":_vm.totalBookings.error,"no-content":_vm.totalBookings.noContent,"label":_vm.$t('subPages.home.labelTotalBookings'),"subtitle":_vm.$t('subPages.home.subTitleBookings'),"alternative":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('stat-filters')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('stat-sites'),_vm._v(" "),_c('stat-list')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('stat-inventory')],1)]),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}})],1)}
var StatPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/StatPage/StatPage.vue
/* script */


/* template */

/* template functional */
var StatPage___vue_template_functional__ = false
/* styles */
var StatPage___vue_styles__ = null
/* scopeId */
var StatPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StatPage___vue_module_identifier__ = null

var StatPage_Component = Object(component_normalizer["a" /* default */])(
  StatPage,
  StatPage_render,
  StatPage_staticRenderFns,
  StatPage___vue_template_functional__,
  StatPage___vue_styles__,
  StatPage___vue_scopeId__,
  StatPage___vue_module_identifier__
)

/* harmony default export */ var StatPage_StatPage = __webpack_exports__["default"] = (StatPage_Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.8.0
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(5); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

/* MIT license */

var conversions = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
};


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}

var convert = function() {
   return new Converter();
};

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   };
});

var colorConvert = convert;

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName) {
   reverseNames[colorName[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$2 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$2.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$2.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();

		if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
			meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
			meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this.update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

var element_arc = core_element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var angleMargin;

		ctx.save();

		ctx.beginPath();
		ctx.arc(vm.x, vm.y, Math.max(vm.outerRadius - pixelMargin, 0), sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
		ctx.closePath();

		ctx.fillStyle = vm.backgroundColor;
		ctx.fill();

		if (vm.borderWidth) {
			if (vm.borderAlign === 'inner') {
				// Draw an inner border by cliping the arc and drawing a double-width border
				// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
				ctx.beginPath();
				angleMargin = pixelMargin / vm.outerRadius;
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA - angleMargin, eA + angleMargin);
				if (vm.innerRadius > pixelMargin) {
					angleMargin = pixelMargin / vm.innerRadius;
					ctx.arc(vm.x, vm.y, vm.innerRadius - pixelMargin, eA + angleMargin, sA - angleMargin, true);
				} else {
					ctx.arc(vm.x, vm.y, pixelMargin, eA + Math.PI / 2, sA - Math.PI / 2);
				}
				ctx.closePath();
				ctx.clip();

				ctx.beginPath();
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
				ctx.closePath();

				ctx.lineWidth = vm.borderWidth * 2;
				ctx.lineJoin = 'round';
			} else {
				ctx.lineWidth = vm.borderWidth;
				ctx.lineJoin = 'bevel';
			}

			ctx.strokeStyle = vm.borderColor;
			ctx.stroke();
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers$1.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			categoryPercentage: 0.8,
			barPercentage: 0.9,
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale.isHorizontal() ? scale.width : scale.height;
	var ticks = scale.getTicks();
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, curr - prev) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = ruler.min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	initialize: function() {
		var me = this;
		var meta;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		me._updateElementGeometry(rectangle, index, reset);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var chart = me.chart;
		var scale = me._getIndexScale();
		var stacked = scale.options.stacked;
		var ilen = last === undefined ? chart.data.datasets.length : last + 1;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = chart.getDatasetMeta(i);
			if (meta.bar && chart.isDatasetVisible(i) &&
				(stacked === false ||
				(stacked === true && stacks.indexOf(meta.stack) === -1) ||
				(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
				stacks.push(meta.stack);
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var stackCount = me.getStackCount();
		var datasetIndex = me.index;
		var isHorizontal = scale.isHorizontal();
		var start = isHorizontal ? scale.left : scale.top;
		var end = start + (isHorizontal ? scale.width : scale.height);
		var pixels = [];
		var i, ilen, min;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, datasetIndex));
		}

		min = helpers$1.isNullOrUndef(scale.options.barThickness)
			? computeMinSampleSize(scale, pixels)
			: -1;

		return {
			min: min,
			pixels: pixels,
			start: start,
			end: end,
			stackCount: stackCount,
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index) {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var value = +scale.getRightValue(datasets[datasetIndex].data[index]);
		var minBarLength = scale.options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = meta.stack;
		var start = 0;
		var i, imeta, ivalue, base, head, size;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < datasetIndex; ++i) {
				imeta = chart.getDatasetMeta(i);

				if (imeta.bar &&
					imeta.stack === stack &&
					imeta.controller._getValueScaleId() === scale.id &&
					chart.isDatasetVisible(i)) {

					ivalue = +scale.getRightValue(datasets[i].data[index]);
					if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + value);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (value >= 0 && !isHorizontal || value < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler) {
		var me = this;
		var options = ruler.scale.options;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			helpers$1.valueOrDefault(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			if (!isNaN(scale.getRightValue(dataset.data[i]))) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(rectangle, index) {
		var me = this;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var dataset = datasets[me.index];
		var custom = rectangle.custom || {};
		var options = chart.options.elements.rectangle;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$1([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	}
});

var valueOrDefault$3 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$3(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$3(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$3(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var dataset = datasets[me.index];
		var custom = point.custom || {};
		var options = chart.options.elements.point;
		var data = dataset.data[index];
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$2([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		// Custom radius resolution
		values.radius = resolve$2([
			custom.radius,
			data ? data.r : undefined,
			dataset.radius,
			options.radius
		], context, index);

		return values;
	}
});

var resolve$3 = helpers$1.options.resolve;
var valueOrDefault$4 = helpers$1.valueOrDefault;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var arcOpts = chart.options.elements.arc;
						var fill = resolve$3([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
						var stroke = resolve$3([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
						var bw = resolve$3([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var availableWidth = chartArea.right - chartArea.left;
		var availableHeight = chartArea.bottom - chartArea.top;
		var minSize = Math.min(availableWidth, availableHeight);
		var offset = {x: 0, y: 0};
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutoutPercentage = opts.cutoutPercentage;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var i, ilen;

		// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
		if (circumference < Math.PI * 2.0) {
			var startAngle = opts.rotation % (Math.PI * 2.0);
			startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
			var endAngle = startAngle + circumference;
			var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
			var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
			var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
			var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
			var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
			var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
			var cutout = cutoutPercentage / 100.0;
			var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
			var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
			var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
			minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
			offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
		chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offset.x * chart.outerRadius;
		chart.offsetY = offset.y * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return (Math.PI * 2.0) * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			options = controller ? controller._resolveElementOptions(arc, i) : arc._options;
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(arc, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = arc.custom || {};
		var options = chart.options.elements.arc;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$3([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$4(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			categoryPercentage: 0.8,
			barPercentage: 0.9,
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;
var resolve$4 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function lineEnabled(dataset, options) {
	return valueOrDefault$5(dataset.showLine, options.showLines);
}

var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.getScaleForId(meta.yAxisID);
		var dataset = me.getDataset();
		var showLine = lineEnabled(dataset, me.chart.options);
		var i, ilen;

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveLineOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var yScale = me.getScaleForId(meta.yAxisID);
		var xScale = me.getScaleForId(meta.xAxisID);
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolvePointOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$5(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolvePointOptions: function(element, index) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options.elements.point;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var ELEMENT_OPTIONS = {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		};
		var keys = Object.keys(ELEMENT_OPTIONS);

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$4([
				custom[key],
				dataset[ELEMENT_OPTIONS[key]],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveLineOptions: function(element) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options;
		var elementOptions = options.elements.line;
		var values = {};
		var i, ilen, key;

		var keys = [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill',
			'cubicInterpolationMode'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$4([
				custom[key],
				dataset[key],
				elementOptions[key]
			]);
		}

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$5(dataset.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$5(dataset.lineTension, elementOptions.tension);
		values.steppedLine = resolve$4([custom.steppedLine, dataset.steppedLine, elementOptions.stepped]);

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var yScale = me.getScaleForId(meta.yAxisID);
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta;

		if (yScale.options.stacked) {
			for (i = 0; i < datasetIndex; i++) {
				ds = chart.data.datasets[i];
				dsMeta = chart.getDatasetMeta(i);
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
					var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			var rightValue = Number(yScale.getRightValue(value));
			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}

		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var ilen = points.length;
		var halfBorderWidth;
		var i = 0;

		if (lineEnabled(me.getDataset(), chart.options)) {
			halfBorderWidth = (meta.dataset._model.borderWidth || 0) / 2;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: area.left,
				right: area.right,
				top: area.top - halfBorderWidth,
				bottom: area.bottom + halfBorderWidth
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$5(options.hoverRadius, options.radius);
	},
});

var resolve$5 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var arcOpts = chart.options.elements.arc;
						var fill = resolve$5([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
						var stroke = resolve$5([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
						var bw = resolve$5([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(arc, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = arc.custom || {};
		var options = chart.options.elements.arc;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$5([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$5([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$6 = helpers$1.options.resolve;

core_defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var dataset = me.getDataset();
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
			dataset.lineTension = dataset.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveLineOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolvePointOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolvePointOptions: function(element, index) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options.elements.point;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var ELEMENT_OPTIONS = {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		};
		var keys = Object.keys(ELEMENT_OPTIONS);

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$6([
				custom[key],
				dataset[ELEMENT_OPTIONS[key]],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveLineOptions: function(element) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options.elements.line;
		var values = {};
		var i, ilen, key;

		var keys = [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$6([
				custom[key],
				dataset[key],
				options[key]
			]);
		}

		values.tension = valueOrDefault$6(dataset.lineTension, options.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.position === position;
	});
}

function sortByWeight(array, reverse) {
	array.forEach(function(v, i) {
		v._tmpIndex_ = i;
		return v;
	});
	array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0._tmpIndex_ - v1._tmpIndex_ :
			v0.weight - v1.weight;
	});
	array.forEach(function(v) {
		delete v._tmpIndex_;
	});
}

function findMaxPadding(boxes) {
	var top = 0;
	var left = 0;
	var bottom = 0;
	var right = 0;
	helpers$1.each(boxes, function(box) {
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			top = Math.max(top, boxPadding.top);
			left = Math.max(left, boxPadding.left);
			bottom = Math.max(bottom, boxPadding.bottom);
			right = Math.max(right, boxPadding.right);
		}
	});
	return {
		top: top,
		left: left,
		bottom: bottom,
		right: right
	};
}

function addSizeByPosition(boxes, size) {
	helpers$1.each(boxes, function(box) {
		size[box.position] += box.isHorizontal() ? box.height : box.width;
	});
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);
		var leftPadding = padding.left;
		var rightPadding = padding.right;
		var topPadding = padding.top;
		var bottomPadding = padding.bottom;

		var leftBoxes = filterByPosition(chart.boxes, 'left');
		var rightBoxes = filterByPosition(chart.boxes, 'right');
		var topBoxes = filterByPosition(chart.boxes, 'top');
		var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
		var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

		// Sort boxes by weight. A higher weight is further away from the chart area
		sortByWeight(leftBoxes, true);
		sortByWeight(rightBoxes, false);
		sortByWeight(topBoxes, true);
		sortByWeight(bottomBoxes, false);

		var verticalBoxes = leftBoxes.concat(rightBoxes);
		var horizontalBoxes = topBoxes.concat(bottomBoxes);
		var outerBoxes = verticalBoxes.concat(horizontalBoxes);

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//
		// What we do to find the best sizing, we do the following
		// 1. Determine the minimum size of the chart area.
		// 2. Split the remaining width equally between each vertical axis
		// 3. Split the remaining height equally between each horizontal axis
		// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
		// 5. Adjust the sizes of each axis based on it's minimum reported size.
		// 6. Refit each axis
		// 7. Position each axis in the final location
		// 8. Tell the chart the final location of the chart area
		// 9. Tell any axes that overlay the chart area the positions of the chart area

		// Step 1
		var chartWidth = width - leftPadding - rightPadding;
		var chartHeight = height - topPadding - bottomPadding;
		var chartAreaWidth = chartWidth / 2; // min 50%

		// Step 2
		var verticalBoxWidth = (width - chartAreaWidth) / verticalBoxes.length;

		// Step 3
		// TODO re-limit horizontal axis height (this limit has affected only padding calculation since PR 1837)
		// var horizontalBoxHeight = (height - chartAreaHeight) / horizontalBoxes.length;

		// Step 4
		var maxChartAreaWidth = chartWidth;
		var maxChartAreaHeight = chartHeight;
		var outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
		var minBoxSizes = [];
		var maxPadding;

		function getMinimumBoxSize(box) {
			var minSize;
			var isHorizontal = box.isHorizontal();

			if (isHorizontal) {
				minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2);
				maxChartAreaHeight -= minSize.height;
			} else {
				minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
				maxChartAreaWidth -= minSize.width;
			}

			minBoxSizes.push({
				horizontal: isHorizontal,
				width: minSize.width,
				box: box,
			});
		}

		helpers$1.each(outerBoxes, getMinimumBoxSize);

		// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
		maxPadding = findMaxPadding(outerBoxes);

		// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
		// be if the axes are drawn at their minimum sizes.
		// Steps 5 & 6

		// Function to fit a box
		function fitBox(box) {
			var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minBox) {
				return minBox.box === box;
			});

			if (minBoxSize) {
				if (minBoxSize.horizontal) {
					var scaleMargin = {
						left: Math.max(outerBoxSizes.left, maxPadding.left),
						right: Math.max(outerBoxSizes.right, maxPadding.right),
						top: 0,
						bottom: 0
					};

					// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
					// on the margin. Sometimes they need to increase in size slightly
					box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
				} else {
					box.update(minBoxSize.width, maxChartAreaHeight);
				}
			}
		}

		// Update, and calculate the left and right margins for the horizontal boxes
		helpers$1.each(verticalBoxes, fitBox);
		addSizeByPosition(verticalBoxes, outerBoxSizes);

		// Set the Left and Right margins for the horizontal boxes
		helpers$1.each(horizontalBoxes, fitBox);
		addSizeByPosition(horizontalBoxes, outerBoxSizes);

		function finalFitVerticalBox(box) {
			var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minSize) {
				return minSize.box === box;
			});

			var scaleMargin = {
				left: 0,
				right: 0,
				top: outerBoxSizes.top,
				bottom: outerBoxSizes.bottom
			};

			if (minBoxSize) {
				box.update(minBoxSize.width, maxChartAreaHeight, scaleMargin);
			}
		}

		// Let the left layout know the final margin
		helpers$1.each(verticalBoxes, finalFitVerticalBox);

		// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
		outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
		addSizeByPosition(outerBoxes, outerBoxSizes);

		// We may be adding some padding to account for rotated x axis labels
		var leftPaddingAddition = Math.max(maxPadding.left - outerBoxSizes.left, 0);
		outerBoxSizes.left += leftPaddingAddition;
		outerBoxSizes.right += Math.max(maxPadding.right - outerBoxSizes.right, 0);

		var topPaddingAddition = Math.max(maxPadding.top - outerBoxSizes.top, 0);
		outerBoxSizes.top += topPaddingAddition;
		outerBoxSizes.bottom += Math.max(maxPadding.bottom - outerBoxSizes.bottom, 0);

		// Figure out if our chart area changed. This would occur if the dataset layout label rotation
		// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
		// without calling `fit` again
		var newMaxChartAreaHeight = height - outerBoxSizes.top - outerBoxSizes.bottom;
		var newMaxChartAreaWidth = width - outerBoxSizes.left - outerBoxSizes.right;

		if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
			helpers$1.each(verticalBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers$1.each(horizontalBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			maxChartAreaHeight = newMaxChartAreaHeight;
			maxChartAreaWidth = newMaxChartAreaWidth;
		}

		// Step 7 - Position the boxes
		var left = leftPadding + leftPaddingAddition;
		var top = topPadding + topPaddingAddition;

		function placeBox(box) {
			if (box.isHorizontal()) {
				box.left = box.fullWidth ? leftPadding : outerBoxSizes.left;
				box.right = box.fullWidth ? width - rightPadding : outerBoxSizes.left + maxChartAreaWidth;
				box.top = top;
				box.bottom = top + box.height;

				// Move to next point
				top = box.bottom;

			} else {

				box.left = left;
				box.right = left + box.width;
				box.top = outerBoxSizes.top;
				box.bottom = outerBoxSizes.top + maxChartAreaHeight;

				// Move to next point
				left = box.right;
			}
		}

		helpers$1.each(leftBoxes.concat(topBoxes), placeBox);

		// Account for chart width and height
		left += maxChartAreaWidth;
		top += maxChartAreaHeight;

		helpers$1.each(rightBoxes, placeBox);
		helpers$1.each(bottomBoxes, placeBox);

		// Step 8
		chart.chartArea = {
			left: outerBoxSizes.left,
			top: outerBoxSizes.top,
			right: outerBoxSizes.left + maxChartAreaWidth,
			bottom: outerBoxSizes.top + maxChartAreaHeight
		};

		// Step 9
		helpers$1.each(chartAreaBoxes, function(box) {
			box.left = chart.chartArea.left;
			box.top = chart.chartArea.top;
			box.right = chart.chartArea.right;
			box.bottom = chart.chartArea.bottom;

			box.update(maxChartAreaWidth, maxChartAreaHeight);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
default: platform_dom
});

function getCjsExportFromNamespace (n) {
	return n && n.default || n;
}

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// https://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * @private
	 */
	_ensureLoaded: function() {
		if (this._loaded) {
			return;
		}

		this._loaded = true;

		// https://github.com/chartjs/Chart.js/issues/5208
		if (!this.disableCSSInjection) {
			injectCSS(this, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// Load platform resources on first chart creation, to make possible to change
		// platform options after importing the library (e.g. `disableCSSInjection`).
		this._ensureLoaded();

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$7(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$7(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$7(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$7(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$7(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$7(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$7(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$7(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$7(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$3 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;

		if (title.length) {
			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = vm._titleAlign;
			ctx.textBaseline = 'top';

			var titleFontSize = vm.titleFontSize;
			var titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			var i, len;
			for (i = 0, len = title.length; i < len; ++i) {
				ctx.fillText(title[i], pt.x, pt.y);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === title.length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var labelColors = vm.labelColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
		var textColor;

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'top';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlign);

		// Before Body
		var fillLineOfText = function(line) {
			ctx.fillText(line, pt.x + xLinePadding, pt.y);
			pt.y += bodyFontSize + bodySpacing;
		};

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlign !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		helpers$1.each(body, function(bodyItem, i) {
			textColor = vm.labelTextColors[i];
			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			helpers$1.each(bodyItem.lines, function(line) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(colorX, pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors[i].borderColor;
					ctx.strokeRect(colorX, pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors[i].backgroundColor;
					ctx.fillRect(colorX + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(line);
			});

			helpers$1.each(bodyItem.after, fillLineOfText);
		});

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;

		if (footer.length) {
			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = vm._footerAlign;
			ctx.textBaseline = 'top';

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			helpers$1.each(footer, function(line) {
				ctx.fillText(line, pt.x, pt.y);
				pt.y += vm.footerFontSize + vm.footerSpacing;
			});
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$3;
core_tooltip.positioners = positioners_1;

var valueOrDefault$8 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$8(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || {};
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || {};

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		// Make sure scales have IDs and are built before we build any controllers.
		me.ensureScalesHaveIDs();
		me.buildOrUpdateScales();
		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$8(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];

		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			var meta = me.getDatasetMeta(datasetIndex);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(datasetIndex);
				meta = me.getDatasetMeta(datasetIndex);
			}
			meta.type = type;

			if (meta.controller) {
				meta.controller.updateIndex(datasetIndex);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, datasetIndex);
				newControllers.push(meta.controller);
			}
		}, me);

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
		}, me);

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller.update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$8(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Draw all the scales
		helpers$1.each(me.boxes, function(box) {
			box.draw(me.chartArea);
		}, me);

		me.drawDatasets(easingValue);
		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		// Draw datasets reversed to support proper line stacking
		for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
			if (me.isDatasetVisible(i)) {
				me.drawDataset(i, easingValue);
			}
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(index, easingValue) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[method](element);
			}
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);

			return isPowerOf10 ? powerOf10 : exponent;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers$1.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers$1.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					tickString = tickValue.toExponential(Math.floor(logTick) - Math.floor(logDelta));
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var valueOrDefault$9 = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (scale.getTicks().length === 1) {
			lineValue -= scale.isHorizontal() ?
				Math.max(lineValue - scale.left, scale.right - lineValue) :
				Math.max(lineValue - scale.top, scale.bottom - lineValue);
		} else if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

function computeTextSize(context, tick, font) {
	return helpers$1.isArray(tick) ?
		helpers$1.longestText(context, font, tick) :
		context.measureText(tick).width;
}

var core_scale = core_element.extend({
	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	mergeTicksOptions: function() {
		var ticks = this.options.ticks;
		if (ticks.minor === false) {
			ticks.minor = {
				display: false
			};
		}
		if (ticks.major === false) {
			ticks.major = {
				display: false
			};
		}
		for (var key in ticks) {
			if (key !== 'major' && key !== 'minor') {
				if (typeof ticks.minor[key] === 'undefined') {
					ticks.minor[key] = ticks[key];
				}
				if (typeof ticks.major[key] === 'undefined') {
					ticks.major[key] = ticks[key];
				}
			}
		}
	},
	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var i, ilen, labels, label, ticks, tick;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = labels.length; i < ilen; ++i) {
			label = labels[i];
			tick = ticks[i];
			if (!tick) {
				ticks.push(tick = {
					label: label,
					major: false
				});
			} else {
				tick.label = label;
			}
		}

		me._ticks = ticks;

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();
		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (helpers$1.isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var context = me.ctx;
		var tickOpts = me.options.ticks;
		var labels = labelsFromTicks(me._ticks);

		// Get the width of each grid by calculating the difference
		// between x offsets between 0 and 1.
		var tickFont = helpers$1.options._parseFont(tickOpts);
		context.font = tickFont.string;

		var labelRotation = tickOpts.minRotation || 0;

		if (labels.length && me.options.display && me.isHorizontal()) {
			var originalLabelWidth = helpers$1.longestText(context, tickFont.string, labels, me.longestTextCache);
			var labelWidth = originalLabelWidth;
			var cosRotation, sinRotation;

			// Allow 3 pixels x2 padding either side for label readability
			var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

			// Max label rotation can be set or default to 90 - also act as a loop counter
			while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
				var angleRadians = helpers$1.toRadians(labelRotation);
				cosRotation = Math.cos(angleRadians);
				sinRotation = Math.sin(angleRadians);

				if (sinRotation * originalLabelWidth > me.maxHeight) {
					// go back one step
					labelRotation--;
					break;
				}

				labelRotation++;
				labelWidth = cosRotation * originalLabelWidth;
			}
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var labels = labelsFromTicks(me._ticks);

		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var position = opts.position;
		var isHorizontal = me.isHorizontal();

		var parseFont = helpers$1.options._parseFont;
		var tickFont = parseFont(tickOpts);
		var tickMarkLength = opts.gridLines.tickMarkLength;

		// Width
		if (isHorizontal) {
			// subtract the margins to line up with the chartArea if we are a full width scale
			minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
		} else {
			minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
		}

		// height
		if (isHorizontal) {
			minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
		} else {
			minSize.height = me.maxHeight; // fill all the height
		}

		// Are we showing a title for the scale?
		if (scaleLabelOpts.display && display) {
			var scaleLabelFont = parseFont(scaleLabelOpts);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabelOpts.padding);
			var deltaHeight = scaleLabelFont.lineHeight + scaleLabelPadding.height;

			if (isHorizontal) {
				minSize.height += deltaHeight;
			} else {
				minSize.width += deltaHeight;
			}
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var largestTextWidth = helpers$1.longestText(me.ctx, tickFont.string, labels, me.longestTextCache);
			var tallestLabelHeightInLines = helpers$1.numberOfLabelLines(labels);
			var lineSpace = tickFont.size * 0.5;
			var tickPadding = me.options.ticks.padding;

			// Store max number of lines and widest label for _autoSkip
			me._maxLabelLines = tallestLabelHeightInLines;
			me.longestLabelWidth = largestTextWidth;

			if (isHorizontal) {
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				// TODO - improve this calculation
				var labelHeight = (sinRotation * largestTextWidth)
					+ (tickFont.lineHeight * tallestLabelHeightInLines)
					+ lineSpace; // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				me.ctx.font = tickFont.string;
				var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.string);
				var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.string);
				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(labels.length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (me.labelRotation !== 0) {
					paddingLeft = position === 'bottom' ? (cosRotation * firstLabelWidth) : (cosRotation * lineSpace);
					paddingRight = position === 'bottom' ? (cosRotation * lineSpace) : (cosRotation * lastLabelWidth);
				} else {
					paddingLeft = firstLabelWidth / 2;
					paddingRight = lastLabelWidth / 2;
				}
				me.paddingLeft = Math.max(paddingLeft - offsetLeft, 0) + 3; // add 3 px to move away from canvas edges
				me.paddingRight = Math.max(paddingRight - offsetRight, 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				if (tickOpts.mirror) {
					largestTextWidth = 0;
				} else {
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					largestTextWidth += tickPadding + lineSpace;
				}

				minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

				me.paddingTop = tickFont.size / 2;
				me.paddingBottom = tickFont.size / 2;
			}
		}

		me.handleMargins();

		me.width = minSize.width;
		me.height = minSize.height;
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
			me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
			me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
			me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},
	isFullWidth: function() {
		return (this.options.fullWidth);
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (helpers$1.isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}
		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		if (me.isHorizontal()) {
			var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
			var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var pixel = (tickWidth * index) + me.paddingLeft;

			if (offset) {
				pixel += tickWidth / 2;
			}

			var finalVal = me.left + pixel;
			finalVal += me.isFullWidth() ? me.margins.left : 0;
			return finalVal;
		}
		var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
		return me.top + (index * (innerHeight / (me._ticks.length - 1)));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;
		if (me.isHorizontal()) {
			var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
			var valueOffset = (innerWidth * decimal) + me.paddingLeft;

			var finalVal = me.left + valueOffset;
			finalVal += me.isFullWidth() ? me.margins.left : 0;
			return finalVal;
		}
		return me.top + (decimal * me.height);
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		var optionTicks = me.options.ticks.minor;
		var tickCount = ticks.length;
		var skipRatio = false;
		var maxTicks = optionTicks.maxTicksLimit;

		// Total space needed to display all ticks. First and last ticks are
		// drawn as their center at end of axis, so tickCount-1
		var ticksLength = me._tickSize() * (tickCount - 1);

		// Axis length
		var axisLength = isHorizontal
			? me.width - (me.paddingLeft + me.paddingRight)
			: me.height - (me.paddingTop + me.PaddingBottom);

		var result = [];
		var i, tick;

		if (ticksLength > axisLength) {
			skipRatio = 1 + Math.floor(ticksLength / axisLength);
		}

		// if they defined a max number of optionTicks,
		// increase skipRatio until that number is met
		if (tickCount > maxTicks) {
			skipRatio = Math.max(skipRatio, 1 + Math.floor(tickCount / maxTicks));
		}

		for (i = 0; i < tickCount; i++) {
			tick = ticks[i];

			if (skipRatio > 1 && i % skipRatio > 0) {
				// leave tick in place but make sure it's not displayed (#4635)
				delete tick.label;
			}
			result.push(tick);
		}
		return result;
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var isHorizontal = me.isHorizontal();
		var optionTicks = me.options.ticks.minor;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var padding = optionTicks.autoSkipPadding || 0;
		var w = (me.longestLabelWidth + padding) || 0;

		var tickFont = helpers$1.options._parseFont(optionTicks);
		var h = (me._maxLabelLines * tickFont.lineHeight + padding) || 0;

		// Calculate space needed for 1 tick in axis direction.
		return isHorizontal
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * Actually draw the scale on the canvas
	 * @param {object} chartArea - the area of the chart to draw full grid lines on
	 */
	draw: function(chartArea) {
		var me = this;
		var options = me.options;

		if (!me._isVisible()) {
			return;
		}

		var chart = me.chart;
		var context = me.ctx;
		var globalDefaults = core_defaults.global;
		var defaultFontColor = globalDefaults.defaultFontColor;
		var optionTicks = options.ticks.minor;
		var optionMajorTicks = options.ticks.major || optionTicks;
		var gridLines = options.gridLines;
		var scaleLabel = options.scaleLabel;
		var position = options.position;

		var isRotated = me.labelRotation !== 0;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();

		var parseFont = helpers$1.options._parseFont;
		var ticks = optionTicks.display && optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
		var tickFontColor = valueOrDefault$9(optionTicks.fontColor, defaultFontColor);
		var tickFont = parseFont(optionTicks);
		var lineHeight = tickFont.lineHeight;
		var majorTickFontColor = valueOrDefault$9(optionMajorTicks.fontColor, defaultFontColor);
		var majorTickFont = parseFont(optionMajorTicks);
		var tickPadding = optionTicks.padding;
		var labelOffset = optionTicks.labelOffset;

		var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

		var scaleLabelFontColor = valueOrDefault$9(scaleLabel.fontColor, defaultFontColor);
		var scaleLabelFont = parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var labelRotationRadians = helpers$1.toRadians(me.labelRotation);

		var itemsToDraw = [];

		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var alignPixel = helpers$1._alignPixel;
		var borderValue, tickStart, tickEnd;

		if (position === 'top') {
			borderValue = alignPixel(chart, me.bottom, axisWidth);
			tickStart = me.bottom - tl;
			tickEnd = borderValue - axisWidth / 2;
		} else if (position === 'bottom') {
			borderValue = alignPixel(chart, me.top, axisWidth);
			tickStart = borderValue + axisWidth / 2;
			tickEnd = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignPixel(chart, me.right, axisWidth);
			tickStart = me.right - tl;
			tickEnd = borderValue - axisWidth / 2;
		} else {
			borderValue = alignPixel(chart, me.left, axisWidth);
			tickStart = borderValue + axisWidth / 2;
			tickEnd = me.left + tl;
		}

		var epsilon = 0.0000001; // 0.0000001 is margin in pixels for Accumulated error.

		helpers$1.each(ticks, function(tick, index) {
			// autoskipper skipped this tick (#4635)
			if (helpers$1.isNullOrUndef(tick.label)) {
				return;
			}

			var label = tick.label;
			var lineWidth, lineColor, borderDash, borderDashOffset;
			if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, index);
				lineColor = valueAtIndexOrDefault(gridLines.color, index);
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			// Common properties
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY, textOffset, textAlign;
			var labelCount = helpers$1.isArray(label) ? label.length : 1;
			var lineValue = getPixelForGridLine(me, index, gridLines.offsetGridLines);

			if (isHorizontal) {
				var labelYOffset = tl + tickPadding;

				if (lineValue < me.left - epsilon) {
					lineColor = 'rgba(0,0,0,0)';
				}

				tx1 = tx2 = x1 = x2 = alignPixel(chart, lineValue, lineWidth);
				ty1 = tickStart;
				ty2 = tickEnd;
				labelX = me.getPixelForTick(index) + labelOffset; // x values for optionTicks (need to consider offsetLabel option)

				if (position === 'top') {
					y1 = alignPixel(chart, chartArea.top, axisWidth) + axisWidth / 2;
					y2 = chartArea.bottom;
					textOffset = ((!isRotated ? 0.5 : 1) - labelCount) * lineHeight;
					textAlign = !isRotated ? 'center' : 'left';
					labelY = me.bottom - labelYOffset;
				} else {
					y1 = chartArea.top;
					y2 = alignPixel(chart, chartArea.bottom, axisWidth) - axisWidth / 2;
					textOffset = (!isRotated ? 0.5 : 0) * lineHeight;
					textAlign = !isRotated ? 'center' : 'right';
					labelY = me.top + labelYOffset;
				}
			} else {
				var labelXOffset = (isMirrored ? 0 : tl) + tickPadding;

				if (lineValue < me.top - epsilon) {
					lineColor = 'rgba(0,0,0,0)';
				}

				tx1 = tickStart;
				tx2 = tickEnd;
				ty1 = ty2 = y1 = y2 = alignPixel(chart, lineValue, lineWidth);
				labelY = me.getPixelForTick(index) + labelOffset;
				textOffset = (1 - labelCount) * lineHeight / 2;

				if (position === 'left') {
					x1 = alignPixel(chart, chartArea.left, axisWidth) + axisWidth / 2;
					x2 = chartArea.right;
					textAlign = isMirrored ? 'left' : 'right';
					labelX = me.right - labelXOffset;
				} else {
					x1 = chartArea.left;
					x2 = alignPixel(chart, chartArea.right, axisWidth) - axisWidth / 2;
					textAlign = isMirrored ? 'right' : 'left';
					labelX = me.left + labelXOffset;
				}
			}

			itemsToDraw.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				labelX: labelX,
				labelY: labelY,
				glWidth: lineWidth,
				glColor: lineColor,
				glBorderDash: borderDash,
				glBorderDashOffset: borderDashOffset,
				rotation: -1 * labelRotationRadians,
				label: label,
				major: tick.major,
				textOffset: textOffset,
				textAlign: textAlign
			});
		});

		// Draw all of the tick labels, tick marks, and grid lines at the correct places
		helpers$1.each(itemsToDraw, function(itemToDraw) {
			var glWidth = itemToDraw.glWidth;
			var glColor = itemToDraw.glColor;

			if (gridLines.display && glWidth && glColor) {
				context.save();
				context.lineWidth = glWidth;
				context.strokeStyle = glColor;
				if (context.setLineDash) {
					context.setLineDash(itemToDraw.glBorderDash);
					context.lineDashOffset = itemToDraw.glBorderDashOffset;
				}

				context.beginPath();

				if (gridLines.drawTicks) {
					context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
					context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
				}

				if (gridLines.drawOnChartArea) {
					context.moveTo(itemToDraw.x1, itemToDraw.y1);
					context.lineTo(itemToDraw.x2, itemToDraw.y2);
				}

				context.stroke();
				context.restore();
			}

			if (optionTicks.display) {
				// Make sure we draw text in the correct color and font
				context.save();
				context.translate(itemToDraw.labelX, itemToDraw.labelY);
				context.rotate(itemToDraw.rotation);
				context.font = itemToDraw.major ? majorTickFont.string : tickFont.string;
				context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
				context.textBaseline = 'middle';
				context.textAlign = itemToDraw.textAlign;

				var label = itemToDraw.label;
				var y = itemToDraw.textOffset;
				if (helpers$1.isArray(label)) {
					for (var i = 0; i < label.length; ++i) {
						// We just make sure the multiline element is a string here..
						context.fillText('' + label[i], 0, y);
						y += lineHeight;
					}
				} else {
					context.fillText(label, 0, y);
				}
				context.restore();
			}
		});

		if (scaleLabel.display) {
			// Draw the scale label
			var scaleLabelX;
			var scaleLabelY;
			var rotation = 0;
			var halfLineHeight = scaleLabelFont.lineHeight / 2;

			if (isHorizontal) {
				scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + ((me.bottom - me.top) / 2);
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}

			context.save();
			context.translate(scaleLabelX, scaleLabelY);
			context.rotate(rotation);
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillStyle = scaleLabelFontColor; // render in correct colour
			context.font = scaleLabelFont.string;
			context.fillText(scaleLabel.labelString, 0, 0);
			context.restore();
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, ticks.length - 1, 0);
			var x1, x2, y1, y2;

			if (isHorizontal) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			context.lineWidth = axisWidth;
			context.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			context.beginPath();
			context.moveTo(x1, y1);
			context.lineTo(x2, y2);
			context.stroke();
		}
	}
});

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	/**
	* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
	* else fall back to data.labels
	* @private
	*/
	getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
	},

	determineDataLimits: function() {
		var me = this;
		var labels = me.getLabels();
		me.minIndex = 0;
		me.maxIndex = labels.length - 1;
		var findIndex;

		if (me.options.ticks.min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(me.options.ticks.min);
			me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
		}

		if (me.options.ticks.max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(me.options.ticks.max);
			me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
		}

		me.min = labels[me.minIndex];
		me.max = labels[me.maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me.getLabels();
		// If we are viewing some subset of labels, slice the original array
		me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me.ticks[index - me.minIndex];
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index) {
		var me = this;
		var offset = me.options.offset;
		// 1 is added because we need the length but we have the indexes
		var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		var valueCategory;
		if (value !== undefined && value !== null) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			var labels = me.getLabels();
			value = valueCategory || value;
			var idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
		}

		if (me.isHorizontal()) {
			var valueWidth = me.width / offsetAmt;
			var widthOffset = (valueWidth * (index - me.minIndex));

			if (offset) {
				widthOffset += (valueWidth / 2);
			}

			return me.left + widthOffset;
		}
		var valueHeight = me.height / offsetAmt;
		var heightOffset = (valueHeight * (index - me.minIndex));

		if (offset) {
			heightOffset += (valueHeight / 2);
		}

		return me.top + heightOffset;
	},

	getPixelForTick: function(index) {
		return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offset = me.options.offset;
		var value;
		var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
		var horz = me.isHorizontal();
		var valueDimension = (horz ? me.width : me.height) / offsetAmt;

		pixel -= horz ? me.left : me.top;

		if (offset) {
			pixel -= (valueDimension / 2);
		}

		if (pixel <= 0) {
			value = 0;
		} else {
			value = Math.round(pixel / valueDimension);
		}

		return value + me.minIndex;
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef(min) && isNullOrUndef(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var data = chart.data;
		var datasets = data.datasets;
		var isHorizontal = me.isHorizontal();
		var DEFAULT_MIN = 0;
		var DEFAULT_MAX = 1;

		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}

		// First Calculate the range
		me.min = null;
		me.max = null;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				if (hasStacks) {
					return;
				}

				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
				}
			});
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (valuesPerStack[key] === undefined) {
					valuesPerStack[key] = {
						positiveValues: [],
						negativeValues: []
					};
				}

				// Store these per type
				var positiveValues = valuesPerStack[key].positiveValues;
				var negativeValues = valuesPerStack[key].negativeValues;

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						positiveValues[index] = positiveValues[index] || 0;
						negativeValues[index] = negativeValues[index] || 0;

						if (opts.relativePoints) {
							positiveValues[index] = 100;
						} else if (value < 0) {
							negativeValues[index] += value;
						} else {
							positiveValues[index] += value;
						}
					});
				}
			});

			helpers$1.each(valuesPerStack, function(valuesForType) {
				var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
				var minVal = helpers$1.min(values);
				var maxVal = helpers$1.max(values);
				me.min = me.min === null ? minVal : Math.min(me.min, minVal);
				me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
			});

		} else {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						if (me.min === null) {
							me.min = value;
						} else if (value < me.min) {
							me.min = value;
						}

						if (me.max === null) {
							me.max = value;
						} else if (value > me.max) {
							me.max = value;
						}
					});
				}
			});
		}

		me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		this.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		// This must be called after fit has been run so that
		// this.left, this.top, this.right, and this.bottom have been defined
		var me = this;
		var start = me.start;

		var rightValue = +me.getRightValue(value);
		var pixel;
		var range = me.end - start;

		if (me.isHorizontal()) {
			pixel = me.left + (me.width / range * (rightValue - start));
		} else {
			pixel = me.bottom - (me.height / range * (rightValue - start));
		}
		return pixel;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		var innerDimension = isHorizontal ? me.width : me.height;
		var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
		return me.start + ((me.end - me.start) * offset);
	},

	getPixelForTick: function(index) {
		return this.getPixelForValue(this.ticksAsNumbers[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$a = helpers$1.valueOrDefault;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$a(generationOptions.min, Math.pow(10, Math.floor(helpers$1.log10(dataRange.min))));

	var endExp = Math.floor(helpers$1.log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(helpers$1.log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(helpers$1.log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$a(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var data = chart.data;
		var datasets = data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}

		// Calculate Range
		me.min = null;
		me.max = null;
		me.minNotZero = null;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				if (hasStacks) {
					return;
				}

				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
				}
			});
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					helpers$1.each(dataset.data, function(rawValue, index) {
						var values = valuesPerStack[key];
						var value = +me.getRightValue(rawValue);
						// invalid, hidden and negative values are ignored
						if (isNaN(value) || meta.data[index].hidden || value < 0) {
							return;
						}
						values[index] = values[index] || 0;
						values[index] += value;
					});
				}
			});

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				}
			});

		} else {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						// invalid, hidden and negative values are ignored
						if (isNaN(value) || meta.data[index].hidden || value < 0) {
							return;
						}

						if (me.min === null) {
							me.min = value;
						} else if (value < me.min) {
							me.min = value;
						}

						if (me.max === null) {
							me.max = value;
						} else if (value > me.max) {
							me.max = value;
						}

						if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
							me.minNotZero = value;
						}
					});
				}
			});
		}

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(helpers$1.log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(helpers$1.log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(helpers$1.log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(helpers$1.log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(helpers$1.log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		return this.getPixelForValue(this.tickValues[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(helpers$1.log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	getPixelForValue: function(value) {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = tickOpts.reverse;
		var log10 = helpers$1.log10;
		var firstTickValue = me._getFirstTickValue(me.minNotZero);
		var offset = 0;
		var innerDimension, pixel, start, end, sign;

		value = +me.getRightValue(value);
		if (reverse) {
			start = me.end;
			end = me.start;
			sign = -1;
		} else {
			start = me.start;
			end = me.end;
			sign = 1;
		}
		if (me.isHorizontal()) {
			innerDimension = me.width;
			pixel = reverse ? me.right : me.left;
		} else {
			innerDimension = me.height;
			sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
			pixel = reverse ? me.top : me.bottom;
		}
		if (value !== start) {
			if (start === 0) { // include zero tick
				offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
				innerDimension -= offset;
				start = firstTickValue;
			}
			if (value !== 0) {
				offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
			}
			pixel += sign * offset;
		}
		return pixel;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = tickOpts.reverse;
		var log10 = helpers$1.log10;
		var firstTickValue = me._getFirstTickValue(me.minNotZero);
		var innerDimension, start, end, value;

		if (reverse) {
			start = me.end;
			end = me.start;
		} else {
			start = me.start;
			end = me.end;
		}
		if (me.isHorizontal()) {
			innerDimension = me.width;
			value = reverse ? me.right - pixel : pixel - me.left;
		} else {
			innerDimension = me.height;
			value = reverse ? pixel - me.top : me.bottom - pixel;
		}
		if (value !== start) {
			if (start === 0) { // include zero tick
				var offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
				value -= offset;
				innerDimension -= offset;
				start = firstTickValue;
			}
			value *= log10(end) - log10(start);
			value /= innerDimension;
			value = Math.pow(10, log10(start) + value);
		}
		return value;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$b = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$7 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getValueCount(scale) {
	var opts = scale.options;
	return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
}

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$b(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = getValueCount(scale);
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i] || '');
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var angleLineOpts = opts.angleLines;
	var gridLineOpts = opts.gridLines;
	var pointLabelOpts = opts.pointLabels;
	var lineWidth = valueOrDefault$b(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
	var lineColor = valueOrDefault$b(angleLineOpts.color, gridLineOpts.color);
	var tickBackdropHeight = getTickBackdropHeight(opts);

	ctx.save();
	ctx.lineWidth = lineWidth;
	ctx.strokeStyle = lineColor;
	if (ctx.setLineDash) {
		ctx.setLineDash(resolve$7([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
		ctx.lineDashOffset = resolve$7([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
	}

	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

	// Point Label Font
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = getValueCount(scale) - 1; i >= 0; i--) {
		if (angleLineOpts.display && lineWidth && lineColor) {
			var outerPosition = scale.getPointPosition(i, outerDistance);
			ctx.beginPath();
			ctx.moveTo(scale.xCenter, scale.yCenter);
			ctx.lineTo(outerPosition.x, outerPosition.y);
			ctx.stroke();
		}

		if (pointLabelOpts.display) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;

			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.lineHeight);
		}
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = getValueCount(scale);
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var angleMultiplier = (Math.PI * 2) / getValueCount(this);
		var startAngle = this.chart.options && this.chart.options.startAngle ?
			this.chart.options.startAngle :
			0;

		var startAngleRadians = startAngle * Math.PI * 2 / 360;

		// Start from the top instead of right, so remove a quarter of the circle
		return index * angleMultiplier + startAngleRadians;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (value === null) {
			return 0; // null always in center
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	draw: function() {
		var me = this;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var tickOpts = opts.ticks;

		if (opts.display) {
			var ctx = me.ctx;
			var startAngle = this.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);

			if (opts.angleLines.display || opts.pointLabels.display) {
				drawPointLabels(me);
			}

			helpers$1.each(me.ticks, function(label, index) {
				// Don't draw a centre value (if it is minimum)
				if (index > 0 || tickOpts.reverse) {
					var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

					// Draw circular lines around the scale
					if (gridLineOpts.display && index !== 0) {
						drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
					}

					if (tickOpts.display) {
						var tickFontColor = valueOrDefault$b(tickOpts.fontColor, core_defaults.global.defaultFontColor);
						ctx.font = tickFont.string;

						ctx.save();
						ctx.translate(me.xCenter, me.yCenter);
						ctx.rotate(startAngle);

						if (tickOpts.showLabelBackdrop) {
							var labelWidth = ctx.measureText(label).width;
							ctx.fillStyle = tickOpts.backdropColor;
							ctx.fillRect(
								-labelWidth / 2 - tickOpts.backdropPaddingX,
								-yCenterOffset - tickFont.size / 2 - tickOpts.backdropPaddingY,
								labelWidth + tickOpts.backdropPaddingX * 2,
								tickFont.size + tickOpts.backdropPaddingY * 2
							);
						}

						ctx.textAlign = 'center';
						ctx.textBaseline = 'middle';
						ctx.fillStyle = tickFontColor;
						ctx.fillText(label, 0, -yCenterOffset);
						ctx.restore();
					}
				}
			});
		}
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var valueOrDefault$c = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 15, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 15, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / (capacity * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, ticks, minUnit, min, max) {
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = valueOrDefault$c(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = min;
	var last = max;
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
		last = +adapter.startOf(last, 'isoWeek', weekday);
	}

	// Align first/last ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);
	last = +adapter.startOf(last, weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last = +adapter.add(last, 1, minor);
	}

	time = first;

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time = +adapter.startOf(time, major);
		time = +adapter.add(time, ~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
		}
		if (!options.time.max) {
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	}

	return {start: start, end: end};
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +scale._adapter.startOf(value, majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from https://momentjs.com/docs/#/parsing/string-format/
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		if (time.format) {
			console.warn('options.time.format is deprecated and replaced by options.time.parser.');
		}

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var timeOpts = me.options.time;
		var unit = timeOpts.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp;
		var dataLabels = chart.data.labels || [];

		// Convert labels to timestamps
		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		// Convert data to timestamps
		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					for (j = 0, jlen = labels.length; j < jlen; ++j) {
						timestamps.push(labels[j]);
					}
					datasets[i] = labels.slice(0);
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			// Sort labels **after** data have been converted
			labels = arrayUnique(labels).sort(sorter);
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = arrayUnique(timestamps).sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, timeOpts.min) || min;
		max = parse(me, timeOpts.max) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._horizontal = me.isHorizontal();
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var timeOpts = options.time;
		var timestamps = [];
		var ticks = [];
		var i, ilen, timestamp;

		switch (options.ticks.source) {
		case 'data':
			timestamps = me._timestamps.data;
			break;
		case 'labels':
			timestamps = me._timestamps.labels;
			break;
		case 'auto':
		default:
			timestamps = generate(me, min, max, me.getLabelCapacity(min), options);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, timeOpts.min) || min;
		max = parse(me, timeOpts.max) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		me._unit = timeOpts.unit || determineUnitForFormatting(me, ticks, timeOpts.minUnit, me.min, me.max);
		me._majorUnit = determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (options.ticks.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var majorTime = +adapter.startOf(time, majorUnit);
		var majorTickOpts = options.ticks.major;
		var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var tickOpts = major ? majorTickOpts : options.ticks.minor;
		var formatter = valueOrDefault$c(tickOpts.callback, tickOpts.userCallback);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var isReverse = me.options.ticks.reverse;
		var size = me._horizontal ? me.width : me.height;
		var start = me._horizontal ? isReverse ? me.right : me.left : isReverse ? me.bottom : me.top;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		var offset = size * (me._offsets.start + pos) / (me._offsets.start + 1 + me._offsets.end);

		return isReverse ? start - offset : start + offset;
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var size = me._horizontal ? me.width : me.height;
		var start = me._horizontal ? me.left : me.top;
		var pos = (size ? (pixel - start) / size : 0) * (me._offsets.start + 1 + me._offsets.start) - me._offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(ticksOpts.maxRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$c(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;

		// pick the longest format (milliseconds) for guestimation
		var format = me.options.time.displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, [], format);
		var tickLabelWidth = me.getLabelWidth(exampleLabel);
		var innerWidth = me.isHorizontal() ? me.width : me.height;
		var capacity = Math.floor(innerWidth / tickLabelWidth);

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment.duration(moment(max).diff(moment(min))).as(unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePosition) {
		target = scale.getBasePosition();
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1;

	ctx.beginPath();

	for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetDraw: function(chart, args) {
		var meta = args.meta.$filler;
		if (!meta) {
			return;
		}

		var ctx = chart.ctx;
		var el = meta.el;
		var view = el._view;
		var points = el._children || [];
		var mapper = meta.mapper;
		var color = view.backgroundColor || core_defaults.global.defaultColor;

		if (mapper && color && points.length) {
			helpers$1.canvas.clipArea(ctx, chart.chartArea);
			doFill(ctx, points, mapper, view, color, el._loop);
			helpers$1.canvas.unclipArea(ctx);
		}
	}
};

var noop$1 = helpers$1.noop;
var valueOrDefault$d = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers$1.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers$1.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		helpers$1.extend(this, config);

		// Contains hit boxes for each dataset (in dataset order)
		this.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		this._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		this.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (display) {
			ctx.font = labelFont.string;

			if (isHorizontal) {
				// Labels

				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'top';

				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					if (i === 0 || lineWidths[lineWidths.length - 1] + width + labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = labelOpts.padding;
					}

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};

					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});

				minSize.height += totalHeight;

			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
				var itemHeight = fontSize + vPadding;

				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					// If too tall, go to new column
					if (i > 0 && currentColHeight + itemHeight > minSize.height - vPadding) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width

						currentColWidth = 0;
						currentColHeight = 0;
					}

					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += itemHeight;

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});

				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				minSize.width += totalWidth;
			}
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (opts.display) {
			var ctx = me.ctx;
			var fontColor = valueOrDefault$d(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;

			// Canvas setup
			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;

			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;

			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}

				// Set the ctx for the box
				ctx.save();

				var lineWidth = valueOrDefault$d(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$d(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$d(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$d(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$d(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$d(legendItem.strokeStyle, defaultColor);

				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$d(legendItem.lineDash, lineDefault.borderDash));
				}

				if (opts.labels && opts.labels.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = x + boxWidth / 2;
					var centerY = y + fontSize / 2;

					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
				} else {
					// Draw box as legend symbol
					if (lineWidth !== 0) {
						ctx.strokeRect(x, y, boxWidth, fontSize);
					}
					ctx.fillRect(x, y, boxWidth, fontSize);
				}

				ctx.restore();
			};
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = boxWidth + halfFontSize + x;
				var yMiddle = y + halfFontSize;

				ctx.fillText(legendItem.text, xLeft, yMiddle);

				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(xLeft + textWidth, yMiddle);
					ctx.stroke();
				}
			};

			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + ((legendWidth - lineWidths[0]) / 2) + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			}

			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;

				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2) + labelOpts.padding;
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					y = cursor.y = me.top + labelOpts.padding;
					cursor.line++;
				}

				drawLegendBox(x, y, legendItem);

				hitboxes[i].left = x;
				hitboxes[i].top = y;

				// Fill the actual label
				fillText(x, y, legendItem, textWidth);

				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}

			});
		}
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var display = opts.display;
		var minSize = me.minSize;
		var lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		var fontOpts = helpers$1.options._parseFont(opts);
		var textSize = display ? (lineCount * fontOpts.lineHeight) + (opts.padding * 2) : 0;

		if (me.isHorizontal()) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = textSize;
		} else {
			minSize.width = textSize;
			minSize.height = me.maxHeight; // fill all the height
		}

		me.width = minSize.width;
		me.height = minSize.height;

	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (opts.display) {
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;

			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;

			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}

			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}

			ctx.restore();
		}
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers(core_controller);

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminItem/AdminItem.vue

/* harmony default export */ var AdminItem = ({
    filters: {
        noReferrence: function noReferrence(ref) {
            return ref || 'n/a';
        }
    },
    props: {
        id: {
            type: Number,
            default: null
        },
        firstName: {
            type: String,
            default: null
        },
        lastName: {
            type: [Number, String],
            default: null
        },
        email: {
            type: String,
            default: null
        },
        status: {
            type: String,
            default: null
        }
    },
    data: function data() {
        return {
            toggled: false
        };
    },

    methods: {
        updateUser: function updateUser() {
            this.$emit('update');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90de9554","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminItem/AdminItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-item",class:{'admin-item__control--toggled': _vm.toggled}},[_c('div',{staticClass:"admin-item__header"},[_c('div',{staticClass:"admin-item__label"},[_vm._v("\n            "+_vm._s(_vm.firstName)+" "+_vm._s(_vm.lastName)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"admin-item__control",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('i',{staticClass:"fa fa-fw fa-info"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"admin-item__content-animation"}},[(_vm.toggled)?_c('div',{staticClass:"admin-item__content"},[_c('div',{staticClass:"admin-item__props"},[_c('div',{staticClass:"admin-item__prop"},[_c('div',{staticClass:"admin-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('adminItem.id'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.id)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop"},[_c('div',{staticClass:"admin-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('adminItem.firstName'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.firstName)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop"},[_c('div',{staticClass:"admin-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('adminItem.lastName'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.lastName)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop"},[_c('div',{staticClass:"admin-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('adminItem.email'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.email)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop"},[_c('div',{staticClass:"admin-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('adminItem.status'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.status)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"admin-item__prop-edit"},[_c('div',{staticClass:"admin-item__prop-edit-value"},[_c('span',{staticClass:"admin-list__edit",on:{"click":_vm.updateUser}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "+_vm._s(_vm.$t('admin.list.edit')))])])])])]):_vm._e()])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/AdminItem/AdminItem.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  AdminItem,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var AdminItem_AdminItem = (Component.exports);

// EXTERNAL MODULE: ./src/components/Fake/Fake.vue + 2 modules
var Fake = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminList/AdminList.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var AdminList = (vue_esm["default"].extend({
    components: {
        AdminItem: AdminItem_AdminItem,
        Fake: Fake["a" /* default */]
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.admin.users.loading;
        },
        noContent: function noContent(state) {
            return state.admin.users.noContent;
        },
        error: function error(state) {
            return state.admin.users.error;
        },
        users: function users(state) {
            return state.admin.users.users;
        },
        user: function user(state) {
            return state.admin.users.user;
        },
        list: function list(state) {
            return state.admin.users.list;
        }
    })),
    created: function created() {
        window.addEventListener('keyup', this.keyPress);
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        setUser: 'admin/setUser',
        toggleEditModal: 'admin/toggleEditModal',
        toggleCreateModal: 'admin/toggleCreateModal'
    }), {
        updateUser: function updateUser(user) {
            this.setUser(user);
            this.toggleEditModal();
        },
        keyPress: function keyPress(key) {
            if (key.key === 'Escape') {
                this.toggleEditModal(false);
                this.toggleCreateModal(false);
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e6b54a8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminList/AdminList.vue
var AdminList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-list"},[(!_vm.loading)?_c('div',{staticClass:"admin-list__content"},[_c('div',{staticClass:"admin-list__header"},[_c('div',{staticClass:"admin-list__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('admin.list.header.heading'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"admin-list__create-user",on:{"click":function($event){return _vm.toggleCreateModal()}}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v(" "+_vm._s(_vm.$t('admin.list.content'))+"\n            ")])]),_vm._v(" "),(!_vm.loading)?_c('table',{staticClass:"admin-list__table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('admin.list.id')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('admin.list.firstname')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('admin.list.lastname')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('admin.list.email')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('admin.list.status')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user,index){return _c('tr',{key:'admin-user-' + index},[_c('td',[_vm._v(_vm._s(user.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.firstName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.status))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('span',{staticClass:"admin-list__edit",on:{"click":function($event){return _vm.updateUser(user)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "+_vm._s(_vm.$t('admin.list.edit'))+"\n                        ")])])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"admin-list__items-list"},_vm._l((_vm.users),function(user,index){return _c('admin-item',{key:'admin-user-item-' + index,attrs:{"id":user.id,"first-name":user.firstName,"last-name":user.lastName,"email":user.email,"status":user.status},on:{"update":function($event){return _vm.updateUser(user)}}})}),1),_vm._v(" "),(!_vm.users)?_c('div',{key:'no-content',staticClass:"admin-list__error"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"admin-list__error-message"},[_vm._v("\n                "+_vm._s(_vm.$t('admin.list.noUsers'))+"\n            ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":10,"body-cells":4}}):_vm._e()],1)}
var AdminList_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminList/AdminList.vue
/* script */


/* template */

/* template functional */
var AdminList___vue_template_functional__ = false
/* styles */
var AdminList___vue_styles__ = null
/* scopeId */
var AdminList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminList___vue_module_identifier__ = null

var AdminList_Component = Object(component_normalizer["a" /* default */])(
  AdminList,
  AdminList_render,
  AdminList_staticRenderFns,
  AdminList___vue_template_functional__,
  AdminList___vue_styles__,
  AdminList___vue_scopeId__,
  AdminList___vue_module_identifier__
)

/* harmony default export */ var AdminList_AdminList = (AdminList_Component.exports);

// EXTERNAL MODULE: ./src/services/ValidatorService.js
var ValidatorService = __webpack_require__(31);
var ValidatorService_default = /*#__PURE__*/__webpack_require__.n(ValidatorService);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminEditModalFormAccept/AdminEditModalFormAccept.vue
var AdminEditModalFormAccept__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var AdminEditModalFormAccept = ({
    props: {
        action: {
            type: String,
            required: true
        }
    },
    computed: AdminEditModalFormAccept__extends({}, Object(vuex_esm["mapState"])({
        submitted: function submitted(state) {
            return state.admin.editModal.form.submitted;
        },
        accepted: function accepted(state) {
            return state.admin.editModal.form.accepted;
        }
    })),
    methods: AdminEditModalFormAccept__extends({}, Object(vuex_esm["mapActions"])({
        acceptEditUserForm: 'admin/acceptEditUserForm',
        cancelEditUserForm: 'admin/cancelEditUserForm'
    }), {
        accept: function accept() {
            this.acceptEditUserForm();
            this.$emit('accept');
        },
        close: function close($event) {
            if ($event.target.id === 'container') {
                this.cancelEditUserForm();
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d750fc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminEditModalFormAccept/AdminEditModalFormAccept.vue
var AdminEditModalFormAccept_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-edit-modal-form-accept"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.submitted)?_c('div',{staticClass:"admin-edit-modal-form-accept__container",attrs:{"id":"container"},on:{"click":function($event){return _vm.close($event)}}},[_c('div',{staticClass:"admin-edit-modal-form-accept__body"},[_c('div',{staticClass:"admin-edit-modal-form-accept__header"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.edit.accept.header.' + _vm.action))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form-accept__content"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.edit.accept.content.' + _vm.action))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form-accept__button-group"},[_c('button',{staticClass:"admin-edit-modal-form-accept__submit",on:{"click":_vm.accept}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.edit.accept.buttons.accept'))+"\n                    ")]),_vm._v(" "),_c('button',{staticClass:"admin-edit-modal-form-accept__cancel",on:{"click":_vm.cancelEditUserForm}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.edit.accept.buttons.cancel'))+"\n                    ")])])])]):_vm._e()])],1)}
var AdminEditModalFormAccept_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminEditModalFormAccept/AdminEditModalFormAccept.vue
/* script */


/* template */

/* template functional */
var AdminEditModalFormAccept___vue_template_functional__ = false
/* styles */
var AdminEditModalFormAccept___vue_styles__ = null
/* scopeId */
var AdminEditModalFormAccept___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminEditModalFormAccept___vue_module_identifier__ = null

var AdminEditModalFormAccept_Component = Object(component_normalizer["a" /* default */])(
  AdminEditModalFormAccept,
  AdminEditModalFormAccept_render,
  AdminEditModalFormAccept_staticRenderFns,
  AdminEditModalFormAccept___vue_template_functional__,
  AdminEditModalFormAccept___vue_styles__,
  AdminEditModalFormAccept___vue_scopeId__,
  AdminEditModalFormAccept___vue_module_identifier__
)

/* harmony default export */ var AdminEditModalFormAccept_AdminEditModalFormAccept = (AdminEditModalFormAccept_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminEditModalForm/AdminEditModalForm.vue
var AdminEditModalForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var AdminEditModalForm = (vue_esm["default"].extend({
    components: {
        AdminEditModalFormAccept: AdminEditModalFormAccept_AdminEditModalFormAccept
    },
    filters: {
        roleFilter: function roleFilter(role) {
            return role.description.slice(role.name.length, role.description.length).toUpperCase();
        }
    },
    data: function data() {
        return {
            action: 'update'
        };
    },

    computed: AdminEditModalForm__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.admin.editModal.user;
        },
        originalUser: function originalUser(state) {
            return state.admin.editModal.originalUser;
        },
        languages: function languages(state) {
            return state.admin.languages.languages;
        },
        roles: function roles(state) {
            return state.admin.roles.roles;
        },
        originalRoles: function originalRoles(state) {
            return state.admin.roles.original;
        }
    }), Object(vuex_esm["mapGetters"])({
        userChanged: 'admin/userChanged'
    }), {
        firstNameClasses: function firstNameClasses() {
            return {
                'admin-edit-modal-form__input--error': this.$v.user.firstName.$dirty && this.$v.user.firstName.$error,
                'admin-edit-modal-form__input--success': this.$v.user.firstName.$dirty && !this.$v.user.firstName.$error
            };
        },
        lastNameClasses: function lastNameClasses() {
            return {
                'admin-edit-modal-form__input--error': this.$v.user.lastName.$dirty && this.$v.user.lastName.$error,
                'admin-edit-modal-form__input--success': this.$v.user.lastName.$dirty && !this.$v.user.lastName.$error
            };
        },
        languageClasses: function languageClasses() {
            return {
                'admin-edit-modal-form__dropdown--error': this.$v.user.language.$dirty && this.$v.user.language.$error,
                'admin-edit-modal-form__dropdown--success': this.$v.user.language.$dirty && !this.$v.user.language.$error
            };
        }
    }),
    methods: AdminEditModalForm__extends({}, Object(vuex_esm["mapActions"])({
        updateUserValues: 'admin/updateEditUserValues',
        editUser: 'admin/editUser',
        blockUser: 'admin/blockUser',
        unblockUser: 'admin/unblockUser',
        deleteUser: 'admin/deleteUser',
        submitEditUserForm: 'admin/submitEditUserForm'
    }), {
        update: function update(obj) {
            this.$v.$touch();
            this.updateUserValues(obj);
        },
        submit: function submit(action) {
            this.action = action;
            this.submitEditUserForm();
        },
        accept: function accept() {
            switch (this.action) {
                case 'update':
                    this.editUser(this.user);
                    break;
                case 'block':
                    this.blockUser(this.user.id);
                    break;
                case 'unblock':
                    this.unblockUser(this.user.id);
                    break;
                case 'delete':
                    this.deleteUser(this.user.id);
                    break;
            }
        },
        hasRole: function hasRole(role) {
            var contains = false;
            this.user.roles.forEach(function (userRole) {
                if (userRole.id === role.id) {
                    contains = true;
                }
            });
            return contains;
        },
        editRoles: function editRoles($event, role) {
            var newRoles = [];
            if ($event.target.checked) {
                newRoles.push(role);
            }
            this.user.roles.forEach(function (userRole) {
                if (userRole.id !== role.id) {
                    newRoles.push(userRole);
                }
            });
            this.update({ roles: newRoles });
        }
    }),
    validations: function validations() {
        return {
            user: {
                firstName: {
                    required: function required(firstName) {
                        return Object(ValidatorService["required"])(firstName, 'First name').valid;
                    }
                },
                lastName: {
                    required: function required(lastName) {
                        return Object(ValidatorService["required"])(lastName, 'Last name').valid;
                    }
                },
                language: {
                    required: function required(language) {
                        return Object(ValidatorService["required"])(language, 'Language').valid;
                    }
                }
            }
        };
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5721594f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminEditModalForm/AdminEditModalForm.vue
var AdminEditModalForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"admin-edit-modal-form"},[(_vm.user.status !== 'inactive' && _vm.user.status !== 'blocked')?_c('div',{staticClass:"admin-edit-modal-form__info"},[_vm._v("\n            "+_vm._s(_vm.$t('admin.edit.form.info'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.user.status === 'inactive' || _vm.user.status === 'blocked')?_c('div',{staticClass:"admin-edit-modal-form__alert"},[_vm._v("\n            "+_vm._s(_vm.$t('admin.edit.form.warning.' + _vm.user.status))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('div',{staticClass:"admin-edit-modal-form__form"},[_c('div',{staticClass:"admin-edit-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.edit.form.firstname')))]),_vm._v(" "),_c('input',{staticClass:"admin-edit-modal-form__input",class:_vm.firstNameClasses,attrs:{"type":"text"},domProps:{"value":_vm.user.firstName},on:{"input":function($event){return _vm.update({firstName: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.user.firstName.$error)?_c('span',{staticClass:"admin-edit-modal-form__error-msg"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.edit.form.validator.firstname'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.edit.form.lastname')))]),_vm._v(" "),_c('input',{staticClass:"admin-edit-modal-form__input",class:_vm.lastNameClasses,attrs:{"type":"text"},domProps:{"value":_vm.user.lastName},on:{"input":function($event){return _vm.update({lastName: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.user.lastName.$error)?_c('span',{staticClass:"admin-edit-modal-form__error-msg"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.edit.form.validator.lastname'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.edit.form.language')))]),_vm._v(" "),_c('select',{staticClass:"admin-edit-modal-form__input-dropdown",class:_vm.languageClasses,domProps:{"value":_vm.user.language},on:{"input":function($event){return _vm.update({language: $event.target.value})}}},_vm._l((_vm.languages),function(language,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(language))])}),0),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form__roles"},[_c('div',{staticClass:"admin-edit-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.edit.form.roles')))]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form__checkbox-group"},_vm._l((_vm.roles),function(role){return _c('div',{key:role.id,staticClass:"admin-edit-modal-form__checkbox-element"},[_c('label',{staticClass:"admin-edit-modal-form__checkbox-label"},[_vm._v(_vm._s(_vm._f("roleFilter")(role)))]),_vm._v(" "),_c('input',{staticClass:"admin-edit-modal-form__checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.hasRole(role)},on:{"click":function($event){return _vm.editRoles($event, role)}}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form__btn-container"},[_c('div',{staticClass:"admin-edit-modal-form__btn-group"},[_c('button',{staticClass:"admin-edit-modal-form__btn admin-edit-modal-form__btn-update",attrs:{"disabled":!_vm.userChanged || _vm.$v.$error || !_vm.user.roles.length},on:{"click":function($event){return _vm.submit('update')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.edit.form.buttons.update'))+"\n                    ")]),_vm._v(" "),(_vm.user.status !== 'blocked')?_c('button',{staticClass:"admin-edit-modal-form__btn admin-edit-modal-form__btn-block",attrs:{"disabled":_vm.user.status === 'inactive'},on:{"click":function($event){return _vm.submit('block')}}},[_vm._v(_vm._s(_vm.$t('admin.edit.form.buttons.block')))]):_vm._e(),_vm._v(" "),(_vm.user.status === 'blocked')?_c('button',{staticClass:"admin-edit-modal-form__btn admin-edit-modal-form__btn-unblock",attrs:{"disabled":_vm.user.status === 'inactive'},on:{"click":function($event){return _vm.submit('unblock')}}},[_vm._v(_vm._s(_vm.$t('admin.edit.form.buttons.unblock')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"admin-edit-modal-form__btn admin-edit-modal-form__btn-delete",on:{"click":function($event){return _vm.submit('delete')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.edit.form.buttons.delete'))+"\n                    ")])])])],1):_vm._e(),_vm._v(" "),_c('admin-edit-modal-form-accept',{attrs:{"action":_vm.action},on:{"accept":_vm.accept}})],1)])}
var AdminEditModalForm_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminEditModalForm/AdminEditModalForm.vue
/* script */


/* template */

/* template functional */
var AdminEditModalForm___vue_template_functional__ = false
/* styles */
var AdminEditModalForm___vue_styles__ = null
/* scopeId */
var AdminEditModalForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminEditModalForm___vue_module_identifier__ = null

var AdminEditModalForm_Component = Object(component_normalizer["a" /* default */])(
  AdminEditModalForm,
  AdminEditModalForm_render,
  AdminEditModalForm_staticRenderFns,
  AdminEditModalForm___vue_template_functional__,
  AdminEditModalForm___vue_styles__,
  AdminEditModalForm___vue_scopeId__,
  AdminEditModalForm___vue_module_identifier__
)

/* harmony default export */ var AdminEditModalForm_AdminEditModalForm = (AdminEditModalForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminEditModal/AdminEditModal.vue
var AdminEditModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var AdminEditModal = (vue_esm["default"].extend({
    components: {
        AdminEditModalForm: AdminEditModalForm_AdminEditModalForm
    },
    computed: AdminEditModal__extends({}, Object(vuex_esm["mapState"])({
        open: function open(state) {
            return state.admin.editModal.open;
        }
    })),
    methods: AdminEditModal__extends({}, Object(vuex_esm["mapActions"])({
        toggleEditModal: 'admin/toggleEditModal'
    }), {
        toggleModal: function toggleModal($event) {
            if ($event.target.id === 'container') {
                this.toggleEditModal();
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18c57ca","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminEditModal/AdminEditModal.vue
var AdminEditModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.open)?_c('div',{staticClass:"admin-edit-modal"},[_c('div',{staticClass:"admin-edit-modal__container",attrs:{"id":"container"},on:{"click":function($event){return _vm.toggleModal($event)}}},[_c('div',{staticClass:"admin-edit-modal__content"},[_c('div',{staticClass:"admin-edit-modal__header"},[_c('div',{staticClass:"admin-edit-modal__heading"},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.edit.header.heading'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal__toggle",on:{"click":function($event){return _vm.toggleEditModal()}}},[_c('i',{staticClass:"fa fa-times-circle"})])]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal__body"},[_c('admin-edit-modal-form')],1)])])]):_vm._e()])}
var AdminEditModal_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminEditModal/AdminEditModal.vue
/* script */


/* template */

/* template functional */
var AdminEditModal___vue_template_functional__ = false
/* styles */
var AdminEditModal___vue_styles__ = null
/* scopeId */
var AdminEditModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminEditModal___vue_module_identifier__ = null

var AdminEditModal_Component = Object(component_normalizer["a" /* default */])(
  AdminEditModal,
  AdminEditModal_render,
  AdminEditModal_staticRenderFns,
  AdminEditModal___vue_template_functional__,
  AdminEditModal___vue_styles__,
  AdminEditModal___vue_scopeId__,
  AdminEditModal___vue_module_identifier__
)

/* harmony default export */ var AdminEditModal_AdminEditModal = (AdminEditModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminCreateModalFormAccept/AdminCreateModalFormAccept.vue
var AdminCreateModalFormAccept__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var AdminCreateModalFormAccept = ({
    computed: AdminCreateModalFormAccept__extends({}, Object(vuex_esm["mapState"])({
        submitted: function submitted(state) {
            return state.admin.createModal.form.submitted;
        },
        accepted: function accepted(state) {
            return state.admin.createModal.form.accepted;
        }
    })),
    methods: AdminCreateModalFormAccept__extends({}, Object(vuex_esm["mapActions"])({
        acceptCreateUserForm: 'admin/acceptCreateUserForm',
        cancelCreateUserForm: 'admin/cancelCreateUserForm'
    }), {
        accept: function accept() {
            this.acceptCreateUserForm();
            this.$emit('accept');
        },
        close: function close($event) {
            if ($event.target.id === 'container') {
                this.cancelCreateUserForm();
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4d02da0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminCreateModalFormAccept/AdminCreateModalFormAccept.vue
var AdminCreateModalFormAccept_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-edit-modal-form-accept"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.submitted)?_c('div',{staticClass:"admin-edit-modal-form-accept__container",attrs:{"id":"container"},on:{"click":function($event){return _vm.close($event)}}},[_c('div',{staticClass:"admin-edit-modal-form-accept__body"},[_c('div',{staticClass:"admin-edit-modal-form-accept__header"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.create.accept.header'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form-accept__content"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.create.accept.content'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"admin-edit-modal-form-accept__button-group"},[_c('button',{staticClass:"admin-edit-modal-form-accept__submit",on:{"click":_vm.accept}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.create.accept.buttons.accept'))+"\n                    ")]),_vm._v(" "),_c('button',{staticClass:"admin-edit-modal-form-accept__cancel",on:{"click":_vm.cancelCreateUserForm}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.create.accept.buttons.cancel'))+"\n                    ")])])])]):_vm._e()])],1)}
var AdminCreateModalFormAccept_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminCreateModalFormAccept/AdminCreateModalFormAccept.vue
/* script */


/* template */

/* template functional */
var AdminCreateModalFormAccept___vue_template_functional__ = false
/* styles */
var AdminCreateModalFormAccept___vue_styles__ = null
/* scopeId */
var AdminCreateModalFormAccept___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminCreateModalFormAccept___vue_module_identifier__ = null

var AdminCreateModalFormAccept_Component = Object(component_normalizer["a" /* default */])(
  AdminCreateModalFormAccept,
  AdminCreateModalFormAccept_render,
  AdminCreateModalFormAccept_staticRenderFns,
  AdminCreateModalFormAccept___vue_template_functional__,
  AdminCreateModalFormAccept___vue_styles__,
  AdminCreateModalFormAccept___vue_scopeId__,
  AdminCreateModalFormAccept___vue_module_identifier__
)

/* harmony default export */ var AdminCreateModalFormAccept_AdminCreateModalFormAccept = (AdminCreateModalFormAccept_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminCreateModalForm/AdminCreateModalForm.vue
var AdminCreateModalForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var AdminCreateModalForm = (vue_esm["default"].extend({
    components: {
        AdminCreateModalFormAccept: AdminCreateModalFormAccept_AdminCreateModalFormAccept
    },
    filters: {
        roleFilter: function roleFilter(role) {
            return role.description.substring(role.name.length, role.description.length).toUpperCase();
        }
    },
    computed: AdminCreateModalForm__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.admin.createModal.user;
        },
        languages: function languages(state) {
            return state.admin.languages.languages;
        },
        roles: function roles(state) {
            return state.admin.roles.roles;
        }
    }), {
        firstNameClasses: function firstNameClasses() {
            return {
                'admin-create-modal-form__input--error': this.$v.user.firstName.$dirty && this.$v.user.firstName.$error,
                'admin-create-modal-form__input--success': this.$v.user.firstName.$dirty && !this.$v.user.firstName.$error
            };
        },
        lastNameClasses: function lastNameClasses() {
            return {
                'admin-create-modal-form__input--error': this.$v.user.lastName.$dirty && this.$v.user.lastName.$error,
                'admin-create-modal-form__input--success': this.$v.user.lastName.$dirty && !this.$v.user.lastName.$error
            };
        },
        emailClasses: function emailClasses() {
            return {
                'admin-create-modal-form__input--error': this.$v.user.email.$dirty && this.$v.user.email.$error,
                'admin-create-modal-form__input--success': this.$v.user.email.$dirty && !this.$v.user.email.$error
            };
        },
        languageClasses: function languageClasses() {
            return {
                'admin-create-modal-form__dropdown--error': this.$v.user.language.$dirty && this.$v.user.language.$error,
                'admin-create-modal-form__dropdown--success': this.$v.user.language.$dirty && !this.$v.user.language.$error
            };
        }
    }),
    methods: AdminCreateModalForm__extends({}, Object(vuex_esm["mapActions"])({
        submitCreateUserForm: 'admin/submitCreateUserForm',
        updateCreateUserValues: 'admin/updateCreateUserValues',
        createUser: 'admin/createUser'
    }), {
        update: function update(obj) {
            this.$v.$touch();
            this.updateCreateUserValues(obj);
        },
        submit: function submit() {
            this.submitCreateUserForm();
        },
        accept: function accept() {
            this.createUser(this.user);
        },
        editRoles: function editRoles($event, role) {
            var newRoles = [];
            if ($event.target.checked) {
                newRoles.push(role);
            }
            this.user.roles.forEach(function (userRole) {
                if (userRole.id !== role.id) {
                    newRoles.push(userRole);
                }
            });
            this.update({ roles: newRoles });
        }
    }),
    validations: function validations() {
        return {
            user: {
                firstName: {
                    required: function required(firstName) {
                        return Object(ValidatorService["required"])(firstName, 'First name').valid;
                    }
                },
                lastName: {
                    required: function required(lastName) {
                        return Object(ValidatorService["required"])(lastName, 'Last name').valid;
                    }
                },
                email: {
                    required: function required(email) {
                        return Object(ValidatorService["required"])(email, 'Email').valid;
                    },
                    validEmail: function validEmail(email) {
                        return Object(ValidatorService["validEmail"])(email).valid;
                    }
                },
                language: {
                    required: function required(language) {
                        return Object(ValidatorService["required"])(language, 'Language').valid;
                    }
                }
            }
        };
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7f2f25a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminCreateModalForm/AdminCreateModalForm.vue
var AdminCreateModalForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"admin-create-modal-form"},[_c('div',{staticClass:"admin-create-modal-form__info"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('admin.create.form.tip'))}})]),_vm._v(" "),_c('div',{staticClass:"admin-create-modal-form__form"},[_c('div',{staticClass:"admin-create-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.create.form.firstname')))]),_vm._v(" "),_c('input',{staticClass:"admin-create-modal-form__input",class:_vm.firstNameClasses,attrs:{"type":"text"},domProps:{"value":_vm.user.firstName},on:{"input":function($event){return _vm.update({firstName: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.user.firstName.$error)?_c('span',{staticClass:"admin-create-modal-form__error-msg"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.create.form.validator.firstname'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"admin-create-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.create.form.lastname')))]),_vm._v(" "),_c('input',{staticClass:"admin-create-modal-form__input",class:_vm.lastNameClasses,attrs:{"type":"text"},domProps:{"value":_vm.user.lastName},on:{"input":function($event){return _vm.update({lastName: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.user.lastName.$error)?_c('span',{staticClass:"admin-create-modal-form__error-msg"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.create.form.validator.lastname'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"admin-create-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.create.form.email')))]),_vm._v(" "),_c('input',{staticClass:"admin-create-modal-form__input",class:_vm.emailClasses,attrs:{"type":"text"},domProps:{"value":_vm.user.email},on:{"input":function($event){return _vm.update({email: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.user.email.$error)?_c('span',{staticClass:"admin-create-modal-form__error-msg"},[_vm._v("\n                    "+_vm._s(_vm.$t('admin.create.form.validator.email'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"admin-create-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.create.form.language')))]),_vm._v(" "),_c('select',{staticClass:"admin-create-modal-form__input-dropdown",class:_vm.languageClasses,domProps:{"value":_vm.user.language},on:{"input":function($event){return _vm.update({language: $event.target.value})}}},_vm._l((_vm.languages),function(language,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(language))])}),0),_vm._v(" "),_c('div',{staticClass:"admin-create-modal-form__label"},[_vm._v(_vm._s(_vm.$t('admin.create.form.roles')))]),_vm._v(" "),_c('div',{staticClass:"admin-create-modal-form__checkbox-group"},_vm._l((_vm.roles),function(role){return _c('div',{key:role.id,staticClass:"admin-create-modal-form__checkbox-element"},[_c('label',{staticClass:"admin-create-modal-form__checkbox-label"},[_vm._v(_vm._s(_vm._f("roleFilter")(role)))]),_vm._v(" "),_c('input',{staticClass:"admin-create-modal-form__checkbox",attrs:{"type":"checkbox"},on:{"click":function($event){return _vm.editRoles($event, role)}}})])}),0),_vm._v(" "),_c('div',{staticClass:"admin-create-modal-form__btn-container"},[_c('div',{staticClass:"admin-create-modal-form__btn-group"},[_c('button',{staticClass:"admin-create-modal-form__btn admin-create-modal-form__btn-update",attrs:{"disabled":!_vm.$v.$dirty || _vm.$v.$error || _vm.user.roles.length === 0},on:{"click":function($event){return _vm.submit('create')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.create.form.button.submit'))+"\n                    ")])])])],1),_vm._v(" "),_c('admin-create-modal-form-accept',{on:{"accept":_vm.accept}})],1)])}
var AdminCreateModalForm_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminCreateModalForm/AdminCreateModalForm.vue
/* script */


/* template */

/* template functional */
var AdminCreateModalForm___vue_template_functional__ = false
/* styles */
var AdminCreateModalForm___vue_styles__ = null
/* scopeId */
var AdminCreateModalForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminCreateModalForm___vue_module_identifier__ = null

var AdminCreateModalForm_Component = Object(component_normalizer["a" /* default */])(
  AdminCreateModalForm,
  AdminCreateModalForm_render,
  AdminCreateModalForm_staticRenderFns,
  AdminCreateModalForm___vue_template_functional__,
  AdminCreateModalForm___vue_styles__,
  AdminCreateModalForm___vue_scopeId__,
  AdminCreateModalForm___vue_module_identifier__
)

/* harmony default export */ var AdminCreateModalForm_AdminCreateModalForm = (AdminCreateModalForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminCreateModal/AdminCreateModal.vue
var AdminCreateModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var AdminCreateModal = (vue_esm["default"].extend({
    components: {
        AdminCreateModalForm: AdminCreateModalForm_AdminCreateModalForm
    },
    computed: AdminCreateModal__extends({}, Object(vuex_esm["mapState"])({
        open: function open(state) {
            return state.admin.createModal.open;
        }
    })),
    methods: AdminCreateModal__extends({}, Object(vuex_esm["mapActions"])({
        toggleCreateModal: 'admin/toggleCreateModal'
    }), {
        toggleModal: function toggleModal($event) {
            if ($event.target.id === 'container') {
                this.toggleCreateModal();
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e285d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminCreateModal/AdminCreateModal.vue
var AdminCreateModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.open)?_c('div',{staticClass:"admin-create-modal"},[_c('div',{staticClass:"admin-create-modal__container",attrs:{"id":"container"},on:{"click":function($event){return _vm.toggleModal($event)}}},[_c('div',{staticClass:"admin-create-modal__content"},[_c('div',{staticClass:"admin-create-modal__header"},[_c('div',{staticClass:"admin-create-modal__heading"},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.create.header.heading'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal__toggle",on:{"click":function($event){return _vm.toggleCreateModal()}}},[_c('i',{staticClass:"fa fa-times-circle"})])]),_vm._v(" "),_c('div',{staticClass:"admin-create-modal__body"},[_c('admin-create-modal-form')],1)])])]):_vm._e()])}
var AdminCreateModal_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminCreateModal/AdminCreateModal.vue
/* script */


/* template */

/* template functional */
var AdminCreateModal___vue_template_functional__ = false
/* styles */
var AdminCreateModal___vue_styles__ = null
/* scopeId */
var AdminCreateModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminCreateModal___vue_module_identifier__ = null

var AdminCreateModal_Component = Object(component_normalizer["a" /* default */])(
  AdminCreateModal,
  AdminCreateModal_render,
  AdminCreateModal_staticRenderFns,
  AdminCreateModal___vue_template_functional__,
  AdminCreateModal___vue_styles__,
  AdminCreateModal___vue_scopeId__,
  AdminCreateModal___vue_module_identifier__
)

/* harmony default export */ var AdminCreateModal_AdminCreateModal = (AdminCreateModal_Component.exports);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/Alert/Alert.vue + 2 modules
var Alert = __webpack_require__(66);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdminPage/AdminPage.vue
var AdminPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











/* harmony default export */ var AdminPage = (vue_esm["default"].extend({
    components: {
        Alert: Alert["a" /* default */],
        Loading: Loading["a" /* default */],
        AdminList: AdminList_AdminList,
        InfoWidget: InfoWidget["a" /* default */],
        AdminEditModal: AdminEditModal_AdminEditModal,
        AdminCreateModal: AdminCreateModal_AdminCreateModal
    },
    computed: AdminPage__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        },
        tips: function tips(state) {
            return state.admin.tips;
        },
        editLoading: function editLoading(state) {
            return state.admin.editModal.form.loading;
        },
        createLoading: function createLoading(state) {
            return state.admin.createModal.form.loading;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    watch: {
        supplier: function supplier(_supplier) {
            store_default.a.dispatch('admin/getUsers', _supplier.id);
            store_default.a.dispatch('admin/getRoles', _supplier.id);
            store_default.a.dispatch('nav/toggleNavMenu', false);
        }
    },
    created: function created() {
        var supplierId = this.supplier.id;
        this.getUsers(supplierId);
        this.getRoles(supplierId);
        this.getLanguages();
        this.toggleNavMenu(false);
    },

    methods: AdminPage__extends({}, Object(vuex_esm["mapActions"])({
        getUsers: 'admin/getUsers',
        getRoles: 'admin/getRoles',
        getLanguages: 'admin/getLanguages',
        toggleNavMenu: 'nav/toggleNavMenu'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ef09cc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminPage/AdminPage.vue
var AdminPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-page"},[_c('div',{staticClass:"admin-page__header"},[_c('div',{staticClass:"admin-page__heading"},[_vm._v("\n            "+_vm._s(_vm.$t('admin.heading.header'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"admin-page__list"},[_c('admin-list')],1),_vm._v(" "),_c('div',{staticClass:"admin-page__edit-modal"},[_c('admin-edit-modal')],1),_vm._v(" "),_c('div',{staticClass:"admin-page__edit-modal"},[_c('admin-create-modal')],1),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}}),_vm._v(" "),(_vm.editLoading || _vm.createLoading)?_c('loading'):_vm._e(),_vm._v(" "),_c('alert',{attrs:{"translation-prefix":'admin.alert'}})],1)}
var AdminPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AdminPage/AdminPage.vue
/* script */


/* template */

/* template functional */
var AdminPage___vue_template_functional__ = false
/* styles */
var AdminPage___vue_styles__ = null
/* scopeId */
var AdminPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdminPage___vue_module_identifier__ = null

var AdminPage_Component = Object(component_normalizer["a" /* default */])(
  AdminPage,
  AdminPage_render,
  AdminPage_staticRenderFns,
  AdminPage___vue_template_functional__,
  AdminPage___vue_styles__,
  AdminPage___vue_scopeId__,
  AdminPage___vue_module_identifier__
)

/* harmony default export */ var AdminPage_AdminPage = __webpack_exports__["default"] = (AdminPage_Component.exports);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/PaginationControl/PaginationControl.vue + 2 modules
var PaginationControl = __webpack_require__(49);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BookingItem/BookingItem.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var BookingItem = ({
    filters: {
        noReferrence: function noReferrence(ref) {
            return ref || 'n/a';
        }
    },
    props: {
        customerName: {
            type: String,
            required: true
        },
        supplierRef: {
            type: [Number, String],
            default: null
        },
        bookingRef: {
            type: [Number, String],
            required: true
        },
        bookingDate: {
            type: String,
            required: true
        },
        bookingStatus: {
            type: String,
            required: true,
            default: 'unknown'
        },
        arrivalDate: {
            type: String,
            required: true
        },
        departureDate: {
            type: String,
            required: true
        },
        domain: {
            type: String,
            required: true
        },
        accommodation: {
            type: String,
            required: true
        },
        site: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            toggled: false
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        }
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48af9ac5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingItem/BookingItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-item",class:{'booking-item__control--toggled': _vm.toggled}},[_c('div',{staticClass:"booking-item__header"},[_c('div',{staticClass:"booking-item__label"},[_vm._v("\n            "+_vm._s(_vm._f("noReferrence")(_vm.supplierRef))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__control",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('i',{staticClass:"fa fa-fw fa-info"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"booking-item__content-animation"}},[(_vm.toggled)?_c('div',{staticClass:"booking-item__content"},[_c('div',{staticClass:"booking-item__props"},[_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.bookingRef'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm._f("convertStringToNumber")(_vm.bookingRef))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.customerName'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.customerName)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.bookingDate'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(_vm.bookingDate,"DD/MM/YYYY"))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.status'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingFilters.status.types.' + _vm.bookingStatus))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.departureDate'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(_vm.departureDate,"DD/MM/YYYY"))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.arrivalDate'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(_vm.arrivalDate,"DD/MM/YYYY"))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.domain'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.domain)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.accommodation'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.accommodation)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop"},[_c('div',{staticClass:"booking-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingItem.site'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"booking-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.site)+"\n                    ")])])])]):_vm._e()])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/BookingItem/BookingItem.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  BookingItem,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BookingItem_BookingItem = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DropDownMenuMultiSelect/DropDownMenuMultiSelect.vue

/* harmony default export */ var DropDownMenuMultiSelect = ({
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: Array,
            default: null
        },
        defaultValue: {
            type: [Number, String],
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledValue: {
            type: String,
            default: 'N/A'
        },
        translationPrefix: {
            type: String,
            default: undefined
        }
    },
    data: function data() {
        return {
            toggled: false,
            event: undefined
        };
    },

    computed: {
        valueClasses: {
            get: function get() {
                var classPrefix = 'dropdown-menu-multi-select__value';
                var length = this.value.length;
                if (length < 3) {
                    return classPrefix;
                } else if (length >= 3 && length < 5) {
                    return classPrefix + '-small';
                } else if (length >= 5 && length < 10) {
                    return classPrefix + '-smaller';
                } else {
                    return classPrefix + '-smallest';
                }
            }
        }
    },
    methods: {
        toggle: function toggle() {
            if (!this.disabled) {
                if (!this.toggled) {
                    document.addEventListener('click', this.clickEvent);
                } else {
                    document.removeEventListener('click', this.clickEvent);
                }
                this.toggled = !this.toggled;
            }
        },
        click: function click(val) {
            if (this.value.indexOf(val) === -1) {
                this.$emit('select', val);
            } else {
                this.$emit('deselect', val);
            }
        },
        reset: function reset() {
            this.$emit('reset');
        },
        clickEvent: function clickEvent(event) {
            if (!event.target.classList.contains('dropdown-menu-multi-select__button')) {
                this.toggle();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe3e9f4a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropDownMenuMultiSelect/DropDownMenuMultiSelect.vue
var DropDownMenuMultiSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu-multi-select",class:{'dropdown-menu-multi-select--disabled': _vm.disabled},on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"dropdown-menu-multi-select__button"},[_c('div',{staticClass:"dropdown-menu-multi-select__label"},[_vm._v("\n            "+_vm._s(_vm.label)+":\n        ")]),_vm._v(" "),(_vm.value.length === 1)?_c('div',{class:_vm.valueClasses},[_c('span',[_vm._v(_vm._s(_vm.translationPrefix ? _vm.$t(_vm.translationPrefix + '.' + _vm.value) : _vm.value))])]):_vm._e(),_vm._v(" "),(_vm.value.length > 1)?_c('div',{class:_vm.valueClasses},_vm._l((_vm.value),function(val,index){return _c('span',{key:'dropdown-multi-value__' + index},[_c('span',[_vm._v(_vm._s(_vm.translationPrefix ? _vm.$t(_vm.translationPrefix + '.' + val) : val))]),_vm._v(" "),(index < _vm.value.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}),0):_vm._e()]),_vm._v(" "),(_vm.toggled)?_c('div',{staticClass:"dropdown-menu-multi-select__dropdown"},[_c('div',{staticClass:"dropdown-menu-multi-select__reset",on:{"click":_vm.reset}},[_vm._v("\n            "+_vm._s(_vm.translationPrefix ? _vm.$t(_vm.translationPrefix + '.' + 'reset') : 'Reset')+"\n        ")]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('div',{key:'dropdown-multi-choice__' + index,staticClass:"dropdown-menu-multi-select__choice",class:{'dropdown-menu-multi-select__choice--selected': _vm.value.indexOf(item) !== -1},on:{"click":function($event){return _vm.click(item)}}},[_vm._v("\n            "+_vm._s(_vm.translationPrefix ? _vm.$t(_vm.translationPrefix + '.' + item) : item)+"\n        ")])})],2):_vm._e()])}
var DropDownMenuMultiSelect_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DropDownMenuMultiSelect/DropDownMenuMultiSelect.vue
/* script */


/* template */

/* template functional */
var DropDownMenuMultiSelect___vue_template_functional__ = false
/* styles */
var DropDownMenuMultiSelect___vue_styles__ = null
/* scopeId */
var DropDownMenuMultiSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DropDownMenuMultiSelect___vue_module_identifier__ = null

var DropDownMenuMultiSelect_Component = Object(component_normalizer["a" /* default */])(
  DropDownMenuMultiSelect,
  DropDownMenuMultiSelect_render,
  DropDownMenuMultiSelect_staticRenderFns,
  DropDownMenuMultiSelect___vue_template_functional__,
  DropDownMenuMultiSelect___vue_styles__,
  DropDownMenuMultiSelect___vue_scopeId__,
  DropDownMenuMultiSelect___vue_module_identifier__
)

/* harmony default export */ var DropDownMenuMultiSelect_DropDownMenuMultiSelect = (DropDownMenuMultiSelect_Component.exports);

// EXTERNAL MODULE: ./src/components/Fake/Fake.vue + 2 modules
var Fake = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BookingList/BookingList.vue
var BookingList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









/* harmony default export */ var BookingList = (vue_esm["default"].extend({
    components: {
        Fake: Fake["a" /* default */],
        PaginationControl: PaginationControl["a" /* default */],
        DropdownMenu: DropdownMenu["a" /* default */],
        BookingItem: BookingItem_BookingItem,
        DropDownMenuMultiSelect: DropDownMenuMultiSelect_DropDownMenuMultiSelect
    },
    filters: {
        noReference: function noReference(ref) {
            return ref || 'n/a';
        }
    },
    data: function data() {
        return {
            tooltip: false
        };
    },

    computed: BookingList__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.booking.bookings.loading;
        },
        noContent: function noContent(state) {
            return state.booking.bookings.noContent;
        },
        error: function error(state) {
            return state.booking.bookings.error;
        },
        page: function page(state) {
            return state.booking.bookings.page;
        },
        limit: function limit(state) {
            return state.booking.bookings.limit;
        },
        limitList: function limitList(state) {
            return state.booking.bookings.limitList;
        },
        predicate: function predicate(state) {
            return state.booking.bookings.predicate;
        },
        defaultPredicate: function defaultPredicate(state) {
            return state.booking.bookings.defaultPredicate;
        },
        predicateList: function predicateList(state) {
            return state.booking.bookings.predicateList;
        },
        hasFetched: function hasFetched(state) {
            return state.booking.bookings.hasFetched;
        },
        navigationMinimized: function navigationMinimized(state) {
            return state.nav.minimized;
        },
        order: function order(state) {
            return state.booking.bookings.order;
        },
        orderList: function orderList(state) {
            return state.booking.bookings.orderList;
        },
        searchword: function searchword(state) {
            return state.booking.bookings.filters.searchword;
        },
        csv: function csv(state) {
            return state.booking.bookings.csv;
        },
        user: function user(state) {
            return state.auth.user;
        }
    }), Object(vuex_esm["mapGetters"])({
        filteredBookings: 'booking/filteredBookings',
        filteredBookingsPaginated: 'booking/filteredBookingsPaginated',
        filteredBookingsMaxPages: 'booking/filteredBookingsMaxPages',
        filteredBookingsCSVFile: 'booking/filteredBookingsCSVFile',
        filteredBookingsXLSFile: 'booking/filteredBookingsXLSFile'
    })),
    methods: BookingList__extends({}, Object(vuex_esm["mapActions"])({
        incrementBookingPagination: 'booking/incrementBookingPagination',
        decrementBookingPagination: 'booking/decrementBookingPagination',
        setPredicate: 'booking/setPredicate',
        selectMultiPredicate: 'booking/selectMultiPredicate',
        setMultiPredicate: 'booking/setMultiPredicate',
        unsetMultiPredicate: 'booking/unsetMultiPredicate',
        resetMultiPredicate: 'booking/resetMultiPredicate',
        setLimit: 'booking/setLimit',
        setOrder: 'booking/setOrder',
        search: 'booking/search',
        downloadFile: 'booking/downloadFile',
        downloadXLS: 'booking/downloadXLS'
    }), {
        downloadFile: function downloadFile(xls) {
            // If not XLS then download as csv
            var encodedURI = encodeURI(xls ? this.filteredBookingsXLSFile : this.filteredBookingsCSVFile);
            var link = document.createElement('a');
            link.setAttribute('href', encodedURI);
            link.setAttribute('download', xls ? 'BookingsList.xls' : 'BookingsList.csv');
            document.body.appendChild(link); // Required for FF

            link.click();
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d48ba2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingList/BookingList.vue
var BookingList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-list"},[(!_vm.loading)?_c('div',{key:'body',staticClass:"booking-list__body"},[_c('div',{staticClass:"booking-list__header",class:{'booking-list__header--minimized': !_vm.navigationMinimized}},[_c('div',{staticClass:"booking-list__heading"},[_vm._v("\n                "+_vm._s(_vm.$tc('bookingList.heading', _vm.filteredBookings.length, {count: _vm.filteredBookings.length}))+"\n                "),_c('span',{staticClass:"booking-list__download",on:{"click":function($event){return _vm.downloadFile(false)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('bookingList.download.csv').toUpperCase())+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"booking-list__download",on:{"click":function($event){return _vm.downloadFile(true)},"mouseenter":function($event){_vm.tooltip = true},"mouseleave":function($event){_vm.tooltip = false}}},[_vm._v("\n                    "+_vm._s(_vm.$t('bookingList.download.xls').toUpperCase())+"\n                    "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.tooltip)?_c('span',{staticClass:"booking-list__xls-tooltip"},[_vm._v("\n                            "+_vm._s(_vm.$t('bookingList.xslTooltip'))+"\n                        ")]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"booking-list__search"},[_c('input',{staticClass:"booking-list__search-field",attrs:{"placeholder":_vm.$t('bookingList.placeholder'),"title":_vm.$t('bookingList.title'),"type":"text"},on:{"keyup":function($event){return _vm.search($event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"booking-list__option booking-list__option--pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.filteredBookingsMaxPages,"current-page":(_vm.filteredBookingsMaxPages) === 0 ? 0 : _vm.page},on:{"next":_vm.incrementBookingPagination,"prev":_vm.decrementBookingPagination}})],1),_vm._v(" "),_c('div',{staticClass:"booking-list__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingList.order'),"value":_vm.order,"items":_vm.orderList,"translation-prefix":'bookingList.orderFields',"searchable":false},on:{"input":function($event){return _vm.setOrder($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"booking-list__option"},[_c('drop-down-menu-multi-select',{attrs:{"label":_vm.$t('bookingList.orderBy'),"value":_vm.predicate,"items":_vm.predicateList,"default-value":_vm.defaultPredicate,"translation-prefix":'booking.tableFields'},on:{"select":function($event){return _vm.setMultiPredicate($event)},"deselect":function($event){return _vm.unsetMultiPredicate($event)},"reset":_vm.resetMultiPredicate}})],1),_vm._v(" "),_c('div',{staticClass:"booking-list__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingList.perPage'),"value":_vm.limit,"items":_vm.limitList,"searchable":false},on:{"input":function($event){return _vm.setLimit($event)}}})],1)]),_vm._v(" "),_c('table',{staticClass:"booking-list__table",attrs:{"id":"booking-list-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'supplierRef'},on:{"click":function($event){return _vm.selectMultiPredicate('supplierRef')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.supplierRef'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'bookingRef'},on:{"click":function($event){return _vm.selectMultiPredicate('bookingRef')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.bookingRef'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'customerName'},on:{"click":function($event){return _vm.selectMultiPredicate('customerName')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.customerName'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'status'},on:{"click":function($event){return _vm.selectMultiPredicate('status')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.status'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'bookingDate'},on:{"click":function($event){return _vm.selectMultiPredicate('bookingDate')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.bookingDate'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'arrivalDate'},on:{"click":function($event){return _vm.selectMultiPredicate('arrivalDate')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.arrivalDate'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'departureDate'},on:{"click":function($event){return _vm.selectMultiPredicate('departureDate')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.departureDate'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'domain'},on:{"click":function($event){return _vm.selectMultiPredicate('domain')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.domain'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'accommodation'},on:{"click":function($event){return _vm.selectMultiPredicate('accommodation')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.accommodation'))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"booking-list__table-header",class:{'booking-list__table-header--selected' : _vm.predicate[0] === 'siteName'},on:{"click":function($event){return _vm.selectMultiPredicate('siteName')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('booking.tableFields.siteName'))+"\n                    ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBookingsPaginated),function(booking,index){return _c('tr',{key:'booking-list-filtered-' + index},[_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(_vm._f("noReference")(booking.supplierRef))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(booking.bookingRef)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(booking.customerName)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(_vm.$t('bookingFilters.status.types.' + booking.status))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(booking.bookingDate,"DD/MM/YYYY"))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(booking.arrivalDate,"DD/MM/YYYY"))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(booking.departureDate,"DD/MM/YYYY"))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(booking.domain)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(booking.accommodation)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"booking-list__table-data"},[_vm._v("\n                        "+_vm._s(booking.siteName)+"\n                    ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"booking-list__items"},[_c('div',{staticClass:"bookings-list__items-list"},_vm._l((_vm.filteredBookingsPaginated),function(booking,index){return _c('booking-item',{key:'booking-list-items-' + index,attrs:{"supplier-ref":booking.supplierRef,"customer-name":booking.customerName,"booking-ref":booking.bookingRef,"booking-status":booking.status,"booking-date":booking.bookingDate,"arrival-date":booking.arrivalDate,"departure-date":booking.departureDate,"domain":booking.domain,"accommodation":booking.accommodation,"site":booking.siteName}})}),1)]),_vm._v(" "),(_vm.error)?_c('div',{key:'error',staticClass:"booking-list__error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),_c('div',{staticClass:"booking-list__error-message"},[_vm._v(_vm._s(_vm.$t('bookingList.error')))])]):_vm._e(),_vm._v(" "),(!_vm.error && (_vm.noContent || !_vm.filteredBookingsPaginated.length))?_c('div',{key:'no-content',staticClass:"booking-list__error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),_c('div',{staticClass:"booking-list__error-message"},[_vm._v(_vm._s(_vm.$t('bookingList.noContent')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"booking-list__footer"},[_c('div',{staticClass:"booking-list__pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.filteredBookingsMaxPages,"current-page":(_vm.filteredBookingsMaxPages) === 0 ? 0 : _vm.page},on:{"prev":_vm.decrementBookingPagination,"next":_vm.incrementBookingPagination}})],1)])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":10,"body-cells":4}}):_vm._e()],1)}
var BookingList_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/BookingList/BookingList.vue
/* script */


/* template */

/* template functional */
var BookingList___vue_template_functional__ = false
/* styles */
var BookingList___vue_styles__ = null
/* scopeId */
var BookingList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BookingList___vue_module_identifier__ = null

var BookingList_Component = Object(component_normalizer["a" /* default */])(
  BookingList,
  BookingList_render,
  BookingList_staticRenderFns,
  BookingList___vue_template_functional__,
  BookingList___vue_styles__,
  BookingList___vue_scopeId__,
  BookingList___vue_module_identifier__
)

/* harmony default export */ var BookingList_BookingList = (BookingList_Component.exports);

// EXTERNAL MODULE: ./src/components/DatePicker/DatePicker.vue + 2 modules
var DatePicker = __webpack_require__(207);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BookingFilters/BookingFilters.vue
var BookingFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var BookingFilters = ({
    components: {
        DatePicker: DatePicker["a" /* default */],
        DropdownMenu: DropdownMenu["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    computed: BookingFilters__extends({}, Object(vuex_esm["mapState"])({
        suppliers: function suppliers(state) {
            return state.booking.bookings.filters.suppliers;
        },
        brands: function brands(state) {
            return state.booking.bookings.filters.brands;
        },
        domains: function domains(state) {
            return state.booking.bookings.filters.domains;
        },
        countries: function countries(state) {
            return state.booking.bookings.filters.countries;
        },
        sites: function sites(state) {
            return state.booking.bookings.filters.sites;
        },
        accommodations: function accommodations(state) {
            return state.booking.bookings.filters.accommodations;
        },
        status: function status(state) {
            return state.booking.bookings.filters.status;
        },
        loading: function loading(state) {
            return state.booking.bookings.filters.loading;
        },
        error: function error(state) {
            return state.booking.bookings.filters.error;
        },
        selected: function selected(state) {
            return state.booking.bookings.filters.selected;
        },
        season: function season(state) {
            return state.booking.bookings.filters.season;
        },
        user: function user(state) {
            return state.auth.user;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    }), Object(vuex_esm["mapGetters"])({
        siteNames: 'booking/siteNames',
        allDomains: 'booking/allDomains',
        allAccommodations: 'booking/allAccommodations'
    }), {
        bookingPeriod: {
            get: function get() {
                return this.$store.state.booking.bookings.filters.bookingPeriod;
            },
            set: function set(value) {
                var _this = this;

                this.setBookingPeriod(value).then(function () {
                    _this.setArrivalPeriod(_this.season).then(function () {
                        _this.getBookings(_this.supplier.id);
                    });
                });
            }
        },
        arrivalPeriod: {
            get: function get() {
                return this.$store.state.booking.bookings.filters.arrivalPeriod;
            },
            set: function set(value) {
                var _this2 = this;

                this.setArrivalPeriod(value).then(function () {
                    _this2.getBookings(_this2.supplier.id);
                });
            }
        }
    }),
    methods: BookingFilters__extends({}, Object(vuex_esm["mapActions"])({
        setBookingPeriod: 'booking/setBookingPeriod',
        setArrivalPeriod: 'booking/setArrivalPeriod',
        setSelectedFilters: 'booking/setSelectedFilters',
        getBookings: 'booking/getBookings'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55716340","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingFilters/BookingFilters.vue
var BookingFilters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-filters"},[(!_vm.loading)?_c('div',{key:'body',staticClass:"booking-filters__body"},[_c('div',{staticClass:"booking-filters__element"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingFilters.brand.label'),"value":_vm.selected.brand,"items":_vm.brands,"enable-deselect":true,"undefined-value":_vm.$t('bookingFilters.brand.all')},on:{"input":function($event){return _vm.setSelectedFilters({brand: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"booking-filters__element"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingFilters.domain.label'),"value":_vm.selected.domain,"items":_vm.domains[_vm.selected.brand] || _vm.allDomains,"enable-deselect":true,"undefined-value":_vm.$t('bookingFilters.domain.all')},on:{"input":function($event){return _vm.setSelectedFilters({domain: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"booking-filters__element"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingFilters.site.label'),"value":_vm.selected.site,"items":_vm.siteNames,"enable-deselect":true,"undefined-value":_vm.$t('bookingFilters.site.all')},on:{"input":function($event){return _vm.setSelectedFilters({site: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"booking-filters__element"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingFilters.accommodation.label'),"value":_vm.selected.accommodation,"items":_vm.sites[_vm.selected.site] || _vm.allAccommodations,"enable-deselect":true,"undefined-value":_vm.$t('bookingFilters.accommodation.all')},on:{"input":function($event){return _vm.setSelectedFilters({accommodation: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"booking-filters__element"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingFilters.country.label'),"value":_vm.selected.country,"items":_vm.countries,"enable-deselect":true,"undefined-value":_vm.$t('bookingFilters.country.all')},on:{"input":function($event){return _vm.setSelectedFilters({country: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"booking-filters__element"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingFilters.status.label'),"value":_vm.selected.status,"items":_vm.status,"enable-deselect":true,"undefined-value":_vm.$t('bookingFilters.status.all'),"translation-prefix":'bookingFilters.status.types'},on:{"input":function($event){return _vm.setSelectedFilters({status: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"booking-filters__element"},[_c('date-picker',{attrs:{"label":_vm.$t('bookingFilters.bookingPeriod.label'),"heading":_vm.$t('bookingFilters.bookingPeriod.datepicker.heading')},model:{value:(_vm.bookingPeriod),callback:function ($$v) {_vm.bookingPeriod=$$v},expression:"bookingPeriod"}})],1),_vm._v(" "),_c('div',{staticClass:"booking-filters__element"},[_c('date-picker',{attrs:{"label":_vm.$t('bookingFilters.arrivalPeriod.label'),"heading":_vm.$t('bookingFilters.arrivalPeriod.datepicker.heading')},model:{value:(_vm.arrivalPeriod),callback:function ($$v) {_vm.arrivalPeriod=$$v},expression:"arrivalPeriod"}})],1)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"body-rows":2,"body-cells":5}}):_vm._e()],1)}
var BookingFilters_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/BookingFilters/BookingFilters.vue
/* script */


/* template */

/* template functional */
var BookingFilters___vue_template_functional__ = false
/* styles */
var BookingFilters___vue_styles__ = null
/* scopeId */
var BookingFilters___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BookingFilters___vue_module_identifier__ = null

var BookingFilters_Component = Object(component_normalizer["a" /* default */])(
  BookingFilters,
  BookingFilters_render,
  BookingFilters_staticRenderFns,
  BookingFilters___vue_template_functional__,
  BookingFilters___vue_styles__,
  BookingFilters___vue_scopeId__,
  BookingFilters___vue_module_identifier__
)

/* harmony default export */ var BookingFilters_BookingFilters = (BookingFilters_Component.exports);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BookingPage/BookingPage.vue
var BookingPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var BookingPage = (vue_esm["default"].extend({
    components: {
        bookingList: BookingList_BookingList,
        bookingFilters: BookingFilters_BookingFilters,
        InfoWidget: InfoWidget["a" /* default */]
    },
    computed: BookingPage__extends({}, Object(vuex_esm["mapState"])({
        tips: function tips(state) {
            return state.booking.bookings.tips;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    watch: {
        supplier: function supplier(_supplier) {
            store_default.a.dispatch('booking/getSupplierFilterData', _supplier.id);
            store_default.a.dispatch('booking/getBookings', _supplier.id);
        }
    },
    created: function created() {
        this.getSupplierFilterData(this.supplier.id);
        this.getBookings(this.supplier.id);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        Promise.all([this.$refs.infoWidget.clean()]).then(function () {
            next();
        });
    },
    destroyed: function destroyed() {
        this.resetState();
    },

    methods: BookingPage__extends({}, Object(vuex_esm["mapActions"])({
        resetState: 'booking/resetState',
        getBookings: 'booking/getBookings',
        getSupplierFilterData: 'booking/getSupplierFilterData'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e295ebb6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingPage/BookingPage.vue
var BookingPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-page"},[_c('booking-filters'),_vm._v(" "),_c('booking-list'),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}})],1)}
var BookingPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/BookingPage/BookingPage.vue
/* script */


/* template */

/* template functional */
var BookingPage___vue_template_functional__ = false
/* styles */
var BookingPage___vue_styles__ = null
/* scopeId */
var BookingPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BookingPage___vue_module_identifier__ = null

var BookingPage_Component = Object(component_normalizer["a" /* default */])(
  BookingPage,
  BookingPage_render,
  BookingPage_staticRenderFns,
  BookingPage___vue_template_functional__,
  BookingPage___vue_styles__,
  BookingPage___vue_scopeId__,
  BookingPage___vue_module_identifier__
)

/* harmony default export */ var BookingPage_BookingPage = __webpack_exports__["default"] = (BookingPage_Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/Alert/Alert.vue + 2 modules
var Alert = __webpack_require__(66);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./src/services/ValidatorService.js
var ValidatorService = __webpack_require__(31);
var ValidatorService_default = /*#__PURE__*/__webpack_require__.n(ValidatorService);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccountForm/AccountForm.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var AccountForm = (vue_esm["default"].extend({
    computed: _extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.account.user.user;
        },
        originalUser: function originalUser(state) {
            return state.account.user.originalUser;
        }
    }), Object(vuex_esm["mapGetters"])({
        userHasChanged: 'account/userHasChanged'
    }), {
        firstNameClasses: function firstNameClasses() {
            return {
                'account-form__input--error': this.$v.user.firstName.$dirty && this.$v.user.firstName.$error,
                'account-form__input--success': this.$v.user.firstName.$dirty && !this.$v.user.firstName.$error
            };
        },
        lastNameClasses: function lastNameClasses() {
            return {
                'account-form__input--error': this.$v.user.lastName.$dirty && this.$v.user.lastName.$error,
                'account-form__input--success': this.$v.user.lastName.$dirty && !this.$v.user.lastName.$error
            };
        }
    }),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        editUser: 'account/editUser',
        updateUser: 'account/updateUser',
        resetUser: 'account/resetUser'
    }), {
        edit: function edit(obj) {
            this.$v.$touch();
            this.editUser(obj);
        }
    }),
    validations: function validations() {
        return {
            user: {
                firstName: {
                    required: function required(firstName) {
                        return Object(ValidatorService["required"])(firstName, 'First name').valid;
                    }
                },
                lastName: {
                    required: function required(lastName) {
                        return Object(ValidatorService["required"])(lastName, 'Last name').valid;
                    }
                }
            }
        };
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ab01a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountForm/AccountForm.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form"},[_c('div',{staticClass:"account-form__heading"},[_c('div',{staticClass:"account-form__header"},[_vm._v("\n            "+_vm._s(_vm.$t('account.form.heading.header'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"account-form__inputs"},[_c('div',{staticClass:"account-form__input-field"},[_c('label',{attrs:{"for":"account-form__id"}},[_vm._v(_vm._s(_vm.$t('account.form.id'))+":")]),_vm._v(" "),_c('input',{staticClass:"account-form__input",attrs:{"id":"account-form__id","disabled":true,"type":"text"},domProps:{"value":_vm.user.id}})]),_vm._v(" "),_c('div',{staticClass:"account-form__input-field"},[_c('label',{attrs:{"for":"account-form__userType"}},[_vm._v(_vm._s(_vm.$t('account.form.accountType.label'))+":")]),_vm._v(" "),_c('input',{staticClass:"account-form__input",attrs:{"id":"account-form__userType","disabled":true,"type":"text"},domProps:{"value":_vm.$t('account.form.accountType.admin.' + _vm.user.admin)}})]),_vm._v(" "),_c('div',{staticClass:"account-form__input-field"},[_c('label',{attrs:{"for":"account-form__firstName"}},[_vm._v(_vm._s(_vm.$t('account.form.firstName'))+":")]),_vm._v(" "),_c('input',{staticClass:"account-form__input",class:_vm.firstNameClasses,attrs:{"id":"account-form__firstName","placeholder":_vm.$t('account.form.placeholder.firstName'),"type":"text"},domProps:{"value":_vm.user.firstName},on:{"input":function($event){return _vm.edit({firstName: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.user.firstName.$error)?_c('div',{staticClass:"account-form__error"},[_vm._v("*"+_vm._s(_vm.$t('account.form.validator.required')))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"account-form__input-field"},[_c('label',{attrs:{"for":"account-form__lastName"}},[_vm._v(_vm._s(_vm.$t('account.form.lastName'))+":")]),_vm._v(" "),_c('input',{staticClass:"account-form__input",class:_vm.lastNameClasses,attrs:{"id":"account-form__lastName","placeholder":_vm.$t('account.form.placeholder.lastName'),"type":"text"},domProps:{"value":_vm.user.lastName},on:{"input":function($event){return _vm.edit({lastName: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.user.lastName.$error)?_c('div',{staticClass:"account-form__error"},[_vm._v("*"+_vm._s(_vm.$t('account.form.validator.required')))]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"account-form__buttons"},[_c('div',{staticClass:"account-form__button-group"},[_c('button',{staticClass:"account-form__btn account-form__btn-update",attrs:{"disabled":!_vm.userHasChanged || _vm.$v.$error},on:{"click":function($event){return _vm.updateUser()}}},[_vm._v("\n                "+_vm._s(_vm.$t('account.form.buttons.update'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"account-form__btn account-form__btn-reset",attrs:{"disabled":!_vm.userHasChanged},on:{"click":function($event){return _vm.resetUser()}}},[_vm._v("\n                "+_vm._s(_vm.$t('account.form.buttons.reset'))+"\n            ")])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/AccountForm/AccountForm.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  AccountForm,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var AccountForm_AccountForm = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccountAvatar/AccountAvatar.vue
var AccountAvatar__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var AccountAvatar = (vue_esm["default"].extend({
    computed: AccountAvatar__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.account.loading;
        }
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4adbc90a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAvatar/AccountAvatar.vue
var AccountAvatar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var AccountAvatar_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-avatar"},[_c('div',{staticClass:"account-avatar__icon"},[_c('i',{staticClass:"fa fa-user"})])])}]

// CONCATENATED MODULE: ./src/components/AccountAvatar/AccountAvatar.vue
/* script */


/* template */

/* template functional */
var AccountAvatar___vue_template_functional__ = false
/* styles */
var AccountAvatar___vue_styles__ = null
/* scopeId */
var AccountAvatar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountAvatar___vue_module_identifier__ = null

var AccountAvatar_Component = Object(component_normalizer["a" /* default */])(
  AccountAvatar,
  AccountAvatar_render,
  AccountAvatar_staticRenderFns,
  AccountAvatar___vue_template_functional__,
  AccountAvatar___vue_styles__,
  AccountAvatar___vue_scopeId__,
  AccountAvatar___vue_module_identifier__
)

/* harmony default export */ var AccountAvatar_AccountAvatar = (AccountAvatar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccountActivityItem/AccountActivityItem.vue

/* harmony default export */ var AccountActivityItem = ({
    props: {
        type: {
            type: String,
            required: true
        },
        accommodation: {
            type: String,
            required: true
        },
        site: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            toggled: false
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18ec5335","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountActivityItem/AccountActivityItem.vue
var AccountActivityItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-activity-item",class:{'account-activity-item__control--toggled': _vm.toggled}},[_c('div',{staticClass:"account-activity-item__header"},[_c('div',{staticClass:"account-activity-item__label"},[_vm._v("\n            "+_vm._s(_vm._f("moment")(_vm.date,"DD/MM/Y\, HH:mm"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__control",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('i',{staticClass:"fa fa-fw fa-info"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"account-activity-item__content-animation"}},[(_vm.toggled)?_c('div',{staticClass:"account-activity-item__content"},[_c('div',{staticClass:"account-activity-item__props"},[_c('div',{staticClass:"account-activity-item__prop"},[_c('div',{staticClass:"account-activity-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('account.activity.type.label'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.$t('account.activity.type.' + _vm.type))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__prop"},[_c('div',{staticClass:"account-activity-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('account.activity.accommodation'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.accommodation)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__prop"},[_c('div',{staticClass:"account-activity-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('account.activity.site'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.site)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__prop"},[_c('div',{staticClass:"account-activity-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('account.activity.status.label'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"account-activity-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.$t('account.activity.status.' + _vm.status))+"\n                    ")])])])]):_vm._e()])],1)}
var AccountActivityItem_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AccountActivityItem/AccountActivityItem.vue
/* script */


/* template */

/* template functional */
var AccountActivityItem___vue_template_functional__ = false
/* styles */
var AccountActivityItem___vue_styles__ = null
/* scopeId */
var AccountActivityItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountActivityItem___vue_module_identifier__ = null

var AccountActivityItem_Component = Object(component_normalizer["a" /* default */])(
  AccountActivityItem,
  AccountActivityItem_render,
  AccountActivityItem_staticRenderFns,
  AccountActivityItem___vue_template_functional__,
  AccountActivityItem___vue_styles__,
  AccountActivityItem___vue_scopeId__,
  AccountActivityItem___vue_module_identifier__
)

/* harmony default export */ var AccountActivityItem_AccountActivityItem = (AccountActivityItem_Component.exports);

// EXTERNAL MODULE: ./src/components/PaginationControl/PaginationControl.vue + 2 modules
var PaginationControl = __webpack_require__(49);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccountActivity/AccountActivity.vue
var AccountActivity__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var AccountActivity = (vue_esm["default"].extend({
    components: {
        AccountActivityItem: AccountActivityItem_AccountActivityItem,
        PaginationControl: PaginationControl["a" /* default */],
        DropDownMenu: DropdownMenu["a" /* default */]
    },
    computed: AccountActivity__extends({}, Object(vuex_esm["mapState"])({
        limit: function limit(state) {
            return state.account.activity.limit;
        },
        limits: function limits(state) {
            return state.account.activity.limits;
        },
        page: function page(state) {
            return state.account.activity.page;
        }
    }), Object(vuex_esm["mapGetters"])({
        activityPaginated: 'account/activityPaginated',
        activityMaxPages: 'account/activityMaxPages'
    })),
    methods: AccountActivity__extends({}, Object(vuex_esm["mapActions"])({
        setRows: 'account/setRows',
        activityPageIncrement: 'account/activityPageIncrement',
        activityPageDecrement: 'account/activityPageDecrement'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b589c3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountActivity/AccountActivity.vue
var AccountActivity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-activity"},[_c('div',{staticClass:"account-activity__header"},[_c('div',{staticClass:"account-activity__heading"},[_vm._v("\n            "+_vm._s(_vm.$t('account.activity.header.heading'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"account-activity__filter"},[_c('drop-down-menu',{attrs:{"label":_vm.$t('account.activity.limit'),"value":_vm.limit,"items":_vm.limits,"searchable":false},on:{"input":function($event){return _vm.setRows($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"account-activity__months"},[_vm._v("\n            "+_vm._s(_vm.$t('account.activity.header.months'))+"\n        ")])]),_vm._v(" "),_c('table',{staticClass:"table account-activity__table"},[_c('thead',{staticClass:"account-activity__table-head"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('account.activity.date')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('account.activity.type.label')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('account.activity.accommodation')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('account.activity.site')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('account.activity.status.label')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.activityPaginated),function(activity,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(activity.updatedAt,"DD/MM/Y\, HH:mm")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('account.activity.type.' + activity.type)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(activity.accommodation))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(activity.site))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('account.activity.status.' + activity.status)))])])}),0)]),_vm._v(" "),(!_vm.activityPaginated)?_c('div',{staticClass:"account-activity__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__error-message"},[_vm._v(_vm._s(_vm.$t('dashboard.notifications.noContent')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-activity__items"},[_c('div',{staticClass:"account-activity__items-list"},_vm._l((_vm.activityPaginated),function(activity,index){return _c('account-activity-item',{key:index,attrs:{"type":activity.type,"accommodation":activity.accommodation,"site":activity.site,"status":activity.status,"date":activity.updatedAt}})}),1)]),_vm._v(" "),(_vm.activityPaginated)?_c('div',{staticClass:"account-activity__footer"},[_c('div',{staticClass:"account-activity__pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.activityMaxPages,"current-page":_vm.page},on:{"prev":_vm.activityPageDecrement,"next":_vm.activityPageIncrement}})],1)]):_vm._e()])}
var AccountActivity_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AccountActivity/AccountActivity.vue
/* script */


/* template */

/* template functional */
var AccountActivity___vue_template_functional__ = false
/* styles */
var AccountActivity___vue_styles__ = null
/* scopeId */
var AccountActivity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountActivity___vue_module_identifier__ = null

var AccountActivity_Component = Object(component_normalizer["a" /* default */])(
  AccountActivity,
  AccountActivity_render,
  AccountActivity_staticRenderFns,
  AccountActivity___vue_template_functional__,
  AccountActivity___vue_styles__,
  AccountActivity___vue_scopeId__,
  AccountActivity___vue_module_identifier__
)

/* harmony default export */ var AccountActivity_AccountActivity = (AccountActivity_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccountPassword/AccountPassword.vue
var AccountPassword__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var AccountPassword = (vue_esm["default"].extend({
    computed: AccountPassword__extends({}, Object(vuex_esm["mapState"])({
        password: function password(state) {
            return state.account.password;
        }
    }), {
        passwordClasses: function passwordClasses() {
            return {
                'account-password__input--error': this.$v.password.password.$dirty && this.$v.password.password.$error,
                'account-password__input--success': this.$v.password.password.$dirty && !this.$v.password.password.$error
            };
        },
        newPasswordClasses: function newPasswordClasses() {
            return {
                'account-password__input--error': this.$v.password.newPassword.$dirty && this.$v.password.newPassword.$error,
                'account-password__input--success': this.$v.password.newPassword.$dirty && !this.$v.password.newPassword.$error
            };
        },
        retypePasswordClasses: function retypePasswordClasses() {
            return {
                'account-password__input--error': this.$v.password.retypePassword.$dirty && this.$v.password.retypePassword.$error,
                'account-password__input--success': this.$v.password.retypePassword.$dirty && !this.$v.password.retypePassword.$error
            };
        }
    }),
    methods: AccountPassword__extends({}, Object(vuex_esm["mapActions"])({
        editPassword: 'account/editPassword',
        resetPassword: 'account/resetPassword',
        updatePassword: 'account/updatePassword'
    }), {
        edit: function edit(obj) {
            this.$v.$touch();
            this.editPassword(obj);
        },
        update: function update() {
            this.$v.$reset();
            this.updatePassword();
        },
        reset: function reset() {
            this.$v.$reset();
            this.resetPassword();
        }
    }),
    validations: function validations() {
        return {
            password: {
                password: {
                    validatePassword: function validatePassword(password) {
                        return Object(ValidatorService["validatePassword"])(password).valid;
                    }
                },
                newPassword: {
                    validatePassword: function validatePassword(password) {
                        return Object(ValidatorService["validatePassword"])(password).valid;
                    }
                },
                retypePassword: {
                    validateStringMatch: function validateStringMatch(retypePassword, state) {
                        return Object(ValidatorService["validateStringMatch"])(retypePassword, state.newPassword).valid;
                    }
                }
            }
        };
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7e8eba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountPassword/AccountPassword.vue
var AccountPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-password"},[_c('div',{staticClass:"account-password__heading"},[_c('div',{staticClass:"account-password__header"},[_vm._v("\n            "+_vm._s(_vm.$t('account.password.heading.header'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"account-password__passwords"},[_c('div',{staticClass:"account-password__password"},[_c('label',{attrs:{"for":"account-password__password"}},[_vm._v(_vm._s(_vm.$t('account.password.password'))+":")]),_vm._v(" "),_c('input',{staticClass:"account-password__input",class:_vm.passwordClasses,attrs:{"id":"account-password__password","placeholder":_vm.$t('account.password.placeholder.password'),"type":"password"},domProps:{"value":_vm.password.password},on:{"input":function($event){return _vm.edit({password: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.password.password.$dirty && _vm.$v.password.password.$error)?_c('div',{staticClass:"account-password__error"},[_vm._v("*"+_vm._s(_vm.$t('account.password.validator.password')))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"account-password__password"},[_c('label',{attrs:{"for":"account-password__new-password"}},[_vm._v(_vm._s(_vm.$t('account.password.newPassword'))+":")]),_vm._v(" "),_c('input',{staticClass:"account-password__input",class:_vm.newPasswordClasses,attrs:{"id":"account-password__new-password","placeholder":_vm.$t('account.password.placeholder.password'),"type":"password"},domProps:{"value":_vm.password.newPassword},on:{"input":function($event){return _vm.edit({newPassword: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.password.newPassword.$dirty && _vm.$v.password.newPassword.$error)?_c('div',{staticClass:"account-password__error"},[_vm._v("*"+_vm._s(_vm.$t('account.password.validator.password')))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"account-password__password"},[_c('label',{attrs:{"for":"account-password__re-password"}},[_vm._v(_vm._s(_vm.$t('account.password.rePassword'))+":")]),_vm._v(" "),_c('input',{staticClass:"account-password__input",class:_vm.retypePasswordClasses,attrs:{"id":"account-password__re-password","placeholder":_vm.$t('account.password.placeholder.password'),"type":"password"},domProps:{"value":_vm.password.retypePassword},on:{"input":function($event){return _vm.edit({retypePassword: $event.target.value})}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$v.password.retypePassword.$error)?_c('div',{staticClass:"account-password__error"},[_vm._v("*"+_vm._s(_vm.$t('account.password.validator.mismatch')))]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"account-password__buttons"},[_c('div',{staticClass:"account-password__button-group"},[_c('button',{staticClass:"account-password__btn account-password__btn-update",attrs:{"disabled":!_vm.$v.$dirty || _vm.$v.$error},on:{"click":function($event){return _vm.update()}}},[_vm._v("\n                "+_vm._s(_vm.$t('account.password.buttons.update'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"account-password__btn account-password__btn-reset",attrs:{"disabled":!_vm.$v.$dirty},on:{"click":function($event){return _vm.reset()}}},[_vm._v("\n                "+_vm._s(_vm.$t('account.password.buttons.reset'))+"\n            ")])])])])}
var AccountPassword_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AccountPassword/AccountPassword.vue
/* script */


/* template */

/* template functional */
var AccountPassword___vue_template_functional__ = false
/* styles */
var AccountPassword___vue_styles__ = null
/* scopeId */
var AccountPassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountPassword___vue_module_identifier__ = null

var AccountPassword_Component = Object(component_normalizer["a" /* default */])(
  AccountPassword,
  AccountPassword_render,
  AccountPassword_staticRenderFns,
  AccountPassword___vue_template_functional__,
  AccountPassword___vue_styles__,
  AccountPassword___vue_scopeId__,
  AccountPassword___vue_module_identifier__
)

/* harmony default export */ var AccountPassword_AccountPassword = (AccountPassword_Component.exports);

// EXTERNAL MODULE: ./src/services/ConverterService.js
var ConverterService = __webpack_require__(50);
var ConverterService_default = /*#__PURE__*/__webpack_require__.n(ConverterService);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccountNotifications/AccountNotifications.vue
var AccountNotifications__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var AccountNotifications = (vue_esm["default"].extend({
    filters: {
        lowercase: function lowercase(string) {
            return string.toLowerCase();
        }
    },
    computed: AccountNotifications__extends({}, Object(vuex_esm["mapState"])({
        editMode: function editMode(state) {
            return state.account.notifications.editMode;
        },
        userNotifications: function userNotifications(state) {
            return state.account.notifications.item;
        },
        originalNotifications: function originalNotifications(state) {
            return state.account.notifications.originalItem;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    }), Object(vuex_esm["mapGetters"])({
        activeWeekdays: 'account/activeWeekdays'
    })),
    methods: AccountNotifications__extends({}, Object(vuex_esm["mapActions"])({
        toggleNotifications: 'account/toggleNotifications',
        updateNotificationsLevel: 'account/updateNotificationsLevel',
        editNotificationsLevel: 'account/editNotificationsLevel',
        toggleNotificationEditMode: 'account/toggleNotificationsEditMode'
    }), {
        cancelEditNotifications: function cancelEditNotifications() {
            this.editNotificationsLevel({ item: this.originalNotifications });
            this.toggleNotificationEditMode(false);
        },
        edit: function edit(obj) {
            // If set to fortnightly then set non-selected days to false
            if (this.userNotifications.fortnightly && obj.hasOwnProperty('days')) {
                this.editNotificationsLevel({ item: Object(ConverterService["convertDaysObject"])(obj) });
            } else {
                // Check if switching from weekly to fortnightly, if so then reset days to set monday true
                if (!obj.hasOwnProperty('days')) {
                    this.editNotificationsLevel({ item: obj });
                    this.editNotificationsLevel({ item: Object(ConverterService["convertDaysObject"])({ days: { monday: true } }) });
                } else {
                    this.editNotificationsLevel({ item: obj });
                }
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bcaf1a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountNotifications/AccountNotifications.vue
var AccountNotifications_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-notifications"},[_c('div',{staticClass:"account-notifications__heading"},[(_vm.editMode)?_c('div',{staticClass:"account-notifications__header"},[_vm._v("\n            "+_vm._s(_vm.$t('admin.profile.notifications.heading.header'))+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"account-notifications__box account-notifications__notification-box"},[_c('div',{staticClass:"account-notifications__notifications-fields"},[_c('div',{staticClass:"account-notifications__display"},[(!_vm.editMode)?_c('div',{staticClass:"account-notifications__notification-status"},[(_vm.userNotifications)?_c('div',{staticClass:"account-notifications__display-checkbox"},[_c('label',{attrs:{"for":"account-notifications__active"}},[_vm._v(_vm._s(_vm.$t('admin.profile.receive'))+" ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.active},attrs:{"id":"account-notifications__active"},on:{"click":function($event){return _vm.toggleNotifications(_vm.supplier.id)}}})]):_vm._e(),_vm._v(" "),(!_vm.userNotifications.active)?_c('div',{staticClass:"account-notifications__display-no-notice"},[_c('strong',[_vm._v(_vm._s(_vm.$t('admin.profile.noNotice')))])]):_vm._e(),_vm._v(" "),(_vm.userNotifications.active)?_c('div',{staticClass:"account-notifications__display-notice"},[_c('span',{staticClass:"account-notifications__display-notice"},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notice'))+"\n                        ")]),_vm._v(" "),(Object.keys(_vm.activeWeekdays).length === 7)?_c('span',{staticClass:"account-notifications__days"},[_c('span',{staticClass:"account-notifications__display-notice"},[_vm._v("\n                                "+_vm._s(_vm.$t('admin.profile.everyday'))+"\n                            ")])]):_vm._e(),_vm._v(" "),(Object.keys(_vm.activeWeekdays).length < 7)?_c('span',{staticClass:"account-notifications__days"},[_vm._l((_vm.activeWeekdays),function(boolean,day,index){return _c('span',{key:index},[(index !== (Object.keys(_vm.activeWeekdays).length - 1))?_c('span',[_c('span',[_vm._v(_vm._s(_vm.$t('admin.profile.notifications.days.' + day).toLowerCase()))]),_vm._v(" "),(index !== (Object.keys(_vm.activeWeekdays).length - 2))?_c('span',[_vm._v(",")]):_vm._e()]):_vm._e(),_vm._v(" "),(index === (Object.keys(_vm.activeWeekdays).length - 1))?_c('span',[(Object.keys(_vm.activeWeekdays).length > 1)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('admin.profile.and'))+" ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('admin.profile.notifications.days.' + day).toLowerCase()))])]):_vm._e()])}),_vm._v(" "),(_vm.userNotifications.weekly)?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('admin.profile.weekly'))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.userNotifications.fortnightly)?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('admin.profile.fortnightly'))+"\n                            ")]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-notifications__display-edit",on:{"click":_vm.toggleNotificationEditMode}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "+_vm._s(_vm.$t('admin.profile.notifications.edit'))+"\n                        ")])]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.editMode)?_c('div',{staticClass:"account-notifications__notification-edit"},[_c('div',{staticClass:"account-notifications__notification-days"},[_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__monday"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.days.monday'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.days.monday},attrs:{"id":"account-notifications__monday"},on:{"click":function($event){return _vm.edit({days: {monday: !_vm.userNotifications.days.monday}})}}})]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__tuesday"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.days.tuesday'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.days.tuesday},attrs:{"id":"account-notifications__tuesday"},on:{"click":function($event){return _vm.edit({days: {tuesday: !_vm.userNotifications.days.tuesday}})}}})]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__wednesday"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.days.wednesday'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.days.wednesday},attrs:{"id":"account-notifications__wednesday"},on:{"click":function($event){return _vm.edit({days: {wednesday: !_vm.userNotifications.days.wednesday}})}}})]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__thursday"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.days.thursday'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.days.thursday},attrs:{"id":"account-notifications__thursday"},on:{"click":function($event){return _vm.edit({days: {thursday: !_vm.userNotifications.days.thursday}})}}})]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__friday"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.days.friday'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.days.friday},attrs:{"id":"account-notifications__friday"},on:{"click":function($event){return _vm.edit({days: {friday: !_vm.userNotifications.days.friday}})}}})]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__saturday"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.days.saturday'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.days.saturday},attrs:{"id":"account-notifications__saturday"},on:{"click":function($event){return _vm.edit({days: {saturday: !_vm.userNotifications.days.saturday}})}}})]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__sunday"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.days.sunday'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.days.sunday},attrs:{"id":"account-notifications__sunday"},on:{"click":function($event){return _vm.edit({days: {sunday: !_vm.userNotifications.days.sunday}})}}})])]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-week"},[_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__weekly"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.weekly'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.weekly},attrs:{"id":"account-notifications__weekly"},on:{"click":function($event){return _vm.edit({weekly: true, fortnightly: false})}}})]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-checkbox"},[_c('label',{staticClass:"account-notifications__notification-label",attrs:{"for":"account-notifications__fortnightly"}},[_vm._v("\n                            "+_vm._s(_vm.$t('admin.profile.notifications.fortnightly'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"account-notifications__checkbox",class:{'account-notifications__checkbox--checked': _vm.userNotifications.fortnightly},attrs:{"id":"account-notifications__fortnightly"},on:{"click":function($event){return _vm.edit({weekly: false, fortnightly: true})}}})])]),_vm._v(" "),_c('div',{staticClass:"account-notifications__notification-buttons"},[_c('button',{staticClass:"account-notifications__btn",on:{"click":function($event){return _vm.updateNotificationsLevel({admin: true, item: _vm.userNotifications})}}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.profile.notifications.update'))+"\n                    ")]),_vm._v(" "),_c('button',{staticClass:"account-notifications__btn",on:{"click":_vm.cancelEditNotifications}},[_vm._v("\n                        "+_vm._s(_vm.$t('admin.profile.notifications.cancel'))+"\n                    ")])])]):_vm._e()])])])}
var AccountNotifications_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AccountNotifications/AccountNotifications.vue
/* script */


/* template */

/* template functional */
var AccountNotifications___vue_template_functional__ = false
/* styles */
var AccountNotifications___vue_styles__ = null
/* scopeId */
var AccountNotifications___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountNotifications___vue_module_identifier__ = null

var AccountNotifications_Component = Object(component_normalizer["a" /* default */])(
  AccountNotifications,
  AccountNotifications_render,
  AccountNotifications_staticRenderFns,
  AccountNotifications___vue_template_functional__,
  AccountNotifications___vue_styles__,
  AccountNotifications___vue_scopeId__,
  AccountNotifications___vue_module_identifier__
)

/* harmony default export */ var AccountNotifications_AccountNotifications = (AccountNotifications_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccountPage/AccountPage.vue
var AccountPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













/* harmony default export */ var AccountPage = (vue_esm["default"].extend({
    components: {
        Alert: Alert["a" /* default */],
        Loading: Loading["a" /* default */],
        InfoWidget: InfoWidget["a" /* default */],
        AccountForm: AccountForm_AccountForm,
        AccountAvatar: AccountAvatar_AccountAvatar,
        AccountActivity: AccountActivity_AccountActivity,
        AccountPassword: AccountPassword_AccountPassword,
        AccountNotifications: AccountNotifications_AccountNotifications
    },
    computed: AccountPage__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        },
        tips: function tips(state) {
            return state.account.tips;
        },
        userLoading: function userLoading(state) {
            return state.account.user.loading;
        },
        passwordLoading: function passwordLoading(state) {
            return state.account.password.loading;
        },
        notificationLoading: function notificationLoading(state) {
            return state.account.notifications.loading;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    watch: {
        supplier: function supplier(_supplier) {
            store_default.a.dispatch('account/getAccount');
            store_default.a.dispatch('account/getAccountActivity', _supplier.id);
            store_default.a.dispatch('account/getAccountNotifications');
            store_default.a.dispatch('nav/toggleNavMenu', false);
        }
    },
    created: function created() {
        var supplierId = this.supplier.id;
        this.getAccount();
        this.getLanguages();
        this.toggleNavMenu(false);
        this.getAccountActivity(supplierId);
        this.getAccountNotifications();
    },

    methods: AccountPage__extends({}, Object(vuex_esm["mapActions"])({
        getAccount: 'account/getAccount',
        getLanguages: 'admin/getLanguages',
        toggleNavMenu: 'nav/toggleNavMenu',
        getAccountActivity: 'account/getAccountActivity',
        getAccountNotifications: 'account/getAccountNotifications'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70084934","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountPage/AccountPage.vue
var AccountPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-page"},[_c('account-avatar'),_vm._v(" "),_c('account-form'),_vm._v(" "),_c('account-password'),_vm._v(" "),(_vm.user.admin)?_c('account-notifications'):_vm._e(),_vm._v(" "),_c('account-activity'),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}}),_vm._v(" "),(_vm.userLoading || _vm.passwordLoading || _vm.notificationLoading)?_c('loading'):_vm._e(),_vm._v(" "),_c('alert',{attrs:{"translation-prefix":'admin.alert'}})],1)}
var AccountPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AccountPage/AccountPage.vue
/* script */


/* template */

/* template functional */
var AccountPage___vue_template_functional__ = false
/* styles */
var AccountPage___vue_styles__ = null
/* scopeId */
var AccountPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountPage___vue_module_identifier__ = null

var AccountPage_Component = Object(component_normalizer["a" /* default */])(
  AccountPage,
  AccountPage_render,
  AccountPage_staticRenderFns,
  AccountPage___vue_template_functional__,
  AccountPage___vue_styles__,
  AccountPage___vue_scopeId__,
  AccountPage___vue_module_identifier__
)

/* harmony default export */ var AccountPage_AccountPage = __webpack_exports__["default"] = (AccountPage_Component.exports);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/Alert/Alert.vue + 2 modules
var Alert = __webpack_require__(66);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./src/components/Instruction/Instruction.vue + 2 modules
var Instruction = __webpack_require__(208);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormSite/ContractFormSite.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormSite = (vue_esm["default"].extend({
    data: function data() {
        return {
            collapseObject: undefined
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.contract.contract.item.sites.sites;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractCollapseObject: 'contract/getContractCollapseObject'
    })),
    created: function created() {
        this.collapseObject = this.getContractCollapseObject;
    },

    methods: {
        collapse: function collapse(obj) {
            for (var i = 0; i < this.collapseObject.length; i++) {
                this.collapseObject[i].collapse = !(i === obj.siteIndex);
                // Use the timeout to ensure that the element is collapsed
                setTimeout(function () {
                    document.getElementById('site_' + obj.siteIndex).scrollIntoView();
                }, 10);
            }
            this.$forceUpdate();
        }
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098a64c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormSite/ContractFormSite.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-site"},[_c('div',{staticClass:"contract-form-site__content"},[_c('div',{staticClass:"contract-form-site__header"},[_c('div',{staticClass:"contract-form-site__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.sites.header.heading'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__body"},[_c('div',{staticClass:"contract-form-site__sites"},_vm._l((_vm.sites),function(site,siteIndex){return _c('div',{key:'site_' + siteIndex,staticClass:"contract-form-site__site",attrs:{"id":'site_' + siteIndex}},[_c('div',{staticClass:"contract-form-site__site-header",class:{'contract-form-site__site-header--collapsed': _vm.collapseObject[siteIndex].collapse},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex})}}},[_vm._v("\n                        "+_vm._s(site.name)+"\n                    ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].collapse)?_c('div',{staticClass:"contract-form-site__content"},[_c('div',{staticClass:"contract-form-site__site-address"},[_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.extra.address}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.address'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_vm._v(_vm._s(site.extra.address))])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.extra.zipCode}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.zipCode'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_vm._v(_vm._s(site.extra.zipCode))])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.extra.city}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.city'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_vm._v(_vm._s(site.extra.city))])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.extra.country}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.country'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_vm._v(_vm._s(site.extra.country))])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.extra.website}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.website'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_c('a',{attrs:{"href":'http://' + site.extra.website,"target":"_blank"}},[_vm._v(_vm._s(site.extra.website))])])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.extra.email}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.email'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_c('a',{attrs:{"href":'mailTo:' + site.extra.email}},[_vm._v(_vm._s(site.extra.email))])])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.extra.phone}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.phone'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_c('a',{attrs:{"href":'tel:' + site.extra.phone}},[_vm._v(_vm._s(site.extra.phone))])])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element"},[_c('div',{staticClass:"contract-form-site__site-address-element-label",class:{'contract-form-site__site-address-element-label--inactive': !site.rating}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contract.form.sites.rating'))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-address-element-data"},[_vm._v(_vm._s(site.rating)+"/5")])])]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-images"},_vm._l((site.imagesS3),function(image,imageIndex){return _c('a',{key:'image_' + imageIndex,staticClass:"contract-form-site__site-image-wrapper",attrs:{"href":image,"target":"_blank"}},[_c('img',{staticClass:"contract-form-site__site-image",attrs:{"src":imageIndex,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"contract-form-site__site-image-overlay"},[_vm._v(_vm._s(_vm.$t('contract.form.sites.view')))])])}),0),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-facilities"},[_c('div',{staticClass:"contract-form-site__site-facilities-header"},[_vm._v("\n                                "+_vm._s(_vm.$t('contract.form.sites.facilities.header'))+"\n                            ")]),_vm._v(" "),_vm._l((site.facilities),function(facility,facilityIndex){return _c('div',{key:'facility_' + facilityIndex,staticClass:"contract-form-site__site-facility-elements"},[_c('div',{staticClass:"contract-form-site__site-facility-element"},[_c('div',{staticClass:"contract-form-site__site-facility-element-label"},[_vm._v(_vm._s(facility.name))]),_vm._v(" "),_c('div',{staticClass:"contract-form-site__site-facility-element-items"},_vm._l((facility.extraInfo),function(item,itemIndex){return _c('div',{key:'item_' + itemIndex,staticClass:"contract-form-site__site-facility-element-item"},[_vm._v("\n                                            "+_vm._s(item)+"\n                                        ")])}),0),_vm._v(" "),(facility.number || facility.distance || facility.size || facility.startDate || facility.endDate)?_c('div',{staticClass:"contract-form-site__site-facility-element-data-list"},[_c('div',{staticClass:"contract-form-site__site-facility-element-data-header"},[_vm._v("\n                                            "+_vm._s(_vm.$t('contract.form.sites.facilities.dataHeader'))+":\n                                        ")]),_vm._v(" "),(facility.number)?_c('div',{staticClass:"contract-form-site__site-facility-element-data"},[_c('span',{staticClass:"contract-form-site__site-facility-element-data-value"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.sites.facilities.number'))+": "+_vm._s(facility.number)+"\n                                            ")])]):_vm._e(),_vm._v(" "),(facility.distance)?_c('div',{staticClass:"contract-form-site__site-facility-element-data"},[_c('span',{staticClass:"contract-form-site__site-facility-element-data-value"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.sites.facilities.distance'))+": "+_vm._s(facility.distance)+"\n                                            ")])]):_vm._e(),_vm._v(" "),(facility.size)?_c('div',{staticClass:"contract-form-site__site-facility-element-data"},[_c('span',{staticClass:"contract-form-site__site-facility-element-data-value"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.sites.facilities.size'))+": "+_vm._s(facility.size)+"\n                                            ")])]):_vm._e(),_vm._v(" "),(facility.startDate)?_c('div',{staticClass:"contract-form-site__site-facility-element-data"},[_c('span',{staticClass:"contract-form-site__site-facility-element-data-value"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.sites.facilities.startDate'))+": "+_vm._s(facility.startDate)+"\n                                            ")])]):_vm._e(),_vm._v(" "),(facility.endDate)?_c('div',{staticClass:"contract-form-site__site-facility-element-data"},[_c('span',{staticClass:"contract-form-site__site-facility-element-data-value"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.sites.facilities.endDate'))+": "+_vm._s(facility.endDate)+"\n                                            ")])]):_vm._e()]):_vm._e()])])})],2)]):_vm._e()])}),0)]),_vm._v(" "),(_vm.sites.length === 0)?_c('div',{staticClass:"contract-form-site__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__no-content-message"},[_vm._v(_vm._s(_vm.$t('contract.form.sites.noContent')))])]):_vm._e()])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ContractFormSite/ContractFormSite.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ContractFormSite,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ContractFormSite_ContractFormSite = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormTerms/ContractFormTerms.vue
var ContractFormTerms__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormTerms = (vue_esm["default"].extend({
    computed: ContractFormTerms__extends({}, Object(vuex_esm["mapState"])({
        terms: function terms(state) {
            return state.contract.contract.item.terms;
        }
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe57812","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormTerms/ContractFormTerms.vue
var ContractFormTerms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-terms"},[_c('div',{staticClass:"contract-form-terms__content"},[_c('div',{staticClass:"contract-form-terms__heading"},[_c('div',{staticClass:"contract-form-terms__header"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.terms.heading.header'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-terms__body"},[_c('div',{staticClass:"contract-form-terms__terms-header"},[_vm._v(_vm._s(_vm.terms.header))]),_vm._v(" "),_c('div',{staticClass:"contract-form-terms__terms-text"},[_vm._v(_vm._s(_vm.terms.text))]),_vm._v(" "),_c('div',{staticClass:"contract-form-terms__items"},_vm._l((_vm.terms.articles),function(article,index){return _c('div',{key:("article_ " + index),staticClass:"contract-form-terms__item"},[_c('div',{staticClass:"contract-form-terms__item-header"},[_vm._v(_vm._s(article.header))]),_vm._v(" "),_c('div',{staticClass:"contract-form-terms__item-clauses"},_vm._l((article.clauses),function(clause,index){return _c('div',{key:("clause_" + index),staticClass:"contract-form-terms__item-clause"},[_c('div',{staticClass:"contract-form-terms__item-clause-header"},[_vm._v(_vm._s(clause.header))]),_vm._v(" "),(clause.clause.title)?[_c('div',{staticClass:"contract-form-terms__item-clause-text"},[_vm._v(_vm._s(clause.clause.title))]),_vm._v(" "),_c('div',{staticClass:"contract-form-terms__item-clause-points"},[_c('ul',_vm._l((clause.clause.points),function(text,clauseIndex){return _c('li',{key:("clauseArray_" + clauseIndex)},[_vm._v("\n                                            "+_vm._s(text)+"\n                                        ")])}),0)])]:[_c('div',{staticClass:"contract-form-terms__item-clause-text"},[_vm._v(_vm._s(clause.clause))])]],2)}),0)])}),0)])])])}
var ContractFormTerms_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormTerms/ContractFormTerms.vue
/* script */


/* template */

/* template functional */
var ContractFormTerms___vue_template_functional__ = false
/* styles */
var ContractFormTerms___vue_styles__ = null
/* scopeId */
var ContractFormTerms___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormTerms___vue_module_identifier__ = null

var ContractFormTerms_Component = Object(component_normalizer["a" /* default */])(
  ContractFormTerms,
  ContractFormTerms_render,
  ContractFormTerms_staticRenderFns,
  ContractFormTerms___vue_template_functional__,
  ContractFormTerms___vue_styles__,
  ContractFormTerms___vue_scopeId__,
  ContractFormTerms___vue_module_identifier__
)

/* harmony default export */ var ContractFormTerms_ContractFormTerms = (ContractFormTerms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormPrice/ContractFormPrice.vue
var ContractFormPrice__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormPrice = (vue_esm["default"].extend({
    filters: {
        percentage: function percentage(string) {
            return string + ' %';
        }
    },
    computed: ContractFormPrice__extends({}, Object(vuex_esm["mapState"])({
        priceGroups: function priceGroups(state) {
            return state.contract.contract.item.prices.priceGroups;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractCollapseObject: 'contract/getContractCollapseObject'
    })),
    created: function created() {
        this.collapseObject = this.getContractCollapseObject;
    },

    methods: {
        collapse: function collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for (var i = 0; i < this.collapseObject[obj.priceGroupIndex].sites[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.priceGroupIndex].sites[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();
                    }, 10);
                }
            } else if (obj.hasOwnProperty('siteIndex')) {
                for (var _i = 0; _i < this.collapseObject[obj.priceGroupIndex].sites.length; _i++) {
                    this.collapseObject[obj.priceGroupIndex].sites[_i].collapse = !(_i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('site_' + obj.siteIndex).scrollIntoView();
                    }, 10);
                }
            } else {
                for (var _i2 = 0; _i2 < this.collapseObject.length; _i2++) {
                    this.collapseObject[_i2].collapse = !(_i2 === obj.priceGroupIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('priceGroup_' + obj.priceGroupIndex).scrollIntoView();
                    }, 10);
                }
            }
            this.$forceUpdate();
        }
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a08f9c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormPrice/ContractFormPrice.vue
var ContractFormPrice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-price"},[_c('div',{staticClass:"contract-form-price__content"},[_c('div',{staticClass:"contract-form-price__header"},[_c('div',{staticClass:"contract-form-price__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.prices.header.heading'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-price__body"},[_c('div',{staticClass:"contract-form-price__items"},_vm._l((_vm.priceGroups),function(priceGroup,priceGroupIndex){return _c('div',{key:'priceGroup_' + priceGroupIndex,staticClass:"contract-form-price__item contract-form-price__item-price",attrs:{"id":'priceGroup_' + priceGroupIndex}},[_c('div',{staticClass:"contract-form-price__price-header",class:{'contract-form-price__price-header--collapsed': _vm.collapseObject[priceGroupIndex].collapse},on:{"click":function($event){return _vm.collapse({priceGroupIndex: priceGroupIndex})}}},[_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.prices.setting.priceType.' + priceGroup.priceType))+" > ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.prices.setting.pricePr.' + priceGroup.pricePr))+" > ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.prices.setting.grossOrNet.' + priceGroup.grossOrNet)))])]),_vm._v(" "),(!_vm.collapseObject[priceGroupIndex].collapse)?_c('div',_vm._l((priceGroup.sites),function(site,siteIndex){return _c('div',{key:'site_' + siteIndex,staticClass:"contract-form-price__item contract-form-price__item-site",attrs:{"id":'site_' + siteIndex}},[_c('div',{staticClass:"contract-form-price__item-header",class:{'contract-form-price__item-header--collapsed': _vm.collapseObject[priceGroupIndex].sites[siteIndex].collapse},on:{"click":function($event){return _vm.collapse({priceGroupIndex: priceGroupIndex, siteIndex: siteIndex})}}},[_vm._v("\n                                "+_vm._s(site.name)+"\n                            ")]),_vm._v(" "),(!_vm.collapseObject[priceGroupIndex].sites[siteIndex].collapse)?_c('div',_vm._l((site.accommodations),function(accommodation,accommodationIndex){return _c('div',{key:'accommodation_' + accommodationIndex,staticClass:"contract-form-price__item contract-form-price__item-accommodation",attrs:{"id":'accommodation_' + accommodationIndex}},[_c('div',{staticClass:"contract-form-price__item-label",class:{'contract-form-price__item-label--collapsed': _vm.collapseObject[priceGroupIndex].sites[siteIndex].accommodations[accommodationIndex]},on:{"click":function($event){return _vm.collapse({priceGroupIndex: priceGroupIndex, siteIndex: siteIndex, accommodationIndex: accommodationIndex})}}},[_vm._v("\n                                        "+_vm._s(accommodation.name)+"\n                                    ")]),_vm._v(" "),(!_vm.collapseObject[priceGroupIndex].sites[siteIndex].accommodations[accommodationIndex])?_c('div',_vm._l((accommodation.prices),function(price,index){return _c('div',{key:'price_' + index,staticClass:"contract-form-price__item contract-form-price__accommodation-row"},[_c('div',{staticClass:"contract-form-price__row-item"},[_c('div',{staticClass:"contract-form-price__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.prices.startDate')))]),_vm._v(" "),(price.startDate)?_c('div',{staticClass:"contract-form-price__item-date"},[_vm._v(_vm._s(_vm._f("moment")(price.startDate,'DD/MM/YYYY')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-price__row-item"},[_c('div',{staticClass:"contract-form-price__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.prices.endDate')))]),_vm._v(" "),(price.endDate)?_c('div',{staticClass:"contract-form-price__item-date"},[_vm._v(_vm._s(_vm._f("moment")(price.endDate,'DD/MM/YYYY')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-price__row-item"},[_c('div',{staticClass:"contract-form-price__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.prices.price')))]),_vm._v(" "),(price.price)?_c('div',{staticClass:"contract-form-price__item-price"},[_vm._v(_vm._s(price.price))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-price__row-item",class:{'contract-form-price__row-item--inactive': priceGroup.grossOrNet === 'net'}},[_c('div',{staticClass:"contract-form-price__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.prices.commission')))]),_vm._v(" "),(price.commission && priceGroup.grossOrNet !== 'net')?_c('div',{staticClass:"contract-form-price__item-commission"},[_vm._v("\n                                                    "+_vm._s(_vm._f("percentage")(price.commission))+"\n                                                ")]):_vm._e(),_vm._v(" "),(!price.commission && priceGroup.grossOrNet === 'net')?_c('div',{staticClass:"contract-form-price__item-commission"},[_vm._v("\n                                                    "+_vm._s(_vm.$t('contract.form.prices.setting.grossOrNet.' + priceGroup.grossOrNet))+"\n                                                ")]):_vm._e()])])}),0):_vm._e()])}),0):_vm._e()])}),0):_vm._e()])}),0)]),_vm._v(" "),(_vm.priceGroups.length === 0)?_c('div',{staticClass:"contract-form-site__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__no-content-message"},[_vm._v(_vm._s(_vm.$t('contract.form.prices.noContent')))])]):_vm._e()])])}
var ContractFormPrice_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormPrice/ContractFormPrice.vue
/* script */


/* template */

/* template functional */
var ContractFormPrice___vue_template_functional__ = false
/* styles */
var ContractFormPrice___vue_styles__ = null
/* scopeId */
var ContractFormPrice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormPrice___vue_module_identifier__ = null

var ContractFormPrice_Component = Object(component_normalizer["a" /* default */])(
  ContractFormPrice,
  ContractFormPrice_render,
  ContractFormPrice_staticRenderFns,
  ContractFormPrice___vue_template_functional__,
  ContractFormPrice___vue_styles__,
  ContractFormPrice___vue_scopeId__,
  ContractFormPrice___vue_module_identifier__
)

/* harmony default export */ var ContractFormPrice_ContractFormPrice = (ContractFormPrice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormExtra/ContractFormExtra.vue
var ContractFormExtra__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormExtra = (vue_esm["default"].extend({
    data: function data() {
        return {
            collapseObject: undefined
        };
    },

    computed: ContractFormExtra__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.contract.contract.item.extras.sites;
        },
        isSupplier: function isSupplier(state) {
            return !state.auth.user.contractManager;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractCollapseObject: 'contract/getContractCollapseObject'
    })),
    created: function created() {
        this.collapseObject = this.getContractCollapseObject;
    },

    methods: {
        collapse: function collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for (var i = 0; i < this.collapseObject[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();
                    }, 10);
                }
            } else {
                for (var _i = 0; _i < this.collapseObject.length; _i++) {
                    this.collapseObject[_i].collapse = !(_i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('site_' + obj.siteIndex).scrollIntoView();
                    }, 10);
                }
            }
            this.$forceUpdate();
        }
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77bcfbb4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormExtra/ContractFormExtra.vue
var ContractFormExtra_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-extra"},[_c('div',{staticClass:"contract-form-extra__content"},[_c('div',{staticClass:"contract-form-extra__header"},[_c('div',{staticClass:"contract-form-extra__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.extras.header.heading'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__body"},[_c('div',{staticClass:"contract-form-extra__items"},_vm._l((_vm.sites),function(site,siteIndex){return _c('div',{key:'site_' + siteIndex,staticClass:"contract-form-extra__item contract-form-extra__item-site",attrs:{"id":'site_' + siteIndex}},[_c('div',{staticClass:"contract-form-extra__item-header",class:{'contract-form-extra__item-header--collapsed': _vm.collapseObject[siteIndex].collapse},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex})}}},[_vm._v("\n                        "+_vm._s(site.name)+"\n                    ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].collapse)?_c('div',{staticClass:"contract-form-extra__accommodation"},_vm._l((site.accommodations),function(accommodation,accommodationIndex){return _c('div',{key:'accommodation_' + accommodationIndex,staticClass:"contract-form-extra__item contract-form-extra__item-accommodation",attrs:{"id":'accommodation_' + accommodationIndex}},[_c('div',{staticClass:"contract-form-extra__item-label",class:{'contract-form-extra__item-label--collapsed': _vm.collapseObject[siteIndex].accommodations[accommodationIndex]},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})}}},[_vm._v("\n                                "+_vm._s(accommodation.name)+"\n                            ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].accommodations[accommodationIndex])?_c('div',_vm._l((accommodation.extras),function(extra,index){return (!(_vm.isSupplier && extra.type === 'inclusive'))?_c('div',{key:'discount_' + index,staticClass:"contract-form-extra__item contract-form-extra__accommodation-row"},[_c('div',{staticClass:"contract-form-extra__row-header"},[_c('span',{staticClass:"contract-form-extra__row-header-left"},[_vm._v(_vm._s(extra.description))]),_vm._v(" "),_c('span',{staticClass:"contract-form-extra__row-header-right"},[_c('span',{staticClass:"contract-form-extra__row-header-type-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.type.' + extra.type)))]),_vm._v(" "),_c('span',{staticClass:"contract-form-extra__row-header-type",class:'contract-form-extra__row-header-type--' + extra.type,attrs:{"title":_vm.$t('contract.form.extras.type.' + extra.type)}})])]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__sections"},[_c('div',{staticClass:"contract-form-extra__section"},[_c('div',{staticClass:"contract-form-extra__section-wrapper"},[_c('div',{staticClass:"contract-form-extra__section-row"},[_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.arrival}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.startDate')))]),_vm._v(" "),(extra.startDate)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm._f("moment")(extra.startDate,'DD/MM/YYYY')))]):_vm._e(),_vm._v(" "),(!extra.startDate)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.arrival}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.endDate')))]),_vm._v(" "),(extra.endDate)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm._f("moment")(extra.endDate,'DD/MM/YYYY')))]):_vm._e(),_vm._v(" "),(!extra.endDate)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section-row"},[_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.arrival}},[_vm._m(0,true),_vm._v(" "),(extra.arrival)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(extra.arrival))]):_vm._e(),_vm._v(" "),(!extra.arrival)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.departure}},[_vm._m(1,true),_vm._v(" "),(extra.departure)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(extra.departure))]):_vm._e(),_vm._v(" "),(!extra.departure)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section"},[_c('div',{staticClass:"contract-form-extra__section-wrapper"},[_c('div',{staticClass:"contract-form-extra__section-row"},[_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-4",class:{'contract-form-extra__section-item--inactive': !extra.ageFrom}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.ageFrom')))]),_vm._v(" "),(extra.ageFrom)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(extra.ageFrom))]):_vm._e(),_vm._v(" "),(!extra.ageFrom)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-4",class:{'contract-form-extra__section-item--inactive': !extra.ageTo}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.ageTo')))]),_vm._v(" "),(extra.ageTo)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(extra.ageTo))]):_vm._e(),_vm._v(" "),(!extra.ageTo)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-4",class:{'contract-form-extra__section-item--inactive': !extra.person}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.person')))]),_vm._v(" "),(extra.person)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(extra.person))]):_vm._e(),_vm._v(" "),(!extra.person)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section"},[_c('div',{staticClass:"contract-form-extra__section-wrapper"},[_c('div',{staticClass:"contract-form-extra__section-row"},[_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.rule}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.rule')))]),_vm._v(" "),(extra.rule)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.per.' + extra.rule)))]):_vm._e(),_vm._v(" "),(!extra.rule)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.sell || extra.sell === 'ignore'}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.sell')))]),_vm._v(" "),(extra.sell && extra.sell !== 'ignore' && extra.sell !== 'ignore')?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.payment.' + extra.sell)))]):_vm._e(),_vm._v(" "),(!extra.sell || extra.sell === 'ignore')?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section"},[_c('div',{staticClass:"contract-form-extra__section-wrapper"},[_c('div',{staticClass:"contract-form-extra__section-row"},[_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.price || extra.sell === 'ignore'}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.price')))]),_vm._v(" "),(extra.price && extra.sell !== 'ignore')?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(extra.price))]):_vm._e(),_vm._v(" "),(!extra.price || extra.sell === 'ignore')?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-extra__section-item contract-form-extra__section-item-6",class:{'contract-form-extra__section-item--inactive': !extra.commission}},[_c('div',{staticClass:"contract-form-extra__section-label"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.commission')))]),_vm._v(" "),(extra.commission)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(extra.commission))]):_vm._e(),_vm._v(" "),(!extra.commission)?_c('div',{staticClass:"contract-form-extra__section-data"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.netPrice')))]):_vm._e()])])])])])]):_vm._e()}),0):_vm._e()])}),0):_vm._e()])}),0)]),_vm._v(" "),(_vm.sites.length === 0)?_c('div',{staticClass:"contract-form-site__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__no-content-message"},[_vm._v(_vm._s(_vm.$t('contract.form.extras.noContent')))])]):_vm._e()])])}
var ContractFormExtra_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-extra__section-icon"},[_c('i',{staticClass:"fa fa-plane-arrival"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-extra__section-icon"},[_c('i',{staticClass:"fa fa-plane-departure"})])}]

// CONCATENATED MODULE: ./src/components/ContractFormExtra/ContractFormExtra.vue
/* script */


/* template */

/* template functional */
var ContractFormExtra___vue_template_functional__ = false
/* styles */
var ContractFormExtra___vue_styles__ = null
/* scopeId */
var ContractFormExtra___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormExtra___vue_module_identifier__ = null

var ContractFormExtra_Component = Object(component_normalizer["a" /* default */])(
  ContractFormExtra,
  ContractFormExtra_render,
  ContractFormExtra_staticRenderFns,
  ContractFormExtra___vue_template_functional__,
  ContractFormExtra___vue_styles__,
  ContractFormExtra___vue_scopeId__,
  ContractFormExtra___vue_module_identifier__
)

/* harmony default export */ var ContractFormExtra_ContractFormExtra = (ContractFormExtra_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormArrival/ContractFormArrival.vue
var ContractFormArrival__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormArrival = (vue_esm["default"].extend({
    data: function data() {
        return {
            collapseObject: undefined
        };
    },

    computed: ContractFormArrival__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.contract.contract.item.arrivalRules.sites;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractCollapseObject: 'contract/getContractCollapseObject'
    })),
    created: function created() {
        this.collapseObject = this.getContractCollapseObject;
    },

    methods: {
        collapse: function collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                this.collapseObject[obj.siteIndex].accommodations[obj.accommodationIndex] = !this.collapseObject[obj.siteIndex].accommodations[obj.accommodationIndex];
            } else {
                this.collapseObject[obj.siteIndex].collapse = !this.collapseObject[obj.siteIndex].collapse;
            }
            this.$forceUpdate();
        }
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24964ae2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormArrival/ContractFormArrival.vue
var ContractFormArrival_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-arrival"},[_c('div',{staticClass:"contract-form-arrival__content"},[_c('div',{staticClass:"contract-form-arrival__header"},[_c('div',{staticClass:"contract-form-arrival__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.arrivalRules.header.heading'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__body"},[_c('div',{staticClass:"contract-form-arrival__items"},_vm._l((_vm.sites),function(site,siteIndex){return _c('div',{key:'site_' + siteIndex,staticClass:"contract-form-arrival__item contract-form-arrival__item-site"},[_c('div',{staticClass:"contract-form-arrival__item-header",class:{'contract-form-arrival__item-header--collapsed': _vm.collapseObject[siteIndex].collapse},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex})}}},[_c('span',[_vm._v(_vm._s(site.name))]),_vm._v(" "),_c('span',{staticClass:"contract-form-arrival__item-header-info"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.arrival'))+": "+_vm._s(site.arrival))]),_vm._v(" "),_c('span',{staticClass:"contract-form-arrival__item-header-info"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.departure'))+": "+_vm._s(site.departure))])]),_vm._v(" "),(!_vm.collapseObject[siteIndex].collapse)?_c('div',_vm._l((site.accommodations),function(accommodation,accommodationIndex){return _c('div',{key:'accommodation_' + accommodationIndex,staticClass:"contract-form-arrival__item contract-form-arrival__item-accommodation"},[_c('div',{staticClass:"contract-form-arrival__item-label",class:{'contract-form-discount__item-label--collapsed': _vm.collapseObject[siteIndex].accommodations[accommodationIndex]},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})}}},[_vm._v("\n                                "+_vm._s(accommodation.name)+"\n                            ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].accommodations[accommodationIndex])?_c('div',_vm._l((accommodation.arrivals),function(arrival,index){return _c('div',{key:'arrival_' + index,staticClass:"contract-form-arrival__item contract-form-arrival__accommodation-row"},[_c('div',{staticClass:"contract-form-arrival__row-item"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.startDate')))]),_vm._v(" "),(arrival.startDate)?_c('div',{staticClass:"contract-form-arrival__item-date"},[_vm._v(_vm._s(_vm._f("moment")(arrival.startDate,'DD/MM/YYYY')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__row-item"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.endDate')))]),_vm._v(" "),(arrival.endDate)?_c('div',{staticClass:"contract-form-arrival__item-date"},[_vm._v(_vm._s(_vm._f("moment")(arrival.endDate,'DD/MM/YYYY')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__row-item"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.minRental')))]),_vm._v(" "),(arrival.minRental)?_c('div',{staticClass:"contract-form-arrival__item-date"},[_vm._v(_vm._s(arrival.minRental)+" "+_vm._s(_vm.$t('contract.form.arrivalRules.days')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__row-item"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.maxRental')))]),_vm._v(" "),(arrival.maxRental)?_c('div',{staticClass:"contract-form-arrival__item-date"},[_vm._v(_vm._s(arrival.maxRental)+" "+_vm._s(_vm.$t('contract.form.arrivalRules.days')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__row-item"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.type.label')))]),_vm._v(" "),(arrival.type)?_c('div',{staticClass:"contract-form-arrival__item-date"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.type.' + arrival.type)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__row-item contract-form-arrival__item-days"},[_c('div',{staticClass:"contract-form-arrival__item-day"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.monday')))]),_vm._v(" "),_c('div',{class:['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.monday}]})]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__item-day"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.tuesday')))]),_vm._v(" "),_c('div',{class:['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.tuesday}]})]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__item-day"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.wednesday')))]),_vm._v(" "),_c('div',{class:['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.wednesday}]})]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__item-day"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.thursday')))]),_vm._v(" "),_c('div',{class:['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.thursday}]})]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__item-day"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.friday')))]),_vm._v(" "),_c('div',{class:['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.friday}]})]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__item-day"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.saturday')))]),_vm._v(" "),_c('div',{class:['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.saturday}]})]),_vm._v(" "),_c('div',{staticClass:"contract-form-arrival__item-day"},[_c('div',{staticClass:"contract-form-arrival__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.sunday')))]),_vm._v(" "),_c('div',{class:['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.sunday}]})])])])}),0):_vm._e()])}),0):_vm._e()])}),0)]),_vm._v(" "),(_vm.sites.length === 0)?_c('div',{staticClass:"contract-form-site__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__no-content-message"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.noContent')))])]):_vm._e()])])}
var ContractFormArrival_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormArrival/ContractFormArrival.vue
/* script */


/* template */

/* template functional */
var ContractFormArrival___vue_template_functional__ = false
/* styles */
var ContractFormArrival___vue_styles__ = null
/* scopeId */
var ContractFormArrival___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormArrival___vue_module_identifier__ = null

var ContractFormArrival_Component = Object(component_normalizer["a" /* default */])(
  ContractFormArrival,
  ContractFormArrival_render,
  ContractFormArrival_staticRenderFns,
  ContractFormArrival___vue_template_functional__,
  ContractFormArrival___vue_styles__,
  ContractFormArrival___vue_scopeId__,
  ContractFormArrival___vue_module_identifier__
)

/* harmony default export */ var ContractFormArrival_ContractFormArrival = (ContractFormArrival_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormDiscount/ContractFormDiscount.vue
var ContractFormDiscount__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormDiscount = (vue_esm["default"].extend({
    data: function data() {
        return {
            collapseObject: undefined
        };
    },

    computed: ContractFormDiscount__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.contract.contract.item.discounts.sites;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractCollapseObject: 'contract/getContractCollapseObject'
    })),
    created: function created() {
        this.collapseObject = this.getContractCollapseObject;
    },

    methods: {
        collapse: function collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for (var i = 0; i < this.collapseObject[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();
                    }, 10);
                }
            } else {
                for (var _i = 0; _i < this.collapseObject.length; _i++) {
                    this.collapseObject[_i].collapse = !(_i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('site_' + obj.siteIndex).scrollIntoView();
                    }, 10);
                }
            }
            this.$forceUpdate();
        }
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feed2f6a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormDiscount/ContractFormDiscount.vue
var ContractFormDiscount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-discount"},[_c('div',{staticClass:"contract-form-discount__content"},[_c('div',{staticClass:"contract-form-discount__header"},[_c('div',{staticClass:"contract-form-discount__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.discounts.header.heading'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-discount__body"},[_c('div',{staticClass:"contract-form-discount__items"},_vm._l((_vm.sites),function(site,siteIndex){return _c('div',{key:'site_' + siteIndex,staticClass:"contract-form-discount__item contract-form-discount__item-site",attrs:{"id":'site_' + siteIndex}},[_c('div',{staticClass:"contract-form-discount__item-header",class:{'contract-form-discount__item-header--collapsed': _vm.collapseObject[siteIndex].collapse},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex})}}},[_vm._v("\n                        "+_vm._s(site.name)+"\n                    ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].collapse)?_c('div',_vm._l((site.accommodations),function(accommodation,accommodationIndex){return _c('div',{key:'accommodation_' + accommodationIndex,staticClass:"contract-form-discount__item contract-form-discount__item-accommodation",attrs:{"id":'accommodation_' + accommodationIndex}},[_c('div',{staticClass:"contract-form-discount__item-label",class:{
                                     'contract-form-discount__item-label--collapsed':
                                         _vm.collapseObject[siteIndex].accommodations[accommodationIndex]
                                 },on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})}}},[_vm._v("\n                                "+_vm._s(accommodation.name)+"\n                            ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].accommodations[accommodationIndex])?_c('div',_vm._l((accommodation.discounts),function(discount,index){return _c('div',{key:'discount_' + index,staticClass:"contract-form-discount__item contract-form-discount__accommodation-row"},[_c('div',{staticClass:"contract-form-discount__item-wrapper"},[_c('div',{staticClass:"contract-form-discount__row-item"},[_c('div',{staticClass:"contract-form-discount__row-label"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.discounts.startDate'))+"\n                                            ")]),_vm._v(" "),(discount.discountRulePeriods.length)?[_vm._l((discount.discountRulePeriods),function(period){return [(period.book_from)?_c('div',{staticClass:"contract-form-discount__item-date"},[_vm._v("\n                                                        "+_vm._s(_vm._f("moment")(period.book_from,'DD/MM/YYYY'))+"\n                                                    ")]):_c('div',{staticClass:"contract-form-discount__item-date"},[_vm._v("\n                                                        "+_vm._s(_vm.$t('contract.form.discounts.noDate'))+"\n                                                    ")])]})]:[_c('div',{staticClass:"contract-form-discount__item-date"},[_vm._v("\n                                                    "+_vm._s(_vm.$t('contract.form.discounts.noDate'))+"\n                                                ")])]],2)]),_vm._v(" "),_c('div',{staticClass:"contract-form-discount__item-wrapper"},[_c('div',{staticClass:"contract-form-discount__row-item"},[_c('div',{staticClass:"contract-form-discount__row-label"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.discounts.endDate'))+"\n                                            ")]),_vm._v(" "),(discount.discountRulePeriods.length)?[_vm._l((discount.discountRulePeriods),function(period){return [(period.book_to)?_c('div',{staticClass:"contract-form-discount__item-date"},[_vm._v("\n                                                        "+_vm._s(_vm._f("moment")(period.book_to,'DD/MM/YYYY'))+"\n                                                    ")]):_c('div',{staticClass:"contract-form-discount__item-date"},[_vm._v("\n                                                        "+_vm._s(_vm.$t('contract.form.discounts.noDate'))+"\n                                                    ")])]})]:[_c('div',{staticClass:"contract-form-discount__item-date"},[_vm._v("\n                                                    "+_vm._s(_vm.$t('contract.form.discounts.noDate'))+"\n                                                ")])]],2)]),_vm._v(" "),_c('div',{staticClass:"contract-form-discount__item-wrapper"},[_c('div',{staticClass:"contract-form-discount__row-item",class:{'contract-form-discount__row-item--inactive': !discount.name}},[_c('div',{staticClass:"contract-form-discount__row-label"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.discounts.name'))+"\n                                            ")]),_vm._v(" "),(discount.name)?_c('div',{staticClass:"contract-form-discount__item-date"},[_vm._v("\n                                                "+_vm._s(discount.name)+"\n                                            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"contract-form-discount__item-wrapper"},[_c('div',{staticClass:"contract-form-discount__row-item"},[_c('div',{staticClass:"contract-form-discount__row-label"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.discounts.arrivalDeparture'))+"\n                                            ")]),_vm._v(" "),(discount.discountRulePeriods.length)?[_vm._l((discount.discountRulePeriods),function(period){return [(period.arrival_from && period.arrival_to)?_c('div',{staticClass:"contract-form-discount__item-date"},[_c('span',[_vm._v(_vm._s(_vm._f("moment")(period.arrival_from,'DD/MM/YYYY')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("moment")(period.arrival_to,'DD/MM/YYYY')))])]):_c('div',{staticClass:"contract-form-discount__item-date"},[_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.discounts.noDate')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.discounts.noDate')))])])]})]:_vm._e()],2),_vm._v(" "),(discount.discountDays.length)?_c('div',_vm._l((discount.discountDays),function(discountDay,index){return _c('div',{key:("contract-form-discount-days__" + index)},[(discountDay.arrivalDay)?_c('span',{staticClass:"contract-form-discount__row-item"},[_vm._v("\n                                                    "+_vm._s(_vm.$t(("contract.form.discounts.day." + (discountDay.arrivalDay))))+" -\n                                                ")]):_vm._e(),_vm._v(" "),(discountDay.departureDay)?_c('span',{staticClass:"contract-form-discount__row-item"},[_vm._v("\n                                                    "+_vm._s(_vm.$t(("contract.form.discounts.day." + (discountDay.departureDay))))+"\n                                                ")]):_vm._e()])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-discount__item-wrapper"},[_c('div',{staticClass:"contract-form-discount__row-item",class:{
                                                 'contract-form-discount__row-item--inactive': !discount.types
                                             }},[_c('div',{staticClass:"contract-form-discount__row-label"},[_vm._v("\n                                                "+_vm._s(_vm.$t('contract.form.discounts.types'))+"\n                                            ")]),_vm._v(" "),(discount.types)?_c('div',{staticClass:"contract-form-discount__item-date"},_vm._l((discount.types),function(type,index){return _c('span',{key:'type_' + index},[(type.note)?_c('span',[_c('i',{staticClass:"fa fa-exclamation-triangle"})]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"title":type.note}},[_vm._v(_vm._s(type.type))]),_vm._v(" "),(index < discount.types.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-form-discount__row-label"},[_vm._v("\n                                                "+_vm._s(_vm.$tc('contract.form.discounts.combine', discount.combinable))+"\n                                            ")])])])])}),0):_vm._e()])}),0):_vm._e()])}),0)]),_vm._v(" "),(_vm.sites.length === 0)?_c('div',{staticClass:"contract-form-site__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__no-content-message"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.discounts.noContent'))+"\n            ")])]):_vm._e()])])}
var ContractFormDiscount_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormDiscount/ContractFormDiscount.vue
/* script */


/* template */

/* template functional */
var ContractFormDiscount___vue_template_functional__ = false
/* styles */
var ContractFormDiscount___vue_styles__ = null
/* scopeId */
var ContractFormDiscount___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormDiscount___vue_module_identifier__ = null

var ContractFormDiscount_Component = Object(component_normalizer["a" /* default */])(
  ContractFormDiscount,
  ContractFormDiscount_render,
  ContractFormDiscount_staticRenderFns,
  ContractFormDiscount___vue_template_functional__,
  ContractFormDiscount___vue_styles__,
  ContractFormDiscount___vue_scopeId__,
  ContractFormDiscount___vue_module_identifier__
)

/* harmony default export */ var ContractFormDiscount_ContractFormDiscount = (ContractFormDiscount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormAllocation/ContractFormAllocation.vue
var ContractFormAllocation__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormAllocation = (vue_esm["default"].extend({
    data: function data() {
        return {
            collapseObject: undefined
        };
    },

    computed: ContractFormAllocation__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.contract.contract.item.allocations.sites;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractCollapseObject: 'contract/getContractCollapseObject'
    })),
    created: function created() {
        this.collapseObject = this.getContractCollapseObject;
    },

    methods: {
        collapse: function collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for (var i = 0; i < this.collapseObject[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();
                    }, 10);
                }
            } else {
                for (var _i = 0; _i < this.collapseObject.length; _i++) {
                    this.collapseObject[_i].collapse = !(_i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('site_' + obj.siteIndex).scrollIntoView();
                    }, 10);
                }
            }
            this.$forceUpdate();
        }
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9632ebc4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormAllocation/ContractFormAllocation.vue
var ContractFormAllocation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-allocation"},[_c('div',{staticClass:"contract-form-allocation__content"},[_c('div',{staticClass:"contract-form-allocation__header"},[_c('div',{staticClass:"contract-form-allocation__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.allocations.header.heading'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-allocation__body"},[_c('div',{staticClass:"contract-form-allocation__items"},_vm._l((_vm.sites),function(site,siteIndex){return _c('div',{key:'site_' + siteIndex,staticClass:"contract-form-allocation__item contract-form-allocation__item-site",attrs:{"id":'site_' + siteIndex}},[_c('div',{staticClass:"contract-form-allocation__item-header",class:{'contract-form-allocation__item-header--collapsed': _vm.collapseObject[siteIndex].collapse},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex})}}},[_vm._v("\n                        "+_vm._s(site.name)+"\n                    ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].collapse)?_c('div',_vm._l((site.accommodations),function(accommodation,accommodationIndex){return _c('div',{key:'accommodation_' + accommodationIndex,staticClass:"contract-form-allocation__item contract-form-allocation__item-accommodation",attrs:{"id":'accommodation_' + accommodationIndex}},[_c('div',{staticClass:"contract-form-allocation__item-label",class:{'contract-form-allocation__item-label--collapsed': _vm.collapseObject[siteIndex].accommodations[accommodationIndex]},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})}}},[_vm._v("\n                                "+_vm._s(accommodation.name)+"\n                            ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].accommodations[accommodationIndex])?_c('div',_vm._l((accommodation.periods),function(period,index){return _c('div',{key:'arrival_' + index,staticClass:"contract-form-allocation__item contract-form-allocation__accommodation-row"},[_c('div',{staticClass:"contract-form-allocation__row-item",class:{'contract-form-allocation__row-item--inactive' : !period.startDate}},[_c('div',{staticClass:"contract-form-allocation__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.startDate')))]),_vm._v(" "),(period.startDate)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm._f("moment")(period.startDate,'DD/MM/YYYY')))]):_vm._e(),_vm._v(" "),(!period.startDate)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-allocation__row-item",class:{'contract-form-allocation__row-item--inactive' : !period.endDate}},[_c('div',{staticClass:"contract-form-allocation__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.endDate')))]),_vm._v(" "),(period.endDate)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm._f("moment")(period.endDate,'DD/MM/YYYY')))]):_vm._e(),_vm._v(" "),(!period.endDate)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-allocation__row-item",class:{'contract-form-allocation__row-item--inactive' : !period.type}},[_c('div',{staticClass:"contract-form-allocation__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.type.label')))]),_vm._v(" "),(period.type)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.type.' + period.type)))]):_vm._e(),_vm._v(" "),(!period.type)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-allocation__row-item",class:{'contract-form-allocation__row-item--inactive' : !period.units}},[_c('div',{staticClass:"contract-form-allocation__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.units')))]),_vm._v(" "),(period.units)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(period.units))]):_vm._e(),_vm._v(" "),(!period.units)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-allocation__row-item",class:{'contract-form-allocation__row-item--inactive' : !period.releaseDate}},[_c('div',{staticClass:"contract-form-allocation__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.releaseDate')))]),_vm._v(" "),(period.releaseDate)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm._f("moment")(period.releaseDate,'DD/MM/YYYY')))]):_vm._e(),_vm._v(" "),(!period.releaseDate)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-allocation__row-item",class:{'contract-form-allocation__row-item--inactive' : !period.releaseDays}},[_c('div',{staticClass:"contract-form-allocation__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.releaseDays')))]),_vm._v(" "),(period.releaseDays)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(period.releaseDays))]):_vm._e(),_vm._v(" "),(!period.releaseDays)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noData')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-allocation__row-item",class:{'contract-form-allocation__row-item--inactive' : !period.releaseType}},[_c('div',{staticClass:"contract-form-allocation__row-label"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.releaseType')))]),_vm._v(" "),(period.releaseType)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.type.' + period.releaseType)))]):_vm._e(),_vm._v(" "),(!period.releaseType)?_c('div',{staticClass:"contract-form-allocation__item-data"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noData')))]):_vm._e()])])}),0):_vm._e()])}),0):_vm._e()])}),0)]),_vm._v(" "),(_vm.sites.length === 0)?_c('div',{staticClass:"contract-form-site__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__no-content-message"},[_vm._v(_vm._s(_vm.$t('contract.form.allocations.noContent')))])]):_vm._e()])])}
var ContractFormAllocation_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormAllocation/ContractFormAllocation.vue
/* script */


/* template */

/* template functional */
var ContractFormAllocation___vue_template_functional__ = false
/* styles */
var ContractFormAllocation___vue_styles__ = null
/* scopeId */
var ContractFormAllocation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormAllocation___vue_module_identifier__ = null

var ContractFormAllocation_Component = Object(component_normalizer["a" /* default */])(
  ContractFormAllocation,
  ContractFormAllocation_render,
  ContractFormAllocation_staticRenderFns,
  ContractFormAllocation___vue_template_functional__,
  ContractFormAllocation___vue_styles__,
  ContractFormAllocation___vue_scopeId__,
  ContractFormAllocation___vue_module_identifier__
)

/* harmony default export */ var ContractFormAllocation_ContractFormAllocation = (ContractFormAllocation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormAccommodation/ContractFormAccommodation.vue
var ContractFormAccommodation__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormAccommodation = (vue_esm["default"].extend({
    data: function data() {
        return {
            collapseObject: undefined
        };
    },

    computed: ContractFormAccommodation__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.contract.contract.item.accommodations.sites;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractCollapseObject: 'contract/getContractCollapseObject'
    })),
    created: function created() {
        this.collapseObject = this.getContractCollapseObject;
    },

    methods: {
        collapse: function collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for (var i = 0; i < this.collapseObject[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();
                    }, 10);
                }
            } else {
                for (var _i = 0; _i < this.collapseObject.length; _i++) {
                    this.collapseObject[_i].collapse = !(_i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(function () {
                        document.getElementById('site_' + obj.siteIndex).scrollIntoView();
                    }, 10);
                }
            }
            this.$forceUpdate();
        }
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143ce398","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormAccommodation/ContractFormAccommodation.vue
var ContractFormAccommodation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-accommodation"},[_c('div',{staticClass:"contract-form-accommodation__content"},[_c('div',{staticClass:"contract-form-accommodation__header"},[_c('div',{staticClass:"contract-form-accommodation__heading"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.accommodations.header.heading'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__body"},[_c('div',{staticClass:"contract-form-accommodation__sites"},_vm._l((_vm.sites),function(site,siteIndex){return _c('div',{key:'site_' + siteIndex,staticClass:"contract-form-accommodation__site",attrs:{"id":'site_' + siteIndex}},[_c('div',{staticClass:"contract-form-accommodation__site-header",class:{'contract-form-accommodation__site-header--collapsed': _vm.collapseObject[siteIndex].collapse},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex})}}},[_vm._v("\n                        "+_vm._s(site.name)+"\n                    ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].collapse)?_c('div',{staticClass:"contract-form-accommodation__accommodations"},_vm._l((site.accommodations),function(accommodation,accommodationIndex){return _c('div',{key:'accommodation_' + accommodationIndex,staticClass:"contract-form-accommodation__accommodation",attrs:{"id":'accommodation_' + accommodationIndex}},[_c('div',{staticClass:"contract-form-accommodation__accommodation-header",class:{'contract-form-accommodation__accommodation-header--collapsed': _vm.collapseObject[siteIndex].accommodations[accommodationIndex]},on:{"click":function($event){return _vm.collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})}}},[_vm._v("\n                                "+_vm._s(accommodation.name)+"\n                            ")]),_vm._v(" "),(!_vm.collapseObject[siteIndex].accommodations[accommodationIndex])?_c('div',{staticClass:"contract-form-accommodation__accommodation"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-label",class:{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.category}},[_vm._v("\n                                            "+_vm._s(_vm.$t('contract.form.accommodations.category'))+"\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-data"},[_vm._v(_vm._s(accommodation.category))])]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-label",class:{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.maxPersons}},[_vm._v("\n                                            "+_vm._s(_vm.$t('contract.form.accommodations.maxPersons'))+"\n                                        ")]),_vm._v(" "),(accommodation.maxPersons)?_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-data"},[_vm._v(_vm._s(accommodation.maxPersons))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-label",class:{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.maxAdults}},[_vm._v("\n                                            "+_vm._s(_vm.$t('contract.form.accommodations.maxAdults'))+"\n                                        ")]),_vm._v(" "),(accommodation.maxAdults)?_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-data"},[_vm._v(_vm._s(accommodation.maxAdults))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-label",class:{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.minFullPay}},[_vm._v("\n                                            "+_vm._s(_vm.$t('contract.form.accommodations.minFullPay'))+"\n                                        ")]),_vm._v(" "),(accommodation.minFullPay)?_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-data"},[_vm._v(_vm._s(accommodation.minFullPay))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element",attrs:{"title":_vm.$t('contract.form.accommodations.childrenAgesInfo')}},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-label",class:{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.childrenAges}},[_vm._v("\n                                            "+_vm._s(_vm.$t('contract.form.accommodations.childrenAges'))+"\n                                        ")]),_vm._v(" "),(accommodation.childrenAges)?_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-data"},[_vm._v(_vm._s(accommodation.childrenAges))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element",attrs:{"title":_vm.$t('contract.form.accommodations.childOutsideAllowedInfo')}},[_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-label",class:{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.childOutsideAllowed}},[_vm._v("\n                                            "+_vm._s(_vm.$t('contract.form.accommodations.childOutsideAllowed'))+"\n                                        ")]),_vm._v(" "),(accommodation.childOutsideAllowed)?_c('div',{staticClass:"contract-form-accommodation__accommodation-info-element-data"},[_vm._v(_vm._s(accommodation.childOutsideAllowed))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-images"},_vm._l((accommodation.imagesS3),function(image,imageIndex){return _c('a',{key:'image_' + imageIndex,staticClass:"contract-form-accommodation__accommodation-image-wrapper",attrs:{"href":image,"target":"_blank"}},[_c('img',{staticClass:"contract-form-accommodation__accommodation-image",attrs:{"src":imageIndex,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"contract-form-accommodation__accommodation-image-overlay"},[_vm._v(_vm._s(_vm.$t('contract.form.accommodations.view')))])])}),0),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-sub-groups"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-sub-groups-header"},[_vm._v("\n                                        "+_vm._s(_vm.$t('contract.form.accommodations.subGroups.header'))+"\n                                    ")]),_vm._v(" "),_vm._l((accommodation.subGroups),function(subGroup,subGroupIndex){return _c('div',{key:'facilityGroup_' + subGroupIndex,staticClass:"contract-form-accommodation__accommodation-sub-group"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-sub-group-header"},[_vm._v("\n                                            "+_vm._s(subGroup.name)+"\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-facilities"},_vm._l((subGroup.facilities),function(facility,facilityIndex){return _c('div',{key:'facility_' + facilityIndex,staticClass:"contract-form-accommodation__accommodation-facility"},[_c('div',{staticClass:"contract-form-accommodation__accommodation-facility-label"},[_vm._v(_vm._s(facility.title))]),_vm._v(" "),_c('div',{staticClass:"contract-form-accommodation__accommodation-facility-data"},[_vm._v(_vm._s(facility.value))])])}),0)])})],2)]):_vm._e()])}),0):_vm._e()])}),0)]),_vm._v(" "),(!_vm.sites.length)?_c('div',{staticClass:"contract-form-accommodation__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__no-content-message"},[_vm._v(_vm._s(_vm.$t('contract.form.accommodations.noContent')))])]):_vm._e()])])}
var ContractFormAccommodation_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormAccommodation/ContractFormAccommodation.vue
/* script */


/* template */

/* template functional */
var ContractFormAccommodation___vue_template_functional__ = false
/* styles */
var ContractFormAccommodation___vue_styles__ = null
/* scopeId */
var ContractFormAccommodation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormAccommodation___vue_module_identifier__ = null

var ContractFormAccommodation_Component = Object(component_normalizer["a" /* default */])(
  ContractFormAccommodation,
  ContractFormAccommodation_render,
  ContractFormAccommodation_staticRenderFns,
  ContractFormAccommodation___vue_template_functional__,
  ContractFormAccommodation___vue_styles__,
  ContractFormAccommodation___vue_scopeId__,
  ContractFormAccommodation___vue_module_identifier__
)

/* harmony default export */ var ContractFormAccommodation_ContractFormAccommodation = (ContractFormAccommodation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormSupplierInfo/ContractFormSupplierInfo.vue
var ContractFormSupplierInfo__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormSupplierInfo = (vue_esm["default"].extend({
    computed: ContractFormSupplierInfo__extends({}, Object(vuex_esm["mapState"])({
        bankInfo: function bankInfo(state) {
            return state.contract.contract.item.supplierInfo.bankInfo;
        },
        bookingInfo: function bookingInfo(state) {
            return state.contract.contract.item.supplierInfo.bookingInfo;
        },
        contactInfo: function contactInfo(state) {
            return state.contract.contract.item.supplierInfo.contactInfo;
        }
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1822544d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormSupplierInfo/ContractFormSupplierInfo.vue
var ContractFormSupplierInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-supplier-info"},[_c('div',{staticClass:"contract-form-supplier-info__header"},[_c('div',{staticClass:"contract-form-supplier-info__heading"},[_vm._v("\n            "+_vm._s(_vm.$t('contract.form.accommodations.header.heading'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"contract-form-supplier-info__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('div',{staticClass:"contract-form-supplier-info__container"},[_c('div',{staticClass:"contract-form-supplier-info__content-heading"},[_vm._v("\n                        "+_vm._s(_vm.$t('contract.form.supplierInfo.bookingInfo.heading'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-supplier-info__content contract-form-supplier-info__content--booking"},_vm._l((_vm.bookingInfo),function(info,key){return _c('div',{key:key,staticClass:"contract-form-supplier-info__item contract-form-supplier-info__item--booking"},[_c('div',{staticClass:"contract-form-supplier-info__item-label",class:{'contract-form-supplier-info__item-label--inactive': !info}},[_vm._v("\n                                "+_vm._s(_vm.$t('contract.form.supplierInfo.bookingInfo.' + key))+":\n                            ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-supplier-info__item-value"},[_vm._v("\n                                "+_vm._s(info)+"\n                            ")])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('div',{staticClass:"contract-form-supplier-info__container"},[_c('div',{staticClass:"contract-form-supplier-info__content-heading"},[_vm._v("\n                        "+_vm._s(_vm.$t('contract.form.supplierInfo.contactInfo.heading'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-supplier-info__content"},_vm._l((_vm.contactInfo),function(info,key){return _c('div',{key:key,staticClass:"contract-form-supplier-info__item"},[_c('div',{staticClass:"contract-form-supplier-info__item-label",class:{'contract-form-supplier-info__item-label--inactive': !info}},[_vm._v("\n                                "+_vm._s(_vm.$t('contract.form.supplierInfo.contactInfo.' + key))+":\n                            ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-supplier-info__item-value"},[_vm._v("\n                                "+_vm._s(info)+"\n                            ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('div',{staticClass:"contract-form-supplier-info__container"},[_c('div',{staticClass:"contract-form-supplier-info__content-heading"},[_vm._v("\n                        "+_vm._s(_vm.$t('contract.form.supplierInfo.bankInfo.heading'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-supplier-info__content"},_vm._l((_vm.bankInfo),function(info,key){return _c('div',{key:key,staticClass:"contract-form-supplier-info__item"},[_c('div',{staticClass:"contract-form-supplier-info__item-label",class:{'contract-form-supplier-info__item-label--inactive': !info}},[_vm._v("\n                                "+_vm._s(_vm.$t('contract.form.supplierInfo.bankInfo.' + key))+":\n                            ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-supplier-info__item-value"},[_vm._v("\n                                "+_vm._s(info)+"\n                            ")])])}),0)])])])])])}
var ContractFormSupplierInfo_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormSupplierInfo/ContractFormSupplierInfo.vue
/* script */


/* template */

/* template functional */
var ContractFormSupplierInfo___vue_template_functional__ = false
/* styles */
var ContractFormSupplierInfo___vue_styles__ = null
/* scopeId */
var ContractFormSupplierInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormSupplierInfo___vue_module_identifier__ = null

var ContractFormSupplierInfo_Component = Object(component_normalizer["a" /* default */])(
  ContractFormSupplierInfo,
  ContractFormSupplierInfo_render,
  ContractFormSupplierInfo_staticRenderFns,
  ContractFormSupplierInfo___vue_template_functional__,
  ContractFormSupplierInfo___vue_styles__,
  ContractFormSupplierInfo___vue_scopeId__,
  ContractFormSupplierInfo___vue_module_identifier__
)

/* harmony default export */ var ContractFormSupplierInfo_ContractFormSupplierInfo = (ContractFormSupplierInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormCancellationRules/ContractFormCancellationRules.vue
var ContractFormCancellationRules__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var ContractFormCancellationRules = ({
    computed: ContractFormCancellationRules__extends({}, Object(vuex_esm["mapState"])({
        cancellationRules: function cancellationRules(state) {
            return state.contract.contract.item.cancellationRules.cancellationRules;
        }
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54402466","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormCancellationRules/ContractFormCancellationRules.vue
var ContractFormCancellationRules_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-cancellation-rules"},[_c('div',{staticClass:"contract-form-cancellation-rules__heading"},[_vm._v("\n        "+_vm._s(_vm.$t('contract.form.cancellationRules.heading'))+"\n    ")]),_vm._v(" "),_c('table',{staticClass:"contract-form-cancellation-rules__table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('contract.form.cancellationRules.labels.days')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('contract.form.cancellationRules.labels.percent')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.cancellationRules),function(rule,index){return _c('tr',{key:index},[_c('td',[_c('span',[_vm._v(_vm._s(rule.days))]),_vm._v(" "),(rule.noShow)?_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.cancellationRules.noShow')))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(rule.percent)+"%")])])}),0)])])}
var ContractFormCancellationRules_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormCancellationRules/ContractFormCancellationRules.vue
/* script */


/* template */

/* template functional */
var ContractFormCancellationRules___vue_template_functional__ = false
/* styles */
var ContractFormCancellationRules___vue_styles__ = null
/* scopeId */
var ContractFormCancellationRules___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormCancellationRules___vue_module_identifier__ = null

var ContractFormCancellationRules_Component = Object(component_normalizer["a" /* default */])(
  ContractFormCancellationRules,
  ContractFormCancellationRules_render,
  ContractFormCancellationRules_staticRenderFns,
  ContractFormCancellationRules___vue_template_functional__,
  ContractFormCancellationRules___vue_styles__,
  ContractFormCancellationRules___vue_scopeId__,
  ContractFormCancellationRules___vue_module_identifier__
)

/* harmony default export */ var ContractFormCancellationRules_ContractFormCancellationRules = (ContractFormCancellationRules_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractForm/ContractForm.vue
var ContractForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














/* harmony default export */ var ContractForm = (vue_esm["default"].extend({
    components: {
        ContractFormSite: ContractFormSite_ContractFormSite,
        ContractFormPrice: ContractFormPrice_ContractFormPrice,
        ContractFormTerms: ContractFormTerms_ContractFormTerms,
        ContractFormExtra: ContractFormExtra_ContractFormExtra,
        ContractFormArrival: ContractFormArrival_ContractFormArrival,
        ContractFormDiscount: ContractFormDiscount_ContractFormDiscount,
        ContractFormAllocation: ContractFormAllocation_ContractFormAllocation,
        ContractFormAccommodation: ContractFormAccommodation_ContractFormAccommodation,
        ContractFormSupplierInfo: ContractFormSupplierInfo_ContractFormSupplierInfo,
        ContractFormCancellationRules: ContractFormCancellationRules_ContractFormCancellationRules
    },
    computed: ContractForm__extends({}, Object(vuex_esm["mapState"])({
        history: function history(state) {
            return state.contract.history.items;
        },
        contract: function contract(state) {
            return state.contract.contract.item;
        },
        part: function part(state) {
            return state.contract.contract.part;
        },
        progress: function progress(state) {
            return state.contract.contract.progress.item;
        },
        loading: function loading(state) {
            return state.contract.contract.form.accept.loading;
        }
    }), Object(vuex_esm["mapGetters"])({
        userCanAccept: 'contract/userCanAccept'
    })),
    methods: ContractForm__extends({}, Object(vuex_esm["mapActions"])({
        contractPartAccept: 'contract/contractPartAccept'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3e4f1f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractForm/ContractForm.vue
var ContractForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form"},[_c('div',{staticClass:"contract-form__content"},[(_vm.contract.status === 'initiated')?_c('div',{staticClass:"contract-form__message"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contract-form__message-text"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.message.' + _vm.contract.status))+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-form__form"},[(_vm.part === 'supplierInfo')?_c('contract-form-supplier-info'):_vm._e(),_vm._v(" "),(_vm.part === 'sites')?_c('contract-form-site'):_vm._e(),_vm._v(" "),(_vm.part === 'prices')?_c('contract-form-price'):_vm._e(),_vm._v(" "),(_vm.part === 'extras')?_c('contract-form-extra'):_vm._e(),_vm._v(" "),(_vm.part === 'arrivalRules')?_c('contract-form-arrival'):_vm._e(),_vm._v(" "),(_vm.part === 'cancellationRules')?_c('contract-form-cancellation-rules'):_vm._e(),_vm._v(" "),(_vm.part ==='discounts')?_c('contract-form-discount'):_vm._e(),_vm._v(" "),(_vm.part ==='allocations')?_c('contract-form-allocation'):_vm._e(),_vm._v(" "),(_vm.part === 'accommodations')?_c('contract-form-accommodation'):_vm._e(),_vm._v(" "),(_vm.part === 'terms')?_c('contract-form-terms'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"contract-form__control"},[(_vm.userCanAccept)?_c('button',{staticClass:"contract-form__accept-btn",attrs:{"disabled":_vm.progress[_vm.part]},on:{"click":function($event){return _vm.contractPartAccept(_vm.part)}}},[(!_vm.progress[_vm.part])?_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('contract.form.acceptPart'))+" "+_vm._s(_vm.$t('contract.form.progress.part.' + _vm.part))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.progress[_vm.part])?_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('contract.form.progress.part.' + _vm.part))+" "+_vm._s(_vm.$t('contract.form.partAccepted'))+"\n                ")]):_vm._e()]):_vm._e()])])])}
var ContractForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form__message-icon"},[_c('i',{staticClass:"fa fa-info"})])}]

// CONCATENATED MODULE: ./src/components/ContractForm/ContractForm.vue
/* script */


/* template */

/* template functional */
var ContractForm___vue_template_functional__ = false
/* styles */
var ContractForm___vue_styles__ = null
/* scopeId */
var ContractForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractForm___vue_module_identifier__ = null

var ContractForm_Component = Object(component_normalizer["a" /* default */])(
  ContractForm,
  ContractForm_render,
  ContractForm_staticRenderFns,
  ContractForm___vue_template_functional__,
  ContractForm___vue_styles__,
  ContractForm___vue_scopeId__,
  ContractForm___vue_module_identifier__
)

/* harmony default export */ var ContractForm_ContractForm = (ContractForm_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash-es/lodash.js + 631 modules
var lodash = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractNotes/ContractNotes.vue
var ContractNotes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var ContractNotes = (vue_esm["default"].extend({
    data: function data() {
        return {
            toggled: false,
            maximized: false,
            element: undefined,
            interval: undefined,
            textFocus: false
        };
    },

    computed: ContractNotes__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.contract.contract.note.loading;
        },
        emailLoading: function emailLoading(state) {
            return state.contract.contract.email.loading;
        },
        error: function error(state) {
            return state.contract.contract.note.error;
        },
        noContent: function noContent(state) {
            return state.contract.contract.notes.noContent;
        },
        notes: function notes(state) {
            return state.contract.contract.notes.item;
        },
        user: function user(state) {
            return state.auth.user;
        },
        note: function note(state) {
            return state.contract.contract.note.item;
        },
        part: function part(state) {
            return state.contract.contract.part;
        },
        progress: function progress(state) {
            return state.contract.contract.progress.item;
        },
        contractId: function contractId(state) {
            return state.contract.contract.item.id;
        },
        readyForSupplier: function readyForSupplier(state) {
            return state.contract.contract.item.readyForSupplier;
        }
    })),
    mounted: function mounted() {
        var _this = this;

        this.scrollToBottom();
        // Fetch net notes with 30 second interval
        this.interval = setInterval(function () {
            _this.getContractNotes({ contractId: _this.contractId });
        }, 30000);
    },
    destroyed: function destroyed() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },

    methods: ContractNotes__extends({}, Object(vuex_esm["mapActions"])({
        contractNoteSet: 'contract/contractNoteSet',
        createContractNote: 'contract/createContractNote',
        getContractNotes: 'contract/getContractNotes',
        setContractFormPart: 'contract/setContractFormPart',
        sendContractEmailNotification: 'contract/sendContractEmailNotification'
    }), {
        sendNote: function sendNote() {
            var _this2 = this;

            this.createContractNote().then(function () {
                _this2.scrollToBottom();
                // If the user is a supplier then notify about sending email notification to contract manager
                if (_this2.user && !_this2.user.contractManager) {
                    if (_this2.notes && _this2.notes[_this2.notes.length - 1].writtenBy === _this2.user.id) {
                        if (confirm(_this2.$t('contract.form.notes.sendEmailToContractManager'))) {
                            _this2.sendContractEmailNotification();
                        }
                    }
                }
            });
        },
        scrollToBottom: function scrollToBottom() {
            var element = document.getElementById('contract-notes__messages');
            element.scrollTop = element.scrollHeight;
        },
        getProgressPartByFieldPosition: function getProgressPartByFieldPosition(field) {
            var index = 1;
            var part = '';
            Object(lodash["each"])(this.progress, function (value, key) {
                if (index === field) {
                    part = key;
                }
                ++index;
            });
            return part;
        },
        messageWithinHour: function messageWithinHour(message, previousMessage) {
            var messageDate = this.$moment(message.createdAt);
            var previousMessageDate = this.$moment(previousMessage.createdAt);
            var difference = messageDate.diff(previousMessageDate, 'minutes');
            return difference > 60;
        },
        sendEmail: function sendEmail() {
            if (confirm(this.$t('contractNotes.messages.sendEmail'))) {
                this.sendContractEmailNotification();
            }
        },
        sendTo: function sendTo() {
            if (this.user.contractManager) {
                if (this.readyForSupplier) {
                    return 'contractNotes.messages.supplierEmail';
                } else {
                    return 'contractNotes.messages.backOfficeEmail';
                }
            } else {
                return 'contractNotes.messages.contractManagerEmail';
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2341a981","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractNotes/ContractNotes.vue
var ContractNotes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-notes",class:{'contract-notes--maximized' : _vm.maximized}},[_c('div',{staticClass:"contract-notes__content",class:[
        {'contract-notes__content--toggled' : _vm.toggled},
        {'contract-notes__content--maximized' : _vm.maximized}
    ]},[_c('div',{staticClass:"contract-notes__header"},[_c('span',{staticClass:"contract-notes__heading",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_vm._v("\n                "+_vm._s(_vm.$t('contractNotes.header.heading'))+"\n            ")]),_vm._v(" "),(_vm.notes && _vm.notes[_vm.notes.length - 1].writtenBy !== _vm.user.id)?_c('span',{staticClass:"contract-notes__header-msg",attrs:{"title":_vm.$t('contractNotes.header.messages')}},[_c('i',{staticClass:"fa fa-envelope"})]):_vm._e(),_vm._v(" "),(!_vm.maximized)?_c('span',{staticClass:"contract-notes__header-maximize",on:{"click":function($event){_vm.maximized = true}}},[_c('i',{staticClass:"far fa-window-maximize"})]):_vm._e(),_vm._v(" "),(_vm.maximized)?_c('span',{staticClass:"contract-notes__header-maximize",on:{"click":function($event){_vm.maximized = false}}},[_c('i',{staticClass:"far fa-window-minimize"})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"contract-notes__header-email",attrs:{"title":_vm.$t(_vm.sendTo())}},[(!_vm.emailLoading)?_c('i',{staticClass:"far fa-bell",on:{"click":_vm.sendEmail}}):_vm._e(),_vm._v(" "),(_vm.emailLoading)?_c('i',{staticClass:"fa fa-bell"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"contract-notes__messages",class:{'contract-notes__messages--maximized' : _vm.maximized},attrs:{"id":"contract-notes__messages"}},[(_vm.noContent)?_c('div',{staticClass:"contract-notes__no-content"},[_vm._v("\n                "+_vm._s(_vm.$t('contractNotes.messages.noContent'))+"\n            ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.notes),function(message,index){return _c('div',{key:'message_' + index,staticClass:"contract-notes__message",attrs:{"title":message.internal ? _vm.$t('contractNotes.messages.internal') : ''}},[(index === 0 || _vm.messageWithinHour(message, _vm.notes[index - 1]))?_c('div',{staticClass:"contract-notes__message-date"},[_vm._v("\n                    "+_vm._s(_vm._f("moment")(message.createdAt,'calendar'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-notes__message-content",class:[
                         {'contract-notes__message-content--own' : _vm.user.id === message.writtenBy},
                         {'contract-notes__message-content--internal' : message.internal}
                     ]},[_c('div',{staticClass:"contract-notes__message-author"},[(message.username)?_c('span',[_vm._v("\n                            "+_vm._s(message.username)+"\n                        ")]):_vm._e(),_vm._v(" "),(!message.username && message.supplier)?_c('span',[_vm._v("\n                            "+_vm._s(_vm.$t('contractNotes.messages.supplier'))+"\n                        ")]):_vm._e(),_vm._v(" "),(!message.username && !message.supplier)?_c('span',[_vm._v("\n                            "+_vm._s(_vm.$t('contractNotes.messages.campingVision'))+"\n                        ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(_vm.$t('contractNotes.messages.wrote'))+":\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"contract-notes__message-body"},[_vm._v(_vm._s(message.note))]),_vm._v(" "),_c('div',{staticClass:"contract-notes__message-ref",on:{"click":function($event){_vm.setContractFormPart({part: _vm.getProgressPartByFieldPosition(message.field)})}}},[_vm._v("\n                        "+_vm._s(_vm.$t('contractNotes.messages.goTo'))+"\n                    ")])])])})],2),_vm._v(" "),_c('div',{staticClass:"contract-notes__control"},[(_vm.user.contractManager)?_c('div',{staticClass:"contract-notes__set-internal"},[_c('span',[_vm._v(_vm._s(_vm.$t('contractNotes.control.internal')))]),_vm._v(" "),_c('span',{staticClass:"contract-notes__checkbox",class:{'contract-notes__checkbox--checked' : _vm.note.internal},on:{"click":function($event){return _vm.contractNoteSet({internal: !_vm.note.internal ? 1 : 0})}}})]):_vm._e(),_vm._v(" "),(!_vm.user.contractManager)?_c('div',{staticClass:"contract-notes__spacer"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-notes__reference"},[_c('span',[_vm._v(_vm._s(_vm.$t('contractNotes.control.reference'))+":")]),_vm._v(" "),_c('span',{staticClass:"contract-notes__dropdown"},[_c('select',{on:{"change":function($event){_vm.contractNoteSet({field: parseInt($event.target.value) + 1})}}},_vm._l((_vm.progress),function(value,key,index){return _c('option',{key:'dropdown_' + index,domProps:{"value":index}},[_vm._v("\n                            "+_vm._s(_vm.$t('contract.form.progress.part.' + key))+"\n                        ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"contract-notes__input"},[_c('textarea',{staticClass:"contract-notes__input-field",class:[
                              {'contract-notes__input-field--focus' : _vm.textFocus},
                              {'contract-notes__input-field--maximized-focus' : _vm.textFocus && _vm.maximized}
                          ],attrs:{"placeholder":_vm.$t('contractNotes.control.placeholder'),"rows":"1","cols":"1"},domProps:{"value":_vm.note.note},on:{"focus":function($event){_vm.textFocus = true},"blur":function($event){_vm.textFocus = false},"input":function($event){return _vm.contractNoteSet({note: $event.target.value})}}})]),_vm._v(" "),_c('div',{staticClass:"contract-notes__buttons"},[_c('button',{staticClass:"contract-notes__send-btn",attrs:{"disabled":_vm.loading},on:{"click":_vm.sendNote}},[_c('i',{staticClass:"fa fa-fw fa-paper-plane"})])])])])])}
var ContractNotes_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractNotes/ContractNotes.vue
/* script */


/* template */

/* template functional */
var ContractNotes___vue_template_functional__ = false
/* styles */
var ContractNotes___vue_styles__ = null
/* scopeId */
var ContractNotes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractNotes___vue_module_identifier__ = null

var ContractNotes_Component = Object(component_normalizer["a" /* default */])(
  ContractNotes,
  ContractNotes_render,
  ContractNotes_staticRenderFns,
  ContractNotes___vue_template_functional__,
  ContractNotes___vue_styles__,
  ContractNotes___vue_scopeId__,
  ContractNotes___vue_module_identifier__
)

/* harmony default export */ var ContractNotes_ContractNotes = (ContractNotes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormAlert/ContractFormAlert.vue
var ContractFormAlert__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormAlert = (vue_esm["default"].extend({
    computed: ContractFormAlert__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        },
        contract: function contract(state) {
            return state.contract.contract;
        }
    }), Object(vuex_esm["mapGetters"])({
        contractProgressObject: 'contract/contractProgressObject',
        emailReadyForSupplierSent: 'contract/emailReadyForSupplierSent'
    })),
    methods: ContractFormAlert__extends({}, Object(vuex_esm["mapActions"])({
        contractManagementSendEmailSupplier: 'contract/contractManagementSendEmailSupplier'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b7523c0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormAlert/ContractFormAlert.vue
var ContractFormAlert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-alert"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"contract-form-alert__content"},[(_vm.contract.error && !_vm.contract.productError)?_c('span',{staticClass:"contract-form-alert__error"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.missingContract'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.contract.error && _vm.contract.productError)?_c('span',{staticClass:"contract-form-alert__error"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.unknownProduct'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.contract.item && !_vm.contract.item.supplierExists)?_c('span',{staticClass:"contract-form-alert__error"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.alert'))+"\n            ")]):_vm._e()])])],1)}
var ContractFormAlert_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormAlert/ContractFormAlert.vue
/* script */


/* template */

/* template functional */
var ContractFormAlert___vue_template_functional__ = false
/* styles */
var ContractFormAlert___vue_styles__ = null
/* scopeId */
var ContractFormAlert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormAlert___vue_module_identifier__ = null

var ContractFormAlert_Component = Object(component_normalizer["a" /* default */])(
  ContractFormAlert,
  ContractFormAlert_render,
  ContractFormAlert_staticRenderFns,
  ContractFormAlert___vue_template_functional__,
  ContractFormAlert___vue_styles__,
  ContractFormAlert___vue_scopeId__,
  ContractFormAlert___vue_module_identifier__
)

/* harmony default export */ var ContractFormAlert_ContractFormAlert = (ContractFormAlert_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormEmail/ContractFormEmail.vue
var ContractFormEmail__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormEmail = (vue_esm["default"].extend({
    computed: ContractFormEmail__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        },
        contract: function contract(state) {
            return state.contract.contract.item;
        }
    }), Object(vuex_esm["mapGetters"])({
        contractProgressObject: 'contract/contractProgressObject'
    })),
    methods: ContractFormEmail__extends({}, Object(vuex_esm["mapActions"])({
        contractManagementSendEmailSupplier: 'contract/contractManagementSendEmailSupplier'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e69d366","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormEmail/ContractFormEmail.vue
var ContractFormEmail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-email"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.contractProgressObject.all && _vm.user.contractManager)?_c('div',{staticClass:"contract-form-email__content"},[_c('div',{staticClass:"contract-form-email__left"},[_vm._v(_vm._s(_vm.$t('contract.form.complete')))]),_vm._v(" "),_c('div',{staticClass:"contract-form-email__right"},[(!_vm.contract || !_vm.contract.readyForSupplier)?_c('button',{staticClass:"contract-form-email__btn",on:{"click":_vm.contractManagementSendEmailSupplier}},[_vm._v("\n                    "+_vm._s(_vm.$t('contract.form.email'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.contract && _vm.contract.readyForSupplier)?_c('span',{staticClass:"contract-form-email__text"},[_vm._v("\n                    "+_vm._s(_vm._f("moment")(_vm.contract.readyForSupplier,"DD/MM/Y\, HH:mm"))+"\n                ")]):_vm._e()])]):_vm._e()])],1)}
var ContractFormEmail_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormEmail/ContractFormEmail.vue
/* script */


/* template */

/* template functional */
var ContractFormEmail___vue_template_functional__ = false
/* styles */
var ContractFormEmail___vue_styles__ = null
/* scopeId */
var ContractFormEmail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormEmail___vue_module_identifier__ = null

var ContractFormEmail_Component = Object(component_normalizer["a" /* default */])(
  ContractFormEmail,
  ContractFormEmail_render,
  ContractFormEmail_staticRenderFns,
  ContractFormEmail___vue_template_functional__,
  ContractFormEmail___vue_styles__,
  ContractFormEmail___vue_scopeId__,
  ContractFormEmail___vue_module_identifier__
)

/* harmony default export */ var ContractFormEmail_ContractFormEmail = (ContractFormEmail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormNotes/ContractFormNotes.vue
var ContractFormNotes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormNotes = (vue_esm["default"].extend({
    data: function data() {
        return {
            toggled: false
        };
    },

    computed: ContractFormNotes__extends({}, Object(vuex_esm["mapState"])({
        form: function form(state) {
            return state.contract.contract.form.item;
        },
        contract: function contract(state) {
            return state.contract.contract.item;
        },
        part: function part(state) {
            return state.contract.contract.part;
        }
    })),
    methods: ContractFormNotes__extends({}, Object(vuex_esm["mapActions"])({
        contractNotesSet: 'contract/contractNotesSet'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28201448","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormNotes/ContractFormNotes.vue
var ContractFormNotes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-notes"},[_c('div',{staticClass:"contract-form-notes__content"},[_c('div',{staticClass:"contract-form-notes__body"},[_c('div',{staticClass:"contract-form-notes__toggle",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('div',{staticClass:"contract-form-notes__toggle-icon"},[(_vm.toggled)?_c('span',[_c('i',{staticClass:"fas fa-chevron-down"})]):_vm._e(),_vm._v(" "),(!_vm.toggled)?_c('span',[_c('i',{staticClass:"fas fa-chevron-up"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-form-notes__toggle-label"},[(_vm.form[_vm.part].note)?_c('span',[_c('i',{staticClass:"fa fa-exclamation-circle"})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.notes.toggle')))])])]),_vm._v(" "),(_vm.toggled)?_c('div',{staticClass:"contract-form-notes__input"},[_c('textarea',{staticClass:"contract-form-notes__input-text",attrs:{"placeholder":_vm.$t('contract.form.notes.placeholder'),"name":"notes","cols":"30","rows":"10"},domProps:{"value":_vm.form[_vm.part].note},on:{"input":function($event){return _vm.contractNotesSet($event.target.value)}}})]):_vm._e()])])])}
var ContractFormNotes_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormNotes/ContractFormNotes.vue
/* script */


/* template */

/* template functional */
var ContractFormNotes___vue_template_functional__ = false
/* styles */
var ContractFormNotes___vue_styles__ = null
/* scopeId */
var ContractFormNotes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormNotes___vue_module_identifier__ = null

var ContractFormNotes_Component = Object(component_normalizer["a" /* default */])(
  ContractFormNotes,
  ContractFormNotes_render,
  ContractFormNotes_staticRenderFns,
  ContractFormNotes___vue_template_functional__,
  ContractFormNotes___vue_styles__,
  ContractFormNotes___vue_scopeId__,
  ContractFormNotes___vue_module_identifier__
)

/* harmony default export */ var ContractFormNotes_ContractFormNotes = (ContractFormNotes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormAccept/ContractFormAccept.vue
var ContractFormAccept__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormAccept = (vue_esm["default"].extend({
    computed: ContractFormAccept__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        },
        contract: function contract(state) {
            return state.contract.contract.item;
        }
    }), Object(vuex_esm["mapGetters"])({
        calculateContractProgress: 'contract/calculateContractProgress'
    })),
    methods: ContractFormAccept__extends({}, Object(vuex_esm["mapActions"])({
        acceptContract: 'contract/acceptContract'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02340b96","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormAccept/ContractFormAccept.vue
var ContractFormAccept_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-accept"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.contract.supplierConfirm && _vm.calculateContractProgress === 100 && !_vm.user.contractManager)?_c('div',{staticClass:"contract-form-accept__content"},[_c('div',{staticClass:"contract-form-accept__left"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.accept'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-accept__right"},[_c('button',{staticClass:"contract-form-accept__btn",on:{"click":_vm.acceptContract}},[_vm._v("\n                    "+_vm._s(_vm.$t('contract.form.sendAccept'))+"\n                ")])])]):(_vm.contract.supplierConfirm)?_c('div',{staticClass:"contract-form-accept__content"},[_c('div',{staticClass:"contract-form-accept__left"},[_vm._v("\n                "+_vm._s(_vm.$t('contract.form.accepted'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-accept__right"},[_vm._v("\n                "+_vm._s(_vm._f("moment")(_vm.contract.supplierConfirm,'DD/MM/YYYY'))+"\n            ")])]):_vm._e()])],1)}
var ContractFormAccept_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormAccept/ContractFormAccept.vue
/* script */


/* template */

/* template functional */
var ContractFormAccept___vue_template_functional__ = false
/* styles */
var ContractFormAccept___vue_styles__ = null
/* scopeId */
var ContractFormAccept___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormAccept___vue_module_identifier__ = null

var ContractFormAccept_Component = Object(component_normalizer["a" /* default */])(
  ContractFormAccept,
  ContractFormAccept_render,
  ContractFormAccept_staticRenderFns,
  ContractFormAccept___vue_template_functional__,
  ContractFormAccept___vue_styles__,
  ContractFormAccept___vue_scopeId__,
  ContractFormAccept___vue_module_identifier__
)

/* harmony default export */ var ContractFormAccept_ContractFormAccept = (ContractFormAccept_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractFormProgress/ContractFormProgress.vue
var ContractFormProgress__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractFormProgress = (vue_esm["default"].extend({
    data: function data() {
        return {
            toggled: true
        };
    },

    computed: ContractFormProgress__extends({}, Object(vuex_esm["mapState"])({
        part: function part(state) {
            return state.contract.contract.part;
        },
        progress: function progress(state) {
            return state.contract.contract.progress.item;
        },
        contract: function contract(state) {
            return state.contract.contract.item;
        }
    }), Object(vuex_esm["mapGetters"])({
        calculateContractProgress: 'contract/calculateContractProgress',
        contractProgressObject: 'contract/contractProgressObject'
    })),
    methods: ContractFormProgress__extends({}, Object(vuex_esm["mapActions"])({
        setContractFormPart: 'contract/setContractFormPart'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb7e15f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractFormProgress/ContractFormProgress.vue
var ContractFormProgress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-form-progress"},[_c('div',{staticClass:"contract-form-progress__header",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('div',{staticClass:"contract-form-progress__heading",class:{'contract-form-progress__heading--toggled': _vm.toggled}},[_c('span',[_vm._v(_vm._s(_vm.$t('contract.form.progress.header.heading'))+" ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fa fa-angle-right"}),_vm._v(" "+_vm._s(_vm.calculateContractProgress)+" %")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","type":"in-out"}},[(_vm.toggled)?_c('div',{staticClass:"contract-form-progress__content"},[_c('div',{staticClass:"contract-form-progress__items"},[_c('div',{staticClass:"contract-form-progress__item"},[_c('div',{staticClass:"contract-form-progress__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('contract.form.progress.label'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-progress__item-elements"},_vm._l((_vm.progress),function(item,index){return _c('div',{key:index,staticClass:"contract-form-progress__item-element",on:{"click":function($event){return _vm.setContractFormPart({part: index})}}},[_c('div',{staticClass:"contract-form-progress__item-sub-header"},[_vm._v("\n                                "+_vm._s(_vm.$t('contract.form.progress.part.' + index))+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"contract-form-progress__item-icon",class:[
                                     {'contract-form-progress__item-icon--done': item},
                                     {'contract-form-progress__item-icon--notification': item.note && !item.accepted},
                                     {'contract-form-progress__item-icon--active': _vm.part === index}]},[(item)?_c('span',[_c('i',{staticClass:"fa fa-check-square"})]):_vm._e(),_vm._v(" "),(!item)?_c('span',[_c('i',{staticClass:"fa fa-minus-square"})]):_vm._e()])])}),0)])])]):_vm._e()])],1)}
var ContractFormProgress_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractFormProgress/ContractFormProgress.vue
/* script */


/* template */

/* template functional */
var ContractFormProgress___vue_template_functional__ = false
/* styles */
var ContractFormProgress___vue_styles__ = null
/* scopeId */
var ContractFormProgress___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractFormProgress___vue_module_identifier__ = null

var ContractFormProgress_Component = Object(component_normalizer["a" /* default */])(
  ContractFormProgress,
  ContractFormProgress_render,
  ContractFormProgress_staticRenderFns,
  ContractFormProgress___vue_template_functional__,
  ContractFormProgress___vue_styles__,
  ContractFormProgress___vue_scopeId__,
  ContractFormProgress___vue_module_identifier__
)

/* harmony default export */ var ContractFormProgress_ContractFormProgress = (ContractFormProgress_Component.exports);

// EXTERNAL MODULE: ./src/components/ContractBreadcrumb/ContractBreadcrumb.vue + 2 modules
var ContractBreadcrumb = __webpack_require__(209);

// EXTERNAL MODULE: ./src/components/PreloaderItem/PreloaderItem.vue + 1 modules
var PreloaderItem = __webpack_require__(83);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractDraftPreview/ContractDraftPreview.vue



/* harmony default export */ var ContractDraftPreview = ({
    components: {
        PreloaderItem: PreloaderItem["a" /* default */]
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        accepted: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        previewContract: function previewContract() {
            this.toggled = true;
            this.$emit('previewContractDraft');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f495504","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractDraftPreview/ContractDraftPreview.vue
var ContractDraftPreview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.accepted)?_c('div',{staticClass:"contract-draft-preview"},[_c('div',{staticClass:"contract-draft-preview__button",on:{"click":_vm.previewContract}},[(!_vm.loading && !_vm.error)?_c('span',[_vm._v(_vm._s(_vm.$t('contract.draft.preview')))]):(!_vm.error)?_c('span',[_c('preloader-item',{staticClass:"contract-draft-preview__pre-loader"})],1):_c('span',[_vm._v(_vm._s(_vm.$t('contract.draft.error')))])])]):_vm._e()}
var ContractDraftPreview_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractDraftPreview/ContractDraftPreview.vue
/* script */


/* template */

/* template functional */
var ContractDraftPreview___vue_template_functional__ = false
/* styles */
var ContractDraftPreview___vue_styles__ = null
/* scopeId */
var ContractDraftPreview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractDraftPreview___vue_module_identifier__ = null

var ContractDraftPreview_Component = Object(component_normalizer["a" /* default */])(
  ContractDraftPreview,
  ContractDraftPreview_render,
  ContractDraftPreview_staticRenderFns,
  ContractDraftPreview___vue_template_functional__,
  ContractDraftPreview___vue_styles__,
  ContractDraftPreview___vue_scopeId__,
  ContractDraftPreview___vue_module_identifier__
)

/* harmony default export */ var ContractDraftPreview_ContractDraftPreview = (ContractDraftPreview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractPage/ContractPage.vue
var ContractPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















/* harmony default export */ var ContractPage = (vue_esm["default"].extend({
    components: {
        Alert: Alert["a" /* default */],
        Loading: Loading["a" /* default */],
        InfoWidget: InfoWidget["a" /* default */],
        Instruction: Instruction["a" /* default */],
        ContractForm: ContractForm_ContractForm,
        ContractNotes: ContractNotes_ContractNotes,
        ContractFormAlert: ContractFormAlert_ContractFormAlert,
        ContractFormEmail: ContractFormEmail_ContractFormEmail,
        ContractFormNotes: ContractFormNotes_ContractFormNotes,
        ContractFormAccept: ContractFormAccept_ContractFormAccept,
        ContractFormProgress: ContractFormProgress_ContractFormProgress,
        ContractBreadcrumb: ContractBreadcrumb["a" /* default */],
        ContractDraftPreview: ContractDraftPreview_ContractDraftPreview
    },
    computed: ContractPage__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.contract.contract.loading;
        },
        formLoading: function formLoading(state) {
            return state.contract.contract.form.loading;
        },
        acceptLoading: function acceptLoading(state) {
            return state.contract.contract.finish.loading;
        },
        emailLoading: function emailLoading(state) {
            return state.contract.contractManagement.form.loading;
        },
        draftLoading: function draftLoading(state) {
            return state.contract.draft.loading;
        },
        draftError: function draftError(state) {
            return state.contract.draft.error;
        },
        draft: function draft(state) {
            return state.contract.draft.item;
        },
        user: function user(state) {
            return state.auth.user;
        },
        notes: function notes(state) {
            return state.contract.contract.notes.item;
        },
        contract: function contract(state) {
            return state.contract.contract.item;
        }
    })),
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var supplierId = to.params.supplierId || undefined;
        var contractId = to.params.contractId || undefined;
        if (supplierId && contractId) {
            Promise.all([store_default.a.dispatch('contract/getContractBySupplierId', { supplierId: supplierId, contractId: contractId }), store_default.a.dispatch('contract/getContractNotes', { contractId: contractId }), store_default.a.dispatch('contract/getContractAcceptedParts', { contractId: contractId })]).then(function () {
                next();
            });
        } else {
            next();
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        // If the supplier has written new messages then send notification email when leaving
        if (this.user && !this.user.contractManager && this.notes) {
            if (this.notes && this.notes[this.notes.length - 1].writtenBy === this.user.id) {
                if (confirm(this.$t('contract.form.notes.sendBeforeLeave'))) {
                    this.sendContractEmailNotification().then(function () {
                        next();
                    });
                } else {
                    next();
                }
            }
        } else {
            next();
        }
    },

    methods: ContractPage__extends({}, Object(vuex_esm["mapActions"])({
        sendContractEmailNotification: 'contract/sendContractEmailNotification',
        previewContractDraft: 'contract/previewContractDraft'
    }), {
        previewContract: function previewContract() {
            if (!this.contract) {
                alert('Please reload page');
            } else {
                this.previewContractDraft({
                    supplierId: this.contract.supplierId,
                    contractId: this.contract.id
                });
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a692a38","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractPage/ContractPage.vue
var ContractPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-page"},[_c('div',{staticClass:"contract-page__content"},[(_vm.user && _vm.user.contractManager)?_c('contract-breadcrumb',{attrs:{"contract":_vm.contract}}):_vm._e(),_vm._v(" "),_c('contract-form-alert'),_vm._v(" "),_c('instruction',{attrs:{"page":'contract'}}),_vm._v(" "),_c('contract-draft-preview',{attrs:{"loading":_vm.draftLoading,"error":_vm.draftError,"accepted":!!_vm.contract.supplierConfirm},on:{"previewContractDraft":_vm.previewContract}}),_vm._v(" "),_c('contract-form-progress'),_vm._v(" "),_c('contract-form-accept'),_vm._v(" "),_c('contract-form-email'),_vm._v(" "),_c('contract-form'),_vm._v(" "),_c('contract-notes'),_vm._v(" "),(_vm.loading || _vm.formLoading || _vm.acceptLoading || _vm.emailLoading)?_c('loading'):_vm._e(),_vm._v(" "),_c('alert',{attrs:{"translation-prefix":'contract.alert'}})],1)])}
var ContractPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractPage/ContractPage.vue
/* script */


/* template */

/* template functional */
var ContractPage___vue_template_functional__ = false
/* styles */
var ContractPage___vue_styles__ = null
/* scopeId */
var ContractPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractPage___vue_module_identifier__ = null

var ContractPage_Component = Object(component_normalizer["a" /* default */])(
  ContractPage,
  ContractPage_render,
  ContractPage_staticRenderFns,
  ContractPage___vue_template_functional__,
  ContractPage___vue_styles__,
  ContractPage___vue_scopeId__,
  ContractPage___vue_module_identifier__
)

/* harmony default export */ var ContractPage_ContractPage = __webpack_exports__["default"] = (ContractPage_Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vue-chartjs/es/index.js + 2 modules
var es = __webpack_require__(131);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardAvailabilityGraph/DashboardAvailabilityGraph.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var DashboardAvailabilityGraph = ({
    extends: es["b" /* Pie */],
    props: {
        labels: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            colors: {
                available: '#51BB83',
                request: '#F4A830',
                blocked: '#D95A4B'
            }
        };
    },

    computed: _extends({}, Object(vuex_esm["mapState"])({
        availability: function availability(state) {
            return state.dashboard.availability.items;
        },
        accommodation: function accommodation(state) {
            return state.dashboard.availability.accommodation;
        }
    })),
    watch: {
        accommodation: {
            handler: function handler() {
                this.$data._chart.destroy();
                this.render();
            }
        }
    },
    mounted: function mounted() {
        this.render();
    },

    methods: {
        render: function render() {
            var _this = this;

            this.renderChart({
                labels: this.labels,
                datasets: [{
                    label: 'Availability',
                    backgroundColor: [this.colors.available, this.colors.request, this.colors.blocked],
                    data: this.accommodation ? [this.availability.accommodations[this.accommodation.value].available, this.availability.accommodations[this.accommodation.value].request, this.availability.accommodations[this.accommodation.value].blocked] : [this.availability.available, this.availability.request, this.availability.blocked]
                }]
            }, {
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        label: function label(item, data) {
                            return _this.labels[item.index] + ': ' + data.datasets[item.datasetIndex].data[item.index] + ' %';
                        }
                    } }
            });
        }
    }
});
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/DashboardAvailabilityGraph/DashboardAvailabilityGraph.vue
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  DashboardAvailabilityGraph,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var DashboardAvailabilityGraph_DashboardAvailabilityGraph = (Component.exports);

// EXTERNAL MODULE: ./src/components/KeyValueMenu/KeyValueMenu.vue + 2 modules
var KeyValueMenu = __webpack_require__(99);

// EXTERNAL MODULE: ./src/components/Fake/Fake.vue + 2 modules
var Fake = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardAvailability/DashboardAvailability.vue
var DashboardAvailability__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var DashboardAvailability = (vue_esm["default"].extend({
    components: {
        Fake: Fake["a" /* default */],
        KeyValueMenu: KeyValueMenu["a" /* default */],
        DashboardAvailabilityGraph: DashboardAvailabilityGraph_DashboardAvailabilityGraph
    },
    computed: DashboardAvailability__extends({}, Object(vuex_esm["mapState"])({
        items: function items(state) {
            return state.dashboard.availability.items;
        },
        loading: function loading(state) {
            return state.dashboard.availability.loading;
        },
        accommodation: function accommodation(state) {
            return state.dashboard.availability.accommodation;
        }
    }), Object(vuex_esm["mapGetters"])({
        getAccommodationsKeyValueObject: 'dashboard/getAccommodationsKeyValueObject'
    })),
    methods: DashboardAvailability__extends({}, Object(vuex_esm["mapActions"])({
        availabilityAccommodationSet: 'dashboard/availabilityAccommodationSet'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38453374","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardAvailability/DashboardAvailability.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-availability"},[_c('div',{staticClass:"dashboard-availability__content"},[(!_vm.loading)?_c('div',{staticClass:"dashboard-availability__container"},[_c('div',{staticClass:"dashboard-availability__header"},[_c('div',{staticClass:"dashboard-availability__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t('dashboard.availability.overview'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"dashboard-availability__filters"},[_c('key-value-menu',{attrs:{"label":_vm.$t('dashboard.availability.select'),"value":_vm.accommodation,"undefined-name":_vm.$t('dashboard.availability.all'),"items":_vm.getAccommodationsKeyValueObject,"enable-deselect":true},on:{"input":function($event){return _vm.availabilityAccommodationSet($event)}}})],1)]),_vm._v(" "),(_vm.items)?_c('div',{staticClass:"dashboard-availability__graph"},[_c('dashboard-availability-graph',{attrs:{"labels":[
                        _vm.$t('dashboard.availability.available'),
                        _vm.$t('dashboard.availability.request'),
                        _vm.$t('dashboard.availability.blocked')
                    ],"height":300,"width":280}})],1):_vm._e(),_vm._v(" "),(!_vm.items)?_c('div',{staticClass:"dashboard-availability__no-content"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_c('br'),_vm._v("\n                "+_vm._s(_vm.$t('dashboard.availability.noContent'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard-availability__footer"},[_c('div',{staticClass:"dashboard-availability__footer-text"},[_vm._v("\n                    "+_vm._s(_vm.$t('dashboard.graph.footer'))+"\n                ")])])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":12,"body-cells":4}}):_vm._e()],1)])}
var staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DashboardAvailability/DashboardAvailability.vue
/* script */


/* template */

/* template functional */
var DashboardAvailability___vue_template_functional__ = false
/* styles */
var DashboardAvailability___vue_styles__ = null
/* scopeId */
var DashboardAvailability___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DashboardAvailability___vue_module_identifier__ = null

var DashboardAvailability_Component = Object(component_normalizer["a" /* default */])(
  DashboardAvailability,
  render,
  staticRenderFns,
  DashboardAvailability___vue_template_functional__,
  DashboardAvailability___vue_styles__,
  DashboardAvailability___vue_scopeId__,
  DashboardAvailability___vue_module_identifier__
)

/* harmony default export */ var DashboardAvailability_DashboardAvailability = (DashboardAvailability_Component.exports);

// EXTERNAL MODULE: ./src/components/PaginationControl/PaginationControl.vue + 2 modules
var PaginationControl = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardNotificationsItem/DashboardNotificationsItem.vue

/* harmony default export */ var DashboardNotificationsItem = ({
    props: {
        accommodationSiteId: {
            type: Number,
            required: true
        },
        accommodation: {
            type: String,
            required: true
        },
        site: {
            type: String,
            required: true
        },
        siteId: {
            type: Number,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        from: {
            type: String,
            required: true
        },
        to: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            toggled: false
        };
    },

    methods: {
        add: function add(obj) {
            this.$emit('add', obj);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45078d35","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardNotificationsItem/DashboardNotificationsItem.vue
var DashboardNotificationsItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-notifications-item",class:{'dashboard-notifications-item__control--toggled': _vm.toggled}},[_c('div',{staticClass:"dashboard-notifications-item__header"},[_c('div',{staticClass:"dashboard-notifications-item__label"},[_vm._v("\n            "+_vm._s(_vm.accommodation)+" > "+_vm._s(_vm.site)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-item__control",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('i',{staticClass:"fa fa-fw fa-info"})]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-item__control",on:{"click":function($event){return _vm.add({
            siteId: _vm.siteId,
            accommodationSiteId: _vm.accommodationSiteId,
            from: _vm.from,
            to: _vm.to
        })}}},[_c('i',{staticClass:"fa fa-plus"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"dashboard-notifications-item__content-animation"}},[(_vm.toggled)?_c('div',{staticClass:"dashboard-notifications-item__content"},[_c('div',{staticClass:"dashboard-notifications-item__props"},[_c('div',{staticClass:"dashboard-notifications-item__prop"},[_c('div',{staticClass:"dashboard-notifications-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('dashboard.notifications.list.site'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.site)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-item__prop"},[_c('div',{staticClass:"dashboard-notifications-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('dashboard.notifications.list.status.label'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.$t('dashboard.notifications.list.status.' + _vm.status))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-item__prop"},[_c('div',{staticClass:"dashboard-notifications-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('dashboard.notifications.list.date'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(_vm.from,"DD/MM/YYYY"))+" - "+_vm._s(_vm._f("moment")(_vm.to,"DD/MM/YYYY"))+"\n                    ")])])])]):_vm._e()])],1)}
var DashboardNotificationsItem_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DashboardNotificationsItem/DashboardNotificationsItem.vue
/* script */


/* template */

/* template functional */
var DashboardNotificationsItem___vue_template_functional__ = false
/* styles */
var DashboardNotificationsItem___vue_styles__ = null
/* scopeId */
var DashboardNotificationsItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DashboardNotificationsItem___vue_module_identifier__ = null

var DashboardNotificationsItem_Component = Object(component_normalizer["a" /* default */])(
  DashboardNotificationsItem,
  DashboardNotificationsItem_render,
  DashboardNotificationsItem_staticRenderFns,
  DashboardNotificationsItem___vue_template_functional__,
  DashboardNotificationsItem___vue_styles__,
  DashboardNotificationsItem___vue_scopeId__,
  DashboardNotificationsItem___vue_module_identifier__
)

/* harmony default export */ var DashboardNotificationsItem_DashboardNotificationsItem = (DashboardNotificationsItem_Component.exports);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardNotificationsFilters/DashboardNotificationsFilters.vue
var DashboardNotificationsFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var DashboardNotificationsFilters = ({
    components: {
        DropdownMenu: DropdownMenu["a" /* default */]
    },
    computed: DashboardNotificationsFilters__extends({}, Object(vuex_esm["mapState"])({
        site: function site(state) {
            return state.dashboard.notifications.filters.site;
        },
        limit: function limit(state) {
            return state.dashboard.notifications.limit;
        },
        limits: function limits(state) {
            return state.dashboard.notifications.limits;
        },
        predicate: function predicate(state) {
            return state.dashboard.notifications.filters.predicate;
        },
        predicates: function predicates(state) {
            return state.dashboard.notifications.filters.predicates;
        },
        accommodation: function accommodation(state) {
            return state.dashboard.notifications.filters.accommodation;
        }
    }), Object(vuex_esm["mapGetters"])({
        accommodationNotificationsFilters: 'dashboard/getAccommodationNotificationFilters'
    })),
    methods: DashboardNotificationsFilters__extends({}, Object(vuex_esm["mapActions"])({
        setSelectedFilters: 'dashboard/setSelectedFilters',
        setLimit: 'dashboard/setNotificationLimit'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00fbe915","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardNotificationsFilters/DashboardNotificationsFilters.vue
var DashboardNotificationsFilters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-notifications-filters"},[_c('div',{staticClass:"dashboard-notifications-filters__options"},[_c('div',{staticClass:"dashboard-notifications-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('dashboard.notifications.limit'),"value":_vm.limit,"items":_vm.limits,"searchable":false},on:{"input":function($event){return _vm.setLimit($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('dashboard.notifications.filters.sites.label'),"value":_vm.site,"items":_vm.accommodationNotificationsFilters.sites,"enable-deselect":true,"undefined-value":_vm.$t('dashboard.notifications.filters.sites.all')},on:{"input":function($event){return _vm.setSelectedFilters({site: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('dashboard.notifications.filters.predicate.label'),"value":_vm.predicate,"items":_vm.predicates,"enable-deselect":true,"undefined-value":_vm.$t('dashboard.notifications.filters.predicate.all'),"translation-prefix":'dashboard.notifications.filters.predicate',"searchable":false},on:{"input":function($event){return _vm.setSelectedFilters({predicate: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('dashboard.notifications.filters.accommodations.label'),"value":_vm.accommodation,"items":_vm.accommodationNotificationsFilters.accommodations,"enable-deselect":true,"undefined-value":_vm.$t('dashboard.notifications.filters.accommodations.all')},on:{"input":function($event){return _vm.setSelectedFilters({accommodation: $event})}}})],1)])])}
var DashboardNotificationsFilters_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DashboardNotificationsFilters/DashboardNotificationsFilters.vue
/* script */


/* template */

/* template functional */
var DashboardNotificationsFilters___vue_template_functional__ = false
/* styles */
var DashboardNotificationsFilters___vue_styles__ = null
/* scopeId */
var DashboardNotificationsFilters___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DashboardNotificationsFilters___vue_module_identifier__ = null

var DashboardNotificationsFilters_Component = Object(component_normalizer["a" /* default */])(
  DashboardNotificationsFilters,
  DashboardNotificationsFilters_render,
  DashboardNotificationsFilters_staticRenderFns,
  DashboardNotificationsFilters___vue_template_functional__,
  DashboardNotificationsFilters___vue_styles__,
  DashboardNotificationsFilters___vue_scopeId__,
  DashboardNotificationsFilters___vue_module_identifier__
)

/* harmony default export */ var DashboardNotificationsFilters_DashboardNotificationsFilters = (DashboardNotificationsFilters_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardNotifications/DashboardNotifications.vue
var DashboardNotifications__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var DashboardNotifications = (vue_esm["default"].extend({
    components: {
        Fake: Fake["a" /* default */],
        PaginationControl: PaginationControl["a" /* default */],
        DashboardNotificationsItem: DashboardNotificationsItem_DashboardNotificationsItem,
        DashboardNotificationsFilters: DashboardNotificationsFilters_DashboardNotificationsFilters
    },
    computed: DashboardNotifications__extends({}, Object(vuex_esm["mapState"])({
        page: function page(state) {
            return state.dashboard.notifications.page;
        },
        loading: function loading(state) {
            return state.dashboard.notifications.loading;
        },
        notifications: function notifications(state) {
            return state.dashboard.notifications.items;
        },
        user: function user(state) {
            return state.auth.user;
        }
    }), Object(vuex_esm["mapGetters"])({
        getAccommodationNotificationsFiltered: 'dashboard/getAccommodationNotificationsFiltered',
        accommodationNotificationsFilteredMaxPages: 'dashboard/accommodationNotificationsFilteredMaxPages',
        getAccommodationNotificationsFilteredPaginated: 'dashboard/getAccommodationNotificationsFilteredPaginated'
    })),
    methods: DashboardNotifications__extends({}, Object(vuex_esm["mapActions"])({
        redirect: 'dashboard/redirect',
        dismissNotification: 'dashboard/dismissNotification',
        accommodationNotificationPageIncrement: 'dashboard/accommodationNotificationPageIncrement',
        accommodationNotificationPageDecrement: 'dashboard/accommodationNotificationPageDecrement'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466313d2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardNotifications/DashboardNotifications.vue
var DashboardNotifications_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-notifications"},[_c('div',{staticClass:"dashboard-notifications__content"},[(!_vm.loading)?_c('div',{staticClass:"dashboard-notifications__container"},[_c('div',{staticClass:"dashboard-notifications__header"},[_c('div',{staticClass:"dashboard-notifications__heading"},[(_vm.user.contractManager)?_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('dashboard.notifications.list.header.contractHeading'))+"\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.user.contractManager)?_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('dashboard.notifications.list.header.heading'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"dashboard-notifications__notification-count"},[_vm._v("\n                        "+_vm._s(_vm.$tc('dashboard.notifications.list.header.count', _vm.getAccommodationNotificationsFiltered.length, {count: _vm.getAccommodationNotificationsFiltered.length}))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications__filters"},[_c('dashboard-notifications-filters')],1)]),_vm._v(" "),_c('table',{staticClass:"table dashboard-notifications__table"},[_c('thead',{staticClass:"dashboard-notifications__table-head"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('dashboard.notifications.list.accommodation')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('dashboard.notifications.list.site')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('dashboard.notifications.list.status.label')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('dashboard.notifications.list.date')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),(_vm.notifications)?_c('tbody',_vm._l((_vm.getAccommodationNotificationsFilteredPaginated),function(accommodation,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(accommodation.accommodation))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(accommodation.site))]),_vm._v(" "),_c('td',{staticClass:"dashboard-notifications__status"},[_vm._v("\n                            "+_vm._s(_vm.$t('dashboard.notifications.list.status.' + accommodation.status))+"\n                        ")]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("moment")(accommodation.from,"DD/MM/YYYY"))+" - ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("moment")(accommodation.to,"DD/MM/YYYY")))])]),_vm._v(" "),_c('td',[_c('div',{class:_vm.user.contractManager ? 'dashboard-notifications__link-contract' : 'dashboard-notifications__link',on:{"click":function($event){return _vm.redirect({
                                     siteId: accommodation.siteId,
                                     accommodationSiteId: accommodation.accommodationSiteId,
                                     from: accommodation.from,
                                     to: accommodation.to})}}},[(!_vm.user.contractManager)?_c('span',[_vm._v("\n                                    "+_vm._s(_vm.$t('dashboard.notifications.list.link'))+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.user.contractManager)?_c('span',[_vm._v("\n                                    "+_vm._s(_vm.$t('dashboard.notifications.list.contractLink'))+"\n                                ")]):_vm._e()])])])}),0):_vm._e()]),_vm._v(" "),(!_vm.notifications || _vm.getAccommodationNotificationsFiltered.length === 0)?_c('div',{staticClass:"dashboard-notifications__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__error-message"},[_vm._v("\n                    "+_vm._s(_vm.$t('dashboard.notifications.noContent'))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard-notifications__items"},[_c('div',{staticClass:"dashboard-notifications__items-list"},_vm._l((_vm.getAccommodationNotificationsFiltered),function(accommodation,index){return _c('dashboard-notifications-item',{key:index,attrs:{"accommodation-site-id":accommodation.accommodationSiteId,"accommodation":accommodation.accommodation,"site-id":accommodation.siteId,"site":accommodation.site,"status":accommodation.status,"from":accommodation.from,"to":accommodation.to},on:{"add":function($event){return _vm.redirect($event)}}})}),1)]),_vm._v(" "),(_vm.notifications && _vm.getAccommodationNotificationsFiltered.length > 0)?_c('div',{staticClass:"dashboard-notifications__footer"},[_c('div',{staticClass:"dashboard-notifications__pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.accommodationNotificationsFilteredMaxPages,"current-page":_vm.page},on:{"prev":_vm.accommodationNotificationPageDecrement,"next":_vm.accommodationNotificationPageIncrement}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":12,"body-cells":4}}):_vm._e()],1)])}
var DashboardNotifications_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DashboardNotifications/DashboardNotifications.vue
/* script */


/* template */

/* template functional */
var DashboardNotifications___vue_template_functional__ = false
/* styles */
var DashboardNotifications___vue_styles__ = null
/* scopeId */
var DashboardNotifications___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DashboardNotifications___vue_module_identifier__ = null

var DashboardNotifications_Component = Object(component_normalizer["a" /* default */])(
  DashboardNotifications,
  DashboardNotifications_render,
  DashboardNotifications_staticRenderFns,
  DashboardNotifications___vue_template_functional__,
  DashboardNotifications___vue_styles__,
  DashboardNotifications___vue_scopeId__,
  DashboardNotifications___vue_module_identifier__
)

/* harmony default export */ var DashboardNotifications_DashboardNotifications = (DashboardNotifications_Component.exports);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/Alert/Alert.vue + 2 modules
var Alert = __webpack_require__(66);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(5);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardWelcome/DashboardWelcome.vue
var DashboardWelcome__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var DashboardWelcome = (vue_esm["default"].extend({
    computed: DashboardWelcome__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        },
        tricks: function tricks(state) {
            return state.dashboard.dashboardPage.tricks;
        }
    }), {
        date: {
            get: function get() {
                moment_default.a.locale(this.$locale.current());
                return moment_default()().format('dddd Do MMMM YYYY');
            }
        },
        trick: {
            get: function get() {
                return this.tricks[Math.floor(Math.random() * 2)];
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83580ffa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardWelcome/DashboardWelcome.vue
var DashboardWelcome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-welcome"},[_c('div',{staticClass:"dashboard-welcome__left"},[_c('div',{staticClass:"dashboard-welcome__trick"},[_c('span',[_vm._v(_vm._s(_vm.$t('dashboard.tricks.welcome'))+" "+_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName)+".")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('dashboard.tricks.' + _vm.trick + '.message')))]),_vm._v(" "),_c('span',[_c('router-link',{attrs:{"to":_vm.$t('dashboard.tricks.' + _vm.trick + '.link')}},[_c('span',{staticClass:"navigation-menu__link-text"},[_vm._v(_vm._s(_vm.$t('dashboard.tricks.click')))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"dashboard-welcome__right"},[_c('div',{staticClass:"dashboard-welcome__time"},[_vm._v("\n            "+_vm._s(_vm.date)+"\n        ")])])])}
var DashboardWelcome_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DashboardWelcome/DashboardWelcome.vue
/* script */


/* template */

/* template functional */
var DashboardWelcome___vue_template_functional__ = false
/* styles */
var DashboardWelcome___vue_styles__ = null
/* scopeId */
var DashboardWelcome___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DashboardWelcome___vue_module_identifier__ = null

var DashboardWelcome_Component = Object(component_normalizer["a" /* default */])(
  DashboardWelcome,
  DashboardWelcome_render,
  DashboardWelcome_staticRenderFns,
  DashboardWelcome___vue_template_functional__,
  DashboardWelcome___vue_styles__,
  DashboardWelcome___vue_scopeId__,
  DashboardWelcome___vue_module_identifier__
)

/* harmony default export */ var DashboardWelcome_DashboardWelcome = (DashboardWelcome_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DashboardPage/DashboardPage.vue
var DashboardPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











/* harmony default export */ var DashboardPage = (vue_esm["default"].extend({
    components: {
        Alert: Alert["a" /* default */],
        Loading: Loading["a" /* default */],
        InfoWidget: InfoWidget["a" /* default */],
        DashboardWelcome: DashboardWelcome_DashboardWelcome,
        DashboardAvailability: DashboardAvailability_DashboardAvailability,
        DashboardNotifications: DashboardNotifications_DashboardNotifications
    },
    computed: DashboardPage__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.dashboard.notifications.dismiss.loading;
        },
        notificationsLoading: function notificationsLoading(state) {
            return state.dashboard.notifications.loading;
        },
        availabilityLoading: function availabilityLoading(state) {
            return state.dashboard.availability.loading;
        },
        tips: function tips(state) {
            return state.dashboard.dashboardPage.tips;
        },
        user: function user(state) {
            return state.auth.user;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    watch: {
        supplier: function supplier(_supplier) {
            if (!_supplier.id) {
                return;
            }
            store_default.a.dispatch('dashboard/getAvailabilityBySupplierId', _supplier.id);
            store_default.a.dispatch('dashboard/getAccommodationNotificationsBySupplierId', _supplier.id);
        }
    },
    created: function created() {
        var supplierId = this.supplier.id;
        if (!supplierId) {
            return;
        }
        this.getAvailabilityBySupplierId(supplierId);
        this.getAccommodationNotificationsBySupplierId(supplierId);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        Promise.all([this.$refs.infoWidget.clean()]).then(function () {
            next();
        });
    },
    destroyed: function destroyed() {
        this.resetState();
    },

    methods: DashboardPage__extends({}, Object(vuex_esm["mapActions"])({
        resetState: 'dashboard/resetState',
        getAvailabilityBySupplierId: 'dashboard/getAvailabilityBySupplierId',
        getAccommodationNotificationsBySupplierId: 'dashboard/getAccommodationNotificationsBySupplierId'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee599510","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardPage/DashboardPage.vue
var DashboardPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-page"},[_c('dashboard-welcome'),_vm._v(" "),_c('dashboard-availability'),_vm._v(" "),_c('dashboard-notifications'),_vm._v(" "),(_vm.loading | _vm.notificationsLoading | _vm.availabilityLoading)?_c('loading'):_vm._e(),_vm._v(" "),_c('alert',{attrs:{"translation-prefix":'dashboard.alert'}}),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}})],1)}
var DashboardPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DashboardPage/DashboardPage.vue
/* script */


/* template */

/* template functional */
var DashboardPage___vue_template_functional__ = false
/* styles */
var DashboardPage___vue_styles__ = null
/* scopeId */
var DashboardPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DashboardPage___vue_module_identifier__ = null

var DashboardPage_Component = Object(component_normalizer["a" /* default */])(
  DashboardPage,
  DashboardPage_render,
  DashboardPage_staticRenderFns,
  DashboardPage___vue_template_functional__,
  DashboardPage___vue_styles__,
  DashboardPage___vue_scopeId__,
  DashboardPage___vue_module_identifier__
)

/* harmony default export */ var DashboardPage_DashboardPage = __webpack_exports__["default"] = (DashboardPage_Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// EXTERNAL MODULE: ./src/components/Fake/Fake.vue + 2 modules
var Fake = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AllocationFilters/AllocationFilters.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var AllocationFilters = ({
    components: {
        DropdownMenu: DropdownMenu["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.allocation.filters.sites;
        },
        suppliers: function suppliers(state) {
            return state.allocation.filters.suppliers;
        },
        selected: function selected(state) {
            return state.allocation.filters.selected;
        },
        loading: function loading(state) {
            return state.allocation.list.loading;
        },
        user: function user(state) {
            return state.auth.user;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    }), Object(vuex_esm["mapGetters"])({
        accommodations: 'allocation/accommodations',
        filteredSites: 'allocation/filteredSites'
    })),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        setSelectedFilters: 'allocation/setSelectedFilters'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41472ba0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllocationFilters/AllocationFilters.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allocation-filters"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.loading)?_c('div',{key:'body',staticClass:"allocation-filters__body"},[_c('div',{staticClass:"allocation-filters__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('bookingFilters.site.label'),"value":_vm.selected.site,"items":_vm.filteredSites,"enable-deselect":true,"undefined-value":_vm.$t('bookingFilters.site.all')},on:{"input":function($event){return _vm.setSelectedFilters({site: $event})}}})],1)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"body-rows":1,"body-cells":1}}):_vm._e()],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/AllocationFilters/AllocationFilters.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  AllocationFilters,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var AllocationFilters_AllocationFilters = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./src/components/PaginationControl/PaginationControl.vue + 2 modules
var PaginationControl = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AllocationItem/AllocationItem.vue
var AllocationItem__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var AllocationItem = ({
    props: {
        name: {
            type: String,
            required: true
        },
        supplier: {
            type: String,
            required: true
        },
        site: {
            type: String,
            required: true
        },
        updatedAt: {
            type: String,
            required: true
        },
        updatedBy: {
            type: String,
            required: true
        },
        siteId: {
            type: Number,
            required: true
        },
        accommodationSiteId: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            toggled: false
        };
    },

    computed: AllocationItem__extends({}, Object(vuex_esm["mapState"])({
        user: function user(state) {
            return state.auth.user;
        }
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea0ed33e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllocationItem/AllocationItem.vue
var AllocationItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allocation-item",class:{'allocation-item__control--toggled': _vm.toggled}},[_c('div',{staticClass:"allocation-item__header"},[_c('div',{staticClass:"allocation-item__label"},[_vm._v("\n            "+_vm._s(_vm.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"allocation-item__control",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('i',{staticClass:"fa fa-fw fa-info"})]),_vm._v(" "),_c('router-link',{staticClass:"allocation-item__control",attrs:{"to":{name: 'manageAccommodationAllocation', params: { siteId: _vm.siteId, accommodationSiteId: _vm.accommodationSiteId }},"tag":"div"}},[_c('i',{staticClass:"fa fa-fw fa-angle-right"})])],1),_vm._v(" "),_c('transition',{attrs:{"name":"allocation-item__content-animation"}},[(_vm.toggled)?_c('div',{staticClass:"allocation-item__content"},[_c('div',{staticClass:"allocation-item__props"},[_c('div',{staticClass:"allocation-item__prop"},[_c('div',{staticClass:"allocation-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('allocationItem.site'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"allocation-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.site)+"\n                    ")])]),_vm._v(" "),(_vm.user.contractManager)?_c('div',{staticClass:"allocation-item__prop"},[_c('div',{staticClass:"allocation-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('allocationItem.supplier'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"allocation-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.supplier)+"\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"allocation-item__prop"},[_c('div',{staticClass:"allocation-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('allocationItem.updatedAt'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"allocation-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(_vm.updatedAt,"DD/MM/Y\, HH:mm"))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"allocation-item__prop"},[_c('div',{staticClass:"allocation-item__prop-key"},[_vm._v("\n                        "+_vm._s(_vm.$t('allocationItem.updatedBy'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"allocation-item__prop-value"},[_vm._v("\n                        "+_vm._s(_vm.updatedBy)+"\n                    ")])])])]):_vm._e()])],1)}
var AllocationItem_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AllocationItem/AllocationItem.vue
/* script */


/* template */

/* template functional */
var AllocationItem___vue_template_functional__ = false
/* styles */
var AllocationItem___vue_styles__ = null
/* scopeId */
var AllocationItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AllocationItem___vue_module_identifier__ = null

var AllocationItem_Component = Object(component_normalizer["a" /* default */])(
  AllocationItem,
  AllocationItem_render,
  AllocationItem_staticRenderFns,
  AllocationItem___vue_template_functional__,
  AllocationItem___vue_styles__,
  AllocationItem___vue_scopeId__,
  AllocationItem___vue_module_identifier__
)

/* harmony default export */ var AllocationItem_AllocationItem = (AllocationItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AllocationList/AllocationList.vue
var AllocationList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var AllocationList = (vue_esm["default"].extend({
    components: {
        Fake: Fake["a" /* default */],
        PaginationControl: PaginationControl["a" /* default */],
        DropdownMenu: DropdownMenu["a" /* default */],
        AllocationItem: AllocationItem_AllocationItem
    },
    computed: AllocationList__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.allocation.list.loading;
        },
        noContent: function noContent(state) {
            return state.allocation.list.noContent;
        },
        error: function error(state) {
            return state.allocation.list.error;
        },
        page: function page(state) {
            return state.allocation.list.page;
        },
        limit: function limit(state) {
            return state.allocation.list.limit;
        },
        limitList: function limitList(state) {
            return state.allocation.list.limitList;
        },
        predicate: function predicate(state) {
            return state.allocation.list.predicate;
        },
        predicateList: function predicateList(state) {
            return state.allocation.list.predicateList;
        },
        order: function order(state) {
            return state.allocation.list.order;
        },
        orderList: function orderList(state) {
            return state.allocation.list.orderList;
        },
        navigationMinimized: function navigationMinimized(state) {
            return state.nav.minimized;
        },
        user: function user(state) {
            return state.auth.user;
        }
    }), Object(vuex_esm["mapGetters"])({
        filteredAccommodations: 'allocation/filteredAccommodations',
        filteredAccommodationsPaginated: 'allocation/filteredAccommodationsPaginated',
        filteredAccommodationsMaxPages: 'allocation/filteredAccommodationsMaxPages'
    })),
    methods: AllocationList__extends({}, Object(vuex_esm["mapActions"])({
        incrementPage: 'allocation/incrementPage',
        decrementPage: 'allocation/decrementPage',
        setPredicate: 'allocation/setPredicate',
        setLimit: 'allocation/setLimit',
        setOrder: 'allocation/setOrder',
        setAccommodation: 'allocation/setAccommodation'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b04c8d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllocationList/AllocationList.vue
var AllocationList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allocation-list"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.loading && _vm.filteredAccommodations.length)?_c('div',{key:'body',staticClass:"allocation-list__body"},[_c('div',{staticClass:"allocation-list__header",class:{'allocation-list__header--minimized': !_vm.navigationMinimized}},[_c('div',{staticClass:"allocation-list__heading"},[_vm._v("\n                    "+_vm._s(_vm.$tc('allocationList.heading', _vm.filteredAccommodations.length, {count: _vm.filteredAccommodations.length}))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"allocation-list__option allocation-list__option--pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.filteredAccommodationsMaxPages,"current-page":_vm.page},on:{"prev":_vm.decrementPage,"next":_vm.incrementPage}})],1),_vm._v(" "),_c('div',{staticClass:"allocation-list__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('allocationList.orderBy'),"value":_vm.predicate,"items":_vm.predicateList,"translation-prefix":'allocationList.tableFields'},on:{"input":function($event){return _vm.setPredicate($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"allocation-list__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('allocationList.order'),"value":_vm.order,"items":_vm.orderList,"translation-prefix":'allocationList.orderFields'},on:{"input":function($event){return _vm.setOrder($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"allocation-list__option"},[_c('dropdown-menu',{attrs:{"label":_vm.$t('allocationList.perPage'),"value":_vm.limit,"items":_vm.limitList},on:{"input":function($event){return _vm.setLimit($event)}}})],1)]),_vm._v(" "),_c('table',{staticClass:"allocation-list__table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('allocationList.tableFields.name')))]),_vm._v(" "),(_vm.user.contractManager)?_c('th',[_vm._v("\n                            "+_vm._s(_vm.$t('allocationList.tableFields.supplier'))+"\n                        ")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('allocationList.tableFields.site')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('allocationList.tableFields.updatedAt')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('allocationList.tableFields.updatedBy')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),(!_vm.loading)?_c('tbody',_vm._l((_vm.filteredAccommodationsPaginated),function(allocation){return _c('tr',{key:allocation.accommodationSiteId},[_c('td',[_vm._v(_vm._s(allocation.name))]),_vm._v(" "),(_vm.user.contractManager)?_c('td',[_vm._v(_vm._s(allocation.supplier))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(allocation.site))]),_vm._v(" "),_c('td',[(allocation.updatedAt)?_c('span',[_vm._v("\n                                "+_vm._s(_vm._f("moment")(allocation.updatedAt,"DD/MM/Y\, HH:mm"))+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allocation.userName))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('router-link',{staticClass:"allocation-list__button",attrs:{"to":{name: 'manageAccommodationAllocation', params: { siteId: allocation.siteId, accommodationSiteId: allocation.accommodationSiteId }}}},[(allocation.pendingRequests)?_c('i',{staticClass:"fa fa-exclamation-triangle"}):_vm._e(),_vm._v("\n                                "+_vm._s(_vm.$t('allocationList.button.update'))+"\n                            ")])],1)])}),0):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"allocation-list__items"},[_c('div',{staticClass:"allocation-list__items-list"},_vm._l((_vm.filteredAccommodationsPaginated),function(allocation){return _c('allocation-item',{key:allocation.accommodationSiteId,attrs:{"name":allocation.name,"supplier":allocation.supplier,"updated-at":allocation.updatedAt,"updated-by":allocation.userName,"site-id":allocation.siteId,"accommodation-site-id":allocation.id,"site":allocation.site}})}),1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"allocation-list__footer"},[(!_vm.loading)?_c('div',{staticClass:"allocation-list__pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.filteredAccommodationsMaxPages,"current-page":_vm.page},on:{"prev":_vm.decrementPage,"next":_vm.incrementPage}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.error)?_c('div',{key:'error',staticClass:"allocation-list__error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),_c('div',{staticClass:"allocation-list__error-message"},[_vm._v("\n                "+_vm._s(_vm.$t('allocationList.messages.error'))+"\n            ")])]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.error && (_vm.noContent || !_vm.filteredAccommodations.length))?_c('div',{key:'no-content',staticClass:"allocation-list__error"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "),_c('div',{staticClass:"allocation-list__error-message"},[_vm._v("\n                "+_vm._s(_vm.$t('allocationList.messages.noContent'))+"\n            ")])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":12,"body-cells":4}}):_vm._e()],1)],1)}
var AllocationList_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AllocationList/AllocationList.vue
/* script */


/* template */

/* template functional */
var AllocationList___vue_template_functional__ = false
/* styles */
var AllocationList___vue_styles__ = null
/* scopeId */
var AllocationList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AllocationList___vue_module_identifier__ = null

var AllocationList_Component = Object(component_normalizer["a" /* default */])(
  AllocationList,
  AllocationList_render,
  AllocationList_staticRenderFns,
  AllocationList___vue_template_functional__,
  AllocationList___vue_styles__,
  AllocationList___vue_scopeId__,
  AllocationList___vue_module_identifier__
)

/* harmony default export */ var AllocationList_AllocationList = (AllocationList_Component.exports);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AllocationPage/AllocationPage.vue
var AllocationPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var AllocationPage = ({
    components: {
        AllocationFilters: AllocationFilters_AllocationFilters,
        AllocationList: AllocationList_AllocationList,
        InfoWidget: InfoWidget["a" /* default */]
    },
    computed: AllocationPage__extends({}, Object(vuex_esm["mapState"])({
        tips: function tips(state) {
            return state.allocation.allocationPage.tips;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    watch: {
        supplier: function supplier(_supplier) {
            store_default.a.dispatch('allocation/getAccommodationList', _supplier.id);
        }
    },
    created: function created() {
        this.getAccommodationList(this.supplier.id);
    },

    methods: AllocationPage__extends({}, Object(vuex_esm["mapActions"])({
        getAccommodationList: 'allocation/getAccommodationList',
        getSuppliers: 'nav/getSuppliers'
    })),
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$refs.infoWidget.clean();
        next();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0c19c6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllocationPage/AllocationPage.vue
var AllocationPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allocation-page"},[_c('allocation-filters'),_vm._v(" "),_c('allocation-list'),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}})],1)}
var AllocationPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AllocationPage/AllocationPage.vue
/* script */


/* template */

/* template functional */
var AllocationPage___vue_template_functional__ = false
/* styles */
var AllocationPage___vue_styles__ = null
/* scopeId */
var AllocationPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AllocationPage___vue_module_identifier__ = null

var AllocationPage_Component = Object(component_normalizer["a" /* default */])(
  AllocationPage,
  AllocationPage_render,
  AllocationPage_staticRenderFns,
  AllocationPage___vue_template_functional__,
  AllocationPage___vue_styles__,
  AllocationPage___vue_scopeId__,
  AllocationPage___vue_module_identifier__
)

/* harmony default export */ var AllocationPage_AllocationPage = __webpack_exports__["default"] = (AllocationPage_Component.exports);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/Alert/Alert.vue + 2 modules
var Alert = __webpack_require__(66);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./src/components/Instruction/Instruction.vue + 2 modules
var Instruction = __webpack_require__(208);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/Fake/Fake.vue + 2 modules
var Fake = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractListOverview/ContractListOverview.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var ContractListOverview = (vue_esm["default"].extend({
    components: {
        Loading: Loading["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        downloadLoading: function downloadLoading(state) {
            return state.contract.contract.download.loading;
        },
        history: function history(state) {
            return state.contract.history.items;
        },
        loading: function loading(state) {
            return state.contract.history.loading;
        },
        error: function error(state) {
            return state.contract.history.error;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        downloadContract: 'contract/downloadContract'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2f0016","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractListOverview/ContractListOverview.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-list-overview"},[(!_vm.loading)?_c('div',{staticClass:"contract-list-overview__content"},[_c('div',{staticClass:"contract-list-overview__heading"},[_c('div',{staticClass:"contract-list-overview__header"},[_vm._v("\n                "+_vm._s(_vm.$t('contractList.overview.heading.header'))+"\n            ")])]),_vm._v(" "),(_vm.history)?_c('div',{staticClass:"contract-list-overview__list"},_vm._l((_vm.history),function(item){return _c('div',{key:item.contractId,staticClass:"contract-list-overview__list-items"},[(item.status === 'readyForSupplier')?_c('router-link',{attrs:{"to":{name: 'contract', params: {supplierId: _vm.supplier.id, contractId: item.contractId}}}},[_c('div',{staticClass:"contract-list-overview__list-item"},[_c('div',{staticClass:"contract-list-overview__list-item-year"},[_vm._v(_vm._s(item.year))]),_vm._v(" "),_c('div',{staticClass:"contract-list-overview__list-item-status"},[(item.contractManagerNotes || item.supplierNotes)?_c('span',{staticClass:"contract-list-overview__notes"},[_c('i',{staticClass:"fa fa-exclamation-triangle"})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('contractList.overview.status.' + item.status)))])])])]):_vm._e(),_vm._v(" "),(item.status !== 'readyForSupplier' && item.status !== 'completed')?_c('div',{staticClass:"contract-list-overview__list-item--disabled"},[_c('div',{staticClass:"contract-list-overview__list-item-year"},[_vm._v(_vm._s(item.year))]),_vm._v(" "),_c('div',{staticClass:"contract-list-overview__list-item-status"},[_c('span',[_vm._v(_vm._s(_vm.$t('contractList.overview.status.' + item.status)))])])]):_vm._e(),_vm._v(" "),(item.status === 'completed')?_c('div',{staticClass:"contract-list-overview__list-item",on:{"click":function($event){return _vm.downloadContract(item.contractS3)}}},[_c('div',{staticClass:"contract-list-overview__list-item-year"},[_vm._v(_vm._s(item.year))]),_vm._v(" "),_c('div',{staticClass:"contract-list-overview__list-item-status"},[_c('span',[_vm._v(_vm._s(_vm.$t('contractList.overview.download')))])])]):_vm._e()],1)}),0):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"header-cells":1,"body-rows":10,"body-cells":2}}):_vm._e(),_vm._v(" "),(!_vm.error && !_vm.loading && !_vm.history)?_c('div',{staticClass:"contract-list-overview__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"contract-list-overview__no-content-message"},[_vm._v(_vm._s(_vm.$t('contractList.overview.noContracts')))])]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"contract-list-overview__error"},[_c('i',{staticClass:"fa fa-fw fa-exclamation-triangle"}),_vm._v(" "),_c('div',{staticClass:"contract-list-overview__no-content-message"},[_vm._v(_vm._s(_vm.$t('contractList.overview.error')))])]):_vm._e(),_vm._v(" "),(_vm.downloadLoading)?_c('loading'):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ContractListOverview/ContractListOverview.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ContractListOverview,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ContractListOverview_ContractListOverview = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractListPage/ContractListPage.vue
var ContractListPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










/* harmony default export */ var ContractListPage = (vue_esm["default"].extend({
    components: {
        Alert: Alert["a" /* default */],
        Loading: Loading["a" /* default */],
        InfoWidget: InfoWidget["a" /* default */],
        Instruction: Instruction["a" /* default */],
        ContractListOverview: ContractListOverview_ContractListOverview
    },
    computed: ContractListPage__extends({}, Object(vuex_esm["mapState"])({
        supplier: function supplier(state) {
            return state.auth.supplier;
        }
    })),
    watch: {
        supplier: function supplier(_supplier) {
            store_default.a.dispatch('contract/getContractHistoryBySupplierId', _supplier.id);
        }
    },
    created: function created() {
        var supplierId = this.supplier.id;
        this.getContractHistoryBySupplierId(supplierId);
    },

    methods: ContractListPage__extends({}, Object(vuex_esm["mapActions"])({
        getContractHistoryBySupplierId: 'contract/getContractHistoryBySupplierId'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f81a808","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractListPage/ContractListPage.vue
var ContractListPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-list-page"},[_c('div',{staticClass:"contract-list-page__content"},[_c('instruction',{attrs:{"page":'contractList'}}),_vm._v(" "),_c('contract-list-overview')],1)])}
var ContractListPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractListPage/ContractListPage.vue
/* script */


/* template */

/* template functional */
var ContractListPage___vue_template_functional__ = false
/* styles */
var ContractListPage___vue_styles__ = null
/* scopeId */
var ContractListPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractListPage___vue_module_identifier__ = null

var ContractListPage_Component = Object(component_normalizer["a" /* default */])(
  ContractListPage,
  ContractListPage_render,
  ContractListPage_staticRenderFns,
  ContractListPage___vue_template_functional__,
  ContractListPage___vue_styles__,
  ContractListPage___vue_scopeId__,
  ContractListPage___vue_module_identifier__
)

/* harmony default export */ var ContractListPage_ContractListPage = __webpack_exports__["default"] = (ContractListPage_Component.exports);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/Alert/Alert.vue + 2 modules
var Alert = __webpack_require__(66);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/PaginationControl/PaginationControl.vue + 2 modules
var PaginationControl = __webpack_require__(49);

// EXTERNAL MODULE: ./src/components/DropdownMenu/DropdownMenu.vue + 2 modules
var DropdownMenu = __webpack_require__(19);

// EXTERNAL MODULE: ./src/components/Fake/Fake.vue + 2 modules
var Fake = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationList/ManageAllocationList.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var ManageAllocationList = ({
    components: {
        PaginationControl: PaginationControl["a" /* default */],
        DropdownMenu: DropdownMenu["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.allocation.allocations.loading;
        },
        noContent: function noContent(state) {
            return state.allocation.allocations.noContent;
        },
        error: function error(state) {
            return state.allocation.allocations.error;
        },
        page: function page(state) {
            return state.allocation.allocations.page;
        },
        limitList: function limitList(state) {
            return state.allocation.allocations.limitList;
        },
        limit: function limit(state) {
            return state.allocation.allocations.limit;
        },
        display: function display(state) {
            return state.allocation.list.display;
        },
        displayOptions: function displayOptions(state) {
            return state.allocation.list.displayOptions;
        }
    }), Object(vuex_esm["mapGetters"])({
        filteredAllocationsPaginated: 'allocation/filteredAllocationsPaginated',
        filteredAllocationsMaxPages: 'allocation/filteredAllocationsMaxPages'
    })),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        incrementAllocationPagination: 'allocation/incrementAllocationPagination',
        decrementAllocationPagination: 'allocation/decrementAllocationPagination',
        allocationListOptionSelect: 'allocation/allocationListOptionSelect',
        getAllocationList: 'allocation/getAllocationList',
        setLimit: 'allocation/setAllocationLimit'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62dab97f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationList/ManageAllocationList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-list"},[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.loading)?_c('div',{key:'body',staticClass:"manage-allocation-list__body"},[_c('div',{staticClass:"manage-allocation-list__header"},[_c('div',{staticClass:"manage-allocation-list__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationList.header'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__option manage-allocation-list__option--pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.filteredAllocationsMaxPages,"current-page":_vm.page},on:{"prev":_vm.decrementAllocationPagination,"next":_vm.incrementAllocationPagination}})],1),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__option"},[_c('dropdown-menu',{attrs:{"value":_vm.limit,"items":_vm.limitList,"label":_vm.$t('bookingList.perPage'),"searchable":false},on:{"input":function($event){return _vm.setLimit($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__option"},[_c('dropdown-menu',{attrs:{"value":_vm.display,"items":_vm.displayOptions,"translation-prefix":'bookingList.display',"label":_vm.$t('bookingList.display.label'),"searchable":false},on:{"input":function($event){return _vm.allocationListOptionSelect($event)}}})],1)]),_vm._v(" "),_c('table',{staticClass:"manage-allocation-list__table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.from')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.to')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.units')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.releaseType')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.releaseDays')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.releaseDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.updatedAt')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.updatedBy')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredAllocationsPaginated),function(allocation,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(allocation.from,"DD/MM/YYYY")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(allocation.to,"DD/MM/YYYY")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allocation.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allocation.units))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allocation.releaseType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allocation.releaseDays))]),_vm._v(" "),_c('td',[(allocation.releaseDate)?_c('span',[_vm._v("\n                                "+_vm._s(_vm._f("moment")(allocation.releaseDate,"DD/MM/YYYY"))+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(allocation.updatedAt,"DD/MM/Y\, HH:mm")))]),_vm._v(" "),_c('td',[_c('span',[_vm._v("\n                                "+_vm._s(allocation.userName)+"\n                            ")]),_vm._v(" "),(allocation.comment)?_c('span',[_c('i',{staticClass:"fa fa-fw fa-info",attrs:{"title":allocation.comment}})]):_vm._e()])])}),0)]),_vm._v(" "),(!_vm.loading && !_vm.error && (_vm.noContent || !_vm.filteredAllocationsPaginated.length))?_c('div',{key:'no-content',staticClass:"manage-allocation-list__error"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__error-message"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationList.noAllocations'))+"\n                ")])]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.error)?_c('div',{key:'error',staticClass:"manage-allocation-list__error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__error-message"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationList.error'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__error-retry",on:{"click":_vm.getAllocationList}},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationList.retry'))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-list__footer"},[(!_vm.loading)?_c('div',{staticClass:"manage-allocation-list__pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.filteredAllocationsMaxPages,"current-page":_vm.page},on:{"prev":_vm.decrementAllocationPagination,"next":_vm.incrementAllocationPagination}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":10,"body-cells":4}}):_vm._e()],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ManageAllocationList/ManageAllocationList.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationList,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ManageAllocationList_ManageAllocationList = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__(71);
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// EXTERNAL MODULE: ./src/services/ValidatorService.js
var ValidatorService = __webpack_require__(31);
var ValidatorService_default = /*#__PURE__*/__webpack_require__.n(ValidatorService);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationFormRow/ManageAllocationFromRow.vue
var ManageAllocationFromRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var ManageAllocationFromRow = ({
    props: {
        row: {
            type: Object,
            required: true
        },
        removable: {
            type: Boolean,
            required: true
        }
    },
    computed: ManageAllocationFromRow__extends({}, Object(vuex_esm["mapState"])({
        chosenYear: function chosenYear(state) {
            return state.allocation.allocations.years.current;
        }
    }), {
        fromClasses: function fromClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.from.$dirty && this.$v.row.from.$error,
                'manage-allocation-form-row__input--success': this.$v.row.from.$dirty && !this.$v.row.from.$error
            };
        },
        toClasses: function toClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.to.$dirty && this.$v.row.to.$error,
                'manage-allocation-form-row__input--success': this.$v.row.to.$dirty && !this.$v.row.to.$error
            };
        },
        typeClasses: function typeClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.type.$dirty && this.$v.row.type.$error,
                'manage-allocation-form-row__input--success': this.$v.row.type.$dirty && !this.$v.row.type.$error
            };
        },
        unitClasses: function unitClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.units.$dirty && this.$v.row.units.$error,
                'manage-allocation-form-row__input--success': this.$v.row.units.$dirty && !this.$v.row.units.$error
            };
        },
        releaseTypeClasses: function releaseTypeClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseType.$dirty && this.$v.row.releaseType.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseType.$dirty && !this.$v.row.releaseType.$error
            };
        },
        releaseMethodClasses: function releaseMethodClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseMethod.$dirty && this.$v.row.releaseMethod.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseMethod.$dirty && !this.$v.row.releaseMethod.$error
            };
        },
        releaseDateClasses: function releaseDateClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseDate.$dirty && this.$v.row.releaseDate.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseDate.$dirty && !this.$v.row.releaseDate.$error
            };
        },
        releaseDaysClasses: function releaseDaysClasses() {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseDays.$dirty && this.$v.row.releaseDays.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseDays.$dirty && !this.$v.row.releaseDays.$error
            };
        }
    }),
    methods: {
        update: function update(obj) {
            this.$v.$touch();
            this.$emit('update', ManageAllocationFromRow__extends({}, this.row, obj));
        },
        add: function add() {
            this.$emit('add');
        },
        remove: function remove() {
            if (this.removable) {
                this.$emit('remove');
            }
        },
        duplicate: function duplicate() {
            this.$emit('duplicate', this.row);
        }
    },
    validations: function validations() {
        var _this = this;

        return {
            row: {
                from: {
                    required: validators["required"],
                    validateValidDate: ValidatorService["validateValidDate"],
                    validateWithinYear: function validateWithinYear(date) {
                        return Object(ValidatorService["validateWithinYear"])(date, _this.chosenYear);
                    }
                },
                to: {
                    required: validators["required"],
                    validateDateAfter: ValidatorService["validateDateAfter"],
                    validateValidDate: ValidatorService["validateValidDate"],
                    validateWithinYear: function validateWithinYear(date) {
                        return Object(ValidatorService["validateWithinYear"])(date, _this.chosenYear);
                    }
                },
                type: {
                    required: validators["required"]
                },
                units: {
                    required: Object(validators["requiredIf"])(function (nestedRow) {
                        return nestedRow.type === 'ALLOTMENT';
                    }),
                    validateMinNumber: function validateMinNumber(units, allocation) {
                        if (allocation.type === 'ALLOTMENT') {
                            return Object(ValidatorService["validateMinNumber"])(units);
                        }
                        return true;
                    }
                },
                releaseType: {
                    required: validators["required"]
                },
                releaseMethod: {
                    required: validators["required"]
                },
                releaseDays: {
                    required: Object(validators["requiredIf"])(function (nestedRow) {
                        return nestedRow.releaseMethod === 'days';
                    })
                },
                releaseDate: {
                    validateValidDate: ValidatorService["validateValidDate"],
                    required: Object(validators["requiredIf"])(function (nestedRow) {
                        return nestedRow.releaseMethod === 'date';
                    })
                }
            }
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a9af070","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationFormRow/ManageAllocationFromRow.vue
var ManageAllocationFromRow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-form-row"},[_c('div',{staticClass:"manage-allocation-form-row__fields"},[_c('div',{staticClass:"manage-allocation-form-row__field"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"manage-allocation-form-row__input",class:_vm.fromClasses,attrs:{"placeholder":_vm.$t('manageAllocationFormRow.dateFormat'),"type":"text"},domProps:{"value":_vm.row.from},on:{"input":function($event){return _vm.update({from: $event.target.value})}}})]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__field"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"manage-allocation-form-row__input",class:_vm.toClasses,attrs:{"placeholder":_vm.$t('manageAllocationFormRow.dateFormat'),"type":"text"},domProps:{"value":_vm.row.to},on:{"input":function($event){return _vm.update({to: $event.target.value})}}})]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__field"},[_c('select',{staticClass:"manage-allocation-form-row__dropdown",class:_vm.typeClasses,domProps:{"value":_vm.row.type},on:{"input":function($event){return _vm.update({type: $event.target.value})}}},[_c('option',{attrs:{"value":"ALLOTMENT"}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.allotment')))]),_vm._v(" "),_c('option',{attrs:{"value":"FREESALE"}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.freeSale')))])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__field"},[_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-form-row__input",class:_vm.unitClasses,attrs:{"disabled":_vm.row.type === 'FREESALE' || _vm.row.type === '' || !_vm.row.type,"placeholder":_vm.row.type === 'ALLOTMENT' ? 'No. of units' : 'For allotment only',"type":"text"},domProps:{"value":_vm.row.units},on:{"input":function($event){return _vm.update({units: $event.target.value})}}})]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__field"},[_c('select',{staticClass:"manage-allocation-form-row__dropdown",class:_vm.releaseMethodClasses,domProps:{"value":_vm.row.releaseMethod},on:{"input":function($event){return _vm.update({releaseMethod: $event.target.value})}}},[_c('option',{attrs:{"value":"days"}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.days')))]),_vm._v(" "),_c('option',{attrs:{"value":"date"}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.date')))])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__field"},[(_vm.row.releaseMethod === 'date')?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"manage-allocation-form-row__input",class:_vm.releaseDateClasses,attrs:{"placeholder":_vm.$t('manageAllocationFormRow.dateFormat'),"type":"text"},domProps:{"value":_vm.row.releaseDate},on:{"input":function($event){return _vm.update({releaseDate: $event.target.value, releaseDays: undefined})}}}):_vm._e(),_vm._v(" "),(_vm.row.releaseMethod === 'days')?_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-form-row__input",class:_vm.releaseDaysClasses,attrs:{"placeholder":_vm.$t('manageAllocationFormRow.days'),"type":"text"},domProps:{"value":_vm.row.releaseDays},on:{"input":function($event){return _vm.update({releaseDays: $event.target.value, releaseDate: undefined})}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__field"},[_c('select',{staticClass:"manage-allocation-form-row__dropdown",class:_vm.releaseTypeClasses,domProps:{"value":_vm.row.releaseType},on:{"input":function($event){return _vm.update({releaseType: $event.target.value})}}},[_c('option',{domProps:{"value":undefined}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.selectType')))]),_vm._v(" "),_c('option',{attrs:{"value":"REQUEST"}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.request')))]),_vm._v(" "),_c('option',{attrs:{"value":"FREESALE"}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.freeSale')))]),_vm._v(" "),_c('option',{attrs:{"value":"BLOCKED"}},[_vm._v(_vm._s(_vm.$t('manageAllocationFormRow.dropDown.blocked')))])])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__controls"},[_c('div',{staticClass:"manage-allocation-form-row__button",on:{"click":_vm.add}},[_c('i',{staticClass:"fa fa-fw fa-plus"})]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__button",on:{"click":_vm.duplicate}},[_c('i',{staticClass:"fa fa-fw fa-clone"})]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-row__button",class:{'manage-allocation-form-row__button--disabled': !_vm.removable},on:{"click":_vm.remove}},[_c('i',{staticClass:"fa fa-fw fa-minus"})])])])}
var ManageAllocationFromRow_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationFormRow/ManageAllocationFromRow.vue
/* script */


/* template */

/* template functional */
var ManageAllocationFromRow___vue_template_functional__ = false
/* styles */
var ManageAllocationFromRow___vue_styles__ = null
/* scopeId */
var ManageAllocationFromRow___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationFromRow___vue_module_identifier__ = null

var ManageAllocationFromRow_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationFromRow,
  ManageAllocationFromRow_render,
  ManageAllocationFromRow_staticRenderFns,
  ManageAllocationFromRow___vue_template_functional__,
  ManageAllocationFromRow___vue_styles__,
  ManageAllocationFromRow___vue_scopeId__,
  ManageAllocationFromRow___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationFormRow_ManageAllocationFromRow = (ManageAllocationFromRow_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c489d8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationFormHeader/ManageAllocationFormHeader.vue
var ManageAllocationFormHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-form-header"},[_c('div',{staticClass:"manage-allocation-form-header__fields"},[_c('div',{staticClass:"manage-allocation-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.startDate'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.endDate'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.allocationType'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.numberOfUnits'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.releaseType'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.releaseBy'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.releaseDaysDate'))+"\n        ")])])])}
var ManageAllocationFormHeader_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationFormHeader/ManageAllocationFormHeader.vue
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var ManageAllocationFormHeader___vue_template_functional__ = false
/* styles */
var ManageAllocationFormHeader___vue_styles__ = null
/* scopeId */
var ManageAllocationFormHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationFormHeader___vue_module_identifier__ = null

var ManageAllocationFormHeader_Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  ManageAllocationFormHeader_render,
  ManageAllocationFormHeader_staticRenderFns,
  ManageAllocationFormHeader___vue_template_functional__,
  ManageAllocationFormHeader___vue_styles__,
  ManageAllocationFormHeader___vue_scopeId__,
  ManageAllocationFormHeader___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationFormHeader = (ManageAllocationFormHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationFormAccept/ManageAllocationFormAccept.vue
var ManageAllocationFormAccept__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var ManageAllocationFormAccept = ({
    props: {
        label: {
            type: String,
            required: true
        },
        method: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            comment: ''
        };
    },

    computed: ManageAllocationFormAccept__extends({}, Object(vuex_esm["mapState"])({
        site: function site(state) {
            return state.allocation.form.filters.selected.site.name;
        },
        accommodation: function accommodation(state) {
            return state.allocation.form.filters.selected.accommodation.name;
        },
        submitted: function submitted(state) {
            return state.allocation.form.submit.submitted;
        },
        accepted: function accepted(state) {
            return state.allocation.form.submit.accepted;
        },
        cancelled: function cancelled(state) {
            return state.allocation.form.submit.cancelled;
        },
        alerts: function alerts(state) {
            return state.allocation.form.submit.alerts;
        },
        user: function user(state) {
            return state.auth.user;
        }
    })),
    methods: ManageAllocationFormAccept__extends({}, Object(vuex_esm["mapActions"])({
        cancel: 'allocation/cancelForm',
        addAllocationComment: 'allocation/addAllocationComment'
    }), {
        accept: function accept() {
            if (this.comment !== '') {
                this.addAllocationComment(this.comment);
            }
            this.$emit('accept');
        },
        close: function close($event) {
            this.comment = '';
            if ($event.target.id === 'container') {
                this.cancel();
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481d6fcd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationFormAccept/ManageAllocationFormAccept.vue
var ManageAllocationFormAccept_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-form-accept"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.submitted)?_c('div',{staticClass:"manage-allocation-form-accept__container",attrs:{"id":"container"},on:{"click":function($event){return _vm.close($event)}}},[_c('div',{staticClass:"manage-allocation-form-accept__body"},[_c('div',{staticClass:"manage-allocation-form-accept__header"},[_vm._v("\n                    "+_vm._s(_vm.label)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-accept__content"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationFormAccept.content.start.' + _vm.method))+"\n                    "),_c('strong',[_vm._v(" "+_vm._s(_vm.site))]),_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationFormAccept.content.end'))+"\n                    "),_c('div',{staticClass:"manage-allocation-form-accept__list"},[_c('div',{staticClass:"manage-allocation-form-accept__name"},[_vm._v("\n                            "+_vm._s(_vm.accommodation)+"\n                        ")])]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('manageAllocationFormAccept.content.note'))}}),_vm._v(" "),(_vm.alerts.length > 0)?_c('div',{staticClass:"manage-allocation-form-accept__alert"},[_c('strong',[_vm._v(_vm._s(_vm.$t('manageAllocationFormAccept.alert.start'))+"\n                            "),_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:index,staticClass:"manage-allocation-form-accept__messages"},[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationFormAccept.alert.from'))+"\n                                "+_vm._s(alert.from)+"\n                                "+_vm._s(_vm.$t('manageAllocationFormAccept.alert.to'))+"\n                                "+_vm._s(alert.to)+"\n                            ")])})],2)]):_vm._e(),_vm._v(" "),(_vm.user.contractManager)?_c('div',{staticClass:"manage-allocation-form-accept__comment"},[_c('div',{staticClass:"manage-allocation-form-accept__comment-label"},[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationFormAccept.content.comment'))+"\n                        ")]),_vm._v(" "),_c('textarea',{staticClass:"manage-allocation-form-accept__comment-text",attrs:{"cols":"60","rows":"8"},domProps:{"value":_vm.comment},on:{"input":function($event){_vm.comment = $event.target.value}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form-accept__button-group"},[_c('button',{staticClass:"manage-allocation-form-accept__submit",on:{"click":_vm.accept}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationFormAccept.buttons.accept'))+"\n                    ")]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-form-accept__cancel",on:{"click":_vm.cancel}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationFormAccept.buttons.cancel'))+"\n                    ")])])])]):_vm._e()])],1)}
var ManageAllocationFormAccept_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationFormAccept/ManageAllocationFormAccept.vue
/* script */


/* template */

/* template functional */
var ManageAllocationFormAccept___vue_template_functional__ = false
/* styles */
var ManageAllocationFormAccept___vue_styles__ = null
/* scopeId */
var ManageAllocationFormAccept___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationFormAccept___vue_module_identifier__ = null

var ManageAllocationFormAccept_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationFormAccept,
  ManageAllocationFormAccept_render,
  ManageAllocationFormAccept_staticRenderFns,
  ManageAllocationFormAccept___vue_template_functional__,
  ManageAllocationFormAccept___vue_styles__,
  ManageAllocationFormAccept___vue_scopeId__,
  ManageAllocationFormAccept___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationFormAccept_ManageAllocationFormAccept = (ManageAllocationFormAccept_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationForm/ManageAllocationForm.vue
var ManageAllocationForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var ManageAllocationForm = ({
    components: {
        ManageAllocationFormRow: ManageAllocationFormRow_ManageAllocationFromRow,
        ManageAllocationFormHeader: ManageAllocationFormHeader,
        ManageAllocationFormAccept: ManageAllocationFormAccept_ManageAllocationFormAccept
    },
    computed: ManageAllocationForm__extends({}, Object(vuex_esm["mapState"])({
        rows: function rows(state) {
            return state.allocation.form.rows;
        },
        loading: function loading(state) {
            return state.allocation.form.allocations.loading;
        },
        error: function error(state) {
            return state.allocation.form.allocations.error;
        },
        noContent: function noContent(state) {
            return state.allocation.allocations.noContent;
        },
        accommodation: function accommodation(state) {
            return state.allocation.form.filters.selected.accommodation;
        },
        selected: function selected(state) {
            return state.allocation.form.filters.selected;
        },
        items: function items(state) {
            return state.allocation.allocations.items;
        },
        validator: function validator(state) {
            return state.allocation.form.validator;
        },
        formOpen: function formOpen(state) {
            return state.allocation.form.open;
        }
    }), {
        formClasses: function formClasses() {
            return {
                "manage-allocation-form__heading--open": this.formOpen,
                "manage-allocation-form__heading--closed": !this.formOpen
            };
        }
    }),
    methods: ManageAllocationForm__extends({}, Object(vuex_esm["mapActions"])({
        setRow: 'allocation/setRow',
        addRow: 'allocation/addRow',
        removeRow: 'allocation/removeRow',
        duplicateRow: 'allocation/duplicateRow',
        resetForm: 'allocation/resetForm',
        getAllocationList: 'allocation/getAllocationList',
        addAllocations: 'allocation/addAllocations',
        validateInputs: 'allocation/validateAddAllocationInputs',
        submit: 'allocation/submitForm',
        toggleForm: 'allocation/toggleAddAllocationForm'
    }), {
        submitForm: function submitForm() {
            this.validateInputs();
            // If input fields are invalid then its not possible to submit
            if (!this.validator.error) {
                var accommodationSiteId = this.selected.accommodation.accommodationSiteId;
                var oldDates = [];
                var newDates = this.rows;
                if (accommodationSiteId) {
                    // If accommodation has allocations then fetch those or just an empty array.
                    oldDates = this.items ? this.items[accommodationSiteId] : [];
                }
                var overlapping = ValidatorService["validateAddAllocationPeriod"](newDates, oldDates);
                this.submit(overlapping);
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69454ee3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationForm/ManageAllocationForm.vue
var ManageAllocationForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-form"},[_c('manage-allocation-form-accept',{attrs:{"label":'Adding allocations',"method":'add'},on:{"accept":_vm.addAllocations}}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form__heading",class:_vm.formClasses,on:{"click":_vm.toggleForm}},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationForm.heading'))+"\n    ")]),_vm._v(" "),(_vm.formOpen)?_c('div',{staticClass:"manage-allocatino-form__content"},[(_vm.validator.error)?_c('div',{staticClass:"manage-allocation-form__error"},_vm._l((_vm.validator.messages),function(message){return _c('p',{key:message},[_vm._v(_vm._s(message))])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form__header"},[_c('manage-allocation-form-header')],1),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form__body"},_vm._l((_vm.rows),function(row,index){return _c('manage-allocation-form-row',{key:index,attrs:{"removable":_vm.rows.length > 1,"row":row},on:{"update":function($event){return _vm.setRow({data: $event, index: index})},"add":function($event){return _vm.addRow(index)},"remove":function($event){return _vm.removeRow(index)},"duplicate":function($event){return _vm.duplicateRow({data: $event, index: index})}}})}),1),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form__controls"},[_c('div',{staticClass:"manage-allocation-form__control-buttons"},[_c('button',{staticClass:"manage-allocation-form__submit",attrs:{"disabled":_vm.loading},on:{"click":_vm.submitForm}},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationForm.buttons.submit'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-form__reset",attrs:{"disabled":_vm.loading},on:{"click":_vm.resetForm}},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationForm.buttons.reset'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-form__control-message"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('manageAllocationForm.control-message.content'))}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.selected.site.name))]),_vm._v(" "),(_vm.selected.accommodation)?_c('span',[_vm._v(_vm._s(_vm.$t('manageAllocationForm.control-message.on')))]):_vm._e(),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.selected.accommodation.name))])])])])]):_vm._e()],1)}
var ManageAllocationForm_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationForm/ManageAllocationForm.vue
/* script */


/* template */

/* template functional */
var ManageAllocationForm___vue_template_functional__ = false
/* styles */
var ManageAllocationForm___vue_styles__ = null
/* scopeId */
var ManageAllocationForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationForm___vue_module_identifier__ = null

var ManageAllocationForm_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationForm,
  ManageAllocationForm_render,
  ManageAllocationForm_staticRenderFns,
  ManageAllocationForm___vue_template_functional__,
  ManageAllocationForm___vue_styles__,
  ManageAllocationForm___vue_scopeId__,
  ManageAllocationForm___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationForm_ManageAllocationForm = (ManageAllocationForm_Component.exports);

// EXTERNAL MODULE: ./src/components/KeyValueMenu/KeyValueMenu.vue + 2 modules
var KeyValueMenu = __webpack_require__(99);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationFilters/ManageAllocationFilters.vue
var ManageAllocationFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var ManageAllocationFilters = ({
    components: {
        KeyValueMenu: KeyValueMenu["a" /* default */],
        DropDownMenu: DropdownMenu["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    data: function data() {
        return {
            selectedSite: undefined,
            selectedAccommodation: undefined
        };
    },

    computed: ManageAllocationFilters__extends({}, Object(vuex_esm["mapState"])({
        sites: function sites(state) {
            return state.allocation.form.filters.sites;
        },
        loading: function loading(state) {
            return state.allocation.form.filters.loading;
        },
        error: function error(state) {
            return state.allocation.form.filters.error;
        },
        selected: function selected(state) {
            return state.allocation.form.filters.selected;
        },
        years: function years(state) {
            return state.allocation.allocations.years.years;
        },
        currentYear: function currentYear(state) {
            return state.allocation.allocations.years.current;
        }
    }), Object(vuex_esm["mapGetters"])({
        routeSiteNames: 'allocation/routeSiteNames',
        routeAccommodationNames: 'allocation/routeAccommodationNames'
    })),
    methods: ManageAllocationFilters__extends({}, Object(vuex_esm["mapActions"])({
        setSelectedRouteFilters: 'allocation/setSelectedRouteFilters',
        updateYear: 'allocation/updateYear'
    }), {
        updateRoute: function updateRoute(obj) {
            var _this = this;

            this.setSelectedRouteFilters(obj).then(function () {
                // If setting the site parameter then set accommodations to all
                if (obj.hasOwnProperty('site')) {
                    _this.setSelectedRouteFilters({ site: obj.site, accommodation: undefined });
                } else {
                    _this.$router.push('/dashboard/allocation-management/' + _this.selected.site.id + '/' + obj.accommodation.accommodationSiteId);
                }
            });
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659e2084","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationFilters/ManageAllocationFilters.vue
var ManageAllocationFilters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-filters"},[(!_vm.loading)?_c('div',{staticClass:"manage-allocation-filters__body"},[_c('div',{staticClass:"manage-allocation-filters__option"},[_c('key-value-menu',{attrs:{"label":'Site',"value":_vm.selected.site,"items":_vm.routeSiteNames},on:{"input":function($event){return _vm.updateRoute({site: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"manage-allocation-filters__option"},[_c('key-value-menu',{key:'allocations-filters-accommodation-' + _vm.routeAccommodationNames,attrs:{"label":'Accommodation',"value":_vm.selected.accommodation,"items":_vm.routeAccommodationNames,"disabled":_vm.loading},on:{"input":function($event){return _vm.updateRoute({accommodation: $event})}}})],1),_vm._v(" "),_c('div',{staticClass:"manage-allocation-filters__option"},[_c('drop-down-menu',{attrs:{"label":_vm.$t('manageAllocationFilters.year'),"value":_vm.currentYear,"items":_vm.years,"searchable":false},on:{"input":function($event){return _vm.updateYear($event)}}})],1)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"body-rows":1,"body-cells":4}}):_vm._e()],1)}
var ManageAllocationFilters_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationFilters/ManageAllocationFilters.vue
/* script */


/* template */

/* template functional */
var ManageAllocationFilters___vue_template_functional__ = false
/* styles */
var ManageAllocationFilters___vue_styles__ = null
/* scopeId */
var ManageAllocationFilters___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationFilters___vue_module_identifier__ = null

var ManageAllocationFilters_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationFilters,
  ManageAllocationFilters_render,
  ManageAllocationFilters_staticRenderFns,
  ManageAllocationFilters___vue_template_functional__,
  ManageAllocationFilters___vue_styles__,
  ManageAllocationFilters___vue_scopeId__,
  ManageAllocationFilters___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationFilters_ManageAllocationFilters = (ManageAllocationFilters_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(5);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/lodash-es/lodash.js + 631 modules
var lodash = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationCalendarElement/ManageAllocationCalendarElement.vue
var ManageAllocationCalendarElement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var ManageAllocationCalendarElement = ({
    filters: {
        displayUnits: function displayUnits(units, allocationType) {
            if (allocationType === 'ALLOTMENT') {
                return units;
            } else if (allocationType === 'BLOCKED') {
                return '-';
            } else if (allocationType === 'FREESALE' || allocationType === 'REQUEST') {
                return '∞';
            } else if (allocationType === 'NULL') {
                return '';
            }
            return null;
        }
    },
    props: {
        allocationType: {
            type: String,
            default: 'NULL'
        },
        units: {
            type: Number,
            default: 0
        },
        date: {
            type: Object,
            default: undefined
        },
        tooltip: {
            type: Object,
            default: undefined
        },
        index: {
            type: Number,
            default: undefined
        },
        arrival: {
            type: Boolean,
            default: false
        },
        past: {
            type: Boolean,
            default: false
        },
        current: {
            type: Boolean,
            default: false
        },
        request: {
            type: Object,
            default: undefined
        }
    },
    data: function data() {
        return {
            showTooltip: false
        };
    },

    computed: ManageAllocationCalendarElement__extends({}, Object(vuex_esm["mapState"])({
        startIndex: function startIndex(state) {
            return state.allocation.calendar.startIndex;
        },
        modalOpen: function modalOpen(state) {
            return state.allocation.modal.open;
        },
        indices: function indices(state) {
            return state.allocation.request.indices;
        }
    }), {
        suffix: function suffix() {
            if (!this.date) return "";
            var dateElement = moment_default()(this.date).format('D');
            var rootDate = parseInt(dateElement) % 10;
            switch (rootDate) {
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }
    }),
    created: function created() {
        window.addEventListener('click', this.deselect);
    },

    methods: ManageAllocationCalendarElement__extends({}, Object(vuex_esm["mapActions"])({
        selectDate: 'allocation/selectCalendarDate',
        deselectCalendarDate: 'allocation/deselectCalendarDate'
    }), {
        deselect: function deselect($event) {
            // Set root element
            var element = this.getRootElement($event.target);
            if (!this.modalOpen && this.startIndex && !element.classList.contains('manage-allocation-calendar-element')) {
                this.deselectCalendarDate();
                this.resetCalendar();
            }
        },
        select: function select($event, date) {
            var element = this.getRootElement($event.target);
            // Check if date is in the past
            if (!this.isPast(element)) {
                // Check if the choosen date is the from date or after the or equal the from date
                if (this.isAfterStartDate(element)) {
                    // If pressing the start date the from date and index will be reset in action
                    this.selectDate({ day: date.format('DD/MM/YYYY'), index: this.index });
                    // Toggle select
                    this.toggleSelect(element);
                    // If the modal is opened then remove the selected class for all elements
                    if (this.modalOpen) {
                        this.resetCalendar();
                    }
                }
            }
        },
        hover: function hover($event) {
            // Display tooltip
            this.showTooltip = true;
            // If start date is set then select all dates within start and end index
            if (this.startIndex !== undefined) {
                var element = this.getRootElement($event.target);
                // Get all the allocation calendar elements
                var elements = document.getElementsByClassName('manage-allocation-calendar-element');
                this.toggleHover(elements, element.id);
            }
        },
        isPast: function isPast(element) {
            return element.classList.contains('PAST');
        },
        isAfterStartDate: function isAfterStartDate(element) {
            // If startIndex is set then validate index is after.
            if (this.startIndex === undefined) return true;
            return parseInt(element.id) >= parseInt(this.startIndex);
        },
        getRootElement: function getRootElement(target) {
            var element = target;
            // Get parent element
            while (element && element.classList.length === 1) {
                element = element.parentNode;
            }
            return element;
        },
        toggleSelect: function toggleSelect(element) {
            // Toggle the selected class
            if (element.classList.contains('selected')) {
                element.classList.remove('selected');
            } else {
                element.classList.add('selected');
            }
        },
        toggleHover: function toggleHover(elements, endIndex) {
            var _this = this;

            Object(lodash["filter"])(elements, function (element) {
                if (parseInt(element.id) > parseInt(_this.startIndex) && parseInt(element.id) < parseInt(endIndex)) {
                    if (!element.classList.contains('selected')) {
                        _this.toggleSelect(element);
                    }
                } else {
                    if (parseInt(element.id) !== parseInt(_this.startIndex) && element.classList.contains('selected')) {
                        _this.toggleSelect(element);
                    }
                }
            });
        },
        resetCalendar: function resetCalendar() {
            var _this2 = this;

            var elements = document.getElementsByClassName('manage-allocation-calendar-element');
            Object(lodash["filter"])(elements, function (element) {
                if (element.classList.contains('selected')) {
                    _this2.toggleSelect(element);
                }
            });
        },
        hideTooltip: function hideTooltip() {
            this.showTooltip = false;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ec0398","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationCalendarElement/ManageAllocationCalendarElement.vue
var ManageAllocationCalendarElement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allocationType)?_c('div',{class:['manage-allocation-calendar-element',
              (_vm.past) ? 'manage-allocation-calendar-element-PAST' : null,
              'manage-allocation-calendar-element-' + _vm.allocationType,
              (_vm.indices.indexOf(_vm.index) !== -1) ? 'manage-allocation-calendar-element-edit' : null,
              (_vm.request && _vm.request.requested) ? 'manage-allocation-calendar-element-request' : null,
              (_vm.arrival) ? 'manage-allocation-calendar-element-arrival-day' : null,
              (_vm.current) ? 'manage-allocation-calendar-element-current-day' : null,
              (_vm.allocationType === 'ALLOTMENT' && _vm.units === 0) ? 'manage-allocation-calendar-element-sold-out' : null],attrs:{"id":_vm.index},on:{"click":function($event){return _vm.select($event, _vm.date)},"mouseover":_vm.hover,"mouseleave":_vm.hideTooltip}},[(_vm.date !== undefined)?_c('div',{staticClass:"manage-allocation-calendar-element__day"},[_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.date,'D')))]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-calendar-element__day--postfix"},[_vm._v(_vm._s(_vm.suffix))])]):_vm._e(),_vm._v(" "),(_vm.date === undefined)?_c('div',{staticClass:"manage-allocation-calendar-element__day"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar-element__units"},[_vm._v("\n        "+_vm._s(_vm._f("displayUnits")(_vm.units,_vm.allocationType))+"\n    ")]),_vm._v(" "),(_vm.showTooltip && _vm.request && _vm.request.requested && !_vm.startIndex)?_c('div',{staticClass:"manage-allocation-calendar-element__tooltip"},[_c('div',{staticClass:"manage-allocation-calendar-element__tooltip-content"},[_c('div',{},[_vm._v(_vm._s(_vm.$t('manageAllocationModalCalendarElement.request.header').toUpperCase()))]),_vm._v(" "),(_vm.request.units)?_c('div',{},[_c('span',[_vm._v(_vm._s(_vm.$t('manageAllocationModalCalendarElement.request.deduct'))+" ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.request.units)+" ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('manageAllocationModalCalendarElement.request.units')))])]):_vm._e(),_vm._v(" "),(_vm.request.releaseDate || _vm.request.releaseDays)?_c('div',{},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModalCalendarElement.request.release'))+"\n                ")]),_vm._v(" "),(_vm.request.releaseDate)?_c('span',[_vm._v("\n                    "+_vm._s(_vm._f("moment")(_vm.request.releaseDate,"DD/MM/YYYY"))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.request.releaseDays)?_c('span',[_vm._v("\n                    "+_vm._s(_vm.request.releaseDays)+" "+_vm._s(_vm.$t('manageAllocationModalCalendarElement.request.days'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.request.type)?_c('div',{},[_vm._v(_vm._s(_vm.$t('manageAllocationModalCalendarElement.request.type'))+" "+_vm._s(_vm.request.type))]):_vm._e()])]):_vm._e()]):_vm._e()}
var ManageAllocationCalendarElement_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationCalendarElement/ManageAllocationCalendarElement.vue
/* script */


/* template */

/* template functional */
var ManageAllocationCalendarElement___vue_template_functional__ = false
/* styles */
var ManageAllocationCalendarElement___vue_styles__ = null
/* scopeId */
var ManageAllocationCalendarElement___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationCalendarElement___vue_module_identifier__ = null

var ManageAllocationCalendarElement_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationCalendarElement,
  ManageAllocationCalendarElement_render,
  ManageAllocationCalendarElement_staticRenderFns,
  ManageAllocationCalendarElement___vue_template_functional__,
  ManageAllocationCalendarElement___vue_styles__,
  ManageAllocationCalendarElement___vue_scopeId__,
  ManageAllocationCalendarElement___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationCalendarElement_ManageAllocationCalendarElement = (ManageAllocationCalendarElement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationCalendarInfoboxPages/ManageAllocationCalendarInfoboxPages.vue
var ManageAllocationCalendarInfoboxPages__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var ManageAllocationCalendarInfoboxPages = ({
    components: {
        CalendarElement: ManageAllocationCalendarElement_ManageAllocationCalendarElement
    },
    computed: ManageAllocationCalendarInfoboxPages__extends({}, Object(vuex_esm["mapState"])({
        infoPage: function infoPage(state) {
            return state.allocation.calendar.infoPage;
        }
    }), {
        defaultDate: {
            get: function get() {
                return moment_default()().startOf('day');
            }
        }
    }),
    methods: ManageAllocationCalendarInfoboxPages__extends({}, Object(vuex_esm["mapActions"])({
        infoPageSet: 'allocation/infoPageSet'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d665f6a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationCalendarInfoboxPages/ManageAllocationCalendarInfoboxPages.vue
var ManageAllocationCalendarInfoboxPages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-in"}},[_c('div',{key:2,staticClass:"manage-allocation-calendar-infobox-pages"},[_c('div',{staticClass:"manage-allocation-calendar-infobox-pages__body"},[(_vm.infoPage === 1)?_c('div',{staticClass:"manage-allocation-calendar-infobox-pages__page"},[_c('div',{staticClass:"manage-allocation-calendar-infobox-pages__content"},[_c('div',{attrs:{"id":"img-1"}},[_c('img',{attrs:{"src":__webpack_require__(488),"height":"450","width":"240"}})]),_vm._v(" "),_c('div',{attrs:{"id":"img-2"}},[_c('img',{attrs:{"src":__webpack_require__(489),"height":"450","width":"240"}})]),_vm._v(" "),_c('div',{attrs:{"id":"img-3"}},[_c('img',{attrs:{"src":__webpack_require__(490),"height":"450","width":"240"}})])])]):_vm._e(),_vm._v(" "),(_vm.infoPage === 2)?_c('div',{staticClass:"manage-allocation-calendar-infobox-pages__page"},[_c('div',{staticClass:"manage-allocation-calendar-infobox-pages__content"},[_c('div',{attrs:{"id":"img-5"}},[_c('img',{attrs:{"src":__webpack_require__(491),"height":"450","width":"240"}})]),_vm._v(" "),_c('div',{attrs:{"id":"img-4"}},[_c('img',{attrs:{"src":__webpack_require__(492),"height":"450","width":"240"}})]),_vm._v(" "),_c('div',{attrs:{"id":"img-6"}},[_c('img',{attrs:{"src":__webpack_require__(493),"height":"450","width":"240"}})])])]):_vm._e()])])])}
var ManageAllocationCalendarInfoboxPages_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationCalendarInfoboxPages/ManageAllocationCalendarInfoboxPages.vue
/* script */


/* template */

/* template functional */
var ManageAllocationCalendarInfoboxPages___vue_template_functional__ = false
/* styles */
var ManageAllocationCalendarInfoboxPages___vue_styles__ = null
/* scopeId */
var ManageAllocationCalendarInfoboxPages___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationCalendarInfoboxPages___vue_module_identifier__ = null

var ManageAllocationCalendarInfoboxPages_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationCalendarInfoboxPages,
  ManageAllocationCalendarInfoboxPages_render,
  ManageAllocationCalendarInfoboxPages_staticRenderFns,
  ManageAllocationCalendarInfoboxPages___vue_template_functional__,
  ManageAllocationCalendarInfoboxPages___vue_styles__,
  ManageAllocationCalendarInfoboxPages___vue_scopeId__,
  ManageAllocationCalendarInfoboxPages___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationCalendarInfoboxPages_ManageAllocationCalendarInfoboxPages = (ManageAllocationCalendarInfoboxPages_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationCalendarInfobox/ManageAllocationCalendarInfobox.vue
var ManageAllocationCalendarInfobox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var ManageAllocationCalendarInfobox = ({
    components: {
        ManageAllocationCalendarInfoboxPages: ManageAllocationCalendarInfoboxPages_ManageAllocationCalendarInfoboxPages
    },
    computed: ManageAllocationCalendarInfobox__extends({}, Object(vuex_esm["mapState"])({
        showInfo: function showInfo(state) {
            return state.allocation.calendar.showInfo;
        },
        infoPage: function infoPage(state) {
            return state.allocation.calendar.infoPage;
        }
    }), {
        defaultDate: {
            get: function get() {
                return moment_default()().startOf('day');
            }
        }
    }),
    methods: ManageAllocationCalendarInfobox__extends({}, Object(vuex_esm["mapActions"])({
        infoPageSet: 'allocation/infoPageSet',
        toggleCalendarInfoBox: 'allocation/toggleCalendarInfoBox'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e48f7e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationCalendarInfobox/ManageAllocationCalendarInfobox.vue
var ManageAllocationCalendarInfobox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showInfo)?_c('div',{key:_vm.infoPage,staticClass:"manage-allocation-calendar-infobox"},[_c('div',{staticClass:"manage-allocation-calendar-infobox__heading"},[_c('div',{staticClass:"manage-allocation-calendar-infobox__heading"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationModalCalendarInfobox.header.heading'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar-infobox__toggle",on:{"click":function($event){return _vm.toggleCalendarInfoBox()}}},[_c('i',{staticClass:"fa fa-times-circle"})])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar-infobox__body"},[_c('manage-allocation-calendar-infobox-pages')],1),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar-infobox__footer"},[_c('div',{staticClass:"manage-allocation-calendar-infobox__controls"},[_c('div',{class:['manage-allocation-calendar-infobox__indicator', (_vm.infoPage === 1) ? 'selected' : null],on:{"click":function($event){return _vm.infoPageSet(1)}}}),_vm._v(" "),_c('div',{class:['manage-allocation-calendar-infobox__indicator', (_vm.infoPage === 2) ? 'selected' : null],on:{"click":function($event){return _vm.infoPageSet(2)}}})])])]):_vm._e()}
var ManageAllocationCalendarInfobox_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationCalendarInfobox/ManageAllocationCalendarInfobox.vue
/* script */


/* template */

/* template functional */
var ManageAllocationCalendarInfobox___vue_template_functional__ = false
/* styles */
var ManageAllocationCalendarInfobox___vue_styles__ = null
/* scopeId */
var ManageAllocationCalendarInfobox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationCalendarInfobox___vue_module_identifier__ = null

var ManageAllocationCalendarInfobox_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationCalendarInfobox,
  ManageAllocationCalendarInfobox_render,
  ManageAllocationCalendarInfobox_staticRenderFns,
  ManageAllocationCalendarInfobox___vue_template_functional__,
  ManageAllocationCalendarInfobox___vue_styles__,
  ManageAllocationCalendarInfobox___vue_scopeId__,
  ManageAllocationCalendarInfobox___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationCalendarInfobox_ManageAllocationCalendarInfobox = (ManageAllocationCalendarInfobox_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87628804","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationCalendarWeekdays/ManageAllocationCalendarWeekdays.vue
var ManageAllocationCalendarWeekdays_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-calendar-weekdays"},[_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        #\n    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationCalendarWeekdays.sunday'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationCalendarWeekdays.monday'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationCalendarWeekdays.tuesday'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationCalendarWeekdays.wednesday'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationCalendarWeekdays.thursday'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationCalendarWeekdays.friday'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekday"},[_vm._v("\n        "+_vm._s(_vm.$t('manageAllocationCalendarWeekdays.saturday'))+"\n    ")])])}
var ManageAllocationCalendarWeekdays_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationCalendarWeekdays/ManageAllocationCalendarWeekdays.vue
/* script */
var ManageAllocationCalendarWeekdays___vue_script__ = null
/* template */

/* template functional */
var ManageAllocationCalendarWeekdays___vue_template_functional__ = false
/* styles */
var ManageAllocationCalendarWeekdays___vue_styles__ = null
/* scopeId */
var ManageAllocationCalendarWeekdays___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationCalendarWeekdays___vue_module_identifier__ = null

var ManageAllocationCalendarWeekdays_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationCalendarWeekdays___vue_script__,
  ManageAllocationCalendarWeekdays_render,
  ManageAllocationCalendarWeekdays_staticRenderFns,
  ManageAllocationCalendarWeekdays___vue_template_functional__,
  ManageAllocationCalendarWeekdays___vue_styles__,
  ManageAllocationCalendarWeekdays___vue_scopeId__,
  ManageAllocationCalendarWeekdays___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationCalendarWeekdays = (ManageAllocationCalendarWeekdays_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationCalendar/ManageAllocationCalendar.vue
var ManageAllocationCalendar__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var ManageAllocationCalendar = ({
    components: {
        ManageAllocationCalendarInfobox: ManageAllocationCalendarInfobox_ManageAllocationCalendarInfobox,
        ManageAllocationCalendarElement: ManageAllocationCalendarElement_ManageAllocationCalendarElement,
        ManageAllocationCalendarWeekdays: ManageAllocationCalendarWeekdays,
        DropDownMenu: DropdownMenu["a" /* default */],
        Fake: Fake["a" /* default */]
    },
    data: function data() {
        return {
            showInfo: false
        };
    },

    computed: ManageAllocationCalendar__extends({}, Object(vuex_esm["mapState"])({
        noContent: function noContent(state) {
            return state.allocation.calendar.noContent;
        },
        loading: function loading(state) {
            return state.allocation.calendar.loading;
        },
        error: function error(state) {
            return state.allocation.calendar.error;
        },
        startMonth: function startMonth(state) {
            return state.allocation.calendar.startMonth;
        },
        endMonth: function endMonth(state) {
            return state.allocation.calendar.endMonth;
        },
        choices: function choices(state) {
            return state.allocation.calendar.display.choices;
        },
        choice: function choice(state) {
            return state.allocation.calendar.display.choice;
        }
    }), Object(vuex_esm["mapGetters"])({
        calendar: 'allocation/getCalendar',
        calendarPaginated: 'allocation/getCalendarPaginated'
    })),
    methods: ManageAllocationCalendar__extends({}, Object(vuex_esm["mapActions"])({
        toggleModal: 'allocation/toggleModal',
        incrementCalendarPage: 'allocation/incrementCalendarPage',
        decrementCalendarPage: 'allocation/decrementCalendarPage',
        choseCalendarDisplay: 'allocation/choseCalendarDisplay',
        toggleCalendarInfoBox: 'allocation/toggleCalendarInfoBox',
        getAllocationCalendar: 'allocation/getAllocationCalendar'
    }), {
        pageUp: function pageUp() {
            if (this.startMonth >= 3) {
                this.incrementCalendarPage();
            }
        },
        pageDown: function pageDown() {
            if (this.endMonth < 12) {
                this.decrementCalendarPage();
            }
        },
        chooseDisplay: function chooseDisplay(value) {
            this.choseCalendarDisplay(value);
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c257d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationCalendar/ManageAllocationCalendar.vue
var ManageAllocationCalendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-calendar"},[_c('div',{staticClass:"manage-allocation-calendar__header"},[_c('div',{staticClass:"manage-allocation-calendar__heading"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationCalendar.header.heading'))+"\n        ")]),_vm._v(" "),(!_vm.showInfo)?_c('div',{staticClass:"manage-allocation-calendar__info",on:{"click":_vm.toggleCalendarInfoBox}},[_c('span',{staticClass:"manage-allocation-calendar__info-label"},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationCalendar.header.howTo'))+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-calendar__info-icon"},[_c('i',{staticClass:"fa fa-info-circle",on:{"click":function($event){return _vm.toggleCalendarInfoBox()}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__dropdown"},[_c('drop-down-menu',{attrs:{"items":_vm.choices,"value":_vm.choice,"translation-prefix":'manageAllocationCalendar.dropdown',"searchable":false,"label":_vm.$t('bookingList.display.label')},on:{"input":_vm.chooseDisplay}})],1)]),_vm._v(" "),(!_vm.error && !_vm.noContent && !_vm.loading)?_c('div',{class:['manage-allocation-calendar__body', (_vm.choice === 'full') ? 'full' : null]},[_c('div',{staticClass:"manage-allocation-calendar__months"},_vm._l(((_vm.choice === 'full') ? _vm.calendar : _vm.calendarPaginated),function(month,index){return _c('div',{key:index,staticClass:"manage-allocation-calendar__wrapper"},[_c('div',{staticClass:"manage-allocation-calendar__month"},[_c('div',{staticClass:"manage-allocation-calendar__label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationCalendar.months.' + month.index))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__weekdays"},[_c('manage-allocation-calendar-weekdays')],1),_vm._v(" "),_vm._l((month.weeks),function(week,index){return _c('div',{key:index,staticClass:"manage-allocation-calendar__weeks"},[_c('div',{staticClass:"manage-allocation-calendar__week"},[_vm._v("\n                            "+_vm._s(week.number)+"\n                        ")]),_vm._v(" "),_vm._l((week.days),function(day,dayNo){return _c('div',{key:dayNo,staticClass:"manage-allocation-calendar__days"},[(!day.day)?_c('manage-allocation-calendar-element',{attrs:{"allocation-type":"empty"}}):_vm._e(),_vm._v(" "),(day.day)?_c('manage-allocation-calendar-element',{attrs:{"allocation-type":day.data.allocationType,"date":day.day,"units":day.data.currentUnits,"index":day.index,"past":day.past,"current":day.currentDay,"arrival":day.data.arrival,"request":day.data.request,"tooltip":{bookings: day.data.bookings, initialUnits: day.data.initialUnits}}}):_vm._e()],1)})],2)})],2)])}),0),_vm._v(" "),(_vm.choice !== 'full')?_c('div',{staticClass:"manage-allocation-calendar__controls"},[_c('button',{staticClass:"manage-allocation-calendar__page-btn",attrs:{"disabled":_vm.startMonth === 0},on:{"click":_vm.pageUp}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-calendar__page-btn",attrs:{"disabled":_vm.endMonth === 12},on:{"click":_vm.pageDown}},[_c('i',{staticClass:"fa fa-chevron-down"})])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.error)?_c('div',{key:'error',staticClass:"manage-allocation-calendar__error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__error-message"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationCalendar.error'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-calendar__error-retry",on:{"click":_vm.getAllocationCalendar}},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationCalendar.retry'))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('fake',{key:'fake',attrs:{"header-rows":1,"body-rows":10,"body-cells":4}}):_vm._e()],1)}
var ManageAllocationCalendar_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationCalendar/ManageAllocationCalendar.vue
/* script */


/* template */

/* template functional */
var ManageAllocationCalendar___vue_template_functional__ = false
/* styles */
var ManageAllocationCalendar___vue_styles__ = null
/* scopeId */
var ManageAllocationCalendar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationCalendar___vue_module_identifier__ = null

var ManageAllocationCalendar_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationCalendar,
  ManageAllocationCalendar_render,
  ManageAllocationCalendar_staticRenderFns,
  ManageAllocationCalendar___vue_template_functional__,
  ManageAllocationCalendar___vue_styles__,
  ManageAllocationCalendar___vue_scopeId__,
  ManageAllocationCalendar___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationCalendar_ManageAllocationCalendar = (ManageAllocationCalendar_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da4bf85","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationModalFormHeader/ManageAllocationModalFormHeader.vue
var ManageAllocationModalFormHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-modal-form-header"},[_c('div',{staticClass:"manage-allocation-modal-form-header__fields"},[_c('div',{staticClass:"manage-allocation-modal-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.allocationType'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.numberOfUnits'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.releaseBy'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.releaseDaysDate'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form-header__field"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationFormHeader.afterRelease'))+"\n        ")])])])}
var ManageAllocationModalFormHeader_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationModalFormHeader/ManageAllocationModalFormHeader.vue
/* script */
var ManageAllocationModalFormHeader___vue_script__ = null
/* template */

/* template functional */
var ManageAllocationModalFormHeader___vue_template_functional__ = false
/* styles */
var ManageAllocationModalFormHeader___vue_styles__ = null
/* scopeId */
var ManageAllocationModalFormHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationModalFormHeader___vue_module_identifier__ = null

var ManageAllocationModalFormHeader_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationModalFormHeader___vue_script__,
  ManageAllocationModalFormHeader_render,
  ManageAllocationModalFormHeader_staticRenderFns,
  ManageAllocationModalFormHeader___vue_template_functional__,
  ManageAllocationModalFormHeader___vue_styles__,
  ManageAllocationModalFormHeader___vue_scopeId__,
  ManageAllocationModalFormHeader___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationModalFormHeader = (ManageAllocationModalFormHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationModalForm/ManageAllocationModalForm.vue
var ManageAllocationModalForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var ManageAllocationModalForm = ({
    components: {
        ManageAllocationFormAccept: ManageAllocationFormAccept_ManageAllocationFormAccept,
        ManageAllocationModalFormHeader: ManageAllocationModalFormHeader
    },
    computed: ManageAllocationModalForm__extends({}, Object(vuex_esm["mapState"])({
        row: function row(state) {
            return state.allocation.form.rows[0];
        },
        loading: function loading(state) {
            return state.allocation.form.allocations.loading;
        },
        error: function error(state) {
            return state.allocation.form.allocations.error;
        },
        noContent: function noContent(state) {
            return state.allocation.allocations.noContent;
        },
        validator: function validator(state) {
            return state.allocation.form.validator;
        },
        accommodation: function accommodation(state) {
            return state.allocation.form.filters.selected.accommodation;
        },
        selected: function selected(state) {
            return state.allocation.form.filters.selected;
        },
        items: function items(state) {
            return state.allocation.allocations.items;
        },
        from: function from(state) {
            return state.allocation.calendar.from;
        },
        to: function to(state) {
            return state.allocation.calendar.to;
        }
    }), {
        fromClasses: function fromClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.from.$dirty && this.$v.row.from.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.from.$dirty && !this.$v.row.from.$error
            };
        },
        toClasses: function toClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.to.$dirty && this.$v.row.to.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.to.$dirty && !this.$v.row.to.$error
            };
        },
        typeClasses: function typeClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.type.$dirty && this.$v.row.type.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.type.$dirty && !this.$v.row.type.$error
            };
        },
        unitClasses: function unitClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.units.$dirty && this.$v.row.units.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.units.$dirty && !this.$v.row.units.$error
            };
        },
        releaseTypeClasses: function releaseTypeClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseType.$dirty && this.$v.row.releaseType.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseType.$dirty && !this.$v.row.releaseType.$error
            };
        },
        releaseMethodClasses: function releaseMethodClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseMethod.$dirty && this.$v.row.releaseMethod.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseMethod.$dirty && !this.$v.row.releaseMethod.$error
            };
        },
        releaseDateClasses: function releaseDateClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseDate.$dirty && this.$v.row.releaseDate.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseDate.$dirty && !this.$v.row.releaseDate.$error
            };
        },
        releaseDaysClasses: function releaseDaysClasses() {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseDays.$dirty && this.$v.row.releaseDays.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseDays.$dirty && !this.$v.row.releaseDays.$error
            };
        }
    }),
    methods: ManageAllocationModalForm__extends({}, Object(vuex_esm["mapActions"])({
        setModalRow: 'allocation/setModalRow',
        validateInputs: 'allocation/validateAddAllocationInputs',
        submit: 'allocation/submitForm',
        resetForm: 'allocation/resetModalForm',
        addAllocations: 'allocation/addAllocations',
        toggleAddAllocation: 'allocation/toggleModalAddAllocations',
        getAllocationList: 'allocation/getAllocationList',
        getAllocationListMerged: 'allocation/getAllocationListMerged',
        getAllocationCalendar: 'allocation/getAllocationCalendar'
    }), {
        update: function update(obj) {
            this.$v.$touch();
            // Set the from and to dates on the row object
            this.setModalRow(ManageAllocationModalForm__extends({}, this.row, obj));
        },
        submitForm: function submitForm() {
            this.$v.$touch();
            this.validateInputs();
            // If input fields are invalid then its not possible to submit
            if (!this.validator.error) {
                this.submit([]);
            }
        }
    }),
    validations: function validations() {
        var _this = this;

        return {
            row: {
                type: {
                    required: validators["required"]
                },
                units: {
                    required: Object(validators["requiredIf"])(function (nestedRow) {
                        return nestedRow.type === 'ALLOTMENT';
                    }),
                    validateMinNumber: function validateMinNumber(units, allocation) {
                        return allocation.type === 'ALLOTMENT' ? Object(ValidatorService["validateMinNumber"])(units) : true;
                    },
                    ValidateUnits: function ValidateUnits(units) {
                        var valid = Object(ValidatorService["validateUpdateUnits"])(units, _this.row);
                        if (!valid.valid) {
                            _this.errors = valid.message;
                        }
                        return valid.valid;
                    }
                },
                releaseType: {
                    required: validators["required"]
                },
                releaseMethod: {
                    required: validators["required"]
                },
                releaseDays: {
                    required: Object(validators["requiredIf"])(function (nestedRow) {
                        return nestedRow.releaseMethod === 'days';
                    }),
                    validateMinNumber: function validateMinNumber(days, allocation) {
                        return allocation.releaseMethod === 'days' ? Object(ValidatorService["validateMinNumber"])(days) : true;
                    }
                },
                releaseDate: {
                    required: Object(validators["requiredIf"])(function (nestedRow) {
                        return nestedRow.releaseMethod === 'date';
                    }),
                    validateValidDate: function validateValidDate(date, allocation) {
                        return allocation.releaseMethod === 'date' ? ValidatorService["validateValidDate"] : true;
                    },
                    beforeOrEqualTo: function beforeOrEqualTo(date, allocation) {
                        return allocation.releaseMethod === 'date' ? Object(ValidatorService["beforeOrEqualTo"])(date, allocation) : true;
                    }
                }
            }
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883dd1e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationModalForm/ManageAllocationModalForm.vue
var ManageAllocationModalForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-modal-form"},[_c('div',{staticClass:"manage-allocation-modal-form__content"},[_c('manage-allocation-form-accept',{attrs:{"label":'Adding allocations',"method":'add'},on:{"accept":_vm.addAllocations}}),_vm._v(" "),_c('manage-allocation-modal-form-header'),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form__fields"},[_c('div',{staticClass:"manage-allocation-modal-form__field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.type),expression:"row.type"}],staticClass:"manage-allocation-modal-form__dropdown",class:_vm.typeClasses,domProps:{"value":_vm.row.type},on:{"input":function($event){return _vm.update({type: $event.target.value})},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.row, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"ALLOTMENT"}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.type.allotment'))+"\n                    ")]),_vm._v(" "),_c('option',{attrs:{"value":"FREESALE"}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.type.freesale'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form__field"},[_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-modal-form__input",class:_vm.unitClasses,attrs:{"disabled":_vm.row.type === 'FREESALE' || _vm.row.type === '' || !_vm.row.type,"placeholder":_vm.row.type === 'ALLOTMENT' ? _vm.$t('manageAllocationModal.form.units.allotment') : _vm.$t('manageAllocationModal.form.units.notAllotment'),"type":"text"},domProps:{"value":_vm.row.units},on:{"input":function($event){return _vm.update({units: $event.target.value})}}})]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form__field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.releaseMethod),expression:"row.releaseMethod"}],staticClass:"manage-allocation-modal-form__dropdown",class:_vm.releaseMethodClasses,domProps:{"value":_vm.row.releaseMethod},on:{"input":function($event){return _vm.update({releaseMethod: $event.target.value})},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.row, "releaseMethod", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"days"}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.releaseMethod.days'))+"\n                    ")]),_vm._v(" "),_c('option',{attrs:{"value":"date"}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.releaseMethod.date'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form__field"},[(_vm.row.releaseMethod === 'date')?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"manage-allocation-modal-form__input",class:_vm.releaseDateClasses,attrs:{"placeholder":_vm.$t('manageAllocationModal.form.date'),"type":"text"},domProps:{"value":_vm.row.releaseDate},on:{"input":function($event){return _vm.update({releaseDate: $event.target.value, releaseDays: undefined})}}}):_vm._e(),_vm._v(" "),(_vm.row.releaseMethod === 'days')?_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-modal-form__input",class:_vm.releaseDaysClasses,attrs:{"placeholder":_vm.$t('manageAllocationModal.form.days'),"type":"text"},domProps:{"value":_vm.row.releaseDays},on:{"input":function($event){return _vm.update({releaseDays: $event.target.value, releaseDate: undefined})}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form__field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.releaseType),expression:"row.releaseType"}],staticClass:"manage-allocation-modal-form__dropdown",class:_vm.releaseTypeClasses,domProps:{"value":_vm.row.releaseType},on:{"input":function($event){return _vm.update({releaseType: $event.target.value})},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.row, "releaseType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.releaseType.selectType'))+"\n                    ")]),_vm._v(" "),_c('option',{domProps:{"value":'REQUEST'}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.releaseType.request'))+"\n                    ")]),_vm._v(" "),_c('option',{domProps:{"value":'FREESALE'}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.releaseType.freesale'))+"\n                    ")]),_vm._v(" "),_c('option',{domProps:{"value":'BLOCKED'}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.releaseType.blocked'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-form__control-buttons"},[_c('button',{staticClass:"manage-allocation-modal-form__submit",attrs:{"disabled":_vm.loading || this.$v.$error},on:{"click":_vm.submitForm}},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationModal.form.buttons.create'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-modal-form__reset",attrs:{"disabled":_vm.loading},on:{"click":_vm.toggleAddAllocation}},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationModal.form.buttons.cancel'))+"\n            ")])])],1)])}
var ManageAllocationModalForm_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationModalForm/ManageAllocationModalForm.vue
/* script */


/* template */

/* template functional */
var ManageAllocationModalForm___vue_template_functional__ = false
/* styles */
var ManageAllocationModalForm___vue_styles__ = null
/* scopeId */
var ManageAllocationModalForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationModalForm___vue_module_identifier__ = null

var ManageAllocationModalForm_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationModalForm,
  ManageAllocationModalForm_render,
  ManageAllocationModalForm_staticRenderFns,
  ManageAllocationModalForm___vue_template_functional__,
  ManageAllocationModalForm___vue_styles__,
  ManageAllocationModalForm___vue_scopeId__,
  ManageAllocationModalForm___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationModalForm_ManageAllocationModalForm = (ManageAllocationModalForm_Component.exports);

// EXTERNAL MODULE: ./src/services/DateToolService.js
var DateToolService = __webpack_require__(48);
var DateToolService_default = /*#__PURE__*/__webpack_require__.n(DateToolService);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationModalList/ManageAllocationModalList.vue
var ManageAllocationModalList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var ManageAllocationModalList = ({
    components: {
        PaginationControl: PaginationControl["a" /* default */],
        ManageAllocationFormAccept: ManageAllocationFormAccept_ManageAllocationFormAccept,
        Loading: Loading["a" /* default */]
    },
    data: function data() {
        return {
            blockingPeriod: null
        };
    },

    computed: ManageAllocationModalList__extends({}, Object(vuex_esm["mapState"])({
        loading: function loading(state) {
            return state.allocation.allocations.loading;
        },
        updating: function updating(state) {
            return state.allocation.modal.overlay.loading;
        },
        page: function page(state) {
            return state.allocation.modal.list.page;
        },
        adding: function adding(state) {
            return state.allocation.modal.adding;
        },
        calendarFrom: function calendarFrom(state) {
            return state.allocation.calendar.from;
        },
        calendarTo: function calendarTo(state) {
            return state.allocation.calendar.to;
        },
        user: function user(state) {
            return state.auth.user;
        }
    }), Object(vuex_esm["mapGetters"])({
        allocationsInPeriod: "allocation/allocationsInPeriodPaginated",
        allocationsInPeriodMaxPages: 'allocation/allocationsInPeriodMaxPages',
        allotmentInPeriod: "allocation/allotmentInPeriod"
    })),
    methods: ManageAllocationModalList__extends({}, Object(vuex_esm["mapActions"])({
        incrementModalPagination: 'allocation/incrementModalPagination',
        decrementModalPagination: 'allocation/decrementModalPagination',
        chooseAllocation: 'allocation/chooseAllocation',
        blockAllocation: 'allocation/blockAllocation',
        addNewAllocation: 'allocation/toggleModalNewAllocation',
        getAllocationList: 'allocation/getAllocationList',
        getAllocationListMerged: 'allocation/getAllocationListMerged',
        getAllocationCalendar: 'allocation/getAllocationCalendar',
        submit: 'allocation/submitForm'
    }), {
        newAllocation: function newAllocation(allocation) {
            // Convert the data
            var newAllocation = Object(DateToolService["calculateNewPeriodFromTo"])(this.calendarFrom, this.calendarTo, allocation);
            this.addNewAllocation(newAllocation);
        },
        block: function block(allocation) {
            this.blockingPeriod = Object(DateToolService["calculateNewPeriodFromTo"])(this.calendarFrom, this.calendarTo, allocation);
            this.submit([this.blockingPeriod]);
        },
        acceptBlock: function acceptBlock(allocation) {
            var _this = this;

            // Convert the data
            var blockAllocation = ManageAllocationModalList__extends({ allocation: allocation }, this.blockingPeriod);
            this.blockAllocation(blockAllocation).then(function () {
                _this.fetchData();
            });
        },
        beforeCalendarFrom: function beforeCalendarFrom(date) {
            var calendarFrom = moment_default()(this.calendarFrom, 'DD/MM/YYYY');
            return moment_default()(date).diff(calendarFrom) > 0;
        },
        afterCalendarTo: function afterCalendarTo(date) {
            var calendarTo = moment_default()(this.calendarTo, 'DD/MM/YYYY');
            return moment_default()(date).diff(calendarTo) < 0;
        },
        fetchData: function fetchData() {
            Promise.all([this.getAllocationList(), this.getAllocationListMerged(), this.getAllocationCalendar()]);
        },
        canBlock: function canBlock(allocation) {
            return !allocation.isReleased && this.user.contractManager && allocation.allocation.type !== 'BLOCKED' || !allocation.isReleased && (allocation.allocation.type === 'FREESALE' || allocation.allocation.type === 'REQUEST') || (allocation.isReleased || Object(DateToolService["isSoldOut"])(this.calendarFrom, this.calendarTo, allocation)) && allocation.allocation.releaseType !== 'BLOCKED' && allocation.allocation.type !== 'BLOCKED';
        },
        blockReleased: function blockReleased(allocation) {
            return !allocation.isReleased && !this.user.contractManager && (allocation.allocation.type === 'ALLOTMENT' || allocation.allocation.type === 'GUARANTEE');
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d436f16a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationModalList/ManageAllocationModalList.vue
var ManageAllocationModalList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.adding && _vm.allocationsInPeriod.length > 0)?_c('div',{staticClass:"manage-allocation-modal-list"},[(_vm.updating || _vm.loading)?_c('loading'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.loading)?_c('div',{key:'content',staticClass:"manage-allocation-modal-list__content"},[_c('div',{staticClass:"manage-allocation-modal-list__header"},[_c('div',{staticClass:"manage-allocation-modal-list__heading"},[(_vm.allocationsInPeriod.length > 0 && _vm.allotmentInPeriod)?_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalList.header.bookingsInPeriod'))+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.allocationsInPeriod.length === 0 || !_vm.allotmentInPeriod)?_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalList.header.noBookingsInPeriod'))+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('table',{staticClass:"manage-allocation-modal-list__table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.from')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.to')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.release')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationList.list.releaseType')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.allocationsInPeriod),function(element,index){return _c('tr',{key:index},[(_vm.beforeCalendarFrom(element.allocation.from))?_c('td',[_vm._v("\n                            "+_vm._s(_vm._f("moment")(element.allocation.from,"DD/MM/YYYY"))+"\n                        ")]):_vm._e(),_vm._v(" "),(!_vm.beforeCalendarFrom(element.allocation.from))?_c('td',[_vm._v("\n                            "+_vm._s(_vm.calendarFrom)+"\n                        ")]):_vm._e(),_vm._v(" "),(_vm.afterCalendarTo(element.allocation.to))?_c('td',[_vm._v("\n                            "+_vm._s(_vm._f("moment")(element.allocation.to,"DD/MM/YYYY"))+"\n                        ")]):_vm._e(),_vm._v(" "),(!_vm.afterCalendarTo(element.allocation.to))?_c('td',[_vm._v("\n                            "+_vm._s(_vm.calendarTo)+"\n                        ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModal.form.type.' + element.allocation.type.toLowerCase()))+"\n                        ")]),_vm._v(" "),(element.allocation.releaseDays)?_c('td',[_vm._v("\n                            "+_vm._s(element.allocation.releaseDays)+" "+_vm._s(_vm.$t('manageAllocationModalList.days'))+"\n                        ")]):_vm._e(),_vm._v(" "),(element.allocation.releaseDate)?_c('td',[_vm._v("\n                            "+_vm._s(_vm._f("moment")(element.allocation.releaseDate,'DD/MM/YYYY'))+"\n                        ")]):_vm._e(),_vm._v(" "),(!element.allocation.releaseDate && !element.allocation.releaseDays)?_c('td',[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModalList.releaseType.null' ))+"\n                        ")]):_vm._e(),_vm._v(" "),(element.allocation.releaseType)?_c('td',[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModalList.releaseType.' + element.allocation.releaseType.toLowerCase() ))+"\n                        ")]):_vm._e(),_vm._v(" "),(!element.allocation.releaseType)?_c('td',[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModalList.releaseType.null' ))+"\n                        ")]):_vm._e(),_vm._v(" "),_c('td',[(element.allocation.type !== 'BLOCKED')?_c('button',{staticClass:"manage-allocation-modal-list__btn manage-allocation-modal-list__btn-edit",attrs:{"disabled":_vm.updating},on:{"click":function($event){return _vm.chooseAllocation(element.allocation)}}},[(element.allocation.type !== 'BLOCKED' && element.hasRequest)?_c('i',{staticClass:"fa fa-exclamation-triangle manage-allocation-modal-list__edit-requests"}):_vm._e(),_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalList.buttons.edit' ))+"\n                            ")]):_vm._e(),_vm._v(" "),(element.allocation.type === 'BLOCKED')?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalList.block.blocked'))+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[(element.isReleased || element.allocation.type === 'BLOCKED')?_c('button',{staticClass:"manage-allocation-modal-list__btn manage-allocation-modal-list__btn-new",attrs:{"disabled":_vm.updating},on:{"click":function($event){return _vm.newAllocation(element.allocation)}}},[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalList.buttons.new' ))+"\n                            ")]):_vm._e(),_vm._v(" "),(!element.isReleased && element.allocation.type !== 'BLOCKED')?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalList.block.false'))+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[(_vm.canBlock(element))?_c('button',{staticClass:"manage-allocation-modal-list__btn manage-allocation-modal-list__btn-block",attrs:{"disabled":_vm.updating},on:{"click":function($event){return _vm.block(element.allocation)}}},[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalList.buttons.block' ))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.blockReleased(element))?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalList.block.false'))+"\n                            ")]):_vm._e(),_vm._v(" "),((element.isReleased && element.allocation.releaseType === 'BLOCKED') || element.allocation.type === 'BLOCKED')?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalList.block.blocked'))+"\n                            ")]):_vm._e(),_vm._v(" "),_c('manage-allocation-form-accept',{attrs:{"label":'Block allocations',"method":'block'},on:{"accept":function($event){return _vm.acceptBlock(element.allocation)}}})],1)])}),0)]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-list__footer"},[(_vm.allocationsInPeriod.length > 0)?_c('div',{staticClass:"manage-allocation-modal-list__pagination"},[_c('pagination-control',{attrs:{"current-page":_vm.page,"max-pages":_vm.allocationsInPeriodMaxPages},on:{"prev":_vm.decrementModalPagination,"next":_vm.incrementModalPagination}})],1):_vm._e()])]):_vm._e()])],1):_vm._e()}
var ManageAllocationModalList_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationModalList/ManageAllocationModalList.vue
/* script */


/* template */

/* template functional */
var ManageAllocationModalList___vue_template_functional__ = false
/* styles */
var ManageAllocationModalList___vue_styles__ = null
/* scopeId */
var ManageAllocationModalList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationModalList___vue_module_identifier__ = null

var ManageAllocationModalList_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationModalList,
  ManageAllocationModalList_render,
  ManageAllocationModalList_staticRenderFns,
  ManageAllocationModalList___vue_template_functional__,
  ManageAllocationModalList___vue_styles__,
  ManageAllocationModalList___vue_scopeId__,
  ManageAllocationModalList___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationModalList_ManageAllocationModalList = (ManageAllocationModalList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationModalOverlayForm/ManageAllocationModalOverlayForm.vue
var ManageAllocationModalOverlayForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var ManageAllocationModalOverlayForm = ({
    components: {
        ManageAllocationModalFormHeader: ManageAllocationModalFormHeader,
        ManageAllocationFormAccept: ManageAllocationFormAccept_ManageAllocationFormAccept
    },
    data: function data() {
        return {
            errors: "",
            updateMessage: "update",
            edit: false,
            editField: undefined,
            showInstruction: false
        };
    },

    computed: ManageAllocationModalOverlayForm__extends({}, Object(vuex_esm["mapState"])({
        trustedSupplier: function trustedSupplier(state) {
            return state.auth.supplier.trusted;
        },
        allocation: function allocation(state) {
            return state.allocation.modal.overlay.allocation.item;
        },
        original: function original(state) {
            return state.allocation.modal.overlay.allocation.original;
        },
        error: function error(state) {
            return state.allocation.modal.overlay.error;
        },
        selected: function selected(state) {
            return state.allocation.form.filters.selected;
        },
        items: function items(state) {
            return state.allocation.allocations.items;
        },
        loading: function loading(state) {
            return state.allocation.modal.overlay.loading;
        },
        from: function from(state) {
            return state.allocation.calendar.from;
        },
        to: function to(state) {
            return state.allocation.calendar.to;
        },
        user: function user(state) {
            return state.auth.user;
        }
    }), Object(vuex_esm["mapGetters"])({
        changed: 'allocation/overlayAllocationChanged',
        changeRequestForAllocation: 'allocation/changeRequestForAllocation',
        getAllocationTypes: 'allocation/getAllocationTypes',
        getStatisticsForPeriod: 'allocation/getStatisticsForPeriod',
        getAllocationReleaseTypes: 'allocation/getAllocationReleaseTypes'
    }), {
        canUpdate: function canUpdate() {
            return !this.changeRequestForAllocation.length && Object(ValidatorService["validateUpdateAllocationPossible"])(this.original, this.allocation, this.trustedSupplier) || this.user.contractManager;
        },
        canBlock: function canBlock() {
            return !this.changeRequestForAllocation.length && (this.checkIfReleased && this.original.releaseType !== 'BLOCKED' || this.original.type === 'REQUEST' || this.original.type === 'FREESALE' || this.user.contractManager || this.trustedSupplier);
        },
        canRequestBlock: function canRequestBlock() {
            return !this.changeRequestForAllocation.length && !this.trustedSupplier && this.original.type !== 'BLOCKED' && !this.checkIfReleased;
        },
        checkIfReleased: function checkIfReleased() {
            return Object(DateToolService["isReleased"])(this.original.to, this.original) || Object(DateToolService["isSoldOut"])(this.from, this.to, this.original);
        }
    }),
    methods: ManageAllocationModalOverlayForm__extends({}, Object(vuex_esm["mapActions"])({
        setOverlayRow: 'allocation/setOverlayRow',
        validateInputs: 'allocation/validateUpdateAllocationInputs',
        submit: 'allocation/submitForm',
        resetForm: 'allocation/resetForm',
        updateAllocation: 'allocation/updateAllocation',
        requestUpdateAllocation: 'allocation/requestUpdateAllocation',
        blockAllocation: 'allocation/blockAllocation',
        requestBlockAllocation: 'allocation/requestBlockAllocation',
        resetOverlayRow: 'allocation/resetOverlayRow'
    }), {
        openEdit: function openEdit(field) {
            if (field === 'units' && this.allocation.type !== 'ALLOTMENT') {
                return;
            }
            this.edit = true;
            this.editField = field;
        },
        closeEdit: function closeEdit() {
            this.edit = false;
            this.editField = undefined;
            this.resetOverlayRow();
        },
        update: function update(obj) {
            this.$v.$touch();
            this.setOverlayRow(obj);
        },
        process: function process(type) {
            this.updateMessage = type;
            this.$v.$touch();
            this.submit([{ from: this.original.from.format('DD/MM/YYYY'), to: this.original.to.format('DD/MM/YYYY') }]);
        },
        accept: function accept() {
            switch (this.updateMessage) {
                case 'submit':
                    this.updateAllocation();
                    break;
                case 'request':
                    this.requestUpdateAllocation();
                    break;
                case 'block':
                    this.setOverlayRow({ type: "BLOCKED" });
                    this.blockAllocation(this.allocation);
                    break;
                case 'requestBlock':
                    this.setOverlayRow({ type: "BLOCKED" });
                    this.requestBlockAllocation(this.allocation);
                    break;
            }
        }
    }),
    validations: function validations() {
        var _this = this;

        return {
            allocation: {
                units: {
                    ValidateUnits: function ValidateUnits(units) {
                        var valid = Object(ValidatorService["validateUpdateUnits"])(units, _this.allocation);
                        if (!valid.valid) {
                            _this.errors = valid.message;
                        }
                        return valid.valid;
                    }
                },
                releaseDays: {
                    validateReleaseDays: function validateReleaseDays(days) {
                        if (_this.original.releaseMethod === 'days') {
                            var valid = Object(ValidatorService["validateUpdateReleaseDays"])(days);
                            if (!valid.valid) {
                                _this.errors = valid.message;
                            }
                            return valid.valid;
                        }
                        return true;
                    }
                },
                releaseDate: {
                    validateReleaseDate: function validateReleaseDate(date) {
                        if (_this.original.releaseMethod === 'date') {
                            var valid = Object(ValidatorService["validateUpdateReleaseDate"])(date, _this.original);
                            if (!valid.valid) {
                                _this.errors = valid.message;
                            }
                            return valid.valid;
                        }
                        return true;
                    }
                }
            }
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a96a4cf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationModalOverlayForm/ManageAllocationModalOverlayForm.vue
var ManageAllocationModalOverlayForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-modal-overlay-form"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__container",attrs:{"id":"container"}},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__content"},[_c('manage-allocation-form-accept',{attrs:{"label":_vm.$t('manageAllocationModalOverlayForm.accept.' + _vm.updateMessage),"method":_vm.updateMessage},on:{"accept":_vm.accept}}),_vm._v(" "),(_vm.$v.$error)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__alert manage-allocation-modal-overlay-form__alert--danger"},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.validator.' + _vm.errors))+"\n            ")]):_vm._e(),_vm._v(" "),(!_vm.changeRequestForAllocation.length && _vm.changed && !_vm.canUpdate)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__alert manage-allocation-modal-overlay-form__alert--warning"},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.request'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.changeRequestForAllocation.length)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__alert manage-allocation-modal-overlay-form__alert--warning"},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.requestPending'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.checkIfReleased)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__alert manage-allocation-modal-overlay-form__alert--warning"},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.released'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__instruction-toggle",on:{"click":function($event){_vm.showInstruction = !_vm.showInstruction}}},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.instruction'))+"\n            ")]),_vm._v(" "),(_vm.showInstruction)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__instruction"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__instruction-text"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__text-default"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.editable.information.default'))+"\n                    ")]),_vm._v(" "),(!_vm.user.contractManager && _vm.trustedSupplier)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('manageAllocationModalOverlayForm.instructionTrusted'))}}):_vm._e(),_vm._v(" "),(!_vm.user.contractManager && !_vm.trustedSupplier)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('manageAllocationModalOverlayForm.instructionNotTrusted'))}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.edit)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit"},[(_vm.editField === 'type')?_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-item"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.editable.type'))+"\n                    ")]),_vm._v(" "),_c('select',{staticClass:"manage-allocation-modal-overlay-form__select",domProps:{"value":_vm.allocation.type},on:{"change":function($event){return _vm.update({type: $event.target.value })}}},_vm._l((_vm.getAllocationTypes),function(type,index){return _c('option',{key:'allocation-type__' + index,staticClass:"manage-allocation-modal-overlay-form__option",domProps:{"value":type}},[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModal.form.type.' + type.toLowerCase()))+"\n                        ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.editField === 'units')?_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-item"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.editable.units'))+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-modal-overlay-form__edit-input",domProps:{"value":_vm.allocation.units},on:{"input":function($event){_vm.update({units: parseInt($event.target.value)})}}}),_vm._v(" "),_c('button',{staticClass:"manage-allocation-modal-overlay-form__increment-btn",attrs:{"disabled":_vm.allocation.type !== 'ALLOTMENT' || _vm.allocation.units <= 1},on:{"click":function($event){_vm.update({units: parseInt(_vm.allocation.units) - 1})}}},[_vm._v("\n                        -\n                    ")]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-modal-overlay-form__decrement-btn",attrs:{"disabled":_vm.allocation.type !== 'ALLOTMENT'},on:{"click":function($event){_vm.update({units: parseInt(_vm.allocation.units) + 1})}}},[_vm._v("\n                        +\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.editField === 'releaseType')?_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-item"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.editable.releaseType'))+"\n                    ")]),_vm._v(" "),_c('select',{staticClass:"manage-allocation-modal-overlay-form__select",domProps:{"value":_vm.allocation.releaseType},on:{"change":function($event){return _vm.update({releaseType: $event.target.value })}}},_vm._l((_vm.getAllocationReleaseTypes),function(releaseType,index){return _c('option',{key:'allocation-release-type__' + index,staticClass:"manage-allocation-modal-overlay-form__option",domProps:{"value":releaseType}},[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModal.form.type.' + releaseType.toLowerCase()))+"\n                        ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.editField === 'releaseDays')?_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-item"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.editable.releaseDays'))+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-modal-overlay-form__edit-input",attrs:{"placeholder":_vm.$t('manageAllocationFormRow.days')},domProps:{"value":_vm.allocation.releaseDays},on:{"input":function($event){return _vm.update({releaseDays: $event.target.value, releaseDate: null})}}}),_vm._v(" "),_c('button',{staticClass:"manage-allocation-modal-overlay-form__increment-btn",attrs:{"disabled":_vm.allocation.releaseDays <= 1},on:{"click":function($event){_vm.update({releaseDays: parseInt(_vm.allocation.releaseDays) - 1})}}},[_vm._v("\n                        -\n                    ")]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-modal-overlay-form__decrement-btn",on:{"click":function($event){_vm.update({releaseDays: parseInt(_vm.allocation.releaseDays) + 1})}}},[_vm._v("\n                        +\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.editField === 'releaseDate')?_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-item"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.editable.releaseDate'))+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"manage-allocation-modal-overlay-form__date",attrs:{"placeholder":_vm.$t('manageAllocationFormRow.dateFormat'),"type":"text"},domProps:{"value":_vm.allocation.releaseDate},on:{"input":function($event){return _vm.update({releaseDate: $event.target.value, releaseDays: null})}}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__form"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__form-item"},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.period'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-value"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(_vm.original.from,"DD/MM/YYYY"))+" - "+_vm._s(_vm._f("moment")(_vm.original.to,"DD/MM/YYYY"))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__form-item--editable",on:{"click":function($event){return _vm.openEdit('type')}}},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.type'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-value"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.type.' +
                        (_vm.original.type ? _vm.original.type.toLowerCase() : 'null')))+"\n                    ")]),_vm._v(" "),(_vm.original.type !== _vm.allocation.type)?_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-change"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.type.' +
                        (_vm.allocation.type ? _vm.allocation.type.toLowerCase() : 'null')))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__form-item--editable",class:{'manage-allocation-modal-overlay-form__form-item--null' : _vm.allocation.units === null},on:{"click":function($event){return _vm.openEdit('units')}}},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.units'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-value"},[_vm._v("\n                        "+_vm._s(_vm.original.units)+"\n                    ")]),_vm._v(" "),(_vm.original.units !== _vm.allocation.units)?_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-change"},[_vm._v("\n                        "+_vm._s(_vm.allocation.units)+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__form-item--editable",on:{"click":function($event){return _vm.openEdit('releaseType')}}},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.releaseMethod'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-value"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.type.' +
                        (_vm.original.releaseType ? _vm.original.releaseType.toLowerCase() : 'null')))+"\n                    ")]),_vm._v(" "),(_vm.original.releaseType !== _vm.allocation.releaseType)?_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-change"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModal.form.type.' +
                        (_vm.allocation.releaseType ? _vm.allocation.releaseType.toLowerCase() : 'null')))+"\n                    ")]):_vm._e()]),_vm._v(" "),(_vm.original.releaseDate !== null)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__form-item--editable",on:{"click":function($event){return _vm.openEdit('releaseDate')}}},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.releaseDate'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-value"},[_vm._v("\n                        "+_vm._s(_vm.original.releaseDate)+"\n                    ")]),_vm._v(" "),(_vm.original.releaseDate !== _vm.allocation.releaseDate)?_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-change"},[_vm._v("\n                        "+_vm._s(_vm.allocation.releaseDate)+"\n                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.original.releaseDays !== null)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__form-item--editable",on:{"click":function($event){return _vm.openEdit('releaseDays')}}},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.releaseDays'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-value"},[_vm._v("\n                        "+_vm._s(_vm.original.releaseDays)+"\n                    ")]),_vm._v(" "),(_vm.original.releaseDays !== _vm.allocation.releaseDays)?_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-change"},[_vm._v("\n                        "+_vm._s(_vm.allocation.releaseDays)+"\n                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.canBlock)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__block",on:{"click":function($event){return _vm.process('block')}}},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.accept.block'))+"\n                ")]):_vm._e(),_vm._v(" "),(!_vm.canBlock && _vm.canRequestBlock)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__block",on:{"click":function($event){return _vm.process('requestBlock')}}},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.accept.requestBlock'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__edit-buttons"},[(_vm.canUpdate)?_c('button',{staticClass:"manage-allocation-modal-overlay-form__button-update",attrs:{"disabled":!_vm.changed || this.$v.$error || _vm.loading},on:{"click":function($event){return _vm.process('submit')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.buttons.update'))+"\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.canUpdate)?_c('button',{staticClass:"manage-allocation-modal-overlay-form__button-request",attrs:{"disabled":_vm.changeRequestForAllocation.length || !_vm.changed || this.$v.$error || _vm.loading},on:{"click":function($event){return _vm.process('request')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.buttons.request'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"manage-allocation-modal-overlay-form__button-reset",on:{"click":_vm.closeEdit}},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.buttons.reset'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__statistics"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__statistics-item"},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.bookings'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-value"},[(!_vm.getStatisticsForPeriod.bookings)?_c('i',{staticClass:"manage-allocation-modal-overlay-form__icon-minus fas fa-minus-square"}):_vm._e(),_vm._v(" "),(_vm.getStatisticsForPeriod.bookings)?_c('i',{staticClass:"manage-allocation-modal-overlay-form__icon-plus fas fa-check-square"}):_vm._e()])]),_vm._v(" "),(_vm.getStatisticsForPeriod.bookings)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-item",attrs:{"title":_vm.$t('manageAllocationModalOverlayForm.labels.bookingsMaxCountToolTip')}},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.bookingsMaxCount'))+":\n                    ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-value"},[_vm._v("\n                        "+_vm._s(_vm.getStatisticsForPeriod.bookingsMaxCount)+"\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__statistics-item"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__item-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.arrivalRules'))+":\n                    ")]),_vm._v(" "),(_vm.getStatisticsForPeriod.arrivalRules.length === 0)?_c('div',{staticClass:"manage-allocation-modal-overlay-form__item-alert"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.noArrivalRules'))+"\n                        ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.getStatisticsForPeriod.arrivalRules),function(rule,index){return _c('div',{key:'arrivalRule_' + index,staticClass:"manage-allocation-modal-overlay-form__item-list"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-item"},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.period'))+":\n                            ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-value"},[_vm._v("\n                                "+_vm._s(_vm._f("moment")(rule.startDate,"DD/MM/YYYY"))+" - "+_vm._s(_vm._f("moment")(rule.endDate,"DD/MM/YYYY"))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-item"},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.arrivalTypes.label'))+":\n                            ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-value"},[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.arrivalTypes.' + rule.type))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-item"},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationModalOverlayForm.labels.arrivalRuleStayLength'))+":\n                            ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__list-value"},[_vm._v("\n                                "+_vm._s(rule.minRental)+" - "+_vm._s(rule.maxRental)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay-form__item-days"},[_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-day"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.sunday')))]),_vm._v(" "),_c('div',{class:['manage-allocation-modal-overlay-form__checkbox', {'manage-allocation-modal-overlay-form__checkbox--checked': rule.sunday}]})]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-day"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.monday')))]),_vm._v(" "),_c('div',{class:['manage-allocation-modal-overlay-form__checkbox', {'manage-allocation-modal-overlay-form__checkbox--checked': rule.monday}]})]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-day"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.tuesday')))]),_vm._v(" "),_c('div',{class:['manage-allocation-modal-overlay-form__checkbox', {'manage-allocation-modal-overlay-form__checkbox--checked': rule.tuesday}]})]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-day"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.wednesday')))]),_vm._v(" "),_c('div',{class:['manage-allocation-modal-overlay-form__checkbox', {'manage-allocation-modal-overlay-form__checkbox--checked': rule.wednesday}]})]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-day"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.thursday')))]),_vm._v(" "),_c('div',{class:['manage-allocation-modal-overlay-form__checkbox', {'manage-allocation-modal-overlay-form__checkbox--checked': rule.thursday}]})]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-day"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.friday')))]),_vm._v(" "),_c('div',{class:['manage-allocation-modal-overlay-form__checkbox', {'manage-allocation-modal-overlay-form__checkbox--checked': rule.friday}]})]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-modal-overlay-form__item-day"},[_c('div',{staticClass:"manage-allocation-modal-overlay-form__list-label"},[_vm._v(_vm._s(_vm.$t('contract.form.arrivalRules.weekdays.saturday')))]),_vm._v(" "),_c('div',{class:['manage-allocation-modal-overlay-form__checkbox', {'manage-allocation-modal-overlay-form__checkbox--checked': rule.saturday}]})])])])})],2)])],1)])])}
var ManageAllocationModalOverlayForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-exclamation-triangle"})])}]

// CONCATENATED MODULE: ./src/components/ManageAllocationModalOverlayForm/ManageAllocationModalOverlayForm.vue
/* script */


/* template */

/* template functional */
var ManageAllocationModalOverlayForm___vue_template_functional__ = false
/* styles */
var ManageAllocationModalOverlayForm___vue_styles__ = null
/* scopeId */
var ManageAllocationModalOverlayForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationModalOverlayForm___vue_module_identifier__ = null

var ManageAllocationModalOverlayForm_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationModalOverlayForm,
  ManageAllocationModalOverlayForm_render,
  ManageAllocationModalOverlayForm_staticRenderFns,
  ManageAllocationModalOverlayForm___vue_template_functional__,
  ManageAllocationModalOverlayForm___vue_styles__,
  ManageAllocationModalOverlayForm___vue_scopeId__,
  ManageAllocationModalOverlayForm___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationModalOverlayForm_ManageAllocationModalOverlayForm = (ManageAllocationModalOverlayForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationModalOverlay/ManageAllocationModalOverlay.vue
var ManageAllocationModalOverlay__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ManageAllocationModalOverlay = ({
    components: {
        ManageAllocationModalOverlayForm: ManageAllocationModalOverlayForm_ManageAllocationModalOverlayForm
    },
    computed: ManageAllocationModalOverlay__extends({}, Object(vuex_esm["mapState"])({
        open: function open(state) {
            return state.allocation.modal.overlay.open;
        }
    })),
    methods: ManageAllocationModalOverlay__extends({}, Object(vuex_esm["mapActions"])({
        toggleModalOverlay: 'allocation/toggleModalOverlay'
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64068bcf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationModalOverlay/ManageAllocationModalOverlay.vue
var ManageAllocationModalOverlay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-modal-overlay"},[_c('transition',{attrs:{"name":"slide-in"}},[(_vm.open)?_c('div',{staticClass:"manage-allocation-modal-overlay__content"},[_c('div',{staticClass:"manage-allocation-modal-overlay__header"},[_c('div',{staticClass:"manage-allocation-modal-overlay__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModalOverlay.header.heading'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay__toggle",on:{"click":_vm.toggleModalOverlay}},[_c('i',{staticClass:"fa fa-chevron-left"})])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal-overlay__body"},[_c('manage-allocation-modal-overlay-form')],1)]):_vm._e()])],1)}
var ManageAllocationModalOverlay_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationModalOverlay/ManageAllocationModalOverlay.vue
/* script */


/* template */

/* template functional */
var ManageAllocationModalOverlay___vue_template_functional__ = false
/* styles */
var ManageAllocationModalOverlay___vue_styles__ = null
/* scopeId */
var ManageAllocationModalOverlay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationModalOverlay___vue_module_identifier__ = null

var ManageAllocationModalOverlay_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationModalOverlay,
  ManageAllocationModalOverlay_render,
  ManageAllocationModalOverlay_staticRenderFns,
  ManageAllocationModalOverlay___vue_template_functional__,
  ManageAllocationModalOverlay___vue_styles__,
  ManageAllocationModalOverlay___vue_scopeId__,
  ManageAllocationModalOverlay___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationModalOverlay_ManageAllocationModalOverlay = (ManageAllocationModalOverlay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationModal/ManageAllocationModal.vue
var ManageAllocationModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var ManageAllocationModal = ({
    components: {
        ManageAllocationModalForm: ManageAllocationModalForm_ManageAllocationModalForm,
        ManageAllocationModalList: ManageAllocationModalList_ManageAllocationModalList,
        ManageAllocationModalOverlay: ManageAllocationModalOverlay_ManageAllocationModalOverlay
    },
    computed: ManageAllocationModal__extends({}, Object(vuex_esm["mapState"])({
        open: function open(state) {
            return state.allocation.modal.open;
        },
        from: function from(state) {
            return state.allocation.calendar.from;
        },
        to: function to(state) {
            return state.allocation.calendar.to;
        },
        error: function error(state) {
            return state.allocation.form.allocations.error;
        },
        errorMessage: function errorMessage(state) {
            return state.allocation.form.allocations.text;
        },
        validationError: function validationError(state) {
            return state.allocation.form.validator.error;
        },
        success: function success(state) {
            return state.allocation.modal.success;
        },
        blocked: function blocked(state) {
            return state.allocation.modal.blocked;
        },
        overlaySuccess: function overlaySuccess(state) {
            return state.allocation.modal.overlay.success;
        },
        overlayFailure: function overlayFailure(state) {
            return state.allocation.modal.overlay.error;
        },
        overlayMessage: function overlayMessage(state) {
            return state.allocation.modal.overlay.message;
        },
        adding: function adding(state) {
            return state.allocation.modal.adding;
        },
        loading: function loading(state) {
            return state.allocation.allocations.loading;
        }
    }), Object(vuex_esm["mapGetters"])({
        allocationsInPeriod: 'allocation/allocationsInPeriodPaginated',
        allotmentInPeriod: 'allocation/allotmentInPeriod'
    })),
    created: function created() {
        window.addEventListener('keyup', this.keyPress);
    },

    methods: ManageAllocationModal__extends({}, Object(vuex_esm["mapActions"])({
        toggleModal: 'allocation/toggleModal',
        toggleAddAllocation: 'allocation/toggleModalAddAllocations'
    }), {
        toggle: function toggle($event) {
            if ($event.target.id === 'container') {
                this.toggleModal();
            }
        },
        keyPress: function keyPress(key) {
            if (key.key === 'Escape' && this.open) {
                this.toggleModal();
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d382b08","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationModal/ManageAllocationModal.vue
var ManageAllocationModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{staticClass:"manage-allocation-modal",on:{"click":function($event){return _vm.toggle($event)}}},[_c('div',{staticClass:"manage-allocation-modal__container",attrs:{"id":"container"}},[_c('div',{staticClass:"manage-allocation-modal__content"},[_c('div',{staticClass:"manage-allocation-modal__header"},[_c('div',{staticClass:"manage-allocation-modal__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModal.header.heading'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal__toggle",on:{"click":_vm.toggleModal}},[_c('i',{staticClass:"fa fa-times-circle"})])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal__body"},[((_vm.allocationsInPeriod.length === 0 || !_vm.allotmentInPeriod) && !_vm.loading)?_c('div',{staticClass:"manage-allocation-modal__title"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModal.noAllocations'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.allocationsInPeriod.length > 0 && _vm.allotmentInPeriod)?_c('div',{staticClass:"manage-allocation-modal__title"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModal.allocations'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"manage-allocation-modal__title"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModal.loading'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal__period"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModal.period'))+" "+_vm._s(_vm.from)+" "+_vm._s(_vm.$t('manageAllocationModal.dash'))+" "+_vm._s(_vm.to)+"\n                ")]),_vm._v(" "),(_vm.allocationsInPeriod.length === 0)?_c('div',{staticClass:"manage-allocation-modal__no-allocations"},[(!_vm.adding && !_vm.loading)?_c('div',{staticClass:"manage-allocation-modal__add"},[_c('button',{staticClass:"manage-allocation-modal__add-btn",on:{"click":function($event){return _vm.toggleAddAllocation()}}},[_vm._v("\n                            "+_vm._s(_vm.$t('manageAllocationModal.buttons.add'))+"\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-modal__info"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('manageAllocationModal.info'))}})])]):_vm._e(),_vm._v(" "),(_vm.adding)?_c('manage-allocation-modal-form'):_vm._e(),_vm._v(" "),_c('manage-allocation-modal-overlay'),_vm._v(" "),(_vm.allocationsInPeriod.length > 0)?_c('div',{staticClass:"manage-allocation-modal__allocations"},[_c('manage-allocation-modal-list')],1):_vm._e(),_vm._v(" "),(_vm.success && !_vm.validationError)?_c('div',{staticClass:"manage-allocation-modal__success"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModal.success'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.blocked && !_vm.validationError)?_c('div',{staticClass:"manage-allocation-modal__success"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationModal.blocked'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.overlaySuccess || _vm.overlayFailure)?_c('div',{staticClass:"manage-allocation-modal__alert",class:'manage-allocation-modal__' + _vm.overlayMessage.level},[_vm._v("\n                    "+_vm._s(_vm.$t( _vm.overlayMessage.text ))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"manage-allocation-modal__error"},[_vm._v("\n                    "+_vm._s(_vm.$t(_vm.errorMessage))+"\n                ")]):_vm._e()],1)])])]):_vm._e()}
var ManageAllocationModal_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationModal/ManageAllocationModal.vue
/* script */


/* template */

/* template functional */
var ManageAllocationModal___vue_template_functional__ = false
/* styles */
var ManageAllocationModal___vue_styles__ = null
/* scopeId */
var ManageAllocationModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationModal___vue_module_identifier__ = null

var ManageAllocationModal_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationModal,
  ManageAllocationModal_render,
  ManageAllocationModal_staticRenderFns,
  ManageAllocationModal___vue_template_functional__,
  ManageAllocationModal___vue_styles__,
  ManageAllocationModal___vue_scopeId__,
  ManageAllocationModal___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationModal_ManageAllocationModal = (ManageAllocationModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationRequestForm/ManageAllocationRequestForm.vue
var ManageAllocationRequestForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var ManageAllocationRequestForm = ({
    components: {
        ManageAllocationFormHeader: ManageAllocationFormHeader,
        ManageAllocationFormAccept: ManageAllocationFormAccept_ManageAllocationFormAccept
    },
    computed: ManageAllocationRequestForm__extends({}, Object(vuex_esm["mapState"])({
        item: function item(state) {
            return state.allocation.request.item;
        },
        itemIndex: function itemIndex(state) {
            return state.allocation.request.itemIndex;
        },
        items: function items(state) {
            return state.allocation.request.items.pending;
        },
        editMode: function editMode(state) {
            return state.allocation.request.editMode;
        }
    }), {
        releaseDateClasses: function releaseDateClasses() {
            return {
                'manage-allocation-request-form__units--error': this.$v.item.changes.release.releaseDate.$dirty && this.$v.item.changes.release.releaseDate.$error,
                'manage-allocation-request-form__units--success': this.$v.item.changes.release.releaseDate.$dirty && !this.$v.item.changes.release.releaseDate.$error
            };
        }
    }),
    methods: ManageAllocationRequestForm__extends({}, Object(vuex_esm["mapActions"])({
        submit: 'allocation/submitForm',
        requestItemSet: 'allocation/requestItemSet',
        requestAcceptModify: 'allocation/requestAcceptModify',
        requestEditToggle: 'allocation/requestEditToggle'
    }), {
        update: function update(obj) {
            this.$v.$touch();
            this.requestItemSet(obj);
        }
    }),
    validations: function validations() {
        var _this = this;

        return {
            item: {
                changes: {
                    release: {
                        releaseDate: {
                            valid: function valid(value) {
                                return !_this.items[_this.itemIndex].changes.release.releaseDate || value.length === 10;
                            },
                            validateValidDate: function validateValidDate(date) {
                                return !_this.items[_this.itemIndex].changes.release.releaseDate || Object(ValidatorService["validateValidDate"])(date);
                            }
                        }
                    }
                }
            }
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d92b37","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationRequestForm/ManageAllocationRequestForm.vue
var ManageAllocationRequestForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-request-form"},[(_vm.editMode)?_c('div',{staticClass:"manage-allocation-request-form__content"},[_c('div',{staticClass:"manage-allocation-request-form__header"},[_c('div',{staticClass:"manage-allocation-request-form__left"},[_c('div',{staticClass:"manage-allocation-request-form__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationRequest.form.header.heading'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request-form__right"},[_c('div',{staticClass:"manage-allocation-request-form__toggle",on:{"click":function($event){return _vm.requestEditToggle(false)}}},[_c('i',{staticClass:"fa fa-chevron-left"})])])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request-form__body"},[_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationRequest.form.body'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request-form__period"},[_c('div',{staticClass:"manage-allocation-request-form__period-title"},[_vm._v("\n                "+_vm._s(_vm.$t('manageAllocationRequest.form.period.title'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request-form__period-body"},[_vm._v("\n                "+_vm._s(_vm.item.from)+" - "+_vm._s(_vm.item.to)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request-form__fields"},[_c('div',{staticClass:"manage-allocation-request-form__field"},[_c('div',{staticClass:"manage-allocation-request-form__label"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationRequest.form.labels.units'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-request-form__increment-btn",attrs:{"disabled":!_vm.items[_vm.itemIndex].changes.deduction.requested},on:{"click":function($event){return _vm.update({deduction: {units: _vm.item.changes.deduction.units - 1}})}}},[_vm._v("\n                    -\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-request-form__input manage-allocation-request-form__units",attrs:{"disabled":!_vm.items[_vm.itemIndex].changes.deduction.requested,"type":"text"},domProps:{"value":_vm.item.changes.deduction.units ? _vm.item.changes.deduction.units : 0},on:{"input":function($event){return _vm.update({deduction: {units: $event.target.value}})}}}),_vm._v(" "),_c('button',{staticClass:"manage-allocation-request-form__decrement-btn",attrs:{"disabled":!_vm.items[_vm.itemIndex].changes.deduction.requested},on:{"click":function($event){_vm.update({deduction: {units: parseInt(_vm.item.changes.deduction.units) + 1}})}}},[_vm._v("\n                    +\n                ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request-form__field"},[_c('div',{staticClass:"manage-allocation-request-form__label"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationRequest.form.labels.release'))+"\n                ")]),_vm._v(" "),(_vm.items[_vm.itemIndex].changes.release.releaseDate)?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"manage-allocation-request-form__input",class:_vm.releaseDateClasses,attrs:{"placeholder":'##/##/####',"type":"text"},domProps:{"value":_vm.item.changes.release.releaseDate},on:{"input":function($event){return _vm.update({release: {releaseDate: $event.target.value}})}}}):_vm._e(),_vm._v(" "),(_vm.items[_vm.itemIndex].changes.release.releaseDays)?_c('button',{staticClass:"manage-allocation-request-form__increment-btn",on:{"click":function($event){return _vm.update({release: {releaseDays: _vm.item.changes.release.releaseDays - 1}})}}},[_vm._v("\n                    -\n                ")]):_vm._e(),_vm._v(" "),(_vm.items[_vm.itemIndex].changes.release.releaseDays)?_c('input',{directives:[{name:"number-only",rawName:"v-number-only"}],staticClass:"manage-allocation-request-form__input manage-allocation-request-form__units",attrs:{"placeholder":'days',"type":"text"},domProps:{"value":_vm.item.changes.release.releaseDays},on:{"input":function($event){return _vm.update({release: {releaseDays: $event.target.value}})}}}):_vm._e(),_vm._v(" "),(_vm.items[_vm.itemIndex].changes.release.releaseDays)?_c('button',{staticClass:"manage-allocation-request-form__decrement-btn",on:{"click":function($event){_vm.update({release: {releaseDays: parseInt(_vm.item.changes.release.releaseDays) + 1}})}}},[_vm._v("\n                    +\n                ")]):_vm._e(),_vm._v(" "),(!_vm.items[_vm.itemIndex].changes.release.releaseDays && !_vm.item.changes.release.releaseDate)?_c('input',{staticClass:"manage-allocation-request-form__input",attrs:{"disabled":true,"type":"text"},domProps:{"value":'n/a'}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request-form__controls"},[_c('div',{staticClass:"manage-allocation-request-form__button-group"},[_c('button',{staticClass:"manage-allocation-request-form__button-accept",attrs:{"disabled":_vm.$v.$error},on:{"click":_vm.requestAcceptModify}},[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.form.buttons.accept')))]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-request-form__button-cancel",on:{"click":function($event){return _vm.requestEditToggle(false)}}},[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.form.buttons.cancel')))])])])]):_vm._e()])}
var ManageAllocationRequestForm_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationRequestForm/ManageAllocationRequestForm.vue
/* script */


/* template */

/* template functional */
var ManageAllocationRequestForm___vue_template_functional__ = false
/* styles */
var ManageAllocationRequestForm___vue_styles__ = null
/* scopeId */
var ManageAllocationRequestForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationRequestForm___vue_module_identifier__ = null

var ManageAllocationRequestForm_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationRequestForm,
  ManageAllocationRequestForm_render,
  ManageAllocationRequestForm_staticRenderFns,
  ManageAllocationRequestForm___vue_template_functional__,
  ManageAllocationRequestForm___vue_styles__,
  ManageAllocationRequestForm___vue_scopeId__,
  ManageAllocationRequestForm___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationRequestForm_ManageAllocationRequestForm = (ManageAllocationRequestForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationRequest/ManageAllocationRequest.vue
var ManageAllocationRequest__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ var ManageAllocationRequest = ({
    components: {
        PaginationControl: PaginationControl["a" /* default */],
        DropDownMenu: DropdownMenu["a" /* default */],
        ManageAllocationRequestForm: ManageAllocationRequestForm_ManageAllocationRequestForm
    },
    filters: {
        blockFilter: function blockFilter(bool) {
            return bool ? 'X' : null;
        }
    },
    data: function data() {
        return {
            open: false
        };
    },

    computed: ManageAllocationRequest__extends({}, Object(vuex_esm["mapState"])({
        pending: function pending(state) {
            return state.allocation.request.items.pending;
        },
        accepted: function accepted(state) {
            return state.allocation.request.items.approved;
        },
        declined: function declined(state) {
            return state.allocation.request.items.denied;
        },
        modified: function modified(state) {
            return state.allocation.request.items.modified;
        },
        predicate: function predicate(state) {
            return state.allocation.request.predicate;
        },
        predicates: function predicates(state) {
            return state.allocation.request.predicates;
        },
        item: function item(state) {
            return state.allocation.request.item;
        },
        page: function page(state) {
            return state.allocation.request.page;
        },
        limit: function limit(state) {
            return state.allocation.request.limit;
        },
        contractManager: function contractManager(state) {
            return state.auth.user.contractManager;
        },
        editMode: function editMode(state) {
            return state.allocation.request.editMode;
        },
        trusted: function trusted(state) {
            return state.auth.supplier.trusted;
        }
    }), Object(vuex_esm["mapGetters"])({
        requestCount: 'allocation/requestCount',
        requestsPaginated: 'allocation/requestsPaginated',
        requestsMaxPages: 'allocation/requestsMaxPages'
    })),
    methods: ManageAllocationRequest__extends({}, Object(vuex_esm["mapActions"])({
        requestAccept: 'allocation/requestAccept',
        requestAcceptModified: 'allocation/requestAcceptModified',
        requestDeny: 'allocation/requestDeny',
        requestEdit: 'allocation/requestEdit',
        requestCancel: 'allocation/requestCancel',
        requestPredicateSet: 'allocation/requestPredicateSet',
        requestPageIncrement: 'allocation/requestPageIncrement',
        requestPageDecrement: 'allocation/requestPageDecrement',
        requestItemSelect: 'allocation/requestItemSelect',
        requestEditToggle: 'allocation/requestEditToggle'
    }), {
        enableEdit: function enableEdit(request, index) {
            var indices = Object(DateToolService["getCalendarHighlightIndices"])(request);
            this.requestItemSelect({ request: request, index: index + (this.page - 1) * this.limit, indices: indices });
            this.requestEditToggle();
        },
        handleRequest: function handleRequest(action, requestId) {
            var _this = this;

            switch (action) {
                case 'accept':
                    this.requestAccept(requestId).then(function () {
                        _this.fetchData();
                    });
                    break;
                case 'deny':
                    this.requestDeny(requestId).then(function () {
                        _this.fetchData();
                    });
                    break;
                case 'cancel':
                    this.requestCancel(requestId).then(function () {
                        _this.fetchData();
                    });
                    break;
            }
        },
        fetchData: function fetchData() {
            Promise.all([this.getAllocationList(), this.getAllocationListMerged(), this.getAllocationCalendar()]);
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6057d24d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationRequest/ManageAllocationRequest.vue
var ManageAllocationRequest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.trusted)?_c('div',{staticClass:"manage-allocation-request",class:{'manage-allocation-request--open' : _vm.open}},[_c('div',{staticClass:"manage-allocation-request__toggle",on:{"click":function($event){_vm.open = !_vm.open}}},[_c('span',[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.toggle'))+" ")]),_vm._v(" "),_c('span',{staticClass:"manage-allocation-request__news"},[_vm._v("\n            "+_vm._s(_vm.requestCount[0])+"\n        ")])]),_vm._v(" "),_c('manage-allocation-request-form'),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request__content"},[_c('div',{staticClass:"manage-allocation-request__header"},[_c('div',{staticClass:"manage-allocation-request__left"},[_c('div',{staticClass:"manage-allocation-request__heading"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationRequest.heading'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request__right"},[_c('drop-down-menu',{attrs:{"label":_vm.$t('manageAllocationRequest.dropdown.label'),"value":_vm.predicate,"items":_vm.predicates,"items-counts":_vm.requestCount,"translation-prefix":'manageAllocationRequest.dropdown'},on:{"input":function($event){return _vm.requestPredicateSet($event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request__list"},[(!_vm.editMode)?_c('table',{staticClass:"manage-allocation-request__table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.table.requestDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.table.period')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.table.deduction')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.table.release')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.table.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('manageAllocationRequest.table.block')))]),_vm._v(" "),(_vm.predicate === 'pending')?_c('th'):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.requestsPaginated),function(request,index){return _c('tr',{key:request.id},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(request.requestDate,"DD/MM/YYYY")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(request.from,"DD/MM/YYYY"))+" - "+_vm._s(_vm._f("moment")(request.to,"DD/MM/YYYY")))]),_vm._v(" "),_c('td',[(request.changes.deduction.units)?_c('span',[_vm._v("\n                                "+_vm._s(request.changes.deduction.units)+" "+_vm._s(_vm.$t('manageAllocationRequest.units'))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.predicate === 'modified' && request.modified.changes.deduction.units)?_c('span',[_vm._v("\n                                ("+_vm._s(request.modified.changes.deduction.units)+" "+_vm._s(_vm.$t('manageAllocationRequest.units'))+")\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[(request.changes.release.releaseDate)?_c('span',[_vm._v("\n                                "+_vm._s(_vm._f("moment")(request.changes.release.releaseDate,"DD/MM/YYYY"))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.predicate === 'modified' && request.modified.changes.release.releaseDate)?_c('span',[_vm._v("\n                                ("+_vm._s(_vm._f("moment")(request.modified.changes.release.releaseDate,"DD/MM/YYYY"))+")\n                            ")]):_vm._e(),_vm._v(" "),(request.changes.release.releaseDays)?_c('span',[_vm._v("\n                                "+_vm._s(request.changes.release.releaseDays)+" "+_vm._s(_vm.$t('manageAllocationRequest.releaseDays'))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.predicate === 'modified' && request.modified.changes.release.releaseDays)?_c('span',[_vm._v("\n                                ("+_vm._s(request.modified.changes.release.releaseDays)+" "+_vm._s(_vm.$t('manageAllocationRequest.releaseDays'))+")\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[(request.changes.type.originalType)?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationRequest.type.' + request.changes.type.originalType.toLowerCase()))+" >\n                            ")]):_vm._e(),_vm._v(" "),(request.changes.type.type)?_c('span',[_vm._v("\n                                "+_vm._s(_vm.$t('manageAllocationRequest.type.' + request.changes.type.type.toLowerCase()))+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("blockFilter")(request.changes.block.requested)))]),_vm._v(" "),(_vm.predicate === 'pending')?_c('td',[(_vm.contractManager)?_c('div',{staticClass:"manage-allocation-request__contract-manager"},[_c('button',{staticClass:"manage-allocation-request__btn manage-allocation-request__btn-accept",on:{"click":function($event){return _vm.requestAccept(request.id)}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('manageAllocationRequest.buttons.accept'))+"\n                                ")]),_vm._v(" "),_c('button',{staticClass:"manage-allocation-request__btn manage-allocation-request__btn-deny",on:{"click":function($event){return _vm.requestDeny(request.id)}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('manageAllocationRequest.buttons.deny'))+"\n                                ")]),_vm._v(" "),(request.changes.deduction.requested || request.changes.release.requested)?_c('button',{staticClass:"manage-allocation-request__btn manage-allocation-request__btn-edit",on:{"click":function($event){return _vm.enableEdit(request, index)}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('manageAllocationRequest.buttons.edit'))+"\n                                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.contractManager)?_c('div',{staticClass:"manage-allocation-request__supplier"},[_c('button',{staticClass:"manage-allocation-request__btn manage-allocation-request__btn-deny",on:{"click":function($event){return _vm.requestCancel(request.id)}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('manageAllocationRequest.buttons.cancel'))+"\n                                ")])]):_vm._e()]):_vm._e()])}),0)]):_vm._e(),_vm._v(" "),(_vm.requestsPaginated.length === 0)?_c('div',{staticClass:"manage-allocation-request__no-content"},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request__no-content-body"},[_vm._v("\n                    "+_vm._s(_vm.$t('manageAllocationRequest.noContent'))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-request__controls"},[(_vm.requestsPaginated.length > 0 && !_vm.editMode)?_c('div',{staticClass:"manage-allocation-request__pagination"},[_c('pagination-control',{attrs:{"max-pages":_vm.requestsMaxPages,"current-page":_vm.page},on:{"prev":_vm.requestPageDecrement,"next":_vm.requestPageIncrement}})],1):_vm._e()])])])],1):_vm._e()}
var ManageAllocationRequest_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationRequest/ManageAllocationRequest.vue
/* script */


/* template */

/* template functional */
var ManageAllocationRequest___vue_template_functional__ = false
/* styles */
var ManageAllocationRequest___vue_styles__ = null
/* scopeId */
var ManageAllocationRequest___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationRequest___vue_module_identifier__ = null

var ManageAllocationRequest_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationRequest,
  ManageAllocationRequest_render,
  ManageAllocationRequest_staticRenderFns,
  ManageAllocationRequest___vue_template_functional__,
  ManageAllocationRequest___vue_styles__,
  ManageAllocationRequest___vue_scopeId__,
  ManageAllocationRequest___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationRequest_ManageAllocationRequest = (ManageAllocationRequest_Component.exports);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManageAllocationPage/ManageAllocationPage.vue
var ManageAllocationPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














/* harmony default export */ var ManageAllocationPage = ({
    components: {
        Loading: Loading["a" /* default */],
        ManageAllocationList: ManageAllocationList_ManageAllocationList,
        ManageAllocationForm: ManageAllocationForm_ManageAllocationForm,
        ManageAllocationFilters: ManageAllocationFilters_ManageAllocationFilters,
        ManageAllocationCalendar: ManageAllocationCalendar_ManageAllocationCalendar,
        ManageAllocationModal: ManageAllocationModal_ManageAllocationModal,
        ManageAllocationRequest: ManageAllocationRequest_ManageAllocationRequest,
        ManageAllocationCalendarInfoBox: ManageAllocationCalendarInfobox_ManageAllocationCalendarInfobox,
        InfoWidget: InfoWidget["a" /* default */],
        Alert: Alert["a" /* default */]
    },
    computed: ManageAllocationPage__extends({}, Object(vuex_esm["mapState"])({
        tips: function tips(state) {
            return state.allocation.manageAllocationPage.tips;
        },
        requestMessage: function requestMessage(state) {
            return state.allocation.request.message;
        },
        error: function error(state) {
            return state.allocation.data.error;
        },
        loading: function loading(state) {
            return state.allocation.data.loading;
        },
        timer: function timer(state) {
            return state.allocation.timer;
        },
        routeParams: function routeParams(state) {
            return state.route.params;
        },
        supplier: function supplier(state) {
            return state.auth.supplier;
        },
        sites: function sites(state) {
            return state.allocation.form.filters.sites;
        }
    })),
    created: function created() {
        var _this = this;

        var siteId = this.routeParams.siteId;
        var accommodationSiteId = this.routeParams.accommodationSiteId;
        this.getRouteFilters(accommodationSiteId).then(function () {
            _this.setRouteFilters({
                siteId: siteId,
                accommodationSiteId: accommodationSiteId
            });
        });
        this.fetchManageAllocationData(accommodationSiteId);
    },

    methods: ManageAllocationPage__extends({}, Object(vuex_esm["mapActions"])({
        countdown: 'allocation/countdown',
        resetState: 'allocation/resetState',
        getRouteFilters: 'allocation/getRouteFilters',
        setRouteFilters: 'allocation/setRouteFilters',
        setAccommodation: 'allocation/setAccommodation',
        setCalendarDates: 'allocation/setCalendarDates',
        setSelectedRouteFilters: 'allocation/setSelectedRouteFilters',
        fetchManageAllocationData: 'allocation/fetchManageAllocationData',
        updateProductAndSupplier: 'nav/updateProductAndSupplier'
    })),
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var params = to.params;
        store_default.a.dispatch('allocation/getRouteFilters', params.accommodationSiteId).then(function () {
            store_default.a.dispatch('allocation/setRouteFilters', {
                siteId: params.siteId,
                accommodationSiteId: params.accommodationSiteId
            });
        });
        store_default.a.dispatch('allocation/fetchManageAllocationData', params.accommodationSiteId);
        next();
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        Promise.all([this.$refs.infoWidget.clean()]).then(function () {
            next();
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0428bb30","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageAllocationPage/ManageAllocationPage.vue
var ManageAllocationPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-allocation-page"},[(_vm.error && !_vm.loading)?_c('div',{staticClass:"manage-allocation-page__error"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),_c('div',{staticClass:"manage-allocation-page__error-message"},[_vm._v(_vm._s(_vm.$t('manageAllocationPage.error')))])]):_vm._e(),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}}),_vm._v(" "),(!_vm.error)?_c('div',{staticClass:"manage-allocation-page__content"},[_c('manage-allocation-modal'),_vm._v(" "),_c('manage-allocation-request'),_vm._v(" "),_c('manage-allocation-filters'),_vm._v(" "),_c('manage-allocation-calendar-info-box'),_vm._v(" "),_c('manage-allocation-calendar'),_vm._v(" "),_c('manage-allocation-list'),_vm._v(" "),_c('alert',{attrs:{"translation-prefix":'manageAllocationPage'}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"manage-allocation-page__mobile"},[_c('div',{staticClass:"manage-allocation-page__mobile-content"},[_c('i',{staticClass:"fa fa-fw fa-exclamation-triangle"}),_vm._v("\n            "+_vm._s(_vm.$t('manageAllocationPage.mobile'))+"\n        ")])])],1)}
var ManageAllocationPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ManageAllocationPage/ManageAllocationPage.vue
/* script */


/* template */

/* template functional */
var ManageAllocationPage___vue_template_functional__ = false
/* styles */
var ManageAllocationPage___vue_styles__ = null
/* scopeId */
var ManageAllocationPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ManageAllocationPage___vue_module_identifier__ = null

var ManageAllocationPage_Component = Object(component_normalizer["a" /* default */])(
  ManageAllocationPage,
  ManageAllocationPage_render,
  ManageAllocationPage_staticRenderFns,
  ManageAllocationPage___vue_template_functional__,
  ManageAllocationPage___vue_styles__,
  ManageAllocationPage___vue_scopeId__,
  ManageAllocationPage___vue_module_identifier__
)

/* harmony default export */ var ManageAllocationPage_ManageAllocationPage = __webpack_exports__["default"] = (ManageAllocationPage_Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "green.jpg?3dd1e1d693bcbb0368d2e274283043f0";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "yellow.jpg?137bbe94183becaece1fe8079707d0a2";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "red.jpg?9106c1a896f778061f4778570744ef1c";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "select.jpg?08aba8a656d93c95dd57601596fdebb5";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "modal.jpg?18350fa6dedd8e6aeaad9882a6b06f6f";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "added.jpg?a35e3b37e19fb1dc5d3135dca3d07491";

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/ContractManagementList/ContractManagementList.vue + 8 modules
var ContractManagementList = __webpack_require__(210);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementPage/ContractManagementPage.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var ContractManagementPage = (vue_esm["default"].extend({
    components: {
        ContractManagementList: ContractManagementList["a" /* default */],
        InfoWidget: InfoWidget["a" /* default */],
        Loading: Loading["a" /* default */]
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        tips: function tips(state) {
            return state.booking.bookings.tips;
        },
        items: function items(state) {
            return state.contract.overview.items;
        },
        listLoading: function listLoading(state) {
            return state.contract.overview.loading;
        }
    })),
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        store_default.a.dispatch('contract/getContractYears').then(function () {
            next();
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        Promise.all([this.$refs.infoWidget.clean()]).then(function () {
            next();
        });
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f10f3c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementPage/ContractManagementPage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-page"},[(_vm.listLoading)?_c('loading'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('contract-management-list')],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"})])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/ContractManagementPage/ContractManagementPage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ContractManagementPage,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ContractManagementPage_ContractManagementPage = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/Alert/Alert.vue + 2 modules
var Alert = __webpack_require__(66);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/InfoWidget/InfoWidget.vue + 2 modules
var InfoWidget = __webpack_require__(37);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/lodash-es/lodash.js + 631 modules
var lodash = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AutoComplete/AutoComplete.vue



/* harmony default export */ var AutoComplete = ({
    props: {
        input: {
            type: Object,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            required: true
        },
        values: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            toggled: false,
            listIndex: -1
        };
    },

    methods: {
        toggle: function toggle($event) {
            var _this = this;

            if ($event.target.classList.contains('auto-complete__input-field')) {
                this.toggled = !this.toggled;

                if (this.toggled) {
                    this.$nextTick(function () {
                        document.addEventListener('click', _this.close);
                    });
                }
            }
        },
        change: function change(value) {
            this.$emit('change', value);
        },
        filteredList: function filteredList() {
            var _this2 = this;

            return Object(lodash["filter"])(this.items, function (item) {
                var inputLower = _this2.input.name ? _this2.input.name.toLowerCase() : '';
                var exist = Object(lodash["filter"])(_this2.values, function (value) {
                    return (value.name ? value.name.toLowerCase() : '') === item.name.toLowerCase() && value.id === item.id;
                }).length > 0;
                if (item.area) {
                    return !exist && (item.name.toLowerCase().indexOf(inputLower) !== -1 || item.area.toLowerCase().indexOf(inputLower) !== -1);
                } else {
                    return !exist && item.name.toLowerCase().indexOf(inputLower) !== -1 && item.name.toLowerCase() !== inputLower;
                }
            });
        },
        select: function select(value) {
            this.toggled = false;
            this.$emit('change', value);
        },
        keys: function keys(key) {
            switch (key) {
                case 'ArrowDown':
                    this.scroll();
                    this.listIndex < this.filteredList().length - 1 ? this.listIndex++ : null;
                    break;
                case 'ArrowUp':
                    this.scroll();
                    this.listIndex > -1 ? this.listIndex-- : null;
                    break;
                case 'Enter':
                    this.toggled = false;
                    if (this.listIndex !== -1) {
                        this.$emit('change', this.filteredList()[this.listIndex]);
                        this.listIndex = -1;
                    }
                    break;
                case 'Backspace':
                    this.toggled = true;
                    break;
                case 'Escape':
                    this.toggled = false;
                    break;
                default:
                    break;
            }
        },
        hide: function hide() {
            if (this.listIndex === -1) {
                this.toggled = false;
            }
        },
        scroll: function scroll() {
            var listElement = document.getElementById('auto-complete__list');
            listElement.scrollTop = this.listIndex * 50 - 50;
        },
        close: function close($event) {
            this.toggled = false;
            $event.currentTarget.removeEventListener('click', this.close);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638b1834","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoComplete/AutoComplete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auto-complete"},[_c('div',{staticClass:"auto-complete__content"},[_c('div',{staticClass:"auto-complete__input"},[(_vm.input.name && !_vm.input.id)?_c('span',{staticClass:"auto-complete__input-icon"},[_c('i',{staticClass:"fa fa-exclamation-triangle"})]):_vm._e(),_vm._v(" "),_c('input',{staticClass:"auto-complete__input-field",attrs:{"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":_vm.input.name},on:{"click":function($event){return _vm.toggle($event)},"input":function($event){return _vm.change({name: $event.target.value, id: null})},"keydown":function($event){return _vm.keys($event.key)},"blur":function($event){return _vm.hide()}}})]),_vm._v(" "),_c('div',{staticClass:"auto-complete__drop-down"},[(_vm.toggled)?_c('div',{staticClass:"auto-complete__list",attrs:{"id":"auto-complete__list"}},_vm._l((_vm.filteredList()),function(item,index){return _c('div',{key:index,staticClass:"auto-complete__choice",class:{'auto-complete__choice--active' : index === _vm.listIndex},on:{"click":function($event){return _vm.select(item)},"mouseenter":function($event){_vm.listIndex = index},"mouseleave":function($event){_vm.listIndex = -1}}},[_c('span',{staticClass:"auto-complete__item-value"},[_vm._v("\n                        "+_vm._s(item.name)+"\n                        "),(item.area)?_c('span',[_vm._v(" ("+_vm._s(item.area)+")")]):_vm._e()])])}),0):_vm._e()])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/AutoComplete/AutoComplete.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  AutoComplete,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var AutoComplete_AutoComplete = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AutoCompleteMulti/AutoCompleteMulti.vue



/* harmony default export */ var AutoCompleteMulti = ({
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            required: true
        },
        values: {
            type: Array,
            required: true
        },
        valueAttribute: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            toggled: false,
            index: -1,
            listIndex: -1,
            suggestion: undefined,
            list: [],
            noResult: false,
            input: ''
        };
    },

    methods: {
        toggle: function toggle($event) {
            var _this = this;

            if ($event.target.classList.contains('auto-complete-multi__input-field')) {
                this.toggled = !this.toggled;

                if (this.toggled) {
                    this.$nextTick(function () {
                        document.addEventListener('click', _this.close);
                    });
                }
            }
        },
        filteredList: function filteredList() {
            var _this2 = this;

            return Object(lodash["filter"])(this.items, function (item) {
                var inputLower = _this2.input ? _this2.input.toLowerCase() : '';
                var exist = Object(lodash["filter"])(_this2.values, function (value) {
                    return value.name.toLowerCase() === item.name.toLowerCase();
                }).length > 0;
                return !exist && item.name && item.name.toLowerCase().indexOf(inputLower) === 0;
            });
        },
        clearInput: function clearInput() {
            document.getElementById('auto-complete-multi__input-field').value = '';
            this.input = '';
            this.toggled = false;
            this.index = -1;
            this.listIndex = -1;
            this.noResult = false;
            this.suggestion = undefined;
        },
        keys: function keys(key) {
            switch (key) {
                case 'ArrowDown':
                    this.index < this.filteredList().length - 1 ? this.index++ : null;
                    this.setSuggestion();
                    this.scroll();
                    break;
                case 'ArrowUp':
                    this.index > -1 ? this.index-- : null;
                    this.setSuggestion();
                    this.scroll();
                    break;
                case 'Escape':
                    this.clearInput();
                    document.getElementById('auto-complete-multi__input-field').blur();
                    break;
                case 'Enter':
                    if (this.listIndex !== -1) {
                        this.add(this.items[this.listIndex]);
                        this.clearInput();
                    } else {
                        this.noResult = true;
                    }
                    break;
                case 'ArrowRight':
                    document.getElementById('auto-complete-multi__input-field').value = this.suggestion.name;
                    this.input = this.suggestion.name;
                    break;
                case 'Backspace':
                    this.noResult = false;
                    break;
                default:
                    this.toggled = true;
                    break;
            }
        },
        fill: function fill(value) {
            this.input = value;
            if (value) {
                // Set the suggestion to first element that matches
                this.suggestion = this.filteredList()[0];
                // Set index to suggested value
                this.listIndex = this.suggestion ? this.items.indexOf(this.suggestion) : -1;
            } else {
                this.suggestion = undefined;
                this.listIndex = -1;
            }
        },
        add: function add(value) {
            this.clearInput();
            this.$emit('add', value);
        },
        remove: function remove(index) {
            this.$emit('remove', index);
        },
        scroll: function scroll() {
            var listElement = document.getElementById('auto-complete-multi__list');
            listElement.scrollTop = this.index * 50 - 50;
        },
        close: function close($event) {
            this.toggled = false;
            $event.currentTarget.removeEventListener('click', this.close);
        },
        setSuggestion: function setSuggestion() {
            this.suggestion = this.filteredList()[this.index];
            this.listIndex = this.items.indexOf(this.suggestion);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185e8fad","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoCompleteMulti/AutoCompleteMulti.vue
var AutoCompleteMulti_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auto-complete-multi"},[_c('div',{staticClass:"auto-complete-multi__selected-items"},[_c('transition-group',{attrs:{"name":"fade","tyep":"in-out"}},_vm._l((_vm.values),function(val,index){return _c('span',{key:'selected-items__' + index,staticClass:"auto-complete-multi__item"},[_c('i',{staticClass:"fa fa-times-circle auto-complete-multi__item-remove",on:{"click":function($event){return _vm.remove(index)}}}),_vm._v(" "+_vm._s(val[_vm.valueAttribute])+"\n            ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"auto-complete-multi__input-fields"},[_c('input',{staticClass:"auto-complete-multi__input auto-complete-multi__input-field",class:{'auto-complete-multi__input-field--no-result': _vm.input && _vm.noResult},attrs:{"id":"auto-complete-multi__input-field","placeholder":_vm.placeholder,"type":"text"},on:{"click":function($event){return _vm.toggle($event)},"input":function($event){return _vm.fill($event.target.value)},"keydown":function($event){return _vm.keys($event.key)}}}),_vm._v(" "),(_vm.suggestion && _vm.input)?_c('span',{staticClass:"auto-complete-multi__input auto-complete-multi__input-pseudo"},[_vm._v("\n            "+_vm._s(_vm.suggestion.name)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"auto-complete-multi__drop-down"},[(_vm.toggled)?_c('div',{staticClass:"auto-complete-multi__list",attrs:{"id":"auto-complete-multi__list"}},_vm._l((_vm.filteredList()),function(item,i){return _c('div',{key:'choice__' + i,staticClass:"auto-complete-multi__choice",class:{'auto-complete__choice--active' : i === _vm.index},on:{"click":function($event){return _vm.add(item)}}},[_vm._v("\n                "+_vm._s(item.name)+"\n                "),(item.area)?_c('span',[_vm._v(" ("+_vm._s(item.area)+")")]):_vm._e()])}),0):_vm._e()])])}
var AutoCompleteMulti_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/AutoCompleteMulti/AutoCompleteMulti.vue
/* script */


/* template */

/* template functional */
var AutoCompleteMulti___vue_template_functional__ = false
/* styles */
var AutoCompleteMulti___vue_styles__ = null
/* scopeId */
var AutoCompleteMulti___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AutoCompleteMulti___vue_module_identifier__ = null

var AutoCompleteMulti_Component = Object(component_normalizer["a" /* default */])(
  AutoCompleteMulti,
  AutoCompleteMulti_render,
  AutoCompleteMulti_staticRenderFns,
  AutoCompleteMulti___vue_template_functional__,
  AutoCompleteMulti___vue_styles__,
  AutoCompleteMulti___vue_scopeId__,
  AutoCompleteMulti___vue_module_identifier__
)

/* harmony default export */ var AutoCompleteMulti_AutoCompleteMulti = (AutoCompleteMulti_Component.exports);

// EXTERNAL MODULE: ./src/components/ContractManagementList/ContractManagementList.vue + 8 modules
var ContractManagementList = __webpack_require__(210);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditUpload/ContractManagementEditUpload.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractManagementEditUpload = (vue_esm["default"].extend({
    filters: {
        fileName: function fileName(path) {
            return path.substring(path.indexOf('_') + 1, path.length);
        }
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        form: function form(state) {
            return state.contract.contractManagement.form;
        },
        contract: function contract(state) {
            return state.contract;
        }
    }), {
        filesList: {
            get: function get() {
                return this.form.part === 'basic' || this.form.subPart === 'arrivalDeparture' ? this.form[this.form.part][this.form.subPart].files : this.form[this.form.part][this.form.subPart][this.form.index].files;
            }
        },
        s3: {
            get: function get() {
                return this.form.part === 'basic' || this.form.subPart === 'arrivalDeparture' ? this.form[this.form.part][this.form.subPart].s3 : this.form[this.form.part][this.form.subPart][this.form.index].s3;
            }
        }
    }),
    watch: {
        contract: {
            handler: function handler() {
                this.resize();
            },

            deep: true
        }
    },
    mounted: function mounted() {
        this.resize();
    },

    methods: _extends({}, Object(vuex_esm["mapActions"])({
        contractManagementFormSet: 'contract/contractManagementFormSet',
        contractManagementFormFileRemove: 'contract/contractManagementFormFileRemove',
        contractManagementFormFileDelete: 'contract/contractManagementFormFileDelete',
        contractManagementFormFileDownload: 'contract/contractManagementFormFileDownload'
    }), {
        add: function add(obj) {
            this.contractManagementFormSet(obj);
            // Clear the input field value to ensure that the upload drag and drop works
            // when remove and then re-insert same file
            document.getElementById('contract-management-edit-upload__input-file').value = "";
        },
        deleteFile: function deleteFile(obj) {
            var confirm = window.confirm(this.$t('contractManagement.edit.form.upload.confirm'));
            if (confirm) {
                this.contractManagementFormFileDelete(obj);
            }
        },
        resize: function resize() {
            if (this.fileList || this.s3) {
                var elementCount = this.filesList.length + this.s3.length;
                var element = document.getElementById('contract-management-edit-upload__input-file');
                if (element) {
                    element.style.height = elementCount * 30 + 'px';
                }
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-665bc856","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditUpload/ContractManagementEditUpload.vue
var ContractManagementEditUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form.subPart !== 'notes')?_c('div',{staticClass:"contract-management-edit-upload"},[_c('div',{staticClass:"contract-management-edit-upload__content"},[_c('div',{staticClass:"contract-management-edit-upload__dropbox",attrs:{"id":"contract-management-edit-upload__dropbox"}},[_c('input',{staticClass:"contract-management-edit-upload__input-file",attrs:{"id":"contract-management-edit-upload__input-file","name":_vm.form.subPart,"type":"file","multiple":"","accept":".xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf"},on:{"change":function($event){return _vm.add({part: _vm.form.part, subPart: _vm.form.subPart, files: $event.target.files})}}}),_vm._v(" "),(_vm.filesList.length === 0 && _vm.s3.length === 0)?_c('div',{staticClass:"contract-management-edit-upload__text"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"contract-management-edit-upload__initial"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.upload.initial')))]),_vm._v(" "),_c('p',{staticClass:"contract-management-edit-upload__accepted"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.upload.accepted')))])]):_vm._e(),_vm._v(" "),(_vm.filesList.length > 0 || _vm.s3.length > 0)?_c('div',[_c('ul',{staticClass:"contract-management-edit-upload__file-list"},[_vm._l((_vm.filesList),function(file,index){return _c('li',{key:'upload_' + index},[_c('span',{staticClass:"contract-management-edit-upload__btn contract-management-edit-upload__remove-button",on:{"click":function($event){return _vm.contractManagementFormFileRemove({part: _vm.form.part, subPart: _vm.form.subPart, index: index, type: 'files'})}}},[_c('i',{staticClass:"fa fa-minus-square"})]),_vm._v(" "),_c('span',{staticClass:"contract-management-edit-upload__file"},[_vm._v(_vm._s(file.name))])])}),_vm._v(" "),_vm._l((_vm.s3),function(file,index){return _c('li',{key:'download_' + index},[_c('span',{staticClass:"contract-management-edit-upload__btn contract-management-edit-upload__delete-button",on:{"click":function($event){return _vm.deleteFile({part: _vm.form.part, subPart: _vm.form.subPart, contractId: _vm.form.contractId, index: index, subIndex: _vm.form.index})}}},[_c('i',{staticClass:"fa fa-trash"})]),_vm._v(" "),_c('span',{staticClass:"contract-management-edit-upload__btn contract-management-edit-upload__download-button",on:{"click":function($event){return _vm.contractManagementFormFileDownload({part: _vm.form.part, subPart: _vm.form.subPart, subIndex: _vm.form.index, index: index})}}},[_c('i',{staticClass:"fa fa-download"})]),_vm._v(" "),_c('span',{staticClass:"contract-management-edit-upload__file"},[_vm._v(_vm._s(_vm._f("fileName")(file)))])])})],2)]):_vm._e()])])]):_vm._e()}
var ContractManagementEditUpload_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"contract-management-edit-images__icon"},[_c('i',{staticClass:"fa fa-file-o"})])}]

// CONCATENATED MODULE: ./src/components/ContractManagementEditUpload/ContractManagementEditUpload.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditUpload___vue_template_functional__ = false
/* styles */
var ContractManagementEditUpload___vue_styles__ = null
/* scopeId */
var ContractManagementEditUpload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditUpload___vue_module_identifier__ = null

var ContractManagementEditUpload_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditUpload,
  ContractManagementEditUpload_render,
  ContractManagementEditUpload_staticRenderFns,
  ContractManagementEditUpload___vue_template_functional__,
  ContractManagementEditUpload___vue_styles__,
  ContractManagementEditUpload___vue_scopeId__,
  ContractManagementEditUpload___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditUpload_ContractManagementEditUpload = (ContractManagementEditUpload_Component.exports);

// EXTERNAL MODULE: ./src/services/DocumentService.js
var DocumentService = __webpack_require__(496);
var DocumentService_default = /*#__PURE__*/__webpack_require__.n(DocumentService);

// EXTERNAL MODULE: ./src/services/ConverterService.js
var ConverterService = __webpack_require__(50);
var ConverterService_default = /*#__PURE__*/__webpack_require__.n(ConverterService);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditImages/ContractManagementEditImages.vue
var ContractManagementEditImages__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var ContractManagementEditImages = (vue_esm["default"].extend({
    filters: {
        fileName: function fileName(path) {
            return path.substring(path.indexOf('_') + 1, path.length);
        },
        tempPath: function tempPath(file) {
            return Object(DocumentService["generateTempPath"])(file);
        },
        downloadPath: function downloadPath(file) {
            return Object(ConverterService["generateS3ImageDownloadPath"])(file);
        }
    },
    computed: ContractManagementEditImages__extends({}, Object(vuex_esm["mapState"])({
        form: function form(state) {
            return state.contract.contractManagement.form;
        },
        contract: function contract(state) {
            return state.contract;
        }
    }), {
        imagesList: {
            get: function get() {
                return this.form[this.form.part][this.form.subPart][this.form.index].images;
            }
        },
        s3: {
            get: function get() {
                return this.form[this.form.part][this.form.subPart][this.form.index].imagesS3;
            }
        }
    }),
    methods: ContractManagementEditImages__extends({}, Object(vuex_esm["mapActions"])({
        contractManagementFormSet: 'contract/contractManagementFormSet',
        contractManagementFormFileRemove: 'contract/contractManagementFormFileRemove',
        contractManagementFormFileDelete: 'contract/contractManagementFormFileDelete',
        contractManagementFormFileDownload: 'contract/contractManagementFormFileDownload',
        imageSizeViolation: 'contract/imageSizeViolation'
    }), {
        add: function add(obj) {
            this.contractManagementFormSet(obj);
            // Clear the input field value to ensure that the upload drag and drop works
            // when remove and then re-insert same file
            document.getElementById('contract-management-edit-images__input-file').value = "";
        },
        fileDelete: function fileDelete(obj) {
            var confirm = window.confirm(this.$t('contractManagement.edit.form.upload.confirm'));
            if (confirm) {
                this.contractManagementFormFileDelete(obj);
            }
        },
        show: function show(element) {
            element.style.opacity = 1;
        },
        hide: function hide(element) {
            element.style.opacity = 0;
        },
        checkForFileReader: function checkForFileReader() {
            return window.FileReader !== null;
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c03b6118","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditImages/ContractManagementEditImages.vue
var ContractManagementEditImages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-images"},[(_vm.checkForFileReader())?_c('div',{staticClass:"contract-management-edit-images__content"},[_c('div',{staticClass:"contract-management-edit-images__dropbox",attrs:{"id":"contract-management-edit-images__dropbox"}},[_c('input',{staticClass:"contract-management-edit-images__input-file",attrs:{"id":"contract-management-edit-images__input-file","name":_vm.form.subPart,"type":"file","multiple":"","accept":".jpg,.jpeg,.bmp,.png"},on:{"change":function($event){return _vm.add({part: _vm.form.part, subPart: _vm.form.subPart, images: $event.target.files})}}}),_vm._v(" "),(_vm.imagesList.length === 0 && _vm.s3.length === 0)?_c('div',{staticClass:"contract-management-edit-images__text"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"contract-management-edit-images__initial"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.images.initial')))]),_vm._v(" "),_c('p',{staticClass:"contract-management-edit-images__accepted"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.images.accepted')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-images__images"},[_c('span',{attrs:{"id":"contract-management-edit-images__upload-images"}},_vm._l((_vm.imagesList),function(file,index){return _c('span',{key:'imageList_' + index,staticClass:"contract-management-edit-images__thumb contract-management-edit-images__thumb-upload"},[_c('img',{staticClass:"contract-management-edit-images__thumb-image",attrs:{"src":_vm._f("tempPath")(file)}}),_vm._v(" "),_c('span',{staticClass:"contract-management-edit-images__thumb-buttons",on:{"mouseenter":function($event){return _vm.show($event.target)},"mouseleave":function($event){return _vm.hide($event.target)}}},[_c('span',{staticClass:"contract-management-edit-images__thumb-button contract-management-edit-images__thumb-remove",on:{"click":function($event){return _vm.contractManagementFormFileRemove({part: _vm.form.part, subPart: _vm.form.subPart, index: index, type: 'images'})}}})])])}),0),_vm._v(" "),_c('span',{attrs:{"id":"contract-management-edit-images__download-images"}},_vm._l((_vm.s3),function(file,index){return _c('span',{key:'s3imageList_' + index,staticClass:"contract-management-edit-images__thumb"},[_c('img',{staticClass:"contract-management-edit-images__thumb-image",attrs:{"src":_vm._f("downloadPath")(file)}}),_vm._v(" "),_c('span',{staticClass:"contract-management-edit-images__thumb-buttons",on:{"mouseenter":function($event){return _vm.show($event.target)},"mouseleave":function($event){return _vm.hide($event.target)}}},[_c('span',{staticClass:"contract-management-edit-images__thumb-button contract-management-edit-images__thumb-delete",on:{"click":function($event){return _vm.fileDelete({part: _vm.form.part, subPart: _vm.form.subPart, contractId: _vm.form.contractId, index: index, subIndex: _vm.form.index, type: 'image'})}}}),_vm._v(" "),_c('a',{staticClass:"contract-management-edit-images__thumb-button contract-management-edit-images__thumb-download",attrs:{"href":_vm._f("downloadPath")(file),"target":"_blank"}})])])}),0)])])]):_vm._e(),_vm._v(" "),(!_vm.checkForFileReader())?_c('div',{staticClass:"contract-management-edit-images__error"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-images__error-message"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.images.unsupported')))])]):_vm._e()])}
var ContractManagementEditImages_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"contract-management-edit-images__icon"},[_c('i',{staticClass:"fa fa-file-image-o"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-images__error-icon"},[_c('i',{staticClass:"fa fa-frown-o"})])}]

// CONCATENATED MODULE: ./src/components/ContractManagementEditImages/ContractManagementEditImages.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditImages___vue_template_functional__ = false
/* styles */
var ContractManagementEditImages___vue_styles__ = null
/* scopeId */
var ContractManagementEditImages___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditImages___vue_module_identifier__ = null

var ContractManagementEditImages_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditImages,
  ContractManagementEditImages_render,
  ContractManagementEditImages_staticRenderFns,
  ContractManagementEditImages___vue_template_functional__,
  ContractManagementEditImages___vue_styles__,
  ContractManagementEditImages___vue_scopeId__,
  ContractManagementEditImages___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditImages_ContractManagementEditImages = (ContractManagementEditImages_Component.exports);

// EXTERNAL MODULE: ./src/services/NavigationService.js
var NavigationService = __webpack_require__(211);
var NavigationService_default = /*#__PURE__*/__webpack_require__.n(NavigationService);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditFormAdd/ContractManagementEditFormAdd.vue
var ContractManagementEditFormAdd__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var ContractManagementEditFormAdd = (vue_esm["default"].extend({
    computed: ContractManagementEditFormAdd__extends({}, Object(vuex_esm["mapState"])({
        form: function form(state) {
            return state.contract.contractManagement.form;
        }
    })),
    methods: ContractManagementEditFormAdd__extends({}, Object(vuex_esm["mapActions"])({
        contractManagementFormAddElement: 'contract/contractManagementFormAddElement',
        contractManagementFormRemoveElement: 'contract/contractManagementFormRemoveElement',
        contractManagementFormSetIndex: 'contract/contractManagementFormSetIndex'
    }), {
        getContractItemTwentyPath: function getContractItemTwentyPath(subPart, id) {
            return Object(NavigationService["getContractItemTwentyPath"])(subPart, id);
        },
        getContractItemCreatePath: function getContractItemCreatePath(subPart) {
            return Object(NavigationService["getContractItemCreatePath"])(subPart);
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9357f596","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditFormAdd/ContractManagementEditFormAdd.vue
var ContractManagementEditFormAdd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-form-add"},[_c('div',{staticClass:"contract-management-edit-form-add__content"},[_c('div',{staticClass:"contract-management-edit-form-add__elements"},_vm._l((_vm.form[_vm.form.part][_vm.form.subPart]),function(element,index){return _c('div',{key:index,staticClass:"contract-management-edit-form-add__element"},[_c('span',{staticClass:"contract-management-edit-form-add__remove",on:{"click":function($event){return _vm.contractManagementFormRemoveElement(index)}}},[_c('i',{staticClass:"fa fa-trash"})]),_vm._v(" "),_c('span',{staticClass:"contract-management-edit-form-add__name",class:{'contract-management-edit-form-add__name--active': index === _vm.form.index},on:{"click":function($event){return _vm.contractManagementFormSetIndex(index)}}},[(element.name)?_c('span',[_vm._v(_vm._s(element.name))]):_vm._e(),_vm._v(" "),(!element.name)?_c('span',[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.noTitle')))]):_vm._e(),_vm._v(" "),(element.id)?_c('span',[_c('a',{attrs:{"href":_vm.getContractItemTwentyPath(_vm.form.subPart, element.id),"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('contractManagement.edit.form.link')))])]):_vm._e(),_vm._v(" "),(!element.id && element.name)?_c('span',[_c('a',{attrs:{"href":_vm.getContractItemCreatePath(_vm.form.subPart),"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('contractManagement.edit.form.create')))])]):_vm._e()])])}),0),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-form-add__control"},[_c('div',{staticClass:"contract-management-edit-form-add__add-btn",on:{"click":_vm.contractManagementFormAddElement}},[_vm._v("\n                "+_vm._s(_vm.$t('contractManagement.edit.form.add'))+"\n            ")])])])])}
var ContractManagementEditFormAdd_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementEditFormAdd/ContractManagementEditFormAdd.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditFormAdd___vue_template_functional__ = false
/* styles */
var ContractManagementEditFormAdd___vue_styles__ = null
/* scopeId */
var ContractManagementEditFormAdd___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditFormAdd___vue_module_identifier__ = null

var ContractManagementEditFormAdd_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditFormAdd,
  ContractManagementEditFormAdd_render,
  ContractManagementEditFormAdd_staticRenderFns,
  ContractManagementEditFormAdd___vue_template_functional__,
  ContractManagementEditFormAdd___vue_styles__,
  ContractManagementEditFormAdd___vue_scopeId__,
  ContractManagementEditFormAdd___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditFormAdd_ContractManagementEditFormAdd = (ContractManagementEditFormAdd_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditBrands/ContractManagementEditBrands.vue
var ContractManagementEditBrands__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractManagementEditBrands = (vue_esm["default"].extend({
    computed: ContractManagementEditBrands__extends({}, Object(vuex_esm["mapState"])({
        brands: function brands(state) {
            return state.contract.contractManagement.brands;
        },
        selectedBrands: function selectedBrands(state) {
            return state.contract.contractManagement.form.extended.brands;
        }
    })),
    methods: ContractManagementEditBrands__extends({}, Object(vuex_esm["mapActions"])({
        addBrand: 'contract/addBrand',
        removeBrand: 'contract/removeBrand'
    }), {
        isSelected: function isSelected(index) {
            return this.selectedBrands.includes(+index);
        },
        toggleBrand: function toggleBrand(index) {
            if (this.isSelected(index)) {
                this.removeBrand(index);
            } else {
                this.addBrand(index);
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1639dff1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditBrands/ContractManagementEditBrands.vue
var ContractManagementEditBrands_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-brands"},[_c('div',{staticClass:"contract-management-edit-brands__text"},[_vm._v("\n        "+_vm._s(_vm.$t('contractManagement.edit.form.brands.info'))+"\n    ")]),_vm._v(" "),_vm._l((_vm.brands.brands),function(brand,index){return _c('div',{key:'brands_' + index,staticClass:"contract-management-edit-brands__open-select",class:{'contract-management-edit-brands__open-select--selected': _vm.isSelected(index)},on:{"click":function($event){return _vm.toggleBrand(index)}}},[_vm._v("\n        "+_vm._s(brand)+"\n    ")])})],2)}
var ContractManagementEditBrands_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementEditBrands/ContractManagementEditBrands.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditBrands___vue_template_functional__ = false
/* styles */
var ContractManagementEditBrands___vue_styles__ = null
/* scopeId */
var ContractManagementEditBrands___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditBrands___vue_module_identifier__ = null

var ContractManagementEditBrands_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditBrands,
  ContractManagementEditBrands_render,
  ContractManagementEditBrands_staticRenderFns,
  ContractManagementEditBrands___vue_template_functional__,
  ContractManagementEditBrands___vue_styles__,
  ContractManagementEditBrands___vue_scopeId__,
  ContractManagementEditBrands___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditBrands_ContractManagementEditBrands = (ContractManagementEditBrands_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditForm/ContractManagementEditForm.vue
var ContractManagementEditForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











/* harmony default export */ var ContractManagementEditForm = (vue_esm["default"].extend({
    components: {
        AutoComplete: AutoComplete_AutoComplete,
        AutoCompleteMulti: AutoCompleteMulti_AutoCompleteMulti,
        ContractManagementList: ContractManagementList["a" /* default */],
        ContractManagementEditUpload: ContractManagementEditUpload_ContractManagementEditUpload,
        ContractManagementEditImages: ContractManagementEditImages_ContractManagementEditImages,
        ContractManagementEditFormAdd: ContractManagementEditFormAdd_ContractManagementEditFormAdd,
        ContractManagementEditBrands: ContractManagementEditBrands_ContractManagementEditBrands
    },
    computed: ContractManagementEditForm__extends({}, Object(vuex_esm["mapState"])({
        form: function form(state) {
            return state.contract.contractManagement.form;
        },
        trigger: function trigger(state) {
            return state.contract.trigger;
        },
        items: function items(state) {
            return state.contract.contractManagement.supplier.items;
        }
    }), Object(vuex_esm["mapGetters"])({
        getContractManagementSites: 'contract/getContractManagementSites'
    })),
    methods: ContractManagementEditForm__extends({}, Object(vuex_esm["mapActions"])({
        contractManagementFormSet: 'contract/contractManagementFormSet',
        contractManagementFormUnset: 'contract/contractManagementFormUnset',
        contractManagementCopyExisting: 'contract/contractManagementCopyExisting',
        contractManagementSetNoChanges: 'contract/contractManagementSetNoChanges'
    }), {
        noChanges: function noChanges(obj) {
            // All parts except sites and accommodations will have this feature
            if (obj.subPart !== 'siteInfo' && obj.subPart !== 'accInfo' && obj.subPart !== 'brands') {
                // Display alert before inserting 'No changes'
                if (confirm(this.$t('contractManagement.noChangesConfirm'))) {
                    this.contractManagementSetNoChanges(obj);
                }
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508a158e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditForm/ContractManagementEditForm.vue
var ContractManagementEditForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-form"},[_c('div',{staticClass:"contract-management-edit-form__content"},[_c('div',{staticClass:"contract-management-edit-form__header"},[_c('div',{staticClass:"contract-management-edit-form__heading"},[_c('span',[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.header.heading.' + _vm.form.part))+" > ")]),_vm._v(" "),_c('span',{staticClass:"contract-management-edit-form__sub-heading"},[_vm._v("\n                    "+_vm._s(_vm.$t('contractManagement.edit.form.subHeader.' + _vm.form.subPart))+"\n                ")]),_vm._v(" "),(_vm.form.subPart === 'notes')?_c('span',{staticClass:"contract-management-edit-form__optional"},[_vm._v("\n                    ("+_vm._s(_vm.$t('contractManagement.edit.form.optional'))+")\n                ")]):_vm._e(),_vm._v(" "),(_vm.form.subPart !== 'siteInfo' && _vm.form.subPart !== 'accInfo' && _vm.form.subPart !== 'brands' && _vm.form.subPart !== 'notes')?_c('span',{staticClass:"contract-management-edit-form__btn",on:{"click":function($event){_vm.noChanges({part: _vm.form.part, subPart: _vm.form.subPart, text: _vm.$t('contractManagement.edit.progress.defaultText')})}}},[_vm._v("\n                    "+_vm._s(_vm.$t('contractManagement.edit.form.copy'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.form.subPart === 'siteInfo' || _vm.form.subPart === 'accInfo')?_c('span',{staticClass:"contract-management-edit-form__btn",on:{"click":_vm.contractManagementCopyExisting}},[_vm._v("\n                    "+_vm._s(_vm.$t('contractManagement.edit.form.copy'))+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-form__body"},[_c('div',{staticClass:"contract-management-edit-form__form"},[(_vm.form.part === 'basic' || _vm.form.subPart === 'arrivalDeparture')?_c('div',{staticClass:"contract-management-edit-form__form-input"},[_c('textarea',{staticClass:"contract-management-edit-form__input contract-management-edit-form__input-text",attrs:{"placeholder":_vm.$t('contractManagement.edit.form.placeholder.' + _vm.form.subPart),"rows":"15"},domProps:{"value":_vm.form[_vm.form.part][_vm.form.subPart].text},on:{"input":function($event){return _vm.contractManagementFormSet({part: _vm.form.part, subPart: _vm.form.subPart, text: $event.target.value})}}})]):_vm._e(),_vm._v(" "),(_vm.form.part === 'extended' && _vm.form.subPart !== 'arrivalDeparture' && _vm.form.subPart !== 'brands')?_c('div',{staticClass:"contract-management-edit-form__form-input"},[_c('div',{staticClass:"contract-management-edit-form__add-field-mobile"},[_c('contract-management-edit-form-add')],1),_vm._v(" "),(_vm.form.subPart === 'accInfo')?_c('div',{staticClass:"contract-management-edit-form__sites"},[_c('auto-complete-multi',{attrs:{"placeholder":_vm.$t('contractManagement.edit.form.autoComplete.multi'),"values":_vm.form[_vm.form.part][_vm.form.subPart][_vm.form.index].sites,"items":_vm.getContractManagementSites,"value-attribute":'name'},on:{"add":function($event){return _vm.contractManagementFormSet({part: _vm.form.part, subPart: _vm.form.subPart, index: _vm.form.index, site: $event})},"remove":function($event){return _vm.contractManagementFormUnset({part: _vm.form.part, subPart: _vm.form.subPart, index: _vm.form.index, site: $event})}}})],1):_vm._e(),_vm._v(" "),(_vm.form.subPart === 'siteInfo')?_c('div',{staticClass:"contract-management-edit-form__checkboxes"},[_c('span',{staticClass:"contract-management-edit-form__checkbox-label"},[_vm._v("\n                            "+_vm._s(_vm.$t('contractManagement.edit.form.checkbox'))+":\n                        ")]),_vm._v(" "),_c('div',{class:['contract-management-edit-form__checkbox', {'contract-management-edit-form__checkbox--checked': _vm.form[_vm.form.part][_vm.form.subPart][_vm.form.index].showInContract}],on:{"click":function($event){return _vm.contractManagementFormSet({part: _vm.form.part, subPart: _vm.form.subPart, index: _vm.form.index, show: !_vm.form[_vm.form.part][_vm.form.subPart][_vm.form.index].showInContract})}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-form__add-field"},[_c('contract-management-edit-form-add')],1),_vm._v(" "),_c('auto-complete',{staticClass:"contract-management-edit-form__input contract-management-edit-form__input-title",attrs:{"input":_vm.form[_vm.form.part][_vm.form.subPart][_vm.form.index],"placeholder":_vm.$t('contractManagement.edit.form.autoComplete.' + _vm.form.subPart),"values":_vm.form[_vm.form.part][_vm.form.subPart],"items":_vm.items[_vm.form.subPart]},on:{"change":function($event){return _vm.contractManagementFormSet({part: _vm.form.part, subPart: _vm.form.subPart, index: _vm.form.index, item: $event})}}}),_vm._v(" "),_c('textarea',{staticClass:"contract-management-edit-form__input contract-management-edit-form__input-text-small",attrs:{"placeholder":_vm.$t('contractManagement.edit.form.placeholder.' + _vm.form.subPart + '.text'),"rows":"15"},domProps:{"value":_vm.form[_vm.form.part][_vm.form.subPart][_vm.form.index].text},on:{"input":function($event){return _vm.contractManagementFormSet({part: _vm.form.part, subPart: _vm.form.subPart, index: _vm.form.index, text: $event.target.value})}}}),_vm._v(" "),_c('contract-management-edit-images')],1):_vm._e(),_vm._v(" "),(_vm.form.subPart === 'brands')?_c('div',[_c('contract-management-edit-brands')],1):_vm._e()])]),_vm._v(" "),(_vm.form.subPart !== 'brands')?_c('div',[_c('div',{staticClass:"contract-management-edit-form__upload"},[_c('contract-management-edit-upload')],1)]):_vm._e()])])}
var ContractManagementEditForm_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementEditForm/ContractManagementEditForm.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditForm___vue_template_functional__ = false
/* styles */
var ContractManagementEditForm___vue_styles__ = null
/* scopeId */
var ContractManagementEditForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditForm___vue_module_identifier__ = null

var ContractManagementEditForm_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditForm,
  ContractManagementEditForm_render,
  ContractManagementEditForm_staticRenderFns,
  ContractManagementEditForm___vue_template_functional__,
  ContractManagementEditForm___vue_styles__,
  ContractManagementEditForm___vue_scopeId__,
  ContractManagementEditForm___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditForm_ContractManagementEditForm = (ContractManagementEditForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditControl/ContractManagementEditControl.vue
var ContractManagementEditControl__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractManagementEditControl = (vue_esm["default"].extend({
    computed: ContractManagementEditControl__extends({}, Object(vuex_esm["mapState"])({
        items: function items(state) {
            return state.contract.overview.items;
        },
        form: function form(state) {
            return state.contract.contractManagement.form;
        }
    }), Object(vuex_esm["mapGetters"])({
        contractManagementPageForward: 'contract/contractManagementPageForward',
        contractManagementPageBackward: 'contract/contractManagementPageBackward',
        formHasChanged: 'contract/formHasChanged'
    })),
    methods: ContractManagementEditControl__extends({}, Object(vuex_esm["mapActions"])({
        contractManagementFormPageSet: 'contract/contractManagementFormPageSet',
        contractManagementFormSave: 'contract/contractManagementFormSave'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c837199","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditControl/ContractManagementEditControl.vue
var ContractManagementEditControl_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-control"},[_c('div',{staticClass:"contract-management-edit-control__content"},[_c('div',{staticClass:"contract-management-edit-control__paging-buttons"},[_c('button',{staticClass:"contract-management-edit-control__page-btn",attrs:{"disabled":!_vm.contractManagementPageBackward},on:{"click":function($event){return _vm.contractManagementFormPageSet(_vm.contractManagementPageBackward)}}},[_c('i',{staticClass:"fa fa-chevron-left"})]),_vm._v(" "),_c('button',{staticClass:"contract-management-edit-control__page-btn",attrs:{"disabled":!_vm.contractManagementPageForward},on:{"click":function($event){return _vm.contractManagementFormPageSet(_vm.contractManagementPageForward)}}},[_c('i',{staticClass:"fa fa-chevron-right"})])]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-control__buttons"},[_c('button',{staticClass:"contract-management-edit-control__btn",on:{"click":function($event){return _vm.contractManagementFormSave()}}},[_vm._v("\n                "+_vm._s(_vm.$t('contractManagement.edit.form.save'))+"\n            ")])])])])}
var ContractManagementEditControl_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementEditControl/ContractManagementEditControl.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditControl___vue_template_functional__ = false
/* styles */
var ContractManagementEditControl___vue_styles__ = null
/* scopeId */
var ContractManagementEditControl___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditControl___vue_module_identifier__ = null

var ContractManagementEditControl_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditControl,
  ContractManagementEditControl_render,
  ContractManagementEditControl_staticRenderFns,
  ContractManagementEditControl___vue_template_functional__,
  ContractManagementEditControl___vue_styles__,
  ContractManagementEditControl___vue_scopeId__,
  ContractManagementEditControl___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditControl_ContractManagementEditControl = (ContractManagementEditControl_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditProgress/ContractManagementEditProgress.vue
var ContractManagementEditProgress__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var ContractManagementEditProgress = (vue_esm["default"].extend({
    data: function data() {
        return {
            toggled: true
        };
    },

    computed: ContractManagementEditProgress__extends({}, Object(vuex_esm["mapState"])({
        basic: function basic(state) {
            return state.contract.contractManagement.progress.basic;
        },
        extended: function extended(state) {
            return state.contract.contractManagement.progress.extended;
        },
        done: function done(state) {
            return state.contract.contractManagement.progress.done;
        },
        part: function part(state) {
            return state.contract.contractManagement.from.part;
        },
        subPart: function subPart(state) {
            return state.contract.contractManagement.form.subPart;
        }
    }), Object(vuex_esm["mapGetters"])({
        calculateContractManagementProgress: 'contract/calculateContractManagementProgress',
        contractManagementProgressObject: 'contract/contractManagementProgressObject'
    })),
    methods: ContractManagementEditProgress__extends({}, Object(vuex_esm["mapActions"])({
        setContractManagementFormPart: 'contract/setContractManagementFormPart',
        contractManagementSetNoChanges: 'contract/contractManagementSetNoChanges'
    }), {
        getContractManagementPartLink: function getContractManagementPartLink(subPart) {
            return Object(ConverterService["getContractManagementPartLink"])(subPart);
        },
        noChanges: function noChanges(obj) {
            // All parts except sites and accommodations will have this feature
            if (obj.subPart !== 'siteInfo' && obj.subPart !== 'accInfo' && obj.subPart !== 'brands') {
                // Display alert before inserting 'No changes'
                if (confirm(this.$t('contractManagement.noChangesConfirm'))) {
                    this.contractManagementSetNoChanges(obj);
                }
            }
        }
    })
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-961a38aa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditProgress/ContractManagementEditProgress.vue
var ContractManagementEditProgress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-progress"},[_c('div',{staticClass:"contract-management-edit-progress__header",on:{"click":function($event){_vm.toggled = !_vm.toggled}}},[_c('div',{staticClass:"contract-management-edit-progress__heading",class:{'contract-management-edit-progress__heading--toggled': _vm.toggled}},[_vm._v("\n            "+_vm._s(_vm.$t('contractManagement.edit.progress.header.heading'))+" > "+_vm._s(_vm.calculateContractManagementProgress)+" %\n        ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","type":"in-out"}},[(_vm.toggled)?_c('div',{staticClass:"contract-management-edit-progress__content"},[_c('div',{staticClass:"contract-management-edit-progress__items"},[_c('div',{staticClass:"contract-management-edit-progress__item"},[_c('div',{staticClass:"contract-management-edit-progress__item-label"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.progress.basic')))]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-progress__item-elements"},_vm._l((_vm.basic),function(item,index){return _c('div',{key:index,staticClass:"contract-management-edit-progress__item-element contract-management-edit-progress__item-element--basic",on:{"dblclick":function($event){_vm.noChanges({part: 'basic', subPart: index, text: _vm.$t('contractManagement.edit.progress.defaultText')})},"click":function($event){return _vm.setContractManagementFormPart({part: 'basic', subPart: index})}}},[_c('div',{staticClass:"contract-management-edit-progress__item-sub-header"},[(index !== 'priceExtra' && index !== 'notes')?_c('span',[_c('a',{staticClass:"contract-management-edit-progress__link",attrs:{"href":_vm.getContractManagementPartLink(index),"target":"_blank"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('contractManagement.edit.progress.subHeader.' + index))+"\n                                    ")])]):_vm._e(),_vm._v(" "),(index === 'priceExtra')?_c('span',[_c('a',{staticClass:"contract-management-edit-progress__link",attrs:{"href":_vm.getContractManagementPartLink(index)[0],"target":"_blank"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('contractManagement.edit.progress.subHeader.' + index + '.price'))+"\n                                    ")]),_vm._v(" "),_c('span',[_vm._v("/")]),_vm._v(" "),_c('a',{staticClass:"contract-management-edit-progress__link",attrs:{"href":_vm.getContractManagementPartLink(index)[1],"target":"_blank"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('contractManagement.edit.progress.subHeader.' + index + '.extra'))+"\n                                    ")])]):_vm._e(),_vm._v(" "),(index === 'notes')?_c('span',[_vm._v("\n                                    "+_vm._s(_vm.$t('contractManagement.edit.progress.subHeader.' + index))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-progress__item-icon",class:[
                                     {'contract-management-edit-progress__item-icon--done': item},
                                     {'contract-management-edit-progress__item-icon--active': _vm.subPart === index},
                                     {'contract-management-edit-progress__item-icon--optional': index === 'notes'}
                                 ]},[(item)?_c('span',[_c('i',{staticClass:"fa fa-check-square"})]):_vm._e(),_vm._v(" "),(!item)?_c('span',[_c('i',{staticClass:"fa fa-minus-square"})]):_vm._e()])])}),0)]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-progress__item"},[_c('div',{staticClass:"contract-management-edit-progress__item-label"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.progress.extended')))]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-progress__item-elements"},_vm._l((_vm.extended),function(item,index){return _c('div',{key:index,staticClass:"contract-management-edit-progress__item-element contract-management-edit-progress__item-element--extended",on:{"dblclick":function($event){_vm.noChanges({part: 'extended', subPart: index, text: _vm.$t('contractManagement.edit.progress.defaultText')})},"click":function($event){return _vm.setContractManagementFormPart({part: 'extended', subPart: index})}}},[_c('div',{staticClass:"contract-management-edit-progress__item-sub-header"},[_c('a',{staticClass:"contract-management-edit-progress__link",attrs:{"href":_vm.getContractManagementPartLink(index),"target":"_blank"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('contractManagement.edit.progress.subHeader.' + index))+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-progress__item-icon",class:[
                                     {'contract-management-edit-progress__item-icon--done': item},
                                     {'contract-management-edit-progress__item-icon--active': _vm.subPart === index},
                                     {'contract-management-edit-progress__item-icon--optional': index === 'notes'} ]},[(item)?_c('span',[_c('i',{staticClass:"fa fa-check-square"})]):_vm._e(),_vm._v(" "),(!item)?_c('span',[_c('i',{staticClass:"fa fa-minus-square"})]):_vm._e()])])}),0)])])]):_vm._e()])],1)}
var ContractManagementEditProgress_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementEditProgress/ContractManagementEditProgress.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditProgress___vue_template_functional__ = false
/* styles */
var ContractManagementEditProgress___vue_styles__ = null
/* scopeId */
var ContractManagementEditProgress___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditProgress___vue_module_identifier__ = null

var ContractManagementEditProgress_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditProgress,
  ContractManagementEditProgress_render,
  ContractManagementEditProgress_staticRenderFns,
  ContractManagementEditProgress___vue_template_functional__,
  ContractManagementEditProgress___vue_styles__,
  ContractManagementEditProgress___vue_scopeId__,
  ContractManagementEditProgress___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditProgress_ContractManagementEditProgress = (ContractManagementEditProgress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditEmail/ContractManagementEditEmail.vue
var ContractManagementEditEmail__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var ContractManagementEditEmail = (vue_esm["default"].extend({
    computed: ContractManagementEditEmail__extends({}, Object(vuex_esm["mapState"])({
        part: function part(state) {
            return state.contract.contractManagement.form.part;
        },
        item: function item(state) {
            return state.contract.contractManagement.item;
        }
    }), Object(vuex_esm["mapGetters"])({
        contractManagementProgressObject: 'contract/contractManagementProgressObject',
        emailSent: 'contract/emailSent'
    })),
    methods: ContractManagementEditEmail__extends({}, Object(vuex_esm["mapActions"])({
        contractManagementSendEmailBackOffice: 'contract/contractManagementSendEmailBackOffice',
        contractManagementSendEmailReview: 'contract/contractManagementSendEmailReview',
        sendReadyForReviewEmail: 'contract/sendReadyForReviewEmail'
    }))
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61057b90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditEmail/ContractManagementEditEmail.vue
var ContractManagementEditEmail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-management-edit-email"},[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.contractManagementProgressObject.basic && _vm.contractManagementProgressObject.extended)?_c('div',{key:'readyForBackOffice',staticClass:"contract-management-edit-email__content"},[_c('div',{staticClass:"contract-management-edit-email__left"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.complete.contract')))]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-email__right"},[(_vm.emailSent.readyForBackOffice)?_c('span',[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.emailSent'))+": "+_vm._s(_vm._f("moment")(_vm.emailSent.readyForBackOffice,"DD/MM/Y\, HH:mm")))]):_vm._e(),_vm._v(" "),(!_vm.emailSent.readyForBackOffice)?_c('span',[_c('button',{staticClass:"contract-management-edit-email__btn",on:{"click":_vm.contractManagementSendEmailBackOffice}},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.email.backOffice')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.emailSent.readyForBackOffice)?_c('div',{key:'readyForReview',staticClass:"contract-management-edit-email__content"},[_c('div',{staticClass:"contract-management-edit-email__left"},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.complete.review')))]),_vm._v(" "),_c('div',{staticClass:"contract-management-edit-email__right"},[(_vm.emailSent.readyForReview)?_c('span',[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.emailSent'))+": "+_vm._s(_vm._f("moment")(_vm.emailSent.readyForReview,"DD/MM/Y\, HH:mm")))]):_vm._e(),_vm._v(" "),(!_vm.emailSent.readyForReview)?_c('span',[_c('button',{staticClass:"contract-management-edit-email__btn",on:{"click":_vm.contractManagementSendEmailReview}},[_vm._v(_vm._s(_vm.$t('contractManagement.edit.form.email.review')))])]):_vm._e()])]):_vm._e()])],1)}
var ContractManagementEditEmail_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementEditEmail/ContractManagementEditEmail.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditEmail___vue_template_functional__ = false
/* styles */
var ContractManagementEditEmail___vue_styles__ = null
/* scopeId */
var ContractManagementEditEmail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditEmail___vue_module_identifier__ = null

var ContractManagementEditEmail_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditEmail,
  ContractManagementEditEmail_render,
  ContractManagementEditEmail_staticRenderFns,
  ContractManagementEditEmail___vue_template_functional__,
  ContractManagementEditEmail___vue_styles__,
  ContractManagementEditEmail___vue_scopeId__,
  ContractManagementEditEmail___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditEmail_ContractManagementEditEmail = (ContractManagementEditEmail_Component.exports);

// EXTERNAL MODULE: ./src/components/ContractBreadcrumb/ContractBreadcrumb.vue + 2 modules
var ContractBreadcrumb = __webpack_require__(209);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContractManagementEditPage/ContractManagementEditPage.vue
var ContractManagementEditPage__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













/* harmony default export */ var ContractManagementEditPage = (vue_esm["default"].extend({
    components: {
        Alert: Alert["a" /* default */],
        Loading: Loading["a" /* default */],
        InfoWidget: InfoWidget["a" /* default */],
        ContractManagementEditForm: ContractManagementEditForm_ContractManagementEditForm,
        ContractManagementEditControl: ContractManagementEditControl_ContractManagementEditControl,
        ContractManagementEditProgress: ContractManagementEditProgress_ContractManagementEditProgress,
        ContractManagementEditEmail: ContractManagementEditEmail_ContractManagementEditEmail,
        ContractBreadcrumb: ContractBreadcrumb["a" /* default */]
    },
    computed: ContractManagementEditPage__extends({}, Object(vuex_esm["mapState"])({
        tips: function tips(state) {
            return state.contract.tips;
        },
        loading: function loading(state) {
            return state.contract.contractManagement.form.loading;
        },
        contract: function contract(state) {
            return state.contract.contractManagement.item;
        },
        user: function user(state) {
            return state.auth.user;
        }
    })),
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        store_default.a.dispatch('contract/getContractManagementByContractId', to.params.contractId).then(function () {
            store_default.a.dispatch('contract/getContractManagementSupplierData', to.params.supplierId).then(function () {
                store_default.a.dispatch('contract/getBrands').then(function () {
                    next();
                });
            });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        Promise.all([store_default.a.dispatch('contract/resetContractManagementState'), this.$refs.infoWidget.clean()]).then(function () {
            next();
        });
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357137ff","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractManagementEditPage/ContractManagementEditPage.vue
var ContractManagementEditPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-page"},[(_vm.loading)?_c('loading'):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.contractManager)?_c('contract-breadcrumb',{attrs:{"contract":_vm.contract}}):_vm._e(),_vm._v(" "),_c('contract-management-edit-progress'),_vm._v(" "),_c('contract-management-edit-email'),_vm._v(" "),_c('contract-management-edit-form'),_vm._v(" "),_c('contract-management-edit-control'),_vm._v(" "),_c('alert',{attrs:{"translation-prefix":'contractManagement.alert'}}),_vm._v(" "),_c('info-widget',{ref:"infoWidget",attrs:{"tips":_vm.tips}})],1)}
var ContractManagementEditPage_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/ContractManagementEditPage/ContractManagementEditPage.vue
/* script */


/* template */

/* template functional */
var ContractManagementEditPage___vue_template_functional__ = false
/* styles */
var ContractManagementEditPage___vue_styles__ = null
/* scopeId */
var ContractManagementEditPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContractManagementEditPage___vue_module_identifier__ = null

var ContractManagementEditPage_Component = Object(component_normalizer["a" /* default */])(
  ContractManagementEditPage,
  ContractManagementEditPage_render,
  ContractManagementEditPage_staticRenderFns,
  ContractManagementEditPage___vue_template_functional__,
  ContractManagementEditPage___vue_styles__,
  ContractManagementEditPage___vue_scopeId__,
  ContractManagementEditPage___vue_module_identifier__
)

/* harmony default export */ var ContractManagementEditPage_ContractManagementEditPage = __webpack_exports__["default"] = (ContractManagementEditPage_Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTempPath = undefined;

var _BrowserService = __webpack_require__(132);

/**
 * Generate a temporary path for the file.
 *
 * @param file
 * @returns {any}
 */
var generateTempPath = exports.generateTempPath = function generateTempPath(file) {
  // If IE then create as image object, else use HTML element
  return _BrowserService.getBrowserName === 'Internet Explorer' ? new Image() : URL.createObjectURL(file);
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _IntroductionContainer = __webpack_require__(498);

var _IntroductionContainer2 = _interopRequireDefault(_IntroductionContainer);

var _IntroductionAcceptPage = __webpack_require__(499);

var _IntroductionAcceptPage2 = _interopRequireDefault(_IntroductionAcceptPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/introduction',
    component: _IntroductionContainer2.default,
    meta: {
        unauthenticated: true
    },
    children: [{
        path: '/introduction/:confirmationToken',
        component: _IntroductionAcceptPage2.default
    }]
};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c39d4c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroductionContainer/IntroductionContainer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction-container",attrs:{"id":"page"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('img',{staticClass:"introduction-container__logo",attrs:{"src":"https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/logo.svg"}}),_vm._v(" "),_c('router-view')],1)])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/IntroductionContainer/IntroductionContainer.vue
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var IntroductionContainer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(2);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__(18);
var store_default = /*#__PURE__*/__webpack_require__.n(store);

// EXTERNAL MODULE: ./src/components/Loading/Loading.vue + 1 modules
var Loading = __webpack_require__(38);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IntroductionAcceptPage/IntroductionAcceptPage.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ var IntroductionAcceptPage = (vue_esm["default"].extend({
    components: {
        Loading: Loading["a" /* default */]
    },
    computed: _extends({}, Object(vuex_esm["mapState"])({
        error: function error(state) {
            return state.introduction.confirmation.error;
        },
        warning: function warning(state) {
            return state.introduction.confirmation.warning;
        },
        loading: function loading(state) {
            return state.introduction.confirmation.loading;
        },
        noContent: function noContent(state) {
            return state.introduction.confirmation.noContent;
        }
    })),
    methods: _extends({}, Object(vuex_esm["mapActions"])({
        sendConfirmation: 'introduction/sendConfirmation'
    })),
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var confirmationToken = to.params.confirmationToken;
        store_default.a.dispatch('introduction/sendConfirmation', confirmationToken);
        next();
    }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1490f437","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroductionAcceptPage/IntroductionAcceptPage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction-accept-page"},[(_vm.loading)?_c('loading'):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"introduction-accept-page__content"},[_c('div',{staticClass:"introduction-accept-page__heading"},[_c('div',{staticClass:"introduction-accept-page__header"},[(!_vm.error && !_vm.warning && !_vm.noContent)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.header.heading')))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.header.error')))]):_vm._e(),_vm._v(" "),(_vm.warning)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.header.warning')))]):_vm._e(),_vm._v(" "),(_vm.noContent)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.header.noContent')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__body"},[(!_vm.error && !_vm.warning && !_vm.noContent)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.body')))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.error')))]):_vm._e(),_vm._v(" "),(_vm.warning)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.warning')))]):_vm._e(),_vm._v(" "),(_vm.noContent)?_c('span',[_vm._v(_vm._s(_vm.$t('introduction.noContent')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__footer"},[_c('div',{staticClass:"introduction-accept-page__field introduction-acceot-page__header-field"},[_vm._v("\n                "+_vm._s(_vm.$t('introduction.footer.title'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__field"},[_c('strong',[_vm._v(_vm._s(_vm.$t('introduction.footer.contact.title')))])]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__field"},[_vm._v(_vm._s(_vm.$t('introduction.footer.contact.address')))]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__field"},[_vm._v(_vm._s(_vm.$t('introduction.footer.contact.street')))]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__field"},[_vm._v(_vm._s(_vm.$t('introduction.footer.contact.city')))]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__field"},[_vm._v(_vm._s(_vm.$t('introduction.footer.contact.country')))]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__field"},[_vm._v(_vm._s(_vm.$t('introduction.footer.contact.tel')))]),_vm._v(" "),_c('div',{staticClass:"introduction-accept-page__field"},[_vm._v(_vm._s(_vm.$t('introduction.footer.contact.email')))])])]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/IntroductionAcceptPage/IntroductionAcceptPage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  IntroductionAcceptPage,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var IntroductionAcceptPage_IntroductionAcceptPage = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NotFoundContainer/NotFoundContainer.vue



/* harmony default export */ var NotFoundContainer = (vue_esm["default"].extend({}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56d6c498","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFoundContainer/NotFoundContainer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-container"},[_vm._v("\n    "+_vm._s(_vm.$t('notFound.heading'))+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/NotFoundContainer/NotFoundContainer.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  NotFoundContainer,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var NotFoundContainer_NotFoundContainer = __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,r){ true?module.exports=r():"function"==typeof define&&define.amd?define("VueRouterMultiguard",[],r):"object"==typeof exports?exports.VueRouterMultiguard=r():t.VueRouterMultiguard=r()}(this,function(){return function(t){function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}var e={};return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,r){return Object.prototype.hasOwnProperty.call(t,r)},r.p="/dist/",r(r.s=0)}([function(t,r,e){"use strict";function n(t){return void 0===t}function o(t,r,e,u){var i=t.slice(0),f=i.shift();if(n(f))return void u();f(r,e,function(t){if(n(t))return void o(i,r,e,u);u(t)})}t.exports=function(t){if(!Array.isArray(t))throw new Error("You must specify an array of guards");return function(r,e,n){return o(t,r,e,n)}}}])});
//# sourceMappingURL=vue-router-multiguard.min.js.map

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _TokenExtractionService = __webpack_require__(180);

var _TokenExtractionService2 = _interopRequireDefault(_TokenExtractionService);

var _StorageService = __webpack_require__(100);

var storageService = _interopRequireWildcard(_StorageService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class AuthGuards
 */
var AuthGuards = function () {
    function AuthGuards() {
        _classCallCheck(this, AuthGuards);
    }

    _createClass(AuthGuards, null, [{
        key: "isAuthenticated",


        /**
         * Checks if an authorization token is present in storage. If it's not
         * present, the user is redirected to the sign in page.
         *
         * @param to
         * @param from
         * @param next
         */
        value: function isAuthenticated(to, from, next) {
            if (to.matched.some(function (r) {
                return r.meta.authenticated;
            }) && !_store2.default.state.auth.user) {
                _store2.default.dispatch('auth/setReferrer', to.path);
                return next({ path: '/', replace: true });
            }
            return next();
        }

        /**
         * Checks if the user is logged in
         *
         * @param to
         * @param from
         * @param next
         * @returns {*}
         */

    }, {
        key: "isUnauthenticated",
        value: function isUnauthenticated(to, from, next) {
            if (to.matched.some(function (r) {
                return r.meta.unauthenticated;
            }) && _store2.default.state.auth.user) {
                return next();
            }
            return next();
        }

        /**
         * Synchronizes the user from the stored token to the application store
         *
         * @param to
         * @param from
         * @param next
         * @returns {*}
         */

    }, {
        key: "synchronizeUser",
        value: function synchronizeUser(to, from, next) {
            if (!_store2.default.state.auth.user || !_store2.default.state.account.user.originalUser) {
                var token = _TokenStorageService2.default.get();
                var user = storageService.get('user');

                if (token) {
                    _store2.default.dispatch('auth/setUser', {
                        user: _extends({}, _TokenExtractionService2.default.user(token), {
                            firstName: user ? user.firstName : _TokenExtractionService2.default.user(token).firstName,
                            lastName: user ? user.lastName : _TokenExtractionService2.default.user(token).lastName
                        })
                    });
                    // Set the suppliers and products
                    _store2.default.dispatch('auth/getSuppliersAndProducts');
                }
            }

            return next();
        }

        /**
         * Checks whether the user is an XML supplier
         *
         * @param to
         * @param from
         * @param next
         */

    }, {
        key: "restrictXMLSupplier",
        value: function restrictXMLSupplier(to, from, next) {
            if (to.matched.some(function (r) {
                return r.meta.restrictXMLSuppliers;
            }) && _store2.default.state.auth.supplier && _store2.default.state.auth.supplier.xmlSupplier) {
                return next({ path: '/dashboard', replace: true });
            }
            return next();
        }

        /**
         * Checks whether the user is an admin
         *
         * @param to
         * @param from
         * @param next
         * @returns {*}
         */

    }, {
        key: "admin",
        value: function admin(to, from, next) {
            if (to.matched.some(function (r) {
                return r.meta.admin;
            }) && !_store2.default.state.auth.user.admin) {
                return next({ path: '/dashboard', replace: true });
            }
            return next();
        }

        /**
         * Checks whether the user is a contract manager.
         *
         * @param to
         * @param from
         * @param next
         * @returns {*}
         */

    }, {
        key: "restrictContractManager",
        value: function restrictContractManager(to, from, next) {
            if (to.matched.some(function (r) {
                return r.meta.restrictContractManager;
            }) && _store2.default.state.auth.user.contractManager) {
                return next({ path: '/dashboard/allocation', replace: true });
            }
            return next();
        }

        /**
         * Checks whether tje user is a supplier.
         *
         * @param to
         * @param from
         * @param next
         * @returns {*}
         */

    }, {
        key: "restrictSupplier",
        value: function restrictSupplier(to, from, next) {
            if (to.matched.some(function (r) {
                return r.meta.restrictSupplier;
            }) && !_store2.default.state.auth.user.contractManager) {
                return next({ path: '/dashboard', replace: true });
            }
            return next();
        }
    }]);

    return AuthGuards;
}();

exports.default = AuthGuards;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Get filtered list of suppliers based on product type.
 *
 * @param state
 * @returns {Array}
 */
var getSuppliersInProductType = exports.getSuppliersInProductType = function getSuppliersInProductType(state) {
  var productType = state.productType;
  var suppliersProducts = state.suppliersProducts.items || [];
  return suppliersProducts[productType] || [];
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CONSTANTS$AUTH_LOGIN;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *  Authentication Mutations
 */
exports.default = (_CONSTANTS$AUTH_LOGIN = {}, _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_LOGIN_PENDING, function (state) {
  state.login = _extends({}, state.login, { loading: true, message: undefined });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_LOGIN_SUCCESS, function (state, payload) {
  state.login = _extends({}, state.login, { loading: true, message: undefined });
  state.originalUser = _extends({}, payload.user);
  state.user = _extends({}, payload.user);
  state.suppliers = payload.suppliers;
  // Chose the first supplier in the supplier list
  state.supplier = _extends({}, state.supplier, payload.suppliers[0]);
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_LOGIN_FAILURE, function (state, payload) {
  state.login = _extends({}, state.login, { loading: false, message: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_FORGOT_PENDING, function (state) {
  state.forgot = _extends({}, state.forgot, { loading: true, message: undefined });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_FORGOT_SUCCESS, function (state, payload) {
  state.forgot = _extends({}, state.forgot, { loading: false, message: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_FORGOT_FAILURE, function (state, payload) {
  state.forgot = _extends({}, state.forgot, { loading: false, message: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_RESET_PENDING, function (state) {
  state.reset = _extends({}, state.reset, { loading: true, message: undefined });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_RESET_SUCCESS, function (state, payload) {
  state.reset = _extends({}, state.reset, { loading: false, message: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_RESET_FAILURE, function (state, payload) {
  state.reset = _extends({}, state.reset, { loading: false, message: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_USER_SET, function (state, payload) {
  state.user = _extends({}, state.user, payload);
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_USER_UNSET, function (state) {
  state.user = null;
  state.login = _extends({}, state.login, { loading: false });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_SUPPLIER_SET, function (state, payload) {
  state.supplier = payload;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_SUPPLIERS_SET, function (state, payload) {
  state.suppliers = payload;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_SUPPLIER_UNSET, function (state) {
  state.supplier = null;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_ACTIVATION_PENDING, function (state) {
  state.activation = _extends({}, state.activation, { loading: true, message: undefined });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_ACTIVATION_SUCCESS, function (state, payload) {
  state.activation = _extends({}, state.activation, { loading: false, message: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_ACTIVATION_FAILURE, function (state, payload) {
  state.activation = _extends({}, state.activation, { loading: false, message: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_MESSAGE_SET, function (state, payload) {
  state.login.message = payload;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_REFERRER_SET, function (state, payload) {
  state.referrer = payload;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_REFERRER_UNSET, function (state) {
  state.referrer = undefined;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_SUPPLIER_SET, function (state, payload) {
  state.supplier = payload;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_PRODUCT_TYPE_SET, function (state, payload) {
  state.productType = payload;
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING, function (state) {
  state.suppliersProducts = _extends({}, state.suppliersProducts, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS, function (state, payload) {
  state.suppliersProducts = _extends({}, state.suppliersProducts, { loading: false, error: false, items: payload });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE, function (state) {
  state.suppliersProducts = _extends({}, state.suppliersProducts, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$AUTH_LOGIN, CONSTANTS.AUTH_PRODUCT_TYPES_SET, function (state, payload) {
  state.productTypes = payload;
}), _CONSTANTS$AUTH_LOGIN);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    user: undefined,
    originalUser: undefined,
    suppliersProducts: {
        loading: false,
        error: false,
        items: undefined
    },
    productTypes: [],
    productType: undefined,
    suppliers: [],
    supplier: {
        xmlSupplier: false
    },
    login: {
        loading: false,
        message: null,
        notice: undefined
    },
    forgot: {
        loading: false,
        message: null
    },
    reset: {
        loading: false,
        message: null
    },
    activation: {
        loading: false,
        message: null
    },
    referrer: undefined
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(507);

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__(508);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(509);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions
};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLanguages = exports.updateLanguage = exports.toggleNavMenu = exports.setMinimizedNav = exports.toggleMinimizeNav = undefined;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Toggle minimize navbar
 *
 * @param commit
 */
var toggleMinimizeNav = exports.toggleMinimizeNav = function toggleMinimizeNav(_ref) {
  var commit = _ref.commit;

  commit(CONSTANTS.NAV_MINIMIZE_TOGGLE);
};

/**
 * Set minimized navbar.
 *
 * @param commit
 * @param payload
 */
var setMinimizedNav = exports.setMinimizedNav = function setMinimizedNav(_ref2, payload) {
  var commit = _ref2.commit;

  commit(CONSTANTS.NAV_MINIMIZE_SET, payload);
};

/**
 * Toggle the top navbar menu.
 * Update selected language.
 *
 * @param commit
 * @param payload
 */
var toggleNavMenu = exports.toggleNavMenu = function toggleNavMenu(_ref3, payload) {
  var commit = _ref3.commit;

  commit(CONSTANTS.NAV_MENU_TOGGLE, payload);
};

/**
 * Update the selected language.
 *
 * @param commit
 * @param payload
 */
var updateLanguage = exports.updateLanguage = function updateLanguage(_ref4, payload) {
  var commit = _ref4.commit;

  commit(CONSTANTS.LANGUAGE_SELECT, payload);
};

/**
 * Set the valid languages from the JSON files in i18n.
 *
 * @param commit
 * @param payload
 */
var setLanguages = exports.setLanguages = function setLanguages(_ref5, payload) {
  var commit = _ref5.commit;

  commit(CONSTANTS.LANGUAGE_SET, payload);
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$NAV_MINIMI;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANTS$NAV_MINIMI = {}, _defineProperty(_CONSTANTS$NAV_MINIMI, CONSTANTS.NAV_MINIMIZE_TOGGLE, function (state) {
    state.minimized = !state.minimized;
}), _defineProperty(_CONSTANTS$NAV_MINIMI, CONSTANTS.NAV_MINIMIZE_SET, function (state, status) {
    state.minimized = status;
}), _defineProperty(_CONSTANTS$NAV_MINIMI, CONSTANTS.NAV_MENU_TOGGLE, function (state, payload) {
    // If payload set open to payload to be able for force close
    if (payload !== undefined) {
        state.menu.open = payload;
    } else {
        state.menu.open = !state.menu.open;
    }
}), _defineProperty(_CONSTANTS$NAV_MINIMI, CONSTANTS.LANGUAGE_SELECT, function (state, payload) {
    state.language = payload;
}), _defineProperty(_CONSTANTS$NAV_MINIMI, CONSTANTS.LANGUAGE_SET, function (state, payload) {
    state.languages = payload;
}), _CONSTANTS$NAV_MINIMI);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _WindowService = __webpack_require__(206);

exports.default = {
    minimized: _WindowService.WindowService.width() <= _WindowService.WindowService.breakpoints.lg,
    menu: {
        open: false
    },
    language: {
        value: 'en',
        name: 'English'
    },
    suppliers: {
        loading: false,
        error: false,
        items: []
    },
    supplier: undefined,
    productTypes: {
        loading: false,
        error: false,
        items: []
    },
    productType: undefined
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(511);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(512);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(513);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(514);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions,
    getters: getters
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = exports.search = exports.selectMultiPredicate = exports.resetMultiPredicate = exports.unsetMultiPredicate = exports.setMultiPredicate = exports.setArrivalPeriod = exports.setBookingPeriod = exports.setOrder = exports.setLimit = exports.setPredicate = exports.decrementBookingPagination = exports.incrementBookingPagination = exports.setBookingPagination = exports.setSelectedFilters = exports.getSupplierFilterData = exports.getBookings = exports.downloadFile = undefined;

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _DateStorageService = __webpack_require__(178);

var _DateStorageService2 = _interopRequireDefault(_DateStorageService);

var _GoogleAnalyticsService = __webpack_require__(74);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Download booking csv file.
 *
 * @param commit
 * @param payload
 */
var downloadFile = exports.downloadFile = function downloadFile(_ref, payload) {
    var commit = _ref.commit;

    commit(CONSTANTS.CSV, payload);
};

/**
 * Get bookings form period.
 *
 * @param context
 * @param payload
 */
var getBookings = exports.getBookings = function getBookings(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(CONSTANTS.BOOKING_FETCH_PENDING);
    var token = _TokenStorageService2.default.get();
    return _GatewayService2.default.getBookings(state.bookings.filters.bookingPeriod.from, state.bookings.filters.bookingPeriod.to, state.bookings.filters.arrivalPeriod.from, state.bookings.filters.arrivalPeriod.to, payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.BOOKING_FETCH_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.BOOKING_FETCH_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.BOOKING_FETCH_FAILURE, {
            level: 'error',
            text: 'booking.messages.error'
        });
    });
};

/**
 * Get bookings form period.
 *
 * @param context
 * @param payload
 */
var getSupplierFilterData = exports.getSupplierFilterData = function getSupplierFilterData(_ref3, payload) {
    var commit = _ref3.commit;

    commit(CONSTANTS.BOOKING_FILTER_PENDING);
    var token = _TokenStorageService2.default.get();
    return _GatewayService2.default.getSupplierFilterData(payload, token).then(function (res) {
        commit(CONSTANTS.BOOKING_FILTER_SUCCESS, res.data.data);
    }).catch(function () {
        commit(CONSTANTS.BOOKING_FETCH_FAILURE, {
            level: 'error',
            text: 'booking.messages.error'
        });
    });
};

/**
 * Updates the selected filters
 *
 * @param context
 * @param rootState
 * @param payload
 */
var setSelectedFilters = exports.setSelectedFilters = function setSelectedFilters(_ref4, payload) {
    var state = _ref4.state,
        commit = _ref4.commit,
        rootState = _ref4.rootState;

    var user = rootState.auth.user;

    if (payload.hasOwnProperty('brand')) {
        payload.domain = undefined;
    } else if (payload.hasOwnProperty('site')) {
        payload.accommodation = undefined;
    }
    commit(CONSTANTS.BOOKING_SET_SELECTED_FILTERS, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('booking', 'bookings', 'bookings filtered by user', user.id)
    });
    commit(CONSTANTS.BOOKING_PAGE_SET, 1);

    if (payload.hasOwnProperty('supplier')) {
        getBookings({ commit: commit, state: state });
    }
};

/**
 * Sets the current page
 *
 * @param context
 * @param payload
 */
var setBookingPagination = exports.setBookingPagination = function setBookingPagination(_ref5, payload) {
    var commit = _ref5.commit;

    commit(CONSTANTS.BOOKING_PAGE_SET, payload);
};

/**
 * Increments the current page
 *
 * @param context
 */
var incrementBookingPagination = exports.incrementBookingPagination = function incrementBookingPagination(_ref6) {
    var commit = _ref6.commit;

    commit(CONSTANTS.BOOKING_PAGE_INCREMENT);
};

/**
 * Decrements the current page
 *
 * @param context
 */
var decrementBookingPagination = exports.decrementBookingPagination = function decrementBookingPagination(_ref7) {
    var commit = _ref7.commit;

    commit(CONSTANTS.BOOKING_PAGE_DECREMENT);
};

/**
 * Updates the predicate to order by
 *
 * @param context
 * @param payload
 */
var setPredicate = exports.setPredicate = function setPredicate(_ref8, payload) {
    var commit = _ref8.commit;

    commit(CONSTANTS.BOOKING_PREDICATE_SET, payload);
    commit(CONSTANTS.BOOKING_PAGE_SET, 1);
};

/**
 * Updates the limit per page
 *
 * @param context
 * @param rootState
 * @param payload
 */
var setLimit = exports.setLimit = function setLimit(_ref9, payload) {
    var commit = _ref9.commit,
        rootState = _ref9.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.BOOKING_LIMIT_SET, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('booking', 'bookings', 'user changed the view limit', user.id)
    });
    commit(CONSTANTS.BOOKING_PAGE_SET, 1);
};

/**
 * Updates the limit per page
 *
 * @param context
 * @param rootState
 * @param payload
 */
var setOrder = exports.setOrder = function setOrder(_ref10, payload) {
    var commit = _ref10.commit,
        rootState = _ref10.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.BOOKING_ORDER_SET, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('booking', 'bookings', 'limit changed by user', user.id)
    });
    commit(CONSTANTS.BOOKING_PAGE_SET, 1);
};

/**
 * Updates the current booking period
 *
 * @param context
 * @param rootState
 * @param payload
 */
var setBookingPeriod = exports.setBookingPeriod = function setBookingPeriod(_ref11, payload) {
    var commit = _ref11.commit,
        rootState = _ref11.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.BOOKING_SET_BOOKING_PERIOD, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('booking', 'bookings', 'booking period changed', user.id)
    });

    _DateStorageService2.default.setBookingBookingPeriodInStorage(payload);
};

/**
 * Updates the current arrival period
 *
 * @param context
 * @param payload
 */
var setArrivalPeriod = exports.setArrivalPeriod = function setArrivalPeriod(_ref12, payload) {
    var commit = _ref12.commit,
        rootState = _ref12.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.BOOKING_SET_ARRIVAL_PERIOD, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('booking', 'bookings', 'arrival period changed', user.id)
    });

    _DateStorageService2.default.setBookingArrivalPeriodInStorage(payload);
};

/**
 * Set the predicate for the multi select dropdown
 *
 * @param commit
 * @param payload
 */
var setMultiPredicate = exports.setMultiPredicate = function setMultiPredicate(_ref13, payload) {
    var commit = _ref13.commit;

    commit(CONSTANTS.BOOKING_MULTI_PREDICATE_SET, payload);
};

/**
 * Unset the predicate for the multi select dropdown
 *
 * @param commit
 * @param payload
 */
var unsetMultiPredicate = exports.unsetMultiPredicate = function unsetMultiPredicate(_ref14, payload) {
    var commit = _ref14.commit;

    commit(CONSTANTS.BOOKING_MULTI_PREDICATE_UNSET, payload);
};

/**
 * Reset the multi select dropdown
 *
 * @param commit
 */
var resetMultiPredicate = exports.resetMultiPredicate = function resetMultiPredicate(_ref15) {
    var commit = _ref15.commit;

    commit(CONSTANTS.BOOKING_MULTI_PREDICATE_RESET);
};

/**
 * Select a specific predicate for the multi dropdown
 *
 * @param commit
 * @param payload
 */
var selectMultiPredicate = exports.selectMultiPredicate = function selectMultiPredicate(_ref16, payload) {
    var commit = _ref16.commit;

    commit(CONSTANTS.BOOKING_MULTI_PREDICATE_SELECT, payload);
};

/**
 * Update the search query.
 *
 * @param commit
 * @param rootState
 * @param payload
 */
var search = exports.search = function search(_ref17, payload) {
    var commit = _ref17.commit,
        rootState = _ref17.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.BOOKING_FILTER_SEARCH, {
        data: payload, // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('booking', 'bookings', 'user searched for booking', user.id)
    });
    commit(CONSTANTS.BOOKING_PAGE_SET, 1);
};

/**
 * Reset the bookings state.
 *
 * @param commit
 */
var resetState = exports.resetState = function resetState(_ref18) {
    var commit = _ref18.commit;

    commit(CONSTANTS.BOOKING_RESET_STATE);
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.allAccommodations = exports.allDomains = exports.filteredBookingsXLSFile = exports.filteredBookingsCSVFile = exports.siteNames = exports.filteredBookingsMaxPages = exports.filteredBookingsPaginated = exports.filteredBookings = undefined;

var _lodashEs = __webpack_require__(14);

var _moment = __webpack_require__(5);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves a list of filtered bookings from the
 * currently selected filters in store.
 *
 * @param state
 * @returns {Array|*}
 */
var filteredBookings = exports.filteredBookings = function filteredBookings(state) {
    var _selected = state.bookings.filters.selected;
    var _bookings = state.bookings.value;
    var _predicate = state.bookings.predicate;
    var _order = state.bookings.order;
    var _searchword = state.bookings.filters.searchword;

    // Filter by searchword
    if (_searchword !== '') {
        _bookings = (0, _lodashEs.filter)(_bookings, function (booking) {
            return booking.supplierRef ? booking.supplierRef.toString().toLowerCase().indexOf(_searchword.toLowerCase()) !== -1 || booking.bookingRef.toString().toLowerCase().indexOf(_searchword.toLowerCase()) !== -1 || booking.customerName.toLowerCase().indexOf(_searchword.toLowerCase()) !== -1 : false;
        });
    }

    if (typeof _selected.brand !== 'undefined') {
        _bookings = (0, _lodashEs.filter)(_bookings, ['brand', _selected.brand]);
    }

    if (typeof _selected.domain !== 'undefined') {
        _bookings = (0, _lodashEs.filter)(_bookings, ['domain', _selected.domain]);
    }

    if (typeof _selected.site !== 'undefined') {
        _bookings = (0, _lodashEs.filter)(_bookings, ['siteName', _selected.site]);
    }

    if (typeof _selected.accommodation !== 'undefined') {
        _bookings = (0, _lodashEs.filter)(_bookings, ['accommodation', _selected.accommodation]);
    }

    if (typeof _selected.country !== 'undefined') {
        _bookings = (0, _lodashEs.filter)(_bookings, ['bookingCountry', _selected.country]);
    }

    if (typeof _selected.status !== 'undefined') {
        _bookings = (0, _lodashEs.filter)(_bookings, ['status', _selected.status]);
    }

    return (0, _lodashEs.orderBy)(_bookings, _predicate, [_order]);
};

/**
 * Retrieves a paginated list of the filtered bookings
 *
 * @param state
 * @param getters
 * @returns {string}
 */
var filteredBookingsPaginated = exports.filteredBookingsPaginated = function filteredBookingsPaginated(state, getters) {
    var _page = state.bookings.page;
    var _limit = state.bookings.limit;

    return getters.filteredBookings.slice(_page * _limit - _limit, _page * _limit);
};

/**
 * Retrieves the maximum number of pages returned
 * from the paginated list of filtered bookings
 *
 * @param state
 * @param getters
 * @returns {number}
 */
var filteredBookingsMaxPages = exports.filteredBookingsMaxPages = function filteredBookingsMaxPages(state, getters) {
    var _limit = state.bookings.limit;
    return Math.ceil(getters.filteredBookings.length / _limit);
};

/**
 * Retrieves a list of site names from supplier filter data
 *
 * @param state
 * @returns {string[]}
 */
var siteNames = exports.siteNames = function siteNames(state) {
    return Object.keys(state.bookings.filters.sites);
};

/**
 * Generate a csv object from the filtered bookings list.
 *
 * @param state
 * @param getters
 * @returns {string}
 */
var filteredBookingsCSVFile = exports.filteredBookingsCSVFile = function filteredBookingsCSVFile(state, getters) {
    var filteredBookings = getters.filteredBookings;
    // Add the headings to the csv file
    var csvString = 'data:text/csv;charset=utf-8,Camping Vision Ref., Booking Ref., Booking date, Arrival date, Departure date, Duration, Accommodation, Site, Brand, Domain, Customer, Booking country, Booking status, Supplier\n';
    // Iterate through the filtered bookings to create the csv object
    (0, _lodashEs.forEach)(filteredBookings, function (booking) {
        (0, _lodashEs.forEach)(booking, function (value, key) {
            // If date then convert to format DD/MM/YYYY
            if (key === 'bookingDate' || key === 'arrivalDate' || key === 'departureDate') {
                value = (0, _moment2.default)(value).format('DD/MM/YYYY');
            }
            // Uppercase first letter in the status
            if (key === 'status') {
                value = value.charAt(0).toUpperCase() + value.slice(1);
            }
            // Add value to the row
            csvString += value + ',';
        });
        // Remove the last comma and add line break
        csvString = csvString.substring(0, csvString.length - 1);
        csvString += '\n';
    });
    return csvString;
};

/**
 * Return filtered booking list as XLS file
 * @param state
 * @param getters
 * @returns {string}
 */
var filteredBookingsXLSFile = exports.filteredBookingsXLSFile = function filteredBookingsXLSFile(state, getters) {
    var filteredBookings = getters.filteredBookings;
    // Add the headings to the csv file
    var xlsString = 'data:application/vnd.ms-excel,';
    // Set the headers
    xlsString += "<table border='2px'>" + "<thead>" + "<th>Camping Vision Ref.</th>" + "<th>Booking Ref.</th>" + "<th>Booking date</th>" + "<th>Arrival date</th>" + "<th>Departure date</th>" + "<th>Duration</th>" + "<th>Accommodation</th>" + "<th>Site</th>" + "<th>Brand</th>" + "<th>Domain</th>" + "<th>Customer</th>" + "<th>Booking country</th>" + "<th>Booking status</th>" + "<th>Supplier</th>" + "</thead>" + "<tbody>";
    // Iterate through the filtered bookings to create the csv object
    (0, _lodashEs.forEach)(filteredBookings, function (booking) {
        // Add opening row tag
        xlsString += "<tr>";
        (0, _lodashEs.forEach)(booking, function (value, key) {
            // Add opening table data tag
            xlsString += "<td>";
            // If date then convert to format DD/MM/YYYY
            if (key === 'bookingDate' || key === 'arrivalDate' || key === 'departureDate') {
                value = (0, _moment2.default)(value).format('DD/MM/YYYY');
            }
            // Uppercase first letter in the status
            if (key === 'status') {
                value = value.charAt(0).toUpperCase() + value.slice(1);
            }
            // Add value to the row and close table data tag
            xlsString += value + '</td>';
        });
        // Add closing row tag
        xlsString += '</tr>';
    });
    // Close the body tag
    xlsString += '</tbody>';
    return xlsString;
};

/**
 * Return a list of all the domains available sorted.
 *
 * @param state
 * @returns {Array}
 */
var allDomains = exports.allDomains = function allDomains(state) {
    var domains = [];
    (0, _lodashEs.forEach)(state.bookings.filters.domains, function (domain) {
        (0, _lodashEs.forEach)(domain, function (brand) {
            domains.push(brand);
        });
    });
    return (0, _lodashEs.sortBy)(domains, [function (o) {
        return o;
    }]);
};

/**
 * Returns a list of all the accommodations available sorted.
 *
 * @param state
 * @returns {Array}
 */
var allAccommodations = exports.allAccommodations = function allAccommodations(state) {
    var accommodations = [];
    (0, _lodashEs.forEach)(state.bookings.filters.sites, function (site) {
        (0, _lodashEs.forEach)(site, function (accommodation) {
            if (accommodations.indexOf(accommodation) === -1) {
                accommodations.push(accommodation);
            }
        });
    });
    return (0, _lodashEs.sortBy)(accommodations, [function (o) {
        return o;
    }]);
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$BOOKING_FE;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _ConverterService = __webpack_require__(50);

var _lodashEs = __webpack_require__(14);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *  Booking Mutations
 */
exports.default = (_CONSTANTS$BOOKING_FE = {}, _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FETCH_PENDING, function (state) {
    state.bookings = _extends({}, state.bookings, { value: undefined, error: false, loading: true, noContent: false });
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FETCH_FAILURE, function (state) {
    state.bookings = _extends({}, state.bookings, {
        value: undefined,
        error: true,
        loading: false,
        noContent: false,
        hasFetched: true
    });
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FETCH_SUCCESS, function (state, payload) {
    // Map the bookings to ensure correct ordering
    state.bookings = _extends({}, state.bookings, {
        value: (0, _ConverterService.mapBookings)(payload),
        error: false,
        loading: false,
        noContent: false,
        hasFetched: true
    });
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FETCH_NO_CONTENT, function (state) {
    state.bookings = _extends({}, state.bookings, {
        value: undefined,
        error: false,
        loading: false,
        noContent: true,
        hasFetched: true
    });
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_PAGE_INCREMENT, function (state) {
    state.bookings.page = state.bookings.page + 1;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_PAGE_DECREMENT, function (state) {
    state.bookings.page = state.bookings.page - 1;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_PAGE_SET, function (state, payload) {
    state.bookings.page = payload;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_PREDICATE_SET, function (state, payload) {
    state.bookings.predicate = payload;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_LIMIT_SET, function (state, payload) {
    state.bookings.limit = payload.data;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_ORDER_SET, function (state, payload) {
    state.bookings.order = payload.data;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FILTER_PENDING, function (state) {
    state.bookings.filters = _extends({}, state.bookings.filters, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FILTER_FAILURE, function (state) {
    state.bookings.filters = _extends({}, state.bookings.filters, {
        loading: false,
        error: true,
        brands: undefined,
        domains: undefined,
        countries: undefined,
        sites: undefined,
        accommodations: undefined
    });
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FILTER_SUCCESS, function (state, payload) {
    state.bookings.filters = _extends({}, state.bookings.filters, {
        loading: false,
        error: false,
        brands: payload.brands,
        domains: payload.domains,
        countries: payload.countries,
        sites: payload.sites,
        accommodations: payload.accommodations,
        suppliers: payload.suppliers,
        selectSuppliers: payload.selectSuppliers
    });
    state.bookings.filters.selected = _extends({}, state.bookings.filters.selected, {
        supplier: payload.selectedSupplier
    });
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_SET_SELECTED_FILTERS, function (state, payload) {
    state.bookings.filters.selected = _extends({}, state.bookings.filters.selected, payload.data);
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_SET_BOOKING_PERIOD, function (state, payload) {
    state.bookings.filters.bookingPeriod = _extends({}, state.bookings.filters.bookingPeriod, payload.data);
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_SET_ARRIVAL_PERIOD, function (state, payload) {
    state.bookings.filters.arrivalPeriod = _extends({}, state.bookings.filters.arrivalPeriod, payload.data);
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_MULTI_PREDICATE_SET, function (state, payload) {
    state.bookings.predicate.push(payload);
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_MULTI_PREDICATE_UNSET, function (state, payload) {
    // If deselecting the final item in the dropdown then set to default value
    if (state.bookings.predicate.length === 1) {
        state.bookings.predicate = [state.bookings.defaultPredicate];
    } else {
        state.bookings.predicate = (0, _lodashEs.remove)(state.bookings.predicate, function (p) {
            return p !== payload;
        });
    }
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_MULTI_PREDICATE_RESET, function (state) {
    state.bookings.predicate = [state.bookings.defaultPredicate];
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_MULTI_PREDICATE_SELECT, function (state, payload) {
    state.bookings.predicate = [payload];
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_FILTER_SEARCH, function (state, payload) {
    state.bookings.filters.searchword = payload.data;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.CSV, function (state, payload) {
    state.bookings.csv = payload;
}), _defineProperty(_CONSTANTS$BOOKING_FE, CONSTANTS.BOOKING_RESET_STATE, function (state) {
    state.bookings = _extends({}, state.bookings, {
        error: undefined,
        noContent: undefined,
        loading: false,
        value: [],
        limit: 20,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        hasFetched: false,
        predicate: ['supplierRef'],
        defaultPredicate: 'supplierRef',
        predicateList: ['supplierRef', 'bookingRef', 'status', 'bookingDate', 'arrivalDate', 'departureDate', 'domain', 'accommodation', 'siteName', "supplierName"],
        orderList: ["asc", "desc"],
        order: "asc",
        csv: undefined,
        tips: [{
            title: 'tips.bookingPage.filters.title',
            body: 'tips.bookingPage.filters.body'
        }, {
            title: 'tips.bookingPage.sortList.title',
            body: 'tips.bookingPage.sortList.body'
        }, {
            title: 'tips.bookingPage.downloadList.title',
            body: 'tips.bookingPage.downloadList.body'
        }, {
            title: 'tips.bookingPage.xlsError.title',
            body: 'tips.bookingPage.xlsError.body'
        }, {
            title: 'tips.bookingPage.search.title',
            body: 'tips.bookingPage.search.body'
        }]
    });
    state.bookings.filters = _extends({}, state.bookings.filters, {
        searchword: '',
        suppliers: [],
        brands: [],
        domains: [],
        countries: [],
        sites: [],
        accommodations: [],
        status: ['booked', 'pending', 'request', 'rejected', 'request-cancel', 'cancelled', 'unknown'],
        loading: false,
        error: false
    });
    state.bookings.filters.season = _extends({}, state.bookings.filters.season, {
        from: _config2.default.business.SEASON_DATE_START,
        to: _config2.default.business.SEASON_DATE_END
    });
    state.bookings.filters.selected = _extends({}, state.bookings.filters.selected, {
        country: undefined,
        brand: undefined,
        domain: undefined,
        site: undefined,
        accommodation: undefined,
        status: 'booked'
    });
}), _CONSTANTS$BOOKING_FE);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    bookings: {
        error: undefined,
        noContent: undefined,
        loading: false,
        value: [],
        limit: 20,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        hasFetched: false,
        predicate: ['supplierRef'],
        defaultPredicate: 'supplierRef',
        predicateList: ['supplierRef', 'bookingRef', 'status', 'bookingDate', 'arrivalDate', 'departureDate', 'domain', 'accommodation', 'siteName', "supplierName"],
        orderList: ["asc", "desc"],
        order: "asc",
        filters: {
            searchword: '',
            season: {
                from: _config2.default.business.SEASON_DATE_START,
                to: _config2.default.business.SEASON_DATE_END
            },
            bookingPeriod: {
                from: _config2.default.business.BOOKING_BOOKING_DATE_START,
                to: _config2.default.business.BOOKING_BOOKING_DATE_END
            },
            arrivalPeriod: {
                from: _config2.default.business.BOOKING_ARRIVAL_DATE_START,
                to: _config2.default.business.BOOKING_ARRIVAL_DATE_END
            },
            suppliers: [],
            selectSuppliers: [],
            brands: [],
            domains: [],
            countries: [],
            sites: [],
            accommodations: [],
            status: ['booked', 'pending', 'request', 'rejected', 'request-cancel', 'cancelled', 'unknown'],
            loading: false,
            error: false,
            selected: {
                country: undefined,
                brand: undefined,
                domain: undefined,
                site: undefined,
                accommodation: undefined,
                supplier: undefined,
                status: 'booked'
            }
        },
        csv: undefined,
        tips: [{
            title: 'tips.bookingPage.filters.title',
            body: 'tips.bookingPage.filters.body'
        }, {
            title: 'tips.bookingPage.sortList.title',
            body: 'tips.bookingPage.sortList.body'
        }, {
            title: 'tips.bookingPage.downloadList.title',
            body: 'tips.bookingPage.downloadList.body'
        }, {
            title: 'tips.bookingPage.xlsError.title',
            body: 'tips.bookingPage.xlsError.body'
        }, {
            title: 'tips.bookingPage.search.title',
            body: 'tips.bookingPage.search.body'
        }]
    }
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(516);

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__(517);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(518);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = exports.setFilter = exports.updateSelectedStatListItem = exports.updateSelectedSite = exports.updateArrivalPeriod = exports.updateBookingPeriod = exports.getTotalRevenue = exports.getPeriodRevenue = undefined;

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _GoogleAnalyticsService = __webpack_require__(74);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves revenue for a given period
 *
 * @param context
 * @param payload
 */
var getPeriodRevenue = exports.getPeriodRevenue = function getPeriodRevenue(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(CONSTANTS.STAT_REVENUE_PERIOD_PENDING);
    var token = _TokenStorageService2.default.get();
    return _GatewayService2.default.getRevenue(state.bookingPeriod.from, state.bookingPeriod.to, state.arrivalPeriod.from, state.arrivalPeriod.to, payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.STAT_REVENUE_PERIOD_SUCCESS, {
                revenue: res.data.data.totalRevenue,
                bookings: res.data.data.totalBookings,
                sites: res.data.data.sites
            });
        } else {
            commit(CONSTANTS.STAT_REVENUE_PERIOD_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.STAT_REVENUE_PERIOD_FAILURE);
    });
};

/**
 * Retrieves revenue for an entire season
 *
 * @param context
 * @param payload
 */
var getTotalRevenue = exports.getTotalRevenue = function getTotalRevenue(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(CONSTANTS.STAT_REVENUE_TOTAL_PENDING);
    var token = _TokenStorageService2.default.get();
    return _GatewayService2.default.getRevenue(state.bookingPeriod.from, state.bookingPeriod.to, null, null, payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.STAT_REVENUE_TOTAL_SUCCESS, {
                revenue: res.data.data.totalRevenue,
                bookings: res.data.data.totalBookings
            });
        } else {
            commit(CONSTANTS.STAT_REVENUE_TOTAL_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.STAT_REVENUE_TOTAL_FAILURE);
    });
};

/**
 * Updates the current booking period
 *
 * @param context
 * @param rootState
 * @param payload
 */
var updateBookingPeriod = exports.updateBookingPeriod = function updateBookingPeriod(_ref3, payload) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.STAT_UPDATE_BOOKING_PERIOD, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('statistics', 'bookings', 'booking period changed', user.id)
    });
};

/**
 * Updates the current arrival period
 *
 * @param context
 * @param payload
 */
var updateArrivalPeriod = exports.updateArrivalPeriod = function updateArrivalPeriod(_ref4, payload) {
    var commit = _ref4.commit,
        rootState = _ref4.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.STAT_UPDATE_ARRIVAL_PERIOD, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('statistics', 'bookings', 'arrival period changed', user.id)
    });
};

/**
 * Updates the currently selected site
 *
 * @param context
 * @param payload
 */
var updateSelectedSite = exports.updateSelectedSite = function updateSelectedSite(_ref5, payload) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.STAT_UPDATE_SELECTED_SITE, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('statistics', 'graph', 'user changed site', user.id)
    });
};

/**
 * Updates the currently selected site in the mobile list
 *
 * @param context
 * @param payload
 */
var updateSelectedStatListItem = exports.updateSelectedStatListItem = function updateSelectedStatListItem(_ref6, payload) {
    var commit = _ref6.commit;

    commit(CONSTANTS.STAT_UPDATE_SELECTED_STAT_LIST_ITEM, payload);
};

/**
 * Sets the selected filters
 *
 * @param context
 * @param payload
 */
var setFilter = exports.setFilter = function setFilter(_ref7, payload) {
    var commit = _ref7.commit;

    if (payload.hasOwnProperty('sites')) {
        commit(CONSTANTS.STAT_UPDATE_DROPDOWN_SITES, payload.sites);
    } else if (payload.hasOwnProperty('accommodation')) {
        commit(CONSTANTS.STAT_UPDATE_DROPDOWN_ACCOMMODATION, payload.accommodation);
    } else if (payload.hasOwnProperty('list')) {
        commit(CONSTANTS.STAT_UPDATE_DROPDOWN_LIST, payload.list);
    }
};

/**
 * Reset the stats state.
 *
 * @param commit
 */
var resetState = exports.resetState = function resetState(_ref8) {
    var commit = _ref8.commit;

    commit(CONSTANTS.STAT_RESET_STATE);
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$STAT_REVEN;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANTS$STAT_REVEN = {}, _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_PERIOD_PENDING, function (state) {
    state.periodRevenue = _extends({}, state.periodRevenue, { loading: true, error: false, noContent: false });
    state.periodBookings = _extends({}, state.periodBookings, { loading: true, error: false, noContent: false });
    state.statSites = _extends({}, state.statSites, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_PERIOD_SUCCESS, function (state, _ref) {
    var revenue = _ref.revenue,
        bookings = _ref.bookings,
        sites = _ref.sites;

    state.periodRevenue = _extends({}, state.periodRevenue, { value: revenue, loading: false, error: false, noContent: false });
    state.periodBookings = _extends({}, state.periodBookings, {
        value: bookings,
        loading: false,
        error: false,
        noContent: false
    });
    state.statSites = _extends({}, state.statSites, { loading: false, error: false, noContent: false });
    state.sites = sites;
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_PERIOD_FAILURE, function (state) {
    state.periodRevenue = _extends({}, state.periodRevenue, { loading: false, error: true, noContent: false });
    state.periodBookings = _extends({}, state.periodBookings, { loading: false, error: true, noContent: false });
    state.statSites = _extends({}, state.statSites, { loading: false, error: true, noContent: false });
    state.selectedSite = undefined;
    state.sites = undefined;
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_PERIOD_NO_CONTENT, function (state) {
    state.periodRevenue = _extends({}, state.periodRevenue, { value: undefined, loading: false, error: false, noContent: true });
    state.periodBookings = _extends({}, state.periodBookings, {
        value: undefined,
        loading: false,
        error: false,
        noContent: true
    });
    state.statSites = _extends({}, state.statSites, { loading: false, error: false, noContent: true });
    state.selectedSite = undefined;
    state.sites = undefined;
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_TOTAL_PENDING, function (state) {
    state.totalRevenue = _extends({}, state.totalRevenue, { loading: true, error: false, noContent: false });
    state.totalBookings = _extends({}, state.totalBookings, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_TOTAL_SUCCESS, function (state, _ref2) {
    var revenue = _ref2.revenue,
        bookings = _ref2.bookings;

    state.totalRevenue = _extends({}, state.totalRevenue, { value: revenue, loading: false, error: false, noContent: false });
    state.totalBookings = _extends({}, state.totalBookings, { value: bookings, loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_TOTAL_FAILURE, function (state) {
    state.totalRevenue = _extends({}, state.totalRevenue, { loading: false, error: true, noContent: false });
    state.totalBookings = _extends({}, state.totalBookings, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_REVENUE_TOTAL_NO_CONTENT, function (state) {
    state.totalRevenue = _extends({}, state.totalRevenue, { value: undefined, loading: false, error: false, noContent: true });
    state.totalBookings = _extends({}, state.totalBookings, { value: undefined, loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_UPDATE_BOOKING_PERIOD, function (state, payload) {
    state.bookingPeriod = _extends({}, state.bookingPeriod, { to: payload.data.to, from: payload.data.from });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_UPDATE_ARRIVAL_PERIOD, function (state, payload) {
    state.arrivalPeriod = _extends({}, state.arrivalPeriod, { to: payload.data.to, from: payload.data.from });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_UPDATE_SELECTED_SITE, function (state, payload) {
    state.selectedSite = payload.data;
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_UPDATE_SELECTED_STAT_LIST_ITEM, function (state, payload) {
    state.statList = _extends({}, state.statList, { selectedItem: payload });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_UPDATE_DROPDOWN_SITES, function (state, payload) {
    state.statSites = _extends({}, state.statSites, { predicate: payload });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_UPDATE_DROPDOWN_ACCOMMODATION, function (state, payload) {
    state.statInventory = _extends({}, state.statInventory, { predicate: payload });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_UPDATE_DROPDOWN_LIST, function (state, payload) {
    state.statList = _extends({}, state.statList, { predicate: payload });
}), _defineProperty(_CONSTANTS$STAT_REVEN, CONSTANTS.STAT_RESET_STATE, function (state) {
    state.season = _extends({}, state.season, { from: _config2.default.business.SEASON_DATE_START, to: _config2.default.business.SEASON_DATE_END });
    state.bookingPeriod = _extends({}, state.bookingPeriod, { from: _config2.default.business.SEASON_DATE_START, to: _config2.default.business.SEASON_DATE_END });
    state.arrivalPeriod = _extends({}, state.arrivalPeriod, { from: _config2.default.business.SEASON_DATE_START, to: _config2.default.business.SEASON_DATE_END });
    state.totalRevenue = _extends({}, state.totalRevenue, { value: undefined, loading: false, error: false, noContent: false });
    state.totalBookings = _extends({}, state.totalBookings, { value: undefined, loading: false, error: false, noContent: false });
    state.periodRevenue = _extends({}, state.periodRevenue, { value: undefined, loading: false, error: false, noContent: false });
    state.periodBookings = _extends({}, state.periodBookings, { value: undefined, loading: false, error: false, noContent: false });
    state.statSites = _extends({}, state.statSites, { loading: false, error: false, noContent: false, predicate: "revenue", predicates: ["revenue", "bookings"] });
    state.statList = _extends({}, state.statList, { selectedItem: undefined, predicate: "revenue", predicates: ["revenue", "bookings"] });
    state.statInventory = _extends({}, state.statInventory, { predicate: "revenue", predicates: ["revenue", "bookings"] });
}), _CONSTANTS$STAT_REVEN);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mode: undefined,
    dateType: 'booking',
    season: {
        from: _config2.default.business.SEASON_DATE_START,
        to: _config2.default.business.SEASON_DATE_END
    },
    bookingPeriod: {
        from: _config2.default.business.SEASON_DATE_START,
        to: _config2.default.business.SEASON_DATE_END
    },
    arrivalPeriod: {
        from: _config2.default.business.SEASON_DATE_START,
        to: _config2.default.business.SEASON_DATE_END
    },
    totalRevenue: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    totalBookings: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    periodRevenue: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    periodBookings: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    statSites: {
        loading: false,
        error: false,
        noContent: false,
        predicate: "revenue",
        predicates: ["revenue", "bookings"]
    },
    statList: {
        selectedItem: undefined,
        predicate: "revenue",
        predicates: ["revenue", "bookings"]
    },
    statInventory: {
        predicate: "revenue",
        predicates: ["revenue", "bookings"]
    },
    sites: undefined,
    selectedSite: undefined,
    inventory: undefined,
    tips: [{
        title: 'tips.statPage.boxes.title',
        body: 'tips.statPage.boxes.body'
    }, {
        title: 'tips.statPage.graph.title',
        body: 'tips.statPage.graph.body'
    }, {
        title: 'tips.statPage.filter.title',
        body: 'tips.statPage.filter.body'
    }]
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(520);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(521);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(522);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(523);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions,
    getters: getters
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addAllocationComment = exports.resetState = exports.setCalendarDates = exports.setRouteFilters = exports.countdown = exports.allocationListOptionReset = exports.allocationListOptionSelect = exports.requestEditToggle = exports.requestItemSet = exports.requestItemSelect = exports.requestPredicateSet = exports.requestPageDecrement = exports.requestPageIncrement = exports.requestCancel = exports.requestDeny = exports.requestAcceptModify = exports.requestAccept = exports.updateYear = exports.toggleModalNewAllocation = exports.toggleModalAddAllocations = exports.infoPageSet = exports.toggleCalendarInfoBox = exports.choseCalendarDisplay = exports.decrementCalendarPage = exports.incrementCalendarPage = exports.deselectCalendarDate = exports.selectCalendarDate = exports.decrementOverlayBookingsPage = exports.incrementOverlayBookingsPage = exports.chooseAllocation = exports.resetOverlayRow = exports.setOverlayRow = exports.setModalRow = exports.toggleModalOverlay = exports.toggleModal = exports.toggleAddAllocationForm = exports.resetValidationMessage = exports.requestBlockAllocation = exports.blockAllocation = exports.requestUpdateAllocation = exports.updateAllocation = exports.addAllocations = exports.validateUpdateAllocationInputs = exports.validateAddAllocationInputs = exports.setSelectedRouteFilters = exports.getRouteFilters = exports.setModalPagination = exports.decrementModalPagination = exports.incrementModalPagination = exports.setAllocationLimit = exports.decrementAllocationPagination = exports.incrementAllocationPagination = exports.setAccommodation = exports.cancelForm = exports.submitForm = exports.resetModalForm = exports.resetForm = exports.duplicateRow = exports.removeRow = exports.addRow = exports.setRow = exports.setOrder = exports.setLimit = exports.setPredicate = exports.decrementPage = exports.incrementPage = exports.setPage = exports.setSelectedFilters = exports.getArrivalRules = exports.getRequestList = exports.getAllocationCalendar = exports.getAllocationListMerged = exports.getAllocationList = exports.getAccommodationList = exports.fetchAllocationData = exports.fetchRequestUpdateData = exports.fetchManageAllocationData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _ConverterService = __webpack_require__(50);

var Converter = _interopRequireWildcard(_ConverterService);

var _routes = __webpack_require__(82);

var _routes2 = _interopRequireDefault(_routes);

var _ValidatorService = __webpack_require__(31);

var Validator = _interopRequireWildcard(_ValidatorService);

var _DateToolService = __webpack_require__(48);

var _GoogleAnalyticsService = __webpack_require__(74);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fetch all data needed for the manage allocation page.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var fetchManageAllocationData = exports.fetchManageAllocationData = function fetchManageAllocationData(_ref, payload) {
    var dispatch = _ref.dispatch;

    dispatch('getRequestList', payload);
    dispatch('getArrivalRules', payload);
    dispatch('getAllocationList', payload);
    dispatch('getAllocationListMerged', payload);
    dispatch('getAllocationCalendar', payload);
};

/**
 * Get all the data needed when handling a request.
 *
 * @param commit
 * @returns {Promise<[(T|never), (T|never), (T|never), (T|never)]>}
 */
var fetchRequestUpdateData = exports.fetchRequestUpdateData = function fetchRequestUpdateData(_ref2) {
    var dispatch = _ref2.dispatch;

    dispatch('getAllocationList');
    dispatch('getAllocationListMerged');
    dispatch('getAllocationCalendar');
    dispatch('getRequestList');
};

/**
 * Fetch all allocation data needed for allocation list and calendar.
 *
 * @param dispatch
 */
var fetchAllocationData = exports.fetchAllocationData = function fetchAllocationData(_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch('getAllocationList');
    dispatch('getAllocationListMerged');
    dispatch('getAllocationCalendar');
};

/**
 * Retrieves list of allocations
 *
 * @param context
 * @param payload
 */
var getAccommodationList = exports.getAccommodationList = function getAccommodationList(_ref4, payload) {
    var commit = _ref4.commit;

    commit(CONSTANTS.ALLOCATION_LIST_FETCH_PENDING);
    var token = _TokenStorageService2.default.get();
    return _GatewayService2.default.getAccommodationList(payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_LIST_FETCH_SUCCESS, res.data.data);
            commit(CONSTANTS.ALLOCATION_LIST_SELECTED_RESET);
        } else {
            commit(CONSTANTS.ALLOCATION_LIST_FETCH_NO_CONTENT);
            commit(CONSTANTS.ALLOCATION_LIST_SELECTED_RESET);
        }
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_LIST_FETCH_FAILURE);
        commit(CONSTANTS.ALLOCATION_LIST_SELECTED_RESET);
    });
};

/**
 * Get allocation list by accommodationSiteId.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T | never>}
 */
var getAllocationList = exports.getAllocationList = function getAllocationList(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var token = _TokenStorageService2.default.get();
    var period = (0, _DateToolService.getSeasonPeriod)(state.allocations.years.current);
    var accommodationSiteId = payload || parseInt(_routes2.default.history.current.params.accommodationSiteId);

    commit(CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_PENDING);

    return _GatewayService2.default.getAllocationList([accommodationSiteId], period.from, period.to, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_FAILURE);
    });
};

/**
 * Get allocation list merged by accommodation site id.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T | never>}
 */
var getAllocationListMerged = exports.getAllocationListMerged = function getAllocationListMerged(_ref6, payload) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var token = _TokenStorageService2.default.get();
    var period = (0, _DateToolService.getSeasonPeriod)(state.allocations.years.current);
    var accommodationSiteId = payload || parseInt(_routes2.default.history.current.params.accommodationSiteId);

    commit(CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_PENDING);

    return _GatewayService2.default.getAllocationListMerged([accommodationSiteId], period.from, period.to, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE);
    });
};

/**
 * Get allocation calendar.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T | never>}
 */
var getAllocationCalendar = exports.getAllocationCalendar = function getAllocationCalendar(_ref7, payload) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var token = _TokenStorageService2.default.get();
    var period = (0, _DateToolService.getSeasonPeriod)(state.allocations.years.current);
    var accommodationSiteId = payload || parseInt(_routes2.default.history.current.params.accommodationSiteId);

    commit(CONSTANTS.ALLOCATION_CALENDAR_FETCH_PENDING);

    return _GatewayService2.default.getAllocationCalendar([accommodationSiteId], period.from, period.to, token).then(function (res) {
        commit(CONSTANTS.ALLOCATION_CALENDAR_FETCH_SUCCESS, res.data.data);
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE);
    });
};

/**
 * Get request list.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T | never>}
 */
var getRequestList = exports.getRequestList = function getRequestList(_ref8, payload) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var token = _TokenStorageService2.default.get();
    var period = (0, _DateToolService.getSeasonPeriod)(state.allocations.years.current);
    var accommodationSiteId = payload || parseInt(_routes2.default.history.current.params.accommodationSiteId);

    commit(CONSTANTS.ALLOCATION_REQUEST_LIST_PENDING);

    return _GatewayService2.default.getRequestList(token, [accommodationSiteId], period.from, period.to).then(function (res) {
        commit(CONSTANTS.ALLOCATION_REQUEST_LIST_SUCCESS, res.data.data);
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_REQUEST_LIST_FAILURE);
    });
};

/**
 * Get arrival rules.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T | never>}
 */
var getArrivalRules = exports.getArrivalRules = function getArrivalRules(_ref9, payload) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var token = _TokenStorageService2.default.get();
    var period = (0, _DateToolService.getSeasonPeriod)(state.allocations.years.current);
    var accommodationSiteId = payload || parseInt(_routes2.default.history.current.params.accommodationSiteId);

    commit(CONSTANTS.ALLOCATION_ARRIVAL_LIST_PENDING);

    return _GatewayService2.default.getArrivalRules(token, [accommodationSiteId], period.from, period.to).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_ARRIVAL_LIST_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ALLOCATION_ARRIVAL_LIST_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_ARRIVAL_LIST_FAILURE);
    });
};

/**
 * Sets the selected filters
 *
 * @param context
 * @param payload
 */
var setSelectedFilters = exports.setSelectedFilters = function setSelectedFilters(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;

    if (payload.hasOwnProperty('site')) {
        payload.accommodation = undefined;
    }
    commit(CONSTANTS.ALLOCATION_LIST_SELECTED_SET, payload);
    // Set the page to the first one
    commit(CONSTANTS.ALLOCATION_LIST_PAGE_SET, 1);

    if (payload.hasOwnProperty('supplier')) {
        state.filters.selected.site = undefined;
        getAccommodationList({ commit: commit, state: state });
    }
};

/**
 * Sets the current page
 *
 * @param context
 * @param payload
 */
var setPage = exports.setPage = function setPage(_ref11, payload) {
    var commit = _ref11.commit;

    commit(CONSTANTS.ALLOCATION_LIST_PAGE_SET, payload);
};

/**
 * Increments the current page
 *
 * @param context
 */
var incrementPage = exports.incrementPage = function incrementPage(_ref12) {
    var commit = _ref12.commit;

    commit(CONSTANTS.ALLOCATION_LIST_PAGE_INCREMENT);
};

/**
 * Decrements the current page
 *
 * @param context
 */
var decrementPage = exports.decrementPage = function decrementPage(_ref13) {
    var commit = _ref13.commit;

    commit(CONSTANTS.ALLOCATION_LIST_PAGE_DECREMENT);
};

/**
 * Sets the predicate to order by
 *
 * @param context
 * @param payload
 */
var setPredicate = exports.setPredicate = function setPredicate(_ref14, payload) {
    var commit = _ref14.commit;

    commit(CONSTANTS.ALLOCATION_LIST_PREDICATE_SET, payload);
    commit(CONSTANTS.ALLOCATION_LIST_PAGE_SET, 1);
};

/**
 * Sets the limit per page
 *
 * @param context
 * @param payload
 */
var setLimit = exports.setLimit = function setLimit(_ref15, payload) {
    var commit = _ref15.commit;

    commit(CONSTANTS.ALLOCATION_LIST_LIMIT_SET, payload);
    commit(CONSTANTS.ALLOCATION_LIST_PAGE_SET, 1);
};

/**
 * Sets the order parameter
 *
 * @param context
 * @param payload
 */
var setOrder = exports.setOrder = function setOrder(_ref16, payload) {
    var commit = _ref16.commit;

    commit(CONSTANTS.ALLOCATION_LIST_ORDER_SET, payload);
    commit(CONSTANTS.ALLOCATION_LIST_PAGE_SET, 1);
};

/**
 * Sets a row in the allocation form
 *
 * @param commit
 * @param payload
 */
var setRow = exports.setRow = function setRow(_ref17, payload) {
    var commit = _ref17.commit;

    commit(CONSTANTS.ALLOCATION_FORM_ROW_SET, payload);
};

/**
 * Adds a row to the allocation form
 *
 * @param commit
 * @param payload
 */
var addRow = exports.addRow = function addRow(_ref18, payload) {
    var commit = _ref18.commit;

    commit(CONSTANTS.ALLOCATION_FORM_ROW_ADD, payload);
};

/**
 * Removes a row from the allocation form
 *
 * @param commit
 * @param payload
 */
var removeRow = exports.removeRow = function removeRow(_ref19, payload) {
    var commit = _ref19.commit;

    commit(CONSTANTS.ALLOCATION_FORM_ROW_REMOVE, payload);
};

/**
 * Removes a row from the allocation form
 *
 * @param commit
 * @param payload
 */
var duplicateRow = exports.duplicateRow = function duplicateRow(_ref20, payload) {
    var commit = _ref20.commit;

    commit(CONSTANTS.ALLOCATION_FORM_ROW_DUPLICATE, payload);
};

/**
 * Resets the form.
 *
 * @param commit
 */
var resetForm = exports.resetForm = function resetForm(_ref21) {
    var commit = _ref21.commit;

    commit(CONSTANTS.ALLOCATION_FORM_ROW_RESET);
};

/**
 * Resets the modal form.
 *
 * @param commit
 */
var resetModalForm = exports.resetModalForm = function resetModalForm(_ref22) {
    var commit = _ref22.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_FORM_RESET);
};

/**
 * Submit the form.
 *
 * @param commit
 * @param payload
 */
var submitForm = exports.submitForm = function submitForm(_ref23, payload) {
    var commit = _ref23.commit;

    commit(CONSTANTS.ALLOCATION_FORM_SUBMIT, payload);
};

/**
 * Cancel the form submission.
 *
 * @param commit
 */
var cancelForm = exports.cancelForm = function cancelForm(_ref24) {
    var commit = _ref24.commit;

    commit(CONSTANTS.ALLOCATION_FORM_CANCEL);
};

/**
 * Set the accommodation.
 *
 * @param commit
 * @param payload
 */
var setAccommodation = exports.setAccommodation = function setAccommodation(_ref25, payload) {
    var commit = _ref25.commit;

    commit(CONSTANTS.ALLOCATION_SELECT, payload);
};

/**
 * Increment the page of the allocations list.
 *
 * @param commit
 */
var incrementAllocationPagination = exports.incrementAllocationPagination = function incrementAllocationPagination(_ref26) {
    var commit = _ref26.commit;

    commit(CONSTANTS.ALLOCATION_ALLOCATIONS_PAGE_INCREMENT);
};

/**
 * Decrement the page of the allocations list.
 *
 * @param commit
 */
var decrementAllocationPagination = exports.decrementAllocationPagination = function decrementAllocationPagination(_ref27) {
    var commit = _ref27.commit;

    commit(CONSTANTS.ALLOCATION_ALLOCATIONS_PAGE_DECREMENT);
};

/**
 * Set allocation page limit.
 *
 * @param commit
 * @param payload
 */
var setAllocationLimit = exports.setAllocationLimit = function setAllocationLimit(_ref28, payload) {
    var commit = _ref28.commit;

    commit(CONSTANTS.ALLOCATION_ALLOCATIONS_LIMIT_SET, payload);
    commit(CONSTANTS.ALLOCATION_ALLOCATIONS_PAGE_SET, 1);
};

/**
 * Increment the page of the allocations list.
 *
 * @param commit
 */
var incrementModalPagination = exports.incrementModalPagination = function incrementModalPagination(_ref29) {
    var commit = _ref29.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_PAGE_INCREMENT);
};

/**
 * Decrement the page of the allocations list.
 *
 * @param commit
 */
var decrementModalPagination = exports.decrementModalPagination = function decrementModalPagination(_ref30) {
    var commit = _ref30.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_PAGE_DECREMENT);
};

/**
 * Set the page number for the modal pagination.
 *
 * @param commit
 * @param payload
 */
var setModalPagination = exports.setModalPagination = function setModalPagination(_ref31, payload) {
    var commit = _ref31.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_PAGE_SET, payload);
};

/**
 * Get filters for the manage allocations form
 *
 * @param context
 * @param payload
 */
var getRouteFilters = exports.getRouteFilters = function getRouteFilters(_ref32, payload) {
    var commit = _ref32.commit;

    commit(CONSTANTS.ALLOCATION_ROUTE_FILTERS_PENDING);
    var token = _TokenStorageService2.default.get();
    return _GatewayService2.default.getAllocationFilterData(payload, token).then(function (res) {
        commit(CONSTANTS.ALLOCATION_ROUTE_FILTERS_SUCCESS, res.data.data);
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_ROUTE_FILTERS_FAILURE);
    });
};

/**
 * Set the selected route filters
 *
 * @param commit
 * @param payload
 */
var setSelectedRouteFilters = exports.setSelectedRouteFilters = function setSelectedRouteFilters(_ref33, payload) {
    var commit = _ref33.commit;

    if (payload.hasOwnProperty('site') && !payload.hasOwnProperty('accommodation')) {
        payload.accommodation = undefined;
    }
    commit(CONSTANTS.ALLOCATION_ROUTE_FILTERS_SELECTED_SET, payload);
};

/**
 * Validate the allocation inputs.
 *
 * @param commit
 * @param state
 */
var validateAddAllocationInputs = exports.validateAddAllocationInputs = function validateAddAllocationInputs(_ref34) {
    var commit = _ref34.commit,
        state = _ref34.state;

    var _rows = state.form.rows;
    var _validator = Validator.validateAddAllocationInputs(_rows);
    if (_validator.valid) {
        commit(CONSTANTS.ALLOCATION_FORM_VALIDATOR_SUCCESS);
    } else {
        commit(CONSTANTS.ALLOCATION_FORM_VALIDATOR_FAILURE, _validator.messages);
    }
};

/**
 * Validate the allocation inputs for updating allocation.
 *
 * @param commit
 * @param state
 */
var validateUpdateAllocationInputs = exports.validateUpdateAllocationInputs = function validateUpdateAllocationInputs(_ref35) {
    var commit = _ref35.commit,
        state = _ref35.state;

    var _rows = state.modal.overlay.allocation;
    var _validator = Validator.validateAddAllocationInputs(_rows);
    if (_validator.valid) {
        commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_VALIDATOR_SUCCESS);
    } else {
        commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_VALIDATOR_FAILURE, _validator.messages);
    }
};

/**
 * Adds the allocations from the form and then reloads the page to fetch the new data.
 *
 * @param commit
 * @param state
 * @param dispatch
 * @param rootState
 */
var addAllocations = exports.addAllocations = function addAllocations(_ref36) {
    var commit = _ref36.commit,
        state = _ref36.state,
        dispatch = _ref36.dispatch,
        rootState = _ref36.rootState;

    commit(CONSTANTS.ALLOCATION_FORM_ACCEPT);
    commit(CONSTANTS.ALLOCATION_ALLOCATIONS_ADD_PENDING);
    var accommodationSiteId = state.form.filters.selected.accommodation.accommodationSiteId;
    var allocation = Converter.addAllocationData(accommodationSiteId, state.form.rows[0]);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.addAllocations(accommodationSiteId, allocation, token).then(function () {
        commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS, {
            text: 'manageAllocationModal.success',
            level: 'success'
        });
        commit(CONSTANTS.ALLOCATION_ALLOCATIONS_ADD_SUCCESS, {
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'add', 'added allocation', user.id)
        });
        // commit(CONSTANTS.ALLOCATION_MODAL_TOGGLE, false);
        commit(CONSTANTS.ALLOCATION_MODAL_ADD_TOGGLE, false);
        dispatch('fetchAllocationData');
    }).catch(function (err) {
        if (err.status === 403) {
            commit(CONSTANTS.ALLOCATION_ALLOCATIONS_ADD_FAILURE, {
                level: 'warning',
                text: 'allocationList.messages.unauthorized'
            });
        } else {
            commit(CONSTANTS.ALLOCATION_ALLOCATIONS_ADD_FAILURE, {
                level: 'error',
                text: 'allocationList.messages.error'
            });
        }
    });
};

/**
 * Update allocations from the modal overlay page.
 *
 * @param commit
 * @param state
 * @param dispatch
 * @param rootState
 * @returns {Promise<T>}
 */
var updateAllocation = exports.updateAllocation = function updateAllocation(_ref37) {
    var commit = _ref37.commit,
        state = _ref37.state,
        dispatch = _ref37.dispatch,
        rootState = _ref37.rootState;

    commit(CONSTANTS.ALLOCATION_FORM_ACCEPT);
    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING);
    var accommodationSiteId = state.form.filters.selected.accommodation.accommodationSiteId;
    var allocation = Converter.updateAllocationData(state.modal.overlay.allocation.item, state.modal.overlay.allocation.original);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.updateAllocation(accommodationSiteId, allocation, token).then(function () {
        commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS, {
            text: 'manageAllocationModal.update',
            level: 'success',
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'update', 'updated allocation', user.id)
        });
        commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        commit(CONSTANTS.ALLOCATION_COMMENT_RESET);
        dispatch('fetchAllocationData');
    }).catch(function (err) {
        if (err.status === 403) {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'warning',
                text: 'manageAllocationModal.unauthorized'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        } else {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'error',
                text: 'manageAllocationModal.error'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        }
    });
};

/**
 * Request an update for an allocation.
 *
 * @param commit
 * @param state
 * @param dispatch
 * @param rootState
 */
var requestUpdateAllocation = exports.requestUpdateAllocation = function requestUpdateAllocation(_ref38) {
    var commit = _ref38.commit,
        state = _ref38.state,
        dispatch = _ref38.dispatch,
        rootState = _ref38.rootState;

    commit(CONSTANTS.ALLOCATION_FORM_ACCEPT);
    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING);
    var accommodationSiteId = state.form.filters.selected.accommodation.accommodationSiteId;
    var allocation = Converter.requestAllocationData(state.modal.overlay.allocation.item, state.modal.overlay.allocation.original);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.requestUpdateAllocation(accommodationSiteId, allocation, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS, {
                text: 'manageAllocationModal.request',
                level: 'success',
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'request', 'requested change', user.id)
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
            dispatch('fetchRequestUpdateData');
        }
    }).catch(function (err) {
        if (err.status === 403) {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'warning',
                text: 'manageAllocationModal.unauthorized'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        } else {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'error',
                text: 'manageAllocationModal.error'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        }
    });
};

/**
 * Block allocations.
 *
 * @param commit
 * @param state
 * @param dispatch
 * @param rootState
 * @param payload
 */
var blockAllocation = exports.blockAllocation = function blockAllocation(_ref39, payload) {
    var commit = _ref39.commit,
        state = _ref39.state,
        dispatch = _ref39.dispatch,
        rootState = _ref39.rootState;

    commit(CONSTANTS.ALLOCATION_FORM_ACCEPT);
    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING);
    var accommodationSiteId = state.form.filters.selected.accommodation.accommodationSiteId;
    var comment = state.modal.overlay.allocation.item.comment;
    var period = Converter.blockAllocationData(payload, comment);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.blockAllocation(accommodationSiteId, period, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS, {
                text: 'manageAllocationModal.blocked',
                level: 'success',
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'block', 'blocked allocation', user.id)
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
            commit(CONSTANTS.ALLOCATION_COMMENT_RESET);
            dispatch('fetchAllocationData');
        }
    }).catch(function (err) {
        if (err.status === 403) {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'warning',
                text: 'allocationList.messages.unauthorized'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        } else {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'error',
                text: 'allocationList.messages.error'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        }
    });
};

/**
 * Request block allocation.
 *
 * @param commit
 * @param state
 * @param dispatch
 * @param rootState
 * @param payload
 * @returns {*|Promise<T>}
 */
var requestBlockAllocation = exports.requestBlockAllocation = function requestBlockAllocation(_ref40, payload) {
    var commit = _ref40.commit,
        state = _ref40.state,
        dispatch = _ref40.dispatch,
        rootState = _ref40.rootState;

    commit(CONSTANTS.ALLOCATION_FORM_ACCEPT);
    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING);
    var accommodationSiteId = state.form.filters.selected.accommodation.accommodationSiteId;
    var period = Converter.blockAllocationData(payload);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.requestBlockAllocation(accommodationSiteId, period, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS, {
                text: 'manageAllocationModal.request',
                level: 'success',
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'request', 'requested block', user.id)
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
            dispatch('fetchRequestUpdateData');
        }
    }).catch(function (err) {
        if (err.status === 403) {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'warning',
                text: 'allocationList.messages.unauthorized'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        } else {
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, {
                level: 'error',
                text: 'allocationList.messages.error'
            });
            commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        }
    });
};

/**
 * Reset the validation state.
 *
 * @param commit
 */
var resetValidationMessage = exports.resetValidationMessage = function resetValidationMessage(_ref41) {
    var commit = _ref41.commit;

    commit(CONSTANTS.ALLOCATION_FORM_VALIDATOR_RESET);
};

/**
 * Toggle the add allocation form.
 *
 * @param commit
 */
var toggleAddAllocationForm = exports.toggleAddAllocationForm = function toggleAddAllocationForm(_ref42) {
    var commit = _ref42.commit;

    commit(CONSTANTS.ALLOCATION_FORM_TOGGLE);
};

/**
 * Toggle modal and reset all functionality for modal.
 *
 * @param commit
 * @param state
 */
var toggleModal = exports.toggleModal = function toggleModal(_ref43) {
    var commit = _ref43.commit,
        state = _ref43.state;

    if (state.calendar.from && state.calendar.to) {
        commit(CONSTANTS.ALLOCATION_MODAL_PAGE_SET, 1);
        commit(CONSTANTS.ALLOCATION_FORM_TOGGLE, false);
        commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, false);
        commit(CONSTANTS.ALLOCATION_MODAL_ADD_TOGGLE, false);
        commit(CONSTANTS.ALLOCATION_MODAL_TOGGLE);
        commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_ERROR_MESSAGE_RESET);
    }
};

/**
 * Toggle the manage allocation modal.
 *
 * @param commit
 */
var toggleModalOverlay = exports.toggleModalOverlay = function toggleModalOverlay(_ref44) {
    var commit = _ref44.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE);
    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET, 1);
};

/**
 * Set the values for the manage allocations modal form.
 *
 * @param commit
 * @param payload
 */
var setModalRow = exports.setModalRow = function setModalRow(_ref45, payload) {
    var commit = _ref45.commit;

    // If changing release method then set other release method to undefined
    if (payload.releaseMethod === 'days') {
        payload = _extends({}, payload, { releaseDate: undefined });
    } else if (payload.releaseMethod === 'date') {
        payload = _extends({}, payload, { releaseDays: undefined });
    }
    commit(CONSTANTS.ALLOCATION_MODAL_FORM_SET, payload);
};

/**
 * Set the values for the manage allocations modal form.
 *
 * @param commit
 * @param payload
 */
var setOverlayRow = exports.setOverlayRow = function setOverlayRow(_ref46, payload) {
    var commit = _ref46.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_FORM_SET, payload);
};

/**
 * Reset the allocation item.
 *
 * @param commit
 */
var resetOverlayRow = exports.resetOverlayRow = function resetOverlayRow(_ref47) {
    var commit = _ref47.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_FORM_RESET);
};

/**
 * Sets the chosen allocation for the modal overlay.
 *
 * @param commit
 * @param state
 * @param payload
 */
var chooseAllocation = exports.chooseAllocation = function chooseAllocation(_ref48, payload) {
    var commit = _ref48.commit,
        state = _ref48.state;

    // Calculate the date to use for the allocation
    var period = (0, _DateToolService.calculatePeriodFromTo)(state.calendar.from, state.calendar.to, payload);
    // Send a copy of the allocation object to be able to manipulate it
    commit(CONSTANTS.ALLOCATION_MODAL_ALLOCATION_SET, _extends({}, Converter.clone(payload), period));
    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, true);
    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET, 1);
};

/**
 * Increments the overlays bookings page
 *
 * @param context
 */
var incrementOverlayBookingsPage = exports.incrementOverlayBookingsPage = function incrementOverlayBookingsPage(_ref49) {
    var commit = _ref49.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_INCREMENT);
};

/**
 * Decrements the overlays bookings page
 *
 * @param context
 */
var decrementOverlayBookingsPage = exports.decrementOverlayBookingsPage = function decrementOverlayBookingsPage(_ref50) {
    var commit = _ref50.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_DECREMENT);
};

/**
 * Set the date for the allocation calendar.
 * If the from date is not set then that date will be set, else it will be the to date
 * and if both is set then the modal opens.
 *
 * @param commit
 * @param state
 * @param payload
 */
var selectCalendarDate = exports.selectCalendarDate = function selectCalendarDate(_ref51, payload) {
    var commit = _ref51.commit,
        state = _ref51.state;

    if (!state.calendar.from) {
        commit(CONSTANTS.ALLOCATION_CALENDAR_DATE_SET, { data: { from: payload.day, startIndex: payload.index } });
    } else if (state.calendar.from && !state.calendar.to) {
        // Add one more day to the end date
        commit(CONSTANTS.ALLOCATION_CALENDAR_DATE_SET, { data: { to: (0, _DateToolService.addDay)(payload.day) } });
        commit(CONSTANTS.ALLOCATION_MODAL_TOGGLE, true);
    }
};

/**
 * Deselect the date from the allocation calendar.
 *
 * @param commit
 * @param state
 */
var deselectCalendarDate = exports.deselectCalendarDate = function deselectCalendarDate(_ref52) {
    var commit = _ref52.commit;

    commit(CONSTANTS.ALLOCATION_CALENDAR_DATE_SET, { data: { from: undefined, startIndex: undefined } });
};

/**
 * Increment the page for the calendar pagination.
 *
 * @param commit
 * @param payload
 */
var incrementCalendarPage = exports.incrementCalendarPage = function incrementCalendarPage(_ref53) {
    var commit = _ref53.commit;

    commit(CONSTANTS.ALLOCATION_CALENDAR_PAGE_INCREMENT);
};

/**
 * Decrement the page for the calendar pagination.
 *
 * @param commit
 * @param payload
 */
var decrementCalendarPage = exports.decrementCalendarPage = function decrementCalendarPage(_ref54) {
    var commit = _ref54.commit;

    commit(CONSTANTS.ALLOCATION_CALENDAR_PAGE_DECREMENT);
};

/**
 * Chose calendar display option.
 *
 * @param commit
 * @param payload
 */
var choseCalendarDisplay = exports.choseCalendarDisplay = function choseCalendarDisplay(_ref55, payload) {
    var commit = _ref55.commit;

    commit(CONSTANTS.ALLOCATION_CALENDAR_DISPLAY_SET, payload);
};

/**
 * Toggle the calendar infobox.
 *
 * @param commit
 * @param payload
 */
var toggleCalendarInfoBox = exports.toggleCalendarInfoBox = function toggleCalendarInfoBox(_ref56, payload) {
    var commit = _ref56.commit;

    commit(CONSTANTS.ALLOCATION_CALENDAR_INFO_TOGGLE, payload);
};

/**
 * Change the info page number.
 *
 * @param commit
 * @param payload
 */
var infoPageSet = exports.infoPageSet = function infoPageSet(_ref57, payload) {
    var commit = _ref57.commit;

    commit(CONSTANTS.ALLOCATION_CALENDAR_INFO_PAGE_SET, payload);
};

/**
 * Toggle modal add allocation form
 *
 * @param commit
 */
var toggleModalAddAllocations = exports.toggleModalAddAllocations = function toggleModalAddAllocations(_ref58) {
    var commit = _ref58.commit;

    commit(CONSTANTS.ALLOCATION_MODAL_ADD_TOGGLE);
};

/**
 * Add new allocation for period that is already assigned, so change dates for calendar and toggle modal add allocation
 *
 * @param commit
 * @param payload
 */
var toggleModalNewAllocation = exports.toggleModalNewAllocation = function toggleModalNewAllocation(_ref59, payload) {
    var commit = _ref59.commit;

    // Set the period to the full period of the allocation chosen
    commit(CONSTANTS.ALLOCATION_CALENDAR_DATE_SET, { from: payload.from, to: payload.to });
    // Toggle the ad allocation modal
    commit(CONSTANTS.ALLOCATION_MODAL_ADD_TOGGLE);
};

/**
 * Change the year.
 *
 * @param commit
 * @param state
 * @param payload
 */
var updateYear = exports.updateYear = function updateYear(_ref60, payload) {
    var commit = _ref60.commit,
        dispatch = _ref60.dispatch;

    commit(CONSTANTS.ALLOCATION_YEAR_SET, payload);
    // Fetch data and toggle the modal overlay
    dispatch('fetchAllocationData');
};

/**
 * Request accept action.
 *
 * @param commit
 * @param dispatch
 * @param rootState
 * @param payload
 * @returns {Promise<T>}
 */
var requestAccept = exports.requestAccept = function requestAccept(_ref61, payload) {
    var commit = _ref61.commit,
        dispatch = _ref61.dispatch,
        rootState = _ref61.rootState;

    commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_PENDING);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.requestAccept(token, payload).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_SUCCESS, {
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'request', 'request accepted', user.id)
            });
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'request.accept.success',
                level: 'success'
            }, { root: true });
            dispatch('fetchRequestUpdateData');
        }
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'request.accept.failure',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Accept request with modifications.
 *
 * @param commit
 * @param dispatch
 * @param state
 * @param rootState
 * @returns {*|Promise<T>}
 */
var requestAcceptModify = exports.requestAcceptModify = function requestAcceptModify(_ref62) {
    var commit = _ref62.commit,
        dispatch = _ref62.dispatch,
        state = _ref62.state,
        rootState = _ref62.rootState;

    commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_PENDING);
    commit(CONSTANTS.ALLOCATION_REQUEST_EDIT_TOGGLE, false);
    var token = _TokenStorageService2.default.get();
    var item = state.request.item;
    var itemIndex = state.request.itemIndex;
    var original = state.request.items.pending[itemIndex];
    var allocationObject = Converter.modifyAllocationData(item, original);
    var user = rootState.auth.user;

    return _GatewayService2.default.requestAcceptModfied(token, { id: item.id, allocationObject: allocationObject }).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_SUCCESS, {
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'request', 'request accepted with modifications', user.id)
            });
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'request.modify.success',
                level: 'success'
            }, { root: true });
            commit(CONSTANTS.ALLOCATION_REQUEST_ITEM_DESELECT);
            dispatch('fetchRequestUpdateData');
        }
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'request.modify.failure',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Request deny action.
 *
 * @param commit
 * @param dispatch
 * @param rootState
 * @param payload
 * @returns {Promise<T>}
 */
var requestDeny = exports.requestDeny = function requestDeny(_ref63, payload) {
    var commit = _ref63.commit,
        dispatch = _ref63.dispatch,
        rootState = _ref63.rootState;

    commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_PENDING);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.requestDeny(token, payload).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_SUCCESS, {
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'request', 'request denied', user.id)
            });
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'request.decline.success',
                level: 'success'
            }, { root: true });
            dispatch('fetchRequestUpdateData');
        }
    }).catch(function () {
        commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'request.decline.failure',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Cancel a request.
 *
 * @param commit
 * @param dispatch
 * @param rootState
 * @param payload
 * @returns {Promise<T>}
 */
var requestCancel = exports.requestCancel = function requestCancel(_ref64, payload) {
    var commit = _ref64.commit,
        dispatch = _ref64.dispatch,
        rootState = _ref64.rootState;

    commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_PENDING);
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;

    return _GatewayService2.default.requestCancel(token, payload).then(function () {
        commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_SUCCESS, {
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('allocation', 'request', 'request cancelled', user.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'request.cancel.success',
            level: 'success'
        }, { root: true });
        dispatch('fetchRequestUpdateData');
    }).catch(function (err) {
        commit(CONSTANTS.ALLOCATION_REQUEST_UPDATE_FAILURE);
        if (err.status === 403) {
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'request.cancel.unauth',
                level: 'danger'
            }, { root: true });
        } else {
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'request.cancel.failure',
                level: 'danger'
            }, { root: true });
        }
    });
};

/**
 * Increment the request page.
 *
 * @param commit
 */
var requestPageIncrement = exports.requestPageIncrement = function requestPageIncrement(_ref65) {
    var commit = _ref65.commit;

    commit(CONSTANTS.ALLOCATION_REQUEST_PAGE_INCREMENT);
};

/**
 * Decrement the request page.
 *
 * @param commit
 */
var requestPageDecrement = exports.requestPageDecrement = function requestPageDecrement(_ref66) {
    var commit = _ref66.commit;

    commit(CONSTANTS.ALLOCATION_REQUEST_PAGE_DECREMENT);
};

/**
 * Set the request predicate.
 *
 * @param commit
 * @param payload
 */
var requestPredicateSet = exports.requestPredicateSet = function requestPredicateSet(_ref67, payload) {
    var commit = _ref67.commit;

    commit(CONSTANTS.ALLOCATION_REQUEST_PREDICATE_SET, payload);
    commit(CONSTANTS.ALLOCATION_REQUEST_PAGE_RESET);
};

/**
 * Select at specific request item.
 *
 * @param commit
 * @param payload
 */
var requestItemSelect = exports.requestItemSelect = function requestItemSelect(_ref68, payload) {
    var commit = _ref68.commit;

    commit(CONSTANTS.ALLOCATION_REQUEST_ITEM_SELECT, _extends({}, payload, { request: Converter.clone(payload.request) }));
};

/**
 * Set the request item.
 *
 * @param commit
 * @param payload
 */
var requestItemSet = exports.requestItemSet = function requestItemSet(_ref69, payload) {
    var commit = _ref69.commit;

    commit(CONSTANTS.ALLOCATION_REQUEST_ITEM_SET, payload);
};

/**
 * Toggle the request edit page.
 *
 * @param commit
 * @param payload
 */
var requestEditToggle = exports.requestEditToggle = function requestEditToggle(_ref70, payload) {
    var commit = _ref70.commit;

    commit(CONSTANTS.ALLOCATION_REQUEST_EDIT_TOGGLE, payload);
    if (payload !== undefined && !payload) {
        commit(CONSTANTS.ALLOCATION_REQUEST_ITEM_DESELECT);
    }
};

/**
 * Allocation list option select.
 *
 * @param commit
 * @param payload
 */
var allocationListOptionSelect = exports.allocationListOptionSelect = function allocationListOptionSelect(_ref71, payload) {
    var commit = _ref71.commit;

    commit(CONSTANTS.ALLOCATION_LIST_DISPLAY_SELECT, payload);
};

/**
 * Allocation list option reset.
 *
 * @param commit
 */
var allocationListOptionReset = exports.allocationListOptionReset = function allocationListOptionReset(_ref72) {
    var commit = _ref72.commit;

    commit(CONSTANTS.ALLOCATION_LIST_DISPLAY_RESET);
};

/**
 * Counts down the allocation timer.
 *
 * @param commit
 */
var countdown = exports.countdown = function countdown(_ref73) {
    var commit = _ref73.commit;

    commit(CONSTANTS.ALLOCATION_COUNTDOWN_DECREMENT);
};

/**
 * Retrieve the route filter data and set filter in state.
 *
 * @param commit
 * @param state
 * @param getters
 * @param payload
 */
var setRouteFilters = exports.setRouteFilters = function setRouteFilters(_ref74, payload) {
    var commit = _ref74.commit,
        state = _ref74.state;

    var sites = state.form.filters.sites;
    var routeData = Converter.getRouteFilterData(sites, payload.siteId, payload.accommodationSiteId);
    commit(CONSTANTS.ALLOCATION_ROUTE_FILTERS_SELECTED_SET, routeData);
};

/**
 * Calculate and set the period for the calendar to which year and which months to display.
 * - At the 1st of november the calendar year will switch.
 *
 * @param commit
 */
var setCalendarDates = exports.setCalendarDates = function setCalendarDates(_ref75) {
    var commit = _ref75.commit;

    var dateObject = (0, _DateToolService.calculateCalendarDates)();
    commit(CONSTANTS.ALLOCATION_CALENDAR_DATES_SET, dateObject);
};

/**
 * Reset the allocations state.
 *
 * @param commit
 */
var resetState = exports.resetState = function resetState(_ref76) {
    var commit = _ref76.commit;

    commit(CONSTANTS.ALLOCATION_RESET_STATE);
};

/**
 * Add allocation comment.
 *
 * @param commit
 * @param payload
 */
var addAllocationComment = exports.addAllocationComment = function addAllocationComment(_ref77, payload) {
    var commit = _ref77.commit;

    commit(CONSTANTS.ALLOCATION_COMMENT_SET, payload);
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStatisticsForPeriod = exports.getAllocationReleaseTypes = exports.getAllocationTypes = exports.filteredSites = exports.requestsMaxPages = exports.requestsPaginated = exports.changeRequestForAllocation = exports.requestCount = exports.getCalendarPaginated = exports.getCalendar = exports.overlayAllocationChanged = exports.allotmentInPeriod = exports.allocationsInPeriodMaxPages = exports.allocationsInPeriodPaginated = exports.allocationsInPeriod = exports.routeAccommodationNames = exports.routeSiteNames = exports.accommodations = exports.siteNames = exports.filteredAllocationsMaxPages = exports.filteredAllocationsPaginated = exports.filteredAllocations = exports.filteredAccommodationsMaxPages = exports.filteredAccommodationsPaginated = exports.filteredAccommodations = undefined;

var _lodashEs = __webpack_require__(14);

var _moment = __webpack_require__(5);

var _moment2 = _interopRequireDefault(_moment);

var _DateToolService = __webpack_require__(48);

var DateTool = _interopRequireWildcard(_DateToolService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves a list of filtered allocations
 *
 * @param state
 * @returns {*|Array}
 */
var filteredAccommodations = exports.filteredAccommodations = function filteredAccommodations(state) {
    var _selected = state.filters.selected;
    var _allocations = state.list.items;
    var _predicate = state.list.predicate;
    var _order = state.list.order;

    _allocations = (0, _lodashEs.filter)(_allocations, function (allocation) {
        var site = _selected.site ? allocation.site === _selected.site : true;
        var accommodation = _selected.accommodation ? allocation.name === _selected.accommodation : true;

        return site && accommodation;
    });

    return (0, _lodashEs.orderBy)(_allocations, [_predicate], [_order]);
};

/**
 * Retrieves a list of filtered allocations sliced by the current
 * page and limit.
 *
 * @param state
 * @param getters
 */
var filteredAccommodationsPaginated = exports.filteredAccommodationsPaginated = function filteredAccommodationsPaginated(state, getters) {
    var _page = state.list.page;
    var _limit = state.list.limit;

    return getters.filteredAccommodations.slice(_page * _limit - _limit, _page * _limit);
};

/**
 * Retrieves the maximum number of pages for the currently
 * filtered allocations
 *
 * @param state
 * @param getters
 * @returns {number}
 */
var filteredAccommodationsMaxPages = exports.filteredAccommodationsMaxPages = function filteredAccommodationsMaxPages(state, getters) {
    var _limit = state.list.limit;
    return Math.ceil(getters.filteredAccommodations.length / _limit);
};

/**
 * Filters the allocation list based on show/hide historical data.
 *
 * @param state
 * @returns {Array}
 */
var filteredAllocations = exports.filteredAllocations = function filteredAllocations(state) {
    var _today = (0, _moment2.default)().startOf('day');
    var _display = state.list.display;

    if (state.allocations.items) {
        var accommodationSiteId = Object.keys(state.allocations.items)[0];
        var allocationsList = (0, _lodashEs.map)(state.allocations.items[accommodationSiteId]);
        return (0, _lodashEs.filter)(allocationsList, function (allocation) {
            switch (_display) {
                case 'current':
                    return _today.diff(DateTool.convertStringDateToDate(allocation.to)) <= 0;
                case 'historical':
                    return _today.diff(DateTool.convertStringDateToDate(allocation.to)) > 0;
                default:
                    return true;
            }
        });
    }
};

/**
 * Retrieves a paginated list of the filtered bookings
 *
 * @param state
 * @returns array
 */
var filteredAllocationsPaginated = exports.filteredAllocationsPaginated = function filteredAllocationsPaginated(state) {
    var _page = state.allocations.page;
    var _limit = state.allocations.limit;
    var _allocationList = filteredAllocations(state);

    if (state.allocations.items) {
        return _allocationList.slice(_page * _limit - _limit, _page * _limit);
    }
    return [];
};

/**
 * Retrieves the maximum number of pages returned
 * from the paginated list of filtered bookings
 *
 * @param state
 * @returns {number}
 */
var filteredAllocationsMaxPages = exports.filteredAllocationsMaxPages = function filteredAllocationsMaxPages(state) {
    var _allocationList = filteredAllocations(state);
    var _limit = state.allocations.limit;
    var _maxPage = 1;

    if (state.allocations.items) {
        _maxPage = Math.ceil(_allocationList.length / _limit);
        return _maxPage > 0 ? _maxPage : 1;
    }
    return _maxPage;
};

/**
 * Retrieves a list of site names from the nested
 * site / accommodations object
 *
 * @param state
 */
var siteNames = exports.siteNames = function siteNames(state) {
    return (0, _lodashEs.map)(state.filters.sites, 'name');
};

/**
 * Retrieve a list of accommodation names from the selected site.
 *
 * @param state
 * @returns {Array}
 */
var accommodations = exports.accommodations = function accommodations(state) {
    var _site = (0, _lodashEs.filter)(state.filters.sites, function (site) {
        if (site.name === state.filters.selected.site) {
            return site;
        }
    });
    var _accommodations = (0, _lodashEs.map)(_site, 'accommodations');
    return (0, _lodashEs.map)(_accommodations[0], 'name');
};

/**
 * Retrieves a list of site names from the nested
 * site / accommodations object, for the route changer
 * on the manage allocations page
 */
var routeSiteNames = exports.routeSiteNames = function routeSiteNames(state) {
    return state.form.filters.sites || [];
};

/**
 * Retrieve a list of the accommodation names belonging to the site chosen.
 *
 * @param state
 * @returns {Array}
 */
var routeAccommodationNames = exports.routeAccommodationNames = function routeAccommodationNames(state) {
    var sites = state.form.filters.sites || [];
    var selectedSiteName = state.form.filters.selected.site ? state.form.filters.selected.site.name : '';
    var site = (0, _lodashEs.filter)(sites, function (site) {
        return site.name === selectedSiteName;
    });
    return site.length ? site[0].accommodations : [];
};

/**
 * Get list of allocations that have parts within a given period
 *
 * @param state
 * @returns {Array}
 */
var allocationsInPeriod = exports.allocationsInPeriod = function allocationsInPeriod(state) {
    var allocationsWithinPeriod = [];
    var from = state.calendar.from;
    var to = state.calendar.to;

    var allocations = state.allocationsMerged.items ? state.allocationsMerged.items : [];
    var changeRequests = state.request.items && state.request.items.pending ? state.request.items.pending : [];
    // If the dates are set then check within periods which allocations that are present.
    if (from && to) {
        allocationsWithinPeriod = DateTool.listOfAllocationsWithinPeriod(from, to, allocations, changeRequests);
    }
    return allocationsWithinPeriod;
};

/**
 * Get list of allocations that have parts within a given period - paginated.
 *
 * @param state
 * @param getters
 * @returns {Array}
 */
var allocationsInPeriodPaginated = exports.allocationsInPeriodPaginated = function allocationsInPeriodPaginated(state, getters) {
    var _page = state.modal.list.page;
    var _limit = state.modal.list.limit;
    var allocationsWithinPeriod = getters.allocationsInPeriod;

    return (0, _lodashEs.map)(allocationsWithinPeriod.slice(_page * _limit - _limit, _page * _limit));
};

/**
 * Retrieves the maximum number of pages for the currently
 * filtered allocations
 *
 * @param state
 * @param getters
 * @returns {number}
 */
var allocationsInPeriodMaxPages = exports.allocationsInPeriodMaxPages = function allocationsInPeriodMaxPages(state, getters) {
    var _limit = state.modal.list.limit;
    return Math.ceil(getters.allocationsInPeriod.length / _limit);
};

/**
 * Check all allocation within period to see if any have allotment on them. If all are blocked or on request return true.
 *
 * @param state
 * @param getters
 * @returns {boolean}
 */
var allotmentInPeriod = exports.allotmentInPeriod = function allotmentInPeriod(state, getters) {
    var allotmentInPeriod = true;
    var allocationsInPeriod = getters.allocationsInPeriod;
    if (allocationsInPeriod.length > 0) {
        allocationsInPeriod.forEach(function (item) {
            allotmentInPeriod = !(item.allocation.type === 'BLOCKED' || item.allocation.type === 'REQUEST' || item.isReleased && item.allocation.releaseType === 'BLOCKED' || item.isReleased && item.allocation.releaseType === 'REQUEST');
        });
    }
    return allotmentInPeriod;
};

/**
 * Check if any attributes has been changed in the overlay alllocation.
 *
 * @param state
 * @returns {boolean}
 */
var overlayAllocationChanged = exports.overlayAllocationChanged = function overlayAllocationChanged(state) {
    var item = state.modal.overlay.allocation.item;
    var original = state.modal.overlay.allocation.original;
    var changed = false;

    if (item) {
        (0, _lodashEs.filter)(item, function (attribute, key) {
            // Check if any attribute has changed.
            if (attribute !== original[key]) {
                changed = true;
            }
        });
    }
    return changed;
};

/**
 * Return the calendar for the calendar view.
 *
 * @param state
 */
var getCalendar = exports.getCalendar = function getCalendar(state) {
    // If accommodations exists then generate the calendar
    if (state.calendar.items !== undefined) {
        // Set initial values
        var calendar = [];
        var index = 0;
        var weekIndex = 0;
        var monthIndex = 0;
        var dates = state.calendar.items.dates;
        // Generate initial dates
        var today = (0, _moment2.default)().startOf('day');
        var current = state.allocations.years.current;
        var startOfYear = (0, _moment2.default)('01/01/' + current, 'DD/MM/YYYY');
        var endOfYear = (0, _moment2.default)('31/12/' + current, 'DD/MM/YYYY').add(1, 'days');

        // Run through the year to generate a yearly calendar with months, weeks and dates.
        while (startOfYear.diff(endOfYear) < 0) {
            // If new month then generate an array to store weeks
            if (!calendar[startOfYear.month()]) {
                calendar[startOfYear.month()] = {
                    index: monthIndex,
                    weeks: []
                };
                monthIndex++;
                weekIndex = 0;
            }
            // If new week then generate a new week to store days
            if (!calendar[startOfYear.month()].weeks[weekIndex]) {
                // Fill array with 7 elements to compensate for days in week not i current month
                calendar[startOfYear.month()].weeks[weekIndex] = {
                    number: startOfYear.week(),
                    days: [{ day: null }, { day: null }, { day: null }, { day: null }, { day: null }, { day: null }, { day: null }]
                };
            }
            // Push dates
            calendar[startOfYear.month()].weeks[weekIndex].days[startOfYear.day()].day = startOfYear.clone();
            // Set an index on each date to use for javascript rendering animations
            calendar[startOfYear.month()].weeks[weekIndex].days[startOfYear.day()].index = index;
            // Set the tooltip data
            calendar[startOfYear.month()].weeks[weekIndex].days[startOfYear.day()].tooltip = { initialUnits: 12, currentUnits: 10, arrivalData: false };
            // Set the data for the current date
            calendar[startOfYear.month()].weeks[weekIndex].days[startOfYear.day()].data = dates[index] ? dates[index] : null;
            // Set boolean to indicate if day is past
            calendar[startOfYear.month()].weeks[weekIndex].days[startOfYear.day()].past = today.diff(startOfYear) > 0;
            // Set the current day boolean
            calendar[startOfYear.month()].weeks[weekIndex].days[startOfYear.day()].currentDay = today.diff(startOfYear) === 0;
            // Increment index
            index++;
            // Go to next day
            startOfYear.add(1, 'days');
            // If new week then increment weekIndex
            if (startOfYear.day() === 0) {
                weekIndex++;
            }
        }
        return calendar;
    }
    return null;
};

/**
 * Paginate the calendar. The initial months are set from april to september
 *
 * @param state
 * @param getters
 * @returns {Array}
 */
var getCalendarPaginated = exports.getCalendarPaginated = function getCalendarPaginated(state, getters) {
    var calendar = getters.getCalendar;
    var startMonth = state.calendar.startMonth;
    var endMonth = state.calendar.endMonth;
    return (0, _lodashEs.filter)(calendar, function (month, index) {
        if (index >= startMonth && index < endMonth) {
            return month;
        }
    });
};

/**
 * Count the amount of requests.
 *
 * @param state
 * @returns {*}
 */
var requestCount = exports.requestCount = function requestCount(state) {
    return state.request.items ? [state.request.items.pending.length, state.request.items.approved.length, state.request.items.denied.length, state.request.items.modified.length] : [];
};

/**
 * Return list of change requests for the allocation.
 *
 * @param state
 * @returns {*}
 */
var changeRequestForAllocation = exports.changeRequestForAllocation = function changeRequestForAllocation(state) {
    var allocation = state.modal.overlay.allocation.original;
    var changeRequests = state.request.items && state.request.items.pending.length ? state.request.items.pending : [];
    var changeRequest = [];
    if (allocation && changeRequests) {
        changeRequest = DateTool.changeRequestForAllocation(allocation, changeRequests);
    }
    return changeRequest;
};

/**
 * Return list of requests paginated.
 *
 * @param state
 * @returns {Array}
 */
var requestsPaginated = exports.requestsPaginated = function requestsPaginated(state) {
    var _predicate = state.request.predicate;
    var _page = state.request.page;
    var _limit = state.request.limit;
    var requests = state.request.items && state.request.items[_predicate] ? state.request.items[_predicate] : [];

    return (0, _lodashEs.map)(requests.slice(_page * _limit - _limit, _page * _limit));
};

/**
 * Return max page count for requests.
 *
 * @param state
 * @returns {number}
 */
var requestsMaxPages = exports.requestsMaxPages = function requestsMaxPages(state) {
    var _predicate = state.request.predicate;
    var _limit = state.request.limit;
    var requests = state.request.items && state.request.items[_predicate] ? state.request.items[_predicate] : [];

    return Math.ceil(requests.length / _limit);
};

/**
 * Get a suppliers sites.
 *
 * @param state
 * @param getters
 * @param rootState
 */
var filteredSites = exports.filteredSites = function filteredSites(state) {
    var allocations = state.list.items;
    return (0, _lodashEs.uniq)((0, _lodashEs.map)(allocations, function (allocation) {
        return allocation.site;
    }));
};

/**
 * Return list of allocation types.
 *
 * @returns {string[]}
 */
var getAllocationTypes = exports.getAllocationTypes = function getAllocationTypes() {
    return ['ALLOTMENT', 'FREESALE', 'REQUEST'];
};

/**
 * Return list of allocation release types.
 *
 * @returns {string[]}
 */
var getAllocationReleaseTypes = exports.getAllocationReleaseTypes = function getAllocationReleaseTypes() {
    return ['FREESALE', 'REQUEST', 'BLOCKED'];
};

/**
 * Get allocation statistics for a given period.
 *
 * @param state
 */
var getStatisticsForPeriod = exports.getStatisticsForPeriod = function getStatisticsForPeriod(state) {
    var calendar = state.calendar.items;
    var allocation = state.modal.overlay.allocation.original;
    var arrivalRules = state.arrivalRules.item;
    var statisticsObject = {
        bookings: false,
        bookingsMaxCount: 0,
        arrival: false,
        arrivalRules: []
    };

    if (allocation && calendar && arrivalRules) {
        var startIndex = (0, _moment2.default)(allocation.from).dayOfYear();
        var endIndex = (0, _moment2.default)(allocation.to).dayOfYear();

        for (startIndex; startIndex < endIndex; startIndex++) {
            var day = calendar.dates[startIndex - 1];
            // If bookings then set statisticsObject.bookings to true
            if (!statisticsObject.bookings && day.bookings) {
                statisticsObject.bookings = true;
                // Check and set statisticsObject.bookingsMaxCount
                if (day.bookings > statisticsObject.bookingsMaxCount) {
                    statisticsObject.bookingsMaxCount = day.bookings;
                }
            }
            // If arrival then set statisticsObject.arrival to true
            if (!statisticsObject.arrival && day.arrival) {
                statisticsObject.arrival = true;
            }
            // If new arrival rule then add to statisticsObject.arrivalRules
            if (day.minStayDays || day.maxStayDays) {
                statisticsObject.arrivalRules = getArrivalRulesFromPeriod(statisticsObject.arrivalRules, day, arrivalRules);
            }
        }
    }
    return statisticsObject;
};

/**
 * Generate and add new arrival rule.
 *
 * @param statisticsObjectArrivalRules
 * @param arrivalRules
 * @param day
 */
var getArrivalRulesFromPeriod = function getArrivalRulesFromPeriod(statisticsObjectArrivalRules, day, arrivalRules) {
    var arrivalRuleOnDay = (0, _lodashEs.filter)(arrivalRules, function (rule) {
        return (0, _moment2.default)(day.date).isBetween((0, _moment2.default)(rule.startDate), (0, _moment2.default)(rule.endDate).add(1, 'days'));
    })[0];
    if (statisticsObjectArrivalRules.length === 0) {
        statisticsObjectArrivalRules.push(arrivalRuleOnDay);
    } else {
        // Check if arrival rule already exists
        if (!(0, _lodashEs.some)(statisticsObjectArrivalRules, arrivalRuleOnDay)) {
            statisticsObjectArrivalRules.push(arrivalRuleOnDay);
        }
    }
    return statisticsObjectArrivalRules;
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$ALLOCATION;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _DateToolService = __webpack_require__(48);

var _moment = __webpack_require__(5);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 *  Booking Mutations
 */
exports.default = (_CONSTANTS$ALLOCATION = {}, _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_FETCH_PENDING, function (state) {
    state.list = _extends({}, state.list, { items: undefined, loading: true, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_FETCH_SUCCESS, function (state, payload) {
    state.list = _extends({}, state.list, { items: payload, loading: false, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_FETCH_FAILURE, function (state) {
    state.list = _extends({}, state.list, { items: undefined, loading: false, noContent: false, error: true });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_FETCH_NO_CONTENT, function (state) {
    state.list = _extends({}, state.list, { items: undefined, loading: false, noContent: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_FILTERS_PENDING, function (state) {
    state.filters = _extends({}, state.filters, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_FILTERS_SUCCESS, function (state, payload) {
    state.filters = _extends({}, state.filters, { loading: false, error: false, sites: payload.sites, suppliers: payload.suppliers });
    state.filters.selected = _extends({}, state.filters.selected, { supplier: payload.selectedSupplier });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_FILTERS_FAILURE, function (state) {
    state.filters = _extends({}, state.filters, { loading: false, error: true, sites: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_PAGE_DECREMENT, function (state) {
    state.list.page = state.list.page - 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_PAGE_INCREMENT, function (state) {
    state.list.page = state.list.page + 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_PAGE_SET, function (state, payload) {
    state.list.page = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_PAGE_DECREMENT, function (state) {
    state.modal.list.page = state.modal.list.page - 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_PAGE_INCREMENT, function (state) {
    state.modal.list.page = state.modal.list.page + 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_PAGE_SET, function (state, payload) {
    state.modal.list.page = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_SELECTED_SET, function (state, payload) {
    state.filters.selected = _extends({}, state.filters.selected, payload);
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_SELECTED_RESET, function (state) {
    state.filters.selected = _extends({}, state.filters.selected, {
        site: undefined,
        accommodation: undefined,
        supplier: undefined
    });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_LIMIT_SET, function (state, payload) {
    state.list.limit = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_PREDICATE_SET, function (state, payload) {
    state.list.predicate = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_ORDER_SET, function (state, payload) {
    state.list.order = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_DISPLAY_SELECT, function (state, payload) {
    state.list.display = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_LIST_DISPLAY_RESET, function (state) {
    state.list.display = 'current';
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_ROW_ADD, function (state, payload) {
    state.form.rows = [].concat(_toConsumableArray(state.form.rows.slice(0, payload + 1)), [state.form.defaultRow], _toConsumableArray(state.form.rows.slice(payload + 1)));
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_ROW_DUPLICATE, function (state, _ref) {
    var index = _ref.index,
        data = _ref.data;

    state.form.rows = [].concat(_toConsumableArray(state.form.rows.slice(0, index + 1)), [data], _toConsumableArray(state.form.rows.slice(index + 1)));
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_ROW_REMOVE, function (state, payload) {
    state.form.rows = state.form.rows.filter(function (item, index) {
        return index !== payload;
    });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_ROW_CLEAR, function (state) {
    state.form.rows = [state.form.defaultRow];
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_ROW_SET, function (state, _ref2) {
    var data = _ref2.data,
        index = _ref2.index;

    // If type is not allotment then reset the units count
    if (!(data.type === 'ALLOTMENT' || data.type === 'GUARANTEE')) {
        data.units = "";
    }
    state.form.rows = state.form.rows.map(function (r, i) {
        return i === index ? data : r;
    });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_ROW_RESET, function (state) {
    state.form.rows = [state.form.defaultRow];
    state.form.validator = _extends({}, state.form.validator, { error: false, messages: [] });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_SUBMIT, function (state, payload) {
    state.form.submit = _extends({}, state.form.submit, { submitted: true, accepted: false, cancelled: false, alerts: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_ACCEPT, function (state) {
    state.form.submit = _extends({}, state.form.submit, {
        submitted: false,
        accepted: true,
        cancelled: false,
        alerts: undefined
    });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_CANCEL, function (state) {
    state.form.submit = _extends({}, state.form.submit, { submitted: false, accepted: false, cancelled: true, alerts: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_PENDING, function (state) {
    state.allocations = _extends({}, state.allocations, { items: undefined, loading: true, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_SUCCESS, function (state, payload) {
    state.allocations = _extends({}, state.allocations, { items: payload, loading: false, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_FAILURE, function (state) {
    state.allocations = _extends({}, state.allocations, { items: undefined, loading: false, noContent: false, error: true });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_FETCH_NO_CONTENT, function (state) {
    state.allocations = _extends({}, state.allocations, { items: undefined, loading: false, noContent: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_PENDING, function (state) {
    state.allocationsMerged = _extends({}, state.allocationsMerged, { items: undefined, loading: true, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_SUCCESS, function (state, payload) {
    state.allocationsMerged = _extends({}, state.allocationsMerged, { items: payload, loading: false, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_FAILURE, function (state) {
    state.allocationsMerged = _extends({}, state.allocationsMerged, { items: undefined, loading: false, noContent: false, error: true });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_MERGED_FETCH_NO_CONTENT, function (state) {
    state.allocationsMerged = _extends({}, state.allocationsMerged, { items: undefined, loading: false, noContent: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_PAGE_DECREMENT, function (state) {
    state.allocations.page = state.allocations.page - 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_PAGE_INCREMENT, function (state) {
    state.allocations.page = state.allocations.page + 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_PAGE_SET, function (state, payload) {
    state.allocations.page = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_LIMIT_SET, function (state, payload) {
    state.allocations.limit = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_SELECT, function (state, payload) {
    state.accommodation = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ROUTE_FILTERS_PENDING, function (state) {
    state.form.filters = _extends({}, state.form.filters, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ROUTE_FILTERS_SUCCESS, function (state, payload) {
    state.form.filters = _extends({}, state.form.filters, { loading: false, error: false, sites: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ROUTE_FILTERS_FAILURE, function (state) {
    state.form.filters = _extends({}, state.form.filters, { loading: false, error: true, sites: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ROUTE_FILTERS_SELECTED_SET, function (state, payload) {
    state.form.filters.selected = _extends({}, state.form.filters.selected, payload);
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_ADD_PENDING, function (state) {
    state.form.allocations = _extends({}, state.form.allocations, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_ADD_SUCCESS, function (state) {
    state.form.allocations = _extends({}, state.form.allocations, { loading: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ALLOCATIONS_ADD_FAILURE, function (state, payload) {
    state.form.allocations = _extends({}, state.form.allocations, { loading: false, error: true, text: payload.text });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_VALIDATOR_SUCCESS, function (state) {
    state.form.validator = _extends({}, state.form.validator, { error: false, messages: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_VALIDATOR_FAILURE, function (state, payload) {
    state.form.validator = _extends({}, state.form.validator, { error: true, messages: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_VALIDATOR_RESET, function (state) {
    state.form.validator = _extends({}, state.form.validator, { error: false, messages: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_FORM_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.form.open = payload;
    } else {
        state.form.open = !state.form.open;
    }
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_TOGGLE, function (state, payload) {
    state.form.rows = [_extends({}, state.form.defaultRow, { from: state.calendar.from, to: state.calendar.to })];
    if (payload !== undefined) {
        state.modal = _extends({}, state.modal, { open: payload, success: false, error: false, blocked: false, adding: false });
    } else {
        state.modal.open = !state.modal.open;
        state.modal = _extends({}, state.modal, { success: false, error: false, blocked: false, adding: false });
    }
    // Reset overlay success message
    state.modal.overlay.success = false;
    // if modal is closed then reset dates for the calendar
    if (!state.modal.open) {
        state.calendar = _extends({}, state.calendar, { from: undefined, to: undefined, startIndex: undefined });
    }
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_FORM_SET, function (state, payload) {
    state.form.rows = state.form.rows.map(function (r, i) {
        return i === 0 ? payload : r;
    });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.modal.overlay.open = payload;
    } else {
        state.modal.overlay.open = !state.modal.overlay.open;
    }
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_ALLOCATION_SET, function (state, payload) {
    if (payload.releaseDate) {
        payload.releaseMethod = 'date';
    } else {
        payload.releaseMethod = 'days';
    }
    state.modal.overlay = _extends({}, state.modal.overlay, { loading: false, error: false, success: false });
    state.modal.overlay.allocation.original = payload;
    // convert the original date if present to use on the copied item
    if (payload.releaseDate !== null && payload.releaseDate.indexOf('/') === -1) {
        payload.releaseDate = (0, _DateToolService.convertStringDateToDate)(payload.releaseDate).format('DD/MM/YYYY');
    }
    state.modal.overlay.allocation.item = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_PENDING, function (state) {
    state.modal.overlay = _extends({}, state.modal.overlay, { loading: true, error: false, success: false, message: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_SUCCESS, function (state, payload) {
    state.modal.overlay = _extends({}, state.modal.overlay, { loading: false, error: false, success: true, message: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_UPDATE_FAILURE, function (state, payload) {
    state.modal.overlay = _extends({}, state.modal.overlay, { loading: false, error: true, success: false, message: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_FORM_SET, function (state, payload) {
    if (payload.hasOwnProperty('type')) {
        if (payload.type === 'ALLOTMENT') {
            payload.units = state.modal.overlay.allocation.original.units || 1;
        } else {
            payload.units = null;
        }
    }
    if (payload.hasOwnProperty('releaseDays') && payload.releaseDays === '') {
        payload.releaseDays = 0;
    }
    if (payload.hasOwnProperty('units') && isNaN(payload.units)) {
        payload.units = 1;
    }
    state.modal.overlay.allocation.item = _extends({}, state.modal.overlay.allocation.item, payload);
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_FORM_RESET, function (state) {
    state.modal.overlay.allocation.item = _extends({}, state.modal.overlay.allocation.item, state.modal.overlay.allocation.original);
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_VALIDATOR_SUCCESS, function (state) {
    state.modal.overlay.validator = _extends({}, state.modal.overlay.validator, { error: false, messages: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_VALIDATOR_FAILURE, function (state, payload) {
    state.modal.overlay.validator = _extends({}, state.modal.overlay.validator, { error: true, messages: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_FORM_RESET, function (state) {
    state.form.rows = [_extends({}, state.form.defaultRow, { from: state.calendar.from, to: state.calendar.to })];
    state.form.validator = _extends({}, state.form.validator, { error: false, messages: [] });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_INCREMENT, function (state) {
    state.modal.overlay.bookings.page = state.modal.overlay.bookings.page + 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_DECREMENT, function (state) {
    state.modal.overlay.bookings.page = state.modal.overlay.bookings.page - 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_BOOKINGS_PAGE_SET, function (state, payload) {
    state.modal.overlay.bookings.page = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_OVERLAY_ERROR_MESSAGE_RESET, function (state) {
    state.form.allocations.error = false;
    state.form.allocations.text = undefined;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_DATE_SET, function (state, payload) {
    state.calendar = _extends({}, state.calendar, payload.data);
    // Set the first row
    state.form.rows = [_extends({}, state.form.defaultRow, { from: state.calendar.from, to: state.calendar.to })];
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_PAGE_INCREMENT, function (state) {
    state.calendar.startMonth = state.calendar.startMonth - 3;
    state.calendar.endMonth = state.calendar.endMonth - 3;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_PAGE_DECREMENT, function (state) {
    state.calendar.startMonth = state.calendar.startMonth + 3;
    state.calendar.endMonth = state.calendar.endMonth + 3;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_DISPLAY_SET, function (state, payload) {
    state.calendar.display.choice = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_INFO_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.calendar.showInfo = payload;
    } else {
        state.calendar.showInfo = !state.calendar.showInfo;
    }
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_INFO_PAGE_SET, function (state, payload) {
    state.calendar.infoPage = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_MODAL_ADD_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.modal.adding = payload;
    } else {
        state.modal.adding = !state.modal.adding;
    }
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_FETCH_PENDING, function (state) {
    state.calendar = _extends({}, state.calendar, { items: undefined, loading: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_FETCH_FAILURE, function (state) {
    state.calendar = _extends({}, state.calendar, { items: undefined, loading: false, error: true });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_FETCH_SUCCESS, function (state, payload) {
    state.calendar = _extends({}, state.calendar, { items: payload, loading: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_YEAR_SET, function (state, payload) {
    state.allocations.years.current = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_UPDATE_PENDING, function (state) {
    state.request = _extends({}, state.request, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_UPDATE_SUCCESS, function (state) {
    state.request = _extends({}, state.request, { loading: false, error: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_UPDATE_FAILURE, function (state) {
    state.request = _extends({}, state.request, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_CHANGE, function (state, payload) {
    state.request.pending[payload.index].changes = _extends({}, state.request.pending[payload.index].changes, payload.value);
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_LIST_PENDING, function (state) {
    state.request = _extends({}, state.request, { loading: true, noContent: false, error: false, items: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_LIST_SUCCESS, function (state, payload) {
    state.request = _extends({}, state.request, { loading: false, noContent: false, error: false, items: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_LIST_FAILURE, function (state) {
    state.request = _extends({}, state.request, { loading: false, noContent: false, error: true, items: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_LIST_NO_CONTENT, function (state) {
    state.request = _extends({}, state.request, { loading: false, noContent: true, error: false, items: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_COUNTDOWN_RESET, function (state) {
    state.timer = 10;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_COUNTDOWN_DECREMENT, function (state) {
    state.timer--;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_DATA_FETCH_PENDING, function (state) {
    state.data = _extends({}, state.data, { loading: true, error: false, noContent: false, message: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_DATA_FETCH_SUCCESS, function (state) {
    state.data = _extends({}, state.data, { loading: false, error: false, noContent: false, message: undefined });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_DATA_FETCH_FAILURE, function (state, payload) {
    state.data = _extends({}, state.data, { loading: false, error: true, noContent: false, message: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_PREDICATE_SET, function (state, payload) {
    state.request.predicate = payload;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_PAGE_RESET, function (state) {
    state.request.page = 1;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_PAGE_INCREMENT, function (state) {
    state.request.page++;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_PAGE_DECREMENT, function (state) {
    state.request.page--;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_ITEM_SELECT, function (state, payload) {
    // Convert dates
    payload.request.from = (0, _DateToolService.convertStringDateToDate)(payload.request.from).format('DD/MM/YYYY');
    payload.request.to = (0, _DateToolService.convertStringDateToDate)(payload.request.to).format('DD/MM/YYYY');
    if (payload.request.changes.release.releaseDate) {
        payload.request.changes.release.releaseDate = (0, _DateToolService.convertStringDateToDate)(payload.request.changes.release.releaseDate).format('DD/MM/YYYY');
    }
    state.request.item = payload.request;
    state.request.itemIndex = payload.index;
    state.request.indices = payload.indices;
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_ITEM_DESELECT, function (state) {
    state.request.item = undefined;
    state.request.itemIndex = undefined;
    state.request.indices = [];
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_ITEM_SET, function (state, payload) {
    state.request.item.changes = _extends({}, state.request.item.changes, payload);
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_REQUEST_EDIT_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.request.editMode = payload;
    } else {
        state.request.editMode = !state.request.editMode;
    }
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_CALENDAR_DATES_SET, function (state, payload) {
    state.allocations.years.current = payload.year;
    state.calendar = _extends({}, state.calendar, payload);
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ARRIVAL_LIST_PENDING, function (state) {
    state.arrivalRules = _extends({}, state.arrivalRules, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ARRIVAL_LIST_SUCCESS, function (state, payload) {
    state.arrivalRules = _extends({}, state.arrivalRules, { loading: false, error: false, noContent: false, item: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ARRIVAL_LIST_FAILURE, function (state) {
    state.arrivalRules = _extends({}, state.arrivalRules, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_ARRIVAL_LIST_NO_CONTENT, function (state) {
    state.arrivalRules = _extends({}, state.arrivalRules, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_COMMENT_SET, function (state, payload) {
    state.modal.overlay.allocation.item = _extends({}, state.modal.overlay.allocation.item, { comment: payload });
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_COMMENT_RESET, function (state) {
    state.modal.overlay.allocation.item = {
        comment: undefined
    };
}), _defineProperty(_CONSTANTS$ALLOCATION, CONSTANTS.ALLOCATION_RESET_STATE, function (state) {
    state.data = _extends({}, state.data, { loading: false, error: false, noContent: false, message: undefined });
    state.list = _extends({}, state.list, {
        loading: false,
        noContent: false,
        error: false,
        items: undefined,
        predicate: "pendingRequests",
        predicateList: ["pendingRequests", "name", "updatedAt", "site"],
        limit: 20,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        display: 'current',
        displayOptions: ['all', 'current', 'historical'],
        orderList: ["asc", "desc"],
        order: "desc"
    });
    state.allocations = _extends({}, state.allocations, { loading: false,
        noContent: false,
        error: false,
        items: undefined,
        years: {
            current: (0, _moment2.default)().startOf('year').format('YYYY'),
            years: [(0, _moment2.default)().startOf('year').format('YYYY'), (0, _moment2.default)().add(1, 'years').startOf('year').format('YYYY'), (0, _moment2.default)().add(2, 'years').startOf('year').format('YYYY')]
        },
        limit: 10,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        orderList: ["asc", "desc"],
        order: "asc"
    });
    state.allocationsMerged = _extends({}, state.allocationsMerged, { loading: false, noContent: false, error: false, items: undefined });
    state.filters = _extends({}, state.filters, { loading: false, error: false, sites: {} });
    state.filters.selected = _extends({}, state.filters.selected, { site: undefined, accommodation: undefined, supplier: undefined });
    state.form = _extends({}, state.form, { open: true });
    state.form.defaultRow = _extends({}, state.form.defaultRow, {
        from: undefined,
        to: undefined,
        type: "ALLOTMENT",
        units: undefined,
        releaseType: undefined,
        releaseMethod: 'days',
        releaseDays: undefined,
        releaseDate: undefined
    });
    state.form.filters = _extends({}, state.form.filters, { sites: {}, loading: false, error: false });
    state.form.filters.selected = _extends({}, state.form.filters.selected, { site: undefined, accommodation: undefined });
    state.form.allocations = _extends({}, state.form.allocations, { loading: false, error: false });
    state.form.validator = _extends({}, state.form.validator, { error: false, message: undefined });
    state.form.submit = _extends({}, state.form.submit, { submitted: false, accepted: false, cancelled: false, alerts: null });
    state.calendar = _extends({}, state.calendar, {
        loading: false,
        error: false,
        from: undefined,
        to: undefined,
        startIndex: undefined,
        fullCalendar: false,
        showInfo: false,
        infoPage: 1,
        startMonth: 3,
        endMonth: 9,
        items: undefined
    });
    state.calendar.display = _extends({}, state.calendar.display, { choices: ['full', 'months'], choice: 'months' });
    state.allocationPeriod = _extends({}, state.allocationPeriod, { from: _config2.default.business.SEASON_DATE_START, to: _config2.default.business.SEASON_DATE_END });
    state.accommodation = _extends({}, state.accommodation, { id: undefined, siteId: undefined });
    state.modal = _extends({}, state.modal, { open: false, loading: undefined, noContent: undefined, error: undefined, success: false, blocked: false, adding: false });
    state.modal.list = _extends({}, state.modal.list, { limit: 3, page: 1 });
    state.modal.overlay = _extends({}, state.modal.overlay, { loading: false, error: false, success: false, open: false, message: undefined });
    state.modal.overlay.allocation = _extends({}, state.modal.overlay.allocation, { item: undefined, original: undefined, changes: false });
    state.modal.overlay.validator = _extends({}, state.modal.overlay.validator, { error: false, messages: undefined });
    state.modal.overlay.bookings = _extends({}, state.modal.overlay.bookings, { page: 1, limit: 3 });
    state.request = _extends({}, state.request, {
        editMode: false,
        loading: false,
        success: false,
        error: false,
        noContent: false,
        message: 'accept.success',
        item: undefined,
        itemIndex: undefined,
        indices: [],
        limit: 3,
        page: 1,
        predicate: 'pending',
        predicates: ['pending', 'approved', 'denied', 'modified']
    });
    state.request.items = _extends({}, state.request.items, { pending: [], approved: [], denied: [], modified: [] });
}), _CONSTANTS$ALLOCATION);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(24);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(5);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    timer: 0,
    data: {
        loading: false,
        error: false,
        noContent: false,
        message: undefined
    },
    arrivalRules: {
        loading: false,
        error: false,
        noContent: false,
        item: undefined
    },
    list: {
        loading: false,
        noContent: false,
        error: false,
        items: undefined,
        predicate: "pendingRequests",
        predicateList: ["pendingRequests", "name", "updatedAt", "site"],
        limit: 20,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        display: 'current',
        displayOptions: ['all', 'current', 'historical'],
        orderList: ["asc", "desc"],
        order: "desc"
    },
    allocations: {
        loading: false,
        noContent: false,
        error: false,
        items: undefined,
        years: {
            current: (0, _moment2.default)().startOf('year').format('YYYY'),
            years: [(0, _moment2.default)().startOf('year').format('YYYY'), (0, _moment2.default)().add(1, 'years').startOf('year').format('YYYY'), (0, _moment2.default)().add(2, 'years').startOf('year').format('YYYY')]
        },
        limit: 10,
        limitList: [5, 10, 20, 50, 100, 200],
        page: 1,
        orderList: ["asc", "desc"],
        order: "asc"
    },
    allocationsMerged: {
        loading: false,
        noContent: false,
        error: false,
        items: undefined
    },
    filters: {
        loading: false,
        error: false,
        sites: {},
        suppliers: {},
        selected: {
            site: undefined,
            accommodation: undefined,
            supplier: undefined
        }
    },
    form: {
        open: true,
        defaultRow: {
            from: undefined,
            to: undefined,
            type: "ALLOTMENT",
            units: undefined,
            releaseType: undefined,
            releaseMethod: 'days',
            releaseDays: undefined,
            releaseDate: undefined
        },
        rows: [{
            from: null,
            to: null,
            type: "ALLOTMENT",
            units: null,
            releaseType: "",
            releaseMethod: "days",
            releaseDays: null,
            releaseDate: null
        }],
        filters: {
            sites: {},
            loading: false,
            error: false,
            selected: {
                site: undefined,
                accommodation: undefined
            }
        },
        allocations: {
            loading: false,
            error: false
        },
        validator: {
            error: false,
            messages: undefined
        },
        submit: {
            submitted: false,
            accepted: false,
            cancelled: false,
            alerts: null
        }
    },
    calendar: {
        loading: false,
        error: false,
        from: undefined,
        to: undefined,
        startIndex: undefined,
        fullCalendar: false,
        showInfo: false,
        infoPage: 1,
        startMonth: 3,
        endMonth: 9,
        items: undefined,
        display: {
            choices: ['full', 'months'],
            choice: 'months'
        }
    },
    allocationPeriod: {
        from: _config2.default.business.SEASON_DATE_START,
        to: _config2.default.business.SEASON_DATE_END
    },
    accommodation: {
        id: undefined,
        siteId: undefined
    },
    modal: {
        open: false,
        loading: undefined,
        noContent: undefined,
        error: undefined,
        success: false,
        blocked: false,
        adding: false,
        list: {
            limit: 3,
            page: 1
        },
        overlay: {
            loading: false,
            error: false,
            success: false,
            open: false,
            message: undefined,
            allocation: {
                item: {
                    comment: undefined
                },
                original: {
                    comment: undefined
                },
                changes: false
            },
            validator: {
                error: false,
                messages: undefined
            },
            bookings: {
                page: 1,
                limit: 3
            }
        }
    },
    allocationPage: {
        tips: [{
            title: 'tips.allocationPage.sort.title',
            body: 'tips.allocationPage.sort.body'
        }, {
            title: 'tips.allocationPage.site.title',
            body: 'tips.allocationPage.site.body'
        }, {
            title: 'tips.allocationPage.update.title',
            body: 'tips.allocationPage.update.body'
        }, {
            title: 'tips.allocationPage.updateBy.title',
            body: 'tips.allocationPage.updateBy.body'
        }]
    },
    manageAllocationPage: {
        tips: [{
            title: 'tips.manageAllocationPage.info.title',
            body: 'tips.manageAllocationPage.info.body'
        }, {
            title: 'tips.manageAllocationPage.select.title',
            body: 'tips.manageAllocationPage.select.body'
        }, {
            title: 'tips.manageAllocationPage.extra.title',
            body: 'tips.manageAllocationPage.extra.body'
        }, {
            title: 'tips.manageAllocationPage.year.title',
            body: 'tips.manageAllocationPage.year.body'
        }, {
            title: 'tips.manageAllocationPage.accommodation.title',
            body: 'tips.manageAllocationPage.accommodation.body'
        }, {
            title: 'tips.manageAllocationPage.display.title',
            body: 'tips.manageAllocationPage.display.body'
        }, {
            title: 'tips.manageAllocationPage.modal.title',
            body: 'tips.manageAllocationPage.modal.body'
        }, {
            title: 'tips.manageAllocationPage.overview.title',
            body: 'tips.manageAllocationPage.overview.body'
        }]
    },
    request: {
        editMode: false,
        loading: false,
        error: false,
        items: {
            pending: [],
            approved: [],
            denied: [],
            modified: []
        },
        item: undefined,
        itemIndex: undefined,
        indices: [],
        limit: 3,
        page: 1,
        predicate: 'pending',
        predicates: ['pending', 'approved', 'denied', 'modified']
    }
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(525);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(526);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(527);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(528);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    actions: actions,
    mutations: _mutations2.default,
    state: _state2.default,
    getters: getters
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLanguages = exports.getRoles = exports.toggleCreateModal = exports.toggleEditModal = exports.updateCreateUserValues = exports.updateEditUserValues = exports.unsetUser = exports.setUser = exports.unblockUser = exports.blockUser = exports.deleteUser = exports.editUser = exports.createUser = exports.acceptEditUserForm = exports.cancelEditUserForm = exports.submitEditUserForm = exports.acceptCreateUserForm = exports.cancelCreateUserForm = exports.submitCreateUserForm = exports.getUser = exports.getUsers = undefined;

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _ConverterService = __webpack_require__(50);

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _GoogleAnalyticsService = __webpack_require__(74);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get all non admin Users for a specific supplier.
 *
 * @param commit
 * @param payload
 * @returns {Promise.<TResult>}
 */
var getUsers = exports.getUsers = function getUsers(_ref, payload) {
    var commit = _ref.commit;

    var token = _TokenStorageService2.default.get();
    commit(CONSTANTS.ADMIN_USERS_GET_PENDING);
    return _GatewayService2.default.getUsers(payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ADMIN_USERS_GET_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ADMIN_USERS_GET_NOCONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ADMIN_USERS_GET_FAILURE);
    });
};

/**
 * Get a specific user.
 *
 * @param commit
 * @param payload, tje id of the User.
 * @returns {Promise.<T>}
 */
var getUser = exports.getUser = function getUser(_ref2, payload) {
    var commit = _ref2.commit;

    var token = _TokenStorageService2.default.get();
    commit(CONSTANTS.ADMIN_USER_GET_PENDING);
    return _GatewayService2.default.getUser(payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ADMIN_USER_GET_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ADMIN_USER_GET_NOCONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ADMIN_USER_GET_FAILURE);
    });
};

/**
 * Submit the form and display the accept modal.
 *
 * @param commit
 */
var submitCreateUserForm = exports.submitCreateUserForm = function submitCreateUserForm(_ref3) {
    var commit = _ref3.commit;

    commit(CONSTANTS.ADMIN_FORM_CREATE_SUBMIT);
};

/**
 * Cancel the form and close the accept modal.
 *
 * @param commit
 */
var cancelCreateUserForm = exports.cancelCreateUserForm = function cancelCreateUserForm(_ref4) {
    var commit = _ref4.commit;

    commit(CONSTANTS.ADMIN_FORM_CREATE_CANCEL);
};

/**
 * Accept the form.
 *
 * @param commit
 */
var acceptCreateUserForm = exports.acceptCreateUserForm = function acceptCreateUserForm(_ref5) {
    var commit = _ref5.commit;

    commit(CONSTANTS.ADMIN_FORM_CREATE_ACCEPT);
};

/**
 * Submit the form and display accept modal.
 *
 * @param commit
 */
var submitEditUserForm = exports.submitEditUserForm = function submitEditUserForm(_ref6) {
    var commit = _ref6.commit;

    commit(CONSTANTS.ADMIN_FORM_EDIT_SUBMIT);
};

/**
 * Cancel the form and close the accept modal.
 *
 * @param commit
 */
var cancelEditUserForm = exports.cancelEditUserForm = function cancelEditUserForm(_ref7) {
    var commit = _ref7.commit;

    commit(CONSTANTS.ADMIN_FORM_EDIT_CANCEL);
};

/**
 * Accept the form.
 *
 * @param commit
 */
var acceptEditUserForm = exports.acceptEditUserForm = function acceptEditUserForm(_ref8) {
    var commit = _ref8.commit;

    commit(CONSTANTS.ADMIN_FORM_EDIT_ACCEPT);
};

/**
 * Create a user.
 *
 * @param commit
 * @param dispatch
 * @param rootState
 * @param payload
 * @returns {Promise<T>}
 */
var createUser = exports.createUser = function createUser(_ref9, payload) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch,
        rootState = _ref9.rootState;

    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;
    var supplierId = rootState.auth.supplier.id;
    commit(CONSTANTS.ADMIN_USER_CREATE_PENDING);
    return _GatewayService2.default.createUser(supplierId, (0, _ConverterService.createUserData)(payload), token).then(function () {
        commit(CONSTANTS.ADMIN_USER_CREATE_SUCCESS, {
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('admin', 'user', 'user created', user.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'created',
            level: 'success'
        }, { root: true });
        dispatch('toggleCreateModal', false);
        dispatch('getUsers', supplierId);
    }).catch(function (err) {
        dispatch('toggleCreateModal', false);
        if (err.status === 400) {
            commit(CONSTANTS.ADMIN_USER_CREATE_FAILURE);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'email',
                level: 'danger'
            }, { root: true });
        } else {
            commit(CONSTANTS.ADMIN_USER_CREATE_FAILURE);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'error',
                level: 'danger'
            }, { root: true });
        }
    });
};

/**
 * Update a specific User.
 *
 * @param commit
 * @param rootState
 * @param dispatch
 * @param payload, the id of the User.
 * @returns {Promise.<TResult>}
 */
var editUser = exports.editUser = function editUser(_ref10, payload) {
    var commit = _ref10.commit,
        rootState = _ref10.rootState,
        dispatch = _ref10.dispatch;

    // If new roles are added then call the update roles
    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;
    var supplierId = rootState.auth.supplier.id;
    commit(CONSTANTS.ADMIN_USER_EDIT_PENDING);
    return _GatewayService2.default.editUser(supplierId, (0, _ConverterService.editUserData)(payload), token).then(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_SUCCESS, {
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('admin', 'user', 'user updated', user.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'updated',
            level: 'success'
        }, { root: true });
        dispatch('toggleEditModal', false);
        dispatch('getUsers', supplierId);
    }).catch(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
        dispatch('toggleEditModal', false);
    });
};

/**
 * Delete a specific User.
 *
 * @param commit
 * @param rootState
 * @param dispatch
 * @param payload, the id of the User.
 * @returns {Promise.<TResult>}
 */
var deleteUser = exports.deleteUser = function deleteUser(_ref11, payload) {
    var commit = _ref11.commit,
        rootState = _ref11.rootState,
        dispatch = _ref11.dispatch;

    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;
    var supplierId = rootState.auth.supplier.id;
    commit(CONSTANTS.ADMIN_USER_EDIT_PENDING);
    return _GatewayService2.default.deleteUser(payload, token).then(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_SUCCESS, {
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('admin', 'user', 'user deleted', user.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'deleted',
            level: 'success'
        }, { root: true });
        dispatch('toggleEditModal', false);
        dispatch('getUsers', supplierId);
    }).catch(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
        dispatch('toggleEditModal', false);
    });
};

/**
 * Block a specific User.
 *
 * @param commit
 * @param rootState
 * @param dispatch
 * @param payload, the id of the User.
 * @returns {Promise.<TResult>}
 */
var blockUser = exports.blockUser = function blockUser(_ref12, payload) {
    var commit = _ref12.commit,
        rootState = _ref12.rootState,
        dispatch = _ref12.dispatch;

    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;
    var supplierId = rootState.auth.supplier.id;
    commit(CONSTANTS.ADMIN_USER_EDIT_PENDING);
    return _GatewayService2.default.blockUser(payload, token).then(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_SUCCESS, {
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('admin', 'user', 'user blocked', user.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'blocked',
            level: 'success'
        }, { root: true });
        dispatch('toggleEditModal', false);
        dispatch('getUsers', supplierId);
    }).catch(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
        dispatch('toggleEditModal', false);
    });
};

/**
 * Unblock a specific User.
 *
 * @param commit
 * @param rootState
 * @param dispatch
 * @param payload, the id of the User.
 * @returns {Promise.<TResult>}
 */
var unblockUser = exports.unblockUser = function unblockUser(_ref13, payload) {
    var commit = _ref13.commit,
        rootState = _ref13.rootState,
        dispatch = _ref13.dispatch;

    var token = _TokenStorageService2.default.get();
    var user = rootState.auth.user;
    var supplierId = rootState.auth.supplier.id;
    commit(CONSTANTS.ADMIN_USER_EDIT_PENDING);
    return _GatewayService2.default.unblockUser(payload, token).then(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_SUCCESS, {
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('admin', 'user', 'user unblocked', user.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'unblocked',
            level: 'success'
        }, { root: true });
        dispatch('toggleEditModal', false);
        dispatch('getUsers', supplierId);
    }).catch(function () {
        commit(CONSTANTS.ADMIN_USER_EDIT_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
        dispatch('toggleEditModal', false);
    });
};

/**
 * Sets the user to edit in state.
 *
 * @param commit
 * @param payload
 */
var setUser = exports.setUser = function setUser(_ref14, payload) {
    var commit = _ref14.commit;

    commit(CONSTANTS.ADMIN_USER_SET, payload);
};

/**
 * Unsets the user to edit in state.
 *
 * @param commit
 */
var unsetUser = exports.unsetUser = function unsetUser(_ref15) {
    var commit = _ref15.commit;

    commit(CONSTANTS.ADMIN_USER_UNSET);
};

/**
 * Update the user values in the edit modal.
 *
 * @param commit
 * @param payload
 */
var updateEditUserValues = exports.updateEditUserValues = function updateEditUserValues(_ref16, payload) {
    var commit = _ref16.commit;

    commit(CONSTANTS.ADMIN_USER_EDIT_VALUES, payload);
};

/**
 * Update the user values for the create modal.
 *
 * @param commit
 * @param payload
 */
var updateCreateUserValues = exports.updateCreateUserValues = function updateCreateUserValues(_ref17, payload) {
    var commit = _ref17.commit;

    commit(CONSTANTS.ADMIN_USER_CREATE_VALUES, payload);
};

/**
 * Toggle the edit user modal, send false as payload to force close.
 *
 * @param commit
 * @param payload
 */
var toggleEditModal = exports.toggleEditModal = function toggleEditModal(_ref18, payload) {
    var commit = _ref18.commit;

    commit(CONSTANTS.ADMIN_USER_EDIT_MODAL_TOGGLE, payload);
};

/**
 * Toggle the edit user modal, send false as payload to force close.
 *
 * @param commit
 * @param payload
 */
var toggleCreateModal = exports.toggleCreateModal = function toggleCreateModal(_ref19, payload) {
    var commit = _ref19.commit;

    commit(CONSTANTS.ADMIN_USER_CREATE_MODAL_TOGGLE, payload);
};

/**
 * Fetch the roles for the supplier.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getRoles = exports.getRoles = function getRoles(_ref20, payload) {
    var commit = _ref20.commit;

    var token = _TokenStorageService2.default.get();
    commit(CONSTANTS.ADMIN_ROLES_GET_PENDING);
    return _GatewayService2.default.getRoles(payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ADMIN_ROLES_GET_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ADMIN_ROLES_GET_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ADMIN_ROLES_GET_FAILURE);
    });
};

/**
 * Fetch the supported languages.
 *
 * @param commit
 * @returns {Promise<T>}
 */
var getLanguages = exports.getLanguages = function getLanguages(_ref21) {
    var commit = _ref21.commit;

    var token = _TokenStorageService2.default.get();
    commit(CONSTANTS.ADMIN_LANGUAGES_GET_PENDING);
    return _GatewayService2.default.getLanguages(token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ADMIN_LANGUAGES_GET_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ADMIN_LANGUAGES_GET_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ADMIN_LANGUAGES_GET_FAILURE);
    });
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userChanged = undefined;

var _lodashEs = __webpack_require__(14);

/**
 * Check if the users data has been changed.
 *
 * @param state
 * @returns {boolean}
 */
var userChanged = exports.userChanged = function userChanged(state) {
  var item = state.editModal.user;
  var original = state.editModal.originalUser;
  return !(0, _lodashEs.isEqual)(item, original);
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$ADMIN_USER;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANTS$ADMIN_USER = {}, _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USERS_GET_PENDING, function (state) {
    state.users = _extends({}, state.users, { loading: true, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USERS_GET_SUCCESS, function (state, payload) {
    state.users = _extends({}, state.users, { loading: false, users: payload, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USERS_GET_NOCONTENT, function (state) {
    state.users = _extends({}, state.users, { loading: false, users: undefined, noContent: true, error: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USERS_GET_FAILURE, function (state) {
    state.users = _extends({}, state.users, { loading: false, users: undefined, noContent: false, error: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_GET_PENDING, function (state) {
    state.users = _extends({}, state.users, { loading: true, user: undefined, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_GET_SUCCESS, function (state, payload) {
    state.users = _extends({}, state.users, { loading: false, user: payload, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_GET_NOCONTENT, function (state) {
    state.users = _extends({}, state.users, { loading: false, user: undefined, noContent: true, error: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_GET_FAILURE, function (state) {
    state.users = _extends({}, state.users, { loading: false, user: undefined, noContent: false, error: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_CREATE_MODAL_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.createModal.open = payload;
    } else {
        state.createModal.open = !state.createModal.open;
    }
    // Reset the user object when modal is toggled
    state.createModal.user = { firstName: undefined, lastName: undefined, email: undefined, language: 'en', roles: [] };
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_CREATE_VALUES, function (state, payload) {
    state.createModal.user = _extends({}, state.createModal.user, payload);
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_FORM_CREATE_SUBMIT, function (state) {
    state.createModal.form = _extends({}, state.createModal.form, { submitted: true, accepted: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_FORM_CREATE_CANCEL, function (state) {
    state.createModal.form = _extends({}, state.createModal.form, { submitted: false, accepted: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_FORM_CREATE_ACCEPT, function (state) {
    state.createModal.form = _extends({}, state.createModal.form, { submitted: false, accepted: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_CREATE_PENDING, function (state) {
    state.createModal.form = _extends({}, state.createModal.form, { error: false, loading: true, success: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_CREATE_SUCCESS, function (state) {
    state.createModal.form = _extends({}, state.createModal.form, { error: false, loading: false, success: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_CREATE_FAILURE, function (state) {
    state.createModal.form = _extends({}, state.createModal.form, { error: true, loading: false, success: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_EDIT_MODAL_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.editModal.open = payload;
    } else {
        state.editModal.open = !state.editModal.open;
    }
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_EDIT_VALUES, function (state, payload) {
    state.editModal.user = _extends({}, state.editModal.user, payload);
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_SET, function (state, payload) {
    // Clone user and set state
    state.editModal.originalUser = payload;
    state.editModal.user = payload;
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_UNSET, function (state) {
    state.editModal.originalUser = undefined;
    state.editModal.user = undefined;
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_FORM_EDIT_SUBMIT, function (state) {
    state.editModal.form = _extends({}, state.editModal.form, { submitted: true, accepted: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_FORM_EDIT_CANCEL, function (state) {
    state.editModal.form = _extends({}, state.editModal.form, { submitted: false, accepted: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_FORM_EDIT_ACCEPT, function (state) {
    state.editModal.form = _extends({}, state.editModal.form, { submitted: false, accepted: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_EDIT_PENDING, function (state) {
    state.editModal.form = _extends({}, state.editModal.form, { error: false, loading: true, success: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_EDIT_SUCCESS, function (state) {
    state.editModal.form = _extends({}, state.editModal.form, { error: false, loading: false, success: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_USER_EDIT_FAILURE, function (state) {
    state.editModal.form = _extends({}, state.editModal.form, { error: true, loading: false, success: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_ROLES_GET_PENDING, function (state) {
    state.roles = _extends({}, state.roles, { roles: undefined, loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_ROLES_GET_SUCCESS, function (state, payload) {
    state.roles = _extends({}, state.roles, { roles: payload, loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_ROLES_GET_FAILURE, function (state) {
    state.roles = _extends({}, state.roles, { roles: undefined, loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_ROLES_GET_NO_CONTENT, function (state) {
    state.roles = _extends({}, state.roles, { roles: undefined, loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_LANGUAGES_GET_PENDING, function (state) {
    state.languages = _extends({}, state.languages, { languages: undefined, loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_LANGUAGES_GET_SUCCESS, function (state, payload) {
    state.languages = _extends({}, state.languages, { languages: payload, loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_LANGUAGES_GET_FAILURE, function (state) {
    state.languages = _extends({}, state.languages, { languages: undefined, loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_LANGUAGES_GET_NO_CONTENT, function (state) {
    state.languages = _extends({}, state.roles, { languages: undefined, loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_COUNTDOWN_DECREMENT, function (state) {
    // Only update the state if any of the timers are triggered
    if (state.createModal.timer > 0 || state.editModal.timer > 0) {
        state.createModal.timer--;
        state.editModal.timer--;
    }
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_COUNTDOWN_CREATE_RESET, function (state) {
    state.createModal.timer = 10;
}), _defineProperty(_CONSTANTS$ADMIN_USER, CONSTANTS.ADMIN_COUNTDOWN_EDIT_RESET, function (state) {
    state.editModal.timer = 10;
}), _CONSTANTS$ADMIN_USER);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    users: {
        users: undefined,
        loading: false,
        noContent: false,
        error: false,
        list: {
            page: undefined,
            maxPages: undefined,
            itemsPerPage: undefined,
            order: undefined,
            orderBy: undefined,
            orderValues: ['asc', 'desc'],
            orderByValues: ['name', 'active'],
            filter: undefined
        }
    },
    notifications: {
        loading: false,
        error: false,
        noContent: false,
        items: {},
        admin: undefined,
        original: undefined
    },
    roles: {
        roles: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    languages: {
        languages: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    createModal: {
        open: false,
        user: {
            firstName: undefined,
            lastName: undefined,
            email: undefined,
            language: 'en', // Default language is English,
            roles: []
        },
        form: {
            submitted: false,
            accepted: false,
            loading: false,
            success: false,
            error: false
        }
    },
    editModal: {
        open: false,
        user: undefined,
        originalUser: undefined,
        form: {
            submitted: false,
            accepted: false,
            loading: false,
            success: false,
            error: false
        }
    },
    tips: [{
        title: 'tips.adminPage.create.title',
        body: 'tips.adminPage.create.body'
    }, {
        title: 'tips.adminPage.edit.title',
        body: 'tips.adminPage.edit.body'
    }, {
        title: 'tips.adminPage.block.title',
        body: 'tips.adminPage.block.body'
    }]
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(530);

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__(531);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(532);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageReset = exports.pageIncrement = exports.pageSelect = exports.toggleInfoWidget = undefined;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Toggle the info widget.
 *
 * @param commit
 */
var toggleInfoWidget = exports.toggleInfoWidget = function toggleInfoWidget(_ref) {
  var commit = _ref.commit;

  commit(CONSTANTS.INFO_WIDGET_TOGGLE);
};

/**
 * Select a specific page.
 *
 * @param commit
 * @param payload
 */
var pageSelect = exports.pageSelect = function pageSelect(_ref2, payload) {
  var commit = _ref2.commit;

  commit(CONSTANTS.INFO_WIDGET_PAGE_SELECT, payload);
};

/**
 * Increment the page.
 *
 * @param commit
 * @param payload
 */
var pageIncrement = exports.pageIncrement = function pageIncrement(_ref3, payload) {
  var commit = _ref3.commit;

  commit(CONSTANTS.INFO_WIDGET_PAGE_INCREMENT, payload);
};

/**
 * Reset the page for the widget.
 *
 * @param commit
 */
var pageReset = exports.pageReset = function pageReset(_ref4) {
  var commit = _ref4.commit;

  commit(CONSTANTS.INFO_WIDGET_PAGE_RESET);
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$INFO_WIDGE;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANTS$INFO_WIDGE = {}, _defineProperty(_CONSTANTS$INFO_WIDGE, CONSTANTS.INFO_WIDGET_TOGGLE, function (state, payload) {
    if (payload !== undefined) {
        state.open = payload;
    } else {
        state.open = !state.open;
    }
}), _defineProperty(_CONSTANTS$INFO_WIDGE, CONSTANTS.INFO_WIDGET_PAGE_SELECT, function (state, payload) {
    state.page = payload;
}), _defineProperty(_CONSTANTS$INFO_WIDGE, CONSTANTS.INFO_WIDGET_PAGE_INCREMENT, function (state, payload) {
    state.page = (state.page + 1) % payload;
}), _defineProperty(_CONSTANTS$INFO_WIDGE, CONSTANTS.INFO_WIDGET_PAGE_RESET, function (state) {
    state.page = 0;
}), _CONSTANTS$INFO_WIDGE);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    open: false,
    page: 0
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(534);

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__(535);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(536);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    actions: actions,
    mutations: _mutations2.default,
    state: _state2.default
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = exports.countdown = undefined;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Countdown the timer.
 *
 * @param commit
 */
var countdown = exports.countdown = function countdown(_ref) {
  var commit = _ref.commit;

  commit(CONSTANTS.ALERT_COUNTDOWN_DECREMENT);
};

/**
 * Reset the countdown. Payload is the message and alert level object.
 * Payload example: {message: 'fetch.success', level: 'success'}
 *
 * @param commit
 * @param payload
 */
var reset = exports.reset = function reset(_ref2, payload) {
  var commit = _ref2.commit;

  commit(CONSTANTS.ALERT_COUNTDOWN_RESET, payload);
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$ALERT_COUN;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANTS$ALERT_COUN = {}, _defineProperty(_CONSTANTS$ALERT_COUN, CONSTANTS.ALERT_COUNTDOWN_RESET, function (state, payload) {
    state.message = payload;
    state.timer = 10;
}), _defineProperty(_CONSTANTS$ALERT_COUN, CONSTANTS.ALERT_COUNTDOWN_DECREMENT, function (state) {
    state.timer--;
}), _CONSTANTS$ALERT_COUN);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _default = 10;

exports.default = {
    timer: 0,
    default: _default,
    message: undefined
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(538);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(539);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(540);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(541);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    mutations: _mutations2.default,
    actions: actions,
    getters: getters,
    state: _state2.default
};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = exports.getAccommodationNotificationsBySupplierId = exports.getAvailabilityBySupplierId = exports.redirect = exports.availabilityAccommodationSet = exports.dismissNotification = exports.setNotificationLimit = exports.accommodationNotificationPageDecrement = exports.accommodationNotificationPageIncrement = exports.accommodationNotificationsPageReset = exports.setSelectedFilters = exports.getAccommodationNotifications = exports.getAvailability = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _routes = __webpack_require__(82);

var _routes2 = _interopRequireDefault(_routes);

var _DateToolService = __webpack_require__(48);

var _GoogleAnalyticsService = __webpack_require__(74);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fetch availability data for the supplier.
 *
 * @param commit
 * @returns {Promise<T>}
 */
var getAvailability = exports.getAvailability = function getAvailability(_ref) {
    var commit = _ref.commit;

    commit(CONSTANTS.DASHBOARD_AVAILABILITY_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getAvailability(token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.DASHBOARD_AVAILABILITY_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.DASHBOARD_AVAILABILITY_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.DASHBOARD_AVAILABILITY_FAILURE);
    });
};

/**
 * Fetch the accommodation notification data.
 *
 * @param commit
 * @returns {Promise<T>}
 */
var getAccommodationNotifications = exports.getAccommodationNotifications = function getAccommodationNotifications(_ref2) {
    var commit = _ref2.commit;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getAccommodationNotifications(token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_FAILURE);
    });
};

/**
 * Sets the accommodation notification filters.
 *
 * @param commit
 * @param rootState
 * @param payload
 */
var setSelectedFilters = exports.setSelectedFilters = function setSelectedFilters(_ref3, payload) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_FILTERS_SET, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('dashboard', 'notifications', 'notifications filtered by user', user.id)
    });
    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_PAGE_RESET);
};

/**
 * Resets the page of the accommodation notification list.
 *
 * @param commit
 */
var accommodationNotificationsPageReset = exports.accommodationNotificationsPageReset = function accommodationNotificationsPageReset(_ref4) {
    var commit = _ref4.commit;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_PAGE_RESET);
};

/**
 * Increment the page of accommodation notification list.
 *
 * @param commit
 */
var accommodationNotificationPageIncrement = exports.accommodationNotificationPageIncrement = function accommodationNotificationPageIncrement(_ref5) {
    var commit = _ref5.commit;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT);
};

/**
 * Decrement the page of accommodation notification list.
 *
 * @param commit
 */
var accommodationNotificationPageDecrement = exports.accommodationNotificationPageDecrement = function accommodationNotificationPageDecrement(_ref6) {
    var commit = _ref6.commit;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT);
};

/**
 * Sets the accommodation notification page limit.
 *
 * @param commit
 * @param payload
 */
var setNotificationLimit = exports.setNotificationLimit = function setNotificationLimit(_ref7, payload) {
    var commit = _ref7.commit;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_LIMIT_SET, payload);
};

/**
 * Dismiss a specific notification.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var dismissNotification = exports.dismissNotification = function dismissNotification(_ref8, payload) {
    var commit = _ref8.commit;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_DISMISS_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.dismissNotification(token, payload).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'dismiss.success',
                level: 'success'
            }, { root: true });
        } else {
            commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'dismiss.noContent',
                level: 'warning'
            }, { root: true });
        }
    }).catch(function () {
        commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'dismiss.error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Sets the availability accommodation id selected.
 *
 * @param commit
 * @param rootState
 * @param payload
 */
var availabilityAccommodationSet = exports.availabilityAccommodationSet = function availabilityAccommodationSet(_ref9, payload) {
    var commit = _ref9.commit,
        rootState = _ref9.rootState;

    var user = rootState.auth.user;

    commit(CONSTANTS.DASHBOARD_AVAILABILITY_ACCOMMODATION_SET, {
        data: payload,
        // Google Analytics
        meta: (0, _GoogleAnalyticsService.eventTracker)('dashboard', 'graph', 'accommodation selected by user', user.id)
    });
};

/**
 * Sets the calendar date and opens the allocation modal for the manage allocation page and redirects.
 *
 * @param commit
 * @param rootState
 * @param payload
 */
var redirect = exports.redirect = function redirect(_ref10, payload) {
    var commit = _ref10.commit,
        rootState = _ref10.rootState;

    var user = rootState.auth.user;

    if (!user.contractManager) {
        // Convert the dates for the calendar
        payload = _extends({}, payload, { from: (0, _DateToolService.convertStringDateToDate)(payload.from).format('DD/MM/YYYY'), to: (0, _DateToolService.convertStringDateToDate)(payload.to).format('DD/MM/YYYY') });
        commit('allocation/ALLOCATION_CALENDAR_DATE_SET', {
            data: payload,
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('dashboard', 'graph', 'accommodation selected by user', user.id)
        }, {
            root: true
        });
        commit('allocation/ALLOCATION_MODAL_TOGGLE', true, { root: true });
    }
    _routes2.default.push('/dashboard/allocation-management/' + payload.siteId + '/' + payload.accommodationSiteId);
};

/**
 * Get availability for a supplier.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getAvailabilityBySupplierId = exports.getAvailabilityBySupplierId = function getAvailabilityBySupplierId(_ref11, payload) {
    var commit = _ref11.commit;

    commit(CONSTANTS.DASHBOARD_AVAILABILITY_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getAvailabilityBySupplierId(token, payload).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.DASHBOARD_AVAILABILITY_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.DASHBOARD_AVAILABILITY_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.DASHBOARD_AVAILABILITY_FAILURE);
    });
};

/**
 * Get notifications for a supplier.
 *
 * @param commit
 * @param payload
 * @param state
 * @returns {Promise<T>}
 */
var getAccommodationNotificationsBySupplierId = exports.getAccommodationNotificationsBySupplierId = function getAccommodationNotificationsBySupplierId(_ref12, payload) {
    var commit = _ref12.commit;

    commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getAccommodationNotificationsBySupplierId(token, payload).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.DASHBOARD_NOTIFICATIONS_FAILURE);
    });
};

/**
 * Reset the dashboard state
 * @param commit
 */
var resetState = exports.resetState = function resetState(_ref13) {
    var commit = _ref13.commit;

    commit(CONSTANTS.DASHBOARD_RESET_STATE);
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAccommodationsKeyValueObject = exports.accommodationNotificationsFilteredMaxPages = exports.getAccommodationNotificationFilters = exports.getAccommodationNotificationsFilteredPaginated = exports.getAccommodationNotificationsFiltered = undefined;

var _lodashEs = __webpack_require__(14);

/**
 * Filters the accommodation notifications.
 *
 * @param state
 * @returns {Array}
 */
var getAccommodationNotificationsFiltered = exports.getAccommodationNotificationsFiltered = function getAccommodationNotificationsFiltered(state) {
    var notifications = state.notifications ? state.notifications.items : [];
    var site = state.notifications.filters.site;
    var accommodation = state.notifications.filters.accommodation;
    var predicate = state.notifications.filters.predicate;

    return (0, _lodashEs.filter)(notifications, function (notification) {
        var filterSite = site ? site === notification.site : true;
        var filterAcc = accommodation ? notification.accommodation === accommodation : true;
        var filterStatus = predicate ? notification.status === predicate : true;
        return filterSite && filterAcc && filterStatus;
    });
};

/**
 * Get the list of accommodation notifications filtered and paginated.
 *
 * @param state
 * @returns {*[]}
 */
var getAccommodationNotificationsFilteredPaginated = exports.getAccommodationNotificationsFilteredPaginated = function getAccommodationNotificationsFilteredPaginated(state) {
    var page = state.notifications.page;
    var limit = state.notifications.limit;
    return getAccommodationNotificationsFiltered(state).slice(page * limit - limit, page * limit);
};

/**
 * Get the filters of sites and accommodations.
 *
 * @param state
 * @returns {{sites: Array, accommodations: Array}}
 */
var getAccommodationNotificationFilters = exports.getAccommodationNotificationFilters = function getAccommodationNotificationFilters(state) {
    var notifications = state.notifications ? state.notifications.items : [];
    var sites = [];
    var accommodations = [];

    (0, _lodashEs.forEach)(notifications, function (notification) {
        if (sites.indexOf(notification.site) === -1) sites.push(notification.site);
        if (accommodations.indexOf(notification.accommodation) === -1) accommodations.push(notification.accommodation);
    });

    return {
        sites: sites,
        accommodations: accommodations
    };
};

/**
 * Returns the max page count of the accommodation notifications filtered.
 *
 * @param state
 * @returns {number}
 */
var accommodationNotificationsFilteredMaxPages = exports.accommodationNotificationsFilteredMaxPages = function accommodationNotificationsFilteredMaxPages(state) {
    var limit = state.notifications.limit;
    return Math.ceil(getAccommodationNotificationsFiltered(state).length / limit);
};

/**
 * Extracts the accommodation key value object.
 *
 * @param state
 * @returns {Array}
 */
var getAccommodationsKeyValueObject = exports.getAccommodationsKeyValueObject = function getAccommodationsKeyValueObject(state) {
    var items = state.availability.items ? state.availability.items.accommodations : [];
    return (0, _lodashEs.map)(items, function (item, index) {
        return { value: index, name: item.accommodationName };
    });
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANST$DASHBOARD_;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANST = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANST$DASHBOARD_ = {}, _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_AVAILABILITY_PENDING, function (state) {
    state.availability = _extends({}, state.availability, { loading: true, error: false, noContent: false, items: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_AVAILABILITY_SUCCESS, function (state, payload) {
    state.availability = _extends({}, state.availability, { loading: false, error: false, noContent: false, items: payload });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_AVAILABILITY_FAILURE, function (state) {
    state.availability = _extends({}, state.availability, { loading: false, error: true, noContent: false, items: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_AVAILABILITY_NO_CONTENT, function (state) {
    state.availability = _extends({}, state.availability, { loading: false, error: false, noContent: true, items: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_PENDING, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: true, error: false, noContent: false, items: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_SUCCESS, function (state, payload) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: false, items: payload });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_FAILURE, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: true, noContent: false, items: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_NO_CONTENT, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: true, items: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_FILTERS_SET, function (state, payload) {
    state.notifications.filters = _extends({}, state.notifications.filters, payload.data);
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_PAGE_RESET, function (state) {
    state.notifications.page = 1;
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT, function (state) {
    state.notifications.page++;
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT, function (state) {
    state.notifications.page--;
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_LIMIT_SET, function (state, payload) {
    state.notifications.limit = payload;
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_PENDING, function (state) {
    state.notifications.dismiss = _extends({}, state.notifications.dismiss, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS, function (state) {
    state.notifications.dismiss = _extends({}, state.notifications.dismiss, { loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE, function (state) {
    state.notifications.dismiss = _extends({}, state.notifications.dismiss, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT, function (state) {
    state.notifications.dismiss = _extends({}, state.notifications.dismiss, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_AVAILABILITY_ACCOMMODATION_SET, function (state, payload) {
    state.availability.accommodation = payload.data;
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_SUPPLIERS_PENDING, function (state) {
    state.suppliers = _extends({}, state.suppliers, { loading: true, error: false, noContent: false, suppliers: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_SUPPLIERS_SUCCESS, function (state, payload) {
    state.suppliers = _extends({}, state.suppliers, { loading: false, error: false, noContent: false, suppliers: payload, supplier: payload[0] });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_SUPPLIERS_FAILURE, function (state) {
    state.suppliers = _extends({}, state.suppliers, { loading: false, error: true, noContent: false, suppliers: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_SUPPLIERS_NO_CONTENT, function (state) {
    state.suppliers = _extends({}, state.suppliers, { loading: false, error: false, noContent: true, suppliers: undefined });
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_SUPPLIER_SET, function (state, payload) {
    state.suppliers.supplier = payload;
}), _defineProperty(_CONSTANST$DASHBOARD_, CONSTANST.DASHBOARD_RESET_STATE, function (state) {
    state.suppliers = _extends({}, state.suppliers, { loading: false, error: false, noContent: false, supplier: undefined, suppliers: undefined });
    state.availability = _extends({}, state.availability, { loading: false, error: false, noContent: false, items: undefined, accommodation: undefined });
    state.notifications = _extends({}, state.notifications, { page: 1, limit: 5, limits: [5, 10, 20, 50], loading: false, error: false, noContent: false, items: undefined });
    state.notifications.filters = _extends({}, state.notifications.filters, { site: undefined, accommodation: undefined, predicate: undefined, predicates: ['soldOut', 'stay', 'arrival', 'released'] });
    state.dismiss = _extends({}, state.dismiss, { loading: false, error: false, noContent: false });
}), _CONSTANST$DASHBOARD_);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    suppliers: {
        loading: false,
        error: false,
        noContent: false,
        supplier: undefined,
        suppliers: undefined
    },
    availability: {
        loading: false,
        error: false,
        noContent: false,
        items: undefined,
        accommodation: undefined
    },
    notifications: {
        page: 1,
        limit: 5,
        limits: [5, 10, 20, 50],
        loading: false,
        error: false,
        noContent: false,
        items: undefined,
        filters: {
            site: undefined,
            accommodation: undefined,
            predicate: undefined,
            predicates: ['soldOut', 'stay', 'arrival', 'released']
        },
        dismiss: {
            loading: false,
            error: false,
            noContent: false
        }
    },
    dashboardPage: {
        tricks: ["allocation", "statistics"],
        tips: [{
            title: 'tips.dashboardPage.graph.title',
            body: 'tips.dashboardPage.graph.body'
        }, {
            title: 'tips.dashboardPage.notifications.title',
            body: 'tips.dashboardPage.notifications.body'
        }, {
            title: 'tips.dashboardPage.add.title',
            body: 'tips.dashboardPage.add.body'
        }, {
            title: 'tips.dashboardPage.filter.title',
            body: 'tips.dashboardPage.filter.body'
        }]
    }
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(543);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(544);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(545);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(546);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    actions: actions,
    mutations: _mutations2.default,
    state: _state2.default,
    getters: getters
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updatePassword = exports.resetPassword = exports.editPassword = exports.updateUser = exports.resetUser = exports.editUser = exports.getAccount = exports.toggleNotificationsEditMode = exports.editNotificationsLevel = exports.updateNotificationsLevel = exports.toggleNotifications = exports.activityPageDecrement = exports.activityPageIncrement = exports.setRows = exports.getAccountNotifications = exports.getAccountActivity = undefined;

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _StorageService = __webpack_require__(100);

var _GoogleAnalyticsService = __webpack_require__(74);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get account activity for last 6 months.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getAccountActivity = exports.getAccountActivity = function getAccountActivity(_ref, payload) {
    var commit = _ref.commit;

    commit(CONSTANTS.ACCOUNT_ACTIVITY_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getAccountActivity(payload, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ACCOUNT_ACTIVITY_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ACCOUNT_ACTIVITY_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ACCOUNT_ACTIVITY_FAILURE);
    });
};

/**
 * Get account notifications settings.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getAccountNotifications = exports.getAccountNotifications = function getAccountNotifications(_ref2) {
    var commit = _ref2.commit;

    commit(CONSTANTS.ACCOUNT_NOTIFICATIONS_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getAccountNotifications(token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ACCOUNT_NOTIFICATIONS_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.ACCOUNT_NOTIFICATIONS_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ACCOUNT_NOTIFICATIONS_FAILURE);
    });
};

/**
 * Set the limit for the activity list. And reset the page count.
 *
 * @param commit
 * @param payload
 */
var setRows = exports.setRows = function setRows(_ref3, payload) {
    var commit = _ref3.commit;

    commit(CONSTANTS.ACCOUNT_ACTIVITY_ROWS_SET, payload);
    commit(CONSTANTS.ACCOUNT_ACTIVITY_PAGE_RESET);
};

/**
 * Increment the activity page.
 *
 * @param commit
 */
var activityPageIncrement = exports.activityPageIncrement = function activityPageIncrement(_ref4) {
    var commit = _ref4.commit;

    commit(CONSTANTS.ACCOUNT_ACTIVITY_PAGE_INCREMENT);
};

/**
 * Decrement the activity page.
 *
 * @param commit
 */
var activityPageDecrement = exports.activityPageDecrement = function activityPageDecrement(_ref5) {
    var commit = _ref5.commit;

    commit(CONSTANTS.ACCOUNT_ACTIVITY_PAGE_DECREMENT);
};

/**
 * Toggle the notification active on/off.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T>}
 */
var toggleNotifications = exports.toggleNotifications = function toggleNotifications(_ref6, payload) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var user = state.user.user;
    var token = _TokenStorageService2.default.get();
    commit(CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_PENDING);

    return _GatewayService2.default.toggleNotifications(token, user.id, payload).then(function (res) {
        commit(CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS, {
            data: res.data.data,
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('account', 'notifications', 'user toggled email notifications', user.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'notifications',
            level: 'success'
        }, { root: true });
        return getAccountNotifications({ commit: commit });
    }).catch(function () {
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
        commit(CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_FAILURE);
    });
};

/**
 * Update the notification level for a user.
 *
 * @param commit
 * @param rootState
 * @param payload
 */
var updateNotificationsLevel = exports.updateNotificationsLevel = function updateNotificationsLevel(_ref7, payload) {
    var commit = _ref7.commit,
        rootState = _ref7.rootState;

    var token = _TokenStorageService2.default.get();
    var supplierId = rootState.auth.supplier.id;
    commit(CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_PENDING);

    return _GatewayService2.default.updateNotificationsLevel(supplierId, token, { id: payload.id, notificationObject: payload.item }).then(function (res) {
        commit(CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_SUCCESS, {
            admin: payload.admin,
            data: res.data.data,
            id: payload.id,
            // Google Analytics
            meta: (0, _GoogleAnalyticsService.eventTracker)('account', 'notifications', 'user modified email notifications', payload.id)
        });
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'notifications',
            level: 'success'
        }, { root: true });
        commit(CONSTANTS.ACCOUNT_NOTIFICATION_EDIT_TOGGLE, false);
        return getAccountNotifications({ commit: commit });
    }).catch(function () {
        commit(CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Updates the notifications object.
 *
 * @param commit
 * @param payload
 */
var editNotificationsLevel = exports.editNotificationsLevel = function editNotificationsLevel(_ref8, payload) {
    var commit = _ref8.commit;

    commit(CONSTANTS.ACCOUNT_NOTIFICATION_EDIT, payload);
};

/**
 * Toggle the notifications edit mode.
 *
 * @param commit
 */
var toggleNotificationsEditMode = exports.toggleNotificationsEditMode = function toggleNotificationsEditMode(_ref9, payload) {
    var commit = _ref9.commit;

    commit(CONSTANTS.ACCOUNT_NOTIFICATION_EDIT_TOGGLE, payload);
};

/**
 * Get account basic information.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getAccount = exports.getAccount = function getAccount(_ref10) {
    var commit = _ref10.commit;

    commit(CONSTANTS.ACCOUNT_USER_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getAccount(token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ACCOUNT_USER_SUCCESS, res.data.data);
            (0, _StorageService.store)('user', { firstName: res.data.data['firstName'], lastName: res.data.data['lastName'] });
        } else {
            commit(CONSTANTS.ACCOUNT_USER_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ACCOUNT_USER_FAILURE);
    });
};

/**
 * Edit the user object.
 *
 * @param commit
 * @param payload
 */
var editUser = exports.editUser = function editUser(_ref11, payload) {
    var commit = _ref11.commit;

    commit(CONSTANTS.ACCOUNT_USER_EDIT, payload);
};

/**
 * Reset the user object.
 *
 * @param commit
 */
var resetUser = exports.resetUser = function resetUser(_ref12) {
    var commit = _ref12.commit;

    commit(CONSTANTS.ACCOUNT_USER_RESET);
    commit(CONSTANTS.ACCOUNT_PASSWORD_RESET);
};

/**
 * Update the user.
 *
 * @param commit
 * @param state
 */
var updateUser = exports.updateUser = function updateUser(_ref13) {
    var commit = _ref13.commit,
        state = _ref13.state;

    commit(CONSTANTS.ACCOUNT_USER_UPDATE_PENDING);
    var token = _TokenStorageService2.default.get();
    var user = state.user.user;

    return _GatewayService2.default.updateUser(user, token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.ACCOUNT_USER_UPDATE_SUCCESS, {
                data: res.data.data,
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('account', 'user', 'account details was updated', user.id)
            });
            commit('auth/AUTH_USER_SET', res.data.data, { root: true });
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'updated',
                level: 'success'
            }, { root: true });
            (0, _StorageService.store)('user', { firstName: res.data.data['firstName'], lastName: res.data.data['lastName'] });
        } else {
            commit(CONSTANTS.ACCOUNT_USER_UPDATE_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.ACCOUNT_USER_UPDATE_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Edit the new password objects.
 *
 * @param commit
 * @param payload
 */
var editPassword = exports.editPassword = function editPassword(_ref14, payload) {
    var commit = _ref14.commit;

    commit(CONSTANTS.ACCOUNT_PASSWORD_EDIT, payload);
};

/**
 * Reset the password fields.
 *
 * @param commit
 */
var resetPassword = exports.resetPassword = function resetPassword(_ref15) {
    var commit = _ref15.commit;

    commit(CONSTANTS.ACCOUNT_PASSWORD_RESET);
};

/**
 * Update the account password.
 *
 * @param commit
 * @param state
 */
var updatePassword = exports.updatePassword = function updatePassword(_ref16) {
    var commit = _ref16.commit,
        state = _ref16.state;

    commit(CONSTANTS.ACCOUNT_PASSWORD_UPDATE_PENDING);
    var oldPassword = state.password.password;
    var newPassword = state.password.newPassword;
    var user = state.user.user;
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.updatePassword(oldPassword, newPassword, token).then(function (res) {
        commit(CONSTANTS.ACCOUNT_PASSWORD_RESET);
        if (res.status === 200) {
            commit(CONSTANTS.ACCOUNT_PASSWORD_UPDATE_SUCCESS, {
                // Google Analytics
                meta: (0, _GoogleAnalyticsService.eventTracker)('account', 'password', 'account password updated', user.id)
            });
            commit('auth/AUTH_USER_SET', res.data.data, { root: true });
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'password',
                level: 'success'
            }, { root: true });
            (0, _StorageService.store)('user', { firstName: res.data.data['firstName'], lastName: res.data.data['lastName'] });
        } else {
            commit(CONSTANTS.ACCOUNT_PASSWORD_UPDATE_NO_CONTENT);
        }
    }).catch(function (err) {
        commit(CONSTANTS.ACCOUNT_PASSWORD_RESET);
        commit(CONSTANTS.ACCOUNT_PASSWORD_UPDATE_FAILURE);
        if (err.status === 403) {
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'wrongPassword',
                level: 'danger'
            }, { root: true });
        } else {
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'error',
                level: 'danger'
            }, { root: true });
        }
    });
};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userHasChanged = exports.activeWeekdays = exports.activityMaxPages = exports.activityPaginated = undefined;

var _lodashEs = __webpack_require__(14);

/**
 * Return activity list paginated.
 *
 * @param state
 * @returns {T[]}
 */
var activityPaginated = exports.activityPaginated = function activityPaginated(state) {
    var _activity = state.activity.items || [];
    var _page = state.activity.page;
    var _limit = state.activity.limit;

    return _activity.slice(_page * _limit - _limit, _page * _limit);
};

/**
 * Get the max page count of the activity list.
 *
 * @param state
 * @returns {number}
 */
var activityMaxPages = exports.activityMaxPages = function activityMaxPages(state) {
    var _activity = state.activity.items || [];
    var _limit = state.activity.limit;

    return Math.ceil(_activity.length / _limit);
};

/**
 * Get a list of the days activated for notification.
 *
 * @param state
 * @returns {{}|*}
 */
var activeWeekdays = exports.activeWeekdays = function activeWeekdays(state) {
    var _weekdays = state.notifications.item ? state.notifications.item.days : [];
    return (0, _lodashEs.pickBy)(_weekdays, function (day) {
        return day;
    });
};

/**
 * Check if the user object has changed.
 *
 * @param state
 * @returns {boolean}
 */
var userHasChanged = exports.userHasChanged = function userHasChanged(state) {
    var _user = state.user.user || {};
    var _originalUser = state.user.originalUser || {};
    return !(0, _lodashEs.isEqual)(_user, _originalUser);
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$ACCOUNT_AC;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANTS$ACCOUNT_AC = {}, _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_PENDING, function (state) {
    state.activity = _extends({}, state.activity, { loading: true, error: false, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_SUCCESS, function (state, payload) {
    state.activity = _extends({}, state.activity, { loading: false, error: false, noContent: false, items: payload });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_FAILURE, function (state) {
    state.activity = _extends({}, state.activity, { loading: false, error: true, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_NO_CONTENT, function (state) {
    state.activity = _extends({}, state.activity, { loading: false, error: false, noContent: true, items: undefined });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATIONS_PENDING, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: true, error: false, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATIONS_SUCCESS, function (state, payload) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: false, item: _extends({}, payload), originalItem: _extends({}, payload) });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATIONS_FAILURE, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: true, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATIONS_NO_CONTENT, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: true, items: undefined });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_ROWS_SET, function (state, payload) {
    state.activity.limit = payload;
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_PAGE_INCREMENT, function (state) {
    state.activity.page++;
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_PAGE_DECREMENT, function (state) {
    state.activity.page--;
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_ACTIVITY_PAGE_RESET, function (state) {
    state.activity.page = 1;
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_PENDING, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS, function (state, payload) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: false, item: _extends({}, payload.data), originalItem: _extends({}, payload.data) });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_FAILURE, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_PENDING, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_SUCCESS, function (state, payload) {
    if (payload.admin) {
        state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: false, admin: _extends({}, payload.data), original: _extends({}, payload.data) });
    } else {
        state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: false });
        state.notifications.items[payload.id] = payload.data;
    }
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_FAILURE, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_NO_CONTENT, function (state) {
    state.notifications = _extends({}, state.notifications, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_EDIT, function (state, payload) {
    if (payload.item.hasOwnProperty('days')) {
        state.notifications.item.days = _extends({}, state.notifications.item.days, payload.item.days);
    } else {
        state.notifications.item = _extends({}, state.notifications.item, payload.item);
    }
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_NOTIFICATION_EDIT_TOGGLE, function (state, payload) {
    if (payload) {
        state.notifications.editMode = payload;
    } else {
        state.notifications.editMode = !state.notifications.editMode;
    }
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_EDIT, function (state, payload) {
    state.user.user = _extends({}, state.user.user, payload);
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_RESET, function (state) {
    state.user.user = state.user.originalUser;
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_PENDING, function (state) {
    state.user = _extends({}, state.user, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_SUCCESS, function (state, payload) {
    state.user = _extends({}, state.user, { loading: false, error: false, noContent: false, user: _extends({}, payload), originalUser: _extends({}, payload) });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_FAILURE, function (state) {
    state.user = _extends({}, state.user, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_NO_CONTENT, function (state) {
    state.user = _extends({}, state.user, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_UPDATE_PENDING, function (state) {
    state.user = _extends({}, state.user, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_UPDATE_SUCCESS, function (state, payload) {
    state.user = _extends({}, state.user, { loading: false, error: false, noContent: false });
    state.user.user = _extends({}, state.user.user, _extends({}, payload.data));
    state.user.originalUser = _extends({}, state.user.originalUser, _extends({}, payload.data));
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_UPDATE_FAILURE, function (state) {
    state.user = _extends({}, state.user, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_USER_UPDATE_NO_CONTENT, function (state) {
    state.user = _extends({}, state.user, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_PASSWORD_EDIT, function (state, payload) {
    state.password = _extends({}, state.password, payload);
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_PASSWORD_RESET, function (state) {
    state.password = _extends({}, state.password, { password: '', newPassword: '', retypePassword: '' });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_PASSWORD_UPDATE_PENDING, function (state) {
    state.password = _extends({}, state.password, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_PASSWORD_UPDATE_SUCCESS, function (state) {
    state.password = _extends({}, state.password, { loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_PASSWORD_UPDATE_FAILURE, function (state) {
    state.password = _extends({}, state.password, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$ACCOUNT_AC, CONSTANTS.ACCOUNT_PASSWORD_UPDATE_NO_CONTENT, function (state) {
    state.password = _extends({}, state.password, { loading: false, error: false, noContent: true });
}), _CONSTANTS$ACCOUNT_AC);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    loading: false,
    user: {
        user: undefined,
        originalUser: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    password: {
        password: '',
        newPassword: '',
        retypePassword: '',
        loading: false,
        error: false,
        noContent: false
    },
    activity: {
        page: 1,
        limit: 5,
        limits: [5, 10, 20],
        loading: false,
        error: false,
        noContent: false,
        items: undefined
    },
    notifications: {
        editMode: false,
        loading: false,
        error: false,
        noContent: false,
        item: undefined,
        originalItem: undefined
    },
    tips: [{
        title: 'tips.accountPage.information.title',
        body: 'tips.accountPage.information.body'
    }, {
        title: 'tips.accountPage.password.title',
        body: 'tips.accountPage.password.body'
    }, {
        title: 'tips.accountPage.notifications.title',
        body: 'tips.accountPage.notifications.body'
    }, {
        title: 'tips.accountPage.activity.title',
        body: 'tips.accountPage.activity.body'
    }]
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(548);

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__(549);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(550);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendConfirmation = undefined;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _BrowserService = __webpack_require__(132);

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _IPService = __webpack_require__(212);

var _IPService2 = _interopRequireDefault(_IPService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Send introduction confirmation.
 *
 * @param commit
 * @param payload
 */
var sendConfirmation = exports.sendConfirmation = function sendConfirmation(_ref, payload) {
    var commit = _ref.commit;

    commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_PENDING);

    // Fetch ip information for the client
    return _IPService2.default.getIpInfo().then(function (res) {
        var browser = (0, _BrowserService.getBrowserName)();
        var ip = res.data.ip;
        return _GatewayService2.default.sendConfirmation(payload, ip, browser).then(function (res) {
            if (res.status === 200) {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_SUCCESS);
            } else {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_NO_CONTENT);
            }
        }).catch(function (err) {
            if (err.status === 400) {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_WARNING);
            } else {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_FAILURE);
            }
        });
    }).catch(function () {
        commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_FAILURE);
    });
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$INTRODUCTI;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CONSTANTS$INTRODUCTI = {}, _defineProperty(_CONSTANTS$INTRODUCTI, CONSTANTS.INTRODUCTION_CONFIRM_SEND_PENDING, function (state) {
    state.confirmation = _extends({}, state.confirmation, { loading: true, error: false, warning: false, noContent: false });
}), _defineProperty(_CONSTANTS$INTRODUCTI, CONSTANTS.INTRODUCTION_CONFIRM_SEND_SUCCESS, function (state) {
    state.confirmation = _extends({}, state.confirmation, { loading: false, error: false, warning: false, noContent: false });
}), _defineProperty(_CONSTANTS$INTRODUCTI, CONSTANTS.INTRODUCTION_CONFIRM_SEND_FAILURE, function (state) {
    state.confirmation = _extends({}, state.confirmation, { loading: false, error: true, warning: false, noContent: false });
}), _defineProperty(_CONSTANTS$INTRODUCTI, CONSTANTS.INTRODUCTION_CONFIRM_SEND_WARNING, function (state) {
    state.confirmation = _extends({}, state.confirmation, { loading: false, error: false, warning: true, noContent: false });
}), _defineProperty(_CONSTANTS$INTRODUCTI, CONSTANTS.INTRODUCTION_CONFIRM_SEND_NO_CONTENT, function (state) {
    state.confirmation = _extends({}, state.confirmation, { loading: false, error: false, warning: false, noContent: true });
}), _CONSTANTS$INTRODUCTI);

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    confirmation: {
        loading: false,
        error: false,
        warning: false
    }
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(552);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(556);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(557);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(558);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions,
    getters: getters
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.previewContractDraft = exports.contractManagementListSearchSet = exports.contractManagementListShowSet = exports.sendContractEmailNotification = exports.getContractAcceptedParts = exports.createContractNote = exports.contractNoteSet = exports.resetContractManagementState = exports.removeBrand = exports.addBrand = exports.getBrands = exports.downloadContract = exports.acceptContract = exports.contractNotesSet = exports.contractPartAccept = exports.setContractFormPart = exports.getContractHistoryBySupplierId = exports.getContractNotes = exports.getContractBySupplierId = exports.contractManagementSetNoChanges = exports.contractManagementCopyExisting = exports.getContractManagementSupplierData = exports.contractManagementFormSetIndex = exports.contractManagementFormRemoveElement = exports.contractManagementFormAddElement = exports.contractManagementSendEmailSupplier = exports.contractManagementSendEmailReview = exports.contractManagementSendEmailBackOffice = exports.contractManagementFormFileDelete = exports.contractManagementFormFileDownload = exports.contractManagementFormSave = exports.contractManagementFormFileRemove = exports.contractManagementFormPageSet = exports.setContractManagementFormPart = exports.contractManagementFormUnset = exports.contractManagementFormSet = exports.contractManagementListPageDecrement = exports.contractManagementListPageIncrement = exports.contractManagementListYearSet = exports.contractManagementListLimitSet = exports.contractManagementListFilterSelect = exports.contractManagementListContractSelect = exports.getContractManagementByContractId = exports.getContractManagementssOverview = exports.getContractYears = undefined;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _GatewayService = __webpack_require__(46);

var _GatewayService2 = _interopRequireDefault(_GatewayService);

var _TokenStorageService = __webpack_require__(43);

var _TokenStorageService2 = _interopRequireDefault(_TokenStorageService);

var _IPService = __webpack_require__(212);

var _IPService2 = _interopRequireDefault(_IPService);

var _BrowserService = __webpack_require__(132);

var _ConverterService = __webpack_require__(50);

var _routes = __webpack_require__(82);

var _routes2 = _interopRequireDefault(_routes);

var _FileSaver = __webpack_require__(553);

var _lodashEs = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Get contract years.
 *
 * @param commit
 * @param state
 * @returns {Promise<T | never>}
 */
var getContractYears = exports.getContractYears = function getContractYears(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getContractYears(token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_YEARS_SUCCESS, res.data.data);
            var currentYear = (0, _ConverterService.getCurrentContractYear)();
            var hasYear = (0, _lodashEs.some)(state.overview.years, function (year) {
                return currentYear === year;
            });
            if (hasYear) {
                contractManagementListYearSet({ commit: commit, state: state }, currentYear);
            } else {
                contractManagementListYearSet({ commit: commit, state: state }, state.overview.years[0]);
            }
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_YEARS_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_FAILURE);
    });
};

/**
 * Get contracts overview.
 *
 * @param commit
 * @param state
 * @returns {Promise<T>}
 */
var getContractManagementssOverview = exports.getContractManagementssOverview = function getContractManagementssOverview(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_PENDING);
    var token = _TokenStorageService2.default.get();
    var year = state.overview.year;
    return _GatewayService2.default.getContractManagementssOverview(token, year).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_FAILURE);
    });
};

/**
 * Get contract data by contract id.
 *
 * @param commit
 * @param payload
 * @returns {Promise.<T>}
 */
var getContractManagementByContractId = exports.getContractManagementByContractId = function getContractManagementByContractId(_ref3, payload) {
    var commit = _ref3.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getContractManagementByContractId(token, payload).then(function (res) {
        if (res.status === 200) {
            var contractData = (0, _ConverterService.convertContractManagementData)(res.data.data, payload);
            var progress = (0, _ConverterService.getContractManagementProgress)(contractData);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_PROGRESS_SET, progress);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS, { item: (0, _ConverterService.JSONClone)(contractData), form: contractData });
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_FAILURE);
    });
};

/**
 * Get the contract data for a specific contract id.
 *
 * @param commit
 * @param state
 * @param payload
 */
var contractManagementListContractSelect = exports.contractManagementListContractSelect = function contractManagementListContractSelect(_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var contractData = (0, _ConverterService.getContractManagementData)(state.overview.items, payload);
    commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS, { item: (0, _ConverterService.JSONClone)(contractData), form: contractData });
    commit(CONSTANTS.CONTRACT_MANAGEMENT_PROGRESS_SET, (0, _ConverterService.getContractManagementProgress)(contractData));
    // When the data is set in state then redirect
    _routes2.default.push('/dashboard/contract-management/' + payload);
};

/**
 * Set the filter option for the contract overview list.
 *
 * @param commit
 * @param payload
 */
var contractManagementListFilterSelect = exports.contractManagementListFilterSelect = function contractManagementListFilterSelect(_ref5, payload) {
    var commit = _ref5.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FILTER_SET, payload);
};

/**
 * Contract list limit set.
 *
 * @param commit
 * @param payload
 */
var contractManagementListLimitSet = exports.contractManagementListLimitSet = function contractManagementListLimitSet(_ref6, payload) {
    var commit = _ref6.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_LIST_LIMIT_SET, payload);
};

/**
 * Set the year a contracts are fetched for and fetch the contracts.
 *
 * @param commit
 * @param state
 * @param payload
 */
var contractManagementListYearSet = exports.contractManagementListYearSet = function contractManagementListYearSet(_ref7, payload) {
    var commit = _ref7.commit,
        state = _ref7.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_LIST_YEAR_SET, payload);
    getContractManagementssOverview({ commit: commit, state: state });
};

/**
 * Contract list page increment.
 *
 * @param commit
 */
var contractManagementListPageIncrement = exports.contractManagementListPageIncrement = function contractManagementListPageIncrement(_ref8) {
    var commit = _ref8.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT);
};

/**
 * Contract list page decrement.
 *
 * @param commit
 */
var contractManagementListPageDecrement = exports.contractManagementListPageDecrement = function contractManagementListPageDecrement(_ref9) {
    var commit = _ref9.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT);
};

/**
 * Edit the form data.
 *
 * @param commit
 * @param state
 * @param payload
 */
var contractManagementFormSet = exports.contractManagementFormSet = function contractManagementFormSet(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;

    if (payload.hasOwnProperty('files')) {
        payload.files = state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ? (0, _ConverterService.mergeFileLists)(state.contractManagement.form[payload.part][payload.subPart].files, payload.files) : (0, _ConverterService.mergeFileLists)(state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].files, payload.files);
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SET, payload);
    } else if (payload.hasOwnProperty('images')) {
        payload.images = (0, _ConverterService.mergeFileLists)(state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].images, payload.images);
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SET, payload);
    } else {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SET, payload);
    }
};

/**
 * Remove contract element from lists.
 *
 * @param commit
 * @param payload
 */
var contractManagementFormUnset = exports.contractManagementFormUnset = function contractManagementFormUnset(_ref11, payload) {
    var commit = _ref11.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_UNSET, payload);
};

/**
 * Set the contract form part.
 *
 * @param commit
 * @param payload
 */
var setContractManagementFormPart = exports.setContractManagementFormPart = function setContractManagementFormPart(_ref12, payload) {
    var commit = _ref12.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_PART_SET, payload);
    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_INDEX_RESET);
};

/**
 * Contract form page forward.
 *
 * @param commit
 * @param payload
 */
var contractManagementFormPageSet = exports.contractManagementFormPageSet = function contractManagementFormPageSet(_ref13, payload) {
    var commit = _ref13.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_PAGE_SET, payload);
    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_INDEX_RESET);
};

/**
 * Remove file from file list.
 *
 * @param commit
 * @param payload
 */
var contractManagementFormFileRemove = exports.contractManagementFormFileRemove = function contractManagementFormFileRemove(_ref14, payload) {
    var commit = _ref14.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_REMOVE, payload);
};

/**
 * Contract form save.
 *
 * @param commit
 * @param state
 */
var contractManagementFormSave = exports.contractManagementFormSave = function contractManagementFormSave(_ref15) {
    var commit = _ref15.commit,
        state = _ref15.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_PENDING);
    var token = _TokenStorageService2.default.get();
    var contractId = state.contractManagement.item.contractId;
    var formData = (0, _ConverterService.getFormSaveData)(state.contractManagement.form);

    return _GatewayService2.default.saveContractManagementByContractId(token, formData, contractId).then(function (res) {
        if (res.status === 200) {
            var contractData = (0, _ConverterService.convertContractManagementData)(res.data.data, res.data.data.contractId);
            var progress = (0, _ConverterService.getContractManagementProgress)(contractData);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS, {
                item: (0, _ConverterService.JSONClone)(contractData),
                form: contractData
            });
            commit(CONSTANTS.CONTRACT_MANAGEMENT_PROGRESS_SET, progress);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'saved',
                level: 'success'
            }, { root: true });
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'notFound',
                level: 'warning'
            }, { root: true });
        }
    }).catch(function (err) {
        if (err.status === 400) {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE);
            if (err.data.code === 1) {
                commit('alert/ALERT_COUNTDOWN_RESET', {
                    message: 'validationError',
                    level: 'danger'
                }, { root: true });
            } else if (err.data.code === 2) {
                commit('alert/ALERT_COUNTDOWN_RESET', {
                    message: 'unsupportedType',
                    level: 'danger'
                }, { root: true });
            }
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'error',
                level: 'danger'
            }, { root: true });
        }
    });
};

/**
 * Download file from s3.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T>}
 */
var contractManagementFormFileDownload = exports.contractManagementFormFileDownload = function contractManagementFormFileDownload(_ref16, payload) {
    var commit = _ref16.commit,
        state = _ref16.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING);
    var token = _TokenStorageService2.default.get();
    var file = payload.part === 'basic' || payload.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart]['s3'][payload.index] : state.contractManagement.form[payload.part][payload.subPart][payload.subIndex]['s3'][payload.index];
    var fileName = (0, _ConverterService.extractFileName)(file);
    return _GatewayService2.default.contractManagementFormFileDownload(token, fileName).then(function (res) {
        if (res.status === 200) {
            var fileType = (0, _ConverterService.getExtensionFromMIMEType)(res.headers['content-type']);
            var _file = undefined;
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
                _file = new Blob([res.data], fileName + "." + fileType, { type: res.headers['content-type'] });
            } else {
                _file = new File([res.data], fileName + "." + fileType, { type: res.headers['content-type'] });
            }
            (0, _FileSaver.saveAs)(_file, fileName + "." + fileType, false);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS);
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE);
    });
};

/**
 * Remove the file object from state.
 *
 * @param commit
 * @param state
 * @param payload
 */
var contractManagementFormFileDelete = exports.contractManagementFormFileDelete = function contractManagementFormFileDelete(_ref17, payload) {
    var commit = _ref17.commit,
        state = _ref17.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING);
    var token = _TokenStorageService2.default.get();
    var file = payload.part === 'basic' || payload.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart]['s3'][payload.index] : payload.type === 'image' ? state.contractManagement.form[payload.part][payload.subPart][payload.subIndex]['imagesS3'][payload.index] : state.contractManagement.form[payload.part][payload.subPart][payload.subIndex]['s3'][payload.index];
    var fileObj = (0, _ConverterService.extractFileAndExtension)(file);

    return _GatewayService2.default.removeFileFromS3(token, fileObj.name, fileObj.extension, payload.contractId).then(function (res) {
        if (res.status === 200) {
            var contractData = (0, _ConverterService.convertContractManagementData)(res.data.data, res.data.data.contractId);
            var progress = (0, _ConverterService.getContractManagementProgress)(contractData);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_PROGRESS_SET, progress);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS, { item: (0, _ConverterService.JSONClone)(contractData), form: contractData });
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'removed',
                level: 'success'
            }, { root: true });
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT, payload);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'noFile',
                level: 'warning'
            }, { root: true });
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Contract send email.
 *
 * @param commit
 * @param state
 * @returns {Promise<T>}
 */
var contractManagementSendEmailBackOffice = exports.contractManagementSendEmailBackOffice = function contractManagementSendEmailBackOffice(_ref18) {
    var commit = _ref18.commit,
        state = _ref18.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING);
    var token = _TokenStorageService2.default.get();
    var contractId = state.contractManagement.item.contractId;

    return _GatewayService2.default.contractManagementSendEmailBackOffice(token, contractId).then(function (res) {
        if (res.status === 200) {
            var contractData = (0, _ConverterService.convertContractManagementData)(res.data.data, res.data.data.contractId);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS, { item: (0, _ConverterService.JSONClone)(contractData), form: contractData });
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'emailSent',
                level: 'success'
            }, { root: true });
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'emailAlreadySent',
                level: 'warning'
            }, { root: true });
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Contract send email.
 *
 * @param commit
 * @param state
 * @returns {Promise<T>}
 */
var contractManagementSendEmailReview = exports.contractManagementSendEmailReview = function contractManagementSendEmailReview(_ref19) {
    var commit = _ref19.commit,
        state = _ref19.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING);
    var token = _TokenStorageService2.default.get();
    var contractId = state.contractManagement.item.contractId;

    return _GatewayService2.default.contractManagementSendEmailReview(token, contractId).then(function (res) {
        if (res.status === 200) {
            var contractData = (0, _ConverterService.convertContractManagementData)(res.data.data, res.data.data.contractId);
            commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS, { item: (0, _ConverterService.JSONClone)(contractData), form: contractData });
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'emailSent',
                level: 'success'
            }, { root: true });
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'emailAlreadySent',
                level: 'warning'
            }, { root: true });
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Send contract ready for supplier email.
 *
 * @param commit
 * @param state
 */
var contractManagementSendEmailSupplier = exports.contractManagementSendEmailSupplier = function contractManagementSendEmailSupplier(_ref20) {
    var commit = _ref20.commit,
        state = _ref20.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING);
    var token = _TokenStorageService2.default.get();
    var contractId = state.contract.item.id;

    return _GatewayService2.default.contractManagementSendEmailSupplier(token, contractId).then(function (res) {
        if (res.status === 200) {
            // commit(CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS, {item: JSONClone(res.data.data), form: res.data.data});
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'emailSent',
                level: 'success'
            }, { root: true });
            _routes2.default.push('/dashboard/contract-management/');
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'emailAlreadySent',
                level: 'warning'
            }, { root: true });
        }
    }).catch(function (err) {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE);
        if (err.status === 400) {
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'supplier',
                level: 'danger'
            }, { root: true });
        } else {
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'error',
                level: 'danger'
            }, { root: true });
        }
    });
};

/**
 * Add a new element to the contract form.
 *
 * @param commit
 * @param state
 */
var contractManagementFormAddElement = exports.contractManagementFormAddElement = function contractManagementFormAddElement(_ref21) {
    var commit = _ref21.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD);
};

/**
 * Remove an element from the contract form.
 *
 * @param commit
 * @param payload
 * @param state
 */
var contractManagementFormRemoveElement = exports.contractManagementFormRemoveElement = function contractManagementFormRemoveElement(_ref22, payload) {
    var commit = _ref22.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE, payload);
};

/**
 * Contract form set index.
 *
 * @param commit
 * @param payload
 */
var contractManagementFormSetIndex = exports.contractManagementFormSetIndex = function contractManagementFormSetIndex(_ref23, payload) {
    var commit = _ref23.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_FORM_INDEX_SET, payload);
};

/**
 * Get the contract supplier data.
 *
 * @param commit
 * @param state
 * @returns {Promise<T>}
 */
var getContractManagementSupplierData = exports.getContractManagementSupplierData = function getContractManagementSupplierData(_ref24, payload) {
    var commit = _ref24.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getContractManagementSupplierData(token, payload).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE);
    });
};

/**
 * Copy existing sites or accommodations for a supplier.
 *
 * @param commit
 * @param getters
 * @param state
 * @returns {*}
 */
var contractManagementCopyExisting = exports.contractManagementCopyExisting = function contractManagementCopyExisting(_ref25) {
    var commit = _ref25.commit,
        getters = _ref25.getters,
        state = _ref25.state;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING);
    var token = _TokenStorageService2.default.get();
    var supplierId = state.contractManagement.item.supplierId;
    var siteIds = null;

    switch (state.contractManagement.form.subPart) {
        case 'siteInfo':
            return _GatewayService2.default.getContractManagementCopiedSites(token, supplierId).then(function (res) {
                if (res.status === 200) {
                    commit(CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS, res.data.data);
                } else {
                    commit(CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT);
                    commit('alert/ALERT_COUNTDOWN_RESET', {
                        message: 'noSitesFound',
                        level: 'warning'
                    }, { root: true });
                }
            }).catch(function () {
                commit(CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE);
                commit('alert/ALERT_COUNTDOWN_RESET', {
                    message: 'error',
                    level: 'error'
                }, { root: true });
            });
        case 'accInfo':
            siteIds = (0, _lodashEs.map)(getters['getContractManagementSites'], 'id');
            return _GatewayService2.default.getContractManagementCopiedAccommodations(token, supplierId, siteIds).then(function (res) {
                if (res.status === 200) {
                    commit(CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS, res.data.data);
                } else {
                    commit(CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT);
                    commit('alert/ALERT_COUNTDOWN_RESET', {
                        message: 'noAccommodationsFound',
                        level: 'warning'
                    }, { root: true });
                }
            }).catch(function () {
                commit(CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE);
                commit('alert/ALERT_COUNTDOWN_RESET', {
                    message: 'error',
                    level: 'error'
                }, { root: true });
            });
    }
};

/**
 * Set the default text to no changes to indicate that nothing changed.
 *
 * @param commit
 * @param payload
 */
var contractManagementSetNoChanges = exports.contractManagementSetNoChanges = function contractManagementSetNoChanges(_ref26, payload) {
    var commit = _ref26.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_NO_CHANGES_SET, payload);
};

/**
 * Get a contract by supplier id.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getContractBySupplierId = exports.getContractBySupplierId = function getContractBySupplierId(_ref27, payload) {
    var commit = _ref27.commit;

    commit(CONSTANTS.CONTRACT_DATA_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getContractBySupplierId(token, payload.supplierId, payload.contractId).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_DATA_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.CONTRACT_DATA_NO_CONTENT);
        }
    }).catch(function (err) {
        if (err.data && err.data.code === 1) {
            commit(CONSTANTS.CONTRACT_DATA_PRODUCT_ERROR);
        } else {
            commit(CONSTANTS.CONTRACT_DATA_FAILURE);
        }
    });
};

/**
 * Get contract notes.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getContractNotes = exports.getContractNotes = function getContractNotes(_ref28, payload) {
    var commit = _ref28.commit;

    commit(CONSTANTS.CONTRACT_NOTES_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getContractNotes(token, payload.contractId).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_NOTES_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.CONTRACT_NOTES_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_NOTES_FAILURE);
    });
};

/**
 * Get contract history by supplier id.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T>}
 */
var getContractHistoryBySupplierId = exports.getContractHistoryBySupplierId = function getContractHistoryBySupplierId(_ref29, payload) {
    var commit = _ref29.commit;

    commit(CONSTANTS.CONTRACT_HISTORY_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getContractHistoryBySupplierId(token, payload).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_HISTORY_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.CONTRACT_HISTORY_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_HISTORY_FAILURE);
    });
};

/**
 * Set the contract part.
 *
 * @param commit
 * @param payload
 */
var setContractFormPart = exports.setContractFormPart = function setContractFormPart(_ref30, payload) {
    var commit = _ref30.commit;

    commit(CONSTANTS.CONTRACT_FORM_PART_SET, payload);
};

/**
 * Accept the contract part, and jump to next part if possible
 *
 * @param commit
 * @param state
 * @param dispatch
 * @param payload
 */
var contractPartAccept = exports.contractPartAccept = function contractPartAccept(_ref31, payload) {
    var commit = _ref31.commit,
        state = _ref31.state;

    var token = _TokenStorageService2.default.get();
    var contractId = state.contract.item.id;
    var progressObj = state.contract.progress.item;

    commit(CONSTANTS.CONTRACT_FORM_PART_ACCEPT_PENDING);

    return _GatewayService2.default.acceptContractPart(token, contractId, { field: _ConverterService.progressPartList.indexOf(payload) + 1 }).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_FORM_PART_ACCEPT_SUCCESS);
            commit(CONSTANTS.CONTRACT_ACCEPT_LIST_SUCCESS, (0, _ConverterService.mapContractAcceptedProgressParts)(res.data.data, progressObj));
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'saved',
                level: 'success'
            }, { root: true });
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_FORM_PART_ACCEPT_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Set the notes of the contract part.
 *
 * @param commit
 * @param state
 * @param payload
 */
var contractNotesSet = exports.contractNotesSet = function contractNotesSet(_ref32, payload) {
    var commit = _ref32.commit,
        state = _ref32.state;

    var part = state.contract.part;
    commit(CONSTANTS.CONTRACT_FORM_NOTES_SET, { part: part, note: payload });
};

/**
 * Finish the contract.
 *
 * @param commit
 * @param state
 * @returns {Promise<T>}
 */
var acceptContract = exports.acceptContract = function acceptContract(_ref33) {
    var commit = _ref33.commit,
        state = _ref33.state;

    commit(CONSTANTS.CONTRACT_FINISH_PENDING);
    var token = _TokenStorageService2.default.get();
    var supplierId = state.contract.item.supplierId;
    var contractId = state.contract.item.id;

    // Fetch ip information for the client
    return _IPService2.default.getIpInfo().then(function (res) {
        var browser = (0, _BrowserService.getBrowserName)();
        var ip = res.data.ip;
        return _GatewayService2.default.acceptContract(token, supplierId, contractId, ip, browser).then(function () {
            commit(CONSTANTS.CONTRACT_FINISH_SUCCESS);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'completed',
                level: 'success'
            }, { root: true });
            _routes2.default.push('/dashboard/contract/' + supplierId);
        }).catch(function () {
            commit(CONSTANTS.CONTRACT_FINISH_FAILURE);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'error',
                level: 'danger'
            }, { root: true });
        });
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_FINISH_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Download the contract.
 *
 * @param commit
 * @param payload
 * @returns {*|AxiosPromise<any>}
 */
var downloadContract = exports.downloadContract = function downloadContract(_ref34, payload) {
    var commit = _ref34.commit;

    commit(CONSTANTS.CONTRACT_DOWNLOAD_PENDING);
    var token = _TokenStorageService2.default.get();
    var fileName = (0, _ConverterService.extractFileName)(payload);

    return _GatewayService2.default.downloadContract(token, fileName).then(function (res) {
        if (res.status === 200) {
            var fileType = (0, _ConverterService.getExtensionFromMIMEType)(res.headers['content-type']);
            var file = undefined;
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
                file = new Blob([res.data], fileName + "." + fileType, { type: res.headers['content-type'] });
            } else {
                file = new File([res.data], fileName + "." + fileType, { type: res.headers['content-type'] });
            }
            (0, _FileSaver.saveAs)(file, fileName + "." + fileType, false);
            commit(CONSTANTS.CONTRACT_DOWNLOAD_SUCCESS);
        } else {
            commit(CONSTANTS.CONTRACT_DOWNLOAD_FAILURE);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_DOWNLOAD_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Get brands.
 *
 * @param commit
 * @returns {Promise<T | never>}
 */
var getBrands = exports.getBrands = function getBrands(_ref35) {
    var commit = _ref35.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_PENDING);
    var token = _TokenStorageService2.default.get();

    return _GatewayService2.default.getBrands(token).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT);
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE);
    });
};

/**
 * Add a brand. Payload is the id of the added brand.
 *
 * @param commit
 * @param payload
 */
var addBrand = exports.addBrand = function addBrand(_ref36, payload) {
    var commit = _ref36.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_ADD_BRAND, +payload);
};

/**
 * Remove a brand. Payload is the index of the brand in the array.
 *
 * @param commit
 * @param state
 * @param payload
 */
var removeBrand = exports.removeBrand = function removeBrand(_ref37, payload) {
    var commit = _ref37.commit,
        state = _ref37.state;

    var brands = state.contractManagement.form.extended.brands;
    commit(CONSTANTS.CONTRACT_MANAGEMENT_REMOVE_BRAND, brands.indexOf(+payload));
};

/**
 * Resets contract management state.
 *
 * @param commit
 */
var resetContractManagementState = exports.resetContractManagementState = function resetContractManagementState(_ref38) {
    var commit = _ref38.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_RESET_STATE);
};

/**
 * Set the contract note object.
 *
 * @param commit
 * @param payload
 */
var contractNoteSet = exports.contractNoteSet = function contractNoteSet(_ref39, payload) {
    var commit = _ref39.commit;

    commit(CONSTANTS.CONTRACT_NOTE_SET, payload);
};

/**
 * Create a contract note.
 *
 * @param commit
 * @param state
 */
var createContractNote = exports.createContractNote = function createContractNote(_ref40) {
    var commit = _ref40.commit,
        state = _ref40.state;

    commit(CONSTANTS.CONTRACT_NOTE_CREATE_PENDING);
    var token = _TokenStorageService2.default.get();
    var contractId = state.contract.item.id;
    var note = state.contract.note.item;

    return _GatewayService2.default.createContractNote(token, contractId, note).then(function (res) {
        if (res.status === 200) {
            commit(CONSTANTS.CONTRACT_NOTE_CREATE_SUCCESS);
            commit(CONSTANTS.CONTRACT_NOTES_SUCCESS, res.data.data);
        } else {
            commit(CONSTANTS.CONTRACT_NOTE_CREATE_FAILURE);
            commit('alert/ALERT_COUNTDOWN_RESET', {
                message: 'error',
                level: 'danger'
            }, { root: true });
        }
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_NOTE_CREATE_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Get contract accepted parts.
 *
 * @param commit
 * @param state
 * @param payload
 * @returns {Promise<T | never>}
 */
var getContractAcceptedParts = exports.getContractAcceptedParts = function getContractAcceptedParts(_ref41, payload) {
    var commit = _ref41.commit,
        state = _ref41.state;

    commit(CONSTANTS.CONTRACT_ACCEPT_LIST_PENDING);
    var token = _TokenStorageService2.default.get();
    var progressObj = state.contract.progress.item;

    return _GatewayService2.default.getContractAcceptedParts(token, payload.contractId).then(function (res) {
        commit(CONSTANTS.CONTRACT_ACCEPT_LIST_SUCCESS, (0, _ConverterService.mapContractAcceptedProgressParts)(res.data.data, progressObj));
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_ACCEPT_LIST_FAILURE);
    });
};

/**
 * Send notification email.
 *
 * @param commit
 * @param state
 */
var sendContractEmailNotification = exports.sendContractEmailNotification = function sendContractEmailNotification(_ref42) {
    var commit = _ref42.commit,
        state = _ref42.state;

    commit(CONSTANTS.CONTRACT_NOTE_EMAIL_PENDING);
    var token = _TokenStorageService2.default.get();
    var supplierId = state.contract.item.supplierId;
    var contractId = state.contract.item.id;

    return _GatewayService2.default.sendContractEmailNotification(token, supplierId, contractId).then(function () {
        commit(CONSTANTS.CONTRACT_NOTE_EMAIL_SUCCESS);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'emailSent',
            level: 'success'
        }, { root: true });
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_NOTE_EMAIL_FAILURE);
        commit('alert/ALERT_COUNTDOWN_RESET', {
            message: 'error',
            level: 'danger'
        }, { root: true });
    });
};

/**
 * Set the show mine or all contracts filter set.
 *
 * @param commit
 * @param payload
 */
var contractManagementListShowSet = exports.contractManagementListShowSet = function contractManagementListShowSet(_ref43, payload) {
    var commit = _ref43.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_LIST_SHOW_SET, payload);
};

/**
 * Set the search object in state.
 *
 * @param commit
 * @param payload
 */
var contractManagementListSearchSet = exports.contractManagementListSearchSet = function contractManagementListSearchSet(_ref44, payload) {
    var commit = _ref44.commit;

    commit(CONSTANTS.CONTRACT_MANAGEMENT_LIST_SEARCH_SET, payload);
};

/**
 * Preview supplier contract draft.
 *
 * @param commit
 * @param payload
 * @returns {Promise<T | never>}
 */
var previewContractDraft = exports.previewContractDraft = function previewContractDraft(_ref45, payload) {
    var commit = _ref45.commit;

    var token = _TokenStorageService2.default.get();
    commit(CONSTANTS.CONTRACT_DRAFT_PENDING);
    return _GatewayService2.default.previewContractDraft(payload.supplierId, payload.contractId, token).then(function (res) {
        var fileName = 'contract-preview';
        var fileType = (0, _ConverterService.getExtensionFromMIMEType)(res.headers['content-type']);
        var file = undefined;
        if (document.documentMode || /Edge/.test(navigator.userAgent)) {
            file = new Blob([res.data], fileName + "." + fileType, { type: res.headers['content-type'] });
        } else {
            file = new File([res.data], fileName + "." + fileType, { type: res.headers['content-type'] });
        }
        (0, _FileSaver.saveAs)(file, fileName + "." + fileType, false);

        commit(CONSTANTS.CONTRACT_DRAFT_SUCCESS, res.data);
    }).catch(function () {
        commit(CONSTANTS.CONTRACT_DRAFT_FAILURE);
    });
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(554) !== null) && (__webpack_require__(555) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contractPartAccepted = exports.getContractCollapseObject = exports.getContractManagementSites = exports.emailSent = exports.userCanAccept = exports.contractProgressObject = exports.contractManagementProgressObject = exports.contractPageBackward = exports.contractPageForward = exports.contractManagementPageBackward = exports.contractManagementPageForward = exports.calculateContractProgress = exports.calculateContractManagementProgress = exports.contractListMaxPages = exports.contractListFilteredPaginated = exports.contractListFiltered = undefined;

var _lodashEs = __webpack_require__(14);

/**
 * Return contract management list filtered.
 *
 * @param state
 * @param getters
 * @param rootState
 * @returns {Array}
 */
var contractListFiltered = exports.contractListFiltered = function contractListFiltered(state, getters, rootState) {
    var contractList = state.overview.items || [];
    var filterValue = state.overview.filter;
    var showMine = state.overview.show === 'mine';
    var userTwentyId = rootState.auth.user.contractManagerTwentyId || null;
    var search = state.overview.search || '';

    return (0, _lodashEs.filter)(contractList, function (contract) {
        var searchValidation = contract.supplierName.toLowerCase().indexOf(search.toLowerCase()) !== -1;
        var filterValidation = filterValue ? contract.status === filterValue : true;
        var ownContractValidation = showMine ? contract.contractManagerId === userTwentyId : true;
        return filterValidation && ownContractValidation && searchValidation;
    });
};

/**
 * Return contract management list filtered and paginated.
 *
 * @param state
 * @param getters
 * @param rootState
 * @returns {*[]}
 */
var contractListFilteredPaginated = exports.contractListFilteredPaginated = function contractListFilteredPaginated(state, getters) {
    var contractList = getters.contractListFiltered;
    var page = state.overview.page;
    var limit = state.overview.limit;

    return contractList.slice(page * limit - limit, page * limit);
};

/**
 * Return the contract management list max page.
 *
 * @param state
 * @param getters
 * @returns {number}
 */
var contractListMaxPages = exports.contractListMaxPages = function contractListMaxPages(state, getters) {
    var contractList = getters.contractListFiltered || [];
    var limit = state.overview.limit;
    var maxPages = Math.ceil(contractList.length / limit);

    return maxPages !== 0 ? maxPages : 1;
};

/**
 * Get the contract management progress percentage.
 *
 * @param state
 */
var calculateContractManagementProgress = exports.calculateContractManagementProgress = function calculateContractManagementProgress(state) {
    var progress = state.contractManagement.progress || [];
    var count = 0;
    var done = 0;
    for (var part in progress) {
        for (var subPart in progress[part]) {
            if (subPart === 'notes') continue;
            count++;
            // If field is done then increment done factor
            if (progress[part][subPart]) {
                done++;
            }
        }
    }
    return count && done ? Math.ceil(done / count * 100) : 0;
};

/**
 * Get the contract progress percentage.
 *
 * @param state
 * @returns {number}
 */
var calculateContractProgress = exports.calculateContractProgress = function calculateContractProgress(state) {
    var count = 0;
    var item = state.contract.progress.item;
    for (var attribute in item) {
        if (item[attribute]) count++;
    }
    return Math.ceil(count / 10 * 100);
};

/**
 * Get the next part and subpart in the contract management form flow.
 *
 * @param state
 * @returns {*}
 */
var contractManagementPageForward = exports.contractManagementPageForward = function contractManagementPageForward(state) {
    var currentPart = state.contractManagement.form.part;
    var currentSubPart = state.contractManagement.form.subPart;
    var progress = state.contractManagement.progress;
    var found = false;

    for (var part in progress) {
        for (var subPart in progress[part]) {
            if (found) {
                return { part: part, subPart: subPart };
            }
            if (part === currentPart && subPart === currentSubPart) {
                found = true;
            }
        }
    }
    return null;
};

/**
 * Get the last part and subpart in the contract management form flow.
 *
 * @param state
 * @returns {*}
 */
var contractManagementPageBackward = exports.contractManagementPageBackward = function contractManagementPageBackward(state) {
    var currentPart = state.contractManagement.form.part;
    var currentSubPart = state.contractManagement.form.subPart;
    var progress = state.contractManagement.progress;
    var lastPart = null;
    var lastSubPart = null;

    for (var part in progress) {
        for (var subPart in progress[part]) {
            if (part === currentPart && subPart === currentSubPart) {
                return lastPart ? { part: lastPart, subPart: lastSubPart } : null;
            }
            lastPart = part;
            lastSubPart = subPart;
        }
    }
    return null;
};

/**
 * Get the next part for the contract form flow.
 *
 * @param state
 * @returns {*}
 */
var contractPageForward = exports.contractPageForward = function contractPageForward(state) {
    var currentPart = state.contract.part;
    var progress = state.contract.progress.item;
    var found = false;

    for (var part in progress) {
        if (found) {
            return { part: part };
        }
        if (part === currentPart) {
            found = true;
        }
    }
    return null;
};

/**
 * Get the previous part for the contract form flow.
 *
 * @param state
 * @returns {*}
 */
var contractPageBackward = exports.contractPageBackward = function contractPageBackward(state) {
    var currentPart = state.contract.part;
    var progress = state.contract.progress.item;
    var lastPart = null;

    for (var part in progress) {
        if (part === currentPart) {
            return lastPart ? { part: lastPart } : null;
        }
        lastPart = part;
    }
    return null;
};

/**
 * Get progress object which determines which main parts are done, and if all is done
 *
 * @param state
 */
var contractManagementProgressObject = exports.contractManagementProgressObject = function contractManagementProgressObject(state) {
    var progressObj = {
        basic: true,
        extended: true,
        done: true,
        all: true
    };
    var progress = state.contractManagement.progress;
    for (var part in progress) {
        for (var subPart in progress[part]) {
            if (subPart === 'notes') continue;
            if (!progress[part][subPart]) {
                progressObj[part] = false;
                progressObj['all'] = false;
            }
        }
    }
    return progressObj;
};

/**
 * Get progress object for the contract.
 *
 * @param state
 */
var contractProgressObject = exports.contractProgressObject = function contractProgressObject(state) {
    var progressObj = {
        all: true
    };
    var progress = state.contract.progress.item;
    for (var part in progress) {
        if (!progress[part]) {
            return false;
        }
    }
    return progressObj;
};

/**
 * Check if the current user can accept contract part.
 *
 * Returns true if:
 * - The user is contract manager and the contract is not ready for supplier
 * - If the user is not a contract manager and the contract is ready for supplier
 *
 * @param rootState
 * @param state
 * @returns {boolean|*}
 */
var userCanAccept = exports.userCanAccept = function userCanAccept(state, getters, rootState) {
    var user = rootState.auth.user || null;
    var contract = state.contract.item || null;
    if (!user || !contract) {
        return false;
    }
    return user.contractManager && !contract.readyForSupplier || !user.contractManager && contract.readyForSupplier;
};

/**
 * Check if the current selected part email has been sent and if so then return the date.
 *
 * @param state
 */
var emailSent = exports.emailSent = function emailSent(state) {
    var item = state.contractManagement.item;

    if (item) {
        return { readyForBackOffice: item['readyForBackOffice'], readyForReview: item['readyForReview'] };
    }
};

/**
 * Get sites for supplier which is a merge of all registered sites for the supplier
 * and newly created sites.
 *
 * @param state
 * @returns {*[]}
 */
var getContractManagementSites = exports.getContractManagementSites = function getContractManagementSites(state) {
    if (state.contractManagement.supplier.items && state.contractManagement.form.extended) {
        return (0, _lodashEs.map)(state.contractManagement.form.extended.siteInfo, function (site) {
            return { name: site.name, id: site.id, area: site.area };
        });
    }
    return [];
};

/**
 * Get the contract collapse object which is used to collapse elements in the list.
 *
 * @param state
 */
var getContractCollapseObject = exports.getContractCollapseObject = function getContractCollapseObject(state) {
    var part = state.contract.part;
    if (state.contract.item) {
        var element = state.contract.item[part];
        switch (part) {
            case 'prices':
                return pricesCollapseObject(element);
            case 'sites':
                return sitesCollapseObject(element);
            case 'terms':
                return null;
            default:
                return defaultCollapseObject(element);
        }
    }
};

/**
 * Generate simple collapse object based on sites > accommodations
 *
 * @param element
 */
var defaultCollapseObject = function defaultCollapseObject(element) {
    return (0, _lodashEs.map)(element.sites, function (site, index) {
        return {
            collapse: index !== 0,
            accommodations: fillArray(site.accommodations.length)
        };
    });
};

/**
 * Generate collapse object for the prices part.
 *
 * @param element
 */
var pricesCollapseObject = function pricesCollapseObject(element) {
    return (0, _lodashEs.map)(element.priceGroups, function (price, index) {
        return {
            collapse: index !== 0,
            sites: (0, _lodashEs.map)(price.sites, function (site, index) {
                return {
                    collapse: index !== 0,
                    accommodations: fillArray(site.accommodations.length)
                };
            })
        };
    });
};

/**
 * Generate collapse object for the sites part.
 *
 * @param element
 * @returns {Array}
 */
var sitesCollapseObject = function sitesCollapseObject(element) {
    return (0, _lodashEs.map)(element.sites, function (element, index) {
        return {
            collapse: index !== 0
        };
    });
};

/**
 * Fill array with boolean values for the collapse object.
 * First element should not be collapsed.
 *
 * @param length
 * @returns {any[]}
 */
var fillArray = function fillArray(length) {
    var array = Array(length).fill(true);
    array[0] = false;
    return array;
};

/**
 * Check if the part of the contract is accepted.
 *
 * @param state
 */
var contractPartAccepted = exports.contractPartAccepted = function contractPartAccepted(state) {
    var part = state.contract.part;
    var item = state.contract.form.item;
    if (part && item) {
        return item[part].accepted;
    }
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CONSTANTS$CONTRACT_M;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _ConverterService = __webpack_require__(50);

var _lodashEs = __webpack_require__(14);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (_CONSTANTS$CONTRACT_M = {}, _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_PENDING, function (state) {
    state.overview = _extends({}, state.overview, { loading: true, error: false, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_YEARS_SUCCESS, function (state, payload) {
    state.overview = _extends({}, state.overview, { loading: false, error: false, noContent: false, years: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_YEARS_NO_CONTENT, function (state) {
    state.overview = _extends({}, state.overview, { loading: false, error: false, noContent: true, years: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_SUCCESS, function (state, payload) {
    state.overview = _extends({}, state.overview, { loading: false, error: false, noContent: false, items: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_FAILURE, function (state) {
    state.overview = _extends({}, state.overview, { loading: false, error: true, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_OVERVIEW_NO_CONTENT, function (state) {
    state.overview = _extends({}, state.overview, { loading: false, error: false, noContent: true, items: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FILTER_SET, function (state, payload) {
    state.overview.filter = payload;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_LIST_LIMIT_SET, function (state, payload) {
    state.overview.limit = payload;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_LIST_YEAR_SET, function (state, payload) {
    state.overview.year = payload;
    state.overview.page = 1;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_INCREMENT, function (state) {
    state.overview.page++;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_DECREMENT, function (state) {
    state.overview.page--;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_LIST_PAGE_RESET, function (state) {
    state.overview.page = 1;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_DATA_PENDING, function (state) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: true, error: false, noContent: false, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_DATA_SUCCESS, function (state, payload) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: false, error: false, noContent: false, item: payload.item });
    state.contractManagement.form = _extends({}, state.contractManagement.form, payload.form);
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_DATA_FAILURE, function (state) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: false, error: true, noContent: false, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_DATA_NO_CONTENT, function (state) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: false, error: false, noContent: true, item: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_SET, function (state, payload) {
    if (payload.hasOwnProperty('files')) {
        state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart].files = payload.files : state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].files = payload.files;
    } else if (payload.hasOwnProperty('images')) {
        state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart].images = payload.images : state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].images = payload.images;
    } else if (payload.hasOwnProperty('text')) {
        state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart].text = payload.text : state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].text = payload.text;
    } else if (payload.hasOwnProperty('name')) {
        state.contractManagement.form.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart].name = payload.name : state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].name = payload.name;
    } else if (payload.hasOwnProperty('site')) {
        state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].sites.push({ name: payload.site.name, id: payload.site.id });
    } else if (payload.hasOwnProperty('item')) {
        state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].name = payload.item.name;
        state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].id = payload.item.id;
        // If chosen site or accommodation then set text to 'No Changes'
        if (payload.item.id) {
            state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].text = 'No changes';
        }
    } else if (payload.hasOwnProperty('show')) {
        state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].showInContract = payload.show;
    }
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_UNSET, function (state, payload) {
    if (payload.hasOwnProperty('site')) {
        state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].sites.splice(payload.site, 1);
    }
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_PART_SET, function (state, payload) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, payload);
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_PAGE_SET, function (state, payload) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, payload);
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_PENDING, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_SUCCESS, function (state, payload) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, payload.form, { loading: false, error: false, noContent: false });
    state.contractManagement.item = payload.item;
    state.contractManagement.form.index = 0;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_FAILURE, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_SAVE_NO_CONTENT, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_PROGRESS_SET, function (state, payload) {
    state.contractManagement.progress = _extends({}, state.contractManagement.progress, payload);
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_PENDING, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_SUCCESS, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_FAILURE, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DELETE_NO_CONTENT, function (state, payload) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false, noContent: true });
    state.contractManagement.form[payload.part][payload.subPart].files = undefined;
    state.contractManagement.form[payload.part][payload.subPart].s3 = undefined;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_PENDING, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_SUCCESS, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_FAILURE, function (state) {
    state.contractManagement.fomr = _extends({}, state.contractManagement.form, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_DOWNLOAD_NO_CONTENT, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_PENDING, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_SUCCESS, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_FAILURE, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_EMAIL_NO_CONTENT, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: true, noContent: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_FILE_REMOVE, function (state, payload) {
    if (payload.type === 'files') {
        payload.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart].files.splice(payload.index, 1) : state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].files.splice(payload.index, 1);
    } else {
        payload.part === 'basic' || state.contractManagement.form.subPart === 'arrivalDeparture' ? state.contractManagement.form[payload.part][payload.subPart].images.splice(payload.index, 1) : state.contractManagement.form[payload.part][payload.subPart][state.contractManagement.form.index].images.splice(payload.index, 1);
    }
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_ELEMENT_ADD, function (state) {
    state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].push(_extends({}, (0, _ConverterService.clone)(state.contractManagement.form.defaults[state.contractManagement.form.part][state.contractManagement.form.subPart]), { sites: [] }));
    state.contractManagement.form.index = state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].length - 1;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_ELEMENT_REMOVE, function (state, payload) {
    // If removing a site then ensure that all accommodations sites arrays are updated accordingly
    if (state.contractManagement.form.subPart === 'siteInfo') {
        var siteName = state.contractManagement.form.extended.siteInfo[payload].name;
        (0, _lodashEs.each)(state.contractManagement.form['extended']['accInfo'], function (accommodation) {
            accommodation.sites = (0, _lodashEs.filter)(accommodation.sites, function (site) {
                return site.name !== siteName;
            });
        });
        state.contractManagement.form.extended.accInfo = (0, _lodashEs.filter)(state.contractManagement.form.extended.accInfo, function (accommodation) {
            return accommodation.sites.length;
        });
    }
    state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].splice(payload, 1);
    // If last element is removed then replace with default element
    if (state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].length === 0) {
        state.contractManagement.form[state.contractManagement.form.part][state.contractManagement.form.subPart].push((0, _ConverterService.clone)(state.contractManagement.form.defaults[state.contractManagement.form.part][state.contractManagement.form.subPart]));
    } else {
        if (payload <= state.contractManagement.form.index && state.contractManagement.form.index > 0) {
            state.contractManagement.form.index--;
        }
    }
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_INDEX_SET, function (state, payload) {
    state.contractManagement.form.index = payload;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_FORM_INDEX_RESET, function (state) {
    state.contractManagement.form.index = 0;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_PENDING, function (state) {
    state.contractManagement.supplier = _extends({}, state.contractManagement.supplier, { loading: true, error: false, noContent: false, items: { sites: [], accommodations: [] } });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_SUCCESS, function (state, payload) {
    state.contractManagement.supplier = _extends({}, state.contractManagement.supplier, { loading: false, error: false, noContent: false, items: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_FAILURE, function (state) {
    state.contractManagement.supplier = _extends({}, state.contractManagement.supplier, { loading: false, error: true, noContent: false, items: { sites: [], accommodations: [] } });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_SUPPLIER_DATA_NO_CONTENT, function (state) {
    state.contractManagement.supplier = _extends({}, state.contractManagement.supplier, { loading: false, error: false, noContent: true, items: { sites: [], accommodations: [] } });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_NO_CHANGES_SET, function (state, payload) {
    state.contractManagement.form[payload.part][payload.subPart].text = payload.text;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DATA_PENDING, function (state) {
    state.contract = _extends({}, state.contract, { loading: true, error: false, noContent: false, productError: false, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DATA_SUCCESS, function (state, payload) {
    state.contract = _extends({}, state.contract, { loading: false, error: false, noContent: false, productError: false, item: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DATA_FAILURE, function (state) {
    state.contract = _extends({}, state.contract, { loading: false, error: true, noContent: false, productError: false, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DATA_PRODUCT_ERROR, function (state) {
    state.contract = _extends({}, state.contract, { loading: false, error: true, noContent: false, productError: true, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DATA_NO_CONTENT, function (state) {
    state.contract = _extends({}, state.contract, { loading: false, error: false, noContent: true, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_HISTORY_PENDING, function (state) {
    state.history = _extends({}, state.history, { loading: true, error: false, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_HISTORY_SUCCESS, function (state, payload) {
    state.history = _extends({}, state.history, { loading: false, error: false, noContent: false, items: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_HISTORY_FAILURE, function (state) {
    state.history = _extends({}, state.history, { loading: false, error: true, noContent: false, items: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_HISTORY_NO_CONTENT, function (state) {
    state.history = _extends({}, state.history, { loading: false, error: false, noContent: true, items: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_PART_SET, function (state, payload) {
    state.contract.part = payload.part;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_PART_ACCEPT_PENDING, function (state) {
    state.contract.progress.accept = _extends({}, state.contract.progress.accept, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_PART_ACCEPT_SUCCESS, function (state) {
    state.contract.progress.accept = _extends({}, state.contract.progress.accept, { loading: false, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_PART_ACCEPT_FAILURE, function (state) {
    state.contract.progress.accept = _extends({}, state.contract.progress.accept, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_NOTES_SET, function (state, payload) {
    state.contract.form.item[payload.part].note = payload.note;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_SAVE_PENDING, function (state) {
    state.contract.form = _extends({}, state.contract.form, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_SAVE_SUCCESS, function (state, payload) {
    state.contract.form = _extends({}, state.contract.form, { loading: false, error: false, item: payload.item });
    state.contract.progress.item = _extends({}, state.contract.progress.item, payload.clone);
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FORM_SAVE_FAILURE, function (state) {
    state.contract.form = _extends({}, state.contract.form, { loading: false, error: true, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTES_PENDING, function (state) {
    state.contract.notes = _extends({}, state.contract.notes, { loading: true, error: false, noCOntent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTES_SUCCESS, function (state, payload) {
    state.contract.notes = _extends({}, state.contract.notes, { loading: false, error: false, noContent: false, item: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTES_FAILURE, function (state) {
    state.contract.notes = _extends({}, state.contract.notes, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTES_NO_CONTENT, function (state) {
    state.contract.notes = _extends({}, state.contract.notes, { loading: false, error: false, noContent: true, item: undefined });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_PENDING, function (state) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_SUCCESS, function (state) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: false, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_READY_FOR_REVIEW_FAILURE, function (state) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FINISH_PENDING, function (state) {
    state.contract.finish = _extends({}, state.contract.finish, { loading: true, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FINISH_SUCCESS, function (state) {
    state.contract.finish = _extends({}, state.contract.finish, { loading: false, error: false, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FINISH_FAILURE, function (state) {
    state.contract.finish = _extends({}, state.contract.finish, { loading: false, error: true, noContent: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_FINISH_NO_CONTENT, function (state) {
    state.contract.finish = _extends({}, state.contract.finish, { loading: false, error: false, noContent: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DOWNLOAD_PENDING, function (state) {
    state.contract.download = _extends({}, state.contract.download, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DOWNLOAD_SUCCESS, function (state) {
    state.contract.download = _extends({}, state.contract.download, { loading: false, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DOWNLOAD_FAILURE, function (state) {
    state.contract.download = _extends({}, state.contract.download, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_PENDING, function (state) {
    state.contractManagement.brands = _extends({}, state.contractManagement.brands, { brands: undefined, loading: true, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_SUCCESS, function (state, payload) {
    state.contractManagement.brands = _extends({}, state.contractManagement.brands, { brands: payload, loading: false, noContent: false, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_NO_CONTENT, function (state) {
    state.contractManagement.brands = _extends({}, state.contractManagement.brands, { brands: undefined, loading: false, noContent: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_GET_BRANDS_FAILURE, function (state) {
    state.contractManagement.brands = _extends({}, state.contractManagement.brands, { brands: undefined, loading: false, noContent: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_ADD_BRAND, function (state, payload) {
    state.contractManagement.form.extended.brands = [].concat(_toConsumableArray(state.contractManagement.form.extended.brands), [payload]);
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_REMOVE_BRAND, function (state, payload) {
    state.contractManagement.form.extended.brands = [].concat(_toConsumableArray(state.contractManagement.form.extended.brands.filter(function (item, index) {
        return index !== payload;
    })));
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_PENDING, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_SITE_SUCCESS, function (state, payload) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false });
    state.contractManagement.form.extended = _extends({}, state.contractManagement.form.extended, { siteInfo: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_ACCOMMODATION_SUCCESS, function (state, payload) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false });
    state.contractManagement.form.extended = _extends({}, state.contractManagement.form.extended, { accInfo: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_NO_CONTENT, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_COPY_EXISTING_FAILURE, function (state) {
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_RESET_STATE, function (state) {
    state.contractManagement = _extends({}, state.contractManagement, { loading: false, error: false, noContent: false });
    state.contractManagement.supplier = _extends({}, state.contractManagement.supplier, { loading: false, error: false, noContent: false });
    state.contractManagement.supplier.items = _extends({}, state.contractManagement.supplier.items, { siteInfo: [], accInfo: [] });
    state.contractManagement.progress.basic = _extends({}, state.contractManagement.progress.basic, { priceExtra: false, allotmentRules: false, arrivalRules: false, commission: false, discounts: false, notes: false });
    state.contractManagement.progress.extended = _extends({}, state.contractManagement.progress.extended, { siteInfo: false, accInfo: false, arrivalDeparture: false, brands: false });
    state.contractManagement.form = _extends({}, state.contractManagement.form, { loading: false, error: false, noContent: false, index: 0 });
    state.contractManagement.form.defaults.basic = _extends({}, state.contractManagement.form.defaults.basic, { text: undefined, files: [], s3: [] });
    state.contractManagement.form.defaults.extended.accInfo = _extends({}, state.contractManagement.form.defaults.extended.accInfo, { entityId: undefined, name: undefined, id: undefined, text: undefined, files: [], images: [], s3: [], imagesS3: [], sites: [] });
    state.contractManagement.form.defaults.extended.siteInfo = _extends({}, state.contractManagement.form.defaults.extended.siteInfo, { showInContract: true, entityId: undefined, name: undefined, id: undefined, text: undefined, area: undefined, files: [], images: [], s3: [], imagesS3: [] });
    state.contractManagement.form.defaults.extended.arrivalDeparture = _extends({}, state.contractManagement.form.defaults.extended.arrivalDeparture, { text: undefined, files: [], s3: [] });
    state.contractManagement.form.defaults.extended.brands = _extends({}, state.contractManagement.form.defaults.extended.brands, { brands: [] });
    state.contractManagement.brands = _extends({}, state.contractManagement.brands, { brands: [], noContent: false, error: false, loading: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTE_SET, function (state, payload) {
    state.contract.note.item = _extends({}, state.contract.note.item, payload);
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTE_CREATE_PENDING, function (state) {
    state.contract.note = _extends({}, state.contract.note, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTE_CREATE_SUCCESS, function (state) {
    state.contract.note = _extends({}, state.contract.note, { loading: false, error: false });
    state.contract.note.item.note = "";
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTE_CREATE_FAILURE, function (state) {
    state.contract.note = _extends({}, state.contract.note, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_ACCEPT_LIST_PENDING, function (state) {
    state.contract.progress = _extends({}, state.contract.progress, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_ACCEPT_LIST_SUCCESS, function (state, payload) {
    state.contract.progress = _extends({}, state.contract.progress, { loading: false, error: false, item: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_ACCEPT_LIST_FAILURE, function (state) {
    state.contract.progress = _extends({}, state.contract.progress, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTE_EMAIL_PENDING, function (state) {
    state.contract.email = _extends({}, state.contract.email, { loading: true, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTE_EMAIL_SUCCESS, function (state) {
    state.contract.email = _extends({}, state.contract.email, { loading: false, error: false });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_NOTE_EMAIL_FAILURE, function (state) {
    state.contract.email = _extends({}, state.contract.email, { loading: false, error: true });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_LIST_SHOW_SET, function (state, payload) {
    state.overview.show = payload;
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DRAFT_PENDING, function (state) {
    state.draft = _extends({}, state.draft, { loading: true, error: false, item: null });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DRAFT_SUCCESS, function (state, payload) {
    state.draft = _extends({}, state.draft, { loading: false, error: false, item: payload });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_DRAFT_FAILURE, function (state) {
    state.draft = _extends({}, state.draft, { loading: false, error: true, item: null });
}), _defineProperty(_CONSTANTS$CONTRACT_M, CONSTANTS.CONTRACT_MANAGEMENT_LIST_SEARCH_SET, function (state, payload) {
    state.overview.search = payload;
}), _CONSTANTS$CONTRACT_M);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    overview: {
        loading: false,
        error: false,
        noContent: false,
        year: undefined,
        years: undefined,
        items: undefined,
        page: 1,
        limits: [5, 10, 20, 50],
        limit: 10,
        show: 'mine',
        showList: ['mine', 'all'],
        filter: '',
        search: '',
        filters: ['initiated', 'readyForBackOffice', 'readyForContractManager', 'readyForSupplier', 'completed']
    },
    contract: {
        loading: false,
        error: false,
        noContent: false,
        item: undefined,
        part: 'supplierInfo',
        email: {
            loading: false,
            error: false
        },
        notes: {
            loading: false,
            error: false,
            noContent: false,
            item: undefined
        },
        note: {
            loading: false,
            error: false,
            item: {
                internal: 0,
                field: 1,
                note: ""
            }
        },
        finish: {
            loading: false,
            error: false,
            noContent: false
        },
        download: {
            loading: false,
            error: false
        },
        progress: {
            loading: false,
            error: false,
            noContent: false,
            accept: {
                loading: false,
                error: false
            },
            item: {
                supplierInfo: false,
                sites: false,
                accommodations: false,
                prices: false,
                extras: false,
                arrivalRules: false,
                cancellationRules: false,
                discounts: false,
                allocations: false,
                terms: false
            }
        },
        form: {
            loading: false,
            error: false,
            item: {
                sites: {
                    id: undefined,
                    field: 1,
                    note: undefined,
                    accepted: false
                },
                accommodations: {
                    id: undefined,
                    field: 2,
                    note: undefined,
                    accepted: false
                },
                prices: {
                    id: undefined,
                    field: 3,
                    note: undefined,
                    accepted: false
                },
                extras: {
                    id: undefined,
                    field: 4,
                    note: undefined,
                    accepted: false
                },
                arrivalRules: {
                    id: undefined,
                    field: 5,
                    note: undefined,
                    accepted: false
                },
                discounts: {
                    id: undefined,
                    field: 6,
                    note: undefined,
                    accepted: false
                },
                allocations: {
                    id: undefined,
                    field: 7,
                    note: undefined,
                    accepted: false
                },
                terms: {
                    id: undefined,
                    field: 8,
                    note: undefined,
                    accepted: false
                },
                supplierInfo: {
                    id: undefined,
                    field: 9,
                    note: undefined,
                    accepted: false
                },
                cancellationRules: {
                    id: undefined,
                    field: 10,
                    note: undefined,
                    accepted: false
                }
            }
        }
    },
    history: {
        loading: false,
        error: false,
        noContent: false,
        items: undefined
    },
    contractManagement: {
        loading: false,
        error: false,
        noContent: false,
        item: undefined,
        supplier: {
            loading: false,
            error: false,
            noContent: false,
            items: {
                siteInfo: [],
                accInfo: []
            }
        },
        progress: {
            basic: {
                priceExtra: false,
                allotmentRules: false,
                arrivalRules: false,
                commission: false,
                discounts: false,
                notes: false
            },
            extended: {
                siteInfo: false,
                accInfo: false,
                arrivalDeparture: false,
                brands: false
            }
        },
        form: {
            loading: false,
            error: false,
            noContent: false,
            part: 'basic',
            subPart: 'priceExtra',
            index: 0,
            defaults: {
                basic: {
                    text: undefined,
                    files: [],
                    s3: []
                },
                extended: {
                    accInfo: {
                        entityId: undefined,
                        name: undefined,
                        id: undefined,
                        text: undefined,
                        files: [],
                        images: [],
                        s3: [],
                        imagesS3: [],
                        sites: []
                    },
                    siteInfo: {
                        showInContract: true,
                        entityId: undefined,
                        name: undefined,
                        id: undefined,
                        text: undefined,
                        area: undefined,
                        files: [],
                        images: [],
                        s3: [],
                        imagesS3: []
                    },
                    arrivalDeparture: {
                        text: undefined,
                        files: [],
                        s3: []
                    },
                    brands: {
                        brands: []
                    }
                }
            },
            basic: undefined,
            extended: undefined
        },
        brands: {
            brands: [],
            noContent: false,
            error: false,
            loading: false
        }
    },
    draft: {
        loading: false,
        error: false,
        item: null
    },
    file: {
        loading: false,
        error: false,
        noContent: false
    },
    tips: [{
        title: 'tips.contractManagementPage.progress.title',
        body: 'tips.contractManagementPage.progress.body'
    }, {
        title: 'tips.contractManagementPage.upload.title',
        body: 'tips.contractManagementPage.upload.body'
    }, {
        title: 'tips.contractManagementPage.expand.title',
        body: 'tips.contractManagementPage.expand.body'
    }, {
        title: 'tips.contractManagementPage.indicator.title',
        body: 'tips.contractManagementPage.indicator.body'
    }]
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__(560);

var actions = _interopRequireWildcard(_actions);

var _mutations = __webpack_require__(561);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(562);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    namespaced: true,
    state: _state2.default,
    mutations: _mutations2.default,
    actions: actions
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDismissStatus = exports.dismissInstruction = undefined;

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

var _StorageService = __webpack_require__(100);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Dismiss the given instruction.
 *
 * @param commit
 * @param payload
 */
var dismissInstruction = exports.dismissInstruction = function dismissInstruction(_ref, payload) {
  var commit = _ref.commit;

  // Set a dismiss cookie
  (0, _StorageService.store)(payload, true);
  commit(CONSTANTS.INSTRUCTION_DISMISS, { page: payload, dismiss: true });
};

/**
 * Get the dismiss status for the given page.
 *
 * @param commit
 * @param payload
 */
var getDismissStatus = exports.getDismissStatus = function getDismissStatus(_ref2, payload) {
  var commit = _ref2.commit;

  var dismiss = (0, _StorageService.get)(payload);
  commit(CONSTANTS.INSTRUCTION_DISMISS, { page: payload, dismiss: dismiss });
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(9);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _defineProperty({}, CONSTANTS.INSTRUCTION_DISMISS, function (state, payload) {
    // If there is any dismiss status then update
    if (payload.dismiss) {
        state[payload.page].dismiss = payload.dismiss;
    }
});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    contract: {
        header: "instruction.defaultHeader",
        body: "instruction.contract.body",
        dismiss: false
    },
    contractList: {
        header: "instruction.contractList.header",
        body: "instruction.contractList.body",
        dismiss: false
    }
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(564);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(567)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./app.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./app.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(565);
exports = module.exports = __webpack_require__(566)(false);
// imports


// module
exports.push([module.i, "a{font-weight:700}/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Quattrocento Sans,Arial,Helvetica,sans-serif;font-size:14px;line-height:1.6;color:#7d7e83;background-color:#f3f3f4}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#2d9ee0;text-decoration:none}a:focus,a:hover{color:#1973a8;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:3px}.img-thumbnail{padding:4px;line-height:1.6;background-color:#f3f3f4;border:1px solid #ddd;border-radius:3px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:22px;margin-bottom:22px;border:0;border-top:1px solid #34495e}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Quattrocento Sans,Arial,Helvetica,sans-serif;font-weight:700;line-height:1.1;color:#7d7e83}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:22px;margin-bottom:11px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:11px;margin-bottom:11px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:32px}.h2,h2{font-size:28px}.h3,h3{font-size:24px}.h4,h4{font-size:20px}.h5,h5{font-size:16px}.h6,h6{font-size:12px}p{margin:0 0 11px}.lead{margin-bottom:22px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#64c1c7}a.text-primary:focus,a.text-primary:hover{color:#42afb6}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#64c1c7}a.bg-primary:focus,a.bg-primary:hover{background-color:#42afb6}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:10px;margin:44px 0 22px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:11px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:22px}dd,dt{line-height:1.6}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{display:table;content:\" \"}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help}.initialism{font-size:90%}blockquote{padding:11px 22px;margin:0 0 22px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.6;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:22px;font-style:normal;line-height:1.6}table{background-color:transparent}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.account-activity__table,.admin-list__table,.allocation-list__table,.contract-form-cancellation-rules__table,.contract-management-list__table,.dashboard-notifications__table,.manage-allocation-list__table,.manage-allocation-modal-list__table,.manage-allocation-request__table,.table{width:100%;max-width:100%;margin-bottom:22px}.account-activity__table>tbody>tr>td,.account-activity__table>tbody>tr>th,.account-activity__table>tfoot>tr>td,.account-activity__table>tfoot>tr>th,.account-activity__table>thead>tr>td,.account-activity__table>thead>tr>th,.admin-list__table>tbody>tr>td,.admin-list__table>tbody>tr>th,.admin-list__table>tfoot>tr>td,.admin-list__table>tfoot>tr>th,.admin-list__table>thead>tr>td,.admin-list__table>thead>tr>th,.allocation-list__table>tbody>tr>td,.allocation-list__table>tbody>tr>th,.allocation-list__table>tfoot>tr>td,.allocation-list__table>tfoot>tr>th,.allocation-list__table>thead>tr>td,.allocation-list__table>thead>tr>th,.contract-form-cancellation-rules__table>tbody>tr>td,.contract-form-cancellation-rules__table>tbody>tr>th,.contract-form-cancellation-rules__table>tfoot>tr>td,.contract-form-cancellation-rules__table>tfoot>tr>th,.contract-form-cancellation-rules__table>thead>tr>td,.contract-form-cancellation-rules__table>thead>tr>th,.contract-management-list__table>tbody>tr>td,.contract-management-list__table>tbody>tr>th,.contract-management-list__table>tfoot>tr>td,.contract-management-list__table>tfoot>tr>th,.contract-management-list__table>thead>tr>td,.contract-management-list__table>thead>tr>th,.dashboard-notifications__table>tbody>tr>td,.dashboard-notifications__table>tbody>tr>th,.dashboard-notifications__table>tfoot>tr>td,.dashboard-notifications__table>tfoot>tr>th,.dashboard-notifications__table>thead>tr>td,.dashboard-notifications__table>thead>tr>th,.manage-allocation-list__table>tbody>tr>td,.manage-allocation-list__table>tbody>tr>th,.manage-allocation-list__table>tfoot>tr>td,.manage-allocation-list__table>tfoot>tr>th,.manage-allocation-list__table>thead>tr>td,.manage-allocation-list__table>thead>tr>th,.manage-allocation-modal-list__table>tbody>tr>td,.manage-allocation-modal-list__table>tbody>tr>th,.manage-allocation-modal-list__table>tfoot>tr>td,.manage-allocation-modal-list__table>tfoot>tr>th,.manage-allocation-modal-list__table>thead>tr>td,.manage-allocation-modal-list__table>thead>tr>th,.manage-allocation-request__table>tbody>tr>td,.manage-allocation-request__table>tbody>tr>th,.manage-allocation-request__table>tfoot>tr>td,.manage-allocation-request__table>tfoot>tr>th,.manage-allocation-request__table>thead>tr>td,.manage-allocation-request__table>thead>tr>th,.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.6;vertical-align:top;border-top:1px solid #ddd}.account-activity__table>thead>tr>th,.admin-list__table>thead>tr>th,.allocation-list__table>thead>tr>th,.contract-form-cancellation-rules__table>thead>tr>th,.contract-management-list__table>thead>tr>th,.dashboard-notifications__table>thead>tr>th,.manage-allocation-list__table>thead>tr>th,.manage-allocation-modal-list__table>thead>tr>th,.manage-allocation-request__table>thead>tr>th,.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.account-activity__table>caption+thead>tr:first-child>td,.account-activity__table>caption+thead>tr:first-child>th,.account-activity__table>colgroup+thead>tr:first-child>td,.account-activity__table>colgroup+thead>tr:first-child>th,.account-activity__table>thead:first-child>tr:first-child>td,.account-activity__table>thead:first-child>tr:first-child>th,.admin-list__table>caption+thead>tr:first-child>td,.admin-list__table>caption+thead>tr:first-child>th,.admin-list__table>colgroup+thead>tr:first-child>td,.admin-list__table>colgroup+thead>tr:first-child>th,.admin-list__table>thead:first-child>tr:first-child>td,.admin-list__table>thead:first-child>tr:first-child>th,.allocation-list__table>caption+thead>tr:first-child>td,.allocation-list__table>caption+thead>tr:first-child>th,.allocation-list__table>colgroup+thead>tr:first-child>td,.allocation-list__table>colgroup+thead>tr:first-child>th,.allocation-list__table>thead:first-child>tr:first-child>td,.allocation-list__table>thead:first-child>tr:first-child>th,.contract-form-cancellation-rules__table>caption+thead>tr:first-child>td,.contract-form-cancellation-rules__table>caption+thead>tr:first-child>th,.contract-form-cancellation-rules__table>colgroup+thead>tr:first-child>td,.contract-form-cancellation-rules__table>colgroup+thead>tr:first-child>th,.contract-form-cancellation-rules__table>thead:first-child>tr:first-child>td,.contract-form-cancellation-rules__table>thead:first-child>tr:first-child>th,.contract-management-list__table>caption+thead>tr:first-child>td,.contract-management-list__table>caption+thead>tr:first-child>th,.contract-management-list__table>colgroup+thead>tr:first-child>td,.contract-management-list__table>colgroup+thead>tr:first-child>th,.contract-management-list__table>thead:first-child>tr:first-child>td,.contract-management-list__table>thead:first-child>tr:first-child>th,.dashboard-notifications__table>caption+thead>tr:first-child>td,.dashboard-notifications__table>caption+thead>tr:first-child>th,.dashboard-notifications__table>colgroup+thead>tr:first-child>td,.dashboard-notifications__table>colgroup+thead>tr:first-child>th,.dashboard-notifications__table>thead:first-child>tr:first-child>td,.dashboard-notifications__table>thead:first-child>tr:first-child>th,.manage-allocation-list__table>caption+thead>tr:first-child>td,.manage-allocation-list__table>caption+thead>tr:first-child>th,.manage-allocation-list__table>colgroup+thead>tr:first-child>td,.manage-allocation-list__table>colgroup+thead>tr:first-child>th,.manage-allocation-list__table>thead:first-child>tr:first-child>td,.manage-allocation-list__table>thead:first-child>tr:first-child>th,.manage-allocation-modal-list__table>caption+thead>tr:first-child>td,.manage-allocation-modal-list__table>caption+thead>tr:first-child>th,.manage-allocation-modal-list__table>colgroup+thead>tr:first-child>td,.manage-allocation-modal-list__table>colgroup+thead>tr:first-child>th,.manage-allocation-modal-list__table>thead:first-child>tr:first-child>td,.manage-allocation-modal-list__table>thead:first-child>tr:first-child>th,.manage-allocation-request__table>caption+thead>tr:first-child>td,.manage-allocation-request__table>caption+thead>tr:first-child>th,.manage-allocation-request__table>colgroup+thead>tr:first-child>td,.manage-allocation-request__table>colgroup+thead>tr:first-child>th,.manage-allocation-request__table>thead:first-child>tr:first-child>td,.manage-allocation-request__table>thead:first-child>tr:first-child>th,.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.account-activity__table>tbody+tbody,.admin-list__table>tbody+tbody,.allocation-list__table>tbody+tbody,.contract-form-cancellation-rules__table>tbody+tbody,.contract-management-list__table>tbody+tbody,.dashboard-notifications__table>tbody+tbody,.manage-allocation-list__table>tbody+tbody,.manage-allocation-modal-list__table>tbody+tbody,.manage-allocation-request__table>tbody+tbody,.table>tbody+tbody{border-top:2px solid #ddd}.account-activity__table .account-activity__table,.account-activity__table .admin-list__table,.account-activity__table .allocation-list__table,.account-activity__table .contract-form-cancellation-rules__table,.account-activity__table .contract-management-list__table,.account-activity__table .dashboard-notifications__table,.account-activity__table .manage-allocation-list__table,.account-activity__table .manage-allocation-modal-list__table,.account-activity__table .manage-allocation-request__table,.account-activity__table .table,.admin-list__table .account-activity__table,.admin-list__table .admin-list__table,.admin-list__table .allocation-list__table,.admin-list__table .contract-form-cancellation-rules__table,.admin-list__table .contract-management-list__table,.admin-list__table .dashboard-notifications__table,.admin-list__table .manage-allocation-list__table,.admin-list__table .manage-allocation-modal-list__table,.admin-list__table .manage-allocation-request__table,.admin-list__table .table,.allocation-list__table .account-activity__table,.allocation-list__table .admin-list__table,.allocation-list__table .allocation-list__table,.allocation-list__table .contract-form-cancellation-rules__table,.allocation-list__table .contract-management-list__table,.allocation-list__table .dashboard-notifications__table,.allocation-list__table .manage-allocation-list__table,.allocation-list__table .manage-allocation-modal-list__table,.allocation-list__table .manage-allocation-request__table,.allocation-list__table .table,.contract-form-cancellation-rules__table .account-activity__table,.contract-form-cancellation-rules__table .admin-list__table,.contract-form-cancellation-rules__table .allocation-list__table,.contract-form-cancellation-rules__table .contract-form-cancellation-rules__table,.contract-form-cancellation-rules__table .contract-management-list__table,.contract-form-cancellation-rules__table .dashboard-notifications__table,.contract-form-cancellation-rules__table .manage-allocation-list__table,.contract-form-cancellation-rules__table .manage-allocation-modal-list__table,.contract-form-cancellation-rules__table .manage-allocation-request__table,.contract-form-cancellation-rules__table .table,.contract-management-list__table .account-activity__table,.contract-management-list__table .admin-list__table,.contract-management-list__table .allocation-list__table,.contract-management-list__table .contract-form-cancellation-rules__table,.contract-management-list__table .contract-management-list__table,.contract-management-list__table .dashboard-notifications__table,.contract-management-list__table .manage-allocation-list__table,.contract-management-list__table .manage-allocation-modal-list__table,.contract-management-list__table .manage-allocation-request__table,.contract-management-list__table .table,.dashboard-notifications__table .account-activity__table,.dashboard-notifications__table .admin-list__table,.dashboard-notifications__table .allocation-list__table,.dashboard-notifications__table .contract-form-cancellation-rules__table,.dashboard-notifications__table .contract-management-list__table,.dashboard-notifications__table .dashboard-notifications__table,.dashboard-notifications__table .manage-allocation-list__table,.dashboard-notifications__table .manage-allocation-modal-list__table,.dashboard-notifications__table .manage-allocation-request__table,.dashboard-notifications__table .table,.manage-allocation-list__table .account-activity__table,.manage-allocation-list__table .admin-list__table,.manage-allocation-list__table .allocation-list__table,.manage-allocation-list__table .contract-form-cancellation-rules__table,.manage-allocation-list__table .contract-management-list__table,.manage-allocation-list__table .dashboard-notifications__table,.manage-allocation-list__table .manage-allocation-list__table,.manage-allocation-list__table .manage-allocation-modal-list__table,.manage-allocation-list__table .manage-allocation-request__table,.manage-allocation-list__table .table,.manage-allocation-modal-list__table .account-activity__table,.manage-allocation-modal-list__table .admin-list__table,.manage-allocation-modal-list__table .allocation-list__table,.manage-allocation-modal-list__table .contract-form-cancellation-rules__table,.manage-allocation-modal-list__table .contract-management-list__table,.manage-allocation-modal-list__table .dashboard-notifications__table,.manage-allocation-modal-list__table .manage-allocation-list__table,.manage-allocation-modal-list__table .manage-allocation-modal-list__table,.manage-allocation-modal-list__table .manage-allocation-request__table,.manage-allocation-modal-list__table .table,.manage-allocation-request__table .account-activity__table,.manage-allocation-request__table .admin-list__table,.manage-allocation-request__table .allocation-list__table,.manage-allocation-request__table .contract-form-cancellation-rules__table,.manage-allocation-request__table .contract-management-list__table,.manage-allocation-request__table .dashboard-notifications__table,.manage-allocation-request__table .manage-allocation-list__table,.manage-allocation-request__table .manage-allocation-modal-list__table,.manage-allocation-request__table .manage-allocation-request__table,.manage-allocation-request__table .table,.table .account-activity__table,.table .admin-list__table,.table .allocation-list__table,.table .contract-form-cancellation-rules__table,.table .contract-management-list__table,.table .dashboard-notifications__table,.table .manage-allocation-list__table,.table .manage-allocation-modal-list__table,.table .manage-allocation-request__table,.table .table{background-color:#f3f3f4}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.account-activity__table>tbody>tr.active>td,.account-activity__table>tbody>tr.active>th,.account-activity__table>tbody>tr>td.active,.account-activity__table>tbody>tr>th.active,.account-activity__table>tfoot>tr.active>td,.account-activity__table>tfoot>tr.active>th,.account-activity__table>tfoot>tr>td.active,.account-activity__table>tfoot>tr>th.active,.account-activity__table>thead>tr.active>td,.account-activity__table>thead>tr.active>th,.account-activity__table>thead>tr>td.active,.account-activity__table>thead>tr>th.active,.admin-list__table>tbody>tr.active>td,.admin-list__table>tbody>tr.active>th,.admin-list__table>tbody>tr>td.active,.admin-list__table>tbody>tr>th.active,.admin-list__table>tfoot>tr.active>td,.admin-list__table>tfoot>tr.active>th,.admin-list__table>tfoot>tr>td.active,.admin-list__table>tfoot>tr>th.active,.admin-list__table>thead>tr.active>td,.admin-list__table>thead>tr.active>th,.admin-list__table>thead>tr>td.active,.admin-list__table>thead>tr>th.active,.allocation-list__table>tbody>tr.active>td,.allocation-list__table>tbody>tr.active>th,.allocation-list__table>tbody>tr>td.active,.allocation-list__table>tbody>tr>th.active,.allocation-list__table>tfoot>tr.active>td,.allocation-list__table>tfoot>tr.active>th,.allocation-list__table>tfoot>tr>td.active,.allocation-list__table>tfoot>tr>th.active,.allocation-list__table>thead>tr.active>td,.allocation-list__table>thead>tr.active>th,.allocation-list__table>thead>tr>td.active,.allocation-list__table>thead>tr>th.active,.contract-form-cancellation-rules__table>tbody>tr.active>td,.contract-form-cancellation-rules__table>tbody>tr.active>th,.contract-form-cancellation-rules__table>tbody>tr>td.active,.contract-form-cancellation-rules__table>tbody>tr>th.active,.contract-form-cancellation-rules__table>tfoot>tr.active>td,.contract-form-cancellation-rules__table>tfoot>tr.active>th,.contract-form-cancellation-rules__table>tfoot>tr>td.active,.contract-form-cancellation-rules__table>tfoot>tr>th.active,.contract-form-cancellation-rules__table>thead>tr.active>td,.contract-form-cancellation-rules__table>thead>tr.active>th,.contract-form-cancellation-rules__table>thead>tr>td.active,.contract-form-cancellation-rules__table>thead>tr>th.active,.contract-management-list__table>tbody>tr.active>td,.contract-management-list__table>tbody>tr.active>th,.contract-management-list__table>tbody>tr>td.active,.contract-management-list__table>tbody>tr>th.active,.contract-management-list__table>tfoot>tr.active>td,.contract-management-list__table>tfoot>tr.active>th,.contract-management-list__table>tfoot>tr>td.active,.contract-management-list__table>tfoot>tr>th.active,.contract-management-list__table>thead>tr.active>td,.contract-management-list__table>thead>tr.active>th,.contract-management-list__table>thead>tr>td.active,.contract-management-list__table>thead>tr>th.active,.dashboard-notifications__table>tbody>tr.active>td,.dashboard-notifications__table>tbody>tr.active>th,.dashboard-notifications__table>tbody>tr>td.active,.dashboard-notifications__table>tbody>tr>th.active,.dashboard-notifications__table>tfoot>tr.active>td,.dashboard-notifications__table>tfoot>tr.active>th,.dashboard-notifications__table>tfoot>tr>td.active,.dashboard-notifications__table>tfoot>tr>th.active,.dashboard-notifications__table>thead>tr.active>td,.dashboard-notifications__table>thead>tr.active>th,.dashboard-notifications__table>thead>tr>td.active,.dashboard-notifications__table>thead>tr>th.active,.manage-allocation-list__table>tbody>tr.active>td,.manage-allocation-list__table>tbody>tr.active>th,.manage-allocation-list__table>tbody>tr>td.active,.manage-allocation-list__table>tbody>tr>th.active,.manage-allocation-list__table>tfoot>tr.active>td,.manage-allocation-list__table>tfoot>tr.active>th,.manage-allocation-list__table>tfoot>tr>td.active,.manage-allocation-list__table>tfoot>tr>th.active,.manage-allocation-list__table>thead>tr.active>td,.manage-allocation-list__table>thead>tr.active>th,.manage-allocation-list__table>thead>tr>td.active,.manage-allocation-list__table>thead>tr>th.active,.manage-allocation-modal-list__table>tbody>tr.active>td,.manage-allocation-modal-list__table>tbody>tr.active>th,.manage-allocation-modal-list__table>tbody>tr>td.active,.manage-allocation-modal-list__table>tbody>tr>th.active,.manage-allocation-modal-list__table>tfoot>tr.active>td,.manage-allocation-modal-list__table>tfoot>tr.active>th,.manage-allocation-modal-list__table>tfoot>tr>td.active,.manage-allocation-modal-list__table>tfoot>tr>th.active,.manage-allocation-modal-list__table>thead>tr.active>td,.manage-allocation-modal-list__table>thead>tr.active>th,.manage-allocation-modal-list__table>thead>tr>td.active,.manage-allocation-modal-list__table>thead>tr>th.active,.manage-allocation-request__table>tbody>tr.active>td,.manage-allocation-request__table>tbody>tr.active>th,.manage-allocation-request__table>tbody>tr>td.active,.manage-allocation-request__table>tbody>tr>th.active,.manage-allocation-request__table>tfoot>tr.active>td,.manage-allocation-request__table>tfoot>tr.active>th,.manage-allocation-request__table>tfoot>tr>td.active,.manage-allocation-request__table>tfoot>tr>th.active,.manage-allocation-request__table>thead>tr.active>td,.manage-allocation-request__table>thead>tr.active>th,.manage-allocation-request__table>thead>tr>td.active,.manage-allocation-request__table>thead>tr>th.active,.table-hover>tbody>tr:hover,.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.account-activity__table>tbody>tr.success>td,.account-activity__table>tbody>tr.success>th,.account-activity__table>tbody>tr>td.success,.account-activity__table>tbody>tr>th.success,.account-activity__table>tfoot>tr.success>td,.account-activity__table>tfoot>tr.success>th,.account-activity__table>tfoot>tr>td.success,.account-activity__table>tfoot>tr>th.success,.account-activity__table>thead>tr.success>td,.account-activity__table>thead>tr.success>th,.account-activity__table>thead>tr>td.success,.account-activity__table>thead>tr>th.success,.admin-list__table>tbody>tr.success>td,.admin-list__table>tbody>tr.success>th,.admin-list__table>tbody>tr>td.success,.admin-list__table>tbody>tr>th.success,.admin-list__table>tfoot>tr.success>td,.admin-list__table>tfoot>tr.success>th,.admin-list__table>tfoot>tr>td.success,.admin-list__table>tfoot>tr>th.success,.admin-list__table>thead>tr.success>td,.admin-list__table>thead>tr.success>th,.admin-list__table>thead>tr>td.success,.admin-list__table>thead>tr>th.success,.allocation-list__table>tbody>tr.success>td,.allocation-list__table>tbody>tr.success>th,.allocation-list__table>tbody>tr>td.success,.allocation-list__table>tbody>tr>th.success,.allocation-list__table>tfoot>tr.success>td,.allocation-list__table>tfoot>tr.success>th,.allocation-list__table>tfoot>tr>td.success,.allocation-list__table>tfoot>tr>th.success,.allocation-list__table>thead>tr.success>td,.allocation-list__table>thead>tr.success>th,.allocation-list__table>thead>tr>td.success,.allocation-list__table>thead>tr>th.success,.contract-form-cancellation-rules__table>tbody>tr.success>td,.contract-form-cancellation-rules__table>tbody>tr.success>th,.contract-form-cancellation-rules__table>tbody>tr>td.success,.contract-form-cancellation-rules__table>tbody>tr>th.success,.contract-form-cancellation-rules__table>tfoot>tr.success>td,.contract-form-cancellation-rules__table>tfoot>tr.success>th,.contract-form-cancellation-rules__table>tfoot>tr>td.success,.contract-form-cancellation-rules__table>tfoot>tr>th.success,.contract-form-cancellation-rules__table>thead>tr.success>td,.contract-form-cancellation-rules__table>thead>tr.success>th,.contract-form-cancellation-rules__table>thead>tr>td.success,.contract-form-cancellation-rules__table>thead>tr>th.success,.contract-management-list__table>tbody>tr.success>td,.contract-management-list__table>tbody>tr.success>th,.contract-management-list__table>tbody>tr>td.success,.contract-management-list__table>tbody>tr>th.success,.contract-management-list__table>tfoot>tr.success>td,.contract-management-list__table>tfoot>tr.success>th,.contract-management-list__table>tfoot>tr>td.success,.contract-management-list__table>tfoot>tr>th.success,.contract-management-list__table>thead>tr.success>td,.contract-management-list__table>thead>tr.success>th,.contract-management-list__table>thead>tr>td.success,.contract-management-list__table>thead>tr>th.success,.dashboard-notifications__table>tbody>tr.success>td,.dashboard-notifications__table>tbody>tr.success>th,.dashboard-notifications__table>tbody>tr>td.success,.dashboard-notifications__table>tbody>tr>th.success,.dashboard-notifications__table>tfoot>tr.success>td,.dashboard-notifications__table>tfoot>tr.success>th,.dashboard-notifications__table>tfoot>tr>td.success,.dashboard-notifications__table>tfoot>tr>th.success,.dashboard-notifications__table>thead>tr.success>td,.dashboard-notifications__table>thead>tr.success>th,.dashboard-notifications__table>thead>tr>td.success,.dashboard-notifications__table>thead>tr>th.success,.manage-allocation-list__table>tbody>tr.success>td,.manage-allocation-list__table>tbody>tr.success>th,.manage-allocation-list__table>tbody>tr>td.success,.manage-allocation-list__table>tbody>tr>th.success,.manage-allocation-list__table>tfoot>tr.success>td,.manage-allocation-list__table>tfoot>tr.success>th,.manage-allocation-list__table>tfoot>tr>td.success,.manage-allocation-list__table>tfoot>tr>th.success,.manage-allocation-list__table>thead>tr.success>td,.manage-allocation-list__table>thead>tr.success>th,.manage-allocation-list__table>thead>tr>td.success,.manage-allocation-list__table>thead>tr>th.success,.manage-allocation-modal-list__table>tbody>tr.success>td,.manage-allocation-modal-list__table>tbody>tr.success>th,.manage-allocation-modal-list__table>tbody>tr>td.success,.manage-allocation-modal-list__table>tbody>tr>th.success,.manage-allocation-modal-list__table>tfoot>tr.success>td,.manage-allocation-modal-list__table>tfoot>tr.success>th,.manage-allocation-modal-list__table>tfoot>tr>td.success,.manage-allocation-modal-list__table>tfoot>tr>th.success,.manage-allocation-modal-list__table>thead>tr.success>td,.manage-allocation-modal-list__table>thead>tr.success>th,.manage-allocation-modal-list__table>thead>tr>td.success,.manage-allocation-modal-list__table>thead>tr>th.success,.manage-allocation-request__table>tbody>tr.success>td,.manage-allocation-request__table>tbody>tr.success>th,.manage-allocation-request__table>tbody>tr>td.success,.manage-allocation-request__table>tbody>tr>th.success,.manage-allocation-request__table>tfoot>tr.success>td,.manage-allocation-request__table>tfoot>tr.success>th,.manage-allocation-request__table>tfoot>tr>td.success,.manage-allocation-request__table>tfoot>tr>th.success,.manage-allocation-request__table>thead>tr.success>td,.manage-allocation-request__table>thead>tr.success>th,.manage-allocation-request__table>thead>tr>td.success,.manage-allocation-request__table>thead>tr>th.success,.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.account-activity__table>tbody>tr.info>td,.account-activity__table>tbody>tr.info>th,.account-activity__table>tbody>tr>td.info,.account-activity__table>tbody>tr>th.info,.account-activity__table>tfoot>tr.info>td,.account-activity__table>tfoot>tr.info>th,.account-activity__table>tfoot>tr>td.info,.account-activity__table>tfoot>tr>th.info,.account-activity__table>thead>tr.info>td,.account-activity__table>thead>tr.info>th,.account-activity__table>thead>tr>td.info,.account-activity__table>thead>tr>th.info,.admin-list__table>tbody>tr.info>td,.admin-list__table>tbody>tr.info>th,.admin-list__table>tbody>tr>td.info,.admin-list__table>tbody>tr>th.info,.admin-list__table>tfoot>tr.info>td,.admin-list__table>tfoot>tr.info>th,.admin-list__table>tfoot>tr>td.info,.admin-list__table>tfoot>tr>th.info,.admin-list__table>thead>tr.info>td,.admin-list__table>thead>tr.info>th,.admin-list__table>thead>tr>td.info,.admin-list__table>thead>tr>th.info,.allocation-list__table>tbody>tr.info>td,.allocation-list__table>tbody>tr.info>th,.allocation-list__table>tbody>tr>td.info,.allocation-list__table>tbody>tr>th.info,.allocation-list__table>tfoot>tr.info>td,.allocation-list__table>tfoot>tr.info>th,.allocation-list__table>tfoot>tr>td.info,.allocation-list__table>tfoot>tr>th.info,.allocation-list__table>thead>tr.info>td,.allocation-list__table>thead>tr.info>th,.allocation-list__table>thead>tr>td.info,.allocation-list__table>thead>tr>th.info,.contract-form-cancellation-rules__table>tbody>tr.info>td,.contract-form-cancellation-rules__table>tbody>tr.info>th,.contract-form-cancellation-rules__table>tbody>tr>td.info,.contract-form-cancellation-rules__table>tbody>tr>th.info,.contract-form-cancellation-rules__table>tfoot>tr.info>td,.contract-form-cancellation-rules__table>tfoot>tr.info>th,.contract-form-cancellation-rules__table>tfoot>tr>td.info,.contract-form-cancellation-rules__table>tfoot>tr>th.info,.contract-form-cancellation-rules__table>thead>tr.info>td,.contract-form-cancellation-rules__table>thead>tr.info>th,.contract-form-cancellation-rules__table>thead>tr>td.info,.contract-form-cancellation-rules__table>thead>tr>th.info,.contract-management-list__table>tbody>tr.info>td,.contract-management-list__table>tbody>tr.info>th,.contract-management-list__table>tbody>tr>td.info,.contract-management-list__table>tbody>tr>th.info,.contract-management-list__table>tfoot>tr.info>td,.contract-management-list__table>tfoot>tr.info>th,.contract-management-list__table>tfoot>tr>td.info,.contract-management-list__table>tfoot>tr>th.info,.contract-management-list__table>thead>tr.info>td,.contract-management-list__table>thead>tr.info>th,.contract-management-list__table>thead>tr>td.info,.contract-management-list__table>thead>tr>th.info,.dashboard-notifications__table>tbody>tr.info>td,.dashboard-notifications__table>tbody>tr.info>th,.dashboard-notifications__table>tbody>tr>td.info,.dashboard-notifications__table>tbody>tr>th.info,.dashboard-notifications__table>tfoot>tr.info>td,.dashboard-notifications__table>tfoot>tr.info>th,.dashboard-notifications__table>tfoot>tr>td.info,.dashboard-notifications__table>tfoot>tr>th.info,.dashboard-notifications__table>thead>tr.info>td,.dashboard-notifications__table>thead>tr.info>th,.dashboard-notifications__table>thead>tr>td.info,.dashboard-notifications__table>thead>tr>th.info,.manage-allocation-list__table>tbody>tr.info>td,.manage-allocation-list__table>tbody>tr.info>th,.manage-allocation-list__table>tbody>tr>td.info,.manage-allocation-list__table>tbody>tr>th.info,.manage-allocation-list__table>tfoot>tr.info>td,.manage-allocation-list__table>tfoot>tr.info>th,.manage-allocation-list__table>tfoot>tr>td.info,.manage-allocation-list__table>tfoot>tr>th.info,.manage-allocation-list__table>thead>tr.info>td,.manage-allocation-list__table>thead>tr.info>th,.manage-allocation-list__table>thead>tr>td.info,.manage-allocation-list__table>thead>tr>th.info,.manage-allocation-modal-list__table>tbody>tr.info>td,.manage-allocation-modal-list__table>tbody>tr.info>th,.manage-allocation-modal-list__table>tbody>tr>td.info,.manage-allocation-modal-list__table>tbody>tr>th.info,.manage-allocation-modal-list__table>tfoot>tr.info>td,.manage-allocation-modal-list__table>tfoot>tr.info>th,.manage-allocation-modal-list__table>tfoot>tr>td.info,.manage-allocation-modal-list__table>tfoot>tr>th.info,.manage-allocation-modal-list__table>thead>tr.info>td,.manage-allocation-modal-list__table>thead>tr.info>th,.manage-allocation-modal-list__table>thead>tr>td.info,.manage-allocation-modal-list__table>thead>tr>th.info,.manage-allocation-request__table>tbody>tr.info>td,.manage-allocation-request__table>tbody>tr.info>th,.manage-allocation-request__table>tbody>tr>td.info,.manage-allocation-request__table>tbody>tr>th.info,.manage-allocation-request__table>tfoot>tr.info>td,.manage-allocation-request__table>tfoot>tr.info>th,.manage-allocation-request__table>tfoot>tr>td.info,.manage-allocation-request__table>tfoot>tr>th.info,.manage-allocation-request__table>thead>tr.info>td,.manage-allocation-request__table>thead>tr.info>th,.manage-allocation-request__table>thead>tr>td.info,.manage-allocation-request__table>thead>tr>th.info,.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.account-activity__table>tbody>tr.warning>td,.account-activity__table>tbody>tr.warning>th,.account-activity__table>tbody>tr>td.warning,.account-activity__table>tbody>tr>th.warning,.account-activity__table>tfoot>tr.warning>td,.account-activity__table>tfoot>tr.warning>th,.account-activity__table>tfoot>tr>td.warning,.account-activity__table>tfoot>tr>th.warning,.account-activity__table>thead>tr.warning>td,.account-activity__table>thead>tr.warning>th,.account-activity__table>thead>tr>td.warning,.account-activity__table>thead>tr>th.warning,.admin-list__table>tbody>tr.warning>td,.admin-list__table>tbody>tr.warning>th,.admin-list__table>tbody>tr>td.warning,.admin-list__table>tbody>tr>th.warning,.admin-list__table>tfoot>tr.warning>td,.admin-list__table>tfoot>tr.warning>th,.admin-list__table>tfoot>tr>td.warning,.admin-list__table>tfoot>tr>th.warning,.admin-list__table>thead>tr.warning>td,.admin-list__table>thead>tr.warning>th,.admin-list__table>thead>tr>td.warning,.admin-list__table>thead>tr>th.warning,.allocation-list__table>tbody>tr.warning>td,.allocation-list__table>tbody>tr.warning>th,.allocation-list__table>tbody>tr>td.warning,.allocation-list__table>tbody>tr>th.warning,.allocation-list__table>tfoot>tr.warning>td,.allocation-list__table>tfoot>tr.warning>th,.allocation-list__table>tfoot>tr>td.warning,.allocation-list__table>tfoot>tr>th.warning,.allocation-list__table>thead>tr.warning>td,.allocation-list__table>thead>tr.warning>th,.allocation-list__table>thead>tr>td.warning,.allocation-list__table>thead>tr>th.warning,.contract-form-cancellation-rules__table>tbody>tr.warning>td,.contract-form-cancellation-rules__table>tbody>tr.warning>th,.contract-form-cancellation-rules__table>tbody>tr>td.warning,.contract-form-cancellation-rules__table>tbody>tr>th.warning,.contract-form-cancellation-rules__table>tfoot>tr.warning>td,.contract-form-cancellation-rules__table>tfoot>tr.warning>th,.contract-form-cancellation-rules__table>tfoot>tr>td.warning,.contract-form-cancellation-rules__table>tfoot>tr>th.warning,.contract-form-cancellation-rules__table>thead>tr.warning>td,.contract-form-cancellation-rules__table>thead>tr.warning>th,.contract-form-cancellation-rules__table>thead>tr>td.warning,.contract-form-cancellation-rules__table>thead>tr>th.warning,.contract-management-list__table>tbody>tr.warning>td,.contract-management-list__table>tbody>tr.warning>th,.contract-management-list__table>tbody>tr>td.warning,.contract-management-list__table>tbody>tr>th.warning,.contract-management-list__table>tfoot>tr.warning>td,.contract-management-list__table>tfoot>tr.warning>th,.contract-management-list__table>tfoot>tr>td.warning,.contract-management-list__table>tfoot>tr>th.warning,.contract-management-list__table>thead>tr.warning>td,.contract-management-list__table>thead>tr.warning>th,.contract-management-list__table>thead>tr>td.warning,.contract-management-list__table>thead>tr>th.warning,.dashboard-notifications__table>tbody>tr.warning>td,.dashboard-notifications__table>tbody>tr.warning>th,.dashboard-notifications__table>tbody>tr>td.warning,.dashboard-notifications__table>tbody>tr>th.warning,.dashboard-notifications__table>tfoot>tr.warning>td,.dashboard-notifications__table>tfoot>tr.warning>th,.dashboard-notifications__table>tfoot>tr>td.warning,.dashboard-notifications__table>tfoot>tr>th.warning,.dashboard-notifications__table>thead>tr.warning>td,.dashboard-notifications__table>thead>tr.warning>th,.dashboard-notifications__table>thead>tr>td.warning,.dashboard-notifications__table>thead>tr>th.warning,.manage-allocation-list__table>tbody>tr.warning>td,.manage-allocation-list__table>tbody>tr.warning>th,.manage-allocation-list__table>tbody>tr>td.warning,.manage-allocation-list__table>tbody>tr>th.warning,.manage-allocation-list__table>tfoot>tr.warning>td,.manage-allocation-list__table>tfoot>tr.warning>th,.manage-allocation-list__table>tfoot>tr>td.warning,.manage-allocation-list__table>tfoot>tr>th.warning,.manage-allocation-list__table>thead>tr.warning>td,.manage-allocation-list__table>thead>tr.warning>th,.manage-allocation-list__table>thead>tr>td.warning,.manage-allocation-list__table>thead>tr>th.warning,.manage-allocation-modal-list__table>tbody>tr.warning>td,.manage-allocation-modal-list__table>tbody>tr.warning>th,.manage-allocation-modal-list__table>tbody>tr>td.warning,.manage-allocation-modal-list__table>tbody>tr>th.warning,.manage-allocation-modal-list__table>tfoot>tr.warning>td,.manage-allocation-modal-list__table>tfoot>tr.warning>th,.manage-allocation-modal-list__table>tfoot>tr>td.warning,.manage-allocation-modal-list__table>tfoot>tr>th.warning,.manage-allocation-modal-list__table>thead>tr.warning>td,.manage-allocation-modal-list__table>thead>tr.warning>th,.manage-allocation-modal-list__table>thead>tr>td.warning,.manage-allocation-modal-list__table>thead>tr>th.warning,.manage-allocation-request__table>tbody>tr.warning>td,.manage-allocation-request__table>tbody>tr.warning>th,.manage-allocation-request__table>tbody>tr>td.warning,.manage-allocation-request__table>tbody>tr>th.warning,.manage-allocation-request__table>tfoot>tr.warning>td,.manage-allocation-request__table>tfoot>tr.warning>th,.manage-allocation-request__table>tfoot>tr>td.warning,.manage-allocation-request__table>tfoot>tr>th.warning,.manage-allocation-request__table>thead>tr.warning>td,.manage-allocation-request__table>thead>tr.warning>th,.manage-allocation-request__table>thead>tr>td.warning,.manage-allocation-request__table>thead>tr>th.warning,.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.account-activity__table>tbody>tr.danger>td,.account-activity__table>tbody>tr.danger>th,.account-activity__table>tbody>tr>td.danger,.account-activity__table>tbody>tr>th.danger,.account-activity__table>tfoot>tr.danger>td,.account-activity__table>tfoot>tr.danger>th,.account-activity__table>tfoot>tr>td.danger,.account-activity__table>tfoot>tr>th.danger,.account-activity__table>thead>tr.danger>td,.account-activity__table>thead>tr.danger>th,.account-activity__table>thead>tr>td.danger,.account-activity__table>thead>tr>th.danger,.admin-list__table>tbody>tr.danger>td,.admin-list__table>tbody>tr.danger>th,.admin-list__table>tbody>tr>td.danger,.admin-list__table>tbody>tr>th.danger,.admin-list__table>tfoot>tr.danger>td,.admin-list__table>tfoot>tr.danger>th,.admin-list__table>tfoot>tr>td.danger,.admin-list__table>tfoot>tr>th.danger,.admin-list__table>thead>tr.danger>td,.admin-list__table>thead>tr.danger>th,.admin-list__table>thead>tr>td.danger,.admin-list__table>thead>tr>th.danger,.allocation-list__table>tbody>tr.danger>td,.allocation-list__table>tbody>tr.danger>th,.allocation-list__table>tbody>tr>td.danger,.allocation-list__table>tbody>tr>th.danger,.allocation-list__table>tfoot>tr.danger>td,.allocation-list__table>tfoot>tr.danger>th,.allocation-list__table>tfoot>tr>td.danger,.allocation-list__table>tfoot>tr>th.danger,.allocation-list__table>thead>tr.danger>td,.allocation-list__table>thead>tr.danger>th,.allocation-list__table>thead>tr>td.danger,.allocation-list__table>thead>tr>th.danger,.contract-form-cancellation-rules__table>tbody>tr.danger>td,.contract-form-cancellation-rules__table>tbody>tr.danger>th,.contract-form-cancellation-rules__table>tbody>tr>td.danger,.contract-form-cancellation-rules__table>tbody>tr>th.danger,.contract-form-cancellation-rules__table>tfoot>tr.danger>td,.contract-form-cancellation-rules__table>tfoot>tr.danger>th,.contract-form-cancellation-rules__table>tfoot>tr>td.danger,.contract-form-cancellation-rules__table>tfoot>tr>th.danger,.contract-form-cancellation-rules__table>thead>tr.danger>td,.contract-form-cancellation-rules__table>thead>tr.danger>th,.contract-form-cancellation-rules__table>thead>tr>td.danger,.contract-form-cancellation-rules__table>thead>tr>th.danger,.contract-management-list__table>tbody>tr.danger>td,.contract-management-list__table>tbody>tr.danger>th,.contract-management-list__table>tbody>tr>td.danger,.contract-management-list__table>tbody>tr>th.danger,.contract-management-list__table>tfoot>tr.danger>td,.contract-management-list__table>tfoot>tr.danger>th,.contract-management-list__table>tfoot>tr>td.danger,.contract-management-list__table>tfoot>tr>th.danger,.contract-management-list__table>thead>tr.danger>td,.contract-management-list__table>thead>tr.danger>th,.contract-management-list__table>thead>tr>td.danger,.contract-management-list__table>thead>tr>th.danger,.dashboard-notifications__table>tbody>tr.danger>td,.dashboard-notifications__table>tbody>tr.danger>th,.dashboard-notifications__table>tbody>tr>td.danger,.dashboard-notifications__table>tbody>tr>th.danger,.dashboard-notifications__table>tfoot>tr.danger>td,.dashboard-notifications__table>tfoot>tr.danger>th,.dashboard-notifications__table>tfoot>tr>td.danger,.dashboard-notifications__table>tfoot>tr>th.danger,.dashboard-notifications__table>thead>tr.danger>td,.dashboard-notifications__table>thead>tr.danger>th,.dashboard-notifications__table>thead>tr>td.danger,.dashboard-notifications__table>thead>tr>th.danger,.manage-allocation-list__table>tbody>tr.danger>td,.manage-allocation-list__table>tbody>tr.danger>th,.manage-allocation-list__table>tbody>tr>td.danger,.manage-allocation-list__table>tbody>tr>th.danger,.manage-allocation-list__table>tfoot>tr.danger>td,.manage-allocation-list__table>tfoot>tr.danger>th,.manage-allocation-list__table>tfoot>tr>td.danger,.manage-allocation-list__table>tfoot>tr>th.danger,.manage-allocation-list__table>thead>tr.danger>td,.manage-allocation-list__table>thead>tr.danger>th,.manage-allocation-list__table>thead>tr>td.danger,.manage-allocation-list__table>thead>tr>th.danger,.manage-allocation-modal-list__table>tbody>tr.danger>td,.manage-allocation-modal-list__table>tbody>tr.danger>th,.manage-allocation-modal-list__table>tbody>tr>td.danger,.manage-allocation-modal-list__table>tbody>tr>th.danger,.manage-allocation-modal-list__table>tfoot>tr.danger>td,.manage-allocation-modal-list__table>tfoot>tr.danger>th,.manage-allocation-modal-list__table>tfoot>tr>td.danger,.manage-allocation-modal-list__table>tfoot>tr>th.danger,.manage-allocation-modal-list__table>thead>tr.danger>td,.manage-allocation-modal-list__table>thead>tr.danger>th,.manage-allocation-modal-list__table>thead>tr>td.danger,.manage-allocation-modal-list__table>thead>tr>th.danger,.manage-allocation-request__table>tbody>tr.danger>td,.manage-allocation-request__table>tbody>tr.danger>th,.manage-allocation-request__table>tbody>tr>td.danger,.manage-allocation-request__table>tbody>tr>th.danger,.manage-allocation-request__table>tfoot>tr.danger>td,.manage-allocation-request__table>tfoot>tr.danger>th,.manage-allocation-request__table>tfoot>tr>td.danger,.manage-allocation-request__table>tfoot>tr>th.danger,.manage-allocation-request__table>thead>tr.danger>td,.manage-allocation-request__table>thead>tr.danger>th,.manage-allocation-request__table>thead>tr>td.danger,.manage-allocation-request__table>thead>tr>th.danger,.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:16.5px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.account-activity__table,.table-responsive>.admin-list__table,.table-responsive>.allocation-list__table,.table-responsive>.contract-form-cancellation-rules__table,.table-responsive>.contract-management-list__table,.table-responsive>.dashboard-notifications__table,.table-responsive>.manage-allocation-list__table,.table-responsive>.manage-allocation-modal-list__table,.table-responsive>.manage-allocation-request__table,.table-responsive>.table{margin-bottom:0}.table-responsive>.account-activity__table>tbody>tr>td,.table-responsive>.account-activity__table>tbody>tr>th,.table-responsive>.account-activity__table>tfoot>tr>td,.table-responsive>.account-activity__table>tfoot>tr>th,.table-responsive>.account-activity__table>thead>tr>td,.table-responsive>.account-activity__table>thead>tr>th,.table-responsive>.admin-list__table>tbody>tr>td,.table-responsive>.admin-list__table>tbody>tr>th,.table-responsive>.admin-list__table>tfoot>tr>td,.table-responsive>.admin-list__table>tfoot>tr>th,.table-responsive>.admin-list__table>thead>tr>td,.table-responsive>.admin-list__table>thead>tr>th,.table-responsive>.allocation-list__table>tbody>tr>td,.table-responsive>.allocation-list__table>tbody>tr>th,.table-responsive>.allocation-list__table>tfoot>tr>td,.table-responsive>.allocation-list__table>tfoot>tr>th,.table-responsive>.allocation-list__table>thead>tr>td,.table-responsive>.allocation-list__table>thead>tr>th,.table-responsive>.contract-form-cancellation-rules__table>tbody>tr>td,.table-responsive>.contract-form-cancellation-rules__table>tbody>tr>th,.table-responsive>.contract-form-cancellation-rules__table>tfoot>tr>td,.table-responsive>.contract-form-cancellation-rules__table>tfoot>tr>th,.table-responsive>.contract-form-cancellation-rules__table>thead>tr>td,.table-responsive>.contract-form-cancellation-rules__table>thead>tr>th,.table-responsive>.contract-management-list__table>tbody>tr>td,.table-responsive>.contract-management-list__table>tbody>tr>th,.table-responsive>.contract-management-list__table>tfoot>tr>td,.table-responsive>.contract-management-list__table>tfoot>tr>th,.table-responsive>.contract-management-list__table>thead>tr>td,.table-responsive>.contract-management-list__table>thead>tr>th,.table-responsive>.dashboard-notifications__table>tbody>tr>td,.table-responsive>.dashboard-notifications__table>tbody>tr>th,.table-responsive>.dashboard-notifications__table>tfoot>tr>td,.table-responsive>.dashboard-notifications__table>tfoot>tr>th,.table-responsive>.dashboard-notifications__table>thead>tr>td,.table-responsive>.dashboard-notifications__table>thead>tr>th,.table-responsive>.manage-allocation-list__table>tbody>tr>td,.table-responsive>.manage-allocation-list__table>tbody>tr>th,.table-responsive>.manage-allocation-list__table>tfoot>tr>td,.table-responsive>.manage-allocation-list__table>tfoot>tr>th,.table-responsive>.manage-allocation-list__table>thead>tr>td,.table-responsive>.manage-allocation-list__table>thead>tr>th,.table-responsive>.manage-allocation-modal-list__table>tbody>tr>td,.table-responsive>.manage-allocation-modal-list__table>tbody>tr>th,.table-responsive>.manage-allocation-modal-list__table>tfoot>tr>td,.table-responsive>.manage-allocation-modal-list__table>tfoot>tr>th,.table-responsive>.manage-allocation-modal-list__table>thead>tr>td,.table-responsive>.manage-allocation-modal-list__table>thead>tr>th,.table-responsive>.manage-allocation-request__table>tbody>tr>td,.table-responsive>.manage-allocation-request__table>tbody>tr>th,.table-responsive>.manage-allocation-request__table>tfoot>tr>td,.table-responsive>.manage-allocation-request__table>tfoot>tr>th,.table-responsive>.manage-allocation-request__table>thead>tr>td,.table-responsive>.manage-allocation-request__table>thead>tr>th,.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:22px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;appearance:none}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{display:block;padding-top:7px;font-size:14px;line-height:1.6;color:#555}.activate-user-page__input,.forgot-password-page__input,.form-control,.input,.manage-allocation-form-row__dropdown,.manage-allocation-form-row__input,.manage-allocation-modal-form__dropdown,.manage-allocation-modal-form__input,.manage-allocation-request-form__dropdown,.manage-allocation-request-form__input,.reset-password-page__input,.sign-in-page__input{display:block;width:100%;height:36px;padding:6px 12px;font-size:14px;line-height:1.6;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:3px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.activate-user-page__input:focus,.forgot-password-page__input:focus,.form-control:focus,.input:focus,.manage-allocation-form-row__dropdown:focus,.manage-allocation-form-row__input:focus,.manage-allocation-modal-form__dropdown:focus,.manage-allocation-modal-form__input:focus,.manage-allocation-request-form__dropdown:focus,.manage-allocation-request-form__input:focus,.reset-password-page__input:focus,.sign-in-page__input:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.activate-user-page__input::-moz-placeholder,.forgot-password-page__input::-moz-placeholder,.form-control::-moz-placeholder,.input::-moz-placeholder,.manage-allocation-form-row__dropdown::-moz-placeholder,.manage-allocation-form-row__input::-moz-placeholder,.manage-allocation-modal-form__dropdown::-moz-placeholder,.manage-allocation-modal-form__input::-moz-placeholder,.manage-allocation-request-form__dropdown::-moz-placeholder,.manage-allocation-request-form__input::-moz-placeholder,.reset-password-page__input::-moz-placeholder,.sign-in-page__input::-moz-placeholder{color:#999;opacity:1}.activate-user-page__input:-ms-input-placeholder,.forgot-password-page__input:-ms-input-placeholder,.form-control:-ms-input-placeholder,.input:-ms-input-placeholder,.manage-allocation-form-row__dropdown:-ms-input-placeholder,.manage-allocation-form-row__input:-ms-input-placeholder,.manage-allocation-modal-form__dropdown:-ms-input-placeholder,.manage-allocation-modal-form__input:-ms-input-placeholder,.manage-allocation-request-form__dropdown:-ms-input-placeholder,.manage-allocation-request-form__input:-ms-input-placeholder,.reset-password-page__input:-ms-input-placeholder,.sign-in-page__input:-ms-input-placeholder{color:#999}.activate-user-page__input::-webkit-input-placeholder,.forgot-password-page__input::-webkit-input-placeholder,.form-control::-webkit-input-placeholder,.input::-webkit-input-placeholder,.manage-allocation-form-row__dropdown::-webkit-input-placeholder,.manage-allocation-form-row__input::-webkit-input-placeholder,.manage-allocation-modal-form__dropdown::-webkit-input-placeholder,.manage-allocation-modal-form__input::-webkit-input-placeholder,.manage-allocation-request-form__dropdown::-webkit-input-placeholder,.manage-allocation-request-form__input::-webkit-input-placeholder,.reset-password-page__input::-webkit-input-placeholder,.sign-in-page__input::-webkit-input-placeholder{color:#999}.activate-user-page__input::-ms-expand,.forgot-password-page__input::-ms-expand,.form-control::-ms-expand,.input::-ms-expand,.manage-allocation-form-row__dropdown::-ms-expand,.manage-allocation-form-row__input::-ms-expand,.manage-allocation-modal-form__dropdown::-ms-expand,.manage-allocation-modal-form__input::-ms-expand,.manage-allocation-request-form__dropdown::-ms-expand,.manage-allocation-request-form__input::-ms-expand,.reset-password-page__input::-ms-expand,.sign-in-page__input::-ms-expand{background-color:transparent;border:0}.activate-user-page__input[disabled],.activate-user-page__input[readonly],.forgot-password-page__input[disabled],.forgot-password-page__input[readonly],.form-control[disabled],.form-control[readonly],.input[disabled],.input[readonly],.manage-allocation-form-row__dropdown[disabled],.manage-allocation-form-row__dropdown[readonly],.manage-allocation-form-row__input[disabled],.manage-allocation-form-row__input[readonly],.manage-allocation-modal-form__dropdown[disabled],.manage-allocation-modal-form__dropdown[readonly],.manage-allocation-modal-form__input[disabled],.manage-allocation-modal-form__input[readonly],.manage-allocation-request-form__dropdown[disabled],.manage-allocation-request-form__dropdown[readonly],.manage-allocation-request-form__input[disabled],.manage-allocation-request-form__input[readonly],.reset-password-page__input[disabled],.reset-password-page__input[readonly],.sign-in-page__input[disabled],.sign-in-page__input[readonly],fieldset[disabled] .activate-user-page__input,fieldset[disabled] .forgot-password-page__input,fieldset[disabled] .form-control,fieldset[disabled] .input,fieldset[disabled] .manage-allocation-form-row__dropdown,fieldset[disabled] .manage-allocation-form-row__input,fieldset[disabled] .manage-allocation-modal-form__dropdown,fieldset[disabled] .manage-allocation-modal-form__input,fieldset[disabled] .manage-allocation-request-form__dropdown,fieldset[disabled] .manage-allocation-request-form__input,fieldset[disabled] .reset-password-page__input,fieldset[disabled] .sign-in-page__input{background-color:#eee;opacity:1}.activate-user-page__input[disabled],.forgot-password-page__input[disabled],.form-control[disabled],.input[disabled],.manage-allocation-form-row__dropdown[disabled],.manage-allocation-form-row__input[disabled],.manage-allocation-modal-form__dropdown[disabled],.manage-allocation-modal-form__input[disabled],.manage-allocation-request-form__dropdown[disabled],.manage-allocation-request-form__input[disabled],.reset-password-page__input[disabled],.sign-in-page__input[disabled],fieldset[disabled] .activate-user-page__input,fieldset[disabled] .forgot-password-page__input,fieldset[disabled] .form-control,fieldset[disabled] .input,fieldset[disabled] .manage-allocation-form-row__dropdown,fieldset[disabled] .manage-allocation-form-row__input,fieldset[disabled] .manage-allocation-modal-form__dropdown,fieldset[disabled] .manage-allocation-modal-form__input,fieldset[disabled] .manage-allocation-request-form__dropdown,fieldset[disabled] .manage-allocation-request-form__input,fieldset[disabled] .reset-password-page__input,fieldset[disabled] .sign-in-page__input{cursor:not-allowed}textarea.activate-user-page__input,textarea.forgot-password-page__input,textarea.form-control,textarea.input,textarea.manage-allocation-form-row__dropdown,textarea.manage-allocation-form-row__input,textarea.manage-allocation-modal-form__dropdown,textarea.manage-allocation-modal-form__input,textarea.manage-allocation-request-form__dropdown,textarea.manage-allocation-request-form__input,textarea.reset-password-page__input,textarea.sign-in-page__input{height:auto}@media screen and (-webkit-min-device-pixel-ratio:0){input.activate-user-page__input[type=date],input.activate-user-page__input[type=datetime-local],input.activate-user-page__input[type=month],input.activate-user-page__input[type=time],input.forgot-password-page__input[type=date],input.forgot-password-page__input[type=datetime-local],input.forgot-password-page__input[type=month],input.forgot-password-page__input[type=time],input.input[type=date],input.input[type=datetime-local],input.input[type=month],input.input[type=time],input.manage-allocation-form-row__dropdown[type=date],input.manage-allocation-form-row__dropdown[type=datetime-local],input.manage-allocation-form-row__dropdown[type=month],input.manage-allocation-form-row__dropdown[type=time],input.manage-allocation-form-row__input[type=date],input.manage-allocation-form-row__input[type=datetime-local],input.manage-allocation-form-row__input[type=month],input.manage-allocation-form-row__input[type=time],input.manage-allocation-modal-form__dropdown[type=date],input.manage-allocation-modal-form__dropdown[type=datetime-local],input.manage-allocation-modal-form__dropdown[type=month],input.manage-allocation-modal-form__dropdown[type=time],input.manage-allocation-modal-form__input[type=date],input.manage-allocation-modal-form__input[type=datetime-local],input.manage-allocation-modal-form__input[type=month],input.manage-allocation-modal-form__input[type=time],input.manage-allocation-request-form__dropdown[type=date],input.manage-allocation-request-form__dropdown[type=datetime-local],input.manage-allocation-request-form__dropdown[type=month],input.manage-allocation-request-form__dropdown[type=time],input.manage-allocation-request-form__input[type=date],input.manage-allocation-request-form__input[type=datetime-local],input.manage-allocation-request-form__input[type=month],input.manage-allocation-request-form__input[type=time],input.reset-password-page__input[type=date],input.reset-password-page__input[type=datetime-local],input.reset-password-page__input[type=month],input.reset-password-page__input[type=time],input.sign-in-page__input[type=date],input.sign-in-page__input[type=datetime-local],input.sign-in-page__input[type=month],input.sign-in-page__input[type=time],input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:36px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input.activate-user-page__input[type=date],input.activate-user-page__input[type=datetime-local],input.activate-user-page__input[type=month],input.activate-user-page__input[type=time],input.forgot-password-page__input[type=date],input.forgot-password-page__input[type=datetime-local],input.forgot-password-page__input[type=month],input.forgot-password-page__input[type=time],input.input--lg[type=date],input.input--lg[type=datetime-local],input.input--lg[type=month],input.input--lg[type=time],input.reset-password-page__input[type=date],input.reset-password-page__input[type=datetime-local],input.reset-password-page__input[type=month],input.reset-password-page__input[type=time],input.sign-in-page__input[type=date],input.sign-in-page__input[type=datetime-local],input.sign-in-page__input[type=month],input.sign-in-page__input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox.disabled label,.radio.disabled label,fieldset[disabled] .checkbox label,fieldset[disabled] .radio label{cursor:not-allowed}.checkbox label,.radio label{min-height:22px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline.disabled,.radio-inline.disabled,fieldset[disabled] .checkbox-inline,fieldset[disabled] .radio-inline{cursor:not-allowed}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.form-control-static{min-height:36px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.activate-user-page__input,.form-control-static.forgot-password-page__input,.form-control-static.input--lg,.form-control-static.input-lg,.form-control-static.input-sm,.form-control-static.reset-password-page__input,.form-control-static.sign-in-page__input{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .activate-user-page__input,.form-group-sm .forgot-password-page__input,.form-group-sm .form-control,.form-group-sm .input,.form-group-sm .manage-allocation-form-row__dropdown,.form-group-sm .manage-allocation-form-row__input,.form-group-sm .manage-allocation-modal-form__dropdown,.form-group-sm .manage-allocation-modal-form__input,.form-group-sm .manage-allocation-request-form__dropdown,.form-group-sm .manage-allocation-request-form__input,.form-group-sm .reset-password-page__input,.form-group-sm .sign-in-page__input{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.activate-user-page__input,.form-group-sm select.forgot-password-page__input,.form-group-sm select.form-control,.form-group-sm select.input,.form-group-sm select.manage-allocation-form-row__dropdown,.form-group-sm select.manage-allocation-form-row__input,.form-group-sm select.manage-allocation-modal-form__dropdown,.form-group-sm select.manage-allocation-modal-form__input,.form-group-sm select.manage-allocation-request-form__dropdown,.form-group-sm select.manage-allocation-request-form__input,.form-group-sm select.reset-password-page__input,.form-group-sm select.sign-in-page__input{height:30px;line-height:30px}.form-group-sm select.activate-user-page__input[multiple],.form-group-sm select.forgot-password-page__input[multiple],.form-group-sm select.input[multiple],.form-group-sm select.manage-allocation-form-row__dropdown[multiple],.form-group-sm select.manage-allocation-form-row__input[multiple],.form-group-sm select.manage-allocation-modal-form__dropdown[multiple],.form-group-sm select.manage-allocation-modal-form__input[multiple],.form-group-sm select.manage-allocation-request-form__dropdown[multiple],.form-group-sm select.manage-allocation-request-form__input[multiple],.form-group-sm select.reset-password-page__input[multiple],.form-group-sm select.sign-in-page__input[multiple],.form-group-sm select[multiple].form-control,.form-group-sm textarea.activate-user-page__input,.form-group-sm textarea.forgot-password-page__input,.form-group-sm textarea.form-control,.form-group-sm textarea.input,.form-group-sm textarea.manage-allocation-form-row__dropdown,.form-group-sm textarea.manage-allocation-form-row__input,.form-group-sm textarea.manage-allocation-modal-form__dropdown,.form-group-sm textarea.manage-allocation-modal-form__input,.form-group-sm textarea.manage-allocation-request-form__dropdown,.form-group-sm textarea.manage-allocation-request-form__input,.form-group-sm textarea.reset-password-page__input,.form-group-sm textarea.sign-in-page__input{height:auto}.form-group-sm .form-control-static{height:30px;min-height:34px;padding:6px 10px;font-size:12px;line-height:1.5}.activate-user-page__input,.forgot-password-page__input,.input--lg,.input-lg,.reset-password-page__input,.sign-in-page__input{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:3px}select.activate-user-page__input,select.forgot-password-page__input,select.input--lg,select.input-lg,select.reset-password-page__input,select.sign-in-page__input{height:46px;line-height:46px}select.activate-user-page__input[multiple],select.forgot-password-page__input[multiple],select.input--lg[multiple],select.reset-password-page__input[multiple],select.sign-in-page__input[multiple],select[multiple].input-lg,textarea.activate-user-page__input,textarea.forgot-password-page__input,textarea.input--lg,textarea.input-lg,textarea.reset-password-page__input,textarea.sign-in-page__input{height:auto}.form-group-lg .activate-user-page__input,.form-group-lg .forgot-password-page__input,.form-group-lg .form-control,.form-group-lg .input,.form-group-lg .manage-allocation-form-row__dropdown,.form-group-lg .manage-allocation-form-row__input,.form-group-lg .manage-allocation-modal-form__dropdown,.form-group-lg .manage-allocation-modal-form__input,.form-group-lg .manage-allocation-request-form__dropdown,.form-group-lg .manage-allocation-request-form__input,.form-group-lg .reset-password-page__input,.form-group-lg .sign-in-page__input{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:3px}.form-group-lg select.activate-user-page__input,.form-group-lg select.forgot-password-page__input,.form-group-lg select.form-control,.form-group-lg select.input,.form-group-lg select.manage-allocation-form-row__dropdown,.form-group-lg select.manage-allocation-form-row__input,.form-group-lg select.manage-allocation-modal-form__dropdown,.form-group-lg select.manage-allocation-modal-form__input,.form-group-lg select.manage-allocation-request-form__dropdown,.form-group-lg select.manage-allocation-request-form__input,.form-group-lg select.reset-password-page__input,.form-group-lg select.sign-in-page__input{height:46px;line-height:46px}.form-group-lg select.activate-user-page__input[multiple],.form-group-lg select.forgot-password-page__input[multiple],.form-group-lg select.input[multiple],.form-group-lg select.manage-allocation-form-row__dropdown[multiple],.form-group-lg select.manage-allocation-form-row__input[multiple],.form-group-lg select.manage-allocation-modal-form__dropdown[multiple],.form-group-lg select.manage-allocation-modal-form__input[multiple],.form-group-lg select.manage-allocation-request-form__dropdown[multiple],.form-group-lg select.manage-allocation-request-form__input[multiple],.form-group-lg select.reset-password-page__input[multiple],.form-group-lg select.sign-in-page__input[multiple],.form-group-lg select[multiple].form-control,.form-group-lg textarea.activate-user-page__input,.form-group-lg textarea.forgot-password-page__input,.form-group-lg textarea.form-control,.form-group-lg textarea.input,.form-group-lg textarea.manage-allocation-form-row__dropdown,.form-group-lg textarea.manage-allocation-form-row__input,.form-group-lg textarea.manage-allocation-modal-form__dropdown,.form-group-lg textarea.manage-allocation-modal-form__input,.form-group-lg textarea.manage-allocation-request-form__dropdown,.form-group-lg textarea.manage-allocation-request-form__input,.form-group-lg textarea.reset-password-page__input,.form-group-lg textarea.sign-in-page__input{height:auto}.form-group-lg .form-control-static{height:46px;min-height:40px;padding:11px 16px;font-size:18px;line-height:1.33333}.has-feedback{position:relative}.has-feedback .activate-user-page__input,.has-feedback .forgot-password-page__input,.has-feedback .form-control,.has-feedback .input,.has-feedback .manage-allocation-form-row__dropdown,.has-feedback .manage-allocation-form-row__input,.has-feedback .manage-allocation-modal-form__dropdown,.has-feedback .manage-allocation-modal-form__input,.has-feedback .manage-allocation-request-form__dropdown,.has-feedback .manage-allocation-request-form__input,.has-feedback .reset-password-page__input,.has-feedback .sign-in-page__input{padding-right:45px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:36px;height:36px;line-height:36px;text-align:center;pointer-events:none}.activate-user-page__input+.form-control-feedback,.forgot-password-page__input+.form-control-feedback,.form-group-lg .activate-user-page__input+.form-control-feedback,.form-group-lg .forgot-password-page__input+.form-control-feedback,.form-group-lg .form-control+.form-control-feedback,.form-group-lg .input+.form-control-feedback,.form-group-lg .manage-allocation-form-row__dropdown+.form-control-feedback,.form-group-lg .manage-allocation-form-row__input+.form-control-feedback,.form-group-lg .manage-allocation-modal-form__dropdown+.form-control-feedback,.form-group-lg .manage-allocation-modal-form__input+.form-control-feedback,.form-group-lg .manage-allocation-request-form__dropdown+.form-control-feedback,.form-group-lg .manage-allocation-request-form__input+.form-control-feedback,.form-group-lg .reset-password-page__input+.form-control-feedback,.form-group-lg .sign-in-page__input+.form-control-feedback,.input--lg+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback,.reset-password-page__input+.form-control-feedback,.sign-in-page__input+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .activate-user-page__input+.form-control-feedback,.form-group-sm .forgot-password-page__input+.form-control-feedback,.form-group-sm .form-control+.form-control-feedback,.form-group-sm .input+.form-control-feedback,.form-group-sm .manage-allocation-form-row__dropdown+.form-control-feedback,.form-group-sm .manage-allocation-form-row__input+.form-control-feedback,.form-group-sm .manage-allocation-modal-form__dropdown+.form-control-feedback,.form-group-sm .manage-allocation-modal-form__input+.form-control-feedback,.form-group-sm .manage-allocation-request-form__dropdown+.form-control-feedback,.form-group-sm .manage-allocation-request-form__input+.form-control-feedback,.form-group-sm .reset-password-page__input+.form-control-feedback,.form-group-sm .sign-in-page__input+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .activate-user-page__input,.has-success .forgot-password-page__input,.has-success .form-control,.has-success .input,.has-success .manage-allocation-form-row__dropdown,.has-success .manage-allocation-form-row__input,.has-success .manage-allocation-modal-form__dropdown,.has-success .manage-allocation-modal-form__input,.has-success .manage-allocation-request-form__dropdown,.has-success .manage-allocation-request-form__input,.has-success .reset-password-page__input,.has-success .sign-in-page__input{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .activate-user-page__input:focus,.has-success .forgot-password-page__input:focus,.has-success .form-control:focus,.has-success .input:focus,.has-success .manage-allocation-form-row__dropdown:focus,.has-success .manage-allocation-form-row__input:focus,.has-success .manage-allocation-modal-form__dropdown:focus,.has-success .manage-allocation-modal-form__input:focus,.has-success .manage-allocation-request-form__dropdown:focus,.has-success .manage-allocation-request-form__input:focus,.has-success .reset-password-page__input:focus,.has-success .sign-in-page__input:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .activate-user-page__input,.has-warning .forgot-password-page__input,.has-warning .form-control,.has-warning .input,.has-warning .manage-allocation-form-row__dropdown,.has-warning .manage-allocation-form-row__input,.has-warning .manage-allocation-modal-form__dropdown,.has-warning .manage-allocation-modal-form__input,.has-warning .manage-allocation-request-form__dropdown,.has-warning .manage-allocation-request-form__input,.has-warning .reset-password-page__input,.has-warning .sign-in-page__input{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .activate-user-page__input:focus,.has-warning .forgot-password-page__input:focus,.has-warning .form-control:focus,.has-warning .input:focus,.has-warning .manage-allocation-form-row__dropdown:focus,.has-warning .manage-allocation-form-row__input:focus,.has-warning .manage-allocation-modal-form__dropdown:focus,.has-warning .manage-allocation-modal-form__input:focus,.has-warning .manage-allocation-request-form__dropdown:focus,.has-warning .manage-allocation-request-form__input:focus,.has-warning .reset-password-page__input:focus,.has-warning .sign-in-page__input:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .activate-user-page__input,.has-error .forgot-password-page__input,.has-error .form-control,.has-error .input,.has-error .manage-allocation-form-row__dropdown,.has-error .manage-allocation-form-row__input,.has-error .manage-allocation-modal-form__dropdown,.has-error .manage-allocation-modal-form__input,.has-error .manage-allocation-request-form__dropdown,.has-error .manage-allocation-request-form__input,.has-error .reset-password-page__input,.has-error .sign-in-page__input{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .activate-user-page__input:focus,.has-error .forgot-password-page__input:focus,.has-error .form-control:focus,.has-error .input:focus,.has-error .manage-allocation-form-row__dropdown:focus,.has-error .manage-allocation-form-row__input:focus,.has-error .manage-allocation-modal-form__dropdown:focus,.has-error .manage-allocation-modal-form__input:focus,.has-error .manage-allocation-request-form__dropdown:focus,.has-error .manage-allocation-request-form__input:focus,.has-error .reset-password-page__input:focus,.has-error .sign-in-page__input:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:27px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#bebfc1}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .activate-user-page__input,.form-inline .forgot-password-page__input,.form-inline .form-control,.form-inline .input,.form-inline .manage-allocation-form-row__dropdown,.form-inline .manage-allocation-form-row__input,.form-inline .manage-allocation-modal-form__dropdown,.form-inline .manage-allocation-modal-form__input,.form-inline .manage-allocation-request-form__dropdown,.form-inline .manage-allocation-request-form__input,.form-inline .reset-password-page__input,.form-inline .sign-in-page__input{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .activate-user-page__input,.form-inline .input-group .forgot-password-page__input,.form-inline .input-group .form-control,.form-inline .input-group .input,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn,.form-inline .input-group .manage-allocation-form-row__dropdown,.form-inline .input-group .manage-allocation-form-row__input,.form-inline .input-group .manage-allocation-modal-form__dropdown,.form-inline .input-group .manage-allocation-modal-form__input,.form-inline .input-group .manage-allocation-request-form__dropdown,.form-inline .input-group .manage-allocation-request-form__input,.form-inline .input-group .reset-password-page__input,.form-inline .input-group .sign-in-page__input{width:auto}.form-inline .input-group>.activate-user-page__input,.form-inline .input-group>.forgot-password-page__input,.form-inline .input-group>.form-control,.form-inline .input-group>.input,.form-inline .input-group>.manage-allocation-form-row__dropdown,.form-inline .input-group>.manage-allocation-form-row__input,.form-inline .input-group>.manage-allocation-modal-form__dropdown,.form-inline .input-group>.manage-allocation-modal-form__input,.form-inline .input-group>.manage-allocation-request-form__dropdown,.form-inline .input-group>.manage-allocation-request-form__input,.form-inline .input-group>.reset-password-page__input,.form-inline .input-group>.sign-in-page__input{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:29px}.form-horizontal .form-group{margin-right:-8px;margin-left:-7px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{display:table;content:\" \"}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:7px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.container{padding-right:8px;padding-left:7px;margin-right:auto;margin-left:auto}.container:after,.container:before{display:table;content:\" \"}.container:after{clear:both}@media (min-width:768px){.container{width:735px}}@media (min-width:992px){.container{width:955px}}@media (min-width:1200px){.container{width:1155px}}.container-fluid{padding-right:8px;padding-left:7px;margin-right:auto;margin-left:auto}.container-fluid:after,.container-fluid:before{display:table;content:\" \"}.container-fluid:after{clear:both}.row{margin-right:-8px;margin-left:-7px}.row:after,.row:before{display:table;content:\" \"}.row:after{clear:both}.row-no-gutters{margin-right:0;margin-left:0}.row-no-gutters [class*=col-]{padding-right:0;padding-left:0}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:7px;padding-left:8px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.33333%}.col-xs-2{width:16.66667%}.col-xs-3{width:25%}.col-xs-4{width:33.33333%}.col-xs-5{width:41.66667%}.col-xs-6{width:50%}.col-xs-7{width:58.33333%}.col-xs-8{width:66.66667%}.col-xs-9{width:75%}.col-xs-10{width:83.33333%}.col-xs-11{width:91.66667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.33333%}.col-xs-pull-2{right:16.66667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.33333%}.col-xs-pull-5{right:41.66667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.33333%}.col-xs-pull-8{right:66.66667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.33333%}.col-xs-pull-11{right:91.66667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.33333%}.col-xs-push-2{left:16.66667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.33333%}.col-xs-push-5{left:41.66667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.33333%}.col-xs-push-8{left:66.66667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.33333%}.col-xs-push-11{left:91.66667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.33333%}.col-xs-offset-2{margin-left:16.66667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.33333%}.col-xs-offset-5{margin-left:41.66667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.33333%}.col-xs-offset-8{margin-left:66.66667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.33333%}.col-xs-offset-11{margin-left:91.66667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.33333%}.col-sm-2{width:16.66667%}.col-sm-3{width:25%}.col-sm-4{width:33.33333%}.col-sm-5{width:41.66667%}.col-sm-6{width:50%}.col-sm-7{width:58.33333%}.col-sm-8{width:66.66667%}.col-sm-9{width:75%}.col-sm-10{width:83.33333%}.col-sm-11{width:91.66667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.33333%}.col-sm-pull-2{right:16.66667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.33333%}.col-sm-pull-5{right:41.66667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.33333%}.col-sm-pull-8{right:66.66667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.33333%}.col-sm-pull-11{right:91.66667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.33333%}.col-sm-push-2{left:16.66667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.33333%}.col-sm-push-5{left:41.66667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.33333%}.col-sm-push-8{left:66.66667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.33333%}.col-sm-push-11{left:91.66667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.33333%}.col-sm-offset-2{margin-left:16.66667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333%}.col-sm-offset-5{margin-left:41.66667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.33333%}.col-sm-offset-8{margin-left:66.66667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333%}.col-sm-offset-11{margin-left:91.66667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.33333%}.col-md-2{width:16.66667%}.col-md-3{width:25%}.col-md-4{width:33.33333%}.col-md-5{width:41.66667%}.col-md-6{width:50%}.col-md-7{width:58.33333%}.col-md-8{width:66.66667%}.col-md-9{width:75%}.col-md-10{width:83.33333%}.col-md-11{width:91.66667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.33333%}.col-md-pull-2{right:16.66667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.33333%}.col-md-pull-5{right:41.66667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.33333%}.col-md-pull-8{right:66.66667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.33333%}.col-md-pull-11{right:91.66667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.33333%}.col-md-push-2{left:16.66667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.33333%}.col-md-push-5{left:41.66667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.33333%}.col-md-push-8{left:66.66667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.33333%}.col-md-push-11{left:91.66667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.33333%}.col-md-offset-2{margin-left:16.66667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333%}.col-md-offset-5{margin-left:41.66667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.33333%}.col-md-offset-8{margin-left:66.66667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333%}.col-md-offset-11{margin-left:91.66667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.33333%}.col-lg-2{width:16.66667%}.col-lg-3{width:25%}.col-lg-4{width:33.33333%}.col-lg-5{width:41.66667%}.col-lg-6{width:50%}.col-lg-7{width:58.33333%}.col-lg-8{width:66.66667%}.col-lg-9{width:75%}.col-lg-10{width:83.33333%}.col-lg-11{width:91.66667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.33333%}.col-lg-pull-2{right:16.66667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.33333%}.col-lg-pull-5{right:41.66667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.33333%}.col-lg-pull-8{right:66.66667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.33333%}.col-lg-pull-11{right:91.66667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.33333%}.col-lg-push-2{left:16.66667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.33333%}.col-lg-push-5{left:41.66667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.33333%}.col-lg-push-8{left:66.66667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.33333%}.col-lg-push-11{left:91.66667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.33333%}.col-lg-offset-2{margin-left:16.66667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.33333%}.col-lg-offset-5{margin-left:41.66667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.33333%}.col-lg-offset-8{margin-left:66.66667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333%}.col-lg-offset-11{margin-left:91.66667%}.col-lg-offset-12{margin-left:100%}}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}33%{-webkit-transform:rotate(-25deg);-moz-transform:rotate(-25deg);-o-transform:rotate(-25deg);transform:rotate(-25deg)}66%{-webkit-transform:rotate(25deg);-moz-transform:rotate(25deg);-o-transform:rotate(25deg);transform:rotate(25deg)}to{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}}@-moz-keyframes spin{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}33%{-webkit-transform:rotate(-25deg);-moz-transform:rotate(-25deg);-o-transform:rotate(-25deg);transform:rotate(-25deg)}66%{-webkit-transform:rotate(25deg);-moz-transform:rotate(25deg);-o-transform:rotate(25deg);transform:rotate(25deg)}to{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}}@-o-keyframes spin{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}33%{-webkit-transform:rotate(-25deg);-moz-transform:rotate(-25deg);-o-transform:rotate(-25deg);transform:rotate(-25deg)}66%{-webkit-transform:rotate(25deg);-moz-transform:rotate(25deg);-o-transform:rotate(25deg);transform:rotate(25deg)}to{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}33%{-webkit-transform:rotate(-25deg);-moz-transform:rotate(-25deg);-o-transform:rotate(-25deg);transform:rotate(-25deg)}66%{-webkit-transform:rotate(25deg);-moz-transform:rotate(25deg);-o-transform:rotate(25deg);transform:rotate(25deg)}to{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}}@-webkit-keyframes maximize{0%{-webkit-transform:scale(.8);-moz-transform:scale(.8);-o-transform:scale(.8);transform:scale(.8)}33%{-webkit-transform:scale(.9);-moz-transform:scale(.9);-o-transform:scale(.9);transform:scale(.9)}66%{-webkit-transform:scale(.97);-moz-transform:scale(.97);-o-transform:scale(.97);transform:scale(.97)}to{-webkit-transform:scale(1);-moz-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}@-moz-keyframes maximize{0%{-webkit-transform:scale(.8);-moz-transform:scale(.8);-o-transform:scale(.8);transform:scale(.8)}33%{-webkit-transform:scale(.9);-moz-transform:scale(.9);-o-transform:scale(.9);transform:scale(.9)}66%{-webkit-transform:scale(.97);-moz-transform:scale(.97);-o-transform:scale(.97);transform:scale(.97)}to{-webkit-transform:scale(1);-moz-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}@-o-keyframes maximize{0%{-webkit-transform:scale(.8);-moz-transform:scale(.8);-o-transform:scale(.8);transform:scale(.8)}33%{-webkit-transform:scale(.9);-moz-transform:scale(.9);-o-transform:scale(.9);transform:scale(.9)}66%{-webkit-transform:scale(.97);-moz-transform:scale(.97);-o-transform:scale(.97);transform:scale(.97)}to{-webkit-transform:scale(1);-moz-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}@keyframes maximize{0%{-webkit-transform:scale(.8);-moz-transform:scale(.8);-o-transform:scale(.8);transform:scale(.8)}33%{-webkit-transform:scale(.9);-moz-transform:scale(.9);-o-transform:scale(.9);transform:scale(.9)}66%{-webkit-transform:scale(.97);-moz-transform:scale(.97);-o-transform:scale(.97);transform:scale(.97)}to{-webkit-transform:scale(1);-moz-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}.activate-user-page__submit,.admin-create-modal-form__btn-update,.admin-create-modal__add-btn,.admin-edit-modal-form-accept__submit,.admin-edit-modal-form__btn-update,.admin-edit-modal__add-btn,.button__primary,.contract-draft-preview__button,.contract-form-email__btn,.contract-management-edit-control__btn,.contract-management-edit-email__btn,.contract-management-edit-form__btn,.forgot-password-page__submit,.manage-allocation-form-accept__submit,.manage-allocation-form__submit,.manage-allocation-modal-form__submit,.manage-allocation-modal-list__btn-new,.manage-allocation-modal__add-btn,.reset-password-page__submit,.sign-in-page__submit{padding:5px 30px;font-size:14px;line-height:1.6;border-radius:3px;color:#f3f3f4;background-color:#64c1c7;border-color:#64c1c7;cursor:pointer;border:1px solid;transition:.2s ease;transition-property:background-color,border-color;font-weight:700;text-decoration:none!important;border:1px solid #42afb6}.activate-user-page__submit:focus,.admin-create-modal-form__btn-update:focus,.admin-create-modal__add-btn:focus,.admin-edit-modal-form-accept__submit:focus,.admin-edit-modal-form__btn-update:focus,.admin-edit-modal__add-btn:focus,.button__primary.focus,.button__primary:focus,.contract-draft-preview__button:focus,.contract-form-email__btn:focus,.contract-management-edit-control__btn:focus,.contract-management-edit-email__btn:focus,.contract-management-edit-form__btn:focus,.focus.activate-user-page__submit,.focus.admin-create-modal-form__btn-update,.focus.admin-create-modal__add-btn,.focus.admin-edit-modal-form-accept__submit,.focus.admin-edit-modal-form__btn-update,.focus.admin-edit-modal__add-btn,.focus.contract-draft-preview__button,.focus.contract-form-email__btn,.focus.contract-management-edit-control__btn,.focus.contract-management-edit-email__btn,.focus.contract-management-edit-form__btn,.focus.forgot-password-page__submit,.focus.manage-allocation-form-accept__submit,.focus.manage-allocation-form__submit,.focus.manage-allocation-modal-form__submit,.focus.manage-allocation-modal-list__btn-new,.focus.manage-allocation-modal__add-btn,.focus.reset-password-page__submit,.focus.sign-in-page__submit,.forgot-password-page__submit:focus,.manage-allocation-form-accept__submit:focus,.manage-allocation-form__submit:focus,.manage-allocation-modal-form__submit:focus,.manage-allocation-modal-list__btn-new:focus,.manage-allocation-modal__add-btn:focus,.reset-password-page__submit:focus,.sign-in-page__submit:focus{color:#f3f3f4;background-color:#42afb6;border-color:#2e797e}.activate-user-page__submit:hover,.admin-create-modal-form__btn-update:hover,.admin-create-modal__add-btn:hover,.admin-edit-modal-form-accept__submit:hover,.admin-edit-modal-form__btn-update:hover,.admin-edit-modal__add-btn:hover,.button__primary:hover,.contract-draft-preview__button:hover,.contract-form-email__btn:hover,.contract-management-edit-control__btn:hover,.contract-management-edit-email__btn:hover,.contract-management-edit-form__btn:hover,.forgot-password-page__submit:hover,.manage-allocation-form-accept__submit:hover,.manage-allocation-form__submit:hover,.manage-allocation-modal-form__submit:hover,.manage-allocation-modal-list__btn-new:hover,.manage-allocation-modal__add-btn:hover,.reset-password-page__submit:hover,.sign-in-page__submit:hover{color:#f3f3f4;background-color:#42afb6;border-color:#3fa8af}.activate-user-page__submit:active,.active.activate-user-page__submit,.active.admin-create-modal-form__btn-update,.active.admin-create-modal__add-btn,.active.admin-edit-modal-form-accept__submit,.active.admin-edit-modal-form__btn-update,.active.admin-edit-modal__add-btn,.active.contract-draft-preview__button,.active.contract-form-email__btn,.active.contract-management-edit-control__btn,.active.contract-management-edit-email__btn,.active.contract-management-edit-form__btn,.active.forgot-password-page__submit,.active.manage-allocation-form-accept__submit,.active.manage-allocation-form__submit,.active.manage-allocation-modal-form__submit,.active.manage-allocation-modal-list__btn-new,.active.manage-allocation-modal__add-btn,.active.reset-password-page__submit,.active.sign-in-page__submit,.admin-create-modal-form__btn-update:active,.admin-create-modal__add-btn:active,.admin-edit-modal-form-accept__submit:active,.admin-edit-modal-form__btn-update:active,.admin-edit-modal__add-btn:active,.button__primary.active,.button__primary:active,.contract-draft-preview__button:active,.contract-form-email__btn:active,.contract-management-edit-control__btn:active,.contract-management-edit-email__btn:active,.contract-management-edit-form__btn:active,.forgot-password-page__submit:active,.manage-allocation-form-accept__submit:active,.manage-allocation-form__submit:active,.manage-allocation-modal-form__submit:active,.manage-allocation-modal-list__btn-new:active,.manage-allocation-modal__add-btn:active,.open>.button__primary.dropdown-toggle,.open>.dropdown-toggle.activate-user-page__submit,.open>.dropdown-toggle.admin-create-modal-form__btn-update,.open>.dropdown-toggle.admin-create-modal__add-btn,.open>.dropdown-toggle.admin-edit-modal-form-accept__submit,.open>.dropdown-toggle.admin-edit-modal-form__btn-update,.open>.dropdown-toggle.admin-edit-modal__add-btn,.open>.dropdown-toggle.contract-draft-preview__button,.open>.dropdown-toggle.contract-form-email__btn,.open>.dropdown-toggle.contract-management-edit-control__btn,.open>.dropdown-toggle.contract-management-edit-email__btn,.open>.dropdown-toggle.contract-management-edit-form__btn,.open>.dropdown-toggle.forgot-password-page__submit,.open>.dropdown-toggle.manage-allocation-form-accept__submit,.open>.dropdown-toggle.manage-allocation-form__submit,.open>.dropdown-toggle.manage-allocation-modal-form__submit,.open>.dropdown-toggle.manage-allocation-modal-list__btn-new,.open>.dropdown-toggle.manage-allocation-modal__add-btn,.open>.dropdown-toggle.reset-password-page__submit,.open>.dropdown-toggle.sign-in-page__submit,.reset-password-page__submit:active,.sign-in-page__submit:active{color:#f3f3f4;background-color:#42afb6;background-image:none;border-color:#3fa8af}.activate-user-page__submit:active.focus,.activate-user-page__submit:active:focus,.activate-user-page__submit:active:hover,.active.activate-user-page__submit:focus,.active.activate-user-page__submit:hover,.active.admin-create-modal-form__btn-update:focus,.active.admin-create-modal-form__btn-update:hover,.active.admin-create-modal__add-btn:focus,.active.admin-create-modal__add-btn:hover,.active.admin-edit-modal-form-accept__submit:focus,.active.admin-edit-modal-form-accept__submit:hover,.active.admin-edit-modal-form__btn-update:focus,.active.admin-edit-modal-form__btn-update:hover,.active.admin-edit-modal__add-btn:focus,.active.admin-edit-modal__add-btn:hover,.active.contract-draft-preview__button:focus,.active.contract-draft-preview__button:hover,.active.contract-form-email__btn:focus,.active.contract-form-email__btn:hover,.active.contract-management-edit-control__btn:focus,.active.contract-management-edit-control__btn:hover,.active.contract-management-edit-email__btn:focus,.active.contract-management-edit-email__btn:hover,.active.contract-management-edit-form__btn:focus,.active.contract-management-edit-form__btn:hover,.active.focus.activate-user-page__submit,.active.focus.admin-create-modal-form__btn-update,.active.focus.admin-create-modal__add-btn,.active.focus.admin-edit-modal-form-accept__submit,.active.focus.admin-edit-modal-form__btn-update,.active.focus.admin-edit-modal__add-btn,.active.focus.contract-draft-preview__button,.active.focus.contract-form-email__btn,.active.focus.contract-management-edit-control__btn,.active.focus.contract-management-edit-email__btn,.active.focus.contract-management-edit-form__btn,.active.focus.forgot-password-page__submit,.active.focus.manage-allocation-form-accept__submit,.active.focus.manage-allocation-form__submit,.active.focus.manage-allocation-modal-form__submit,.active.focus.manage-allocation-modal-list__btn-new,.active.focus.manage-allocation-modal__add-btn,.active.focus.reset-password-page__submit,.active.focus.sign-in-page__submit,.active.forgot-password-page__submit:focus,.active.forgot-password-page__submit:hover,.active.manage-allocation-form-accept__submit:focus,.active.manage-allocation-form-accept__submit:hover,.active.manage-allocation-form__submit:focus,.active.manage-allocation-form__submit:hover,.active.manage-allocation-modal-form__submit:focus,.active.manage-allocation-modal-form__submit:hover,.active.manage-allocation-modal-list__btn-new:focus,.active.manage-allocation-modal-list__btn-new:hover,.active.manage-allocation-modal__add-btn:focus,.active.manage-allocation-modal__add-btn:hover,.active.reset-password-page__submit:focus,.active.reset-password-page__submit:hover,.active.sign-in-page__submit:focus,.active.sign-in-page__submit:hover,.admin-create-modal-form__btn-update:active.focus,.admin-create-modal-form__btn-update:active:focus,.admin-create-modal-form__btn-update:active:hover,.admin-create-modal__add-btn:active.focus,.admin-create-modal__add-btn:active:focus,.admin-create-modal__add-btn:active:hover,.admin-edit-modal-form-accept__submit:active.focus,.admin-edit-modal-form-accept__submit:active:focus,.admin-edit-modal-form-accept__submit:active:hover,.admin-edit-modal-form__btn-update:active.focus,.admin-edit-modal-form__btn-update:active:focus,.admin-edit-modal-form__btn-update:active:hover,.admin-edit-modal__add-btn:active.focus,.admin-edit-modal__add-btn:active:focus,.admin-edit-modal__add-btn:active:hover,.button__primary.active.focus,.button__primary.active:focus,.button__primary.active:hover,.button__primary:active.focus,.button__primary:active:focus,.button__primary:active:hover,.contract-draft-preview__button:active.focus,.contract-draft-preview__button:active:focus,.contract-draft-preview__button:active:hover,.contract-form-email__btn:active.focus,.contract-form-email__btn:active:focus,.contract-form-email__btn:active:hover,.contract-management-edit-control__btn:active.focus,.contract-management-edit-control__btn:active:focus,.contract-management-edit-control__btn:active:hover,.contract-management-edit-email__btn:active.focus,.contract-management-edit-email__btn:active:focus,.contract-management-edit-email__btn:active:hover,.contract-management-edit-form__btn:active.focus,.contract-management-edit-form__btn:active:focus,.contract-management-edit-form__btn:active:hover,.forgot-password-page__submit:active.focus,.forgot-password-page__submit:active:focus,.forgot-password-page__submit:active:hover,.manage-allocation-form-accept__submit:active.focus,.manage-allocation-form-accept__submit:active:focus,.manage-allocation-form-accept__submit:active:hover,.manage-allocation-form__submit:active.focus,.manage-allocation-form__submit:active:focus,.manage-allocation-form__submit:active:hover,.manage-allocation-modal-form__submit:active.focus,.manage-allocation-modal-form__submit:active:focus,.manage-allocation-modal-form__submit:active:hover,.manage-allocation-modal-list__btn-new:active.focus,.manage-allocation-modal-list__btn-new:active:focus,.manage-allocation-modal-list__btn-new:active:hover,.manage-allocation-modal__add-btn:active.focus,.manage-allocation-modal__add-btn:active:focus,.manage-allocation-modal__add-btn:active:hover,.open>.button__primary.dropdown-toggle.focus,.open>.button__primary.dropdown-toggle:focus,.open>.button__primary.dropdown-toggle:hover,.open>.dropdown-toggle.activate-user-page__submit:focus,.open>.dropdown-toggle.activate-user-page__submit:hover,.open>.dropdown-toggle.admin-create-modal-form__btn-update:focus,.open>.dropdown-toggle.admin-create-modal-form__btn-update:hover,.open>.dropdown-toggle.admin-create-modal__add-btn:focus,.open>.dropdown-toggle.admin-create-modal__add-btn:hover,.open>.dropdown-toggle.admin-edit-modal-form-accept__submit:focus,.open>.dropdown-toggle.admin-edit-modal-form-accept__submit:hover,.open>.dropdown-toggle.admin-edit-modal-form__btn-update:focus,.open>.dropdown-toggle.admin-edit-modal-form__btn-update:hover,.open>.dropdown-toggle.admin-edit-modal__add-btn:focus,.open>.dropdown-toggle.admin-edit-modal__add-btn:hover,.open>.dropdown-toggle.contract-draft-preview__button:focus,.open>.dropdown-toggle.contract-draft-preview__button:hover,.open>.dropdown-toggle.contract-form-email__btn:focus,.open>.dropdown-toggle.contract-form-email__btn:hover,.open>.dropdown-toggle.contract-management-edit-control__btn:focus,.open>.dropdown-toggle.contract-management-edit-control__btn:hover,.open>.dropdown-toggle.contract-management-edit-email__btn:focus,.open>.dropdown-toggle.contract-management-edit-email__btn:hover,.open>.dropdown-toggle.contract-management-edit-form__btn:focus,.open>.dropdown-toggle.contract-management-edit-form__btn:hover,.open>.dropdown-toggle.focus.activate-user-page__submit,.open>.dropdown-toggle.focus.admin-create-modal-form__btn-update,.open>.dropdown-toggle.focus.admin-create-modal__add-btn,.open>.dropdown-toggle.focus.admin-edit-modal-form-accept__submit,.open>.dropdown-toggle.focus.admin-edit-modal-form__btn-update,.open>.dropdown-toggle.focus.admin-edit-modal__add-btn,.open>.dropdown-toggle.focus.contract-draft-preview__button,.open>.dropdown-toggle.focus.contract-form-email__btn,.open>.dropdown-toggle.focus.contract-management-edit-control__btn,.open>.dropdown-toggle.focus.contract-management-edit-email__btn,.open>.dropdown-toggle.focus.contract-management-edit-form__btn,.open>.dropdown-toggle.focus.forgot-password-page__submit,.open>.dropdown-toggle.focus.manage-allocation-form-accept__submit,.open>.dropdown-toggle.focus.manage-allocation-form__submit,.open>.dropdown-toggle.focus.manage-allocation-modal-form__submit,.open>.dropdown-toggle.focus.manage-allocation-modal-list__btn-new,.open>.dropdown-toggle.focus.manage-allocation-modal__add-btn,.open>.dropdown-toggle.focus.reset-password-page__submit,.open>.dropdown-toggle.focus.sign-in-page__submit,.open>.dropdown-toggle.forgot-password-page__submit:focus,.open>.dropdown-toggle.forgot-password-page__submit:hover,.open>.dropdown-toggle.manage-allocation-form-accept__submit:focus,.open>.dropdown-toggle.manage-allocation-form-accept__submit:hover,.open>.dropdown-toggle.manage-allocation-form__submit:focus,.open>.dropdown-toggle.manage-allocation-form__submit:hover,.open>.dropdown-toggle.manage-allocation-modal-form__submit:focus,.open>.dropdown-toggle.manage-allocation-modal-form__submit:hover,.open>.dropdown-toggle.manage-allocation-modal-list__btn-new:focus,.open>.dropdown-toggle.manage-allocation-modal-list__btn-new:hover,.open>.dropdown-toggle.manage-allocation-modal__add-btn:focus,.open>.dropdown-toggle.manage-allocation-modal__add-btn:hover,.open>.dropdown-toggle.reset-password-page__submit:focus,.open>.dropdown-toggle.reset-password-page__submit:hover,.open>.dropdown-toggle.sign-in-page__submit:focus,.open>.dropdown-toggle.sign-in-page__submit:hover,.reset-password-page__submit:active.focus,.reset-password-page__submit:active:focus,.reset-password-page__submit:active:hover,.sign-in-page__submit:active.focus,.sign-in-page__submit:active:focus,.sign-in-page__submit:active:hover{color:#f3f3f4;background-color:#38969c;border-color:#2e797e}.activate-user-page__submit[disabled].focus,.activate-user-page__submit[disabled]:focus,.activate-user-page__submit[disabled]:hover,.admin-create-modal-form__btn-update[disabled].focus,.admin-create-modal-form__btn-update[disabled]:focus,.admin-create-modal-form__btn-update[disabled]:hover,.admin-create-modal__add-btn[disabled].focus,.admin-create-modal__add-btn[disabled]:focus,.admin-create-modal__add-btn[disabled]:hover,.admin-edit-modal-form-accept__submit[disabled].focus,.admin-edit-modal-form-accept__submit[disabled]:focus,.admin-edit-modal-form-accept__submit[disabled]:hover,.admin-edit-modal-form__btn-update[disabled].focus,.admin-edit-modal-form__btn-update[disabled]:focus,.admin-edit-modal-form__btn-update[disabled]:hover,.admin-edit-modal__add-btn[disabled].focus,.admin-edit-modal__add-btn[disabled]:focus,.admin-edit-modal__add-btn[disabled]:hover,.button__primary.disabled.focus,.button__primary.disabled:focus,.button__primary.disabled:hover,.button__primary[disabled].focus,.button__primary[disabled]:focus,.button__primary[disabled]:hover,.contract-draft-preview__button[disabled].focus,.contract-draft-preview__button[disabled]:focus,.contract-draft-preview__button[disabled]:hover,.contract-form-email__btn[disabled].focus,.contract-form-email__btn[disabled]:focus,.contract-form-email__btn[disabled]:hover,.contract-management-edit-control__btn[disabled].focus,.contract-management-edit-control__btn[disabled]:focus,.contract-management-edit-control__btn[disabled]:hover,.contract-management-edit-email__btn[disabled].focus,.contract-management-edit-email__btn[disabled]:focus,.contract-management-edit-email__btn[disabled]:hover,.contract-management-edit-form__btn[disabled].focus,.contract-management-edit-form__btn[disabled]:focus,.contract-management-edit-form__btn[disabled]:hover,.disabled.activate-user-page__submit:focus,.disabled.activate-user-page__submit:hover,.disabled.admin-create-modal-form__btn-update:focus,.disabled.admin-create-modal-form__btn-update:hover,.disabled.admin-create-modal__add-btn:focus,.disabled.admin-create-modal__add-btn:hover,.disabled.admin-edit-modal-form-accept__submit:focus,.disabled.admin-edit-modal-form-accept__submit:hover,.disabled.admin-edit-modal-form__btn-update:focus,.disabled.admin-edit-modal-form__btn-update:hover,.disabled.admin-edit-modal__add-btn:focus,.disabled.admin-edit-modal__add-btn:hover,.disabled.contract-draft-preview__button:focus,.disabled.contract-draft-preview__button:hover,.disabled.contract-form-email__btn:focus,.disabled.contract-form-email__btn:hover,.disabled.contract-management-edit-control__btn:focus,.disabled.contract-management-edit-control__btn:hover,.disabled.contract-management-edit-email__btn:focus,.disabled.contract-management-edit-email__btn:hover,.disabled.contract-management-edit-form__btn:focus,.disabled.contract-management-edit-form__btn:hover,.disabled.focus.activate-user-page__submit,.disabled.focus.admin-create-modal-form__btn-update,.disabled.focus.admin-create-modal__add-btn,.disabled.focus.admin-edit-modal-form-accept__submit,.disabled.focus.admin-edit-modal-form__btn-update,.disabled.focus.admin-edit-modal__add-btn,.disabled.focus.contract-draft-preview__button,.disabled.focus.contract-form-email__btn,.disabled.focus.contract-management-edit-control__btn,.disabled.focus.contract-management-edit-email__btn,.disabled.focus.contract-management-edit-form__btn,.disabled.focus.forgot-password-page__submit,.disabled.focus.manage-allocation-form-accept__submit,.disabled.focus.manage-allocation-form__submit,.disabled.focus.manage-allocation-modal-form__submit,.disabled.focus.manage-allocation-modal-list__btn-new,.disabled.focus.manage-allocation-modal__add-btn,.disabled.focus.reset-password-page__submit,.disabled.focus.sign-in-page__submit,.disabled.forgot-password-page__submit:focus,.disabled.forgot-password-page__submit:hover,.disabled.manage-allocation-form-accept__submit:focus,.disabled.manage-allocation-form-accept__submit:hover,.disabled.manage-allocation-form__submit:focus,.disabled.manage-allocation-form__submit:hover,.disabled.manage-allocation-modal-form__submit:focus,.disabled.manage-allocation-modal-form__submit:hover,.disabled.manage-allocation-modal-list__btn-new:focus,.disabled.manage-allocation-modal-list__btn-new:hover,.disabled.manage-allocation-modal__add-btn:focus,.disabled.manage-allocation-modal__add-btn:hover,.disabled.reset-password-page__submit:focus,.disabled.reset-password-page__submit:hover,.disabled.sign-in-page__submit:focus,.disabled.sign-in-page__submit:hover,.forgot-password-page__submit[disabled].focus,.forgot-password-page__submit[disabled]:focus,.forgot-password-page__submit[disabled]:hover,.manage-allocation-form-accept__submit[disabled].focus,.manage-allocation-form-accept__submit[disabled]:focus,.manage-allocation-form-accept__submit[disabled]:hover,.manage-allocation-form__submit[disabled].focus,.manage-allocation-form__submit[disabled]:focus,.manage-allocation-form__submit[disabled]:hover,.manage-allocation-modal-form__submit[disabled].focus,.manage-allocation-modal-form__submit[disabled]:focus,.manage-allocation-modal-form__submit[disabled]:hover,.manage-allocation-modal-list__btn-new[disabled].focus,.manage-allocation-modal-list__btn-new[disabled]:focus,.manage-allocation-modal-list__btn-new[disabled]:hover,.manage-allocation-modal__add-btn[disabled].focus,.manage-allocation-modal__add-btn[disabled]:focus,.manage-allocation-modal__add-btn[disabled]:hover,.reset-password-page__submit[disabled].focus,.reset-password-page__submit[disabled]:focus,.reset-password-page__submit[disabled]:hover,.sign-in-page__submit[disabled].focus,.sign-in-page__submit[disabled]:focus,.sign-in-page__submit[disabled]:hover,fieldset[disabled] .activate-user-page__submit:focus,fieldset[disabled] .activate-user-page__submit:hover,fieldset[disabled] .admin-create-modal-form__btn-update:focus,fieldset[disabled] .admin-create-modal-form__btn-update:hover,fieldset[disabled] .admin-create-modal__add-btn:focus,fieldset[disabled] .admin-create-modal__add-btn:hover,fieldset[disabled] .admin-edit-modal-form-accept__submit:focus,fieldset[disabled] .admin-edit-modal-form-accept__submit:hover,fieldset[disabled] .admin-edit-modal-form__btn-update:focus,fieldset[disabled] .admin-edit-modal-form__btn-update:hover,fieldset[disabled] .admin-edit-modal__add-btn:focus,fieldset[disabled] .admin-edit-modal__add-btn:hover,fieldset[disabled] .button__primary.focus,fieldset[disabled] .button__primary:focus,fieldset[disabled] .button__primary:hover,fieldset[disabled] .contract-draft-preview__button:focus,fieldset[disabled] .contract-draft-preview__button:hover,fieldset[disabled] .contract-form-email__btn:focus,fieldset[disabled] .contract-form-email__btn:hover,fieldset[disabled] .contract-management-edit-control__btn:focus,fieldset[disabled] .contract-management-edit-control__btn:hover,fieldset[disabled] .contract-management-edit-email__btn:focus,fieldset[disabled] .contract-management-edit-email__btn:hover,fieldset[disabled] .contract-management-edit-form__btn:focus,fieldset[disabled] .contract-management-edit-form__btn:hover,fieldset[disabled] .focus.activate-user-page__submit,fieldset[disabled] .focus.admin-create-modal-form__btn-update,fieldset[disabled] .focus.admin-create-modal__add-btn,fieldset[disabled] .focus.admin-edit-modal-form-accept__submit,fieldset[disabled] .focus.admin-edit-modal-form__btn-update,fieldset[disabled] .focus.admin-edit-modal__add-btn,fieldset[disabled] .focus.contract-draft-preview__button,fieldset[disabled] .focus.contract-form-email__btn,fieldset[disabled] .focus.contract-management-edit-control__btn,fieldset[disabled] .focus.contract-management-edit-email__btn,fieldset[disabled] .focus.contract-management-edit-form__btn,fieldset[disabled] .focus.forgot-password-page__submit,fieldset[disabled] .focus.manage-allocation-form-accept__submit,fieldset[disabled] .focus.manage-allocation-form__submit,fieldset[disabled] .focus.manage-allocation-modal-form__submit,fieldset[disabled] .focus.manage-allocation-modal-list__btn-new,fieldset[disabled] .focus.manage-allocation-modal__add-btn,fieldset[disabled] .focus.reset-password-page__submit,fieldset[disabled] .focus.sign-in-page__submit,fieldset[disabled] .forgot-password-page__submit:focus,fieldset[disabled] .forgot-password-page__submit:hover,fieldset[disabled] .manage-allocation-form-accept__submit:focus,fieldset[disabled] .manage-allocation-form-accept__submit:hover,fieldset[disabled] .manage-allocation-form__submit:focus,fieldset[disabled] .manage-allocation-form__submit:hover,fieldset[disabled] .manage-allocation-modal-form__submit:focus,fieldset[disabled] .manage-allocation-modal-form__submit:hover,fieldset[disabled] .manage-allocation-modal-list__btn-new:focus,fieldset[disabled] .manage-allocation-modal-list__btn-new:hover,fieldset[disabled] .manage-allocation-modal__add-btn:focus,fieldset[disabled] .manage-allocation-modal__add-btn:hover,fieldset[disabled] .reset-password-page__submit:focus,fieldset[disabled] .reset-password-page__submit:hover,fieldset[disabled] .sign-in-page__submit:focus,fieldset[disabled] .sign-in-page__submit:hover{background-color:#64c1c7;border-color:#64c1c7}.activate-user-page__submit .badge,.admin-create-modal-form__btn-update .badge,.admin-create-modal__add-btn .badge,.admin-edit-modal-form-accept__submit .badge,.admin-edit-modal-form__btn-update .badge,.admin-edit-modal__add-btn .badge,.button__primary .badge,.contract-draft-preview__button .badge,.contract-form-email__btn .badge,.contract-management-edit-control__btn .badge,.contract-management-edit-email__btn .badge,.contract-management-edit-form__btn .badge,.forgot-password-page__submit .badge,.manage-allocation-form-accept__submit .badge,.manage-allocation-form__submit .badge,.manage-allocation-modal-form__submit .badge,.manage-allocation-modal-list__btn-new .badge,.manage-allocation-modal__add-btn .badge,.reset-password-page__submit .badge,.sign-in-page__submit .badge{color:#64c1c7;background-color:#f3f3f4}.activate-user-page__submit[disabled],.admin-create-modal-form__btn-update[disabled],.admin-create-modal__add-btn[disabled],.admin-edit-modal-form-accept__submit[disabled],.admin-edit-modal-form__btn-update[disabled],.admin-edit-modal__add-btn[disabled],.button__primary.disabled,.button__primary[disabled],.contract-draft-preview__button[disabled],.contract-form-email__btn[disabled],.contract-management-edit-control__btn[disabled],.contract-management-edit-email__btn[disabled],.contract-management-edit-form__btn[disabled],.disabled.activate-user-page__submit,.disabled.admin-create-modal-form__btn-update,.disabled.admin-create-modal__add-btn,.disabled.admin-edit-modal-form-accept__submit,.disabled.admin-edit-modal-form__btn-update,.disabled.admin-edit-modal__add-btn,.disabled.contract-draft-preview__button,.disabled.contract-form-email__btn,.disabled.contract-management-edit-control__btn,.disabled.contract-management-edit-email__btn,.disabled.contract-management-edit-form__btn,.disabled.forgot-password-page__submit,.disabled.manage-allocation-form-accept__submit,.disabled.manage-allocation-form__submit,.disabled.manage-allocation-modal-form__submit,.disabled.manage-allocation-modal-list__btn-new,.disabled.manage-allocation-modal__add-btn,.disabled.reset-password-page__submit,.disabled.sign-in-page__submit,.forgot-password-page__submit[disabled],.manage-allocation-form-accept__submit[disabled],.manage-allocation-form__submit[disabled],.manage-allocation-modal-form__submit[disabled],.manage-allocation-modal-list__btn-new[disabled],.manage-allocation-modal__add-btn[disabled],.reset-password-page__submit[disabled],.sign-in-page__submit[disabled],fieldset[disabled] .activate-user-page__submit,fieldset[disabled] .admin-create-modal-form__btn-update,fieldset[disabled] .admin-create-modal__add-btn,fieldset[disabled] .admin-edit-modal-form-accept__submit,fieldset[disabled] .admin-edit-modal-form__btn-update,fieldset[disabled] .admin-edit-modal__add-btn,fieldset[disabled] .button__primary,fieldset[disabled] .contract-draft-preview__button,fieldset[disabled] .contract-form-email__btn,fieldset[disabled] .contract-management-edit-control__btn,fieldset[disabled] .contract-management-edit-email__btn,fieldset[disabled] .contract-management-edit-form__btn,fieldset[disabled] .forgot-password-page__submit,fieldset[disabled] .manage-allocation-form-accept__submit,fieldset[disabled] .manage-allocation-form__submit,fieldset[disabled] .manage-allocation-modal-form__submit,fieldset[disabled] .manage-allocation-modal-list__btn-new,fieldset[disabled] .manage-allocation-modal__add-btn,fieldset[disabled] .reset-password-page__submit,fieldset[disabled] .sign-in-page__submit{cursor:default;background-color:#9cd7db;border-color:#9cd7db}.activate-user-page__submit[disabled].focus,.activate-user-page__submit[disabled]:focus,.activate-user-page__submit[disabled]:hover,.admin-create-modal-form__btn-update[disabled].focus,.admin-create-modal-form__btn-update[disabled]:focus,.admin-create-modal-form__btn-update[disabled]:hover,.admin-create-modal__add-btn[disabled].focus,.admin-create-modal__add-btn[disabled]:focus,.admin-create-modal__add-btn[disabled]:hover,.admin-edit-modal-form-accept__submit[disabled].focus,.admin-edit-modal-form-accept__submit[disabled]:focus,.admin-edit-modal-form-accept__submit[disabled]:hover,.admin-edit-modal-form__btn-update[disabled].focus,.admin-edit-modal-form__btn-update[disabled]:focus,.admin-edit-modal-form__btn-update[disabled]:hover,.admin-edit-modal__add-btn[disabled].focus,.admin-edit-modal__add-btn[disabled]:focus,.admin-edit-modal__add-btn[disabled]:hover,.button__primary.disabled.focus,.button__primary.disabled:focus,.button__primary.disabled:hover,.button__primary[disabled].focus,.button__primary[disabled]:focus,.button__primary[disabled]:hover,.contract-draft-preview__button[disabled].focus,.contract-draft-preview__button[disabled]:focus,.contract-draft-preview__button[disabled]:hover,.contract-form-email__btn[disabled].focus,.contract-form-email__btn[disabled]:focus,.contract-form-email__btn[disabled]:hover,.contract-management-edit-control__btn[disabled].focus,.contract-management-edit-control__btn[disabled]:focus,.contract-management-edit-control__btn[disabled]:hover,.contract-management-edit-email__btn[disabled].focus,.contract-management-edit-email__btn[disabled]:focus,.contract-management-edit-email__btn[disabled]:hover,.contract-management-edit-form__btn[disabled].focus,.contract-management-edit-form__btn[disabled]:focus,.contract-management-edit-form__btn[disabled]:hover,.disabled.activate-user-page__submit:focus,.disabled.activate-user-page__submit:hover,.disabled.admin-create-modal-form__btn-update:focus,.disabled.admin-create-modal-form__btn-update:hover,.disabled.admin-create-modal__add-btn:focus,.disabled.admin-create-modal__add-btn:hover,.disabled.admin-edit-modal-form-accept__submit:focus,.disabled.admin-edit-modal-form-accept__submit:hover,.disabled.admin-edit-modal-form__btn-update:focus,.disabled.admin-edit-modal-form__btn-update:hover,.disabled.admin-edit-modal__add-btn:focus,.disabled.admin-edit-modal__add-btn:hover,.disabled.contract-draft-preview__button:focus,.disabled.contract-draft-preview__button:hover,.disabled.contract-form-email__btn:focus,.disabled.contract-form-email__btn:hover,.disabled.contract-management-edit-control__btn:focus,.disabled.contract-management-edit-control__btn:hover,.disabled.contract-management-edit-email__btn:focus,.disabled.contract-management-edit-email__btn:hover,.disabled.contract-management-edit-form__btn:focus,.disabled.contract-management-edit-form__btn:hover,.disabled.focus.activate-user-page__submit,.disabled.focus.admin-create-modal-form__btn-update,.disabled.focus.admin-create-modal__add-btn,.disabled.focus.admin-edit-modal-form-accept__submit,.disabled.focus.admin-edit-modal-form__btn-update,.disabled.focus.admin-edit-modal__add-btn,.disabled.focus.contract-draft-preview__button,.disabled.focus.contract-form-email__btn,.disabled.focus.contract-management-edit-control__btn,.disabled.focus.contract-management-edit-email__btn,.disabled.focus.contract-management-edit-form__btn,.disabled.focus.forgot-password-page__submit,.disabled.focus.manage-allocation-form-accept__submit,.disabled.focus.manage-allocation-form__submit,.disabled.focus.manage-allocation-modal-form__submit,.disabled.focus.manage-allocation-modal-list__btn-new,.disabled.focus.manage-allocation-modal__add-btn,.disabled.focus.reset-password-page__submit,.disabled.focus.sign-in-page__submit,.disabled.forgot-password-page__submit:focus,.disabled.forgot-password-page__submit:hover,.disabled.manage-allocation-form-accept__submit:focus,.disabled.manage-allocation-form-accept__submit:hover,.disabled.manage-allocation-form__submit:focus,.disabled.manage-allocation-form__submit:hover,.disabled.manage-allocation-modal-form__submit:focus,.disabled.manage-allocation-modal-form__submit:hover,.disabled.manage-allocation-modal-list__btn-new:focus,.disabled.manage-allocation-modal-list__btn-new:hover,.disabled.manage-allocation-modal__add-btn:focus,.disabled.manage-allocation-modal__add-btn:hover,.disabled.reset-password-page__submit:focus,.disabled.reset-password-page__submit:hover,.disabled.sign-in-page__submit:focus,.disabled.sign-in-page__submit:hover,.forgot-password-page__submit[disabled].focus,.forgot-password-page__submit[disabled]:focus,.forgot-password-page__submit[disabled]:hover,.manage-allocation-form-accept__submit[disabled].focus,.manage-allocation-form-accept__submit[disabled]:focus,.manage-allocation-form-accept__submit[disabled]:hover,.manage-allocation-form__submit[disabled].focus,.manage-allocation-form__submit[disabled]:focus,.manage-allocation-form__submit[disabled]:hover,.manage-allocation-modal-form__submit[disabled].focus,.manage-allocation-modal-form__submit[disabled]:focus,.manage-allocation-modal-form__submit[disabled]:hover,.manage-allocation-modal-list__btn-new[disabled].focus,.manage-allocation-modal-list__btn-new[disabled]:focus,.manage-allocation-modal-list__btn-new[disabled]:hover,.manage-allocation-modal__add-btn[disabled].focus,.manage-allocation-modal__add-btn[disabled]:focus,.manage-allocation-modal__add-btn[disabled]:hover,.reset-password-page__submit[disabled].focus,.reset-password-page__submit[disabled]:focus,.reset-password-page__submit[disabled]:hover,.sign-in-page__submit[disabled].focus,.sign-in-page__submit[disabled]:focus,.sign-in-page__submit[disabled]:hover,fieldset[disabled] .activate-user-page__submit:focus,fieldset[disabled] .activate-user-page__submit:hover,fieldset[disabled] .admin-create-modal-form__btn-update:focus,fieldset[disabled] .admin-create-modal-form__btn-update:hover,fieldset[disabled] .admin-create-modal__add-btn:focus,fieldset[disabled] .admin-create-modal__add-btn:hover,fieldset[disabled] .admin-edit-modal-form-accept__submit:focus,fieldset[disabled] .admin-edit-modal-form-accept__submit:hover,fieldset[disabled] .admin-edit-modal-form__btn-update:focus,fieldset[disabled] .admin-edit-modal-form__btn-update:hover,fieldset[disabled] .admin-edit-modal__add-btn:focus,fieldset[disabled] .admin-edit-modal__add-btn:hover,fieldset[disabled] .button__primary.focus,fieldset[disabled] .button__primary:focus,fieldset[disabled] .button__primary:hover,fieldset[disabled] .contract-draft-preview__button:focus,fieldset[disabled] .contract-draft-preview__button:hover,fieldset[disabled] .contract-form-email__btn:focus,fieldset[disabled] .contract-form-email__btn:hover,fieldset[disabled] .contract-management-edit-control__btn:focus,fieldset[disabled] .contract-management-edit-control__btn:hover,fieldset[disabled] .contract-management-edit-email__btn:focus,fieldset[disabled] .contract-management-edit-email__btn:hover,fieldset[disabled] .contract-management-edit-form__btn:focus,fieldset[disabled] .contract-management-edit-form__btn:hover,fieldset[disabled] .focus.activate-user-page__submit,fieldset[disabled] .focus.admin-create-modal-form__btn-update,fieldset[disabled] .focus.admin-create-modal__add-btn,fieldset[disabled] .focus.admin-edit-modal-form-accept__submit,fieldset[disabled] .focus.admin-edit-modal-form__btn-update,fieldset[disabled] .focus.admin-edit-modal__add-btn,fieldset[disabled] .focus.contract-draft-preview__button,fieldset[disabled] .focus.contract-form-email__btn,fieldset[disabled] .focus.contract-management-edit-control__btn,fieldset[disabled] .focus.contract-management-edit-email__btn,fieldset[disabled] .focus.contract-management-edit-form__btn,fieldset[disabled] .focus.forgot-password-page__submit,fieldset[disabled] .focus.manage-allocation-form-accept__submit,fieldset[disabled] .focus.manage-allocation-form__submit,fieldset[disabled] .focus.manage-allocation-modal-form__submit,fieldset[disabled] .focus.manage-allocation-modal-list__btn-new,fieldset[disabled] .focus.manage-allocation-modal__add-btn,fieldset[disabled] .focus.reset-password-page__submit,fieldset[disabled] .focus.sign-in-page__submit,fieldset[disabled] .forgot-password-page__submit:focus,fieldset[disabled] .forgot-password-page__submit:hover,fieldset[disabled] .manage-allocation-form-accept__submit:focus,fieldset[disabled] .manage-allocation-form-accept__submit:hover,fieldset[disabled] .manage-allocation-form__submit:focus,fieldset[disabled] .manage-allocation-form__submit:hover,fieldset[disabled] .manage-allocation-modal-form__submit:focus,fieldset[disabled] .manage-allocation-modal-form__submit:hover,fieldset[disabled] .manage-allocation-modal-list__btn-new:focus,fieldset[disabled] .manage-allocation-modal-list__btn-new:hover,fieldset[disabled] .manage-allocation-modal__add-btn:focus,fieldset[disabled] .manage-allocation-modal__add-btn:hover,fieldset[disabled] .reset-password-page__submit:focus,fieldset[disabled] .reset-password-page__submit:hover,fieldset[disabled] .sign-in-page__submit:focus,fieldset[disabled] .sign-in-page__submit:hover{background-color:#9cd7db;border-color:#9cd7db}.activate-user-page__submit,.button__primary--lg,.forgot-password-page__submit,.reset-password-page__submit,.sign-in-page__submit{padding:8.4px 30px;font-size:17px;line-height:1.6;border-radius:3px}.button__primary--sm{padding:5px 15px;font-size:13px;line-height:1.6;border-radius:3px}.button__primary--xs{padding:5px 10px;font-size:12px;line-height:1.6;border-radius:3px}.account-form__btn,.account-notifications__btn,.account-password__btn,.allocation-list__button,.button__default,.contract-management-list__btn,.dashboard-notifications__btn-dismiss,.dashboard-notifications__link-contract,.manage-allocation-modal-list__btn-edit,.manage-allocation-modal-overlay-form__decrement-btn,.manage-allocation-modal-overlay-form__increment-btn,.manage-allocation-request-form__decrement-btn,.manage-allocation-request-form__increment-btn{padding:5px 30px;font-size:14px;line-height:1.6;border-radius:3px;color:#7d7e83;background-color:#fff;border-color:#fff;cursor:pointer;border:1px solid;transition:.2s ease;transition-property:background-color,border-color;font-weight:700;text-decoration:none!important;border:1px solid #e6e6e6}.account-form__btn:focus,.account-notifications__btn:focus,.account-password__btn:focus,.allocation-list__button:focus,.button__default.focus,.button__default:focus,.contract-management-list__btn:focus,.dashboard-notifications__btn-dismiss:focus,.dashboard-notifications__link-contract:focus,.focus.account-form__btn,.focus.account-notifications__btn,.focus.account-password__btn,.focus.allocation-list__button,.focus.contract-management-list__btn,.focus.dashboard-notifications__btn-dismiss,.focus.dashboard-notifications__link-contract,.focus.manage-allocation-modal-list__btn-edit,.focus.manage-allocation-modal-overlay-form__decrement-btn,.focus.manage-allocation-modal-overlay-form__increment-btn,.focus.manage-allocation-request-form__decrement-btn,.focus.manage-allocation-request-form__increment-btn,.manage-allocation-modal-list__btn-edit:focus,.manage-allocation-modal-overlay-form__decrement-btn:focus,.manage-allocation-modal-overlay-form__increment-btn:focus,.manage-allocation-request-form__decrement-btn:focus,.manage-allocation-request-form__increment-btn:focus{color:#7d7e83;background-color:#e6e6e6;border-color:#bfbfbf}.account-form__btn:hover,.account-notifications__btn:hover,.account-password__btn:hover,.allocation-list__button:hover,.button__default:hover,.contract-management-list__btn:hover,.dashboard-notifications__btn-dismiss:hover,.dashboard-notifications__link-contract:hover,.manage-allocation-modal-list__btn-edit:hover,.manage-allocation-modal-overlay-form__decrement-btn:hover,.manage-allocation-modal-overlay-form__increment-btn:hover,.manage-allocation-request-form__decrement-btn:hover,.manage-allocation-request-form__increment-btn:hover{color:#7d7e83;background-color:#e6e6e6;border-color:#e0e0e0}.account-form__btn:active,.account-notifications__btn:active,.account-password__btn:active,.active.account-form__btn,.active.account-notifications__btn,.active.account-password__btn,.active.allocation-list__button,.active.contract-management-list__btn,.active.dashboard-notifications__btn-dismiss,.active.dashboard-notifications__link-contract,.active.manage-allocation-modal-list__btn-edit,.active.manage-allocation-modal-overlay-form__decrement-btn,.active.manage-allocation-modal-overlay-form__increment-btn,.active.manage-allocation-request-form__decrement-btn,.active.manage-allocation-request-form__increment-btn,.allocation-list__button:active,.button__default.active,.button__default:active,.contract-management-list__btn:active,.dashboard-notifications__btn-dismiss:active,.dashboard-notifications__link-contract:active,.manage-allocation-modal-list__btn-edit:active,.manage-allocation-modal-overlay-form__decrement-btn:active,.manage-allocation-modal-overlay-form__increment-btn:active,.manage-allocation-request-form__decrement-btn:active,.manage-allocation-request-form__increment-btn:active,.open>.button__default.dropdown-toggle,.open>.dropdown-toggle.account-form__btn,.open>.dropdown-toggle.account-notifications__btn,.open>.dropdown-toggle.account-password__btn,.open>.dropdown-toggle.allocation-list__button,.open>.dropdown-toggle.contract-management-list__btn,.open>.dropdown-toggle.dashboard-notifications__btn-dismiss,.open>.dropdown-toggle.dashboard-notifications__link-contract,.open>.dropdown-toggle.manage-allocation-modal-list__btn-edit,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__decrement-btn,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__increment-btn,.open>.dropdown-toggle.manage-allocation-request-form__decrement-btn,.open>.dropdown-toggle.manage-allocation-request-form__increment-btn{color:#7d7e83;background-color:#e6e6e6;background-image:none;border-color:#e0e0e0}.account-form__btn:active.focus,.account-form__btn:active:focus,.account-form__btn:active:hover,.account-notifications__btn:active.focus,.account-notifications__btn:active:focus,.account-notifications__btn:active:hover,.account-password__btn:active.focus,.account-password__btn:active:focus,.account-password__btn:active:hover,.active.account-form__btn:focus,.active.account-form__btn:hover,.active.account-notifications__btn:focus,.active.account-notifications__btn:hover,.active.account-password__btn:focus,.active.account-password__btn:hover,.active.allocation-list__button:focus,.active.allocation-list__button:hover,.active.contract-management-list__btn:focus,.active.contract-management-list__btn:hover,.active.dashboard-notifications__btn-dismiss:focus,.active.dashboard-notifications__btn-dismiss:hover,.active.dashboard-notifications__link-contract:focus,.active.dashboard-notifications__link-contract:hover,.active.focus.account-form__btn,.active.focus.account-notifications__btn,.active.focus.account-password__btn,.active.focus.allocation-list__button,.active.focus.contract-management-list__btn,.active.focus.dashboard-notifications__btn-dismiss,.active.focus.dashboard-notifications__link-contract,.active.focus.manage-allocation-modal-list__btn-edit,.active.focus.manage-allocation-modal-overlay-form__decrement-btn,.active.focus.manage-allocation-modal-overlay-form__increment-btn,.active.focus.manage-allocation-request-form__decrement-btn,.active.focus.manage-allocation-request-form__increment-btn,.active.manage-allocation-modal-list__btn-edit:focus,.active.manage-allocation-modal-list__btn-edit:hover,.active.manage-allocation-modal-overlay-form__decrement-btn:focus,.active.manage-allocation-modal-overlay-form__decrement-btn:hover,.active.manage-allocation-modal-overlay-form__increment-btn:focus,.active.manage-allocation-modal-overlay-form__increment-btn:hover,.active.manage-allocation-request-form__decrement-btn:focus,.active.manage-allocation-request-form__decrement-btn:hover,.active.manage-allocation-request-form__increment-btn:focus,.active.manage-allocation-request-form__increment-btn:hover,.allocation-list__button:active.focus,.allocation-list__button:active:focus,.allocation-list__button:active:hover,.button__default.active.focus,.button__default.active:focus,.button__default.active:hover,.button__default:active.focus,.button__default:active:focus,.button__default:active:hover,.contract-management-list__btn:active.focus,.contract-management-list__btn:active:focus,.contract-management-list__btn:active:hover,.dashboard-notifications__btn-dismiss:active.focus,.dashboard-notifications__btn-dismiss:active:focus,.dashboard-notifications__btn-dismiss:active:hover,.dashboard-notifications__link-contract:active.focus,.dashboard-notifications__link-contract:active:focus,.dashboard-notifications__link-contract:active:hover,.manage-allocation-modal-list__btn-edit:active.focus,.manage-allocation-modal-list__btn-edit:active:focus,.manage-allocation-modal-list__btn-edit:active:hover,.manage-allocation-modal-overlay-form__decrement-btn:active.focus,.manage-allocation-modal-overlay-form__decrement-btn:active:focus,.manage-allocation-modal-overlay-form__decrement-btn:active:hover,.manage-allocation-modal-overlay-form__increment-btn:active.focus,.manage-allocation-modal-overlay-form__increment-btn:active:focus,.manage-allocation-modal-overlay-form__increment-btn:active:hover,.manage-allocation-request-form__decrement-btn:active.focus,.manage-allocation-request-form__decrement-btn:active:focus,.manage-allocation-request-form__decrement-btn:active:hover,.manage-allocation-request-form__increment-btn:active.focus,.manage-allocation-request-form__increment-btn:active:focus,.manage-allocation-request-form__increment-btn:active:hover,.open>.button__default.dropdown-toggle.focus,.open>.button__default.dropdown-toggle:focus,.open>.button__default.dropdown-toggle:hover,.open>.dropdown-toggle.account-form__btn:focus,.open>.dropdown-toggle.account-form__btn:hover,.open>.dropdown-toggle.account-notifications__btn:focus,.open>.dropdown-toggle.account-notifications__btn:hover,.open>.dropdown-toggle.account-password__btn:focus,.open>.dropdown-toggle.account-password__btn:hover,.open>.dropdown-toggle.allocation-list__button:focus,.open>.dropdown-toggle.allocation-list__button:hover,.open>.dropdown-toggle.contract-management-list__btn:focus,.open>.dropdown-toggle.contract-management-list__btn:hover,.open>.dropdown-toggle.dashboard-notifications__btn-dismiss:focus,.open>.dropdown-toggle.dashboard-notifications__btn-dismiss:hover,.open>.dropdown-toggle.dashboard-notifications__link-contract:focus,.open>.dropdown-toggle.dashboard-notifications__link-contract:hover,.open>.dropdown-toggle.focus.account-form__btn,.open>.dropdown-toggle.focus.account-notifications__btn,.open>.dropdown-toggle.focus.account-password__btn,.open>.dropdown-toggle.focus.allocation-list__button,.open>.dropdown-toggle.focus.contract-management-list__btn,.open>.dropdown-toggle.focus.dashboard-notifications__btn-dismiss,.open>.dropdown-toggle.focus.dashboard-notifications__link-contract,.open>.dropdown-toggle.focus.manage-allocation-modal-list__btn-edit,.open>.dropdown-toggle.focus.manage-allocation-modal-overlay-form__decrement-btn,.open>.dropdown-toggle.focus.manage-allocation-modal-overlay-form__increment-btn,.open>.dropdown-toggle.focus.manage-allocation-request-form__decrement-btn,.open>.dropdown-toggle.focus.manage-allocation-request-form__increment-btn,.open>.dropdown-toggle.manage-allocation-modal-list__btn-edit:focus,.open>.dropdown-toggle.manage-allocation-modal-list__btn-edit:hover,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__decrement-btn:focus,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__decrement-btn:hover,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__increment-btn:focus,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__increment-btn:hover,.open>.dropdown-toggle.manage-allocation-request-form__decrement-btn:focus,.open>.dropdown-toggle.manage-allocation-request-form__decrement-btn:hover,.open>.dropdown-toggle.manage-allocation-request-form__increment-btn:focus,.open>.dropdown-toggle.manage-allocation-request-form__increment-btn:hover{color:#7d7e83;background-color:#d4d4d4;border-color:#bfbfbf}.account-form__btn .badge,.account-notifications__btn .badge,.account-password__btn .badge,.allocation-list__button .badge,.button__default .badge,.contract-management-list__btn .badge,.dashboard-notifications__btn-dismiss .badge,.dashboard-notifications__link-contract .badge,.manage-allocation-modal-list__btn-edit .badge,.manage-allocation-modal-overlay-form__decrement-btn .badge,.manage-allocation-modal-overlay-form__increment-btn .badge,.manage-allocation-request-form__decrement-btn .badge,.manage-allocation-request-form__increment-btn .badge{color:#fff;background-color:#7d7e83}.account-form__btn[disabled],.account-notifications__btn[disabled],.account-password__btn[disabled],.allocation-list__button[disabled],.button__default.disabled,.button__default[disabled],.contract-management-list__btn[disabled],.dashboard-notifications__btn-dismiss[disabled],.dashboard-notifications__link-contract[disabled],.disabled.account-form__btn,.disabled.account-notifications__btn,.disabled.account-password__btn,.disabled.allocation-list__button,.disabled.contract-management-list__btn,.disabled.dashboard-notifications__btn-dismiss,.disabled.dashboard-notifications__link-contract,.disabled.manage-allocation-modal-list__btn-edit,.disabled.manage-allocation-modal-overlay-form__decrement-btn,.disabled.manage-allocation-modal-overlay-form__increment-btn,.disabled.manage-allocation-request-form__decrement-btn,.disabled.manage-allocation-request-form__increment-btn,.manage-allocation-modal-list__btn-edit[disabled],.manage-allocation-modal-overlay-form__decrement-btn[disabled],.manage-allocation-modal-overlay-form__increment-btn[disabled],.manage-allocation-request-form__decrement-btn[disabled],.manage-allocation-request-form__increment-btn[disabled],fieldset[disabled] .account-form__btn,fieldset[disabled] .account-notifications__btn,fieldset[disabled] .account-password__btn,fieldset[disabled] .allocation-list__button,fieldset[disabled] .button__default,fieldset[disabled] .contract-management-list__btn,fieldset[disabled] .dashboard-notifications__btn-dismiss,fieldset[disabled] .dashboard-notifications__link-contract,fieldset[disabled] .manage-allocation-modal-list__btn-edit,fieldset[disabled] .manage-allocation-modal-overlay-form__decrement-btn,fieldset[disabled] .manage-allocation-modal-overlay-form__increment-btn,fieldset[disabled] .manage-allocation-request-form__decrement-btn,fieldset[disabled] .manage-allocation-request-form__increment-btn{cursor:default;background-color:#fff;border-color:#fff}.account-form__btn[disabled].focus,.account-form__btn[disabled]:focus,.account-form__btn[disabled]:hover,.account-notifications__btn[disabled].focus,.account-notifications__btn[disabled]:focus,.account-notifications__btn[disabled]:hover,.account-password__btn[disabled].focus,.account-password__btn[disabled]:focus,.account-password__btn[disabled]:hover,.allocation-list__button[disabled].focus,.allocation-list__button[disabled]:focus,.allocation-list__button[disabled]:hover,.button__default.disabled.focus,.button__default.disabled:focus,.button__default.disabled:hover,.button__default[disabled].focus,.button__default[disabled]:focus,.button__default[disabled]:hover,.contract-management-list__btn[disabled].focus,.contract-management-list__btn[disabled]:focus,.contract-management-list__btn[disabled]:hover,.dashboard-notifications__btn-dismiss[disabled].focus,.dashboard-notifications__btn-dismiss[disabled]:focus,.dashboard-notifications__btn-dismiss[disabled]:hover,.dashboard-notifications__link-contract[disabled].focus,.dashboard-notifications__link-contract[disabled]:focus,.dashboard-notifications__link-contract[disabled]:hover,.disabled.account-form__btn:focus,.disabled.account-form__btn:hover,.disabled.account-notifications__btn:focus,.disabled.account-notifications__btn:hover,.disabled.account-password__btn:focus,.disabled.account-password__btn:hover,.disabled.allocation-list__button:focus,.disabled.allocation-list__button:hover,.disabled.contract-management-list__btn:focus,.disabled.contract-management-list__btn:hover,.disabled.dashboard-notifications__btn-dismiss:focus,.disabled.dashboard-notifications__btn-dismiss:hover,.disabled.dashboard-notifications__link-contract:focus,.disabled.dashboard-notifications__link-contract:hover,.disabled.focus.account-form__btn,.disabled.focus.account-notifications__btn,.disabled.focus.account-password__btn,.disabled.focus.allocation-list__button,.disabled.focus.contract-management-list__btn,.disabled.focus.dashboard-notifications__btn-dismiss,.disabled.focus.dashboard-notifications__link-contract,.disabled.focus.manage-allocation-modal-list__btn-edit,.disabled.focus.manage-allocation-modal-overlay-form__decrement-btn,.disabled.focus.manage-allocation-modal-overlay-form__increment-btn,.disabled.focus.manage-allocation-request-form__decrement-btn,.disabled.focus.manage-allocation-request-form__increment-btn,.disabled.manage-allocation-modal-list__btn-edit:focus,.disabled.manage-allocation-modal-list__btn-edit:hover,.disabled.manage-allocation-modal-overlay-form__decrement-btn:focus,.disabled.manage-allocation-modal-overlay-form__decrement-btn:hover,.disabled.manage-allocation-modal-overlay-form__increment-btn:focus,.disabled.manage-allocation-modal-overlay-form__increment-btn:hover,.disabled.manage-allocation-request-form__decrement-btn:focus,.disabled.manage-allocation-request-form__decrement-btn:hover,.disabled.manage-allocation-request-form__increment-btn:focus,.disabled.manage-allocation-request-form__increment-btn:hover,.manage-allocation-modal-list__btn-edit[disabled].focus,.manage-allocation-modal-list__btn-edit[disabled]:focus,.manage-allocation-modal-list__btn-edit[disabled]:hover,.manage-allocation-modal-overlay-form__decrement-btn[disabled].focus,.manage-allocation-modal-overlay-form__decrement-btn[disabled]:focus,.manage-allocation-modal-overlay-form__decrement-btn[disabled]:hover,.manage-allocation-modal-overlay-form__increment-btn[disabled].focus,.manage-allocation-modal-overlay-form__increment-btn[disabled]:focus,.manage-allocation-modal-overlay-form__increment-btn[disabled]:hover,.manage-allocation-request-form__decrement-btn[disabled].focus,.manage-allocation-request-form__decrement-btn[disabled]:focus,.manage-allocation-request-form__decrement-btn[disabled]:hover,.manage-allocation-request-form__increment-btn[disabled].focus,.manage-allocation-request-form__increment-btn[disabled]:focus,.manage-allocation-request-form__increment-btn[disabled]:hover,fieldset[disabled] .account-form__btn:focus,fieldset[disabled] .account-form__btn:hover,fieldset[disabled] .account-notifications__btn:focus,fieldset[disabled] .account-notifications__btn:hover,fieldset[disabled] .account-password__btn:focus,fieldset[disabled] .account-password__btn:hover,fieldset[disabled] .allocation-list__button:focus,fieldset[disabled] .allocation-list__button:hover,fieldset[disabled] .button__default.focus,fieldset[disabled] .button__default:focus,fieldset[disabled] .button__default:hover,fieldset[disabled] .contract-management-list__btn:focus,fieldset[disabled] .contract-management-list__btn:hover,fieldset[disabled] .dashboard-notifications__btn-dismiss:focus,fieldset[disabled] .dashboard-notifications__btn-dismiss:hover,fieldset[disabled] .dashboard-notifications__link-contract:focus,fieldset[disabled] .dashboard-notifications__link-contract:hover,fieldset[disabled] .focus.account-form__btn,fieldset[disabled] .focus.account-notifications__btn,fieldset[disabled] .focus.account-password__btn,fieldset[disabled] .focus.allocation-list__button,fieldset[disabled] .focus.contract-management-list__btn,fieldset[disabled] .focus.dashboard-notifications__btn-dismiss,fieldset[disabled] .focus.dashboard-notifications__link-contract,fieldset[disabled] .focus.manage-allocation-modal-list__btn-edit,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__decrement-btn,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__increment-btn,fieldset[disabled] .focus.manage-allocation-request-form__decrement-btn,fieldset[disabled] .focus.manage-allocation-request-form__increment-btn,fieldset[disabled] .manage-allocation-modal-list__btn-edit:focus,fieldset[disabled] .manage-allocation-modal-list__btn-edit:hover,fieldset[disabled] .manage-allocation-modal-overlay-form__decrement-btn:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__decrement-btn:hover,fieldset[disabled] .manage-allocation-modal-overlay-form__increment-btn:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__increment-btn:hover,fieldset[disabled] .manage-allocation-request-form__decrement-btn:focus,fieldset[disabled] .manage-allocation-request-form__decrement-btn:hover,fieldset[disabled] .manage-allocation-request-form__increment-btn:focus,fieldset[disabled] .manage-allocation-request-form__increment-btn:hover{background-color:#fff;border-color:#fff}.allocation-list__button,.button__default--lg{padding:8.4px 30px;font-size:17px;line-height:1.6;border-radius:3px}.button__default--sm{padding:5px 15px;font-size:13px;line-height:1.6;border-radius:3px}.button__default--xs{padding:5px 10px;font-size:12px;line-height:1.6;border-radius:3px}.button__info{padding:5px 30px;font-size:14px;line-height:1.6;border-radius:3px;color:#fff;background-color:#5bc0de;border-color:#5bc0de;cursor:pointer;border:1px solid;transition:.2s ease;transition-property:background-color,border-color;font-weight:700;text-decoration:none!important;border:1px solid #2390b0}.button__info.focus,.button__info:focus{color:#fff;background-color:#31b0d5;border-color:#1f7e9a}.button__info:hover{color:#fff;background-color:#31b0d5;border-color:#2aabd2}.button__info.active,.button__info:active,.open>.button__info.dropdown-toggle{color:#fff;background-color:#31b0d5;background-image:none;border-color:#2aabd2}.button__info.active.focus,.button__info.active:focus,.button__info.active:hover,.button__info:active.focus,.button__info:active:focus,.button__info:active:hover,.open>.button__info.dropdown-toggle.focus,.open>.button__info.dropdown-toggle:focus,.open>.button__info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1f7e9a}.button__info.disabled.focus,.button__info.disabled:focus,.button__info.disabled:hover,.button__info[disabled].focus,.button__info[disabled]:focus,.button__info[disabled]:hover,fieldset[disabled] .button__info.focus,fieldset[disabled] .button__info:focus,fieldset[disabled] .button__info:hover{background-color:#5bc0de;border-color:#5bc0de}.button__info .badge{color:#5bc0de;background-color:#fff}.button__info.disabled,.button__info[disabled],fieldset[disabled] .button__info{cursor:default;background-color:#9bd8eb;border-color:#9bd8eb}.button__info.disabled.focus,.button__info.disabled:focus,.button__info.disabled:hover,.button__info[disabled].focus,.button__info[disabled]:focus,.button__info[disabled]:hover,fieldset[disabled] .button__info.focus,fieldset[disabled] .button__info:focus,fieldset[disabled] .button__info:hover{background-color:#9bd8eb;border-color:#9bd8eb}.button__info--lg{padding:8.4px 30px;font-size:17px;line-height:1.6;border-radius:3px}.button__info--sm{padding:5px 15px;font-size:13px;line-height:1.6;border-radius:3px}.button__info--xs{padding:5px 10px;font-size:12px;line-height:1.6;border-radius:3px}.admin-edit-modal-form__btn-unblock,.button__success,.contract-form-accept__btn,.contract-form__accept-btn,.dashboard-notifications__link,.manage-allocation-modal-overlay-form__button-update,.manage-allocation-request-form__button-accept{padding:5px 30px;font-size:14px;line-height:1.6;border-radius:3px;color:#f3f3f4;background-color:#51bb83;border-color:#51bb83;cursor:pointer;border:1px solid;transition:.2s ease;transition-property:background-color,border-color;font-weight:700;text-decoration:none!important;border:1px solid #3d9c6a}.admin-edit-modal-form__btn-unblock:focus,.button__success.focus,.button__success:focus,.contract-form-accept__btn:focus,.contract-form__accept-btn:focus,.dashboard-notifications__link:focus,.focus.admin-edit-modal-form__btn-unblock,.focus.contract-form-accept__btn,.focus.contract-form__accept-btn,.focus.dashboard-notifications__link,.focus.manage-allocation-modal-overlay-form__button-update,.focus.manage-allocation-request-form__button-accept,.manage-allocation-modal-overlay-form__button-update:focus,.manage-allocation-request-form__button-accept:focus{color:#f3f3f4;background-color:#3d9c6a;border-color:#276545}.admin-edit-modal-form__btn-unblock:hover,.button__success:hover,.contract-form-accept__btn:hover,.contract-form__accept-btn:hover,.dashboard-notifications__link:hover,.manage-allocation-modal-overlay-form__button-update:hover,.manage-allocation-request-form__button-accept:hover{color:#f3f3f4;background-color:#3d9c6a;border-color:#3a9565}.active.admin-edit-modal-form__btn-unblock,.active.contract-form-accept__btn,.active.contract-form__accept-btn,.active.dashboard-notifications__link,.active.manage-allocation-modal-overlay-form__button-update,.active.manage-allocation-request-form__button-accept,.admin-edit-modal-form__btn-unblock:active,.button__success.active,.button__success:active,.contract-form-accept__btn:active,.contract-form__accept-btn:active,.dashboard-notifications__link:active,.manage-allocation-modal-overlay-form__button-update:active,.manage-allocation-request-form__button-accept:active,.open>.button__success.dropdown-toggle,.open>.dropdown-toggle.admin-edit-modal-form__btn-unblock,.open>.dropdown-toggle.contract-form-accept__btn,.open>.dropdown-toggle.contract-form__accept-btn,.open>.dropdown-toggle.dashboard-notifications__link,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-update,.open>.dropdown-toggle.manage-allocation-request-form__button-accept{color:#f3f3f4;background-color:#3d9c6a;background-image:none;border-color:#3a9565}.active.admin-edit-modal-form__btn-unblock:focus,.active.admin-edit-modal-form__btn-unblock:hover,.active.contract-form-accept__btn:focus,.active.contract-form-accept__btn:hover,.active.contract-form__accept-btn:focus,.active.contract-form__accept-btn:hover,.active.dashboard-notifications__link:focus,.active.dashboard-notifications__link:hover,.active.focus.admin-edit-modal-form__btn-unblock,.active.focus.contract-form-accept__btn,.active.focus.contract-form__accept-btn,.active.focus.dashboard-notifications__link,.active.focus.manage-allocation-modal-overlay-form__button-update,.active.focus.manage-allocation-request-form__button-accept,.active.manage-allocation-modal-overlay-form__button-update:focus,.active.manage-allocation-modal-overlay-form__button-update:hover,.active.manage-allocation-request-form__button-accept:focus,.active.manage-allocation-request-form__button-accept:hover,.admin-edit-modal-form__btn-unblock:active.focus,.admin-edit-modal-form__btn-unblock:active:focus,.admin-edit-modal-form__btn-unblock:active:hover,.button__success.active.focus,.button__success.active:focus,.button__success.active:hover,.button__success:active.focus,.button__success:active:focus,.button__success:active:hover,.contract-form-accept__btn:active.focus,.contract-form-accept__btn:active:focus,.contract-form-accept__btn:active:hover,.contract-form__accept-btn:active.focus,.contract-form__accept-btn:active:focus,.contract-form__accept-btn:active:hover,.dashboard-notifications__link:active.focus,.dashboard-notifications__link:active:focus,.dashboard-notifications__link:active:hover,.manage-allocation-modal-overlay-form__button-update:active.focus,.manage-allocation-modal-overlay-form__button-update:active:focus,.manage-allocation-modal-overlay-form__button-update:active:hover,.manage-allocation-request-form__button-accept:active.focus,.manage-allocation-request-form__button-accept:active:focus,.manage-allocation-request-form__button-accept:active:hover,.open>.button__success.dropdown-toggle.focus,.open>.button__success.dropdown-toggle:focus,.open>.button__success.dropdown-toggle:hover,.open>.dropdown-toggle.admin-edit-modal-form__btn-unblock:focus,.open>.dropdown-toggle.admin-edit-modal-form__btn-unblock:hover,.open>.dropdown-toggle.contract-form-accept__btn:focus,.open>.dropdown-toggle.contract-form-accept__btn:hover,.open>.dropdown-toggle.contract-form__accept-btn:focus,.open>.dropdown-toggle.contract-form__accept-btn:hover,.open>.dropdown-toggle.dashboard-notifications__link:focus,.open>.dropdown-toggle.dashboard-notifications__link:hover,.open>.dropdown-toggle.focus.admin-edit-modal-form__btn-unblock,.open>.dropdown-toggle.focus.contract-form-accept__btn,.open>.dropdown-toggle.focus.contract-form__accept-btn,.open>.dropdown-toggle.focus.dashboard-notifications__link,.open>.dropdown-toggle.focus.manage-allocation-modal-overlay-form__button-update,.open>.dropdown-toggle.focus.manage-allocation-request-form__button-accept,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-update:focus,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-update:hover,.open>.dropdown-toggle.manage-allocation-request-form__button-accept:focus,.open>.dropdown-toggle.manage-allocation-request-form__button-accept:hover{color:#f3f3f4;background-color:#338258;border-color:#276545}.admin-edit-modal-form__btn-unblock[disabled].focus,.admin-edit-modal-form__btn-unblock[disabled]:focus,.admin-edit-modal-form__btn-unblock[disabled]:hover,.button__success.disabled.focus,.button__success.disabled:focus,.button__success.disabled:hover,.button__success[disabled].focus,.button__success[disabled]:focus,.button__success[disabled]:hover,.contract-form-accept__btn[disabled].focus,.contract-form-accept__btn[disabled]:focus,.contract-form-accept__btn[disabled]:hover,.contract-form__accept-btn[disabled].focus,.contract-form__accept-btn[disabled]:focus,.contract-form__accept-btn[disabled]:hover,.dashboard-notifications__link[disabled].focus,.dashboard-notifications__link[disabled]:focus,.dashboard-notifications__link[disabled]:hover,.disabled.admin-edit-modal-form__btn-unblock:focus,.disabled.admin-edit-modal-form__btn-unblock:hover,.disabled.contract-form-accept__btn:focus,.disabled.contract-form-accept__btn:hover,.disabled.contract-form__accept-btn:focus,.disabled.contract-form__accept-btn:hover,.disabled.dashboard-notifications__link:focus,.disabled.dashboard-notifications__link:hover,.disabled.focus.admin-edit-modal-form__btn-unblock,.disabled.focus.contract-form-accept__btn,.disabled.focus.contract-form__accept-btn,.disabled.focus.dashboard-notifications__link,.disabled.focus.manage-allocation-modal-overlay-form__button-update,.disabled.focus.manage-allocation-request-form__button-accept,.disabled.manage-allocation-modal-overlay-form__button-update:focus,.disabled.manage-allocation-modal-overlay-form__button-update:hover,.disabled.manage-allocation-request-form__button-accept:focus,.disabled.manage-allocation-request-form__button-accept:hover,.manage-allocation-modal-overlay-form__button-update[disabled].focus,.manage-allocation-modal-overlay-form__button-update[disabled]:focus,.manage-allocation-modal-overlay-form__button-update[disabled]:hover,.manage-allocation-request-form__button-accept[disabled].focus,.manage-allocation-request-form__button-accept[disabled]:focus,.manage-allocation-request-form__button-accept[disabled]:hover,fieldset[disabled] .admin-edit-modal-form__btn-unblock:focus,fieldset[disabled] .admin-edit-modal-form__btn-unblock:hover,fieldset[disabled] .button__success.focus,fieldset[disabled] .button__success:focus,fieldset[disabled] .button__success:hover,fieldset[disabled] .contract-form-accept__btn:focus,fieldset[disabled] .contract-form-accept__btn:hover,fieldset[disabled] .contract-form__accept-btn:focus,fieldset[disabled] .contract-form__accept-btn:hover,fieldset[disabled] .dashboard-notifications__link:focus,fieldset[disabled] .dashboard-notifications__link:hover,fieldset[disabled] .focus.admin-edit-modal-form__btn-unblock,fieldset[disabled] .focus.contract-form-accept__btn,fieldset[disabled] .focus.contract-form__accept-btn,fieldset[disabled] .focus.dashboard-notifications__link,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__button-update,fieldset[disabled] .focus.manage-allocation-request-form__button-accept,fieldset[disabled] .manage-allocation-modal-overlay-form__button-update:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__button-update:hover,fieldset[disabled] .manage-allocation-request-form__button-accept:focus,fieldset[disabled] .manage-allocation-request-form__button-accept:hover{background-color:#51bb83;border-color:#51bb83}.admin-edit-modal-form__btn-unblock .badge,.button__success .badge,.contract-form-accept__btn .badge,.contract-form__accept-btn .badge,.dashboard-notifications__link .badge,.manage-allocation-modal-overlay-form__button-update .badge,.manage-allocation-request-form__button-accept .badge{color:#51bb83;background-color:#f3f3f4}.admin-edit-modal-form__btn-unblock[disabled],.button__success.disabled,.button__success[disabled],.contract-form-accept__btn[disabled],.contract-form__accept-btn[disabled],.dashboard-notifications__link[disabled],.disabled.admin-edit-modal-form__btn-unblock,.disabled.contract-form-accept__btn,.disabled.contract-form__accept-btn,.disabled.dashboard-notifications__link,.disabled.manage-allocation-modal-overlay-form__button-update,.disabled.manage-allocation-request-form__button-accept,.manage-allocation-modal-overlay-form__button-update[disabled],.manage-allocation-request-form__button-accept[disabled],fieldset[disabled] .admin-edit-modal-form__btn-unblock,fieldset[disabled] .button__success,fieldset[disabled] .contract-form-accept__btn,fieldset[disabled] .contract-form__accept-btn,fieldset[disabled] .dashboard-notifications__link,fieldset[disabled] .manage-allocation-modal-overlay-form__button-update,fieldset[disabled] .manage-allocation-request-form__button-accept{cursor:default;background-color:#88d0aa;border-color:#88d0aa}.admin-edit-modal-form__btn-unblock[disabled].focus,.admin-edit-modal-form__btn-unblock[disabled]:focus,.admin-edit-modal-form__btn-unblock[disabled]:hover,.button__success.disabled.focus,.button__success.disabled:focus,.button__success.disabled:hover,.button__success[disabled].focus,.button__success[disabled]:focus,.button__success[disabled]:hover,.contract-form-accept__btn[disabled].focus,.contract-form-accept__btn[disabled]:focus,.contract-form-accept__btn[disabled]:hover,.contract-form__accept-btn[disabled].focus,.contract-form__accept-btn[disabled]:focus,.contract-form__accept-btn[disabled]:hover,.dashboard-notifications__link[disabled].focus,.dashboard-notifications__link[disabled]:focus,.dashboard-notifications__link[disabled]:hover,.disabled.admin-edit-modal-form__btn-unblock:focus,.disabled.admin-edit-modal-form__btn-unblock:hover,.disabled.contract-form-accept__btn:focus,.disabled.contract-form-accept__btn:hover,.disabled.contract-form__accept-btn:focus,.disabled.contract-form__accept-btn:hover,.disabled.dashboard-notifications__link:focus,.disabled.dashboard-notifications__link:hover,.disabled.focus.admin-edit-modal-form__btn-unblock,.disabled.focus.contract-form-accept__btn,.disabled.focus.contract-form__accept-btn,.disabled.focus.dashboard-notifications__link,.disabled.focus.manage-allocation-modal-overlay-form__button-update,.disabled.focus.manage-allocation-request-form__button-accept,.disabled.manage-allocation-modal-overlay-form__button-update:focus,.disabled.manage-allocation-modal-overlay-form__button-update:hover,.disabled.manage-allocation-request-form__button-accept:focus,.disabled.manage-allocation-request-form__button-accept:hover,.manage-allocation-modal-overlay-form__button-update[disabled].focus,.manage-allocation-modal-overlay-form__button-update[disabled]:focus,.manage-allocation-modal-overlay-form__button-update[disabled]:hover,.manage-allocation-request-form__button-accept[disabled].focus,.manage-allocation-request-form__button-accept[disabled]:focus,.manage-allocation-request-form__button-accept[disabled]:hover,fieldset[disabled] .admin-edit-modal-form__btn-unblock:focus,fieldset[disabled] .admin-edit-modal-form__btn-unblock:hover,fieldset[disabled] .button__success.focus,fieldset[disabled] .button__success:focus,fieldset[disabled] .button__success:hover,fieldset[disabled] .contract-form-accept__btn:focus,fieldset[disabled] .contract-form-accept__btn:hover,fieldset[disabled] .contract-form__accept-btn:focus,fieldset[disabled] .contract-form__accept-btn:hover,fieldset[disabled] .dashboard-notifications__link:focus,fieldset[disabled] .dashboard-notifications__link:hover,fieldset[disabled] .focus.admin-edit-modal-form__btn-unblock,fieldset[disabled] .focus.contract-form-accept__btn,fieldset[disabled] .focus.contract-form__accept-btn,fieldset[disabled] .focus.dashboard-notifications__link,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__button-update,fieldset[disabled] .focus.manage-allocation-request-form__button-accept,fieldset[disabled] .manage-allocation-modal-overlay-form__button-update:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__button-update:hover,fieldset[disabled] .manage-allocation-request-form__button-accept:focus,fieldset[disabled] .manage-allocation-request-form__button-accept:hover{background-color:#88d0aa;border-color:#88d0aa}.button__success--lg{padding:8.4px 30px;font-size:17px;line-height:1.6;border-radius:3px}.button__success--sm{padding:5px 15px;font-size:13px;line-height:1.6;border-radius:3px}.button__success--xs{padding:5px 10px;font-size:12px;line-height:1.6;border-radius:3px}.admin-edit-modal-form-accept__cancel,.admin-edit-modal-form__btn-delete,.button__danger,.manage-allocation-form-accept__cancel,.manage-allocation-form__reset,.manage-allocation-modal-form__reset,.manage-allocation-modal-list__btn-block,.manage-allocation-modal-overlay-form__button-reset,.manage-allocation-request-form__button-cancel{padding:5px 30px;font-size:14px;line-height:1.6;border-radius:3px;color:#f3f3f4;background-color:#d95a4b;border-color:#d95a4b;cursor:pointer;border:1px solid;transition:.2s ease;transition-property:background-color,border-color;font-weight:700;text-decoration:none!important;border:1px solid #c73b2a}.admin-edit-modal-form-accept__cancel:focus,.admin-edit-modal-form__btn-delete:focus,.button__danger.focus,.button__danger:focus,.focus.admin-edit-modal-form-accept__cancel,.focus.admin-edit-modal-form__btn-delete,.focus.manage-allocation-form-accept__cancel,.focus.manage-allocation-form__reset,.focus.manage-allocation-modal-form__reset,.focus.manage-allocation-modal-list__btn-block,.focus.manage-allocation-modal-overlay-form__button-reset,.focus.manage-allocation-request-form__button-cancel,.manage-allocation-form-accept__cancel:focus,.manage-allocation-form__reset:focus,.manage-allocation-modal-form__reset:focus,.manage-allocation-modal-list__btn-block:focus,.manage-allocation-modal-overlay-form__button-reset:focus,.manage-allocation-request-form__button-cancel:focus{color:#f3f3f4;background-color:#c73b2a;border-color:#88281d}.admin-edit-modal-form-accept__cancel:hover,.admin-edit-modal-form__btn-delete:hover,.button__danger:hover,.manage-allocation-form-accept__cancel:hover,.manage-allocation-form__reset:hover,.manage-allocation-modal-form__reset:hover,.manage-allocation-modal-list__btn-block:hover,.manage-allocation-modal-overlay-form__button-reset:hover,.manage-allocation-request-form__button-cancel:hover{color:#f3f3f4;background-color:#c73b2a;border-color:#bf3828}.active.admin-edit-modal-form-accept__cancel,.active.admin-edit-modal-form__btn-delete,.active.manage-allocation-form-accept__cancel,.active.manage-allocation-form__reset,.active.manage-allocation-modal-form__reset,.active.manage-allocation-modal-list__btn-block,.active.manage-allocation-modal-overlay-form__button-reset,.active.manage-allocation-request-form__button-cancel,.admin-edit-modal-form-accept__cancel:active,.admin-edit-modal-form__btn-delete:active,.button__danger.active,.button__danger:active,.manage-allocation-form-accept__cancel:active,.manage-allocation-form__reset:active,.manage-allocation-modal-form__reset:active,.manage-allocation-modal-list__btn-block:active,.manage-allocation-modal-overlay-form__button-reset:active,.manage-allocation-request-form__button-cancel:active,.open>.button__danger.dropdown-toggle,.open>.dropdown-toggle.admin-edit-modal-form-accept__cancel,.open>.dropdown-toggle.admin-edit-modal-form__btn-delete,.open>.dropdown-toggle.manage-allocation-form-accept__cancel,.open>.dropdown-toggle.manage-allocation-form__reset,.open>.dropdown-toggle.manage-allocation-modal-form__reset,.open>.dropdown-toggle.manage-allocation-modal-list__btn-block,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-reset,.open>.dropdown-toggle.manage-allocation-request-form__button-cancel{color:#f3f3f4;background-color:#c73b2a;background-image:none;border-color:#bf3828}.active.admin-edit-modal-form-accept__cancel:focus,.active.admin-edit-modal-form-accept__cancel:hover,.active.admin-edit-modal-form__btn-delete:focus,.active.admin-edit-modal-form__btn-delete:hover,.active.focus.admin-edit-modal-form-accept__cancel,.active.focus.admin-edit-modal-form__btn-delete,.active.focus.manage-allocation-form-accept__cancel,.active.focus.manage-allocation-form__reset,.active.focus.manage-allocation-modal-form__reset,.active.focus.manage-allocation-modal-list__btn-block,.active.focus.manage-allocation-modal-overlay-form__button-reset,.active.focus.manage-allocation-request-form__button-cancel,.active.manage-allocation-form-accept__cancel:focus,.active.manage-allocation-form-accept__cancel:hover,.active.manage-allocation-form__reset:focus,.active.manage-allocation-form__reset:hover,.active.manage-allocation-modal-form__reset:focus,.active.manage-allocation-modal-form__reset:hover,.active.manage-allocation-modal-list__btn-block:focus,.active.manage-allocation-modal-list__btn-block:hover,.active.manage-allocation-modal-overlay-form__button-reset:focus,.active.manage-allocation-modal-overlay-form__button-reset:hover,.active.manage-allocation-request-form__button-cancel:focus,.active.manage-allocation-request-form__button-cancel:hover,.admin-edit-modal-form-accept__cancel:active.focus,.admin-edit-modal-form-accept__cancel:active:focus,.admin-edit-modal-form-accept__cancel:active:hover,.admin-edit-modal-form__btn-delete:active.focus,.admin-edit-modal-form__btn-delete:active:focus,.admin-edit-modal-form__btn-delete:active:hover,.button__danger.active.focus,.button__danger.active:focus,.button__danger.active:hover,.button__danger:active.focus,.button__danger:active:focus,.button__danger:active:hover,.manage-allocation-form-accept__cancel:active.focus,.manage-allocation-form-accept__cancel:active:focus,.manage-allocation-form-accept__cancel:active:hover,.manage-allocation-form__reset:active.focus,.manage-allocation-form__reset:active:focus,.manage-allocation-form__reset:active:hover,.manage-allocation-modal-form__reset:active.focus,.manage-allocation-modal-form__reset:active:focus,.manage-allocation-modal-form__reset:active:hover,.manage-allocation-modal-list__btn-block:active.focus,.manage-allocation-modal-list__btn-block:active:focus,.manage-allocation-modal-list__btn-block:active:hover,.manage-allocation-modal-overlay-form__button-reset:active.focus,.manage-allocation-modal-overlay-form__button-reset:active:focus,.manage-allocation-modal-overlay-form__button-reset:active:hover,.manage-allocation-request-form__button-cancel:active.focus,.manage-allocation-request-form__button-cancel:active:focus,.manage-allocation-request-form__button-cancel:active:hover,.open>.button__danger.dropdown-toggle.focus,.open>.button__danger.dropdown-toggle:focus,.open>.button__danger.dropdown-toggle:hover,.open>.dropdown-toggle.admin-edit-modal-form-accept__cancel:focus,.open>.dropdown-toggle.admin-edit-modal-form-accept__cancel:hover,.open>.dropdown-toggle.admin-edit-modal-form__btn-delete:focus,.open>.dropdown-toggle.admin-edit-modal-form__btn-delete:hover,.open>.dropdown-toggle.focus.admin-edit-modal-form-accept__cancel,.open>.dropdown-toggle.focus.admin-edit-modal-form__btn-delete,.open>.dropdown-toggle.focus.manage-allocation-form-accept__cancel,.open>.dropdown-toggle.focus.manage-allocation-form__reset,.open>.dropdown-toggle.focus.manage-allocation-modal-form__reset,.open>.dropdown-toggle.focus.manage-allocation-modal-list__btn-block,.open>.dropdown-toggle.focus.manage-allocation-modal-overlay-form__button-reset,.open>.dropdown-toggle.focus.manage-allocation-request-form__button-cancel,.open>.dropdown-toggle.manage-allocation-form-accept__cancel:focus,.open>.dropdown-toggle.manage-allocation-form-accept__cancel:hover,.open>.dropdown-toggle.manage-allocation-form__reset:focus,.open>.dropdown-toggle.manage-allocation-form__reset:hover,.open>.dropdown-toggle.manage-allocation-modal-form__reset:focus,.open>.dropdown-toggle.manage-allocation-modal-form__reset:hover,.open>.dropdown-toggle.manage-allocation-modal-list__btn-block:focus,.open>.dropdown-toggle.manage-allocation-modal-list__btn-block:hover,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-reset:focus,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-reset:hover,.open>.dropdown-toggle.manage-allocation-request-form__button-cancel:focus,.open>.dropdown-toggle.manage-allocation-request-form__button-cancel:hover{color:#f3f3f4;background-color:#aa3224;border-color:#88281d}.admin-edit-modal-form-accept__cancel[disabled].focus,.admin-edit-modal-form-accept__cancel[disabled]:focus,.admin-edit-modal-form-accept__cancel[disabled]:hover,.admin-edit-modal-form__btn-delete[disabled].focus,.admin-edit-modal-form__btn-delete[disabled]:focus,.admin-edit-modal-form__btn-delete[disabled]:hover,.button__danger.disabled.focus,.button__danger.disabled:focus,.button__danger.disabled:hover,.button__danger[disabled].focus,.button__danger[disabled]:focus,.button__danger[disabled]:hover,.disabled.admin-edit-modal-form-accept__cancel:focus,.disabled.admin-edit-modal-form-accept__cancel:hover,.disabled.admin-edit-modal-form__btn-delete:focus,.disabled.admin-edit-modal-form__btn-delete:hover,.disabled.focus.admin-edit-modal-form-accept__cancel,.disabled.focus.admin-edit-modal-form__btn-delete,.disabled.focus.manage-allocation-form-accept__cancel,.disabled.focus.manage-allocation-form__reset,.disabled.focus.manage-allocation-modal-form__reset,.disabled.focus.manage-allocation-modal-list__btn-block,.disabled.focus.manage-allocation-modal-overlay-form__button-reset,.disabled.focus.manage-allocation-request-form__button-cancel,.disabled.manage-allocation-form-accept__cancel:focus,.disabled.manage-allocation-form-accept__cancel:hover,.disabled.manage-allocation-form__reset:focus,.disabled.manage-allocation-form__reset:hover,.disabled.manage-allocation-modal-form__reset:focus,.disabled.manage-allocation-modal-form__reset:hover,.disabled.manage-allocation-modal-list__btn-block:focus,.disabled.manage-allocation-modal-list__btn-block:hover,.disabled.manage-allocation-modal-overlay-form__button-reset:focus,.disabled.manage-allocation-modal-overlay-form__button-reset:hover,.disabled.manage-allocation-request-form__button-cancel:focus,.disabled.manage-allocation-request-form__button-cancel:hover,.manage-allocation-form-accept__cancel[disabled].focus,.manage-allocation-form-accept__cancel[disabled]:focus,.manage-allocation-form-accept__cancel[disabled]:hover,.manage-allocation-form__reset[disabled].focus,.manage-allocation-form__reset[disabled]:focus,.manage-allocation-form__reset[disabled]:hover,.manage-allocation-modal-form__reset[disabled].focus,.manage-allocation-modal-form__reset[disabled]:focus,.manage-allocation-modal-form__reset[disabled]:hover,.manage-allocation-modal-list__btn-block[disabled].focus,.manage-allocation-modal-list__btn-block[disabled]:focus,.manage-allocation-modal-list__btn-block[disabled]:hover,.manage-allocation-modal-overlay-form__button-reset[disabled].focus,.manage-allocation-modal-overlay-form__button-reset[disabled]:focus,.manage-allocation-modal-overlay-form__button-reset[disabled]:hover,.manage-allocation-request-form__button-cancel[disabled].focus,.manage-allocation-request-form__button-cancel[disabled]:focus,.manage-allocation-request-form__button-cancel[disabled]:hover,fieldset[disabled] .admin-edit-modal-form-accept__cancel:focus,fieldset[disabled] .admin-edit-modal-form-accept__cancel:hover,fieldset[disabled] .admin-edit-modal-form__btn-delete:focus,fieldset[disabled] .admin-edit-modal-form__btn-delete:hover,fieldset[disabled] .button__danger.focus,fieldset[disabled] .button__danger:focus,fieldset[disabled] .button__danger:hover,fieldset[disabled] .focus.admin-edit-modal-form-accept__cancel,fieldset[disabled] .focus.admin-edit-modal-form__btn-delete,fieldset[disabled] .focus.manage-allocation-form-accept__cancel,fieldset[disabled] .focus.manage-allocation-form__reset,fieldset[disabled] .focus.manage-allocation-modal-form__reset,fieldset[disabled] .focus.manage-allocation-modal-list__btn-block,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__button-reset,fieldset[disabled] .focus.manage-allocation-request-form__button-cancel,fieldset[disabled] .manage-allocation-form-accept__cancel:focus,fieldset[disabled] .manage-allocation-form-accept__cancel:hover,fieldset[disabled] .manage-allocation-form__reset:focus,fieldset[disabled] .manage-allocation-form__reset:hover,fieldset[disabled] .manage-allocation-modal-form__reset:focus,fieldset[disabled] .manage-allocation-modal-form__reset:hover,fieldset[disabled] .manage-allocation-modal-list__btn-block:focus,fieldset[disabled] .manage-allocation-modal-list__btn-block:hover,fieldset[disabled] .manage-allocation-modal-overlay-form__button-reset:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__button-reset:hover,fieldset[disabled] .manage-allocation-request-form__button-cancel:focus,fieldset[disabled] .manage-allocation-request-form__button-cancel:hover{background-color:#d95a4b;border-color:#d95a4b}.admin-edit-modal-form-accept__cancel .badge,.admin-edit-modal-form__btn-delete .badge,.button__danger .badge,.manage-allocation-form-accept__cancel .badge,.manage-allocation-form__reset .badge,.manage-allocation-modal-form__reset .badge,.manage-allocation-modal-list__btn-block .badge,.manage-allocation-modal-overlay-form__button-reset .badge,.manage-allocation-request-form__button-cancel .badge{color:#d95a4b;background-color:#f3f3f4}.admin-edit-modal-form-accept__cancel[disabled],.admin-edit-modal-form__btn-delete[disabled],.button__danger.disabled,.button__danger[disabled],.disabled.admin-edit-modal-form-accept__cancel,.disabled.admin-edit-modal-form__btn-delete,.disabled.manage-allocation-form-accept__cancel,.disabled.manage-allocation-form__reset,.disabled.manage-allocation-modal-form__reset,.disabled.manage-allocation-modal-list__btn-block,.disabled.manage-allocation-modal-overlay-form__button-reset,.disabled.manage-allocation-request-form__button-cancel,.manage-allocation-form-accept__cancel[disabled],.manage-allocation-form__reset[disabled],.manage-allocation-modal-form__reset[disabled],.manage-allocation-modal-list__btn-block[disabled],.manage-allocation-modal-overlay-form__button-reset[disabled],.manage-allocation-request-form__button-cancel[disabled],fieldset[disabled] .admin-edit-modal-form-accept__cancel,fieldset[disabled] .admin-edit-modal-form__btn-delete,fieldset[disabled] .button__danger,fieldset[disabled] .manage-allocation-form-accept__cancel,fieldset[disabled] .manage-allocation-form__reset,fieldset[disabled] .manage-allocation-modal-form__reset,fieldset[disabled] .manage-allocation-modal-list__btn-block,fieldset[disabled] .manage-allocation-modal-overlay-form__button-reset,fieldset[disabled] .manage-allocation-request-form__button-cancel{cursor:default;background-color:#e6948a;border-color:#e6948a}.admin-edit-modal-form-accept__cancel[disabled].focus,.admin-edit-modal-form-accept__cancel[disabled]:focus,.admin-edit-modal-form-accept__cancel[disabled]:hover,.admin-edit-modal-form__btn-delete[disabled].focus,.admin-edit-modal-form__btn-delete[disabled]:focus,.admin-edit-modal-form__btn-delete[disabled]:hover,.button__danger.disabled.focus,.button__danger.disabled:focus,.button__danger.disabled:hover,.button__danger[disabled].focus,.button__danger[disabled]:focus,.button__danger[disabled]:hover,.disabled.admin-edit-modal-form-accept__cancel:focus,.disabled.admin-edit-modal-form-accept__cancel:hover,.disabled.admin-edit-modal-form__btn-delete:focus,.disabled.admin-edit-modal-form__btn-delete:hover,.disabled.focus.admin-edit-modal-form-accept__cancel,.disabled.focus.admin-edit-modal-form__btn-delete,.disabled.focus.manage-allocation-form-accept__cancel,.disabled.focus.manage-allocation-form__reset,.disabled.focus.manage-allocation-modal-form__reset,.disabled.focus.manage-allocation-modal-list__btn-block,.disabled.focus.manage-allocation-modal-overlay-form__button-reset,.disabled.focus.manage-allocation-request-form__button-cancel,.disabled.manage-allocation-form-accept__cancel:focus,.disabled.manage-allocation-form-accept__cancel:hover,.disabled.manage-allocation-form__reset:focus,.disabled.manage-allocation-form__reset:hover,.disabled.manage-allocation-modal-form__reset:focus,.disabled.manage-allocation-modal-form__reset:hover,.disabled.manage-allocation-modal-list__btn-block:focus,.disabled.manage-allocation-modal-list__btn-block:hover,.disabled.manage-allocation-modal-overlay-form__button-reset:focus,.disabled.manage-allocation-modal-overlay-form__button-reset:hover,.disabled.manage-allocation-request-form__button-cancel:focus,.disabled.manage-allocation-request-form__button-cancel:hover,.manage-allocation-form-accept__cancel[disabled].focus,.manage-allocation-form-accept__cancel[disabled]:focus,.manage-allocation-form-accept__cancel[disabled]:hover,.manage-allocation-form__reset[disabled].focus,.manage-allocation-form__reset[disabled]:focus,.manage-allocation-form__reset[disabled]:hover,.manage-allocation-modal-form__reset[disabled].focus,.manage-allocation-modal-form__reset[disabled]:focus,.manage-allocation-modal-form__reset[disabled]:hover,.manage-allocation-modal-list__btn-block[disabled].focus,.manage-allocation-modal-list__btn-block[disabled]:focus,.manage-allocation-modal-list__btn-block[disabled]:hover,.manage-allocation-modal-overlay-form__button-reset[disabled].focus,.manage-allocation-modal-overlay-form__button-reset[disabled]:focus,.manage-allocation-modal-overlay-form__button-reset[disabled]:hover,.manage-allocation-request-form__button-cancel[disabled].focus,.manage-allocation-request-form__button-cancel[disabled]:focus,.manage-allocation-request-form__button-cancel[disabled]:hover,fieldset[disabled] .admin-edit-modal-form-accept__cancel:focus,fieldset[disabled] .admin-edit-modal-form-accept__cancel:hover,fieldset[disabled] .admin-edit-modal-form__btn-delete:focus,fieldset[disabled] .admin-edit-modal-form__btn-delete:hover,fieldset[disabled] .button__danger.focus,fieldset[disabled] .button__danger:focus,fieldset[disabled] .button__danger:hover,fieldset[disabled] .focus.admin-edit-modal-form-accept__cancel,fieldset[disabled] .focus.admin-edit-modal-form__btn-delete,fieldset[disabled] .focus.manage-allocation-form-accept__cancel,fieldset[disabled] .focus.manage-allocation-form__reset,fieldset[disabled] .focus.manage-allocation-modal-form__reset,fieldset[disabled] .focus.manage-allocation-modal-list__btn-block,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__button-reset,fieldset[disabled] .focus.manage-allocation-request-form__button-cancel,fieldset[disabled] .manage-allocation-form-accept__cancel:focus,fieldset[disabled] .manage-allocation-form-accept__cancel:hover,fieldset[disabled] .manage-allocation-form__reset:focus,fieldset[disabled] .manage-allocation-form__reset:hover,fieldset[disabled] .manage-allocation-modal-form__reset:focus,fieldset[disabled] .manage-allocation-modal-form__reset:hover,fieldset[disabled] .manage-allocation-modal-list__btn-block:focus,fieldset[disabled] .manage-allocation-modal-list__btn-block:hover,fieldset[disabled] .manage-allocation-modal-overlay-form__button-reset:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__button-reset:hover,fieldset[disabled] .manage-allocation-request-form__button-cancel:focus,fieldset[disabled] .manage-allocation-request-form__button-cancel:hover{background-color:#e6948a;border-color:#e6948a}.button__danger--lg{padding:8.4px 30px;font-size:17px;line-height:1.6;border-radius:3px}.button__danger--sm{padding:5px 15px;font-size:13px;line-height:1.6;border-radius:3px}.button__danger--xs{padding:5px 10px;font-size:12px;line-height:1.6;border-radius:3px}.admin-edit-modal-form__btn-block,.button__warning,.manage-allocation-modal-overlay-form__button-request{padding:5px 30px;font-size:14px;line-height:1.6;border-radius:3px;color:#f3f3f4;background-color:#f4a830;border-color:#f4a830;cursor:pointer;border:1px solid;transition:.2s ease;transition-property:background-color,border-color;font-weight:700;text-decoration:none!important;border:1px solid #e5910c}.admin-edit-modal-form__btn-block:focus,.button__warning.focus,.button__warning:focus,.focus.admin-edit-modal-form__btn-block,.focus.manage-allocation-modal-overlay-form__button-request,.manage-allocation-modal-overlay-form__button-request:focus{color:#f3f3f4;background-color:#e5910c;border-color:#9c6308}.admin-edit-modal-form__btn-block:hover,.button__warning:hover,.manage-allocation-modal-overlay-form__button-request:hover{color:#f3f3f4;background-color:#e5910c;border-color:#db8b0c}.active.admin-edit-modal-form__btn-block,.active.manage-allocation-modal-overlay-form__button-request,.admin-edit-modal-form__btn-block:active,.button__warning.active,.button__warning:active,.manage-allocation-modal-overlay-form__button-request:active,.open>.button__warning.dropdown-toggle,.open>.dropdown-toggle.admin-edit-modal-form__btn-block,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-request{color:#f3f3f4;background-color:#e5910c;background-image:none;border-color:#db8b0c}.active.admin-edit-modal-form__btn-block:focus,.active.admin-edit-modal-form__btn-block:hover,.active.focus.admin-edit-modal-form__btn-block,.active.focus.manage-allocation-modal-overlay-form__button-request,.active.manage-allocation-modal-overlay-form__button-request:focus,.active.manage-allocation-modal-overlay-form__button-request:hover,.admin-edit-modal-form__btn-block:active.focus,.admin-edit-modal-form__btn-block:active:focus,.admin-edit-modal-form__btn-block:active:hover,.button__warning.active.focus,.button__warning.active:focus,.button__warning.active:hover,.button__warning:active.focus,.button__warning:active:focus,.button__warning:active:hover,.manage-allocation-modal-overlay-form__button-request:active.focus,.manage-allocation-modal-overlay-form__button-request:active:focus,.manage-allocation-modal-overlay-form__button-request:active:hover,.open>.button__warning.dropdown-toggle.focus,.open>.button__warning.dropdown-toggle:focus,.open>.button__warning.dropdown-toggle:hover,.open>.dropdown-toggle.admin-edit-modal-form__btn-block:focus,.open>.dropdown-toggle.admin-edit-modal-form__btn-block:hover,.open>.dropdown-toggle.focus.admin-edit-modal-form__btn-block,.open>.dropdown-toggle.focus.manage-allocation-modal-overlay-form__button-request,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-request:focus,.open>.dropdown-toggle.manage-allocation-modal-overlay-form__button-request:hover{color:#f3f3f4;background-color:#c37b0a;border-color:#9c6308}.admin-edit-modal-form__btn-block[disabled].focus,.admin-edit-modal-form__btn-block[disabled]:focus,.admin-edit-modal-form__btn-block[disabled]:hover,.button__warning.disabled.focus,.button__warning.disabled:focus,.button__warning.disabled:hover,.button__warning[disabled].focus,.button__warning[disabled]:focus,.button__warning[disabled]:hover,.disabled.admin-edit-modal-form__btn-block:focus,.disabled.admin-edit-modal-form__btn-block:hover,.disabled.focus.admin-edit-modal-form__btn-block,.disabled.focus.manage-allocation-modal-overlay-form__button-request,.disabled.manage-allocation-modal-overlay-form__button-request:focus,.disabled.manage-allocation-modal-overlay-form__button-request:hover,.manage-allocation-modal-overlay-form__button-request[disabled].focus,.manage-allocation-modal-overlay-form__button-request[disabled]:focus,.manage-allocation-modal-overlay-form__button-request[disabled]:hover,fieldset[disabled] .admin-edit-modal-form__btn-block:focus,fieldset[disabled] .admin-edit-modal-form__btn-block:hover,fieldset[disabled] .button__warning.focus,fieldset[disabled] .button__warning:focus,fieldset[disabled] .button__warning:hover,fieldset[disabled] .focus.admin-edit-modal-form__btn-block,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__button-request,fieldset[disabled] .manage-allocation-modal-overlay-form__button-request:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__button-request:hover{background-color:#f4a830;border-color:#f4a830}.admin-edit-modal-form__btn-block .badge,.button__warning .badge,.manage-allocation-modal-overlay-form__button-request .badge{color:#f4a830;background-color:#f3f3f4}.admin-edit-modal-form__btn-block[disabled],.button__warning.disabled,.button__warning[disabled],.disabled.admin-edit-modal-form__btn-block,.disabled.manage-allocation-modal-overlay-form__button-request,.manage-allocation-modal-overlay-form__button-request[disabled],fieldset[disabled] .admin-edit-modal-form__btn-block,fieldset[disabled] .button__warning,fieldset[disabled] .manage-allocation-modal-overlay-form__button-request{cursor:default;background-color:#f8c779;border-color:#f8c779}.admin-edit-modal-form__btn-block[disabled].focus,.admin-edit-modal-form__btn-block[disabled]:focus,.admin-edit-modal-form__btn-block[disabled]:hover,.button__warning.disabled.focus,.button__warning.disabled:focus,.button__warning.disabled:hover,.button__warning[disabled].focus,.button__warning[disabled]:focus,.button__warning[disabled]:hover,.disabled.admin-edit-modal-form__btn-block:focus,.disabled.admin-edit-modal-form__btn-block:hover,.disabled.focus.admin-edit-modal-form__btn-block,.disabled.focus.manage-allocation-modal-overlay-form__button-request,.disabled.manage-allocation-modal-overlay-form__button-request:focus,.disabled.manage-allocation-modal-overlay-form__button-request:hover,.manage-allocation-modal-overlay-form__button-request[disabled].focus,.manage-allocation-modal-overlay-form__button-request[disabled]:focus,.manage-allocation-modal-overlay-form__button-request[disabled]:hover,fieldset[disabled] .admin-edit-modal-form__btn-block:focus,fieldset[disabled] .admin-edit-modal-form__btn-block:hover,fieldset[disabled] .button__warning.focus,fieldset[disabled] .button__warning:focus,fieldset[disabled] .button__warning:hover,fieldset[disabled] .focus.admin-edit-modal-form__btn-block,fieldset[disabled] .focus.manage-allocation-modal-overlay-form__button-request,fieldset[disabled] .manage-allocation-modal-overlay-form__button-request:focus,fieldset[disabled] .manage-allocation-modal-overlay-form__button-request:hover{background-color:#f8c779;border-color:#f8c779}.button__warning--lg{padding:8.4px 30px;font-size:17px;line-height:1.6;border-radius:3px}.button__warning--sm{padding:5px 15px;font-size:13px;line-height:1.6;border-radius:3px}.button__warning--xs{padding:5px 10px;font-size:12px;line-height:1.6;border-radius:3px}.activate-user-page__alert--error,.activate-user-page__alert--success,.activate-user-page__alert--warning,.alert,.forgot-password-page__alert--error,.forgot-password-page__alert--success,.forgot-password-page__alert--warning,.manage-allocation-form__error,.manage-allocation-modal-form__error,.manage-allocation-modal-overlay-form__alert,.manage-allocation-modal-overlay__success,.reset-password-page__alert--error,.reset-password-page__alert--success,.reset-password-page__alert--warning,.sign-in-page__alert--error,.sign-in-page__alert--info,.sign-in-page__alert--warning{padding:15px 30px;border-radius:3px;border:1px solid;margin-bottom:15px}.activate-user-page__alert--warning,.alert--warning,.forgot-password-page__alert--warning,.manage-allocation-modal-overlay-form__alert--warning,.reset-password-page__alert--warning,.sign-in-page__alert--warning{color:#845407;background-color:#fce5c1;border-color:#f8c779}.activate-user-page__alert--warning hr,.alert--warning hr,.forgot-password-page__alert--warning hr,.manage-allocation-modal-overlay-form__alert--warning hr,.reset-password-page__alert--warning hr,.sign-in-page__alert--warning hr{border-top-color:#f7bc60}.activate-user-page__alert--warning .alert-link,.alert--warning .alert-link,.forgot-password-page__alert--warning .alert-link,.manage-allocation-modal-overlay-form__alert--warning .alert-link,.reset-password-page__alert--warning .alert-link,.sign-in-page__alert--warning .alert-link{color:#543504}.activate-user-page__alert--error,.alert--danger,.forgot-password-page__alert--error,.manage-allocation-form__error,.manage-allocation-modal-form__error,.manage-allocation-modal-overlay-form__alert--danger,.reset-password-page__alert--error,.sign-in-page__alert--error{color:#732218;background-color:#f4cec9;border-color:#e6948a}.activate-user-page__alert--error hr,.alert--danger hr,.forgot-password-page__alert--error hr,.manage-allocation-form__error hr,.manage-allocation-modal-form__error hr,.manage-allocation-modal-overlay-form__alert--danger hr,.reset-password-page__alert--error hr,.sign-in-page__alert--error hr{border-top-color:#e28175}.activate-user-page__alert--error .alert-link,.alert--danger .alert-link,.forgot-password-page__alert--error .alert-link,.manage-allocation-form__error .alert-link,.manage-allocation-modal-form__error .alert-link,.manage-allocation-modal-overlay-form__alert--danger .alert-link,.reset-password-page__alert--error .alert-link,.sign-in-page__alert--error .alert-link{color:#49150f}.alert--info,.manage-allocation-modal-overlay-form__alert--info,.sign-in-page__alert--info{color:#1f7e9a;background-color:#daf1f8;border-color:#5bc0de}.alert--info hr,.manage-allocation-modal-overlay-form__alert--info hr,.sign-in-page__alert--info hr{border-top-color:#46b8da}.alert--info .alert-link,.manage-allocation-modal-overlay-form__alert--info .alert-link,.sign-in-page__alert--info .alert-link{color:#175b70}.alert--primary{color:#27676b;background-color:#d4eef0;border-color:#9cd7db}.alert--primary hr{border-top-color:#89d0d5}.alert--primary .alert-link{color:#194346}.activate-user-page__alert--success,.alert--success,.forgot-password-page__alert--success,.manage-allocation-modal-overlay__success,.reset-password-page__alert--success{color:#205338;background-color:#bfe6d1;border-color:#88d0aa}.activate-user-page__alert--success hr,.alert--success hr,.forgot-password-page__alert--success hr,.manage-allocation-modal-overlay__success hr,.reset-password-page__alert--success hr{border-top-color:#76c99d}.activate-user-page__alert--success .alert-link,.alert--success .alert-link,.forgot-password-page__alert--success .alert-link,.manage-allocation-modal-overlay__success .alert-link,.reset-password-page__alert--success .alert-link{color:#122e1f}.account-activity,.account-avatar,.account-form,.account-notifications,.account-password,.admin-create-modal__content,.admin-edit-modal-form-accept__body,.admin-edit-modal__content,.admin-list,.admin-page__error,.admin-page__header,.admin-page__success,.allocation-filters,.allocation-list,.booking-filters,.booking-list,.card,.card-slim,.contract-form-accept__content,.contract-form-alert__error,.contract-form-email__content,.contract-form-progress,.contract-form__content,.contract-list-overview,.contract-management-edit-control,.contract-management-edit-email__content,.contract-management-edit-form,.contract-management-edit-progress,.contract-management-list,.contract-notes__content,.dashboard-availability__content,.dashboard-graph__content,.dashboard-notifications__content,.dashboard-welcome__left,.dashboard-welcome__right,.date-picker__body,.instruction,.manage-allocation-calendar,.manage-allocation-calendar-infobox,.manage-allocation-filters,.manage-allocation-form,.manage-allocation-form-accept__body,.manage-allocation-list,.manage-allocation-modal-overlay__content,.manage-allocation-modal__content,.manage-allocation-page__alert,.manage-allocation-page__fake,.manage-allocation-page__mobile,.manage-allocation-request-form__content,.manage-allocation-request__content,.message,.stat-filters,.stat-inventory,.stat-list,.stat-sites{background-color:#fff;padding:15px;-webkit-box-shadow:0 0 15px 3px rgba(0,0,0,.08);-moz-box-shadow:0 0 15px 3px rgba(0,0,0,.08);-o-box-shadow:0 0 15px 3px rgba(0,0,0,.08);box-shadow:0 0 15px 3px rgba(0,0,0,.08);margin-bottom:15px}.account-activity,.account-avatar,.account-form,.account-notifications,.account-password,.admin-list,.admin-page__error,.admin-page__header,.admin-page__success,.allocation-list,.booking-filters,.booking-list,.card-slim,.contract-form-accept__content,.contract-form-alert__error,.contract-form-email__content,.contract-form-progress,.contract-form__content,.contract-list-overview,.contract-management-edit-control,.contract-management-edit-email__content,.contract-management-edit-form,.contract-management-edit-progress,.contract-management-list,.contract-notes__content,.dashboard-availability__content,.dashboard-graph__content,.dashboard-notifications__content,.dashboard-welcome__left,.dashboard-welcome__right,.instruction,.manage-allocation-calendar,.manage-allocation-calendar-infobox,.manage-allocation-form,.manage-allocation-list,.manage-allocation-modal-overlay__content,.manage-allocation-modal__content,.manage-allocation-page__alert,.manage-allocation-page__fake,.manage-allocation-page__mobile,.manage-allocation-request-form__content,.manage-allocation-request__content,.message,.stat-inventory,.stat-list,.stat-sites{padding:0}body{overflow-x:hidden}.field,.field-disabled,.field-edit,.field-info,.manage-allocation-modal-overlay-form__edit,.manage-allocation-modal-overlay-form__form-item,.manage-allocation-modal-overlay-form__form-item--editable,.manage-allocation-modal-overlay-form__form-item--null,.manage-allocation-modal-overlay-form__instruction,.manage-allocation-modal-overlay-form__item-list,.manage-allocation-modal-overlay-form__statistics{cursor:default;padding:15px;border:1px solid #e7e7e7;margin-bottom:15px}.field-edit,.manage-allocation-modal-overlay-form__form-item--editable{cursor:pointer}.field-edit:before,.manage-allocation-modal-overlay-form__form-item--editable:before{content:\"\\F044\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900}.field-info{background-color:#f2f2f2;color:#7d7e83}.field-disabled,.manage-allocation-modal-overlay-form__form-item--null{cursor:default;color:#d9d9d9;border-color:#f7f7f7}.fade-enter{opacity:0}.fade-enter-to,.fade-leave{opacity:1}.fade-leave-to{opacity:0}.fade-enter-active,.fade-leave-active{transition:opacity .3s}.fake-primary,.stat-number__fake-label,.stat-number__fake-subtitle,.stat-number__fake-value{border-radius:3px;background:linear-gradient(90deg,#77c8ce 0,#77c8ce 30%,#89d0d5 50%,#77c8ce 70%,#77c8ce);background-size:400% 400%;animation:gradientFlashPrimary 2s ease infinite}.fake-grey,.stat-number--alternative .stat-number__fake-label,.stat-number--alternative .stat-number__fake-subtitle,.stat-number--alternative .stat-number__fake-value{border-radius:3px;background:linear-gradient(90deg,#8a8b8f 0,#8a8b8f 30%,#97989c 50%,#8a8b8f 70%,#8a8b8f);background-size:400% 400%;animation:gradientFlashPrimary 2s ease infinite}.allocation-filters__fake-cell,.fake-white,.fake__body-cell,.fake__header-cell,.stat-inventory__fake-bar,.stat-sites__fake-bar{border-radius:3px;background:linear-gradient(90deg,#fafafa 0,#fafafa 30%,#f5f5f5 50%,#fafafa 70%,#fafafa);background-size:400% 400%;animation:gradientFlashPrimary 2s ease infinite}@keyframes gradientFlashPrimary{0%{background-position:0 50%}to{background-position:100% 50%}}.slide-in-enter{margin-left:-100%}.slide-in-enter-to,.slide-in-leave{margin-left:0}.slide-in-leave-to{margin-left:-100%}.slide-in-enter-active,.slide-in-leave-active{transition:margin-left .3s}.slide-top-enter-active{transition:all .3s ease}.slide-top-leave-active{transition:all .3s cubic-bezier(1,.5,.8,1)}.slide-top-enter,.slide-top-leave-to{transform:translate(200px) scaleX(.5);opacity:0}.slide-fade-enter-active{transition:all .3s ease}.slide-fade-leave-active{transition:all .3s cubic-bezier(1,.5,.8,1)}.slide-fade-enter,.slide-fade-leave-to{transform:translate(200px) scale(.5);opacity:0}.expand-vertical-enter-active,.expand-vertical-leave-active{transition:all .3s ease}.expand-vertical-enter,.expand-vertical-leave-to{transform:scaleY(.1);opacity:0}.message{position:fixed;top:60px;right:0;height:71px;text-align:center;padding:25px 35px 35px 45px;opacity:.95;z-index:100}.message--info{background-color:#f2f2f2;color:#717176}.message--info:before{content:\"\\F06A\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);left:15px;padding-right:30px;font-size:24px}.message--success{background-color:#bfe6d1;color:#368a5d}.message--success:before{content:\"\\F164\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);left:15px;padding-right:30px;font-size:24px}.message--warning{background-color:#fce5c1;color:#cd810b}.message--warning:before{content:\"\\F071\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);left:15px;padding-right:30px;font-size:24px}.message--danger{background-color:#f4cec9;color:#b23426}.message--danger:before{content:\"\\F165\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);left:15px;padding-right:30px;font-size:24px}.fake__content{height:100%;margin:15px}.fake__header-row{height:70px}.fake__header-row:first-child{padding-top:15px}.fake__header-cell{height:70px;border:4px solid #fff;padding:2px;float:right}.fake__body-row{height:40px;width:100%;padding-top:15px}.fake__body-row:last-child{margin-bottom:30px}.fake__body-cell{height:40px;border:4px solid #fff;padding:2px;float:right}.pre-loader{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.6);z-index:9}.pre-loader__loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:40px;height:40px;background-color:#64c1c7;display:inline-block;border-radius:100%;animation:sk-scaleout 1s infinite ease-in-out}@keyframes sk-scaleout{0%{transform:scale(0)}to{transform:scale(1);opacity:0}}.auto-complete__input{position:relative;height:50px;display:inline-block;width:100%}.auto-complete__input-field{position:absolute;width:100%;height:50px;padding-left:15px;font-size:14px;border:1px solid #e7e7e7;background-color:transparent}@media screen and (min-width:992px){.auto-complete__input-field{font-size:18px}}.auto-complete__input-field:focus{outline:none}.auto-complete__input-pseudo{line-height:50px;opacity:.5;z-index:1}.auto-complete__drop-down{position:relative;width:100%}.auto-complete__list{position:absolute;left:0;top:0;background-color:#fff;width:100%;border-bottom:1px solid #e7e7e7;border-left:1px solid #e7e7e7;border-right:1px solid #e7e7e7;box-shadow:0 10px 15px 0 rgba(0,0,0,.08);max-height:250px;overflow-y:auto;z-index:999}.auto-complete__choice{height:50px;line-height:50px;padding:0 15px;z-index:500;position:relative}.auto-complete__choice:not(:last-child){border-bottom:1px solid #e7e7e7}.auto-complete__choice:hover{background-color:#f7f7f7;cursor:pointer}.auto-complete__choice--selected:after{content:\"\\F00C\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none;color:#64c1c7}.auto-complete__choice--active{background-color:#f7f7f7}.auto-complete__input-icon{width:100%;float:right;text-align:right;position:absolute;padding:15px;color:#e6948a}.auto-complete-multi__input-fields{height:50px}.auto-complete-multi__input{position:absolute;width:calc(100% - 60px);height:50px;padding-left:15px;font-size:17px;text-transform:capitalize}.auto-complete-multi__input-field{border:1px solid #e7e7e7;z-index:2;background-color:transparent}.auto-complete-multi__input-field:focus{outline:none}.auto-complete-multi__input-field--no-result{border:2px solid #ebccd1}.auto-complete-multi__input-pseudo{line-height:50px;opacity:.5;z-index:1}.auto-complete-multi__selected-items{padding:10px;text-transform:capitalize}.auto-complete-multi__item{cursor:default;display:inline-block;background-color:#64c1c7;color:#fff;padding:3px 10px;border-radius:15px;margin:3px}.auto-complete-multi__item-remove{cursor:pointer;transition:all .2s ease;opacity:.5}.auto-complete-multi__item-remove:hover{opacity:1}.auto-complete-multi__drop-down{position:relative}.auto-complete-multi__list{position:absolute;left:0;top:0;background-color:#fff;width:100%;border-bottom:1px solid #e7e7e7;border-left:1px solid #e7e7e7;border-right:1px solid #e7e7e7;box-shadow:0 10px 15px 0 rgba(0,0,0,.08);max-height:250px;overflow-y:auto;z-index:999}.auto-complete-multi__choice{height:50px;line-height:50px;padding:0 15px;z-index:500;position:relative}.auto-complete-multi__choice:not(:last-child){border-bottom:1px solid #e7e7e7}.auto-complete-multi__choice:hover{background-color:#f7f7f7;cursor:pointer}.auto-complete-multi__choice--selected:after{content:\"\\F00C\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none;color:#64c1c7}.account-form{width:100%;float:left;margin-left:0}@media screen and (min-width:768px){.account-form{height:320px;width:50%}}@media screen and (min-width:992px){.account-form{width:calc(35% - 15px);margin-left:15px}}.account-form__header{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.account-form__inputs{margin-top:10px;padding:15px;text-align:center}@media screen and (min-width:768px){.account-form__inputs{text-align:left}}.account-form__input-field>label{width:100%}@media screen and (min-width:768px){.account-form__input-field>label{width:130px}}.account-form__input-field:nth-child(3){margin-top:15px}.account-form__input{background:none;border:none;border-bottom:1px solid #e7e7e7;text-align:center;font-size:18px;width:120px}@media screen and (min-width:768px){.account-form__input{text-align:left;font-size:14px}}.account-form__input:focus{outline:none}.account-form__input:disabled{border:none}.account-form__input--error,.account-form__input--success{border-bottom:1px solid #e7e7e7}.account-form__input--error{border-color:#d95a4b}.account-form__error{font-size:10px;color:#e6948a;padding-left:0}@media screen and (min-width:768px){.account-form__error{padding-left:135px}}.account-form__buttons{width:100%;margin-top:10px;float:left}.account-form__button-group{position:relative;left:50%;transform:translateX(-50%);display:inline-block;margin-bottom:15px}.account-form__btn{width:100px}.account-form__btn:disabled{color:#d9d9d9;cursor:not-allowed;border:1px solid #e7e7e7}.account-form__btn:disabled:hover{border:1px solid #e7e7e7}.account-avatar{display:none;height:320px;width:30%;float:left}@media screen and (min-width:992px){.account-avatar{display:block}}.account-avatar__icon{position:relative;left:50%;transform:translateX(-50%);top:35px;width:250px;height:250px;text-align:center;background-color:#d9d9d9;border-radius:150px}.account-avatar__icon>i{padding-top:25px;color:#fff;font-size:200px}.account-password{width:100%;float:left;margin-left:0}@media screen and (min-width:768px){.account-password{height:320px;margin-left:15px;width:calc(50% - 15px)}}@media screen and (min-width:992px){.account-password{width:calc(35% - 15px)}}.account-password__header{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.account-password__input{background:none;border:none;border-bottom:1px solid #e7e7e7;text-align:center;font-size:18px;width:120px}@media screen and (min-width:768px){.account-password__input{text-align:left;font-size:14px}}.account-password__input:focus{outline:none}.account-password__input:disabled{border:none}.account-password__input--success{border-bottom:1px solid #e7e7e7}.account-password__input--error{border-bottom:1px solid #e7e7e7;border-color:#d95a4b}.account-password__passwords{margin-top:15px;padding:15px;float:left;width:100%;text-align:center}@media screen and (min-width:768px){.account-password__passwords{text-align:left}}.account-password__password>label{width:100%}@media screen and (min-width:768px){.account-password__password>label{width:130px}}.account-password__password:nth-child(2){margin-top:15px}.account-password__error{font-size:10px;color:#e6948a;padding-left:0;text-overflow:ellipsis;overflow:hidden;width:100%;height:15px}@media screen and (min-width:768px){.account-password__error{padding-left:135px}}.account-password__buttons{width:100%;margin-top:15px;float:left}.account-password__button-group{position:relative;left:50%;transform:translateX(-50%);display:inline-block;margin-bottom:15px}.account-password__btn{width:100px}.account-password__btn:disabled{color:#d9d9d9;cursor:not-allowed;border:1px solid #e7e7e7}.account-password__btn:disabled:hover{border:1px solid #e7e7e7}.account-activity{width:100%;float:left}.account-activity__heading{position:relative;font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7;width:100%;float:left}@media screen and (min-width:768px){.account-activity__heading{width:calc(100% - 350px)}}.account-activity__filter{float:right;height:71px;width:100%;border-bottom:1px solid #e7e7e7;border-left:1px solid #e7e7e7}@media screen and (min-width:768px){.account-activity__filter{width:200px}}.account-activity__months{font-size:17px;font-weight:400;text-align:center;float:right;height:71px;padding:23px 15px;width:100%;border-bottom:1px solid #e7e7e7;background-color:#f2f2f2}@media screen and (min-width:768px){.account-activity__months{width:150px;text-align:right;background-color:#fff}}.account-activity__table{border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;display:none;text-align:center}@media screen and (min-width:768px){.account-activity__table{display:table;font-size:12px}}@media screen and (min-width:992px){.account-activity__table{font-size:13px}}@media screen and (min-width:1200px){.account-activity__table{font-size:14px}}.account-activity__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center;width:20%}.account-activity__table tbody>tr>td{height:63px;vertical-align:middle;border-color:#e7e7e7;text-align:center;width:20%}.account-activity__footer{float:left;width:100%;height:71px;padding:15px}@media screen and (min-width:768px){.account-activity__footer{position:relative}}.account-activity__pagination{position:absolute;left:50%;transform:translateX(-50%);float:left;font-size:10px}@media screen and (min-width:768px){.account-activity__pagination{font-size:14px}}.account-activity__items{width:100%;float:left;display:block}@media screen and (min-width:768px){.account-activity__items{display:none}}.account-activity__no-content{height:384px;text-align:center;padding:15px}.account-activity__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.account-activity__no-content i.fa{font-size:96px}}@media screen and (max-width:767px){.account-activity__no-content i.fa{margin-top:30px}}.account-activity-item__header{height:40px}.account-activity-item__label{padding:0 15px;line-height:40px;width:calc(100% - 50px)}.account-activity-item__control,.account-activity-item__label{height:40px;position:relative;float:left;border-bottom:1px solid #e7e7e7}.account-activity-item__control{width:50px;border-left:1px solid #e7e7e7;cursor:pointer}.account-activity-item__control:hover{background-color:#f7f7f7}.account-activity-item__control i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.account-activity-item__content{border-bottom:1px solid #e7e7e7;padding:15px;background-color:#f7f7f7}.account-activity-item__props{border:1px solid #e7e7e7;background-color:#fff}.account-activity-item__prop{overflow-y:auto;border-bottom:1px solid #e7e7e7;padding:5px 0}.account-activity-item__prop-key{font-weight:700;text-align:center}.account-activity-item__prop-edit-value,.account-activity-item__prop-value{text-align:center}.account-notifications{width:100%;float:left;margin-left:0}.account-notifications__header{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.account-notifications__box,.account-notifications__notification-box{float:left;width:100%;text-align:center}.account-notifications__notification-checkbox{float:left;position:relative;padding-left:15px;width:50%}.account-notifications__notification-status{background-color:#f2f2f2;padding:15px;margin:15px}.account-notifications__display-edit{cursor:pointer;color:#64c1c7;margin-top:5px}.account-notifications__notification-edit{margin-top:15px}.account-notifications__notification-label{width:120px;margin-left:5px}@media screen and (max-width:767px){.account-notifications__notification-label{width:100%}}.account-notifications__notification-days{width:100%;float:left}.account-notifications__notification-week{width:100%;float:left;padding-top:10px;background-color:transparent}.account-notifications__notification-buttons{width:100%;float:left;margin:15px 0}.account-notifications__btn{width:100px}.account-notifications__checkbox{display:inline-block;cursor:pointer;height:13px;width:13px;background-image:url(" + escape(__webpack_require__(75)) + ");margin-left:5px}.account-notifications__checkbox--checked{background-image:url(" + escape(__webpack_require__(76)) + ")}.admin-page__header{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.admin-page__heading{font-size:18px}.admin-page__error{background-color:#f4cec9;color:#b23426}.admin-page__error,.admin-page__success{font-size:17px;width:100%;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7;text-align:center}.admin-page__success{background-color:#bfe6d1;color:#368a5d}.admin-list,.admin-list__heading{width:100%;float:left}.admin-list__heading{font-size:17px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.admin-list__heading{width:calc(100% - 250px)}}.admin-list__option{width:100%}@media screen and (max-width:767px){.admin-list__option:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.admin-list__option{border-bottom:none;float:left;width:25%}.admin-list__option:not(:nth-child(2)){border-left:1px solid #e7e7e7}}@media screen and (min-width:1200px){.admin-list__option{border-bottom:none;border-left:1px solid #e7e7e7;float:right;width:220px}}.admin-list__option--pagination{height:70px;padding-top:15px;text-align:center}@media screen and (max-width:767px){.admin-list__option--pagination{padding-left:15px;padding-right:15px}}@media screen and (min-width:768px){.admin-list__option--pagination .pagination-control{display:inline-block}}.admin-list__header{border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.admin-list__header{height:71px}}@media screen and (min-width:1200px){.admin-list__header--minimized .admin-list__heading{float:none;width:100%}}.admin-list__header--minimized .admin-list__option{width:25%}.admin-list__header--minimized .admin-list__option:nth-child(2){border-left:none}.admin-list__table{border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;text-align:center}@media screen and (min-width:768px){.admin-list__table{display:table;font-size:12px}}@media screen and (min-width:992px){.admin-list__table{font-size:13px}}@media screen and (min-width:1200px){.admin-list__table{font-size:14px}}.admin-list__table thead>tr>th{display:none;background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center;width:16.66667%}@media screen and (min-width:768px){.admin-list__table thead>tr>th{display:table-cell}}.admin-list__table tbody>tr>td{display:none;height:63px;vertical-align:middle;border-color:#e7e7e7;text-align:center;width:16.66667%}@media screen and (min-width:768px){.admin-list__table tbody>tr>td{display:table-cell}}.admin-list__items-list{display:block}@media screen and (min-width:768px){.admin-list__items-list{display:none}}.admin-list__footer{padding:15px}.admin-list__create-user{border-bottom:1px solid #e7e7e7;width:100%;cursor:pointer;float:right;color:#64c1c7;transition:all .2s ease;height:71px;padding:22px 15px 15px;text-align:center;font-size:18px}.admin-list__create-user:hover{color:#717176}@media screen and (min-width:768px){.admin-list__create-user{padding-top:25px;border:none;width:200px;display:block;position:relative;font-size:14px}}.admin-list__edit{color:#64c1c7;cursor:pointer;transition:all .2s ease}.admin-list__edit:hover{color:#717176}.admin-list__error{height:330px;text-align:center;padding:15px}.admin-list__error i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.admin-list__error i.fa{font-size:96px}}.admin-list__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.admin-list__error-message{font-size:20px}}.admin-item__header{height:40px}.admin-item__label{padding:0 15px;line-height:40px;width:calc(100% - 50px)}.admin-item__control,.admin-item__label{height:40px;position:relative;float:left;border-bottom:1px solid #e7e7e7}.admin-item__control{width:50px;border-left:1px solid #e7e7e7;cursor:pointer}.admin-item__control:hover{background-color:#f7f7f7}.admin-item__control i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.admin-item__content{border-bottom:1px solid #e7e7e7;padding:15px;background-color:#f7f7f7}.admin-item__props{border:1px solid #e7e7e7;background-color:#fff}.admin-item__prop{padding:5px 0}.admin-item__prop,.admin-item__prop-edit{overflow-y:auto;border-bottom:1px solid #e7e7e7}.admin-item__prop-edit{padding:15px}.admin-item__prop-key{font-weight:700;text-align:center}.admin-item__prop-edit-value,.admin-item__prop-value{text-align:center}.admin-create-modal__container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:200}.admin-create-modal__content{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;z-index:99;padding:0}@media screen and (min-width:768px){.admin-create-modal__content{width:480px;max-height:720px}}@media screen and (min-width:1200px){.admin-create-modal__content{width:640px;max-height:720px}}.admin-create-modal__heading{position:relative;font-weight:700;font-size:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.admin-create-modal__toggle{width:50px;height:50px;color:#a4a5a8;float:right;position:absolute;right:10px;top:10px;text-align:center;padding-top:6px;font-size:24px;cursor:pointer}.admin-create-modal__body{height:560px;overflow:auto}.admin-create-modal__title{font-size:32px;text-align:center;padding-top:100px}.admin-create-modal__period{text-align:center;font-size:14px}.admin-create-modal__add{text-align:center;margin-top:100px}.admin-create-modal__info{bottom:50px;background-color:#f2f2f2}.admin-create-modal__info,.admin-create-modal__success{position:absolute;text-align:center;width:100%;padding:15px}.admin-create-modal__success{top:85px;color:#368a5d;background-color:#bfe6d1}.admin-create-modal-form__form{position:absolute;top:70px;width:100%;padding:30px;overflow:auto;bottom:20px}@media screen and (min-width:768px){.admin-create-modal-form__form{top:140px}}.admin-create-modal-form__input{width:100%;border:none;border-bottom:1px solid #d9d9d9;background-color:transparent;float:left;font-size:20px;margin-bottom:15px}.admin-create-modal-form__input:focus{outline:none}.admin-create-modal-form__input--success{border-color:#f7f7f7}.admin-create-modal-form__input--error{border-color:#d95a4b}.admin-create-modal-form__input-dropdown{cursor:pointer;width:100%;border:none;border-bottom:1px solid #f7f7f7;background-color:transparent;float:left;font-size:20px;margin-bottom:15px}.admin-create-modal-form__input-dropdown:focus{outline:none}.admin-create-modal-form__input-dropdown--success{border-color:#f7f7f7}.admin-create-modal-form__input-dropdown--error{border-color:#d95a4b}.admin-create-modal-form__error-msg{width:100%;position:relative;top:-15px;height:20px;color:#d95a4b}.admin-create-modal-form__checkbox-group{width:100%;background-color:#f7f7f7}.admin-create-modal-form__checkbox-element{display:inline-block;margin:10px}@media screen and (min-width:768px){.admin-create-modal-form__checkbox-element{margin:15px}}.admin-create-modal-form__checkbox-label{margin-right:15px}.admin-create-modal-form__checkbox{cursor:pointer;position:relative;top:3px;height:15px;width:15px}.admin-create-modal-form__btn-container{position:relative;top:15px;width:100%}@media screen and (min-width:768px){.admin-create-modal-form__btn-container{top:25px}}.admin-create-modal-form__btn-group{position:absolute;left:50%;transform:translateX(-50%);width:100%}.admin-create-modal-form__btn{display:block;width:100%;float:left;height:40px;margin-top:10px}@media screen and (min-width:768px){.admin-create-modal-form__btn{height:36px}}.admin-create-modal-form__btn-update:disabled{background-color:#9cd7db;border:none;cursor:not-allowed}.admin-create-modal-form__info{display:none;position:absolute;top:85px;left:0;height:60px;padding-top:20px;margin-bottom:20px;width:100%;text-align:center;background-color:#f2f2f2}@media screen and (min-width:768px){.admin-create-modal-form__info{display:block}}.admin-create-modal-form__alert{position:absolute;top:85px;left:0;height:60px;padding-top:20px;margin-bottom:20px;width:100%;text-align:center;background-color:#f4cec9;color:#b23426}@media screen and (min-width:768px){.admin-edit-modal-form-accept__body{width:450px}}.admin-edit-modal__container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:200}.admin-edit-modal__content{width:100%;height:100%;z-index:99;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);padding:0}@media screen and (min-width:768px){.admin-edit-modal__content{width:480px;max-height:600px}}@media screen and (min-width:1200px){.admin-edit-modal__content{width:640px;max-height:600px}}.admin-edit-modal__heading{position:relative;font-weight:700;font-size:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.admin-edit-modal__toggle{width:50px;height:50px;color:#a4a5a8;float:right;position:absolute;right:10px;top:10px;text-align:center;padding-top:6px;font-size:24px;cursor:pointer}.admin-edit-modal__body{height:520px;overflow:auto}.admin-edit-modal__title{font-size:32px;text-align:center;padding-top:100px}.admin-edit-modal__period{text-align:center;font-size:14px}.admin-edit-modal__add{text-align:center;margin-top:100px}.admin-edit-modal__info{bottom:50px;background-color:#f2f2f2}.admin-edit-modal__info,.admin-edit-modal__success{position:absolute;text-align:center;width:100%;padding:15px}.admin-edit-modal__success{top:85px;color:#368a5d;background-color:#bfe6d1}.admin-edit-modal-form__form{position:absolute;top:70px;width:100%;padding:30px;overflow:auto;bottom:20px}@media screen and (min-width:768px){.admin-edit-modal-form__form{top:140px}}.admin-edit-modal-form__input{width:100%;border:none;border-bottom:1px solid #d9d9d9;background-color:transparent;float:left;font-size:20px;margin-bottom:15px}.admin-edit-modal-form__input:focus{outline:none}.admin-edit-modal-form__input--success{border-color:#f7f7f7}.admin-edit-modal-form__input--error{border-color:#d95a4b}.admin-edit-modal-form__input-dropdown{cursor:pointer;width:100%;border:none;border-bottom:1px solid #f7f7f7;background-color:transparent;float:left;font-size:20px;margin-bottom:15px}.admin-edit-modal-form__input-dropdown:focus{outline:none}.admin-edit-modal-form__input-dropdown--success{border-color:#f7f7f7}.admin-edit-modal-form__input-dropdown--error{border-color:#d95a4b}.admin-edit-modal-form__error-msg{width:100%;position:relative;top:-15px;height:20px;color:#d95a4b}.admin-edit-modal-form__notifications{margin-top:20px}.admin-edit-modal-form__checkbox-group{width:100%;background-color:#f7f7f7}.admin-edit-modal-form__checkbox-element{display:inline-block;margin:10px}@media screen and (min-width:768px){.admin-edit-modal-form__checkbox-element{margin:15px}}.admin-edit-modal-form__checkbox-label{margin-right:15px}.admin-edit-modal-form__checkbox{cursor:pointer;position:relative;top:3px;height:15px;width:15px}.admin-edit-modal-form__btn-container{position:relative;top:15px;width:100%}@media screen and (min-width:768px){.admin-edit-modal-form__btn-container{top:25px}}.admin-edit-modal-form__btn-group{position:absolute;left:50%;transform:translateX(-50%);width:100%}.admin-edit-modal-form__btn{display:block;width:100%;float:left;height:40px;margin-top:10px}@media screen and (min-width:768px){.admin-edit-modal-form__btn{height:36px;width:calc(33.33333% - 20px);margin:0 10px 10px}}.admin-edit-modal-form__btn-update:disabled{background-color:#9cd7db;border:none;cursor:not-allowed}.admin-edit-modal-form__btn-block:disabled{background-color:#f8c779;border:none;cursor:not-allowed}.admin-edit-modal-form__info{display:none;position:absolute;top:85px;left:0;height:60px;padding-top:20px;margin-bottom:20px;width:100%;text-align:center;background-color:#f2f2f2}@media screen and (min-width:768px){.admin-edit-modal-form__info{display:block}}.admin-edit-modal-form__alert{display:none;position:absolute;top:85px;left:0;height:60px;padding-top:20px;margin-bottom:20px;width:100%;text-align:center;background-color:#f4cec9;color:#b23426}@media screen and (min-width:768px){.admin-edit-modal-form__alert{display:block}}.admin-edit-modal-form-accept__container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:98}.admin-edit-modal-form-accept__body{overflow-y:auto;width:calc(100% - 30px);z-index:99;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);padding:0;margin-bottom:0;text-align:center}@media screen and (min-width:768px){.admin-edit-modal-form-accept__body{width:650px}}.admin-edit-modal-form-accept__header{text-align:center;background-color:#f2f2f2;color:#7d7e83;font-weight:700;font-size:20px;padding:12px 0 10px;line-height:1}.admin-edit-modal-form-accept__content{overflow-y:auto;padding:15px}.admin-edit-modal-form-accept__button-group{text-align:center;height:50px;margin-bottom:15px}.admin-edit-modal-form-accept__submit{margin-right:30px}.admin-edit-modal-form-accept__alert{color:#e6948a}.auth-container{padding-top:30px}@media screen and (min-width:768px){.auth-container{padding-top:60px}}@media screen and (min-width:992px){.auth-container{padding-top:120px}}.auth-container__logo{max-width:100%;height:auto;display:block;margin-right:auto;margin-left:auto;max-width:220px;margin-bottom:30px}@media screen and (min-width:768px){.auth-container__logo{max-width:400px;margin-bottom:60px}}@media screen and (min-width:992px){.auth-container__logo{max-width:600px;margin-bottom:60px}}.select-language__elements{text-align:center}.select-language__element{display:inline-block;margin:5px;padding-top:5px}.select-language__image{cursor:pointer;width:25px;height:15px;opacity:.4;transition:all .2s ease;-webkit-box-shadow:0 0 4px 0 rgba(0,0,0,.5);-moz-box-shadow:0 0 4px 0 rgba(0,0,0,.5);box-shadow:0 0 4px 0 rgba(0,0,0,.5)}.select-language__image:hover{opacity:1;-webkit-box-shadow:0 0 6px 0 rgba(0,0,0,.5);-moz-box-shadow:0 0 6px 0 rgba(0,0,0,.5);box-shadow:0 0 6px 0 rgba(0,0,0,.5)}.select-language__image-selected{cursor:pointer;width:25px;height:15px;opacity:1;transition:all .2s ease}.dashboard-welcome{display:none}@media screen and (min-width:1200px){.dashboard-welcome{display:block}}.dashboard-welcome__left{position:relative;float:left;width:70%;height:71px}.dashboard-welcome__trick{position:absolute;top:50%;transform:translateY(-50%);padding-left:15px;padding-right:15px;font-size:17px}.dashboard-welcome__right{position:relative;float:left;margin-left:15px;width:calc(30% - 15px);height:71px}.dashboard-welcome__time{width:100%;position:absolute;top:50%;transform:translateY(-50%);text-align:center;text-transform:capitalize;font-size:17px}.dashboard-welcome__filters{height:71px}.dashboard-availability__content{width:100%;height:490px;margin-left:0;float:left}@media screen and (min-width:768px){.dashboard-availability__content{height:590px;float:left}}@media screen and (min-width:1200px){.dashboard-availability__content{width:30%;float:left}}.dashboard-availability__heading{position:relative;font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;float:left;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.dashboard-availability__filters{float:left;width:100%;border-left:1px solid #e7e7e7;border-bottom:1px solid #e7e7e7}.dashboard-availability__graph{float:left;width:100%;margin-top:15px}.dashboard-availability__no-content{height:450px;text-align:center;padding:15px;font-size:17px}.dashboard-availability__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.dashboard-availability__no-content i.fa{font-size:96px}}.dashboard-availability__footer{position:relative;width:100%;float:left;height:71px;margin-top:30px;background-color:#f7f7f7;text-align:center}@media screen and (max-width:767px){.dashboard-availability__footer{display:none}}.dashboard-availability__footer-text{position:absolute;top:50%;transform:translateY(-50%);width:100%;padding:15px}.dashboard-graph__content{width:100%}@media screen and (min-width:992px){.dashboard-graph__content{width:30%;float:left}}.dashboard-notifications__content{width:100%;float:left}@media screen and (min-width:1200px){.dashboard-notifications__content{margin-left:15px;width:calc(70% - 15px);float:left}}.dashboard-notifications__heading{position:relative;font-weight:700;font-size:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.dashboard-notifications__notification-count{font-size:17px;font-weight:400;float:right}.dashboard-notifications__table{border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;display:none;text-align:center}@media screen and (min-width:768px){.dashboard-notifications__table{display:table;font-size:12px}}@media screen and (min-width:992px){.dashboard-notifications__table{font-size:13px}}@media screen and (min-width:1200px){.dashboard-notifications__table{font-size:14px}}.dashboard-notifications__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center;width:20%}.dashboard-notifications__table tbody>tr>td{height:63px;vertical-align:middle;border-color:#e7e7e7;text-align:center;width:20%}.dashboard-notifications__status{color:#e6948a}.dashboard-notifications__status:before{content:\"\\F071\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;margin-right:15px;font-size:17px}.dashboard-notifications__footer{display:none;height:71px;padding:15px}@media screen and (min-width:768px){.dashboard-notifications__footer{position:relative;display:block}}.dashboard-notifications__pagination{position:absolute;left:50%;transform:translateX(-50%)}.dashboard-notifications__items{width:100%;float:left;display:block}@media screen and (min-width:768px){.dashboard-notifications__items{display:none}}.dashboard-notifications__link,.dashboard-notifications__link-contract{cursor:pointer;font-size:12px;padding-left:10px;padding-right:10px}.dashboard-notifications__btn-dismiss{font-size:12px}.dashboard-notifications__no-content{height:384px;text-align:center;padding:15px}.dashboard-notifications__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.dashboard-notifications__no-content i.fa{font-size:96px}}@media screen and (max-width:767px){.dashboard-notifications__no-content i.fa{margin-top:30px}}.dashboard-notifications-item__header{height:40px}.dashboard-notifications-item__label{height:40px;padding:0 15px;line-height:40px;position:relative;width:calc(100% - 100px);float:left;border-bottom:1px solid #e7e7e7}.dashboard-notifications-item__control{float:left;width:50px;position:relative;height:40px;border-left:1px solid #e7e7e7;border-bottom:1px solid #e7e7e7;cursor:pointer}.dashboard-notifications-item__control:hover{background-color:#f7f7f7}.dashboard-notifications-item__control i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.dashboard-notifications-item__content{border-bottom:1px solid #e7e7e7;padding:15px;background-color:#f7f7f7}.dashboard-notifications-item__props{border:1px solid #e7e7e7;background-color:#fff}.dashboard-notifications-item__prop{overflow-y:auto;border-bottom:1px solid #e7e7e7;padding:5px 0}.dashboard-notifications-item__prop-key{font-weight:700;text-align:center}.dashboard-notifications-item__prop-value{text-align:center}.dashboard-notifications-filters{padding:0}.dashboard-notifications-filters__option{float:right;width:100%;border-bottom:1px solid #e7e7e7;border-left:1px solid #e7e7e7}.dashboard-notifications-filters__option:first-child{display:none}@media screen and (min-width:992px){.dashboard-notifications-filters__option{width:50%}.dashboard-notifications-filters__option:first-child{display:block}}@media screen and (min-width:1600px){.dashboard-notifications-filters__option{width:25%}.dashboard-notifications-filters__option:first-child{display:block}}.dashboard-container__topbar{width:100%;height:60px;background-color:#7d7e83}.dashboard-container__menu{float:left}.dashboard-container__page{float:left;padding:15px;overflow-y:scroll;height:calc(100vh - 60px);width:100%;position:relative;-webkit-overflow-scrolling:touch}@media screen and (min-width:1200px){.dashboard-container__page{width:calc(100% - 300px)}}.dashboard-container--nav-minimized .dashboard-container__page{width:100%}@media screen and (min-width:1200px){.dashboard-container--nav-minimized .dashboard-container__page{width:calc(100% - 60px)}}.sign-in-page{margin:0 auto;text-align:center}@media screen and (min-width:768px){.sign-in-page{max-width:400px}}.sign-in-page__heading{font-size:14px;font-weight:700;margin-bottom:10px}@media screen and (min-width:768px){.sign-in-page__heading{font-size:20px;margin-bottom:15px}}.sign-in-page__paragraph{font-size:13px;margin-bottom:15px}@media screen and (min-width:768px){.sign-in-page__paragraph{font-size:17px;margin-bottom:30px}}.sign-in-page__form{margin-bottom:15px}.sign-in-page__forgot-password-link{font-size:13px}@media screen and (min-width:768px){.sign-in-page__forgot-password-link{font-size:17px}}.sign-in-page__input-group{margin-bottom:15px}.sign-in-page__input-group--error{margin-bottom:0}.sign-in-page__input--success{border-color:#51bb83}.sign-in-page__input--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.sign-in-page__input--error{border-color:#d95a4b}.sign-in-page__input--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.sign-in-page__input-help{color:#d95a4b;display:block;text-align:left;margin:3px 3px 0}.sign-in-page__submit{width:100%}.forgot-password-page{margin:0 auto;text-align:center}@media screen and (min-width:768px){.forgot-password-page{max-width:400px}}.forgot-password-page__heading{font-size:14px;font-weight:700;margin-bottom:10px}@media screen and (min-width:768px){.forgot-password-page__heading{font-size:20px;margin-bottom:15px}}.forgot-password-page__paragraph{font-size:13px;margin-bottom:15px}@media screen and (min-width:768px){.forgot-password-page__paragraph{font-size:17px;margin-bottom:30px}}.forgot-password-page__form{margin-bottom:15px}.forgot-password-page__sign-in-link{font-size:13px}@media screen and (min-width:768px){.forgot-password-page__sign-in-link{font-size:17px}}.forgot-password-page__input-group{margin-bottom:15px}.forgot-password-page__input-group--error{margin-bottom:0}.forgot-password-page__input--success{border-color:#51bb83}.forgot-password-page__input--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.forgot-password-page__input--error{border-color:#d95a4b}.forgot-password-page__input--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.forgot-password-page__input-help{color:#d95a4b;display:block;text-align:left;margin:3px 3px 0}.forgot-password-page__submit{width:100%}.reset-password-page{margin:0 auto;text-align:center}@media screen and (min-width:768px){.reset-password-page{max-width:400px}}.reset-password-page__heading{font-size:14px;font-weight:700;margin-bottom:10px}@media screen and (min-width:768px){.reset-password-page__heading{font-size:20px;margin-bottom:15px}}.reset-password-page__paragraph{font-size:13px;margin-bottom:15px}@media screen and (min-width:768px){.reset-password-page__paragraph{font-size:17px;margin-bottom:30px}}.reset-password-page__form{margin-bottom:15px}.reset-password-page__forgot-password-link{font-size:13px}@media screen and (min-width:768px){.reset-password-page__forgot-password-link{font-size:17px}}.reset-password-page__input-group{margin-bottom:15px}.reset-password-page__input-group--error{margin-bottom:0}.reset-password-page__input--success{border-color:#51bb83}.reset-password-page__input--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.reset-password-page__input--error{border-color:#d95a4b}.reset-password-page__input--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.reset-password-page__input-help{color:#d95a4b;display:block;text-align:left;margin:3px 3px 0}.reset-password-page__submit{width:100%}.activate-user-page{margin:0 auto;text-align:center}@media screen and (min-width:768px){.activate-user-page{max-width:400px}}.activate-user-page__heading{font-size:14px;font-weight:700;margin-bottom:10px}@media screen and (min-width:768px){.activate-user-page__heading{font-size:20px;margin-bottom:15px}}.activate-user-page__paragraph{font-size:13px;margin-bottom:15px}@media screen and (min-width:768px){.activate-user-page__paragraph{font-size:17px;margin-bottom:30px}}.activate-user-page__form{margin-bottom:15px}.activate-user-page__forgot-password-link{font-size:13px}@media screen and (min-width:768px){.activate-user-page__forgot-password-link{font-size:17px}}.activate-user-page__input-group{margin-bottom:15px}.activate-user-page__input-group--error{margin-bottom:0}.activate-user-page__input--success{border-color:#51bb83}.activate-user-page__input--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.activate-user-page__input--error{border-color:#d95a4b}.activate-user-page__input--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.activate-user-page__input-help{color:#d95a4b;display:block;text-align:left;margin:3px 3px 0}.activate-user-page__submit{width:100%}.preloader-item{text-align:center;height:27.2px}.preloader-item__label{color:#fff}.preloader-item__loader{position:relative;margin:0 auto;width:27.2px}.preloader-item__loader:before{content:\"\";display:block;padding-top:100%}.preloader-item__circle{animation:animation--rotate 2s linear infinite;height:100%;transform-origin:center center;width:100%;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.preloader-item__path{stroke-dasharray:1,200;stroke-dashoffset:0;animation:animation--dash 1.5s ease-in-out infinite,animation--color-xs 6s ease-in-out infinite;stroke-linecap:round;stroke-width:6px}@keyframes animation--rotate{to{transform:rotate(1turn)}}@keyframes animation--dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px}to{stroke-dasharray:89,200;stroke-dashoffset:-124px}}@keyframes animation--color-xs{0%,to{stroke:#fff}}.navigation-menu{position:fixed;width:100%;background-color:rgba(0,0,0,.3);height:calc(100vh - 60px);transition:background-color .2s ease;z-index:10}@media screen and (min-width:1200px){.navigation-menu{position:static;width:auto;background-color:transparent;transition:none}}.navigation-menu--minimized{background-color:transparent;pointer-events:none}.navigation-menu--minimized .navigation-menu__inner{position:fixed;left:-250px}@media screen and (min-width:1200px){.navigation-menu--minimized{width:60px;pointer-events:all}.navigation-menu--minimized .navigation-menu__inner{width:60px;left:0}.navigation-menu--minimized .navigation-menu__link{padding:0;text-align:center;border:none}.navigation-menu--minimized .navigation-menu__link:after{display:none}.navigation-menu--minimized .navigation-menu__link:before{margin-right:0}.navigation-menu--minimized .navigation-menu__link--active:before{color:#64c1c7}.navigation-menu--minimized .navigation-menu__link-text{display:none}}.navigation-menu__inner{height:calc(100vh - 60px);background-color:#fff;width:250px;box-shadow:0 0 15px 3px rgba(0,0,0,.08);position:fixed;transition:left .2s ease;left:0}@media screen and (min-width:1200px){.navigation-menu__inner{position:relative;width:300px;transition:none}}.navigation-menu__header{padding:5px 15px;background-color:#7d7e83;height:60px}.navigation-menu__header--minimized{padding:10px}.navigation-menu__icon,.navigation-menu__logo{width:100%}.navigation-menu__list{padding-left:0;list-style:none}.navigation-menu__item{border-bottom:1px solid #e7e7e7}.navigation-menu__link{cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:50px;font-weight:400;font-size:17px;padding:0 40px 0 15px;position:relative;display:block;border-left:3px solid transparent}.navigation-menu__link,.navigation-menu__link:active,.navigation-menu__link:focus,.navigation-menu__link:hover{color:#7d7e83;text-decoration:none}.navigation-menu__link:after{content:\"\\F105\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;line-height:50px;right:15px;font-size:18px}.navigation-menu__link:hover{background-color:#f7f7f7}.navigation-menu__link--active{border-left:3px solid #64c1c7;background-color:#f7f7f7}.navigation-menu__link--active:after{color:#64c1c7}.navigation-menu__link--home:before{content:\"\\F3FD\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;margin-right:10px}.navigation-menu__link--statistics:before{content:\"\\F201\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;margin-right:10px}.navigation-menu__link--booking:before{content:\"\\F274\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;margin-right:10px}.navigation-menu__link--allocation:before{content:\"\\F200\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;margin-right:10px}.navigation-menu__link--contract:before,.navigation-menu__link--contractManagement:before{content:\"\\F15B\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;margin-right:10px}.navigation-menu__select-language{position:absolute;bottom:15px;display:block;width:100%;text-align:center;font-size:12px}@media screen and (min-width:768px){.navigation-menu__select-language{display:none}}.top-menu{height:60px;background-color:#7d7e83;position:relative}.top-menu--minimized .top-menu__brand{width:60px}.top-menu--minimized .top-menu__logo{display:none}.top-menu--minimized .top-menu__icon{display:inline}.top-menu .top-menu__left{float:left;color:#fff}.top-menu .top-menu__right{float:right;color:#fff}.top-menu__brand{width:60px;line-height:60px;text-align:center;float:left}@media screen and (min-width:1200px){.top-menu__brand{width:300px}}.top-menu__logo{width:245px;display:none}@media screen and (min-width:1200px){.top-menu__logo{display:inline}}.top-menu__icon{width:40px;display:inline}@media screen and (min-width:1200px){.top-menu__icon{display:none}}.top-menu__nav-toggle{cursor:pointer;width:60px;background-color:#64c1c7;line-height:60px;text-align:center;font-size:30px;float:left;color:#fff;transition:background-color .2s ease}.top-menu__nav-toggle:hover{background-color:#3b9da3}.top-menu__welcome-note{display:none;position:relative;top:20px;left:15px}@media screen and (min-width:768px){.top-menu__welcome-note{display:inline-block}}.top-menu__user-controls{display:block;height:60px;line-height:60px;padding:0 15px;cursor:pointer;float:right}.top-menu__user-controls:hover{background-color:#717176}.top-menu__user-controls:after{content:\"\\F0D7\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;margin-left:5px}.top-menu__user-dropdown{padding-left:0;list-style:none;padding:0;position:absolute;top:60px;right:0;box-shadow:0 0 15px 0 rgba(0,0,0,.08);z-index:999}.top-menu__user-dropdown-item{line-height:40px}.top-menu__user-dropdown-link{display:block;font-weight:400;background-color:#fff;padding:0 15px;width:200px;cursor:pointer}.top-menu__user-dropdown-link,.top-menu__user-dropdown-link:active,.top-menu__user-dropdown-link:focus,.top-menu__user-dropdown-link:hover{color:#7d7e83;text-decoration:none}.top-menu__user-dropdown-link:hover{background-color:#f7f7f7}.top-menu__user-dropdown-link i.fa{color:#64c1c7;margin-right:5px}.top-menu__select-language{display:none;padding-top:8px;height:60px;float:right;top:0}@media screen and (min-width:768px){.top-menu__select-language{display:inline-block}}.stat-sites{display:none}@media screen and (min-width:768px){.stat-sites{display:block}}.stat-sites__content{position:relative}.stat-sites__header{height:71px;border-bottom:1px solid #e7e7e7}.stat-sites__heading{float:left;font-size:17px;font-weight:700;width:calc(100% - 250px);padding:0 15px;line-height:71px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.stat-sites__option{width:250px;float:left;border-left:1px solid #e7e7e7}.stat-sites__subheading{font-size:14px}.stat-sites__body{padding:15px;height:430px}.stat-sites__fake{overflow-y:auto;height:482.2px}.stat-sites__fake-left{width:200px;padding:15px 0 15px 15px;float:left}.stat-sites__fake-right{width:calc(100% - 200px);padding:15px;float:left}.stat-sites__fake-bar{height:30px}.stat-sites__fake-bar:not(:last-child){margin-bottom:15px}.stat-sites__fake-bar:first-child{margin-bottom:30px;height:32px}.stat-sites__no-content{height:482.2px;padding-top:150px}.stat-sites__no-content-icon{text-align:center}.stat-sites__no-content-icon i.fa{font-size:96px;color:#cbccce}.stat-sites__no-content-message{font-size:32px;font-weight:700;text-align:center}.stat-number{background-color:#64c1c7;margin-bottom:15px;color:#fff;text-align:center;padding:20px 15px;box-shadow:0 0 15px 3px rgba(0,0,0,.08);line-height:1}.stat-number__label{font-size:14px;font-weight:700;margin-bottom:9px}@media screen and (min-width:768px){.stat-number__label{font-size:20px}}@media screen and (min-width:992px){.stat-number__label{font-size:16px}}@media screen and (min-width:1200px){.stat-number__label{font-size:24px}}.stat-number__value{font-weight:700;font-size:32px;margin-bottom:5px}@media screen and (min-width:768px){.stat-number__value{font-size:32px;margin-bottom:0}}@media screen and (min-width:992px){.stat-number__value{font-size:57.6px}}@media screen and (min-width:1200px){.stat-number__value{font-size:80px}}.stat-number__subtitle{font-size:14px;font-weight:700}@media screen and (min-width:768px){.stat-number__subtitle{font-size:20px}}@media screen and (min-width:992px){.stat-number__subtitle{font-size:16px}}@media screen and (min-width:1200px){.stat-number__subtitle{font-size:24px}}.stat-number--alternative{background-color:#7d7e83}.stat-number__fake-label{height:12px;margin-bottom:15px}@media screen and (min-width:768px){.stat-number__fake-label{height:14px}}@media screen and (min-width:992px){.stat-number__fake-label{height:18px}}@media screen and (min-width:1200px){.stat-number__fake-label{height:24px}}.stat-number__fake-value{height:20px;margin-bottom:15px}@media screen and (min-width:768px){.stat-number__fake-value{height:23px}}@media screen and (min-width:992px){.stat-number__fake-value{height:33px}}@media screen and (min-width:1200px){.stat-number__fake-value{height:59px}}.stat-number__fake-subtitle{height:12px}@media screen and (min-width:768px){.stat-number__fake-subtitle{height:14px}}@media screen and (min-width:992px){.stat-number__fake-subtitle{height:18px}}@media screen and (min-width:1200px){.stat-number__fake-subtitle{height:24px}}.stat-number__error-label{font-size:14px;font-weight:700;margin-bottom:9px}@media screen and (min-width:768px){.stat-number__error-label{font-size:20px}}@media screen and (min-width:992px){.stat-number__error-label{font-size:16px}}@media screen and (min-width:1200px){.stat-number__error-label{font-size:24px}}.stat-number__error-icon{margin-bottom:15px}@media screen and (min-width:768px){.stat-number__error-icon{margin-bottom:10px}}@media screen and (min-width:992px){.stat-number__error-icon{margin-bottom:15px}}.stat-number__error-icon i.fa{font-size:68px}@media screen and (min-width:768px){.stat-number__error-icon i.fa{font-size:22px}}@media screen and (min-width:992px){.stat-number__error-icon i.fa{font-size:43px}}@media screen and (min-width:1200px){.stat-number__error-icon i.fa{font-size:65px}}.stat-number__error-message{font-size:14px;font-weight:700}@media screen and (min-width:768px){.stat-number__error-message{font-size:20px}}@media screen and (min-width:992px){.stat-number__error-message{font-size:16px}}@media screen and (min-width:1200px){.stat-number__error-message{font-size:24px}}.stat-filters{padding:0}@media screen and (min-width:992px){.stat-filters{overflow-y:auto}}.stat-filters__option{border-right:1px solid #e7e7e7}.stat-filters__option:not(:last-child){border-bottom:1px solid #e7e7e7}@media screen and (min-width:992px){.stat-filters__option:not(:last-child){border-bottom:none}}@media screen and (min-width:992px){.stat-filters__option{width:25%;float:left}}@media screen and (min-width:768px){.stat-list{display:none}}.stat-list__content{position:relative}.stat-list__header{line-height:50px;border-bottom:1px solid #e7e7e7;padding:0 15px;font-size:17px;font-weight:700;color:#a4a5a8}.stat-list__controls{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:51px;line-height:55px;padding:0 30px 0 15px;cursor:pointer;position:relative;border-bottom:1px solid #e7e7e7}.stat-list__controls:active,.stat-list__controls:focus,.stat-list__controls:hover{background-color:#f7f7f7}.stat-list__controls:after{content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px}.stat-list__control-label{font-weight:700}.stat-list__body{position:relative;min-height:585px;overflow:hidden}.stat-list__item{overflow-y:auto}.stat-list__item:not(:nth-child(10)){border-bottom:1px solid #e7e7e7}.stat-list__label{float:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:calc(100% - 90px);padding:15px;position:relative}.stat-list__label:hover{background-color:#f7f7f7;cursor:pointer}.stat-list__label:after{content:\"\\F105\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px}.stat-list__value{float:left;padding:15px;width:85px;border-left:1px solid #e7e7e7;text-align:right}.stat-list__inventory{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;box-shadow:0 0 15px 3px rgba(0,0,0,.08)}.stat-list__inventory-back{line-height:52px;padding:0 15px 0 30px;position:relative;border-bottom:1px solid #e7e7e7;height:51px}.stat-list__inventory-back:hover{background-color:#f7f7f7;cursor:pointer}.stat-list__inventory-back:before{content:\"\\F104\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);left:15px;font-size:17px}.stat-list__inventory-item{overflow-y:auto;border-bottom:1px solid #e7e7e7}.stat-list__inventory-item:nth-child(10){border-bottom:none}.stat-list__inventory-label{float:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:calc(100% - 90px);padding:15px;position:relative}.stat-list__inventory-value{float:left;padding:15px;width:85px;border-left:1px solid #e7e7e7;text-align:right}.stat-list__option{border-bottom:1px solid #e7e7e7}.stat-inventory{display:none}@media screen and (min-width:768px){.stat-inventory{display:block}}.stat-inventory__content{position:relative}.stat-inventory__header{height:71px;border-bottom:1px solid #e7e7e7}.stat-inventory__heading{float:left;font-size:17px;font-weight:700;width:calc(100% - 250px);padding:0 15px;line-height:71px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.stat-inventory__option{width:250px;float:left;border-left:1px solid #e7e7e7}.stat-inventory__subheading{font-size:14px}.stat-inventory__body{padding:15px;height:430px}.stat-inventory__fake{overflow-y:auto;height:482.2px}.stat-inventory__fake-left{width:200px;padding:15px 0 15px 15px;float:left}.stat-inventory__fake-right{width:calc(100% - 200px);padding:15px;float:left}.stat-inventory__fake-bar{height:30px}.stat-inventory__fake-bar:not(:last-child){margin-bottom:15px}.stat-inventory__fake-bar:first-child{margin-bottom:30px;height:32px}.stat-inventory__no-content{height:482.2px;padding-top:150px}.stat-inventory__no-content-icon{text-align:center}.stat-inventory__no-content-icon i.fa{font-size:96px;color:#cbccce}.stat-inventory__no-content-message{font-size:32px;font-weight:700;text-align:center}.date-picker__container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:98}.date-picker__body{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);overflow-y:auto;width:calc(100% - 30px);z-index:99;padding:0;margin-bottom:0}@media screen and (min-width:768px){.date-picker__body{width:650px}}.date-picker__header{text-align:center;background-color:#f2f2f2;color:#7d7e83;font-weight:700;font-size:20px;padding:12px 0 10px;line-height:1}.date-picker__calendars{overflow-y:auto;padding:15px}@media screen and (min-width:768px){.date-picker__calendars{padding:30px}}@media screen and (min-width:768px){.date-picker__calendar{float:left;width:calc(50% - 7.5px)}}@media screen and (min-width:768px){.date-picker__calendar:first-child{margin-right:15px}}.date-picker__calendar:nth-child(2){display:none}@media screen and (min-width:768px){.date-picker__calendar:nth-child(2){display:block}}.date-picker__controls{overflow-y:auto;background-color:#58585c;color:#fff}.date-picker__button{line-height:30px;width:40px;text-align:center;font-size:20px;height:30px;float:left;background-color:#58585c;cursor:pointer}.date-picker__button:hover{background-color:#717176}.date-picker__description{float:left;line-height:30px;height:30px;width:calc(100% - 80px);text-align:center}.date-picker__weekday{float:left;width:14.28571%;height:28px;text-align:center;background-color:#7d7e83;color:#fff;line-height:28px;pointer-events:none}.date-picker__month,.date-picker__weekdays{overflow-y:auto}.date-picker__date{float:left;width:14.28571%;height:28px;text-align:center;background-color:#fff;border-right:1px solid #d9d9d9;border-bottom:1px solid #d9d9d9;line-height:28px;cursor:pointer}.date-picker__date:hover{background-color:#f7f7f7}.date-picker__date:nth-child(7n+1){border-left:1px solid #d9d9d9}.date-picker__date--out{color:#cbccce}.date-picker__date--selected{background-color:#51bb83;color:#fff}.date-picker__date--selected:hover{background-color:#47b67b}.date-picker__date--outselect{background-color:#88d0aa;color:#fff}.date-picker__date--outselect:hover{background-color:#88d0aa}.date-picker__predefined{background-color:#f2f2f2;overflow-y:auto;padding:15px}.date-picker__predefined-link{float:left;width:50%;display:block;text-align:center;color:#7d7e83;text-decoration:none;cursor:pointer}.date-picker__predefined-link:active,.date-picker__predefined-link:focus,.date-picker__predefined-link:hover{color:#58585c;text-decoration:none}@media screen and (min-width:768px){.date-picker__predefined-link{width:25%}}.date-picker__option{height:70px;width:100%;padding:10px 15px;cursor:pointer;position:relative}.date-picker__option:hover{background-color:#f7f7f7}.date-picker__option:after{content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px}.date-picker__option-label{width:calc(100% - 20px);font-size:17px;color:#a4a5a8}.date-picker__option-label,.date-picker__option-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none;font-weight:700}.date-picker__option-value{font-size:14px;margin-right:15px;height:22px}.booking-filters{float:left;width:100%}@media screen and (max-width:767px){.booking-filters__element:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.booking-filters__element{width:50%;float:left}.booking-filters__element:nth-child(-n+8){border-bottom:1px solid #e7e7e7}.booking-filters__element:last-child,.booking-filters__element:nth-child(2n-1){border-right:1px solid #e7e7e7}}@media screen and (min-width:1200px){.booking-filters__element{width:20%;float:left}.booking-filters__element:nth-child(2n-1){border-right:none}.booking-filters__element:last-child{border-right:1px solid #e7e7e7}.booking-filters__element:not(:first-child){border-left:1px solid #e7e7e7}}.booking-filters__option{width:100%;height:70px;padding:10px 15px;cursor:pointer}.booking-filters__option:hover{background-color:#f7f7f7}.booking-filters__option:after{content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px}.booking-filters__option-label{pointer-events:none;font-weight:700;font-size:17px;color:#a4a5a8}.booking-filters__option-default,.booking-filters__option-value{pointer-events:none;font-size:14px;font-weight:700}.booking-filters__option-default{color:#d9d9d9}.booking-filters__select__option{padding:5px 15px;cursor:pointer}@media screen and (min-width:992px){.booking-filters__select__option{width:300px}}.booking-filters__select__option:hover{background-color:#f7f7f7}.booking-list{float:left;width:100%}.booking-list__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7;text-align:center;overflow:visible}@media screen and (min-width:768px){.booking-list__heading{float:left;width:75%;text-align:left;font-weight:400}}@media screen and (min-width:1200px){.booking-list__heading{float:left;width:75%;border-bottom:none;text-align:left;font-weight:400}}.booking-list__download{display:none;padding-left:15px;cursor:pointer;transition:all .2s ease;font-size:12px;color:#64c1c7}.booking-list__download:hover{color:#7d7e83}@media screen and (min-width:768px){.booking-list__download{display:inline-block}}.booking-list__search{height:71px;width:100%;border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.booking-list__search{float:right;width:25%;border-left:1px solid #e7e7e7;border-bottom:none}}.booking-list__search-field{background-color:transparent;height:71px;width:100%;font-size:17px;border:none;text-align:center;margin:0}@media screen and (min-width:768px){.booking-list__search-field{text-align:left;padding-left:15px;font-size:14px}}.booking-list__search-field:focus{outline:none}.booking-list__option{width:100%}.booking-list__option:not(:nth-child(2)){border-left:1px solid #e7e7e7}@media screen and (max-width:767px){.booking-list__option:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.booking-list__option{float:left;width:25%}}.booking-list__option--pagination{height:70px;padding-top:15px;text-align:center}@media screen and (max-width:767px){.booking-list__option--pagination{padding-left:15px;padding-right:15px}}@media screen and (min-width:768px){.booking-list__option--pagination .pagination-control{display:inline-block}}.booking-list__header{border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.booking-list__header{height:71px}}.booking-list__table{width:100%;border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;display:none}@media screen and (min-width:768px){.booking-list__table{display:table;font-size:12px}}@media screen and (min-width:992px){.booking-list__table{font-size:13px}}@media screen and (min-width:1200px){.booking-list__table{font-size:14px}}.booking-list__table-header{background-color:#f2f2f2;height:63px;cursor:pointer;text-align:center;width:10%}.booking-list__table-header--selected,.booking-list__table-header:hover{background-color:#d9d9d9}.booking-list__table-data{height:63px;border-bottom:1px solid #e7e7e7;text-align:center;text-transform:capitalize}.booking-list__table-data:first-child{padding-left:15px;font-weight:700;border-right:1px solid #e7e7e7}.booking-list__footer{padding:15px}.booking-list__pagination{position:relative;left:50%;transform:translateX(-50%);width:160px}@media screen and (min-width:768px){.booking-list__items{display:none}}.booking-list__error{height:400px;text-align:center;padding:15px}.booking-list__error i.fa{margin-top:165px;font-size:64px}@media screen and (min-width:768px){.booking-list__error i.fa{font-size:96px}}.booking-list__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.booking-list__error-message{font-size:20px}}.booking-list__xls-tooltip{color:#fff;position:relative;left:15px;background-color:rgba(0,0,0,.6);padding:10px;transition:all .2s ease}.booking-list__xls-tooltip:hover{opacity:1}.dropdown-menu{position:relative;width:100%}.dropdown-menu__button{padding:10px 15px;cursor:pointer;height:70px}.dropdown-menu__button:hover{background-color:#f7f7f7}.dropdown-menu:after{content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none}.dropdown-menu__label{width:calc(100% - 20px);font-size:17px;color:#a4a5a8}.dropdown-menu__label,.dropdown-menu__value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none;font-weight:700}.dropdown-menu__value{font-size:14px;margin-right:15px;height:22px}.dropdown-menu__value--empty{color:#cbccce}.dropdown-menu__dropdown{position:absolute;left:0;top:100%;background-color:#fff;width:100%;border-top:1px solid #e7e7e7;box-shadow:0 10px 15px 0 rgba(0,0,0,.08);max-height:350px;white-space:nowrap;overflow-x:hidden;overflow-y:auto;text-overflow:ellipsis;z-index:999}.dropdown-menu__choice{height:51px;line-height:51px;padding:0 15px;z-index:500;position:relative;overflow:hidden}.dropdown-menu__choice:not(:last-child){border-bottom:1px solid #e7e7e7}.dropdown-menu__choice:hover{background-color:#f7f7f7;cursor:pointer}.dropdown-menu__choice--selected:after{content:\"\\F00C\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none;color:#64c1c7}.dropdown-menu--disabled .dropdown-menu__button{cursor:no-drop;opacity:.5}.dropdown-menu--disabled .dropdown-menu__button:hover{background-color:#fff}.dropdown-menu--disabled:after{opacity:0}.dropdown-menu-multi-select{position:relative;width:100%}.dropdown-menu-multi-select__button{padding:10px 15px;cursor:pointer;height:70px}.dropdown-menu-multi-select__button:hover{background-color:#f7f7f7}.dropdown-menu-multi-select:after{content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none}.dropdown-menu-multi-select__label{pointer-events:none;font-weight:700;font-size:17px;color:#a4a5a8}.dropdown-menu-multi-select__value{width:200px;pointer-events:none;font-size:14px;font-weight:700}.dropdown-menu-multi-select__value--empty{color:#cbccce}.dropdown-menu-multi-select__value-small{width:200px;pointer-events:none;font-size:10px;font-weight:700}.dropdown-menu-multi-select__value-smaller{width:200px;pointer-events:none;font-size:8px;font-weight:700}.dropdown-menu-multi-select__value-smallest{width:200px;pointer-events:none;font-size:7px;font-weight:700}.dropdown-menu-multi-select__dropdown{position:absolute;left:0;top:100%;background-color:#fff;width:100%;border-top:1px solid #e7e7e7;box-shadow:0 10px 15px 0 rgba(0,0,0,.08);max-height:350px;overflow-y:auto;z-index:999}.dropdown-menu-multi-select__choice{height:51px;line-height:51px;padding:0 15px;z-index:500;position:relative}.dropdown-menu-multi-select__choice:not(:last-child){border-bottom:1px solid #e7e7e7}.dropdown-menu-multi-select__choice:hover{background-color:#f7f7f7;cursor:pointer}.dropdown-menu-multi-select__choice--selected:after{content:\"\\F00C\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none;color:#64c1c7}.dropdown-menu-multi-select__reset{height:51px;line-height:51px;padding:0 15px;z-index:500;position:relative;background-color:#f4cec9;color:#fff}.dropdown-menu-multi-select__reset:hover{background-color:#e6948a;cursor:pointer}.dropdown-menu-multi-select--disabled .dropdown-menu-multi-select__button{cursor:no-drop;opacity:.5}.dropdown-menu-multi-select--disabled .dropdown-menu-multi-select__button:hover{background-color:#fff}.dropdown-menu-multi-select--disabled:after{opacity:0}.pagination-control{height:42px}.pagination-control__controls{overflow-y:auto;border:1px solid #e7e7e7;width:100%}@media screen and (min-width:768px){.pagination-control__controls{width:160px}}.pagination-control__button{position:relative;float:left;height:40px;width:40px;background-color:#fff;cursor:pointer}.pagination-control__button:hover{background-color:#f7f7f7}.pagination-control__button--prev:before{content:\"\\F104\"}.pagination-control__button--next:before,.pagination-control__button--prev:before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;font-size:17px}.pagination-control__button--next:before{content:\"\\F105\"}.pagination-control__button--disabled{background-color:#f7f7f7;cursor:no-drop}.pagination-control__info{float:left;height:40px;line-height:42px;overflow-y:hidden;width:calc(100% - 80px);padding:0 15px;text-align:center;border-right:1px solid #e7e7e7;border-left:1px solid #e7e7e7;font-weight:700;background-color:#f7f7f7;user-select:none}.pagination-control__info--small{font-size:10px}.booking-item__header{height:40px}.booking-item__label{padding:0 15px;line-height:40px;width:calc(100% - 50px)}.booking-item__control,.booking-item__label{height:40px;position:relative;float:left;border-bottom:1px solid #e7e7e7}.booking-item__control{width:50px;border-left:1px solid #e7e7e7;cursor:pointer}.booking-item__control:hover{background-color:#f7f7f7}.booking-item__control i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.booking-item__content{border-bottom:1px solid #e7e7e7;padding:15px;background-color:#f7f7f7}.booking-item__props{border:1px solid #e7e7e7;background-color:#fff}.booking-item__prop{overflow-y:auto;border-bottom:1px solid #e7e7e7;padding:5px 0}.booking-item__prop-key{font-weight:700;text-align:center}.booking-item__prop-value{text-align:center}.allocation-filters{padding:0;height:70px}@media screen and (max-width:767px){.allocation-filters{height:140px}}@media screen and (max-width:767px){.allocation-filters__option{width:100%;float:left}.allocation-filters__option:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.allocation-filters__option{width:50%;float:left}.allocation-filters__option:nth-child(-n+6){border-bottom:1px solid #e7e7e7}.allocation-filters__option:nth-child(2n-1){border-right:1px solid #e7e7e7}}@media screen and (min-width:1200px){.allocation-filters__option{width:25%;float:left}.allocation-filters__option:nth-child(2n-1){border-right:none}.allocation-filters__option:not(:first-child){border-left:1px solid #e7e7e7}.allocation-filters__option:nth-child(5){border-left:none}.allocation-filters__option:nth-child(-n+4){border-bottom:1px solid #e7e7e7}.allocation-filters__option:last-child{border-right:1px solid #e7e7e7;width:calc(100% / 4 + 1px)}}.allocation-filters__fake{height:140px;padding:15px}@media screen and (min-width:768px){.allocation-filters__fake{height:70px}}.allocation-filters__fake-cell{height:47px;width:100%;float:left}.allocation-filters__fake-cell:first-child{margin-bottom:15px}@media screen and (min-width:768px){.allocation-filters__fake-cell{width:calc(100% / 2 - 7.5px);height:40px}.allocation-filters__fake-cell:first-child{margin-right:15px}}@media screen and (min-width:1200px){.allocation-filters__fake-cell{width:calc(100% / 4 - 7.5px)}}.allocation-list__header{border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.allocation-list__header{height:71px}}@media screen and (min-width:1200px){.allocation-list__header--minimized .allocation-list__heading{float:none;width:100%}}.allocation-list__header--minimized .allocation-list__option{width:25%}.allocation-list__header--minimized .allocation-list__option:nth-child(2){border-left:none}.allocation-list__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}@media screen and (min-width:1200px){.allocation-list__heading{border-bottom:none;float:left;width:calc(100% - 880px)}}.allocation-list__option{width:100%}@media screen and (max-width:767px){.allocation-list__option:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.allocation-list__option{border-bottom:none;float:left;width:25%}.allocation-list__option:not(:nth-child(2)){border-left:1px solid #e7e7e7}}@media screen and (min-width:1200px){.allocation-list__option{border-bottom:none;border-left:1px solid #e7e7e7;float:left;width:220px}}.allocation-list__option--pagination{height:70px;padding-top:15px;text-align:center}@media screen and (max-width:767px){.allocation-list__option--pagination{padding-left:15px;padding-right:15px}}@media screen and (min-width:768px){.allocation-list__option--pagination .pagination-control{display:inline-block}}.allocation-list__table{border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;display:none;text-align:center}@media screen and (min-width:768px){.allocation-list__table{display:table;font-size:12px}}@media screen and (min-width:992px){.allocation-list__table{font-size:13px}}@media screen and (min-width:1200px){.allocation-list__table{font-size:14px}}.allocation-list__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center;width:16.66667%}.allocation-list__table thead>tr>th:first-child{padding-left:15px}.allocation-list__table thead>tr>th:last-child{padding-right:15px}.allocation-list__table tbody>tr>td{height:63px;vertical-align:middle;width:16.66667%}.allocation-list__table tbody>tr>td:first-child{padding-left:15px;font-weight:700;border-right:1px solid #e7e7e7}.allocation-list__table tbody>tr>td:last-child{padding-right:15px}.allocation-list__footer{padding:15px}.allocation-list__pagination{display:inline-block;margin-top:5px;position:relative;left:50%;transform:translateX(-50%)}@media screen and (min-width:768px){.allocation-list__items{display:none}}.allocation-list__error{height:522px;text-align:center;padding:15px}.allocation-list__error i.fa{margin-top:165px;font-size:64px}@media screen and (min-width:768px){.allocation-list__error i.fa{font-size:96px}}.allocation-list__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.allocation-list__error-message{font-size:20px}}.allocation-list__button{margin-right:10px;font-weight:400;padding-left:10px;padding-right:10px;font-size:12px}.allocation-list__button:after{margin-left:10px;content:\"\\F105\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900}.allocation-list__button>i{position:relative;bottom:2px;right:2px;font-size:8px;color:#e6948a}@media screen and (min-width:992px){.allocation-list__button{font-size:17px}}.allocation-item__header{height:40px}.allocation-item__label{padding:0 15px;line-height:40px;width:calc(100% - 100px)}.allocation-item__control,.allocation-item__label{height:40px;position:relative;float:left;border-bottom:1px solid #e7e7e7}.allocation-item__control{width:50px;border-left:1px solid #e7e7e7;cursor:pointer}.allocation-item__control:hover{background-color:#f7f7f7}.allocation-item__control i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.allocation-item__content{border-bottom:1px solid #e7e7e7;padding:15px;background-color:#f7f7f7}.allocation-item__props{border:1px solid #e7e7e7;background-color:#fff}.allocation-item__prop{overflow-y:auto;border-bottom:1px solid #e7e7e7;padding:5px 0}.allocation-item__prop-key{font-weight:700;text-align:center}.allocation-item__prop-value{text-align:center}.manage-allocation-page__content{display:none}@media screen and (min-width:768px){.manage-allocation-page__content{display:block}}.manage-allocation-page__mobile{padding:90px 30px}@media screen and (min-width:768px){.manage-allocation-page__mobile{display:none}}.manage-allocation-page__mobile-content{text-align:center;font-size:17px}.manage-allocation-page__mobile-content i.fa{font-size:35px;margin-bottom:10px;display:block;margin-right:auto;margin-left:auto}.manage-allocation-page__alert{position:fixed;top:60px;right:0;height:71px;text-align:center;padding:25px 30px 30px;opacity:.95;z-index:100}.manage-allocation-page__success{background-color:#bfe6d1;color:#368a5d}.manage-allocation-page__warning{background-color:#f4cec9;color:#b23426}.manage-allocation-page__error{width:100%;height:522px;text-align:center;padding:15px;display:block}.manage-allocation-page__error i.fa{margin-top:165px;font-size:64px}@media screen and (min-width:768px){.manage-allocation-page__error i.fa{font-size:96px}}@media screen and (max-width:767px){.manage-allocation-page__error{display:none}}.manage-allocation-page__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.manage-allocation-page__error-message{font-size:20px}}.manage-allocation-list__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}@media screen and (min-width:1200px){.manage-allocation-list__heading{border-bottom:none;float:left;width:calc(100% - 660px)}}.manage-allocation-list__option{width:100%}@media screen and (max-width:767px){.manage-allocation-list__option:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.manage-allocation-list__option{border-bottom:none;float:left;width:33.33333%}.manage-allocation-list__option:not(:nth-child(2)){border-left:1px solid #e7e7e7}}@media screen and (min-width:1200px){.manage-allocation-list__option{border-bottom:none;border-left:1px solid #e7e7e7;float:right;width:220px}}.manage-allocation-list__option--pagination{height:70px;padding-top:15px;text-align:center}@media screen and (max-width:767px){.manage-allocation-list__option--pagination{padding-left:15px;padding-right:15px}}@media screen and (min-width:768px){.manage-allocation-list__option--pagination .pagination-control{display:inline-block}}.manage-allocation-list__header{border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.manage-allocation-list__header{height:71px}}@media screen and (min-width:1200px){.manage-allocation-list__header--minimized .manage-allocation-list__heading{float:none;width:100%}}.manage-allocation-list__header--minimized .manage-allocation-list__option{width:25%}.manage-allocation-list__header--minimized .manage-allocation-list__option:nth-child(2){border-left:none}.manage-allocation-list__table{border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;display:none;text-align:center}@media screen and (min-width:768px){.manage-allocation-list__table{display:table;font-size:12px}}@media screen and (min-width:992px){.manage-allocation-list__table{font-size:13px}}@media screen and (min-width:1200px){.manage-allocation-list__table{font-size:14px}}.manage-allocation-list__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center}.manage-allocation-list__table thead>tr>th:first-child{width:100px;padding-left:15px}.manage-allocation-list__table thead>tr>th:nth-child(2),.manage-allocation-list__table thead>tr>th:nth-child(3){width:100px}.manage-allocation-list__table thead>tr>th:nth-child(4){width:50px}.manage-allocation-list__table thead>tr>th:nth-child(5){width:100px;padding-right:15px}.manage-allocation-list__table thead>tr>th:nth-child(6){width:50px}.manage-allocation-list__table thead>tr>th:nth-child(7),.manage-allocation-list__table thead>tr>th:nth-child(8),.manage-allocation-list__table thead>tr>th:nth-child(9){width:100px}.manage-allocation-list__table tbody>tr>td{height:63px;vertical-align:middle;border-color:#e7e7e7;text-align:center}.manage-allocation-list__table tbody>tr>td:first-child{width:100px;padding-left:15px}.manage-allocation-list__table tbody>tr>td:nth-child(2),.manage-allocation-list__table tbody>tr>td:nth-child(3){width:100px}.manage-allocation-list__table tbody>tr>td:nth-child(4){width:50px}.manage-allocation-list__table tbody>tr>td:nth-child(5){width:100px;padding-right:15px}.manage-allocation-list__table tbody>tr>td:nth-child(6){width:50px}.manage-allocation-list__table tbody>tr>td:nth-child(7),.manage-allocation-list__table tbody>tr>td:nth-child(8),.manage-allocation-list__table tbody>tr>td:nth-child(9){width:100px}.manage-allocation-list__footer{padding:15px}.manage-allocation-list__pagination{display:inline-block;margin-top:5px;position:relative;left:50%;transform:translateX(-50%)}@media screen and (min-width:768px){.manage-allocation-list__items{display:none}}.manage-allocation-list__error{height:330px;text-align:center;padding:15px}.manage-allocation-list__error i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.manage-allocation-list__error i.fa{font-size:96px}}.manage-allocation-list__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.manage-allocation-list__error-message{font-size:20px}}.manage-allocation-list__error-retry{cursor:pointer;color:#5bc0de}.manage-allocation-form__heading{position:relative;font-weight:700;font-size:17px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7;cursor:pointer}.manage-allocation-form__heading--open:after{content:\"\\F106\"}.manage-allocation-form__heading--closed:after,.manage-allocation-form__heading--open:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;font-weight:400;pointer-events:none}.manage-allocation-form__heading--closed:after{content:\"\\F107\"}.manage-allocation-form__body{padding:0 15px 15px;overflow-y:auto}.manage-allocation-form__error{text-align:center;padding-bottom:5px}.manage-allocation-form__controls{padding:15px;border-top:1px solid #e7e7e7;overflow-y:auto}.manage-allocation-form__submit{float:left}.manage-allocation-form__reset{width:160px;float:right}.manage-allocation-form__control-buttons{float:left;width:330px}.manage-allocation-form__control-message{float:left;width:calc(100% - 330px);line-height:34.4px;padding-left:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.manage-allocation-request{position:fixed;bottom:-400px;left:0;height:440px;width:100%;transition:all .2s ease;z-index:100}.manage-allocation-request--open{bottom:0}.manage-allocation-request__toggle{position:relative;left:50%;transform:translateX(-50%);text-transform:uppercase;height:60px;width:220px;background-color:#64c1c7;color:#fff;text-align:center;padding-top:10px;border-radius:15px;cursor:pointer;opacity:.9;transition:all .2s ease}.manage-allocation-request__toggle:hover{opacity:.98}.manage-allocation-request__news{position:absolute;top:11px;right:20px;padding-top:1px;text-align:center;display:inline-block;height:20px;width:20px;font-size:12px;font-weight:700;color:#64c1c7;background-color:#fff;border-radius:10px;text-shadow:none}.manage-allocation-request__header{height:71px;border-bottom:1px solid #e7e7e7}.manage-allocation-request__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px}.manage-allocation-request__left{height:71px;width:calc(100% - 250px);float:left}.manage-allocation-request__right{height:71px;width:250px;float:right;border-left:1px solid #e7e7e7}.manage-allocation-request__content{position:relative;top:-20px;height:400px;width:100%;background-color:#fff;opacity:.98}.manage-allocation-request__list-header{cursor:pointer;text-align:center;position:relative;width:100%;border-bottom:1px solid hsla(0,0%,100%,.3);text-transform:uppercase;background-color:#9cd7db;font-weight:700}.manage-allocation-request__table{border-bottom:1px solid #e7e7e7;font-size:12px;margin-bottom:0;text-align:center}.manage-allocation-request__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center;width:14.28571%}.manage-allocation-request__table tbody>tr>td{height:63px;vertical-align:middle;border-color:#e7e7e7;text-align:center;width:14.28571%}@media screen and (min-width:1200px){.manage-allocation-request__table{font-size:14px}}.manage-allocation-request__btn{height:20px;width:45px;font-size:10px;color:#fff;margin:2px}@media screen and (min-width:1200px){.manage-allocation-request__btn{height:30px;width:50px;font-size:12px}}.manage-allocation-request__btn-accept{background:#51bb83;border:1px solid #368a5d;transition:all .2s ease}.manage-allocation-request__btn-accept:hover{background:#368a5d}.manage-allocation-request__btn-cancel,.manage-allocation-request__btn-deny{background:#d95a4b;border:1px solid #b23426;transition:all .2s ease}.manage-allocation-request__btn-cancel:hover,.manage-allocation-request__btn-deny:hover{background:#b23426}.manage-allocation-request__btn-edit{background:#64c1c7;border:1px solid #3b9da3;transition:all .2s ease}.manage-allocation-request__btn-edit:hover{background:#3b9da3}.manage-allocation-request__input{background-color:hsla(0,0%,100%,.2);border:none;text-align:center}.manage-allocation-request__input:focus{outline:none}.manage-allocation-request__no-content{padding-top:70px;text-align:center;height:270px}.manage-allocation-request__no-content>i{font-size:52px}.manage-allocation-request__controls{margin:15px;width:100%}.manage-allocation-request__pagination{position:absolute;left:50%;transform:translateX(-50%);width:160px;background-color:#d95a4b}.manage-allocation-request-form__content{position:relative;top:-20px;height:400px;width:100%;background-color:#fff;opacity:.98}.manage-allocation-request-form__header{height:71px;border-bottom:1px solid #e7e7e7}.manage-allocation-request-form__left{height:71px;width:calc(100% - 70px);float:left}.manage-allocation-request-form__right{height:71px;width:70px;float:right}.manage-allocation-request-form__toggle{cursor:pointer;padding:25px 15px}.manage-allocation-request-form__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px}.manage-allocation-request-form__fields{position:absolute;left:50%;transform:translateX(-50%);width:70%}@media screen and (min-width:992px){.manage-allocation-request-form__fields{width:50%}}.manage-allocation-request-form__field{float:left;width:50%;padding:5px}.manage-allocation-request-form__field:last-child{padding-left:0}.manage-allocation-request-form__controls{float:left;margin-top:100px;width:100%;padding:5px;text-align:center}.manage-allocation-request-form__input{text-align:center}.manage-allocation-request-form__input--success{border-color:#51bb83}.manage-allocation-request-form__input--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.manage-allocation-request-form__input--error{border-color:#d95a4b}.manage-allocation-request-form__input--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.manage-allocation-request-form__units{float:left;width:33.33333%}.manage-allocation-request-form__units--success{border-color:#51bb83}.manage-allocation-request-form__units--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.manage-allocation-request-form__units--error{border-color:#d95a4b}.manage-allocation-request-form__units--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.manage-allocation-request-form__button-accept{width:200px}.manage-allocation-request-form__button-accept:disabled{cursor:not-allowed;background-color:#88d0aa;border:none}.manage-allocation-request-form__button-cancel{width:200px}.manage-allocation-request-form__increment-btn{float:left;height:36px;width:33.33333%}.manage-allocation-request-form__increment-btn:disabled{cursor:not-allowed;border:none}.manage-allocation-request-form__decrement-btn{float:left;height:36px;width:33.33333%}.manage-allocation-request-form__decrement-btn:disabled{cursor:not-allowed;border:none}.manage-allocation-request-form__label{text-align:center}.manage-allocation-request-form__body{padding-top:20px;height:63px;text-align:center;margin-bottom:20px;background-color:#f2f2f2}.manage-allocation-request-form__period{text-align:center;font-size:17px}.manage-allocation-request-form__period-title{font-weight:700}.manage-allocation-form-accept__container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:98}.manage-allocation-form-accept__body{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-box-shadow:0 0 20px 0 rgba(0,0,0,.55);-moz-box-shadow:0 0 20px 0 rgba(0,0,0,.55);-o-box-shadow:0 0 20px 0 rgba(0,0,0,.55);box-shadow:0 0 20px 0 rgba(0,0,0,.55);overflow-y:auto;width:calc(100% - 30px);z-index:99;padding:0;margin-bottom:0;text-align:center}@media screen and (min-width:768px){.manage-allocation-form-accept__body{width:650px}}.manage-allocation-form-accept__header{text-align:center;background-color:#f2f2f2;color:#7d7e83;font-weight:700;font-size:20px;padding:12px 0 10px;line-height:1}.manage-allocation-form-accept__content{overflow-y:auto;padding:15px}.manage-allocation-form-accept__button-group{text-align:center;height:50px;margin-bottom:15px}.manage-allocation-form-accept__submit{margin-right:30px}.manage-allocation-form-accept__alert{color:#e6948a}.manage-allocation-form-row{overflow-y:auto}.manage-allocation-form-row__fields{float:left;width:calc(100% - 110px)}.manage-allocation-form-row__field{float:left;width:14.28571%;padding:5px}.manage-allocation-form-row__field:last-child{padding-left:0}.manage-allocation-form-row__controls{float:left;width:110px;padding:5px;text-align:center}.manage-allocation-form-row__input--success{border-color:#51bb83}.manage-allocation-form-row__input--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.manage-allocation-form-row__input--error{border-color:#d95a4b}.manage-allocation-form-row__input--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.manage-allocation-form-row__button{position:relative;width:30px;height:30px;border-radius:40px;border:1px solid #a4a5a8;margin-top:2px;background-color:#fff;transition:background-color .15s ease,border;float:left;margin-right:5px}.manage-allocation-form-row__button i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:12px;color:#a4a5a8;transition:color .15s ease}.manage-allocation-form-row__button:hover{background-color:#f2f2f2;border-color:#7d7e83;cursor:pointer}.manage-allocation-form-row__button:hover i.fa{color:#7d7e83}.manage-allocation-form-row__button:last-child{margin-right:0}.manage-allocation-form-row__button--disabled{opacity:.3;pointer-events:none}.manage-allocation-form-header__fields{width:calc(100% - 110px);overflow-y:auto;padding:15px 15px 0}.manage-allocation-form-header__field{float:left;width:14.28571%;padding:5px;font-weight:700;height:33px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.manage-allocation-form-header__field:first-child{padding-left:0}.manage-allocation-filters{padding:0;height:140px}@media screen and (min-width:768px){.manage-allocation-filters{height:70px}}@media screen and (max-width:767px){.manage-allocation-filters__option:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.manage-allocation-filters__option{width:33.33333%;float:left}.manage-allocation-filters__option:nth-child(-n+6){border-bottom:1px solid #e7e7e7}.manage-allocation-filters__option:nth-child(2n-1){border-right:1px solid #e7e7e7}}@media screen and (min-width:1200px){.manage-allocation-filters__option{width:25%;float:left}.manage-allocation-filters__option:nth-child(2n-1){border-right:none}.manage-allocation-filters__option:not(:first-child){border-left:1px solid #e7e7e7}.manage-allocation-filters__option:nth-child(5){border-left:none}.manage-allocation-filters__option:nth-child(-n+4){border-bottom:1px solid #e7e7e7}.manage-allocation-filters__option:last-child{border-right:1px solid #e7e7e7;width:calc(100% / 4 + 1px)}}.manage-allocation-calendar__heading{font-size:17px;font-weight:700;width:200px;float:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.manage-allocation-calendar__header{position:relative;border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.manage-allocation-calendar__header{height:71px}}.manage-allocation-calendar__body{margin-top:20px;height:780px;position:relative}@media screen and (max-width:1500px){.manage-allocation-calendar__body{height:1120px}}.manage-allocation-calendar__body.full{height:1450px}@media screen and (max-width:1500px){.manage-allocation-calendar__body.full{height:2150px}}.manage-allocation-calendar__info{cursor:pointer;position:absolute;right:250px;width:280px;height:71px;padding-top:15px;text-align:right;margin-right:15px}.manage-allocation-calendar__info-label{text-transform:uppercase}.manage-allocation-calendar__info-icon>i{position:relative;top:5px;color:#64c1c7;padding-left:10px;font-size:32px;opacity:.8;transition:.2s ease}.manage-allocation-calendar__info-icon>i>i:hover{opacity:1}.manage-allocation-calendar__dropdown{float:right;width:250px;height:71px;border-left:1px solid #d9d9d9}.manage-allocation-calendar__expand{float:right;width:50px;height:71px;text-align:right}.manage-allocation-calendar__expand-off,.manage-allocation-calendar__expand-on{position:absolute;top:50%;transform:translateY(-50%)}.manage-allocation-calendar__wrapper{height:350px;width:33.33333%;float:left;overflow:visible}@media screen and (max-width:1500px){.manage-allocation-calendar__wrapper{width:50%}}.manage-allocation-calendar__month{height:320px;width:360px;margin-left:auto;margin-right:auto}.manage-allocation-calendar__label{height:40px;text-align:center;font-size:20px}.manage-allocation-calendar__week{float:left;height:40px;width:40px;margin:2px;background-color:#d9d9d9;color:#fff;padding-top:10px;padding-right:5px;text-align:right;font-size:22px}.manage-allocation-calendar__weekday{text-align:center;height:20px;width:40px;margin:2px;float:left}.manage-allocation-calendar__controls{position:absolute;left:50%;transform:translateX(-50%);bottom:10px;width:120px;height:50px}.manage-allocation-calendar__page-btn{background-color:#f7f7f7;border:1px solid #d9d9d9;width:40px;height:40px;margin:5px;position:relative;cursor:pointer;transition:.2s ease}.manage-allocation-calendar__page-btn:hover{background-color:#f2f2f2}.manage-allocation-calendar__page-btn:disabled{opacity:.5;cursor:default}.manage-allocation-calendar__page-btn i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.manage-allocation-calendar__error{height:330px;text-align:center;padding:15px}.manage-allocation-calendar__error i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.manage-allocation-calendar__error i.fa{font-size:96px}}.manage-allocation-calendar__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.manage-allocation-calendar__error-message{font-size:20px}}.manage-allocation-calendar__error-retry{cursor:pointer;color:#5bc0de}.manage-allocation-calendar-element{margin:2px;height:40px;width:40px;float:left;transition:.2s ease;cursor:pointer}.manage-allocation-calendar-element.selected{filter:brightness(75%)}.manage-allocation-calendar-element:hover{-webkit-transform:scale(1.1);-moz-transform:scale(1.1);-ms-transform:scale(1.1);-o-transform:scale(1.1);transform:scale(1.1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-empty{cursor:default;background-color:#f7f7f7}.manage-allocation-calendar-element.manage-allocation-calendar-element-PAST{cursor:default;opacity:.4;overflow:hidden}.manage-allocation-calendar-element.manage-allocation-calendar-element-PAST:hover{transform:none}.manage-allocation-calendar-element.manage-allocation-calendar-element-ALLOTMENT{background:#51bb83;background:-moz-linear-gradient(-45deg,#51bb83 0,#51bb83 50%,#51bb83 50%,#368a5d 51%,#368a5d 100%);background:-webkit-linear-gradient(-45deg,#51bb83,#51bb83 50%,#51bb83 0,#368a5d 51%,#368a5d);background:linear-gradient(135deg,#51bb83,#51bb83 50%,#51bb83 0,#368a5d 51%,#368a5d);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-success\",endColorstr=\"$brand-success-dark\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-ALLOTMENT.manage-allocation-calendar-element-arrival-day{border:2px solid #205338}.manage-allocation-calendar-element.manage-allocation-calendar-element-ALLOTMENT.manage-allocation-calendar-element-current-day{border:2px solid #717176}.manage-allocation-calendar-element.manage-allocation-calendar-element-ALLOTMENT.manage-allocation-calendar-element-request{background:#51bb83;background:-moz-linear-gradient(-45deg,#51bb83 0,#51bb83 50%,#51bb83 50%,#f4a830 51%,#f4a830 100%);background:-webkit-linear-gradient(-45deg,#51bb83,#51bb83 50%,#51bb83 0,#f4a830 51%,#f4a830);background:linear-gradient(135deg,#51bb83,#51bb83 50%,#51bb83 0,#f4a830 51%,#f4a830);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-success\",endColorstr=\"$brand-warning\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-ALLOTMENT.manage-allocation-calendar-element-sold-out{background:#d95a4b;background:-moz-linear-gradient(-45deg,#d95a4b 0,#d95a4b 50%,#d95a4b 50%,#b23426 51%,#b23426 100%);background:-webkit-linear-gradient(-45deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#b23426 51%,#b23426);background:linear-gradient(135deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#b23426 51%,#b23426);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-danger\",endColorstr=\"$brand-danger-dark\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-FREESALE{background:#51bb83;background:-moz-linear-gradient(-45deg,#51bb83 0,#51bb83 50%,#51bb83 50%,#368a5d 51%,#368a5d 100%);background:-webkit-linear-gradient(-45deg,#51bb83,#51bb83 50%,#51bb83 0,#368a5d 51%,#368a5d);background:linear-gradient(135deg,#51bb83,#51bb83 50%,#51bb83 0,#368a5d 51%,#368a5d);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-success\",endColorstr=\"$brand-success-dark\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-FREESALE.manage-allocation-calendar-element-request{background:#51bb83;background:-moz-linear-gradient(-45deg,#51bb83 0,#51bb83 50%,#51bb83 50%,#f4a830 51%,#f4a830 100%);background:-webkit-linear-gradient(-45deg,#51bb83,#51bb83 50%,#51bb83 0,#f4a830 51%,#f4a830);background:linear-gradient(135deg,#51bb83,#51bb83 50%,#51bb83 0,#f4a830 51%,#f4a830);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-success\",endColorstr=\"$brand-warning\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-FREESALE.manage-allocation-calendar-element-arrival-day{border:2px solid #205338}.manage-allocation-calendar-element.manage-allocation-calendar-element-FREESALE.manage-allocation-calendar-element-current-day{border:2px solid #717176}.manage-allocation-calendar-element.manage-allocation-calendar-element-REQUEST{background:#f4a830;background:-moz-linear-gradient(-45deg,#f4a830 0,#f4a830 50%,#f4a830 50%,#cd810b 51%,#cd810b 100%);background:-webkit-linear-gradient(-45deg,#f4a830,#f4a830 50%,#f4a830 0,#cd810b 51%,#cd810b);background:linear-gradient(135deg,#f4a830,#f4a830 50%,#f4a830 0,#cd810b 51%,#cd810b);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-warning\",endColorstr=\"$brand-warning-dark\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-REQUEST.manage-allocation-calendar-element-request{background:#f4a830}.manage-allocation-calendar-element.manage-allocation-calendar-element-REQUEST.manage-allocation-calendar-element-arrival-day{border:2px solid #845407}.manage-allocation-calendar-element.manage-allocation-calendar-element-REQUEST.manage-allocation-calendar-element-current-day{border:2px solid #717176}.manage-allocation-calendar-element.manage-allocation-calendar-element-BLOCKED{background:#d95a4b;background:-moz-linear-gradient(-45deg,#d95a4b 0,#d95a4b 50%,#d95a4b 50%,#b23426 51%,#b23426 100%);background:-webkit-linear-gradient(-45deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#b23426 51%,#b23426);background:linear-gradient(135deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#b23426 51%,#b23426);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-danger\",endColorstr=\"$brand-danger-dark\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-BLOCKED.manage-allocation-calendar-element-request{background:#d95a4b;background:-moz-linear-gradient(-45deg,#d95a4b 0,#d95a4b 50%,#d95a4b 50%,#f4a830 51%,#f4a830 100%);background:-webkit-linear-gradient(-45deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#f4a830 51%,#f4a830);background:linear-gradient(135deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#f4a830 51%,#f4a830);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-danger\",endColorstr=\"$brand-warning\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-BLOCKED.manage-allocation-calendar-element-arrival-day{border:2px solid #732218}.manage-allocation-calendar-element.manage-allocation-calendar-element-BLOCKED.manage-allocation-calendar-element-current-day{border:2px solid #717176}.manage-allocation-calendar-element.manage-allocation-calendar-element-NULL{background:#d95a4b;background:-moz-linear-gradient(-45deg,#d95a4b 0,#d95a4b 50%,#d95a4b 50%,#b23426 51%,#b23426 100%);background:-webkit-linear-gradient(-45deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#b23426 51%,#b23426);background:linear-gradient(135deg,#d95a4b,#d95a4b 50%,#d95a4b 0,#b23426 51%,#b23426);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"$brand-danger\",endColorstr=\"$brand-danger-dark\",GradientType=1)}.manage-allocation-calendar-element.manage-allocation-calendar-element-NULL.manage-allocation-calendar-element-arrival-day{border:2px solid #732218}.manage-allocation-calendar-element.manage-allocation-calendar-element-NULL.manage-allocation-calendar-element-current-day{border:2px solid #717176}.manage-allocation-calendar-element.manage-allocation-calendar-element-edit{filter:brightness(75%);transform:scale(1.05)}.manage-allocation-calendar-element__day{margin-top:2px;font-size:11px;color:#fff;padding-left:3px}.manage-allocation-calendar-element__day--postfix{font-size:9px}.manage-allocation-calendar-element__units{font-size:12px;color:#fff;z-index:10;float:right;margin-top:1px;padding-right:3px}.manage-allocation-calendar-element__tooltip{position:relative;display:block;background-color:rgba(0,0,0,.7);color:#fff;width:160px;height:60px;bottom:85px;left:-55px}.manage-allocation-calendar-element__tooltip-content{position:relative;top:50%;left:50%;transform:translate(-50%,-50%);height:60px;width:160px;text-align:center;font-size:10px;top:15px}.manage-allocation-calendar-infobox__heading{font-size:17px;font-weight:700;width:100%;float:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px}.manage-allocation-calendar-infobox__header,.manage-allocation-calendar-infobox__heading{position:relative;border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.manage-allocation-calendar-infobox__header{height:71px}}.manage-allocation-calendar-infobox__body{height:450px;width:100%;position:relative;overflow:hidden}.manage-allocation-calendar-infobox__footer{height:50px}.manage-allocation-calendar-infobox__controls{position:absolute;left:50%;transform:translateX(-50%);height:50px;padding-top:10px}.manage-allocation-calendar-infobox__indicator{float:left;margin:3px;width:15px;height:15px;border:1px solid #7d7e83;border-radius:50px;cursor:pointer}.manage-allocation-calendar-infobox__indicator.selected{background-color:#7d7e83}.manage-allocation-calendar-infobox__toggle{width:50px;height:50px;color:#a4a5a8;float:right;position:absolute;right:5px;text-align:center;padding-top:3px;font-size:24px;cursor:pointer}.manage-allocation-calendar-infobox-pages__body{height:100%;width:100%}.manage-allocation-calendar-infobox-pages__content{position:relative;left:0;width:100%;height:400px}.manage-allocation-calendar-infobox-pages #img-1,.manage-allocation-calendar-infobox-pages #img-2,.manage-allocation-calendar-infobox-pages #img-3,.manage-allocation-calendar-infobox-pages #img-4,.manage-allocation-calendar-infobox-pages #img-5,.manage-allocation-calendar-infobox-pages #img-6{float:left;width:33.33333%;text-align:center}.manage-allocation-modal__container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:200}.manage-allocation-modal__content{-webkit-box-shadow:0 0 20px 0 rgba(0,0,0,.55);-moz-box-shadow:0 0 20px 0 rgba(0,0,0,.55);-o-box-shadow:0 0 20px 0 rgba(0,0,0,.55);box-shadow:0 0 20px 0 rgba(0,0,0,.55);position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;z-index:99;overflow-x:hidden;overflow-y:auto}@media screen and (min-width:768px){.manage-allocation-modal__content{width:750px;max-height:720px}}@media screen and (min-width:1200px){.manage-allocation-modal__content{width:1150px;max-height:720px}}.manage-allocation-modal__heading{font-weight:700;font-size:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.manage-allocation-modal__toggle{position:absolute;height:71px;line-height:71px;color:#a4a5a8;top:0;right:0;padding-top:5px;margin-right:15px;font-size:24px;cursor:pointer}.manage-allocation-modal__body{height:600px}.manage-allocation-modal__title{font-size:32px;text-align:center;padding-top:100px}.manage-allocation-modal__period{text-align:center;font-size:14px}.manage-allocation-modal__add{text-align:center;margin-top:100px}.manage-allocation-modal__info{position:absolute;top:600px;text-align:center;width:100%;padding:15px;background-color:#f2f2f2}.manage-allocation-modal__alert{position:absolute;top:85px;text-align:center;width:100%;padding:15px}.manage-allocation-modal__success{color:#368a5d;background-color:#bfe6d1}.manage-allocation-modal__warning{color:#cd810b;background-color:#fce5c1}.manage-allocation-modal__error{position:absolute;top:71px;text-align:center;width:100%;padding:15px;color:#b23426;background-color:#f4cec9}.manage-allocation-modal-form{overflow-y:auto;padding:15px}.manage-allocation-modal-form__content{height:300px;width:100%;overflow-y:auto}.manage-allocation-modal-form__fields{float:left;width:100%}.manage-allocation-modal-form__field{float:left;width:20%;padding:5px}.manage-allocation-modal-form__field:last-child{padding-left:0}.manage-allocation-modal-form__input--success{border-color:#51bb83}.manage-allocation-modal-form__input--success:focus{border-color:#51bb83;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(81,187,131,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(81,187,131,.6) rgba(0,0,0,.55)}.manage-allocation-modal-form__input--error{border-color:#d95a4b}.manage-allocation-modal-form__input--error:focus{border-color:#d95a4b;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);-o-box-shadow:inset 0 1px 1px rgba(0,0,0,.075) 0 0 8px rgba(217,90,75,.6) 20px 0 rgba(0,0,0,.55);box-shadow:inset 0 1px 1px 0 0 8px 20px 0 rgba(0,0,0,.075) rgba(217,90,75,.6) rgba(0,0,0,.55)}.manage-allocation-modal-form__button{position:relative;width:30px;height:30px;border-radius:40px;border:1px solid #a4a5a8;margin-top:2px;background-color:#fff;transition:background-color .15s ease,border;float:left;margin-right:5px}.manage-allocation-modal-form__button i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:12px;color:#a4a5a8;transition:color .15s ease}.manage-allocation-modal-form__button:hover{background-color:#f2f2f2;border-color:#7d7e83;cursor:pointer}.manage-allocation-modal-form__button:hover i.fa{color:#7d7e83}.manage-allocation-modal-form__button:last-child{margin-right:0}.manage-allocation-modal-form__button--disabled{opacity:.3;pointer-events:none}.manage-allocation-modal-form__submit{margin-right:10px}.manage-allocation-modal-form__reset{width:160px}.manage-allocation-modal-form__control-buttons{top:15px;width:100%;display:flex;justify-content:center;position:relative;left:50%;transform:translateX(-50%)}.manage-allocation-modal-form__control-message{float:left;width:calc(100% - 330px);line-height:34.4px;padding-left:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.manage-allocation-modal-form__error{position:absolute;left:50%;transform:translateX(-50%);text-align:center;padding-bottom:5px;bottom:130px;width:100%;border-radius:0}.manage-allocation-modal-list__content{position:absolute;width:100%;height:430px;top:290px}.manage-allocation-modal-list__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}@media screen and (min-width:1200px){.manage-allocation-modal-list__heading{border-bottom:none;float:left;width:calc(100% - 440px)}}.manage-allocation-modal-list__option{width:100%}@media screen and (max-width:767px){.manage-allocation-modal-list__option:not(:last-child){border-bottom:1px solid #e7e7e7}}@media screen and (min-width:768px){.manage-allocation-modal-list__option{border-bottom:none;float:left;width:11.11111%}.manage-allocation-modal-list__option:not(:nth-child(2)){border-left:1px solid #e7e7e7}}@media screen and (min-width:1200px){.manage-allocation-modal-list__option{border-bottom:none;border-left:1px solid #e7e7e7;float:right;width:220px}}.manage-allocation-modal-list__option--pagination{height:70px;padding-top:15px;text-align:center}@media screen and (max-width:767px){.manage-allocation-modal-list__option--pagination{padding-left:15px;padding-right:15px}}@media screen and (min-width:768px){.manage-allocation-modal-list__option--pagination .pagination-control{display:inline-block}}.manage-allocation-modal-list__header{border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.manage-allocation-modal-list__header{height:71px}}@media screen and (min-width:1200px){.manage-allocation-modal-list__header--minimized .manage-allocation-modal-list__heading{float:none;width:100%}}.manage-allocation-modal-list__header--minimized .manage-allocation-modal-list__option{width:11.11111%}.manage-allocation-modal-list__header--minimized .manage-allocation-modal-list__option:nth-child(2){border-left:none}.manage-allocation-modal-list__table{border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;display:none;text-align:center}@media screen and (min-width:768px){.manage-allocation-modal-list__table{display:table;font-size:12px}}@media screen and (min-width:992px){.manage-allocation-modal-list__table{font-size:13px}}@media screen and (min-width:1200px){.manage-allocation-modal-list__table{font-size:14px}}.manage-allocation-modal-list__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center}.manage-allocation-modal-list__table thead>tr>th:first-child{width:100px;padding-left:15px}.manage-allocation-modal-list__table thead>tr>th:nth-child(2),.manage-allocation-modal-list__table thead>tr>th:nth-child(3),.manage-allocation-modal-list__table thead>tr>th:nth-child(4),.manage-allocation-modal-list__table thead>tr>th:nth-child(5),.manage-allocation-modal-list__table thead>tr>th:nth-child(6),.manage-allocation-modal-list__table thead>tr>th:nth-child(7){width:100px}.manage-allocation-modal-list__table thead>tr>th:nth-child(8){width:100px;padding-right:15px}.manage-allocation-modal-list__table tbody>tr>td{height:63px;vertical-align:middle;border-color:#e7e7e7}.manage-allocation-modal-list__table tbody>tr>td:first-child{width:100px;padding-left:15px}.manage-allocation-modal-list__table tbody>tr>td:nth-child(2),.manage-allocation-modal-list__table tbody>tr>td:nth-child(3),.manage-allocation-modal-list__table tbody>tr>td:nth-child(4),.manage-allocation-modal-list__table tbody>tr>td:nth-child(5),.manage-allocation-modal-list__table tbody>tr>td:nth-child(6),.manage-allocation-modal-list__table tbody>tr>td:nth-child(7){width:100px}.manage-allocation-modal-list__table tbody>tr>td:nth-child(8){width:100px;padding-right:15px}.manage-allocation-modal-list__btn{padding:8px;font-size:12px}.manage-allocation-modal-list__edit-requests{color:#e6948a}.manage-allocation-modal-list__footer{position:absolute;left:50%;transform:translateX(-50%);bottom:0;padding:15px}@media screen and (min-width:768px){.manage-allocation-modal-list__items{display:none}}.manage-allocation-modal-list__error{height:330px;text-align:center;padding:15px}.manage-allocation-modal-list__error i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.manage-allocation-modal-list__error i.fa{font-size:96px}}.manage-allocation-modal-list__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.manage-allocation-modal-list__error-message{font-size:20px}}.manage-allocation-modal-overlay__content{position:absolute;top:0;left:0;margin-bottom:0;width:100%;height:720px;z-index:99}.manage-allocation-modal-overlay__heading{position:relative;font-weight:700;font-size:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.manage-allocation-modal-overlay__toggle{position:absolute;height:71px;line-height:71px;color:#a4a5a8;top:0;right:0;padding-top:5px;margin-right:15px;font-size:24px;cursor:pointer}.manage-allocation-modal-overlay__body{position:relative;height:calc(100% - 71px);overflow:auto}.manage-allocation-modal-overlay__period{height:70px;padding-left:15px;padding-top:15px;font-size:24px}.manage-allocation-modal-overlay__info{position:absolute;top:600px;text-align:center;width:100%;padding:15px;background-color:#f2f2f2}.manage-allocation-modal-overlay__success{text-align:center}.manage-allocation-modal-overlay-form{overflow-y:auto;padding:15px}.manage-allocation-modal-overlay-form__alert{text-align:center}.manage-allocation-modal-overlay-form__form{width:calc(50% - 15px);float:left}.manage-allocation-modal-overlay-form__block{display:inline-block;font-size:13px;color:#e6948a;cursor:pointer;padding-left:15px;-webkit-transition:all .2s ease;-o-transition:.2s all ease;transition:all .2s ease}.manage-allocation-modal-overlay-form__block:hover{color:#b23426}.manage-allocation-modal-overlay-form__statistics{width:50%;float:right;padding:15px;font-size:16px}.manage-allocation-modal-overlay-form__instruction-toggle{cursor:pointer;text-align:center;font-size:13px;color:#5bc0de}.manage-allocation-modal-overlay-form__icon-plus{color:#88d0aa}.manage-allocation-modal-overlay-form__icon-minus{color:#e6948a}.manage-allocation-modal-overlay-form__edit{width:50%;float:right;padding:15px;font-size:16px}.manage-allocation-modal-overlay-form__edit-label{text-align:center;padding-bottom:15px;margin-bottom:15px;border-bottom:1px solid #e7e7e7;font-weight:700}.manage-allocation-modal-overlay-form__edit-input{width:100%;text-align:center;border:none;padding:10px}.manage-allocation-modal-overlay-form__edit-input:focus{outline:none}.manage-allocation-modal-overlay-form__date{width:100%;text-align:center}.manage-allocation-modal-overlay-form__instruction{width:100%;float:left;text-align:center}.manage-allocation-modal-overlay-form__text-default{margin-bottom:15px}.manage-allocation-modal-overlay-form__select{cursor:pointer;width:100%;height:30px;text-align:center;padding-left:5px}@media screen and (min-width:1200px){.manage-allocation-modal-overlay-form__select{height:40px}}.manage-allocation-modal-overlay-form__edit-buttons{margin-top:15px}.manage-allocation-modal-overlay-form__increment-btn{float:left;height:36px;width:50%}.manage-allocation-modal-overlay-form__increment-btn:disabled{cursor:not-allowed;border:none}.manage-allocation-modal-overlay-form__decrement-btn{float:left;height:36px;width:50%}.manage-allocation-modal-overlay-form__decrement-btn:disabled{cursor:not-allowed;border:none}.manage-allocation-modal-overlay-form__item-label{font-weight:700}.manage-allocation-modal-overlay-form__item-value{float:right}.manage-allocation-modal-overlay-form__item-change{float:right;margin-right:15px;color:#f8c779}.manage-allocation-modal-overlay-form__item-alert{margin-top:15px;text-align:center;font-size:13px;color:#e6948a}.manage-allocation-modal-overlay-form__list-item{font-size:13px}.manage-allocation-modal-overlay-form__list-value{float:right}.manage-allocation-modal-overlay-form__item-days{margin-top:5px}.manage-allocation-modal-overlay-form__item-day{text-align:center;font-size:12px;width:calc(14.28571% - 4px);display:inline-block}.manage-allocation-modal-overlay-form__checkbox{display:inline-block;cursor:default;height:13px;width:13px;background-image:url(" + escape(__webpack_require__(75)) + ")}.manage-allocation-modal-overlay-form__checkbox--checked{background-image:url(" + escape(__webpack_require__(76)) + ")}.manage-allocation-modal-form-header__fields{width:100%;overflow-y:auto;padding:15px 15px 0}.manage-allocation-modal-form-header__field{float:left;width:20%;padding:5px;font-weight:700;height:33px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.manage-allocation-modal-form-header__field:first-child{padding-left:0}.key-value-menu{position:relative;width:100%}.key-value-menu__button{padding:10px 15px;cursor:pointer;height:70px}.key-value-menu__button:hover{background-color:#f7f7f7}.key-value-menu:after{content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none}.key-value-menu__label{width:calc(100% - 20px);font-size:17px;color:#a4a5a8}.key-value-menu__label,.key-value-menu__value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none;font-weight:700}.key-value-menu__value{font-size:14px}.key-value-menu__value--empty{color:#cbccce}.key-value-menu__dropdown{position:absolute;left:0;top:100%;background-color:#fff;width:100%;border-top:1px solid #e7e7e7;box-shadow:0 10px 15px 0 rgba(0,0,0,.08);max-height:350px;white-space:nowrap;overflow-x:hidden;overflow-y:auto;text-overflow:ellipsis;z-index:999}.key-value-menu__choice{height:51px;line-height:51px;padding:0 15px;z-index:500;position:relative}.key-value-menu__choice:not(:last-child){border-bottom:1px solid #e7e7e7}.key-value-menu__choice:hover{background-color:#f7f7f7;cursor:pointer}.key-value-menu__choice--selected:after{content:\"\\F00C\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;transform:translateY(-50%);right:15px;font-size:17px;pointer-events:none;color:#64c1c7}.key-value-menu--disabled .key-value-menu__button{cursor:no-drop;opacity:.5}.key-value-menu--disabled .key-value-menu__button:hover{background-color:#fff}.key-value-menu--disabled:after{opacity:0}.info-widget__toggle{color:#fff;text-shadow:0 0 5px rgba(0,0,0,.5);cursor:pointer;font-size:32px;position:fixed;height:50px;width:100px;bottom:50px;right:-50px;padding-left:15px;padding-top:2px;background-color:#64c1c7;border-radius:35px;transition:all .2s ease;-webkit-box-shadow:0 0 4px 1px rgba(0,0,0,.4);-moz-box-shadow:0 0 4px 1px rgba(0,0,0,.4);box-shadow:0 0 4px 1px rgba(0,0,0,.4);z-index:100}.info-widget__toggle:hover{height:55px;right:-45px;bottom:48px;font-size:35px;padding-left:15px;padding-top:2px}.info-widget__container{position:fixed;text-shadow:0 0 2px rgba(0,0,0,.3);right:-200px;bottom:-150px;height:600px;width:600px;display:block;background:#6bc3c9;background:-moz-linear-gradient(-45deg,#6bc3c9 0,#6bc3c9 0,#5aabb1 80%);background:-webkit-linear-gradient(-45deg,#6bc3c9,#6bc3c9 0,#5aabb1 80%);background:linear-gradient(135deg,#6bc3c9,#6bc3c9 0,#5aabb1 80%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#6bc3c9\",endColorstr=\"#5aabb1\",GradientType=1);border-radius:300px;color:#fff;-webkit-box-shadow:0 0 15px 1px rgba(0,0,0,.4);-moz-box-shadow:0 0 15px 1px rgba(0,0,0,.4);box-shadow:0 0 15px 1px rgba(0,0,0,.4);transition:all .2s ease;z-index:99;opacity:.98}.info-widget__content{cursor:default;display:block;height:250px;width:280px;position:relative;top:80px;left:80px;margin:30px}.info-widget__info-title{font-weight:700;font-size:17px;height:27px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.info-widget__info-body{height:70px;overflow:hidden;text-overflow:ellipsis;white-space:normal}.info-widget__info-body--expanded{height:200px}.info-widget__info-more{top:-5px}.info-widget__info-less,.info-widget__info-more{cursor:pointer;text-align:center;position:relative}.info-widget__welcome{font-size:24px;font-weight:700;margin-bottom:15px}.info-widget__tips{margin-bottom:10px;height:120px;overflow:hidden;border-bottom:1px solid hsla(0,0%,100%,.3);transition:all .2s ease}.info-widget__tips--expanded{height:250px}.info-widget__tips-controls{height:30px;text-align:center;width:100%}.info-widget__tips-page{display:inline-block;cursor:pointer;height:10px;width:10px;border:1px solid #fff;border-radius:15px;margin:5px}.info-widget__tips-page--selected{background-color:#fff}.info-widget__contact-header{font-size:17px;font-weight:700}.info-widget__contact-email{text-decoration:none;color:#fff;font-weight:400}.info-widget__contact-email:hover{color:#fff}.instruction__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.instruction__header-icon{padding-right:10px}.instruction__body{margin:15px;padding-bottom:15px;font-weight:700}.instruction__dismiss{background-color:#51bb83}.instruction__dismiss-btn{width:100%;background-color:#fff;border:none;border-top:1px solid #e7e7e7;padding:5px;-webkit-transition:all .2s ease}.instruction__dismiss-btn:hover{background-color:#f2f2f2}.introduction-container{padding-top:30px}@media screen and (min-width:768px){.introduction-container{padding-top:60px}}@media screen and (min-width:992px){.introduction-container{padding-top:120px}}.introduction-container__logo{max-width:100%;height:auto;display:block;margin-right:auto;margin-left:auto;max-width:220px;margin-bottom:30px}@media screen and (min-width:768px){.introduction-container__logo{max-width:400px;margin-bottom:60px}}@media screen and (min-width:992px){.introduction-container__logo{max-width:600px;margin-bottom:60px}}.introduction-accept-page{text-align:center}.introduction-accept-page__header{font-weight:700;font-size:30px;margin-bottom:35px}@media screen and (min-width:768px){.introduction-accept-page__header{font-size:52px;margin-bottom:50px}}.introduction-accept-page__body{font-size:14px;margin-bottom:35px}@media screen and (min-width:768px){.introduction-accept-page__body{font-size:17px;margin-bottom:250px}}.introduction-accept-page__footer{font-size:13px}.contract-management-list{clear:both}.contract-management-list__header,.contract-management-list__heading{height:71px;border-bottom:1px solid #e7e7e7;width:100%}.contract-management-list__heading{font-size:17px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:71px;padding:0 15px}@media screen and (min-width:1200px){.contract-management-list__heading{border-bottom:none;float:left;width:280px}}.contract-management-list__filters{width:100%;float:right}@media screen and (min-width:1600px){.contract-management-list__filters{width:calc(100% - 280px)}}.contract-management-list__table{border-bottom:1px solid #e7e7e7;font-size:14px;margin-bottom:0;display:none;text-align:center}@media screen and (min-width:768px){.contract-management-list__table{display:table;font-size:12px}}@media screen and (min-width:992px){.contract-management-list__table{font-size:13px}}@media screen and (min-width:1200px){.contract-management-list__table{font-size:14px}}.contract-management-list__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center;width:20%}.contract-management-list__table tbody>tr>td{height:63px;vertical-align:middle;border-color:#e7e7e7;text-align:center;width:20%}.contract-management-list__footer{padding:15px}.contract-management-list__pagination{display:inline-block;margin-top:5px;position:relative;left:50%;transform:translateX(-50%)}.contract-management-list__items{float:left;width:100%;margin-bottom:15px}.contract-management-list__error{height:330px;text-align:center;padding:15px}.contract-management-list__error i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-management-list__error i.fa{font-size:96px}}.contract-management-list__error-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-management-list__error-message{font-size:20px}}.contract-management-list__btn{display:inline-block;margin:5px}@media screen and (min-width:768px){.contract-management-list__items{display:none}}.contract-management-list__notes{color:#e6948a}.contract-management-list-filters{width:100%;position:relative;clear:both}.contract-management-list-filters__option{position:relative;height:71px;width:100%;float:right;border-left:1px solid #e7e7e7;border-bottom:1px solid #e7e7e7}@media screen and (min-width:768px){.contract-management-list-filters__option{width:50%}.contract-management-list-filters__option:nth-child(n+5){border-bottom:none}}@media screen and (min-width:992px){.contract-management-list-filters__option{width:16.66667%;border-bottom:none}}.contract-management-list-filters__pagination{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:inline-block}.contract-management-list-filters__search-input{height:69px;width:100%;line-height:71px;border:none;padding-left:15px}.contract-management-list-filters__search-input:focus{outline:none}.contract-management-item{clear:both}.contract-management-item__label{padding:0 15px;width:calc(100% - 50px)}.contract-management-item__control,.contract-management-item__label{height:40px;line-height:40px;float:left;border-bottom:1px solid #e7e7e7}.contract-management-item__control{width:50px;border-left:1px solid #e7e7e7;padding-left:15px}.contract-management-item__control:hover{background-color:#f7f7f7}.contract-management-item__content{float:left;border-bottom:1px solid #e7e7e7;padding:15px;background-color:#f7f7f7;width:100%}.contract-management-item__props{border:1px solid #e7e7e7;background-color:#fff}.contract-management-item__prop{overflow-y:auto;border-bottom:1px solid #e7e7e7;padding:5px 0}.contract-management-item__prop-key{font-weight:700;text-align:center}.contract-management-item__prop-value{text-align:center}.contract-management-item__prop-button{display:block;width:100%;color:#7d7e83;font-weight:400;text-align:center;cursor:pointer}.contract-management-item__prop-button:hover{text-decoration:none;color:#7d7e83}.contract-management-edit-form__content{width:100%}.contract-management-edit-form__heading{font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-management-edit-form__body{width:100%;height:390px}.contract-management-edit-form__sub-heading{display:inline-block;font-weight:200;font-size:14px}.contract-management-edit-form__optional{font-size:13px;font-weight:200}.contract-management-edit-form__btn{display:inline-block;margin:15px;float:right;cursor:pointer}.contract-management-edit-form__form-input{float:left;width:100%}.contract-management-edit-form__form-auto-complete{display:inline-block;width:calc(80% - 5px)}.contract-management-edit-form__input{width:calc(100% - 30px);float:left;margin:0 15px 15px}.contract-management-edit-form__input:focus{outline:none}.contract-management-edit-form__input-title{width:calc(100% - 30px);margin-top:15px}@media screen and (min-width:992px){.contract-management-edit-form__input-title{width:calc(80% - 15px)}}.contract-management-edit-form__input-label{float:left;cursor:pointer;margin-left:15px;font-weight:400;width:calc(100% - 30px);height:200px;text-align:center;padding-top:90px;border:1px solid #e7e7e7}.contract-management-edit-form__input-text{margin-top:15px;padding:15px;min-height:360px;max-height:360px;border:1px solid #e7e7e7}.contract-management-edit-form__input-text-small{padding:15px;min-height:360px;max-height:360px;min-width:calc(100% - 30px);max-width:calc(100% - 30px);border:1px solid #e7e7e7}@media screen and (min-width:992px){.contract-management-edit-form__input-text-small{min-width:calc(40% - 30px);max-width:calc(40% - 30px)}}.contract-management-edit-form__sites{margin:0 15px}.contract-management-edit-form__upload{display:inline-block;width:100%}.contract-management-edit-form__add-field{display:none}@media screen and (min-width:992px){.contract-management-edit-form__add-field{display:block}}.contract-management-edit-form__add-field-mobile{display:inline-block;width:100%}@media screen and (min-width:992px){.contract-management-edit-form__add-field-mobile{display:none}}.contract-management-edit-form__checkboxes{height:50px;padding:15px;width:calc(100% - 30px);margin:15px 15px 0;border:1px solid #e7e7e7}.contract-management-edit-form__checkbox{display:inline-block;cursor:pointer;height:13px;width:13px;background-image:url(" + escape(__webpack_require__(75)) + ");margin-left:5px}.contract-management-edit-form__checkbox--checked{background-image:url(" + escape(__webpack_require__(76)) + ")}.contract-management-edit-form-add{float:right;width:calc(100% - 30px);max-height:427px;border:1px solid #e7e7e7;padding:15px 15px 0;margin:15px 15px 0}@media screen and (min-width:992px){.contract-management-edit-form-add{height:427px;width:calc(20% - 30px);margin:15px 15px 0 0}}.contract-management-edit-form-add__add-btn{height:40px;font-weight:700;cursor:pointer;margin-top:40px;padding-top:10px;margin-bottom:-10px;position:relative;top:50%;left:50%;transform:translate(-50%,-50%);color:#64c1c7;text-align:center;border-top:1px solid #e7e7e7;transition:all .2s ease}.contract-management-edit-form-add__add-btn:hover{background-color:#9cd7db;color:#fff}@media screen and (min-width:992px){.contract-management-edit-form-add__add-btn{margin-top:20px;margin-bottom:-20px}}.contract-management-edit-form-add__elements{height:auto;overflow:auto}@media screen and (min-width:992px){.contract-management-edit-form-add__elements{height:360px;overflow:auto}}.contract-management-edit-form-add__name{display:inline-block;width:calc(100% - 25px);cursor:pointer;transition:all .2s ease;padding-left:5px}.contract-management-edit-form-add__name:hover{background-color:#f7f7f7}.contract-management-edit-form-add__name--active:after{content:\"\\F060\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:relative;transform:translateY(-50%);font-size:10px;left:5px;top:-1px}.contract-management-edit-form-add__remove{cursor:pointer;color:#e6948a;margin-right:5px;transition:all .2s ease}.contract-management-edit-form-add__remove:hover{color:#d95a4b}.contract-management-edit-upload{padding-bottom:15px}.contract-management-edit-upload__content{float:left;margin:0 15px;width:calc(100% - 30px)}.contract-management-edit-upload__dropbox{outline:2px dotted #d9d9d9;color:#7d7e83;padding:10px;min-height:120px;margin-bottom:5px;position:relative;cursor:pointer}.contract-management-edit-upload__dropbox:hover{background-color:#f7f7f7}.contract-management-edit-upload__text{text-align:center;margin-top:-100px}.contract-management-edit-upload__icon{font-size:18px}.contract-management-edit-upload__accepted{font-size:12px}.contract-management-edit-upload__input-file{opacity:0;width:100%;min-height:120px;cursor:pointer}.contract-management-edit-upload__file-list{list-style-type:none;position:absolute;top:0;left:0;margin:15px -15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.contract-management-edit-upload__btn{margin-right:10px;font-size:18px}.contract-management-edit-upload__btn:hover{color:#58585c}.contract-management-edit-upload__delete-button,.contract-management-edit-upload__remove-button{color:#e6948a}.contract-management-edit-upload__delete-button:hover,.contract-management-edit-upload__remove-button:hover{color:#d95a4b}.contract-management-edit-images{padding-bottom:15px}.contract-management-edit-images__content{float:left;margin:0 15px 15px;width:calc(100% - 30px);height:360px}@media screen and (min-width:992px){.contract-management-edit-images__content{width:40%;margin:0}}.contract-management-edit-images__dropbox{outline:2px dotted #d9d9d9;color:#7d7e83;height:360px;position:relative;cursor:pointer;padding:10px}.contract-management-edit-images__dropbox:hover{background-color:#f7f7f7}.contract-management-edit-images__text{position:absolute;width:100%;text-align:center;margin-top:120px;z-index:0;user-select:none;pointer-events:none}.contract-management-edit-images__icon{font-size:18px}.contract-management-edit-images__accepted{font-size:12px}.contract-management-edit-images__input-file{position:absolute;opacity:0;width:90%;min-height:360px;cursor:pointer;z-index:0}.contract-management-edit-images__images{top:15px;width:100%;height:100%;overflow:auto}.contract-management-edit-images__thumb{position:relative;display:inline-block;height:75px;width:calc(16.66667% - 8px);overflow:hidden;margin-right:5px;border:1px solid #e7e7e7;background-color:#000}.contract-management-edit-images__thumb-upload{border:1px solid #9cd7db}.contract-management-edit-images__thumb-wrapper{height:100%;transition:all .2s ease}.contract-management-edit-images__thumb-image{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transition:all .2s ease;z-index:0;height:150%}.contract-management-edit-images__thumb-buttons{position:absolute;width:100%;height:100%;opacity:0;transition:all .2s ease;background-color:rgba(100,193,199,.9)}.contract-management-edit-images__thumb-button{position:relative;display:inline-block;height:100%;z-index:10;opacity:.2;transition:all .2s ease}.contract-management-edit-images__thumb-button:hover{opacity:.9}.contract-management-edit-images__thumb-remove{width:100%}.contract-management-edit-images__thumb-remove:before{content:\"\\F068\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:15px;color:#fff}.contract-management-edit-images__thumb-delete{width:calc(50% - 2px)}.contract-management-edit-images__thumb-delete:before{content:\"\\F1F8\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:15px;color:#fff}.contract-management-edit-images__thumb-download{width:calc(50% - 2px)}.contract-management-edit-images__thumb-download:before{content:\"\\F019\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:15px;color:#fff}.contract-management-edit-images__error{float:left;width:calc(50% - 30px);height:360px;text-align:center;padding:15px;border:1px solid #e7e7e7}.contract-management-edit-images__error-icon{margin-top:120px;font-size:32px}.contract-management-edit-control__content{width:100%;height:125px}@media screen and (min-width:992px){.contract-management-edit-control__content{height:70px}}.contract-management-edit-control__paging-buttons{display:inline-block;position:relative;left:50%;transform:translateX(-50%);margin-top:10px;margin-bottom:15px}.contract-management-edit-control__page-btn{background-color:#f7f7f7;border:1px solid #d9d9d9;width:40px;height:40px;margin:5px;position:relative;cursor:pointer;transition:.2s ease}.contract-management-edit-control__page-btn:hover{background-color:#f2f2f2}.contract-management-edit-control__page-btn:disabled{opacity:.5;cursor:default}.contract-management-edit-control__page-btn i.fa{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.contract-management-edit-control__buttons{display:inline-block;position:relative;margin:8px 0;float:right;top:70px;right:50%;transform:translateX(50%)}@media screen and (min-width:992px){.contract-management-edit-control__buttons{margin:18px 15px;right:0;transform:translateX(0);top:0}}.contract-management-edit-control__btn:disabled{background-color:#f7f7f7;color:#d9d9d9}.contract-management-edit-control__btn:disabled:hover{background-color:#f7f7f7;border:1px solid #e7e7e7}.contract-management-edit-progress__content{width:100%}.contract-management-edit-progress__heading{cursor:pointer;font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-management-edit-progress__heading:after{float:right;content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900}.contract-management-edit-progress__heading--toggled:after{float:right;content:\"\\F106\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900}.contract-management-edit-progress__items{height:305px}@media screen and (min-width:992px){.contract-management-edit-progress__items{height:140px}}.contract-management-edit-progress__item{float:left;width:calc(100% - 30px);margin:15px;border:1px solid #e7e7e7}@media screen and (min-width:992px){.contract-management-edit-progress__item:first-child{width:calc(60% - 30px)}.contract-management-edit-progress__item:nth-child(2){width:calc(40% - 30px)}}.contract-management-edit-progress__item-label{margin-top:5px;text-align:center;width:100%;border-bottom:1px solid #e7e7e7;font-size:12px;text-overflow:ellipsis;overflow:hidden;height:25px;line-height:25px}@media screen and (min-width:992px){.contract-management-edit-progress__item-label{font-size:14px}}.contract-management-edit-progress__item-element{cursor:pointer;height:30px;float:left;margin:15px}.contract-management-edit-progress__item-element--basic{width:calc(100% / 3 - 30px)}.contract-management-edit-progress__item-element--extended{width:calc(100% / 4 - 30px)}@media screen and (min-width:768px){.contract-management-edit-progress__item-element--basic{width:calc(100% / 6 - 30px)}.contract-management-edit-progress__item-element--extended{width:calc(100% / 4 - 30px)}}@media screen and (min-width:992px){.contract-management-edit-progress__item-element{height:50px}}.contract-management-edit-progress__item-sub-header{text-align:center;font-size:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}@media screen and (min-width:992px){.contract-management-edit-progress__item-sub-header{font-size:10px}}.contract-management-edit-progress__item-icon{height:100%;width:100%;text-align:center;font-size:18px;color:#e6948a}.contract-management-edit-progress__item-icon--done{color:#88d0aa}.contract-management-edit-progress__item-icon--active{color:#64c1c7!important;text-shadow:0 0 3px rgba(0,0,0,.4)}.contract-management-edit-progress__item-icon--optional{color:#f8c779}@media screen and (min-width:992px){.contract-management-edit-progress__item-icon{font-size:28px}}.contract-management-edit-progress__link{color:#a4a5a8}.contract-management-edit-progress__link:hover{color:#7d7e83}.contract-management-edit-email__content{height:142px;margin-bottom:15px}@media screen and (min-width:992px){.contract-management-edit-email__content{height:71px}}.contract-management-edit-email__left{font-size:17px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;float:left;height:71px;width:100%;line-height:71px;padding:0 15px;text-align:center;border-bottom:1px solid #e7e7e7}@media screen and (min-width:992px){.contract-management-edit-email__left{width:50%;text-align:left;border-bottom:none}}.contract-management-edit-email__right{float:left;height:71px;width:100%;line-height:71px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 15px;text-align:center}@media screen and (min-width:992px){.contract-management-edit-email__right{width:50%;text-align:right;float:right}}.contract-notes{-webkit-transition:all .2s ease;-o-transition:.2s all ease;transition:all .2s ease}.contract-notes--maximized{position:fixed;top:60px;left:0;width:100%;height:calc(100% - 60px);background-color:rgba(0,0,0,.4);z-index:1}.contract-notes__content{position:fixed;top:calc(100% - 40px);right:100px;width:280px;background-color:#fff;-webkit-transition:all .2s ease;-o-transition:.2s all ease;transition:all .2s ease;z-index:1000}.contract-notes__content--toggled{top:calc(100% - 500px)}.contract-notes__content--maximized{top:100px;width:calc(100% - 200px);height:calc(100% - 200px)}.contract-notes__header{background-color:#7d7e83;color:#fff;height:40px;line-height:40px;padding-left:15px}.contract-notes__heading{display:inline-block;cursor:pointer}.contract-notes__header-msg{font-size:12px;padding-left:5px}.contract-notes__header-email{position:absolute;right:15px;color:#fff;top:0;height:40px;line-height:40px;padding-top:2px;cursor:pointer;-webkit-transition:all .2s ease;-o-transition:.2s all ease;transition:all .2s ease}.contract-notes__header-email:hover{-webkit-animation-iteration-count:1;-webkit-animation-delay:.2s;-webkit-animation-duration:.5s;-webkit-animation-name:spin;-webkit-animation-fill-mode:forwards;-moz-animation-iteration-count:1;-moz-animation-delay:.2s;-moz-animation-duration:.5s;-moz-animation-name:spin;-moz-animation-fill-mode:forwards;-o-animation-iteration-count:1;-o-animation-delay:.2s;-o-animation-duration:.5s;-o-animation-name:spin;-o-animation-fill-mode:forwards;animation-iteration-count:1;animation-delay:.2s;animation-duration:.5s;animation-name:spin;animation-fill-mode:forwards}.contract-notes__header-maximize{position:absolute;right:35px;color:#fff;top:0;height:40px;line-height:40px;padding-top:2px;cursor:pointer;-webkit-transition:all .2s ease;-o-transition:.2s all ease;transition:all .2s ease}.contract-notes__header-maximize:hover{-webkit-animation-iteration-count:1;-webkit-animation-delay:.2s;-webkit-animation-duration:.5s;-webkit-animation-name:maximize;-webkit-animation-fill-mode:forwards;-moz-animation-iteration-count:1;-moz-animation-delay:.2s;-moz-animation-duration:.5s;-moz-animation-name:maximize;-moz-animation-fill-mode:forwards;-o-animation-iteration-count:1;-o-animation-delay:.2s;-o-animation-duration:.5s;-o-animation-name:maximize;-o-animation-fill-mode:forwards;animation-iteration-count:1;animation-delay:.2s;animation-duration:.5s;animation-name:maximize;animation-fill-mode:forwards}.contract-notes__messages{height:360px;overflow-y:auto;overflow-x:hidden;border-bottom:1px solid #e7e7e7}.contract-notes__messages--maximized{height:calc(100% - 140px)}.contract-notes__message-content{background-color:#f7f7f7;float:left}.contract-notes__message-content,.contract-notes__message-content--own{display:inline-block;width:75%;margin:0 15px 15px;padding:10px;border-radius:5px}.contract-notes__message-content--own{background-color:#9cd7db;float:right;color:#fff}.contract-notes__message-content--internal{background-color:#f4a830;color:#fff}.contract-notes__message-date{font-size:13px;display:inline-block;text-align:center;width:100%}.contract-notes__message-author{font-size:13px}.contract-notes__message-ref{font-size:12px;text-align:right;cursor:pointer}.contract-notes__message-body{white-space:pre-line}.contract-notes__no-content{text-align:center;background-color:#f7f7f7;padding:15px;margin:15px}.contract-notes__control{margin:5px 15px;height:100px;overflow:hidden}.contract-notes__set-internal{font-size:13px}.contract-notes__spacer{height:20px}.contract-notes__reference{height:30px;line-height:30px}.contract-notes__dropdown{margin-left:5px;font-size:12px}.contract-notes__checkbox{display:inline-block;position:relative;cursor:pointer;height:13px;width:13px;background-image:url(" + escape(__webpack_require__(75)) + ");margin-left:10px;top:2px}.contract-notes__checkbox--checked{background-image:url(" + escape(__webpack_require__(76)) + ")}.contract-notes__input{display:inline-block;width:calc(100% - 35px)}.contract-notes__input-field{display:inline-block;width:100%;height:30px;resize:none}.contract-notes__input-field--focus{position:absolute;height:80px;width:calc(100% - 65px);bottom:25px}.contract-notes__input-field--maximized-focus{position:absolute;height:80px;width:calc(100% - 65px);bottom:15px}.contract-notes__buttons{display:inline-block;float:right}.contract-notes__send-btn{cursor:pointer;width:30px;height:30px;padding-left:4px;background-color:#64c1c7;color:#fff;line-height:30px;border:none;-webkit-transition:all .2s ease;-o-transition:.2s all ease;transition:all .2s ease}.contract-notes__send-btn:hover{background-color:#3b9da3}.contract-notes__send-btn:disabled,.contract-notes__send-btn:disabled:hover{background-color:#d9d9d9}.contract-form{margin-bottom:145px}@media screen and (min-width:992px){.contract-form{margin-bottom:15px}}.contract-form__content{display:block}.contract-form__message{margin-top:150px;margin-bottom:150px;text-align:center}.contract-form__form{display:inline-block;width:100%}.contract-form__message-icon{font-size:64px}.contract-form__accept-btn{display:inline-block;position:relative;left:50%;transform:translateX(-50%);margin-bottom:15px}.contract-form-price{margin-bottom:70px}.contract-form-price__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-price__body{margin:15px}.contract-form-price__item{margin:0;padding-bottom:15px;text-align:center}.contract-form-price__item-label{cursor:pointer;position:relative;background-color:#f2f2f2;font-weight:700}.contract-form-price__item-label:after{content:\"\\F068\"}.contract-form-price__item-label--collapsed:after,.contract-form-price__item-label:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px)}.contract-form-price__item-label--collapsed:after{content:\"\\F067\"}.contract-form-price__item-price{margin:0}.contract-form-price__price-header{cursor:pointer;position:relative;font-size:14px;margin:15px 0;text-align:left;background-color:#e6e6e6;padding:10px}@media screen and (min-width:992px){.contract-form-price__price-header{font-size:18px}}.contract-form-price__price-header:after{content:\"\\F068\"}.contract-form-price__price-header--collapsed:after,.contract-form-price__price-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px);color:#7d7e83}.contract-form-price__price-header--collapsed:after{content:\"\\F067\"}.contract-form-price__item-header{cursor:pointer;position:relative;font-size:14px;background-color:#a4a5a8;color:#fff;margin:15px 0}@media screen and (min-width:992px){.contract-form-price__item-header{font-size:18px}}.contract-form-price__item-header:after{content:\"\\F068\"}.contract-form-price__item-header--collapsed:after,.contract-form-price__item-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;left:50%;transform:translateX(-50%);left:calc(100% - 15px);color:#fff}.contract-form-price__item-header--collapsed:after{content:\"\\F067\"}.contract-form-price__item-sub-header{font-size:14px;background-color:#a4a5a8;color:#fff;margin:15px 0}@media screen and (min-width:992px){.contract-form-price__item-sub-header{font-size:18px}}.contract-form-price__accommodation-row{margin-bottom:0;padding-bottom:0}.contract-form-price__row-item{font-size:12px;display:inline-block;width:calc(25% - 3px);text-align:center;border-top:1px solid #e7e7e7}@media screen and (min-width:992px){.contract-form-price__row-item{font-size:14px}}.contract-form-price__row-item--inactive{color:#d9d9d9}.contract-form-price__row-label{font-weight:700}.contract-form-price__no-content{height:330px;text-align:center;padding:15px}.contract-form-price__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-form-price__no-content i.fa{font-size:96px}}.contract-form-price__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-form-price__no-content-message{font-size:20px}}.contract-form-supplier-info:after,.contract-form-supplier-info:before{display:table;content:\" \"}.contract-form-supplier-info:after{clear:both}.contract-form-supplier-info__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-supplier-info__body{margin:15px;text-align:center}.contract-form-supplier-info__container{margin-bottom:15px;background-color:#f7f7f7}.contract-form-supplier-info__container:after,.contract-form-supplier-info__container:before{display:table;content:\" \"}.contract-form-supplier-info__container:after{clear:both}.contract-form-supplier-info__content-heading{position:relative;font-size:14px;background-color:#d9d9d9;padding:15px}@media screen and (min-width:992px){.contract-form-supplier-info__content-heading{font-size:18px}}.contract-form-supplier-info__content{margin:10px}@media screen and (min-width:992px){.contract-form-supplier-info__content--booking:after,.contract-form-supplier-info__content--booking:before{display:table;content:\" \"}.contract-form-supplier-info__content--booking:after{clear:both}}.contract-form-supplier-info__item{padding:10px;border-bottom:1px solid #e7e7e7;background-color:#fff}.contract-form-supplier-info__item:after,.contract-form-supplier-info__item:before{display:table;content:\" \"}.contract-form-supplier-info__item:after{clear:both}.contract-form-supplier-info__item:last-child{border:none}@media screen and (min-width:992px){.contract-form-supplier-info__item--booking{float:left;width:calc(50% - 5px)}.contract-form-supplier-info__item--booking:not(:nth-last-child(n+3)){border-bottom:none}.contract-form-supplier-info__item--booking:nth-child(odd){margin-right:5px}.contract-form-supplier-info__item--booking:nth-child(2n){margin-left:5px}}.contract-form-supplier-info__item-label{text-align:center;margin-bottom:5px;font-weight:600}@media screen and (min-width:768px){.contract-form-supplier-info__item-label{margin:0;text-align:left;float:left}}.contract-form-supplier-info__item-label--inactive{color:#d9d9d9}.contract-form-supplier-info__item-value{text-align:center}@media screen and (min-width:768px){.contract-form-supplier-info__item-value{text-align:left;float:right}}.contract-form-arrival{margin-bottom:70px}.contract-form-arrival__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-arrival__body{margin:15px}.contract-form-arrival__item{margin:0;padding-bottom:15px;text-align:center}.contract-form-arrival__item-label{cursor:pointer;position:relative;background-color:#f2f2f2;font-weight:700}.contract-form-arrival__item-label:after{content:\"\\F068\"}.contract-form-arrival__item-label--collapsed:after,.contract-form-arrival__item-label:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px)}.contract-form-arrival__item-label--collapsed:after{content:\"\\F067\"}.contract-form-arrival__item-price{margin:0}.contract-form-arrival__item-header{cursor:pointer;position:relative;font-size:14px;background-color:#a4a5a8;color:#fff;margin:15px 0;padding:10px}@media screen and (min-width:992px){.contract-form-arrival__item-header{font-size:18px}}.contract-form-arrival__item-header:after{content:\"\\F068\"}.contract-form-arrival__item-header--collapsed:after,.contract-form-arrival__item-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px);color:#fff}.contract-form-arrival__item-header--collapsed:after{content:\"\\F067\"}.contract-form-arrival__item-header-info{display:block;font-size:13px;width:100%}@media screen and (min-width:992px){.contract-form-arrival__item-header-info{display:inline-block;width:auto}}.contract-form-arrival__accommodation-row{margin-bottom:0;padding-bottom:0}.contract-form-arrival__row-item{font-size:12px;display:inline-block;text-align:center;border-top:1px solid #e7e7e7}.contract-form-arrival__row-item:not(:last-child){width:calc(50% - 3px)}.contract-form-arrival__row-item:last-child{width:calc(100% - 3px)}@media screen and (min-width:992px){.contract-form-arrival__row-item{font-size:14px;width:calc(16.66667% - 3px)}.contract-form-arrival__row-item:last-child,.contract-form-arrival__row-item:not(:last-child){width:calc(16.66667% - 3px)}}.contract-form-arrival__row-label{font-weight:700}.contract-form-arrival__item-day{display:inline-block;width:calc(14.28571% - 5px)}.contract-form-arrival__checkbox{display:inline-block;cursor:default;height:13px;width:13px;background-image:url(" + escape(__webpack_require__(75)) + ");margin-left:5px}.contract-form-arrival__checkbox--checked{background-image:url(" + escape(__webpack_require__(76)) + ")}.contract-form-arrival__no-content{height:330px;text-align:center;padding:15px}.contract-form-arrival__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-form-arrival__no-content i.fa{font-size:96px}}.contract-form-arrival__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-form-arrival__no-content-message{font-size:20px}}.contract-form-notes__content{display:block}.contract-form-notes__input-text{width:calc(100% - 30px);height:150px;resize:none;padding:15px;margin:0 15px;border:1px solid #e7e7e7}.contract-form-notes__toggle{margin-top:5px;cursor:pointer;text-align:center;display:inline-block;position:relative;left:50%;transform:translateX(-50%);line-height:14px;opacity:.8;transition:all .2s ease}.contract-form-notes__toggle:hover{opacity:1}.contract-form-notes__toggle-label{text-transform:uppercase;font-size:10px}.contract-form-progress__content{width:100%}.contract-form-progress__heading{cursor:pointer;font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-progress__heading:after{float:right;content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900}.contract-form-progress__heading--toggled:after{float:right;content:\"\\F106\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900}.contract-form-progress__items{height:302px}@media screen and (min-width:992px){.contract-form-progress__items{height:140px}}.contract-form-progress__item{float:left;width:calc(100% - 30px);margin:15px;border:1px solid #e7e7e7}.contract-form-progress__item-label{margin-top:5px;text-align:center;width:100%;border-bottom:1px solid #e7e7e7;font-size:12px;text-overflow:ellipsis;overflow:hidden;height:25px;line-height:25px}@media screen and (min-width:992px){.contract-form-progress__item-label{font-size:14px}}.contract-form-progress__item-element{cursor:pointer;height:30px;float:left;margin:15px;width:calc(33.33333% - 30px)}@media screen and (min-width:992px){.contract-form-progress__item-element{height:50px;width:calc(10% - 30px)}}.contract-form-progress__item-sub-header{text-align:center;font-size:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}@media screen and (min-width:992px){.contract-form-progress__item-sub-header{font-size:10px}}.contract-form-progress__item-icon{height:100%;width:100%;text-align:center;font-size:18px;color:#e6948a}.contract-form-progress__item-icon--done{color:#88d0aa}.contract-form-progress__item-icon--active{color:#64c1c7!important;text-shadow:0 0 3px rgba(0,0,0,.4)}.contract-form-progress__item-icon--notification{color:#f8c779}@media screen and (min-width:992px){.contract-form-progress__item-icon{font-size:28px}}.contract-form-discount{margin-bottom:70px}.contract-form-discount__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-discount__body{margin:15px}.contract-form-discount__item{margin:0;padding:7.5px 0;text-align:center;flex-direction:row;align-items:center}.contract-form-discount__item-label{cursor:pointer;position:relative;background-color:#f2f2f2;font-weight:700}.contract-form-discount__item-label:after{content:\"\\F068\"}.contract-form-discount__item-label--collapsed:after,.contract-form-discount__item-label:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px)}.contract-form-discount__item-label--collapsed:after{content:\"\\F067\"}.contract-form-discount__item-price{margin:0}.contract-form-discount__item-header{cursor:pointer;position:relative;font-size:14px;background-color:#a4a5a8;color:#fff;margin:15px 0}@media screen and (min-width:992px){.contract-form-discount__item-header{font-size:18px}}.contract-form-discount__item-header:after{content:\"\\F068\"}.contract-form-discount__item-header--collapsed:after,.contract-form-discount__item-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px);color:#fff}.contract-form-discount__item-header--collapsed:after{content:\"\\F067\"}.contract-form-discount__accommodation-row{border-top:1px solid #e7e7e7;display:flex}.contract-form-discount__item-wrapper{position:relative;display:inline-block;width:calc(100% - 3px);height:100%}@media screen and (min-width:992px){.contract-form-discount__item-wrapper{width:calc(20% - 3px)}}.contract-form-discount__row-item{font-size:12px;text-align:center}.contract-form-discount__row-item--inactive{color:#d9d9d9}@media screen and (min-width:992px){.contract-form-discount__row-item{font-size:14px}}.contract-form-discount__row-label{font-weight:700}.contract-form-discount__item-day{display:inline-block;width:calc(14.28571% - 5px)}.contract-form-discount__checkbox{display:inline-block;cursor:default;height:13px;width:13px;background-image:url(" + escape(__webpack_require__(75)) + ");margin-left:5px}.contract-form-discount__checkbox--checked{background-image:url(" + escape(__webpack_require__(76)) + ")}.contract-form-discount__no-content{height:330px;text-align:center;padding:15px}.contract-form-discount__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-form-discount__no-content i.fa{font-size:96px}}.contract-form-discount__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-form-discount__no-content-message{font-size:20px}}.contract-form-allocation{margin-bottom:70px}.contract-form-allocation__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-allocation__body{margin:15px}.contract-form-allocation__item{margin:0;padding-bottom:15px;text-align:center}.contract-form-allocation__item-label{cursor:pointer;position:relative;background-color:#f2f2f2;font-weight:700}.contract-form-allocation__item-label:after{content:\"\\F068\"}.contract-form-allocation__item-label--collapsed:after,.contract-form-allocation__item-label:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px)}.contract-form-allocation__item-label--collapsed:after{content:\"\\F067\"}.contract-form-allocation__price-header{cursor:pointer;position:relative;font-size:14px;margin:15px 0;text-align:left}@media screen and (min-width:992px){.contract-form-allocation__price-header{font-size:18px}}.contract-form-allocation__price-header:after{content:\"\\F068\"}.contract-form-allocation__price-header--collapsed:after,.contract-form-allocation__price-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px);color:#fff}.contract-form-allocation__price-header--collapsed:after{content:\"\\F067\"}.contract-form-allocation__item-header{cursor:pointer;position:relative;font-size:14px;background-color:#a4a5a8;color:#fff;margin:15px 0}@media screen and (min-width:992px){.contract-form-allocation__item-header{font-size:18px}}.contract-form-allocation__item-header:after{content:\"\\F068\"}.contract-form-allocation__item-header--collapsed:after,.contract-form-allocation__item-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;left:50%;transform:translateX(-50%);left:calc(100% - 15px);color:#fff}.contract-form-allocation__item-header--collapsed:after{content:\"\\F067\"}.contract-form-allocation__item-sub-header{font-size:14px;background-color:#a4a5a8;color:#fff;margin:15px 0}@media screen and (min-width:992px){.contract-form-allocation__item-sub-header{font-size:18px}}.contract-form-allocation__accommodation-row{margin-bottom:0;padding-bottom:0}.contract-form-allocation__row-item{font-size:12px;display:inline-block;width:calc(50% - 3px);text-align:center;border-top:1px solid #e7e7e7}.contract-form-allocation__row-item:last-child{width:calc(100% - 3px)}.contract-form-allocation__row-item--inactive{color:#d9d9d9}@media screen and (min-width:992px){.contract-form-allocation__row-item{font-size:14px;width:calc(14.28571% - 3px)}.contract-form-allocation__row-item:last-child{width:calc(14.28571% - 3px)}}.contract-form-allocation__row-label{font-weight:700}.contract-form-allocation__no-content{height:330px;text-align:center;padding:15px}.contract-form-allocation__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-form-allocation__no-content i.fa{font-size:96px}}.contract-form-allocation__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-form-allocation__no-content-message{font-size:20px}}.contract-form-extra{margin-bottom:70px}.contract-form-extra__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-extra__body{margin:15px}.contract-form-extra__item{margin:0;padding-bottom:15px;text-align:center}.contract-form-extra__item-label{cursor:pointer;position:relative;background-color:#f2f2f2;font-weight:700;padding:15px 0;font-size:17px}.contract-form-extra__item-label:after{content:\"\\F068\"}.contract-form-extra__item-label--collapsed:after,.contract-form-extra__item-label:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px)}.contract-form-extra__item-label--collapsed:after{content:\"\\F067\"}.contract-form-extra__item-price{margin:0}.contract-form-extra__item-header{cursor:pointer;position:relative;font-size:14px;background-color:#a4a5a8;color:#fff;margin:15px 0}@media screen and (min-width:992px){.contract-form-extra__item-header{font-size:18px}}.contract-form-extra__item-header:after{content:\"\\F068\"}.contract-form-extra__item-header--collapsed:after,.contract-form-extra__item-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px);color:#fff}.contract-form-extra__item-header--collapsed:after{content:\"\\F067\"}.contract-form-extra__accommodation{margin-bottom:30px}.contract-form-extra__accommodation-row{height:550px;margin:10px;padding-top:10px;background-color:#fcfcfc}@media screen and (min-width:992px){.contract-form-extra__accommodation-row{height:190px}}.contract-form-extra__accommodation-row--ignore{height:80px}.contract-form-extra__row-item{font-size:12px;display:inline-table;width:calc(7.69231% - 5px);text-align:center;border-top:1px solid #e7e7e7}@media screen and (min-width:992px){.contract-form-extra__row-item{font-size:14px}}.contract-form-extra__row-header{position:relative;width:calc(100% - 20px);height:58px;border:1px solid #e7e7e7;margin:0 10px;overflow:hidden}.contract-form-extra__row-header-left{display:inline-block;float:left;text-align:center;width:100%;font-size:14px;padding:15px;z-index:10}@media screen and (min-width:992px){.contract-form-extra__row-header-left{width:50%;font-size:18px;text-align:left;float:left}}.contract-form-extra__row-header-right{position:absolute;display:inline-block;text-align:right;width:50%;padding:10px;top:2px;right:0;font-size:17px}@media screen and (min-width:992px){.contract-form-extra__row-header-right{position:relative;display:inline-block;font-size:24px;color:#7d7e83;float:right}}.contract-form-extra__section{float:left;width:calc(100% - 20px);border:1px solid #e7e7e7;height:100px;margin:10px}@media screen and (min-width:992px){.contract-form-extra__section{width:calc(100% / 4 - 20px)}}.contract-form-extra__section-wrapper{position:relative;top:50%;transform:translateY(-50%)}.contract-form-extra__section-row{width:100%;height:50px}.contract-form-extra__section-item{float:left}.contract-form-extra__section-item--inactive{color:#d9d9d9}.contract-form-extra__section-item-4{width:33.33333%;position:relative;top:50%;transform:translateY(-50%)}.contract-form-extra__section-item-6{width:50%;position:relative;top:50%;transform:translateY(-50%)}.contract-form-extra__section-item-12{width:100%}.contract-form-extra__section-label{font-weight:700}.contract-form-extra__row-header-type-label{font-size:14px}.contract-form-extra__row-header-type{cursor:help}.contract-form-extra__row-header-type--inclusive:before{content:\"\\F466\"}.contract-form-extra__row-header-type--inclusive:before,.contract-form-extra__row-header-type--mandatory:before{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:relative;top:50%;transform:translateY(-50%)}.contract-form-extra__row-header-type--mandatory:before{content:\"\\F06A\"}.contract-form-extra__row-header-type--optional:before{content:\"\\F059\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:relative;top:50%;transform:translateY(-50%)}.contract-form-extra__row-header-type--information:before{content:\"\\F05A\"}.contract-form-extra__row-header-type--information:before,.contract-form-extra__row-header-type--person:before{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:relative;top:50%;transform:translateY(-50%)}.contract-form-extra__row-header-type--person:before{content:\"\\F0D0\"}.contract-form-extra__no-content{height:330px;text-align:center;padding:15px}.contract-form-extra__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-form-extra__no-content i.fa{font-size:96px}}.contract-form-extra__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-form-extra__no-content-message{font-size:20px}}.contract-form-alert__error{margin-bottom:15px;padding:25px 15px 15px;text-align:center;background-color:#f4cec9;color:#b23426;display:block}@media screen and (min-width:992px){.contract-form-alert__error{height:71px}}.contract-form-terms{margin-bottom:70px}.contract-form-terms__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-terms__body{padding:15px}.contract-form-terms__terms-header{font-size:17px;font-weight:700}.contract-form-terms__terms-text{margin-top:15px;margin-bottom:30px}.contract-form-terms__item-header{font-size:14px;font-weight:700;margin-top:15px;margin-bottom:15px}.contract-form-terms__item-clause{margin-bottom:5px}.contract-form-terms__item-clause-header{font-size:14px;font-weight:700;width:20px;float:left}.contract-form-terms__item-clause-text{padding-left:30px;width:calc(100% - 30px)}.contract-form-terms__item-clause-points{margin-left:15px}.contract-form-accept__content{height:142px;margin-bottom:15px}@media screen and (min-width:992px){.contract-form-accept__content{height:71px}}.contract-form-accept__left{font-size:17px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;float:left;height:71px;width:100%;line-height:71px;padding:0 15px;text-align:center;border-bottom:1px solid #e7e7e7}@media screen and (min-width:992px){.contract-form-accept__left{width:50%;text-align:left;border-bottom:none}}.contract-form-accept__right{float:left;height:71px;width:100%;line-height:71px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 15px;text-align:center}@media screen and (min-width:992px){.contract-form-accept__right{width:50%;text-align:right;float:right}}.contract-form-site{margin-bottom:70px}.contract-form-site__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-site__body{margin:15px;text-align:center}.contract-form-site__site{background-color:#f7f7f7}.contract-form-site__site-header{margin-top:10px;cursor:pointer;position:relative;font-size:14px;background-color:#a4a5a8;color:#fff;padding:15px}@media screen and (min-width:992px){.contract-form-site__site-header{font-size:18px}}.contract-form-site__site-header:after{content:\"\\F068\"}.contract-form-site__site-header--collapsed:after,.contract-form-site__site-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px);color:#fff}.contract-form-site__site-header--collapsed:after{content:\"\\F067\"}.contract-form-site__site-address{height:340px;float:left;width:calc(100% - 15px);margin:10px;background-color:#fff;font-size:10px}@media screen and (min-width:992px){.contract-form-site__site-address{width:calc(50% - 20px);font-size:14px}}.contract-form-site__site-address-element{text-align:left;margin:2px;height:40.5px;padding-top:10px;padding-left:15px;border-bottom:1px solid #e7e7e7}.contract-form-site__site-address-element-label{float:left;width:30%}.contract-form-site__site-address-element-label--inactive{color:#d9d9d9}@media screen and (min-width:992px){.contract-form-site__site-address-element-label{width:50%}}.contract-form-site__site-address-element-data{float:left;width:calc(70% - 15px);text-align:right}@media screen and (min-width:992px){.contract-form-site__site-address-element-data{width:50%}}.contract-form-site__site-images{height:340px;float:right;border:1px solid #e7e7e7;width:calc(100% - 15px);overflow:auto;margin:10px;background-color:#fff}@media screen and (min-width:992px){.contract-form-site__site-images{width:calc(50% - 20px)}}.contract-form-site__site-image-wrapper{position:relative;float:left;width:calc(50% - 8px);height:77px;overflow:hidden;margin:4px}@media screen and (min-width:992px){.contract-form-site__site-image-wrapper{width:calc(25% - 8px)}}.contract-form-site__site-image{cursor:pointer;position:relative;top:50%;left:50%;transform:translate(-50%,-50%);width:130%;transition:all .2s ease;opacity:1;z-index:1}.contract-form-site__site-image:hover{width:150%;opacity:.1}.contract-form-site__site-image-overlay{position:absolute;top:0;left:0;height:100%;width:100%;padding-top:30px;background-color:#58585c;color:#fff;z-index:0;font-weight:200;text-transform:uppercase}.contract-form-site__site-facilities{display:inline-block;width:100%}.contract-form-site__site-facilities-header{background-color:#a4a5a8;color:#fff;font-size:17px;padding:10px}.contract-form-site__site-facility-element{float:left;width:100%;border-bottom:1px solid #e7e7e7;padding:10px}.contract-form-site__site-facility-element-label{width:50%;float:left;text-align:left}.contract-form-site__site-facility-element-items{width:50%;float:right;text-align:right}.contract-form-site__site-facility-element-data-list{width:100%;float:left;text-align:right}.contract-form-site__site-facility-element-data-header{font-weight:700}.contract-form-site__no-content{height:330px;text-align:center;padding:15px}.contract-form-site__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-form-site__no-content i.fa{font-size:96px}}.contract-form-site__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-form-site__no-content-message{font-size:20px}}.contract-form-email__content{height:142px;margin-bottom:15px}@media screen and (min-width:992px){.contract-form-email__content{height:71px}}.contract-form-email__left{font-size:17px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;float:left;height:71px;width:100%;line-height:71px;padding:0 15px;text-align:center;border-bottom:1px solid #e7e7e7}@media screen and (min-width:992px){.contract-form-email__left{width:50%;text-align:left;border-bottom:none}}.contract-form-email__right{float:left;height:71px;width:100%;line-height:71px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 15px;text-align:center}@media screen and (min-width:992px){.contract-form-email__right{width:50%;text-align:right;float:right}}.contract-form-cancellation-rules__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-cancellation-rules__table{border-bottom:1px solid #e7e7e7;font-size:14px;text-align:center;margin-bottom:15px}@media screen and (max-width:767px){.contract-form-cancellation-rules__table{font-size:13px}}.contract-form-cancellation-rules__table thead>tr>th{background-color:#f2f2f2;border-bottom:none;height:63px;vertical-align:middle;text-align:center;width:16.66667%}.contract-form-cancellation-rules__table thead>tr>th:not(:last-child){border-right:1px solid #e7e7e7}.contract-form-cancellation-rules__table thead>tr>th:first-child{padding-left:15px}.contract-form-cancellation-rules__table thead>tr>th:last-child{padding-right:15px}.contract-form-cancellation-rules__table tbody>tr>td{height:63px;vertical-align:middle;width:16.66667%;font-weight:700}.contract-form-cancellation-rules__table tbody>tr>td:first-child{padding-left:15px;border-right:1px solid #e7e7e7}.contract-form-cancellation-rules__table tbody>tr>td:last-child{padding-right:15px}.contract-form-accommodation{margin-bottom:70px}.contract-form-accommodation__heading{font-weight:700;font-size:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;width:100%;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-form-accommodation__body{margin:15px;text-align:center}.contract-form-accommodation__accommodation{background-color:#f7f7f7}.contract-form-accommodation__site-header{margin-top:10px;cursor:pointer;position:relative;background-color:#a4a5a8;color:#fff}@media screen and (min-width:992px){.contract-form-accommodation__site-header{font-size:18px}}.contract-form-accommodation__site-header:after{content:\"\\F068\"}.contract-form-accommodation__site-header--collapsed:after,.contract-form-accommodation__site-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px);color:#fff}.contract-form-accommodation__site-header--collapsed:after{content:\"\\F067\"}.contract-form-accommodation__accommodation-header{cursor:pointer;position:relative;font-size:14px;background-color:#d9d9d9;margin-top:15px;padding:15px}@media screen and (min-width:992px){.contract-form-accommodation__accommodation-header{font-size:18px}}.contract-form-accommodation__accommodation-header:after{content:\"\\F068\"}.contract-form-accommodation__accommodation-header--collapsed:after,.contract-form-accommodation__accommodation-header:after{font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);left:calc(100% - 15px)}.contract-form-accommodation__accommodation-header--collapsed:after{content:\"\\F067\"}.contract-form-accommodation__accommodation-info{height:240px;float:left;width:calc(100% - 20px);margin:10px;background-color:#fff;font-size:10px}@media screen and (min-width:992px){.contract-form-accommodation__accommodation-info{height:259px;width:calc(50% - 20px);font-size:14px}}.contract-form-accommodation__accommodation-info-element{width:100%;float:left;padding:10px;border-bottom:1px solid #e7e7e7}.contract-form-accommodation__accommodation-info-element-label{width:50%;float:left;text-align:left}.contract-form-accommodation__accommodation-info-element-label--inactive{color:#d9d9d9}.contract-form-accommodation__accommodation-info-element-data{width:50%;float:right;text-align:right}.contract-form-accommodation__accommodation-images{height:259px;float:right;border:1px solid #e7e7e7;width:calc(100% - 20px);overflow:auto;margin:10px;background-color:#fff}@media screen and (min-width:992px){.contract-form-accommodation__accommodation-images{width:calc(50% - 20px)}}.contract-form-accommodation__accommodation-image-wrapper{position:relative;float:left;width:calc(50% - 8px);height:77px;overflow:hidden;margin:4px}@media screen and (min-width:992px){.contract-form-accommodation__accommodation-image-wrapper{width:calc(25% - 8px)}}.contract-form-accommodation__accommodation-image{cursor:pointer;position:relative;top:50%;left:50%;transform:translate(-50%,-50%);width:130%;transition:all .2s ease;opacity:1;z-index:1}.contract-form-accommodation__accommodation-image:hover{width:150%;opacity:.1}.contract-form-accommodation__accommodation-image-overlay{position:absolute;top:0;left:0;height:100%;width:100%;padding-top:30px;background-color:#58585c;color:#fff;z-index:0;font-weight:200;text-transform:uppercase}.contract-form-accommodation__accommodation-sub-groups{display:inline-block;width:100%}.contract-form-accommodation__accommodation-sub-groups-header{position:relative;background-color:#a4a5a8;color:#fff;font-size:17px;margin-bottom:10px;padding:10px}.contract-form-accommodation__accommodation-sub-group-header{font-size:17px;background-color:#a4a5a8;color:#fff;padding-right:15px}.contract-form-accommodation__accommodation-facility{text-align:left;margin:2px;height:40.5px;padding-top:10px;padding-left:15px;border-bottom:1px solid #e7e7e7;font-size:10px}@media screen and (min-width:992px){.contract-form-accommodation__accommodation-facility{font-size:14px}}.contract-form-accommodation__accommodation-facility-label{float:left;width:50%}.contract-form-accommodation__accommodation-facility-data{float:left;width:calc(50% - 15px);text-align:right}.contract-form-accommodation__accommodation-facility-header{background-color:#a4a5a8;color:#fff;margin:0 10px 10px;font-size:17px}.contract-form-accommodation__facilities-element{float:left;margin:0 10px 10px;width:calc(100% - 20px);border:1px solid #e7e7e7;background-color:#fff}.contract-form-accommodation__facilities-element-label{width:100%;float:left;border-bottom:1px solid #e7e7e7;font-weight:700}.contract-form-accommodation__facilities-element-label>i{font-size:10px}.contract-form-accommodation__facilities-element-items{width:100%;float:right;border-left:1px solid #e7e7e7}.contract-form-accommodation__facilities-element-data-list{width:100%;float:left;border-right:1px solid #e7e7e7}.contract-form-accommodation__no-content{height:330px;text-align:center;padding:15px}.contract-form-accommodation__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-form-accommodation__no-content i.fa{font-size:96px}}.contract-form-accommodation__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-form-accommodation__no-content-message{font-size:20px}}.contract-list-overview__heading{cursor:pointer;font-size:17px;font-weight:700;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:71px;line-height:71px;padding:0 15px;border-bottom:1px solid #e7e7e7}.contract-list-overview__heading:after{float:right;content:\"\\F107\";font-family:Font Awesome\\ 5 free,sans-serif;font-weight:900}.contract-list-overview__list-item{cursor:pointer;display:inline-block;padding:15px;margin:15px;border:1px solid #e7e7e7;width:calc(100% - 30px);color:#717176;transition:all .2s ease}.contract-list-overview__list-item--disabled,.contract-list-overview__list-item:hover{background-color:#f7f7f7;text-decoration:none;color:#717176}.contract-list-overview__list-item--disabled{display:inline-block;cursor:default;padding:15px;margin:15px;border:1px solid #e7e7e7;width:calc(100% - 30px)}.contract-list-overview__list-item-year{float:left;width:50%;text-align:left}.contract-list-overview__list-item-status{float:right;width:50%;text-align:right}.contract-list-overview__error{height:330px;text-align:center;padding:15px}.contract-list-overview__error i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-list-overview__error i.fa{font-size:96px}}.contract-list-overview__no-content{height:330px;text-align:center;padding:15px}.contract-list-overview__no-content i.fa{margin-top:105px;font-size:64px}@media screen and (min-width:768px){.contract-list-overview__no-content i.fa{font-size:96px}}.contract-list-overview__no-content-message{font-size:17px;margin-top:10px}@media screen and (min-width:768px){.contract-list-overview__no-content-message{font-size:20px}}.contract-list-overview__notes{color:#e6948a}.contract-management-edit-brands__text{margin-top:15px;padding:10px;text-align:center;margin-bottom:15px}.contract-management-edit-brands__open-select{text-align:center;cursor:pointer;color:#64c1c7;padding:3px 10px;border-radius:15px;border:1px solid #64c1c7;margin:5px;-webkit-transition:all .2s ease;-o-transition:.2s all ease;transition:all .2s ease}.contract-management-edit-brands__open-select--selected{background-color:#64c1c7;color:#fff;border:2px solid #64c1c7}.contract-management-edit-brands__open-select:hover{background-color:#64c1c7;color:#fff}.contract-draft-preview{text-align:right;height:50px}.contract-draft-preview__button{display:inline-block;margin-bottom:10px;min-width:180px;height:40px;line-height:30px}", ""]);

// exports


/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 566 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(568);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 568 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 569 */
/***/ (function(module, exports) {

exports.sync = function (store, router, options) {
  var moduleName = (options || {}).moduleName || 'route'

  store.registerModule(moduleName, {
    namespaced: true,
    state: cloneRoute(router.currentRoute),
    mutations: {
      'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
        store.state[moduleName] = cloneRoute(transition.to, transition.from)
      }
    }
  })

  var isTimeTraveling = false
  var currentPath

  // sync router on store change
  var storeUnwatch = store.watch(
    function (state) { return state[moduleName]; },
    function (route) {
      var fullPath = route.fullPath;
      if (fullPath === currentPath) {
        return
      }
      if (currentPath != null) {
        isTimeTraveling = true
        router.push(route)
      }
      currentPath = fullPath
    },
    { sync: true }
  )

  // sync store on router navigation
  var afterEachUnHook = router.afterEach(function (to, from) {
    if (isTimeTraveling) {
      isTimeTraveling = false
      return
    }
    currentPath = to.fullPath
    store.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
  })

  return function unsync () {
    // On unsync, remove router hook
    if (afterEachUnHook != null) {
      afterEachUnHook()
    }

    // On unsync, remove store watch
    if (storeUnwatch != null) {
      storeUnwatch()
    }

    // On unsync, unregister Module with store
    store.unregisterModule(moduleName)
  }
}

function cloneRoute (to, from) {
  var clone = {
    name: to.name,
    path: to.path,
    hash: to.hash,
    query: to.query,
    params: to.params,
    fullPath: to.fullPath,
    meta: to.meta
  }
  if (from) {
    clone.from = cloneRoute(from)
  }
  return Object.freeze(clone)
}



/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
 * vue-i18n v7.8.1 
 * (c) 2018 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * utilites
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || Array.isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || Array.isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function getOldChoiceIndexFixed (choice) {
  return choice
    ? choice > 1
      ? 1
      : 0
    : 1
}

function getChoiceIndex (choice, choicesLength) {
  choice = Math.abs(choice);

  if (choicesLength === 2) { return getOldChoiceIndexFixed(choice) }

  return choice ? Math.min(choice, 2) : 0
}

function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message && typeof message !== 'string') { return null }
  var choices = message.split('|');

  choice = getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

var canUseDateTimeFormat =
  typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined';

var canUseNumberFormat =
  typeof Intl !== 'undefined' && typeof Intl.NumberFormat !== 'undefined';

/*  */

function extend (Vue) {
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$t', {
    get: function get () {
      var this$1 = this;

      return function (key) {
        var values = [], len = arguments.length - 1;
        while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

        var i18n = this$1.$i18n;
        return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this$1 ].concat( values ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$tc', {
    get: function get () {
      var this$1 = this;

      return function (key, choice) {
        var values = [], len = arguments.length - 2;
        while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

        var i18n = this$1.$i18n;
        return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this$1, choice ].concat( values ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$te', {
    get: function get () {
      var this$1 = this;

      return function (key, locale) {
        var i18n = this$1.$i18n;
        return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$d', {
    get: function get () {
      var this$1 = this;

      return function (value) {
        var ref;

        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
        return (ref = this$1.$i18n).d.apply(ref, [ value ].concat( args ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$n', {
    get: function get () {
      var this$1 = this;

      return function (value) {
        var ref;

        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
        return (ref = this$1.$i18n).n.apply(ref, [ value ].concat( args ))
      }
    }
  });
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject(options.i18n)) {
        // component local i18n
        if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
          options.i18n.root = this.$root.$i18n;
          options.i18n.formatter = this.$root.$i18n.formatter;
          options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
          options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }
      } else {
        if (false) {
          warn("Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    if (this._subscribing) {
      this._i18n.unsubscribeDataChanging(this);
      delete this._subscribing;
    }

    if (this._i18nWatcher) {
      this._i18nWatcher();
      delete this._i18nWatcher;
    }

    if (this._localeWatcher) {
      this._localeWatcher();
      delete this._localeWatcher;
    }

    this._i18n = null;
  }
}

/*  */

var component = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var data = ref.data;
    var children = ref.children;
    var parent = ref.parent;

    var i18n = parent.$i18n;

    children = (children || []).filter(function (child) {
      return child.tag || (child.text = child.text.trim())
    });

    if (!i18n) {
      if (false) {
        warn('Cannot find VueI18n instance!');
      }
      return children
    }

    var path = props.path;
    var locale = props.locale;

    var params = {};
    var places = props.places || {};

    var hasPlaces = Array.isArray(places)
      ? places.length > 0
      : Object.keys(places).length > 0;

    var everyPlace = children.every(function (child) {
      if (child.data && child.data.attrs) {
        var place = child.data.attrs.place;
        return (typeof place !== 'undefined') && place !== ''
      }
    });

    if (hasPlaces && children.length > 0 && !everyPlace) {
      warn('If places prop is set, all child elements must have place prop set.');
    }

    if (Array.isArray(places)) {
      places.forEach(function (el, i) {
        params[i] = el;
      });
    } else {
      Object.keys(places).forEach(function (key) {
        params[key] = places[key];
      });
    }

    children.forEach(function (child, i) {
      var key = everyPlace
        ? ("" + (child.data.attrs.place))
        : ("" + i);
      params[key] = child;
    });

    return h(props.tag, data, i18n.i(path, locale, params))
  }
}

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  if (localeEqual(el, vnode) && looseEqual(binding.value, binding.oldValue)) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  el.textContent = '';
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('not exist Vue instance in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('not exist VueI18n instance in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('not support value type');
    return
  }

  if (!path) {
    warn('required `path` in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (typeof value === 'string') {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install (_Vue) {
  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (false) {
    warn('already installed.');
    return
  }
  install.installed = true;

  /* istanbul ignore if */
  if (false) {
    warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
    return
  }

  Object.defineProperty(Vue.prototype, '$i18n', {
    get: function get () { return this._i18n }
  });

  extend(Vue);
  Vue.mixin(mixin);
  Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  Vue.component(component.name, component);

  // use object-based merge strategy
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = strats.methods;
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== '}') {
        sub += char;
        char = format[position++];
      }

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (false) {
            warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
          }
        }
        break
      case 'unknown':
        if (false) {
          warn("Detect 'unknown' type of token!");
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path paerser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30: // 0
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  // a-z, A-Z
  if ((code >= 0x61 && code <= 0x7A) || (code >= 0x41 && code <= 0x5A)) {
    return 'ident'
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) { return 'number' }

  return 'else'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





function empty (target) {
  /* istanbul ignore else */
  if (Array.isArray(target)) {
    return target.length === 0
  } else {
    return false
  }
}

var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (empty(paths)) {
    return null
  } else {
    var length = paths.length;
    var ret = null;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        last = null;
        break
      }
      last = value;
      i++;
    }

    ret = last;
    return ret
  }
};

/*  */



var numberFormatKeys = [
  'style',
  'currency',
  'currencyDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'localeMatcher',
  'formatMatcher'
];

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || new BaseFormatter();
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : !!options.silentTranslationWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];

  this._exist = function (message, key) {
    if (!message || !key) { return false }
    return !isNull(this$1._path.getPathValue(message, key))
  };

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true } };

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data });
  Vue.config.silent = silent;
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      Vue.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (typeof missingRet === 'string') {
      return missingRet
    }
  } else {
    if (false) {
      warn(
        "Cannot translate the value of keypath '" + key + "'. " +
        'Use the value of keypath as default.'
      );
    }
  }
  return key
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (Array.isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (typeof ret !== 'string') {
        if (false) {
          warn(("Value of key '" + key + "' is not a string!"));
        }
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (typeof pathRet === 'string') {
      ret = pathRet;
    } else {
      if (false) {
        warn(("Value of key '" + key + "' is not a string!"));
      }
      return null
    }
  }

  // Check for the existance of links within the translated string
  if (ret.indexOf('@:') >= 0) {
    ret = this._link(locale, message, ret, host, interpolateMode, values);
  }

  return this._render(ret, interpolateMode, values)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values
) {
    var this$1 = this;

  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(/(@:[\w\-_|.]+)/g);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    // Remove the leading @:
    var linkPlaceholder = link.substr(2);
    // Translate the link
    var translated = this$1._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values
    );

    if (this$1._isFallbackRoot(translated)) {
      if (false) {
        warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this$1._root) { throw Error('unexpected error') }
      var root = this$1._root;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this$1._warnDefault(
      locale, linkPlaceholder, translated, host,
      Array.isArray(values) ? values : [values]
    );

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._render = function _render (message, interpolateMode, values) {
  var ret = this._formatter.interpolate(message, values);
  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' ? ret.join('') : ret
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var res =
    this._interpolate(locale, messages[locale], key, host, interpolateMode, args);
  if (!isNull(res)) { return res }

  res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args);
  if (!isNull(res)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale."));
    }
    return res
  } else {
    return null
  }
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with root locale."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).t.apply(ref, [ key ].concat( values ))
  } else {
    return this._warnDefault(locale, key, ret, host, values)
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
    }
    if (!this._root) { throw Error('unexpected error') }
    return this._root.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values])
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (typeof locale !== 'string') {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }
  return fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  this._vm.$set(this._vm.messages, locale, Vue.util.extend(this._vm.messages[locale] || {}, message));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, Vue.util.extend(this._vm.dateTimeFormats[locale] || {}, format));
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' datetime formats from '" + locale + " datetime formats."));
    }
    _locale = fallback;
    formats = dateTimeFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {
  /* istanbul ignore if */
  if (false) {
    warn('Cannot format a Date value due to not supported Intl.DateTimeFormat.');
    return ''
  }

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to datetime localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, Vue.util.extend(this._vm.numberFormats[locale] || {}, format));
};

VueI18n.prototype._localizeNumber = function _localizeNumber (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' number formats from '" + locale + " number formats."));
    }
    _locale = fallback;
    formats = numberFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (false) {
    warn('Cannot format a Number value due to not supported Intl.NumberFormat.');
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var ret =
    this._localizeNumber(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to number localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (numberFormatKeys.includes(key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

VueI18n.availabilities = {
  dateTimeFormat: canUseDateTimeFormat,
  numberFormat: canUseNumberFormat
};
VueI18n.install = install;
VueI18n.version = '7.8.1';

/* harmony default export */ __webpack_exports__["default"] = (VueI18n);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en = __webpack_require__(572);

var _en2 = _interopRequireDefault(_en);

var _de = __webpack_require__(573);

var _de2 = _interopRequireDefault(_de);

var _it = __webpack_require__(574);

var _it2 = _interopRequireDefault(_it);

var _es = __webpack_require__(575);

var _es2 = _interopRequireDefault(_es);

var _nl = __webpack_require__(576);

var _nl2 = _interopRequireDefault(_nl);

var _hr = __webpack_require__(577);

var _hr2 = _interopRequireDefault(_hr);

var _fr = __webpack_require__(578);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    en: _en2.default,
    de: _de2.default,
    it: _it2.default,
    es: _es2.default,
    nl: _nl2.default,
    hr: _hr2.default,
    fr: _fr2.default
};

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = {"valid":true,"tips":{"hi":"Hi","help":"Do you need help?","more":"more","less":"less","camping":"Contact Camping Vision IT","adminPage":{"edit":{"body":"Any users that you have created can be edited. It's possible to change everything except their email. If a user changes email you will have to create a new user to invite that email to the marketplace","title":"Edit user"},"block":{"body":"It's possible to block access to the marketplace for any user you create. This is done by pressing edit on the user, and then pressing the block button. It's possible to give a blocked user access again afterwards by unblocking them from the same place. You are also able to delete users from the edit screen. Note this action is irreversible!","title":"Block or delete users"},"create":{"body":"It's possible to create a new user by pressing the new user button in the top right corner. The new user can be granted access to either read and write or only to read on the marketplace","title":"Create a new user"}},"statPage":{"boxes":{"body":"The four boxes at the top of the page displays the revenue and bookings. The grey ones shows for the complete season and the blue for the selected period","title":"The four top boxes"},"graph":{"body":"The graph on the left shows the top selling sites. You can click on a site to select it, which will show the top accommodations on the graph to the right","title":"The graphs"},"filter":{"body":"You can click the booking period and arrival period filter to narrow or expand the period data is shown for","title":"Booking period / Arrival period"}},"dashboardPage":{"add":{"body":"You can easily add new allotment by clicking the 'Add allotment' button, this will take you to the calendar overview where you are able to add more allotment","title":"Add allotment"},"graph":{"body":"The graph displays the availability for all your accommodations across your sites, you can choose a specific accommodation from the drop down list","title":"Availability graph"},"filter":{"body":"You can filter the notifications list by site or accommodation to only show information about that specific item","title":"Notifications filter"},"notifications":{"body":"The notifications list displays urgent information about allotment being sold out or released. If we have no allotment, we have nothing to sell for you.","title":"Missing out on sale?"}},"bookingPage":{"search":{"body":"You can search for a specific booking in the upright corner of the bookings list. It will search for the booking no.","title":"Search for booking no."},"filters":{"body":"You are able to filter the booking list based on site, domain, accommodation, booking country, status etc.","title":"Top filters"},"sortList":{"body":"You can sort the booking list by clicking on the attribute header, and further sort by multiple options by using the sort type drop down","title":"Sort booking list"},"xlsError":{"body":"Some versions of Excel will see the XLS file as damaged, but if you click yes to the error message in Excel, it will open as normal","title":"Trouble with opening the XLS?"},"downloadList":{"body":"You can download the filtered list either as a comma separated file (CSV) or as an Excel document (XLS)","title":"Download CSV or XLS"}},"allocationPage":{"sort":{"body":"You can sort your accommodations on last updated, name and site","title":"Sort accommodations"},"site":{"body":"You can filter the list and only show accommodations for one specific site from the drop down in the top","title":"Filter sites"},"update":{"body":"Click the update button for the accommodation you wish to manage allocations for. This will take you to the manage allocation calendar where you can add, edit and block allocations","title":"Update allocations"},"updateBy":{"body":"The updated by column shows who made the last allocation changes for that accommodation, the '@' sign indicates that it's done by a Camping Vision employee","title":"Update by"}},"accountPage":{"password":{"body":"In order to change your account password you need to enter your current password and then the new desired password which should be verified in the re-enter field","title":"Change password"},"activity":{"body":"The account activity list displays all the allocation modifications the account has done within the last 6 months, including adding allocation, altering allocation and requesting changes to allocations","title":"Account activity"},"information":{"body":"The account information shows your account id and account type. You are able to change your first- and last name","title":"Account information"},"notifications":{"body":"You can select whether to receive email notifications or not. If you click on modify you can further specify which days you want to receive the email on. NOTE! If you select fortnightly you can only select one day","title":"Receive notifications"}},"manageAllocationPage":{"error":"Couldn't retrieve data, please try again. If the issue persists pls contact us.","year":{"body":"By default the current year is selected, but you can select up to two years ahead from the 'Choose year' drop down","title":"Select year"},"info":{"body":"Click on the 'info' button above the calendar to the right to show a guide on how to use the calendar","title":"How to use the calendar?"},"modal":{"body":"When a period is selected a pop up window will appear. If no allocations has been added you will be displayed a button to add allocation. If allocations are already created in the period you will be able to manage those allocations by clicking edit, add or block. These options vary from allocation types and if they are released or not","title":"The pop up window"},"extra":{"body":"When choosing a period an extra day is added in the end to indicate that the period is based on nights and the next day will therefore be a departure date","title":"Extra day in period"},"select":{"body":"Use the calendar to choose a period to edit or add allocations. This is done by clicking on the start date and then clicking on the end date. This will open a pop up window in which you can manage allocations for the given period.","title":"Select period"},"display":{"body":"By clicking the display drop down just above the calendar it is possible to display either six months or the full calendar year","title":"Show full year or 6 months"},"overview":{"body":"An overview of allocations is found just below the calendar. Here you can see the details for the allocations. The unit count will show the originally stated unit count without taking bookings into account","title":"Allocation overview"},"accommodation":{"body":"You can switch to another accommodation from the top drop down, the accommodations is limited to the site. To choose another site you have to go back to the allocation main page and select it from there","title":"Want another accommodation?"},"alert":{"requestError":"Request update failed, please try again","requestAccept":"Request accepted successfully","requestDenied":"Request denied successfully","requestUnauthorized":"Request update unauthorized"}},"contractManagementPage":{"upload":{"body":"You can upload files as attachment to the different contract parts, accepted file types are: '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'","title":"Upload files"},"expand":{"body":"You can collapse or expand the progress view by clicking on the progress header","title":"Expand progress view"},"progress":{"body":"In the header you can track you contract progress in percentage","title":"Track you progress"},"indicator":{"body":"The icons shows if information has been stored for a given part, or if there are any notifications to said part","title":"Progress indicator icons"}}},"adminItem":{"id":"Id","edit":"Edit","email":"Email","status":"Status","lastName":"Last name","firstName":"First name"},"admin":{"list":{"id":"Id","edit":"Edit","email":"Email","status":"Status","noUsers":"No users created","content":"Create user","lastname":"Last name","firstname":"First name","header":{"heading":"Users list"}},"alert":{"email":"The email is already taken","error":"Something went wrong","updated":"User successfully updated","deleted":"User successfully deleted","created":"User successfully created","blocked":"User successfully blocked","password":"Password successfully updated","unblocked":"User successfully unblocked","notifications":"Notifications status successfully updated","wrongPassword":"Incorrect password"},"profile":{"and":"and","email":"Email","weekly":"on a weekly basis","notice":"You are currently receiving notifications:","receive":"Receive notifications","language":"Language","noNotice":"You are currently NOT receiving notifications","everyday":"everyday","fullName":"Full name","fortnightly":"on a fortnightly basis","header":{"heading":"Account information"},"notifications":{"edit":"Modify","weekly":"Weekly","cancel":"Cancel","update":"Update","fortnightly":"Fortnightly","days":{"friday":"Friday","monday":"Monday","sunday":"Sunday","tuesday":"Tuesday","saturday":"Saturday","thursday":"Thursday","wednesday":"Wednesday"},"heading":{"header":"Change notifications setting"}}},"form":{"create":"User successfully created","edit":{"edit":"User successfully updated","block":"User successfully blocked","delete":"User successfully deleted","unblock":"User successfully unblocked"},"error":{"edit":"Something went wrong, please try again later.","email":"The email address is already in use.","error":"Something went wrong, please try again later."}},"heading":{"header":"Administrator panel"},"edit":{"form":{"info":"Edit the user and press update to save the changes","roles":"Roles","lastname":"Last name","language":"Language","firstname":"First name","button":{"submit":"Create user"},"notifications":"Receive notifications","buttons":{"block":"Block","update":"Update","delete":"Delete","unblock":"Unblock"},"warning":{"blocked":"NOTE! - This user is currently blocked","inactive":"NOTE! - This user is currently inactive"},"validator":{"lastname":"*Last name is required","firstname":"*First name is required"}},"header":{"heading":"Edit user"},"accept":{"header":{"block":"Block user","update":"Update user","delete":"Delete user","unblock":"Unblock user"},"content":{"block":"Are you sure you want to block the user?","delete":"Are you sure you want to delete the user?","update":"Are you sure you want to update the user?","unblock":"Are you sure you want to unblock the user?"},"buttons":{"accept":"Accept","cancel":"Cancel"}}},"create":{"form":{"tip":"<strong>Roles:</strong> Set a role for the user to supply access level.","roles":"Roles","email":"Email","language":"Language","lastname":"Last name","firstname":"First name","button":{"submit":"Create user"},"validator":{"email":"*Valid email is required","lastname":"*Last name is required","firstname":"*First name is required"}},"button":{"submit":"Create user"},"accept":{"header":"Create user","content":"Are you sure you want to create this user?","buttons":{"cancel":"Cancel","accept":"Accept"}},"header":{"heading":"Create user"}}},"signIn":{"button":"Sign in","heading":"Welcome to CampingVision Marketplace","description":"Sign in and start selling on Europe's largest online marketplace specializing in camping holidays.","logoutNotice":"You have been successfully logged out","invalidNotice":"Please sign in again to confirm your identity","pass":{"placeholder":"Password","errors":{"required":"You must provide a valid password"}},"inactivityNotice":"You have been logged out due to inactivity","email":{"placeholder":"Email","errors":{"email":"You must provide a valid email","required":"You must provide an email"}},"messages":{"mismatch":"The username and password doesn't match","unexpected":"An unexpected error occurred. Our development team has been notified. Please try again later"},"forgotPasswordLink":"Forgot your password?"},"booking":{"button":"Activate account","heading":"Bookings","filterText":"Search...","dateTypes":["Booking date","Arrival date"],"placeholder":"Search...","description":"List of all bookings for a given period. Period can filter by either arrival date or boooking date.","tableFields":{"#":"#","reset":"Clear sort","status":"Status","domain":"Domain","duration":"Duration","siteName":"Site","bookingRef":"CV No.","bookingDate":"Booking date","arrivalDate":"Arrival","supplierRef":"Booking No.","supplierName":"Supplier name","customerName":"Customer","departureDate":"Departure","accommodation":"Accommodation"},"messages":{"error":"Something went wrong, please try again later.","expired":"Your authorization token has expired."},"filterOptions":{"site":"Site","option":"Choose..","domain":"Choose domain...","default":"Filter by","bookingAgent":"Booking Agent","accommodation":"Accommodation","bookingCountry":"Booking Country"}},"account":{"form":{"id":"Id","email":"Email","lastName":"Last name","firstName":"First name","buttons":{"reset":"Reset","update":"Update"},"heading":{"header":"Edit account information"},"accountType":{"label":"Account type","admin":{"true":"Admin","false":"Basic"}},"validator":{"required":"This field is required"},"placeholder":{"lastName":"Enter last name","firstName":"Enter first name"}},"activity":{"site":"Site","date":"Date","limit":"Show rows","type":{"label":"Activity type","request":"Request","allocation":"Modify"},"status":{"label":"Action","RELEASED":"Allocation released","USER_EDIT":"Edit allocation","USER_INSERT":"Add allocation"},"header":{"months":"(Last 6 months)","heading":"Account activity"},"accommodation":"Accommodation"},"password":{"password":"Current password","rePassword":"Re-type password","newPassword":"New password","buttons":{"reset":"Reset","update":"Update"},"heading":{"header":"Change password"},"validator":{"mismatch":"The two passwords doesn't match","password":"Min. 8 chars / upper- & lowercase / number"},"placeholder":{"password":"••••••••"}}},"statList":{"heading":"Revenue","predicate":"Filter by","backButton":"Back"},"bookingItem":{"site":"Site","status":"Status","domain":"Domain","duration":"Duration","bookingRef":"Camping Vision Ref. number","arrivalDate":"Arrival","supplierRef":"Ref. number","bookingDate":"Booking date","supplierName":"Supplier name","customerName":"Customer","departureDate":"Departure","accommodation":"Accommodation"},"notFound":{"heading":"404 - Not Found"},"introduction":{"body":"We have now been notified about your interest to proceed with selling through the Camping Vision's broad sales channels. We will now continue with the sales procedure and we will contact you as soon as possible","error":"It seems that there was an error while trying to process your request, please try again later. If the problem persists please contact us","warning":"We are working as hard as we can and promise you that we will get back to you shortly.","noContent":"The token you specified could not be found, did you supply the correct token in the url?","footer":{"title":"Do you have any questions?","contact":{"tel":"Tel: +31 (0)416 849 853","city":"1212 Grand-Lancy","title":"Camping Vision","email":"info@campingvision.com","street":"Rue du Bachet 14","country":"Switzerland","address":"Office Geneva"}},"header":{"error":"We're very sorry :'(","warning":"Thanks again :-)","heading":"Thank you for your interest!","noContent":"Ooops..."}},"statSites":{"heading":"Sites","dropdown":{"label":"Filter by"},"noContent":{"error":"Failed to fetch data","missing":"No data found"},"predicate":{"revenue":"Revenue","bookings":"Bookings"},"alternativeHeading":"Top 10 sites"},"bookingList":{"order":"Order","error":"An unexpected error occurred","title":"Search for booking number, reference number or customer name","search":"Search booking No.","heading":"No matching bookings | 1 booking found | {count} bookings found","perPage":"Show rows","orderBy":"Sort type","noContent":"No bookings found","xslTooltip":"If Excel displays error, click 'yes' to open.","display":{"all":"All","label":"Display option","current":"Current","historical":"Historical"},"placeholder":"Search","download":{"xls":"Download list (XLS)","csv":"Download list (CSV)"},"orderFields":{"asc":"Ascending","desc":"Descending"}},"instruction":{"dismiss":"Don't show again","defaultHeader":"How to use","contract":{"body":"Read through each part of the contract carefully to ensure everything is correct. If you find any discrepancies please write it in the notifications field by expanding the notification box at the bottom of the page. If a part is validated and correct please click the 'Accept Part' button at the bottom.<br/>To navigate between the different parts click the square icon in the progress module just below or use the arrows at the bottom of the page. <br/><br/>Please remember to save you changes."},"contractList":{"body":"From the list below you can see an overview of your contracts. Once a new contract is ready for review you will be able to click it and go to the review page. Once every part has been reviewed an accepted, it will be possible to download a PDF copy of the contract.","header":"Find your contracts below"}},"topMenu":{"right":{"admin":"Administrator","logout":"Logout","account":"Account"},"left":{"welcome":"Welcome"}},"allocationItem":{"site":"Site","supplier":"Supplier","updatedAt":"Last updated","updatedBy":"Updated by"},"activateUser":{"button":"Activate account","heading":"Activate your account","description":"You have requested to activate your account. Please enter your desired password below","messages":{"token":"Your request could not be processed. Please try again later.","success":"You account was successfully activated. You will be redirected to the login page shortly.","mismatch":"Your password should be at least 8 characters long and contain at least 1 uppercase letter and at least 1 number.","unexpected":"An unexpected error occurred. Our development team has been notified. Please try again later"},"pass":{"placeholder":"New password","errors":{"required":"You must provide a password."}},"passCheck":{"placeholder":"Re-enter password","errors":{"required":"You must re-enter your password","mismatch":"This does not match the password above"}}},"contract":{"breadcrumb":{"label":"Contract"},"draft":{"preview":"Preview contract","Error":"Error... retry"},"form":{"email":"Send ready for supplier email","alert":"Supplier not created in the Marketplace","accept":"Accept and complete contract","accepted":"Contract accepted","complete":"Contract ready for supplier","sites":{"view":"View","city":"City","email":"Email","phone":"Phone","rating":"Rating","address":"Address","country":"Country","zipCode":"Zip Code","website":"Website","noContent":"No sites found for this contract","header":{"heading":"Sites"},"facilities":{"size":"Size (sqm)","number":"Number","header":"Facilities","endDate":"End date","distance":"Distance","startDate":"Start date","dataHeader":"Extended info"}},"acceptPart":"Accept","sendAccept":"Accept contract","extras":{"rule":"Rule","sell":"Sell","ageTo":"Age to","price":"Price","person":"Person","noData":"n/a","endDate":"End date","ageFrom":"Age from","arrival":"Arrival","per":{"stay":"Per stay","week":"Per week","hour":"Per hour","night":"Per night","piece":"Per piece","person":"Per person","personNight":"Per person, per night","accommodation":"Per accommodation"},"netPrice":"Net price","startDate":"Start date","departure":"Departure","noContent":"No extras found for this contract","commission":"Commission","description":"Description","type":{"person":"Person","optional":"Optional","inclusive":"Inclusive","mandatory":"Mandatory","information":"Information"},"payment":{"ignore":"n/a","arrival":"Payment on arrival","booking":"Payment on booking","bookingArrival":"Booked and payed on arrival"},"header":{"heading":"Extras"}},"partAccepted":"accepted","notes":{"toggle":"Notifications","placeholder":"Enter any notifications here...","header":{"heading":"Notes"},"sendBeforeLeave":"Do you wish to send email notification to your contract manager about new messages?","sendEmailToContractManager":"Would you like to send an email notification to the contract manager about this message?"},"control":{"save":"Save","cancel":"Cancel accept","accept":"Accept part","accepted":"Part has been accepted"},"prices":{"price":"Price","endDate":"End date","noContent":"No price groups found for this contract","startDate":"Start date","commission":"Commission","header":{"heading":"Prices & commissions"},"setting":{"pricePr":{"unit":"Per unit","person":"Person"},"grossOrNet":{"net":"Net price","gross":"Gross price"},"priceType":{"singleDay":"Single day"}}},"progress":{"label":"Contract information","part":{"terms":"Terms of sale","sites":"Sites","extras":"Extras","prices":"Price groups","discounts":"Discounts","allocations":"Allocations","arrivalRules":"Arrival rules","supplierInfo":"Supplier info","accommodations":"Accommodations","cancellationRules":"Cancellation rules"},"header":{"heading":"Contract progress"}},"unknownProduct":"Unknow product type","discounts":{"name":"Name","types":"Type(s)","noDate":"n/a","endDate":"End date","startDate":"Start date","combine":"Can be combined|Can't be combined","noContent":"No discounts found for this contract","header":{"heading":"Discounts"},"arrivalDeparture":"Arrival/Departure","arrivalDay":"Arrival day","departureDay":"Departure day","day":{"mon":"Monday","tue":"Tuesday","wed":"Wednesday","thu":"Thursday","fri":"Friday","sat":"Saturday","sun":"Sunday"}},"missingContract":"Error in loading contract","message":{"initiated":"You contract is currently pending..."},"arrivalRules":{"days":"days","arrival":"Arrival","endDate":"End date","noContent":"No arrival rules found for this contract","minRental":"Min. rental","maxRental":"Max. rental","departure":"Departure","startDate":"Start date","type":{"label":"Type","arrival":"Arrival","departure":"Departure"},"header":{"heading":"Arrival rules"},"weekdays":{"friday":"Fr","monday":"Mo","sunday":"Su","tuesday":"Tu","thursday":"Th","saturday":"Sa","wednesday":"We"}},"allocations":{"units":"Units","noData":"n/a","endDate":"End date","startDate":"Start date","noContent":"No allocations found for this contract","type":{"label":"Type","BLOCKED":"Blocked","REQUEST":"Request","FREESALE":"Free sale","GUARANTEE":"Guarantee","ALLOTMENT":"Allotment"},"releaseDate":"Release date","releaseDays":"Release days","releaseType":"Release type","header":{"heading":"Allocations"}},"accommodations":{"view":"View","noData":"n/a","category":"Category","maxAdults":"Max. adults","noContent":"No accommodations found for this contract","maxPersons":"Max. persons","minFullPay":"Min. full paying","childrenAges":"Age","header":{"heading":"Accommodations"},"subGroups":{"header":"Facilities"},"childrenAgesInfo":"Eg. 14, 2 (Children max age 14 and 2 years old)","childOutsideAllowed":"1. child outside max. allowed","childOutsideAllowedInfo":"Eg. 2 (One child below 2 years old is allowed outside the total number of persons calculation)"},"terms":{"heading":{"header":"Terms of sale"}},"cancellationRules":{"noShow":"Absent","heading":"Cancellation rules","labels":{"days":"Days before arrival","percent":"Charged payment"}},"supplierInfo":{"bankInfo":{"bic":"BIC","info":"Info","name":"Name","bank":"Bank","iban":"IBAN","email":"Email","terms":"Terms","method":"Payment method","heading":"Bank information","account":"Account","bankCurrency":"Bank currency","priceCurrency":"Price currency"},"contactInfo":{"name":"Name","city":"City","email":"Email","phone":"Phone","heading":"Contact information","website":"Website","country":"Country","address":"Address","zipCode":"ZIP Code"},"bookingInfo":{"heading":"Booking information","amendEmail":"Amend email","bookingPhone":"Bookings contact phone","bookingEmail":"Booking email","requestEmail":"Request email","bookingPerson":"Bookings contact person ","complaintPhone":"Complaints phone","complaintEmail":"Complaint email","complaintPerson":"Complaints contact person ","cancellationEmail":"Cancellation email","confirmationEmail":"Confirmation email"}}},"alert":{"saved":"Contract saved successfully","error":"Something went wrong","noFile":"File not found","removed":"File removed successfully","supplier":"Supplier not registered in the Marketplace","notFound":"Contract not found","emailSent":"Email sent","completed":"Contract has been completed","illegalSize":"Image exceeds limit of 3500x2500 px","unsupportedType":"Illegal file type","emailAlreadySent":"Email has already been sent"}},"resetPassword":{"button":"Reset password","heading":"Reset password","description":"You have requested to reset your password. Please enter your desired password below","messages":{"token":"Your request could not be processed. Please try again later.","success":"Your password has been reset. You will be redirected to the login page shortly.","mismatch":"Your password should be at least 8 characters long and contain at least 1 uppercase letter and at least 1 number.","unexpected":"An unexpected error occurred. Our development team has been notified. Please try again later"},"pass":{"placeholder":"New password","errors":{"required":"You must provide a password"}},"passCheck":{"placeholder":"Re-enter password","errors":{"mismatch":"This does not match the password above","required":"You must re-enter your password"}}},"allocationList":{"order":"Order","orderBy":"Sort type","perPage":"Show rows","heading":"Manage allocations","button":{"update":"Update"},"messages":{"error":"An unexpected error occurred","noContent":"No allocations found","unauthorized":"Action not allowed by user permissions"},"orderFields":{"asc":"Ascending","desc":"Descending"},"tableFields":{"site":"Site","name":"Acc. unit","supplier":"Supplier","updatedBy":"Updated by","updatedAt":"Last updated","pendingRequests":"Pending requests"}},"dashboard":{"graph":{"label":"Graph here","footer":"The graph displays availability for your accommodations"},"tricks":{"click":"Click here","welcome":"Welcome","statistics":{"link":"/dashboard/stats","message":"You can get a quick overview of your sales from the statistics page."},"allocation":{"link":"/dashboard/allocation","message":"Did you know you can manage your allocations via the allocation page?"}},"suppliers":{"label":"Select supplier"},"date":{"days":{"friday":"Friday","monday":"Monday","sunday":"Sunday","tuesday":"Tuesday","thursday":"Thursday","saturday":"Saturday","wednesday":"Wednesday"}},"availability":{"all":"All accommodations","select":"Select accommodation","request":"On request","blocked":"Sold out / blocked","overview":"Availability overview %","noContent":"No data found","available":"Available"},"notifications":{"limit":"Show rows","noContent":"No notifications","list":{"site":"Site","link":"Add allotment","date":"Date","dismiss":"Dismiss","status":{"stay":"Inadequate stay length","label":"Status","arrival":"Inadequate arrival","soldOut":"Sold out","released":"Release date reached"},"contractLink":"Go to calendar","header":{"count":"No notifications | 1 notification found | {count} notifications found","heading":"Are you missing out on sales opportunities?","contractHeading":"Notifications overview"},"accommodation":"Accommodation"},"filters":{"sites":{"all":"All sites","label":"Select site"},"predicate":{"all":"Any status","stay":"Inadequate stay length","label":"Select status","arrival":"Inadequate arrival","soldOut":"Sold out","released":"Release date reached"},"accommodations":{"all":"All accommodations","label":"Select accommodation"}}},"alert":{"dismiss":{"error":"Something went wrong","success":"Notification has been dismissed","noContent":"The notification couldn't be found"}}},"statInventory":{"heading":"Inventory","dropdown":{"label":"Filter by"},"noContent":{"error":"Failed to fetch data","missing":"No data found"},"predicate":{"revenue":"Revenue","bookings":"Bookings"},"alternativeHeading":"Top 10 inventory"},"forgotPassword":{"button":"Request reset","heading":"Forgot your password?","signInLink":"Back to login","description":"Enter your email to request a reset of your password.","messages":{"noexist":"The email does not exist","success":"An email has been sent with a link to reset your password","unexpected":"An unexpected error occurred. Our development team has been notified. Please try again later"},"email":{"placeholder":"Email","errors":{"email":"You must provide a valid email","required":"You must provide an email"}}},"bookingFilters":{"site":{"all":"All sites","label":"Site"},"brand":{"all":"All brands","label":"Brand"},"status":{"all":"All types","label":"Status","types":{"booked":"Booked","pending":"Pending","unknown":"No status","request":"Request","rejected":"Rejected","cancelled":"Cancelled","request-cancel":"Request cancel"}},"domain":{"all":"All domains","label":"Domain"},"country":{"all":"All countries","label":"Booking country"},"supplier":{"all":"All suppliers","label":"Supplier"},"accommodation":{"all":"All accommodations","label":"Accommodations"},"arrivalPeriod":{"label":"Arrival period","datepicker":{"heading":"Select an arrival period"}},"bookingPeriod":{"label":"Booking period","datepicker":{"heading":"Select a booking period"}}},"navigation-menu":{"language":"Select language","items":{"stats":"Statistics","booking":"Booking","supplier":"Supplier","contract":"Contract","dashboard":"Dashboard","allocation":"Allocation","productType":"Product type","products":{"Hotel":"Hotel","Shuttle":"Shuttle","Camping":"Camping","Badeland":"Waterpark","Skiferie":"Ski","Krydstogt":"Cruise","Disneyland":"Disneyland","Feriebolig":"Property"}}},"manageAllocationList":{"error":"Failed to load allocation list","retry":"Try again","header":" Allocation overview","list":{"to":"To","new":"New allocation","type":"Type","from":"From","edit":"Edit allocation","block":"Block for period","units":"Units","release":"Release date/days","released":"Released in period","updatedBy":"Updated by","updatedAt":"Updated at","releaseDate":"Release date","releaseDays":"Release days","releaseType":"Release type"},"noAllocations":"No Allocations found!"},"manageAllocationPage":{"error":"Something went wrong, please try again later.","mobile":"This content can only be displayed on a desktop device.","request":{"cancel":{"unauth":"You are unauthorized to cancel requests","success":"Request cancelled successfully","failure":"An error occurred, please try later","noContent":"The request id didn't match any existing ids"},"accept":{"success":"Request accepted successfully","failure":"An error occurred, please try later"},"modify":{"failure":"An error occurred, please try later","success":"Request modified and accepted successfully"},"decline":{"failure":"An error occurred, please try later","success":"Request declined successfully"}}},"manageAllocationModal":{"info":"Click on the add button above to start adding allocations for the chosen period. <br/>NOTE! The last day in the period is NOT included","dash":"-","error":"Something went wrong, please try again later","period":"Period:","update":"Allocation has been successfully updated","loading":"Loading Allocations","success":"Allocation has been successfully added.","request":"Allocation request has been successfully sent","blocked":"Allocation has been successfully blocked","form":{"days":"Days","date":"##/##/####","type":{"null":"n/a","blocked":"Blocked","request":"Request","freesale":"Free sale","allotment":"Allotment"},"units":{"null":"n/a","allotment":"No. of units","notAllotment":"Only for allotments"},"buttons":{"add":"Add","create":"Add allocations","submit":"Submit changes","cancel":"Cancel"},"releaseType":{"null":"n/a","request":"Request","blocked":"Blocked","freesale":"Free sale","selectType":"Select type"},"releaseMethod":{"null":"n/a","date":"Date","days":"Days"}},"allocations":"Allocations found","buttons":{"add":"Add"},"unauthorized":"Unauthorized","noAllocations":"No Allocations found","overlaySuccess":"Allocation has been successfully updated.","header":{"heading":"Manage Allocations"}},"statNumber":{"body":{"noDataFound":"No data found","failedToFetchData":"Failed to fetch data"}},"contractList":{"heading":{"header":"Contracts"},"overview":{"error":"Failed to load data","download":"Download","noContracts":"No contracts found","heading":{"header":"Contract overview"},"status":{"initiated":"Contract is currently pending...","readyForSupplier":"Contract ready for review"}},"history":{"heading":{"header":"History"}}},"contractNotes":{"messages":{"goTo":"Go to ref.","wrote":"wrote","supplier":"Supplier","internal":"Internal message","sendEmail":"Do you wish to send an notification alert email?","noContent":"No notifications","campingVision":"Camping Vision","supplierEmail":"Send notification alert email to supplier","backOfficeEmail":"Send notification alert email to back office","contractManagerEmail":"Send notification alert email to contract manager"},"header":{"heading":"Notifications","messages":"Unanswered message(s)"},"control":{"internal":"Send as internal message?","reference":"Reference","placeholder":"Type your message..."}},"manageAllocationFormRow":{"days":"Days","dateFormat":"DD/MM/YYYY","dropDown":{"date":"Date","days":"Days","request":"Request","blocked":"Blocked","freeSale":"Free sale","allotment":"Allotment","guarantee":"Guarantee","selectType":"Select a type","chooseType":"Choose type"}},"contractManagement":{"list":{"year":"Year","edit":"Edit","view":"View contract","perPage":"Per","supplier":"Supplier","download":"Download","show":{"all":"All contracts","mine":"Only my contracts","label":"Show"},"updatedBy":"Updated by","status":{"done":"Done","basic":"Basic contract open","label":"Status","pending":"Waiting for supplier","extended":"Extended contract open","completed":"Completed","initiated":"Contract open","notification":"Notification","readyForSupplier":"Awaiting supplier","readyForBackOffice":"Awaiting back office","supplierNotifications":"Notes from supplier","readyForContractManager":"Awaiting contract manager","contractManagerNotifications":"Notes from contract manager"},"noContracts":"No contracts matched your criteria","display":{"all":"Any status","label":"Status"},"lastUpdated":"Last updated","viewSupplier":"View supplier progress","heading":{"header":"Contract status list"}},"alert":{"error":"Something went wrong","saved":"Contract saved successfully","noFile":"File not found","removed":"File removed successfully","notFound":"Contract not found","emailSent":"Email sent","illegalSize":"Image exceeds limit of 3500x2500 px","noSitesFound":"No sites found","unsupportedType":"Illegal file type","validationError":"Form incomplete","emailAlreadySent":"Email has already been sent","noAccommodationsFound":"No accommodations found"},"edit":{"form":{"add":"Add","save":"Save form","link":"Link","copy":"Copy existing","create":"Create","remove":"Remove file","confirm":"Are you sure you want to delete the file?","noTitle":"Untitled","optional":"Optional","checkbox":"Show in contract","download":"Download","emailSent":"Email sent","brands":{"info":"Select the brands that the contract should be applied to:"},"email":{"review":"Send ready for review email","supplier":"Send ready for supplier email","backOffice":"Send email to back office"},"images":{"remove":"Remove","initial":"Click or drag images here","confirm":"Confirm","accepted":"File types accepted: '.jpg,.jpeg,.bmp,.png'","unsupported":"Image upload not supported by your browser"},"upload":{"remove":"Remove","confirm":"Confirm","initial":"Click or drag files here","accepted":"File types accepted: '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'"},"complete":{"review":"Contract ready for review ?","contract":"Basic / extended part completed"},"subHeader":{"notes":"Notes","brands":"Brands","accInfo":"Accommodation(s)","accepted":"Accepted","siteInfo":"Site(s)","discounts":"Discounts","commission":"Commission","priceExtra":"Prices and extras","arrivalRules":"Arrival rules","allotmentRules":"Allocation and rules","arrivalDeparture":"Arrival/Departure"},"placeholder":{"notes":"Enter extra information here eg. personal experience etc.","discounts":"Enter discount information here...","priceExtra":"Enter price list for accommodation types and extras...","commission":"Enter commission rates...","arrivalRules":"Enter arrival rules...","accInfo":{"site":"Choose site(s)","text":"Enter accommodation description here...","name":"Enter / choose accommodation name"},"siteInfo":{"text":"Enter site description here...","name":"Enter / choose site name"},"allotmentRules":"Enter dates for allotment, accommodation type and rules for said allotment...","arrivalDeparture":"Enter arrival and departure info along with minimum rental here..."},"autoComplete":{"multi":"Attach to site...","accInfo":"Enter accommodation name here...","siteInfo":"Enter site name here..."},"header":{"heading":{"done":"Accepted by supplier","basic":"Basic information","extended":"Extended information"}}},"progress":{"done":"Accepted by supplier","basic":"Basic information","extended":"Extended information","defaultText":"No changes","header":{"heading":"Contract progress overview"},"subHeader":{"notes":"Notes","brands":"Brands","accInfo":"Accommodation(s)","accepted":"Accepted","siteInfo":"Site(s)","discounts":"Discounts","commission":"Commission","arrivalRules":"Arrival","allotmentRules":"Allocation","priceExtra":{"price":"Prices","extra":"Extra"},"arrivalDeparture":"Arrival/Departure"}}},"noChangesConfirm":"This will add 'No changes' to this part, proceed?"},"manageAllocationForm":{"heading":"Add allocations","buttons":{"reset":"Reset form","submit":"Submit changes"},"control-message":{"on":" on ","content":"<strong>NOTE:</strong> You are adding allocation for:"}},"manageAllocationFilters":{"year":"Choose year"},"subPages":{"home":{"subTitleRevenue":"EUR","subTitleBookings":"pcs","labelTotalRevenue":"Total revenue","labelTotalBookings":"Total bookings","labelPeriodRevenue":"Period Revenue","labelPeriodBookings":"Period bookings"}},"manageAllocationRequest":{"units":"units","toggle":"Pending requests","heading":"Request overview","form":{"body":"You can alter the request from the form below. Click accept to accept the request with the modifications applied","period":{"title":"Period"},"labels":{"units":"Units","release":"Release date/days"},"header":{"heading":"Modify request"},"buttons":{"cancel":"Cancel","accept":"Accept"}},"noContent":"No requests found","table":{"type":"Change type","block":"Request block","period":"Period","release":"Change release","deduction":"Allotment deduction","requestDate":"Request date"},"releaseDays":"days","type":{"request":"Request","blocked":"Blocked","freesale":"Freesale","allotment":"Allotment","guaranteed":"Guaranteed"},"buttons":{"deny":"Deny","edit":"Edit","cancel":"Cancel","accept":"Accept"},"dropdown":{"label":"Request type","denied":"Declined","pending":"Pending","approved":"Approved","modified":"Modified"},"headings":{"modified":"Accepted changes - with alterations from Contract Manager","accepted":"Accepted changes","declined":"Declined changes","requested":"Requested changes"}},"manageAllocationModalList":{"new":"New allocation","date":"date","edit":"Edit allocation","days":"days","released":"Released","block":{"true":"Block for period","false":"Not released","blocked":"Blocked"},"buttons":{"new":"New allocation","edit":"Edit allocation","block":"Block allocation"},"releaseType":{"null":"n/a","request":"Request","blocked":"Blocked","freesale":"Free sale"},"header":{"bookingsInPeriod":"Allocations within period:","noBookingsInPeriod":"No allocations in period"}},"manageAllocationCalendar":{"retry":"Try again","error":"Failed to load calendar","months":["January","February","March","April","May","June","July","August","September","October","November","December"],"header":{"howTo":"How to use the calendar","heading":"Allocation Calendar"},"dropdown":{"full":"Full year","months":"6 months"}},"datePicker":{"predefinedLinks":{"today":"Today","thisWeek":"This week","lastYear":"Last year","thisYear":"This year","lastWeek":"Last week","lastMonth":"Last month","yesterday":"Yesterday","thisMonth":"This month"}},"manageAllocationFormAccept":{"header":"Adding allocations","alert":{"to":"To: ","end":"At this time you are not able to change release rules unless you go from free sale to allotment.<br/>It's not possible to deduct the number of units, units can only be added.","from":"From: ","start":"This will overwrite the following period"},"content":{"end":" for the following accommodation(s):","note":"<strong>NOTE! These changes are irreversible.</strong>","comment":"Add comment","start":{"add":"You are about to add allocations on","block":"You are about to block allocations on","submit":"You are about to update allocations on","request":"You are about to request allocation changes on","requestBlock":"You are about to request block allocation on"}},"buttons":{"accept":"Accept","cancel":"Cancel"}},"validator":{"validateDates":{"dateBefore":"To date has to be after the from datedsa"}},"manageAllocationFormHeader":{"endDate":"End date","startDate":"Start date","releaseBy":"Release by","releaseType":"Release type","afterRelease":"Status after release","numberOfUnits":"Number of units","allocationType":"Allocation type","releaseDaysDate":"Release days/date"},"statFilters":{"datepickers":{"booking":{"label":"Booking period","heading":"Booking period"},"arrival":{"label":"Arrival period","heading":"Arrival period"}}},"manageAllocationModalOverlayForm":{"info":"You can change the amount of units along with the release date/days. Blocking is possible when the units are released","units":"Change no. of units","status":"Change status","denied":"You are not allowed to make allocation changes","success":"The allocations has been successfully updated.","blocked":"NOTE! This product is blocked, and no changes will be submitted","warning":"NOTE! This product has been released. You can block it or add new allocation from the previous page.","request":"NOTE! These changes can't be directly applied. You can request the change which will be reviewed by a contract manager. This can take up to 5 working days","released":"NOTE! This product has been released.","instruction":"Need help?","labels":{"type":"Allocation type","units":"Initial units","cancel":"Cancel","period":"Period","bookings":"Bookings in period","releaseDate":"Release date","releaseDays":"Release days","releaseType":"Release type","arrivalRules":"Arrival rule(s) in period","releaseMethod":"Release method","noArrivalRules":"You have not defined any arrival rules for this period","bookingsMaxCount":"Max. bookings in period","arrivalTypes":{"label":"Type","arrival":"Arrival","departure":"Departure"},"arrivalRuleStayLength":"Stay length in days","bookingsMaxCountToolTip":"The maximum number of bookings on a given day within the allocation period"},"release":{"date":"Change release date","null":"No release date","days":"Change release days"},"accept":{"block":"Block allocation","submit":"Update allocation","update":"Update allocation","request":"Request update allocation","requestBlock":"Request block allocation"},"pending":{"days":"days","units":"units","label":"There is pending requests","requested":"Requested"},"buttons":{"reset":"Reset","block":"Block","cancel":"Cancel","update":"Update","request":"Request","requestBlock":"Request block"},"editable":{"type":"Change allocation type","units":"Change number of allotment","releaseDate":"Change release date","releaseType":"Change allocation release type","releaseDays":"Change release days","information":{"default":"Fields that are editable are displayed with the edit symbol. Click on the field to open up the edit box. You can do multiple changes before updating and by clicking reset you discard all changes."}},"requestPending":"NOTE! You can't make changes to this period as there are pending change requests","requestMessage":"NOTE! These changes can't be directly applied. You can request the change which will be reviewed by a contract manager within 24 hours on weekdays","changesRequested":"You can't edit the allocation as there are pending requests","instructionTrusted":"Once a change is saved it will be applied directly to the allocation and will be instantly visible across our brands.<br/>Please be aware that some limitations might occur e.g. You can't withdraw allotment below the number of bookings currently present on the allocation.","validator":{"days":{"set":"Release days has to be set to a value above 0","lower":"You are not allowed to increase the release days"},"date":{"set":"Release date has to be set and in valid format DD/MM/YYYY","lower":"You are not allowed to move the release date backwards","before":"The release date should be before or equal to the start date of the allocations","beforeEnd":"The release date should be before or equal to the end date of the allocations"},"units":{"set":"Units count should be between 1 and 10. If you want to withdraw all units then block the allocation"}},"instructionNotTrusted":"Once a change is saved it will be applied directly to the allocation and will be instantly visible across our brands.<br/>You can't deduct allotment, change type to request or block unreleased allocation directly, if you wish to make those changes you can request the change.<br/><br/>Changes are reviewed and handled by your contract manager within 5 working days."},"manageAllocationCalendarWeekdays":{"sunday":"Su","monday":"Mo","friday":"Fr","tuesday":"Tu","thursday":"Th","saturday":"Sa","wednesday":"We"},"manageAllocationModalCalendarElement":{"units":"Initial units: ","bookings":"Bookings: ","request":{"days":"days","type":"Change type:","units":"unit(s)","header":"Requested changes","deduct":"Deduct:","release":"Change release:"}},"manageAllocationModalOverlay":{"header":{"heading":"Edit allocation"}},"manageAllocationModalCalendarInfobox":{"header":{"heading":"Calendar Infobox"}}}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"valid":false,"tips":{"hi":"-/-","help":"-/-","more":"-/-","less":"-/-","camping":"-/-","adminPage":{"edit":{"body":"-/-","title":"-/-"},"block":{"body":"-/-","title":"-/-"},"create":{"body":"-/-","title":"-/-"}},"statPage":{"boxes":{"body":"-/-","title":"-/-"},"graph":{"body":"-/-","title":"-/-"},"filter":{"body":"-/-","title":"-/-"}},"dashboardPage":{"add":{"body":"-/-","title":"-/-"},"graph":{"body":"-/-","title":"-/-"},"filter":{"body":"-/-","title":"-/-"},"notifications":{"body":"-/-","title":"-/-"}},"bookingPage":{"search":{"body":"-/-","title":"-/-"},"filters":{"body":"-/-","title":"-/-"},"sortList":{"body":"-/-","title":"-/-"},"xlsError":{"body":"-/-","title":"-/-"},"downloadList":{"body":"-/-","title":"-/-"}},"allocationPage":{"sort":{"body":"-/-","title":"-/-"},"site":{"body":"-/-","title":"-/-"},"update":{"body":"-/-","title":"-/-"},"updateBy":{"body":"-/-","title":"-/-"}},"accountPage":{"password":{"body":"-/-","title":"-/-"},"activity":{"body":"-/-","title":"-/-"},"information":{"body":"-/-","title":"-/-"},"notifications":{"body":"-/-","title":"-/-"}},"manageAllocationPage":{"error":"-/-","year":{"body":"-/-","title":"-/-"},"info":{"body":"-/-","title":"-/-"},"modal":{"body":"-/-","title":"-/-"},"extra":{"body":"-/-","title":"-/-"},"select":{"body":"-/-","title":"-/-"},"display":{"body":"-/-","title":"-/-"},"overview":{"body":"-/-","title":"-/-"},"accommodation":{"body":"-/-","title":"-/-"},"alert":{"requestError":"-/-","requestAccept":"-/-","requestDenied":"-/-","requestUnauthorized":"-/-"}},"contractManagementPage":{"upload":{"body":"-/-","title":"-/-"},"expand":{"body":"-/-","title":"-/-"},"progress":{"body":"-/-","title":"-/-"},"indicator":{"body":"-/-","title":"-/-"}}},"adminItem":{"id":"-/-","edit":"-/-","email":"-/-","status":"-/-","lastName":"-/-","firstName":"-/-"},"admin":{"list":{"id":"-/-","edit":"-/-","email":"-/-","status":"-/-","noUsers":"-/-","content":"-/-","lastname":"-/-","firstname":"-/-","header":{"heading":"-/-"}},"alert":{"email":"-/-","error":"-/-","updated":"-/-","deleted":"-/-","created":"-/-","blocked":"-/-","password":"-/-","unblocked":"-/-","notifications":"-/-","wrongPassword":"-/-"},"profile":{"and":"-/-","email":"-/-","weekly":"-/-","notice":"-/-","receive":"-/-","language":"-/-","noNotice":"-/-","everyday":"-/-","fullName":"-/-","fortnightly":"-/-","header":{"heading":"-/-"},"notifications":{"edit":"-/-","weekly":"-/-","cancel":"-/-","update":"-/-","fortnightly":"-/-","days":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","saturday":"-/-","thursday":"-/-","wednesday":"-/-"},"heading":{"header":"-/-"}}},"form":{"create":"-/-","edit":{"edit":"-/-","block":"-/-","delete":"-/-","unblock":"-/-"},"error":{"edit":"-/-","email":"-/-","error":"-/-"}},"heading":{"header":"-/-"},"edit":{"form":{"info":"-/-","roles":"-/-","lastname":"-/-","language":"-/-","firstname":"-/-","button":{"submit":"-/-"},"notifications":"-/-","buttons":{"block":"-/-","update":"-/-","delete":"-/-","unblock":"-/-"},"warning":{"blocked":"-/-","inactive":"-/-"},"validator":{"lastname":"-/-","firstname":"-/-"}},"header":{"heading":"-/-"},"accept":{"header":{"block":"-/-","update":"-/-","delete":"-/-","unblock":"-/-"},"content":{"block":"-/-","delete":"-/-","update":"-/-","unblock":"-/-"},"buttons":{"accept":"-/-","cancel":"-/-"}}},"create":{"form":{"tip":"-/-","roles":"-/-","email":"-/-","language":"-/-","lastname":"-/-","firstname":"-/-","button":{"submit":"-/-"},"validator":{"email":"-/-","lastname":"-/-","firstname":"-/-"}},"button":{"submit":"-/-"},"accept":{"header":"-/-","content":"-/-","buttons":{"cancel":"-/-","accept":"-/-"}},"header":{"heading":"-/-"}}},"signIn":{"button":"-/-","heading":"-/-","description":"-/-","logoutNotice":"-/-","invalidNotice":"-/-","pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"inactivityNotice":"-/-","email":{"placeholder":"-/-","errors":{"email":"-/-","required":"-/-"}},"messages":{"mismatch":"-/-","unexpected":"-/-"},"forgotPasswordLink":"-/-"},"booking":{"button":"-/-","heading":"-/-","filterText":"-/-","dateTypes":["-/-","-/-"],"placeholder":"-/-","description":"-/-","tableFields":{"#":"-/-","reset":"-/-","status":"-/-","domain":"-/-","duration":"-/-","siteName":"-/-","bookingRef":"-/-","bookingDate":"-/-","arrivalDate":"-/-","supplierRef":"-/-","supplierName":"-/-","customerName":"-/-","departureDate":"-/-","accommodation":"-/-"},"messages":{"error":"-/-","expired":"-/-"},"filterOptions":{"site":"-/-","option":"-/-","domain":"-/-","default":"-/-","bookingAgent":"-/-","accommodation":"-/-","bookingCountry":"-/-"}},"account":{"form":{"id":"-/-","email":"-/-","lastName":"-/-","firstName":"-/-","buttons":{"reset":"-/-","update":"-/-"},"heading":{"header":"-/-"},"accountType":{"label":"-/-","admin":{"true":"-/-","false":"-/-"}},"validator":{"required":"-/-"},"placeholder":{"lastName":"-/-","firstName":"-/-"}},"activity":{"site":"-/-","date":"-/-","limit":"-/-","type":{"label":"-/-","request":"-/-","allocation":"-/-"},"status":{"label":"-/-","RELEASED":"-/-","USER_EDIT":"-/-","USER_INSERT":"-/-"},"header":{"months":"-/-","heading":"-/-"},"accommodation":"-/-"},"password":{"password":"-/-","rePassword":"-/-","newPassword":"-/-","buttons":{"reset":"-/-","update":"-/-"},"heading":{"header":"-/-"},"validator":{"mismatch":"-/-","password":"-/-"},"placeholder":{"password":"-/-"}}},"statList":{"heading":"-/-","predicate":"-/-","backButton":"-/-"},"bookingItem":{"site":"-/-","status":"-/-","domain":"-/-","duration":"-/-","bookingRef":"-/-","arrivalDate":"-/-","supplierRef":"-/-","bookingDate":"-/-","supplierName":"-/-","customerName":"-/-","departureDate":"-/-","accommodation":"-/-"},"notFound":{"heading":"-/-"},"introduction":{"body":"-/-","error":"-/-","warning":"-/-","noContent":"-/-","footer":{"title":"-/-","contact":{"tel":"-/-","city":"-/-","title":"-/-","email":"-/-","street":"-/-","country":"-/-","address":"-/-"}},"header":{"error":"-/-","warning":"-/-","heading":"-/-","noContent":"-/-"}},"statSites":{"heading":"-/-","dropdown":{"label":"-/-"},"noContent":{"error":"-/-","missing":"-/-"},"predicate":{"revenue":"-/-","bookings":"-/-"},"alternativeHeading":"-/-"},"bookingList":{"order":"-/-","error":"-/-","title":"-/-","search":"-/-","heading":"-/-","perPage":"-/-","orderBy":"-/-","noContent":"-/-","xslTooltip":"-/-","display":{"all":"-/-","label":"-/-","current":"-/-","historical":"-/-"},"placeholder":"-/-","download":{"xls":"-/-","csv":"-/-"},"orderFields":{"asc":"-/-","desc":"-/-"}},"instruction":{"dismiss":"-/-","defaultHeader":"-/-","contract":{"body":"-/-"},"contractList":{"body":"-/-","header":"-/-"}},"topMenu":{"right":{"admin":"-/-","logout":"-/-","account":"-/-"},"left":{"welcome":"-/-"}},"allocationItem":{"site":"-/-","supplier":"-/-","updatedAt":"-/-","updatedBy":"-/-"},"activateUser":{"button":"-/-","heading":"-/-","description":"-/-","messages":{"token":"-/-","success":"-/-","mismatch":"-/-","unexpected":"-/-"},"pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"passCheck":{"placeholder":"-/-","errors":{"required":"-/-","mismatch":"-/-"}}},"contract":{"form":{"email":"-/-","alert":"-/-","accept":"-/-","complete":"-/-","sites":{"view":"-/-","city":"-/-","email":"-/-","phone":"-/-","rating":"-/-","address":"-/-","country":"-/-","zipCode":"-/-","website":"-/-","noContent":"-/-","header":{"heading":"-/-"},"facilities":{"size":"-/-","number":"-/-","header":"-/-","endDate":"-/-","distance":"-/-","startDate":"-/-","dataHeader":"-/-"}},"acceptPart":"-/-","sendAccept":"-/-","extras":{"rule":"-/-","sell":"-/-","ageTo":"-/-","price":"-/-","person":"-/-","noData":"-/-","endDate":"-/-","ageFrom":"-/-","arrival":"-/-","per":{"stay":"-/-","week":"-/-","hour":"-/-","night":"-/-","piece":"-/-","person":"-/-","personNight":"-/-","accommodation":"-/-"},"netPrice":"-/-","startDate":"-/-","departure":"-/-","noContent":"-/-","commission":"-/-","description":"-/-","type":{"person":"-/-","optional":"-/-","inclusive":"-/-","mandatory":"-/-","information":"-/-"},"payment":{"ignore":"-/-","arrival":"-/-","booking":"-/-","bookingArrival":"-/-"},"header":{"heading":"-/-"}},"partAccepted":"-/-","notes":{"toggle":"-/-","placeholder":"-/-","header":{"heading":"-/-"},"sendBeforeLeave":"-/-","sendEmailToContractManager":"-/-"},"control":{"save":"-/-","cancel":"-/-","accept":"-/-","accepted":"-/-"},"prices":{"price":"-/-","endDate":"-/-","noContent":"-/-","startDate":"-/-","commission":"-/-","header":{"heading":"-/-"},"setting":{"pricePr":{"unit":"-/-","person":"-/-"},"grossOrNet":{"net":"-/-","gross":"-/-"},"priceType":{"singleDay":"-/-"}}},"progress":{"label":"-/-","part":{"terms":"-/-","sites":"-/-","extras":"-/-","prices":"-/-","discounts":"-/-","allocations":"-/-","arrivalRules":"-/-","supplierInfo":"-/-","accommodations":"-/-","cancellationRules":"-/-"},"header":{"heading":"-/-"}},"unknownProduct":"-/-","discounts":{"name":"-/-","types":"-/-","noDate":"-/-","endDate":"-/-","startDate":"-/-","noContent":"-/-","header":{"heading":"-/-"},"arrivalDeparture":"-/-"},"missingContract":"-/-","message":{"initiated":"-/-"},"arrivalRules":{"days":"-/-","arrival":"-/-","endDate":"-/-","noContent":"-/-","minRental":"-/-","maxRental":"-/-","departure":"-/-","startDate":"-/-","type":{"label":"-/-","arrival":"-/-","departure":"-/-"},"header":{"heading":"-/-"},"weekdays":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"}},"allocations":{"units":"-/-","noData":"-/-","endDate":"-/-","startDate":"-/-","noContent":"-/-","type":{"label":"-/-","BLOCKED":"-/-","REQUEST":"-/-","FREESALE":"-/-","GUARANTEE":"-/-","ALLOTMENT":"-/-"},"releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-","header":{"heading":"-/-"}},"accommodations":{"view":"-/-","noData":"-/-","category":"-/-","maxAdults":"-/-","noContent":"-/-","maxPersons":"-/-","minFullPay":"-/-","childrenAges":"-/-","header":{"heading":"-/-"},"subGroups":{"header":"-/-"},"childrenAgesInfo":"-/-","childOutsideAllowed":"-/-","childOutsideAllowedInfo":"-/-"},"terms":{"heading":{"header":"-/-"}},"cancellationRules":{"noShow":"-/-","heading":"-/-","labels":{"days":"-/-","percent":"-/-"}},"supplierInfo":{"bankInfo":{"bic":"-/-","info":"-/-","name":"-/-","bank":"-/-","iban":"-/-","email":"-/-","terms":"-/-","method":"-/-","heading":"-/-","account":"-/-","bankCurrency":"-/-","priceCurrency":"-/-"},"contactInfo":{"name":"-/-","city":"-/-","email":"-/-","phone":"-/-","heading":"-/-","website":"-/-","country":"-/-","address":"-/-","zipCode":"-/-"},"bookingInfo":{"heading":"-/-","amendEmail":"-/-","bookingPhone":"-/-","bookingEmail":"-/-","requestEmail":"-/-","bookingPerson":"-/-","complaintPhone":"-/-","complaintEmail":"-/-","complaintPerson":"-/-","cancellationEmail":"-/-","confirmationEmail":"-/-"}}},"alert":{"saved":"-/-","error":"-/-","noFile":"-/-","removed":"-/-","supplier":"-/-","notFound":"-/-","emailSent":"-/-","completed":"-/-","illegalSize":"-/-","unsupportedType":"-/-","emailAlreadySent":"-/-"}},"resetPassword":{"button":"-/-","heading":"-/-","description":"-/-","messages":{"token":"-/-","success":"-/-","mismatch":"-/-","unexpected":"-/-"},"pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"passCheck":{"placeholder":"-/-","errors":{"mismatch":"-/-","required":"-/-"}}},"allocationList":{"order":"-/-","orderBy":"-/-","perPage":"-/-","heading":"-/-","button":{"update":"-/-"},"messages":{"error":"-/-","noContent":"-/-","unauthorized":"-/-"},"orderFields":{"asc":"-/-","desc":"-/-"},"tableFields":{"site":"-/-","name":"-/-","supplier":"-/-","updatedBy":"-/-","updatedAt":"-/-","pendingRequests":"-/-"}},"dashboard":{"graph":{"label":"-/-","footer":"-/-"},"tricks":{"click":"-/-","welcome":"-/-","statistics":{"link":"-/-","message":"-/-"},"allocation":{"link":"-/-","message":"-/-"}},"suppliers":{"label":"-/-"},"date":{"days":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"}},"availability":{"all":"-/-","select":"-/-","request":"-/-","blocked":"-/-","overview":"-/-","noContent":"-/-","available":"-/-"},"notifications":{"limit":"-/-","noContent":"-/-","list":{"site":"-/-","link":"-/-","date":"-/-","dismiss":"-/-","status":{"stay":"-/-","label":"-/-","arrival":"-/-","soldOut":"-/-","released":"-/-"},"contractLink":"-/-","header":{"count":"-/-","heading":"-/-","contractHeading":"-/-"},"accommodation":"-/-"},"filters":{"sites":{"all":"-/-","label":"-/-"},"predicate":{"all":"-/-","stay":"-/-","label":"-/-","arrival":"-/-","soldOut":"-/-","released":"-/-"},"accommodations":{"all":"-/-","label":"-/-"}}},"alert":{"dismiss":{"error":"-/-","success":"-/-","noContent":"-/-"}}},"statInventory":{"heading":"-/-","dropdown":{"label":"-/-"},"noContent":{"error":"-/-","missing":"-/-"},"predicate":{"revenue":"-/-","bookings":"-/-"},"alternativeHeading":"-/-"},"forgotPassword":{"button":"-/-","heading":"-/-","signInLink":"-/-","description":"-/-","messages":{"noexist":"-/-","success":"-/-","unexpected":"-/-"},"email":{"placeholder":"-/-","errors":{"email":"-/-","required":"-/-"}}},"bookingFilters":{"site":{"all":"-/-","label":"-/-"},"brand":{"all":"-/-","label":"-/-"},"status":{"all":"-/-","label":"-/-","types":{"booked":"-/-","pending":"-/-","unknown":"-/-","request":"-/-","rejected":"-/-","cancelled":"-/-","request-cancel":"-/-"}},"domain":{"all":"-/-","label":"-/-"},"country":{"all":"-/-","label":"-/-"},"supplier":{"all":"-/-","label":"-/-"},"accommodation":{"all":"-/-","label":"-/-"},"arrivalPeriod":{"label":"-/-","datepicker":{"heading":"-/-"}},"bookingPeriod":{"label":"-/-","datepicker":{"heading":"-/-"}}},"navigation-menu":{"language":"-/-","items":{"stats":"-/-","booking":"-/-","supplier":"-/-","contract":"-/-","dashboard":"-/-","allocation":"-/-","productType":"-/-","products":{"Hotel":"-/-","Shuttle":"-/-","Camping":"-/-","Badeland":"-/-","Skiferie":"-/-","Krydstogt":"-/-","Disneyland":"-/-","Feriebolig":"-/-"}}},"manageAllocationList":{"error":"-/-","retry":"-/-","header":"-/-","list":{"to":"-/-","new":"-/-","type":"-/-","from":"-/-","edit":"-/-","block":"-/-","units":"-/-","release":"-/-","released":"-/-","updatedBy":"-/-","updatedAt":"-/-","releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-"},"noAllocations":"-/-"},"manageAllocationPage":{"error":"-/-","mobile":"-/-","request":{"cancel":{"unauth":"-/-","success":"-/-","failure":"-/-","noContent":"-/-"},"accept":{"success":"-/-","failure":"-/-"},"modify":{"failure":"-/-","success":"-/-"},"decline":{"failure":"-/-","success":"-/-"}}},"manageAllocationModal":{"info":"-/-","dash":"-/-","error":"-/-","period":"-/-","update":"-/-","loading":"-/-","success":"-/-","request":"-/-","blocked":"-/-","form":{"days":"-/-","date":"-/-","type":{"null":"-/-","blocked":"-/-","request":"-/-","freesale":"-/-","allotment":"-/-"},"units":{"null":"-/-","allotment":"-/-","notAllotment":"-/-"},"buttons":{"add":"-/-","create":"-/-","submit":"-/-","cancel":"-/-"},"releaseType":{"null":"-/-","request":"-/-","blocked":"-/-","freesale":"-/-","selectType":"-/-"},"releaseMethod":{"null":"-/-","date":"-/-","days":"-/-"}},"allocations":"-/-","buttons":{"add":"-/-"},"unauthorized":"-/-","noAllocations":"-/-","overlaySuccess":"-/-","header":{"heading":"-/-"}},"statNumber":{"body":{"noDataFound":"-/-","failedToFetchData":"-/-"}},"contractList":{"heading":{"header":"-/-"},"overview":{"error":"-/-","download":"-/-","noContracts":"-/-","heading":{"header":"-/-"},"status":{"initiated":"-/-","readyForSupplier":"-/-"}},"history":{"heading":{"header":"-/-"}}},"contractNotes":{"messages":{"goTo":"-/-","wrote":"-/-","supplier":"-/-","internal":"-/-","sendEmail":"-/-","noContent":"-/-","campingVision":"-/-","supplierEmail":"-/-","backOfficeEmail":"-/-","contractManagerEmail":"-/-"},"header":{"heading":"-/-","messages":"-/-"},"control":{"internal":"-/-","reference":"-/-","placeholder":"-/-"}},"manageAllocationFormRow":{"days":"-/-","dateFormat":"-/-","dropDown":{"date":"-/-","days":"-/-","request":"-/-","blocked":"-/-","freeSale":"-/-","allotment":"-/-","guarantee":"-/-","selectType":"-/-","chooseType":"-/-"}},"contractManagement":{"list":{"year":"-/-","edit":"-/-","view":"-/-","perPage":"-/-","supplier":"-/-","download":"-/-","show":{"all":"-/-","mine":"-/-","label":"-/-"},"updatedBy":"-/-","status":{"done":"-/-","basic":"-/-","label":"-/-","pending":"-/-","extended":"-/-","completed":"-/-","initiated":"-/-","notification":"-/-","readyForSupplier":"-/-","readyForBackOffice":"-/-","supplierNotifications":"-/-","readyForContractManager":"-/-","contractManagerNotifications":"-/-"},"noContracts":"-/-","display":{"all":"-/-","label":"-/-"},"lastUpdated":"-/-","viewSupplier":"-/-","heading":{"header":"-/-"}},"alert":{"error":"-/-","saved":"-/-","noFile":"-/-","removed":"-/-","notFound":"-/-","emailSent":"-/-","illegalSize":"-/-","noSitesFound":"-/-","unsupportedType":"-/-","validationError":"-/-","emailAlreadySent":"-/-","noAccommodationsFound":"-/-"},"edit":{"form":{"add":"-/-","save":"-/-","link":"-/-","copy":"-/-","create":"-/-","remove":"-/-","confirm":"-/-","noTitle":"-/-","optional":"-/-","checkbox":"-/-","download":"-/-","emailSent":"-/-","brands":{"info":"-/-"},"email":{"review":"-/-","supplier":"-/-","backOffice":"-/-"},"images":{"remove":"-/-","initial":"-/-","confirm":"-/-","accepted":"-/-","unsupported":"-/-"},"upload":{"remove":"-/-","confirm":"-/-","initial":"-/-","accepted":"-/-"},"complete":{"review":"-/-","contract":"-/-"},"subHeader":{"notes":"-/-","brands":"-/-","accInfo":"-/-","accepted":"-/-","siteInfo":"-/-","discounts":"-/-","commission":"-/-","priceExtra":"-/-","arrivalRules":"-/-","allotmentRules":"-/-","arrivalDeparture":"-/-"},"placeholder":{"notes":"-/-","discounts":"-/-","priceExtra":"-/-","commission":"-/-","arrivalRules":"-/-","accInfo":{"site":"-/-","text":"-/-","name":"-/-"},"siteInfo":{"text":"-/-","name":"-/-"},"allotmentRules":"-/-","arrivalDeparture":"-/-"},"autoComplete":{"multi":"-/-","accInfo":"-/-","siteInfo":"-/-"},"header":{"heading":{"done":"-/-","basic":"-/-","extended":"-/-"}}},"progress":{"done":"-/-","basic":"-/-","extended":"-/-","defaultText":"-/-","header":{"heading":"-/-"},"subHeader":{"notes":"-/-","brands":"-/-","accInfo":"-/-","accepted":"-/-","siteInfo":"-/-","discounts":"-/-","commission":"-/-","arrivalRules":"-/-","allotmentRules":"-/-","priceExtra":{"price":"-/-","extra":"-/-"},"arrivalDeparture":"-/-"}}},"noChangesConfirm":"-/-"},"manageAllocationForm":{"heading":"-/-","buttons":{"reset":"-/-","submit":"-/-"},"control-message":{"on":"-/-","content":"-/-"}},"manageAllocationFilters":{"year":"-/-"},"subPages":{"home":{"subTitleRevenue":"-/-","subTitleBookings":"-/-","labelTotalRevenue":"-/-","labelTotalBookings":"-/-","labelPeriodRevenue":"-/-","labelPeriodBookings":"-/-"}},"manageAllocationRequest":{"units":"-/-","toggle":"-/-","heading":"-/-","form":{"body":"-/-","period":{"title":"-/-"},"labels":{"units":"-/-","release":"-/-"},"header":{"heading":"-/-"},"buttons":{"cancel":"-/-","accept":"-/-"}},"noContent":"-/-","table":{"type":"-/-","block":"-/-","period":"-/-","release":"-/-","deduction":"-/-","requestDate":"-/-"},"releaseDays":"-/-","type":{"request":"-/-","blocked":"-/-","freesale":"-/-","allotment":"-/-","guaranteed":"-/-"},"buttons":{"deny":"-/-","edit":"-/-","cancel":"-/-","accept":"-/-"},"dropdown":{"label":"-/-","denied":"-/-","pending":"-/-","approved":"-/-","modified":"-/-"},"headings":{"modified":"-/-","accepted":"-/-","declined":"-/-","requested":"-/-"}},"manageAllocationModalList":{"new":"-/-","date":"-/-","edit":"-/-","days":"-/-","released":"-/-","block":{"true":"-/-","false":"-/-","blocked":"-/-"},"buttons":{"new":"-/-","edit":"-/-","block":"-/-"},"releaseType":{"null":"-/-","request":"-/-","blocked":"-/-","freesale":"-/-"},"header":{"bookingsInPeriod":"-/-","noBookingsInPeriod":"-/-"}},"manageAllocationCalendar":{"retry":"-/-","error":"-/-","months":["-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-"],"header":{"howTo":"-/-","heading":"-/-"},"dropdown":{"full":"-/-","months":"-/-"}},"datePicker":{"predefinedLinks":{"today":"-/-","thisWeek":"-/-","lastYear":"-/-","thisYear":"-/-","lastWeek":"-/-","lastMonth":"-/-","yesterday":"-/-","thisMonth":"-/-"}},"manageAllocationFormAccept":{"header":"-/-","alert":{"to":"-/-","end":"-/-","from":"-/-","start":"-/-"},"content":{"end":"-/-","note":"-/-","comment":"-/-","start":{"add":"-/-","block":"-/-","submit":"-/-","request":"-/-","requestBlock":"-/-"}},"buttons":{"accept":"-/-","cancel":"-/-"}},"validator":{"validateDates":{"dateBefore":"-/-"}},"manageAllocationFormHeader":{"endDate":"-/-","startDate":"-/-","releaseBy":"-/-","releaseType":"-/-","afterRelease":"-/-","numberOfUnits":"-/-","allocationType":"-/-","releaseDaysDate":"-/-"},"statFilters":{"datepickers":{"booking":{"label":"-/-","heading":"-/-"},"arrival":{"label":"-/-","heading":"-/-"}}},"manageAllocationModalOverlayForm":{"info":"-/-","units":"-/-","status":"-/-","denied":"-/-","success":"-/-","blocked":"-/-","warning":"-/-","request":"-/-","released":"-/-","instruction":"-/-","labels":{"type":"-/-","units":"-/-","cancel":"-/-","period":"-/-","bookings":"-/-","releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-","arrivalRules":"-/-","releaseMethod":"-/-","noArrivalRules":"-/-","bookingsMaxCount":"-/-","arrivalTypes":{"label":"-/-","arrival":"-/-","departure":"-/-"},"arrivalRuleStayLength":"-/-","bookingsMaxCountToolTip":"-/-"},"release":{"date":"-/-","null":"-/-","days":"-/-"},"accept":{"block":"-/-","submit":"-/-","update":"-/-","request":"-/-","requestBlock":"-/-"},"pending":{"days":"-/-","units":"-/-","label":"-/-","requested":"-/-"},"buttons":{"reset":"-/-","block":"-/-","cancel":"-/-","update":"-/-","request":"-/-","requestBlock":"-/-"},"editable":{"type":"-/-","units":"-/-","releaseDate":"-/-","releaseType":"-/-","releaseDays":"-/-","information":{"default":"-/-"}},"requestPending":"-/-","requestMessage":"-/-","changesRequested":"-/-","instructionTrusted":"-/-","validator":{"days":{"set":"-/-","lower":"-/-"},"date":{"set":"-/-","lower":"-/-","before":"-/-","beforeEnd":"-/-"},"units":{"set":"-/-"}},"instructionNotTrusted":"-/-"},"manageAllocationCalendarWeekdays":{"sunday":"-/-","monday":"-/-","friday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"},"manageAllocationModalCalendarElement":{"units":"-/-","bookings":"-/-","request":{"days":"-/-","type":"-/-","units":"-/-","header":"-/-","deduct":"-/-","release":"-/-"}},"manageAllocationModalOverlay":{"header":{"heading":"-/-"}},"manageAllocationModalCalendarInfobox":{"header":{"heading":"-/-"}}}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = {"valid":true,"tips":{"hi":"Buongiorno","help":"Ha bisogno di aiuto?","more":"più","less":"meno","camping":"contatto Camping Vision IT","adminPage":{"edit":{"body":"Tutti gli utenti che hai creato possono essere modificati. È possibile cambiare tutto tranne la loro e-mail. Se un utente cambia email, dovrai creare un nuovo utente per invitare quell'e-mail al marketplace","title":"Modifica utente"},"block":{"body":"È possibile bloccare l'accesso al Marketplace per qualsiasi utente che crei. Questo viene fatto premendo modifica sull'utente, e quindi premendo il pulsante di blocco. In seguito è possibile dare nuovamente l'accesso ad un utente bloccato sbloccandoli dallo stesso luogo. Puoi anche eliminare utenti dalla schermata di modifica. Nota che questa azione è irreversibile!","title":"Blocca o elimina utenti"},"create":{"body":"È possibile creare un nuovo utente premendo il pulsante \"Nuovo utente\" nell'angolo in alto a destra. Al nuovo utente può essere concesso l'accesso a leggere e scrivere o solo a leggere sul mercato","title":"Crea un nuovo utente"}},"statPage":{"boxes":{"body":"Le quattro caselle in alto indicano fatturato e numero di prenotazioni. Grigio indica tutta la stagione, blu solo il periodo selezionato","title":"Le quattro caselle in alto"},"graph":{"body":"Il grafico a sinistra mostra le destinazioni più vendute. è possibile cliccare su un sito per selezionarlo, che mostrerà le migliori sistemazioni sul grafico a destra","title":"I grafici"},"filter":{"body":"È possibile cliccare sul periodo di prenotazione e sul filtro del periodo di arrivo per restringere o espandere il periodo in cui i dati vengono visualizzati","title":"Periodo di prenotazione / periodo di arrivo"}},"dashboardPage":{"add":{"body":"Si può facilmente aggiungere nuovi sistemazioni facendo clic sul pulsante ' Aggiungi sistemazioni ', questo vi porterà alla panoramica del calendario dove si è in grado di aggiungere più sistemazioni","title":"Aggiungi sistemazioni"},"graph":{"body":"Il grafico visualizza la disponibilità per tutti i suoi alloggi tra i suoi siti, potra' scegliere una sistemazione specifica dall'elenco a discesa","title":"Grafico disponibilità"},"filter":{"body":"È possibile filtrare l'elenco delle notifiche per sito o per alloggio per visualizzare solo le informazioni su questo specifico elemento","title":"Filtro notifiche"},"notifications":{"body":"L'elenco delle notifiche mostra informazioni urgenti sulle sistemazioni che vengono vendute o rilasciate. Se non abbiamo nessuna sistemazione, non abbiamo nulla da venderle.","title":"Mancano le vendite?"}},"bookingPage":{"search":{"body":"Puo cercare una prenotazione specifica nell'angolo verticale dell'elenco delle prenotazioni. Cercherà il numero di prenotazione","title":"Cerca il numero di prenotazione"},"filters":{"body":"È possibile filtrare l'elenco delle prenotazioni in base a sito, dominio, alloggio, paese di prenotazione, stato ecc.","title":"Filtri principali"},"sortList":{"body":"È possibile ordinare l'elenco di prenotazione cliccando sull'intestazione del soggetto e selezionare ulteriormente per più opzioni utilizzando il menu \"drop down\"","title":"Ordina la lista di prenotazioni"},"xlsError":{"body":"Alcune versioni di Excel vedranno il file XLS come danneggiato, ma cliccando al \"sì\" al messaggio di errore in Excel, si aprirà normalmente","title":"Problemi con l'apertura del XLS?"},"downloadList":{"body":"È possibile scaricare l'elenco filtrato sia come file (CSV) sia come (XLS)","title":"Scarica CSV o XLS"}},"allocationPage":{"sort":{"body":"È possibile ordinare gli alloggi sull'ultimo aggiornamento, nome e sito","title":"Ordina gli alloggi"},"site":{"body":"È possibile filtrare l'elenco e mostrare solo le sistemazioni per una destinazione specifico dal menu \"drop down\" in alto","title":"Filtra destinazione"},"update":{"body":"Fare clic sul pulsante Aggiorna per l'alloggio per cui si desidera gestire le allocazioni. Questo vi porterà al calendario di gestione allocazione in cui è possibile aggiungere, modificare e bloccare le allocazioni","title":"Aggiornare le allocazioni"},"updateBy":{"body":"L'aggiornamento per colonna mostra chi ha apportato le ultime modifiche di allocazione per tale alloggio, il segno ' @' indica che è fatto da un dipendente di Camping Vision","title":"Aggiorna per"}},"accountPage":{"password":{"body":"Al fine di modificare la password dell'account è necessario inserire la password corrente e quindi la nuova password desiderata che dovrebbe essere verificata nel campo di Re-Enter","title":"Modificare la password"},"activity":{"body":"L'elenco attività account Visualizza tutte le modifiche di allocazione effettuate dall'account negli ultimi 6 mesi, inclusa l'aggiunta dell'allocazione, la modifica dell'allocazione e la richiesta di modifiche alle allocazioni","title":"Attività del conto"},"information":{"body":"Le informazioni sul conto mostrano l'ID account e il tipo di account. Sei in grado di cambiare il tuo nome e cognome","title":"Informazioni sul conto"},"notifications":{"body":"È possibile scegliere se ricevere o no le notifiche tramite posta elettronica. Se si fa clic su modifica è possibile specificare ulteriormente i giorni in cui si desidera ricevere l'e-mail. Nota! Se selezioni quindicinale puoi selezionare solo un giorno","title":"Ricevere notifiche"}},"manageAllocationPage":{"error":"Impossibile recuperare i dati, si prega di riprovare. Se il problema persiste si prega di contattaci.","year":{"body":"Per impostazione predefinita, l'anno corrente è selezionato, ma è possibile selezionare fino a due anni in anticipo dal menu a discesa \"Scegli anno\"","title":"Seleziona anno"},"info":{"body":"Fare clic sul pulsante ' info ' sopra il calendario a destra per mostrare una guida su come utilizzare il calendario","title":"Come utilizzare il calendario?"},"modal":{"body":"Quando viene selezionato un punto, apparirà una finestra pop-up. Se non è stata aggiunta alcuna allocazione, verrà visualizzato un pulsante per aggiungere l'allocazione. Se le allocazioni sono già create nel periodo in cui sarai in grado di gestire tali allocazioni, fai clic su modifica, aggiungi o blocca. Queste opzioni variano da tipi di allocazione e se vengono rilasciate oppure no.","title":"La finestra pop-up"},"extra":{"body":"Quando si sceglie un periodo un giorno supplementare viene aggiunto alla fine per indicare che il periodo è basato su notti e il giorno successivo sarà quindi una data di partenza","title":"Giorno supplementare in periodo"},"select":{"body":"Utilizzare il calendario per scegliere un periodo per modificare o aggiungere allocazioni. Questa operazione viene eseguita facendo clic sulla data di inizio e poi facendo clic sulla data di fine. Verrà aperta una finestra popup in cui è possibile gestire le allocazioni per il periodo specificato.","title":"Seleziona periodo"},"display":{"body":"Facendo clic sul display a discesa appena sopra il calendario è possibile visualizzare sei mesi o l'intero anno solare","title":"Mostra l'anno intero o 6 mesi"},"overview":{"body":"Una panoramica delle allocazioni si trova appena sotto il calendario. Qui è possibile visualizzare i dettagli per le allocazioni. Il conteggio unità mostrerà il conteggio delle unità originariamente indicato senza prendere in considerazione le prenotazioni","title":"Panoramica dell'allocazione"},"accommodation":{"body":"È possibile passare ad un altro alloggio scrollando dall'alto verso il basso, le sistemazioni sono limitate al sito. Per scegliere un altro sito è necessario tornare alla pagina principale di allocazione e selezionarlo da lì","title":"Vuoi un altro alloggio?"},"alert":{"requestError":"Richiesta di aggiornamento non riuscita, riprova","requestAccept":"Richiesta accettata con successo","requestDenied":"Richiesta rifiutata correttamente","requestUnauthorized":"Richiesta di aggiornamento non autorizzata"}},"contractManagementPage":{"upload":{"body":"È possibile caricare i file come allegati alle diverse parti del contratto, i tipi di file accettati sono:'. xlsx,. xls,. doc,. docx,. ppt,. pptx,. txt,. pdf '","title":"Caricare file"},"expand":{"body":"È possibile comprimere o espandere la visualizzazione di avanzamento facendo clic sull'intestazione di avanzamento","title":"Espandi la vista di avanzamento"},"progress":{"body":"Nell'intestazione è possibile monitorare l'avanzamento del contratto in percentuale","title":"Tenere traccia dei progressi compiuti"},"indicator":{"body":"Le icone mostrano se le informazioni sono state memorizzate per una determinata parte o se ci sono notifiche a detta parte","title":"Icone indicatore di avanzamento"}}},"adminItem":{"id":"Id","edit":"Modifica","email":"Posta elettronica","status":"Stato","lastName":"Il cognome","firstName":"Nome"},"admin":{"list":{"id":"Id","edit":"Modifica","email":"Posta elettronica","status":"Stato","noUsers":"Nessun utente creato","content":"Crea utente","lastname":"Il cognome","firstname":"Nome","header":{"heading":"Elenco utenti"}},"alert":{"email":"L'email è già in uso","error":"Qualcosa è andato storto","updated":"Utente aggiornato con successo","deleted":"Utente eliminato correttamente","created":"Utente creato con successo","blocked":"Utente bloccato correttamente","password":"Password aggiornata con successo","unblocked":"L'utente ha sbloccato con successo","notifications":"Stato delle notifiche aggiornato con successo","wrongPassword":"Password errata"},"profile":{"and":"e","email":"Posta elettronica","weekly":"su base settimanale","notice":"Attualmente Riceve le notifiche:","receive":"Ricevere notifiche","language":"Lingua","noNotice":"Al momento NON riceve notifiche","everyday":"ogni giorno","fullName":"Nome completo","fortnightly":"su base quindicinale","header":{"heading":"Informazioni sull'account"},"notifications":{"edit":"Modificare","weekly":"Settimanale","cancel":"Annulla","update":"Aggiornamento","fortnightly":"Quindicinale","days":{"friday":"Venerdì","monday":"Lunedì","sunday":"Domenica","tuesday":"Martedì","saturday":"Sabato","thursday":"Giovedì","wednesday":"Mercoledì"},"heading":{"header":"Impostazione delle notifiche di modifica"}}},"form":{"create":"Utente creato con successo","edit":{"edit":"Utente aggiornato con successo","block":"Utente bloccato correttamente","delete":"Utente eliminato correttamente","unblock":"L'utente ha sbloccato con successo"},"error":{"edit":"Qualcosa è andato storto, si prega di riprovare più tardi.","email":"L'indirizzo email è già in uso.","error":"Qualcosa è andato storto, si prega di riprovare più tardi."}},"heading":{"header":"Pannello amministratore"},"edit":{"form":{"info":"Modificare l'utente e premere aggiorna per salvare le modifiche","roles":"Ruoli","lastname":"Il cognome","language":"Lingua","firstname":"Nome","button":{"submit":"Crea utente"},"notifications":"Ricevere notifiche","buttons":{"block":"Blocco","update":"Aggiornamento","delete":"Elimina","unblock":"Sbloccare"},"warning":{"blocked":"Nota bene! -Questo utente è attualmente bloccato","inactive":"Nota bene! -Questo utente è attualmente inattivo"},"validator":{"lastname":"* Il cognome è obbligatorio","firstname":"* Il nome è obbligatorio"}},"header":{"heading":"Modifica utente"},"accept":{"header":{"block":"Blocca utente","update":"Aggiorna utente","delete":"Cancella utente","unblock":"Sblocca utente"},"content":{"block":"Sei sicuro di voler bloccare l'utente?","delete":"Sei sicuro di voler eliminare l'utente?","update":"Sei sicuro di voler aggiornare l'utente?","unblock":"Sei sicuro di voler sbloccare l'utente?"},"buttons":{"accept":"Accettare","cancel":"Annulla"}}},"create":{"form":{"tip":"<strong>Ruoli:</strong> Impostare un ruolo per l'utente per fornire il livello di accesso.","roles":"Ruoli","email":"Posta elettronica","language":"Lingua","lastname":"Il cognome","firstname":"Nome","button":{"submit":"Crea utente"},"validator":{"email":"* È richiesta una posta elettronica valida","lastname":"* Il cognome è obbligatorio","firstname":"* Il nome è obbligatorio"}},"button":{"submit":"Crea utente"},"accept":{"header":"Crea utente","content":"Sei sicuro di voler creare questo utente?","buttons":{"cancel":"Annulla","accept":"Accettare"}},"header":{"heading":"Crea utente"}}},"signIn":{"button":"Accedi","heading":"Benvenuti in CampingVision Marketplace","description":"Accedi e inizia a vendere sul mercato online più grande d'Europa specializzato in vacanze in campeggio.","logoutNotice":"Sei stato disconnesso con successo","invalidNotice":"Si prega di accedere di nuovo per confermare la vostra identità","pass":{"placeholder":"Password","errors":{"required":"È necessario fornire una password valida"}},"inactivityNotice":"Sei stato disconnesso a causa di inattività","email":{"placeholder":"Posta elettronica","errors":{"email":"È necessario fornire una e-mail valida","required":"È necessario fornire un'e-mail"}},"messages":{"mismatch":"Il nome utente e la password non corrispondono","unexpected":"Si è verificato un errore imprevisto. Il nostro team di sviluppo è stato avvisato. Riprova più tardi"},"forgotPasswordLink":"Hai dimenticato la password?"},"booking":{"button":"Attiva account","heading":"Prenotazioni","filterText":"Ricerca...","dateTypes":["Data di prenotazione","Data di arrivo"],"placeholder":"Ricerca...","description":"Elenco di tutte le prenotazioni per un determinato periodo. Il periodo può filtrare in base alla data di arrivo o alla data di prenotazione.","tableFields":{"#":"#","reset":"Cancella ordinamento","status":"Stato","domain":"Dominio","duration":"Durata","siteName":"Campeggio","bookingRef":"CV No.","bookingDate":"Data di prenotazione","arrivalDate":"Arrivo","supplierRef":"n. di prenotazione","supplierName":"Nome del fornitore","customerName":"Cliente","departureDate":"Partenza","accommodation":"Alloggio"},"messages":{"error":"Qualcosa è andato storto, si prega di riprovare più tardi.","expired":"La sua autorizzazione è scaduta"},"filterOptions":{"site":"Campeggio","option":"Scegliere..","domain":"Scegli il dominio...","default":"Filtra per","bookingAgent":"Agente di prenotazione","accommodation":"Alloggio","bookingCountry":"Paese di prenotazione"}},"account":{"form":{"id":"Id","email":"Posta elettronica","lastName":"Il cognome","firstName":"Nome","buttons":{"reset":"Reimpostare","update":"Aggiornamento"},"heading":{"header":"Modificare le informazioni del conto"},"accountType":{"label":"Tipo di conto","admin":{"true":"Amministrazione","false":"Base"}},"validator":{"required":"Questo campo è obbligatorio"},"placeholder":{"lastName":"Inserisci il cognome","firstName":"Inserisci il nome"}},"activity":{"site":"Campeggio","date":"Data","limit":"Mostra righe","type":{"label":"Tipo di attività","request":"Richiesta","allocation":"Modificare"},"status":{"label":"Azione","RELEASED":"Allocazione rilasciata","USER_EDIT":"Modifica allocazione","USER_INSERT":"Aggiungi allocazione"},"header":{"months":"(Ultimi 6 mesi)","heading":"Attività del conto"},"accommodation":"Alloggio"},"password":{"password":"Password corrente","rePassword":"Digitare nuovamente la password","newPassword":"Nuova password","buttons":{"reset":"Reimpostare","update":"Aggiornamento"},"heading":{"header":"Modificare la password"},"validator":{"mismatch":"Le due password non corrispondono","password":"Minimo 8 caratteri/maiuscolo e minuscolo/numero"},"placeholder":{"password":"••••••••"}}},"statList":{"heading":"Entrate","predicate":"Filtra per","backButton":"Indietro"},"bookingItem":{"site":"Campeggio","status":"Stato","domain":"Dominio","duration":"Durata","bookingRef":"Numero di riferimento del Campeggio","arrivalDate":"Arrivo","supplierRef":"Numero Rif.","bookingDate":"Data di prenotazione","supplierName":"Nome del fornitore","customerName":"Cliente","departureDate":"Partenza","accommodation":"Alloggio"},"notFound":{"heading":"404-non trovato"},"introduction":{"body":"Ora siamo stati informati del tuo interesse a procedere con la vendita attraverso i canali di vendita di Camping Vision. Ora proseguiremo con la procedura di vendita e vi contatteremo il prima possibile","error":"Sembra che ci sia stato un errore durante il tentativo di elaborare la richiesta, si prega di riprovare più tardi. Se il problema persiste non esitate a contattarci","warning":"Siamo molto impegnati e le promettiamo di ricontattarla a breve.","noContent":"Il simbolo specificato non è stato trovato, è stato fornito il simbolo corretto nell'URL?","footer":{"title":"Hai qualche domanda?","contact":{"tel":"Tel: +31 (0)416 849 853","city":"1212 Grand-Lancy","title":"Camping Vision","email":"info@campingvision.com","street":"Rue du Bachet 14","country":"Svizzera","address":"Ufficio Ginevra"}},"header":{"error":"Siamo molto dispiaciuti:' (","warning":"Grazie ancora:-)","heading":"Grazie per il vostro interesse!","noContent":"Ops..."}},"statSites":{"heading":"Campeggi","dropdown":{"label":"Filtra per"},"noContent":{"error":"Impossibile recuperare i dati","missing":"Nessun dato trovato"},"predicate":{"revenue":"Entrate","bookings":"Prenotazioni"},"alternativeHeading":"Top 10 siti"},"bookingList":{"order":"Ordine","error":"Si è verificato un errore imprevisto","title":"Cerca il numero di prenotazione, il numero di riferimento o il nome del cliente","search":"Ricerca No. prenotazione","heading":"Nessuna prenotazione corrispondente | 1 prenotazione trovata | {count} prenotazioni trovate","perPage":"Mostra righe","orderBy":"Tipo di ordinamento","noContent":"Nessuna prenotazione trovata","xslTooltip":"Se Excel Visualizza l'errore, fare clic su' Sì' per aprire.","display":{"all":"Tutti","label":"Opzione di visualizzazione","current":"Corrente","historical":"Storico"},"placeholder":"cercare","download":{"xls":"Lista di download (XLS)","csv":"Elenco di download (CSV)"},"orderFields":{"asc":"Ascendente","desc":"Discendente"}},"instruction":{"dismiss":"Non mostrare più","defaultHeader":"Come utilizzare","contract":{"body":"Leggere attentamente ogni parte del contratto per assicurarsi che tutto sia corretto. Se riscontri discrepanze, scrivilo nel campo delle notifiche espandendo la casella di notifica nella parte inferiore della pagina. Se una parte viene convalidata e corretta, fare clic sul pulsante 'Accetta parte' in basso.<br/> Per navigare tra le diverse parti, fare clic sull'icona quadrata nel modulo di avanzamento appena sotto o utilizzare le frecce nella parte inferiore della pagina. <br/><br/> Ricordati di salvare le modifiche."},"contractList":{"body":"Dall'elenco sottostante puo vedere una panoramica dei vostri contratti. Una volta che un nuovo contratto è pronto per la revisione si sarà in grado di fare clic su di esso e andare alla pagina di revisione. Una volta che ogni parte è stata esaminata un accettato, sarà possibile scaricare una copia PDF del contratto.","header":"Trova i suoi contratti qui sotto"}},"topMenu":{"right":{"admin":"Amministratore","logout":"Disconnettersi","account":"Conto"},"left":{"welcome":"Benvenuto"}},"allocationItem":{"site":"Camping","supplier":"Fornitore","updatedAt":"Ultimo aggiornamento","updatedBy":"Aggiornato da"},"activateUser":{"button":"Attiva account","heading":"Attiva il tuo account","description":"Hai richiesto di attivare il tuo account. Inserisci la password desiderata qui sotto","messages":{"token":"Impossibile elaborare la richiesta. Riprova più tardi.","success":"L'account è stato attivato correttamente. Sarete reindirizzati alla pagina di login a breve.","mismatch":"La password deve essere lunga almeno 8 caratteri e contenere almeno 1 lettera maiuscola e almeno 1 numero.","unexpected":"Si è verificato un errore imprevisto. Il nostro team di sviluppo è stato informato. Riprova più tardi"},"pass":{"placeholder":"Nuova password","errors":{"required":"È necessario fornire una password."}},"passCheck":{"placeholder":"Reinserire la password","errors":{"required":"È necessario reinserire la password","mismatch":"Questo non corrisponde alla password precedente"}}},"contract":{"form":{"email":"Inviare posta elettronica <<pronto per fornitore>>","alert":"Fornitore non creato nel Marketplace","accept":"Accettare e completare il contratto","complete":"Contratto pronto per il fornitore","sites":{"view":"Mostra","city":"Città","email":"Posta elettronica","phone":"Telefono","rating":"Voto","address":"Indirizzo","country":"Paese","zipCode":"CAP","website":"Sito web","noContent":"Nessun sito trovato per questo contratto","header":{"heading":"Campeggi"},"facilities":{"size":"Dimensioni (mq)","number":"Numero","header":"Strutture","endDate":"Data di fine","distance":"Distanza","startDate":"Data di inizio","dataHeader":"Informazioni estese"}},"acceptPart":"Accettare ","sendAccept":"Accetta contratto","extras":{"rule":"Regola","sell":"Vendere","ageTo":"Età per","price":"Prezzo","person":"Persona","noData":"n/a","endDate":"Data di fine","ageFrom":"Età da","arrival":"Arrivo","per":{"stay":"Per soggiorno","week":"Per settimana","hour":"Per ora","night":"Per notte","piece":"Per pezzo","person":"Per persona","personNight":"Per persona, a notte","accommodation":"Per sistemazione"},"netPrice":"Prezzo netto","startDate":"Data di inizio","departure":"Partenza","noContent":"Nessun supplemento trovato per questo contratto","commission":"Commissione","description":"Descrizione","type":{"person":"Persona","optional":"Opzionale","inclusive":"Compreso","mandatory":"Obbligatorio","information":"Informazioni"},"payment":{"ignore":"n/a","arrival":"Pagamento all'arrivo","booking":"Pagamento alla prenotazione","bookingArrival":"Prenotato e pagato all'arrivo"},"header":{"heading":"Supplemento"}},"partAccepted":"Accettato","notes":{"toggle":"Notifiche","placeholder":"Inserisci le notifiche qui...","header":{"heading":"Note"},"sendBeforeLeave":"Desideri inviare una notifica e-mail al tuo gestore dei contratti sui nuovi messaggi?","sendEmailToContractManager":"Vuoi inviare una notifica e-mail al responsabile del contratto su questo messaggio?"},"control":{"save":"Salvare","cancel":"Annulla accettazione","accept":"Accetta una parte","accepted":"Parte è stata accettata"},"prices":{"price":"Prezzo","endDate":"Data di fine","noContent":"Nessun gruppo di prezzi trovato per questo contratto","startDate":"Data di inizio","commission":"Commissione","header":{"heading":"Prezzi e commissioni"},"setting":{"pricePr":{"unit":"Per unità","person":"Persona"},"grossOrNet":{"net":"Prezzo netto","gross":"Prezzo lordo"},"priceType":{"singleDay":"Giorno singolo"}}},"progress":{"label":"Informazioni contrattuali","part":{"terms":"Condizioni di vendita","sites":"Campeggi","extras":"Supplemento","prices":"Gruppi di prezzi","discounts":"Sconti","allocations":"Indennità","arrivalRules":"Regole di arrivo","supplierInfo":"Info fornitore","accommodations":"Alloggi","cancellationRules":"Regole di annullamento"},"header":{"heading":"Avanzamento del contratto"}},"unknownProduct":"Tipo di prodotto sconosciuto","discounts":{"name":"Nome","types":"Tipo/i","noDate":"n/a","endDate":"Data di fine","startDate":"Data di inizio","noContent":"Nessun sconto trovato per questo contratto","header":{"heading":"Sconti"},"arrivalDeparture":"Arrivo/Partenza"},"missingContract":"Errore nel contratto di caricamento","message":{"initiated":"Il contratto è attualmente in sospeso..."},"arrivalRules":{"days":"giorni","arrival":"Arrivo","endDate":"Data di fine","noContent":"Nessuna regola di arrivo trovata per questo contratto","minRental":"noleggio minimo","maxRental":"noleggio massimo","departure":"Partenza","startDate":"Data di inizio","type":{"label":"Tipo","arrival":"Arrivo","departure":"Partenza"},"header":{"heading":"Regole di arrivo"},"weekdays":{"friday":"Ven","monday":"Lun","sunday":"Dom","tuesday":"Mar","thursday":"Gio","saturday":"Sab","wednesday":"Mer"}},"allocations":{"units":"Unità","noData":"n/a","endDate":"Data di fine","startDate":"Data di inizio","noContent":"Nessuna allocazione trovata per questo contratto","type":{"label":"Tipo","BLOCKED":"Bloccato","REQUEST":"Richiesta","FREESALE":"Free sale","GUARANTEE":"Garanzia","ALLOTMENT":"Contingente"},"releaseDate":"Data di rilascio","releaseDays":"Giorni di rilascio","releaseType":"Tipo di rilascio","header":{"heading":"Allocazioni"}},"accommodations":{"view":"vista","noData":"n/a","category":"Categoria","maxAdults":"Max. Adulti","noContent":"Nessuna sistemazione trovata per questo contratto","maxPersons":"Max. persone","minFullPay":"Pagamento totale min.","childrenAges":"età","header":{"heading":"Alloggi"},"subGroups":{"header":"Strutture"},"childrenAgesInfo":"Ad esempio. 14, 2 (Bambini max di età 14 e 2 anni)","childOutsideAllowed":"1. bambino al di fuori di max. Consentito","childOutsideAllowedInfo":"Ad esempio. 2 (un bambino al di sotto dei 2 anni è consentito al di fuori del calcolo totale del numero di persone)"},"terms":{"heading":{"header":"Condizioni di vendita"}},"cancellationRules":{"noShow":"Assente","heading":"Regole di annullamento","labels":{"days":"Giorni prima dell'arrivo","percent":"Pagamento addebitato"}},"supplierInfo":{"bankInfo":{"bic":"BIC","info":"Info","name":"Nome","bank":"Banca","iban":"IBAN","email":"Posta elettronica","terms":"Termini","method":"Metodo di pagamento","heading":"Informazioni bancarie","account":"Conto","bankCurrency":"Valuta bancaria","priceCurrency":"Prezzo valuta"},"contactInfo":{"name":"Nome","city":"Città","email":"Posta elettronica","phone":"Telefono","heading":"Informazioni di contatto","website":"sito web","country":"Paese","address":"Indirizzo","zipCode":"CAP"},"bookingInfo":{"heading":"Informazioni sulla prenotazione","amendEmail":"Modificare l'e-mail","bookingPhone":"Prenotazioni telefono di contatto","bookingEmail":"E-mail di prenotazione","requestEmail":"Richiedi e-mail","bookingPerson":"Persona di contatto per prenotazioni","complaintPhone":"Indirizzo email per reclami","complaintEmail":"E-mail di reclamo","complaintPerson":"persona di contatto per reclami","cancellationEmail":"E-mail di annullamento","confirmationEmail":"E-mail di conferma"}}},"alert":{"saved":"Contratto salvato con successo","error":"Qualcosa è andato storto","noFile":"File non trovato","removed":"File rimosso correttamente","supplier":"Fornitore non registrato nel Marketplace","notFound":"Contratto non trovato","emailSent":"Email inviata","completed":"Il contratto è stato completato","illegalSize":"L'immagine supera il limite di 3500x2500 px","unsupportedType":"Tipo di file non valido","emailAlreadySent":"L'e-mail è già stata inviata"}},"resetPassword":{"button":"Reimposta password","heading":"Reimposta password","description":"Hai richiesto di reimpostare la password. Inserisci la password desiderata qui sotto","messages":{"token":"Impossibile elaborare la richiesta. Riprova più tardi.","success":"La password è stata reimpostata. Sarete reindirizzati alla pagina di login a breve.","mismatch":"La password deve avere una lunghezza di almeno 8 caratteri e contenere almeno 1 lettera maiuscola e almeno 1 numero.","unexpected":"Si è verificato un errore imprevisto. Il nostro team di sviluppo è stato informato. Riprova più tardi"},"pass":{"placeholder":"Nuova password","errors":{"required":"È necessario fornire una password"}},"passCheck":{"placeholder":"Reinserire la password","errors":{"mismatch":"Questo non corrisponde alla password precedente","required":"È necessario reinserire la password"}}},"allocationList":{"order":"ordinazione","orderBy":"Ordina per tipo","perPage":"Mostra righe","heading":"Gestire le allocazioni","button":{"update":"Aggiornare"},"messages":{"error":"Errore imprevisto","noContent":"Nessuna allocazione trovata","unauthorized":"Azione non consentita dalle autorizzazioni utente"},"orderFields":{"asc":"Ascendente","desc":"Discendente"},"tableFields":{"site":"Camping ","name":"Unita di sistemazione","supplier":"Fornitore","updatedBy":"Aggiornato da","updatedAt":"Ultimo aggiornamento","pendingRequests":"Richieste in sospeso"}},"dashboard":{"graph":{"label":"Grafico qui","footer":"Il grafico mostra la disponibilità per i tuoi alloggi"},"tricks":{"click":"Clicca qui","welcome":"Benvenuto","statistics":{"link":"/dashboard/statistiche","message":"È possibile ottenere una rapida panoramica delle vendite dalla pagina delle statistiche."},"allocation":{"link":"/dashboard/allocazione","message":"Sapevi di poter gestire le allocazioni tramite la pagina di allocazione?"}},"suppliers":{"label":"Seleziona fornitore"},"date":{"days":{"friday":"Venerdì","monday":"Lunedì","sunday":"Domenica","tuesday":"Martedì","thursday":"Giovedì","saturday":"Sabato","wednesday":"Mercoledì"}},"availability":{"all":"Tutte le sistemazioni","select":"Seleziona sistemazione","request":"Su richiesta","blocked":"Esaurito / bloccato","overview":"Panoramica della disponibilità %","noContent":"Nessun dato trovato","available":"disponibile"},"notifications":{"limit":"Mostra righe","noContent":"Nessuna notifica","list":{"site":"Campeggio","link":"Aggiungere contingente","date":"Data","dismiss":"Scartare","status":{"stay":"Lunghezza del soggiorno inadeguata","label":"Stato","arrival":"Arrivo inadeguato","soldOut":"Esaurito","released":"Data di rilascio raggiunta"},"contractLink":"Vai al calendario","header":{"count":"Nessuna notifica | 1 notifica trovata | {quantita }Trovate notifiche di conteggio","heading":"Ti stai perdendo le opportunità di vendita?","contractHeading":"Panoramica delle notifiche"},"accommodation":"sistemazione"},"filters":{"sites":{"all":"Tutti campeggi","label":"Selezionare campeggio"},"predicate":{"all":"Qualsiasi stato","stay":"Lunghezza del soggiorno inadeguata","label":"Selezionare lo stato","arrival":"Arrivo inadeguato","soldOut":"esaurito","released":"Data di rilascio raggiunta"},"accommodations":{"all":"Tutte le sistemazioni","label":"Seleziona alloggio"}}},"alert":{"dismiss":{"error":"Qualcosa è andato storto","success":"La notifica e' stata eliminata","noContent":"Impossibile trovare la notifica"}}},"statInventory":{"heading":"inventario","dropdown":{"label":"Filtra per"},"noContent":{"error":"Impossibile recuperare i dati","missing":"Nessun dato trovato"},"predicate":{"revenue":"entrate","bookings":"Prenotazioni"},"alternativeHeading":"Il top 10 del inventario"},"forgotPassword":{"button":"Richiesta di reimpostazione","heading":"Hai dimenticato la password?","signInLink":"Torna al login","description":"Inserisci la tua email per richiedere una reimpostazione della password.","messages":{"noexist":"L'e-mail non esiste","success":"È stata inviata un'e-mail con un link per reimpostare la password","unexpected":"Si è verificato un errore imprevisto. Il nostro team di sviluppo è stato informato. Riprova più tardi"},"email":{"placeholder":"Posta elettronica","errors":{"email":"È necessario fornire un indirizzo e-mail valido","required":"È necessario fornire un'e-mail"}}},"bookingFilters":{"site":{"all":"Tutti i campeggi","label":"Campeggio"},"brand":{"all":"Tutte le marche","label":"Marca"},"status":{"all":"Tutti i tipi","label":"Stato","types":{"booked":"Prenotato","pending":"In sospeso","unknown":"Nessuno stato","request":"Richiesta","rejected":"Rifiutato","cancelled":"Annullato","request-cancel":"Richiesta di annullamento"}},"domain":{"all":"Tutti i domini","label":"Dominio"},"country":{"all":"Tutti i paesi","label":"Paese di prenotazione"},"supplier":{"all":"Tutti i fornitori","label":"fornitore"},"accommodation":{"all":"Tutte le sistemazioni","label":"Alloggi"},"arrivalPeriod":{"label":"Periodo di arrivo","datepicker":{"heading":"Seleziona un periodo di arrivo"}},"bookingPeriod":{"label":"Periodo di prenotazione","datepicker":{"heading":"Seleziona un periodo di prenotazione"}}},"navigation-menu":{"language":"Seleziona lingua","items":{"stats":"Statistiche","booking":"Prenotazione","supplier":"Fornitore","contract":"Contratto","dashboard":"Pannello","allocation":"Allocazione","productType":"Tipo di prodotto","products":{"Hotel":"Albergo","Shuttle":"Navetta","Camping":"Campeggio","Badeland":"Parco acquatico","Skiferie":"sci","Krydstogt":"Crociera","Disneyland":"Disneyland","Feriebolig":"Proprietà"}}},"manageAllocationList":{"error":"Impossibile caricare l'elenco di allocazione","retry":"Riprova","header":"Panoramica dell'allocazione","list":{"to":"A","new":"Nuova allocazione","type":"Tipo","from":"Da","edit":"Modifica allocazione","block":"Blocca per il periodo","units":"Unità","release":"Data/giorni di rilascio","released":"Rilasciato nel periodo","updatedBy":"Aggiornato da","updatedAt":"Aggiornato alle","releaseDate":"Data di rilascio","releaseDays":"Giorni di rilascio","releaseType":"Tipo di rilascio"},"noAllocations":"Nessuna allocazione trovata!"},"manageAllocationPage":{"error":"Si è verificato un errore, provare più tardi","mobile":"Questo contenuto può essere visualizzato solo su un dispositivo desktop.","request":{"cancel":{"unauth":"L'utente non è autorizzato ad annullare le richieste","success":"Richiesta annullata con successo","failure":"Si è verificato un errore, provare più tardi","noContent":"L'ID richiesta non corrisponde ad alcun ID esistente"},"accept":{"success":"Richiesta accettata con successo","failure":"Si è verificato un errore, provare più tardi"},"modify":{"failure":"Si è verificato un errore, provare più tardi","success":"Richiesta modificata e accettata correttamente"},"decline":{"failure":"Si è verificato un errore, provare più tardi","success":"Richiesta rifiutata correttamente"}}},"manageAllocationModal":{"info":"Fare clic sul pulsante Aggiungi sopra per iniziare ad aggiungere allocazioni per il periodo scelto. <br/>NOT! L'ultimo giorno del periodo NON è incluso","dash":"-","error":"Si è verificato un problema, riprova più tardi","period":"Periodo","update":"L'allocazione è stata aggiornata correttamente","loading":"Caricamento delle allocazioni","success":"L' allocazione e' stata aggiunta correttamente","request":"La richiesta di allocazione è stata inviata correttamente","blocked":"L'allocazione è stata bloccata correttamente","form":{"days":"Giorni","date":"##/##/####","type":{"null":"n/a","blocked":"Bloccato","request":"richiesta","freesale":"Vendita libera","allotment":"contingente"},"units":{"null":"n/a","allotment":"No. di unità","notAllotment":"Solo per contingente"},"buttons":{"add":"Aggiungere","create":"Aggiungere allocazioni","submit":"Invia modifiche","cancel":"Annulla"},"releaseType":{"null":"n/a","request":"Riquiesta","blocked":"Bloccato","freesale":"Vendita gratuita","selectType":"Seleziona tipo"},"releaseMethod":{"null":"n/a","date":"Data ","days":"Giorni"}},"allocations":"Allocazioni trovate","buttons":{"add":"Aggiungere"},"unauthorized":"non autorizzato","noAllocations":"Nessuna allocazione trovata","overlaySuccess":"L'allocazione è stata aggiornata correttamente.","header":{"heading":"Gestire le allocazioni"}},"statNumber":{"body":{"noDataFound":"Nessun dato trovato","failedToFetchData":"Impossibile recuperare i dati"}},"contractList":{"heading":{"header":"Contratti"},"overview":{"error":"Impossibile caricare i dati","download":"scaricare","noContracts":"Nessun contratto trovato","heading":{"header":"Panoramica del contratto"},"status":{"initiated":"Il contratto è attualmente in sospeso...","readyForSupplier":"Contratto pronto per la revisione"}},"history":{"heading":{"header":"Storia"}}},"contractNotes":{"messages":{"goTo":"Vai al rif.","wrote":"-Scritto","supplier":"Fornitore","internal":"Messaggio interno","sendEmail":"Si desidera inviare un'e-mail di avviso di notifica?","noContent":"Nessuna notifica","campingVision":"Camping Vision","supplierEmail":"Invia e-mail di avviso di notifica al fornitore","backOfficeEmail":"Inviare un messaggio di posta elettronica di avviso di notifica al back office","contractManagerEmail":"Inviare un messaggio di posta elettronica di avviso di notifica al responsabile del contratto"},"header":{"heading":"Notifiche","messages":"Messaggio(i) senza risposta"},"control":{"internal":"Inviare come messaggio interno?","reference":"Referenza","placeholder":"Digitare il messaggio..."}},"manageAllocationFormRow":{"days":"Giorni","dateFormat":"GG/MM/AAAA","dropDown":{"date":"Data","days":"Giorni","request":"Richiesta","blocked":"Bloccato","freeSale":"Free sale","allotment":"Contingente","guarantee":"Garentire","selectType":"Selezionare un tipo","chooseType":"Scegli il testo"}},"contractManagement":{"list":{"year":"Anno","edit":"Modificare","view":"Visualizza contratto","perPage":"Per ","supplier":"Fornitore","download":"Scaricare","show":{"all":"Tutti i contratti","mine":"Solo i miei contratti","label":"Mostrare "},"updatedBy":"Aggiornato da","status":{"done":"Fatto","basic":"Contratto di base aperto","label":"Stato","pending":"In attesa del fornitore","extended":"Contratto esteso aperto","completed":"Completato","initiated":"Contratto aperto","notification":"Notifica","readyForSupplier":"In attesa del fornitore","readyForBackOffice":"In attesa di back office","supplierNotifications":"Note dal fornitore","readyForContractManager":"In attesa del responsabile del contratto","contractManagerNotifications":"Note dal responsabile del contratto"},"noContracts":"Nessun contratto corrispondeva ai tuoi criteri","display":{"all":"Qualsiasi stato","label":"Stato"},"lastUpdated":"Ultimo aggiornamento","viewSupplier":"Visualizzare lo stato di avanzamento del fornitore","heading":{"header":"Il stato del contratto"}},"alert":{"error":"Qualcosa è andato storto","saved":"Contratto salvato con successo","noFile":"File non trovato","removed":"File rimosso correttamente","notFound":"Contratto non trovato","emailSent":"Email inviata","illegalSize":"L'immagine supera il limite di 3500x2500 px","noSitesFound":"Nessun sito trovato","unsupportedType":"Tipo di file non valido","validationError":"Modulo incompleto","emailAlreadySent":"L'e-mail è già stata inviata","noAccommodationsFound":"Nessuna sistemazione trovata"},"edit":{"form":{"add":"Aggiungere","save":"Salva modulo","link":"legame","copy":"Copiare","create":"Creare","remove":"Rimuovi file","confirm":"Sei sicuro di voler eliminare il file?","noTitle":"Senza titolo","optional":"Facoltativo","checkbox":"Mostra nel contratto","download":"Scaricare","emailSent":"Email inviata","brands":{"info":"Selezionare i marchi a cui applicare il contratto:"},"email":{"review":"Invia e-mail pronto per la revisione","supplier":"Invia pronto per l'e-mail del fornitore","backOffice":"Inviare un messaggio di posta elettronica al back office"},"images":{"remove":"Togliere","initial":"Fare clic o trascinare le immagini qui","confirm":"Confermare","accepted":"Tipi di file accettati:'. jpg,. jpeg,. bmp,. png '","unsupported":"Caricamento delle immagini non supportato dal browser"},"upload":{"remove":"Togliere","confirm":"confermare","initial":"Fare clic o trascinare i file qui","accepted":"Tipi di file accettati: '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'"},"complete":{"review":"Contratto pronto per la revisione?","contract":"Parte di base/estesa completata"},"subHeader":{"notes":"Note","brands":"Marche","accInfo":"Alloggio (i)","accepted":"Accettato","siteInfo":"Sito (i)","discounts":"Sconti","commission":"Commissione","priceExtra":"Prezzi ed extra","arrivalRules":"Regole di arrivo","allotmentRules":"Allocazione e regole","arrivalDeparture":"Arrivo/partenza"},"placeholder":{"notes":"Inserire informazioni aggiuntive qui ad esempio. esperienza personale, ecc.","discounts":"Inserirele informazioni di sconto qui...","priceExtra":"Inserire il listino prezzi per i tipi di alloggio e gli extra...","commission":"Inserire i tassi di Commissione...","arrivalRules":"Inserire le regole di arrivo...","accInfo":{"site":"Scegliere il/i sito/i","text":"Inserire la descrizione dell'alloggio qui...","name":"Inserire/Scegliere il nome dell'alloggio"},"siteInfo":{"text":"Inserire la descrizione del sito qui...","name":"Inserire/Scegliere il nome del sito"},"allotmentRules":"Inserire le date per il contingente, il tipo di alloggio e le regole per tale contingente...","arrivalDeparture":"Inserire le informazioni di arrivo e partenza insieme al noleggio minimo qui..."},"autoComplete":{"multi":"Allegare al sito...","accInfo":"Inserire il nome dell'alloggio qui...","siteInfo":"Inserire qui il nome del sito..."},"header":{"heading":{"done":"Accettati dal fornitore","basic":"Informazioni di base","extended":"Informazioni estese"}}},"progress":{"done":"Accettati dal fornitore","basic":"Informazioni di base","extended":"Informazioni estese","defaultText":"Nessuna modifica","header":{"heading":"Panoramica del progresso del contratto"},"subHeader":{"notes":"Note","brands":"Marche","accInfo":"Alloggio (i)","accepted":"Accettato","siteInfo":"Sito (i)","discounts":"Sconti","commission":"Commissione","arrivalRules":"Arrivo","allotmentRules":"Allocazione","priceExtra":{"price":"Prezzi","extra":"Extra ?"},"arrivalDeparture":"Arrivo/partenza"}}},"noChangesConfirm":"Questo aggiungerà 'Nessuna modifica' a questa parte, procedere?"},"manageAllocationForm":{"heading":"Aggiungere contingente","buttons":{"reset":"Reimposta modulo","submit":"Invia modifiche"},"control-message":{"on":"su","content":"NOTA <strong>:</strong> Si sta aggiungendo un contingente per:"}},"manageAllocationFilters":{"year":"Scegliere l' anno"},"subPages":{"home":{"subTitleRevenue":"EUR","subTitleBookings":"Pezzi","labelTotalRevenue":"Ricavi totali","labelTotalBookings":"Totale prenotazioni","labelPeriodRevenue":"Periodo Ricavi","labelPeriodBookings":"Periodo di Prenotazioni"}},"manageAllocationRequest":{"units":"Unità","toggle":"Richieste in sospeso","heading":"Panoramica delle richieste","form":{"body":"È possibile modificare la richiesta dal modulo sottostante. Fare clic su Accetto per accettare la richiesta con le modifiche applicate","period":{"title":"Periodo"},"labels":{"units":"Unità","release":"Data/giorni di scadenza"},"header":{"heading":"Modifica richiesta"},"buttons":{"cancel":"Cancellare","accept":"Accettare"}},"noContent":"Nessuna richiesta trovata","table":{"type":"Cambia tipo","block":"Richiesta blocco","period":"Periodo","release":"Modifica della scadenza","deduction":"Deduzione del contingente","requestDate":"Data di richiesta"},"releaseDays":"Giorni","type":{"request":"richiesta","blocked":"Bloccato","freesale":"Free sale","allotment":"Contingente","guaranteed":"Garantite"},"buttons":{"deny":"Negare","edit":"Modificare","cancel":"Annullare","accept":"Accettare"},"dropdown":{"label":"Tipo di richiesta","denied":"Rifiutato","pending":"In sospeso","approved":"Approvato","modified":"Modificato"},"headings":{"modified":"Modifiche accettate-con alterazioni dal Contract Manager","accepted":"Modifiche accettate","declined":"Modifiche rifiutate","requested":"Modifiche richieste"}},"manageAllocationModalList":{"new":"Nuova allocazione","date":"Data","edit":"Modifica allocazione","days":"Giorni","released":"Scaduto","block":{"true":"Blocco per periodo","false":"Non scaduto","blocked":"Bloccato"},"buttons":{"new":"Nuova allocazione","edit":"Modifica allocazione","block":"Bloccare allocazione"},"releaseType":{"null":"n/a","request":"Richiesta","blocked":"Bloccato","freesale":"Free Sale"},"header":{"bookingsInPeriod":"Allocazione entro il periodo:","noBookingsInPeriod":"Nessun contingente nel periodo"}},"manageAllocationCalendar":{"retry":"Riprova","error":"Impossibile caricare il calendario","months":["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],"header":{"howTo":"Come utilizzare il calendario","heading":"Calendario allocazione"},"dropdown":{"full":"Anno completo","months":"6 mesi"}},"datePicker":{"predefinedLinks":{"today":"oggi","thisWeek":"questa settimana","lastYear":"L'anno scorso","thisYear":"Quest'anno","lastWeek":"La settimana scorsa","lastMonth":"Il mese scorso","yesterday":"Ieri","thisMonth":"Questo mese"}},"manageAllocationFormAccept":{"header":"Aggiunta di contingente","alert":{"to":"A:","end":"In questo momento non è in grado di modificare le regole di scadenza a meno che non si va dalla vendita gratuita all'assegnazione.<br>Non è possibile dedurre il numero di unità, le unità possono essere aggiunte solo.","from":"Da:","start":"Questo sovrascriverà il seguente periodo"},"content":{"end":"per le seguenti strutture:","note":"<strong>Nota bene ! Questi cambiamenti sono irreversibili.</strong>","comment":"Aggiungere commento","start":{"add":"Sta per aggiungere contingente su","block":"Sta per bloccare il contingente su","submit":"Sta per aggiornare il contingente su","request":"Sta per richiedere le modifiche del contingente","requestBlock":"Sta per richiedere il blocco del contingente"}},"buttons":{"accept":"Accettare","cancel":"Cancellare"}},"validator":{"validateDates":{"dateBefore":"La data di fine deve essere successiva all'inizio."}},"manageAllocationFormHeader":{"endDate":"Data di fine","startDate":"Data di inizio","releaseBy":"scandenza da","releaseType":"Tipo di scadenza","afterRelease":"Stato dopo la scadenza","numberOfUnits":"Numero di unità","allocationType":"Tipo di contingente","releaseDaysDate":"Giorni di scadenza/data"},"statFilters":{"datepickers":{"booking":{"label":"Periodo di prenotazione","heading":"Periodo di prenotazione"},"arrival":{"label":"Periodo di arrivo","heading":"Periodo di arrivo"}}},"manageAllocationModalOverlayForm":{"info":"È possibile modificare la quantità di unità insieme alla data/giorni di scadenza. Il blocco è possibile quando le unità sono rilasciate/disponibili.","units":"Cambia No. di unità","status":"Modifica dello stato","denied":"Non è consentito apportare modifiche all'allocazione","success":"il contingente e stato aggiornate correttamente.","blocked":"Nota bene! Questo prodotto è bloccato e non verranno inviate modifiche","warning":"Nota bene! Questo prodotto è scaduto. È possibile bloccarlo o aggiungere nuovo contingente dalla pagina precedente.","request":"Nota bene! Queste modifiche non possono essere applicate direttamente. È possibile richiedere la modifica che verrà esaminata da un responsabile del contratto. Questo può richiedere fino a 5 giorni lavorativi","released":"nota! Questo prodotto è stato rilasciato","instruction":"Hai bisogno di aiuto?","labels":{"type":"Tipo di contingente","units":"Unità iniziali:","cancel":"Cancella","period":"Periodo","bookings":"Prenotazioni in periodo","releaseDate":"Data di scadenza","releaseDays":"Giorni di scadenza/data","releaseType":"Tipo di sblocco","arrivalRules":"Regola/e di arrivo nel periodo","releaseMethod":"Metodo di sblocco","noArrivalRules":"Non è stata definita alcuna regola di arrivo per questo periodo","bookingsMaxCount":"max. prenotazioni nel periodo","arrivalTypes":{"label":"Tipo","arrival":"Arrivo","departure":"Partenza"},"arrivalRuleStayLength":"Durata del soggiorno in giorni","bookingsMaxCountToolTip":"Il numero massimo di prenotazioni in un determinato giorno all'interno del periodo di assegnazione"},"release":{"date":"Modifica data di scadenza","null":"Nessuna data di scadenza","days":"Modifica giorni di scadenza"},"accept":{"block":"Blocca contingente","submit":"Aggiorna contingente","update":"Aggiorna allocazione","request":"Richiede l'aggiornamento delle allocazioni","requestBlock":"Richiede blocco allocazione"},"pending":{"days":"Giorni","units":"Unità","label":"Vi sono richieste in atteso","requested":"Richiesto"},"buttons":{"reset":"Azzerare","block":"Blocco","cancel":"Annulla","update":"Aggiornamento","request":"Richiede","requestBlock":"Richiede blocco"},"editable":{"type":"Modificare il tipo di allocazione","units":"Modifica del numero di assegnazione","releaseDate":"Modificare la data di rilascio","releaseType":"Cambiare allocazione per ogni tipo","releaseDays":"Modificare i giorni di rilascio","information":{"default":"I campi modificabili vengono visualizzati con il simbolo di modifica. Fare clic sul campo per aprire la casella di modifica. È possibile apportare più modifiche prima dell'aggiornamento e facendo clic su Reimposta si annullano tutte le modifiche."}},"requestPending":"Nota! Non è possibile apportare modifiche a questo periodo in quanto sono presenti richieste di modifica in sospeso","requestMessage":"Nota bene! Queste modifiche non possono essere applicate direttamente. È possibile richiedere la modifica che verrà esaminata da un responsabile del contratto entro 24 ore nei giorni feriali","changesRequested":"Non è possibile modificare l'allocazione in quanto vi sono richieste in sospeso","instructionTrusted":"Una volta salvata, una modifica verrà applicata direttamente all'allocazione e sarà immediatamente visibile tra i nostri marchi.<br/> Tieni presente che potrebbero verificarsi alcune limitazioni, ad esempio non è possibile prelevare l'assegnazione al di sotto del numero di prenotazioni attualmente presenti nell'allocazione.","validator":{"days":{"set":"I giorni di rilascio deve essere impostato su un valore superiore a 0","lower":"Non è consentito aumentare i giorni di scadenza"},"date":{"set":"La data di rilascio deve essere impostata e in formato valido GG/MM/AAAA","lower":"Non è consentito spostare la data di scadenza all'indietro","before":"La data di rilascio deve essere prima o uguale alla data di fine del contingente","beforeEnd":"La data di rilascio deve essere prima o uguale alla data di fine del contingente"},"units":{"set":"Il conteggio delle unità deve essere compreso tra 1 e 10. Se si desidera ritirare tutte le unità, quindi bloccare il contingente"}},"instructionNotTrusted":"Una volta salvata, una modifica verrà applicata direttamente all'allocazione e sarà immediatamente visibile tra i nostri marchi.<br/> Non è possibile detrarre l'assegnazione, il tipo di modifica per richiedere o bloccare direttamente l'allocazione non rilasciata, se si desidera apportare tali modifiche è possibile richiedere la modifica.<br/><br/> Le modifiche vengono esaminate e gestite dal responsabile del contratto entro 5 giorni lavorativi."},"manageAllocationCalendarWeekdays":{"sunday":"Dom","monday":"Lun","friday":"Ven","tuesday":"Mar","thursday":"Gio","saturday":"Sab","wednesday":"Mer"},"manageAllocationModalCalendarElement":{"units":"Unità iniziali:","bookings":"Prenotazioni:","request":{"days":"Giorni","type":"Tipo di modifica:","units":"Unità","header":"Modifiche richieste","deduct":"Dedurre:","release":"Modifica del rilascio:"}},"manageAllocationModalOverlay":{"header":{"heading":"Modifica contingente"}},"manageAllocationModalCalendarInfobox":{"header":{"heading":"Riquadro informazioni calendario"}}}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = {"valid":true,"tips":{"hi":"Hola","help":"¿Necesita ayuda?","more":"más","less":"menos","camping":"Contacte con nuestro departamento informático","adminPage":{"edit":{"body":"Todos los usuarios que ha creado pueden editarse. Se puede editar todo salvo el correo electrónico. Si un usuario cambia de correo electrónico debe crear un nuevo usuario e invitarle a Marketplace.","title":"Editar usuario"},"block":{"body":"Se puede bloquear el acceso a Marketplace a cualquier usuario que haya creado. Para bloquearlo presione editar en el usuario y luego presione el botón de bloquear. Se puede volver a dar acceso a un usuario bloqueado desblqueándolo en el mismo lugar que se boqueó. También puede eliminar a un usuario desde la ventana de edición. ¡Tenga en cuenta que esta acción es irreversible!","title":"Bloquear o eliminar usuarios"},"create":{"body":"Se puede crear un nuevo usuario presionando el botón de nuevo usuario en la esquina de arriba a la derecha. Al nuevo usuario se le puede dar acceso dentro de Marketplace con opción de escritura y lectura o solamente de lectura.","title":"Crear un nuevo usuario"}},"statPage":{"boxes":{"body":"Las cuatro casillas al inicio de la página muestran los ingresos y las reservas. Las casillas grises muestran toda la temporada y las azules el período seleccionado.","title":"Las cuatro casillas al inicio"},"graph":{"body":"El gráfico de la izquierda muestra los establecimientos más vendidos. Seleccione un establecimiento marcándolo y se mostrarán los mejores alojamientos en el gráfico de la derecha.","title":"Los gráficos"},"filter":{"body":"Puede filtrar un período seleccionando las fechas de la reserva y las fechas de llegada, para expandir o reducir la información que se muestre.","title":"Fecha de reserva / Fecha de llegada"}},"dashboardPage":{"add":{"body":"Usted puede añadir fácilmente nuevas asignaciones marcando el botón de \"Añadir asignación\", eso le llevará al calendario de gestión donde puede añadir nuevas asignaciones.","title":"Añadir asignación"},"graph":{"body":"El gráfico muestra la disponibilidad de todos sus alojamientos en sus establecimientos, puede elegir un alojamiento específico mediante el desplegable.","title":"Gráfico de disponibilidad"},"filter":{"body":"Puede filtrar el listado de notificaciones por establecimiento o por alojamiento para ver información específica de un producto","title":"Filtro de Notificaciones"},"notifications":{"body":"El listado de notificaciones muestra información urgente sobre asignaciones que se están agotando o retrocediendo. Si no tenemos ninguna asignación, no podemos vender ninguno de sus productos.","title":"¿Está perdiendo ventas?"}},"bookingPage":{"search":{"body":"Puede realizar la búsqueda de una reserva en concreto mediante el botón de la esquina del listado de reservas.","title":"Búsqueda mediante número de reserva"},"filters":{"body":"Puede filtrar una lista de reservas en base al establecimiento, dominio, alojamiento, país de la reserva, estado de la reserva etc...","title":"Filtros principales"},"sortList":{"body":"Puede filtrar el listado de reservas marcando el encabezamiento de los atributos, y posteriormente filtrar por multitud de opciones usando el desplegable.","title":"Filtrar el listado de reservas"},"xlsError":{"body":"En algunas versiones de Excel se verá el archivo XLS como dañado, pero si acepta el mensaje de error en Excel, podrá ver el archivo con normalidad.","title":"¿Tiene problemas abriendo el archivo XLS?"},"downloadList":{"body":"Puede descargarse el listado de reservas filtrado como archivo separado por comas (CSV) o como archivo Excel (XLS)","title":"Descargar CSV o XLS"}},"allocationPage":{"sort":{"body":"Puede filtrar sus alojamientos por última actualización, nombre o establecimiento","title":"Filtrar alojamientos"},"site":{"body":"Puede filtrar el listado y mostrar únicamente los ajojamientos para un establecimiento en concreto mediante el desplegable al inicio.","title":"Filtrar los establecimientos"},"update":{"body":"Marque el botón de actualización para los alojamientos en los que quiera gestionar asignaciones. Eso le conducirá al calendario de gestión de asignaciones donde podrá, añadir, editar y bloquear asignaciones.","title":"Actualizar asignaciones"},"updateBy":{"body":"La actualización por columna indica quien hizo la última modificación en la asignación de alojamientos, el símbolo \"@\" indica que sólo lo puede realizar un empleado de Camping Vision","title":"Actualizado por"}},"accountPage":{"password":{"body":"Para poder cambiar la contraseña debe introducir su contraseña actual y la contraseña nueva que desea, la cual se verificará en la casilla \"reintroduzca contraseña\".","title":"Modificar contraseña"},"activity":{"body":"La lista de actividad de la cuenta muestra todas la modificaciones que se han hecho en las asignaciones en los últimos 6 meses, tales como incluir asignaciones, modificar asignaciones y solicitar cambios en las asignaciones.","title":"Actividad de la cuenta"},"information":{"body":"La información de la cuenta muestra su número de identificación y tipo de cuenta. Usted puede cambiar su nombre y su apellido.","title":"Información de la cuenta"},"notifications":{"body":"Puede seleccionar si desea recibir notificaciones o no. Si marca en la tecla modificar puede elegir los días en los que desea recibir las notificaciones. ¡ATENCIÓN! Si selecciona quincenalmente, sólo puede elegir un día.","title":"Recibir notificaciones"}},"manageAllocationPage":{"error":"No hemos podido recuperar la información solicitada, por favor inténtelo de nuevo. Si el error persiste, póngase en contacto con nosotros.","year":{"body":"El año actual se selecciona por defecto, pero puede seleccionar hasta dos años en adelante mediante el desplegable \"Seleccionar Año\"","title":"Seleccionar Año"},"info":{"body":"Marque el botón \"información\" sobre el calendario a la derecha para que se muestre una guía de como utilizar el calendario","title":"¿Cómo usar el calendario?"},"modal":{"body":"Cuando se selecciona un período aparecerá una ventana emergente. Si no se ha añadido ninguna asignación, se mostrará un botón para añadir la asignación. Si las asignaciones ya han sido creadas en el período podrá gestionar estas asignaciones editando, añadiendo o bloqueando. Estas opciones varian en función del tipo de asignación y de si han sido retrocedidas o no.","title":"Ventana emergente"},"extra":{"body":"Cuando se selecciona un período se añade un día adicional al final para indicar que la información se basa en noches, por lo tanto, el día adicional será el día de partida.","title":"Día adicional en el período"},"select":{"body":"Utilice el calendario para seleccionar un período y editar o añadir asignaciones. Esto lo puede realizar seleccionando la fecha de inicio y la fecha de fin. De este modo se abrirá una ventana emergente en la cual podrá gestionar las asignaciones para el período seleccionado","title":"Seleccionar período"},"display":{"body":"Seleccionando el desplegable situado sobre el calendario se pueden mostrar seis meses o bien todo el año","title":"Muestre todo el año ó 6 meses"},"overview":{"body":"Una visión general de las asignaciones se muestra en la parte de abajo del calendario. Aquí podrá ver el detalle de las asignaciones. El número de unidades mostrará el número inicial de asignaciones sin tener en cuenta las reservas.","title":"Visión general de asignaciones"},"accommodation":{"body":"Puede cambiar a otro alojamiento desde el desplegable de arriba, los alojamientos están limitados al establecimiento. Si desea seleccionar otro establecimiento debe volver a la página principal de asignaciones y seleccionarlo desde allí.","title":"¿Quiere otro alojamiento?"},"alert":{"requestError":"Solicitud fallida, por favor, inténtelo de nuevo","requestAccept":"Solicitud aceptada con éxito","requestDenied":"Solicitud denegada con éxito","requestUnauthorized":"Solicitud no autorizada"}},"contractManagementPage":{"upload":{"body":"Puede adjuntar archivos como anexos al contrato, los tipos de archivos aceptados son: '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'","title":"Adjuntar archivos"},"expand":{"body":"Puede ampliar o reducir la visualización del progreso, marcando el encabezamiento.","title":"Ampliar la visualización del progreso"},"progress":{"body":"En el encabezamiento puede hacer el seguimiento del progreso de su contrato en porcentaje.","title":"Seguimiento de su progreso"},"indicator":{"body":"Los iconos indican si la información ha sido almacenada por una de las partes, o si hay notificaciones para alguna de las partes.","title":"Iconos indicadores del progreso"}}},"adminItem":{"id":"Id","edit":"Editar","email":"Correo electrónico","status":"Estado","lastName":"Apellido","firstName":"Nombre"},"admin":{"list":{"id":"N.I.","edit":"Editar","email":"Correo electrónico","status":"Estado","noUsers":"Sin usuarios creados","content":"Crear usuario","lastname":"Apellido","firstname":"Nombre","header":{"heading":"Listado de usuarios"}},"alert":{"email":"El correo electrónico pertence a otro usuario.","error":"Ha habido un error","updated":"Usuario actualizado con éxito","deleted":"Usuario eliminado con éxito","created":"Usuario creado con éxito","blocked":"Usuario bloqueado con éxito","password":"Contraseña actualizada con éxito","unblocked":"Usuario desbloqueado con éxito","notifications":"Estado de las notificaciones actualizado con éxito","wrongPassword":"Contraseña incorrecta"},"profile":{"and":"y","email":"Correo electrónico","weekly":"Una vez a la semana","notice":"Actualmente recibe notificaciones","receive":"Recibir notificaciones","language":"Idioma","noNotice":"Actualmente NO recibe notificaciones","everyday":"Cada día","fullName":"Nombre completo","fortnightly":"Una vez cada dos semanas","header":{"heading":"Información de la cuenta"},"notifications":{"edit":"Modificar","weekly":"Semanalmente","cancel":"Cancelar","update":"Actualizar","fortnightly":"Quincenalmente","days":{"friday":"Viernes","monday":"Lunes","sunday":"Domingo","tuesday":"Martes","saturday":"Sábado","thursday":"Jueves","wednesday":"Miércoles"},"heading":{"header":"Cambiar los parámetros de las notificaciones"}}},"form":{"create":"Usuario creado con éxito","edit":{"edit":"Usuario actualizado con éxito.","block":"Usuario bloqueado con éxito","delete":"Usuario eliminado con éxito","unblock":"Usuario desbloqueado con éxito."},"error":{"edit":"Ha habido un error, por favor inténtelo de nuevo más tarde.","email":"El correo electrónico pertence a otro usuario.","error":"Ha habido un error, por favor inténtelo de nuevo más tarde."}},"heading":{"header":"Panel del administrador"},"edit":{"form":{"info":"Edite el usuario y actualize para salvar los cambios","roles":"Rol","lastname":"Apellido","language":"Idioma","firstname":"Nombre","button":{"submit":"Crear usuario"},"notifications":"Recibir notificaciones","buttons":{"block":"Bloquear","update":"Actualizar","delete":"Eliminar","unblock":"Desbloquear"},"warning":{"blocked":"ATENCIÓN: Este usuario está bloqueado","inactive":"ATENCIÓN: Este usuario está inactivo"},"validator":{"lastname":"*Se requiere el apellido","firstname":"*Se requiere el nombre"}},"header":{"heading":"Editar usuario"},"accept":{"header":{"block":"Bloquear usuario","update":"Actualizar usuario","delete":"Eliminar usuario","unblock":"Desbloquear usuario"},"content":{"block":"¿Está seguro de que quiere bloquear este usuario?","delete":"¿Está seguro de que quiere eliminar este usuario?","update":"¿Está seguro de que quiere actualizar este usuario?","unblock":"¿Está seguro de que quiere desbloquear este usuario?"},"buttons":{"accept":"Aceptar","cancel":"Cancelar"}}},"create":{"form":{"tip":"<strong> Rol:</strong> Indique un rol parapara dar niver de acceso al usuario ","roles":"Rol","email":"Correo electrónico","language":"Idioma","lastname":"Apellido","firstname":"Nombre","button":{"submit":"Crear usuario"},"validator":{"email":"*Se requiere un correo electrónico válido","lastname":"*Se requiere un apellido válido","firstname":"*Se requiere un nombre válido"}},"button":{"submit":"Crear usuario"},"accept":{"header":"Crear usuario","content":"¿Está seguro de que quiere crear este usuario?","buttons":{"cancel":"Cancelar","accept":"Aceptar"}},"header":{"heading":"Crear usuario"}}},"signIn":{"button":"Iniciar sesión","heading":"Bienvenido a Camping Vision Marketplace","description":"Regístrese y empiece a vender","logoutNotice":"Ha cerrado la sesión correctamente","invalidNotice":"Por favor inicie sesión de nuevo para confirmar su identidad","pass":{"placeholder":"Contraseña","errors":{"required":"Introduzca una contraseña válida"}},"inactivityNotice":"Se ha cerrado la sesión debido a inactividad","email":{"placeholder":"Correo electrónico","errors":{"email":"Introduzca un correo electrónico válido","required":"Introduzca un correo electrónico"}},"messages":{"mismatch":"El nombre de usuario y la contraseña no son válidos","unexpected":"Ha habido un error. Nuestro departamento informático ha sido informado. Por favor inténtelo de nuevo más tarde."},"forgotPasswordLink":"¿Ha olvidado su contraseña?"},"booking":{"button":"Activar cuenta","heading":"Reservas","filterText":"Búsqueda","dateTypes":["Fecha de la reserva","Fecha de llegada"],"placeholder":"Búsqueda","description":"Listado de reservas para un período determinado","tableFields":{"#":"#","reset":"Eliminar filtro","status":"Estado","domain":"Dominio","duration":"Duración","siteName":"Establecimiento","bookingRef":"Número de CV","bookingDate":"Fecha de la reserva","arrivalDate":"Fecha de llegada","supplierRef":"Número de reserva","supplierName":"Nombre del proveedor","customerName":"Cliente","departureDate":"Fecha de salida","accommodation":"Alojamiento"},"messages":{"error":"Ha habido un error, por favor inténtelo de nuevo más tarde.","expired":"Su autorización ha caducado."},"filterOptions":{"site":"Establecimiento","option":"Elija","domain":"Elija dominio","default":"Filtrar por","bookingAgent":"Agente de la reserva","accommodation":"Alojamiento","bookingCountry":"País de la reserva"}},"account":{"form":{"id":"N.I.","email":"Correo electrónico","lastName":"Apellido","firstName":"Nombre","buttons":{"reset":"Reiniciar","update":"Actualizar"},"heading":{"header":"Modificar la información de la cuenta"},"accountType":{"label":"Tipo de cuenta","admin":{"true":"Administrador","false":"Básico"}},"validator":{"required":"Este campo es obligatorio"},"placeholder":{"lastName":"Introduzca su apellido","firstName":"Introduzca su nombre"}},"activity":{"site":"Establecimiento","date":"Fecha","limit":"Mostrar filas","type":{"label":"Tipo de actividad","request":"Solicitar","allocation":"Modificar"},"status":{"label":"Acción","RELEASED":"Asignación retrocedida","USER_EDIT":"Modificar asignación","USER_INSERT":"Añadir asignación"},"header":{"months":"(Últimos 6 meses)","heading":"Actividad de la cuenta"},"accommodation":"Alojamiento"},"password":{"password":"Contraseña actual","rePassword":"Confirmar contraseña","newPassword":"Nueva contraseña","buttons":{"reset":"Reiniciar","update":"Actualizar"},"heading":{"header":"Modificar contraseña"},"validator":{"mismatch":"Las contraseñas no coinciden","password":"Min. 8 caractéres / mayúsculas & minúsculas / números"},"placeholder":{"password":"********"}}},"statList":{"heading":"Ingresos","predicate":"Filtrar por","backButton":"Atrás"},"bookingItem":{"site":"Establecimiento","status":"Estado","domain":"Dominio","duration":"Duración","bookingRef":"Número de referencia de Camping Vision","arrivalDate":"Fecha de llegada","supplierRef":"Número de referencia","bookingDate":"Fecha de la reserva","supplierName":"Nombre del proveedor","customerName":"Cliente","departureDate":"Fecha de salida","accommodation":"Alojamiento"},"notFound":{"heading":"404 - No encontrado"},"introduction":{"body":"Nos han informado que está interesado en proceder a la venta de sus productos a través de los amplios canales de venta de Camping Vision. Siguiendo nuestro proceso de venta, nos pondremos en contacto con usted lo antes posible.","error":"Parece que ha habido un error en la gestión de su solicitud, por favor, inténtelo de nuevo más tarde. SI el problema continua, póngase en contacto con nosotros.","warning":"Estamos trabajando a pleno rendimiento y le damos nuestra palabra de que nos pondremos en contacto con usted en breve.","noContent":"El enlace que ha marcado no funciona correctamente, por favor, contacte con el Gestor del Contrato.","footer":{"title":"¿Tiene alguna pregunta?","contact":{"tel":"Tel: +31 (0)416 849 853","city":"1212 Grand-Lancy","title":"Camping Vision","email":"info@campingvision.com","street":"Rue du Bachet 14","country":"Suiza","address":"Oficina en Ginebra"}},"header":{"error":"Lo sentimos :'(","warning":"Gracias de nuevo .-)","heading":"¡Gracias por su interés!","noContent":"Upssss...."}},"statSites":{"heading":"Establecimientos","dropdown":{"label":"Filtrar por"},"noContent":{"error":"Error al buscar los datos","missing":"No se ha encontrado la información"},"predicate":{"revenue":"Ingresos","bookings":"Reservas"},"alternativeHeading":"Los 10 mejores establecimientos"},"bookingList":{"order":"Comando","error":"Ha habido un error inesperado.","title":"Búsqueda por número de reserva o nombre del cliente","search":"Búsqueda por número de reserva","heading":"Ninguna reserva coincide | se ha encontrado 1 reserva | {count} reservas encontradas","perPage":"Mostrar filas","orderBy":"Filtrar por tipo","noContent":"No se han encontrado reservas","xslTooltip":"Si el Excel muestra un error, marque \"sí\" para abrirlo.","display":{"all":"Todo","label":"Desplegar opciones","current":"Actual","historical":"Histórico"},"placeholder":"Búsqueda","download":{"xls":"Descargar listado (XLS)","csv":"Descargar listado (CSV)"},"orderFields":{"asc":"Ascendente","desc":"Descendente"}},"instruction":{"dismiss":"No volver a mostrar","defaultHeader":"Instrucciones de uso","contract":{"body":"Lea cuidadosamente cada una de las partes del contrato para asegurarse de que la información es correcta. Si encuentra alguna discrepancia, por favor indíquelo en el campo de notificaciones mediante el cuadro de norificaciones al final de la página. Si una parte es correcta, por favor acéptela mediante el botón de \"Aceptar parte\" al final de la página. <br/> Para navegar dentro de las distintas partes marque el icono cuadrado del módulo de progreso justo abajo o utilice las flechas al final de la página. <br/><br/> Por favor recuerde guardar los cambios."},"contractList":{"body":"El listado de abajo le muestra una visión global de sus contratos. Una vez un contrato está listo para su revisión, puede marcarlo e ir a la página de revisión. Una vez todas las partes hayan sido revisadas y aceptadas, podrá descargarse una copia del contrato en formato pdf.","header":"En la parte inferior encontrará sus contratos"}},"topMenu":{"right":{"admin":"Administrador","logout":"Desconectar","account":"Cuenta"},"left":{"welcome":"Bienvenido"}},"allocationItem":{"site":"Establecimiento","supplier":"Proveedor","updatedAt":"Última actualización","updatedBy":"Actualizado por"},"activateUser":{"button":"Activar cuenta","heading":"Activar su cuenta","description":"Ha solicitado activar su cuenta. Por favor indique su contraseña.","messages":{"token":"Su solicitud no ha podido ser procesada. Por favor inténtelo de nuevo más tarde.","success":"Su cuenta ha sido actualizada con éxito. Se le redirigirá a la página de inicio en breve.","mismatch":"Su contraseña debe tener al menos 8 caracteres de largo y contener al menos una mayúscula y un número","unexpected":"Ha habido un error inesperado. Nuestro departamento informático ha sido informado. Inténtelo de nuevo más tarde."},"pass":{"placeholder":"Nueva contraseña","errors":{"required":"Introduzca una contraseña"}},"passCheck":{"placeholder":"Confirme la contraseña","errors":{"required":"Debe confirmar su contraseña de nuevo","mismatch":"La contraseña no coincide"}}},"contract":{"form":{"email":"El contrato está listo, enviar correo al proveedor","alert":"El proveedor no está creado en Marketplace","accept":"Aceptar y completar contrato","complete":"Contrato listo para el proveedor","sites":{"view":"Visualizar","city":"Ciudad","email":"Correo electrónico","phone":"Teléfono","rating":"Clasificación","address":"Dirección","country":"País","zipCode":"Código Postal","website":"Página web","noContent":"No se han encontrado establecimientos para este contrato","header":{"heading":"Establecimientos"},"facilities":{"size":"Tamaño (m²)","number":"Número","header":"Instalaciones","endDate":"Fecha de finalización","distance":"Distancia","startDate":"Fecha de inicio","dataHeader":"Información complementaria"}},"acceptPart":"Aceptar","sendAccept":"Aceptar contrato","extras":{"rule":"Regla","sell":"Venta","ageTo":"Edad máxima","price":"Precio","person":"Persona","noData":"n/a","endDate":"Fecha de finalización","ageFrom":"Edad mínima","arrival":"Fecha de llegada","per":{"stay":"Por estancia","week":"Por semana","hour":"Por hora","night":"Por noche","piece":"Por unidad","person":"Por persona","personNight":"Por persona por noche","accommodation":"Por alojamiento"},"netPrice":"Precio Neto","startDate":"Fecha de inicio","departure":"Salida","noContent":"No se han encontrado suplementos para este contrato","commission":"Comisión","description":"Descripción","type":{"person":"Persona","optional":"Opcional","inclusive":"Incluido","mandatory":"Obligatorio","information":"Información"},"payment":{"ignore":"n/a","arrival":"Pago a la llegada","booking":"Pago al realizar la reserva","bookingArrival":"Reserva y pago a la llegada"},"header":{"heading":"Suplementos"}},"partAccepted":"aceptado","notes":{"toggle":"Notificaciones","placeholder":"Introduzca notificaciones aquí...","header":{"heading":"Comentarios"},"sendBeforeLeave":"¿Deasea enviar una notificación por correo a su Gestor del contrato en relación a este mensaje?","sendEmailToContractManager":"¿Desea enviar una notificación por correo al Gestor del Contrato en relación a este mensaje?"},"control":{"save":"Guardar","cancel":"Cancelar aceptación","accept":"Aceptar esta parte","accepted":"Esta parte se ha aceptado"},"prices":{"price":"Precio","endDate":"Fecha de finalización","noContent":"No se ha encontrado tarifa de precios en este contrato","startDate":"Fecha de inicio","commission":"Comisión","header":{"heading":"Precios & comisiones"},"setting":{"pricePr":{"unit":"Por unidad","person":"Persona"},"grossOrNet":{"net":"Precio neto","gross":"Precio bruto"},"priceType":{"singleDay":"Tarifa diaria"}}},"progress":{"label":"Información del contrato","part":{"terms":"Condiciones de venta","sites":"Establecimientos","extras":"Suplementos","prices":"Tarifa de precios","discounts":"Descuentos","allocations":"Asignaciones","arrivalRules":"Normas de llegada","supplierInfo":"Información del proveedor","accommodations":"Alojamientos","cancellationRules":"Normas de cancelación"},"header":{"heading":"Progreso del contrato"}},"unknownProduct":"Tipo de producto desconocido","discounts":{"name":"Nombre","types":"Tipo(s)","noDate":"n/a","endDate":"Día de finalización","startDate":"Día de inicio","noContent":"No se han encontrado descuentos en este contrato","header":{"heading":"Descuentos"},"arrivalDeparture":"Llegada/Salida"},"missingContract":"Error al descargar el contrato","message":{"initiated":"Su contrato sigue pendiente"},"arrivalRules":{"days":"días","arrival":"Fecha de llegada","endDate":"Fecha de fin","noContent":"No se han encontrado normas de llegada en este contrato","minRental":"Estancia mín.","maxRental":"Estancia máx.","departure":"Salida","startDate":"Fecha de inicio","type":{"label":"tipo","arrival":"Fecha de llegada","departure":"Salida"},"header":{"heading":"Normas de llegada"},"weekdays":{"friday":"Vi","monday":"Lu","sunday":"Do","tuesday":"Ma","thursday":"Ju","saturday":"Sa","wednesday":"Mi"}},"allocations":{"units":"Unidades","noData":"n/a","endDate":"Fecha final","startDate":"Fecha inicial","noContent":"No se han encontrado asignaciones para este contrato","type":{"label":"Tipo","BLOCKED":"Bloqueado","REQUEST":"Solicitar","FREESALE":"Venta libre","GUARANTEE":"Garantía","ALLOTMENT":"Asignación"},"releaseDate":"Fecha de retrocesión","releaseDays":"Días de retrocesión","releaseType":"Tipo de retrocesión","header":{"heading":"Asignaciones"}},"accommodations":{"view":"Visualizar","noData":"n/a","category":"Categoría","maxAdults":"№ Máx. adultos","noContent":"No se han encontrado alojamientos para este contrato","maxPersons":"№ Máx. personas","minFullPay":"№ Mín. pago completo","childrenAges":"Edad","header":{"heading":"Alojamientos"},"subGroups":{"header":"Instalaciones"},"childrenAgesInfo":"Ej. 14, 2 (Niños de máx. 14 y 2 años de edad)","childOutsideAllowed":"1 niño adicional fuera del № Máx. permitido","childOutsideAllowedInfo":"Ej. 2 ( Se permite un niño de menos de 2 años de edad fuera del cálculo total del número de personas)"},"terms":{"heading":{"header":"Condiciones de venta"}},"cancellationRules":{"noShow":"Ausente","heading":"Normas de anulación","labels":{"days":"Días antes de la llegada","percent":"Pago facturado"}},"supplierInfo":{"bankInfo":{"bic":"BIC","info":"Información","name":"Nombre","bank":"Banco","iban":"IBAN","email":"Correo electrónico","terms":"Condiciones de pago","method":"Modalidad de pago","heading":"Datos bancarios","account":"Número de cuenta","bankCurrency":"Divisa de la cuenta","priceCurrency":"Precio de la divisa"},"contactInfo":{"name":"Nombre","city":"Ciudad","email":"Correo electrónico","phone":"Teléfono","heading":"Información de contacto","website":"Página web","country":"País","address":"Dirección","zipCode":"Código postal"},"bookingInfo":{"heading":"Información de la reserva","amendEmail":"Correo electrónico para modificaciones","bookingPhone":"Teléfono de contacto para las reservas","bookingEmail":"Correo electrónico para las reservas","requestEmail":"Correo electrónico para las solicitudes","bookingPerson":"Persona de contacto para reservas","complaintPhone":"Teléfono de contacto para las quejas","complaintEmail":"Correo electrónico para las quejas","complaintPerson":"Persona de contacto para las quejas","cancellationEmail":"Correo electrónico para las anulaciones","confirmationEmail":"Correo electrónico para las confirmaciones"}}},"alert":{"saved":"El contrato se ha guardado satisfactoriamente","error":"Ha habido un problema","noFile":"No se ha encontrado el archivo","removed":"Se ha eliminado el archivo","supplier":"El proveedor no está regristado en Marketplace","notFound":"No se ha encontrado el contrato","emailSent":"Correo electrónico enviado","completed":"Se ha completado el contrato","illegalSize":"La imagen excede el límite de 3500x2500 px","unsupportedType":"Tipo de archivo no aceptado","emailAlreadySent":"El correo electrónico ya ha sido enviado"}},"resetPassword":{"button":"Restablecer contraseña","heading":"Restablecer contraseña","description":"Ha solicitado restablecer su contraseña. Por favor introduzca su nueva contraseña","messages":{"token":"No se ha podido procesar su solicitud. Inténtelo de nuevo más tarde","success":"Se ha reestablecido su contraseña. Se le redirigirá a la página de inicio en breve.","mismatch":"Su contraseña debe tener al menos 8 caracteres de largo y contener al menos una mayúscula y un número","unexpected":"Ha habido un error inesperado. Hemos informado a nuestro departamento informático. Inténtelo de nuevo más tarde."},"pass":{"placeholder":"Contraseña nueva","errors":{"required":"Introduzca una contraseña"}},"passCheck":{"placeholder":"Confirme su contraseña","errors":{"mismatch":"La contraseña no coincide","required":"Debe confirmar su contraseña de nuevo"}}},"allocationList":{"order":"Comando","orderBy":"Filtrar por tipo","perPage":"Mostrar filas","heading":"Gestionar las asignaciones","button":{"update":"Actualizar"},"messages":{"error":"Ha habiso un error inesperado.","noContent":"No se han encontrado asignaciones","unauthorized":"Acción no autorizada debido a permisos de usuario"},"orderFields":{"asc":"Ascendente","desc":"Descendente"},"tableFields":{"site":"Establecimiento","name":"Alojamiento","supplier":"Proveedor","updatedBy":"Actualizado por","updatedAt":"Ùltima actualización","pendingRequests":"Solicitudes pendientes"}},"dashboard":{"graph":{"label":"Gráficos","footer":"El gráfico muestra la disponibilidad de sus alojamientos"},"tricks":{"click":"Haga \"click\" aquí","welcome":"Bienvenido","statistics":{"link":"/paneldecontrol/estadisticas","message":"Desde la página de estadísticas podrá tener una rápida visión global de sus ventas"},"allocation":{"link":"/paneldecontrol/asignacion","message":"¿Sabe que puede gestionar las asignaciones desde la página de gestión de asignaciones?"}},"suppliers":{"label":"Seleccione un proveedor"},"date":{"days":{"friday":"Viernes","monday":"Lunes","sunday":"Domingo","tuesday":"Martes","thursday":"Jueves","saturday":"Sábado","wednesday":"Miércoles"}},"availability":{"all":"Todos los alojamientos","select":"Alojamiento","request":"Bajo petición","blocked":"Agotado / Bloqueado","overview":"Disponibilidad global (%)","noContent":"No se han encontrado datos","available":"Disponible"},"notifications":{"limit":"Mostrar filas","noContent":"Sin notificaciones","list":{"site":"Establecimiento","link":"Añadir asignación","date":"Fecha","dismiss":"Descartar","status":{"stay":"Duración de la estancia inadecuada","label":"Estatus","arrival":"Fecha de llegada inadecuada","soldOut":"Agotado","released":"Fecha de retrocesión alcanzada"},"contractLink":"Ir al calendario","header":{"count":"Sin notificaciones | 1 notificación encontrada | {count} notificaciones encontradas","heading":"¿Está perdiendo oportunidades de venta?","contractHeading":"Gestión de notificaciones"},"accommodation":"Alojamiento"},"filters":{"sites":{"all":"Todos los establecimientos","label":"Selecione establecimiento"},"predicate":{"all":"Cualquier estado","stay":"Duración de la estancia inadecuada","label":"Seleccione estado","arrival":"Fecha de llegada inadecuada","soldOut":"Agotado","released":"Fecha de retrocesión alcanzada"},"accommodations":{"all":"Todos los alojamientos","label":"Seleccione alojamiento"}}},"alert":{"dismiss":{"error":"Ha habido un problema","success":"Se han descartado las notificaciones","noContent":"No se ha podido encontrar la notificación"}}},"statInventory":{"heading":"Inventario","dropdown":{"label":"Filtrar por"},"noContent":{"error":"Error al buscar la información","missing":"No se ha encontrado información"},"predicate":{"revenue":"Ingresos","bookings":"Reservas"},"alternativeHeading":"Los 10 inventarios principales"},"forgotPassword":{"button":"Solicitud restablecida","heading":"¿Ha olvidado su contraseña?","signInLink":"Volver al inicio","description":"Introduzca su correo electrónico para restablecer su contraseña","messages":{"noexist":"El correo electrónico no existe","success":"Se le ha enviado un correo con el enlace para restablecer su contraseña","unexpected":"Ha habido un error inesperado. Hemos informado a nuestro departamento informático. Inténtelo de nuevo más tarde."},"email":{"placeholder":"Correo electrónico","errors":{"email":"Introduzca un correo electrónico válido","required":"Introduzca un correo electrónico"}}},"bookingFilters":{"site":{"all":"Todos los establecimientos","label":"Establecimiento"},"brand":{"all":"Todas las marcas","label":"Marcas"},"status":{"all":"Todos los tipos","label":"Estado","types":{"booked":"Reservado","pending":"Pendiente","unknown":"Sin estado","request":"Solicitado","rejected":"Denegado","cancelled":"Anulado","request-cancel":"Solicitud cancelada"}},"domain":{"all":"Todos los dominios","label":"Dominios"},"country":{"all":"Todos los países","label":"País de la reserva"},"supplier":{"all":"Todos los proveedores","label":"Proveedores"},"accommodation":{"all":"Todos los alojamientos","label":"Alojamientos"},"arrivalPeriod":{"label":"Fecha de llegada","datepicker":{"heading":"Seleccione la fecha de llegada"}},"bookingPeriod":{"label":"Fecha de la reserva","datepicker":{"heading":"Seleccione la fecha de la reserva"}}},"navigation-menu":{"language":"Seleccione un idioma","items":{"stats":"Estadísticas","booking":"Reservas","supplier":"Proveedor","contract":"Contrato","dashboard":"Panel de control","allocation":"Asignaciones","productType":"Tipo de producto","products":{"Hotel":"Hoteles","Shuttle":"Autobús","Camping":"Campings ","Badeland":"Parques acuáticos","Skiferie":"Esquí","Krydstogt":"Cruceros","Disneyland":"Disneylandia","Feriebolig":"Propiedades"}}},"manageAllocationList":{"error":"No se ha podido cargar la lista de asignaciones","retry":"Inténtelo de nuevo","header":"Vista global de asignaciones","list":{"to":"A","new":"Asignación nueva","type":"Tipo","from":"De","edit":"Modificar asignación","block":"Bloquear el período","units":"Unidades","release":"Fecha/Días de retrocesión","released":"Retrocedidas en el período","updatedBy":"Actualizado por","updatedAt":"Actualizado a","releaseDate":"Fecha de retrocesión","releaseDays":"Días de retrocesión","releaseType":"Tipo de retrocesión"},"noAllocations":"¡No se han encontrado asignaciones!"},"manageAllocationPage":{"error":"Ha habido un problema, por favor inténtelo de nuevo más tarde.","mobile":"El contenido solo puede mostrarse en un ordenador.","request":{"cancel":{"unauth":"No tiene autorización para cancelar reservas","success":"Solicitud cancelada con éxito","failure":"Ha habido un problema, por favor inténtelo de nuevo más tarde.","noContent":"El número de identificación de la solicitud no concuerda con los números de identificación existentes"},"accept":{"success":"Solicitud aceptada con éxito","failure":"Ha habido un problema, por favor inténtelo de nuevo más tarde."},"modify":{"failure":"Ha habido un problema, por favor inténtelo de nuevo más tarde.","success":"Solicitud modificada y aceptada con éxito"},"decline":{"failure":"Ha habido un problema, por favor inténtelo de nuevo más tarde.","success":"Solicitud denegada con éxito"}}},"manageAllocationModal":{"info":"Marque el botón de añadir para empezar a añadir asignaciones para el período seleccionado.<br/> ATENCIÓN: El último día del período no está incluido.","dash":"-","error":"Ha habido un problema, por favor, inténtelo de nuevo más tarde","period":"Período:","update":"La asignación se ha actualizado con éxito.","loading":"Cargando asignaciones","success":"La asignación se ha actualizado con éxito.","request":"La solicitud de asignación se ha enviado con éxito","blocked":"La asignación se ha actualizado con éxito.","form":{"days":"Días","date":"dd/mm/aaaa","type":{"null":"n/a","blocked":"Bloqueado","request":"Bajo petición","freesale":"Venta libre","allotment":"Asignación"},"units":{"null":"n/a","allotment":"Número de unidades","notAllotment":"Sólo para asignaciones"},"buttons":{"add":"Añadir","create":"Añadir asignaciones","submit":"Procesar cambios","cancel":"Cancelar"},"releaseType":{"null":"n/a","request":"Bajo petición","blocked":"Bloqueado","freesale":"Venta libre","selectType":"Seleccione tipo"},"releaseMethod":{"null":"n/a","date":"Fecha","days":"Días"}},"allocations":"Se han encontrado asignaciones","buttons":{"add":"Añadir"},"unauthorized":"No está autorizado","noAllocations":"No se han encontrado asignaciones","overlaySuccess":"La asignación se ha actualizado con éxito.","header":{"heading":"Gestionar asignaciones"}},"statNumber":{"body":{"noDataFound":"No se ha encontrado información","failedToFetchData":"Error al buscar la información"}},"contractList":{"heading":{"header":"Contratos"},"overview":{"error":"Fallo al cargar los datos","download":"Descargar","noContracts":"No se han encontrado contratos","heading":{"header":"Visualización del contrato"},"status":{"initiated":"El contrato está en estado pendiente","readyForSupplier":"El contrato está listo para revisión"}},"history":{"heading":{"header":"Historial"}}},"contractNotes":{"messages":{"goTo":"Ir a la ref.","wrote":"Escrito","supplier":"Proveedor","internal":"Mensaje interno","sendEmail":"¿Deasea enviar un correo de alterta de notificación?","noContent":"Sin notificaciones","campingVision":"Camping Vision","supplierEmail":"Enviar alerta de notificación por correo al proveedor","backOfficeEmail":"Enviar alerta de notificación por correo al departamento de Back Office","contractManagerEmail":"Enviar alerta de notificación por correo al Gestor del Contrato"},"header":{"heading":"Notificaciones","messages":"Mensaje(s) sin responder"},"control":{"internal":"¿Enviar como mensaje interno?","reference":"Referencia","placeholder":"Escriba su mensaje..."}},"manageAllocationFormRow":{"days":"Días","dateFormat":"DD/MM/AAAA","dropDown":{"date":"Fecha","days":"Días","request":"Solicitado","blocked":"Bloqueado","freeSale":"Venta libre","allotment":"Asignación","guarantee":"Garantía","selectType":"Seleccione un tipo","chooseType":"Elegir el tipo"}},"contractManagement":{"list":{"year":"Año","edit":"Modificar","view":"Visualizar contrato","perPage":"Por página","supplier":"Proveedor","download":"Descargar","show":{"all":"Todos los contratos","mine":"Sólo mis contratos","label":"Mostrar  "},"updatedBy":"Actualizado por","status":{"done":"Hecho","basic":"Contrato básico abierto","label":"Estado","pending":"En espera de proveedor","extended":"Extensión de contrato abierto","completed":"Completado","initiated":"Contrato abierto","notification":"Notificación","readyForSupplier":"En espera del proveedor","readyForBackOffice":"En espera de Back Office","supplierNotifications":"Comentarios del proveedor","readyForContractManager":"En espera del gestor del contrato","contractManagerNotifications":"Comentarios del gestor del contrato"},"noContracts":"Ningún contrato coincide con sus criterios","display":{"all":"Cualquier estado","label":"Estado"},"lastUpdated":"Última actualización","viewSupplier":"Visualizar el progreso del proveedor","heading":{"header":"Estado del contrato"}},"alert":{"error":"Ha habido un error","saved":"Contrato guardado con éxito","noFile":"No se ha encontrado el archivo","removed":"Se ha eliminado el archivo correctamente","notFound":"No se ha encontrado el contrato","emailSent":"Correo enviado","illegalSize":"La imagen excede el límite de 3500x2500 px","noSitesFound":"No se ha encontrado ningún establecimiento","unsupportedType":"No se acepta este tipo de archivo","validationError":"Formulario incompleto","emailAlreadySent":"El correo ya ha sido enviado.","noAccommodationsFound":"No se ha encontrado ningún alojamiento"},"edit":{"form":{"add":"Añadir","save":"Guardar formulario","link":"Enlace","copy":"Copia","create":"Crear","remove":"Eliminar archivo","confirm":"¿Está seguro que quiere eliminar este archivo?","noTitle":"Sin título","optional":"Opcional","checkbox":"Mostrar en el contrato","download":"Descargar","emailSent":"Correo enviado","brands":{"info":"Seleccione las marcas para las que se aplica el contrato:"},"email":{"review":"Enviar correo de listo para revisión","supplier":"Enviar correo de listo para el proveedor","backOffice":"Enviar un correo a Back Office"},"images":{"remove":"Eliminar","initial":"Marque o arraste las imágenes aquí","confirm":"Confirmar","accepted":"Tipos de archivos aceptados: '.jpg,.jpeg,.bmp,.png'","unsupported":"Su navegador no soporta la carga de imágenes"},"upload":{"remove":"Eliminar","confirm":"Confirmar","initial":"Marque o desplace los ficheros aquí","accepted":"Tipos de ficheros aceptados: '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'"},"complete":{"review":"¿Contrato listo para revisión?","contract":"Parte básica / parte complementaria completada"},"subHeader":{"notes":"Comentarios","brands":"Marcas","accInfo":"Alojamiento(s)","accepted":"Aceptado","siteInfo":"Establecimiento(s)","discounts":"Descuentos","commission":"Comisión","priceExtra":"Tarifas y suplementos","arrivalRules":"Normas de llegada","allotmentRules":"Asignaciones y regulaciones","arrivalDeparture":"Llegada/Salida"},"placeholder":{"notes":"Introduzca información adicional aquí, por ej: experiencia personal, etc...","discounts":"Introduzca los descuentos aquí","priceExtra":"Introduzca la tarifa de precios por alojamiento incluyendo extras","commission":"Introduzca el porcentaje de la comisión","arrivalRules":"Introduzca las normas de llegada","accInfo":{"site":"Seleccione establecimiento(s)","text":"Introduzca la descripción del alojamiento aquí","name":"Introduzca/seleccione el nombre del alojamiento"},"siteInfo":{"text":"Introduzca la descripción del establecimiento aquí","name":"Introduzca/seleccione el nombre del establecimiento"},"allotmentRules":"Introduzca las fechas de la asignación, el tipo de alojamiento y la regulación del mismo","arrivalDeparture":"Introduzca la información de llegada y salida así como la estáncia mínima"},"autoComplete":{"multi":"Adjuntar en establecimiento","accInfo":"Introduzca el nombre del alojamiento aquí","siteInfo":"Inroduzca el nombre del establecimiento aquí"},"header":{"heading":{"done":"Aceptado por el proveedor","basic":"Información básica","extended":"Información complementaria"}}},"progress":{"done":"Aceptada por el proveedor","basic":"Información básica","extended":"Información complementaria","defaultText":"No hay cambios","header":{"heading":"Progreso del contrato"},"subHeader":{"notes":"Comentarios","brands":"Marcas","accInfo":"Alojamiento(s)","accepted":"Aceptado","siteInfo":"Establecimiento(s)","discounts":"Descuentos","commission":"Comisión","arrivalRules":"Fecha de llegada","allotmentRules":"Asignacion","priceExtra":{"price":"Precios","extra":"Suplementos"},"arrivalDeparture":"Llegada/Salida"}}},"noChangesConfirm":"Esto no añadirá \"Ningún cambio\" a esta parte, ¿desea proceder?"},"manageAllocationForm":{"heading":"Añada asignaciones","buttons":{"reset":"Reiniciar el formulario","submit":"Procesar los cambios"},"control-message":{"on":"sobre","content":"<strong>ATENCIÓN:</strong> Está añadiendo una asignación para:"}},"manageAllocationFilters":{"year":"Seleccione el año"},"subPages":{"home":{"subTitleRevenue":"EURO","subTitleBookings":"piezas","labelTotalRevenue":"Ingresos totales","labelTotalBookings":"Reservas totales","labelPeriodRevenue":"Período de ingresos","labelPeriodBookings":"Período de reservas"}},"manageAllocationRequest":{"units":"Unidades","toggle":"Solicitudes pendientes","heading":"Visión global de solicitudes","form":{"body":"Puede modificar la solicitud a través del formulario a continuación. Marque aceptar para aceptar la solicitud modificada","period":{"title":"Período"},"labels":{"units":"Unidades","release":"Fecha/Días de retrocesión"},"header":{"heading":"Modificar la solicitud"},"buttons":{"cancel":"Cancelar","accept":"Aceptar"}},"noContent":"No se han encontrado solicitudes","table":{"type":"Cambiar tipo","block":"Solicitud bloqueada","period":"Período","release":"Cambiar la retrocesión","deduction":"Disminución de la asignación","requestDate":"Fecha de la solicitud"},"releaseDays":"días","type":{"request":"Solicitud","blocked":"Bloqueado","freesale":"Venta libre","allotment":"Asignación","guaranteed":"Garantizado"},"buttons":{"deny":"Denegar","edit":"Modificar","cancel":"Cancelar","accept":"Aceptar"},"dropdown":{"label":"Tipo de solicitud","denied":"Denegada","pending":"Pendiente","approved":"Aprobada","modified":"Modificada"},"headings":{"modified":"Aceptar cambios - con modificaciones del Gestor del Contrato","accepted":"Aceptar cambios","declined":"Declinar cambios","requested":"Cambios solicitados"}},"manageAllocationModalList":{"new":"Nueva asignación","date":"fecha","edit":"Modificar la asignación","days":"días","released":"Retrocedido","block":{"true":"Bloqueado en el período","false":"No retrocedido","blocked":"Bloqueado"},"buttons":{"new":"Nueva asignación","edit":"Modificar la asignación","block":"Bloquear la asignación"},"releaseType":{"null":"n/a","request":"Solicitar","blocked":"Bloqueado","freesale":"Venta libre"},"header":{"bookingsInPeriod":"Asignaciones en el período","noBookingsInPeriod":"No hay asignaciones en el período"}},"manageAllocationCalendar":{"retry":"Inténtelo de nuevo","error":"Ha habido un fallo al cargar el calendario","months":["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],"header":{"howTo":"Como usar el calendario","heading":"Calendario de asignación"},"dropdown":{"full":"Año completo","months":"6 meses"}},"datePicker":{"predefinedLinks":{"today":"Hoy","thisWeek":"Esta semana","lastYear":"El año pasado","thisYear":"Este año","lastWeek":"La semana pasada","lastMonth":"El mes pasado","yesterday":"Ayer","thisMonth":"Este mes"}},"manageAllocationFormAccept":{"header":"Añadir asignaciones","alert":{"to":"Para:","end":"En estos momentos no puede modificar las reglas de retrocesión salvo que modifique de venta libre a asignación.<br/> No se puede reducir el número de unidades, las unidades solo se pueden añadir.","from":"De:","start":"Esto reemplazará el siguiente período"},"content":{"end":"para la(s) asignación(es) siguiente(s):","note":"<strong> ¡ATENCIÓN! Estos cambios son irreversibles.</strong>","comment":"Añadir comentario","start":{"add":"Está a punto de añadir asignaciones en","block":"Está a punto de bloquear asignaciones en","submit":"Está a punto de actualizar asignaciones en","request":"Está a punto de solicitar cambios en las asignaciones en","requestBlock":"Está a punto de solicitar el bloqueo de asignaciones en"}},"buttons":{"accept":"Aceptar","cancel":"Cancelar"}},"validator":{"validateDates":{"dateBefore":"La fecha final ha de ser posterior a la fecha inicial"}},"manageAllocationFormHeader":{"endDate":"Fecha final","startDate":"Fecha inicial","releaseBy":"Retrocedido por","releaseType":"Tipo de retrocesiión","afterRelease":"Estado tras la retrocesión","numberOfUnits":"Número de unidades","allocationType":"Tipo de asignación","releaseDaysDate":"Fecha/Días de retrocesión"},"statFilters":{"datepickers":{"booking":{"label":"Período de la reserva","heading":"Período de la reserva"},"arrival":{"label":"Fecha de llegada","heading":"Fecha de llegada"}}},"manageAllocationModalOverlayForm":{"info":"Puede modificar el número de unidades así como la fecha/los días de retrocesión. Sólo se puede bloquear una vez las unidades han sido retrocedidas.","units":"Modificar el número de unidades","status":"Modificar el estatus","denied":"No le está permitido realizar cambios en las asignaciones","success":"Las asignaciones se han actualizado con éxito.","blocked":"¡ATENCIÓN! Este producto está bloqueado y no se procesará ningún cambio.","warning":"¡ATENCIÓN! Este producto se ha retrocedido. Puede bloquearlo o añadir nuevas asignaciones desde la página anterior.","request":"¡ATENCIÓN! Estos cambios no se pueden aplicar directamente. Puede solicitar la modificación, la cual será revisada por el Gestor del Contrato. El proceso puede tardar hasta 5 días hábiles.","released":"¡ATENCIÓN! Este producto se ha retrocedido.  ","instruction":"¿Necesita ayuda?","labels":{"type":"Tipo de asignación","units":"Unidades iniciales","cancel":"Cancelar","period":"Período","bookings":"Reservas en el período","releaseDate":"Fecha de retrocesión","releaseDays":"Días de retrocesión","releaseType":"Tipo de retrocesión","arrivalRules":"Norma(s) de llegada en el periodo","releaseMethod":"Método de retrocesión","noArrivalRules":"No ha definido ninguna norma de llegada para este periodo","bookingsMaxCount":"Número máximo de reservas en el período","arrivalTypes":{"label":"Tipo","arrival":"Llegada ","departure":"Salida"},"arrivalRuleStayLength":"Duración de la estancia en días","bookingsMaxCountToolTip":"El número máximo de reservas en un día concreto dentro del periodo de asignación"},"release":{"date":"Cambiar la fecha de retrocesión","null":"No hay fecha de retrocesión","days":"Cambiar los días de retrocesión"},"accept":{"block":"Bloquear asignación","submit":"Actualizar asignación","update":"Actualizar asignación","request":"Solicite actualizar la asignación","requestBlock":"Solicite bloquear la asignación"},"pending":{"days":"días","units":"unidades","label":"Hay solicitudes pendientes","requested":"Solicitado"},"buttons":{"reset":"Reiniciar","block":"Bloquear","cancel":"Cancelar","update":"Actualizar","request":"Solicitar","requestBlock":"Solicitar bloqueo"},"editable":{"type":"Modificar el tipo de asignación","units":"Modificar el número de asignaciones","releaseDate":"Modificar la fecha de retrocesión","releaseType":"Modificar el tipo de retrocesión","releaseDays":"Modificar los días de retrocesión","information":{"default":"Los campos que se pueden editar se muestran con el símbolo de edición. Marque el campo para abrir la caja de edición. Puede realizar múltiples cambios antes de presionar actualizar, si presiona reiniciar descarta los cambios realizados."}},"requestPending":"¡ATENCIÓN! No puede realizar cambios en este período ya que hay solicitudes pendients.","requestMessage":"¡ATENCIÓN! Estos cambios no se pueden aplicar directamente. Puede solicitar la modificación, la cual será revisada por el Gestor del Contrato en un plazo de 24 horas entre semana.","changesRequested":"No puede modificar la asignación ya que hay solicitudes pendientes","instructionTrusted":"Una vez salvado un cambio se aplicará directamente a la asignación y será visible para todas nuestras marcas.<br/> Tenga en cuenta que pueden haber limitaciones a estos cambios, por ejemplo, no puede reducir el número de asignaciones por debajo del número de reservas realizadas en la asignación.","validator":{"days":{"set":"Los días de retrocesión deben ser introducidos con un valor superior a 0","lower":"No está autorizado para incrementar los días de retrocesión"},"date":{"set":"La fecha de retrocesión debe introducirse en un formato válido DD/MM/AAAA","lower":"No puede adelantar la fecha de retrocesión","before":"La fecha de retrocesión debe ser igual o inferior a la fecha de inicio de la asignación","beforeEnd":"La fecha de retrocesión debe ser igual o inferior a la fecha final de la asignación"},"units":{"set":"El número de unidades debe estar entre 1 y 10"}},"instructionNotTrusted":"Una vez salvado un cambio se aplicará directamente a la asignación y será visible para todas nuestras marcas.<br/> No le está permitido reducir la asignación, cambiar el estado a bajo petición o bloquear directamente asignaciones que no se hayan retrocecido, si desea hacer este tipo de cambios puede enviar una solicitud.<br/><br/>Su Gerente de Contrato revisa y gestiona las solicitudes en un plazo de 5 días hábiles. "},"manageAllocationCalendarWeekdays":{"sunday":"Do","monday":"Lu","friday":"Vi","tuesday":"Ma","thursday":"Ju","saturday":"Sa","wednesday":"Mi"},"manageAllocationModalCalendarElement":{"units":"Unidades iniciales:","bookings":"Reservas:","request":{"days":"días","type":"Tipo de cambio:","units":"unidad(es)","header":"Solicitar cambios","deduct":"Deducir:","release":"Modificar retrocesión"}},"manageAllocationModalOverlay":{"header":{"heading":"Modificar asignaciones"}},"manageAllocationModalCalendarInfobox":{"header":{"heading":"Cuadro de información del calendario"}}}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = {"valid":false,"tips":{"hi":"Hi","help":"Heeft u hulp nodig?","more":"meer","less":"minder","camping":"Contacteer Camping Vision IT","adminPage":{"edit":{"body":"-/-","title":"-/-"},"block":{"body":"-/-","title":"-/-"},"create":{"body":"-/-","title":"-/-"}},"statPage":{"boxes":{"body":"De vier vakjes bovenaan de pagina tonen de inkomsten en boekingen. De grijze vakjes tonen dit voor het gehele seizoen en de blauwe voor de geselecteerde periode.","title":"De vier vakjes bovenaan de pagina"},"graph":{"body":"De grafiek links toont de best verkopende campings. U kunt op een camping klikken om deze te selecteren. De best scorende accommodaties worden dan in de grafiek rechts getoond.","title":"De grafieken"},"filter":{"body":"U kunt filteren op boekingsperiode en op aankomstperiode om de getoonde periode te verruimen of te beperken.","title":"Boekingsperiode / Aankomstperiode"}},"dashboardPage":{"add":{"body":"-/-","title":"-/-"},"graph":{"body":"-/-","title":"-/-"},"filter":{"body":"-/-","title":"-/-"},"notifications":{"body":"-/-","title":"-/-"}},"bookingPage":{"search":{"body":"-/-","title":"-/-"},"filters":{"body":"-/-","title":"-/-"},"sortList":{"body":"-/-","title":"-/-"},"xlsError":{"body":"-/-","title":"-/-"},"downloadList":{"body":"-/-","title":"-/-"}},"allocationPage":{"sort":{"body":"-/-","title":"-/-"},"site":{"body":"-/-","title":"-/-"},"update":{"body":"-/-","title":"-/-"},"updateBy":{"body":"-/-","title":"-/-"}},"accountPage":{"password":{"body":"-/-","title":"-/-"},"activity":{"body":"-/-","title":"-/-"},"information":{"body":"-/-","title":"-/-"},"notifications":{"body":"-/-","title":"-/-"}},"manageAllocationPage":{"error":"-/-","year":{"body":"-/-","title":"-/-"},"info":{"body":"-/-","title":"-/-"},"modal":{"body":"-/-","title":"-/-"},"extra":{"body":"-/-","title":"-/-"},"select":{"body":"-/-","title":"-/-"},"display":{"body":"-/-","title":"-/-"},"overview":{"body":"-/-","title":"-/-"},"accommodation":{"body":"-/-","title":"-/-"},"alert":{"requestError":"-/-","requestAccept":"-/-","requestDenied":"-/-","requestUnauthorized":"-/-"}},"contractManagementPage":{"upload":{"body":"-/-","title":"-/-"},"expand":{"body":"-/-","title":"-/-"},"progress":{"body":"-/-","title":"-/-"},"indicator":{"body":"-/-","title":"-/-"}}},"adminItem":{"id":"-/-","edit":"-/-","email":"-/-","status":"-/-","lastName":"-/-","firstName":"-/-"},"admin":{"list":{"id":"-/-","edit":"-/-","email":"-/-","status":"-/-","noUsers":"-/-","content":"-/-","lastname":"-/-","firstname":"-/-","header":{"heading":"-/-"}},"alert":{"email":"-/-","error":"-/-","updated":"-/-","deleted":"-/-","created":"-/-","blocked":"-/-","password":"-/-","unblocked":"-/-","notifications":"-/-","wrongPassword":"-/-"},"profile":{"and":"-/-","email":"-/-","weekly":"-/-","notice":"-/-","receive":"-/-","language":"-/-","noNotice":"-/-","everyday":"-/-","fullName":"-/-","fortnightly":"-/-","header":{"heading":"-/-"},"notifications":{"edit":"-/-","weekly":"-/-","cancel":"-/-","update":"-/-","fortnightly":"-/-","days":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","saturday":"-/-","thursday":"-/-","wednesday":"-/-"},"heading":{"header":"-/-"}}},"form":{"create":"-/-","edit":{"edit":"-/-","block":"-/-","delete":"-/-","unblock":"-/-"},"error":{"edit":"-/-","email":"-/-","error":"-/-"}},"heading":{"header":"-/-"},"edit":{"form":{"info":"-/-","roles":"-/-","lastname":"-/-","language":"-/-","firstname":"-/-","button":{"submit":"-/-"},"notifications":"-/-","buttons":{"block":"-/-","update":"-/-","delete":"-/-","unblock":"-/-"},"warning":{"blocked":"-/-","inactive":"-/-"},"validator":{"lastname":"-/-","firstname":"-/-"}},"header":{"heading":"-/-"},"accept":{"header":{"block":"-/-","update":"-/-","delete":"-/-","unblock":"-/-"},"content":{"block":"-/-","delete":"-/-","update":"-/-","unblock":"-/-"},"buttons":{"accept":"-/-","cancel":"-/-"}}},"create":{"form":{"tip":"-/-","roles":"-/-","email":"-/-","language":"-/-","lastname":"-/-","firstname":"-/-","button":{"submit":"-/-"},"validator":{"email":"-/-","lastname":"-/-","firstname":"-/-"}},"button":{"submit":"-/-"},"accept":{"header":"-/-","content":"-/-","buttons":{"cancel":"-/-","accept":"-/-"}},"header":{"heading":"-/-"}}},"signIn":{"button":"-/-","heading":"-/-","description":"-/-","logoutNotice":"-/-","invalidNotice":"-/-","pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"inactivityNotice":"-/-","email":{"placeholder":"-/-","errors":{"email":"-/-","required":"-/-"}},"messages":{"mismatch":"-/-","unexpected":"-/-"},"forgotPasswordLink":"-/-"},"booking":{"button":"-/-","heading":"-/-","filterText":"-/-","dateTypes":["-/-","-/-"],"placeholder":"-/-","description":"-/-","tableFields":{"#":"-/-","reset":"-/-","status":"-/-","domain":"-/-","duration":"-/-","siteName":"-/-","bookingRef":"-/-","bookingDate":"-/-","arrivalDate":"-/-","supplierRef":"-/-","supplierName":"-/-","customerName":"-/-","departureDate":"-/-","accommodation":"-/-"},"messages":{"error":"-/-","expired":"-/-"},"filterOptions":{"site":"-/-","option":"-/-","domain":"-/-","default":"-/-","bookingAgent":"-/-","accommodation":"-/-","bookingCountry":"-/-"}},"account":{"form":{"id":"-/-","email":"-/-","lastName":"-/-","firstName":"-/-","buttons":{"reset":"-/-","update":"-/-"},"heading":{"header":"-/-"},"accountType":{"label":"-/-","admin":{"true":"-/-","false":"-/-"}},"validator":{"required":"-/-"},"placeholder":{"lastName":"-/-","firstName":"-/-"}},"activity":{"site":"-/-","date":"-/-","limit":"-/-","type":{"label":"-/-","request":"-/-","allocation":"-/-"},"status":{"label":"-/-","RELEASED":"-/-","USER_EDIT":"-/-","USER_INSERT":"-/-"},"header":{"months":"-/-","heading":"-/-"},"accommodation":"-/-"},"password":{"password":"-/-","rePassword":"-/-","newPassword":"-/-","buttons":{"reset":"-/-","update":"-/-"},"heading":{"header":"-/-"},"validator":{"mismatch":"-/-","password":"-/-"},"placeholder":{"password":"-/-"}}},"statList":{"heading":"-/-","predicate":"-/-","backButton":"-/-"},"bookingItem":{"site":"-/-","status":"-/-","domain":"-/-","duration":"-/-","bookingRef":"-/-","arrivalDate":"-/-","supplierRef":"-/-","bookingDate":"-/-","supplierName":"-/-","customerName":"-/-","departureDate":"-/-","accommodation":"-/-"},"notFound":{"heading":"-/-"},"introduction":{"body":"-/-","error":"-/-","warning":"-/-","noContent":"-/-","footer":{"title":"-/-","contact":{"tel":"-/-","city":"-/-","title":"-/-","email":"-/-","street":"-/-","country":"-/-","address":"-/-"}},"header":{"error":"-/-","warning":"-/-","heading":"-/-","noContent":"-/-"}},"statSites":{"heading":"-/-","dropdown":{"label":"-/-"},"noContent":{"error":"-/-","missing":"-/-"},"predicate":{"revenue":"-/-","bookings":"-/-"},"alternativeHeading":"-/-"},"bookingList":{"order":"-/-","error":"-/-","title":"-/-","search":"-/-","heading":"-/-","perPage":"-/-","orderBy":"-/-","noContent":"-/-","xslTooltip":"-/-","display":{"all":"-/-","label":"-/-","current":"-/-","historical":"-/-"},"placeholder":"-/-","download":{"xls":"-/-","csv":"-/-"},"orderFields":{"asc":"-/-","desc":"-/-"}},"instruction":{"dismiss":"-/-","defaultHeader":"-/-","contract":{"body":"-/-"},"contractList":{"body":"-/-","header":"-/-"}},"topMenu":{"right":{"admin":"-/-","logout":"-/-","account":"-/-"},"left":{"welcome":"-/-"}},"allocationItem":{"site":"-/-","supplier":"-/-","updatedAt":"-/-","updatedBy":"-/-"},"activateUser":{"button":"-/-","heading":"-/-","description":"-/-","messages":{"token":"-/-","success":"-/-","mismatch":"-/-","unexpected":"-/-"},"pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"passCheck":{"placeholder":"-/-","errors":{"required":"-/-","mismatch":"-/-"}}},"contract":{"form":{"email":"-/-","alert":"-/-","accept":"-/-","complete":"-/-","sites":{"view":"-/-","city":"-/-","email":"-/-","phone":"-/-","rating":"-/-","address":"-/-","country":"-/-","zipCode":"-/-","website":"-/-","noContent":"-/-","header":{"heading":"-/-"},"facilities":{"size":"-/-","number":"-/-","header":"-/-","endDate":"-/-","distance":"-/-","startDate":"-/-","dataHeader":"-/-"}},"acceptPart":"-/-","sendAccept":"-/-","extras":{"rule":"-/-","sell":"-/-","ageTo":"-/-","price":"-/-","person":"-/-","noData":"-/-","endDate":"-/-","ageFrom":"-/-","arrival":"-/-","per":{"stay":"-/-","week":"-/-","hour":"-/-","night":"-/-","piece":"-/-","person":"-/-","personNight":"-/-","accommodation":"-/-"},"netPrice":"-/-","startDate":"-/-","departure":"-/-","noContent":"-/-","commission":"-/-","description":"-/-","type":{"person":"-/-","optional":"-/-","inclusive":"-/-","mandatory":"-/-","information":"-/-"},"payment":{"ignore":"-/-","arrival":"-/-","booking":"-/-","bookingArrival":"-/-"},"header":{"heading":"-/-"}},"partAccepted":"-/-","notes":{"toggle":"-/-","placeholder":"-/-","header":{"heading":"-/-"},"sendBeforeLeave":"-/-","sendEmailToContractManager":"-/-"},"control":{"save":"-/-","cancel":"-/-","accept":"-/-","accepted":"-/-"},"prices":{"price":"-/-","endDate":"-/-","noContent":"-/-","startDate":"-/-","commission":"-/-","header":{"heading":"-/-"},"setting":{"pricePr":{"unit":"-/-","person":"-/-"},"grossOrNet":{"net":"-/-","gross":"-/-"},"priceType":{"singleDay":"-/-"}}},"progress":{"label":"-/-","part":{"terms":"-/-","sites":"-/-","extras":"-/-","prices":"-/-","discounts":"-/-","allocations":"-/-","arrivalRules":"-/-","supplierInfo":"-/-","accommodations":"-/-","cancellationRules":"-/-"},"header":{"heading":"-/-"}},"unknownProduct":"-/-","discounts":{"name":"-/-","types":"-/-","noDate":"-/-","endDate":"-/-","startDate":"-/-","noContent":"-/-","header":{"heading":"-/-"},"arrivalDeparture":"-/-"},"missingContract":"-/-","message":{"initiated":"-/-"},"arrivalRules":{"days":"-/-","arrival":"-/-","endDate":"-/-","noContent":"-/-","minRental":"-/-","maxRental":"-/-","departure":"-/-","startDate":"-/-","type":{"label":"-/-","arrival":"-/-","departure":"-/-"},"header":{"heading":"-/-"},"weekdays":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"}},"allocations":{"units":"-/-","noData":"-/-","endDate":"-/-","startDate":"-/-","noContent":"-/-","type":{"label":"-/-","BLOCKED":"-/-","REQUEST":"-/-","FREESALE":"-/-","GUARANTEE":"-/-","ALLOTMENT":"-/-"},"releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-","header":{"heading":"-/-"}},"accommodations":{"view":"-/-","noData":"-/-","category":"-/-","maxAdults":"-/-","noContent":"-/-","maxPersons":"-/-","minFullPay":"-/-","childrenAges":"-/-","header":{"heading":"-/-"},"subGroups":{"header":"-/-"},"childrenAgesInfo":"-/-","childOutsideAllowed":"-/-","childOutsideAllowedInfo":"-/-"},"terms":{"heading":{"header":"-/-"}},"cancellationRules":{"noShow":"-/-","heading":"-/-","labels":{"days":"-/-","percent":"-/-"}},"supplierInfo":{"bankInfo":{"bic":"-/-","info":"-/-","name":"-/-","bank":"-/-","iban":"-/-","email":"-/-","terms":"-/-","method":"-/-","heading":"-/-","account":"-/-","bankCurrency":"-/-","priceCurrency":"-/-"},"contactInfo":{"name":"-/-","city":"-/-","email":"-/-","phone":"-/-","heading":"-/-","website":"-/-","country":"-/-","address":"-/-","zipCode":"-/-"},"bookingInfo":{"heading":"-/-","amendEmail":"-/-","bookingPhone":"-/-","bookingEmail":"-/-","requestEmail":"-/-","bookingPerson":"-/-","complaintPhone":"-/-","complaintEmail":"-/-","complaintPerson":"-/-","cancellationEmail":"-/-","confirmationEmail":"-/-"}}},"alert":{"saved":"-/-","error":"-/-","noFile":"-/-","removed":"-/-","supplier":"-/-","notFound":"-/-","emailSent":"-/-","completed":"-/-","illegalSize":"-/-","unsupportedType":"-/-","emailAlreadySent":"-/-"}},"resetPassword":{"button":"-/-","heading":"-/-","description":"-/-","messages":{"token":"-/-","success":"-/-","mismatch":"-/-","unexpected":"-/-"},"pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"passCheck":{"placeholder":"-/-","errors":{"mismatch":"-/-","required":"-/-"}}},"allocationList":{"order":"-/-","orderBy":"-/-","perPage":"-/-","heading":"-/-","button":{"update":"-/-"},"messages":{"error":"-/-","noContent":"-/-","unauthorized":"-/-"},"orderFields":{"asc":"-/-","desc":"-/-"},"tableFields":{"site":"-/-","name":"-/-","supplier":"-/-","updatedBy":"-/-","updatedAt":"-/-","pendingRequests":"-/-"}},"dashboard":{"graph":{"label":"-/-","footer":"-/-"},"tricks":{"click":"-/-","welcome":"-/-","statistics":{"link":"-/-","message":"-/-"},"allocation":{"link":"-/-","message":"-/-"}},"suppliers":{"label":"-/-"},"date":{"days":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"}},"availability":{"all":"-/-","select":"-/-","request":"-/-","blocked":"-/-","overview":"-/-","noContent":"-/-","available":"-/-"},"notifications":{"limit":"-/-","noContent":"-/-","list":{"site":"-/-","link":"-/-","date":"-/-","dismiss":"-/-","status":{"stay":"-/-","label":"-/-","arrival":"-/-","soldOut":"-/-","released":"-/-"},"contractLink":"-/-","header":{"count":"-/-","heading":"-/-","contractHeading":"-/-"},"accommodation":"-/-"},"filters":{"sites":{"all":"-/-","label":"-/-"},"predicate":{"all":"-/-","stay":"-/-","label":"-/-","arrival":"-/-","soldOut":"-/-","released":"-/-"},"accommodations":{"all":"-/-","label":"-/-"}}},"alert":{"dismiss":{"error":"-/-","success":"-/-","noContent":"-/-"}}},"statInventory":{"heading":"-/-","dropdown":{"label":"-/-"},"noContent":{"error":"-/-","missing":"-/-"},"predicate":{"revenue":"-/-","bookings":"-/-"},"alternativeHeading":"-/-"},"forgotPassword":{"button":"-/-","heading":"-/-","signInLink":"-/-","description":"-/-","messages":{"noexist":"-/-","success":"-/-","unexpected":"-/-"},"email":{"placeholder":"-/-","errors":{"email":"-/-","required":"-/-"}}},"bookingFilters":{"site":{"all":"-/-","label":"-/-"},"brand":{"all":"-/-","label":"-/-"},"status":{"all":"-/-","label":"-/-","types":{"booked":"-/-","pending":"-/-","unknown":"-/-","request":"-/-","rejected":"-/-","cancelled":"-/-","request-cancel":"-/-"}},"domain":{"all":"-/-","label":"-/-"},"country":{"all":"-/-","label":"-/-"},"supplier":{"all":"-/-","label":"-/-"},"accommodation":{"all":"-/-","label":"-/-"},"arrivalPeriod":{"label":"-/-","datepicker":{"heading":"-/-"}},"bookingPeriod":{"label":"-/-","datepicker":{"heading":"-/-"}}},"navigation-menu":{"language":"-/-","items":{"stats":"-/-","booking":"-/-","supplier":"-/-","contract":"-/-","dashboard":"-/-","allocation":"-/-","productType":"-/-","products":{"Hotel":"-/-","Shuttle":"-/-","Camping":"-/-","Badeland":"-/-","Skiferie":"-/-","Krydstogt":"-/-","Disneyland":"-/-","Feriebolig":"-/-"}}},"manageAllocationList":{"error":"-/-","retry":"-/-","header":"-/-","list":{"to":"-/-","new":"-/-","type":"-/-","from":"-/-","edit":"-/-","block":"-/-","units":"-/-","release":"-/-","released":"-/-","updatedBy":"-/-","updatedAt":"-/-","releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-"},"noAllocations":"-/-"},"manageAllocationPage":{"error":"-/-","mobile":"-/-","request":{"cancel":{"unauth":"-/-","success":"-/-","failure":"-/-","noContent":"-/-"},"accept":{"success":"-/-","failure":"-/-"},"modify":{"failure":"-/-","success":"-/-"},"decline":{"failure":"-/-","success":"-/-"}}},"manageAllocationModal":{"info":"-/-","dash":"-/-","error":"-/-","period":"-/-","update":"-/-","loading":"-/-","success":"-/-","request":"-/-","blocked":"-/-","form":{"days":"-/-","date":"-/-","type":{"null":"-/-","blocked":"-/-","request":"-/-","freesale":"-/-","allotment":"-/-"},"units":{"null":"-/-","allotment":"-/-","notAllotment":"-/-"},"buttons":{"add":"-/-","create":"-/-","submit":"-/-","cancel":"-/-"},"releaseType":{"null":"-/-","request":"-/-","blocked":"-/-","freesale":"-/-","selectType":"-/-"},"releaseMethod":{"null":"-/-","date":"-/-","days":"-/-"}},"allocations":"-/-","buttons":{"add":"-/-"},"unauthorized":"-/-","noAllocations":"-/-","overlaySuccess":"-/-","header":{"heading":"-/-"}},"statNumber":{"body":{"noDataFound":"-/-","failedToFetchData":"-/-"}},"contractList":{"heading":{"header":"-/-"},"overview":{"error":"-/-","download":"-/-","noContracts":"-/-","heading":{"header":"-/-"},"status":{"initiated":"-/-","readyForSupplier":"-/-"}},"history":{"heading":{"header":"-/-"}}},"contractNotes":{"messages":{"goTo":"-/-","wrote":"-/-","supplier":"-/-","internal":"-/-","sendEmail":"-/-","noContent":"-/-","campingVision":"-/-","supplierEmail":"-/-","backOfficeEmail":"-/-","contractManagerEmail":"-/-"},"header":{"heading":"-/-","messages":"-/-"},"control":{"internal":"-/-","reference":"-/-","placeholder":"-/-"}},"manageAllocationFormRow":{"days":"-/-","dateFormat":"-/-","dropDown":{"date":"-/-","days":"-/-","request":"-/-","blocked":"-/-","freeSale":"-/-","allotment":"-/-","guarantee":"-/-","selectType":"-/-","chooseType":"-/-"}},"contractManagement":{"list":{"year":"-/-","edit":"-/-","view":"-/-","perPage":"-/-","supplier":"-/-","download":"-/-","show":{"all":"-/-","mine":"-/-","label":"-/-"},"updatedBy":"-/-","status":{"done":"-/-","basic":"-/-","label":"-/-","pending":"-/-","extended":"-/-","completed":"-/-","initiated":"-/-","notification":"-/-","readyForSupplier":"-/-","readyForBackOffice":"-/-","supplierNotifications":"-/-","readyForContractManager":"-/-","contractManagerNotifications":"-/-"},"noContracts":"-/-","display":{"all":"-/-","label":"-/-"},"lastUpdated":"-/-","viewSupplier":"-/-","heading":{"header":"-/-"}},"alert":{"error":"-/-","saved":"-/-","noFile":"-/-","removed":"-/-","notFound":"-/-","emailSent":"-/-","illegalSize":"-/-","noSitesFound":"-/-","unsupportedType":"-/-","validationError":"-/-","emailAlreadySent":"-/-","noAccommodationsFound":"-/-"},"edit":{"form":{"add":"-/-","save":"-/-","link":"-/-","copy":"-/-","create":"-/-","remove":"-/-","confirm":"-/-","noTitle":"-/-","optional":"-/-","checkbox":"-/-","download":"-/-","emailSent":"-/-","brands":{"info":"-/-"},"email":{"review":"-/-","supplier":"-/-","backOffice":"-/-"},"images":{"remove":"-/-","initial":"-/-","confirm":"-/-","accepted":"-/-","unsupported":"-/-"},"upload":{"remove":"-/-","confirm":"-/-","initial":"-/-","accepted":"-/-"},"complete":{"review":"-/-","contract":"-/-"},"subHeader":{"notes":"-/-","brands":"-/-","accInfo":"-/-","accepted":"-/-","siteInfo":"-/-","discounts":"-/-","commission":"-/-","priceExtra":"-/-","arrivalRules":"-/-","allotmentRules":"-/-","arrivalDeparture":"-/-"},"placeholder":{"notes":"-/-","discounts":"-/-","priceExtra":"-/-","commission":"-/-","arrivalRules":"-/-","accInfo":{"site":"-/-","text":"-/-","name":"-/-"},"siteInfo":{"text":"-/-","name":"-/-"},"allotmentRules":"-/-","arrivalDeparture":"-/-"},"autoComplete":{"multi":"-/-","accInfo":"-/-","siteInfo":"-/-"},"header":{"heading":{"done":"-/-","basic":"-/-","extended":"-/-"}}},"progress":{"done":"-/-","basic":"-/-","extended":"-/-","defaultText":"-/-","header":{"heading":"-/-"},"subHeader":{"notes":"-/-","brands":"-/-","accInfo":"-/-","accepted":"-/-","siteInfo":"-/-","discounts":"-/-","commission":"-/-","arrivalRules":"-/-","allotmentRules":"-/-","priceExtra":{"price":"-/-","extra":"-/-"},"arrivalDeparture":"-/-"}}},"noChangesConfirm":"-/-"},"manageAllocationForm":{"heading":"-/-","buttons":{"reset":"-/-","submit":"-/-"},"control-message":{"on":"-/-","content":"-/-"}},"manageAllocationFilters":{"year":"-/-"},"subPages":{"home":{"subTitleRevenue":"-/-","subTitleBookings":"-/-","labelTotalRevenue":"-/-","labelTotalBookings":"-/-","labelPeriodRevenue":"-/-","labelPeriodBookings":"-/-"}},"manageAllocationRequest":{"units":"-/-","toggle":"-/-","heading":"-/-","form":{"body":"-/-","period":{"title":"-/-"},"labels":{"units":"-/-","release":"-/-"},"header":{"heading":"-/-"},"buttons":{"cancel":"-/-","accept":"-/-"}},"noContent":"-/-","table":{"type":"-/-","block":"-/-","period":"-/-","release":"-/-","deduction":"-/-","requestDate":"-/-"},"releaseDays":"-/-","type":{"request":"-/-","blocked":"-/-","freesale":"-/-","allotment":"-/-","guaranteed":"-/-"},"buttons":{"deny":"-/-","edit":"-/-","cancel":"-/-","accept":"-/-"},"dropdown":{"label":"-/-","denied":"-/-","pending":"-/-","approved":"-/-","modified":"-/-"},"headings":{"modified":"-/-","accepted":"-/-","declined":"-/-","requested":"-/-"}},"manageAllocationModalList":{"new":"-/-","date":"-/-","edit":"-/-","days":"-/-","released":"-/-","block":{"true":"-/-","false":"-/-","blocked":"-/-"},"buttons":{"new":"-/-","edit":"-/-","block":"-/-"},"releaseType":{"null":"-/-","request":"-/-","blocked":"-/-","freesale":"-/-"},"header":{"bookingsInPeriod":"-/-","noBookingsInPeriod":"-/-"}},"manageAllocationCalendar":{"retry":"-/-","error":"-/-","months":["-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-"],"header":{"howTo":"-/-","heading":"-/-"},"dropdown":{"full":"-/-","months":"-/-"}},"datePicker":{"predefinedLinks":{"today":"-/-","thisWeek":"-/-","lastYear":"-/-","thisYear":"-/-","lastWeek":"-/-","lastMonth":"-/-","yesterday":"-/-","thisMonth":"-/-"}},"manageAllocationFormAccept":{"header":"-/-","alert":{"to":"-/-","end":"-/-","from":"-/-","start":"-/-"},"content":{"end":"-/-","note":"-/-","comment":"-/-","start":{"add":"-/-","block":"-/-","submit":"-/-","request":"-/-","requestBlock":"-/-"}},"buttons":{"accept":"-/-","cancel":"-/-"}},"validator":{"validateDates":{"dateBefore":"-/-"}},"manageAllocationFormHeader":{"endDate":"-/-","startDate":"-/-","releaseBy":"-/-","releaseType":"-/-","afterRelease":"-/-","numberOfUnits":"-/-","allocationType":"-/-","releaseDaysDate":"-/-"},"statFilters":{"datepickers":{"booking":{"label":"-/-","heading":"-/-"},"arrival":{"label":"-/-","heading":"-/-"}}},"manageAllocationModalOverlayForm":{"info":"-/-","units":"-/-","status":"-/-","denied":"-/-","success":"-/-","blocked":"-/-","warning":"-/-","request":"-/-","released":"-/-","instruction":"-/-","labels":{"type":"-/-","units":"-/-","cancel":"-/-","period":"-/-","bookings":"-/-","releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-","arrivalRules":"-/-","releaseMethod":"-/-","noArrivalRules":"-/-","bookingsMaxCount":"-/-","arrivalTypes":{"label":"-/-","arrival":"-/-","departure":"-/-"},"arrivalRuleStayLength":"-/-","bookingsMaxCountToolTip":"-/-"},"release":{"date":"-/-","null":"-/-","days":"-/-"},"accept":{"block":"-/-","submit":"-/-","update":"-/-","request":"-/-","requestBlock":"-/-"},"pending":{"days":"-/-","units":"-/-","label":"-/-","requested":"-/-"},"buttons":{"reset":"-/-","block":"-/-","cancel":"-/-","update":"-/-","request":"-/-","requestBlock":"-/-"},"editable":{"type":"-/-","units":"-/-","releaseDate":"-/-","releaseType":"-/-","releaseDays":"-/-","information":{"default":"-/-"}},"requestPending":"-/-","requestMessage":"-/-","changesRequested":"-/-","instructionTrusted":"-/-","validator":{"days":{"set":"-/-","lower":"-/-"},"date":{"set":"-/-","lower":"-/-","before":"-/-","beforeEnd":"-/-"},"units":{"set":"-/-"}},"instructionNotTrusted":"-/-"},"manageAllocationCalendarWeekdays":{"sunday":"-/-","monday":"-/-","friday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"},"manageAllocationModalCalendarElement":{"units":"-/-","bookings":"-/-","request":{"days":"-/-","type":"-/-","units":"-/-","header":"-/-","deduct":"-/-","release":"-/-"}},"manageAllocationModalOverlay":{"header":{"heading":"-/-"}},"manageAllocationModalCalendarInfobox":{"header":{"heading":"-/-"}}}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = {"valid":false,"tips":{"hi":"-/-","help":"-/-","more":"-/-","less":"-/-","camping":"-/-","adminPage":{"edit":{"body":"-/-","title":"-/-"},"block":{"body":"-/-","title":"-/-"},"create":{"body":"-/-","title":"-/-"}},"statPage":{"boxes":{"body":"-/-","title":"-/-"},"graph":{"body":"-/-","title":"-/-"},"filter":{"body":"-/-","title":"-/-"}},"dashboardPage":{"add":{"body":"-/-","title":"-/-"},"graph":{"body":"-/-","title":"-/-"},"filter":{"body":"-/-","title":"-/-"},"notifications":{"body":"-/-","title":"-/-"}},"bookingPage":{"search":{"body":"-/-","title":"-/-"},"filters":{"body":"-/-","title":"-/-"},"sortList":{"body":"-/-","title":"-/-"},"xlsError":{"body":"-/-","title":"-/-"},"downloadList":{"body":"-/-","title":"-/-"}},"allocationPage":{"sort":{"body":"-/-","title":"-/-"},"site":{"body":"-/-","title":"-/-"},"update":{"body":"-/-","title":"-/-"},"updateBy":{"body":"-/-","title":"-/-"}},"accountPage":{"password":{"body":"-/-","title":"-/-"},"activity":{"body":"-/-","title":"-/-"},"information":{"body":"-/-","title":"-/-"},"notifications":{"body":"-/-","title":"-/-"}},"manageAllocationPage":{"error":"-/-","year":{"body":"-/-","title":"-/-"},"info":{"body":"-/-","title":"-/-"},"modal":{"body":"-/-","title":"-/-"},"extra":{"body":"-/-","title":"-/-"},"select":{"body":"-/-","title":"-/-"},"display":{"body":"-/-","title":"-/-"},"overview":{"body":"-/-","title":"-/-"},"accommodation":{"body":"-/-","title":"-/-"},"alert":{"requestError":"-/-","requestAccept":"-/-","requestDenied":"-/-","requestUnauthorized":"-/-"}},"contractManagementPage":{"upload":{"body":"-/-","title":"-/-"},"expand":{"body":"-/-","title":"-/-"},"progress":{"body":"-/-","title":"-/-"},"indicator":{"body":"-/-","title":"-/-"}}},"adminItem":{"id":"-/-","edit":"-/-","email":"-/-","status":"-/-","lastName":"-/-","firstName":"-/-"},"admin":{"list":{"id":"-/-","edit":"-/-","email":"-/-","status":"-/-","noUsers":"-/-","content":"-/-","lastname":"-/-","firstname":"-/-","header":{"heading":"-/-"}},"alert":{"email":"-/-","error":"-/-","updated":"-/-","deleted":"-/-","created":"-/-","blocked":"-/-","password":"-/-","unblocked":"-/-","notifications":"-/-","wrongPassword":"-/-"},"profile":{"and":"-/-","email":"-/-","weekly":"-/-","notice":"-/-","receive":"-/-","language":"-/-","noNotice":"-/-","everyday":"-/-","fullName":"-/-","fortnightly":"-/-","header":{"heading":"-/-"},"notifications":{"edit":"-/-","weekly":"-/-","cancel":"-/-","update":"-/-","fortnightly":"-/-","days":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","saturday":"-/-","thursday":"-/-","wednesday":"-/-"},"heading":{"header":"-/-"}}},"form":{"create":"-/-","edit":{"edit":"-/-","block":"-/-","delete":"-/-","unblock":"-/-"},"error":{"edit":"-/-","email":"-/-","error":"-/-"}},"heading":{"header":"-/-"},"edit":{"form":{"info":"-/-","roles":"-/-","lastname":"-/-","language":"-/-","firstname":"-/-","button":{"submit":"-/-"},"notifications":"-/-","buttons":{"block":"-/-","update":"-/-","delete":"-/-","unblock":"-/-"},"warning":{"blocked":"-/-","inactive":"-/-"},"validator":{"lastname":"-/-","firstname":"-/-"}},"header":{"heading":"-/-"},"accept":{"header":{"block":"-/-","update":"-/-","delete":"-/-","unblock":"-/-"},"content":{"block":"-/-","delete":"-/-","update":"-/-","unblock":"-/-"},"buttons":{"accept":"-/-","cancel":"-/-"}}},"create":{"form":{"tip":"-/-","roles":"-/-","email":"-/-","language":"-/-","lastname":"-/-","firstname":"-/-","button":{"submit":"-/-"},"validator":{"email":"-/-","lastname":"-/-","firstname":"-/-"}},"button":{"submit":"-/-"},"accept":{"header":"-/-","content":"-/-","buttons":{"cancel":"-/-","accept":"-/-"}},"header":{"heading":"-/-"}}},"signIn":{"button":"-/-","heading":"-/-","description":"-/-","logoutNotice":"-/-","invalidNotice":"-/-","pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"inactivityNotice":"-/-","email":{"placeholder":"-/-","errors":{"email":"-/-","required":"-/-"}},"messages":{"mismatch":"-/-","unexpected":"-/-"},"forgotPasswordLink":"-/-"},"booking":{"button":"-/-","heading":"-/-","filterText":"-/-","dateTypes":["-/-","-/-"],"placeholder":"-/-","description":"-/-","tableFields":{"#":"-/-","reset":"-/-","status":"-/-","domain":"-/-","duration":"-/-","siteName":"-/-","bookingRef":"-/-","bookingDate":"-/-","arrivalDate":"-/-","supplierRef":"-/-","supplierName":"-/-","customerName":"-/-","departureDate":"-/-","accommodation":"-/-"},"messages":{"error":"-/-","expired":"-/-"},"filterOptions":{"site":"-/-","option":"-/-","domain":"-/-","default":"-/-","bookingAgent":"-/-","accommodation":"-/-","bookingCountry":"-/-"}},"account":{"form":{"id":"-/-","email":"-/-","lastName":"-/-","firstName":"-/-","buttons":{"reset":"-/-","update":"-/-"},"heading":{"header":"-/-"},"accountType":{"label":"-/-","admin":{"true":"-/-","false":"-/-"}},"validator":{"required":"-/-"},"placeholder":{"lastName":"-/-","firstName":"-/-"}},"activity":{"site":"-/-","date":"-/-","limit":"-/-","type":{"label":"-/-","request":"-/-","allocation":"-/-"},"status":{"label":"-/-","RELEASED":"-/-","USER_EDIT":"-/-","USER_INSERT":"-/-"},"header":{"months":"-/-","heading":"-/-"},"accommodation":"-/-"},"password":{"password":"-/-","rePassword":"-/-","newPassword":"-/-","buttons":{"reset":"-/-","update":"-/-"},"heading":{"header":"-/-"},"validator":{"mismatch":"-/-","password":"-/-"},"placeholder":{"password":"-/-"}}},"statList":{"heading":"-/-","predicate":"-/-","backButton":"-/-"},"bookingItem":{"site":"-/-","status":"-/-","domain":"-/-","duration":"-/-","bookingRef":"-/-","arrivalDate":"-/-","supplierRef":"-/-","bookingDate":"-/-","supplierName":"-/-","customerName":"-/-","departureDate":"-/-","accommodation":"-/-"},"notFound":{"heading":"-/-"},"introduction":{"body":"-/-","error":"-/-","warning":"-/-","noContent":"-/-","footer":{"title":"-/-","contact":{"tel":"-/-","city":"-/-","title":"-/-","email":"-/-","street":"-/-","country":"-/-","address":"-/-"}},"header":{"error":"-/-","warning":"-/-","heading":"-/-","noContent":"-/-"}},"statSites":{"heading":"-/-","dropdown":{"label":"-/-"},"noContent":{"error":"-/-","missing":"-/-"},"predicate":{"revenue":"-/-","bookings":"-/-"},"alternativeHeading":"-/-"},"bookingList":{"order":"-/-","error":"-/-","title":"-/-","search":"-/-","heading":"-/-","perPage":"-/-","orderBy":"-/-","noContent":"-/-","xslTooltip":"-/-","display":{"all":"-/-","label":"-/-","current":"-/-","historical":"-/-"},"placeholder":"-/-","download":{"xls":"-/-","csv":"-/-"},"orderFields":{"asc":"-/-","desc":"-/-"}},"instruction":{"dismiss":"-/-","defaultHeader":"-/-","contract":{"body":"-/-"},"contractList":{"body":"-/-","header":"-/-"}},"topMenu":{"right":{"admin":"-/-","logout":"-/-","account":"-/-"},"left":{"welcome":"-/-"}},"allocationItem":{"site":"-/-","supplier":"-/-","updatedAt":"-/-","updatedBy":"-/-"},"activateUser":{"button":"-/-","heading":"-/-","description":"-/-","messages":{"token":"-/-","success":"-/-","mismatch":"-/-","unexpected":"-/-"},"pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"passCheck":{"placeholder":"-/-","errors":{"required":"-/-","mismatch":"-/-"}}},"contract":{"form":{"email":"-/-","alert":"-/-","accept":"-/-","complete":"-/-","sites":{"view":"-/-","city":"-/-","email":"-/-","phone":"-/-","rating":"-/-","address":"-/-","country":"-/-","zipCode":"-/-","website":"-/-","noContent":"-/-","header":{"heading":"-/-"},"facilities":{"size":"-/-","number":"-/-","header":"-/-","endDate":"-/-","distance":"-/-","startDate":"-/-","dataHeader":"-/-"}},"acceptPart":"-/-","sendAccept":"-/-","extras":{"rule":"-/-","sell":"-/-","ageTo":"-/-","price":"-/-","person":"-/-","noData":"-/-","endDate":"-/-","ageFrom":"-/-","arrival":"-/-","per":{"stay":"-/-","week":"-/-","hour":"-/-","night":"-/-","piece":"-/-","person":"-/-","personNight":"-/-","accommodation":"-/-"},"netPrice":"-/-","startDate":"-/-","departure":"-/-","noContent":"-/-","commission":"-/-","description":"-/-","type":{"person":"-/-","optional":"-/-","inclusive":"-/-","mandatory":"-/-","information":"-/-"},"payment":{"ignore":"-/-","arrival":"-/-","booking":"-/-","bookingArrival":"-/-"},"header":{"heading":"-/-"}},"partAccepted":"-/-","notes":{"toggle":"-/-","placeholder":"-/-","header":{"heading":"-/-"},"sendBeforeLeave":"-/-","sendEmailToContractManager":"-/-"},"control":{"save":"-/-","cancel":"-/-","accept":"-/-","accepted":"-/-"},"prices":{"price":"-/-","endDate":"-/-","noContent":"-/-","startDate":"-/-","commission":"-/-","header":{"heading":"-/-"},"setting":{"pricePr":{"unit":"-/-","person":"-/-"},"grossOrNet":{"net":"-/-","gross":"-/-"},"priceType":{"singleDay":"-/-"}}},"progress":{"label":"-/-","part":{"terms":"-/-","sites":"-/-","extras":"-/-","prices":"-/-","discounts":"-/-","allocations":"-/-","arrivalRules":"-/-","supplierInfo":"-/-","accommodations":"-/-","cancellationRules":"-/-"},"header":{"heading":"-/-"}},"unknownProduct":"-/-","discounts":{"name":"-/-","types":"-/-","noDate":"-/-","endDate":"-/-","startDate":"-/-","noContent":"-/-","header":{"heading":"-/-"},"arrivalDeparture":"-/-"},"missingContract":"-/-","message":{"initiated":"-/-"},"arrivalRules":{"days":"-/-","arrival":"-/-","endDate":"-/-","noContent":"-/-","minRental":"-/-","maxRental":"-/-","departure":"-/-","startDate":"-/-","type":{"label":"-/-","arrival":"-/-","departure":"-/-"},"header":{"heading":"-/-"},"weekdays":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"}},"allocations":{"units":"-/-","noData":"-/-","endDate":"-/-","startDate":"-/-","noContent":"-/-","type":{"label":"-/-","BLOCKED":"-/-","REQUEST":"-/-","FREESALE":"-/-","GUARANTEE":"-/-","ALLOTMENT":"-/-"},"releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-","header":{"heading":"-/-"}},"accommodations":{"view":"-/-","noData":"-/-","category":"-/-","maxAdults":"-/-","noContent":"-/-","maxPersons":"-/-","minFullPay":"-/-","childrenAges":"-/-","header":{"heading":"-/-"},"subGroups":{"header":"-/-"},"childrenAgesInfo":"-/-","childOutsideAllowed":"-/-","childOutsideAllowedInfo":"-/-"},"terms":{"heading":{"header":"-/-"}},"cancellationRules":{"noShow":"-/-","heading":"-/-","labels":{"days":"-/-","percent":"-/-"}},"supplierInfo":{"bankInfo":{"bic":"-/-","info":"-/-","name":"-/-","bank":"-/-","iban":"-/-","email":"-/-","terms":"-/-","method":"-/-","heading":"-/-","account":"-/-","bankCurrency":"-/-","priceCurrency":"-/-"},"contactInfo":{"name":"-/-","city":"-/-","email":"-/-","phone":"-/-","heading":"-/-","website":"-/-","country":"-/-","address":"-/-","zipCode":"-/-"},"bookingInfo":{"heading":"-/-","amendEmail":"-/-","bookingPhone":"-/-","bookingEmail":"-/-","requestEmail":"-/-","bookingPerson":"-/-","complaintPhone":"-/-","complaintEmail":"-/-","complaintPerson":"-/-","cancellationEmail":"-/-","confirmationEmail":"-/-"}}},"alert":{"saved":"-/-","error":"-/-","noFile":"-/-","removed":"-/-","supplier":"-/-","notFound":"-/-","emailSent":"-/-","completed":"-/-","illegalSize":"-/-","unsupportedType":"-/-","emailAlreadySent":"-/-"}},"resetPassword":{"button":"-/-","heading":"-/-","description":"-/-","messages":{"token":"-/-","success":"-/-","mismatch":"-/-","unexpected":"-/-"},"pass":{"placeholder":"-/-","errors":{"required":"-/-"}},"passCheck":{"placeholder":"-/-","errors":{"mismatch":"-/-","required":"-/-"}}},"allocationList":{"order":"-/-","orderBy":"-/-","perPage":"-/-","heading":"-/-","button":{"update":"-/-"},"messages":{"error":"-/-","noContent":"-/-","unauthorized":"-/-"},"orderFields":{"asc":"-/-","desc":"-/-"},"tableFields":{"site":"-/-","name":"-/-","supplier":"-/-","updatedBy":"-/-","updatedAt":"-/-","pendingRequests":"-/-"}},"dashboard":{"graph":{"label":"-/-","footer":"-/-"},"tricks":{"click":"-/-","welcome":"-/-","statistics":{"link":"-/-","message":"-/-"},"allocation":{"link":"-/-","message":"-/-"}},"suppliers":{"label":"-/-"},"date":{"days":{"friday":"-/-","monday":"-/-","sunday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"}},"availability":{"all":"-/-","select":"-/-","request":"-/-","blocked":"-/-","overview":"-/-","noContent":"-/-","available":"-/-"},"notifications":{"limit":"-/-","noContent":"-/-","list":{"site":"-/-","link":"-/-","date":"-/-","dismiss":"-/-","status":{"stay":"-/-","label":"-/-","arrival":"-/-","soldOut":"-/-","released":"-/-"},"contractLink":"-/-","header":{"count":"-/-","heading":"-/-","contractHeading":"-/-"},"accommodation":"-/-"},"filters":{"sites":{"all":"-/-","label":"-/-"},"predicate":{"all":"-/-","stay":"-/-","label":"-/-","arrival":"-/-","soldOut":"-/-","released":"-/-"},"accommodations":{"all":"-/-","label":"-/-"}}},"alert":{"dismiss":{"error":"-/-","success":"-/-","noContent":"-/-"}}},"statInventory":{"heading":"-/-","dropdown":{"label":"-/-"},"noContent":{"error":"-/-","missing":"-/-"},"predicate":{"revenue":"-/-","bookings":"-/-"},"alternativeHeading":"-/-"},"forgotPassword":{"button":"-/-","heading":"-/-","signInLink":"-/-","description":"-/-","messages":{"noexist":"-/-","success":"-/-","unexpected":"-/-"},"email":{"placeholder":"-/-","errors":{"email":"-/-","required":"-/-"}}},"bookingFilters":{"site":{"all":"-/-","label":"-/-"},"brand":{"all":"-/-","label":"-/-"},"status":{"all":"-/-","label":"-/-","types":{"booked":"-/-","pending":"-/-","unknown":"-/-","request":"-/-","rejected":"-/-","cancelled":"-/-","request-cancel":"-/-"}},"domain":{"all":"-/-","label":"-/-"},"country":{"all":"-/-","label":"-/-"},"supplier":{"all":"-/-","label":"-/-"},"accommodation":{"all":"-/-","label":"-/-"},"arrivalPeriod":{"label":"-/-","datepicker":{"heading":"-/-"}},"bookingPeriod":{"label":"-/-","datepicker":{"heading":"-/-"}}},"navigation-menu":{"language":"-/-","items":{"stats":"-/-","booking":"-/-","supplier":"-/-","contract":"-/-","dashboard":"-/-","allocation":"-/-","productType":"-/-","products":{"Hotel":"-/-","Shuttle":"-/-","Camping":"-/-","Badeland":"-/-","Skiferie":"-/-","Krydstogt":"-/-","Disneyland":"-/-","Feriebolig":"-/-"}}},"manageAllocationList":{"error":"-/-","retry":"-/-","header":"-/-","list":{"to":"-/-","new":"-/-","type":"-/-","from":"-/-","edit":"-/-","block":"-/-","units":"-/-","release":"-/-","released":"-/-","updatedBy":"-/-","updatedAt":"-/-","releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-"},"noAllocations":"-/-"},"manageAllocationPage":{"error":"-/-","mobile":"-/-","request":{"cancel":{"unauth":"-/-","success":"-/-","failure":"-/-","noContent":"-/-"},"accept":{"success":"-/-","failure":"-/-"},"modify":{"failure":"-/-","success":"-/-"},"decline":{"failure":"-/-","success":"-/-"}}},"manageAllocationModal":{"info":"-/-","dash":"-/-","error":"-/-","period":"-/-","update":"-/-","loading":"-/-","success":"-/-","request":"-/-","blocked":"-/-","form":{"days":"-/-","date":"-/-","type":{"null":"-/-","blocked":"-/-","request":"-/-","freesale":"-/-","allotment":"-/-"},"units":{"null":"-/-","allotment":"-/-","notAllotment":"-/-"},"buttons":{"add":"-/-","create":"-/-","submit":"-/-","cancel":"-/-"},"releaseType":{"null":"-/-","request":"-/-","blocked":"-/-","freesale":"-/-","selectType":"-/-"},"releaseMethod":{"null":"-/-","date":"-/-","days":"-/-"}},"allocations":"-/-","buttons":{"add":"-/-"},"unauthorized":"-/-","noAllocations":"-/-","overlaySuccess":"-/-","header":{"heading":"-/-"}},"statNumber":{"body":{"noDataFound":"-/-","failedToFetchData":"-/-"}},"contractList":{"heading":{"header":"-/-"},"overview":{"error":"-/-","download":"-/-","noContracts":"-/-","heading":{"header":"-/-"},"status":{"initiated":"-/-","readyForSupplier":"-/-"}},"history":{"heading":{"header":"-/-"}}},"contractNotes":{"messages":{"goTo":"-/-","wrote":"-/-","supplier":"-/-","internal":"-/-","sendEmail":"-/-","noContent":"-/-","campingVision":"-/-","supplierEmail":"-/-","backOfficeEmail":"-/-","contractManagerEmail":"-/-"},"header":{"heading":"-/-","messages":"-/-"},"control":{"internal":"-/-","reference":"-/-","placeholder":"-/-"}},"manageAllocationFormRow":{"days":"-/-","dateFormat":"-/-","dropDown":{"date":"-/-","days":"-/-","request":"-/-","blocked":"-/-","freeSale":"-/-","allotment":"-/-","guarantee":"-/-","selectType":"-/-","chooseType":"-/-"}},"contractManagement":{"list":{"year":"-/-","edit":"-/-","view":"-/-","perPage":"-/-","supplier":"-/-","download":"-/-","show":{"all":"-/-","mine":"-/-","label":"-/-"},"updatedBy":"-/-","status":{"done":"-/-","basic":"-/-","label":"-/-","pending":"-/-","extended":"-/-","completed":"-/-","initiated":"-/-","notification":"-/-","readyForSupplier":"-/-","readyForBackOffice":"-/-","supplierNotifications":"-/-","readyForContractManager":"-/-","contractManagerNotifications":"-/-"},"noContracts":"-/-","display":{"all":"-/-","label":"-/-"},"lastUpdated":"-/-","viewSupplier":"-/-","heading":{"header":"-/-"}},"alert":{"error":"-/-","saved":"-/-","noFile":"-/-","removed":"-/-","notFound":"-/-","emailSent":"-/-","illegalSize":"-/-","noSitesFound":"-/-","unsupportedType":"-/-","validationError":"-/-","emailAlreadySent":"-/-","noAccommodationsFound":"-/-"},"edit":{"form":{"add":"-/-","save":"-/-","link":"-/-","copy":"-/-","create":"-/-","remove":"-/-","confirm":"-/-","noTitle":"-/-","optional":"-/-","checkbox":"-/-","download":"-/-","emailSent":"-/-","brands":{"info":"-/-"},"email":{"review":"-/-","supplier":"-/-","backOffice":"-/-"},"images":{"remove":"-/-","initial":"-/-","confirm":"-/-","accepted":"-/-","unsupported":"-/-"},"upload":{"remove":"-/-","confirm":"-/-","initial":"-/-","accepted":"-/-"},"complete":{"review":"-/-","contract":"-/-"},"subHeader":{"notes":"-/-","brands":"-/-","accInfo":"-/-","accepted":"-/-","siteInfo":"-/-","discounts":"-/-","commission":"-/-","priceExtra":"-/-","arrivalRules":"-/-","allotmentRules":"-/-","arrivalDeparture":"-/-"},"placeholder":{"notes":"-/-","discounts":"-/-","priceExtra":"-/-","commission":"-/-","arrivalRules":"-/-","accInfo":{"site":"-/-","text":"-/-","name":"-/-"},"siteInfo":{"text":"-/-","name":"-/-"},"allotmentRules":"-/-","arrivalDeparture":"-/-"},"autoComplete":{"multi":"-/-","accInfo":"-/-","siteInfo":"-/-"},"header":{"heading":{"done":"-/-","basic":"-/-","extended":"-/-"}}},"progress":{"done":"-/-","basic":"-/-","extended":"-/-","defaultText":"-/-","header":{"heading":"-/-"},"subHeader":{"notes":"-/-","brands":"-/-","accInfo":"-/-","accepted":"-/-","siteInfo":"-/-","discounts":"-/-","commission":"-/-","arrivalRules":"-/-","allotmentRules":"-/-","priceExtra":{"price":"-/-","extra":"-/-"},"arrivalDeparture":"-/-"}}},"noChangesConfirm":"-/-"},"manageAllocationForm":{"heading":"-/-","buttons":{"reset":"-/-","submit":"-/-"},"control-message":{"on":"-/-","content":"-/-"}},"manageAllocationFilters":{"year":"-/-"},"subPages":{"home":{"subTitleRevenue":"-/-","subTitleBookings":"-/-","labelTotalRevenue":"-/-","labelTotalBookings":"-/-","labelPeriodRevenue":"-/-","labelPeriodBookings":"-/-"}},"manageAllocationRequest":{"units":"-/-","toggle":"-/-","heading":"-/-","form":{"body":"-/-","period":{"title":"-/-"},"labels":{"units":"-/-","release":"-/-"},"header":{"heading":"-/-"},"buttons":{"cancel":"-/-","accept":"-/-"}},"noContent":"-/-","table":{"type":"-/-","block":"-/-","period":"-/-","release":"-/-","deduction":"-/-","requestDate":"-/-"},"releaseDays":"-/-","type":{"request":"-/-","blocked":"-/-","freesale":"-/-","allotment":"-/-","guaranteed":"-/-"},"buttons":{"deny":"-/-","edit":"-/-","cancel":"-/-","accept":"-/-"},"dropdown":{"label":"-/-","denied":"-/-","pending":"-/-","approved":"-/-","modified":"-/-"},"headings":{"modified":"-/-","accepted":"-/-","declined":"-/-","requested":"-/-"}},"manageAllocationModalList":{"new":"-/-","date":"-/-","edit":"-/-","days":"-/-","released":"-/-","block":{"true":"-/-","false":"-/-","blocked":"-/-"},"buttons":{"new":"-/-","edit":"-/-","block":"-/-"},"releaseType":{"null":"-/-","request":"-/-","blocked":"-/-","freesale":"-/-"},"header":{"bookingsInPeriod":"-/-","noBookingsInPeriod":"-/-"}},"manageAllocationCalendar":{"retry":"-/-","error":"-/-","months":["-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-","-/-"],"header":{"howTo":"-/-","heading":"-/-"},"dropdown":{"full":"-/-","months":"-/-"}},"datePicker":{"predefinedLinks":{"today":"-/-","thisWeek":"-/-","lastYear":"-/-","thisYear":"-/-","lastWeek":"-/-","lastMonth":"-/-","yesterday":"-/-","thisMonth":"-/-"}},"manageAllocationFormAccept":{"header":"-/-","alert":{"to":"-/-","end":"-/-","from":"-/-","start":"-/-"},"content":{"end":"-/-","note":"-/-","comment":"-/-","start":{"add":"-/-","block":"-/-","submit":"-/-","request":"-/-","requestBlock":"-/-"}},"buttons":{"accept":"-/-","cancel":"-/-"}},"validator":{"validateDates":{"dateBefore":"-/-"}},"manageAllocationFormHeader":{"endDate":"-/-","startDate":"-/-","releaseBy":"-/-","releaseType":"-/-","afterRelease":"-/-","numberOfUnits":"-/-","allocationType":"-/-","releaseDaysDate":"-/-"},"statFilters":{"datepickers":{"booking":{"label":"-/-","heading":"-/-"},"arrival":{"label":"-/-","heading":"-/-"}}},"manageAllocationModalOverlayForm":{"info":"-/-","units":"-/-","status":"-/-","denied":"-/-","success":"-/-","blocked":"-/-","warning":"-/-","request":"-/-","released":"-/-","instruction":"-/-","labels":{"type":"-/-","units":"-/-","cancel":"-/-","period":"-/-","bookings":"-/-","releaseDate":"-/-","releaseDays":"-/-","releaseType":"-/-","arrivalRules":"-/-","releaseMethod":"-/-","noArrivalRules":"-/-","bookingsMaxCount":"-/-","arrivalTypes":{"label":"-/-","arrival":"-/-","departure":"-/-"},"arrivalRuleStayLength":"-/-","bookingsMaxCountToolTip":"-/-"},"release":{"date":"-/-","null":"-/-","days":"-/-"},"accept":{"block":"-/-","submit":"-/-","update":"-/-","request":"-/-","requestBlock":"-/-"},"pending":{"days":"-/-","units":"-/-","label":"-/-","requested":"-/-"},"buttons":{"reset":"-/-","block":"-/-","cancel":"-/-","update":"-/-","request":"-/-","requestBlock":"-/-"},"editable":{"type":"-/-","units":"-/-","releaseDate":"-/-","releaseType":"-/-","releaseDays":"-/-","information":{"default":"-/-"}},"requestPending":"-/-","requestMessage":"-/-","changesRequested":"-/-","instructionTrusted":"-/-","validator":{"days":{"set":"-/-","lower":"-/-"},"date":{"set":"-/-","lower":"-/-","before":"-/-","beforeEnd":"-/-"},"units":{"set":"-/-"}},"instructionNotTrusted":"-/-"},"manageAllocationCalendarWeekdays":{"sunday":"-/-","monday":"-/-","friday":"-/-","tuesday":"-/-","thursday":"-/-","saturday":"-/-","wednesday":"-/-"},"manageAllocationModalCalendarElement":{"units":"-/-","bookings":"-/-","request":{"days":"-/-","type":"-/-","units":"-/-","header":"-/-","deduct":"-/-","release":"-/-"}},"manageAllocationModalOverlay":{"header":{"heading":"-/-"}},"manageAllocationModalCalendarInfobox":{"header":{"heading":"-/-"}}}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = {"valid":true,"tips":{"hi":"Bonjour","help":"Avez-vous besoin d'aide ?","more":"plus","less":"moins","camping":"Contacter Camping Vision IT","adminPage":{"edit":{"body":"Tous les utilisateurs que vous avez créés peuvent être modifiés. Il est possible de tout changer sauf leur email. Si un utilisateur change d'email, vous devrez créer un nouvel utilisateur pour inviter cet email au marketplace.","title":"Modifier l'utilisateur"},"block":{"body":"Il est possible de bloquer l'accès au marketplace pour n'importe quel utilisateur que vous créez. Cela se fait en appuyant sur edit sur l'utilisateur, puis en appuyant sur le bouton de blocage. Il est possible de redonner l'accès à un utilisateur bloqué en le débloquant depuis le même endroit. Vous pouvez également supprimer des utilisateurs de l'écran d'édition. Notez que cette action est irréversible !","title":"Bloquer ou supprimer des utilisateurs"},"create":{"body":"Il est possible de créer un nouvel utilisateur en appuyant sur le bouton Nouvel utilisateur dans le coin supérieur droit. Le nouvel utilisateur peut être autorisé à lire et à écrire ou seulement à lire sur le marketplace.","title":"Créer un nouvel utilisateur"}},"statPage":{"boxes":{"body":"Les quatre cases en haut de la page affichent le chiffre d'affaires et les réservations. Les grises montrent la saison complète et les bleues la période sélectionnée.","title":"Les quatre cases en haut"},"graph":{"body":"Le graphique de gauche montre les campings les plus demandés. Cliquez sur un camping pour le sélectionner, et vous verrez les meilleurs hébergements dans le graphique de droite.","title":"Les graphiques"},"filter":{"body":"Vous pouvez cliquer sur le filtre de la période de réservation et de la période d'arrivée pour réduire ou augmenter les données de période.","title":"Période de réservation / Période d'arrivée"}},"dashboardPage":{"add":{"body":"Vous pouvez facilement ajouter de nouveaux allotements en cliquant sur le bouton 'Add allotment', ce qui vous mènera à l'aperçu du calendrier où vous pourrez ajouter des allotements supplémentaires.","title":"Ajouter allotement"},"graph":{"body":"Le graphique affiche la disponibilité de tous vos hébergements sur l'ensemble de vos campings, vous pouvez choisir un hébergement spécifique dans la liste déroulante.","title":"Graphique des disponibilités"},"filter":{"body":"Vous pouvez filtrer la liste des notifications par camping ou par hébergement pour n'afficher que les informations spécifiques au filtre.","title":"Filtre des notifications"},"notifications":{"body":"La liste des notifications affiche des informations urgentes sur les allotements vendus ou débloqués. Si nous n'avons pas d'allotement, nous n'avons rien à proposer pour vous.","title":"Perdez-vous des ventes ?"}},"bookingPage":{"search":{"body":"Vous pouvez rechercher une réservation spécifique dans le coin supérieur droit de la liste des réservations. Recherche avec le numéro de réservation.","title":"Rechercher un numéro de réservation."},"filters":{"body":"Vous pouvez filtrer la liste des réservations en fonction du camping, du domaine, de l'hébergement, du pays de réservation, du statut, etc.","title":"Filtres principaux"},"sortList":{"body":"Vous pouvez trier la liste des réservations en cliquant sur l'en-tête de l'attribut et trier par options multiples à l'aide du menu déroulant Trier par type","title":"Trier la liste de réservations"},"xlsError":{"body":"Certaines versions d'Excel verront le fichier XLS comme endommagé, mais si vous cliquez oui au message d'erreur dans Excel, il s'ouvrira normalement.","title":"Problème d'ouverture du XLS ?"},"downloadList":{"body":"Vous pouvez télécharger la liste filtrée sous forme de fichier séparé par des virgules (CSV) ou de document Excel (XLS).","title":"Télécharger CSV ou XLS"}},"allocationPage":{"sort":{"body":"Vous pouvez trier vos hébergements sur la dernière mise à jour, le nom et le camping.","title":"Trier les hébergements"},"site":{"body":"Vous pouvez filtrer la liste et n'afficher que les hébergements pour un camping spécifique à partir du menu déroulant en haut de la page.","title":"Filtrer les camping"},"update":{"body":"Cliquez sur le bouton de mise à jour de l'hébergement pour lequel vous souhaitez gérer les allotements. Vous verrez le calendrier d'allotement où vous pouvez ajouter, modifier et bloquer les allotements.","title":"Mettre à jour les allotements"},"updateBy":{"body":"La \"mise à jour par colonne\" indique qui a fait les derniers changements d'allotement pour ce logement, le signe \" @ \" indique qu'il s'agit d'un employé de Camping Vision.","title":"Mise à jour par"}},"accountPage":{"password":{"body":"Pour changer le mot de passe de votre compte, vous devez entrer votre mot de passe actuel, puis le nouveau mot de passe choisi qui doit être vérifié dans le champ de saisie.","title":"Modifier le mot de passe"},"activity":{"body":"La liste des activités du compte affiche toutes les modifications d'allotement que le compte a effectué au cours des 6 derniers mois, y compris l'ajout d'un allotement, les modifications d'allotement et les demandes de modification des allotements.","title":"Activité du compte"},"information":{"body":"Les informations de compte indiquent l'ID de votre compte et le type de compte. Vous pouvez changer votre prénom et votre nom de famille.","title":"Informations de compte"},"notifications":{"body":"Vous pouvez choisir de recevoir ou non des notifications par e-mail. Si vous cliquez sur Modifier, vous pouvez préciser les jours pour lesquels vous souhaitez recevoir le courriel. REMARQUE : Si vous choisissez bimensuel, vous ne pouvez sélectionner qu'un seul jour.","title":"Recevoir des notifications"}},"manageAllocationPage":{"error":"Nous n'avons pas pu récupérer les données, veuillez réessayer. Si le problème persiste, contactez-nous.","year":{"body":"Par défaut, l'année en cours est sélectionnée, mais vous pouvez sélectionner jusqu'à deux ans à l'avance à partir du menu déroulant \" Sélectionner l'année \".","title":"Sélectionner l'année"},"info":{"body":"Cliquez sur le bouton 'info' au-dessus du calendrier à droite pour afficher un guide d'utilisation du calendrier.","title":"Comment utiliser le calendrier ?"},"modal":{"body":"Lorsqu'une période est sélectionnée, une fenêtre contextuelle apparaît. Si aucune allotement n'a été ajouté, vous verrez apparaître un bouton pour ajouter un allotement. Si des allotements sont déjà créés dans la période, vous pourrez gérer ces allotements en cliquant sur modifier, ajouter ou bloquer. Ces options diffèrent des types d`allotement et s'ils ont été rétrocédés ou non.","title":"La fenêtre contextuelle"},"extra":{"body":"Lors du choix d'une période, un jour supplémentaire est ajouté à la fin pour indiquer que la période est basée sur les nuits et que le jour suivant sera donc une date de départ.","title":"Jour supplémentaire dans la période"},"select":{"body":"Utilisez le calendrier pour choisir une période pour modifier ou ajouter des allotements. Pour ce faire, cliquez sur la date de début, puis sur la date de fin. Cela ouvrira une fenêtre contextuelle dans laquelle vous pourrez gérer les allotements pour la période donnée.","title":"Sélectionner la période"},"display":{"body":"En cliquant sur le menu déroulant situé juste au-dessus du calendrier, il est possible d'afficher soit six mois, soit l'année complète.","title":"Afficher toute l'année ou 6 mois"},"overview":{"body":"Un aperçu des allotements se trouve juste en dessous du calendrier. Vous pouvez voir ici le détail des allotements. Le nombre d'unités correspondt au nombre d'unités indiqué préalablement sans tenir compte des réservations.","title":"Aperçu des allotements"},"accommodation":{"body":"Vous pouvez passer à un autre hébergement à partir du menu déroulant en haut, les hébergements appartiennent au camping selectionné. Pour choisir un autre camping, vous devez retourner à la page principale d'allotement et le sélectionner à partir de là.","title":"Vous voulez un autre hébergement ?"},"alert":{"requestError":"Mise à jour de la demande échouée, veuillez réessayer","requestAccept":"Demande acceptée avec succès","requestDenied":"Demande refusée avec succès","requestUnauthorized":"Mise à jour de la demande non autorisée"}},"contractManagementPage":{"upload":{"body":"Vous pouvez télécharger des fichiers en pièce jointe aux différentes parties du contrat, les types de fichiers acceptés sont : '.xlsx,.xls,.doc,.docx,.docx,.ppt,.pptx,.txt,.pdf''.","title":"Télécharger des fichiers"},"expand":{"body":"Vous pouvez réduire ou développer le champ de la progression en cliquant sur l'en-tête de la progression.","title":"Agrandir le champ de la progression"},"progress":{"body":"Dans l'en-tête, vous pouvez suivre l'avancement du contrat en pourcentage.","title":"Suivre votre progrès"},"indicator":{"body":"Les icônes indiquent si des informations ont été stockées pour une unité précise, ou s'il y a des notifications à la dite unité.","title":"Icônes d'indicateur de progrès"}}},"adminItem":{"id":"Id","edit":"Modifier","email":"Email","status":"Statut","lastName":"Nom de famille","firstName":"Nom"},"admin":{"list":{"id":"Id","edit":"Modifier","email":"Email","status":"Status","noUsers":"Aucun utilisateur créé","content":"Créer un utilisateur","lastname":"Nom de famille","firstname":"Nom","header":{"heading":"Liste des utilisateurs"}},"alert":{"email":"Cet email appartient à un autre utilisateur","error":"Il y a eu une erreur","updated":"Utilisateur mis à jour avec succès","deleted":"Utilisateur supprimé avec succès","created":"Utilisateur créé avec succès","blocked":"Utilisateur bloqué avec succès","password":"Mot de passe mis à jour avec succès","unblocked":"Utilisateur débloqué avec succès","notifications":"Statut de notification mis à jour avec succès","wrongPassword":"Mot de passe incorrect"},"profile":{"and":"et","email":"Email","weekly":"une fois par semaine","notice":"Vous recevez actuellement des notifications :","receive":"Recevoir des notifications","language":"Langue","noNotice":"Vous ne recevez actuellement aucunes notifications","everyday":"chaque jour","fullName":"Nom complet","fortnightly":"tous les quinze jours","header":{"heading":"Information sur le compte"},"notifications":{"edit":"Modifier","weekly":"Hebdomadaire","cancel":"Annuler","update":"Mettre à jour","fortnightly":"Bimensuel","days":{"friday":"Vendredi","monday":"Lundi","sunday":"Dimanche","tuesday":"Mardi","saturday":"Samedi","thursday":"Jeudi","wednesday":"Mercredi"},"heading":{"header":"Modifier le paramétrage des notifications"}}},"form":{"create":"Utilisateur créé avec succès","edit":{"edit":"Utilisateur mis à jour avec succès","block":"Utilisateur bloqué avec succès","delete":"Utilisateur supprimé avec succès","unblock":"Utilisateur débloqué avec succès"},"error":{"edit":"Il y a eu une erreur, veuillez réessayer.","email":"L'adresse email est déjà utilisée.","error":"Il y a eu une erreur, veuillez réessayer."}},"heading":{"header":"Panneau d'administration"},"edit":{"form":{"info":"Modifiez l'utilisateur et appuyer sur mettre à jour pour enregistrer les modifications","roles":"Rôles","lastname":"Nom de famille","language":"Langue","firstname":"Prénom","button":{"submit":"Créer un utilisateur"},"notifications":"Recevoir des notifications","buttons":{"block":"Bloquer","update":"Mettre à jour","delete":"Supprimer","unblock":"Débloquer"},"warning":{"blocked":"ATTENTION : Cet utilisateur est bloqué","inactive":"ATTENTION : Cet utilisateur est inactif"},"validator":{"lastname":"*Le nom de famille est obligatoire","firstname":"*Le prénom est obligatoire."}},"header":{"heading":"Modifier l'utilisateur"},"accept":{"header":{"block":"Bloquer l'utilisateur","update":"Mettre à jour l'utilisateur","delete":"Supprimer l'utilisateur","unblock":"Débloquer l'utilisateur"},"content":{"block":"Êtes-vous sûr de vouloir bloquer l'utilisateur ?","delete":"Êtes-vous sûr de vouloir supprimer l'utilisateur ?","update":"Êtes-vous sûr de vouloir mettre à jour l'utilisateur ?","unblock":"Êtes-vous sûr de vouloir débloquer l'utilisateur ?"},"buttons":{"accept":"Accepter","cancel":"Annuler"}}},"create":{"form":{"tip":"<strong>Rôles:</strong> Définir un rôle pour l'utilisateur pour fournir le niveau d'accès.","roles":"Rôles","email":"Email","language":"Langue","lastname":"Nom de famille","firstname":"Prénom","button":{"submit":"Créer un utilisateur"},"validator":{"email":"*Un email valide est requis","lastname":"*Le nom de famille est obligatoire","firstname":"*Le nom est obligatoire"}},"button":{"submit":"Créer un utilisateur"},"accept":{"header":"Créer un utilisateur","content":"Êtes-vous sûr de vouloir créer cet utilisateur ?","buttons":{"cancel":"Annuler","accept":"Accepter"}},"header":{"heading":"Créer un utilisateur"}}},"signIn":{"button":"Enregistrer","heading":"Bienvenue au Camping Vision Marketplace","description":"Inscrivez-vous et commencez à vendre sur le plus grand marché en ligne d'Europe, spécialisé dans les vacances en camping.","logoutNotice":"Vous avez été déconnecté avec succès.","invalidNotice":"Veuillez vous identifier à nouveau pour confirmer votre identité.","pass":{"placeholder":"Mot de passe","errors":{"required":"Vous devez fournir un mot de passe valide."}},"inactivityNotice":"Vous avez été déconnecté pour cause d'inactivité","email":{"placeholder":"Email","errors":{"email":"Vous devez fournir une adresse électronique valide.","required":"Vous devez fournir une adresse électronique."}},"messages":{"mismatch":"Le nom d'utilisateur et le mot de passe ne correspondent pas.","unexpected":"Une erreur inattendue s'est produite. Notre équipe de développement a été informée. Veuillez réessayer plus tard"},"forgotPasswordLink":"Vous avez oublié votre mot de passe ?"},"booking":{"button":"Activer le compte","heading":"Réservations","filterText":"Rechercher.....","dateTypes":["Date de la réservation","Date d'arrivée"],"placeholder":"Rechercher.....","description":"Liste de toutes les réservations pour une période donnée. La période peut être filtrée par date d'arrivée ou par date de réservation.","tableFields":{"#":"#","reset":"Annuler le tri","status":"Statut de notification mis à jour avec succès","domain":"Domaine","duration":"Durée","siteName":"Camping","bookingRef":"Numéro de CV","bookingDate":"Date de la réservation","arrivalDate":"Date d'arrivée","supplierRef":"Numéro de réservation","supplierName":"Nom du fournisseur","customerName":"Client","departureDate":"Date de départ","accommodation":"Hébergement"},"messages":{"error":"Une erreur s'est produite, veuillez réessayer plus tard.","expired":"Votre autorisation a expiré."},"filterOptions":{"site":"Camping","option":"Choisir..","domain":"Choisir domaine...","default":"Filtrer par","bookingAgent":"Agent de réservation","accommodation":"Hébergement","bookingCountry":"Pays de réservation"}},"account":{"form":{"id":"Id","email":"Email","lastName":"Nom de famille","firstName":"Prénom","buttons":{"reset":"Réinitialiser","update":"Mettre à jour"},"heading":{"header":"Modifier les informations de compte"},"accountType":{"label":"Type de compte","admin":{"true":"Admin","false":"de base"}},"validator":{"required":"Ce champ est obligatoire"},"placeholder":{"lastName":"Entrez votre nom de famille","firstName":"Entrez votre prénom"}},"activity":{"site":"Camping","date":"Date","limit":"Afficher lignes","type":{"label":"Type d'activité","request":"Demande","allocation":"Modifier"},"status":{"label":"Action","RELEASED":"Allotement débloqué","USER_EDIT":"Modifier l'allotement","USER_INSERT":"Ajouter l'allotement"},"header":{"months":"(6 derniers mois)","heading":"Activité du compte"},"accommodation":"Hébergement"},"password":{"password":"Mot de passe actuel","rePassword":"Confirmer le mot de passe","newPassword":"Nouveau mot de passe","buttons":{"reset":"Réinitialiser","update":"Mettre à jour"},"heading":{"header":"Modifier le mot de passe"},"validator":{"mismatch":"Les deux mots de passe ne correspondent pas","password":"Min. 8 caractères / majuscules & minuscules / chiffres"},"placeholder":{"password":"••••••••"}}},"statList":{"heading":"Revenu","predicate":"Filtrer par","backButton":"Retour"},"bookingItem":{"site":"Camping","status":"Statut","domain":"Domaine","duration":"Durée","bookingRef":"Numéro de référence de Camping Vision","arrivalDate":"Date d'arrivée","supplierRef":"Numéro de référence","bookingDate":"Date de la réservation","supplierName":"Nom du fournisseur","customerName":"Client","departureDate":"Date de départ","accommodation":"Hébergement"},"notFound":{"heading":"404 - Non trouvé"},"introduction":{"body":"Nous avons été informés de votre intérêt à procéder à la vente par l'intermédiaire des larges canaux de vente de Camping Vision. Nous allons maintenant continuer la procédure de vente et nous vous contacterons dès que possible.","error":"Une erreur inattendue s'est produite lors du traitement de votre demande, veuillez réessayer plus tard. Si le problème persiste, veuillez nous contacter.","warning":"Nous travaillons activement pour vous répondre dans les plus brefs délais.","noContent":"Le symbole que vous avez spécifié n'a pas pu être trouvé, avez-vous fourni le bon symbole dans l'url ?","footer":{"title":"Avez-vous des questions ?","contact":{"tel":"Tel: +31 (0)416 849 853","city":"1212 Grand-Lancy","title":"Camping Vision","email":"info@campingvision.com","street":"Rue du Bachet 14","country":"Suisse","address":"Bureau Genève"}},"header":{"error":"Nous sommes vraiment désolés :'(","warning":"Merci encore :-)","heading":"Merci de votre intérêt !","noContent":"Oups....."}},"statSites":{"heading":"Campings","dropdown":{"label":"Filtrer par"},"noContent":{"error":"Erreur dans la recherche de données","missing":"Aucune donnée trouvée"},"predicate":{"revenue":"Revenu","bookings":"Réservations"},"alternativeHeading":"Top 10 des campings"},"bookingList":{"order":"Commande","error":"Une erreur inattendue s'est produite","title":"Rechercher un n° de réservation, de référence ou un nom de client","search":"Rechercher un n° de réservation","heading":"Aucune réservation correspondante | 1 Réservation trouvée | {compte} Réservations trouvées","perPage":"Afficher les lignes","orderBy":"Trier par type","noContent":"Aucune réservation trouvée","xslTooltip":"Si Excel affiche une erreur, cliquez sur 'oui' pour l'ouvrir.","display":{"all":"Tous","label":"Afficher option","current":"Courant","historical":"Historique"},"placeholder":"Rechercher","download":{"xls":"Télécharger la liste (XLS)","csv":"Télécharger la liste (CSV)"},"orderFields":{"asc":"Par ordre croissant","desc":"Par ordre décroissant"}},"instruction":{"dismiss":"Ne plus montrer","defaultHeader":"Comment utiliser","contract":{"body":"Lisez attentivement chaque partie du contrat pour vous assurer que tout est correct. Si vous constatez des divergences, veuillez les indiquer dans le champ de notification en agrandissant la zone de notification au bas de la page. Si une partie est validée et correcte, cliquez sur le bouton 'Accepter la partie' en bas de la page. <br/>Pour naviguer entre les différentes parties, cliquez sur l'icône carrée dans le module de progression juste en dessous ou utilisez les flèches en bas de la page. <br/>><br/>N'oubliez pas de sauvegarder vos modifications."},"contractList":{"body":"Dans la liste ci-dessous, vous avez une vue d'ensemble de vos contrats. Dès qu'un nouveau contrat est prêt pour la révision, vous pouvez cliquer dessus et aller à la page de révision. Une fois que chaque partie est examinée et acceptée, il est possible de télécharger une copie PDF du contrat.","header":"Trouvez vos contrats ci-dessous"}},"topMenu":{"right":{"admin":"Administrateur","logout":"Déconnecter","account":"Compte"},"left":{"welcome":"Bienvenue"}},"allocationItem":{"site":"Camping","supplier":"Fournisseur","updatedAt":"Dernière mise à jour","updatedBy":"Mis à jour par"},"activateUser":{"button":"Activer le compte","heading":"Activer votre compte","description":"Vous avez demandé à activer votre compte. Veuillez définir un mot de passe et le saisir ci-dessous","messages":{"token":"Votre demande n'a pas pu être traitée. Veuillez réessayer plus tard.","success":"Votre compte a été activé avec succès. Vous allez être redirigé vers la page de connexion.","mismatch":"Votre mot de passe doit comporter au moins 8 caractères et contenir au moins 1 lettre majuscule et au moins 1 chiffre.","unexpected":"Une erreur inattendue s'est produite. Notre équipe de développement a été informée. Veuillez réessayer plus tard"},"pass":{"placeholder":"Nouveau mot de passe","errors":{"required":"Vous devez fournir un mot de passe"}},"passCheck":{"placeholder":"Confirmer le mot de passe","errors":{"required":"Vous devez saisir à nouveau votre mot de passe","mismatch":"Cela ne correspond pas au mot de passe ci-dessus."}}},"contract":{"form":{"email":"Envoyer l'email « prêt pour le fournisseur ».","alert":"Fournisseur non créé dans Marketplace","accept":"Accepter et compléter le contrat","complete":"Contrat prêt pour le fournisseur","sites":{"view":"Voir","city":"Ville","email":"Email","phone":"Téléphone","rating":"Classification","address":"Adresse","country":"Pays","zipCode":"Code postal","website":"Site web","noContent":"Aucun camping trouvé pour ce contrat","header":{"heading":"Campings"},"facilities":{"size":"Superficie (m²)","number":"Nombre","header":"Services","endDate":"Date de fin","distance":"Distance","startDate":"Date de début","dataHeader":"Informations supplémentaires"}},"acceptPart":"Accepter","sendAccept":"Accepter le contrat","extras":{"rule":"Condition","sell":"Vente","ageTo":"Âge maximum","price":"Prix","person":"Personne","noData":"n/d","endDate":"Date de fin","ageFrom":"Âge minimum","arrival":"Arrivée","per":{"stay":"Par séjour","week":"Par semaine","hour":"Par heure","night":"Par nuit","piece":"Par unité","person":"Par personne","personNight":"Par personne et par nuit","accommodation":"Par hébergement"},"netPrice":"Prix net","startDate":"Date de début","departure":"Départ","noContent":"Aucun supplément trouvé pour ce contrat","commission":"Commission","description":"Description","type":{"person":"Personne","optional":"Facultatif","inclusive":"Inclus","mandatory":"Obligatoire","information":"Information"},"payment":{"ignore":"n/d","arrival":"Paiement à l'arrivée","booking":"Paiement à la réservation","bookingArrival":"Réservé et payé à l'arrivée"},"header":{"heading":"Suppléments"}},"partAccepted":"accepté","notes":{"toggle":"Notifications","placeholder":"Saisissez ici toutes les notifications....","header":{"heading":"Remarques"},"sendBeforeLeave":"Souhaitez-vous envoyer une notification par e-mail au gestionnaire de contrat concernant les nouveaux messages?","sendEmailToContractManager":"Souhaitez-vous envoyer une notification par e-mail au gestionnaire de contrat concernant ce message?"},"control":{"save":"Sauvegarder","cancel":"Annuler l'acceptation","accept":"Accepter partie","accepted":"La partie a été acceptée"},"prices":{"price":"Prix","endDate":"Date de fin","noContent":"Aucun groupe de prix trouvé pour ce contrat","startDate":"Date de début","commission":"Commission","header":{"heading":"Prix & commissions"},"setting":{"pricePr":{"unit":"Par unité","person":"Personne"},"grossOrNet":{"net":"Prix net","gross":"Prix brut"},"priceType":{"singleDay":"Journalier"}}},"progress":{"label":"Information sur le contrat","part":{"terms":"Conditions de vente","sites":"Campings","extras":"Suppléments","prices":"Groupes de prix","discounts":"Réductions","allocations":"Allotements","arrivalRules":"Conditions d'arrivée","supplierInfo":"Info sur le fournisseur","accommodations":"Hébergements","cancellationRules":"Conditions d'annulation"},"header":{"heading":"Avancement du contrat"}},"unknownProduct":"Type de produit inconnu","discounts":{"name":"Nom","types":"Type(s)","noDate":"n/d","endDate":"Date de fin","startDate":"Date de début","noContent":"Aucune réduction trouvée pour ce contrat.","header":{"heading":"Réductions"},"arrivalDeparture":"Arrivée/Départ"},"missingContract":"Erreur dans le chargement du contrat","message":{"initiated":"Votre contrat est actuellement en attente...."},"arrivalRules":{"days":"jours","arrival":"Arrivée","endDate":"Date de fin","noContent":"Aucune condition d'arrivée trouvée pour ce contrat","minRental":"Séjour minimum","maxRental":"Séjour maximal","departure":"Départ","startDate":"Date de début","type":{"label":"Type","arrival":"Arrivée","departure":"Départ"},"header":{"heading":"Conditions d'arrivée"},"weekdays":{"friday":"Lu","monday":"Ve","sunday":"Di","tuesday":"Ma","thursday":"Je","saturday":"Sa","wednesday":"Me"}},"allocations":{"units":"Unités","noData":"n/d","endDate":"Date de fin","startDate":"Date de début","noContent":"Aucun allotement trouvé pour ce contrat.","type":{"label":"Type","BLOCKED":"Bloqué","REQUEST":"Sur demande","FREESALE":"Vente libre","GUARANTEE":"Garantie","ALLOTMENT":"Allotement"},"releaseDate":"Date de rétrocession","releaseDays":"Jours de rétrocession","releaseType":"Type de rétrocession","header":{"heading":"Allotements"}},"accommodations":{"view":"Voir","noData":"n/d","category":"Catégorie","maxAdults":"Nombre max. d'adultes","noContent":"Aucun hébergement trouvé pour ce contrat","maxPersons":"Nombre max. de personnes","minFullPay":"Nombre min. de personnes payantes","childrenAges":"Âge","header":{"heading":"Hébergements"},"subGroups":{"header":"Equipements"},"childrenAgesInfo":"Par ex., 14, 2 (enfants de 14 ans et 2 ans au maximum)","childOutsideAllowed":"1 enfant en dehors du max. autorisé","childOutsideAllowedInfo":"Par ex. 2 (un enfant de moins de 2 ans est autorisé en dehors du calcul du nombre total de personnes)"},"terms":{"heading":{"header":"Conditions de vente"}},"cancellationRules":{"noShow":"Absent","heading":"Conditions d'annulation","labels":{"days":"Jours avant l'arrivée","percent":"Paiement facturé"}},"supplierInfo":{"bankInfo":{"bic":"BIC","info":"Information","name":"Nom","bank":"Banque","iban":"IBAN","email":"Email","terms":"Conditions","method":"Mode de paiement","heading":"Coordonnées bancaires","account":"Compte","bankCurrency":"Devise bancaire","priceCurrency":"Devise du prix"},"contactInfo":{"name":"Nom","city":"Ville","email":"Email","phone":"Téléphone","heading":"Coordonnées","website":"Site web","country":"Pays","address":"Adresse","zipCode":"Code postal"},"bookingInfo":{"heading":"Information sur la réservation","amendEmail":"Email pour modifications","bookingPhone":"Numéro de téléphone pour les réservations","bookingEmail":"Email pour réservations","requestEmail":"Email pour demandes","bookingPerson":"Contact pour les réservations","complaintPhone":"Numéro de téléphone pour réclamation","complaintEmail":"Email pour réclamation","complaintPerson":"Contact pour les réclamations","cancellationEmail":"Email pour annulations","confirmationEmail":"Email pour confirmations"}}},"alert":{"saved":"Contrat sauvegardé avec succès","error":"Il y a eu une erreur","noFile":"Fichier non trouvé","removed":"Fichier supprimé avec succès","supplier":"Fournisseur non enregistré dans Marketplace","notFound":"Contrat non trouvé","emailSent":"Email envoyé","completed":"Le contrat a été complété","illegalSize":"L'image dépasse la limite de 3500x2500 px","unsupportedType":"Type de fichier non accepté","emailAlreadySent":"L'email a déjà été envoyé"}},"resetPassword":{"button":"Réinitialiser le mot de passe","heading":"Réinitialiser le mot de passe","description":"Vous avez demandé à réinitialiser votre mot de passe. Veuillez entrer votre mot de passe désiré ci-dessous","messages":{"token":"Votre demande n'a pas pu être traitée. Veuillez réessayer plus tard.","success":"Votre mot de passe a été réinitialisé. Vous allez être redirigé vers la page de connexion.","mismatch":"Votre mot de passe doit comporter au moins 8 caractères et contenir au moins 1 lettre majuscule et au moins 1 chiffre.","unexpected":"Une erreur inattendue s'est produite. Notre équipe de développement a été informée. Veuillez réessayer plus tard"},"pass":{"placeholder":"Nouveau mot de passe","errors":{"required":"Vous devez fournir un mot de passe"}},"passCheck":{"placeholder":"Confirmer le mot de passe","errors":{"mismatch":"Cela ne correspond pas au mot de passe ci-dessus.","required":"Vous devez saisir à nouveau votre mot de passe"}}},"allocationList":{"order":"Commande","orderBy":"Trier par type","perPage":"Afficher les lignes","heading":"Gérer les allotements","button":{"update":"Mettre à jour"},"messages":{"error":"Une erreur inattendue s'est produite","noContent":"Aucun allotement n'a été trouvé","unauthorized":"Action non autorisée par les permissions de l'utilisateur"},"orderFields":{"asc":"Par ordre croissant","desc":"Par ordre décroissant"},"tableFields":{"site":"Camping","name":"Hébergement","supplier":"Fournisseur","updatedBy":"Mis à jour par","updatedAt":"Dernière mise à jour","pendingRequests":"Demandes en attente"}},"dashboard":{"graph":{"label":"Graphique ici","footer":"Le graphique affiche la disponibilité de vos hébergements"},"tricks":{"click":"Cliquez ici","welcome":"Bienvenue","statistics":{"link":"tableau de bord/stats","message":"Vous pouvez obtenir un aperçu rapide de vos ventes à partir de la page des statistiques."},"allocation":{"link":"tableau de bord/allotement","message":"Saviez-vous que vous pouvez gérer vos allotements via la page d'allotement?"}},"suppliers":{"label":"Sélectionner un fournisseur"},"date":{"days":{"friday":"Vendredi","monday":"Lundi","sunday":"Dimanche","tuesday":"Mardi","thursday":"Jeudi","saturday":"Samedi","wednesday":"Mercredi"}},"availability":{"all":"Tous les hébergements","select":"Sélectionner un hébergement","request":"Sur demande","blocked":"Complet / bloqué","overview":"Aperçu des disponibilités (%)","noContent":"Aucune donnée trouvée","available":"Disponible"},"notifications":{"limit":"Afficher lignes","noContent":"Aucune notification","list":{"site":"Camping","link":"Ajouter allotement","date":"Date","dismiss":"Rejeter","status":{"stay":"Durée de séjour inadéquate","label":"Statut","arrival":"Date d'arrivée inadéquate","soldOut":"Complet","released":"Date de rétrocession atteinte"},"contractLink":"Aller au calendrier","header":{"count":"Aucune notification | 1 notification trouvée | {count} notifications trouvées","heading":"Vous manquez des opportunités de vente ?","contractHeading":"Aperçu des notifications"},"accommodation":"Hébergement"},"filters":{"sites":{"all":"Tous les campings","label":"Choisissez camping"},"predicate":{"all":"Tous les statuts","stay":"Durée de séjour inadéquate","label":"Sélectionner le statut","arrival":"Date d'arrivée inadéquate","soldOut":"Complet","released":"Date de rétrocession atteinte"},"accommodations":{"all":"Tous les hébergements","label":"Sélectionner un hébergement"}}},"alert":{"dismiss":{"error":"Il y a eu une erreur","success":"La notification a été rejetée","noContent":"La notification n'a pas pu être trouvée"}}},"statInventory":{"heading":"Inventaire","dropdown":{"label":"Filtrer par"},"noContent":{"error":"Échec de la récupération des données","missing":"Aucune donnée trouvée"},"predicate":{"revenue":"Revenu","bookings":"Réservations"},"alternativeHeading":"Top 10 des inventaires"},"forgotPassword":{"button":"Réinitialisation de la demande","heading":"Oublié votre mot de passe ?","signInLink":"Retour au login","description":"Entrez votre email pour demander une réinitialisation de votre mot de passe.","messages":{"noexist":"L'email n'existe pas","success":"Un email a été envoyé avec un lien pour réinitialiser votre mot de passe.","unexpected":"Une erreur inattendue s'est produite. Notre équipe de développement a été informée. Veuillez réessayer plus tard"},"email":{"placeholder":"Email","errors":{"email":"Vous devez fournir une adresse électronique valide.","required":"Vous devez fournir une adresse électronique."}}},"bookingFilters":{"site":{"all":"Tous les campings","label":"Camping"},"brand":{"all":"Toutes les marques","label":"Marque"},"status":{"all":"Tous les types","label":"Statut","types":{"booked":"Réservé","pending":"En attente","unknown":"Statut inconnu","request":"Demande","rejected":"Rejeté","cancelled":"Annulé","request-cancel":"Annulation demande"}},"domain":{"all":"Tous les domaines","label":"Domaine"},"country":{"all":"Tous les pays","label":"Pays de réservation"},"supplier":{"all":"Tous les fournisseurs","label":"Fournisseur"},"accommodation":{"all":"Tous les hébergements","label":"Hébergements"},"arrivalPeriod":{"label":"Date d'arrivée","datepicker":{"heading":"Sélectionnez une date d'arrivée"}},"bookingPeriod":{"label":"Période de réservation","datepicker":{"heading":"Sélectionnez une période de réservation"}}},"navigation-menu":{"language":"Sélectionner la langue","items":{"stats":"Statistiques","booking":"Réservations","supplier":"Fournisseur","contract":"Contrat","dashboard":"Tableau de bord","allocation":"Allotement","productType":"Type de produit","products":{"Hotel":"Hôtel","Shuttle":"Navette","Camping":"Camping","Badeland":"Parc aquatique","Skiferie":"Ski","Krydstogt":"Croisière","Disneyland":"Disneyland","Feriebolig":"Propriété"}}},"manageAllocationList":{"error":"Echec du chargement de la liste d'allotements","retry":"Veuillez réessayer","header":"Aperçu des allotements","list":{"to":"à","new":"Nouvel allotement","type":"Type","from":"De","edit":"Modifier allotement","block":"Bloquer pour la période","units":"Unités","release":"Date/jours de rétrocession","released":"Rétrocession dans la periode","updatedBy":"Mis à jour par","updatedAt":"Mis à jour à","releaseDate":"Date de rétrocession","releaseDays":"Jours de rétrocession","releaseType":"Type de rétrocession"},"noAllocations":"Aucun allotement n'a été trouvé !"},"manageAllocationPage":{"error":"Une erreur s'est produite, veuillez réessayer plus tard.","mobile":"Ce contenu ne peut être affiché que sur un ordinateur de bureau.","request":{"cancel":{"unauth":"Vous n'êtes pas autorisé à annuler les demandes.","success":"Demande annulée avec succès","failure":"Une erreur s'est produite, veuillez essayer plus tard.","noContent":"L'identifiant de la demande ne correspondait à aucun identifiant existant."},"accept":{"success":"Demande acceptée avec succès","failure":"Une erreur s'est produite, veuillez essayer plus tard."},"modify":{"failure":"Une erreur s'est produite, veuillez essayer plus tard.","success":"Demande modifiée et acceptée avec succès"},"decline":{"failure":"Une erreur s'est produite, veuillez essayer plus tard.","success":"Demande refusée"}}},"manageAllocationModal":{"info":"Cliquez sur le bouton 'Ajouter' ci-dessus pour ajouter des allotements pour la période choisie. <br/>NOTE ! Le dernier jour de la période n'est PAS inclus.","dash":"-","error":"Une erreur s'est produite, veuillez réessayer plus tard.","period":"Période:","update":"L'allotement a été mis à jour avec succès.","loading":"Chargement des allotments","success":"L'allotement a été ajouté avec succès.","request":"La demande d'allotement a été envoyé avec succès.","blocked":"L'allotement a été bloqué avec succès.","form":{"days":"Jours","date":"##/##/####","type":{"null":"n/d","blocked":"Bloqué","request":"Demande","freesale":"Vente libre","allotment":"Allotement"},"units":{"null":"n/d","allotment":"Nombre d'unités","notAllotment":"Uniquement pour allotements"},"buttons":{"add":"Ajouter","create":"Ajouter des allotements","submit":"Soumettre les changements","cancel":"Annuler"},"releaseType":{"null":"n/d","request":"Sur demande","blocked":"Bloqué","freesale":"Vente libre","selectType":"Sélectionner type"},"releaseMethod":{"null":"n/d","date":"Date","days":"Jours"}},"allocations":"Allotements trouvés","buttons":{"add":"Ajouter"},"unauthorized":"Non autorisé","noAllocations":"Aucun allotement n'a été trouvé","overlaySuccess":"L'allotement a été mise à jour avec succès.","header":{"heading":"Gérer les allotements"}},"statNumber":{"body":{"noDataFound":"Aucune donnée trouvée","failedToFetchData":"Échec de la récupération des données"}},"contractList":{"heading":{"header":"Contrats"},"overview":{"error":"Echec du chargement des données","download":"Télécharger","noContracts":"Aucun contrat trouvé","heading":{"header":"Aperçu du contrat"},"status":{"initiated":"Le contrat est actuellement en attente....","readyForSupplier":"Le contrat est prêt pour révision"}},"history":{"heading":{"header":"Historique"}}},"contractNotes":{"messages":{"goTo":"Aller à la réf.","wrote":"écrit","supplier":"Fournisseur","internal":"Message interne","sendEmail":"Souhaitez-vous envoyer une alerte de notification e-mail?","noContent":"Pas de notifications","campingVision":"Camping Vision","supplierEmail":"Envoyer une alerte de notification e-mail au fournisseur","backOfficeEmail":"Envoyer une alerte de notification e-mail au back office","contractManagerEmail":"Envoyer une alerte de notification e-mail au gestionnaire de contrat"},"header":{"heading":"Notifications","messages":"Message(s) sans réponse"},"control":{"internal":"Envoyer comme message interne?","reference":"Référence","placeholder":"Tapez votre message..."}},"manageAllocationFormRow":{"days":"Jours","dateFormat":"JJ/MM/AAAA","dropDown":{"date":"Date","days":"Jours","request":"Demande","blocked":"Bloqué","freeSale":"Vente libre","allotment":"Allotement","guarantee":"Garantie","selectType":"Sélectionnez un type","chooseType":"Choisir le type"}},"contractManagement":{"list":{"year":"Année","edit":"Modifier","view":"Voir le contrat","perPage":"Par page","supplier":"Fournisseur","download":"Télécharger","show":{"all":"Tous les contrats","mine":"Seulement mes contrats","label":"Afficher"},"updatedBy":"Mis à jour par","status":{"done":"Fait","basic":"Contrat de base ouvert","label":"Statut","pending":"En attente du fournisseur","extended":"Contrat prolongé ouvert","completed":"Complété","initiated":"Contrat ouvert","notification":"Notification","readyForSupplier":"En attente du fournisseur","readyForBackOffice":"En attente du Back Office","supplierNotifications":"Remarques du fournisseur","readyForContractManager":"En attente du gestionnaire de contrat","contractManagerNotifications":"Remarques du gestionnaire de contrat"},"noContracts":"Aucun contrat ne correspond à vos critères","display":{"all":"Tout statut","label":"Statut"},"lastUpdated":"Dernière mise à jour","viewSupplier":"Voir l'état d'avancement du fournisseur","heading":{"header":"Liste de statut du contrat"}},"alert":{"error":"Il y a eu une erreur","saved":"Contrat sauvegardé avec succès","noFile":"Fichier non trouvé","removed":"Fichier supprimé avec succès","notFound":"Contrat non trouvé","emailSent":"Email envoyé","illegalSize":"L'image dépasse la limite de 3500x2500 px","noSitesFound":"Aucun site trouvé","unsupportedType":"Type de fichier non autorisé","validationError":"Formulaire incomplet","emailAlreadySent":"L'email a déjà été envoyé","noAccommodationsFound":"Aucun hébergement trouvé"},"edit":{"form":{"add":"Ajouter","save":"Sauvegarder le formulaire","link":"Lien","copy":"Copie","create":"Créer","remove":"Supprimer le fichier","confirm":"Êtes-vous sûr de vouloir supprimer le fichier ?","noTitle":"Sans titre","optional":"Facultatif","checkbox":"Montrer dans le contrat","download":"Télécharger","emailSent":"Email envoyé","brands":{"info":"Sélectionnez les marques auxquelles le contrat doit être appliqué:"},"email":{"review":"Envoyer l'email « prêt pour révision ».","supplier":"Envoyer l'email « prêt pour le fournisseur ».","backOffice":"Envoyer un email à Back Office"},"images":{"remove":"Enlever","initial":"Cliquez ou faites glisser les images ici","confirm":"Confirmer","accepted":"Types de fichiers acceptés : jpg,.jpg,.jpeg,.bmp,.png.","unsupported":"Votre navigateur ne permet pas l'affichage des images"},"upload":{"remove":"Supprimer","confirm":"Confirmer","initial":"Cliquez ou faites glisser les fichiers ici","accepted":"Types de fichiers acceptés : '.xlsx,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'."},"complete":{"review":"Contrat prêt pour révision ?","contract":"Partie de base / étendue complétée"},"subHeader":{"notes":"Notes","brands":"Marques","accInfo":"Hébergement(s)","accepted":"Accepté(e)","siteInfo":"Camping(s)","discounts":"Réductions","commission":"Commission","priceExtra":"Tarifs et suppléments","arrivalRules":"Les règles d'arrivée","allotmentRules":"Allotement et conditions d'attribution","arrivalDeparture":"Arrivée/Départ"},"placeholder":{"notes":"Entrez ici des informations supplémentaires, par exemple votre expérience personnelle, etc.","discounts":"Entrez les informations sur les réductions ici....","priceExtra":"Entrez la liste des tarifs pour les types d'hébergement et les suppléments.....","commission":"Entrez les taux de commission.....","arrivalRules":"Entrez les conditions d'arrivée.....","accInfo":{"site":"Choisir camping(s)","text":"Entrez ici la description de l'hébergement.....","name":"Entrez / choisissez le nom de l'hébergement"},"siteInfo":{"text":"Entrez la description du camping ici.....","name":"Entrez / choisissez le nom du camping"},"allotmentRules":"Entrez les dates des allotements, le type d'hébergement et les conditions de ces allotements.....","arrivalDeparture":"Entrez les infos d'arrivée et de départ ainsi que la durée minimale du séjour ici...."},"autoComplete":{"multi":"Lier au camping","accInfo":"Entrez le nom de l'hébergement ici....","siteInfo":"Entrez le nom du camping ici...."},"header":{"heading":{"done":"Accepté par le fournisseur","basic":"Informations de base","extended":"Informations complémentaires"}}},"progress":{"done":"Accepté par le fournisseur","basic":"Informations de base","extended":"Informations complémentaires","defaultText":"Pas de changements","header":{"heading":"Aperçu de l'avancement du contrat"},"subHeader":{"notes":"Notes","brands":"Marques","accInfo":"Hébergement(s)","accepted":"Accepté(e)","siteInfo":"Camping(s)","discounts":"Réductions","commission":"Commission","arrivalRules":"Arrivée","allotmentRules":"Allotement","priceExtra":{"price":"Prix","extra":"Suppléments"},"arrivalDeparture":"Arrivée/Départ"}}},"noChangesConfirm":"Cela va ajouter \"pas de changements\" à cette partie, poursuivre?"},"manageAllocationForm":{"heading":"Ajouter des allotements","buttons":{"reset":"Réinitialiser le formulaire","submit":"Soumettre les changements"},"control-message":{"on":"sur","content":"<strong>NOTE:</strong> Vous ajoutez l'allotement pour :"}},"manageAllocationFilters":{"year":"Choisir l'année"},"subPages":{"home":{"subTitleRevenue":"EUR","subTitleBookings":"pcs","labelTotalRevenue":"Total des revenus","labelTotalBookings":"Total des réservations","labelPeriodRevenue":"Période Revenus","labelPeriodBookings":"Période réservations"}},"manageAllocationRequest":{"units":"unités","toggle":"Demandes en attente","heading":"Aperçu des demandes","form":{"body":"Vous pouvez modifier la demande à partir du formulaire ci-dessous. Cliquez sur Accepter pour accepter la demande avec les modifications appliquées.","period":{"title":"Période"},"labels":{"units":"unités","release":"Date et jours de rétrocession"},"header":{"heading":"Modifier la demande"},"buttons":{"cancel":"Annuler","accept":"Accepter"}},"noContent":"Aucune demande trouvée","table":{"type":"Type de changement","block":"Blocage de la demande","period":"Période","release":"Changer rétrocession","deduction":"Déduction d'allotement","requestDate":"Date de la demande"},"releaseDays":"jours","type":{"request":"Demande","blocked":"Bloqué","freesale":"Vente libre","allotment":"Allotement","guaranteed":"Garanti"},"buttons":{"deny":"Refuser","edit":"Modifier","cancel":"Annuler","accept":"Accepter"},"dropdown":{"label":"Type de demande","denied":"Refusé","pending":"En attente","approved":"Approuvé","modified":"Modifié"},"headings":{"modified":"Modifications acceptées - avec des modifications de la part du gestionnaire de contrat","accepted":"Modifications acceptées","declined":"Changements refusés","requested":"Modifications demandées"}},"manageAllocationModalList":{"new":"Nouvel allotement","date":"date","edit":"Modifier allotement","days":"jours","released":"Rétrocédé","block":{"true":"Bloquer pour la période","false":"Non rétrocédé","blocked":"Bloqué"},"buttons":{"new":"Nouvelle allotement","edit":"Modifier allotement","block":"Bloquer allotement"},"releaseType":{"null":"n/d","request":"Demande","blocked":"Bloqué","freesale":"Vente libre"},"header":{"bookingsInPeriod":"Allotements dans la période:","noBookingsInPeriod":"Aucun allotement dans la période"}},"manageAllocationCalendar":{"retry":"Veuillez réessayer","error":"Echec de chargement du calendrier","months":["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],"header":{"howTo":"Comment utiliser le calendrier","heading":"Calendrier d'allotement"},"dropdown":{"full":"Année entière","months":"6 mois"}},"datePicker":{"predefinedLinks":{"today":"Aujourd'hui","thisWeek":"Cette semaine","lastYear":"L'année dernière","thisYear":"Cette année","lastWeek":"La semaine dernière","lastMonth":"Le mois dernier","yesterday":"Hier","thisMonth":"Ce mois-ci"}},"manageAllocationFormAccept":{"header":"Ajouter des allotements","alert":{"to":"À:","end":"Pour l'instant, vous ne pouvez pas changer les règles de rétrocession à moins de passer de la vente libre à l'allotement.<br/>Il n'est pas possible de déduire le nombre d'unités, les unités peuvent seulement être ajoutées.","from":"De:","start":"Ceci remplacera la période suivante."},"content":{"end":"pour le(s) hébergement(s) suivant(s) :","note":"<strong>ATTENTION ! Ces changements sont irréversibles.</strong>.","comment":"Ajouter un commentaire","start":{"add":"Vous êtes sur le point d'ajouter des allotements sur","block":"Vous êtes sur le point de bloquer les allotements sur","submit":"Vous êtes sur le point de mettre à jour les allotements sur","request":"Vous êtes sur le point de demander des changements d'allotement sur","requestBlock":"Vous êtes sur le point de demander un blocage d'allotement sur"}},"buttons":{"accept":"Accepter","cancel":"Annuler"}},"validator":{"validateDates":{"dateBefore":"La date de fin doit être postérieure à celle de début."}},"manageAllocationFormHeader":{"endDate":"Date de fin","startDate":"Date de début","releaseBy":"Rétrocession par","releaseType":"Type de rétrocession","afterRelease":"Statut après rétrocession","numberOfUnits":"Nombre d'unités","allocationType":"Type d'allotement","releaseDaysDate":"Date/jours de rétrocession"},"statFilters":{"datepickers":{"booking":{"label":"Période de réservation","heading":"Période de réservation"},"arrival":{"label":"Période d'arrivée","heading":"Période d'arrivée"}}},"manageAllocationModalOverlayForm":{"info":"Vous pouvez ajouter plus d'allotement et changer la date de rétrocession. Il n'est possible de bloquer que les allotements rétrocédés ou la vente libre.","units":"Changer le nombre d'unités","status":"Modifier le statut","denied":"Vous n'êtes pas autorisé à faire des modifications d'allotements","success":"Les allotements ont été mis à jour avec succès.","blocked":"ATTENTION : Ce produit est bloqué, et aucun changement ne sera soumis.","warning":"ATTENTION : Ce produit a été rétrocédé. Vous pouvez le bloquer ou ajouter un nouvel allotement à partir de la page précédente.","request":"ATTENTION : Ces changements ne peuvent pas être appliqués directement. Vous pouvez demander la modification qui sera examinée par un gestionnaire de contrat. Cela peut prendre jusqu'à 5 jours ouvrables.","released":"ATTENTION : Ce produit a été rétrocédé. ","instruction":"Besoin d'aide?","labels":{"type":"Type d'allotement","units":"Unités initiales","cancel":"Annuler","period":"Période","bookings":"Réservation à la période","releaseDate":"Date de rétrocession","releaseDays":"Jours de rétrocession","releaseType":"Type de rétrocession","arrivalRules":"Règle(s) d'arrivée à la période","releaseMethod":"Méthode de rétrocession","noArrivalRules":"Vous n'avez défini aucune règle d'arrivée pour cette période","bookingsMaxCount":"Max. de réservations à la période","arrivalTypes":{"label":"Type","arrival":"Arrivée","departure":"Départ"},"arrivalRuleStayLength":"Durée du séjour en jours","bookingsMaxCountToolTip":"Le nombre maximum de réservations pour un jour donné au cours de la période d'allotement"},"release":{"date":"Changer date de rétrocession","null":"Pas de date de rétrocession","days":"Changer jours de rétrocession"},"accept":{"block":"Bloquer l'allotement","submit":"Mettre à jour allotement","update":"Mettre à jour l'allotement","request":"Demande de mise à jour de l'allotement","requestBlock":"Demande de blocage de l'allotement"},"pending":{"days":"jours","units":"unités","label":"Il y a des demandes en attente","requested":"Demandé"},"buttons":{"reset":"Réinitialiser","block":"Bloquer","cancel":"Annuler","update":"Mettre à jour","request":"Demande","requestBlock":"Demande de blocage"},"editable":{"type":"Changer le type d'allotement","units":"Changer le nombre d'allotements","releaseDate":"Changer la date de rétrocession","releaseType":"Changer le type de rétrocession de l'allotement","releaseDays":"Changer les jours de rétrocession","information":{"default":"Les champs éditables sont affichés avec le symbole d'édition.Cliquez sur le champ pour ouvrir la boîte d'édition. Vous pouvez effectuer plusieurs modifications avant la mise à jour et en cliquant sur \"Réinitialiser\", vous supprimerez toutes les modifications."}},"requestPending":"ATTENTION : Vous ne pouvez pas effectuer de changements à cette période, car il y a déjà des demandes de changement en attente.","requestMessage":"NOTE : Ces changements ne peuvent pas être appliqués directement. Vous pouvez demander le changement qui sera examiné par un gestionnaire de contrat dans les 24 heures les jours ouvrables.","changesRequested":"Vous ne pouvez pas modifier l'allotement car il y a des demandes en attente.","instructionTrusted":"Une fois un changement enregistré, il sera appliqué directement à l'allotement et visible instantanément sur toutes nos marques. <br/>Veuillez noter que certaines limitations peuvent survenir, par exemple, vous ne pouvez pas réduire un allotement en dessous du nombre de réservations actuellement présentes dans l'allotement.","validator":{"days":{"set":"Les jours de rétrocession doivent être réglés à une valeur supérieure à 0.","lower":"Vous n'avez pas le droit d'augmenter le nombre de jours de rétrocession."},"date":{"set":"La date de rétrocession doit être définie et dans un format valide JJ/MMM/AAAA.","lower":"Vous n'êtes pas autorisé à déplacer la date de rétrocession vers l'arrière.","before":"La date de rétrocession doit être antérieure ou égale à la date de début des allotements.","beforeEnd":"La date de rétrocession doit être antérieure ou égale à la date de fin des allotements."},"units":{"set":"Le nombre d'unités doit être compris entre 1 et 10."}},"instructionNotTrusted":"Une fois un changement enregistré, il sera appliqué directement à l'allotement et visible instantanément sur toutes nos marques. <br/>Vous ne pouvez pas réduire l'allotement, en changer le type en demande ou bloquer directement l'allotement non libéré. Si vous souhaitez effectuer ces modifications, vous pouvez demander une modification. <br/><br/>Les demandes de modifications sont examinées et traitées par votre gestionnaire de contrat dans les 5 jours ouvrables."},"manageAllocationCalendarWeekdays":{"sunday":"Di","monday":"Lu","friday":"Ve","tuesday":"Ma","thursday":"Je","saturday":"Sa","wednesday":"Me"},"manageAllocationModalCalendarElement":{"units":"Unités initiales :","bookings":"Réservations :","request":{"days":"jours","type":"Changer type:","units":"unité(s)","header":"Modifications demandées","deduct":"Déduire:","release":"Changer rétrocession"}},"manageAllocationModalOverlay":{"header":{"heading":"Modifier l'allotement"}},"manageAllocationModalCalendarInfobox":{"header":{"heading":"Calendrier Boîte d'info"}}}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _letterFilters = __webpack_require__(580);

exports.default = {
    install: function install(Vue) {
        Vue.filter('sentenceCase', _letterFilters.LetterFilters.sentenceCase);
        Vue.filter('titleCase', _letterFilters.LetterFilters.titleCase);
        Vue.filter('upperCase', _letterFilters.LetterFilters.upperCase);
        Vue.filter('lowerCase', _letterFilters.LetterFilters.lowerCase);
    }
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LetterFilters = exports.LetterFilters = function () {
    function LetterFilters() {
        _classCallCheck(this, LetterFilters);
    }

    _createClass(LetterFilters, null, [{
        key: "sentenceCase",


        /**
         * Converts a string to sentence case
         *
         * @param value
         */
        value: function sentenceCase(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        }

        /**
         * Converts a string to title case
         *
         * @param value
         * @returns {string}
         */

    }, {
        key: "titleCase",
        value: function titleCase(value) {
            return value.replace(/\w\S*/g, function (v) {
                return v.charAt(0).toUpperCase() + v.substr(1).toLowerCase();
            });
        }

        /**
         * Converts a string to upper case
         *
         * @param value
         */

    }, {
        key: "upperCase",
        value: function upperCase(value) {
            return value.toUpperCase();
        }

        /**
         * Converts a string to lower case
         *
         * @param value
         * @returns {string}
         */

    }, {
        key: "lowerCase",
        value: function lowerCase(value) {
            return value.toLowerCase();
        }
    }]);

    return LetterFilters;
}();

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputDirectives = __webpack_require__(582);

exports.default = {
    install: function install(Vue) {
        Vue.directive('numberOnly', _inputDirectives.NumberOnly);
    }
};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Ensures that only numbers can be typed in an input
 *
 * @type {{bind(*): void}}
 */
var NumberOnly = exports.NumberOnly = {
    bind: function bind(el) {
        el.addEventListener('keypress', function (e) {
            if (e.key.length === 1 && isNaN(e.key) && !e.ctrlKey) {
                e.preventDefault();
            }
        });
    }
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
	install: function (Vue, options) {
		var moment = options && options.moment ? options.moment : __webpack_require__(5);
		
		Object.defineProperties(Vue.prototype, {
			$moment: {
				get: function() {
					return moment;
				},
			},
		});

		Vue.moment = moment

		Vue.filter('moment', function() {
			var args = Array.prototype.slice.call(arguments),
				input = args.shift(),
				date;

			if (Array.isArray(input) && typeof input[0] === 'string') {
				// If input is array, assume we're being passed a format pattern to parse against.
				// Format pattern will accept an array of potential formats to parse against.
				// Date string should be at [0], format pattern(s) should be at [1]
				date = moment(string = input[0], formats = input[1], true);
			} else if (typeof input === 'number') {
				// If input is an integer, assume it's a Unix timestamp.
				date = moment.unix(input);
			} else {
				// Otherwise, throw the input at moment and see what happens...
				date = moment(input);
			}

			if (!input || !date.isValid()) {
				// Log a warning if moment couldn't reconcile the input. Better than throwing an error?
				console.warn('Could not build a valid `moment` object from input.');
				return input;
			}

			function parse() {
				var args = Array.prototype.slice.call(arguments),
					method = args.shift();

				switch (method) {
					case 'add':

						// Mutates the original moment by adding time.
						// http://momentjs.com/docs/#/manipulating/add/

						var addends = args.shift()
										  .split(',')
										  .map(Function.prototype.call, String.prototype.trim);
						var obj = {};
						for (var n = 0; n < addends.length; n++) {
							var addend = addends[n].split(' ');
							obj[addend[1]] = addend[0];
						}
						date = date.add(obj);
						break;

					case 'subtract':

						// Mutates the original moment by subtracting time.
						// http://momentjs.com/docs/#/manipulating/subtract/

						var subtrahends = args.shift()
										  .split(',')
										  .map(Function.prototype.call, String.prototype.trim);
						obj = {};
						for (var n = 0; n < subtrahends.length; n++) {
							var subtrahend = subtrahends[n].split(' ');
							obj[subtrahend[1]] = subtrahend[0];
						}
						date = date.subtract(obj);
						break;

					case 'from':

						// Display a moment in relative time, either from now or from a specified date.
						// http://momentjs.com/docs/#/displaying/fromnow/

						var from = 'now';
						if (args[0] == 'now') args.shift();

						if (moment(args[0]).isValid()) {
							// If valid, assume it is a date we want the output computed against.
							from = moment(args.shift());
						}

						var removeSuffix = false;
						if (args[0] === true) {
							args.shift();
							var removeSuffix = true;
						}

						if (from != 'now') {
							date = date.from(from, removeSuffix);
							break;
						}

						date = date.fromNow(removeSuffix);
						break;
						
					case 'diff':

						// Mutates the original moment by doing a difference with another date.
						// http://momentjs.com/docs/#/displaying/difference/

						var dateDiff = 'now';
						if (args[0] == 'now') args.shift();

						if (moment(args[0]).isValid()) {
							dateDiff = moment(args.shift());
						}

						var units = '';
						if (args[0]) {
							var units = args.shift();
						}

						var floatingValue = false;
						if (args[0] === true) {
							args.shift();
							var floatingValue = true;
						}

						date = date.diff(dateDiff, units, floatingValue)
						break;

					case 'calendar':

						// Formats a date with different strings depending on how close to a certain date (today by default) the date is.
						// http://momentjs.com/docs/#/displaying/calendar-time/

						var referenceTime = moment();

						if (moment(args[0]).isValid()) {
							// If valid, assume it is a date we want the output computed against.
							referenceTime = moment(args.shift());
						}

						date = date.calendar(referenceTime);
						break;

					case 'timezone':
						// Mutates the original moment by converting to a new timezone.
						// https://momentjs.com/timezone/docs/#/using-timezones/converting-to-zone/
						date = date.tz(args.shift());
						break;

					default:
						// Format
						// Formats a date by taking a string of tokens and replacing them with their corresponding values.
						// http://momentjs.com/docs/#/displaying/format/

						var format = method;
						date = date.format(format);
				}

				if (args.length) parse.apply(parse, args);
			}

			parse.apply(parse, args);


			return date;
		});
	},
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _shortNumber = __webpack_require__(585);

var _shortNumber2 = _interopRequireDefault(_shortNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    install: function install(Vue) {
        Object.defineProperties(Vue.prototype, {
            $shortNumber: {
                get: function get() {
                    return _shortNumber2.default;
                }
            }
        });
    }
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.shortNumber = factory();
}(this, function (num) {
    'use strict';

    return function (num) {
        if(typeof num !== 'number') {
            throw new TypeError('Expected a number');
        }

        if(num > 1e19) {
            throw new RangeError('Input expected to be < 1e19');
        }

        if(num < -1e19) {
            throw new RangeError('Input expected to be > 1e19');
        }

        if(Math.abs(num) < 1000) {
            return num;
        }

        var shortNumber;
        var exponent;
        var size;
        var sign = num < 0 ? '-' : '';
        var suffixes = {
            'K': 6,
            'M': 9,
            'B': 12,
            'T': 16
        };

        num = Math.abs(num);
        size = Math.floor(num).toString().length;

        exponent = size % 3 === 0 ? size - 3 : size - (size % 3);
        shortNumber = Math.round(10 * (num / Math.pow(10, exponent))) / 10;

        for(var suffix in suffixes) {
            if(exponent < suffixes[suffix]) {
                shortNumber += suffix;
                break;
            }
        }

        return sign + shortNumber;
    };
}));


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VueMaskDirective", function() { return directive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VueMaskPlugin", function() { return plugin; });
function format (text, wholeMask) {
  if (!wholeMask) return text;
  var maskStartRegExp = /^([^#ANX]+)/;

  if (+text.length === 1 && maskStartRegExp.test(wholeMask)) {
    text = maskStartRegExp.exec(wholeMask)[0] + text;
  }

  var newText = '';
  var charOffset = 0;

  for (var maskIndex = 0; maskIndex < wholeMask.length; maskIndex += 1) {
    var mask = wholeMask.charAt(maskIndex);

    switch (mask) {
      case '#':
        break;

      case 'A':
        break;

      case '?':
        break;

      case 'N':
        break;

      case 'X':
        break;

      default:
        text = text.replace(mask, '');
    }
  }

  for (var _maskIndex = 0, x = 1; x && _maskIndex < wholeMask.length; _maskIndex += 1) {
    var char = text.charAt(_maskIndex - charOffset);

    var _mask = wholeMask.charAt(_maskIndex);

    switch (_mask) {
      case '#':
        /\d/.test(char) ? newText += char : x = 0;
        break;

      case 'A':
        /[a-z]/i.test(char) ? newText += char : x = 0;
        break;

      case 'N':
        /[a-z0-9]/i.test(char) ? newText += char : x = 0;
        break;

      case '?':
        charOffset += 1;
        break;

      case 'X':
        newText += char;
        break;

      default:
        newText += _mask;

        if (char && char !== _mask) {
          text = " ".concat(text);
        }

        break;
    }
  }

  return newText;
}

var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
var queryInputElementInside = function queryInputElementInside(el) {
  return el instanceof HTMLInputElement ? el : el.querySelector('input') || el;
};

var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

function updateValue(el) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var value = el.value,
      _el$dataset = el.dataset,
      _el$dataset$previousV = _el$dataset.previousValue,
      previousValue = _el$dataset$previousV === void 0 ? '' : _el$dataset$previousV,
      mask = _el$dataset.mask;

  if (force || value && value !== previousValue && value.length > previousValue.length) {
    el.value = format(value, mask);

    if (isAndroid && isChrome) {
      setTimeout(function () {
        return trigger(el, 'input');
      }, 0);
    } else {
      trigger(el, 'input');
    }
  }

  el.dataset.previousValue = value;
}

function updateMask(el, mask) {
  el.dataset.mask = mask;
}

var directive = {
  bind: function bind(el, _ref) {
    var value = _ref.value;
    el = queryInputElementInside(el);
    updateMask(el, value);
    updateValue(el);
  },
  componentUpdated: function componentUpdated(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue;
    el = queryInputElementInside(el);
    var isMaskChanged = value !== oldValue;

    if (isMaskChanged) {
      updateMask(el, value);
    }

    updateValue(el, isMaskChanged);
  }
};

var plugin = (function (Vue) {
  Vue.directive('mask', directive);
});

/* harmony default export */ __webpack_exports__["default"] = (plugin);



/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):t.VueProgressBar=o()}(this,function(){"use strict";!function(){if("undefined"!=typeof document){var t=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style"),i=" .__cov-progress { opacity: 1; z-index: 999999; } ";o.type="text/css",o.styleSheet?o.styleSheet.cssText=i:o.appendChild(document.createTextNode(i)),t.appendChild(o)}}();var t="undefined"!=typeof window,r={render:function(){var t=this,o=t.$createElement;return(t._self._c||o)("div",{staticClass:"__cov-progress",style:t.style})},staticRenderFns:[],name:"VueProgress",serverCacheKey:function(){return"Progress"},computed:{style:function(){var t=this.progress,o=t.options,i=!!o.show,e=o.location,s={"background-color":o.canSuccess?o.color:o.failedColor,opacity:o.show?1:0,position:o.position};return"top"===e||"bottom"===e?("top"===e?s.top="0px":s.bottom="0px",o.inverse?s.right="0px":s.left="0px",s.width=t.percent+"%",s.height=o.thickness,s.transition=(i?"width "+o.transition.speed+", ":"")+"opacity "+o.transition.opacity):"left"!==e&&"right"!==e||("left"===e?s.left="0px":s.right="0px",o.inverse?s.top="0px":s.bottom="0px",s.height=t.percent+"%",s.width=o.thickness,s.transition=(i?"height "+o.transition.speed+", ":"")+"opacity "+o.transition.opacity),s},progress:function(){return t?window.VueProgressBarEventBus.RADON_LOADING_BAR:{percent:0,options:{canSuccess:!0,show:!1,color:"rgb(19, 91, 55)",failedColor:"red",thickness:"2px",transition:{speed:"0.2s",opacity:"0.6s",termination:300},location:"top",autoRevert:!0,inverse:!1}}}}};return{install:function(o){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},i=(o.version.split(".")[0],"undefined"!=typeof window),e={$vm:null,state:{tFailColor:"",tColor:"",timer:null,cut:0},init:function(t){this.$vm=t},start:function(t){var o=this;this.$vm&&(t||(t=3e3),this.$vm.RADON_LOADING_BAR.percent=0,this.$vm.RADON_LOADING_BAR.options.show=!0,this.$vm.RADON_LOADING_BAR.options.canSuccess=!0,this.state.cut=1e4/Math.floor(t),clearInterval(this.state.timer),this.state.timer=setInterval(function(){o.increase(o.state.cut*Math.random()),95<o.$vm.RADON_LOADING_BAR.percent&&o.$vm.RADON_LOADING_BAR.options.autoFinish&&o.finish()},100))},set:function(t){this.$vm.RADON_LOADING_BAR.options.show=!0,this.$vm.RADON_LOADING_BAR.options.canSuccess=!0,this.$vm.RADON_LOADING_BAR.percent=Math.floor(t)},get:function(){return Math.floor(this.$vm.RADON_LOADING_BAR.percent)},increase:function(t){this.$vm.RADON_LOADING_BAR.percent=Math.min(99,this.$vm.RADON_LOADING_BAR.percent+Math.floor(t))},decrease:function(t){this.$vm.RADON_LOADING_BAR.percent=this.$vm.RADON_LOADING_BAR.percent-Math.floor(t)},hide:function(){var t=this;clearInterval(this.state.timer),this.state.timer=null,setTimeout(function(){t.$vm.RADON_LOADING_BAR.options.show=!1,o.nextTick(function(){setTimeout(function(){t.$vm.RADON_LOADING_BAR.percent=0},100),t.$vm.RADON_LOADING_BAR.options.autoRevert&&setTimeout(function(){t.revert()},300)})},this.$vm.RADON_LOADING_BAR.options.transition.termination)},pause:function(){clearInterval(this.state.timer)},finish:function(){this.$vm&&(this.$vm.RADON_LOADING_BAR.percent=100,this.hide())},fail:function(){this.$vm.RADON_LOADING_BAR.options.canSuccess=!1,this.$vm.RADON_LOADING_BAR.percent=100,this.hide()},setFailColor:function(t){this.$vm.RADON_LOADING_BAR.options.failedColor=t},setColor:function(t){this.$vm.RADON_LOADING_BAR.options.color=t},setLocation:function(t){this.$vm.RADON_LOADING_BAR.options.location=t},setTransition:function(t){this.$vm.RADON_LOADING_BAR.options.transition=t},tempFailColor:function(t){this.state.tFailColor=this.$vm.RADON_LOADING_BAR.options.failedColor,this.$vm.RADON_LOADING_BAR.options.failedColor=t},tempColor:function(t){this.state.tColor=this.$vm.RADON_LOADING_BAR.options.color,this.$vm.RADON_LOADING_BAR.options.color=t},tempLocation:function(t){this.state.tLocation=this.$vm.RADON_LOADING_BAR.options.location,this.$vm.RADON_LOADING_BAR.options.location=t},tempTransition:function(t){this.state.tTransition=this.$vm.RADON_LOADING_BAR.options.transition,this.$vm.RADON_LOADING_BAR.options.transition=t},revertColor:function(){this.$vm.RADON_LOADING_BAR.options.color=this.state.tColor,this.state.tColor=""},revertFailColor:function(){this.$vm.RADON_LOADING_BAR.options.failedColor=this.state.tFailColor,this.state.tFailColor=""},revertLocation:function(){this.$vm.RADON_LOADING_BAR.options.location=this.state.tLocation,this.state.tLocation=""},revertTransition:function(){this.$vm.RADON_LOADING_BAR.options.transition=this.state.tTransition,this.state.tTransition={}},revert:function(){this.$vm.RADON_LOADING_BAR.options.autoRevert&&(this.state.tColor&&this.revertColor(),this.state.tFailColor&&this.revertFailColor(),this.state.tLocation&&this.revertLocation(),!this.state.tTransition||void 0===this.state.tTransition.speed&&void 0===this.state.tTransition.opacity||this.revertTransition())},parseMeta:function(t){for(var o in t.func){var i=t.func[o];switch(i.call){case"color":switch(i.modifier){case"set":this.setColor(i.argument);break;case"temp":this.tempColor(i.argument)}break;case"fail":switch(i.modifier){case"set":this.setFailColor(i.argument);break;case"temp":this.tempFailColor(i.argument)}break;case"location":switch(i.modifier){case"set":this.setLocation(i.argument);break;case"temp":this.tempLocation(i.argument)}break;case"transition":switch(i.modifier){case"set":this.setTransition(i.argument);break;case"temp":this.tempTransition(i.argument)}}}}},s=function(t,o){for(var i,e,s=1;s<arguments.length;++s)for(i in e=arguments[s])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}({canSuccess:!0,show:!1,color:"#73ccec",position:"fixed",failedColor:"red",thickness:"2px",transition:{speed:"0.2s",opacity:"0.6s",termination:300},autoRevert:!0,location:"top",inverse:!1,autoFinish:!0},t),n=new o({data:{RADON_LOADING_BAR:{percent:0,options:s}}});i&&(window.VueProgressBarEventBus=n,e.init(n)),o.component("vue-progress-bar",r),o.prototype.$Progress=e}}});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var Rollbar = __webpack_require__(589);

module.exports = {
  install: function(Vue, options) {
    Vue.rollbar = new Rollbar(options);
    Vue.prototype.rollbar = Vue.rollbar;
  }
};


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.rollbar=e():t.rollbar=e()}(this,function(){return r={},o.m=n=[function(t,e,n){var y=n(10),i={},r=!1;function p(t,e){return e===b(t)}function b(t){var e=typeof t;return"object"!=e?e:t?t instanceof Error?"error":{}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase():"null"}function a(t){return p(t,"function")}function o(t){var e=Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?"),n=RegExp("^"+e+"$");return function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}(t)&&n.test(t)}function u(t,e,n){var r,o,i,a=p(t,"object"),s=p(t,"array"),u=[];if(a&&-1!==n.indexOf(t))return t;if(n.push(t),a)for(r in t)Object.prototype.hasOwnProperty.call(t,r)&&u.push(r);else if(s)for(i=0;i<t.length;++i)u.push(i);var c=a?{}:[],l=!0;for(i=0;i<u.length;++i)o=t[r=u[i]],c[r]=e(r,o,n),l=l&&c[r]===t[r];return 0==u.length||l?t:c}function s(){return"********"}function w(){var n=x();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(t){var e=(n+16*Math.random())%16|0;return n=Math.floor(n/16),("x"===t?e:7&e|8).toString(16)})}r||(r=!0,p(JSON,"undefined")||(o(JSON.stringify)&&(i.stringify=JSON.stringify),o(JSON.parse)&&(i.parse=JSON.parse)),a(i.stringify)&&a(i.parse)||n(11)(i));var c={strictMode:!1,key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}};function l(e,n){var r,o;try{r=i.stringify(e)}catch(t){if(n&&a(n))try{r=n(e)}catch(t){o=t}else o=t}return{error:o,value:r}}function _(n,r){return function(t,e){try{r(t,e)}catch(t){n.error(t)}}}var f=["log","network","dom","navigation","error","manual"],h=["critical","error","warning","info","debug"];function d(t,e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1}function x(){return Date.now?+Date.now():+new Date}t.exports={addParamsAndAccessTokenToPath:function(t,e,n){(n=n||{}).access_token=t;var r,o=[];for(r in n)Object.prototype.hasOwnProperty.call(n,r)&&o.push([r,n[r]].join("="));var i="?"+o.sort().join("&");(e=e||{}).path=e.path||"";var a,s=e.path.indexOf("?"),u=e.path.indexOf("#");-1!==s&&(-1===u||s<u)?(a=e.path,e.path=a.substring(0,s)+i+"&"+a.substring(s+1)):-1!==u?(a=e.path,e.path=a.substring(0,u)+i+a.substring(u)):e.path=e.path+i},createItem:function(t,e,n,r,o){for(var i,a,s,u,c,l,p=[],f=0,h=t.length;f<h;++f){var d=b(l=t[f]);switch(d){case"undefined":break;case"string":i?p.push(l):i=l;break;case"function":u=_(e,l);break;case"date":p.push(l);break;case"error":case"domexception":case"exception":a?p.push(l):a=l;break;case"object":case"array":if(l instanceof Error||"undefined"!=typeof DOMException&&l instanceof DOMException){a?p.push(l):a=l;break}if(r&&"object"===d&&!c){for(var m=0,g=r.length;m<g;++m)if(void 0!==l[r[m]]){c=l;break}if(c)break}s?p.push(l):s=l;break;default:if(l instanceof Error||"undefined"!=typeof DOMException&&l instanceof DOMException){a?p.push(l):a=l;break}p.push(l)}}0<p.length&&((s=y(s)).extraArgs=p);var v={message:i,err:a,custom:s,timestamp:x(),callback:u,uuid:w()};return s&&void 0!==s.level&&(v.level=s.level,delete s.level),r&&c&&(v.request=c),o&&(v.lambdaContext=o),v._originalArgs=t,v},createTelemetryEvent:function(t){for(var e,n,r,o,i=0,a=t.length;i<a;++i)switch(b(o=t[i])){case"string":d(f,o)?e=o:d(h,o)&&(r=o);break;case"object":n=o}return{type:e||"manual",metadata:n||{},level:r}},filterIp:function(t,e){if(t&&t.user_ip&&!0!==e){var n=t.user_ip;if(e)try{var r;if(-1!==n.indexOf("."))(r=n.split(".")).pop(),r.push("0"),n=r.join(".");else if(-1!==n.indexOf(":")){if(2<(r=n.split(":")).length){var o=r.slice(0,3),i=o[2].indexOf("/");-1!==i&&(o[2]=o[2].substring(0,i)),n=o.concat("0000:0000:0000:0000:0000").join(":")}}else n=null}catch(t){n=null}else n=null;t.user_ip=n}},formatArgsAsString:function(t){var e,n,r,o=[];for(e=0,n=t.length;e<n;++e){switch(b(r=t[e])){case"object":500<(r=(r=l(r)).error||r.value).length&&(r=r.substr(0,497)+"...");break;case"null":r="null";break;case"undefined":r="undefined";break;case"symbol":r=r.toString()}o.push(r)}return o.join(" ")},formatUrl:function(t,e){if(!(e=e||t.protocol)&&t.port&&(80===t.port?e="http:":443===t.port&&(e="https:")),e=e||"https:",!t.hostname)return null;var n=e+"//"+t.hostname;return t.port&&(n=n+":"+t.port),t.path&&(n+=t.path),n},get:function(t,e){if(t){var n=e.split("."),r=t;try{for(var o=0,i=n.length;o<i;++o)r=r[n[o]]}catch(t){r=void 0}return r}},handleOptions:function(t,e,n){var r=y(t,e,n);return!e||e.overwriteScrubFields||e.scrubFields&&(r.scrubFields=(t.scrubFields||[]).concat(e.scrubFields)),r},isError:function(t){return p(t,"error")||p(t,"exception")},isFunction:a,isIterable:function(t){var e=b(t);return"object"===e||"array"===e},isNativeFunction:o,isType:p,jsonParse:function(t){var e,n;try{e=i.parse(t)}catch(t){n=t}return{error:n,value:e}},LEVELS:{debug:0,info:1,warning:2,error:3,critical:4},makeUnhandledStackInfo:function(t,e,n,r,o,i,a,s){var u={url:e||"",line:n,column:r};u.func=s.guessFunctionName(u.url,u.line),u.context=s.gatherContext(u.url,u.line);var c=document&&document.location&&document.location.href,l=window&&window.navigator&&window.navigator.userAgent;return{mode:i,message:o?String(o):t||a,url:c,stack:[u],useragent:l}},merge:y,now:x,redact:s,sanitizeUrl:function(t){var e=function(t){if(p(t,"string")){for(var r=c,e=r.parser[r.strictMode?"strict":"loose"].exec(t),o={},n=0,i=r.key.length;n<i;++n)o[r.key[n]]=e[n]||"";return o[r.q.name]={},o[r.key[12]].replace(r.q.parser,function(t,e,n){e&&(o[r.q.name][e]=n)}),o}}(t);return e?(""===e.anchor&&(e.source=e.source.replace("#","")),t=e.source.replace("?"+e.query,"")):"(unknown)"},scrub:function(t,e){var i=function(t){for(var e,n=[],r=0;r<t.length;++r)e="^\\[?(%5[bB])?"+t[r]+"\\[?(%5[bB])?\\]?(%5[dD])?$",n.push(new RegExp(e,"i"));return n}(e=e||[]),a=function(t){for(var e,n=[],r=0;r<t.length;++r)e="\\[?(%5[bB])?"+t[r]+"\\[?(%5[bB])?\\]?(%5[dD])?",n.push(new RegExp("("+e+"=)([^&\\n]+)","igm"));return n}(e);function s(t,e){return e+"********"}return u(t,function t(e,n,r){var o=function(t,e){var n;for(n=0;n<i.length;++n)if(i[n].test(t)){e="********";break}return e}(e,n);return o===n?p(n,"object")||p(n,"array")?u(n,t,r):function(t){var e;if(p(t,"string"))for(e=0;e<a.length;++e)t=t.replace(a[e],s);return t}(o):o},[])},set:function(t,e,n){if(t){var r=e.split("."),o=r.length;if(!(o<1))if(1!==o)try{for(var i=t[r[0]]||{},a=i,s=1;s<o-1;++s)i[r[s]]=i[r[s]]||{},i=i[r[s]];i[r[o-1]]=n,t[r[0]]=a}catch(t){return}else t[r[0]]=n}},stringify:l,traverse:u,typeName:b,uuid4:w}},function(t,e,n){n(17);var r=n(18),o=n(0);t.exports={error:function(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),r.ieVersion()<=8?console.error(o.formatArgsAsString(t)):console.error.apply(console,t)},info:function(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),r.ieVersion()<=8?console.info(o.formatArgsAsString(t)):console.info.apply(console,t)},log:function(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),r.ieVersion()<=8?console.log(o.formatArgsAsString(t)):console.log.apply(console,t)}}},function(t,e,n){var s=n(0);function c(t,e){return[t,s.stringify(t,e)]}function u(t,e){var n=t.length;return 2*e<n?t.slice(0,e).concat(t.slice(n-e)):t}function l(t,e,n){n=void 0===n?30:n;var r,o=t.data.body;if(o.trace_chain)for(var i=o.trace_chain,a=0;a<i.length;a++)r=u(r=i[a].frames,n),i[a].frames=r;else o.trace&&(r=u(r=o.trace.frames,n),o.trace.frames=r);return[t,s.stringify(t,e)]}function i(t,e){return e&&e.length>t?e.slice(0,t-3).concat("..."):e}function p(o,t,e){return[t=s.traverse(t,function t(e,n,r){switch(s.typeName(n)){case"string":return i(o,n);case"object":case"array":return s.traverse(n,t,r);default:return n}},[]),s.stringify(t,e)]}function a(t){return t.exception&&(delete t.exception.description,t.exception.message=i(255,t.exception.message)),t.frames=u(t.frames,1),t}function f(t,e){var n=t.data.body;if(n.trace_chain)for(var r=n.trace_chain,o=0;o<r.length;o++)r[o]=a(r[o]);else n.trace&&(n.trace=a(n.trace));return[t,s.stringify(t,e)]}t.exports={truncate:function(t,e,n){n=void 0===n?524288:n;for(var r,o,i,a,s,u=[c,l,p.bind(null,1024),p.bind(null,512),p.bind(null,256),f];r=u.shift();)if(t=(o=r(t,e))[0],(i=o[1]).error||(a=i.value,s=n,!(a.length>s)))return i;return i},raw:c,truncateFrames:l,truncateStrings:p,maybeTruncateValue:i}},function(t,e){t.exports={parse:function(t){var e,n,r={protocol:null,auth:null,host:null,path:null,hash:null,href:t,hostname:null,port:null,pathname:null,search:null,query:null};if(n=-1!==(e=t.indexOf("//"))?(r.protocol=t.substring(0,e),e+2):0,-1!==(e=t.indexOf("@",n))&&(r.auth=t.substring(n,e),n=e+1),-1===(e=t.indexOf("/",n))){if(-1===(e=t.indexOf("?",n)))return-1===(e=t.indexOf("#",n))?r.host=t.substring(n):(r.host=t.substring(n,e),r.hash=t.substring(e)),r.hostname=r.host.split(":")[0],r.port=r.host.split(":")[1],r.port&&(r.port=parseInt(r.port,10)),r;r.host=t.substring(n,e),r.hostname=r.host.split(":")[0],r.port=r.host.split(":")[1],r.port&&(r.port=parseInt(r.port,10)),n=e}else r.host=t.substring(n,e),r.hostname=r.host.split(":")[0],r.port=r.host.split(":")[1],r.port&&(r.port=parseInt(r.port,10)),n=e;if(-1===(e=t.indexOf("#",n))?r.path=t.substring(n):(r.path=t.substring(n,e),r.hash=t.substring(e)),r.path){var o=r.path.split("?");r.pathname=o[0],r.query=o[1],r.search=r.query?"?"+r.query:null}return r}}},function(t,e,n){var i=n(22),r=new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");function o(){return null}function a(t){var e={};return e._stackFrame=t,e.url=t.fileName,e.line=t.lineNumber,e.func=t.functionName,e.column=t.columnNumber,e.args=t.args,e.context=null,e}function s(o){var t=o.constructor&&o.constructor.name;return t&&t.length&&!(t.length<3)||(t=o.name),{stack:function(){var e,n=[];if(o.stack)e=o;else try{throw o}catch(t){e=t}try{n=i.parse(e)}catch(t){n=[]}for(var t=[],r=0;r<n.length;r++)t.push(new a(n[r]));return t}(),message:o.message,name:t,rawStack:o.stack,rawException:o}}t.exports={guessFunctionName:function(){return"?"},guessErrorClass:function(t){if(!t||!t.match)return["Unknown error. There was no error message to display.",""];var e=t.match(r),n="(unknown)";return e&&(n=e[e.length-1],t=(t=t.replace((e[e.length-2]||"")+n+":","")).replace(/(^[\s]+|[\s]+$)/g,"")),[n,t]},gatherContext:o,parse:function(t){return new s(t)},Stack:s,Frame:a}},function(t,e,n){t.exports=n(6)},function(t,e,n){var r=n(7),o="undefined"!=typeof window&&window._rollbarConfig,i=o&&o.globalAlias||"Rollbar",a="undefined"!=typeof window&&window[i]&&"function"==typeof window[i].shimId&&void 0!==window[i].shimId();if("undefined"==typeof window||window._rollbarStartTime||(window._rollbarStartTime=(new Date).getTime()),!a&&o){var s=new r(o);window[i]=s}else"undefined"!=typeof window?(window.rollbar=r,window._rollbarDidLoad=!0):"undefined"!=typeof self&&(self.rollbar=r,self._rollbarDidLoad=!0);t.exports=r},function(t,e,n){var i=n(8),u=n(0),a=n(15),s=n(1),r=n(19),c=n(20),l=n(3),p=n(21),f=n(24),h=n(25),d=n(26),m=n(4),g=n(27);function o(t,e){this.options=u.handleOptions(_,t),this.options._configuredOptions=t;var n=new a(this.options,c,l);this.client=e||new i(this.options,n,s,"browser");var r=w(),o="undefined"!=typeof document&&document;this.isChrome=r.chrome&&r.chrome.runtime,this.anonymousErrorsPending=0,function(t,e){t.addTransform(p.handleItemWithError).addTransform(p.ensureItemHasSomethingToSay).addTransform(p.addBaseInfo).addTransform(p.addRequestInfo(e)).addTransform(p.addClientInfo(e)).addTransform(p.addPluginInfo(e)).addTransform(p.addBody).addTransform(f.addMessageWithError).addTransform(f.addTelemetryData).addTransform(f.addConfigToPayload).addTransform(p.scrubPayload).addTransform(f.userTransform(s)).addTransform(f.addConfiguredOptions).addTransform(f.addDiagnosticKeys).addTransform(f.itemToPayload)}(this.client.notifier,r),function(t){t.addPredicate(d.checkLevel).addPredicate(h.checkIgnore).addPredicate(d.userCheckIgnore(s)).addPredicate(d.urlIsNotBlacklisted(s)).addPredicate(d.urlIsWhitelisted(s)).addPredicate(d.messageIsIgnored(s))}(this.client.queue),this.setupUnhandledCapture(),this.instrumenter=new g(this.options,this.client.telemeter,this,r,o),this.instrumenter.instrument()}var v=null;function y(t){var e="Rollbar is not initialized";s.error(e),t&&t(new Error(e))}function b(t){for(var e=0,n=t.length;e<n;++e)if(u.isFunction(t[e]))return t[e]}function w(){return"undefined"!=typeof window&&window||"undefined"!=typeof self&&self}o.init=function(t,e){return v?v.global(t).configure(t):v=new o(t,e)},o.prototype.global=function(t){return this.client.global(t),this},o.global=function(t){if(v)return v.global(t);y()},o.prototype.configure=function(t,e){var n=this.options,r={};return e&&(r={payload:e}),this.options=u.handleOptions(n,t,r),this.options._configuredOptions=u.handleOptions(n._configuredOptions,t,r),this.client.configure(this.options,e),this.instrumenter.configure(this.options),this.setupUnhandledCapture(),this},o.configure=function(t,e){if(v)return v.configure(t,e);y()},o.prototype.lastError=function(){return this.client.lastError},o.lastError=function(){if(v)return v.lastError();y()},o.prototype.log=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.log(t),{uuid:e}},o.log=function(){if(v)return v.log.apply(v,arguments);y(b(arguments))},o.prototype.debug=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.debug(t),{uuid:e}},o.debug=function(){if(v)return v.debug.apply(v,arguments);y(b(arguments))},o.prototype.info=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.info(t),{uuid:e}},o.info=function(){if(v)return v.info.apply(v,arguments);y(b(arguments))},o.prototype.warn=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warn(t),{uuid:e}},o.warn=function(){if(v)return v.warn.apply(v,arguments);y(b(arguments))},o.prototype.warning=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warning(t),{uuid:e}},o.warning=function(){if(v)return v.warning.apply(v,arguments);y(b(arguments))},o.prototype.error=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.error(t),{uuid:e}},o.error=function(){if(v)return v.error.apply(v,arguments);y(b(arguments))},o.prototype.critical=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.critical(t),{uuid:e}},o.critical=function(){if(v)return v.critical.apply(v,arguments);y(b(arguments))},o.prototype.buildJsonPayload=function(t){return this.client.buildJsonPayload(t)},o.buildJsonPayload=function(){if(v)return v.buildJsonPayload.apply(v,arguments);y()},o.prototype.sendJsonPayload=function(t){return this.client.sendJsonPayload(t)},o.sendJsonPayload=function(){if(v)return v.sendJsonPayload.apply(v,arguments);y()},o.prototype.setupUnhandledCapture=function(){var t=w();this.unhandledExceptionsInitialized||(this.options.captureUncaught||this.options.handleUncaughtExceptions)&&(r.captureUncaughtExceptions(t,this),r.wrapGlobals(t,this),this.unhandledExceptionsInitialized=!0),this.unhandledRejectionsInitialized||(this.options.captureUnhandledRejections||this.options.handleUnhandledRejections)&&(r.captureUnhandledRejections(t,this),this.unhandledRejectionsInitialized=!0)},o.prototype.handleUncaughtException=function(t,e,n,r,o,i){if(this.options.captureUncaught||this.options.handleUncaughtExceptions)if(this.options.inspectAnonymousErrors&&this.isChrome&&!o)this.anonymousErrorsPending+=1;else{var a,s=u.makeUnhandledStackInfo(t,e,n,r,o,"onerror","uncaught exception",m);u.isError(o)?(a=this._createItem([t,o,i]))._unhandledStackInfo=s:u.isError(e)?(a=this._createItem([t,e,i]))._unhandledStackInfo=s:(a=this._createItem([t,i])).stackInfo=s,a.level=this.options.uncaughtErrorLevel,a._isUncaught=!0,this.client.log(a)}},o.prototype.handleAnonymousErrors=function(){if(this.options.inspectAnonymousErrors&&this.isChrome){var n=this;try{Error.prepareStackTrace=function(t,e){if(n.options.inspectAnonymousErrors&&n.anonymousErrorsPending){if(n.anonymousErrorsPending-=1,!t)return;t._isAnonymous=!0,n.handleUncaughtException(t.message,null,null,null,t)}return t.toString()}}catch(t){this.options.inspectAnonymousErrors=!1,this.error("anonymous error handler failed",t)}}},o.prototype.handleUnhandledRejection=function(t,e){if(this.options.captureUnhandledRejections||this.options.handleUnhandledRejections){var n="unhandled rejection was null or undefined!";if(t)if(t.message)n=t.message;else{var r=u.stringify(t);r.value&&(n=r.value)}var o,i=t&&t._rollbarContext||e&&e._rollbarContext;u.isError(t)?o=this._createItem([n,t,i]):(o=this._createItem([n,t,i])).stackInfo=u.makeUnhandledStackInfo(n,"",0,0,null,"unhandledrejection","",m),o.level=this.options.uncaughtErrorLevel,o._isUncaught=!0,o._originalArgs=o._originalArgs||[],o._originalArgs.push(e),this.client.log(o)}},o.prototype.wrap=function(n,t,r){try{var o;if(o=u.isFunction(t)?t:function(){return t||{}},!u.isFunction(n))return n;if(n._isWrap)return n;if(!n._rollbar_wrapped&&(n._rollbar_wrapped=function(){r&&u.isFunction(r)&&r.apply(this,arguments);try{return n.apply(this,arguments)}catch(t){var e=t;throw e&&window._rollbarWrappedError!==e&&(u.isType(e,"string")&&(e=new String(e)),e._rollbarContext=o()||{},e._rollbarContext._wrappedSource=n.toString(),window._rollbarWrappedError=e),e}},n._rollbar_wrapped._isWrap=!0,n.hasOwnProperty))for(var e in n)n.hasOwnProperty(e)&&"_rollbar_wrapped"!==e&&(n._rollbar_wrapped[e]=n[e]);return n._rollbar_wrapped}catch(t){return n}},o.wrap=function(t,e){if(v)return v.wrap(t,e);y()},o.prototype.captureEvent=function(){var t=u.createTelemetryEvent(arguments);return this.client.captureEvent(t.type,t.metadata,t.level)},o.captureEvent=function(){if(v)return v.captureEvent.apply(v,arguments);y()},o.prototype.captureDomContentLoaded=function(t,e){return e||(e=new Date),this.client.captureDomContentLoaded(e)},o.prototype.captureLoad=function(t,e){return e||(e=new Date),this.client.captureLoad(e)};var _={version:"2.9.0",scrubFields:["pw","pass","passwd","password","secret","confirm_password","confirmPassword","password_confirmation","passwordConfirmation","access_token","accessToken","secret_key","secretKey","secretToken","cc-number","card number","cardnumber","cardnum","ccnum","ccnumber","cc num","creditcardnumber","credit card number","newcreditcardnumber","new credit card","creditcardno","credit card no","card#","card #","cc-csc","cvc2","cvv2","ccv2","security code","card verification","name on credit card","name on card","nameoncard","cardholder","card holder","name des karteninhabers","card type","cardtype","cc type","cctype","payment type","expiration date","expirationdate","expdate","cc-exp"],logLevel:"debug",reportLevel:"debug",uncaughtErrorLevel:"error",endpoint:"api.rollbar.com/api/1/item/",verbose:!(o.prototype._createItem=function(t){return u.createItem(t,s,this)}),enabled:!0,transmit:!0,sendConfig:!1,includeItemsInTelemetry:!0,captureIp:!0,inspectAnonymousErrors:!0};t.exports=o},function(t,e,n){var r=n(9),o=n(12),i=n(13),a=n(14),s=n(0);function u(t,e,n,r){this.options=s.merge(t),this.logger=n,u.rateLimiter.configureGlobal(this.options),u.rateLimiter.setPlatformOptions(r,this.options),this.api=e,this.queue=new o(u.rateLimiter,e,n,this.options),this.notifier=new i(this.queue,this.options),this.telemeter=new a(this.options),this.lastError=null,this.lastErrorHash="none"}u.rateLimiter=new r({maxItems:0,itemsPerMinute:60}),u.prototype.global=function(t){return u.rateLimiter.configureGlobal(t),this},u.prototype.configure=function(t,e){var n=this.options,r={};return e&&(r={payload:e}),this.options=s.merge(n,t,r),this.notifier&&this.notifier.configure(this.options),this.telemeter&&this.telemeter.configure(this.options),this.global(this.options),this},u.prototype.log=function(t){var e=this._defaultLogLevel();return this._log(e,t)},u.prototype.debug=function(t){this._log("debug",t)},u.prototype.info=function(t){this._log("info",t)},u.prototype.warn=function(t){this._log("warning",t)},u.prototype.warning=function(t){this._log("warning",t)},u.prototype.error=function(t){this._log("error",t)},u.prototype.critical=function(t){this._log("critical",t)},u.prototype.wait=function(t){this.queue.wait(t)},u.prototype.captureEvent=function(t,e,n){return this.telemeter.captureEvent(t,e,n)},u.prototype.captureDomContentLoaded=function(t){return this.telemeter.captureDomContentLoaded(t)},u.prototype.captureLoad=function(t){return this.telemeter.captureLoad(t)},u.prototype.buildJsonPayload=function(t){return this.api.buildJsonPayload(t)},u.prototype.sendJsonPayload=function(t){this.api.postJsonPayload(t)},u.prototype._log=function(t,e){var n;if(e.callback&&(n=e.callback,delete e.callback),this._sameAsLastError(e)){if(n){var r=new Error("ignored identical item");r.item=e,n(r)}}else try{e.level=e.level||t,this.telemeter._captureRollbarItem(e),e.telemetryEvents=this.telemeter.copyEvents(),this.notifier.log(e,n)}catch(t){this.logger.error(t)}},u.prototype._defaultLogLevel=function(){return this.options.logLevel||"debug"},u.prototype._sameAsLastError=function(t){if(!t._isUncaught)return!1;var e=function(t){var e=t.message||"",n=(t.err||{}).stack||String(t.err);return e+"::"+n}(t);return this.lastErrorHash===e||(this.lastError=t.err,this.lastErrorHash=e,!1)},t.exports=u},function(t,e,n){var s=n(0);function u(t){this.startTime=s.now(),this.counter=0,this.perMinCounter=0,this.platform=null,this.platformOptions={},this.configureGlobal(t)}function c(t,e,n){return!t.ignoreRateLimit&&1<=e&&e<n}function l(t,e,n,r,o,i,a){var s=null;return n&&(n=new Error(n)),n||r||(s=function(t,e,n,r,o){var i,a=e.environment||e.payload&&e.payload.environment;i=o?"item per minute limit reached, ignoring errors until timeout":"maxItems has been hit, ignoring errors until reset.";var s={body:{message:{body:i,extra:{maxItems:n,itemsPerMinute:r}}},language:"javascript",environment:a,notifier:{version:e.notifier&&e.notifier.version||e.version}};"browser"===t?(s.platform="browser",s.framework="browser-js",s.notifier.name="rollbar-browser-js"):"server"===t?(s.framework=e.framework||"node-js",s.notifier.name=e.notifier.name):"react-native"===t&&(s.framework=e.framework||"react-native",s.notifier.name=e.notifier.name);return s}(t,e,o,i,a)),{error:n,shouldSend:r,payload:s}}u.globalSettings={startTime:s.now(),maxItems:void 0,itemsPerMinute:void 0},u.prototype.configureGlobal=function(t){void 0!==t.startTime&&(u.globalSettings.startTime=t.startTime),void 0!==t.maxItems&&(u.globalSettings.maxItems=t.maxItems),void 0!==t.itemsPerMinute&&(u.globalSettings.itemsPerMinute=t.itemsPerMinute)},u.prototype.shouldSend=function(t,e){var n=(e=e||s.now())-this.startTime;(n<0||6e4<=n)&&(this.startTime=e,this.perMinCounter=0);var r=u.globalSettings.maxItems,o=u.globalSettings.itemsPerMinute;if(c(t,r,this.counter))return l(this.platform,this.platformOptions,r+" max items reached",!1);if(c(t,o,this.perMinCounter))return l(this.platform,this.platformOptions,o+" items per minute reached",!1);this.counter++,this.perMinCounter++;var i=!c(t,r,this.counter),a=i;return i=i&&!c(t,o,this.perMinCounter),l(this.platform,this.platformOptions,null,i,r,o,a)},u.prototype.setPlatformOptions=function(t,e){this.platform=t,this.platformOptions=e},t.exports=u},function(t,e,n){"use strict";var o=Object.prototype.hasOwnProperty,i=Object.prototype.toString,c=function(t){if(!t||"[object Object]"!==i.call(t))return!1;var e,n=o.call(t,"constructor"),r=t.constructor&&t.constructor.prototype&&o.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!n&&!r)return!1;for(e in t);return void 0===e||o.call(t,e)};t.exports=function t(){var e,n,r,o,i,a={},s=null,u=arguments.length;for(e=0;e<u;e++)if(null!=(s=arguments[e]))for(i in s)n=a[i],a!==(r=s[i])&&(r&&c(r)?(o=n&&c(n)?n:{},a[i]=t(o,r)):void 0!==r&&(a[i]=r));return a}},function(t,e){t.exports=function(t){var l,p,n,f,o,i,e,r,s,u,c,h,d,a=/[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;function m(t){return t<10?"0"+t:t}function g(){return this.valueOf()}function v(t){return a.lastIndex=0,a.test(t)?'"'+t.replace(a,function(t){var e=n[t];return"string"==typeof e?e:"\\u"+("0000"+t.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+t+'"'}"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+m(this.getUTCMonth()+1)+"-"+m(this.getUTCDate())+"T"+m(this.getUTCHours())+":"+m(this.getUTCMinutes())+":"+m(this.getUTCSeconds())+"Z":null},Boolean.prototype.toJSON=g,Number.prototype.toJSON=g,String.prototype.toJSON=g),"function"!=typeof t.stringify&&(n={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},t.stringify=function(t,e,n){var r;if(p=l="","number"==typeof n)for(r=0;r<n;r+=1)p+=" ";else"string"==typeof n&&(p=n);if((f=e)&&"function"!=typeof e&&("object"!=typeof e||"number"!=typeof e.length))throw new Error("JSON.stringify");return function t(e,n){var r,o,i,a,s,u=l,c=n[e];switch(c&&"object"==typeof c&&"function"==typeof c.toJSON&&(c=c.toJSON(e)),"function"==typeof f&&(c=f.call(n,e,c)),typeof c){case"string":return v(c);case"number":return isFinite(c)?String(c):"null";case"boolean":case"null":return String(c);case"object":if(!c)return"null";if(l+=p,s=[],"[object Array]"===Object.prototype.toString.apply(c)){for(a=c.length,r=0;r<a;r+=1)s[r]=t(r,c)||"null";return i=0===s.length?"[]":l?"[\n"+l+s.join(",\n"+l)+"\n"+u+"]":"["+s.join(",")+"]",l=u,i}if(f&&"object"==typeof f)for(a=f.length,r=0;r<a;r+=1)"string"!=typeof f[r]||(i=t(o=f[r],c))&&s.push(v(o)+(l?": ":":")+i);else for(o in c)!Object.prototype.hasOwnProperty.call(c,o)||(i=t(o,c))&&s.push(v(o)+(l?": ":":")+i);return i=0===s.length?"{}":l?"{\n"+l+s.join(",\n"+l)+"\n"+u+"}":"{"+s.join(",")+"}",l=u,i}}("",{"":t})}),"function"!=typeof t.parse&&(t.parse=(u={"\\":"\\",'"':'"',"/":"/",t:"\t",n:"\n",r:"\r",f:"\f",b:"\b"},c={go:function(){o="ok"},firstokey:function(){r=s,o="colon"},okey:function(){r=s,o="colon"},ovalue:function(){o="ocomma"},firstavalue:function(){o="acomma"},avalue:function(){o="acomma"}},h={go:function(){o="ok"},ovalue:function(){o="ocomma"},firstavalue:function(){o="acomma"},avalue:function(){o="acomma"}},d={"{":{go:function(){i.push({state:"ok"}),e={},o="firstokey"},ovalue:function(){i.push({container:e,state:"ocomma",key:r}),e={},o="firstokey"},firstavalue:function(){i.push({container:e,state:"acomma"}),e={},o="firstokey"},avalue:function(){i.push({container:e,state:"acomma"}),e={},o="firstokey"}},"}":{firstokey:function(){var t=i.pop();s=e,e=t.container,r=t.key,o=t.state},ocomma:function(){var t=i.pop();e[r]=s,s=e,e=t.container,r=t.key,o=t.state}},"[":{go:function(){i.push({state:"ok"}),e=[],o="firstavalue"},ovalue:function(){i.push({container:e,state:"ocomma",key:r}),e=[],o="firstavalue"},firstavalue:function(){i.push({container:e,state:"acomma"}),e=[],o="firstavalue"},avalue:function(){i.push({container:e,state:"acomma"}),e=[],o="firstavalue"}},"]":{firstavalue:function(){var t=i.pop();s=e,e=t.container,r=t.key,o=t.state},acomma:function(){var t=i.pop();e.push(s),s=e,e=t.container,r=t.key,o=t.state}},":":{colon:function(){if(Object.hasOwnProperty.call(e,r))throw new SyntaxError("Duplicate key '"+r+'"');o="ovalue"}},",":{ocomma:function(){e[r]=s,o="okey"},acomma:function(){e.push(s),o="avalue"}},true:{go:function(){s=!0,o="ok"},ovalue:function(){s=!0,o="ocomma"},firstavalue:function(){s=!0,o="acomma"},avalue:function(){s=!0,o="acomma"}},false:{go:function(){s=!1,o="ok"},ovalue:function(){s=!1,o="ocomma"},firstavalue:function(){s=!1,o="acomma"},avalue:function(){s=!1,o="acomma"}},null:{go:function(){s=null,o="ok"},ovalue:function(){s=null,o="ocomma"},firstavalue:function(){s=null,o="acomma"},avalue:function(){s=null,o="acomma"}}},function(t,a){var e,n,r=/^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;o="go",i=[];try{for(;e=r.exec(t);)e[1]?d[e[1]][o]():e[2]?(s=+e[2],h[o]()):(n=e[3],s=n.replace(/\\(?:u(.{4})|([^u]))/g,function(t,e,n){return e?String.fromCharCode(parseInt(e,16)):u[n]}),c[o]()),t=t.slice(e[0].length)}catch(t){o=t}if("ok"!==o||/[^\u0020\t\n\r]/.test(t))throw o instanceof SyntaxError?o:new SyntaxError("JSON");return"function"==typeof a?function t(e,n){var r,o,i=e[n];if(i&&"object"==typeof i)for(r in s)Object.prototype.hasOwnProperty.call(i,r)&&(void 0!==(o=t(i,r))?i[r]=o:delete i[r]);return a.call(e,n,i)}({"":s},""):s}))}},function(t,e,n){var i=n(0);function r(t,e,n,r){this.rateLimiter=t,this.api=e,this.logger=n,this.options=r,this.predicates=[],this.pendingItems=[],this.pendingRequests=[],this.retryQueue=[],this.retryHandle=null,this.waitCallback=null,this.waitIntervalID=null}r.prototype.configure=function(t){this.api&&this.api.configure(t);var e=this.options;return this.options=i.merge(e,t),this},r.prototype.addPredicate=function(t){return i.isFunction(t)&&this.predicates.push(t),this},r.prototype.addPendingItem=function(t){this.pendingItems.push(t)},r.prototype.removePendingItem=function(t){var e=this.pendingItems.indexOf(t);-1!==e&&this.pendingItems.splice(e,1)},r.prototype.addItem=function(n,r,t,e){r&&i.isFunction(r)||(r=function(){});var o=this._applyPredicates(n);if(o.stop)return this.removePendingItem(e),void r(o.err);if(this._maybeLog(n,t),this.removePendingItem(e),this.options.transmit){this.pendingRequests.push(n);try{this._makeApiRequest(n,function(t,e){this._dequeuePendingRequest(n),r(t,e)}.bind(this))}catch(t){this._dequeuePendingRequest(n),r(t)}}else r(new Error("Transmit disabled"))},r.prototype.wait=function(t){i.isFunction(t)&&(this.waitCallback=t,this._maybeCallWait()||(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitIntervalID=setInterval(function(){this._maybeCallWait()}.bind(this),500)))},r.prototype._applyPredicates=function(t){for(var e=null,n=0,r=this.predicates.length;n<r;n++)if(!(e=this.predicates[n](t,this.options))||void 0!==e.err)return{stop:!0,err:e.err};return{stop:!1,err:null}},r.prototype._makeApiRequest=function(n,r){var t=this.rateLimiter.shouldSend(n);t.shouldSend?this.api.postItem(n,function(t,e){t?this._maybeRetry(t,n,r):r(t,e)}.bind(this)):t.error?r(t.error):this.api.postItem(t.payload,r)};var a=["ECONNRESET","ENOTFOUND","ESOCKETTIMEDOUT","ETIMEDOUT","ECONNREFUSED","EHOSTUNREACH","EPIPE","EAI_AGAIN"];r.prototype._maybeRetry=function(t,e,n){var r=!1;if(this.options.retryInterval)for(var o=0,i=a.length;o<i;o++)if(t.code===a[o]){r=!0;break}r?this._retryApiRequest(e,n):n(t)},r.prototype._retryApiRequest=function(t,e){this.retryQueue.push({item:t,callback:e}),this.retryHandle||(this.retryHandle=setInterval(function(){for(;this.retryQueue.length;){var t=this.retryQueue.shift();this._makeApiRequest(t.item,t.callback)}}.bind(this),this.options.retryInterval))},r.prototype._dequeuePendingRequest=function(t){var e=this.pendingRequests.indexOf(t);-1!==e&&(this.pendingRequests.splice(e,1),this._maybeCallWait())},r.prototype._maybeLog=function(t,e){if(this.logger&&this.options.verbose){var n=e;if(n=(n=n||i.get(t,"body.trace.exception.message"))||i.get(t,"body.trace_chain.0.exception.message"))return void this.logger.error(n);(n=i.get(t,"body.message.body"))&&this.logger.log(n)}},r.prototype._maybeCallWait=function(){return!(!i.isFunction(this.waitCallback)||0!==this.pendingItems.length||0!==this.pendingRequests.length)&&(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitCallback(),!0)},t.exports=r},function(t,e,n){var i=n(0);function r(t,e){this.queue=t,this.options=e,this.transforms=[]}r.prototype.configure=function(t){this.queue&&this.queue.configure(t);var e=this.options;return this.options=i.merge(e,t),this},r.prototype.addTransform=function(t){return i.isFunction(t)&&this.transforms.push(t),this},r.prototype.log=function(n,r){if(r&&i.isFunction(r)||(r=function(){}),!this.options.enabled)return r(new Error("Rollbar is not enabled"));this.queue.addPendingItem(n);var o=n.err;this._applyTransforms(n,function(t,e){if(t)return this.queue.removePendingItem(n),r(t,null);this.queue.addItem(e,r,o,n)}.bind(this))},r.prototype._applyTransforms=function(t,n){var r=-1,o=this.transforms.length,i=this.transforms,a=this.options,s=function(t,e){t?n(t,null):++r!==o?i[r](e,a,s):n(null,e)};s(null,t)},t.exports=r},function(t,e,n){var a=n(0);function r(t){this.queue=[],this.options=a.merge(t);var e=this.options.maxTelemetryEvents||100;this.maxQueueSize=Math.max(0,Math.min(e,100))}r.prototype.configure=function(t){var e=this.options;this.options=a.merge(e,t);var n=this.options.maxTelemetryEvents||100,r=Math.max(0,Math.min(n,100)),o=0;this.maxQueueSize>r&&(o=this.maxQueueSize-r),this.maxQueueSize=r,this.queue.splice(0,o)},r.prototype.copyEvents=function(){var t=Array.prototype.slice.call(this.queue,0);if(a.isFunction(this.options.filterTelemetry))try{for(var e=t.length;e--;)this.options.filterTelemetry(t[e])&&t.splice(e,1)}catch(t){this.options.filterTelemetry=null}return t},r.prototype.capture=function(t,e,n,r,o){var i={level:function(t,e){if(e)return e;return{error:"error",manual:"info"}[t]||"info"}(t,n),type:t,timestamp_ms:o||a.now(),body:e,source:"client"};r&&(i.uuid=r);try{if(a.isFunction(this.options.filterTelemetry)&&this.options.filterTelemetry(i))return!1}catch(t){this.options.filterTelemetry=null}return this.push(i),i},r.prototype.captureEvent=function(t,e,n,r){return this.capture(t,e,n,r)},r.prototype.captureError=function(t,e,n,r){var o={message:t.message||String(t)};return t.stack&&(o.stack=t.stack),this.capture("error",o,e,n,r)},r.prototype.captureLog=function(t,e,n,r){return this.capture("log",{message:t},e,n,r)},r.prototype.captureNetwork=function(t,e,n,r){e=e||"xhr",t.subtype=t.subtype||e,r&&(t.request=r);var o=this.levelFromStatus(t.status_code);return this.capture("network",t,o,n)},r.prototype.levelFromStatus=function(t){return 200<=t&&t<400?"info":0===t||400<=t?"error":"info"},r.prototype.captureDom=function(t,e,n,r,o){var i={subtype:t,element:e};return void 0!==n&&(i.value=n),void 0!==r&&(i.checked=r),this.capture("dom",i,"info",o)},r.prototype.captureNavigation=function(t,e,n){return this.capture("navigation",{from:t,to:e},"info",n)},r.prototype.captureDomContentLoaded=function(t){return this.capture("navigation",{subtype:"DOMContentLoaded"},"info",void 0,t&&t.getTime())},r.prototype.captureLoad=function(t){return this.capture("navigation",{subtype:"load"},"info",void 0,t&&t.getTime())},r.prototype.captureConnectivityChange=function(t,e){return this.captureNetwork({change:t},"connectivity",e)},r.prototype._captureRollbarItem=function(t){if(this.options.includeItemsInTelemetry)return t.err?this.captureError(t.err,t.level,t.uuid,t.timestamp):t.message?this.captureLog(t.message,t.level,t.uuid,t.timestamp):t.custom?this.capture("log",t.custom,t.level,t.uuid,t.timestamp):void 0},r.prototype.push=function(t){this.queue.push(t),this.queue.length>this.maxQueueSize&&this.queue.shift()},t.exports=r},function(t,e,n){var r=n(0),o=n(16),i=n(2),a={hostname:"api.rollbar.com",path:"/api/1/item/",search:null,version:"1",protocol:"https:",port:443};function s(t,e,n,r){this.options=t,this.transport=e,this.url=n,this.jsonBackup=r,this.accessToken=t.accessToken,this.transportOptions=u(t,n)}function u(t,e){return o.getTransportFromOptions(t,a,e)}s.prototype.postItem=function(t,e){var n=o.transportOptions(this.transportOptions,"POST"),r=o.buildPayload(this.accessToken,t,this.jsonBackup);this.transport.post(this.accessToken,n,r,e)},s.prototype.buildJsonPayload=function(t,e){var n=o.buildPayload(this.accessToken,t,this.jsonBackup),r=i.truncate(n);return r.error?(e&&e(r.error),null):r.value},s.prototype.postJsonPayload=function(t,e){var n=o.transportOptions(this.transportOptions,"POST");this.transport.postJsonPayload(this.accessToken,n,t,e)},s.prototype.configure=function(t){var e=this.oldOptions;return this.options=r.merge(e,t),this.transportOptions=u(this.options,this.url),void 0!==this.options.accessToken&&(this.accessToken=this.options.accessToken),this},t.exports=s},function(t,e,n){var o=n(0);t.exports={buildPayload:function(t,e,n){if(!o.isType(e.context,"string")){var r=o.stringify(e.context,n);r.error?e.context="Error: could not serialize 'context'":e.context=r.value||"",255<e.context.length&&(e.context=e.context.substr(0,255))}return{access_token:t,data:e}},getTransportFromOptions:function(t,e,n){var r=e.hostname,o=e.protocol,i=e.port,a=e.path,s=e.search,u=t.proxy;if(t.endpoint){var c=n.parse(t.endpoint);r=c.hostname,o=c.protocol,i=c.port,a=c.pathname,s=c.search}return{hostname:r,protocol:o,port:i,path:a,search:s,proxy:u}},transportOptions:function(t,e){var n=t.protocol||"https:",r=t.port||("http:"===n?80:"https:"===n?443:void 0),o=t.hostname,i=t.path;return t.search&&(i+=t.search),t.proxy&&(i=n+"//"+o+i,o=t.proxy.host||t.proxy.hostname,r=t.proxy.port,n=t.proxy.protocol||n),{protocol:n,hostname:o,path:i,port:r,method:e}},appendPathToPath:function(t,e){var n=/\/$/.test(t),r=/^\//.test(e);return n&&r?e=e.substring(1):n||r||(e="/"+e),t+e}}},function(t,e){!function(t){"use strict";t.console||(t.console={});for(var e,n,r=t.console,o=function(){},i=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=i.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=o)}("undefined"==typeof window?this:window)},function(t,e){var n={ieVersion:function(){if(document){for(var t=3,e=document.createElement("div"),n=e.getElementsByTagName("i");e.innerHTML="\x3c!--[if gt IE "+ ++t+"]><i></i><![endif]--\x3e",n[0];);return 4<t?t:void 0}}};t.exports=n},function(t,e){function a(r,t,e){if(t.hasOwnProperty&&t.hasOwnProperty("addEventListener")){for(var o=t.addEventListener;o._rollbarOldAdd&&o.belongsToShim;)o=o._rollbarOldAdd;function n(t,e,n){o.call(this,t,r.wrap(e),n)}n._rollbarOldAdd=o,n.belongsToShim=e,t.addEventListener=n;for(var i=t.removeEventListener;i._rollbarOldRemove&&i.belongsToShim;)i=i._rollbarOldRemove;function a(t,e,n){i.call(this,t,e&&e._rollbar_wrapped||e,n)}a._rollbarOldRemove=i,a.belongsToShim=e,t.removeEventListener=a}}t.exports={captureUncaughtExceptions:function(e,n,t){if(e){var r;if("function"==typeof n._rollbarOldOnError)r=n._rollbarOldOnError;else if(e.onerror){for(r=e.onerror;r._rollbarOldOnError;)r=r._rollbarOldOnError;n._rollbarOldOnError=r}function o(){var t=Array.prototype.slice.call(arguments,0);!function(t,e,n,r){t._rollbarWrappedError&&(r[4]||(r[4]=t._rollbarWrappedError),r[5]||(r[5]=t._rollbarWrappedError._rollbarContext),t._rollbarWrappedError=null),e.handleUncaughtException.apply(e,r),n&&n.apply(t,r)}(e,n,r,t)}n.handleAnonymousErrors(),t&&(o._rollbarOldOnError=r),e.onerror=o}},captureUnhandledRejections:function(t,o,e){if(t){function n(t){var e,n,r;try{e=t.reason}catch(t){e=void 0}try{n=t.promise}catch(t){n="[unhandledrejection] error getting `promise` from event"}try{r=t.detail,!e&&r&&(e=r.reason,n=r.promise)}catch(t){}e||(e="[unhandledrejection] error getting `reason` from event"),o&&o.handleUnhandledRejection&&o.handleUnhandledRejection(e,n)}"function"==typeof t._rollbarURH&&t._rollbarURH.belongsToShim&&t.removeEventListener("unhandledrejection",t._rollbarURH),n.belongsToShim=e,t._rollbarURH=n,t.addEventListener("unhandledrejection",n)}},wrapGlobals:function(t,e,n){if(t){var r,o,i="EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for(r=0;r<i.length;++r)t[o=i[r]]&&t[o].prototype&&a(e,t[o].prototype,n)}}}},function(t,e,n){var c=n(0),s=n(2),l=n(1);function u(t,e,n,r,o,i){var a="undefined"!=typeof window&&window||"undefined"!=typeof self&&self,s=a&&a.Zone&&a.Zone.current;s&&"angular"===s._name?s._parent.run(function(){p(t,e,n,r,o,i)}):p(t,e,n,r,o,i)}function p(t,e,n,r,o,i){if("undefined"!=typeof RollbarProxy)return function(t,e){(new RollbarProxy).sendJsonPayload(t,function(t){},function(t){e(new Error(t))})}(r,o);var a;if(!(a=i?i():function(){var t,e,n=[function(){return new XMLHttpRequest},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml3.XMLHTTP")},function(){return new ActiveXObject("Microsoft.XMLHTTP")}],r=n.length;for(e=0;e<r;e++)try{t=n[e]();break}catch(t){}return t}()))return o(new Error("No way to send a request"));try{try{var s=function(){try{if(s&&4===a.readyState){s=void 0;var t=c.jsonParse(a.responseText);if(function(t){return t&&t.status&&200===t.status}(a))return void o(t.error,t.value);if(function(t){return t&&c.isType(t.status,"number")&&400<=t.status&&t.status<600}(a)){if(403===a.status){var e=t.value&&t.value.message;l.error(e)}o(new Error(String(a.status)))}else{o(f("XHR response had no status code (likely connection failure)"))}}}catch(t){var n;n=t&&t.stack?t:new Error(t),o(n)}};a.open(n,e,!0),a.setRequestHeader&&(a.setRequestHeader("Content-Type","application/json"),a.setRequestHeader("X-Rollbar-Access-Token",t)),a.onreadystatechange=s,a.send(r)}catch(t){if("undefined"!=typeof XDomainRequest){if(!window||!window.location)return o(new Error("No window available during request, unknown environment"));"http:"===window.location.href.substring(0,5)&&"https"===e.substring(0,5)&&(e="http"+e.substring(5));var u=new XDomainRequest;u.onprogress=function(){},u.ontimeout=function(){o(f("Request timed out","ETIMEDOUT"))},u.onerror=function(){o(new Error("Error during request"))},u.onload=function(){var t=c.jsonParse(u.responseText);o(t.error,t.value)},u.open(n,e,!0),u.send(r)}else o(new Error("Cannot find a method to transport a request"))}}catch(t){o(t)}}function f(t,e){var n=new Error(t);return n.code=e||"ENOTFOUND",n}t.exports={get:function(t,e,n,r,o){r&&c.isFunction(r)||(r=function(){}),c.addParamsAndAccessTokenToPath(t,e,n),u(t,c.formatUrl(e),"GET",null,r,o)},post:function(t,e,n,r,o){if(r&&c.isFunction(r)||(r=function(){}),!n)return r(new Error("Cannot send empty request"));var i=s.truncate(n);if(i.error)return r(i.error);var a=i.value;u(t,c.formatUrl(e),"POST",a,r,o)},postJsonPayload:function(t,e,n,r,o){r&&c.isFunction(r)||(r=function(){}),u(t,c.formatUrl(e),"POST",n,r,o)}}},function(t,e,n){var b=n(0),w=n(4),r=n(1);function _(t,e,n){var r=t.message,o=t.custom;if(!r)if(o){var i=e.scrubFields,a=b.stringify(b.scrub(o,i));r=a.error||a.value||""}else r="";var s={body:r};o&&(s.extra=b.merge(o)),b.set(t,"data.body",{message:s}),n(null,t)}t.exports={handleItemWithError:function(e,t,n){if(e.data=e.data||{},e.err)try{e.stackInfo=e.err._savedStackTrace||w.parse(e.err)}catch(t){r.error("Error while parsing the error object.",t);try{e.message=e.err.message||e.err.description||e.message||String(e.err)}catch(t){e.message=String(e.err)||String(t)}delete e.err}n(null,e)},ensureItemHasSomethingToSay:function(t,e,n){t.message||t.stackInfo||t.custom||n(new Error("No message, stack info, or custom data"),null),n(null,t)},addBaseInfo:function(t,e,n){var r=e.payload&&e.payload.environment||e.environment;t.data=b.merge(t.data,{environment:r,level:t.level,endpoint:e.endpoint,platform:"browser",framework:"browser-js",language:"javascript",server:{},uuid:t.uuid,notifier:{name:"rollbar-browser-js",version:e.version}}),n(null,t)},addRequestInfo:function(o){return function(t,e,n){if(!o||!o.location)return n(null,t);var r="$remote_ip";e.captureIp?!0!==e.captureIp&&(r+="_anonymize"):r=null,b.set(t,"data.request",{url:o.location.href,query_string:o.location.search,user_ip:r}),n(null,t)}},addClientInfo:function(i){return function(t,e,n){if(!i)return n(null,t);var r=i.navigator||{},o=i.screen||{};b.set(t,"data.client",{runtime_ms:t.timestamp-i._rollbarStartTime,timestamp:Math.round(t.timestamp/1e3),javascript:{browser:r.userAgent,language:r.language,cookie_enabled:r.cookieEnabled,screen:{width:o.width,height:o.height}}}),n(null,t)}},addPluginInfo:function(u){return function(t,e,n){if(!u||!u.navigator)return n(null,t);for(var r,o=[],i=u.navigator.plugins||[],a=0,s=i.length;a<s;++a)r=i[a],o.push({name:r.name,description:r.description});b.set(t,"data.client.javascript.plugins",o),n(null,t)}},addBody:function(t,e,n){t.stackInfo?function(t,e,n){var r=t.data.description,o=t.stackInfo,i=t.custom,a=w.guessErrorClass(o.message),s=o.name||a[0],u=a[1],c={exception:{class:s,message:u}};r&&(c.exception.description=r);var l=o.stack;if(l&&0===l.length&&t._unhandledStackInfo&&t._unhandledStackInfo.stack&&(l=t._unhandledStackInfo.stack),l){var p,f,h,d,m,g,v,y;for(0===l.length&&(c.exception.stack=o.rawStack,c.exception.raw=String(o.rawException)),c.frames=[],v=0;v<l.length;++v)p=l[v],f={filename:p.url?b.sanitizeUrl(p.url):"(unknown)",lineno:p.line||null,method:p.func&&"?"!==p.func?p.func:"[anonymous]",colno:p.column},e.sendFrameUrl&&(f.url=p.url),f.method&&f.method.endsWith&&f.method.endsWith("_rollbar_wrapped")||(h=d=m=null,(g=p.context?p.context.length:0)&&(y=Math.floor(g/2),d=p.context.slice(0,y),h=p.context[y],m=p.context.slice(y)),h&&(f.code=h),(d||m)&&(f.context={},d&&d.length&&(f.context.pre=d),m&&m.length&&(f.context.post=m)),p.args&&(f.args=p.args),c.frames.push(f));c.frames.reverse(),i&&(c.extra=b.merge(i)),b.set(t,"data.body",{trace:c}),n(null,t)}else t.message=s+": "+u,_(t,e,n)}(t,e,n):_(t,e,n)},scrubPayload:function(t,e,n){var r=e.scrubFields;t.data=b.scrub(t.data,r),n(null,t)}}},function(n,r,o){var i,a,s;!function(t,e){"use strict";a=[o(23)],void 0===(s="function"==typeof(i=function(s){var n=/(^|@)\S+\:\d+/,r=/^\s*at .*(\S+\:\d+|\(native\))/m,o=/^(eval@)?(\[native code\])?$/;function i(t,e,n){if("function"==typeof Array.prototype.map)return t.map(e,n);for(var r=new Array(t.length),o=0;o<t.length;o++)r[o]=e.call(n,t[o]);return r}function a(t,e,n){if("function"==typeof Array.prototype.filter)return t.filter(e,n);for(var r=[],o=0;o<t.length;o++)e.call(n,t[o])&&r.push(t[o]);return r}return{parse:function(t){if(void 0!==t.stacktrace||void 0!==t["opera#sourceloc"])return this.parseOpera(t);if(t.stack&&t.stack.match(r))return this.parseV8OrIE(t);if(t.stack)return this.parseFFOrSafari(t);throw new Error("Cannot parse given Error object")},extractLocation:function(t){if(-1===t.indexOf(":"))return[t];var e=t.replace(/[\(\)\s]/g,"").split(":"),n=e.pop(),r=e[e.length-1];if(isNaN(parseFloat(r))||!isFinite(r))return[e.join(":"),n,void 0];var o=e.pop();return[e.join(":"),o,n]},parseV8OrIE:function(t){var e=a(t.stack.split("\n"),function(t){return!!t.match(r)},this);return i(e,function(t){-1<t.indexOf("(eval ")&&(t=t.replace(/eval code/g,"eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g,""));var e=t.replace(/^\s+/,"").replace(/\(eval code/g,"(").split(/\s+/).slice(1),n=this.extractLocation(e.pop()),r=e.join(" ")||void 0,o="eval"===n[0]?void 0:n[0];return new s(r,void 0,o,n[1],n[2],t)},this)},parseFFOrSafari:function(t){var e=a(t.stack.split("\n"),function(t){return!t.match(o)},this);return i(e,function(t){if(-1<t.indexOf(" > eval")&&(t=t.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g,":$1")),-1===t.indexOf("@")&&-1===t.indexOf(":"))return new s(t);var e=t.split("@"),n=this.extractLocation(e.pop()),r=e.shift()||void 0;return new s(r,void 0,n[0],n[1],n[2],t)},this)},parseOpera:function(t){return!t.stacktrace||-1<t.message.indexOf("\n")&&t.message.split("\n").length>t.stacktrace.split("\n").length?this.parseOpera9(t):t.stack?this.parseOpera11(t):this.parseOpera10(t)},parseOpera9:function(t){for(var e=/Line (\d+).*script (?:in )?(\S+)/i,n=t.message.split("\n"),r=[],o=2,i=n.length;o<i;o+=2){var a=e.exec(n[o]);a&&r.push(new s(void 0,void 0,a[2],a[1],void 0,n[o]))}return r},parseOpera10:function(t){for(var e=/Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i,n=t.stacktrace.split("\n"),r=[],o=0,i=n.length;o<i;o+=2){var a=e.exec(n[o]);a&&r.push(new s(a[3]||void 0,void 0,a[2],a[1],void 0,n[o]))}return r},parseOpera11:function(t){var e=a(t.stack.split("\n"),function(t){return!!t.match(n)&&!t.match(/^Error created at/)},this);return i(e,function(t){var e,n=t.split("@"),r=this.extractLocation(n.pop()),o=n.shift()||"",i=o.replace(/<anonymous function(: (\w+))?>/,"$2").replace(/\([^\)]*\)/g,"")||void 0;o.match(/\(([^\)]*)\)/)&&(e=o.replace(/^[^\(]+\(([^\)]*)\)$/,"$1"));var a=void 0===e||"[arguments not available]"===e?void 0:e.split(",");return new s(i,a,r[0],r[1],r[2],t)},this)}}})?i.apply(r,a):i)||(n.exports=s)}()},function(n,r,t){var o,i,a;!function(t,e){"use strict";i=[],void 0===(a="function"==typeof(o=function(){function e(t){return!isNaN(parseFloat(t))&&isFinite(t)}function t(t,e,n,r,o,i){void 0!==t&&this.setFunctionName(t),void 0!==e&&this.setArgs(e),void 0!==n&&this.setFileName(n),void 0!==r&&this.setLineNumber(r),void 0!==o&&this.setColumnNumber(o),void 0!==i&&this.setSource(i)}return t.prototype={getFunctionName:function(){return this.functionName},setFunctionName:function(t){this.functionName=String(t)},getArgs:function(){return this.args},setArgs:function(t){if("[object Array]"!==Object.prototype.toString.call(t))throw new TypeError("Args must be an Array");this.args=t},getFileName:function(){return this.fileName},setFileName:function(t){this.fileName=String(t)},getLineNumber:function(){return this.lineNumber},setLineNumber:function(t){if(!e(t))throw new TypeError("Line Number must be a Number");this.lineNumber=Number(t)},getColumnNumber:function(){return this.columnNumber},setColumnNumber:function(t){if(!e(t))throw new TypeError("Column Number must be a Number");this.columnNumber=Number(t)},getSource:function(){return this.source},setSource:function(t){this.source=String(t)},toString:function(){return(this.getFunctionName()||"{anonymous}")+"("+(this.getArgs()||[]).join(",")+")"+(this.getFileName()?"@"+this.getFileName():"")+(e(this.getLineNumber())?":"+this.getLineNumber():"")+(e(this.getColumnNumber())?":"+this.getColumnNumber():"")}},t})?o.apply(r,i):o)||(n.exports=a)}()},function(t,e,n){var s=n(0);t.exports={itemToPayload:function(t,e,n){var r=e.payload||{};r.body&&delete r.body;var o=s.merge(t.data,r);t._isUncaught&&(o._isUncaught=!0),t._originalArgs&&(o._originalArgs=t._originalArgs),n(null,o)},addTelemetryData:function(t,e,n){t.telemetryEvents&&s.set(t,"data.body.telemetry",t.telemetryEvents),n(null,t)},addMessageWithError:function(t,e,n){if(t.message){var r="data.body.trace_chain.0",o=s.get(t,r);if(o||(r="data.body.trace",o=s.get(t,r)),o){if(!o.exception||!o.exception.description)return s.set(t,r+".exception.description",t.message),void n(null,t);var i=s.get(t,r+".extra")||{},a=s.merge(i,{message:t.message});s.set(t,r+".extra",a)}n(null,t)}else n(null,t)},userTransform:function(o){return function(e,n,r){var t=s.merge(e);try{s.isFunction(n.transform)&&n.transform(t.data,e)}catch(t){return n.transform=null,o.error("Error while calling custom transform() function. Removing custom transform().",t),void r(null,e)}r(null,t)}},addConfigToPayload:function(t,e,n){if(!e.sendConfig)return n(null,t);var r=s.get(t,"data.custom")||{};r._rollbarConfig=e,t.data.custom=r,n(null,t)},addConfiguredOptions:function(t,e,n){delete e._configuredOptions.accessToken,t.data.notifier.configured_options=e._configuredOptions,n(null,t)},addDiagnosticKeys:function(t,e,n){var r={};s.get(t,"err._isAnonymous")&&(r.isAnonymous=!0),t.data.notifier.diagnostic=s.merge(t.data.notifier.diagnostic,r),n(null,t)}}},function(t,e,n){var r=n(0);t.exports={checkIgnore:function(t,e){return!r.get(e,"plugins.jquery.ignoreAjaxErrors")||!r.get(t,"body.message.extra.isAjax")}}},function(t,e,n){var d=n(0);function r(t,e,n,r){var o,i,a,s,u,c,l,p,f=!1;"blacklist"===n&&(f=!0);try{if(c=(o=f?e.hostBlackList:e.hostWhiteList)&&o.length,i=d.get(t,"body.trace"),!o||0===c)return!f;if(!i||!i.frames||0===i.frames.length)return!f;for(s=i.frames.length,l=0;l<s;l++){if(a=i.frames[l].filename,!d.isType(a,"string"))return!f;for(p=0;p<c;p++)if(u=o[p],new RegExp(u).test(a))return!0}}catch(t){f?e.hostBlackList=null:e.hostWhiteList=null;var h=f?"hostBlackList":"hostWhiteList";return r.error("Error while reading your configuration's "+h+" option. Removing custom "+h+".",t),!f}return!1}t.exports={checkLevel:function(t,e){var n=t.level,r=d.LEVELS[n]||0,o=e.reportLevel;return!(r<(d.LEVELS[o]||0))},userCheckIgnore:function(o){return function(t,e){var n=!!t._isUncaught;delete t._isUncaught;var r=t._originalArgs;delete t._originalArgs;try{d.isFunction(e.onSendCallback)&&e.onSendCallback(n,r,t)}catch(t){e.onSendCallback=null,o.error("Error while calling onSendCallback, removing",t)}try{if(d.isFunction(e.checkIgnore)&&e.checkIgnore(n,r,t))return!1}catch(t){e.checkIgnore=null,o.error("Error while calling custom checkIgnore(), removing",t)}return!0}},urlIsNotBlacklisted:function(n){return function(t,e){return!r(t,e,"blacklist",n)}},urlIsWhitelisted:function(n){return function(t,e){return r(t,e,"whitelist",n)}},messageIsIgnored:function(l){return function(t,e){var n,r,o,i,a,s,u,c;try{if(a=!1,!(o=e.ignoredMessages)||0===o.length)return!0;if(s=t.body,u=d.get(s,"trace.exception.message"),c=d.get(s,"message.body"),!(n=u||c))return!0;for(i=o.length,r=0;r<i&&!(a=new RegExp(o[r],"gi").test(n));r++);}catch(t){e.ignoredMessages=null,l.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.")}return!a}}}},function(t,e,n){var m=n(0),i=n(3),a=n(28),s={network:!0,networkResponseHeaders:!1,networkResponseBody:!1,networkRequestBody:!1,log:!0,dom:!0,navigation:!0,connectivity:!0};function r(t,e,n,r,o){var i=t[e];t[e]=n(i),r&&r[o].push([t,e,i])}function o(t,e){for(var n;t[e].length;)(n=t[e].shift())[0][n[1]]=n[2]}function u(t,e,n,r,o){var i=t.autoInstrument;!1===t.enabled||!1===i?this.autoInstrument={}:(m.isType(i,"object")||(i=s),this.autoInstrument=m.merge(s,i)),this.scrubTelemetryInputs=!!t.scrubTelemetryInputs,this.telemetryScrubber=t.telemetryScrubber,this.defaultValueScrubber=function(t){for(var r=[],e=0;e<t.length;++e)r.push(new RegExp(t[e],"i"));return function(t){var e=function(t){if(!t||!t.attributes)return null;for(var e=t.attributes,n=0;n<e.length;++n)if("name"===e[n].key)return e[n].value;return null}(t);if(!e)return!1;for(var n=0;n<r.length;++n)if(r[n].test(e))return!0;return!1}}(t.scrubFields),this.telemeter=e,this.rollbar=n,this._window=r||{},this._document=o||{},this.replacements={network:[],log:[],navigation:[],connectivity:[]},this.eventRemovers={dom:[],connectivity:[]},this._location=this._window.location,this._lastHref=this._location&&this._location.href}u.prototype.configure=function(t){var e=t.autoInstrument,n=m.merge(this.autoInstrument);!1===t.enabled||!1===e?this.autoInstrument={}:(m.isType(e,"object")||(e=s),this.autoInstrument=m.merge(s,e)),this.instrument(n),void 0!==t.scrubTelemetryInputs&&(this.scrubTelemetryInputs=!!t.scrubTelemetryInputs),void 0!==t.telemetryScrubber&&(this.telemetryScrubber=t.telemetryScrubber)},u.prototype.instrument=function(t){!this.autoInstrument.network||t&&t.network?!this.autoInstrument.network&&t&&t.network&&this.deinstrumentNetwork():this.instrumentNetwork(),!this.autoInstrument.log||t&&t.log?!this.autoInstrument.log&&t&&t.log&&this.deinstrumentConsole():this.instrumentConsole(),!this.autoInstrument.dom||t&&t.dom?!this.autoInstrument.dom&&t&&t.dom&&this.deinstrumentDom():this.instrumentDom(),!this.autoInstrument.navigation||t&&t.navigation?!this.autoInstrument.navigation&&t&&t.navigation&&this.deinstrumentNavigation():this.instrumentNavigation(),!this.autoInstrument.connectivity||t&&t.connectivity?!this.autoInstrument.connectivity&&t&&t.connectivity&&this.deinstrumentConnectivity():this.instrumentConnectivity()},u.prototype.deinstrumentNetwork=function(){o(this.replacements,"network")},u.prototype.instrumentNetwork=function(){var d=this;function n(t,e){t in e&&m.isFunction(e[t])&&r(e,t,function(t){return d.rollbar.wrap(t)})}if("XMLHttpRequest"in this._window){var t=this._window.XMLHttpRequest.prototype;r(t,"open",function(n){return function(t,e){return m.isType(e,"string")&&(this.__rollbar_xhr={method:t,url:e,status_code:null,start_time_ms:m.now(),end_time_ms:null}),n.apply(this,arguments)}},this.replacements,"network"),r(t,"send",function(t){return function(f){var h=this;function e(){if(h.__rollbar_xhr){if(null===h.__rollbar_xhr.status_code){h.__rollbar_xhr.status_code=0;var t=null;d.autoInstrument.networkRequestBody&&(t=f),h.__rollbar_event=d.telemeter.captureNetwork(h.__rollbar_xhr,"xhr",void 0,t)}if(h.readyState<2&&(h.__rollbar_xhr.start_time_ms=m.now()),3<h.readyState){h.__rollbar_xhr.end_time_ms=m.now();var e=null;if(d.autoInstrument.networkResponseHeaders){var n=d.autoInstrument.networkResponseHeaders;e={};try{var r,o;if(!0===n){var i=h.getAllResponseHeaders();if(i){var a,s,u=i.trim().split(/[\r\n]+/);for(o=0;o<u.length;o++)r=(a=u[o].split(": ")).shift(),s=a.join(": "),e[r]=s}}else for(o=0;o<n.length;o++)e[r=n[o]]=h.getResponseHeader(r)}catch(t){}}var c=null;if(d.autoInstrument.networkResponseBody)try{c=h.responseText}catch(t){}var l=null;(c||e)&&(l={},c&&(l.body=c),e&&(l.headers=e)),l&&(h.__rollbar_xhr.response=l);try{var p=h.status;p=1223===p?204:p,h.__rollbar_xhr.status_code=p,h.__rollbar_event.level=d.telemeter.levelFromStatus(p)}catch(t){}}}}return n("onload",h),n("onerror",h),n("onprogress",h),"onreadystatechange"in h&&m.isFunction(h.onreadystatechange)?r(h,"onreadystatechange",function(t){return d.rollbar.wrap(t,void 0,e)}):h.onreadystatechange=e,t.apply(this,arguments)}},this.replacements,"network")}"fetch"in this._window&&r(this._window,"fetch",function(l){return function(t,e){for(var n=new Array(arguments.length),r=0,o=n.length;r<o;r++)n[r]=arguments[r];var i,a=n[0],s="GET";m.isType(a,"string")?i=a:a&&(i=a.url,a.method&&(s=a.method)),n[1]&&n[1].method&&(s=n[1].method);var u={method:s,url:i,status_code:null,start_time_ms:m.now(),end_time_ms:null},c=null;return d.autoInstrument.networkRequestBody&&(n[1]&&n[1].body?c=n[1].body:n[0]&&!m.isType(n[0],"string")&&n[0].body&&(c=n[0].body)),d.telemeter.captureNetwork(u,"fetch",void 0,c),l.apply(this,n).then(function(t){u.end_time_ms=m.now(),u.status_code=t.status;var e=null;if(d.autoInstrument.networkResponseHeaders){var n=d.autoInstrument.networkResponseHeaders;e={};try{if(!0===n);else for(var r=0;r<n.length;r++){var o=n[r];e[o]=t.headers.get(o)}}catch(t){}}var i=null;return e&&(i={headers:e}),i&&(u.response=i),t})}},this.replacements,"network")},u.prototype.deinstrumentConsole=function(){if("console"in this._window&&this._window.console.log)for(var t;this.replacements.log.length;)t=this.replacements.log.shift(),this._window.console[t[0]]=t[1]},u.prototype.instrumentConsole=function(){if("console"in this._window&&this._window.console.log)for(var i=this,e=this._window.console,t=["debug","info","warn","error","log"],n=0,r=t.length;n<r;n++)o(t[n]);function o(t){var n=e[t],r=e,o="warn"===t?"warning":t;e[t]=function(){var t=Array.prototype.slice.call(arguments),e=m.formatArgsAsString(t);i.telemeter.captureLog(e,o),n&&Function.prototype.apply.call(n,r,t)},i.replacements.log.push([t,n])}},u.prototype.deinstrumentDom=function(){("addEventListener"in this._window||"attachEvent"in this._window)&&this.removeListeners("dom")},u.prototype.instrumentDom=function(){if("addEventListener"in this._window||"attachEvent"in this._window){var t=this.handleClick.bind(this),e=this.handleBlur.bind(this);this.addListener("dom",this._window,"click","onclick",t,!0),this.addListener("dom",this._window,"blur","onfocusout",e,!0)}},u.prototype.handleClick=function(t){try{var e=a.getElementFromEvent(t,this._document),n=e&&e.tagName,r=a.isDescribedElement(e,"a")||a.isDescribedElement(e,"button");n&&(r||a.isDescribedElement(e,"input",["button","submit"]))?this.captureDomEvent("click",e):a.isDescribedElement(e,"input",["checkbox","radio"])&&this.captureDomEvent("input",e,e.value,e.checked)}catch(t){}},u.prototype.handleBlur=function(t){try{var e=a.getElementFromEvent(t,this._document);e&&e.tagName&&(a.isDescribedElement(e,"textarea")?this.captureDomEvent("input",e,e.value):a.isDescribedElement(e,"select")&&e.options&&e.options.length?this.handleSelectInputChanged(e):a.isDescribedElement(e,"input")&&!a.isDescribedElement(e,"input",["button","submit","hidden","checkbox","radio"])&&this.captureDomEvent("input",e,e.value))}catch(t){}},u.prototype.handleSelectInputChanged=function(t){if(t.multiple)for(var e=0;e<t.options.length;e++)t.options[e].selected&&this.captureDomEvent("input",t,t.options[e].value);else 0<=t.selectedIndex&&t.options[t.selectedIndex]&&this.captureDomEvent("input",t,t.options[t.selectedIndex].value)},u.prototype.captureDomEvent=function(t,e,n,r){if(void 0!==n)if(this.scrubTelemetryInputs||"password"===a.getElementType(e))n="[scrubbed]";else{var o=a.describeElement(e);this.telemetryScrubber?this.telemetryScrubber(o)&&(n="[scrubbed]"):this.defaultValueScrubber(o)&&(n="[scrubbed]")}var i=a.elementArrayToString(a.treeToArray(e));this.telemeter.captureDom(t,i,n,r)},u.prototype.deinstrumentNavigation=function(){var t=this._window.chrome;t&&t.app&&t.app.runtime||!this._window.history||!this._window.history.pushState||o(this.replacements,"navigation")},u.prototype.instrumentNavigation=function(){var t=this._window.chrome;if(!(t&&t.app&&t.app.runtime)&&this._window.history&&this._window.history.pushState){var n=this;r(this._window,"onpopstate",function(e){return function(){var t=n._location.href;n.handleUrlChange(n._lastHref,t),e&&e.apply(this,arguments)}},this.replacements,"navigation"),r(this._window.history,"pushState",function(e){return function(){var t=2<arguments.length?arguments[2]:void 0;return t&&n.handleUrlChange(n._lastHref,t+""),e.apply(this,arguments)}},this.replacements,"navigation")}},u.prototype.handleUrlChange=function(t,e){var n=i.parse(this._location.href),r=i.parse(e),o=i.parse(t);this._lastHref=e,n.protocol===r.protocol&&n.host===r.host&&(e=r.path+(r.hash||"")),n.protocol===o.protocol&&n.host===o.host&&(t=o.path+(o.hash||"")),this.telemeter.captureNavigation(t,e)},u.prototype.deinstrumentConnectivity=function(){("addEventListener"in this._window||"body"in this._document)&&(this._window.addEventListener?this.removeListeners("connectivity"):o(this.replacements,"connectivity"))},u.prototype.instrumentConnectivity=function(){if("addEventListener"in this._window||"body"in this._document)if(this._window.addEventListener)this.addListener("connectivity",this._window,"online",void 0,function(){this.telemeter.captureConnectivityChange("online")}.bind(this),!0),this.addListener("connectivity",this._window,"offline",void 0,function(){this.telemeter.captureConnectivityChange("offline")}.bind(this),!0);else{var e=this;r(this._document.body,"ononline",function(t){return function(){e.telemeter.captureConnectivityChange("online"),t&&t.apply(this,arguments)}},this.replacements,"connectivity"),r(this._document.body,"onoffline",function(t){return function(){e.telemeter.captureConnectivityChange("offline"),t&&t.apply(this,arguments)}},this.replacements,"connectivity")}},u.prototype.addListener=function(t,e,n,r,o,i){e.addEventListener?(e.addEventListener(n,o,i),this.eventRemovers[t].push(function(){e.removeEventListener(n,o,i)})):r&&(e.attachEvent(r,o),this.eventRemovers[t].push(function(){e.detachEvent(r,o)}))},u.prototype.removeListeners=function(t){for(;this.eventRemovers[t].length;)this.eventRemovers[t].shift()()},t.exports=u},function(t,e){function o(t){return(t.getAttribute("type")||"").toLowerCase()}function s(t){if(!t||!t.tagName)return"";var e=[t.tagName];t.id&&e.push("#"+t.id),t.classes&&e.push("."+t.classes.join("."));for(var n=0;n<t.attributes.length;n++)e.push("["+t.attributes[n].key+'="'+t.attributes[n].value+'"]');return e.join("")}function i(t){if(!t||!t.tagName)return null;var e,n,r,o,i={};i.tagName=t.tagName.toLowerCase(),t.id&&(i.id=t.id),(e=t.className)&&"string"==typeof e&&(i.classes=e.split(/\s+/));var a=["type","name","title","alt"];for(i.attributes=[],o=0;o<a.length;o++)n=a[o],(r=t.getAttribute(n))&&i.attributes.push({key:n,value:r});return i}t.exports={describeElement:i,descriptionToString:s,elementArrayToString:function(t){for(var e,n,r=" > ".length,o=[],i=0,a=t.length-1;0<=a;a--){if(e=s(t[a]),n=i+o.length*r+e.length,a<t.length-1&&83<=n){o.unshift("...");break}o.unshift(e),i+=e.length}return o.join(" > ")},treeToArray:function(t){for(var e,n=[],r=0;t&&r<5&&"html"!==(e=i(t)).tagName;r++)n.unshift(e),t=t.parentNode;return n},getElementFromEvent:function(t,e){return t.target?t.target:e&&e.elementFromPoint?e.elementFromPoint(t.clientX,t.clientY):void 0},isDescribedElement:function(t,e,n){if(t.tagName.toLowerCase()!==e.toLowerCase())return!1;if(!n)return!0;t=o(t);for(var r=0;r<n.length;r++)if(n[r]===t)return!0;return!1},getElementType:o}}],o.c=r,o.d=function(t,e,n){o.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},o.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)o.d(n,r,function(t){return e[t]}.bind(null,r));return n},o.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return o.d(e,"a",e),e},o.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},o.p="",o(o.s=5);function o(t){if(r[t])return r[t].exports;var e=r[t]={i:t,l:!1,exports:{}};return n[t].call(e.exports,e,e.exports,o),e.l=!0,e.exports}var n,r});
//# sourceMappingURL=rollbar.umd.min.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    accessToken: "f3453d0e52104a15aca06ce04cc1b07e",
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: JSON.parse("true"),
    payload: {
        environment: "production",
        client: {
            javascript: {
                code_version: "00ec3da0-3d47-11f0-b869-cffa0fe4860b"
            }
        }
    }
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.064602861ed3440b641a.js